(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("VidiunPlayer", [], factory);
	else if(typeof exports === 'object')
		exports["VidiunPlayer"] = factory();
	else
		root["VidiunPlayer"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 148);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var core = __webpack_require__(23);
var hide = __webpack_require__(13);
var redefine = __webpack_require__(14);
var ctx = __webpack_require__(20);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(4);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(54)('wks');
var uid = __webpack_require__(34);
var Symbol = __webpack_require__(2).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(3)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(1);
var IE8_DOM_DEFINE = __webpack_require__(102);
var toPrimitive = __webpack_require__(24);
var dP = Object.defineProperty;

exports.f = __webpack_require__(6) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(26);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("core",[],t):"object"==typeof exports?exports.core=t():(e.pakhshkit=e.pakhshkit||{},e.pakhshkit.core=t())}(this,function(){return function(e){function t(i){if(n[i])return n[i].exports;var r=n[i]={i:i,l:!1,exports:{}};return e[i].call(r.exports,r,r.exports,t),r.l=!0,r.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,i){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:i})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=39)}([function(e,t,n){"use strict";function i(e){return e?s.get(e):s}function r(e){return i(e).getLevel()}function a(e,t){i(t).setLevel(e)}Object.defineProperty(t,"__esModule",{value:!0}),t.setLogLevel=t.getLogLevel=t.LogLevelType=t.LogLevel=void 0;var o=n(44),s=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}(o),u={DEBUG:s.DEBUG,INFO:s.INFO,TIME:s.TIME,WARN:s.WARN,ERROR:s.ERROR,OFF:s.OFF},l={};Object.keys(u).forEach(function(e){l[e]=e}),s.useDefaults({defaultLevel:s.ERROR}),t.default=i,t.LogLevel=u,t.LogLevelType=l,t.getLogLevel=r,t.setLogLevel=a},function(e,t,n){"use strict";function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var r=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}(),a=function(){function e(t,n){i(this,e),this.bubbles=!1,this.cancelable=!1,this.defaultPrevented=!1,this.timeStamp=window.performance?window.performance.now():Date.now(),this.type=t,this.isTrusted=!1,this.currentTarget=null,this.target=null,this.stopped=!1,this.payload=n}return r(e,[{key:"preventDefault",value:function(){}},{key:"stopImmediatePropagation",value:function(){this.stopped=!0}},{key:"stopPropagation",value:function(){}}]),e}();t.default=a},function(e,t,n){"use strict";function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var r=n(0),a=function(e){return e&&e.__esModule?e:{default:e}}(r),o=n(45),s=n(46),u=n(48),l=function e(t,n,a){var o=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{};i(this,e),this.severity=t,this.category=n,this.code=a,this.data=o,(0,r.getLogLevel)("Error")!==r.LogLevel.OFF&&e._logger.error("Category:"+n+" | Code:"+a+" |",o)};l.Severity=o.Severity,l.Category=u.Category,l.Code=s.Code,l._logger=(0,a.default)("Error"),t.default=l},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.CustomEventType=t.Html5EventType=t.EventType=void 0;var i=n(5),r=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}(i),a=n(13),o={ABORT:"abort",CAN_PLAY:"canplay",CAN_PLAY_THROUGH:"canplaythrough",DURATION_CHANGE:"durationchange",EMPTIED:"emptied",ENDED:"ended",ERROR:"error",LOADED_DATA:"loadeddata",LOADED_METADATA:"loadedmetadata",LOAD_START:"loadstart",PAUSE:"pause",PLAY:"play",PLAYING:"playing",PROGRESS:"progress",RATE_CHANGE:"ratechange",SEEKED:"seeked",SEEKING:"seeking",STALLED:"stalled",SUSPEND:"suspend",TIME_UPDATE:"timeupdate",VOLUME_CHANGE:"volumechange",WAITING:"waiting",ENTER_PICTURE_IN_PICTURE:"enterpictureinpicture",LEAVE_PICTURE_IN_PICTURE:"leavepictureinpicture",PRESENTATION_MODE_CHANGED:"webkitpresentationmodechanged"},s={MEDIA_LOADED:"medialoaded",PLAYER_RESET:"playerreset",PLAYER_DESTROY:"playerdestroy",ENTER_FULLSCREEN:"enterfullscreen",EXIT_FULLSCREEN:"exitfullscreen",AUTOPLAY_FAILED:"autoplayfailed",FALLBACK_TO_MUTED_AUTOPLAY:"fallbacktomutedautoplay",CHANGE_SOURCE_STARTED:"changesourcestarted",CHANGE_SOURCE_ENDED:"changesourceended",MUTE_CHANGE:"mutechange",VIDEO_TRACK_CHANGED:"videotrackchanged",AUDIO_TRACK_CHANGED:"audiotrackchanged",TEXT_TRACK_CHANGED:"texttrackchanged",TEXT_CUE_CHANGED:"textcuechanged",TRACKS_CHANGED:"trackschanged",ABR_MODE_CHANGED:"abrmodechanged",PLAYER_STATE_CHANGED:"playerstatechanged",PLAYBACK_START:"playbackstart",FIRST_PLAY:"firstplay",FIRST_PLAYING:"firstplaying",PLAYBACK_ENDED:"playbackended",SOURCE_SELECTED:"sourceselected",TEXT_STYLE_CHANGED:"textstylechanged",MEDIA_RECOVERED:"mediarecovered",VR_STEREO_MODE_CHANGED:"vrstereomodechanged",FPS_DROP:"fpsdrop",BOOKMARK_ERROR:"bookmarkerror",CONCURRENCY_LIMIT:"concurrencylimit",RESIZE:"resize",TIMED_METADATA:"timedmetadata"},u=r.Object.merge([o,s,a.AdEventType]);t.EventType=u,t.Html5EventType=o,t.CustomEventType=s},function(e,t,n){"use strict";function i(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var a=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}(),o=n(16),s=i(o),u=n(1),l=(i(u),function(){function e(){r(this,e),this._bindingMap=new s.default}return a(e,[{key:"destroy",value:function(){return this.removeAll(),this._bindingMap=null,Promise.resolve()}},{key:"listenOnce",value:function(e,t,n,i){var r=this,a=function i(a){r.unlisten(e,t,i),n.call(r,a)};this.listen(e,t,a,i)}},{key:"listen",value:function(e,t,n,i){var r=new c(e,t,n,i);this._bindingMap&&this._bindingMap.push(t,r)}},{key:"unlisten",value:function(e,t,n){if(this._bindingMap)for(var i=this._bindingMap.get(t),r=0;r<i.length;++r){var a=i[r];a.target!==e||a.listener!==n&&n||(a.unlisten(),this._bindingMap&&this._bindingMap.remove(t,a))}}},{key:"removeAll",value:function(){if(this._bindingMap){var e=this._bindingMap.getAll(),t=!0,n=!1,i=void 0;try{for(var r,a=e[Symbol.iterator]();!(t=(r=a.next()).done);t=!0){r.value.unlisten()}}catch(e){n=!0,i=e}finally{try{!t&&a.return&&a.return()}finally{if(n)throw i}}this._bindingMap&&this._bindingMap.clear()}}}]),e}()),c=function(){function e(t,n,i,a){r(this,e),this.target=t,this.type=n,this.listener=i,this.options=a,this.target.addEventListener(n,i,a)}return a(e,[{key:"unlisten",value:function(){this.target&&(this.target.removeEventListener(this.type,this.listener,this.options),this.target=null,this.listener=null,this.options=null)}}]),e}();t.default=l},function(e,t,n){"use strict";function i(e){return Array.isArray(e)?e:Array.from(e)}function r(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}function a(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}Object.defineProperty(t,"__esModule",{value:!0}),t.VERSION=t.Http=t.Dom=t.Generator=t.Object=t.String=t.Number=void 0;var o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},s=n(43),u={isNumber:function(e){return Number(e)===e},isInt:function(e){return this.isNumber(e)&&e%1==0},isFloat:function(e){return this.isNumber(e)&&e%1!=0}},l={capitlize:function(e){return"string"!=typeof e?e:e.charAt(0).toUpperCase()+e.slice(1)},endsWith:function(e,t){return"string"==typeof e&&"string"==typeof t&&-1!=e.indexOf(t,e.length-t.length)}},c={merge:function(e){var t={},n=!0,i=!1,r=void 0;try{for(var a,o=e[Symbol.iterator]();!(n=(a=o.next()).done);n=!0){var s=a.value;Object.assign(t,s)}}catch(e){i=!0,r=e}finally{try{!n&&o.return&&o.return()}finally{if(i)throw r}}return t},isObject:function(e){return e&&"object"===(void 0===e?"undefined":o(e))&&!Array.isArray(e)},mergeDeep:function(e){for(var t=arguments.length,n=Array(t>1?t-1:0),i=1;i<t;i++)n[i-1]=arguments[i];if(!n.length)return e;var o=n.shift();if(this.isObject(e)&&this.isObject(o))for(var s in o)this.isObject(o[s])?(e[s]||Object.assign(e,a({},s,{})),this.mergeDeep(e[s],o[s])):Object.assign(e,a({},s,o[s]));return this.mergeDeep.apply(this,[e].concat(r(n)))},copyDeep:function(e){var t=this,n=void 0;return Array.isArray(e)?(n=e.length>0?e.slice(0):[],n.forEach(function(e,i){("object"===(void 0===e?"undefined":o(e))&&e!=={}||Array.isArray(e)&&e.length>0)&&(n[i]=t.copyDeep(e))})):null!==e&&"object"===(void 0===e?"undefined":o(e))?e.clone&&"function"==typeof e.clone?n=e.clone():(n=Object.assign({__proto__:e.__proto__},e),Object.keys(n).forEach(function(e){("object"===o(n[e])&&n[e]!=={}||Array.isArray(n[e])&&n[e].length>0)&&(n[e]=t.copyDeep(n[e]))})):n=e,n},isEmptyObject:function(e){for(var t in e)if(e.hasOwnProperty(t))return!1;return!0},getPropertyPath:function(e,t){return t.split(".").reduce(function(e,t){return void 0===e||null===e?e:e[t]},e)},hasPropertyPath:function(e,t){if(!t)return!1;for(var n=t.split("."),i=0;i<n.length;i++){var r=n[i];if(!e||!e.hasOwnProperty(r))return!1;e=e[r]}return!0},createPropertyPath:function(e,t){for(var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null,r=t.split("."),a=e;r.length>1;){var o=r,s=i(o),u=s[0];r=s.slice(1),void 0===a[u]&&(a[u]={}),a=a[u]}return a[r[0]]=n,e},deletePropertyPath:function(e,t){if(e&&t){for(var n=t.split("."),i=0;i<n.length-1;i++)if(void 0===(e=e[n[i]]))return;delete e[n.pop()]}},defer:function(){var e=void 0,t=void 0,n=new Promise(function(n,i){e=n,t=i});return n.resolve=e,n.reject=t,n},bind:function(e,t){return function(){t.apply(e,arguments)}}},d={uniqueId:function(e){var t=2+(!e||e<0?0:e-2);return"_"+Math.random().toString(36).substr(2,t)},guid:function(){var e=function(){return(65536*(1+Math.random())|0).toString(16).substring(1)};return e()+e()+"-"+e()+"-"+e()+"-"+e()+"-"+e()+e()+e()}},f={addClassName:function(e,t){e.classList?e.classList.add(t):f.hasClassName(e,t)||(e.className+=t)},removeClassName:function(e,t){e.classList?e.classList.remove(t):f.hasClassName(e,t)&&(e.className=e.className.replace(new RegExp("(\\s|^)"+t+"(\\s|$)")," ").replace(/^\s+|\s+$/g,""))},hasClassName:function(e,t){return e.className&&new RegExp("(^|\\s)"+t+"(\\s|$)").test(e.className)},setAttribute:function(e,t,n){e.setAttribute(t,n)},removeAttribute:function(e,t){e.removeAttribute(t)},setStyle:function(e,t,n){void 0!==e.style.getPropertyValue(t)&&e.style.setProperty(t,n)},appendChild:function(e,t){e&&t&&e.appendChild&&e.appendChild(t)},removeChild:function(e,t){e&&t&&e.removeChild&&e.removeChild(t)},prependTo:function(e,t){t.firstChild?t.insertBefore(e,t.firstChild):t.appendChild(e)},getElementById:function(e){return document.getElementById(e)},getElementsByTagName:function(e){return document.getElementsByTagName(e)},createElement:function(e){return document.createElement(e)},loadScriptAsync:function(e){var t=this;return new Promise(function(n,i){var r=!1,a=document.getElementsByTagName("script")[0],o=t.createElement("script");o.type="text/javascript",o.src=e,o.async=!0,o.onload=o.onreadystatechange=function(){r||this.readyState&&"complete"!==this.readyState||(r=!0,n(this))},o.onerror=o.onabort=i,a&&a.parentNode&&a.parentNode.insertBefore(o,a)})},getElementBySelector:function(e){try{return document.querySelector(e)}catch(e){return}},insertBefore:function(e,t,n){try{return e.insertBefore(t,n)}catch(e){return null}}},h={execute:function(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"POST",i=arguments[3],r=new XMLHttpRequest;return new Promise(function(a,o){r.onreadystatechange=function(){if(4===r.readyState)if(200===r.status)try{var e=JSON.parse(r.responseText);a(e)}catch(e){a(r.responseText)}else o(r.responseText)},r.open(n,e),i&&i.forEach(function(e,t){r.setRequestHeader(t,e)}),r.send(t)})},jsonp:s.jsonp},_={compare:function(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};n=c.merge([{lexicographical:!1,zeroExtend:!0},n]);var i=n.lexicographical,r=n.zeroExtend,a=(e||"0").split("."),o=(t||"0").split("."),s=function(e){return(i?/^\d+[A-Za-zαß]*$/:/^\d+[A-Za-zαß]?$/).test(e)},u=function(e){return e.map(function(e){var t=/[A-Za-zαß]/.exec(e);return Number(t?e.replace(t[0],"."+e.charCodeAt(t.index)):e)})};if(!a.every(s)||!o.every(s))return NaN;if(r){for(;a.length<o.length;)a.push("0");for(;o.length<a.length;)o.push("0")}i||(a=u(a),o=u(o));for(var l=0;l<a.length;++l){if(o.length===l)return 1;if(a[l]!==o[l])return a[l]>o[l]?1:-1}return a.length!==o.length?-1:0}};t.Number=u,t.String=l,t.Object=c,t.Generator=d,t.Dom=f,t.Http=h,t.VERSION=_},function(e,t,n){"use strict";function i(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var a=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}(),o=n(1),s=(i(o),n(16)),u=i(s),l=function(){function e(){r(this,e),this._listeners=new u.default,this.dispatchTarget=this}return a(e,[{key:"addEventListener",value:function(e,t){this._listeners.push(e,t)}},{key:"removeEventListener",value:function(e,t){this._listeners.remove(e,t)}},{key:"dispatchEvent",value:function(e){for(var t=this._listeners.get(e.type)||[],n=0;n<t.length;++n){e.target=this.dispatchTarget,e.currentTarget=this.dispatchTarget;var i=t[n];try{i.handleEvent?i.handleEvent(e):i.call(this,e)}catch(e){}if(e.stopped)break}return e.defaultPrevented}}]),e}();t.default=l},function(e,t,n){"use strict";function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var r=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}(),a=function(){function e(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};i(this,e),this._id=t.id,this._active=t.active,this._label=t.label,this._language=t.language,this._index=t.index,this.clone=e.clone.bind(null,this)}return r(e,[{key:"id",get:function(){return this._id}},{key:"active",get:function(){return this._active},set:function(e){this._active=e}},{key:"label",get:function(){return this._label},set:function(e){this._label=e}},{key:"language",get:function(){return this._language}},{key:"index",get:function(){return this._index},set:function(e){this._index=e}}],[{key:"langComparer",value:function(e,t){try{return e=e.toLowerCase(),t=t.toLowerCase(),!!e&&(e.startsWith(t)||t.startsWith(e))}catch(e){return!1}}},{key:"clone",value:function(e){return Object.assign(Object.create(Object.getPrototypeOf(e)),e)}}]),e}();t.default=a},function(e,t,n){"use strict";function i(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}(),l=n(12),c=i(l),d=n(4),f=i(d),h=n(42),_=i(h),p=n(1),A=i(p),v=n(6),g=i(v),y=n(3),E=n(5),T=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}(E),m=n(49),b=i(m),k=n(0),w=i(k),S=n(17),C=i(S),O=n(18),R=(i(O),n(50)),D=i(R),P=n(7),I=i(P),N=n(10),L=i(N),M=n(11),x=i(M),U=n(9),F=i(U),j=n(20),H=i(j),B=(n(14),n(21)),G=n(19),V=n(15),Y=n(52),W=n(25),K=n(26),X=n(27),z=n(28),q=n(29),Q=n(54),Z=i(Q),J=n(56);n(57);var $=n(2),ee=i($),te=n(30),ne=n(72),ie=n(34),re=n(35),ae=n(36),oe=n(13),se=n(73),ue=n(74),le=n(75),ce="off",de=function(e){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};r(this,t);var n=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this));return n._activeTextCues=[],n._textDisplaySettings={},n._playbackAttributesState={muted:void 0,volume:void 0,rate:void 0,audioLanguage:"",textLanguage:""},n._setConfigLogLevel(e),n._playerId=T.Generator.uniqueId(5),n._prepareVideoElement(),t.runCapabilities(),n._env=c.default,n._tracks=[],n._firstPlay=!0,n._repositionCuesTimeout=!1,n._loadingMedia=!1,n._loading=!1,n._playbackStart=!1,n._firstPlaying=!1,n._reset=!0,n._destroyed=!1,n._fallbackToMutedAutoPlay=!1,n._config=t._defaultConfig,n._eventManager=new f.default,n._posterManager=new _.default,n._stateManager=new D.default(n),n._pluginManager=new C.default,n._controllerProvider=new se.ControllerProvider(n._pluginManager),n._resizeWatcher=new ue.ResizeWatcher,n._playbackMiddleware=new Z.default,n._textStyle=new H.default,n._createReadyPromise(),n._createPlayerContainer(),n._appendDomElements(),n._externalCaptionsHandler=new ne.ExternalCaptionsHandler(n),n.configure(e),n._fullscreenController=new le.FullscreenController(n),n}return o(t,e),u(t,null,[{key:"runCapabilities",value:function(){t._logger.debug("Running player capabilities"),te.EngineProvider.getEngines().forEach(function(e){return e.runCapabilities()})}},{key:"getCapabilities",value:function(e){t._logger.debug("Get player capabilities",e);var n=[];return te.EngineProvider.getEngines().forEach(function(e){return n.push(e.getCapabilities())}),Promise.all(n).then(function(n){var i={};return n.forEach(function(e){return Object.assign(i,e)}),T.Object.mergeDeep(i,t._playerCapabilities),e?i[e]:i})}},{key:"setCapabilities",value:function(e,n){t._logger.debug("Set player capabilities",e,n),t._playerCapabilities[e]=T.Object.mergeDeep({},t._playerCapabilities[e],n)}}]),u(t,[{key:"configure",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this._setConfigLogLevel(e),this._hasSources(e.sources)?(this._configureOrLoadPlugins(e.plugins),this._maybeCreateAdsController(),this.reset(),this._resizeWatcher.init(T.Dom.getElementById(this._playerId)),t._logger.debug("Change source started"),this.dispatchEvent(new A.default(y.CustomEventType.CHANGE_SOURCE_STARTED)),this._pluginManager.loadMedia(),T.Object.mergeDeep(this._config,e),this._reset=!1,this._selectEngineByPriority()?(this.dispatchEvent(new A.default(y.CustomEventType.SOURCE_SELECTED,{selectedSource:this._config.sources[this._streamType]})),this._attachMedia(),this._handlePlaybackOptions(),this._posterManager.setSrc(this._config.sources.poster),this._handlePreload(),this._handleAutoPlay(),t._logger.debug("Change source ended"),this.dispatchEvent(new A.default(y.CustomEventType.CHANGE_SOURCE_ENDED))):(t._logger.warn("No playable engines was found to play the given sources"),this.dispatchEvent(new A.default(y.Html5EventType.ERROR,new ee.default(ee.default.Severity.CRITICAL,ee.default.Category.PLAYER,ee.default.Code.NO_ENGINE_FOUND_TO_PLAY_THE_SOURCE,"No Engine Found To Play The Source"))))):(T.Object.mergeDeep(this._config,e),this._configureOrLoadPlugins(e.plugins),this._maybeCreateAdsController())}},{key:"ready",value:function(){return this._readyPromise?this._readyPromise:Promise.resolve()}},{key:"load",value:function(){var e=this,t=function(){e._loading=!1,e._reset=!1};if(this._engine&&!this.src&&!this._loading){this._loading=!0;var n=this._config.playback.startTime;this._engine.load(n).then(function(n){e._updateTracks(n.tracks),e.dispatchEvent(new A.default(y.CustomEventType.TRACKS_CHANGED,{tracks:e._tracks})),t()}).catch(function(n){e.dispatchEvent(new A.default(y.Html5EventType.ERROR,n)),t()})}}},{key:"play",value:function(){var e=this;this._playbackStart||(this._playbackStart=!0,this.dispatchEvent(new A.default(y.CustomEventType.PLAYBACK_START))),this._engine?this._playbackMiddleware.play(function(){return e._play()}):this._loadingMedia?(this._prepareVideoElement(),this._playbackMiddleware.play(function(){return e._playAfterAsyncMiddleware()})):this.dispatchEvent(new A.default(y.Html5EventType.ERROR,new ee.default(ee.default.Severity.CRITICAL,ee.default.Category.PLAYER,ee.default.Code.NO_SOURCE_PROVIDED,"No Source Provided")))}},{key:"pause",value:function(){this._engine&&this._playbackMiddleware.pause(this._pause.bind(this))}},{key:"getView",value:function(){return this._el}},{key:"getVideoElement",value:function(){if(this._engine)return this._engine.getVideoElement()}},{key:"reset",value:function(){this._reset||(this.pause(),this._externalCaptionsHandler.reset(),this._posterManager.reset(),this._pluginManager.reset(),this._stateManager.reset(),this._config.sources={},this._activeTextCues=[],this._updateTextDisplay([]),this._tracks=[],this._resetStateFlags(),this._engineType="",this._streamType="",this._engine.reset(),this._showBlackCover(),this._reset=!0,this.dispatchEvent(new A.default(y.CustomEventType.PLAYER_RESET)),this._eventManager.removeAll(),this._resizeWatcher.init(T.Dom.getElementById(this._playerId)),this._createReadyPromise())}},{key:"destroy",value:function(){this._destroyed||(this._externalCaptionsHandler.destroy(),t._playerCapabilities={},this._posterManager.destroy(),this._pluginManager.destroy(),this._stateManager.destroy(),this._clearRepositionTimeout(),this._activeTextCues=[],this._textDisplaySettings={},this._config={},this._tracks=[],this._engineType="",this._streamType="",this._readyPromise=null,this._resetStateFlags(),this._playbackAttributesState={},this._engine&&this._engine.destroy(),this._resizeWatcher.destroy(),this._el&&T.Dom.removeChild(this._el.parentNode,this._el),this._destroyed=!0,this.dispatchEvent(new A.default(y.CustomEventType.PLAYER_DESTROY)),this._eventManager.destroy())}},{key:"isLive",value:function(){return!(this._config.sources.type===X.MediaType.VOD||!(this._config.sources.type===X.MediaType.LIVE||this._engine&&this._engine.isLive()))}},{key:"isDvr",value:function(){return this.isLive()&&this._config.sources.dvr}},{key:"seekToLiveEdge",value:function(){this._engine&&this.isLive()&&this._engine.seekToLiveEdge()}},{key:"getStartTimeOfDvrWindow",value:function(){return this._engine?this._engine.getStartTimeOfDvrWindow():0}},{key:"getTracks",value:function(e){return T.Object.copyDeep(this._getTracksByType(e))}},{key:"getActiveTracks",value:function(){return T.Object.copyDeep({video:this._getTracksByType(V.TrackType.VIDEO).find(function(e){return e.active}),audio:this._getTracksByType(V.TrackType.AUDIO).find(function(e){return e.active}),text:this._getTracksByType(V.TrackType.TEXT).find(function(e){return e.active})})}},{key:"selectTrack",value:function(e){this._engine&&(e instanceof L.default?this._engine.selectVideoTrack(e):e instanceof x.default?this._engine.selectAudioTrack(e):e instanceof F.default&&(this._resetTextDisplay(),e.language===ce?(this.hideTextTrack(),this._externalCaptionsHandler.hideTextTrack(),this._playbackAttributesState.textLanguage=ce):e.external&&!this._config.playback.useNativeTextTrack?(this._engine.hideTextTrack(),this._externalCaptionsHandler.selectTextTrack(e)):(this._externalCaptionsHandler.hideTextTrack(),this._engine.selectTextTrack(e))))}},{key:"hideTextTrack",value:function(){if(this._engine){this._engine.hideTextTrack(),this._resetTextDisplay();var e=this._getTracksByType(V.TrackType.TEXT);e.map(function(e){return e.active=!1});var t=e.find(function(e){return e.language===ce});t&&(t.active=!0,this.dispatchEvent(new A.default(y.CustomEventType.TEXT_TRACK_CHANGED,{selectedTextTrack:t})))}}},{key:"enableAdaptiveBitrate",value:function(){this._engine&&this._engine.enableAdaptiveBitrate()}},{key:"isAdaptiveBitrateEnabled",value:function(){return!!this._engine&&this._engine.isAdaptiveBitrateEnabled()}},{key:"setTextDisplaySettings",value:function(e){this._textDisplaySettings=e,this._updateCueDisplaySettings();for(var t=0;t<this._activeTextCues.length;t++)this._activeTextCues[t].hasBeenReset=!0;this._updateTextDisplay(this._activeTextCues)}},{key:"isFullscreen",value:function(){return this._fullscreenController.isFullscreen()}},{key:"notifyEnterFullscreen",value:function(){this.isFullscreen()&&this.dispatchEvent(new A.default(y.CustomEventType.ENTER_FULLSCREEN))}},{key:"notifyExitFullscreen",value:function(){this.isFullscreen()||this.dispatchEvent(new A.default(y.CustomEventType.EXIT_FULLSCREEN))}},{key:"enterFullscreen",value:function(e){this._fullscreenController.enterFullscreen(e)}},{key:"exitFullscreen",value:function(){this._fullscreenController.exitFullscreen()}},{key:"enterPictureInPicture",value:function(){this.isFullscreen()&&this.exitFullscreen(),this._engine.isInPictureInPicture||this._engine.enterPictureInPicture()}},{key:"exitPictureInPicture",value:function(){this._engine.isInPictureInPicture&&this._engine.exitPictureInPicture()}},{key:"isInPictureInPicture",value:function(){return this._engine.isInPictureInPicture}},{key:"isPictureInPictureSupported",value:function(){return!!this._config.playback.pictureInPicture&&this._engine.isPictureInPictureSupported()}},{key:"isVr",value:function(){return!!this._config.sources.vr}},{key:"toggleVrStereoMode",value:function(){var e=this._pluginManager.get("vr");e&&"function"==typeof e.toggleVrStereoMode&&e.toggleVrStereoMode()}},{key:"isInVrStereoMode",value:function(){var e=this._pluginManager.get("vr");return!(!e||"function"!=typeof e.isInStereoMode)&&e.isInStereoMode()}},{key:"getLogLevel",value:function(e){return(0,k.getLogLevel)(e)}},{key:"setLogLevel",value:function(e,t){(0,k.setLogLevel)(e,t)}},{key:"_resetTextDisplay",value:function(){this._activeTextCues=[],this._updateTextDisplay([])}},{key:"_prepareVideoElement",value:function(){var e=this;te.EngineProvider.getEngines().forEach(function(t){t.prepareVideoElement(e._playerId)})}},{key:"_setConfigLogLevel",value:function(e){e.logLevel&&k.LogLevel[e.logLevel]&&(0,k.setLogLevel)(k.LogLevel[e.logLevel])}},{key:"_hasSources",value:function(e){return!!e&&!!Object.values(W.StreamType).find(function(t){return e[t]&&e[t].length>0})}},{key:"_createPlayerContainer",value:function(){var e=this._el=T.Dom.createElement("div");T.Dom.addClassName(e,"pakhshkit-container"),T.Dom.setAttribute(e,"id",this._playerId),T.Dom.setAttribute(e,"tabindex","-1")}},{key:"_appendEngineEl",value:function(){if(this._el){var e=this._engine.getVideoElement();T.Dom.addClassName(e,"pakhshkit-engine");var t="pakhshkit-engine-"+this._engine.id;T.Dom.addClassName(e,t),T.Dom.prependTo(e,this._el)}}},{key:"_appendDomElements",value:function(){this._textDisplayEl=T.Dom.createElement("div"),T.Dom.addClassName(this._textDisplayEl,"pakhshkit-subtitles"),T.Dom.appendChild(this._el,this._textDisplayEl),this._blackCoverEl=T.Dom.createElement("div"),T.Dom.addClassName(this._blackCoverEl,"pakhshkit-black-cover"),T.Dom.appendChild(this._el,this._blackCoverEl);var e=this._posterManager.getElement();T.Dom.addClassName(e,"pakhshkit-poster"),T.Dom.appendChild(this._el,e)}},{key:"_configureOrLoadPlugins",value:function(){var e=this,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};t&&Object.keys(t).forEach(function(n){var i=e._pluginManager.get(n);if(i)i.updateConfig(t[n]),e._config.plugins[n]=i.getConfig();else if(e._engine)delete e._config.plugins[n];else{try{e._pluginManager.load(n,e,t[n])}catch(t){e.dispatchEvent(t)}var r=e._pluginManager.get(n);r&&(e._config.plugins[n]=r.getConfig(),"function"==typeof r.getMiddlewareImpl&&e._playbackMiddleware.use(r.getMiddlewareImpl()))}})}},{key:"_createReadyPromise",value:function(){var e=this;this._readyPromise=new Promise(function(t,n){e._eventManager.listenOnce(e,y.CustomEventType.TRACKS_CHANGED,function(){e.dispatchEvent(new A.default(y.CustomEventType.MEDIA_LOADED)),t()}),e._eventManager.listen(e,y.Html5EventType.ERROR,n)}).catch(function(){})}},{key:"_selectEngineByPriority",value:function(){var e=this,n=this._config.playback.streamPriority,i=this._config.playback.preferNative,r=this._config.sources,a=!0,o=!1,u=void 0;try{for(var l,c=n[Symbol.iterator]();!(a=(l=c.next()).done);a=!0){var d=function(){var n=l.value,a="string"==typeof n.engine?n.engine.toLowerCase():"",o="string"==typeof n.format?n.format.toLowerCase():"",s=te.EngineProvider.getEngines().find(function(e){return e.id===a});if(s){var u=r[o];if(u&&u.length>0){var c=u[0];if(s.canPlaySource(c,i[o],e._config.drm))return t._logger.debug("Source selected: ",u),e._loadEngine(s,c),e._engineType=a,e._streamType=o,{v:!0}}}}();if("object"===(void 0===d?"undefined":s(d)))return d.v}}catch(e){o=!0,u=e}finally{try{!a&&c.return&&c.return()}finally{if(o)throw u}}return!1}},{key:"_loadEngine",value:function(e,t){this._engine?this._engine.id===e.id?this._engine.restore(t,this._config):(this._engine.destroy(),this._createEngine(e,t),this._appendEngineEl()):(this._createEngine(e,t),this._appendEngineEl())}},{key:"_createEngine",value:function(e,t){var n=e.createEngine(t,this._config),i=Object.values(this._pluginManager.getAll()),r=i.find(function(e){return"function"==typeof e.getEngineDecorator});this._engine=r?r.getEngineDecorator(n):n}},{key:"_attachMedia",value:function(){var e=this;this._engine&&(Object.keys(y.Html5EventType).forEach(function(t){e._eventManager.listen(e._engine,y.Html5EventType[t],function(t){return e.dispatchEvent(t)})}),this._eventManager.listen(this._engine,y.Html5EventType.SEEKED,function(){var t=e._env.browser.name;"Edge"!==t&&"IE"!==t||e._removeTextCuePatch()}),this._eventManager.listen(this._engine,y.CustomEventType.VIDEO_TRACK_CHANGED,function(t){return e._markActiveTrack(t.payload.selectedVideoTrack),e.dispatchEvent(t)}),this._eventManager.listen(this._engine,y.CustomEventType.AUDIO_TRACK_CHANGED,function(t){e.ready().then(function(){return e._playbackAttributesState.audioLanguage=t.payload.selectedAudioTrack.language}),e._markActiveTrack(t.payload.selectedAudioTrack),e.dispatchEvent(t)}),this._eventManager.listen(this._engine,y.CustomEventType.TEXT_TRACK_CHANGED,function(t){return e._onTextTrackChanged(t)}),this._eventManager.listen(this._engine,y.CustomEventType.TRACKS_CHANGED,function(t){return e._onTracksChanged(t)}),this._eventManager.listen(this._engine,y.CustomEventType.TEXT_CUE_CHANGED,function(t){return e._onCueChange(t)}),this._eventManager.listen(this._engine,y.CustomEventType.ABR_MODE_CHANGED,function(t){return e.dispatchEvent(t)}),this._eventManager.listen(this._engine,y.CustomEventType.TIMED_METADATA,function(t){return e.dispatchEvent(t)}),this._eventManager.listen(this._engine,y.CustomEventType.AUTOPLAY_FAILED,function(t){e.pause(),e._firstPlay&&e._config.playback.autoplay&&e.dispatchEvent(t)}),this._eventManager.listen(this._engine,y.CustomEventType.FPS_DROP,function(t){return e.dispatchEvent(t)}),this._eventManager.listen(this,y.Html5EventType.PLAY,this._onPlay.bind(this)),this._eventManager.listen(this,y.Html5EventType.PLAYING,this._onPlaying.bind(this)),this._eventManager.listen(this,y.Html5EventType.ENDED,this._onEnded.bind(this)),this._eventManager.listen(this,y.CustomEventType.PLAYBACK_ENDED,this._onPlaybackEnded.bind(this)),this._eventManager.listen(this,y.CustomEventType.MUTE_CHANGE,function(){e._playbackAttributesState.muted=e.muted}),this._eventManager.listen(this,y.Html5EventType.VOLUME_CHANGE,function(){e._playbackAttributesState.volume=e.volume}),this._eventManager.listen(this,y.Html5EventType.RATE_CHANGE,function(){e._playbackAttributesState.rate=e.playbackRate}),this._eventManager.listen(this,y.CustomEventType.ENTER_FULLSCREEN,function(){return e._resetTextCuesAndReposition()}),this._eventManager.listen(this,y.CustomEventType.EXIT_FULLSCREEN,function(){return e._resetTextCuesAndReposition()}),this._eventManager.listen(this._resizeWatcher,y.CustomEventType.RESIZE,function(t){e._resetTextCuesAndReposition(),e.dispatchEvent(t)}),this._eventManager.listen(this._engine,y.CustomEventType.MEDIA_RECOVERED,function(){return e._handleRecovered()}),this._eventManager.listen(this._externalCaptionsHandler,y.CustomEventType.TEXT_CUE_CHANGED,function(t){return e._onCueChange(t)}),this._eventManager.listen(this._externalCaptionsHandler,y.CustomEventType.TEXT_TRACK_CHANGED,function(t){return e._onTextTrackChanged(t)}),this._eventManager.listen(this._externalCaptionsHandler,y.Html5EventType.ERROR,function(t){return e.dispatchEvent(t)}),this._adsController&&this._eventManager.listen(this._adsController,oe.AdEventType.AD_BREAK_START,function(){e._firstPlay&&(e._posterManager.hide(),e._hideBlackCover())}))}},{key:"_handleRecovered",value:function(){this._stateManager.currentState.type===G.StateType.PLAYING&&this.play()}},{key:"_onTextTrackChanged",value:function(e){var t=this;this.ready().then(function(){return t._playbackAttributesState.textLanguage=e.payload.selectedTextTrack.language}),this._markActiveTrack(e.payload.selectedTextTrack),this._config.playback.useNativeTextTrack&&this._externalCaptionsHandler.selectTextTrack(e.payload.selectedTextTrack),this.dispatchEvent(e)}},{key:"_resetTextCuesAndReposition",value:function(){var e=this;this._engine.resetAllCues(),this._updateTextDisplay([]);for(var t=0;t<this._activeTextCues.length;t++)this._activeTextCues[t].hasBeenReset=!0;this._clearRepositionTimeout(),this._repositionCuesTimeout=setTimeout(function(){e._updateTextDisplay(e._activeTextCues),e._repositionCuesTimeout=!1},1e3)}},{key:"_clearRepositionTimeout",value:function(){this._repositionCuesTimeout&&clearTimeout(this._repositionCuesTimeout)}},{key:"_removeTextCuePatch",value:function(){var e=this,t=this._activeTextCues.filter(function(t){var n=t._endTime,i=t._startTime,r=e.currentTime;if(r<n&&r>i)return t});this._updateTextDisplay(t)}},{key:"_handlePlaybackOptions",value:function(){this._config.playback=this._config.playback||{},"boolean"==typeof this._playbackAttributesState.muted?this.muted=this._playbackAttributesState.muted:"boolean"==typeof this._config.playback.muted&&(this.muted=this._config.playback.muted),"number"==typeof this._playbackAttributesState.volume?this.volume=this._playbackAttributesState.volume:"number"==typeof this._config.playback.volume&&(this.volume=this._config.playback.volume),"boolean"==typeof this._config.playback.playsinline&&(this.playsinline=this._config.playback.playsinline),"string"==typeof this._config.playback.crossOrigin&&(this.crossOrigin=this._config.playback.crossOrigin)}},{key:"_handlePreload",value:function(){"auto"===this._config.playback.preload&&!this._config.playback.autoplay&&this._canPreload()&&this.load()}},{key:"_canPreload",value:function(){return!this._config.plugins||this._config.plugins&&!this._config.plugins.ima||this._config.plugins.ima&&this._config.plugins.ima.disable}},{key:"_handleAutoPlay",value:function(){var e=this;if(!0===this._config.playback.autoplay){var n=this._config.playback.allowMutedAutoPlay;t.getCapabilities(this.engineType).then(function(t){t.autoplay?i():t.mutedAutoPlay?e.muted&&!e._fallbackToMutedAutoPlay?r():n?a():o():o()})}else this._posterManager.show();var i=function(){t._logger.debug("Start autoplay"),e._fallbackToMutedAutoPlay&&(e._fallbackToMutedAutoPlay=!1,e.muted=!1),e.play()},r=function(){t._logger.debug("Start muted autoplay"),e.play()},a=function(){t._logger.debug("Fallback to muted autoplay"),e._fallbackToMutedAutoPlay=!0,e.muted=!0,e.dispatchEvent(new A.default(y.CustomEventType.FALLBACK_TO_MUTED_AUTOPLAY)),e.play()},o=function(){t._logger.warn("Autoplay failed, pause player"),e._posterManager.show(),e._canPreload()&&e.load(),e.ready().then(function(){return e.pause()}),e.dispatchEvent(new A.default(y.CustomEventType.AUTOPLAY_FAILED))}}},{key:"_maybeCreateAdsController",value:function(){if(!this._adsController){var e=this._controllerProvider.getAdsController();e&&(this._adsController=new ae.AdsController(this,e))}}},{key:"_playAfterAsyncMiddleware",value:function(){var e=this;this._engine?this._play():this._eventManager.listenOnce(this,y.CustomEventType.SOURCE_SELECTED,function(){return e._play()})}},{key:"_play",value:function(){var e=this;this._engine.src||this.load(),this.ready().then(function(){e.isLive()&&!e.isDvr()&&e.seekToLiveEdge(),e._engine.play()}).catch(function(t){e.dispatchEvent(new A.default(y.Html5EventType.ERROR,t))})}},{key:"_pause",value:function(){this._engine.pause()}},{key:"_onPlay",value:function(){this._firstPlay&&(this._firstPlay=!1,this.dispatchEvent(new A.default(y.CustomEventType.FIRST_PLAY)),this._posterManager.hide(),this._hideBlackCover(),"number"==typeof this._playbackAttributesState.rate&&(this.playbackRate=this._playbackAttributesState.rate))}},{key:"_onPlaying",value:function(){this._firstPlaying||(this._firstPlaying=!0,this.dispatchEvent(new A.default(y.CustomEventType.FIRST_PLAYING)))}},{key:"_hideBlackCover",value:function(){this._blackCoverEl&&(this._blackCoverEl.style.visibility="hidden")}},{key:"_showBlackCover",value:function(){this._blackCoverEl&&(this._blackCoverEl.style.visibility="visible")}},{key:"_onEnded",value:function(){var e=this;this._adsController&&!this._adsController.allAdsCompleted?this._eventManager.listenOnce(this._adsController,oe.AdEventType.ALL_ADS_COMPLETED,function(){e.dispatchEvent(new A.default(y.CustomEventType.PLAYBACK_ENDED))}):setTimeout(function(){return e.dispatchEvent(new A.default(y.CustomEventType.PLAYBACK_ENDED))},0),this.paused||this._pause()}},{key:"_onPlaybackEnded",value:function(){this.config.playback.loop&&(this.currentTime=0,this.play())}},{key:"_resetStateFlags",value:function(){this._loading=!1,this._firstPlay=!0,this._loadingMedia=!1,this._playbackStart=!1,this._firstPlaying=!1}},{key:"_onTracksChanged",value:function(e){this._updateTracks(e.payload.tracks),this.dispatchEvent(e)}},{key:"_updateTracks",value:function(e){t._logger.debug("Tracks changed",e),this._tracks=e.concat(this._externalCaptionsHandler.getExternalTracks(e)),this._addTextTrackOffOption(),this._maybeSetTracksLabels(),this._maybeAdjustTextTracksIndexes(),this._setDefaultTracks()}},{key:"_maybeAdjustTextTracksIndexes",value:function(){var e=this;if(this._config.playback.useNativeTextTrack){var t=function(t){var n=e.getVideoElement();return n?Array.from(n.textTracks).findIndex(function(e){return!!e&&e.language===t.language}):-1};this._getTracksByType(V.TrackType.TEXT).forEach(function(e){return e.index=t(e)})}}},{key:"_getTracksByType",value:function(e){return e?this._tracks.filter(function(t){return e===V.TrackType.VIDEO?t instanceof L.default:e===V.TrackType.AUDIO?t instanceof x.default:e!==V.TrackType.TEXT||t instanceof F.default}):this._tracks}},{key:"_markActiveTrack",value:function(e){var t=void 0;if(e instanceof L.default?t=V.TrackType.VIDEO:e instanceof x.default?t=V.TrackType.AUDIO:e instanceof F.default&&(t=V.TrackType.TEXT),t)for(var n=this._getTracksByType(t),i=0;i<n.length;i++)n[i].active=e.index===n[i].index}},{key:"_onCueChange",value:function(e){t._logger.debug("Text cue changed",e.payload.cues),this._activeTextCues=e.payload.cues,this._updateCueDisplaySettings(),this._updateTextDisplay(this._activeTextCues)}},{key:"_updateCueDisplaySettings",value:function(){for(var e=this._activeTextCues,t=this._textDisplaySettings,n=0;n<e.length;n++){var i=e[n];for(var r in t)i[r]=t[r]}}},{key:"_updateTextDisplay",value:function(e){this._config.playback.useNativeTextTrack||(0,B.processCues)(window,e,this._textDisplayEl,this._textStyle)}},{key:"_addTextTrackOffOption",value:function(){var e=this._getTracksByType(V.TrackType.TEXT);e&&e.length&&this._tracks.push(new F.default({active:!1,index:e.length,kind:"subtitles",label:"Off",language:ce}))}},{key:"_setDefaultTracks",value:function(){var e=this.getActiveTracks(),t=this.config.playback,n=this._getTracksByType(V.TrackType.TEXT).find(function(e){return F.default.langComparer(ce,e.language)}),i=this._playbackAttributesState.textLanguage||this._getLanguage(t.textLanguage,e.text,V.TrackType.TEXT),r=this._playbackAttributesState.audioLanguage||t.audioLanguage;this._setDefaultTrack(V.TrackType.TEXT,i,n),this._setDefaultTrack(V.TrackType.AUDIO,r,e.audio)}},{key:"_getLanguage",value:function(e,t,n){var i=e;if("auto"===i){var r=this._getTracksByType(n),a=r.find(function(e){return I.default.langComparer(b.default.language,e.language)});a?i=a.language:t&&t.language!==ce?i=t.language:r&&r.length>0&&(i=r[0].language)}return i}},{key:"_setDefaultTrack",value:function(e,t,n){var i=this._getTracksByType(e).find(function(e){return I.default.langComparer(t,e.language)});i?(this.selectTrack(i),this._markActiveTrack(i)):n&&!n.active&&this.selectTrack(n)}},{key:"_maybeSetTracksLabels",value:function(){var e=this._config.customLabels;if(e)for(var t in e)this._setTracksCustomLabels(this._getTracksByType(Y.LabelToTrackMap[t]),e[t])}},{key:"_setTracksCustomLabels",value:function(e,t){e.forEach(function(e){var n=t(T.Object.copyDeep(e));n&&(e.label=n)})}},{key:"buffered",get:function(){if(this._engine)return this._engine.buffered}},{key:"currentTime",set:function(e){if(this._engine&&T.Number.isNumber(e)){var t=e;e<0&&(t=0),t>this._engine.duration-.1&&(t=this._engine.duration-.1),this._engine.currentTime=t}},get:function(){if(this._engine)return this._engine.currentTime}},{key:"duration",get:function(){if(this._engine)return this._engine.duration}},{key:"volume",set:function(e){if(this._engine&&(T.Number.isFloat(e)||0===e||1===e)){var t=e;t<0&&(t=0),t>1&&(t=1),this._engine.volume=t}},get:function(){if(this._engine)return this._engine.volume}},{key:"paused",get:function(){if(this._engine)return this._engine.paused}},{key:"seeking",get:function(){if(this._engine)return this._engine.seeking}},{key:"playsinline",set:function(e){this._engine&&(this._engine.playsinline=e)},get:function(){if(this._engine)return this._engine.playsinline}},{key:"muted",set:function(e){this._engine&&(this._engine.muted=e,this.dispatchEvent(new A.default(y.CustomEventType.MUTE_CHANGE,{mute:e})),!1===e&&(this._fallbackToMutedAutoPlay=e))},get:function(){if(this._engine)return this._engine.muted}},{key:"src",get:function(){if(this._engine)return this._engine.src}},{key:"dimensions",get:function(){return{width:this._el.clientWidth,height:this._el.clientHeight}}},{key:"poster",get:function(){return this._posterManager.src}},{key:"playbackRate",set:function(e){this._engine&&(this._engine.playbackRate=e)},get:function(){if(this._engine)return this._engine.playbackRate}},{key:"playbackRates",get:function(){return this._engine?this._engine.playbackRates:[]}},{key:"defaultPlaybackRate",get:function(){return this._engine?this._engine.defaultPlaybackRate:1}},{key:"engineType",get:function(){return this._engineType}},{key:"streamType",get:function(){return this._streamType}},{key:"env",get:function(){return this._env}},{key:"config",get:function(){return T.Object.mergeDeep({},this._config)}},{key:"loadingMedia",set:function(e){this._loadingMedia=e}},{key:"crossOrigin",set:function(e){this._engine&&(this._engine.crossOrigin=e)},get:function(){if(this._engine)return this._engine.crossOrigin}},{key:"ended",get:function(){if(this._engine)return this._engine.ended}},{key:"textStyle",set:function(e){if(!(e instanceof H.default))throw new Error("Style must be instance of TextStyle");var n=T.Dom.getElementBySelector("."+this._playerId+".pakhshkit-subtitles-style");n||(n=T.Dom.createElement("style"),T.Dom.addClassName(n,this._playerId),T.Dom.addClassName(n,"pakhshkit-subtitles-style"),T.Dom.appendChild(document.head,n));for(var i=n.sheet;i.cssRules.length;)i.deleteRule(0);try{this._textStyle=e,this._config.playback.useNativeTextTrack?i.insertRule("#"+this._playerId+" video.pakhshkit-engine::cue { "+e.toCSS()+" }",0):this._engine&&(this._engine.resetAllCues(),this._externalCaptionsHandler.resetAllCues(),this._updateTextDisplay(this._activeTextCues)),this.dispatchEvent(new A.default(y.CustomEventType.TEXT_STYLE_CHANGED))}catch(e){t._logger.error(e.message)}},get:function(){return this._textStyle.clone()}},{key:"ads",get:function(){return this._adsController}},{key:"plugins",get:function(){return this._pluginManager.getAll()}},{key:"Event",get:function(){return y.EventType}},{key:"TextStyle",get:function(){return H.default}},{key:"State",get:function(){return G.StateType}},{key:"Track",get:function(){return V.TrackType}},{key:"LogLevelType",get:function(){return k.LogLevelType}},{key:"LogLevel",get:function(){return k.LogLevel}},{key:"AbrMode",get:function(){return z.AbrMode}},{key:"MediaType",get:function(){return X.MediaType}},{key:"StreamType",get:function(){return W.StreamType}},{key:"EngineType",get:function(){return K.EngineType}},{key:"CorsType",get:function(){return q.CorsType}},{key:"AdBreakType",get:function(){return ie.AdBreakType}},{key:"AdTagType",get:function(){return re.AdTagType}},{key:"Error",get:function(){return ee.default}}],[{key:"_defaultConfig",get:function(){return T.Object.copyDeep(J.DefaultConfig)}}]),t}(g.default);de._logger=(0,w.default)("Player"),de._playerCapabilities={},t.default=de},function(e,t,n){"use strict";function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function r(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.TextTrack=void 0;var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}(),s=n(7),u=function(e){return e&&e.__esModule?e:{default:e}}(s),l=function(e){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};i(this,t);var n=r(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n._label=n.label||n.language,n._kind=e.kind,n._external=e.external,n}return a(t,e),o(t,[{key:"kind",get:function(){return this._kind}},{key:"external",get:function(){return this._external}}]),t}(u.default);t.default=l,t.TextTrack=l},function(e,t,n){"use strict";function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function r(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}(),s=n(7),u=function(e){return e&&e.__esModule?e:{default:e}}(s),l=function(e){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};i(this,t);var n=r(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n._bandwidth=e.bandwidth,n._width=e.width,n._height=e.height,n._label=e.label?e.label:n._height?n._height+"p":void 0,n}return a(t,e),o(t,[{key:"bandwidth",get:function(){return this._bandwidth}},{key:"width",get:function(){return this._width}},{key:"height",get:function(){return this._height}}]),t}(u.default);t.default=l},function(e,t,n){"use strict";function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function r(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var o=n(7),s=function(e){return e&&e.__esModule?e:{default:e}}(o),u=function(e){function t(){return i(this,t),r(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return a(t,e),t}(s.default);t.default=u},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=n(40),r=function(e){return e&&e.__esModule?e:{default:e}}(i),a=(new r.default).getResult();t.default=a},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i={AD_CAN_SKIP:"adcanskip",AD_MANIFEST_LOADED:"admanifestloaded",AD_LOADED:"adloaded",AD_STARTED:"adstarted",AD_RESUMED:"adresumed",AD_PAUSED:"adpaused",AD_CLICKED:"adclicked",AD_SKIPPED:"adskipped",AD_COMPLETED:"adcompleted",AD_ERROR:"aderror",ALL_ADS_COMPLETED:"alladscompleted",AD_BREAK_START:"adbreakstart",AD_BREAK_END:"adbreakend",AD_FIRST_QUARTILE:"adfirstquartile",AD_MIDPOINT:"admidpoint",AD_THIRD_QUARTILE:"adthirdquartile",USER_CLOSED_AD:"userclosedad",AD_VOLUME_CHANGED:"advolumechanged",AD_MUTED:"admuted",AD_PROGRESS:"adprogress",AD_BUFFERING:"adbuffering"};t.AdEventType=i},function(e,t,n){"use strict";function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function r(e){return"string"==typeof e&&(!!u[e.toLowerCase()]&&e.toLowerCase())}function a(e){return"string"==typeof e&&(!!l[e.toLowerCase()]&&e.toLowerCase())}Object.defineProperty(t,"__esModule",{value:!0}),t.Cue=void 0;var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}(),s=n(21),u={"":!0,lr:!0,rl:!0},l={start:!0,middle:!0,end:!0,left:!0,right:!0},c=function(){function e(t,n,r){i(this,e),this.hasBeenReset=!1,this.displayState=void 0,this._id="",this._pauseOnExit=!1,this._region=null,this._vertical="",this._snapToLines=!0,this._line="auto",this._lineAlign="start",this._position=50,this._positionAlign="middle",this._size=50,this._align="middle",this._startTime=t,this._endTime=n,this._text=r}return o(e,[{key:"resetCue",value:function(){this.hasBeenReset=!0}},{key:"getCueAsHTML",value:function(){return(0,s.convertCueToDOMTree)(window,this.text)}},{key:"id",get:function(){return this._id},set:function(e){this._id=""+e}},{key:"pauseOnExit",get:function(){return this._pauseOnExit},set:function(e){this._pauseOnExit=e}},{key:"startTime",get:function(){return this._startTime},set:function(e){if("number"!=typeof e)throw new TypeError("Start time must be set to a number.");this._startTime=e,this.resetCue()}},{key:"endTime",get:function(){return this._endTime},set:function(e){if("number"!=typeof e)throw new TypeError("End time must be set to a number.");this._endTime=e,this.resetCue()}},{key:"text",get:function(){return this._text},set:function(e){this._text=""+e,this.resetCue()}},{key:"region",get:function(){return this._region},set:function(e){this._region=e,this.resetCue()}},{key:"vertical",get:function(){return this._vertical},set:function(e){var t=r(e);if(!1===t)throw new SyntaxError("An invalid or illegal string was specified.");"string"==typeof t&&(this._vertical=t,this.resetCue())}},{key:"snapToLines",get:function(){return this._snapToLines},set:function(e){this._snapToLines=e,this.resetCue()}},{key:"line",get:function(){return this._line},set:function(e){if("number"!=typeof e&&"auto"!==e)throw new SyntaxError("An invalid number or illegal string was specified.");this._line=e,this.resetCue()}},{key:"lineAlign",get:function(){return this._lineAlign},set:function(e){var t=a(e);if(!t)throw new SyntaxError("An invalid or illegal string was specified.");"string"==typeof t&&(this._lineAlign=t,this.resetCue())}},{key:"position",get:function(){return this._position},set:function(e){if(e<0||e>100)throw new Error("Position must be between 0 and 100.");this._position=e,this.resetCue()}},{key:"positionAlign",get:function(){return this._positionAlign},set:function(e){var t=a(e);if(!t)throw new SyntaxError("An invalid or illegal string was specified.");"string"==typeof t&&(this._positionAlign=t,this.resetCue())}},{key:"size",get:function(){return this._size},set:function(e){if(e<0||e>100)throw new Error("Size must be between 0 and 100.");this._size=e,this.resetCue()}},{key:"align",get:function(){return this._align},set:function(e){var t=a(e);if(!t)throw new SyntaxError("An invalid or illegal string was specified.");"string"==typeof t&&(this._align=t,this.resetCue())}}]),e}(),d=void 0;"undefined"!=typeof window&&window.VTTCue?t.Cue=d=window.VTTCue:t.Cue=d=c,t.Cue=d},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i={VIDEO:"video",AUDIO:"audio",TEXT:"text"};t.TrackType=i},function(e,t,n){"use strict";function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var r=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}(),a=function(){function e(){i(this,e),this._map=new Map}return r(e,[{key:"push",value:function(e,t){if(this._map.has(e)){var n=this._map.get(e);Array.isArray(n)&&(n.push(t),this._map.set(e,n))}else this._map.set(e,[t])}},{key:"set",value:function(e,t){this._map.set(e,t)}},{key:"has",value:function(e){return this._map.has(e)}},{key:"get",value:function(e){var t=this._map.get(e);return t?t.slice():[]}},{key:"getAll",value:function(){var e=[],t=!0,n=!1,i=void 0;try{for(var r,a=this._map.values()[Symbol.iterator]();!(t=(r=a.next()).done);t=!0){var o=r.value;e=e.concat(o)}}catch(e){n=!0,i=e}finally{try{!t&&a.return&&a.return()}finally{if(n)throw i}}return e}},{key:"remove",value:function(e,t){if(this._map.has(e)){var n=this._map.get(e);if(Array.isArray(n))for(var i=0;i<n.length;++i)n[i]==t&&(n.splice(i,1),--i)}}},{key:"keys",value:function(){return this._map.keys()}},{key:"clear",value:function(){this._map.clear()}}]),e}();t.default=a},function(e,t,n){"use strict";function i(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.registerPlugin=void 0;var a=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}(),o=n(18),s=i(o),u=n(2),l=i(u),c=n(8),d=(i(c),n(0)),f=i(d),h=(0,f.default)("PluginManager"),_=function(){function e(){r(this,e),this._plugins={},this._isDisabledPluginMap=new Map}return a(e,[{key:"load",value:function(t,n){var i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};if(!e._registry.has(t))throw h.warn("Plugin <"+t+"> loading failed, plugin is not registered"),new l.default(l.default.Severity.RECOVERABLE,l.default.Category.PLAYER,l.default.Code.RUNTIME_ERROR_NOT_REGISTERED_PLUGIN,t);var r=e._registry.get(t);"boolean"==typeof i.disable&&this._isDisabledPluginMap.set(t,i.disable);var a=!!this._isDisabledPluginMap.get(t),o=!!r&&r.isValid();return r&&o&&!a?(this._plugins[t]=r.createPlugin(t,n,i),this._isDisabledPluginMap.set(t,!1),h.debug("Plugin <"+t+"> has been loaded"),!0):(h.debug("Plugin <"+t+"> isn't loaded, isValid()="+o.toString()+", disabled="+a.toString()),!1)}},{key:"loadMedia",value:function(){var e=this;Object.keys(this._plugins).forEach(function(t){return e._plugins[t].loadMedia()})}},{key:"destroy",value:function(){var e=this;Object.keys(this._plugins).forEach(function(t){e._plugins[t].destroy(),delete e._plugins[t]})}},{key:"reset",value:function(){var e=this;Object.keys(this._plugins).forEach(function(t){return e._plugins[t].reset()})}},{key:"get",value:function(e){return this._plugins[e]}},{key:"getAll",value:function(){return this._plugins}}],[{key:"register",value:function(t,n){return"function"!=typeof n||n.prototype instanceof s.default==!1?(h.error("Plugin <"+t+"> registration failed, either plugin is not an instance of BasePlugin or plugin handler is not a function"),!1):e._registry.has(t)?(h.debug("Plugin <"+t+"> is already registered, do not register again"),!1):(e._registry.set(t,n),h.debug("Plugin <"+t+"> has been registered successfully"),!0)}},{key:"unRegister",value:function(t){e._registry.has(t)&&(e._registry.delete(t),h.debug("Unregistered <"+t+"> plugin."))}}]),e}();_._registry=new Map,t.default=_;var p=_.register;t.registerPlugin=p},function(e,t,n){"use strict";function i(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var a=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}(),o=n(8),s=(i(o),n(0)),u=i(s),l=n(5),c=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}(l),d=n(4),f=i(d),h=n(2),_=i(h),p=n(1),A=i(p),v=function(){function e(t,n,i){r(this,e),this.name=t,this.player=n,this.eventManager=new f.default,this.logger=(0,u.default)(c.String.capitlize(this.name)),this.config={},c.Object.mergeDeep(this.config,this.constructor.defaultConfig,i)}return a(e,null,[{key:"createPlugin",value:function(e,t){return new this(e,t,arguments.length>2&&void 0!==arguments[2]?arguments[2]:{})}},{key:"isValid",value:function(){throw new _.default(_.default.Severity.CRITICAL,_.default.Category.PLAYER,_.default.Code.RUNTIME_ERROR_METHOD_NOT_IMPLEMENTED,"isValid()")}}]),a(e,[{key:"getConfig",value:function(e){return e?c.Object.copyDeep(this.config[e]):c.Object.copyDeep(this.config)}},{key:"updateConfig",value:function(e){c.Object.mergeDeep(this.config,e)}},{key:"loadMedia",value:function(){}},{key:"destroy",value:function(){}},{key:"reset",value:function(){}},{key:"getName",value:function(){return this.name}},{key:"dispatchEvent",value:function(e,t){this.logger.debug("Fire event: "+e,t),this.player.dispatchEvent(new A.default(e,t))}}]),e}();v.defaultConfig={},t.default=v},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i={IDLE:"idle",LOADING:"loading",PLAYING:"playing",PAUSED:"paused",BUFFERING:"buffering"};t.StateType=i},function(e,t,n){"use strict";function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var r=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}(),a=function(){function e(){i(this,e),this.fontSize="100%",this.fontScale=1,this.fontFamily=e.FontFamily.SANS_SERIF,this.fontColor=e.StandardColors.WHITE,this.fontOpacity=e.StandardOpacities.OPAQUE,this.backgroundColor=e.StandardColors.BLACK,this.backgroundOpacity=e.StandardOpacities.OPAQUE,this.fontEdge=e.EdgeStyles.NONE}return r(e,[{key:"getTextShadow",value:function(){for(var t=[],n=0;n<this.fontEdge.length;n++){var i=this.fontEdge[n].slice(0,3),r=this.fontEdge[n].slice(3,6);t.push(e.toRGBA(i,this.fontOpacity)+" "+r.join("px ")+"px")}return t.join(",")}},{key:"toCSS",value:function(){var t=[];return t.push("font-family: "+this.fontFamily),t.push("color: "+e.toRGBA(this.fontColor,this.fontOpacity)),t.push("background-color: "+e.toRGBA(this.backgroundColor,this.backgroundOpacity)),t.push("text-shadow: "+this.getTextShadow()),t.join("!important; ")}},{key:"clone",value:function(){var t=new e;return t.fontEdge=this.fontEdge,t.fontSize=this.fontSize,t.fontScale=this.fontScale,t.fontColor=this.fontColor,t.fontOpacity=this.fontOpacity,t.backgroundColor=this.backgroundColor,t.backgroundOpacity=this.backgroundOpacity,t.fontFamily=this.fontFamily,t}},{key:"isEqual",value:function(e){return e.fontEdge===this.fontEdge&&e.fontSize===this.fontSize&&e.fontColor===this.fontColor&&e.fontOpacity===this.fontOpacity&&e.backgroundColor===this.backgroundColor&&e.backgroundOpacity===this.backgroundOpacity}},{key:"implicitFontScale",get:function(){return.25*this.fontScale+1}}],[{key:"toRGBA",value:function(e,t){return"rgba("+e.concat(t).join(",")+")"}}]),e}();a.FontFamily={ARIAL:"Arial",HELVETICA:"Helvetica",VERDANA:"Verdana",SANS_SERIF:"sans-serif"},a.StandardColors={WHITE:[255,255,255],BLACK:[0,0,0],RED:[255,0,0],GREEN:[0,255,0],BLUE:[0,0,255],YELLOW:[255,255,0],MAGENTA:[255,0,255],CYAN:[0,255,255]},a.StandardOpacities={OPAQUE:1,SEMI_HIGH:.75,SEMI_LOW:.25,TRANSPARENT:0},a.EdgeStyles={NONE:[],RAISED:[[34,34,34,1,1,0],[34,34,34,2,2,0],[34,34,34,3,3,0]],DEPRESSED:[[204,204,204,1,1,0],[204,204,204,0,1,0],[34,34,34,-1,-1,0],[34,34,34,0,-1,0]],UNIFORM:[[34,34,34,0,0,4],[34,34,34,0,0,4],[34,34,34,0,0,4],[34,34,34,0,0,4]],DROP:[[34,34,34,2,2,3],[34,34,34,2,2,4],[34,34,34,2,2,5]]},a.FontSizes=[{value:-2,label:"50%"},{value:-1,label:"75%"},{value:0,label:"100%"},{value:2,label:"200%"},{value:3,label:"300%"},{value:4,label:"400%"}],t.default=a},function(e,t,n){"use strict";function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function r(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e){function t(e,t,n,i){return 3600*(0|e)+60*(0|t)+(0|n)+(0|i)/1e3}var n=e.match(/^(\d+):(\d{2})(:\d{2})?\.(\d{3})/);return n?n[3]?t(n[1],n[2],n[3].replace(":",""),n[4]):n[1]>59?t(n[1],n[2],0,n[4]):t(0,n[1],n[2],n[4]):null}function s(){this.values=x(null)}function u(e,t,n,i){var r=i?e.split(i):[e];for(var a in r)if("string"==typeof r[a]){var o=r[a].split(n);if(2===o.length){var s=o[0],u=o[1];t(s,u)}}}function l(e,t,n){function i(){var t=o(e);if(null===t)throw new v(v.Errors.BadTimeStamp,"Malformed timestamp: "+a);return e=e.replace(/^[^\sa-zA-Z-]+/,""),t}function r(){e=e.replace(/^\s+/,"")}var a=e;if(r(),t.startTime=i(),r(),"--\x3e"!==e.substr(0,3))throw new v(v.Errors.BadTimeStamp,"Malformed time stamp (time stamps must be separated by '--\x3e'): "+a);e=e.substr(3),r(),t.endTime=i(),r(),function(e,t){var i=new s;u(e,function(e,t){switch(e){case"region":for(var r=n.length-1;r>=0;r--)if(n[r].id===t){i.set(e,n[r].region);break}break;case"vertical":i.alt(e,t,["rl","lr"]);break;case"line":var a=t.split(","),o=a[0];i.integer(e,o),i.percent(e,o)&&i.set("snapToLines",!1),i.alt(e,o,["auto"]),2===a.length&&i.alt("lineAlign",a[1],["start","middle","end"]);break;case"position":a=t.split(","),i.percent(e,a[0]),2===a.length&&i.alt("positionAlign",a[1],["start","middle","end"]);break;case"size":i.percent(e,t);break;case"align":i.alt(e,t,["start","middle","end","left","right"])}},/:/,/\s/),t.region=i.get("region",null),t.vertical=i.get("vertical",""),t.line=i.get("line",t.line||"auto"),t.lineAlign=i.get("lineAlign","start"),t.snapToLines=i.get("snapToLines",!0),t.size=i.get("size",100),t.align=i.get("align","middle"),t.position=i.get("position",t.position||"auto"),t.positionAlign=i.get("positionAlign",{start:"start",left:"start",middle:"middle",end:"end",right:"end"},t.align)}(e,t)}function c(e,t){function n(e){return k[e]}for(var i=e.document.createElement("div"),r=i,a=void 0,s=[];null!==(a=function(){if(!t)return null;var e=t.match(/^([^<]*)(<[^>]+>?)?/);return function(e){return t=t.substr(e.length),e}(e[1]?e[1]:e[2])}());)if("<"!==a[0])r.appendChild(e.document.createTextNode(function(e){for(var t=void 0;t=e.match(/&(amp|lt|gt|lrm|rlm|nbsp);/);)e=e.replace(t[0],n);return e}(a)));else{if("/"===a[1]){s.length&&s[s.length-1]===a.substr(2).replace(">","")&&(s.pop(),r=r.parentNode);continue}var u=o(a.substr(1,a.length-2)),l=void 0;if(u){l=e.document.createProcessingInstruction("timestamp",u),r.appendChild(l);continue}var c=a.match(/^<([^.\s\/0-9>]+)(\.[^\s\\>]+)?([^>\\]+)?(\\?)>?$/);if(!c)continue;if(!(l=function(t,n){var i=w[t];if(!i)return null;var r=e.document.createElement(i),a=S[t];return a&&n&&(r[a]=n.trim()),r}(c[1],c[3])))continue;if(!function(e,t){return!C[t.localName]||C[t.localName]===e.localName}(r,l))continue;c[2]&&(l.className=c[2].substr(1).replace("."," ")),s.push(c[1]),r.appendChild(l),r=l}return i}function d(e){for(var t=0;t<O.length;t++){var n=O[t];if(e>=n[0]&&e<=n[1])return!0}return!1}function f(e){function t(e,t){for(var n=t.childNodes.length-1;n>=0;n--)e.push(t.childNodes[n])}function n(e){if(!e||!e.length)return null;var i=e.pop(),r=i.textContent||i.innerText;if(r){var a=r.match(/^.*(\n|\r)/);return a?(e.length=0,a[0]):r}return"ruby"===i.tagName?n(e):i.childNodes?(t(e,i),n(e)):void 0}var i=[],r="",a=void 0;if(!e||!e.childNodes)return"ltr";for(t(i,e);r=n(i);)for(var o=0;o<r.length;o++)if(a=r.charCodeAt(o),d(a))return"rtl";return"ltr"}function h(e){if("number"==typeof e.line&&(e.snapToLines||e.line>=0&&e.line<=100))return e.line;if(!e.track||!e.track.textTrackList||!e.track.textTrackList.mediaElement)return-1;for(var t=e.track,n=t.textTrackList,i=0,r=0;r<n.length&&n[r]!==t;r++)"showing"===n[r].mode&&i++;return-1*++i}function _(e,t,n){var i=new P(e),r=e.cue,a=h(r),o=[];if(r.snapToLines){var s=void 0;switch(r.vertical){case"":o=["+y","-y"],s="height";break;case"rl":o=["+x","-x"],s="width";break;case"lr":o=["-x","+x"],s="width"}var u=i.lineHeight,l=u*Math.round(a),c=t[s]+u,d=o[0];Math.abs(l)>c&&(l=l<0?-1:1,l*=Math.ceil(c/u)*u),a<0&&(l+=""===r.vertical?t.height:t.width,o=o.reverse()),i.move(d,l)}else{var f=i.lineHeight/t.height*100;switch(r.lineAlign){case"middle":a-=f/2;break;case"end":a-=f}switch(r.vertical){case"":e.applyStyles({top:e.formatStyle(a,"%")});break;case"rl":e.applyStyles({left:e.formatStyle(a,"%")});break;case"lr":e.applyStyles({right:e.formatStyle(a,"%")})}o=["+y","-x","+x","-y"],i=new P(e)}var _=function(e,i){for(var r=void 0,a=new P(e),o=1,s=0;s<i.length;s++){for(;e.overlapsOppositeAxis(t,i[s])||e.within(t)&&e.overlapsAny(n);)e.move(i[s]);if(e.within(t))return e;var u=e.intersectPercentage(t);o>u&&(r=new P(e),o=u),e=new P(a)}return r||a}(i,o);e.move(_.toCSSCompatValues(t))}function p(e,t){return e&&t?c(e,t):null}function A(e,t,n,i){if(!e||!t||!n)return null;for(;n.firstChild;)n.removeChild(n.firstChild);var r=e.document.createElement("div");if(r.style.position="absolute",r.style.left="0",r.style.right="0",r.style.top="0",r.style.bottom="0",r.style.margin=N,n.appendChild(r),function(e){for(var t=0;t<e.length;t++)if(e[t].hasBeenReset||!e[t].displayState)return!0;return!1}(t)){var a=[],o=P.getSimpleBoxPosition(r),s=o.height<o.width?o.height:o.width,u=Math.round(s*I*100)/100,l={font:u*b*i.implicitFontScale+"px "+i.fontFamily,color:m.default.toRGBA(i.fontColor,i.fontOpacity),backgroundColor:m.default.toRGBA(i.backgroundColor,i.backgroundOpacity),textShadow:i.getTextShadow()};!function(){for(var n=void 0,i=void 0,s=0;s<t.length;s++)i=t[s],n=new D(e,i,l),r.appendChild(n.div),_(n,o,a),i.displayState=n.div,a.push(P.getSimpleBoxPosition(n))}()}else for(var c=0;c<t.length;c++)r.appendChild(t[c].displayState)}function v(e,t){this.name="ParsingError",this.code=e.code,this.message=t||e.message}Object.defineProperty(t,"__esModule",{value:!0}),t.StringDecoder=t.Parser=t.convertCueToDOMTree=t.processCues=void 0;var g=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}(),y=n(14),E=n(51),T=n(20),m=function(e){return e&&e.__esModule?e:{default:e}}(T),b=1,k={"&amp;":"&","&lt;":"<","&gt;":">","&lrm;":"‎","&rlm;":"‏","&nbsp;":" "},w={c:"span",i:"i",b:"b",u:"u",ruby:"ruby",rt:"rt",v:"span",lang:"span"},S={v:"title",lang:"lang"},C={rt:"ruby"};s.prototype={set:function(e,t){this.get(e)||""===t||(this.values[e]=t)},get:function(e,t,n){return n?this.has(e)?this.values[e]:t[n]:this.has(e)?this.values[e]:t},has:function(e){return e in this.values},alt:function(e,t,n){for(var i=0;i<n.length;++i)if(t===n[i]){this.set(e,t);break}},integer:function(e,t){/^-?\d+$/.test(t)&&this.set(e,parseInt(t,10))},percent:function(e,t){return!!(t.match(/^([\d]{1,3})(\.[\d]*)?%$/)&&(t=parseFloat(t))>=0&&t<=100)&&(this.set(e,t),!0)}};var O=[[1470,1470],[1472,1472],[1475,1475],[1478,1478],[1488,1514],[1520,1524],[1544,1544],[1547,1547],[1549,1549],[1563,1563],[1566,1610],[1645,1647],[1649,1749],[1765,1766],[1774,1775],[1786,1805],[1807,1808],[1810,1839],[1869,1957],[1969,1969],[1984,2026],[2036,2037],[2042,2042],[2048,2069],[2074,2074],[2084,2084],[2088,2088],[2096,2110],[2112,2136],[2142,2142],[2208,2208],[2210,2220],[8207,8207],[64285,64285],[64287,64296],[64298,64310],[64312,64316],[64318,64318],[64320,64321],[64323,64324],[64326,64449],[64467,64829],[64848,64911],[64914,64967],[65008,65020],[65136,65140],[65142,65276],[67584,67589],[67592,67592],[67594,67637],[67639,67640],[67644,67644],[67647,67669],[67671,67679],[67840,67867],[67872,67897],[67903,67903],[67968,68023],[68030,68031],[68096,68096],[68112,68115],[68117,68119],[68121,68147],[68160,68167],[68176,68184],[68192,68223],[68352,68405],[68416,68437],[68440,68466],[68472,68479],[68608,68680],[126464,126467],[126469,126495],[126497,126498],[126500,126500],[126503,126503],[126505,126514],[126516,126519],[126521,126521],[126523,126523],[126530,126530],[126535,126535],[126537,126537],[126539,126539],[126541,126543],[126545,126546],[126548,126548],[126551,126551],[126553,126553],[126555,126555],[126557,126557],[126559,126559],[126561,126562],[126564,126564],[126567,126570],[126572,126578],[126580,126583],[126585,126588],[126590,126590],[126592,126601],[126603,126619],[126625,126627],[126629,126633],[126635,126651],[1114109,1114109]],R=function(){function e(){a(this,e)}return g(e,[{key:"applyStyles",value:function(e,t){t=t||this.div;for(var n in e)e.hasOwnProperty(n)&&(t.style[n]=e[n])}},{key:"formatStyle",value:function(e,t){return 0===e?0:e+t}}]),e}(),D=function(e){function t(e,n,r){a(this,t);var o=i(this,(t.__proto__||Object.getPrototypeOf(t)).call(this)),s="undefined"!=typeof navigator&&/MSIE\s8\.0/.test(navigator.userAgent);"undefined"!=typeof WebVTTSet&&(WebVTTSet.fontSet,WebVTTSet.backgroundSet,WebVTTSet.edgeSet),s&&"rgb(255, 255, 255)",o.cue=n,o.cueDiv=c(e,n.text);var u={color:r.color,backgroundColor:r.backgroundColor,textShadow:r.textShadow,position:"relative",left:0,right:0,top:0,bottom:0,display:"inline"};s||(u.writingMode=""===n.vertical?"horizontal-tb":"lr"===n.vertical?"vertical-lr":"vertical-rl",u.unicodeBidi="plaintext"),o.applyStyles(u,o.cueDiv),o.div=e.document.createElement("div"),u={textAlign:"middle"===n.align?"center":n.align,font:r.font,whiteSpace:"pre-line",position:"absolute"},s||(u.direction=f(o.cueDiv),u.writingMode=""===n.vertical?"horizontal-tb":"lr"===n.vertical?"vertical-lr":"vertical-rl".stylesunicodeBidi="plaintext"),o.applyStyles(u),o.div.appendChild(o.cueDiv);var l=0;switch(n.positionAlign){case"start":l=n.position;break;case"middle":l=n.position-n.size/2;break;case"end":l=n.position-n.size}return""===n.vertical?o.applyStyles({left:o.formatStyle(l,"%"),width:o.formatStyle(n.size,"%")}):o.applyStyles({top:o.formatStyle(l,"%"),height:o.formatStyle(n.size,"%")}),o.move=function(e){this.applyStyles({top:this.formatStyle(e.top,"px"),bottom:this.formatStyle(e.bottom,"px"),left:this.formatStyle(e.left,"px"),right:this.formatStyle(e.right,"px"),height:this.formatStyle(e.height,"px"),width:this.formatStyle(e.width,"px")})},o}return r(t,e),t}(R),P=function(){function e(t){a(this,e),this.overlaps=function(e){return this.left<e.right&&this.right>e.left&&this.top<e.bottom&&this.bottom>e.top};var n="undefined"!=typeof navigator&&/MSIE\s8\.0/.test(navigator.userAgent),i=void 0,r=void 0,o=void 0,s=void 0;if(t.div){r=t.div.offsetHeight,o=t.div.offsetWidth,s=t.div.offsetTop;var u=(u=t.div.childNodes)&&(u=u[0])&&u.getClientRects&&u.getClientRects();t=t.div.getBoundingClientRect(),i=u?Math.max(u[0]&&u[0].height||0,t.height/u.length):0}this.left=t.left,this.right=t.right,this.top=t.top||s,this.height=t.height||r,this.bottom=t.bottom||s+(t.height||r),this.width=t.width||o,this.lineHeight=void 0!==i?i:t.lineHeight,n&&!this.lineHeight&&(this.lineHeight=13)}return g(e,[{key:"move",value:function(e,t){switch(t=void 0!==t?t:this.lineHeight,e){case"+x":this.left+=t,this.right+=t;break;case"-x":this.left-=t,this.right-=t;break;case"+y":this.top+=t,this.bottom+=t;break;case"-y":this.top-=t,this.bottom-=t}}},{key:"overlapsAny",value:function(e){for(var t=0;t<e.length;t++)if(this.overlaps(e[t]))return!0;return!1}},{key:"within",value:function(e){return this.top>=e.top&&this.bottom<=e.bottom&&this.left>=e.left&&this.right<=e.right}},{key:"overlapsOppositeAxis",value:function(e,t){switch(t){case"+x":return this.left<e.left;case"-x":return this.right>e.right;case"+y":return this.top<e.top;case"-y":return this.bottom>e.bottom}}},{key:"intersectPercentage",value:function(e){return Math.max(0,Math.min(this.right,e.right)-Math.max(this.left,e.left))*Math.max(0,Math.min(this.bottom,e.bottom)-Math.max(this.top,e.top))/(this.height*this.width)}},{key:"toCSSCompatValues",value:function(e){return{top:this.top-e.top,bottom:e.bottom-this.bottom,left:this.left-e.left,right:e.right-this.right,height:this.height,width:this.width}}}],[{key:"getSimpleBoxPosition",value:function(e){var t=e.div?e.div.offsetHeight:e.tagName?e.offsetHeight:0,n=e.div?e.div.offsetWidth:e.tagName?e.offsetWidth:0,i=e.div?e.div.offsetTop:e.tagName?e.offsetTop:0;return e=e.div?e.div.getBoundingClientRect():e.tagName?e.getBoundingClientRect():e,{left:e.left,right:e.right,top:e.top||i,height:e.height||t,bottom:e.bottom||i+(e.height||t),width:e.width||n}}}]),e}(),I=.058,N="1.5%",L=function(e,t){this.window=e,this.state="INITIAL",this.buffer="",this.decoder=t||new TextDecoder("utf8"),this.regionList=[]},M=function(){return{decode:function(e){if(!e)return"";if("string"!=typeof e)throw new Error("Error - expected string data.");return decodeURIComponent(encodeURIComponent(e))}}},x=Object.create||function(){function e(){}return function(t){if(1!==arguments.length)throw new Error("Object.create shim only accepts one parameter.");return e.prototype=t,new e}}();v.prototype=x(Error.prototype),v.prototype.constructor=v,v.Errors={BadSignature:{code:0,message:"Malformed WebVTT signature."},BadTimeStamp:{code:1,message:"Malformed time stamp."}},L.prototype={reportOrThrowError:function(e){if(!(e instanceof v))throw e;this.onparsingerror&&this.onparsingerror(e)},parse:function(e){function t(){for(var e=i.buffer,t=0;t<e.length&&"\r"!==e[t]&&"\n"!==e[t];)++t;var n=e.substr(0,t);return"\r"===e[t]&&++t,"\n"===e[t]&&++t,i.buffer=e.substr(t),n}function n(e){var t=new s;if(u(e,function(e,n){switch(e){case"id":t.set(e,n);break;case"width":t.percent(e,n);break;case"lines":t.integer(e,n);break;case"regionanchor":case"viewportanchor":var i=n.split(",");if(2!==i.length)break;var r=new s;if(r.percent("x",i[0]),r.percent("y",i[1]),!r.has("x")||!r.has("y"))break;t.set(e+"X",r.get("x")),t.set(e+"Y",r.get("y"));break;case"scroll":t.alt(e,n,["up"])}},/=/,/\s/),t.has("id")){var n=new E.Region;n.width=t.get("width",100),n.lines=t.get("lines",3),n.regionAnchorX=t.get("regionanchorX",0),n.regionAnchorY=t.get("regionanchorY",100),n.viewportAnchorX=t.get("viewportanchorX",0),n.viewportAnchorY=t.get("viewportanchorY",100),n.scroll=t.get("scroll",""),i.onregion&&i.onregion(n),i.regionList.push({id:t.get("id"),region:n})}}var i=this;e&&(i.buffer+=i.decoder.decode(e,{stream:!0}));try{var r;if("INITIAL"===i.state){if(!/\r\n|\n/.test(i.buffer))return this;r=t();var a=r.match(/^WEBVTT([ \t].*)?$/);if(!a||!a[0])throw new v(v.Errors.BadSignature);i.state="HEADER"}for(var o=!1;i.buffer;){if(!/\r\n|\n/.test(i.buffer))return this;switch(o?o=!1:r=t(),i.state){case"HEADER":/:/.test(r)?function(e){u(e,function(e,t){switch(e){case"Region":n(t)}},/:/)}(r):r||(i.state="ID");continue;case"NOTE":r||(i.state="ID");continue;case"ID":if(/^NOTE($|[ \t])/.test(r)){i.state="NOTE";break}if(!r)continue;if(i.cue=new y.Cue(0,0,""),i.state="CUE",-1===r.indexOf("--\x3e")){i.cue.id=r;continue}case"CUE":try{l(r,i.cue,i.regionList)}catch(e){i.reportOrThrowError(e),i.cue=null,i.state="BADCUE";continue}i.state="CUETEXT";continue;case"CUETEXT":var c=-1!==r.indexOf("--\x3e");if(!r||c&&(o=!0)){i.oncue&&i.oncue(i.cue),i.cue=null,i.state="ID";continue}i.cue.text&&(i.cue.text+="\n"),i.cue.text+=r;continue;case"BADCUE":r||(i.state="ID");continue}}}catch(e){i.reportOrThrowError(e),"CUETEXT"===i.state&&i.cue&&i.oncue&&i.oncue(i.cue),i.cue=null,i.state="INITIAL"===i.state?"BADWEBVTT":"BADCUE"}return this},flush:function(){var e=this;try{if(e.buffer+=e.decoder.decode(),(e.cue||"HEADER"===e.state)&&(e.buffer+="\n\n",e.parse()),"INITIAL"===e.state)throw new v(v.Errors.BadSignature)}catch(t){e.reportOrThrowError(t)}return e.onflush&&e.onflush(),this}},t.processCues=A,t.convertCueToDOMTree=p,t.Parser=L,t.StringDecoder=M},function(e,t,n){"use strict";function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var r=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}(),a=function(){function e(){i(this,e)}return r(e,[{key:"callNext",value:function(e){e&&e()}}]),e}();t.default=a},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});t.DrmScheme={WIDEVINE:"com.widevine.alpha",PLAYREADY:"com.microsoft.playready",FAIRPLAY:"com.apple.fairplay"}},function(e,t,n){"use strict";function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var r=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}(),a=function(){function e(t){i(this,e),this.type=t,this._duration=0,this._timestamp=Date.now()/1e3}return r(e,[{key:"duration",get:function(){return this._duration},set:function(e){this._duration=e-this._timestamp}}]),e}();t.default=a},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i={DASH:"dash",HLS:"hls",PROGRESSIVE:"progressive"};t.StreamType=i},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i={HTML5:"html5",FLASH:"flash",SILVERLIGHT:"silverlight",CAST:"cast"};t.EngineType=i},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i={VOD:"Vod",LIVE:"Live",AUDIO:"Audio",UNKNOWN:"Unknown"};t.MediaType=i},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i={MANUAL:"manual",AUTO:"auto"};t.AbrMode=i},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i={ANONYMOUS:"anonymous",USE_CREDENTIALS:"use-credentials"};t.CorsType=i},function(e,t,n){"use strict";function i(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.EngineProvider=t.unRegisterEngine=t.registerEngine=void 0;var a=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}(),o=n(0),s=i(o),u=n(62),l=i(u),c=function(){function e(){r(this,e)}return a(e,null,[{key:"register",value:function(t,n){t&&!e._engineProviders[t]?(e._logger.debug("Engine <"+t+"> has been registered successfully"),e._engineProviders[t]=n):e._logger.debug("Engine <"+t+"> is already registered, do not register again")}},{key:"unRegister",value:function(t){e._engineProviders[t]&&(e._logger.debug("Unregistered <"+t+"> Engine"),delete e._engineProviders[t])}},{key:"getEngines",value:function(){return Object.keys(e._engineProviders).map(function(t){return e._engineProviders[t]})}},{key:"destroy",value:function(){e._engineProviders={}}}]),e}();c._logger=(0,s.default)("EngineProvider"),c._engineProviders={},l.default.isSupported()&&c.register(l.default.id,l.default);var d=c.register,f=c.unRegister;t.registerEngine=d,t.unRegisterEngine=f,t.EngineProvider=c},function(e,t,n){"use strict";function i(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.registerMediaSourceAdapter=void 0;var a=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}(),o=n(63),s=i(o),u=n(0),l=i(u),c=function(){function e(){r(this,e)}return a(e,null,[{key:"register",value:function(t){t&&(e._mediaSourceAdapters.includes(t)?e._logger.debug("Adapter <"+t.id+"> is already registered, do not register again"):(e._logger.debug("Adapter <"+t.id+"> has been registered successfully"),e._mediaSourceAdapters.push(t)))}},{key:"unRegister",value:function(t){var n=e._mediaSourceAdapters.indexOf(t);n>-1&&(e._logger.debug("Unregistered <"+t.id+"> adapter"),e._mediaSourceAdapters.splice(n,1))}},{key:"canPlaySource",value:function(t){var n=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],i=arguments[2];e._orderMediaSourceAdapters(n);var r=e._mediaSourceAdapters;if(t&&t.mimetype)for(var a=0;a<r.length;a++)if(r[a].canPlayType(t.mimetype)&&(!t.drmData||r[a].canPlayDrm(t.drmData,i)))return e._selectedAdapter=r[a],e._logger.debug("Selected adapter is <"+e._selectedAdapter.id+">"),!0;return!1}},{key:"_orderMediaSourceAdapters",value:function(t){e._mediaSourceAdapters=e._mediaSourceAdapters.filter(function(e){return"NativeAdapter"!==e.id}),t?e._mediaSourceAdapters.unshift(s.default):e._mediaSourceAdapters.push(s.default)}},{key:"getMediaSourceAdapter",value:function(t,n,i){return t&&n&&i?(e._selectedAdapter||e.canPlaySource(n,!0,i.drm),e._selectedAdapter?e._selectedAdapter.createAdapter(t,n,i):null):null}},{key:"destroy",value:function(){e._selectedAdapter=null}}]),e}();c._logger=(0,l.default)("MediaSourceProvider"),c._mediaSourceAdapters=[s.default],c._selectedAdapter=null,t.default=c;var d=c.register;t.registerMediaSourceAdapter=d},function(e,t,n){"use strict";function i(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}(),u=n(1),l=i(u),c=n(6),d=i(c),f=n(2),h=i(f),_=n(3),p=n(0),A=i(p),v=n(7),g=(i(v),n(10)),y=i(g),E=n(11),T=i(E),m=n(9),b=i(m),k=function(e){function t(e,n){var i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};r(this,t);var o=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this));return o._capabilities={fpsControl:!1},o._videoElement=e,o._sourceObj=n,o._config=i,o._handleLiveTimeUpdate(),o}return o(t,e),s(t,null,[{key:"isSupported",value:function(){return!0}}]),s(t,[{key:"destroy",value:function(){return this._sourceObj=null,this._config={},Promise.resolve()}},{key:"_onTrackChanged",value:function(e){e instanceof y.default?this._trigger(_.CustomEventType.VIDEO_TRACK_CHANGED,{selectedVideoTrack:e}):e instanceof T.default?this._trigger(_.CustomEventType.AUDIO_TRACK_CHANGED,{selectedAudioTrack:e}):e instanceof b.default&&this._trigger(_.CustomEventType.TEXT_TRACK_CHANGED,{selectedTextTrack:e})}},{key:"_trigger",value:function(e,t){this.dispatchEvent(new l.default(e,t))}},{key:"load",value:function(){return t._throwNotImplementedError("load")}},{key:"selectVideoTrack",value:function(e){return t._throwNotImplementedError("selectVideoTrack")}},{key:"selectAudioTrack",value:function(e){t._throwNotImplementedError("selectAudioTrack")}},{key:"selectTextTrack",value:function(e){t._throwNotImplementedError("selectTextTrack")}},{key:"hideTextTrack",value:function(){t._throwNotImplementedError("hideTextTrack")}},{key:"enableAdaptiveBitrate",value:function(){t._throwNotImplementedError("enableAdaptiveBitrate")}},{key:"isAdaptiveBitrateEnabled",value:function(){return t._throwNotImplementedError("isAdaptiveBitrateEnabled")}},{key:"_getLiveEdge",value:function(){return t._throwNotImplementedError("_getLiveEdge")}},{key:"seekToLiveEdge",value:function(){t._throwNotImplementedError("seekToLiveEdge")}},{key:"isLive",value:function(){return t._throwNotImplementedError("isLive")}},{key:"setMaxBitrate",value:function(e){}},{key:"_handleLiveTimeUpdate",value:function(){var e=this;this._videoElement.addEventListener(_.Html5EventType.DURATION_CHANGE,function(){e.isLive()&&e._videoElement.paused&&e._trigger(_.Html5EventType.TIME_UPDATE)})}},{key:"handleMediaError",value:function(e){return!1}},{key:"getStartTimeOfDvrWindow",value:function(){return t._throwNotImplementedError("getStartTimeOfDvrWindow")}},{key:"currentTime",get:function(){return this.isLive()?this._videoElement.currentTime-this.getStartTimeOfDvrWindow():this._videoElement.currentTime},set:function(e){this.isLive()&&(e+=this.getStartTimeOfDvrWindow()),this._videoElement.currentTime=e}},{key:"duration",get:function(){return this.isLive()?this._getLiveEdge()-this.getStartTimeOfDvrWindow():this._videoElement.duration}},{key:"src",get:function(){return this._loadPromise&&this._sourceObj?this._sourceObj.url:""},set:function(e){!this._loadPromise&&this._sourceObj&&(this._sourceObj.url=e)}},{key:"capabilities",get:function(){return this._capabilities}}],[{key:"canPlayType",value:function(e,n){return t._throwNotImplementedError("static canPlayType")}},{key:"_throwNotImplementedError",value:function(e){throw new h.default(h.default.Severity.CRITICAL,h.default.Category.PLAYER,h.default.Code.RUNTIME_ERROR_METHOD_NOT_IMPLEMENTED,e)}}]),t}(d.default);k.getLogger=A.default,t.default=k},function(e,t,n){"use strict";function i(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var a=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}(),o=n(0),s=i(o),u=n(2),l=i(u),c=n(66),d=i(c),f=n(23),h=function(){function e(){r(this,e)}return a(e,null,[{key:"isConfigured",value:function(e,t){throw new l.default(l.default.Severity.CRITICAL,l.default.Category.PLAYER,l.default.Code.RUNTIME_ERROR_METHOD_NOT_IMPLEMENTED,"static isConfigured")}},{key:"canPlayDrm",value:function(e){throw new l.default(l.default.Severity.CRITICAL,l.default.Category.PLAYER,l.default.Code.RUNTIME_ERROR_METHOD_NOT_IMPLEMENTED,"static canPlayDrm")}},{key:"setDrmPlayback",value:function(){throw new l.default(l.default.Severity.CRITICAL,l.default.Category.PLAYER,l.default.Code.RUNTIME_ERROR_METHOD_NOT_IMPLEMENTED,"static setDrmPlayback")}}]),e}();h.getLogger=s.default,h.DrmSupport=d.default,h.DrmScheme=f.DrmScheme,t.default=h},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i={PRE:"preroll",MID:"midroll",POST:"postroll",OVERLAY:"overlay"};t.AdBreakType=i},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i={VAST:"vast",VMAP:"vmap"};t.AdTagType=i},function(e,t,n){"use strict";function i(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.AdsController=void 0;var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}(),u=n(8),l=(i(u),n(13)),c=n(4),d=i(c),f=n(6),h=i(f),_=n(1),p=(i(_),n(3)),A=n(2),v=i(A),g=(n(37),n(38),function(e){function t(e,n){r(this,t);var i=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this));return i._player=e,i._adsPluginController=n,i._initMembers(),i._addBindings(),i}return o(t,e),s(t,[{key:"isAdBreak",value:function(){return!!this._adBreak}},{key:"getAdBreaksLayout",value:function(){return this._adBreaksLayout}},{key:"getAdBreak",value:function(){return this._adBreak}},{key:"getAd",value:function(){return this._ad}},{key:"skipAd",value:function(){this._adsPluginController.skipAd()}},{key:"playAdNow",value:function(e){this._adsPluginController.playAdNow(e)}},{key:"_initMembers",value:function(){this._allAdsCompleted=!0,this._adBreaksLayout=[],this._adBreak=null,this._ad=null}},{key:"_addBindings",value:function(){var e=this;this._eventManager=new d.default,this._eventManager.listen(this._player,l.AdEventType.AD_MANIFEST_LOADED,function(t){return e._onAdManifestLoaded(t)}),this._eventManager.listen(this._player,l.AdEventType.AD_BREAK_START,function(t){return e._onAdBreakStart(t)}),this._eventManager.listen(this._player,l.AdEventType.AD_LOADED,function(t){return e._onAdLoaded(t)}),this._eventManager.listen(this._player,l.AdEventType.AD_BREAK_END,function(){return e._onAdBreakEnd()}),this._eventManager.listen(this._player,l.AdEventType.ALL_ADS_COMPLETED,function(t){return e._onAllAdsCompleted(t)}),this._eventManager.listen(this._player,l.AdEventType.AD_ERROR,function(t){return e._onAdError(t)}),this._eventManager.listen(this._player,p.CustomEventType.PLAYER_RESET,function(){return e._reset()}),this._eventManager.listen(this._player,p.Html5EventType.ENDED,function(){return e._onEnded()})}},{key:"_onAdManifestLoaded",value:function(e){this._adBreaksLayout=e.payload.adBreaksPosition,this._allAdsCompleted=!1}},{key:"_onAdBreakStart",value:function(e){this._adBreak=e.payload.adBreak,this.dispatchEvent(e)}},{key:"_onAdLoaded",value:function(e){this._ad=e.payload.ad}},{key:"_onAdBreakEnd",value:function(){this._adBreak=null,this._ad=null}},{key:"_onAllAdsCompleted",value:function(e){this._allAdsCompleted=!0,this.dispatchEvent(e)}},{key:"_onAdError",value:function(e){e.payload.severity===v.default.Severity.CRITICAL&&(this._allAdsCompleted=!0)}},{key:"_onEnded",value:function(){this._allAdsCompleted||this._adBreaksLayout.includes(-1)||(this._allAdsCompleted=!0)}},{key:"_reset",value:function(){this._initMembers()}},{key:"allAdsCompleted",get:function(){return this._allAdsCompleted}}]),t}(h.default));t.AdsController=g},function(e,t,n){"use strict";function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var r=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}(),a=function(){function e(t){i(this,e),this._type=t.type,this._position=t.position,this._numAds=t.numAds}return r(e,[{key:"toJSON",value:function(){return{type:this.type,position:this.position,numAds:this.numAds}}},{key:"type",get:function(){return this._type}},{key:"position",get:function(){return this._position}},{key:"numAds",get:function(){return this._numAds}}]),e}();t.AdBreak=a},function(e,t,n){"use strict";function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var r=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}(),a=function(){function e(t,n){i(this,e),this._id=t,this._system=n.system,this._url=n.url,this._contentType=n.contentType,this._title=n.title,this._position=n.position,this._duration=n.duration,this._clickThroughUrl=n.clickThroughUrl,this._posterUrl=n.posterUrl,this._skipOffset=n.skipOffset,this._linear=n.linear,this._width=n.width||0,this._height=n.height||0,this._bitrate=n.bitrate||0}return r(e,[{key:"toJSON",value:function(){return{id:this.id,system:this.system,url:this.url,contentType:this.contentType,title:this.title,position:this.position,duration:this.duration,clickThroughUrl:this.clickThroughUrl,posterUrl:this.posterUrl,skipOffset:this.skipOffset,linear:this.linear,skippable:this.skippable,width:this.width,height:this.height,bitrate:this.bitrate}}},{key:"id",get:function(){return this._id}},{key:"system",get:function(){return this._system}},{key:"contentType",get:function(){return this._contentType}},{key:"url",get:function(){return this._url}},{key:"title",get:function(){return this._title}},{key:"position",get:function(){return this._position}},{key:"duration",get:function(){return this._duration}},{key:"clickThroughUrl",get:function(){return this._clickThroughUrl}},{key:"posterUrl",get:function(){return this._posterUrl}},{key:"skipOffset",get:function(){return this._skipOffset}},{key:"linear",get:function(){return this._linear}},{key:"width",get:function(){return this._width}},{key:"height",get:function(){return this._height}},{key:"bitrate",get:function(){return this._bitrate}},{key:"skippable",get:function(){return!!(this.skipOffset&&this.skipOffset>0)}}]),e}();t.Ad=a},function(e,t,n){"use strict";function i(e){return e&&e.__esModule?e:{default:e}}function r(e){return new o.default(e||{})}Object.defineProperty(t,"__esModule",{value:!0}),t.BaseEngineDecorator=t.setLogLevel=t.getLogLevel=t.LogLevel=t.getLogger=t.MimeType=t.DrmScheme=t.CorsType=t.LogLevelType=t.AbrMode=t.StreamType=t.MediaType=t.EngineType=t.TrackType=t.StateType=t.EventType=t.CustomEventType=t.Html5EventType=t.AdEventType=t.AdsController=t.AdTagType=t.AdBreakType=t.AdBreak=t.Ad=t.unRegisterEngine=t.registerEngine=t.setCapabilities=t.getCapabilities=t.BaseDrmProtocol=t.State=t.Env=t.PLAYER_NAME=t.VERSION=t.EventManager=t.FakeEventTarget=t.FakeEvent=t.Error=t.Utils=t.TextStyle=t.TextTrack=t.AudioTrack=t.VideoTrack=t.Track=t.BaseMiddleware=t.BasePlugin=t.registerPlugin=t.BaseMediaSourceAdapter=t.registerMediaSourceAdapter=void 0,t.loadPlayer=r;var a=n(8),o=i(a),s=n(32),u=i(s),l=n(31),c=n(30),d=n(17),f=n(33),h=i(f),_=n(22),p=i(_),A=n(18),v=i(A),g=n(24),y=i(g),E=n(7),T=i(E),m=n(10),b=i(m),k=n(11),w=i(k),S=n(9),C=i(S),O=n(20),R=i(O),D=n(12),P=i(D),I=n(5),N=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}(I),L=n(2),M=i(L),x=n(1),U=i(x),F=n(6),j=i(F),H=n(4),B=i(H),G=n(19),V=n(15),Y=n(25),W=n(26),K=n(27),X=n(3),z=n(28),q=n(0),Q=i(q),Z=n(29),J=n(23),$=n(76),ee=n(38),te=n(37),ne=n(34),ie=n(35),re=n(36),ae=n(13),oe=n(77);t.registerMediaSourceAdapter=l.registerMediaSourceAdapter,t.BaseMediaSourceAdapter=u.default,t.registerPlugin=d.registerPlugin,t.BasePlugin=v.default,t.BaseMiddleware=p.default,t.Track=T.default,t.VideoTrack=b.default,t.AudioTrack=w.default,t.TextTrack=C.default,t.TextStyle=R.default,t.Utils=N,t.Error=M.default,t.FakeEvent=U.default,t.FakeEventTarget=j.default,t.EventManager=B.default,t.VERSION="0.46.2",t.PLAYER_NAME="@pakhshkit-js/pakhshkit-js",t.Env=P.default,t.State=y.default,t.BaseDrmProtocol=h.default;var se=o.default.getCapabilities,ue=o.default.setCapabilities;t.getCapabilities=se,t.setCapabilities=ue,t.registerEngine=c.registerEngine,t.unRegisterEngine=c.unRegisterEngine,t.Ad=ee.Ad,t.AdBreak=te.AdBreak,t.AdBreakType=ne.AdBreakType,t.AdTagType=ie.AdTagType,t.AdsController=re.AdsController,t.AdEventType=ae.AdEventType,t.Html5EventType=X.Html5EventType,t.CustomEventType=X.CustomEventType,t.EventType=X.EventType,t.StateType=G.StateType,t.TrackType=V.TrackType,t.EngineType=W.EngineType,t.MediaType=K.MediaType,t.StreamType=Y.StreamType,t.AbrMode=z.AbrMode,t.LogLevelType=q.LogLevelType,t.CorsType=Z.CorsType,t.DrmScheme=J.DrmScheme,t.MimeType=$.MimeType,t.getLogger=Q.default,t.LogLevel=q.LogLevel,t.getLogLevel=q.getLogLevel,t.setLogLevel=q.setLogLevel,t.BaseEngineDecorator=oe.BaseEngineDecorator,t.default=r},function(e,t,n){var i;!function(r,a){"use strict";var o="model",s="name",u="type",l="vendor",c="version",d="mobile",f="tablet",h={extend:function(e,t){var n={};for(var i in e)t[i]&&t[i].length%2==0?n[i]=t[i].concat(e[i]):n[i]=e[i];return n},has:function(e,t){return"string"==typeof e&&-1!==t.toLowerCase().indexOf(e.toLowerCase())},lowerize:function(e){return e.toLowerCase()},major:function(e){return"string"==typeof e?e.replace(/[^\d\.]/g,"").split(".")[0]:void 0},trim:function(e){return e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,"")}},_={rgx:function(e,t){for(var n,i,r,a,o,s,u=0;u<t.length&&!o;){var l=t[u],c=t[u+1];for(n=i=0;n<l.length&&!o;)if(o=l[n++].exec(e))for(r=0;r<c.length;r++)s=o[++i],a=c[r],"object"==typeof a&&a.length>0?2==a.length?"function"==typeof a[1]?this[a[0]]=a[1].call(this,s):this[a[0]]=a[1]:3==a.length?"function"!=typeof a[1]||a[1].exec&&a[1].test?this[a[0]]=s?s.replace(a[1],a[2]):void 0:this[a[0]]=s?a[1].call(this,s,a[2]):void 0:4==a.length&&(this[a[0]]=s?a[3].call(this,s.replace(a[1],a[2])):void 0):this[a]=s||void 0;u+=2}},str:function(e,t){for(var n in t)if("object"==typeof t[n]&&t[n].length>0){for(var i=0;i<t[n].length;i++)if(h.has(t[n][i],e))return"?"===n?void 0:n}else if(h.has(t[n],e))return"?"===n?void 0:n;return e}},p={browser:{oldsafari:{version:{"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"}}},device:{amazon:{model:{"Fire Phone":["SD","KF"]}},sprint:{model:{"Evo Shift 4G":"7373KT"},vendor:{HTC:"APA",Sprint:"Sprint"}}},os:{windows:{version:{ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2000:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"}}}},A={browser:[[/(opera\smini)\/([\w\.-]+)/i,/(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,/(opera).+version\/([\w\.]+)/i,/(opera)[\/\s]+([\w\.]+)/i],[s,c],[/(opios)[\/\s]+([\w\.]+)/i],[[s,"Opera Mini"],c],[/\s(opr)\/([\w\.]+)/i],[[s,"Opera"],c],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]+)*/i,/(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,/(?:ms|\()(ie)\s([\w\.]+)/i,/(rekonq)\/([\w\.]+)*/i,/(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser)\/([\w\.-]+)/i],[s,c],[/(trident).+rv[:\s]([\w\.]+).+like\sgecko/i],[[s,"IE"],c],[/(edge)\/((\d+)?[\w\.]+)/i],[s,c],[/(yabrowser)\/([\w\.]+)/i],[[s,"Yandex"],c],[/(puffin)\/([\w\.]+)/i],[[s,"Puffin"],c],[/(uc\s?browser)[\/\s]?([\w\.]+)/i,/ucweb.+(ucbrowser)[\/\s]?([\w\.]+)/i,/juc.+(ucweb)[\/\s]?([\w\.]+)/i,/(ucbrowser)\/([\w\.]+)/i],[[s,"UCBrowser"],c],[/(comodo_dragon)\/([\w\.]+)/i],[[s,/_/g," "],c],[/(micromessenger)\/([\w\.]+)/i],[[s,"WeChat"],c],[/m?(qqbrowser)[\/\s]?([\w\.]+)/i],[s,c],[/xiaomi\/miuibrowser\/([\w\.]+)/i],[c,[s,"MIUI Browser"]],[/;fbav\/([\w\.]+);/i],[c,[s,"Facebook"]],[/(headlesschrome) ([\w\.]+)/i],[c,[s,"Chrome Headless"]],[/\swv\).+(chrome)\/([\w\.]+)/i],[[s,/(.+)/,"$1 WebView"],c],[/android.+samsungbrowser\/([\w\.]+)/i,/android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i],[c,[s,"Android Browser"]],[/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i],[s,c],[/(dolfin)\/([\w\.]+)/i],[[s,"Dolphin"],c],[/((?:android.+)crmo|crios)\/([\w\.]+)/i],[[s,"Chrome"],c],[/(coast)\/([\w\.]+)/i],[[s,"Opera Coast"],c],[/fxios\/([\w\.-]+)/i],[c,[s,"Firefox"]],[/version\/([\w\.]+).+?mobile\/\w+\s(safari)/i],[c,[s,"Mobile Safari"]],[/version\/([\w\.]+).+?(mobile\s?safari|safari)/i],[c,s],[/webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i],[s,[c,_.str,p.browser.oldsafari.version]],[/(konqueror)\/([\w\.]+)/i,/(webkit|khtml)\/([\w\.]+)/i],[s,c],[/(navigator|netscape)\/([\w\.-]+)/i],[[s,"Netscape"],c],[/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,/(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix)\/([\w\.-]+)/i,/(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,/(links)\s\(([\w\.]+)/i,/(gobrowser)\/?([\w\.]+)*/i,/(ice\s?browser)\/v?([\w\._]+)/i,/(mosaic)[\/\s]([\w\.]+)/i],[s,c]],cpu:[[/(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i],[["architecture","amd64"]],[/(ia32(?=;))/i],[["architecture",h.lowerize]],[/((?:i[346]|x)86)[;\)]/i],[["architecture","ia32"]],[/windows\s(ce|mobile);\sppc;/i],[["architecture","arm"]],[/((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i],[["architecture",/ower/,"",h.lowerize]],[/(sun4\w)[;\)]/i],[["architecture","sparc"]],[/((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+;))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i],[["architecture",h.lowerize]]],device:[[/\((ipad|playbook);[\w\s\);-]+(rim|apple)/i],[o,l,[u,f]],[/applecoremedia\/[\w\.]+ \((ipad)/],[o,[l,"Apple"],[u,f]],[/(apple\s{0,1}tv)/i],[[o,"Apple TV"],[l,"Apple"]],[/(archos)\s(gamepad2?)/i,/(hp).+(touchpad)/i,/(hp).+(tablet)/i,/(kindle)\/([\w\.]+)/i,/\s(nook)[\w\s]+build\/(\w+)/i,/(dell)\s(strea[kpr\s\d]*[\dko])/i],[l,o,[u,f]],[/(kf[A-z]+)\sbuild\/[\w\.]+.*silk\//i],[o,[l,"Amazon"],[u,f]],[/(sd|kf)[0349hijorstuw]+\sbuild\/[\w\.]+.*silk\//i],[[o,_.str,p.device.amazon.model],[l,"Amazon"],[u,d]],[/\((ip[honed|\s\w*]+);.+(apple)/i],[o,l,[u,d]],[/\((ip[honed|\s\w*]+);/i],[o,[l,"Apple"],[u,d]],[/(blackberry)[\s-]?(\w+)/i,/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|huawei|meizu|motorola|polytron)[\s_-]?([\w-]+)*/i,/(hp)\s([\w\s]+\w)/i,/(asus)-?(\w+)/i],[l,o,[u,d]],[/\(bb10;\s(\w+)/i],[o,[l,"BlackBerry"],[u,d]],[/android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone)/i],[o,[l,"Asus"],[u,f]],[/(sony)\s(tablet\s[ps])\sbuild\//i,/(sony)?(?:sgp.+)\sbuild\//i],[[l,"Sony"],[o,"Xperia Tablet"],[u,f]],[/(?:sony)?(?:(?:(?:c|d)\d{4})|(?:so[-l].+))\sbuild\//i],[[l,"Sony"],[o,"Xperia Phone"],[u,d]],[/\s(ouya)\s/i,/(nintendo)\s([wids3u]+)/i],[l,o,[u,"console"]],[/android.+;\s(shield)\sbuild/i],[o,[l,"Nvidia"],[u,"console"]],[/(playstation\s[34portablevi]+)/i],[o,[l,"Sony"],[u,"console"]],[/(sprint\s(\w+))/i],[[l,_.str,p.device.sprint.vendor],[o,_.str,p.device.sprint.model],[u,d]],[/(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i],[l,o,[u,f]],[/(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i,/(zte)-(\w+)*/i,/(alcatel|geeksphone|huawei|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]+)*/i],[l,[o,/_/g," "],[u,d]],[/(nexus\s9)/i],[o,[l,"HTC"],[u,f]],[/(nexus\s6p)/i],[o,[l,"Huawei"],[u,d]],[/(microsoft);\s(lumia[\s\w]+)/i],[l,o,[u,d]],[/[\s\(;](xbox(?:\sone)?)[\s\);]/i],[o,[l,"Microsoft"],[u,"console"]],[/(kin\.[onetw]{3})/i],[[o,/\./g," "],[l,"Microsoft"],[u,d]],[/\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?(:?\s4g)?)[\w\s]+build\//i,/mot[\s-]?(\w+)*/i,/(XT\d{3,4}) build\//i,/(nexus\s6)/i],[o,[l,"Motorola"],[u,d]],[/android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i],[o,[l,"Motorola"],[u,f]],[/hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i],[[l,h.trim],[o,h.trim],[u,"smarttv"]],[/hbbtv.+maple;(\d+)/i],[[o,/^/,"SmartTV"],[l,"Samsung"],[u,"smarttv"]],[/\(dtv[\);].+(aquos)/i],[o,[l,"Sharp"],[u,"smarttv"]],[/android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,/((SM-T\w+))/i],[[l,"Samsung"],o,[u,f]],[/smart-tv.+(samsung)/i],[l,[u,"smarttv"],o],[/((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,/(sam[sung]*)[\s-]*(\w+-?[\w-]*)*/i,/sec-((sgh\w+))/i],[[l,"Samsung"],o,[u,d]],[/sie-(\w+)*/i],[o,[l,"Siemens"],[u,d]],[/(maemo|nokia).*(n900|lumia\s\d+)/i,/(nokia)[\s_-]?([\w-]+)*/i],[[l,"Nokia"],o,[u,d]],[/android\s3\.[\s\w;-]{10}(a\d{3})/i],[o,[l,"Acer"],[u,f]],[/android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i],[[l,"LG"],o,[u,f]],[/(lg) netcast\.tv/i],[l,o,[u,"smarttv"]],[/(nexus\s[45])/i,/lg[e;\s\/-]+(\w+)*/i],[o,[l,"LG"],[u,d]],[/android.+(ideatab[a-z0-9\-\s]+)/i],[o,[l,"Lenovo"],[u,f]],[/linux;.+((jolla));/i],[l,o,[u,d]],[/((pebble))app\/[\d\.]+\s/i],[l,o,[u,"wearable"]],[/android.+;\s(oppo)\s?([\w\s]+)\sbuild/i],[l,o,[u,d]],[/crkey/i],[[o,"Chromecast"],[l,"Google"]],[/android.+;\s(glass)\s\d/i],[o,[l,"Google"],[u,"wearable"]],[/android.+;\s(pixel c)\s/i],[o,[l,"Google"],[u,f]],[/android.+;\s(pixel xl|pixel)\s/i],[o,[l,"Google"],[u,d]],[/android.+(\w+)\s+build\/hm\1/i,/android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,/android.+(mi[\s\-_]*(?:one|one[\s_]plus|note lte)?[\s_]*(?:\d\w)?)\s+build/i],[[o,/_/g," "],[l,"Xiaomi"],[u,d]],[/android.+a000(1)\s+build/i],[o,[l,"OnePlus"],[u,d]],[/\s(tablet)[;\/]/i,/\s(mobile)(?:[;\/]|\ssafari)/i],[[u,h.lowerize],l,o]],engine:[[/windows.+\sedge\/([\w\.]+)/i],[c,[s,"EdgeHTML"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i,/(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,/(icab)[\/\s]([23]\.[\d\.]+)/i],[s,c],[/rv\:([\w\.]+).*(gecko)/i],[c,s]],os:[[/microsoft\s(windows)\s(vista|xp)/i],[s,c],[/(windows)\snt\s6\.2;\s(arm)/i,/(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s]+\w)*/i,/(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i],[s,[c,_.str,p.os.windows.version]],[/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i],[[s,"Windows"],[c,_.str,p.os.windows.version]],[/\((bb)(10);/i],[[s,"BlackBerry"],c],[/(blackberry)\w*\/?([\w\.]+)*/i,/(tizen)[\/\s]([\w\.]+)/i,/(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]+)*/i,/linux;.+(sailfish);/i],[s,c],[/(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]+)*/i],[[s,"Symbian"],c],[/\((series40);/i],[s],[/mozilla.+\(mobile;.+gecko.+firefox/i],[[s,"Firefox OS"],c],[/(nintendo|playstation)\s([wids34portablevu]+)/i,/(mint)[\/\s\(]?(\w+)*/i,/(mageia|vectorlinux)[;\s]/i,/(joli|[kxln]?ubuntu|debian|[open]*suse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]+)*/i,/(hurd|linux)\s?([\w\.]+)*/i,/(gnu)\s?([\w\.]+)*/i],[s,c],[/(cros)\s[\w]+\s([\w\.]+\w)/i],[[s,"Chromium OS"],c],[/(sunos)\s?([\w\.]+\d)*/i],[[s,"Solaris"],c],[/\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]+)*/i],[s,c],[/(haiku)\s(\w+)/i],[s,c],[/(ip[honead]+)(?:.*os\s([\w]+)*\slike\smac|;\sopera)/i],[[s,"iOS"],[c,/_/g,"."]],[/(mac\sos\sx)\s?([\w\s\.]+\w)*/i,/(macintosh|mac(?=_powerpc)\s)/i],[[s,"Mac OS"],[c,/_/g,"."]],[/((?:open)?solaris)[\/\s-]?([\w\.]+)*/i,/(aix)\s((\d)(?=\.|\)|\s)[\w\.]*)*/i,/(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms)/i,/(unix)\s?([\w\.]+)*/i],[s,c]]},v=function(e,t){this[s]=e,this[c]=t},g=function(e){this.architecture=e},y=function(e,t,n){this[l]=e,this[o]=t,this[u]=n},E=v,T=v,m=function(e,t){if(!(this instanceof m))return new m(e,t).getResult();var n=e||(r&&r.navigator&&r.navigator.userAgent?r.navigator.userAgent:""),i=t?h.extend(A,t):A,a=new v,o=new g,s=new y,u=new E,l=new T;return this.getBrowser=function(){return _.rgx.call(a,n,i.browser),a.major=h.major(a.version),a},this.getCPU=function(){return _.rgx.call(o,n,i.cpu),o},this.getDevice=function(){return _.rgx.call(s,n,i.device),s},this.getEngine=function(){return _.rgx.call(u,n,i.engine),u},this.getOS=function(){return _.rgx.call(l,n,i.os),l},this.getResult=function(){return{ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}},this.getUA=function(){return n},this.setUA=function(e){return n=e,a=new v,o=new g,s=new y,u=new E,l=new T,this},this};m.VERSION="0.7.13",m.BROWSER={NAME:s,MAJOR:"major",VERSION:c},m.CPU={ARCHITECTURE:"architecture"},m.DEVICE={MODEL:o,VENDOR:l,TYPE:u,CONSOLE:"console",MOBILE:d,SMARTTV:"smarttv",TABLET:f,WEARABLE:"wearable",EMBEDDED:"embedded"},m.ENGINE={NAME:s,VERSION:c},m.OS={NAME:s,VERSION:c},void 0!==t?(void 0!==e&&e.exports&&(t=e.exports=m),t.UAParser=m):n(41)?void 0!==(i=function(){return m}.call(t,n,t,e))&&(e.exports=i):r.UAParser=m;var b=r.jQuery||r.Zepto;if(void 0!==b){var k=new m;b.ua=k.getResult(),b.ua.get=function(){return k.getUA()},b.ua.set=function(e){k.setUA(e);var t=k.getResult();for(var n in t)b.ua[n]=t[n]}}}("object"==typeof window?window:this)},function(e,t){(function(t){e.exports=t}).call(t,{})},function(e,t,n){"use strict";function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var r=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}(),a=n(5),o=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}(a),s=function(){function e(){i(this,e),this._createEl()}return r(e,[{key:"setSrc",value:function(e){e&&(this._posterUrl=e,o.Dom.setStyle(this._el,"background-image",'url("'+this._posterUrl+'")'),this.hide())}},{key:"getElement",value:function(){return this._el}},{key:"_createEl",value:function(){if(!this._el){var e=this._el=o.Dom.createElement("div");o.Dom.setAttribute(e,"id",o.Generator.uniqueId(5)),o.Dom.setAttribute(e,"tabindex","-1")}}},{key:"_removeEl",value:function(){this._el&&o.Dom.removeChild(this._el.parentNode,this._el)}},{key:"show",value:function(){o.Dom.setStyle(this._el,"display","")}},{key:"hide",value:function(){o.Dom.setStyle(this._el,"display","none")}},{key:"reset",value:function(){this._posterUrl="",o.Dom.setStyle(this._el,"background-image","")}},{key:"destroy",value:function(){this.reset(),this._removeEl()}},{key:"src",get:function(){return this._posterUrl}}]),e}();t.default=s},function(e,t,n){"use strict";function i(e,t,n){n=n||{};var i=n.timeout?n.timeout:o,r=document.createElement("script"),l=s+Math.round(Date.now()+1000001*Math.random()),c=e,d=void 0,f=function(){r&&r.parentNode&&r.parentNode.removeChild(r),window[l]=function(){},d&&clearTimeout(d)};return new Promise(function(n,o){i&&(d=setTimeout(function(){f(),o(new a.default(a.default.Severity.CRITICAL,a.default.Category.NETWORK,a.default.Code.TIMEOUT,e))},i)),window[l]=function(i){var r=t(i,e);f(),n(r)},c.match(/\?/)?c+="&"+u+l:c+="?"+u+l,r.type="text/javascript",r.src=c,document.getElementsByTagName("head")[0].appendChild(r)})}Object.defineProperty(t,"__esModule",{value:!0}),t.jsonp=void 0;var r=n(2),a=function(e){return e&&e.__esModule?e:{default:e}}(r),o=5e3,s="jsonpcallback",u="responseFormat=jsonp&callback=";t.jsonp=i},function(e,t,n){var i,r;/*!
 * js-logger - http://github.com/jonnyreeves/js-logger
 * Jonny Reeves, http://jonnyreeves.co.uk/
 * js-logger may be freely distributed under the MIT license.
 */
!function(a){"use strict";var o={};o.VERSION="1.4.1";var s,u={},l=function(e,t){return function(){return t.apply(e,arguments)}},c=function(){var e,t,n=arguments,i=n[0];for(t=1;t<n.length;t++)for(e in n[t])e in i||!n[t].hasOwnProperty(e)||(i[e]=n[t][e]);return i},d=function(e,t){return{value:e,name:t}};o.DEBUG=d(1,"DEBUG"),o.INFO=d(2,"INFO"),o.TIME=d(3,"TIME"),o.WARN=d(4,"WARN"),o.ERROR=d(8,"ERROR"),o.OFF=d(99,"OFF");var f=function(e){this.context=e,this.setLevel(e.filterLevel),this.log=this.info};f.prototype={setLevel:function(e){e&&"value"in e&&(this.context.filterLevel=e)},getLevel:function(){return this.context.filterLevel},enabledFor:function(e){var t=this.context.filterLevel;return e.value>=t.value},debug:function(){this.invoke(o.DEBUG,arguments)},info:function(){this.invoke(o.INFO,arguments)},warn:function(){this.invoke(o.WARN,arguments)},error:function(){this.invoke(o.ERROR,arguments)},time:function(e){"string"==typeof e&&e.length>0&&this.invoke(o.TIME,[e,"start"])},timeEnd:function(e){"string"==typeof e&&e.length>0&&this.invoke(o.TIME,[e,"end"])},invoke:function(e,t){s&&this.enabledFor(e)&&s(t,c({level:e},this.context))}};var h=new f({filterLevel:o.OFF});!function(){var e=o;e.enabledFor=l(h,h.enabledFor),e.debug=l(h,h.debug),e.time=l(h,h.time),e.timeEnd=l(h,h.timeEnd),e.info=l(h,h.info),e.warn=l(h,h.warn),e.error=l(h,h.error),e.log=e.info}(),o.setHandler=function(e){s=e},o.setLevel=function(e){h.setLevel(e);for(var t in u)u.hasOwnProperty(t)&&u[t].setLevel(e)},o.getLevel=function(){return h.getLevel()},o.get=function(e){return u[e]||(u[e]=new f(c({name:e},h.context)))},o.createDefaultHandler=function(e){e=e||{},e.formatter=e.formatter||function(e,t){t.name&&e.unshift("["+t.name+"]")};var t={},n=function(e,t){Function.prototype.apply.call(e,console,t)};return"undefined"==typeof console?function(){}:function(i,r){i=Array.prototype.slice.call(i);var a,s=console.log;r.level===o.TIME?(a=(r.name?"["+r.name+"] ":"")+i[0],"start"===i[1]?console.time?console.time(a):t[a]=(new Date).getTime():console.timeEnd?console.timeEnd(a):n(s,[a+": "+((new Date).getTime()-t[a])+"ms"])):(r.level===o.WARN&&console.warn?s=console.warn:r.level===o.ERROR&&console.error?s=console.error:r.level===o.INFO&&console.info?s=console.info:r.level===o.DEBUG&&console.debug&&(s=console.debug),e.formatter(i,r),n(s,i))}},o.useDefaults=function(e){o.setLevel(e&&e.defaultLevel||o.DEBUG),o.setHandler(o.createDefaultHandler(e))},i=o,void 0!==(r="function"==typeof i?i.call(t,n,t,e):i)&&(e.exports=r)}()},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i={RECOVERABLE:1,CRITICAL:2};t.Severity=i},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.Code=void 0;var i=n(47),r={UNSUPPORTED_SCHEME:1e3,BAD_HTTP_STATUS:1001,HTTP_ERROR:1002,TIMEOUT:1003,MALFORMED_DATA_URI:1004,UNKNOWN_DATA_URI_ENCODING:1005,REQUEST_FILTER_ERROR:1006,RESPONSE_FILTER_ERROR:1007,INVALID_TEXT_HEADER:2e3,INVALID_TEXT_CUE:2001,UNABLE_TO_DETECT_ENCODING:2003,BAD_ENCODING:2004,INVALID_XML:2005,INVALID_MP4_TTML:2007,INVALID_MP4_VTT:2008,UNABLE_TO_CREATE_TEXT_CUE:2009,DASH_ADAPTER_ERROR_PARSE_ISSUE:2010,UNKNOWN_FILE_TYPE:2011,UNKNOWN_LANGUAGE:2012,BUFFER_READ_OUT_OF_BOUNDS:3e3,JS_INTEGER_OVERFLOW:3001,EBML_OVERFLOW:3002,EBML_BAD_FLOATING_POINT_SIZE:3003,MP4_SIDX_WRONG_BOX_TYPE:3004,MP4_SIDX_INVALID_TIMESCALE:3005,MP4_SIDX_TYPE_NOT_SUPPORTED:3006,WEBM_CUES_ELEMENT_MISSING:3007,WEBM_EBML_HEADER_ELEMENT_MISSING:3008,WEBM_SEGMENT_ELEMENT_MISSING:3009,WEBM_INFO_ELEMENT_MISSING:3010,WEBM_DURATION_ELEMENT_MISSING:3011,WEBM_CUE_TRACK_POSITIONS_ELEMENT_MISSING:3012,WEBM_CUE_TIME_ELEMENT_MISSING:3013,MEDIA_SOURCE_OPERATION_FAILED:3014,MEDIA_SOURCE_OPERATION_THREW:3015,VIDEO_ERROR:3016,QUOTA_EXCEEDED_ERROR:3017,HLS_FATAL_MEDIA_ERROR:3018,HLS_FRAG_PARSING_ERROR:3019,HLS_BUFFER_APPEND_ISSUE:3020,HLS_BUFFER_APPENDING_ISSUE:3021,NATIVE_ADAPTER_LOAD_FAILED:3022,HLS_BUFFER_STALLED_ERROR:3023,UNABLE_TO_GUESS_MANIFEST_TYPE:4e3,DASH_INVALID_XML:4001,DASH_NO_SEGMENT_INFO:4002,DASH_EMPTY_ADAPTATION_SET:4003,DASH_EMPTY_PERIOD:4004,DASH_WEBM_MISSING_INIT:4005,DASH_UNSUPPORTED_CONTAINER:4006,DASH_PSSH_BAD_ENCODING:4007,DASH_NO_COMMON_KEY_SYSTEM:4008,DASH_MULTIPLE_KEY_IDS_NOT_SUPPORTED:4009,DASH_CONFLICTING_KEY_IDS:4010,UNPLAYABLE_PERIOD:4011,RESTRICTIONS_CANNOT_BE_MET:4012,NO_PERIODS:4014,HLS_PLAYLIST_HEADER_MISSING:4015,INVALID_HLS_TAG:4016,HLS_INVALID_PLAYLIST_HIERARCHY:4017,DASH_DUPLICATE_REPRESENTATION_ID:4018,HLS_MULTIPLE_MEDIA_INIT_SECTIONS_FOUND:4020,HLS_COULD_NOT_GUESS_MIME_TYPE:4021,HLS_MASTER_PLAYLIST_NOT_PROVIDED:4022,HLS_REQUIRED_ATTRIBUTE_MISSING:4023,HLS_REQUIRED_TAG_MISSING:4024,HLS_COULD_NOT_GUESS_CODECS:4025,HLS_KEYFORMATS_NOT_SUPPORTED:4026,DASH_UNSUPPORTED_XLINK_ACTUATE:4027,DASH_XLINK_DEPTH_LIMIT:4028,HLS_LIVE_CONTENT_NOT_SUPPORTED:4029,HLSJS_CANNOT_PARSE:4030,INVALID_STREAMS_CHOSEN:5005,NO_RECOGNIZED_KEY_SYSTEMS:6e3,REQUESTED_KEY_SYSTEM_CONFIG_UNAVAILABLE:6001,FAILED_TO_CREATE_CDM:6002,FAILED_TO_ATTACH_TO_VIDEO:6003,INVALID_SERVER_CERTIFICATE:6004,FAILED_TO_CREATE_SESSION:6005,FAILED_TO_GENERATE_LICENSE_REQUEST:6006,LICENSE_REQUEST_FAILED:6007,LICENSE_RESPONSE_REJECTED:6008,ENCRYPTED_CONTENT_WITHOUT_DRM_INFO:6010,NO_LICENSE_SERVER_GIVEN:6012,OFFLINE_SESSION_REMOVED:6013,EXPIRED:6014,BAD_FAIRPLAY_RESPONSE:6015,COULD_NOT_CREATE_MEDIA_KEYS:6016,COULD_NOT_CREATE_KEY_SESSION:6017,LOAD_INTERRUPTED:7e3,BITRATE_SWITCH_ISSUE:7001,LOAD_FAILED:7002,RUNTIME_ERROR_NOT_REGISTERED_PLUGIN:7003,RUNTIME_ERROR_METHOD_NOT_IMPLEMENTED:7004,RUNTIME_ERROR_NOT_VALID_HANDLER:7005,NO_SOURCE_PROVIDED:7006,NO_ENGINE_FOUND_TO_PLAY_THE_SOURCE:7007,ENTER_PICTURE_IN_PICTURE_FAILED:7008,EXIT_PICTURE_IN_PICTURE_FAILED:7009,CAST_API_UNAVAILABLE:8e3,NO_CAST_RECEIVERS:8001,ALREADY_CASTING:8002,UNEXPECTED_CAST_ERROR:8003,CAST_CANCELED_BY_USER:8004,CAST_CONNECTION_TIMED_OUT:8005,CAST_RECEIVER_APP_UNAVAILABLE:8006,STORAGE_NOT_SUPPORTED:9e3,INDEXED_DB_ERROR:9001,OPERATION_ABORTED:9002,REQUESTED_ITEM_NOT_FOUND:9003,MALFORMED_OFFLINE_URI:9004,CANNOT_STORE_LIVE_OFFLINE:9005,STORE_ALREADY_IN_PROGRESS:9006,NO_INIT_DATA_FOR_OFFLINE:9007,LOCAL_PLAYER_INSTANCE_REQUIRED:9008,CONTENT_UNSUPPORTED_BY_BROWSER:9009,CANNOT_ADD_ITEM:9010,DOWNLOAD_FAILED:9011,COULD_NOT_GET_INFO_FROM_MEDIA_PROVIDER:9012,ENTRY_DOES_NOT_EXIST:9013,PAUSE_FAILED:9014,RESUME_FAILED:9015,RENEW_LICENSE_FAILED:9016,ENTRY_ALREADY_EXISTS:9017,REMOVE_FAILED:9018,CAST_LOAD_MEDIA_FAILED:10001,CAST_CUSTOM_MESSAGE_PARSING_ERROR:100002,CAST_EDIT_TRACKS_INFO_ERROR:10003,VR_NOT_SUPPORTED:11e3};Object.assign(r,i.AdErrorCode),t.Code=r},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i={XML_PARSING_ERROR:8100,VAST_SCHEMA_VALIDATION_ERROR:8101,VAST_RESPONSE_VERSION_NOT_SUPPORTED:8102,TRAFFICKING_ERROR:8200,VAST_UNEXPECTED_LINEARITY:8201,VAST_UNEXPECTED_DURATION_ERROR:8201,VAST_UNEXPECTED_SIZE_ERROR:8203,VAST_WRAPPER_ERROR:8300,VAST_URI_ERROR:8301,VAST_TOO_MANY_REDIRECTS:8302,NO_ADS_VAST_RESPONSE:8303,GENERAL_LINEAR_ERROR:8400,FILE_NOT_FOUND:8401,VAST_MEDIA_LOAD_TIMEOUT:8402,MEDIA_FILE_NOT_FOUND:8403,MEDIA_FILE_DISPLAY_ERROR:8405,MEZZANINE_FILE_NOT_PROVIDED:8406,MEZZANINE_DOWNLOADED_FOR_THE_FIRST_TIME:8407,VAST_RESPONSE_AD_REJECTED:8408,CREATIVE_WAS_NOT_EXECUTED:8409,CODE_REFERENCED_NOT_EXECUTED:8410,GENERAL_NON_LINEAR_AD_ERROR:8500,NON_LINEAR_CREATIVE_DIMENSIONS_NOT_ALIGN_ERROR:8501,NON_LINEAR_FETCH_ERROR:8502,NON_LINEAR_RESOURCE_NOT_FOUND:8503,GENERAL_COMPANION_ADS_ERROR:8600,COMPANION_DIMENSIONS_NOT_FIT:8601,COMPANION_CANNOT_BE_DISPLAY:8602,COMPANION_CANNOT_BE_FETCHED:8603,COMPANION_TYPE_NOT_FOUND:8604,AD_UNDEFINED_ERROR:8900,GENERAL_VPAID_ERROR:8901};t.AdErrorCode=i},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i={NETWORK:1,TEXT:2,MEDIA:3,MANIFEST:4,STREAMING:5,DRM:6,PLAYER:7,ADS:8,STORAGE:9,CAST:10,VR:11};t.Category=i},function(e,t,n){"use strict";function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var r=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}(),a=function(){function e(){i(this,e)}return r(e,null,[{key:"language",get:function(){var e=void 0;return e=navigator.languages&&navigator.languages.length?navigator.languages[0]:navigator.userLanguage?navigator.userLanguage:navigator.language,e&&e.match("-")&&(e=e.split("-")[0]),e}}]),e}();t.default=a},function(e,t,n){"use strict";function i(e){return e&&e.__esModule?e:{default:e}}function r(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}(),s=n(8),u=(i(s),n(4)),l=i(u),c=n(24),d=i(c),f=n(19),h=n(3),_=n(1),p=i(_),A=n(0),v=i(A),g=function(){function e(t){var n,i,o,s,u,c,_=this;a(this,e),this._transitions=(c={},r(c,f.StateType.IDLE,(n={},r(n,h.Html5EventType.LOAD_START,function(){_._updateState(f.StateType.LOADING),_._dispatchEvent()}),r(n,h.Html5EventType.PLAY,function(){_._updateState(f.StateType.BUFFERING),_._dispatchEvent()}),r(n,h.Html5EventType.SEEKED,function(){_._updateState(f.StateType.PAUSED),_._dispatchEvent()}),n)),r(c,f.StateType.LOADING,(i={},r(i,h.Html5EventType.LOADED_METADATA,function(){_._updateState(f.StateType.PAUSED),_._dispatchEvent()}),r(i,h.Html5EventType.ERROR,function(){_._updateState(f.StateType.IDLE),_._dispatchEvent()}),i)),r(c,f.StateType.PAUSED,(o={},r(o,h.Html5EventType.PLAY,function(){_._updateState(f.StateType.PLAYING),_._dispatchEvent()}),r(o,h.Html5EventType.PLAYING,function(){_._updateState(f.StateType.PLAYING),_._dispatchEvent()}),r(o,h.Html5EventType.ENDED,function(){_._updateState(f.StateType.IDLE),_._dispatchEvent()}),o)),r(c,f.StateType.PLAYING,(s={},r(s,h.Html5EventType.PAUSE,function(){_._updateState(f.StateType.PAUSED),_._dispatchEvent()}),r(s,h.Html5EventType.WAITING,function(){_._updateState(f.StateType.BUFFERING),_._lastWaitingTime=_._player.currentTime,_._dispatchEvent()}),r(s,h.Html5EventType.ENDED,function(){_._updateState(f.StateType.IDLE),_._dispatchEvent()}),r(s,h.Html5EventType.ERROR,function(){_._updateState(f.StateType.IDLE),_._dispatchEvent()}),s)),r(c,f.StateType.BUFFERING,(u={},r(u,h.Html5EventType.PLAYING,function(){_._updateState(f.StateType.PLAYING),_._dispatchEvent()}),r(u,h.Html5EventType.PAUSE,function(){_._updateState(f.StateType.PAUSED),_._dispatchEvent()}),r(u,h.Html5EventType.SEEKED,function(){_._prevState&&_._prevState.type===f.StateType.PLAYING&&(_._updateState(f.StateType.PLAYING),_._dispatchEvent())}),r(u,h.Html5EventType.TIME_UPDATE,function(){_._player.currentTime!==_._lastWaitingTime&&_._prevState&&_._prevState.type===f.StateType.PLAYING&&(_._lastWaitingTime=null,_._updateState(f.StateType.PLAYING),_._dispatchEvent())}),u)),c),this._player=t,this._logger=(0,v.default)("StateManager"),this._eventManager=new l.default,this._history=[],this._prevState=null,this._curState=new d.default(f.StateType.IDLE),this._attachListeners()}return o(e,[{key:"_attachListeners",value:function(){this._eventManager.listen(this._player,h.Html5EventType.ERROR,this._doTransition.bind(this)),this._eventManager.listen(this._player,h.Html5EventType.ENDED,this._doTransition.bind(this)),this._eventManager.listen(this._player,h.Html5EventType.PLAY,this._doTransition.bind(this)),this._eventManager.listen(this._player,h.Html5EventType.LOAD_START,this._doTransition.bind(this)),this._eventManager.listen(this._player,h.Html5EventType.PLAYING,this._doTransition.bind(this)),this._eventManager.listen(this._player,h.Html5EventType.LOADED_METADATA,this._doTransition.bind(this)),this._eventManager.listen(this._player,h.Html5EventType.PAUSE,this._doTransition.bind(this)),this._eventManager.listen(this._player,h.Html5EventType.WAITING,this._doTransition.bind(this)),this._eventManager.listen(this._player,h.Html5EventType.SEEKED,this._doTransition.bind(this)),this._eventManager.listen(this._player,h.Html5EventType.TIME_UPDATE,this._doTransition.bind(this))}},{key:"_doTransition",value:function(e){(e.type!==h.Html5EventType.TIME_UPDATE||this._curState===f.StateType.BUFFERING&&e.type===h.Html5EventType.TIME_UPDATE)&&this._logger.debug("Do transition request",e.type);var t=this._transitions[this._curState.type];"function"==typeof t[e.type]&&t[e.type]()}},{key:"_updateState",value:function(e){this._curState.type!==e&&(this._curState.duration=Date.now()/1e3,this._history.push(this._curState),this._prevState=this._curState,this._curState=new d.default(e),this._logger.debug("Switch player state: from "+this._prevState.type+" to "+this._curState.type))}},{key:"_dispatchEvent",value:function(){var e=new p.default(h.CustomEventType.PLAYER_STATE_CHANGED,{oldState:this._prevState,newState:this._curState});this._player.dispatchEvent(e)}},{key:"destroy",value:function(){this._history=[],this._eventManager.destroy()}},{key:"reset",value:function(){this._history=[]}},{key:"currentState",get:function(){return this._curState}},{key:"previousState",get:function(){return this._prevState}},{key:"history",get:function(){return this._history}}]),e}();t.default=g},function(e,t,n){"use strict";function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function r(e){return"string"==typeof e&&(!!s[e.toLowerCase()]&&e.toLowerCase())}function a(e){return"number"==typeof e&&e>=0&&e<=100}Object.defineProperty(t,"__esModule",{value:!0});var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}(),s={"":!0,up:!0},u=function(){function e(){i(this,e),this._width=100,this._lines=3,this._regionAnchorX=0,this._regionAnchorY=100,this._viewportAnchorX=0,this._viewportAnchorY=100,this._scroll=""}return o(e,[{key:"width",get:function(){return this._width},set:function(e){if(!a(e))throw new Error("Width must be between 0 and 100.");this._width=e}},{key:"scroll",get:function(){return this._scroll},set:function(e){var t=r(e);if(!1===t)throw new SyntaxError("An invalid or illegal string was specified.");this._scroll=t}},{key:"viewportAnchorY",get:function(){return this._viewportAnchorY},set:function(e){if(!a(e))throw new Error("ViewportAnchorY must be between 0 and 100.");this._viewportAnchorY=e}},{key:"viewportAnchorX",get:function(){return this._viewportAnchorX},set:function(e){if(!a(e))throw new Error("ViewportAnchorX must be between 0 and 100.");this._viewportAnchorX=e}},{key:"regionAnchorX",get:function(){return this._regionAnchorX},set:function(e){if(!a(e))throw new Error("RegionAnchorY must be between 0 and 100.");this._regionAnchorX=e}},{key:"lines",get:function(){return this._lines},set:function(e){if("number"!=typeof e)throw new TypeError("Lines must be set to a number.");this._lines=e}},{key:"regionAnchorY",get:function(){return this._regionAnchorY},set:function(e){if(!a(e))throw new Error("RegionAnchorX must be between 0 and 100.");this._regionAnchorY=e}}]),e}(),l=void 0;"undefined"!=typeof window&&window.VTTRegion?t.Region=l=window.VTTRegion:t.Region=l=u,t.Region=l},function(e,t,n){"use strict";function i(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}Object.defineProperty(t,"__esModule",{value:!0}),t.LabelToTrackMap=void 0;var r,a=n(15),o=n(53),s=(r={},i(r,o.LabelOptions.AUDIO,a.TrackType.AUDIO),i(r,o.LabelOptions.CAPTIONS,a.TrackType.TEXT),i(r,o.LabelOptions.QUALITIES,a.TrackType.VIDEO),r);t.LabelToTrackMap=s},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i={AUDIO:"audio",CAPTIONS:"captions",QUALITIES:"qualities"};t.LabelOptions=i},function(e,t,n){"use strict";function i(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var a=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}(),o=n(55),s=i(o),u=n(22),l=(i(u),function(){function e(){r(this,e),this._middleware=new s.default(e.Actions)}return a(e,[{key:"use",value:function(e){this._middleware.use(e)}},{key:"play",value:function(t){this._middleware.run(e.Actions.PLAY,t)}},{key:"pause",value:function(t){this._middleware.run(e.Actions.PAUSE,t)}}]),e}());l.Actions={PLAY:"play",PAUSE:"pause"},t.default=l},function(e,t,n){"use strict";function i(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var a=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}(),o=n(16),s=i(o),u=n(22),l=(i(u),n(0)),c=i(l),d=function(){function e(t){r(this,e),this._actions=t,this._middlewares=new s.default,this._logger=(0,c.default)("Middleware")}return a(e,[{key:"use",value:function(e){for(var t in this._actions){var n=this._actions[t];"function"==typeof e[n]&&(this._logger.debug("Register <"+e.id+"> for action "+n),this._middlewares.push(n,e[n].bind(e)))}}},{key:"run",value:function(e,t){var n=this;this._logger.debug("Start middleware chain for action "+e);var i=this._middlewares.get(e);this._executeMiddleware(i,function(){n._logger.debug("Finish middleware chain for action "+e),t()})}},{key:"_executeMiddleware",value:function(e,t){e.reduceRight(function(e,t){return function(n){t(e)}},t)()}}]),e}();t.default=d},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i={logLevel:"ERROR",sources:{options:{forceRedirectExternalStreams:!1},metadata:{}},plugins:{},playback:{audioLanguage:"",textLanguage:"",useNativeTextTrack:!1,enableCEA708Captions:!1,captionsTextTrack1Label:"English",captionsTextTrack1LanguageCode:"en",captionsTextTrack2Label:"Spanish",captionsTextTrack2LanguageCode:"es",volume:1,startTime:-1,playsinline:!0,preload:"none",autoplay:!1,loop:!1,allowMutedAutoPlay:!0,muted:!1,pictureInPicture:!0,options:{html5:{hls:{},dash:{},native:{}}},preferNative:{hls:!1,dash:!1},inBrowserFullscreen:!1,streamPriority:[{engine:"html5",format:"hls"},{engine:"html5",format:"dash"},{engine:"html5",format:"progressive"},{engine:"flash",format:"hls"}]},abr:{enabled:!0,fpsDroppedFramesInterval:5e3,fpsDroppedMonitoringThreshold:.2,capLevelOnFPSDrop:!0,capLevelToPlayerSize:!1,defaultBandwidthEstimate:5e5,restrictions:{minBitrate:0,maxBitrate:1/0}},drm:{keySystem:""}};t.DefaultConfig=i},function(e,t,n){var i=n(58);"string"==typeof i&&(i=[[e.i,i,""]]);var r={};r.transform=void 0;n(60)(i,r);i.locals&&(e.exports=i.locals)},function(e,t,n){t=e.exports=n(59)(void 0),t.push([e.i,".pakhshkit-container {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100%;\r\n  color: #fff;\r\n  outline: none;\r\n  -webkit-touch-callout: none;\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n  -webkit-tap-highlight-color: transparent;\r\n}\r\n\r\n.pakhshkit-engine {\r\n  width: 100%;\r\n  height: 100%;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  object-fit: contain;\r\n}\r\n\r\n.pakhshkit-engine video::-webkit-media-controls-panel,\r\n.pakhshkit-engine video::-webkit-media-controls-panel-container,\r\n.pakhshkit-engine video::-webkit-media-controls-start-playback-button,\r\n.pakhshkit-engine video::-webkit-media-controls-play-button {\r\n  display: none;\r\n  -webkit-appearance: none;\r\n}\r\n\r\n.pakhshkit-poster {\r\n  position: absolute;\r\n  display: block;\r\n  top: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n  background-size: contain;\r\n  background-position: center center;\r\n  background-repeat: no-repeat;\r\n  background-color: #000;\r\n}\r\n\r\n.pakhshkit-subtitles {\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  right: 0;\r\n  left: 0;\r\n}\r\n\r\n.pakhshkit-black-cover {\r\n  position: absolute;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: black;\r\n}\r\n\r\n.pakhshkit-size-iframe {\r\n  width: 100%;\r\n  height: 100%;\r\n  position: absolute;\r\n  visibility: hidden;\r\n  z-index: -1;\r\n}\r\n\r\n.pakhshkit-in-browser-fullscreen-mode {\r\n  width: 100% !important;\r\n  height: 100% !important;\r\n  position: fixed !important;\r\n  top: 0 !important;\r\n  left: 0 !important;\r\n  /*added for blocking element with fixed position which could be on the top of the player */\r\n  z-index: 999999 !important;\r\n}\r\n",""])},function(e,t){function n(e,t){var n=e[1]||"",r=e[3];if(!r)return n;if(t&&"function"==typeof btoa){var a=i(r);return[n].concat(r.sources.map(function(e){return"/*# sourceURL="+r.sourceRoot+e+" */"})).concat([a]).join("\n")}return[n].join("\n")}function i(e){return"/*# sourceMappingURL=data:application/json;charset=utf-8;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(e))))+" */"}e.exports=function(e){var t=[];return t.toString=function(){return this.map(function(t){var i=n(t,e);return t[2]?"@media "+t[2]+"{"+i+"}":i}).join("")},t.i=function(e,n){"string"==typeof e&&(e=[[null,e,""]]);for(var i={},r=0;r<this.length;r++){var a=this[r][0];"number"==typeof a&&(i[a]=!0)}for(r=0;r<e.length;r++){var o=e[r];"number"==typeof o[0]&&i[o[0]]||(n&&!o[2]?o[2]=n:n&&(o[2]="("+o[2]+") and ("+n+")"),t.push(o))}},t}},function(e,t,n){function i(e,t){for(var n=0;n<e.length;n++){var i=e[n],r=_[i.id];if(r){r.refs++;for(var a=0;a<r.parts.length;a++)r.parts[a](i.parts[a]);for(;a<i.parts.length;a++)r.parts.push(c(i.parts[a],t))}else{for(var o=[],a=0;a<i.parts.length;a++)o.push(c(i.parts[a],t));_[i.id]={id:i.id,refs:1,parts:o}}}}function r(e,t){for(var n=[],i={},r=0;r<e.length;r++){var a=e[r],o=t.base?a[0]+t.base:a[0],s=a[1],u=a[2],l=a[3],c={css:s,media:u,sourceMap:l};i[o]?i[o].parts.push(c):n.push(i[o]={id:o,parts:[c]})}return n}function a(e,t){var n=A(e.insertInto);if(!n)throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");var i=y[y.length-1];if("top"===e.insertAt)i?i.nextSibling?n.insertBefore(t,i.nextSibling):n.appendChild(t):n.insertBefore(t,n.firstChild),y.push(t);else{if("bottom"!==e.insertAt)throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");n.appendChild(t)}}function o(e){if(null===e.parentNode)return!1;e.parentNode.removeChild(e);var t=y.indexOf(e);t>=0&&y.splice(t,1)}function s(e){var t=document.createElement("style");return e.attrs.type="text/css",l(t,e.attrs),a(e,t),t}function u(e){var t=document.createElement("link");return e.attrs.type="text/css",e.attrs.rel="stylesheet",l(t,e.attrs),a(e,t),t}function l(e,t){Object.keys(t).forEach(function(n){e.setAttribute(n,t[n])})}function c(e,t){var n,i,r,a;if(t.transform&&e.css){if(!(a=t.transform(e.css)))return function(){};e.css=a}if(t.singleton){var l=g++;n=v||(v=s(t)),i=d.bind(null,n,l,!1),r=d.bind(null,n,l,!0)}else e.sourceMap&&"function"==typeof URL&&"function"==typeof URL.createObjectURL&&"function"==typeof URL.revokeObjectURL&&"function"==typeof Blob&&"function"==typeof btoa?(n=u(t),i=h.bind(null,n,t),r=function(){o(n),n.href&&URL.revokeObjectURL(n.href)}):(n=s(t),i=f.bind(null,n),r=function(){o(n)});return i(e),function(t){if(t){if(t.css===e.css&&t.media===e.media&&t.sourceMap===e.sourceMap)return;i(e=t)}else r()}}function d(e,t,n,i){var r=n?"":i.css;if(e.styleSheet)e.styleSheet.cssText=T(t,r);else{var a=document.createTextNode(r),o=e.childNodes;o[t]&&e.removeChild(o[t]),o.length?e.insertBefore(a,o[t]):e.appendChild(a)}}function f(e,t){var n=t.css,i=t.media;if(i&&e.setAttribute("media",i),e.styleSheet)e.styleSheet.cssText=n;else{for(;e.firstChild;)e.removeChild(e.firstChild);e.appendChild(document.createTextNode(n))}}function h(e,t,n){var i=n.css,r=n.sourceMap,a=void 0===t.convertToAbsoluteUrls&&r;(t.convertToAbsoluteUrls||a)&&(i=E(i)),r&&(i+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(r))))+" */");var o=new Blob([i],{type:"text/css"}),s=e.href;e.href=URL.createObjectURL(o),s&&URL.revokeObjectURL(s)}var _={},p=function(e){var t;return function(){return void 0===t&&(t=e.apply(this,arguments)),t}}(function(){return window&&document&&document.all&&!window.atob}),A=function(e){var t={};return function(n){return void 0===t[n]&&(t[n]=e.call(this,n)),t[n]}}(function(e){return document.querySelector(e)}),v=null,g=0,y=[],E=n(61);e.exports=function(e,t){if("undefined"!=typeof DEBUG&&DEBUG&&"object"!=typeof document)throw new Error("The style-loader cannot be used in a non-browser environment");t=t||{},t.attrs="object"==typeof t.attrs?t.attrs:{},t.singleton||(t.singleton=p()),t.insertInto||(t.insertInto="head"),t.insertAt||(t.insertAt="bottom");var n=r(e,t);return i(n,t),function(e){for(var a=[],o=0;o<n.length;o++){var s=n[o],u=_[s.id];u.refs--,a.push(u)}if(e){i(r(e,t),t)}for(var o=0;o<a.length;o++){var u=a[o];if(0===u.refs){for(var l=0;l<u.parts.length;l++)u.parts[l]();delete _[u.id]}}}};var T=function(){var e=[];return function(t,n){return e[t]=n,e.filter(Boolean).join("\n")}}()},function(e,t){e.exports=function(e){var t="undefined"!=typeof window&&window.location;if(!t)throw new Error("fixUrls requires window.location");if(!e||"string"!=typeof e)return e;var n=t.protocol+"//"+t.host,i=n+t.pathname.replace(/\/[^\/]*$/,"/");return e.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi,function(e,t){var r=t.trim().replace(/^"(.*)"$/,function(e,t){return t}).replace(/^'(.*)'$/,function(e,t){return t});if(/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(r))return e;var a;return a=0===r.indexOf("//")?r:0===r.indexOf("/")?n+r:i+r.replace(/^\.\//,""),"url("+JSON.stringify(a)+")"})}},function(e,t,n){"use strict";function i(e){return e&&e.__esModule?e:{default:e}}function r(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var u=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}(),l=n(6),c=i(l),d=n(1),f=i(d),h=n(4),_=i(h),p=n(3),A=n(31),v=i(A),g=n(10),y=(i(g),n(11)),E=(i(y),n(9),n(14)),T=n(5),m=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}(T),b=n(69),k=i(b),w=n(2),S=i(w),C=n(0),O=i(C),R=n(71),D=function(e){function t(e,n,i){a(this,t);var r=o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this));return r._eventManager=new _.default,r._canLoadMediaSourceAdapterPromise=Promise.resolve(),r._createVideoElement(i),r._init(e,n),r}return s(t,e),u(t,null,[{key:"isSupported",value:function(){try{var e=m.Dom.createElement("video");return e.volume=.5,!!e.canPlayType}catch(e){return!1}}},{key:"createEngine",value:function(e,t,n){return new this(e,t,n)}},{key:"canPlaySource",value:function(e,t,n){return v.default.canPlaySource(e,t,n)}},{key:"runCapabilities",value:function(){t._capabilities.forEach(function(e){return e.runCapability()})}},{key:"getCapabilities",value:function(){var e=[];return t._capabilities.forEach(function(t){return e.push(t.getCapability())}),Promise.all(e).then(function(e){var n={};return e.forEach(function(e){return Object.assign(n,e)}),r({},t.id,n)})}},{key:"prepareVideoElement",value:function(e){if(!t.videoElementStore[e]){t._logger.debug("Create the video element for playing "+e);var n=m.Dom.createElement("video");t.videoElementStore[e]=n}t._logger.debug("Prepare the video element for playing "+e),t.videoElementStore[e].load()}}]),u(t,[{key:"restore",value:function(e,t){this.reset(),this._init(e,t)}},{key:"reset",value:function(){this.detach(),this._eventManager.removeAll(),this._mediaSourceAdapter&&(this._canLoadMediaSourceAdapterPromise=this._mediaSourceAdapter.destroy(),this._mediaSourceAdapter=null),this._el&&this._el.src&&(m.Dom.setAttribute(this._el,"src",""),m.Dom.removeAttribute(this._el,"src"))}},{key:"destroy",value:function(){this.detach(),this._droppedFramesWatcher.destroy(),this._el&&(this.pause(),m.Dom.removeAttribute(this._el,"src"),m.Dom.removeChild(this._el.parentNode,this._el)),this._eventManager.destroy(),v.default.destroy(),this._mediaSourceAdapter&&(this._mediaSourceAdapter.destroy(),this._mediaSourceAdapter=null)}},{key:"attach",value:function(){var e=this;Object.keys(p.Html5EventType).forEach(function(t){e._eventManager.listen(e._el,p.Html5EventType[t],function(){p.Html5EventType[t]===p.Html5EventType.ERROR?e._handleVideoError():e.dispatchEvent(new f.default(p.Html5EventType[t]))})}),this._handleMetadataTrackEvents(),this._mediaSourceAdapter&&(this._eventManager.listen(this._mediaSourceAdapter,p.CustomEventType.VIDEO_TRACK_CHANGED,function(t){return e.dispatchEvent(t)}),this._eventManager.listen(this._mediaSourceAdapter,p.CustomEventType.AUDIO_TRACK_CHANGED,function(t){return e.dispatchEvent(t)}),this._eventManager.listen(this._mediaSourceAdapter,p.CustomEventType.TEXT_TRACK_CHANGED,function(t){return e.dispatchEvent(t)}),this._eventManager.listen(this._mediaSourceAdapter,p.CustomEventType.ABR_MODE_CHANGED,function(t){return e.dispatchEvent(t)}),this._eventManager.listen(this._mediaSourceAdapter,p.CustomEventType.TEXT_CUE_CHANGED,function(t){return e.dispatchEvent(t)}),this._eventManager.listen(this._mediaSourceAdapter,p.CustomEventType.TRACKS_CHANGED,function(t){return e.dispatchEvent(t)}),this._eventManager.listen(this._mediaSourceAdapter,p.Html5EventType.ERROR,function(t){return e.dispatchEvent(t)}),this._eventManager.listen(this._mediaSourceAdapter,p.Html5EventType.TIME_UPDATE,function(t){return e.dispatchEvent(t)}),this._eventManager.listen(this._mediaSourceAdapter,p.Html5EventType.PLAYING,function(t){return e.dispatchEvent(t)}),this._eventManager.listen(this._mediaSourceAdapter,p.Html5EventType.WAITING,function(t){return e.dispatchEvent(t)}),this._eventManager.listen(this._mediaSourceAdapter,p.CustomEventType.MEDIA_RECOVERED,function(t){return e.dispatchEvent(t)}),this._eventManager.listen(this._mediaSourceAdapter,"hlsFragParsingMetadata",function(t){return e.dispatchEvent(t)}),this._eventManager.listen(this._droppedFramesWatcher,p.CustomEventType.FPS_DROP,function(t){return e.dispatchEvent(t)}))}},{key:"detach",value:function(){var e=this;Object.keys(p.Html5EventType).forEach(function(t){e._eventManager.unlisten(e._el,p.Html5EventType[t])}),this._mediaSourceAdapter&&(this._eventManager.unlisten(this._mediaSourceAdapter,p.CustomEventType.VIDEO_TRACK_CHANGED),this._eventManager.unlisten(this._mediaSourceAdapter,p.CustomEventType.AUDIO_TRACK_CHANGED),this._eventManager.unlisten(this._mediaSourceAdapter,p.CustomEventType.TEXT_TRACK_CHANGED),this._eventManager.unlisten(this._mediaSourceAdapter,p.CustomEventType.TEXT_CUE_CHANGED))}},{key:"getVideoElement",value:function(){return this._el}},{key:"selectVideoTrack",value:function(e){this._mediaSourceAdapter&&this._mediaSourceAdapter.selectVideoTrack(e)}},{key:"selectAudioTrack",value:function(e){this._mediaSourceAdapter&&this._mediaSourceAdapter.selectAudioTrack(e)}},{key:"selectTextTrack",value:function(e){this._removeCueChangeListeners(),this._mediaSourceAdapter&&this._mediaSourceAdapter.selectTextTrack(e),this.resetAllCues(),this._addCueChangeListener()}},{key:"hideTextTrack",value:function(){this._mediaSourceAdapter&&this._mediaSourceAdapter.hideTextTrack(),this._removeCueChangeListeners()}},{key:"enableAdaptiveBitrate",value:function(){this._mediaSourceAdapter&&this._mediaSourceAdapter.enableAdaptiveBitrate()}},{key:"isAdaptiveBitrateEnabled",value:function(){return!!this._mediaSourceAdapter&&this._mediaSourceAdapter.isAdaptiveBitrateEnabled()}},{key:"seekToLiveEdge",value:function(){this._mediaSourceAdapter&&this._mediaSourceAdapter.seekToLiveEdge()}},{key:"getStartTimeOfDvrWindow",value:function(){return this._mediaSourceAdapter?this._mediaSourceAdapter.getStartTimeOfDvrWindow():0}},{key:"isLive",value:function(){return!!this._mediaSourceAdapter&&this._mediaSourceAdapter.isLive()}},{key:"play",value:function(){var e=this,t=this._el.play();t&&t.catch(function(){return e.dispatchEvent(new f.default(p.CustomEventType.AUTOPLAY_FAILED))})}},{key:"pause",value:function(){return this._el.pause()}},{key:"load",value:function(e){var t=this;return this._el.load(),this._canLoadMediaSourceAdapterPromise.then(function(){return t._mediaSourceAdapter?t._mediaSourceAdapter.load(e).catch(function(e){return Promise.reject(e)}):Promise.resolve({})}).catch(function(e){return Promise.reject(e)})}},{key:"enterPictureInPicture",value:function(){var e=this;try{document.pictureInPictureEnabled&&"function"==typeof this._el.requestPictureInPicture?this._el.requestPictureInPicture().catch(function(t){e.dispatchEvent(new f.default(p.Html5EventType.ERROR,new S.default(S.default.Severity.RECOVERABLE,S.default.Category.PLAYER,S.default.Code.ENTER_PICTURE_IN_PICTURE_FAILED,t)))}):"function"==typeof this._el.webkitSetPresentationMode&&(this._el.webkitSetPresentationMode("picture-in-picture"),setTimeout(function(){return e.dispatchEvent(new f.default(p.Html5EventType.ENTER_PICTURE_IN_PICTURE))},0))}catch(e){this.dispatchEvent(new f.default(p.Html5EventType.ERROR,new S.default(S.default.Severity.RECOVERABLE,S.default.Category.PLAYER,S.default.Code.ENTER_PICTURE_IN_PICTURE_FAILED,e)))}}},{key:"exitPictureInPicture",value:function(){var e=this;try{document.pictureInPictureEnabled&&"function"==typeof document.exitPictureInPicture?document.exitPictureInPicture().catch(function(t){e.dispatchEvent(new f.default(p.Html5EventType.ERROR,new S.default(S.default.Severity.RECOVERABLE,S.default.Category.PLAYER,S.default.Code.EXIT_PICTURE_IN_PICTURE_FAILED,t)))}):"function"==typeof this._el.webkitSetPresentationMode&&(this._el.webkitSetPresentationMode("inline"),setTimeout(function(){return e.dispatchEvent(new f.default(p.Html5EventType.LEAVE_PICTURE_IN_PICTURE))},0))}catch(e){this.dispatchEvent(new f.default(p.Html5EventType.ERROR,new S.default(S.default.Severity.RECOVERABLE,S.default.Category.PLAYER,S.default.Code.EXIT_PICTURE_IN_PICTURE_FAILED,e)))}}},{key:"isPictureInPictureSupported",value:function(){return!!document.pictureInPictureEnabled||"function"==typeof this._el.webkitSupportsPresentationMode&&this._el.webkitSupportsPresentationMode("picture-in-picture")}},{key:"_init",value:function(e,t){this._config=t,this._loadMediaSourceAdapter(e),this.attach()}},{key:"_createVideoElement",value:function(e){this._el=t.videoElementStore[e]||m.Dom.createElement("video"),this._el.id=m.Generator.uniqueId(5),this._el.controls=!1}},{key:"_loadMediaSourceAdapter",value:function(e){this._mediaSourceAdapter=v.default.getMediaSourceAdapter(this.getVideoElement(),e,this._config),this._mediaSourceAdapter&&(this._droppedFramesWatcher=new R.DroppedFramesWatcher(this._mediaSourceAdapter,this._config.abr,this._el))}},{key:"_addCueChangeListener",value:function(){var e=this,t=Array.from(this._el.textTracks).find(function(e){return e&&"disabled"!==e.mode});t&&this._eventManager.listen(t,"cuechange",function(t){return e._onCueChange(t)})}},{key:"_removeCueChangeListeners",value:function(){for(var e=0;e<this._el.textTracks.length;e++)this._eventManager.unlisten(this._el.textTracks[e],"cuechange")}},{key:"_onCueChange",value:function(e){var t=e.currentTarget,n=[],i=!0,r=!1,a=void 0;try{for(var o,s=t.activeCues[Symbol.iterator]();!(i=(o=s.next()).done);i=!0){var u=o.value;if(window.VTTCue&&u instanceof window.VTTCue)n.push(u);else if(window.TextTrackCue&&u instanceof window.TextTrackCue)try{n.push(new E.Cue(u.startTime,u.endTime,u.text))}catch(e){new S.default(S.default.Severity.RECOVERABLE,S.default.Category.TEXT,S.default.Code.UNABLE_TO_CREATE_TEXT_CUE,e)}}}catch(e){r=!0,a=e}finally{try{!i&&s.return&&s.return()}finally{if(r)throw a}}this.dispatchEvent(new f.default(p.CustomEventType.TEXT_CUE_CHANGED,{cues:n}))}},{key:"resetAllCues",value:function(){var e=Array.from(this._el.textTracks).find(function(e){return e&&"disabled"!==e.mode});if(e)for(var t=0;t<e.cues.length;t++)e.cues[t].hasBeenReset=!0}},{key:"_handleVideoError",value:function(){if(this._el.error){var e=this._el.error.code;if(1!==e){var t=this._getMsExtendedError(),n=this._el.error.message;if(this._mediaSourceAdapter&&!this._mediaSourceAdapter.handleMediaError(this._el.error)){var i=new S.default(S.default.Severity.CRITICAL,S.default.Category.MEDIA,S.default.Code.VIDEO_ERROR,{code:e,extended:t,message:n});this.dispatchEvent(new f.default(p.Html5EventType.ERROR,i))}}}}},{key:"_getMsExtendedError",value:function(){var e=this._el.error.msExtendedCode;return e&&(e<0&&(e+=Math.pow(2,32)),e=e.toString(16)),e}},{key:"_handleMetadataTrackEvents",value:function(){var e=this,t=function(t){t.mode="hidden",t.addEventListener("cuechange",function(){e.dispatchEvent(new f.default(p.CustomEventType.TIMED_METADATA,{cues:Array.from(t.activeCues)}))})},n=Array.from(this._el.textTracks).find(function(e){return"metadata"===e.kind});n?t(n):this._eventManager.listen(this._el.textTracks,"addtrack",function(n){"metadata"===n.track.kind?t(n.track):Array.from(e._el.textTracks).forEach(function(e){"metadata"===e.kind&&setTimeout(function(){return e.mode="hidden"},100)})})}},{key:"id",get:function(){return t.id}},{key:"src",set:function(e){this._mediaSourceAdapter&&(this._mediaSourceAdapter.src=e)},get:function(){return this._mediaSourceAdapter?this._mediaSourceAdapter.src:""}},{key:"currentTime",get:function(){return this._mediaSourceAdapter?this._mediaSourceAdapter.currentTime:0},set:function(e){this._mediaSourceAdapter&&(this._mediaSourceAdapter.currentTime=e)}},{key:"duration",get:function(){return this._mediaSourceAdapter?this._mediaSourceAdapter.duration:NaN}},{key:"volume",set:function(e){this._el.volume=e},get:function(){return this._el.volume}},{key:"paused",get:function(){return this._el.paused}},{key:"seeking",get:function(){return this._el.seeking}},{key:"seekable",get:function(){return this._el.seekable}},{key:"played",get:function(){return this._el.played}},{key:"buffered",get:function(){return this._el.buffered}},{key:"muted",set:function(e){this._el.muted=e},get:function(){return this._el.muted}},{key:"defaultMuted",get:function(){return this._el.defaultMuted}},{key:"poster",set:function(e){this._el.poster=e},get:function(){return this._el.poster}},{key:"preload",set:function(e){this._el.preload=e},get:function(){return this._el.preload}},{key:"autoplay",set:function(e){this._el.autoplay=e},get:function(){return this._el.autoplay}},{key:"loop",set:function(e){this._el.loop=e},get:function(){return this._el.loop}},{key:"controls",set:function(e){this._el.controls=e},get:function(){return this._el.controls}},{key:"playbackRate",set:function(e){this._el.playbackRate=e},get:function(){return this._el.playbackRate}},{key:"defaultPlaybackRate",set:function(e){this._el.defaultPlaybackRate=e},get:function(){return this._el.defaultPlaybackRate}},{key:"ended",get:function(){return this._el.ended}},{key:"error",get:function(){return this._el.error}},{key:"networkState",get:function(){return this._el.networkState}},{key:"readyState",get:function(){return this._el.readyState}},{key:"videoHeight",get:function(){return this._el.videoHeight}},{key:"videoWidth",get:function(){return this._el.videoWidth}},{key:"playsinline",set:function(e){e?this._el.setAttribute("playsinline",""):this._el.removeAttribute("playsinline")},get:function(){return""===this._el.getAttribute("playsinline")}},{key:"crossOrigin",set:function(e){"string"==typeof e?this._el.setAttribute("crossorigin",e):this._el.removeAttribute("crossorigin")},get:function(){return this._el.getAttribute("crossorigin")}},{key:"playbackRates",get:function(){return t.PLAYBACK_RATES}},{key:"isInPictureInPicture",get:function(){return!!document.pictureInPictureElement&&null!=document.pictureInPictureElement&&this._el===document.pictureInPictureElement||!!this._el.webkitPresentationMode&&"picture-in-picture"===this._el.webkitPresentationMode}}]),t}(c.default);D._logger=(0,O.default)("Html5"),D._capabilities=[k.default],D.id="html5",D.videoElementStore={},D.PLAYBACK_RATES=[.5,1,2,4],t.default=D},function(e,t,n){"use strict";function i(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function e(t,n,i){null===t&&(t=Function.prototype);var r=Object.getOwnPropertyDescriptor(t,n);if(void 0===r){var a=Object.getPrototypeOf(t);return null===a?void 0:e(a,n,i)}if("value"in r)return r.value;var o=r.get;if(void 0!==o)return o.call(i)},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}(),l=n(4),c=i(l),d=n(3),f=n(7),h=(i(f),n(10)),_=i(h),p=n(11),A=i(p),v=n(9),g=n(32),y=i(g),E=n(64),T=n(5),m=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}(T),b=n(65),k=i(b),w=n(12),S=i(w),C=n(2),O=i(C),R=n(67),D=i(R),P=n(68),I=function(e){function t(e,n,i){r(this,t),t._logger.debug("Creating adapter");var o=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e,n,i));return o._lastTimeUpdate=0,o._waitingEventTriggered=!1,o._eventManager=new c.default,o._config=m.Object.mergeDeep({},D.default,o._config),o._progressiveSources=i.progressiveSources,o._liveEdge=0,o}return o(t,e),u(t,null,[{key:"canPlayType",value:function(e){var n=!1;return"string"==typeof e&&(n=!!t.TEST_VIDEO.canPlayType(e.toLowerCase())),t._logger.debug("canPlayType result for mimeType:"+e+" is "+n.toString()),n}},{key:"canPlayDrm",value:function(e,n){var i=!1,r=!0,a=!1,o=void 0;try{for(var s,u=t._drmProtocols[Symbol.iterator]();!(r=(s=u.next()).done);r=!0){var l=s.value;if(l.isConfigured(e,n)){t._drmProtocol=l,i=!0;break}}}catch(e){a=!0,o=e}finally{try{!r&&u.return&&u.return()}finally{if(a)throw o}}if(!i){var c=!0,d=!1,f=void 0;try{for(var h,_=t._drmProtocols[Symbol.iterator]();!(c=(h=_.next()).done);c=!0){var p=h.value;if(p.canPlayDrm(e)){t._drmProtocol=p,i=!0;break}}}catch(e){d=!0,f=e}finally{try{!c&&_.return&&_.return()}finally{if(d)throw f}}}return t._logger.debug("canPlayDrm result is "+i.toString(),e),i}},{key:"createAdapter",value:function(e,t,n){var i={displayTextTrack:!1,progressiveSources:[]};return m.Object.hasPropertyPath(n,"playback.useNativeTextTrack")&&(i.displayTextTrack=m.Object.getPropertyPath(n,"playback.useNativeTextTrack")),m.Object.hasPropertyPath(n,"sources.progressive")&&(i.progressiveSources=m.Object.getPropertyPath(n,"sources.progressive")),n.playback&&(i.enableCEA708Captions=n.playback.enableCEA708Captions,i.captionsTextTrack1Label=n.playback.captionsTextTrack1Label,i.captionsTextTrack1LanguageCode=n.playback.captionsTextTrack1LanguageCode,i.captionsTextTrack2Label=n.playback.captionsTextTrack2Label,i.captionsTextTrack2LanguageCode=n.playback.captionsTextTrack2LanguageCode,m.Object.hasPropertyPath(n.playback,"options.html5.native")&&m.Object.mergeDeep(i,n.playback.options.html5.native)),new this(e,t,i)}}]),u(t,[{key:"_dispatchErrorCallback",value:function(e){this._trigger(d.Html5EventType.ERROR,e)}},{key:"_maybeSetDrmPlayback",value:function(){var e=this;if(t._drmProtocol&&this._sourceObj&&this._sourceObj.drmData){var n={licenseUrl:"",certificate:""};t._drmProtocol.setDrmPlayback(n,this._sourceObj.drmData),this._drmHandler=new P.FairplayDrmHandler(this._videoElement,n,function(t){return e._dispatchErrorCallback(t)})}}},{key:"_setProgressiveSource",value:function(){var e=(0,E.getSuitableSourceForResolution)(this._progressiveSources,this._videoElement.offsetWidth,this._videoElement.offsetHeight);e&&(this._sourceObj=e)}},{key:"_isProgressivePlayback",value:function(){return!!this._sourceObj&&"video/mp4"===this._sourceObj.mimetype}},{key:"load",value:function(e){var t=this;return this._maybeSetDrmPlayback(),this._loadPromise||(this._loadPromise=new Promise(function(n,i){t._lastTimeUpdate=e||0,t._loadPromiseReject=i,t._eventManager.listenOnce(t._videoElement,d.Html5EventType.LOADED_DATA,function(){return t._onLoadedData(n,e)}),t._eventManager.listen(t._videoElement,d.Html5EventType.TIME_UPDATE,function(){return t._onTimeUpdate()}),t._eventManager.listen(t._videoElement,d.Html5EventType.PLAY,function(){return t._resetHeartbeatTimeout()}),t._eventManager.listen(t._videoElement,d.Html5EventType.PAUSE,function(){return t._clearHeartbeatTimeout()}),t._eventManager.listen(t._videoElement,d.Html5EventType.ENDED,function(){return t._clearHeartbeatTimeout()}),t._eventManager.listen(t._videoElement,d.Html5EventType.ABORT,function(){return t._clearHeartbeatTimeout()}),t._eventManager.listen(t._videoElement,d.Html5EventType.SEEKED,function(){return t._syncCurrentTime()}),t._eventManager.listen(window,"focus",function(){return setTimeout(function(){return t._syncCurrentTime()},1e3)}),t._isProgressivePlayback()&&t._setProgressiveSource(),t._sourceObj&&t._sourceObj.url&&(t._videoElement.src=t._sourceObj.url,t._trigger(d.CustomEventType.ABR_MODE_CHANGED,{mode:t._isProgressivePlayback()?"manual":"auto"})),t._videoElement.load()})),this._loadPromise}},{key:"handleMediaError",value:function(e){return!!this._loadPromiseReject&&(this._loadPromiseReject(new O.default(O.default.Severity.CRITICAL,O.default.Category.MEDIA,O.default.Code.NATIVE_ADAPTER_LOAD_FAILED,e)),!0)}},{key:"_onLoadedData",value:function(e,n){var i=this,r=function(){i._playerTracks=i._getParsedTracks(),i._addNativeAudioTrackChangeListener(),i._addNativeTextTrackChangeListener(),i._addNativeTextTrackAddedListener(),t._logger.debug("The source has been loaded successfully"),i._loadPromiseReject=null,e({tracks:i._playerTracks}),i.isLive()&&i._handleLiveDurationChange()};n&&n>-1&&(this._videoElement.currentTime=n),this._videoElement.textTracks.length>0?r():this._eventManager.listenOnce(this._videoElement,d.Html5EventType.CAN_PLAY,r.bind(this))}},{key:"_onTimeUpdate",value:function(){this._videoElement.paused||(this._videoElement.currentTime>this._lastTimeUpdate?(this._waitingEventTriggered&&(this._waitingEventTriggered=!1,this._trigger(d.Html5EventType.PLAYING)),this._resetHeartbeatTimeout()):(this._waitingEventTriggered=!0,this._trigger(d.Html5EventType.WAITING)))}},{key:"_syncCurrentTime",value:function(){this._lastTimeUpdate=this._videoElement.currentTime}},{key:"_resetHeartbeatTimeout",value:function(){var e=this;this._lastTimeUpdate=this._videoElement.currentTime,this._clearHeartbeatTimeout();var t=function(){e._clearHeartbeatTimeout(),e._trigger(d.Html5EventType.ERROR,new O.default(O.default.Severity.CRITICAL,O.default.Category.NETWORK,O.default.Code.TIMEOUT,"The player exceeded max buffer time of "+e._config.heartbeatTimeout+" ms. No progress has been done during this time."))};this._heartbeatTimeoutId=setTimeout(t,this._config.heartbeatTimeout)}},{key:"_clearHeartbeatTimeout",value:function(){this._heartbeatTimeoutId&&(clearTimeout(this._heartbeatTimeoutId),this._heartbeatTimeoutId=null)}},{key:"destroy",value:function(){var e=this;return t._logger.debug("destroy"),s(t.prototype.__proto__||Object.getPrototypeOf(t.prototype),"destroy",this).call(this).then(function(){e._eventManager.destroy(),e._drmHandler&&e._drmHandler.destroy(),e._waitingEventTriggered=!1,e._progressiveSources=[],e._loadPromise=null,e._loadPromiseReject=null,e._liveEdge=0,e._lastTimeUpdate=0,e._clearHeartbeatTimeout(),e._liveDurationChangeInterval&&(clearInterval(e._liveDurationChangeInterval),e._liveDurationChangeInterval=null)})}},{key:"_getParsedTracks",value:function(){var e=this._getParsedVideoTracks(),t=this._getParsedAudioTracks(),n=this._getParsedTextTracks();return e.concat(t).concat(n)}},{key:"_getParsedVideoTracks",value:function(){return this._isProgressivePlayback()?this._getParsedProgressiveVideoTracks():this._getParsedAdaptiveVideoTracks()}},{key:"_getParsedProgressiveVideoTracks",value:function(){var e=this._progressiveSources,t=[];if(e)for(var n=0;n<e.length;n++){var i={id:e[n].id,bandwidth:e[n].bandwidth,width:e[n].width,height:e[n].height,active:!!this._sourceObj&&e[n].id===this._sourceObj.id,index:n};t.push(new _.default(i))}return t}},{key:"_getParsedAdaptiveVideoTracks",value:function(){var e=this._videoElement.videoTracks,t=[];if(e)for(var n=0;n<e.length;n++){var i={id:e[n].id,active:e[n].selected,label:e[n].label,language:e[n].language,index:n};t.push(new _.default(i))}return t}},{key:"_getParsedAudioTracks",value:function(){var e=this._videoElement.audioTracks,t=[];if(e)for(var n=0;n<e.length;n++){var i={id:e[n].id,active:e[n].enabled,label:e[n].label,language:e[n].language,index:n};t.push(new A.default(i))}return t}},{key:"_getParsedTextTracks",value:function(){var e=[this._config.captionsTextTrack1Label,this._config.captionsTextTrack2Label],t=[this._config.captionsTextTrack1LanguageCode,this._config.captionsTextTrack2LanguageCode],n=this._videoElement.textTracks,i=[];if(n)for(var r=0;r<n.length;r++){var a={kind:n[r].kind,active:"showing"===n[r].mode,label:n[r].label,language:n[r].language,index:r};"subtitles"===a.kind?i.push(new v.TextTrack(a)):"captions"===a.kind&&this._config.enableCEA708Captions&&(a.label=a.label||e.shift(),a.language=a.language||t.shift(),i.push(new v.TextTrack(a)))}return i}},{key:"selectVideoTrack",value:function(e){this._isProgressivePlayback()?this._selectProgressiveVideoTrack(e):this.selectAdaptiveVideoTrack(e)}},{key:"_selectProgressiveVideoTrack",value:function(e){var t=this,n=this._progressiveSources;if(e instanceof _.default&&n&&n[e.index]){var i=this._videoElement.currentTime,r=this._videoElement.paused;this._sourceObj=n[e.index],this._eventManager.listenOnce(this._videoElement,d.Html5EventType.LOADED_DATA,function(){"Android Browser"===S.default.browser.name?(t._eventManager.listenOnce(t._videoElement,d.Html5EventType.DURATION_CHANGE,function(){t._videoElement.currentTime=i}),t._eventManager.listenOnce(t._videoElement,d.Html5EventType.SEEKED,function(){t._onTrackChanged(e),r&&t._videoElement.pause()}),t._videoElement.play()):(t._eventManager.listenOnce(t._videoElement,d.Html5EventType.SEEKED,function(){t._onTrackChanged(e)}),t._videoElement.currentTime=i,r||t._videoElement.play())}),this._videoElement.src=this._sourceObj?this._sourceObj.url:""}}},{key:"selectAdaptiveVideoTrack",value:function(e){var t=this._videoElement.videoTracks;e instanceof _.default&&t&&t[e.index]&&(this._disableVideoTracks(),t[e.index].selected=!0,this._onTrackChanged(e))}},{key:"selectAudioTrack",value:function(e){var t=this._videoElement.audioTracks;e instanceof A.default&&t&&t[e.index]&&(this._removeNativeAudioTrackChangeListener(),this._disableAudioTracks(),t[e.index].enabled=!0,this._onTrackChanged(e),this._addNativeAudioTrackChangeListener())}},{key:"_removeNativeAudioTrackChangeListener",value:function(){this._videoElement.audioTracks&&this._eventManager.unlisten(this._videoElement.audioTracks,"change")}},{key:"_addNativeAudioTrackChangeListener",value:function(){var e=this;this._videoElement.audioTracks&&this._eventManager.listen(this._videoElement.audioTracks,"change",function(){return e._onNativeAudioTrackChange()})}},{key:"_onNativeAudioTrackChange",value:function(){var e=this,n=this._playerTracks.filter(function(e){return e instanceof A.default});t._logger.debug("Video element audio track change");var i=function(){for(var t=0;t<e._videoElement.audioTracks.length;t++){if(e._videoElement.audioTracks[t].enabled)return t}return-1}(),r=function(){var e=n.find(function(e){return!0===e.active});return e?e.index:-1}();if(i!==r){var a=n.find(function(e){return e.index===i});a&&(t._logger.debug("Native selection of track, update the player audio track ("+r+" -> "+i+")"),this._onTrackChanged(a))}}},{key:"selectTextTrack",value:function(e){var n=this._videoElement.textTracks;if(e instanceof v.TextTrack&&("subtitles"===e.kind||"captions"===e.kind)&&n){this._removeNativeTextTrackChangeListener();var i=Array.from(n).find(function(t,n){return e.index===n&&t&&("subtitles"===t.kind||"captions"===t.kind)});i&&(this._disableTextTracks(),i.mode=this._getDisplayTextTrackModeString(),t._logger.debug("Text track changed",i),this._onTrackChanged(e),this._addNativeTextTrackChangeListener())}}},{key:"_removeNativeTextTrackChangeListener",value:function(){this._videoElement.textTracks&&this._eventManager.unlisten(this._videoElement.textTracks,"change")}},{key:"_addNativeTextTrackChangeListener",value:function(){var e=this;this._videoElement.textTracks&&this._eventManager.listen(this._videoElement.textTracks,"change",function(){return e._onNativeTextTrackChange()})}},{key:"_onNativeTextTrackChange",value:function(){var e=this,n=this._playerTracks.filter(function(e){return e instanceof v.TextTrack}),i=n.find(function(e){return"off"===e.language});t._logger.debug("Video element text track change");var r=function(){for(var t=0;t<e._videoElement.textTracks.length;t++){var n=e._videoElement.textTracks[t];if(e._getDisplayTextTrackModeString()===n.mode)return t}return-1}(),a=function(){var e=n.find(function(e){return!0===e.active});return e?e.index:-1}();if(r!==a)if(-1==r)i&&(t._logger.debug("Native selection of track, update the player text track ("+a+" -> off)"),this._onTrackChanged(i));else{var o=n.find(function(e){return e.index===r});o&&(t._logger.debug("Native selection of track, update the player text track ("+a+" -> "+r+")"),this._onTrackChanged(o))}}},{key:"_getDisplayTextTrackModeString",value:function(){return this._config.displayTextTrack?"showing":"hidden"}},{key:"_addNativeTextTrackAddedListener",value:function(){var e=this;!this._config.displayTextTrack&&this._videoElement.textTracks&&this._eventManager.listen(this._videoElement.textTracks,"addtrack",function(){return e._onNativeTextTrackAdded()})}},{key:"_onNativeTextTrackAdded",value:function(){this._playerTracks=this._getParsedTracks(),this._trigger(d.CustomEventType.TRACKS_CHANGED,{tracks:this._playerTracks})}},{key:"hideTextTrack",value:function(){this._disableTextTracks()}},{key:"enableAdaptiveBitrate",value:function(){t._logger.warn("Enabling adaptive bitrate is not supported for native playback")}},{key:"isAdaptiveBitrateEnabled",value:function(){return!this._isProgressivePlayback()}},{key:"_disableVideoTracks",value:function(){var e=this._videoElement.videoTracks;if(e)for(var t=0;t<e.length;t++)e[t].selected=!1}},{key:"_disableAudioTracks",value:function(){var e=this._videoElement.audioTracks;if(e)for(var t=0;t<e.length;t++)e[t].enabled=!1}},{key:"_disableTextTracks",value:function(){var e=this._videoElement.textTracks;if(e)for(var t=0;t<e.length;t++)("subtitles"===e[t].kind||"captions"===e[t].kind)&&(e[t].mode="disabled")}},{key:"_getLiveEdge",value:function(){return this._videoElement.seekable.length?this._videoElement.seekable.end(this._videoElement.seekable.length-1):this._videoElement.buffered.length?this._videoElement.buffered.end(this._videoElement.buffered.length-1):this._videoElement.duration}},{key:"seekToLiveEdge",value:function(){try{this._videoElement.currentTime=this._getLiveEdge()}catch(e){return}}},{key:"isLive",value:function(){return this._videoElement.duration===1/0}},{key:"_handleLiveDurationChange",value:function(){var e=this;this._liveDurationChangeInterval=setInterval(function(){var t=e._getLiveEdge();e._liveEdge!==t&&(e._liveEdge=t,e._videoElement.dispatchEvent(new window.Event(d.Html5EventType.DURATION_CHANGE)))},2e3)}},{key:"getStartTimeOfDvrWindow",value:function(){return this.isLive()&&this._videoElement.seekable.length?this._videoElement.seekable.start(0):0}}]),t}(y.default);I.id="NativeAdapter",I._logger=y.default.getLogger(I.id),I.TEST_VIDEO=m.Dom.createElement("video"),I._drmProtocols=[k.default],I._drmProtocol=null,t.default=I},function(e,t,n){"use strict";function i(e,t,n){var i=null;if(n&&e){var r=[],a=1/0,o=!0,s=!1,u=void 0;try{for(var l,c=e[Symbol.iterator]();!(o=(l=c.next()).done);o=!0){var d=l.value,f=Math.abs(d.width-t);f<a?(a=f,r=[d]):f===a&&r.push(d)}}catch(e){s=!0,u=e}finally{try{!o&&c.return&&c.return()}finally{if(s)throw u}}var h=t/n,_=r,p=1/0,A=!0,v=!1,g=void 0;try{for(var y,E=r[Symbol.iterator]();!(A=(y=E.next()).done);A=!0){var T=y.value;if(T.height){var m=Math.abs(T.width/T.height-h);m<p?(p=m,_=[T]):m===p&&_.push(T)}}}catch(e){v=!0,g=e}finally{try{!A&&E.return&&E.return()}finally{if(v)throw g}}var b=0,k=!0,w=!1,S=void 0;try{for(var C,O=_[Symbol.iterator]();!(k=(C=O.next()).done);k=!0){var R=C.value;(R.bandwidth>b||!R.bandwidth)&&(b=R.bandwidth||b,i=R)}}catch(e){w=!0,S=e}finally{try{!k&&O.return&&O.return()}finally{if(w)throw S}}}return i}Object.defineProperty(t,"__esModule",{value:!0}),t.getSuitableSourceForResolution=i},function(e,t,n){"use strict";function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function r(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}(),s=n(33),u=function(e){return e&&e.__esModule?e:{default:e}}(s),l=function(e){function t(){return i(this,t),r(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return a(t,e),o(t,null,[{key:"isConfigured",value:function(e,t){return u.default.DrmScheme.FAIRPLAY===t.keySystem&&!!e.find(function(e){return e.scheme===t.keySystem})}},{key:"canPlayDrm",value:function(e){return t._logger.debug("Can play DRM scheme of: "+u.default.DrmScheme.FAIRPLAY),u.default.DrmSupport.isProtocolSupported(u.default.DrmScheme.FAIRPLAY,e)}},{key:"setDrmPlayback",value:function(e,n){t._logger.debug("Sets drm playback");var i=n.find(function(e){return e.scheme===u.default.DrmScheme.FAIRPLAY});i&&(e.licenseUrl=i.licenseUrl,e.certificate=i.certificate)}}]),t}(u.default);l._logger=u.default.getLogger("FairPlay"),l._KeySystem="com.apple.fps.1_0",l._WebkitEvents={NEED_KEY:"webkitneedkey",KEY_MESSAGE:"webkitkeymessage",KEY_ADDED:"webkitkeyadded",KEY_ERROR:"webkitkeyerror"},t.default=l},function(e,t,n){"use strict";function i(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var a=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}(),o=n(12),s=i(o),u=n(0),l=i(u),c=n(23),d="not_supported_drm_playback",f=function(){function e(){r(this,e)}return a(e,null,[{key:"isProtocolSupported",value:function(t,n){var i=s.default.browser.name;if("function"==typeof e._Browsers[i]){var r=e._Browsers[i]();return e._logger.debug("Supported DRM scheme for current environment is: "+r),r===t&&!!n.find(function(e){return e.scheme===t})}return!1}}]),e}();f._logger=(0,l.default)("DrmSupport"),f._Browsers={Safari:function(){var e=s.default.device.type,t=s.default.os.name;return e||"Mac OS"!==t?d:c.DrmScheme.FAIRPLAY},Chrome:function(){var e=s.default.device.type,t=s.default.os.name;return e&&"Android"!==t?d:c.DrmScheme.WIDEVINE},Firefox:function(){return s.default.device.type?d:c.DrmScheme.WIDEVINE},Edge:function(){return s.default.device.type?d:c.DrmScheme.PLAYREADY},IE:function(){var e=s.default.device.type,t=s.default.os.name,n=s.default.os.version;return!e&&"Windows"===t&&Number.parseFloat(n)>=8.1?c.DrmScheme.PLAYREADY:d},"Mobile Safari":function(){return s.default.browser.major>=11?c.DrmScheme.FAIRPLAY:d}},t.default=f},function(e,t){e.exports={heartbeatTimeout:3e4}},function(e,t,n){"use strict";function i(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.FairplayDrmHandler=void 0;var a=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}(),o=n(2),s=i(o),u=n(0),l=i(u),c={NEED_KEY:"webkitneedkey",KEY_MESSAGE:"webkitkeymessage",KEY_ADDED:"webkitkeyadded",KEY_ERROR:"webkitkeyerror"},d=function(){function e(t,n,i){var a=this;r(this,e),this._logger=(0,l.default)("FairPlayDrmHandler"),this._retryLicenseRequest=4,this._config=n,this._errorCallback=i,this._videoElement=t,this._onWebkitNeedKeyHandler=function(e){return a._onWebkitNeedKey(e)},this._videoElement.addEventListener(c.NEED_KEY,this._onWebkitNeedKeyHandler,!1)}return a(e,[{key:"_onWebkitNeedKey",value:function(t){var n=this;this._logger.debug("Webkit need key triggered");var i=t.target,r=t.initData,a=e._extractContentId(r),o=e._base64DecodeUint8Array(this._config.certificate);if(r=e._concatInitDataIdAndCertificate(r,a,o),!i.webkitKeys){var u=this._selectKeySystem();this._logger.debug("Sets media keys"),i.webkitSetMediaKeys(new window.WebKitMediaKeys(u))}i.webkitKeys||this._onError(s.default.Code.COULD_NOT_CREATE_MEDIA_KEYS),this._logger.debug("Creates session"),this._keySession=i.webkitKeys.createSession("video/mp4",r),this._keySession||this._onError(s.default.Code.COULD_NOT_CREATE_KEY_SESSION),this._keySession.contentId=a,this._keySession.addEventListener(c.KEY_MESSAGE,function(e){return n._onWebkitKeyMessage(e)},!1),this._keySession.addEventListener(c.KEY_ADDED,function(){return n._onWebkitKeyAdded()},!1),this._keySession.addEventListener(c.KEY_ERROR,function(e){return n._onWebkitKeyError(e)},!1)}},{key:"destroy",value:function(){this._videoElement.removeEventListener(c.NEED_KEY,this._onWebkitNeedKeyHandler),this._keySession.close(),this._keySession=null}},{key:"_onWebkitKeyMessage",value:function(t){var n=this;this._logger.debug("Webkit key message triggered");var i=t.message,r=new XMLHttpRequest;r.responseType="text",r.addEventListener("load",function(e){return n._licenseRequestLoaded(e)},!1);var a=e._base64EncodeUint8Array(i);r.open("POST",this._config.licenseUrl,!0),r.setRequestHeader("Content-type","application/json"),this._logger.debug("Ready for license request"),r.onerror=function(){n._onError(s.default.Code.LICENSE_REQUEST_FAILED,{status:r.status,responseText:r.responseText})},r.send(a)}},{key:"_onWebkitKeyAdded",value:function(){this._logger.debug("Decryption key was added to session")}},{key:"_onWebkitKeyError",value:function(e){this._logger.error("A decryption key error was encountered",e),this._retryLicenseRequest<=0&&this._onError(s.default.Code.LICENSE_REQUEST_FAILED,e.target.error),this._retryLicenseRequest--}},{key:"_licenseRequestLoaded",value:function(t){this._logger.debug("License request loaded");var n=t.target;if(n.status>299)return void this._onError(s.default.Code.LICENSE_REQUEST_FAILED,{status:n.status,error:n.responseText});var i={};try{var r=n.responseText.trim();i=JSON.parse(r)}catch(e){this._onError(s.default.Code.BAD_FAIRPLAY_RESPONSE,{error:e,responseText:n.responseText})}var a=e._validateResponse(i);if(a.valid){var o=e._base64DecodeUint8Array(i.ckc);this._keySession.update(o)}else this._onError(s.default.Code.BAD_FAIRPLAY_RESPONSE,a)}},{key:"_onError",value:function(e,t){this._errorCallback(new s.default(s.default.Severity.CRITICAL,s.default.Category.DRM,e,t))}},{key:"_selectKeySystem",value:function(){var e=null;return window.WebKitMediaKeys.isTypeSupported("com.apple.fps.1_0","video/mp4")?e="com.apple.fps.1_0":this._logger.warn("Key System not supported"),e}}],[{key:"_validateResponse",value:function(e){return e.message&&e.message.indexOf("error")>0||null===e.reference||500===e.status_code?{valid:!1,details:"internal server error"}:""===e.ckc?{valid:!1,details:"ckc is missing"}:{valid:!0}}},{key:"_extractContentId",value:function(t){var n=document.createElement("a");return n.href=e._arrayToString(t),n.hostname}},{key:"_arrayToString",value:function(e){return String.fromCharCode.apply(null,new Uint16Array(e.buffer))}},{key:"_base64DecodeUint8Array",value:function(e){for(var t=window.atob(e),n=t.length,i=new Uint8Array(new ArrayBuffer(n)),r=0;r<n;r++)i[r]=t.charCodeAt(r);return i}},{key:"_concatInitDataIdAndCertificate",value:function(t,n,i){"string"==typeof n&&(n=e._stringToArray(n));var r=0,a=new ArrayBuffer(t.byteLength+4+n.byteLength+4+i.byteLength),o=new DataView(a);new Uint8Array(a,r,t.byteLength).set(t),r+=t.byteLength,o.setUint32(r,n.byteLength,!0),r+=4;var s=new Uint8Array(a,r,n.byteLength);return s.set(n),r+=s.byteLength,o.setUint32(r,i.byteLength,!0),r+=4,new Uint8Array(a,r,i.byteLength).set(i),new Uint8Array(a,0,a.byteLength)}},{key:"_stringToArray",value:function(e){for(var t=new ArrayBuffer(2*e.length),n=new Uint16Array(t),i=0,r=e.length;i<r;i++)n[i]=e.charCodeAt(i);return n}},{key:"_base64EncodeUint8Array",value:function(e){for(var t="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",n="",i=void 0,r=void 0,a=void 0,o=void 0,s=void 0,u=void 0,l=void 0,c=0;c<e.length;)i=e[c++],r=c<e.length?e[c++]:Number.NaN,a=c<e.length?e[c++]:Number.NaN,o=i>>2,s=(3&i)<<4|r>>4,u=(15&r)<<2|a>>6,l=63&a,isNaN(r)?u=l=64:isNaN(a)&&(l=64),n+=t.charAt(o)+t.charAt(s)+t.charAt(u)+t.charAt(l);return n}}]),e}();d.WebkitEvents=c,d.WebkitEvents=c,t.FairplayDrmHandler=d},function(e,t,n){"use strict";function i(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var a=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}(),o=n(5),s=i(o),u=n(3),l=n(0),c=function(e){return e&&e.__esModule?e:{default:e}}(l),d=n(70),f=i(d),h=function(){function e(){r(this,e)}return a(e,null,[{key:"runCapability",value:function(){e._vid||(e._vid=s.Dom.createElement("video"),e._vid.src=f.Base64Mp4Source,e._vid.setAttribute("playsinline","")),e._playPromiseResult=new Promise(function(t){e._setMuted(!1),e._getPlayPromise().then(function(){return t({autoplay:!0,mutedAutoPlay:!0})}).catch(function(){e._setMuted(!0),e._getPlayPromise().then(function(){return t({autoplay:!1,mutedAutoPlay:!0})}).catch(function(){return t({autoplay:!1,mutedAutoPlay:!1})})})})}},{key:"getCapability",value:function(){return e._playPromiseResult.then(function(t){return t.autoplay?t:(e.runCapability(),e._playPromiseResult)})}},{key:"_getPlayPromise",value:function(){return e._vid.play()||e._forcePromiseReturnValue()}},{key:"_setMuted",value:function(t){t?(e._vid.muted=!0,e._vid.setAttribute("muted","")):(e._vid.muted=!1,e._vid.removeAttribute("muted"))}},{key:"_forcePromiseReturnValue",value:function(){return new Promise(function(t,n){e._vid.addEventListener(u.Html5EventType.ERROR,function(){n()});var i=setTimeout(function(){e._logger.debug("Timeout 500 ms has been reached"),n()},500);!0===e._vid.paused?(clearTimeout(i),n()):(clearTimeout(i),t())})}}]),e}();h._logger=(0,c.default)("Html5AutoPlayCapability"),t.default=h},function(e,t){e.exports={Base64Mp4Source:"data:video/mp4;base64,AAAAHGZ0eXBpc29tAAACAGlzb21pc28ybXA0MQAAAAhmcmVlAAAC721kYXQhEAUgpBv/wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA3pwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcCEQBSCkG//AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADengAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcAAAAsJtb292AAAAbG12aGQAAAAAAAAAAAAAAAAAAAPoAAAALwABAAABAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAAAB7HRyYWsAAABcdGtoZAAAAAMAAAAAAAAAAAAAAAIAAAAAAAAALwAAAAAAAAAAAAAAAQEAAAAAAQAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAACRlZHRzAAAAHGVsc3QAAAAAAAAAAQAAAC8AAAAAAAEAAAAAAWRtZGlhAAAAIG1kaGQAAAAAAAAAAAAAAAAAAKxEAAAIAFXEAAAAAAAtaGRscgAAAAAAAAAAc291bgAAAAAAAAAAAAAAAFNvdW5kSGFuZGxlcgAAAAEPbWluZgAAABBzbWhkAAAAAAAAAAAAAAAkZGluZgAAABxkcmVmAAAAAAAAAAEAAAAMdXJsIAAAAAEAAADTc3RibAAAAGdzdHNkAAAAAAAAAAEAAABXbXA0YQAAAAAAAAABAAAAAAAAAAAAAgAQAAAAAKxEAAAAAAAzZXNkcwAAAAADgICAIgACAASAgIAUQBUAAAAAAfQAAAHz+QWAgIACEhAGgICAAQIAAAAYc3R0cwAAAAAAAAABAAAAAgAABAAAAAAcc3RzYwAAAAAAAAABAAAAAQAAAAIAAAABAAAAHHN0c3oAAAAAAAAAAAAAAAIAAAFzAAABdAAAABRzdGNvAAAAAAAAAAEAAAAsAAAAYnVkdGEAAABabWV0YQAAAAAAAAAhaGRscgAAAAAAAAAAbWRpcmFwcGwAAAAAAAAAAAAAAAAtaWxzdAAAACWpdG9vAAAAHWRhdGEAAAABAAAAAExhdmY1Ni40MC4xMDE="}},function(e,t,n){"use strict";function i(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.DroppedFramesWatcher=void 0;var s=function(){function e(e,t){var n=[],i=!0,r=!1,a=void 0;try{for(var o,s=e[Symbol.iterator]();!(i=(o=s.next()).done)&&(n.push(o.value),!t||n.length!==t);i=!0);}catch(e){r=!0,a=e}finally{try{!i&&s.return&&s.return()}finally{if(r)throw a}}return n}return function(t,n){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return e(t,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),u=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}(),l=n(6),c=i(l),d=n(0),f=i(d),h=n(3),_=n(4),p=i(_),A=n(1),v=i(A),g=-1,y=function(e){function t(e,n,i){r(this,t);var o=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this));return o._droppedFramesInterval=null,o._lastDroppedFrames=0,o._lastDecodedFrames=0,o._lastTime=0,o._currentBitrate=0,o._eventManager=new p.default,o._mediaSourceAdapter=e,o._config=n,o._videoElement=i,o._mediaSourceAdapter.capabilities.fpsControl?(o._eventManager.listen(o._mediaSourceAdapter,h.CustomEventType.FPS_DROP,function(e){return o._triggerFPSDrop(e.payload.data)}),a(o)):(o._getDroppedAndDecodedFrames()[0]===g?t._logger.debug("Dropped frame watcher is not supported"):o._config.capLevelOnFPSDrop&&o._init(),o)}return o(t,e),u(t,[{key:"_init",value:function(){var e=this;this._eventManager.listen(this._mediaSourceAdapter,h.CustomEventType.VIDEO_TRACK_CHANGED,function(t){return e._currentBitrate=t.payload.selectedVideoTrack.bandwidth}),this._droppedFramesInterval=setInterval(function(){return e._checkFPS()},this._config.fpsDroppedFramesInterval)}},{key:"_triggerFPSDrop",value:function(e){this.dispatchEvent(new v.default(h.CustomEventType.FPS_DROP,e))}},{key:"_getDroppedAndDecodedFrames",value:function(){if("function"==typeof this._videoElement.getVideoPlaybackQuality){var e=this._videoElement.getVideoPlaybackQuality();return[e.droppedVideoFrames,e.totalVideoFrames]}return"number"==typeof this._videoElement.webkitDroppedFrameCount&&"number"==typeof this._videoElement.webkitDecodedFrameCount?[this._videoElement.webkitDroppedFrameCount,this._videoElement.webkitDecodedFrameCount]:[g,g]}},{key:"_checkFPS",value:function(){var e=this._getDroppedAndDecodedFrames(),n=s(e,2),i=n[0],r=n[1];try{var a=performance.now();if(r){if(this._lastTime){var o=a-this._lastTime,u=i-this._lastDroppedFrames,l=r-this._lastDecodedFrames,c=1e3*u/o;c>0&&(t._logger.debug("checkFPS : droppedFPS/decodedFPS:"+c/(1e3*l/o)),u>this._config.fpsDroppedMonitoringThreshold*l&&(this._mediaSourceAdapter.setMaxBitrate(this._currentBitrate-1),this._triggerFPSDrop({currentDropped:u,currentDecoded:l,totalDroppedFrames:c})))}this._lastTime=a,this._lastDroppedFrames=i,this._lastDecodedFrames=r}}catch(e){t._logger.error("Error occur while trying to check dropFrames: ",e)}}},{key:"destroy",value:function(){this._droppedFramesInterval&&clearInterval(this._droppedFramesInterval),this._droppedFramesInterval=null,this._eventManager.destroy()}}]),t}(c.default);y._logger=(0,f.default)("droppedFramesWatcher"),t.DroppedFramesWatcher=y},function(e,t,n){"use strict";function i(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.ExternalCaptionsHandler=void 0;var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}(),u=n(2),l=i(u),c=n(5),d=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}(c),f=n(21),h=n(15),_=n(9),p=i(_),A=n(7),v=i(A),g=n(3),y=n(1),E=i(y),T=n(0),m=i(T),b=n(4),k=i(b),w=n(6),S=i(w),C=(n(14),n(8)),O=(i(C),{NOT_DOWNLOADED:1,DOWNLOADING:2,DOWNLOADED:3}),R=function(e){function t(e){r(this,t);var n=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this));return n._externalCueIndex=0,n._textTrackModel={},n._activeTextCues=[],n._isTextTrackActive=!1,n._lastTimeUpdate=0,n._player=e,n._eventManager=new k.default,n}return o(t,e),s(t,[{key:"hideTextTrack",value:function(){this._isTextTrackActive&&(this._eventManager.unlisten(this._player,g.Html5EventType.TIME_UPDATE),this.dispatchEvent(new E.default(g.CustomEventType.TEXT_CUE_CHANGED,{cues:[]})),this._resetCurrentTrack())}},{key:"getExternalTracks",value:function(e){var t=this,n=this._player.config.sources.captions;if(!n)return[];var i=e.filter(function(e){return e instanceof p.default}),r=i.length||0,a=[];return n.forEach(function(e){if(e.language){var n=t._createTextTrack(e,r++);t._maybeAddTrack(n,e,i,a)}else{var o=new l.default(l.default.Severity.RECOVERABLE,l.default.Category.TEXT,l.default.Code.UNKNOWN_LANGUAGE,{caption:e});t.dispatchEvent(new E.default(g.Html5EventType.ERROR,o))}}),a}},{key:"_maybeAddTrack",value:function(e,n,i,r){var a=i.find(function(e){return v.default.langComparer(n.language,e.language)});a?t._logger.warn("duplicated language, taking the inband option. Language: ",a.language):(this._player.config.playback.useNativeTextTrack&&this._addNativeTextTrack(e),r.push(e),this._updateTextTracksModel(n))}},{key:"_createTextTrack",value:function(e,t){return new p.default({active:!!e.default,index:t,kind:"subtitles",label:e.label,language:e.language,external:!0})}},{key:"_updateTextTracksModel",value:function(e){this._textTrackModel[e.language]={cuesStatus:O.NOT_DOWNLOADED,cues:[],url:e.url,type:e.type}}},{key:"selectTextTrack",value:function(e){var t=this;this._textTrackModel[e.language]&&(this._textTrackModel[e.language].cuesStatus!==O.DOWNLOADED||this._player.config.playback.useNativeTextTrack?this._textTrackModel[e.language].cuesStatus===O.NOT_DOWNLOADED&&(e.active=!0,this._player.config.playback.useNativeTextTrack||this.dispatchEvent(new E.default(g.CustomEventType.TEXT_TRACK_CHANGED,{selectedTextTrack:e})),this._downloadAndParseCues(e).then(function(){t._textTrackModel[e.language].cuesStatus=O.DOWNLOADED,t._player.config.playback.useNativeTextTrack?t._addCuesToNativeTextTrack(e,t._textTrackModel[e.language].cues):(t.hideTextTrack(),t._setTextTrack(e))}).catch(function(e){return t.dispatchEvent(new E.default(g.Html5EventType.ERROR,e))})):(e.active=!0,this.dispatchEvent(new E.default(g.CustomEventType.TEXT_TRACK_CHANGED,{selectedTextTrack:e})),this.hideTextTrack(),this._setTextTrack(e)))}},{key:"resetAllCues",value:function(){for(var e in this._textTrackModel)this._textTrackModel[e].cues.forEach(function(e){e.hasBeenReset=!0})}},{key:"reset",value:function(){this._resetCurrentTrack(),this._textTrackModel={},this._eventManager.removeAll()}},{key:"destroy",value:function(){this._textTrackModel={},this._eventManager.destroy(),this._activeTextCues=[]}},{key:"_resetCurrentTrack",value:function(){this._activeTextCues=[],this._isTextTrackActive=!1,this._maybeSetExternalCueIndex()}},{key:"_getCuesString",value:function(e){var t=this;return new Promise(function(n,i){var r=t._textTrackModel[e.language],a=r.type||t._getFileType(r.url);["srt","vtt"].includes(a)||(t._textTrackModel[e.language].cuesStatus=O.NOT_DOWNLOADED,i(new l.default(l.default.Severity.RECOVERABLE,l.default.Category.TEXT,l.default.Code.UNKNOWN_FILE_TYPE,{captionType:a}))),d.Http.execute(r.url,{},"GET").then(function(e){n("srt"===a?t._convertSrtToVtt(e):e)}).catch(function(){t._textTrackModel[e.language].cuesStatus=O.NOT_DOWNLOADED,i(new l.default(l.default.Severity.RECOVERABLE,l.default.Category.TEXT,l.default.Code.HTTP_ERROR,{url:r.url}))})})}},{key:"_parseCues",value:function(e){return new Promise(function(n,i){var r=new f.Parser(window,(0,f.StringDecoder)()),a=[];r.oncue=function(e){return a.push(e)},r.onflush=function(){t._logger.debug("finished parsing external cues"),n(a)},r.parse(e),r.flush(),r.onparsingerror(function(e){return i(e)})})}},{key:"_convertSrtToVtt",value:function(e){return"WEBVTT\n\n"+e.replace(/(\d\d:\d\d:\d\d),(\d\d\d) --> (\d\d:\d\d:\d\d),(\d\d\d)/g,function(e,t,n,i,r){return t+"."+n+" --\x3e "+i+"."+r})}},{key:"_downloadAndParseCues",value:function(e){var t=this;return this._textTrackModel[e.language].cuesStatus=O.DOWNLOADING,new Promise(function(n,i){t._getCuesString(e).then(function(e){return t._parseCues(e)}).then(function(i){t._textTrackModel[e.language].cues=i,n()}).catch(function(e){return i(e)})})}},{key:"_getFileType",value:function(e){return e.split(/[#?]/)[0].split(".").pop().trim()}},{key:"_handleCaptionOnTimeUpdate",value:function(e){var t=this._player.currentTime;if(t){var n=!1;this._hadSeeked()&&(this._activeTextCues=[],n=this._maybeSetExternalCueIndex());var i=this._maybeRemoveActiveCues(),r=this._maybeAddToActiveCues(e);(n||r||i)&&this.dispatchEvent(new E.default(g.CustomEventType.TEXT_CUE_CHANGED,{cues:this._activeTextCues})),this._lastTimeUpdate=t}}},{key:"_hadSeeked",value:function(){return!!this._player.currentTime&&Math.abs(this._player.currentTime-this._lastTimeUpdate)>1}},{key:"_maybeRemoveActiveCues",value:function(){var e=this._player.currentTime;if(!e)return!1;for(var t=!1,n=0;n<this._activeTextCues.length;n++){var i=this._activeTextCues[n];(e<i.startTime||i.endTime<e)&&(this._activeTextCues.splice(n,1),t=!0)}return t}},{key:"_maybeAddToActiveCues",value:function(e){var t=this._player.currentTime;if(!t)return!1;for(var n=!1,i=this._textTrackModel[e.language].cues;this._externalCueIndex<i.length&&t>i[this._externalCueIndex].startTime;)this._activeTextCues.push(i[this._externalCueIndex]),this._externalCueIndex++,n=!0;return n}},{key:"_maybeSetExternalCueIndex",value:function(){var e=this._player.getTracks(h.TrackType.TEXT).find(function(e){return e instanceof p.default&&e.active&&e.external});if(e&&e.external){for(var t=this._textTrackModel[e.language]?this._textTrackModel[e.language].cues:[],n=0;n<t.length&&!(t[n].startTime<this._player.currentTime&&this._player.currentTime<t[n].endTime)&&!(t[n].endTime>this._player.currentTime&&t[n].startTime>this._player.currentTime);n++);return this._externalCueIndex=n,!0}return!1}},{key:"_addCuesToNativeTextTrack",value:function(e,t){var n=this._player.getVideoElement();if(n){var i=Array.from(n.textTracks).find(function(t){return!!t&&t.language===e.language});i&&t.forEach(function(e){return i.addCue(e)})}}},{key:"_addNativeTextTrack",value:function(e){var t=this._player.getVideoElement();if(t){var n=Array.from(t.textTracks).findIndex(function(t){return!!t&&t.language===e.language});if(n>-1){var i=t.textTracks[n];i.cues&&Object.values(i.cues).forEach(function(e){return i.removeCue(e)})}else t.addTextTrack("subtitles",e.label||e.language,e.language)}}},{key:"_setTextTrack",value:function(e){var n=this;this._player.config.playback.useNativeTextTrack||(this._isTextTrackActive=!0,t._logger.debug("External text track changed",e),this._activeTextCues=[],this.dispatchEvent(new E.default(g.CustomEventType.TEXT_CUE_CHANGED,{cues:this._activeTextCues})),this._eventManager.listen(this._player,g.Html5EventType.TIME_UPDATE,function(){return n._handleCaptionOnTimeUpdate(e)}))}}]),t}(S.default);R._logger=(0,m.default)("ExternalCaptionsHandler"),t.ExternalCaptionsHandler=R},function(e,t,n){"use strict";function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.ControllerProvider=void 0;var r=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}(),a=n(17),o=(function(e){e&&e.__esModule}(a),function(){function e(t){i(this,e),this._pluginManager=t}return r(e,[{key:"getAdsController",value:function(){var e=Object.values(this._pluginManager.getAll()).find(function(e){return"function"==typeof e.getAdsController});return e&&e.getAdsController()}}]),e}());t.ControllerProvider=o},function(e,t,n){"use strict";function i(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.ResizeWatcher=void 0;var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}(),u=n(1),l=i(u),c=n(6),d=i(c),f=n(3),h=function(e){function t(){return r(this,t),a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this))}return o(t,e),s(t,[{key:"destroy",value:function(){this._observer&&this._observer.disconnect(),this._observer=null,this._el=null}},{key:"init",value:function(e){this._observer||(this._el=e,window.ResizeObserver?this._createNativeObserver():this._createIframeObserver(),this._el instanceof HTMLElement&&this._observer&&this._observer.observe(this._el))}},{key:"_createNativeObserver",value:function(){var e=this;this._observer=new window.ResizeObserver(function(t){t.forEach(function(){e._triggerResize()})})}},{key:"_createIframeObserver",value:function(){this._observer=new _(this._triggerResize.bind(this))}},{key:"_triggerResize",value:function(){this.dispatchEvent(new l.default(f.CustomEventType.RESIZE))}}]),t}(d.default),_=function(){function e(t){r(this,e),this._observersStore={},this._onChangeCallback=t}return s(e,[{key:"observe",value:function(e){var t=this,n=this._createIframe(),i=e.getAttribute("id");this._observersStore[i]=n,e.appendChild(n),n.contentWindow.onresize=function(){return t._onChangeCallback()}}},{key:"disconnect",value:function(){for(var e in this._observersStore){var t=document.getElementById(e),n=this._observersStore[e];n.onresize=null,t&&(t.removeChild(n),delete this._observersStore[t.getAttribute("id")])}}},{key:"_createIframe",value:function(){var e=document.createElement("iframe");return e.className="pakhshkit-size-iframe",e}}]),e}();t.ResizeWatcher=h},function(e,t,n){"use strict";function i(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.FullscreenController=void 0;var a=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}(),o=n(4),s=i(o),u=n(8),l=(i(u),n(1)),c=i(l),d=n(5),f=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}(d),h=function(){function e(t){r(this,e),this._player=t,this._inBrowserFullscreenConfig=this._player.config.playback.inBrowserFullscreen,this._playsinlineConfig=this._player.config.playback.playsinline,this._isInBrowserFullscreen=!1,this._isEnterFullscreenEventFired=!1,this.registerFullScreenEvents()}return a(e,[{key:"_isNativeFullscreen",value:function(){var e="function"==typeof this._player.getVideoElement?this._player.getVideoElement():null;return!!(document.fullscreenElement||document.webkitFullscreenElement||document.mozFullScreenElement||document.msFullscreenElement||"iOS"===this._player.env.os.name&&e&&e.webkitDisplayingFullscreen)}},{key:"isFullscreen",value:function(){return this._isNativeFullscreen()||this._isInBrowserFullscreen}},{key:"enterFullscreen",value:function(e){if(!this.isFullscreen()){var t=e&&f.Dom.getElementById(e);if(t||(t=this._player.getView()),"iOS"===this._player.env.os.name)if(this._inBrowserFullscreenConfig&&this._playsinlineConfig)this._enterInBrowserFullscreen(t);else{var n=this._player.getVideoElement();n&&"function"==typeof n.webkitEnterFullScreen&&n.webkitEnterFullScreen()}else this._requestFullscreen(t)}}},{key:"exitFullscreen",value:function(){if(this.isFullscreen())if("iOS"===this._player.env.os.name)if(this._inBrowserFullscreenConfig&&this._playsinlineConfig)this._exitInBrowserFullscreen();else{var e=this._player.getVideoElement();e&&"function"==typeof e.webkitExitFullscreen&&e.webkitExitFullscreen()}else this._requestExitFullscreen()}},{key:"_requestFullscreen",value:function(e){this._player.isInPictureInPicture()&&this._player.exitPictureInPicture(),"function"==typeof e.requestFullscreen?e.requestFullscreen():"function"==typeof e.mozRequestFullScreen?e.mozRequestFullScreen():"function"==typeof e.webkitRequestFullScreen?e.webkitRequestFullScreen():"function"==typeof e.msRequestFullscreen&&e.msRequestFullscreen()}},{key:"_requestExitFullscreen",value:function(){"function"==typeof document.exitFullscreen?document.exitFullscreen():"function"==typeof document.webkitExitFullscreen?document.webkitExitFullscreen():"function"==typeof document.mozCancelFullScreen?document.mozCancelFullScreen():"function"==typeof document.msExitFullscreen&&document.msExitFullscreen()}},{key:"_enterInBrowserFullscreen",value:function(e){f.Dom.addClassName(e,"pakhshkit-in-browser-fullscreen-mode"),this._isInBrowserFullscreen=!0,this._fullscreenEnterHandler(),this._player.dispatchEvent(new c.default(this._player.Event.RESIZE))}},{key:"_exitInBrowserFullscreen",value:function(){var e=f.Dom.getElementBySelector(".pakhshkit-in-browser-fullscreen-mode");e&&f.Dom.removeClassName(e,"pakhshkit-in-browser-fullscreen-mode"),this._isInBrowserFullscreen=!1,this._fullscreenExitHandler(),this._player.dispatchEvent(new c.default(this._player.Event.RESIZE))}},{key:"registerFullScreenEvents",value:function(){var e=this,t=new s.default;t.listen(document,"webkitfullscreenchange",function(){return e._fullscreenChangeHandler()}),t.listen(document,"mozfullscreenchange",function(){return e._fullscreenChangeHandler()}),t.listen(document,"fullscreenchange",function(){return e._fullscreenChangeHandler()}),t.listen(document,"MSFullscreenChange",function(){return e._fullscreenChangeHandler()}),this._handleIosFullscreen(t)}},{key:"_handleIosFullscreen",value:function(e){var t=this;if("iOS"===this._player.env.os.name){var n=function(){e.listen(t._player.getVideoElement(),"webkitbeginfullscreen",function(){return t._fullscreenEnterHandler()}),e.listen(t._player.getVideoElement(),"webkitendfullscreen",function(){return t._fullscreenExitHandler()})};this._player.getVideoElement()?n():e.listenOnce(this._player,this._player.Event.SOURCE_SELECTED,function(){return n()})}}},{key:"_fullscreenChangeHandler",value:function(){this.isFullscreen()?this._fullscreenEnterHandler():this._fullscreenExitHandler()}},{key:"_fullscreenEnterHandler",value:function(){this.isFullscreen()&&!this._isEnterFullscreenEventFired&&(this._player.dispatchEvent(new c.default(this._player.Event.ENTER_FULLSCREEN)),this._isEnterFullscreenEventFired=!0)}},{key:"_fullscreenExitHandler",value:function(){!this.isFullscreen()&&this._isEnterFullscreenEventFired&&(this._player.dispatchEvent(new c.default(this._player.Event.EXIT_FULLSCREEN)),this._isEnterFullscreenEventFired=!1)}}]),e}();t.FullscreenController=h},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i={HLS:["application/x-mpegurl","application/vnd.apple.mpegurl"],DASH:["application/dash+xml"],PROGRESSIVE:["video/mp4"],SMOOTH_STREAMING:["application/vnd.ms-sstr+xml"]};t.MimeType=i},function(e,t,n){"use strict";function i(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.BaseEngineDecorator=void 0;var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}(),u=n(10),l=(i(u),n(11)),c=(i(l),n(9)),d=(i(c),n(6)),f=i(d),h=n(3),_=n(4),p=i(_),A=function(e){function t(e){r(this,t);var n=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this));return n._engine=e,n._eventManager=new p.default,Object.values(h.EventType).forEach(function(e){return n._eventManager.listen(n._engine,e,function(e){return n.dispatchEvent(e)})}),n}return o(t,e),s(t,[{key:"restore",value:function(e,t){this._engine.restore(e,t)}},{key:"attach",value:function(){this._engine.attach()}},{key:"detach",value:function(){this._engine.detach()}},{key:"load",value:function(e){return this._engine.load(e)}},{key:"play",value:function(){this._engine.play()}},{key:"pause",value:function(){this._engine.pause()}},{key:"getVideoElement",value:function(){return this._engine.getVideoElement()}},{key:"reset",value:function(){this._engine.reset()}},{key:"destroy",value:function(){this._eventManager.destroy()}},{key:"isLive",value:function(){return this._engine.isLive()}},{key:"isDvr",value:function(){return this._engine.isDvr()}},{key:"seekToLiveEdge",value:function(){this._engine.seekToLiveEdge()}},{key:"getStartTimeOfDvrWindow",value:function(){return this._engine.getStartTimeOfDvrWindow()}},{key:"selectVideoTrack",value:function(e){this._engine.selectVideoTrack(e)}},{key:"selectAudioTrack",value:function(e){this._engine.selectAudioTrack(e)}},{key:"selectTextTrack",value:function(e){this._engine.selectTextTrack(e)}},{key:"hideTextTrack",value:function(){this._engine.hideTextTrack()}},{key:"resetAllCues",value:function(){this._engine.resetAllCues()}},{key:"enableAdaptiveBitrate",value:function(){this._engine.enableAdaptiveBitrate()}},{key:"isAdaptiveBitrateEnabled",value:function(){return this._engine.isAdaptiveBitrateEnabled()}},{key:"enterPictureInPicture",value:function(){this._engine.enterPictureInPicture()}},{key:"exitPictureInPicture",value:function(){this._engine.exitPictureInPicture()}},{key:"isPictureInPictureSupported",value:function(){return this._engine.isPictureInPictureSupported()}},{key:"isInPictureInPicture",get:function(){return this._engine.isInPictureInPicture}},{key:"id",get:function(){return this._engine.id}},{key:"buffered",get:function(){return this._engine.buffered}},{key:"currentTime",set:function(e){this._engine.currentTime=e},get:function(){return this._engine.currentTime}},{key:"duration",get:function(){return this._engine.duration}},{key:"volume",set:function(e){this._engine.volume=e},get:function(){return this._engine.volume}},{key:"paused",get:function(){return this._engine.paused}},{key:"seeking",get:function(){return this._engine.seeking}},{key:"playsinline",set:function(e){this._engine.playsinline=e},get:function(){return this._engine.playsinline}},{key:"muted",set:function(e){this._engine.muted=e},get:function(){return this._engine.muted}},{key:"src",set:function(e){this._engine.src=e},get:function(){return this._engine.src}},{key:"autoplay",set:function(e){this._engine.autoplay=e},get:function(){return this._engine.autoplay}},{key:"controls",set:function(e){this._engine.controls=e},get:function(){return this._engine.controls}},{key:"defaultMuted",get:function(){return this._engine.defaultMuted}},{key:"error",get:function(){return this._engine.error}},{key:"loop",set:function(e){this._engine.loop=e},get:function(){return this._engine.loop}},{key:"networkState",get:function(){return this._engine.networkState}},{key:"played",get:function(){return this._engine.played}},{key:"poster",set:function(e){this._engine.poster=e},get:function(){return this._engine.poster}},{key:"preload",set:function(e){this._engine.preload=e},get:function(){return this._engine.preload}},{key:"readyState",get:function(){return this._engine.readyState}},{key:"seekable",get:function(){return this._engine.seekable}},{key:"videoHeight",get:function(){return this._engine.videoHeight}},{key:"videoWidth",get:function(){return this._engine.videoWidth}},{key:"playbackRate",set:function(e){this._engine.playbackRate=e},get:function(){return this._engine.playbackRate}},{key:"playbackRates",get:function(){return this._engine.playbackRates}},{key:"defaultPlaybackRate",set:function(e){this._engine.defaultPlaybackRate=e},get:function(){return this._engine.defaultPlaybackRate}},{key:"ended",get:function(){return this._engine.ended}},{key:"crossOrigin",set:function(e){this._engine.crossOrigin=e},get:function(){return this._engine.crossOrigin}}]),t}(f.default);t.BaseEngineDecorator=A}])});


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(25);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 12 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(7);
var createDesc = __webpack_require__(33);
module.exports = __webpack_require__(6) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var hide = __webpack_require__(13);
var has = __webpack_require__(12);
var SRC = __webpack_require__(34)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(23).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var fails = __webpack_require__(3);
var defined = __webpack_require__(25);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setLogLevel = exports.getLogLevel = exports.LogLevel = undefined;

var _jsLogger = __webpack_require__(149);

var JsLogger = _interopRequireWildcard(_jsLogger);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var LogLevel = {
  DEBUG: JsLogger.DEBUG,
  INFO: JsLogger.INFO,
  TIME: JsLogger.TIME,
  WARN: JsLogger.WARN,
  ERROR: JsLogger.ERROR,
  OFF: JsLogger.OFF
};


JsLogger.useDefaults({ defaultLevel: JsLogger.ERROR });

/**
 * get a logger
 * @private
 * @param {?string} name - the logger name
 * @returns {Object} - the logger class
 */
function getLogger(name) {
  if (!name) {
    return JsLogger;
  }
  return JsLogger.get(name);
}

/**
 * get the log level
 * @private
 * @param {?string} name - the logger name
 * @returns {LogLevelObject} - the log level
 */
function getLogLevel(name) {
  return getLogger(name).getLevel();
}

/**
 * sets the logger level
 * @private
 * @param {LogLevelObject} level - the log level
 * @param {?string} name - the logger name
 * @returns {void}
 */
function setLogLevel(level, name) {
  getLogger(name).setLevel(level);
}

exports.default = getLogger;
exports.LogLevel = LogLevel;
exports.getLogLevel = getLogLevel;
exports.setLogLevel = setLogLevel;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(50);
var defined = __webpack_require__(25);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(51);
var createDesc = __webpack_require__(33);
var toIObject = __webpack_require__(17);
var toPrimitive = __webpack_require__(24);
var has = __webpack_require__(12);
var IE8_DOM_DEFINE = __webpack_require__(102);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(6) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(12);
var toObject = __webpack_require__(10);
var IE_PROTO = __webpack_require__(74)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(11);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 21 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(3);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 23 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(4);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 25 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 26 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(0);
var core = __webpack_require__(23);
var fails = __webpack_require__(3);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(20);
var IObject = __webpack_require__(50);
var toObject = __webpack_require__(10);
var toLength = __webpack_require__(8);
var asc = __webpack_require__(91);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(6)) {
  var LIBRARY = __webpack_require__(35);
  var global = __webpack_require__(2);
  var fails = __webpack_require__(3);
  var $export = __webpack_require__(0);
  var $typed = __webpack_require__(64);
  var $buffer = __webpack_require__(97);
  var ctx = __webpack_require__(20);
  var anInstance = __webpack_require__(41);
  var propertyDesc = __webpack_require__(33);
  var hide = __webpack_require__(13);
  var redefineAll = __webpack_require__(43);
  var toInteger = __webpack_require__(26);
  var toLength = __webpack_require__(8);
  var toIndex = __webpack_require__(128);
  var toAbsoluteIndex = __webpack_require__(37);
  var toPrimitive = __webpack_require__(24);
  var has = __webpack_require__(12);
  var classof = __webpack_require__(52);
  var isObject = __webpack_require__(4);
  var toObject = __webpack_require__(10);
  var isArrayIter = __webpack_require__(88);
  var create = __webpack_require__(38);
  var getPrototypeOf = __webpack_require__(19);
  var gOPN = __webpack_require__(39).f;
  var getIterFn = __webpack_require__(90);
  var uid = __webpack_require__(34);
  var wks = __webpack_require__(5);
  var createArrayMethod = __webpack_require__(28);
  var createArrayIncludes = __webpack_require__(55);
  var speciesConstructor = __webpack_require__(62);
  var ArrayIterators = __webpack_require__(93);
  var Iterators = __webpack_require__(47);
  var $iterDetect = __webpack_require__(59);
  var setSpecies = __webpack_require__(40);
  var arrayFill = __webpack_require__(92);
  var arrayCopyWithin = __webpack_require__(118);
  var $DP = __webpack_require__(7);
  var $GOPD = __webpack_require__(18);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(123);
var $export = __webpack_require__(0);
var shared = __webpack_require__(54)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(126))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(34)('meta');
var isObject = __webpack_require__(4);
var has = __webpack_require__(12);
var setDesc = __webpack_require__(7).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(3)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(5)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(13)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 34 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 35 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(104);
var enumBugKeys = __webpack_require__(75);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(26);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(1);
var dPs = __webpack_require__(105);
var enumBugKeys = __webpack_require__(75);
var IE_PROTO = __webpack_require__(74)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(72)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(76).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(104);
var hiddenKeys = __webpack_require__(75).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(2);
var dP = __webpack_require__(7);
var DESCRIPTORS = __webpack_require__(6);
var SPECIES = __webpack_require__(5)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 41 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(20);
var call = __webpack_require__(116);
var isArrayIter = __webpack_require__(88);
var anObject = __webpack_require__(1);
var toLength = __webpack_require__(8);
var getIterFn = __webpack_require__(90);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(14);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VidiunPlayer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _pakhshkitJsUi = __webpack_require__(68);

var _pakhshkitJsProviders = __webpack_require__(136);

var _setupHelpers = __webpack_require__(138);

var _logger = __webpack_require__(16);

var _logger2 = _interopRequireDefault(_logger);

var _vidiunParams = __webpack_require__(143);

var _pluginsConfig = __webpack_require__(144);

var _poster = __webpack_require__(145);

__webpack_require__(371);

var _uiWrapper = __webpack_require__(141);

var _playlistManager = __webpack_require__(376);

var _playlistEventType = __webpack_require__(101);

var _castEventType = __webpack_require__(100);

var _remotePlayerManager = __webpack_require__(98);

var _baseRemotePlayer = __webpack_require__(70);

var _remoteSession = __webpack_require__(53);

var _pakhshkitJs = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VidiunPlayer = function (_FakeEventTarget) {
  _inherits(VidiunPlayer, _FakeEventTarget);

  function VidiunPlayer(options) {
    _classCallCheck(this, VidiunPlayer);

    var _this = _possibleConstructorReturn(this, (VidiunPlayer.__proto__ || Object.getPrototypeOf(VidiunPlayer)).call(this));

    _this._mediaInfo = null;
    _this._remotePlayer = null;

    _this._eventManager = new _pakhshkitJs.EventManager();
    var sources = options.sources;

    var noSourcesOptions = _pakhshkitJs.Utils.Object.mergeDeep({}, options, { sources: null });
    _this._localPlayer = (0, _pakhshkitJs.loadPlayer)(noSourcesOptions);
    _this._logger = (0, _logger2.default)('VidiunPlayer' + _pakhshkitJs.Utils.Generator.uniqueId(5));
    _this._uiWrapper = new _uiWrapper.UIWrapper(_this, options);
    _this._provider = new _pakhshkitJsProviders.Provider(options.provider, "0.41.2");
    _this._playlistManager = new _playlistManager.PlaylistManager(_this, options);
    _this._playlistManager.configure(options.playlist);
    Object.values(_pakhshkitJs.EventType).forEach(function (coreEvent) {
      return _this._eventManager.listen(_this._localPlayer, coreEvent, function (e) {
        return _this.dispatchEvent(e);
      });
    });
    _this._localPlayer.configure({ sources: sources });
    return _this;
  }

  _createClass(VidiunPlayer, [{
    key: 'loadMedia',
    value: function loadMedia(mediaInfo) {
      var _this2 = this;

      this._logger.debug('loadMedia', mediaInfo);
      this._mediaInfo = mediaInfo;
      this.reset();
      this._localPlayer.loadingMedia = true;
      this._uiWrapper.setLoadingSpinnerState(true);
      var providerResult = this._provider.getMediaConfig(mediaInfo);
      providerResult.then(function (mediaConfig) {
        return _this2.setMedia(mediaConfig);
      }, function (e) {
        return _this2._localPlayer.dispatchEvent(new _pakhshkitJs.FakeEvent(_pakhshkitJs.EventType.ERROR, new _pakhshkitJs.Error(_pakhshkitJs.Error.Severity.CRITICAL, _pakhshkitJs.Error.Category.PLAYER, _pakhshkitJs.Error.Code.LOAD_FAILED, e)));
      }).then(function () {
        _this2._maybeSetEmbedConfig();
      });
      return providerResult;
    }
  }, {
    key: 'setMedia',
    value: function setMedia(mediaConfig) {
      this._logger.debug('setMedia', mediaConfig);
      var playerConfig = _pakhshkitJs.Utils.Object.copyDeep(mediaConfig);
      _pakhshkitJs.Utils.Object.mergeDeep(playerConfig.sources, this._localPlayer.config.sources);
      _pakhshkitJs.Utils.Object.mergeDeep(playerConfig.session, this._localPlayer.config.session);
      Object.keys(this._localPlayer.config.plugins).forEach(function (name) {
        playerConfig.plugins[name] = {};
      });
      (0, _poster.addVidiunPoster)(playerConfig.sources, mediaConfig.sources, this._localPlayer.dimensions);
      (0, _vidiunParams.addVidiunParams)(this, playerConfig);
      (0, _setupHelpers.maybeSetStreamPriority)(this, playerConfig);
      if (!(0, _setupHelpers.hasYoutubeSource)(playerConfig.sources)) {
        this._uiWrapper.setSeekbarConfig(mediaConfig, this._localPlayer.config.ui);
      }
      this.configure(playerConfig);
    }

    /**
     * Loads a playlist by id.
     * @param {ProviderPlaylistInfoObject} playlistInfo - The playlist info.
     * @param {VPPlaylistConfigObject} [playlistConfig] - The playlist config.
     * @returns {Promise<ProviderPlaylistObject>} - The playlist data from the provider.
     * @instance
     * @memberof VidiunPlayer
     * @example
     * vidiunPlayer.loadPlaylist({playlistId: '123456'}, {options: {autoContinue: false}});
     */

  }, {
    key: 'loadPlaylist',
    value: function loadPlaylist(playlistInfo, playlistConfig) {
      var _this3 = this;

      this._logger.debug('loadPlaylist', playlistInfo);
      this._uiWrapper.setLoadingSpinnerState(true);
      var providerResult = this._provider.getPlaylistConfig(playlistInfo);
      providerResult.then(function (playlistData) {
        return _this3.setPlaylist(playlistData, playlistConfig);
      }, function (e) {
        return _this3._localPlayer.dispatchEvent(new _pakhshkitJs.FakeEvent(_pakhshkitJs.EventType.ERROR, new _pakhshkitJs.Error(_pakhshkitJs.Error.Severity.CRITICAL, _pakhshkitJs.Error.Category.PLAYER, _pakhshkitJs.Error.Code.LOAD_FAILED, e)));
      });
      return providerResult;
    }

    /**
     * Loads a playlist by entry list.
     * @param {ProviderEntryListObject} entryList - The playlist info.
     * @param {VPPlaylistConfigObject} [playlistConfig] - The playlist config.
     * @returns {Promise<ProviderPlaylistObject>} - The playlist data from the provider.
     * @instance
     * @memberof VidiunPlayer
     * @example
     * vidiunPlayer.loadPlaylistByEntryList({entries: [{entryId: '01234'}, {entryId: '56789'}]}, {options: {autoContinue: false}});
     */

  }, {
    key: 'loadPlaylistByEntryList',
    value: function loadPlaylistByEntryList(entryList, playlistConfig) {
      var _this4 = this;

      this._logger.debug('loadPlaylistByEntryList', entryList);
      this._uiWrapper.setLoadingSpinnerState(true);
      var providerResult = this._provider.getEntryListConfig(entryList);
      providerResult.then(function (playlistData) {
        return _this4.setPlaylist(playlistData, playlistConfig, entryList);
      }, function (e) {
        return _this4._localPlayer.dispatchEvent(new _pakhshkitJs.FakeEvent(_pakhshkitJs.EventType.ERROR, new _pakhshkitJs.Error(_pakhshkitJs.Error.Severity.CRITICAL, _pakhshkitJs.Error.Category.PLAYER, _pakhshkitJs.Error.Code.LOAD_FAILED, e)));
      });
      return providerResult;
    }
  }, {
    key: 'setPlaylist',
    value: function setPlaylist(playlistData, playlistConfig, entryList) {
      this._logger.debug('setPlaylist', playlistData);
      var config = { playlist: playlistData, plugins: {} };
      Object.keys(this._localPlayer.config.plugins).forEach(function (name) {
        config.plugins[name] = {};
      });
      // $FlowFixMe
      (0, _pluginsConfig.evaluatePluginsConfig)(config.plugins, config);
      this._localPlayer.configure({ plugins: config.plugins });
      this._playlistManager.load(playlistData, playlistConfig, entryList);
    }
  }, {
    key: 'getMediaInfo',
    value: function getMediaInfo() {
      return _pakhshkitJs.Utils.Object.copyDeep(this._mediaInfo);
    }

    /**
     * Config the player.
     * @param {Object} [config={}] - The player config.
     * @returns {void}
     * @instance
     * @memberof VidiunPlayer
     * @example
     * vidiunPlayer.configure({playback: {autoplay: true}});
     */

  }, {
    key: 'configure',
    value: function configure() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      config = (0, _setupHelpers.supportLegacyOptions)(config);
      var configDoctionary = _pakhshkitJs.Utils.Object.mergeDeep({}, this.config, config);
      (0, _pluginsConfig.evaluatePluginsConfig)(config.plugins, configDoctionary);
      this._localPlayer.configure(config);
      var uiConfig = config.ui;
      if (uiConfig) {
        (0, _pluginsConfig.evaluateUIConfig)(uiConfig, this.config);
        this._uiWrapper.setConfig(uiConfig);
      }
      if (config.playlist) {
        this._playlistManager.configure(config.playlist);
      }
    }
  }, {
    key: 'ready',
    value: function ready() {
      return this._localPlayer.ready();
    }
  }, {
    key: 'load',
    value: function load() {
      this._localPlayer.load();
    }
  }, {
    key: 'play',
    value: function play() {
      this._localPlayer.play();
    }
  }, {
    key: 'pause',
    value: function pause() {
      this._localPlayer.pause();
    }
  }, {
    key: 'getView',
    value: function getView() {
      return this._localPlayer.getView();
    }
  }, {
    key: 'getVideoElement',
    value: function getVideoElement() {
      return this._localPlayer.getVideoElement();
    }
  }, {
    key: 'reset',
    value: function reset() {
      this._localPlayer.reset();
      this._uiWrapper.reset();
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      var targetId = this.config.ui.targetId;
      this._localPlayer.destroy();
      this._uiWrapper.destroy();
      this._eventManager.destroy();
      var targetContainer = document.getElementById(targetId);
      if (targetContainer && targetContainer.parentNode) {
        _pakhshkitJs.Utils.Dom.removeChild(targetContainer.parentNode, targetContainer);
      }
    }
  }, {
    key: 'isLive',
    value: function isLive() {
      return this._localPlayer.isLive();
    }
  }, {
    key: 'isDvr',
    value: function isDvr() {
      return this._localPlayer.isDvr();
    }
  }, {
    key: 'seekToLiveEdge',
    value: function seekToLiveEdge() {
      this._localPlayer.seekToLiveEdge();
    }
  }, {
    key: 'getStartTimeOfDvrWindow',
    value: function getStartTimeOfDvrWindow() {
      return this._localPlayer.getStartTimeOfDvrWindow();
    }
  }, {
    key: 'getTracks',
    value: function getTracks(type) {
      return this._localPlayer.getTracks(type);
    }
  }, {
    key: 'getActiveTracks',
    value: function getActiveTracks() {
      return this._localPlayer.getActiveTracks();
    }
  }, {
    key: 'selectTrack',
    value: function selectTrack(track) {
      this._localPlayer.selectTrack(track);
    }
  }, {
    key: 'hideTextTrack',
    value: function hideTextTrack() {
      this._localPlayer.hideTextTrack();
    }
  }, {
    key: 'enableAdaptiveBitrate',
    value: function enableAdaptiveBitrate() {
      this._localPlayer.enableAdaptiveBitrate();
    }
  }, {
    key: 'isAdaptiveBitrateEnabled',
    value: function isAdaptiveBitrateEnabled() {
      return this._localPlayer.isAdaptiveBitrateEnabled();
    }
  }, {
    key: 'setTextDisplaySettings',
    value: function setTextDisplaySettings(settings) {
      this._localPlayer.setTextDisplaySettings(settings);
    }
  }, {
    key: 'isFullscreen',
    value: function isFullscreen() {
      return this._localPlayer.isFullscreen();
    }
  }, {
    key: 'notifyEnterFullscreen',
    value: function notifyEnterFullscreen() {
      this._localPlayer.notifyEnterFullscreen();
    }
  }, {
    key: 'notifyExitFullscreen',
    value: function notifyExitFullscreen() {
      this._localPlayer.notifyExitFullscreen();
    }
  }, {
    key: 'enterFullscreen',
    value: function enterFullscreen(fullScreenElementId) {
      var elementId = fullScreenElementId ? fullScreenElementId : this.config.ui.targetId;
      this._localPlayer.enterFullscreen(elementId);
    }
  }, {
    key: 'exitFullscreen',
    value: function exitFullscreen() {
      this._localPlayer.exitFullscreen();
    }
  }, {
    key: 'enterPictureInPicture',
    value: function enterPictureInPicture() {
      this._localPlayer.enterPictureInPicture();
    }
  }, {
    key: 'exitPictureInPicture',
    value: function exitPictureInPicture() {
      this._localPlayer.exitPictureInPicture();
    }
  }, {
    key: 'isInPictureInPicture',
    value: function isInPictureInPicture() {
      return this._localPlayer.isInPictureInPicture();
    }
  }, {
    key: 'isPictureInPictureSupported',
    value: function isPictureInPictureSupported() {
      return this._localPlayer.isPictureInPictureSupported();
    }
  }, {
    key: 'getLogLevel',
    value: function getLogLevel(name) {
      return this._localPlayer.getLogLevel(name);
    }
  }, {
    key: 'startCasting',
    value: function startCasting(type) {
      return _remotePlayerManager.RemotePlayerManager.startCasting(type);
    }
  }, {
    key: 'isCastAvailable',
    value: function isCastAvailable(type) {
      return _remotePlayerManager.RemotePlayerManager.isCastAvailable(type);
    }
  }, {
    key: 'getCastSession',
    value: function getCastSession() {
      return null;
    }
  }, {
    key: 'stopCasting',
    value: function stopCasting() {
      // Empty implementation
    }
  }, {
    key: 'isCasting',
    value: function isCasting() {
      return false;
    }
  }, {
    key: 'isVr',
    value: function isVr() {
      return this._localPlayer.isVr();
    }
  }, {
    key: 'toggleVrStereoMode',
    value: function toggleVrStereoMode() {
      this._localPlayer.toggleVrStereoMode();
    }
  }, {
    key: 'isInVrStereoMode',
    value: function isInVrStereoMode() {
      return this._localPlayer.isInVrStereoMode();
    }
  }, {
    key: 'setLogLevel',
    value: function setLogLevel(level, name) {
      this._localPlayer.setLogLevel(level, name);
    }
  }, {
    key: '_maybeSetEmbedConfig',


    /**
     * set the share config
     * @returns {void}
     * @private
     */
    value: function _maybeSetEmbedConfig() {
      var ui = this.config.ui;
      if (ui && ui.components && ui.components.share) {
        (0, _pluginsConfig.evaluateUIConfig)(ui, this.config);
        this._uiWrapper.setConfig(ui);
      }
    }
  }, {
    key: 'textStyle',
    set: function set(style) {
      this._localPlayer.textStyle = style;
    },
    get: function get() {
      return this._localPlayer.textStyle;
    }
  }, {
    key: 'buffered',
    get: function get() {
      return this._localPlayer.buffered;
    }
  }, {
    key: 'currentTime',
    set: function set(to) {
      this._localPlayer.currentTime = to;
    },
    get: function get() {
      return this._localPlayer.currentTime;
    }
  }, {
    key: 'duration',
    get: function get() {
      return this._localPlayer.duration;
    }
  }, {
    key: 'volume',
    set: function set(vol) {
      this._localPlayer.volume = vol;
    },
    get: function get() {
      return this._localPlayer.volume;
    }
  }, {
    key: 'paused',
    get: function get() {
      return this._localPlayer.paused;
    }
  }, {
    key: 'seeking',
    get: function get() {
      return this._localPlayer.seeking;
    }
  }, {
    key: 'playsinline',
    set: function set(playsinline) {
      this._localPlayer.playsinline = playsinline;
    },
    get: function get() {
      return this._localPlayer.playsinline;
    }
  }, {
    key: 'muted',
    set: function set(mute) {
      this._localPlayer.muted = mute;
    },
    get: function get() {
      return this._localPlayer.muted;
    }
  }, {
    key: 'src',
    get: function get() {
      return this._localPlayer.src;
    }
  }, {
    key: 'dimensions',
    get: function get() {
      return this._localPlayer.dimensions;
    }
  }, {
    key: 'poster',
    get: function get() {
      return this._localPlayer.poster;
    }
  }, {
    key: 'ended',
    get: function get() {
      return this._localPlayer.ended;
    }
  }, {
    key: 'playbackRate',
    set: function set(rate) {
      this._localPlayer.playbackRate = rate;
    },
    get: function get() {
      return this._localPlayer.playbackRate;
    }
  }, {
    key: 'playbackRates',
    get: function get() {
      return this._localPlayer.playbackRates;
    }
  }, {
    key: 'defaultPlaybackRate',
    get: function get() {
      return this._localPlayer.defaultPlaybackRate;
    }
  }, {
    key: 'engineType',
    get: function get() {
      return this._localPlayer.engineType;
    }
  }, {
    key: 'streamType',
    get: function get() {
      return this._localPlayer.streamType;
    }
  }, {
    key: 'env',
    get: function get() {
      return this._localPlayer.env;
    }
  }, {
    key: 'config',
    get: function get() {
      return this._localPlayer.config;
    }
  }, {
    key: 'loadingMedia',
    set: function set(loading) {
      this._localPlayer.loadingMedia = loading;
    }
  }, {
    key: 'ads',
    get: function get() {
      return this._localPlayer.ads;
    }
  }, {
    key: 'plugins',
    get: function get() {
      return this._localPlayer.plugins;
    }

    /**
     * The playlist controller.
     * @type {PlaylistManager}
     * @instance
     * @memberof VidiunPlayer
     * @example
     * VidiunPlayer.playlist.playNext();
     */

  }, {
    key: 'playlist',
    get: function get() {
      return this._playlistManager;
    }
  }, {
    key: 'Event',
    get: function get() {
      return _extends({
        Cast: _castEventType.CastEventType,
        Core: _pakhshkitJs.EventType,
        Playlist: _playlistEventType.PlaylistEventType,
        UI: _pakhshkitJsUi.EventType
      }, _pakhshkitJs.EventType);
    }
  }, {
    key: 'TextStyle',
    get: function get() {
      return this._localPlayer.TextStyle;
    }
  }, {
    key: 'State',
    get: function get() {
      return this._localPlayer.State;
    }
  }, {
    key: 'Track',
    get: function get() {
      return this._localPlayer.Track;
    }
  }, {
    key: 'LogLevelType',
    get: function get() {
      return this._localPlayer.LogLevelType;
    }
  }, {
    key: 'LogLevel',
    get: function get() {
      return this._localPlayer.LogLevel;
    }
  }, {
    key: 'AbrMode',
    get: function get() {
      return this._localPlayer.AbrMode;
    }
  }, {
    key: 'MediaType',
    get: function get() {
      return this._localPlayer.MediaType;
    }
  }, {
    key: 'StreamType',
    get: function get() {
      return this._localPlayer.StreamType;
    }
  }, {
    key: 'EngineType',
    get: function get() {
      return this._localPlayer.EngineType;
    }
  }, {
    key: 'Error',
    get: function get() {
      return this._localPlayer.Error;
    }
  }]);

  return VidiunPlayer;
}(_pakhshkitJs.FakeEventTarget);

exports.VidiunPlayer = VidiunPlayer;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(7).f;
var has = __webpack_require__(12);
var TAG = __webpack_require__(5)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var defined = __webpack_require__(25);
var fails = __webpack_require__(3);
var spaces = __webpack_require__(78);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(4);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 49 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(21);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 51 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(21);
var TAG = __webpack_require__(5)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class RemoteSession
 * @param {string} id - Session ID.
 * @param {string} friendlyName - Receiver friendly name.
 * @param {boolean} [resuming] - Whether the session is resuming.
 */
var RemoteSession = function () {
  function RemoteSession(id, friendlyName, resuming) {
    _classCallCheck(this, RemoteSession);

    this._id = id;
    this._friendlyName = friendlyName;
    this._resuming = resuming;
  }

  /**
   * Receiver friendly name.
   * @type {string}
   * @instance
   * @memberof RemoteSession
   */


  _createClass(RemoteSession, [{
    key: "deviceFriendlyName",
    get: function get() {
      return this._friendlyName;
    }

    /**
     * Session ID.
     * @type {string}
     * @instance
     * @memberof RemoteSession
     */

  }, {
    key: "id",
    get: function get() {
      return this._id;
    }

    /**
     * Whether the session is resuming.
     * @type {?boolean}
     * @instance
     * @memberof RemoteSession
     */

  }, {
    key: "resuming",
    get: function get() {
      return this._resuming;
    }
  }]);

  return RemoteSession;
}();

exports.RemoteSession = RemoteSession;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(17);
var toLength = __webpack_require__(8);
var toAbsoluteIndex = __webpack_require__(37);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 56 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(21);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(4);
var cof = __webpack_require__(21);
var MATCH = __webpack_require__(5)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(5)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(1);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hide = __webpack_require__(13);
var redefine = __webpack_require__(14);
var fails = __webpack_require__(3);
var defined = __webpack_require__(25);
var wks = __webpack_require__(5);

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);
  var fns = exec(defined, SYMBOL, ''[KEY]);
  var strfn = fns[0];
  var rxfn = fns[1];
  if (fails(function () {
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  })) {
    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(1);
var aFunction = __webpack_require__(11);
var SPECIES = __webpack_require__(5)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(2);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(14);
var redefineAll = __webpack_require__(43);
var meta = __webpack_require__(31);
var forOf = __webpack_require__(42);
var anInstance = __webpack_require__(41);
var isObject = __webpack_require__(4);
var fails = __webpack_require__(3);
var $iterDetect = __webpack_require__(59);
var setToStringTag = __webpack_require__(45);
var inheritIfRequired = __webpack_require__(79);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var hide = __webpack_require__(13);
var uid = __webpack_require__(34);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(35) || !__webpack_require__(3)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(2)[K];
});


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(11);
var ctx = __webpack_require__(20);
var forOf = __webpack_require__(42);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("ui",[],t):"object"==typeof exports?exports.ui=t():(e.pakhshkit=e.pakhshkit||{},e.pakhshkit.ui=t())}(this,function(){return function(e){function t(a){if(n[a])return n[a].exports;var r=n[a]={i:a,l:!1,exports:{}};return e[a].call(r.exports,r,r.exports,t),r.l=!0,r.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,a){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:a})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=88)}([function(e,t,n){!function(){"use strict";function t(){}function n(e,n){var a,r,o,i,s=I;for(i=arguments.length;i-- >2;)j.push(arguments[i]);for(n&&null!=n.children&&(j.length||j.push(n.children),delete n.children);j.length;)if((r=j.pop())&&void 0!==r.pop)for(i=r.length;i--;)j.push(r[i]);else!0!==r&&!1!==r||(r=null),(o="function"!=typeof e)&&(null==r?r="":"number"==typeof r?r=String(r):"string"!=typeof r&&(o=!1)),o&&a?s[s.length-1]+=r:s===I?s=[r]:s.push(r),a=o;var l=new t;return l.nodeName=e,l.children=s,l.attributes=null==n?void 0:n,l.key=null==n?void 0:n.key,void 0!==M.vnode&&M.vnode(l),l}function a(e,t){for(var n in t)e[n]=t[n];return e}function r(e,t){return n(e.nodeName,a(a({},e.attributes),t),arguments.length>2?[].slice.call(arguments,2):e.children)}function o(e){!e.__d&&(e.__d=!0)&&1==N.push(e)&&(M.debounceRendering||setTimeout)(i)}function i(){var e,t=N;for(N=[];e=t.pop();)e.__d&&T(e)}function s(e,t,n){return"string"==typeof t||"number"==typeof t?void 0!==e.splitText:"string"==typeof t.nodeName?!e._componentConstructor&&l(e,t.nodeName):n||e._componentConstructor===t.nodeName}function l(e,t){return e.__n===t||e.nodeName.toLowerCase()===t.toLowerCase()}function p(e){var t=a({},e.attributes);t.children=e.children;var n=e.nodeName.defaultProps;if(void 0!==n)for(var r in n)void 0===t[r]&&(t[r]=n[r]);return t}function c(e,t){var n=t?document.createElementNS("http://www.w3.org/2000/svg",e):document.createElement(e);return n.__n=e,n}function u(e){e.parentNode&&e.parentNode.removeChild(e)}function h(e,t,n,a,r){if("className"===t&&(t="class"),"key"===t);else if("ref"===t)n&&n(null),a&&a(e);else if("class"!==t||r)if("style"===t){if(a&&"string"!=typeof a&&"string"!=typeof n||(e.style.cssText=a||""),a&&"object"==typeof a){if("string"!=typeof n)for(var o in n)o in a||(e.style[o]="");for(var o in a)e.style[o]="number"==typeof a[o]&&!1===D.test(o)?a[o]+"px":a[o]}}else if("dangerouslySetInnerHTML"===t)a&&(e.innerHTML=a.__html||"");else if("o"==t[0]&&"n"==t[1]){var i=t!==(t=t.replace(/Capture$/,""));t=t.toLowerCase().substring(2),a?n||e.addEventListener(t,d,i):e.removeEventListener(t,d,i),(e.__l||(e.__l={}))[t]=a}else if("list"!==t&&"type"!==t&&!r&&t in e)k(e,t,null==a?"":a),null!=a&&!1!==a||e.removeAttribute(t);else{var s=r&&t!==(t=t.replace(/^xlink\:?/,""));null==a||!1===a?s?e.removeAttributeNS("http://www.w3.org/1999/xlink",t.toLowerCase()):e.removeAttribute(t):"function"!=typeof a&&(s?e.setAttributeNS("http://www.w3.org/1999/xlink",t.toLowerCase(),a):e.setAttribute(t,a))}else e.className=a||""}function k(e,t,n){try{e[t]=n}catch(e){}}function d(e){return this.__l[e.type](M.event&&M.event(e)||e)}function f(){for(var e;e=U.pop();)M.afterMount&&M.afterMount(e),e.componentDidMount&&e.componentDidMount()}function y(e,t,n,a,r,o){L++||(R=null!=r&&void 0!==r.ownerSVGElement,B=null!=e&&!("__preactattr_"in e));var i=v(e,t,n,a,o);return r&&i.parentNode!==r&&r.appendChild(i),--L||(B=!1,o||f()),i}function v(e,t,n,a,r){var o=e,i=R;if(null==t&&(t=""),"string"==typeof t)return e&&void 0!==e.splitText&&e.parentNode&&(!e._component||r)?e.nodeValue!=t&&(e.nodeValue=t):(o=document.createTextNode(t),e&&(e.parentNode&&e.parentNode.replaceChild(o,e),m(e,!0))),o.__preactattr_=!0,o;if("function"==typeof t.nodeName)return C(e,t,n,a);if(R="svg"===t.nodeName||"foreignObject"!==t.nodeName&&R,(!e||!l(e,String(t.nodeName)))&&(o=c(String(t.nodeName),R),e)){for(;e.firstChild;)o.appendChild(e.firstChild);e.parentNode&&e.parentNode.replaceChild(o,e),m(e,!0)}var s=o.firstChild,p=o.__preactattr_||(o.__preactattr_={}),u=t.children;return!B&&u&&1===u.length&&"string"==typeof u[0]&&null!=s&&void 0!==s.splitText&&null==s.nextSibling?s.nodeValue!=u[0]&&(s.nodeValue=u[0]):(u&&u.length||null!=s)&&b(o,u,n,a,B||null!=p.dangerouslySetInnerHTML),_(o,t.attributes,p),R=i,o}function b(e,t,n,a,r){var o,i,l,p,c=e.childNodes,h=[],k={},d=0,f=0,y=c.length,b=0,g=t?t.length:0;if(0!==y)for(var _=0;_<y;_++){var w=c[_],E=w.__preactattr_,P=g&&E?w._component?w._component.__k:E.key:null;null!=P?(d++,k[P]=w):(E||(void 0!==w.splitText?!r||w.nodeValue.trim():r))&&(h[b++]=w)}if(0!==g)for(var _=0;_<g;_++){l=t[_],p=null;var P=l.key;if(null!=P)d&&void 0!==k[P]&&(p=k[P],k[P]=void 0,d--);else if(!p&&f<b)for(o=f;o<b;o++)if(void 0!==h[o]&&s(i=h[o],l,r)){p=i,h[o]=void 0,o===b-1&&b--,o===f&&f++;break}p=v(p,l,n,a),p&&p!==e&&(_>=y?e.appendChild(p):p!==c[_]&&(p===c[_+1]?u(c[_]):e.insertBefore(p,c[_]||null)))}if(d)for(var _ in k)void 0!==k[_]&&m(k[_],!1);for(;f<=b;)void 0!==(p=h[b--])&&m(p,!1)}function m(e,t){var n=e._component;n?x(n):(null!=e.__preactattr_&&e.__preactattr_.ref&&e.__preactattr_.ref(null),!1!==t&&null!=e.__preactattr_||u(e),g(e))}function g(e){for(e=e.lastChild;e;){var t=e.previousSibling;m(e,!0),e=t}}function _(e,t,n){var a;for(a in n)t&&null!=t[a]||null==n[a]||h(e,a,n[a],n[a]=void 0,R);for(a in t)"children"===a||"innerHTML"===a||a in n&&t[a]===("value"===a||"checked"===a?e[a]:n[a])||h(e,a,n[a],n[a]=t[a],R)}function w(e){var t=e.constructor.name;(z[t]||(z[t]=[])).push(e)}function E(e,t,n){var a,r=z[e.name];if(e.prototype&&e.prototype.render?(a=new e(t,n),S.call(a,t,n)):(a=new S(t,n),a.constructor=e,a.render=P),r)for(var o=r.length;o--;)if(r[o].constructor===e){a.__b=r[o].__b,r.splice(o,1);break}return a}function P(e,t,n){return this.constructor(e,n)}function O(e,t,n,a,r){e.__x||(e.__x=!0,(e.__r=t.ref)&&delete t.ref,(e.__k=t.key)&&delete t.key,!e.base||r?e.componentWillMount&&e.componentWillMount():e.componentWillReceiveProps&&e.componentWillReceiveProps(t,a),a&&a!==e.context&&(e.__c||(e.__c=e.context),e.context=a),e.__p||(e.__p=e.props),e.props=t,e.__x=!1,0!==n&&(1!==n&&!1===M.syncComponentUpdates&&e.base?o(e):T(e,1,r)),e.__r&&e.__r(e))}function T(e,t,n,r){if(!e.__x){var o,i,s,l=e.props,c=e.state,u=e.context,h=e.__p||l,k=e.__s||c,d=e.__c||u,v=e.base,b=e.__b,g=v||b,_=e._component,w=!1;if(v&&(e.props=h,e.state=k,e.context=d,2!==t&&e.shouldComponentUpdate&&!1===e.shouldComponentUpdate(l,c,u)?w=!0:e.componentWillUpdate&&e.componentWillUpdate(l,c,u),e.props=l,e.state=c,e.context=u),e.__p=e.__s=e.__c=e.__b=null,e.__d=!1,!w){o=e.render(l,c,u),e.getChildContext&&(u=a(a({},u),e.getChildContext()));var P,C,S=o&&o.nodeName;if("function"==typeof S){var A=p(o);i=_,i&&i.constructor===S&&A.key==i.__k?O(i,A,1,u,!1):(P=i,e._component=i=E(S,A,u),i.__b=i.__b||b,i.__u=e,O(i,A,0,u,!1),T(i,1,n,!0)),C=i.base}else s=g,P=_,P&&(s=e._component=null),(g||1===t)&&(s&&(s._component=null),C=y(s,o,u,n||!v,g&&g.parentNode,!0));if(g&&C!==g&&i!==_){var j=g.parentNode;j&&C!==j&&(j.replaceChild(C,g),P||(g._component=null,m(g,!1)))}if(P&&x(P),e.base=C,C&&!r){for(var I=e,D=e;D=D.__u;)(I=D).base=C;C._component=I,C._componentConstructor=I.constructor}}if(!v||n?U.unshift(e):w||(f(),e.componentDidUpdate&&e.componentDidUpdate(h,k,d),M.afterUpdate&&M.afterUpdate(e)),null!=e.__h)for(;e.__h.length;)e.__h.pop().call(e);L||r||f()}}function C(e,t,n,a){for(var r=e&&e._component,o=r,i=e,s=r&&e._componentConstructor===t.nodeName,l=s,c=p(t);r&&!l&&(r=r.__u);)l=r.constructor===t.nodeName;return r&&l&&(!a||r._component)?(O(r,c,3,n,a),e=r.base):(o&&!s&&(x(o),e=i=null),r=E(t.nodeName,c,n),e&&!r.__b&&(r.__b=e,i=null),O(r,c,1,n,a),e=r.base,i&&e!==i&&(i._component=null,m(i,!1))),e}function x(e){M.beforeUnmount&&M.beforeUnmount(e);var t=e.base;e.__x=!0,e.componentWillUnmount&&e.componentWillUnmount(),e.base=null;var n=e._component;n?x(n):t&&(t.__preactattr_&&t.__preactattr_.ref&&t.__preactattr_.ref(null),e.__b=t,u(t),w(e),g(t)),e.__r&&e.__r(null)}function S(e,t){this.__d=!0,this.context=t,this.props=e,this.state=this.state||{}}function A(e,t,n){return y(n,e,{},!1,t,!1)}var M={},j=[],I=[],D=/acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,N=[],U=[],L=0,R=!1,B=!1,z={};a(S.prototype,{setState:function(e,t){var n=this.state;this.__s||(this.__s=a({},n)),a(n,"function"==typeof e?e(n,this.props):e),t&&(this.__h=this.__h||[]).push(t),o(this)},forceUpdate:function(e){e&&(this.__h=this.__h||[]).push(e),T(this,2)},render:function(){}});var V={h:n,createElement:n,cloneElement:r,Component:S,render:A,rerender:i,options:M};e.exports=V}()},function(e,t,n){var a=n(122);"string"==typeof a&&(a=[[e.i,a,""]]);var r={};r.transform=void 0;n(124)(a,r);a.locals&&(e.exports=a.locals)},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),function(e){function a(){}function r(e){"undefined"!=typeof console&&"function"==typeof console.error&&console.error(e);try{throw new Error(e)}catch(e){}}function o(){q||(q=!0,r("<Provider> does not support changing `store` on the fly. It is most likely that you see this error because you updated to Redux 2.x and React Redux 2.x which no longer hot reload reducers automatically. See https://github.com/reactjs/react-redux/releases/tag/v2.0.0 for the migration instructions."))}function i(){var e=[],t=[];return{clear:function(){t=ne,e=ne},notify:function(){for(var n=e=t,a=0;a<n.length;a++)n[a]()},subscribe:function(n){var a=!0;return t===e&&(t=e.slice()),t.push(n),function(){a&&e!==ne&&(a=!1,t===e&&(t=e.slice()),t.splice(t.indexOf(n),1))}}}}function s(){}function l(e,t){var n={run:function(a){try{var r=e(t.getState(),a);(r!==n.props||n.error)&&(n.shouldComponentUpdate=!0,n.props=r,n.error=null)}catch(e){n.shouldComponentUpdate=!0,n.error=e}}};return n}function p(e){var t,n,a=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=a.getDisplayName,o=void 0===r?function(e){return"ConnectAdvanced("+e+")"}:r,i=a.methodName,p=void 0===i?"connectAdvanced":i,c=a.renderCountProp,u=void 0===c?void 0:c,h=a.shouldHandleStateChanges,k=void 0===h||h,d=a.storeKey,f=void 0===d?"store":d,y=a.withRef,v=void 0!==y&&y,b=W(a,["getDisplayName","methodName","renderCountProp","shouldHandleStateChanges","storeKey","withRef"]),m=f+"Subscription",g=oe++,_=(t={},t[f]=F,t[m]=V,t),w=(n={},n[m]=V,n);return function(t){te("function"==typeof t,"You must pass a component to the function returned by connect. Instead received "+JSON.stringify(t));var n=t.displayName||t.name||"Component",a=o(n),r=Y({},b,{getDisplayName:o,methodName:p,renderCountProp:u,shouldHandleStateChanges:k,storeKey:f,withRef:v,displayName:a,wrappedComponentName:n,WrappedComponent:t}),i=function(n){function o(e,t){H(this,o);var r=X(this,n.call(this,e,t));return r.version=g,r.state={},r.renderCount=0,r.store=e[f]||t[f],r.propsMode=Boolean(e[f]),r.setWrappedInstance=r.setWrappedInstance.bind(r),te(r.store,'Could not find "'+f+'" in either the context or props of "'+a+'". Either wrap the root component in a <Provider>, or explicitly pass "'+f+'" as a prop to "'+a+'".'),r.initSelector(),r.initSubscription(),r}return G(o,n),o.prototype.getChildContext=function(){var e,t=this.propsMode?null:this.subscription;return e={},e[m]=t||this.context[m],e},o.prototype.componentDidMount=function(){k&&(this.subscription.trySubscribe(),this.selector.run(this.props),this.selector.shouldComponentUpdate&&this.forceUpdate())},o.prototype.componentWillReceiveProps=function(e){this.selector.run(e)},o.prototype.shouldComponentUpdate=function(){return this.selector.shouldComponentUpdate},o.prototype.componentWillUnmount=function(){this.subscription&&this.subscription.tryUnsubscribe(),this.subscription=null,this.notifyNestedSubs=s,this.store=null,this.selector.run=s,this.selector.shouldComponentUpdate=!1},o.prototype.getWrappedInstance=function(){return te(v,"To access the wrapped instance, you need to specify { withRef: true } in the options argument of the "+p+"() call."),this.wrappedInstance},o.prototype.setWrappedInstance=function(e){this.wrappedInstance=e},o.prototype.initSelector=function(){var t=e(this.store.dispatch,r);this.selector=l(t,this.store),this.selector.run(this.props)},o.prototype.initSubscription=function(){if(k){var e=(this.propsMode?this.props:this.context)[m];this.subscription=new re(this.store,e,this.onStateChange.bind(this)),this.notifyNestedSubs=this.subscription.notifyNestedSubs.bind(this.subscription)}},o.prototype.onStateChange=function(){this.selector.run(this.props),this.selector.shouldComponentUpdate?(this.componentDidUpdate=this.notifyNestedSubsOnComponentDidUpdate,this.setState(ie)):this.notifyNestedSubs()},o.prototype.notifyNestedSubsOnComponentDidUpdate=function(){this.componentDidUpdate=void 0,this.notifyNestedSubs()},o.prototype.isSubscribed=function(){return Boolean(this.subscription)&&this.subscription.isSubscribed()},o.prototype.addExtraProps=function(e){if(!(v||u||this.propsMode&&this.subscription))return e;var t=Y({},e);return v&&(t.ref=this.setWrappedInstance),u&&(t[u]=this.renderCount++),this.propsMode&&this.subscription&&(t[m]=this.subscription),t},o.prototype.render=function(){var e=this.selector;if(e.shouldComponentUpdate=!1,e.error)throw e.error;return Object(L.h)(t,this.addExtraProps(e.props))},o}(L.Component);return i.WrappedComponent=t,i.displayName=a,i.childContextTypes=w,i.contextTypes=_,i.prototype.componentWillUpdate=function(){this.version!==g&&(this.version=g,this.initSelector(),this.subscription&&this.subscription.tryUnsubscribe(),this.initSubscription(),k&&this.subscription.trySubscribe())},ee(i,t)}}function c(e,t){return e===t?0!==e||0!==t||1/e==1/t:e!==e&&t!==t}function u(e,t){if(c(e,t))return!0;if("object"!==(void 0===e?"undefined":K(e))||null===e||"object"!==(void 0===t?"undefined":K(t))||null===t)return!1;var n=Object.keys(e),a=Object.keys(t);if(n.length!==a.length)return!1;for(var r=0;r<n.length;r++)if(!se.call(t,n[r])||!c(e[n[r]],t[n[r]]))return!1;return!0}function h(e){var t=ke.call(e,fe),n=e[fe];try{e[fe]=void 0;var a=!0}catch(e){}var r=de.call(e);return a&&(t?e[fe]=n:delete e[fe]),r}function k(e){return ve.call(e)}function d(e){return null==e?void 0===e?me:be:ge&&ge in Object(e)?h(e):k(e)}function f(e){return null!=e&&"object"==(void 0===e?"undefined":K(e))}function y(e){if(!f(e)||d(e)!=we)return!1;var t=_e(e);if(null===t)return!0;var n=Te.call(t,"constructor")&&t.constructor;return"function"==typeof n&&n instanceof n&&Oe.call(n)==Ce}function v(e,t,n){y(e)||r(n+"() in "+t+" must return a plain object. Instead received "+e+".")}function b(e){return function(t,n){function a(){return r}var r=e(t,n);return a.dependsOnOwnProps=!1,a}}function m(e){return null!==e.dependsOnOwnProps&&void 0!==e.dependsOnOwnProps?Boolean(e.dependsOnOwnProps):1!==e.length}function g(e,t){return function(n,a){var r=a.displayName,o=function(e,t){return o.dependsOnOwnProps?o.mapToProps(e,t):o.mapToProps(e)};return o.dependsOnOwnProps=!0,o.mapToProps=function(n,a){o.mapToProps=e,o.dependsOnOwnProps=m(e);var i=o(n,a);return"function"==typeof i&&(o.mapToProps=i,o.dependsOnOwnProps=m(i),i=o(n,a)),v(i,r,t),i},o}}function _(e){return"function"==typeof e?g(e,"mapDispatchToProps"):void 0}function w(e){return e?void 0:b(function(e){return{dispatch:e}})}function E(e){return e&&"object"===(void 0===e?"undefined":K(e))?b(function(t){return Object(R.bindActionCreators)(e,t)}):void 0}function P(e){return"function"==typeof e?g(e,"mapStateToProps"):void 0}function O(e){return e?void 0:b(function(){return{}})}function T(e,t,n){return Y({},n,e,t)}function C(e){return function(t,n){var a=n.displayName,r=n.pure,o=n.areMergedPropsEqual,i=!1,s=void 0;return function(t,n,l){var p=e(t,n,l);return i?r&&o(p,s)||(s=p):(i=!0,s=p,v(s,a,"mergeProps")),s}}}function x(e){return"function"==typeof e?C(e):void 0}function S(e){return e?void 0:function(){return T}}function A(e,t,n){if(!e)throw new Error("Unexpected value for "+t+" in "+n+".");"mapStateToProps"!==t&&"mapDispatchToProps"!==t||e.hasOwnProperty("dependsOnOwnProps")||r("The selector for "+t+" of "+n+" did not specify a value for dependsOnOwnProps.")}function M(e,t,n,a){A(e,"mapStateToProps",a),A(t,"mapDispatchToProps",a),A(n,"mergeProps",a)}function j(e,t,n,a){return function(r,o){return n(e(r,o),t(a,o),o)}}function I(e,t,n,a,r){function o(r,o){return d=r,f=o,y=e(d,f),v=t(a,f),b=n(y,v,f),k=!0,b}function i(){return y=e(d,f),t.dependsOnOwnProps&&(v=t(a,f)),b=n(y,v,f)}function s(){return e.dependsOnOwnProps&&(y=e(d,f)),t.dependsOnOwnProps&&(v=t(a,f)),b=n(y,v,f)}function l(){var t=e(d,f),a=!h(t,y);return y=t,a&&(b=n(y,v,f)),b}function p(e,t){var n=!u(t,f),a=!c(e,d);return d=e,f=t,n&&a?i():n?s():a?l():b}var c=r.areStatesEqual,u=r.areOwnPropsEqual,h=r.areStatePropsEqual,k=!1,d=void 0,f=void 0,y=void 0,v=void 0,b=void 0;return function(e,t){return k?p(e,t):o(e,t)}}function D(e,t){var n=t.initMapStateToProps,a=t.initMapDispatchToProps,r=t.initMergeProps,o=W(t,["initMapStateToProps","initMapDispatchToProps","initMergeProps"]),i=n(e,o),s=a(e,o),l=r(e,o);return M(i,s,l,o.displayName),(o.pure?I:j)(i,s,l,e,o)}function N(e,t,n){for(var a=t.length-1;a>=0;a--){var r=t[a](e);if(r)return r}return function(t,a){throw new Error("Invalid value of type "+(void 0===e?"undefined":K(e))+" for "+n+" argument when connecting component "+a.wrappedComponentName+".")}}function U(e,t){return e===t}n.d(t,"Provider",function(){return Z}),n.d(t,"connect",function(){return Me}),n.d(t,"connectAdvanced",function(){return p});var L=n(0),R=(n.n(L),n(13)),B={only:function(e){return e&&e[0]||null}};a.isRequired=a;var z={element:a,func:a,shape:function(){return a},instanceOf:function(){return a}},V=z.shape({trySubscribe:z.func.isRequired,tryUnsubscribe:z.func.isRequired,notifyNestedSubs:z.func.isRequired,isSubscribed:z.func.isRequired}),F=z.shape({subscribe:z.func.isRequired,dispatch:z.func.isRequired,getState:z.func.isRequired}),K="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},H=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")},Y=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a])}return e},G=function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)},W=function(e,t){var n={};for(var a in e)t.indexOf(a)>=0||Object.prototype.hasOwnProperty.call(e,a)&&(n[a]=e[a]);return n},X=function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t},q=!1,Z=function(){var e,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"store",n=arguments[1],a=n||t+"Subscription",r=function(e){function n(a,r){H(this,n);var o=X(this,e.call(this,a,r));return o[t]=a.store,o}return G(n,e),n.prototype.getChildContext=function(){var e;return e={},e[t]=this[t],e[a]=null,e},n.prototype.render=function(){return B.only(this.props.children)},n}(L.Component);return r.prototype.componentWillReceiveProps=function(e){this[t]!==e.store&&o()},r.childContextTypes=(e={},e[t]=F.isRequired,e[a]=V,e),r.displayName="Provider",r}(),Q={childContextTypes:!0,contextTypes:!0,defaultProps:!0,displayName:!0,getDefaultProps:!0,mixins:!0,propTypes:!0,type:!0},J={name:!0,length:!0,prototype:!0,caller:!0,arguments:!0,arity:!0},$="function"==typeof Object.getOwnPropertySymbols,ee=function(e,t,n){if("string"!=typeof t){var a=Object.getOwnPropertyNames(t);$&&(a=a.concat(Object.getOwnPropertySymbols(t)));for(var r=0;r<a.length;++r)if(!(Q[a[r]]||J[a[r]]||n&&n[a[r]]))try{e[a[r]]=t[a[r]]}catch(e){}}return e},te=function(){},ne=null,ae={notify:function(){}},re=function(){function e(t,n,a){H(this,e),this.store=t,this.parentSub=n,this.onStateChange=a,this.unsubscribe=null,this.listeners=ae}return e.prototype.addNestedSub=function(e){return this.trySubscribe(),this.listeners.subscribe(e)},e.prototype.notifyNestedSubs=function(){this.listeners.notify()},e.prototype.isSubscribed=function(){return Boolean(this.unsubscribe)},e.prototype.trySubscribe=function(){this.unsubscribe||(this.unsubscribe=this.parentSub?this.parentSub.addNestedSub(this.onStateChange):this.store.subscribe(this.onStateChange),this.listeners=i())},e.prototype.tryUnsubscribe=function(){this.unsubscribe&&(this.unsubscribe(),this.unsubscribe=null,this.listeners.clear(),this.listeners=ae)},e}(),oe=0,ie={},se=Object.prototype.hasOwnProperty,le="object"==(void 0===e?"undefined":K(e))&&e&&e.Object===Object&&e,pe="object"==("undefined"==typeof self?"undefined":K(self))&&self&&self.Object===Object&&self,ce=le||pe||Function("return this")(),ue=ce.Symbol,he=Object.prototype,ke=he.hasOwnProperty,de=he.toString,fe=ue?ue.toStringTag:void 0,ye=Object.prototype,ve=ye.toString,be="[object Null]",me="[object Undefined]",ge=ue?ue.toStringTag:void 0,_e=function(e,t){return function(n){return e(t(n))}}(Object.getPrototypeOf,Object),we="[object Object]",Ee=Function.prototype,Pe=Object.prototype,Oe=Ee.toString,Te=Pe.hasOwnProperty,Ce=Oe.call(Object),xe=[_,w,E],Se=[P,O],Ae=[x,S],Me=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.connectHOC,n=void 0===t?p:t,a=e.mapStateToPropsFactories,r=void 0===a?Se:a,o=e.mapDispatchToPropsFactories,i=void 0===o?xe:o,s=e.mergePropsFactories,l=void 0===s?Ae:s,c=e.selectorFactory,h=void 0===c?D:c;return function(e,t,a){var o=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{},s=o.pure,p=void 0===s||s,c=o.areStatesEqual,k=void 0===c?U:c,d=o.areOwnPropsEqual,f=void 0===d?u:d,y=o.areStatePropsEqual,v=void 0===y?u:y,b=o.areMergedPropsEqual,m=void 0===b?u:b,g=W(o,["pure","areStatesEqual","areOwnPropsEqual","areStatePropsEqual","areMergedPropsEqual"]),_=N(e,r,"mapStateToProps"),w=N(t,i,"mapDispatchToProps"),E=N(a,l,"mergeProps");return n(h,Y({methodName:"connect",getDisplayName:function(e){return"Connect("+e+")"},shouldHandleStateChanges:Boolean(e),initMapStateToProps:_,initMapDispatchToProps:w,initMergeProps:E,pure:p,areStatesEqual:k,areOwnPropsEqual:f,areStatePropsEqual:v,areMergedPropsEqual:m},g))}}(),je={Provider:Z,connect:Me,connectAdvanced:p};t.default=je}.call(t,n(28))},function(e,t,n){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function r(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.BaseComponent=void 0;var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),s=n(0),l=n(30),p=function(e){return e&&e.__esModule?e:{default:e}}(l),c=n(62),u=n(120),h=function(e){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{config:{}};a(this,t);var n=r(this,(t.__proto__||Object.getPrototypeOf(t)).call(this));return n.name=e.name,n.player=e.player,n.config=e.config,n.eventManager=new u.EventManager,n.logger=(0,p.default)("UI "+n.name),n.logger.debug("Initialized"),n}return o(t,e),i(t,[{key:"notifyClick",value:function(e){this.context.store.dispatch({type:c.types.COMPONENT_CLICKED,name:this.name,payload:e})}},{key:"notifyChange",value:function(e){this.context.store.dispatch({type:c.types.COMPONENT_CHANGED,name:this.name,payload:e})}},{key:"componentWillUnmount",value:function(){this.eventManager.removeAll()}}]),t}(s.Component);h.defaultProps={},t.default=h,t.BaseComponent=h},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.IconType=t.Icon=t.default=void 0;var a=n(16);Object.defineProperty(t,"Icon",{enumerable:!0,get:function(){return a.Icon}}),Object.defineProperty(t,"IconType",{enumerable:!0,get:function(){return a.IconType}});var r=function(e){return e&&e.__esModule?e:{default:e}}(a);t.default=r.default},function(e,t,n){function a(e){return null!==e&&void 0!==e}function r(e,t){var n=o({},e);for(var a in t)t.hasOwnProperty(a)&&(n[a]=e[a]&&t[a]&&"object"==typeof e[a]&&"object"==typeof t[a]?r(e[a],t[a]):e[a]||t[a]);return n}function o(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n]);return e}function i(e){if(e=e||{},"string"==typeof e&&(e=e.split(",")),"join"in e){for(var t={},n=0;n<e.length;n++){var a=e[n].trim();a&&(t[a.split(".").pop()]=a)}return t}return e}function s(e,t){return u=t||b,e&&e.replace(/\{\{([\w.-]+)\}\}/g,l)}function l(e,t){for(var n=t.split("."),a=u,r=0;r<n.length;r++)if(null==(a=a[n[r]]))return"";return"string"==typeof a&&a.match(/\{\{/)&&(a=s(a,u)),a}function p(e,t,n,r,o,i){t&&(e=t+"."+e);var l=n&&k(n,e);return(o||0===o)&&l&&"object"==typeof l&&(l=l.splice?l[o]||l[0]:0===o&&a(l.none)?l.none:1===o&&a(l.one||l.singular)?l.one||l.singular:l.some||l.many||l.plural||l.other||l),l&&s(l,r)||i||null}function c(e,t,n){var a={};t=t||{},e=i(e);for(var r in e)if(e.hasOwnProperty(r)&&e[r]){var s=e[r];n||"string"!=typeof s?s.nodeName===m&&(s=o({fallback:s.children&&s.children[0]},s.attributes),a[r]=p(s.id,t.scope,t.dictionary,s.fields,s.plural,s.fallback)):a[r]=p(s,t.scope,t.dictionary)}return a}var u,h=n(0),k=function(e){return e&&"object"==typeof e&&"default"in e?e.default:e}(n(105)),d=/[?&#]intl=show/,f=function(e){function t(){e.apply(this,arguments)}return e&&(t.__proto__=e),t.prototype=Object.create(e&&e.prototype),t.prototype.constructor=t,t.prototype.getChildContext=function(){var e=this.props,t=e.scope,n=e.definition,a=e.mark,i=o({},this.context.intl||{});return t&&(i.scope=t),n&&(i.dictionary=r(i.dictionary||{},n)),(a||"undefined"!=typeof location&&String(location).match(d))&&(i.mark=!0),{intl:i}},t.prototype.render=function(e){var t=e.children;return t&&t[0]||null},t}(h.Component),y=function(){for(var e=[],t=arguments.length;t--;)e[t]=arguments[t];if(e.length>1)return v(e[0],e[1]);var n=e[0];return function(e){return v(e,n)}},v=function(e,t){return function(n){return h.h(f,t||{},h.h(e,n))}},b={},m=function(e,t){var n=e.id,a=e.children,r=e.plural,o=e.fields,i=t.intl,s=a&&a[0],l=p(n,i&&i.scope,i&&i.dictionary,o,r,s);if(i&&i.mark){var c="dictionary"+(i&&i.scope?"."+i.scope:"")+"."+n;return h.h("mark",{style:"background: "+(l?k(i,c)?"rgba(119,231,117,.5)":"rgba(229,226,41,.5)":"rgba(228,147,51,.5)"),title:n},l)}return l},g=function(e,t){var n=e.children,a=t.intl,r=n&&n[0];return r&&h.cloneElement(r,c(r.attributes,a,!0))},_=function(e){return function(t){return function(n,a){var r="function"==typeof e?e(n):e,o=c(r,a.intl);return h.h(t,assign({},n,o))}}};y.intl=y,y.IntlProvider=f,y.Text=m,y.Localizer=g,y.withText=_,e.exports=y},function(e,t,n){"use strict";function a(e){p.SEMI_COLON="firefox"===e.browser.name.toLowerCase()?59:186}function r(e){for(var t in p)if(p[t]===e)return t;return"NOT_FOUND"}function o(e){return l(e,p.TAB)}function i(e){return l(e,p.ENTER)}function s(e){return l(e,p.ESC)}function l(e,t){return e===t}Object.defineProperty(t,"__esModule",{value:!0}),t.setEnv=a,t.getKeyName=r,t.isTab=o,t.isEnter=i,t.isEsc=s;var p=t.KeyMap={TAB:9,ENTER:13,ESC:27,SPACE:32,END:35,HOME:36,LEFT:37,UP:38,RIGHT:39,DOWN:40,C:67,F:70,M:77,SEMI_COLON:186,COMMA:188,PERIOD:190}},function(e,t,n){"use strict";function a(e){return function(t){return r({},(0,o.bindActionCreators)(e,t))}}Object.defineProperty(t,"__esModule",{value:!0});var r=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a])}return e};t.bindActions=a;var o=n(13)},function(e,t,n){"use strict";function a(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}Object.defineProperty(t,"__esModule",{value:!0});var r=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a])}return e},o=t.types={ADD_PLAYER_CLASS:"shell/ADD_PLAYER_CLASS",REMOVE_PLAYER_CLASS:"shell/REMOVE_PLAYER_CLASS",UPDATE_IS_MOBILE:"shell/UPDATE_IS_MOBILE",UPDATE_PLAYER_SIZE:"shell/UPDATE_PLAYER_SIZE",UPDATE_PLAYER_CLIENT_RECT:"shell/UPDATE_PLAYER_CLIENT_RECT",UPDATE_DOCUMENT_WIDTH:"shell/UPDATE_DOCUMENT_WIDTH",UPDATE_PLAYER_HOVER_STATE:"shell/UPDATE_PLAYER_HOVER_STATE",UPDATE_PLAYER_NAV_STATE:"shell/UPDATE_PLAYER_NAV_STATE",UPDATE_BOTTOM_BAR_HOVER_ACTIVE:"shell/UPDATE_BOTTOM_BAR_HOVER_ACTIVE",UPDATE_SMART_CONTAINER_OPEN:"shell/UPDATE_SMART_CONTAINER_OPEN"},i=t.initialState={playerClasses:[],playerHover:!1,playerNav:!1,smartContainerOpen:!1};t.default=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:i,t=arguments[1];switch(t.type){case o.ADD_PLAYER_CLASS:return e.playerClasses.includes(t.className)?e:r({},e,{playerClasses:[].concat(a(e.playerClasses),[t.className])});case o.REMOVE_PLAYER_CLASS:return r({},e,{playerClasses:e.playerClasses.filter(function(e){return e!==t.className})});case o.UPDATE_IS_MOBILE:return r({},e,{isMobile:t.isMobile});case o.UPDATE_PLAYER_SIZE:return r({},e,{playerSize:t.playerSize});case o.UPDATE_PLAYER_CLIENT_RECT:return r({},e,{playerClientRect:t.playerClientRect});case o.UPDATE_DOCUMENT_WIDTH:return r({},e,{documentWidth:t.documentWidth});case o.UPDATE_PLAYER_HOVER_STATE:return r({},e,{playerHover:t.hover});case o.UPDATE_PLAYER_NAV_STATE:return r({},e,{playerNav:t.nav});case o.UPDATE_BOTTOM_BAR_HOVER_ACTIVE:return r({},e,{bottomBarHoverActive:t.active});case o.UPDATE_SMART_CONTAINER_OPEN:return r({},e,{smartContainerOpen:t.open});default:return e}};t.actions={addPlayerClass:function(e){return{type:o.ADD_PLAYER_CLASS,className:e}},removePlayerClass:function(e){return{type:o.REMOVE_PLAYER_CLASS,className:e}},updateIsMobile:function(e){return{type:o.UPDATE_IS_MOBILE,isMobile:e}},updatePlayerSize:function(e){return{type:o.UPDATE_PLAYER_SIZE,playerSize:e}},updatePlayerClientRect:function(e){return{type:o.UPDATE_PLAYER_CLIENT_RECT,playerClientRect:e}},updateDocumentWidth:function(e){return{type:o.UPDATE_DOCUMENT_WIDTH,documentWidth:e}},updatePlayerHoverState:function(e){return{type:o.UPDATE_PLAYER_HOVER_STATE,hover:e}},updatePlayerNavState:function(e){return{type:o.UPDATE_PLAYER_NAV_STATE,nav:e}},updateBottomBarHoverActive:function(e){return{type:o.UPDATE_BOTTOM_BAR_HOVER_ACTIVE,active:e}},updateSmartContainerOpen:function(e){return{type:o.UPDATE_SMART_CONTAINER_OPEN,open:e}}}},function(e,t,n){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.FakeEvent=void 0;var r=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),o=n(31),i=function(){function e(t,n){a(this,e),this.bubbles=!1,this.cancelable=!1,this.defaultPrevented=!1,this.timeStamp=window.performance?window.performance.now():Date.now(),this.type=t,this.isTrusted=!1,this.currentTarget=null,this.target=null,this.stopped=!1,n&&(this.payload=n)}return r(e,[{key:"preventDefault",value:function(){}},{key:"stopImmediatePropagation",value:function(){this.stopped=!0}},{key:"stopPropagation",value:function(){}}]),e}();i.Type=o.EventType,t.FakeEvent=i},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function r(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.PLAYER_SIZE=t.CONTROL_BAR_HOVER_DEFAULT_TIMEOUT=t.Shell=void 0;var l,p,c=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),u=function e(t,n,a){null===t&&(t=Function.prototype);var r=Object.getOwnPropertyDescriptor(t,n);if(void 0===r){var o=Object.getPrototypeOf(t);return null===o?void 0:e(o,n,a)}if("value"in r)return r.value;var i=r.get;if(void 0!==i)return i.call(a)},h=n(1),k=a(h),d=n(0),f=n(3),y=a(f),v=n(2),b=n(7),m=n(8),g=n(11),_=n(6),w=function(e){return{targetId:e.config.targetId,forceTouchUI:e.config.forceTouchUI,metadataLoaded:e.engine.metadataLoaded,currentState:e.engine.playerState.currentState,playerClasses:e.shell.playerClasses,isMobile:e.shell.isMobile,playerSize:e.shell.playerSize,isCasting:e.engine.isCasting,playerClientRect:e.shell.playerClientRect,playerHover:e.shell.playerHover,playerNav:e.shell.playerNav,seekbarDraggingActive:e.seekbar.draggingActive,seekbarHoverActive:e.seekbar.hoverActive,bottomBarHoverActive:e.shell.bottomBarHoverActive,volumeHoverActive:e.volume.hover,adBreak:e.engine.adBreak,prePlayback:e.engine.prePlayback,smartContainerOpen:e.shell.smartContainerOpen,fullscreen:e.engine.fullscreen,fallbackToMutedAutoPlay:e.engine.fallbackToMutedAutoPlay,playlist:e.engine.playlist}},E={TINY:"tiny",EXTRA_SMALL:"extrasmall",SMALL:"small",MEDIUM:"medium",LARGE:"large",EXTRA_LARGE:"extralarge"},P={TINY:280,EXTRA_SMALL:380,SMALL:480,MEDIUM:768,LARGE:1024},O=(l=(0,v.connect)(w,(0,b.bindActions)(Object.assign({},m.actions,g.actions))))(p=function(e){function t(e){o(this,t);var n=i(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,{name:"Shell",player:e.player}));return n._environmentClasses=["pakhshkit-"+n.player.env.os.name.replace(/ /g,"-"),"pakhshkit-"+n.player.env.browser.name.replace(/ /g,"-")],n}return s(t,e),c(t,[{key:"onMouseOver",value:function(){this.props.isMobile||(this.state.nav&&(this.setState({nav:!1}),this.props.updatePlayerNavState(!1)),this.props.bottomBarHoverActive||this._updatePlayerHoverState())}},{key:"onMouseLeave",value:function(e){e.toElement&&(this.props.isMobile||this.state.hover&&(this.setState({hover:!1}),this.props.updatePlayerHoverState(!1)))}},{key:"onMouseMove",value:function(){this.props.isMobile||this._updatePlayerHoverState()}},{key:"onClick",value:function(){this.props.fallbackToMutedAutoPlay&&(this.player.muted=!1),this.notifyClick()}},{key:"onTouchEnd",value:function(e){this.props.prePlayback||(this.props.fallbackToMutedAutoPlay&&(this.player.muted=!1),this.state.hover||e.stopPropagation(),this._updatePlayerHoverState())}},{key:"onKeyDown",value:function(e){this.state.nav||e.keyCode!==_.KeyMap.TAB||(this.setState({nav:!0}),this.props.updatePlayerNavState(!0))}},{key:"componentDidMount",value:function(){var e=this;this.props.updateIsMobile(!!this.player.env.device.type||this.props.forceTouchUI),this._onWindowResize(),this.eventManager.listen(this.player,this.player.Event.RESIZE,function(){return e._onWindowResize()}),this.eventManager.listen(this.player,this.player.Event.FIRST_PLAY,function(){return e._onWindowResize()})}},{key:"_onWindowResize",value:function(){var e=document.getElementById(this.props.targetId);e&&this.props.updatePlayerClientRect(e.getBoundingClientRect()),document.body&&this.props.updateDocumentWidth(document.body.clientWidth)}},{key:"componentWillUnmount",value:function(){u(t.prototype.__proto__||Object.getPrototypeOf(t.prototype),"componentWillUnmount",this).call(this),this._clearHoverTimeout()}},{key:"_updatePlayerHoverState",value:function(){this.props.prePlayback||(this.state.hover||(this.props.updatePlayerHoverState(!0),this.setState({hover:!0})),this._startHoverTimeout())}},{key:"_canEndHoverState",value:function(){return!(this.props.seekbarDraggingActive||this.props.seekbarHoverActive||this.props.volumeHoverActive||this.props.smartContainerOpen||this.player.paused)}},{key:"_startHoverTimeout",value:function(){var e=this;this._clearHoverTimeout(),this.hoverTimeout=setTimeout(function(){e._canEndHoverState()&&(e.props.updatePlayerHoverState(!1),e.setState({hover:!1}))},this.props.hoverTimeout||3e3)}},{key:"_clearHoverTimeout",value:function(){this.hoverTimeout&&(clearTimeout(this.hoverTimeout),this.hoverTimeout=null)}},{key:"componentDidUpdate",value:function(e){(!this.props.prePlayback&&e.prePlayback||!this.props.adBreak&&e.adBreak)&&this._updatePlayerHoverState()}},{key:"render",value:function(e){var t=this,n=[k.default.player,k.default.skinDefault].concat(r(this._environmentClasses));return n.push(e.playerClasses),this.props.prePlayback&&n.push(k.default.prePlayback),this.props.isCasting&&n.push("pakhshkit-casting"),this.props.isMobile&&n.push(k.default.touch),this.props.playerNav&&n.push(k.default.nav),(this.props.playerHover||this.props.playerNav)&&n.push(k.default.hover),this.props.metadataLoaded&&n.push(k.default.metadataLoaded),this.props.adBreak&&n.push(k.default.adBreak),this.props.metadataLoaded&&n.push(k.default["state-"+this.props.currentState]),this.props.seekbarDraggingActive&&n.push(k.default.hover),this.props.fullscreen&&n.push(k.default.fullscreen),this.props.playlist&&n.push(k.default.playlist),this.props.playerClientRect&&(this.props.playerClientRect.width<=P.TINY?(n.push(k.default.sizeTy),this.props.updatePlayerSize(E.TINY)):this.props.playerClientRect.width<=P.EXTRA_SMALL?(n.push(k.default.sizeXs),this.props.updatePlayerSize(E.EXTRA_SMALL)):this.props.playerClientRect.width<=P.SMALL?(n.push(k.default.sizeSm),this.props.updatePlayerSize(E.SMALL)):this.props.playerClientRect.width<=P.MEDIUM?(n.push(k.default.sizeMd),this.props.updatePlayerSize(E.MEDIUM)):this.props.playerClientRect.width<=P.LARGE?(n.push(k.default.sizeLg),this.props.updatePlayerSize(E.LARGE)):this.props.updatePlayerSize(E.EXTRA_LARGE)),n=n.join(" "),(0,d.h)("div",{tabIndex:"0",className:n,onClick:function(){return t.onClick()},onTouchEnd:function(e){return t.onTouchEnd(e)},onMouseOver:function(){return t.onMouseOver()},onMouseMove:function(){return t.onMouseMove()},onMouseLeave:function(e){return t.onMouseLeave(e)},onKeyDown:function(e){return t.onKeyDown(e)}},e.children)}}]),t}(y.default))||p;t.Shell=O,t.CONTROL_BAR_HOVER_DEFAULT_TIMEOUT=3e3,t.PLAYER_SIZE=E},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.actions=t.initialState=t.types=void 0;var a=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a])}return e},r=n(32),o=n(12),i=t.types={UPDATE_PLAYER_STATE:"engine/UPDATE_PLAYER_STATE",UPDATE_PRE_PLAYBACK:"engine/UPDATE_PRE_PLAYBACK",UPDATE_IS_PLAYING:"engine/UPDATE_IS_PLAYING",UPDATE_IS_PAUSED:"engine/UPDATE_IS_PAUSED",UPDATE_IS_SEEKING:"engine/UPDATE_IS_SEEKING",UPDATE_LAST_SEEK_POINT:"engine/UPDATE_LAST_SEEK_POINT",UPDATE_IS_CHANGING_SOURCE:"engine/UPDATE_IS_CHANGING_SOURCE",UPDATE_IS_ENDED:"engine/UPDATE_IS_ENDED",UPDATE_IS_PLAYBACK_STARTED:"engine/UPDATE_IS_PLAYBACK_STARTED",UPDATE_IS_PLAYBACK_ENDED:"engine/UPDATE_IS_PLAYBACK_ENDED",UPDATE_CURRENT_TIME:"engine/UPDATE_CURRENT_TIME",UPDATE_DURATION:"engine/UPDATE_DURATION",UPDATE_VOLUME:"engine/UPDATE_VOLUME",UPDATE_MUTED:"engine/UPDATE_MUTED",UPDATE_METADATA_LOADING_STATUS:"engine/UPDATE_METADATA_LOADING_STATUS",UPDATE_AUDIO_TRACKS:"engine/UPDATE_AUDIO_TRACKS",UPDATE_VIDEO_TRACKS:"engine/UPDATE_VIDEO_TRACKS",UPDATE_TEXT_TRACKS:"engine/UPDATE_TEXT_TRACKS",UPDATE_AD_BREAK:"engine/UPDATE_AD_BREAK",UPDATE_AD_BREAK_PROGRESS:"engine/UPDATE_AD_BREAK_PROGRESS",UPDATE_AD_BREAK_COMPLETED:"engine/UPDATE_AD_BREAK_COMPLETED",UPDATE_AD_IS_PLAYING:"engine/UPDATE_AD_IS_PLAYING",UPDATE_AD_SKIP_TIME_OFFSET:"engine/UPDATE_AD_SKIP_TIME_OFFSET",UPDATE_AD_SKIPPABLE_STATE:"engine/UPDATE_AD_SKIPPABLE_STATE",UPDATE_AD_URL:"engine/UPDATE_AD_URL",UPDATE_AD_IS_LINEAR:"engine/UPDATE_AD_IS_LINEAR",UPDATE_PLAYER_POSTER:"engine/UPDATE_PLAYER_POSTER",UPDATE_IS_LIVE:"engine/UPDATE_IS_LIVE",UPDATE_IS_DVR:"engine/UPDATE_IS_DVR",UPDATE_ERROR:"engine/ERROR",UPDATE_IS_IDLE:"engine/UPDATE_IS_IDLE",UPDATE_FALLBACK_TO_MUTED_AUTOPLAY:"engine/UPDATE_FALLBACK_TO_MUTED_AUTOPLAY",UPDATE_IS_VR:"engine/UPDATE_IS_VR",UPDATE_VR_STEREO_MODE:"engine/UPDATE_VR_STEREO_MODE",UPDATE_IS_CASTING:"engine/UPDATE_IS_CASTING",UPDATE_CAST_SESSION:"engine/UPDATE_CAST_SESSION",UPDATE_IS_CAST_AVAILABLE:"engine/UPDATE_IS_CAST_AVAILABLE",UPDATE_PLAYLIST:"engine/UPDATE_PLAYLIST",UPDATE_PICTURE_IN_PICTURE_SUPPORTED:"engine/UPDATE_PICTURE_IN_PICTURE_SUPPORTED",UPDATE_PICTURE_IN_PICTURE_MODE:"engine/UPDATE_PICTURE_IN_PICTURE_MODE",UPDATE_FULLSCREEN:"engine/UPDATE_FULLSCREEN"},s=t.initialState={isIdle:!1,isPlaying:!1,isPaused:!1,isSeeking:!1,isEnded:!1,isPlaybackStarted:!1,isPlaybackEnded:!1,isChangingSource:!1,prePlayback:!0,metadataLoaded:!1,playerState:{previousState:"",currentState:""},fallbackToMutedAutoPlay:!1,poster:"",currentTime:0,lastSeekPoint:0,duration:0,volume:1,muted:!1,videoTracks:[],audioTracks:[],textTracks:[],adIsLinear:!1,adBreak:!1,adIsPlaying:!1,adSkipTimeOffset:0,adSkippableState:!1,isLive:!1,isDvr:!1,adProgress:{currentTime:0,duration:0},adUrl:"",hasError:!1,isVr:!1,vrStereoMode:!1,isCasting:!1,castSession:null,isCastAvailable:!1,pictureInPictureSupported:!1,isInPictureInPicture:!1,playlist:null,fullscreen:!1};t.default=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:s,t=arguments[1];switch(t.type){case o.types.UPDATE:return(0,r.getComponentStateFromConfig)("engine",e,t);case o.types.UPDATE_COMPONENT:return(0,r.getComponentStateFromComponentConfig)("engine",e,t);case i.UPDATE_ERROR:return a({},e,{hasError:t.hasError});case i.UPDATE_PLAYER_STATE:return a({},e,{playerState:t.playerState});case i.UPDATE_PRE_PLAYBACK:return a({},e,{prePlayback:t.prePlayback});case i.UPDATE_IS_PLAYING:return a({},e,{isPlaying:t.isPlaying});case i.UPDATE_IS_PAUSED:return a({},e,{isPaused:t.isPaused});case i.UPDATE_IS_SEEKING:return a({},e,{isSeeking:t.isSeeking});case i.UPDATE_LAST_SEEK_POINT:return a({},e,{lastSeekPoint:t.lastSeekPoint});case i.UPDATE_IS_ENDED:return a({},e,{isEnded:t.isEnded});case i.UPDATE_IS_PLAYBACK_STARTED:return a({},e,{isPlaybackStarted:t.isPlaybackStarted});case i.UPDATE_IS_PLAYBACK_ENDED:return a({},e,{isPlaybackEnded:t.isPlaybackEnded});case i.UPDATE_CURRENT_TIME:return a({},e,{currentTime:t.currentTime});case i.UPDATE_DURATION:return a({},e,{duration:t.duration});case i.UPDATE_VOLUME:return a({},e,{volume:t.volume});case i.UPDATE_MUTED:return a({},e,{muted:t.muted});case i.UPDATE_METADATA_LOADING_STATUS:return a({},e,{metadataLoaded:t.metadataLoaded});case i.UPDATE_AUDIO_TRACKS:return a({},e,{audioTracks:t.tracks});case i.UPDATE_VIDEO_TRACKS:return a({},e,{videoTracks:t.tracks});case i.UPDATE_TEXT_TRACKS:return a({},e,{textTracks:t.tracks});case i.UPDATE_AD_BREAK:return a({},e,{adBreak:t.adBreak});case i.UPDATE_AD_BREAK_PROGRESS:return a({},e,{adProgress:t.adProgress});case i.UPDATE_AD_BREAK_COMPLETED:return a({},e,{adProgress:{currentTime:e.adProgress.duration,duration:e.adProgress.duration}});case i.UPDATE_AD_IS_PLAYING:return a({},e,{adIsPlaying:t.adIsPlaying});case i.UPDATE_AD_IS_LINEAR:return a({},e,{adIsLinear:t.adIsLinear});case i.UPDATE_AD_SKIP_TIME_OFFSET:return a({},e,{adSkipTimeOffset:t.adSkipTimeOffset});case i.UPDATE_AD_SKIPPABLE_STATE:return a({},e,{adSkippableState:t.adSkippableState});case i.UPDATE_AD_URL:return a({},e,{adUrl:t.adUrl});case i.UPDATE_PLAYER_POSTER:return a({},e,{poster:t.poster});case i.UPDATE_IS_LIVE:return a({},e,{isLive:t.isLive});case i.UPDATE_IS_DVR:return a({},e,{isDvr:t.isDvr});case i.UPDATE_IS_IDLE:return a({},e,{isIdle:t.IsIdle});case i.UPDATE_FALLBACK_TO_MUTED_AUTOPLAY:return a({},e,{fallbackToMutedAutoPlay:t.fallback});case i.UPDATE_IS_VR:return a({},e,{isVr:t.isVr});case i.UPDATE_VR_STEREO_MODE:return a({},e,{vrStereoMode:t.vrStereoMode});case i.UPDATE_IS_CASTING:return a({},e,{isCasting:t.isCasting});case i.UPDATE_CAST_SESSION:return a({},e,{castSession:t.castSession});case i.UPDATE_IS_CAST_AVAILABLE:return a({},e,{isCastAvailable:t.isCastAvailable});case i.UPDATE_IS_CHANGING_SOURCE:return a({},e,{isChangingSource:t.isChangingSource});case i.UPDATE_PLAYLIST:return a({},e,{playlist:t.playlist});case i.UPDATE_PICTURE_IN_PICTURE_SUPPORTED:return a({},e,{isPictureInPictureSupported:t.isPictureInPictureSupported});case i.UPDATE_PICTURE_IN_PICTURE_MODE:return a({},e,{isInPictureInPicture:t.isInPictureInPicture});case i.UPDATE_FULLSCREEN:return a({},e,{fullscreen:t.fullscreen});default:return e}};t.actions={updateHasError:function(e){return{type:i.UPDATE_ERROR,hasError:e}},updatePlayerState:function(e,t){return{type:i.UPDATE_PLAYER_STATE,playerState:{prevoiusState:e,currentState:t}}},updatePrePlayback:function(e){return{type:i.UPDATE_PRE_PLAYBACK,prePlayback:e}},updateIsPlaying:function(e){return{type:i.UPDATE_IS_PLAYING,isPlaying:e}},updateIsPaused:function(e){return{type:i.UPDATE_IS_PAUSED,isPaused:e}},updateIsSeeking:function(e){return{type:i.UPDATE_IS_SEEKING,isSeeking:e}},updateLastSeekPoint:function(e){return{type:i.UPDATE_LAST_SEEK_POINT,lastSeekPoint:e}},updateIsEnded:function(e){return{type:i.UPDATE_IS_ENDED,isEnded:e}},updateIsPlaybackStarted:function(e){return{type:i.UPDATE_IS_PLAYBACK_STARTED,isPlaybackStarted:e}},updateIsPlaybackEnded:function(e){return{type:i.UPDATE_IS_PLAYBACK_ENDED,isPlaybackEnded:e}},updateCurrentTime:function(e){return{type:i.UPDATE_CURRENT_TIME,currentTime:e}},updateDuration:function(e){return{type:i.UPDATE_DURATION,duration:e}},updateVolume:function(e){return{type:i.UPDATE_VOLUME,volume:e}},updateMuted:function(e){return{type:i.UPDATE_MUTED,muted:e}},updateMetadataLoadingStatus:function(e){return{type:i.UPDATE_METADATA_LOADING_STATUS,metadataLoaded:e}},updateAudioTracks:function(e){return{type:i.UPDATE_AUDIO_TRACKS,tracks:e}},updateVideoTracks:function(e){return{type:i.UPDATE_VIDEO_TRACKS,tracks:e}},updateTextTracks:function(e){return{type:i.UPDATE_TEXT_TRACKS,tracks:e}},updateAdBreak:function(e){return{type:i.UPDATE_AD_BREAK,adBreak:e}},updateAdBreakProgress:function(e,t){return{type:i.UPDATE_AD_BREAK_PROGRESS,adProgress:{currentTime:e,duration:t}}},updateAdBreakCompleted:function(){return{type:i.UPDATE_AD_BREAK_COMPLETED}},updateAdIsPlaying:function(e){return{type:i.UPDATE_AD_IS_PLAYING,adIsPlaying:e}},updateAdSkipTimeOffset:function(e){return{type:i.UPDATE_AD_SKIP_TIME_OFFSET,adSkipTimeOffset:e}},updateAdSkippableState:function(e){return{type:i.UPDATE_AD_SKIPPABLE_STATE,adSkippableState:e}},updateAdClickUrl:function(e){return{type:i.UPDATE_AD_URL,adUrl:e}},updateAdIsLinear:function(e){return{type:i.UPDATE_AD_IS_LINEAR,adIsLinear:e}},updatePlayerPoster:function(e){return{type:i.UPDATE_PLAYER_POSTER,poster:e}},updateIsLive:function(e){return{type:i.UPDATE_IS_LIVE,isLive:e}},updateIsDvr:function(e){return{type:i.UPDATE_IS_DVR,isDvr:e}},updateIsIdle:function(e){return{type:i.UPDATE_IS_IDLE,IsIdle:e}},updateFallbackToMutedAutoPlay:function(e){return{type:i.UPDATE_FALLBACK_TO_MUTED_AUTOPLAY,fallback:e}},updateIsVr:function(e){return{type:i.UPDATE_IS_VR,isVr:e}},updateVrStereoMode:function(e){return{type:i.UPDATE_VR_STEREO_MODE,vrStereoMode:e}},updateIsCasting:function(e){return{type:i.UPDATE_IS_CASTING,isCasting:e}},updateCastSession:function(e){return{type:i.UPDATE_CAST_SESSION,castSession:e}},updateIsCastAvailable:function(e){return{type:i.UPDATE_IS_CAST_AVAILABLE,isCastAvailable:e}},updateIsChangingSource:function(e){return{type:i.UPDATE_IS_CHANGING_SOURCE,isChangingSource:e}},updatePlaylist:function(e){return{type:i.UPDATE_PLAYLIST,playlist:e}},updatePictureInPictureSupport:function(e){return{type:i.UPDATE_PICTURE_IN_PICTURE_SUPPORTED,isPictureInPictureSupported:e}},updateIsInPictureInPicture:function(e){return{type:i.UPDATE_PICTURE_IN_PICTURE_MODE,isInPictureInPicture:e}},updateFullscreen:function(e){return{type:i.UPDATE_FULLSCREEN,fullscreen:e}}}},function(e,t,n){"use strict";function a(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}Object.defineProperty(t,"__esModule",{value:!0}),t.actions=t.initialState=t.types=void 0;var r=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a])}return e},o=n(29),i=t.types={UPDATE:"config/UPDATE",UPDATE_COMPONENT:"config/UPDATE_COMPONENT",RESET:"config/RESET"},s=t.initialState={forceTouchUI:!1,components:{watermark:{},seekbar:{},vrStereo:{},share:{}}};t.default=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:s,t=arguments[1];switch(t.type){case i.UPDATE:var n=(0,o.mergeDeep)({},e,t.config);return r({},e,n);case i.UPDATE_COMPONENT:return r({},e,{components:r({},e.components,a({},t.componentAlias,(0,o.mergeDeep)({},e.components[t.componentAlias],t.config)))});default:return e}};t.actions={updateConfig:function(e){return{type:i.UPDATE,config:e}},updateComponentConfig:function(e,t){return{type:i.UPDATE_COMPONENT,componentAlias:e,config:t}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(56),r=n(102),o=n(103),i=n(104),s=n(60);n(59);n.d(t,"createStore",function(){return a.b}),n.d(t,"combineReducers",function(){return r.a}),n.d(t,"bindActionCreators",function(){return o.a}),n.d(t,"applyMiddleware",function(){return i.a}),n.d(t,"compose",function(){return s.a})},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.actions=t.initialState=t.types=void 0;var a=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a])}return e},r=n(12),o=n(32),i=t.types={UPDATE_LOADING_SPINNER_STATE:"loading/UPDATE_LOADING_SPINNER_STATE"},s=t.initialState={show:!1};t.default=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:s,t=arguments[1];switch(t.type){case r.types.UPDATE:return(0,o.getComponentStateFromConfig)("loading",e,t);case r.types.UPDATE_COMPONENT:return(0,o.getComponentStateFromComponentConfig)("loading",e,t);case i.UPDATE_LOADING_SPINNER_STATE:return a({},e,{show:t.show});default:return e}};t.actions={updateLoadingSpinnerState:function(e){return{type:i.UPDATE_LOADING_SPINNER_STATE,show:e}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(129);Object.defineProperty(t,"Loading",{enumerable:!0,get:function(){return a.Loading}})},function(e,t,n){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function r(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.IconType=t.Icon=void 0;var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),s=n(1),l=function(e){return e&&e.__esModule?e:{default:e}}(s),p=n(0),c={Maximize:"maximize",Minimize:"minimize",Play:"play",Pause:"pause",VolumeBase:"volume-base",VolumeWaves:"volume-waves",VolumeWave:"volume-wave",VolumeMute:"volume-mute",Close:"close",Share:"share",Settings:"settings",Check:"check",Language:"language",Quality:"quality",Captions:"captions",Speed:"speed",SpeedDown:"speed-down",SpeedUp:"speed-up",Audio:"audio",Copy:"copy",Facebook:"facebook",Twitter:"twitter",GooglePlus:"google-plus",Linkedin:"linkedin",Email:"email",Embed:"embed",Link:"link",ArrowDown:"arrow-down",StartOver:"start-over",SeekForward:"seek-forward",SeekEnd:"seek-end",Rewind:"rewind",Rewind10:"rewind10",vrStereo:"vr-stereo",vrStereoFull:"vr-stereo-full",Cast:"cast",CastBrand:"cast-brand",Next:"next",Prev:"prev",PictureInPicture:"picture-in-picture"},u=function(e){function t(){return a(this,t),r(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return o(t,e),i(t,[{key:"render",value:function(e){switch(e.type){case c.Maximize:return(0,p.h)("i",{className:[l.default.icon,l.default.iconMaximize].join(" ")});case c.Minimize:return(0,p.h)("i",{className:[l.default.icon,l.default.iconMinimize].join(" ")});case c.Play:return(0,p.h)("i",{className:[l.default.icon,l.default.iconPlay].join(" ")});case c.Pause:return(0,p.h)("i",{className:[l.default.icon,l.default.iconPause].join(" ")});case c.VolumeBase:return(0,p.h)("i",{className:[l.default.icon,l.default.iconVolumeBase].join(" ")});case c.VolumeWaves:return(0,p.h)("i",{className:[l.default.icon,l.default.iconVolumeWaves].join(" ")});case c.VolumeWave:return(0,p.h)("i",{className:[l.default.icon,l.default.iconVolumeWave].join(" ")});case c.VolumeMute:return(0,p.h)("i",{className:[l.default.icon,l.default.iconVolumeMute].join(" ")});case c.Close:return(0,p.h)("i",{className:[l.default.icon,l.default.iconClose].join(" ")});case c.Share:return(0,p.h)("i",{className:[l.default.icon,l.default.iconShare].join(" ")});case c.Settings:return(0,p.h)("i",{className:[l.default.icon,l.default.iconSettings].join(" ")});case c.Check:return(0,p.h)("i",{className:[l.default.icon,l.default.iconCheck].join(" ")});case c.Language:return(0,p.h)("i",{className:[l.default.icon,l.default.iconLanguage].join(" ")});case c.Quality:return(0,p.h)("i",{className:[l.default.icon,l.default.iconQuality].join(" ")});case c.Captions:return(0,p.h)("i",{className:[l.default.icon,l.default.iconCaptions].join(" ")});case c.Speed:return(0,p.h)("i",{className:[l.default.icon,l.default.iconSpeed].join(" ")});case c.SpeedDown:return(0,p.h)("i",{className:[l.default.icon,l.default.iconSpeedDown].join(" ")});case c.SpeedUp:return(0,p.h)("i",{className:[l.default.icon,l.default.iconSpeedUp].join(" ")});case c.Audio:return(0,p.h)("i",{className:[l.default.icon,l.default.iconAudio].join(" ")});case c.Copy:return(0,p.h)("i",{className:[l.default.icon,l.default.iconCopy].join(" ")});case c.Facebook:return(0,p.h)("i",{className:[l.default.icon,l.default.iconFacebook].join(" ")});case c.Twitter:return(0,p.h)("i",{className:[l.default.icon,l.default.iconTwitter].join(" ")});case c.GooglePlus:return(0,p.h)("i",{className:[l.default.icon,l.default.iconGooglePlus].join(" ")});case c.Linkedin:return(0,p.h)("i",{className:[l.default.icon,l.default.iconLinkedin].join(" ")});case c.Email:return(0,p.h)("i",{className:[l.default.icon,l.default.iconEmail].join(" ")});case c.Embed:return(0,p.h)("i",{className:[l.default.icon,l.default.iconEmbed].join(" ")});case c.Link:return(0,p.h)("i",{className:[l.default.icon,l.default.iconLink].join(" ")});case c.ArrowDown:return(0,p.h)("i",{className:[l.default.icon,l.default.iconArrowDown].join(" ")});case c.StartOver:return(0,p.h)("i",{className:[l.default.icon,l.default.iconStartOver].join(" ")});case c.SeekForward:return(0,p.h)("i",{className:[l.default.icon,l.default.iconSeekForward].join(" ")});case c.SeekEnd:return(0,p.h)("i",{className:[l.default.icon,l.default.iconSeekEnd].join(" ")});case c.Rewind:return(0,p.h)("i",{className:[l.default.icon,l.default.iconRewind].join(" ")});case c.Rewind10:return(0,p.h)("i",{className:[l.default.icon,l.default.iconRewind10].join(" ")});case c.vrStereo:return(0,p.h)("i",{className:[l.default.icon,l.default.iconVrStereo].join(" ")});case c.vrStereoFull:return(0,p.h)("i",{className:[l.default.icon,l.default.iconVrStereoFull].join(" ")});case c.Cast:return(0,p.h)("i",{className:[l.default.icon,l.default.iconChromecast].join(" ")});case c.CastBrand:return(0,p.h)("i",{className:[l.default.icon,l.default.iconChromecastBrand].join(" ")});case c.Next:return(0,p.h)("i",{className:[l.default.icon,l.default.iconNext].join(" ")});case c.Prev:return(0,p.h)("i",{className:[l.default.icon,l.default.iconPrev].join(" ")});case c.PictureInPicture:return(0,p.h)("i",{className:[l.default.icon,l.default.iconPictureInPicture].join(" ")})}}}]),t}(p.Component);t.default=u,t.Icon=u,t.IconType=c},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(139);Object.defineProperty(t,"Overlay",{enumerable:!0,get:function(){return a.Overlay}})},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a])}return e},r=t.types={UPDATE_SEEKBAR_DRAGGING_STATUS:"seekbar/UPDATE_SEEKBAR_DRAGGING_STATUS",UPDATE_SEEKBAR_HOVER_ACTIVE:"seekbar/UPDATE_SEEKBAR_HOVER_ACTIVE",UPDATE_CURRENT_TIME:"seekbar/UPDATE_CURRENT_TIME",UPDATE_DURATION:"seekbar/UPDATE_DURATION"},o=t.initialState={currentTime:0,duration:0,draggingActive:!1,hoverActive:!1};t.default=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:o,t=arguments[1];switch(t.type){case r.UPDATE_SEEKBAR_DRAGGING_STATUS:return a({},e,{draggingActive:t.draggingActive});case r.UPDATE_SEEKBAR_HOVER_ACTIVE:return a({},e,{hoverActive:t.hoverActive});case r.UPDATE_CURRENT_TIME:return a({},e,{currentTime:t.currentTime});case r.UPDATE_DURATION:return a({},e,{duration:t.duration});default:return e}};t.actions={updateSeekbarDraggingStatus:function(e){return{type:r.UPDATE_SEEKBAR_DRAGGING_STATUS,draggingActive:e}},updateSeekbarHoverActive:function(e){return{type:r.UPDATE_SEEKBAR_HOVER_ACTIVE,hoverActive:e}},updateDuration:function(e){return{type:r.UPDATE_DURATION,duration:e}},updateCurrentTime:function(e){return{type:r.UPDATE_CURRENT_TIME,currentTime:e}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.actions=t.initialState=t.types=void 0;var a=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a])}return e},r=n(12),o=n(32),i=t.types={TOGGLE_SHARE_OVERLAY:"share/TOGGLE_SHARE_OVERLAY"},s=t.initialState={overlayOpen:!1};t.default=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:s,t=arguments[1];switch(t.type){case r.types.UPDATE:return(0,o.getComponentStateFromConfig)("share",e,t);case r.types.UPDATE_COMPONENT:return(0,o.getComponentStateFromComponentConfig)("share",e,t);case i.TOGGLE_SHARE_OVERLAY:return a({},e,{overlayOpen:t.show});default:return e}};t.actions={toggleShareOverlay:function(e){return{type:i.TOGGLE_SHARE_OVERLAY,show:e}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a])}return e},r=t.types={TOGGLE_CVAA_OVERLAY:"cvaa/TOGGLE_CVAA_OVERLAY",UPDATE_CAPTIONS_STYLE:"cvaa/UPDATE_CAPTIONS_STYLE"},o=t.initialState={overlayOpen:!1,style:"default"};t.default=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:o,t=arguments[1];switch(t.type){case r.TOGGLE_CVAA_OVERLAY:return a({},e,{overlayOpen:t.show});case r.UPDATE_CAPTIONS_STYLE:return a({},e,{style:t.style});default:return e}};t.actions={toggleCVAAOverlay:function(e){return{type:r.TOGGLE_CVAA_OVERLAY,show:e}},updateCaptionsStyle:function(e){return{type:r.UPDATE_CAPTIONS_STYLE,style:e}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a])}return e},r=t.types={UPDATE_ACTION_ICON:"overlay-action/UPDATE_ACTION_ICON"},o=t.initialState={iconType:null};t.default=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:o,t=arguments[1];switch(t.type){case r.UPDATE_ACTION_ICON:return a({},e,{iconType:t.iconType});default:return e}};t.actions={updateOverlayActionIcon:function(e){return{type:r.UPDATE_ACTION_ICON,iconType:e}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(136);Object.defineProperty(t,"VolumeControl",{enumerable:!0,get:function(){return a.VolumeControl}})},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(146);Object.defineProperty(t,"FullscreenControl",{enumerable:!0,get:function(){return a.FullscreenControl}})},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(150);Object.defineProperty(t,"BottomBar",{enumerable:!0,get:function(){return a.BottomBar}})},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(41);Object.defineProperty(t,"KeyboardControl",{enumerable:!0,get:function(){return a.KeyboardControl}})},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(152);Object.defineProperty(t,"UnmuteIndication",{enumerable:!0,get:function(){return a.UnmuteIndication}})},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(154);Object.defineProperty(t,"PlaybackControls",{enumerable:!0,get:function(){return a.PlaybackControls}})},function(e,t){var n;n=function(){return this}();try{n=n||Function("return this")()||(0,eval)("this")}catch(e){"object"==typeof window&&(n=window)}e.exports=n},function(e,t,n){"use strict";function a(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}function r(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function o(e){return e&&"object"===(void 0===e?"undefined":s(e))&&!Array.isArray(e)}function i(e){for(var t=arguments.length,n=Array(t>1?t-1:0),s=1;s<t;s++)n[s-1]=arguments[s];if(!n.length)return e;var l=n.shift();if(o(e)&&o(l))for(var p in l)o(l[p])?(e[p]||Object.assign(e,r({},p,{})),i(e[p],l[p])):Object.assign(e,r({},p,l[p]));return i.apply(void 0,[e].concat(a(n)))}Object.defineProperty(t,"__esModule",{value:!0});var s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.mergeDeep=i,t.isObject=o},function(e,t,n){"use strict";function a(e){return e?s.get(e):s}function r(e){return a(e).getLevel()}function o(e,t){a(t).setLevel(e)}Object.defineProperty(t,"__esModule",{value:!0}),t.setLogLevel=t.getLogLevel=t.LogLevel=void 0;var i=n(107),s=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}(i),l={DEBUG:s.DEBUG,INFO:s.INFO,TIME:s.TIME,WARN:s.WARN,ERROR:s.ERROR,OFF:s.OFF};s.useDefaults({defaultLevel:s.ERROR}),t.default=a,t.LogLevel=l,t.getLogLevel=r,t.setLogLevel=o},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a="pakhshkit-ui",r={UI_CLICKED:a+"-uiclicked",UI_VISIBILITY_CHANGED:a+"-uivisibilitychanged",USER_CLICKED_PLAY:a+"-userclickedplay",USER_CLICKED_PAUSE:a+"-userclickedpause",USER_CLICKED_REWIND:a+"-userclickedrewind",USER_CLICKED_LIVE_TAG:a+"-userclickedlivetag",USER_CLICKED_MUTE:a+"-userclickedmute",USER_CLICKED_UNMUTE:a+"-userclickedunmute",USER_CHANGED_VOLUME:a+"-userchangedvolume",USER_SELECTED_CAPTION_TRACK:a+"-userselectedcaptiontrack",USER_SELECTED_AUDIO_TRACK:a+"-userselectedaudiotrack",USER_SELECTED_QUALITY_TRACK:a+"-userselectedqualitytrack",USER_ENTERED_FULL_SCREEN:a+"-userenteredfullscreen",USER_EXITED_FULL_SCREEN:a+"-userexitedfullscreen",USER_SELECTED_CAPTIONS_STYLE:a+"-userselectedcaptionsstyle",USER_SELECTED_SPEED:a+"-userselectedspeed",USER_SEEKED:a+"-userseeked"};t.EventType=r},function(e,t,n){"use strict";function a(e,t,n){var a=n.config.components&&n.config.components[e];return a?(0,o.mergeDeep)(t,a):t}function r(e,t,n){return n.componentAlias===e?(0,o.mergeDeep)(t,n.config):t}Object.defineProperty(t,"__esModule",{value:!0}),t.getComponentStateFromComponentConfig=t.getComponentStateFromConfig=void 0;var o=n(29);t.getComponentStateFromConfig=a,t.getComponentStateFromComponentConfig=r},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a])}return e},r=t.types={UPDATE_VOLUME_DRAGGING_STATUS:"volume/UPDATE_VOLUME_DRAGGING_STATUS",UPDATE_HOVER:"volume/UPDATE_HOVER"},o=t.initialState={draggingActive:!1,hover:!1};t.default=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:o,t=arguments[1];switch(t.type){case r.UPDATE_VOLUME_DRAGGING_STATUS:return a({},e,{draggingActive:t.draggingActive});case r.UPDATE_HOVER:return a({},e,{hover:t.hover});default:return e}};t.actions={updateVolumeDraggingStatus:function(e){return{type:r.UPDATE_VOLUME_DRAGGING_STATUS,draggingActive:e}},updateVolumeHover:function(e){return{type:r.UPDATE_HOVER,hover:e}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a])}return e},r=t.types={UPDATE_QUALITY:"settings/UPDATE_QUALITY",UPDATE_SPEED:"settings/UPDATE_SPEED"},o=t.initialState={quality:1,speed:2};t.default=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:o,t=arguments[1];switch(t.type){case r.UPDATE_QUALITY:return a({},e,{quality:t.quality});case r.UPDATE_SPEED:return a({},e,{speed:t.speed});default:return e}};t.actions={updateQuality:function(e){return{type:r.UPDATE_QUALITY,quality:e}},updateSpeed:function(e){return{type:r.UPDATE_SPEED,speed:e}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a])}return e},r=t.types={UPDATE_BACKDROP_VISIBILITY:"backdrop/UPDATE_BACKDROP_VISIBILITY"},o=t.initialState={show:!1};t.default=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:o,t=arguments[1];switch(t.type){case r.UPDATE_BACKDROP_VISIBILITY:return a({},e,{show:t.show});default:return e}};t.actions={updateBackdropVisibility:function(e){return{type:r.UPDATE_BACKDROP_VISIBILITY,show:e}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(131);Object.defineProperty(t,"OverlayAction",{enumerable:!0,get:function(){return a.OverlayAction}})},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});t.isPlayingAdOrPlayback=function(e){return e.adBreak&&e.adIsPlaying||!e.adBreak&&e.isPlaying}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(132);Object.defineProperty(t,"PrePlaybackPlayOverlay",{enumerable:!0,get:function(){return a.PrePlaybackPlayOverlay}})},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(135);Object.defineProperty(t,"SeekBarControl",{enumerable:!0,get:function(){return a.SeekBarControl}})},function(e,t,n){"use strict";function a(e){var t=parseInt(e,10),n=Math.floor(t/3600),a=Math.floor((t-3600*n)/60),r=t-3600*n-60*a;return n<10&&(n="0"+n),a<10&&(a="0"+a),r<10&&(r="0"+r),("00"!==n?n+":":"")+a+":"+r}function r(e){var t=e.split(":"),n=0;if(2===t.length){if(parseInt(t[0])>59||parseInt(t[1])>59)return 0;n+=60*parseInt(t[0]),n+=parseInt(t[1])}return n}Object.defineProperty(t,"__esModule",{value:!0}),t.toHHMMSS=a,t.toSecondsFromHHMMSS=r},function(e,t,n){"use strict";function a(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.KeyboardControl=t.KEYBOARD_DEFAULT_VOLUME_JUMP=t.KEYBOARD_DEFAULT_SEEK_JUMP=void 0;var s,l,p=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a])}return e},c=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),u=n(3),h=function(e){return e&&e.__esModule?e:{default:e}}(u),k=n(2),d=n(8),f=n(21),y=n(7),v=n(6),b=n(4),m=n(10),g=n(37),_=function(e){return{isPlayingAdOrPlayback:(0,g.isPlayingAdOrPlayback)(e.engine),playerNav:e.shell.playerNav,textTracks:e.engine.textTracks,shareOverlay:e.share.overlayOpen}},w=t.KEYBOARD_DEFAULT_SEEK_JUMP=5,E=t.KEYBOARD_DEFAULT_VOLUME_JUMP=5,P=(s=(0,k.connect)(_,(0,y.bindActions)(Object.assign({},d.actions,f.actions))))(l=function(e){function t(e){var n;r(this,t);var i=o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,{name:"Keyboard",player:e.player,config:e.config}));i._lastActiveTextLanguage="",i._hoverTimeout=null,i.keyboardHandlers=(n={},a(n,v.KeyMap.SPACE,function(){return i.props.isPlayingAdOrPlayback?(i.player.pause(),i.props.updateOverlayActionIcon(b.IconType.Pause)):(i.player.play(),i.props.updateOverlayActionIcon(b.IconType.Play)),i.toggleHoverState(),!0}),a(n,v.KeyMap.UP,function(){var e=(Math.round(100*i.player.volume)+E)/100;return e=e>1?1:e,i.logger.debug("Changing volume. "+i.player.volume+" => "+e),i.player.muted&&(i.player.muted=!1),i.player.volume=e,i.props.updateOverlayActionIcon([b.IconType.VolumeBase,b.IconType.VolumeWaves]),{volume:i.player.volume}}),a(n,v.KeyMap.DOWN,function(){var e=(Math.round(100*i.player.volume)-E)/100;return e=e<0?0:e,i.logger.debug("Changing volume. "+i.player.volume+" => "+e),i.player.volume=e,0===e?(i.player.muted=!0,i.props.updateOverlayActionIcon([b.IconType.VolumeBase,b.IconType.VolumeMute])):i.props.updateOverlayActionIcon([b.IconType.VolumeBase,b.IconType.VolumeWave]),{volume:i.player.volume}}),a(n,v.KeyMap.F,function(){if(!i.player.isFullscreen())return i.logger.debug("Enter fullscreen"),i.player.enterFullscreen(),!0}),a(n,v.KeyMap.ESC,function(){if(i.player.isFullscreen())return i.logger.debug("Exit fullscreen"),i.player.exitFullscreen(),!0}),a(n,v.KeyMap.LEFT,function(){if(!i.player.ads||!i.player.ads.isAdBreak()){var e=i.player.currentTime-w,t=i.player.currentTime,n=e>0?e:0;return i.logger.debug("Seek. "+t+" => "+n),i.player.currentTime=n,i.props.updateOverlayActionIcon(b.IconType.Rewind),i.toggleHoverState(),{from:t,to:n}}}),a(n,v.KeyMap.RIGHT,function(){if(!i.player.ads||!i.player.ads.isAdBreak()){var e=i.player.currentTime+w,t=i.player.currentTime,n=e>i.player.duration?i.player.duration:e;return i.logger.debug("Seek. "+t+" => "+n),i.player.currentTime=e>i.player.duration?i.player.duration:e,i.props.updateOverlayActionIcon(b.IconType.SeekForward),i.toggleHoverState(),{from:t,to:n}}}),a(n,v.KeyMap.HOME,function(){if(!i.player.ads||!i.player.ads.isAdBreak()){var e=i.player.currentTime;return i.logger.debug("Seek. "+e+" => 0"),i.player.currentTime=0,i.props.updateOverlayActionIcon(b.IconType.StartOver),i.toggleHoverState(),{from:e,to:0}}}),a(n,v.KeyMap.END,function(){if(!i.player.ads||!i.player.ads.isAdBreak()){var e=i.player.currentTime,t=i.player.duration;return i.logger.debug("Seek. "+e+" => "+t),i.player.currentTime=t,i.props.updateOverlayActionIcon(b.IconType.SeekEnd),i.toggleHoverState(),{from:e,to:t}}}),a(n,v.KeyMap.M,function(){return i.logger.debug(i.player.muted?"Umnute":"Mute"),i.player.muted=!i.player.muted,i.player.muted?i.props.updateOverlayActionIcon([b.IconType.VolumeBase,b.IconType.VolumeMute]):i.props.updateOverlayActionIcon([b.IconType.VolumeBase,b.IconType.VolumeWaves]),!0}),a(n,v.KeyMap.SEMI_COLON,function(e){if(e&&i.player.playbackRate!==i.player.defaultPlaybackRate)return i.logger.debug("Changing playback rate. "+i.player.playbackRate+" => "+i.player.defaultPlaybackRate),i.player.playbackRate=i.player.defaultPlaybackRate,i.props.updateOverlayActionIcon(b.IconType.Speed),{speed:i.player.defaultPlaybackRate}}),a(n,v.KeyMap.PERIOD,function(e){if(e){var t=i.player.playbackRate,n=i.player.playbackRates.indexOf(t);if(n<i.player.playbackRates.length-1)return i.logger.debug("Changing playback rate. "+t+" => "+i.player.playbackRates[n+1]),i.player.playbackRate=i.player.playbackRates[n+1],i.props.updateOverlayActionIcon(b.IconType.SpeedUp),{speed:i.player.playbackRates[n+1]}}}),a(n,v.KeyMap.COMMA,function(e){if(e){var t=i.player.playbackRate,n=i.player.playbackRates.indexOf(t);if(n>0)return i.logger.debug("Changing playback rate. "+t+" => "+i.player.playbackRates[n-1]),i.player.playbackRate=i.player.playbackRates[n-1],i.props.updateOverlayActionIcon(b.IconType.SpeedDown),{speed:i.player.playbackRates[n-1]}}}),a(n,v.KeyMap.C,function(){var e=i.player.getActiveTracks().text;if("off"===e.language&&i._lastActiveTextLanguage){i.logger.debug("Changing text track to language",i._lastActiveTextLanguage);var t=i.player.getTracks("text").find(function(e){return e.language===i._lastActiveTextLanguage});return i.player.selectTrack(t),{track:t}}"off"===e.language||i._lastActiveTextLanguage||(i.logger.debug("Hiding text track"),i._lastActiveTextLanguage=e.language,i.player.hideTextTrack())}),n);var s=document.getElementById(i.config.targetId);return s?(s.onkeydown=function(e){if(!i.props.shareOverlay&&!i.props.playerNav&&"function"==typeof i.keyboardHandlers[e.keyCode]){e.preventDefault(),i.logger.debug("KeyDown -> keyName: "+(0,v.getKeyName)(e.keyCode)+", shiftKey: "+e.shiftKey.toString());var t=i.keyboardHandlers[e.keyCode](e.shiftKey);t&&i.notifyClick(p({key:e.keyCode},t))}},i):o(i)}return i(t,e),c(t,[{key:"componentWillReceiveProps",value:function(e){var t=this.props.textTracks.find(function(e){return e.active}),n=e.textTracks.find(function(e){return e.active});t&&"off"!==t.language&&n&&"off"===n.language?this._lastActiveTextLanguage=t.language:n&&"off"!==n.language&&(this._lastActiveTextLanguage="")}},{key:"toggleHoverState",value:function(){var e=this;null!==this._hoverTimeout&&(clearTimeout(this._hoverTimeout),this._hoverTimeout=null),this.props.updatePlayerHoverState(!0),this._hoverTimeout=setTimeout(function(){e.props.updatePlayerHoverState(!1)},m.CONTROL_BAR_HOVER_DEFAULT_TIMEOUT)}}]),t}(h.default))||l;t.KeyboardControl=P},function(e,t,n){"use strict";function a(e,t){return function(){t.apply(e,arguments)}}Object.defineProperty(t,"__esModule",{value:!0}),t.bindMethod=a},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(137);Object.defineProperty(t,"SettingsControl",{enumerable:!0,get:function(){return a.SettingsControl}})},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(138);Object.defineProperty(t,"SmartContainer",{enumerable:!0,get:function(){return a.SmartContainer}})},function(e,t,n){!function(t,a){e.exports=a(n(0))}(0,function(e){"use strict";var t=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")},n=function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)},a=function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t},r=function(r){function i(){return t(this,i),a(this,r.apply(this,arguments))}return n(i,r),i.prototype.componentDidUpdate=function(e){for(var t in e)if(e[t]!==this.props[t])return this.renderLayer()},i.prototype.componentDidMount=function(){this.renderLayer()},i.prototype.componentWillUnmount=function(){this.renderLayer(!1),this.remote&&this.remote.parentNode.removeChild(this.remote)},i.prototype.findNode=function(e){return"string"==typeof e?document.querySelector(e):e},i.prototype.renderLayer=function(){var t=arguments.length<=0||void 0===arguments[0]||arguments[0];this.props.into!==this.intoPointer&&(this.intoPointer=this.props.into,this.into&&this.remote&&(this.remote=e.render(e.h(o,null),this.into,this.remote)),this.into=this.findNode(this.props.into)),this.remote=e.render(e.h(o,{context:this.context},t&&this.props.children||null),this.into,this.remote)},i.prototype.render=function(){return null},i}(e.Component),o=function(e){function r(){return t(this,r),a(this,e.apply(this,arguments))}return n(r,e),r.prototype.getChildContext=function(){return this.props.context},r.prototype.render=function(e){var t=e.children;return t&&t[0]||null},r}(e.Component);return r})},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(140);Object.defineProperty(t,"DropDown",{enumerable:!0,get:function(){return a.DropDown}})},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(142);Object.defineProperty(t,"LanguageControl",{enumerable:!0,get:function(){return a.LanguageControl}})},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(147);Object.defineProperty(t,"VrStereoToggleControl",{enumerable:!0,get:function(){return a.VrStereoToggleControl}})},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(149);Object.defineProperty(t,"TimeDisplay",{enumerable:!0,get:function(){return a.TimeDisplay}})},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(151);Object.defineProperty(t,"OverlayPortal",{enumerable:!0,get:function(){return a.OverlayPortal}})},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.Watermark=void 0;var s,l,p=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),c=n(1),u=a(c),h=n(0),k=n(3),d=a(k),f=n(2),y=function(e){return{config:Object.assign({placement:"top-left",timeout:0},e.config.components.watermark)}},v=(s=(0,f.connect)(y))(l=function(e){function t(e){r(this,t);var n=o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,{name:"Watermark",player:e.player}));return n.setState({show:!0}),n}return i(t,e),p(t,null,[{key:"shouldRender",value:function(e){var t=e.config.components[this.displayName];return!(0===Object.keys(t).length&&t.constructor===Object)}}]),p(t,[{key:"componentDidMount",value:function(){var e=this,t=function(){e.props.config.timeout>0&&setTimeout(function(){return e.setState({show:!1})},e.props.config.timeout)};this.eventManager.listenOnce(this.player,this.player.Event.PLAYING,t),this.eventManager.listen(this.player,this.player.Event.CHANGE_SOURCE_ENDED,function(){e.setState({show:!0}),e.eventManager.listenOnce(e.player,e.player.Event.PLAYING,t)})}},{key:"render",value:function(e){if(e.config.img){var t=[u.default.watermark];return e.config.placement.split("-").forEach(function(e){t.push(u.default[e])}),this.state.show||t.push(u.default.hideWatermark),(0,h.h)("div",{className:t.join(" ")},(0,h.h)("a",{href:e.config.url,target:"_blank",rel:"noopener noreferrer"},(0,h.h)("img",{src:e.config.img})))}}}]),t}(d.default))||l;v.displayName="watermark",t.Watermark=v},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(153);Object.defineProperty(t,"CastControl",{enumerable:!0,get:function(){return a.CastControl}})},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.CastBeforePlay=void 0;var s,l,p=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),c=n(1),u=a(c),h=n(0),k=n(3),d=a(k),f=n(2),y=n(4),v=n(35),b=n(16),m=n(5),g=function(e){return{isPlaybackEnded:e.engine.isPlaybackEnded,prePlayback:e.engine.prePlayback,loading:e.loading.show,isCastAvailable:e.engine.isCastAvailable}},_=(s=(0,f.connect)(g,v.actions))(l=function(e){function t(e){return r(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,{name:"CastBeforePlay",player:e.player}))}return i(t,e),p(t,[{key:"onClick",value:function(){var e=this;this.props.updateBackdropVisibility(!0),this.player.startCasting().catch(function(){return e.props.updateBackdropVisibility(!1)})}},{key:"componentDidMount",value:function(){var e=this;setTimeout(function(){e.setState({show:!0})},700)}},{key:"render",value:function(e){var t=this;if(e.isCastAvailable&&!e.loading&&e.prePlayback){var n=[u.default.castOnTvButtonContainer];return this.state.show&&n.push(u.default.showCastOnTv),(0,h.h)("div",null,(0,h.h)("div",{className:n.join(" "),onClick:function(){return t.onClick()}},(0,h.h)("a",{className:[u.default.btn,u.default.btnDarkTransparent,u.default.castOnTvButton].join(" ")},(0,h.h)("div",{className:u.default.castOnTvIconContainer},(0,h.h)(b.Icon,{type:e.icon})),(0,h.h)(m.Localizer,null,(0,h.h)("span",null,(0,h.h)(m.Text,{id:"cast.play_on_tv"}))))))}}}]),t}(d.default))||l;_.defaultProps={icon:y.IconType.Cast},t.CastBeforePlay=_},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(160);Object.defineProperty(t,"PictureInPicture",{enumerable:!0,get:function(){return a.PictureInPicture}})},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(162);Object.defineProperty(t,"ShareControl",{enumerable:!0,get:function(){return a.ShareControl}})},function(e,t,n){"use strict";function a(e,t,n){function o(){v===y&&(v=y.slice())}function l(){return f}function p(e){if("function"!=typeof e)throw new Error("Expected listener to be a function.");var t=!0;return o(),v.push(e),function(){if(t){t=!1,o();var n=v.indexOf(e);v.splice(n,1)}}}function c(e){if(!Object(r.a)(e))throw new Error("Actions must be plain objects. Use custom middleware for async actions.");if(void 0===e.type)throw new Error('Actions may not have an undefined "type" property. Have you misspelled a constant?');if(b)throw new Error("Reducers may not dispatch actions.");try{b=!0,f=d(f,e)}finally{b=!1}for(var t=y=v,n=0;n<t.length;n++){(0,t[n])()}return e}function u(e){if("function"!=typeof e)throw new Error("Expected the nextReducer to be a function.");d=e,c({type:s.INIT})}function h(){var e,t=p;return e={subscribe:function(e){function n(){e.next&&e.next(l())}if("object"!=typeof e)throw new TypeError("Expected the observer to be an object.");return n(),{unsubscribe:t(n)}}},e[i.a]=function(){return this},e}var k;if("function"==typeof t&&void 0===n&&(n=t,t=void 0),void 0!==n){if("function"!=typeof n)throw new Error("Expected the enhancer to be a function.");return n(a)(e,t)}if("function"!=typeof e)throw new Error("Expected the reducer to be a function.");var d=e,f=t,y=[],v=y,b=!1;return c({type:s.INIT}),k={dispatch:c,subscribe:p,getState:l,replaceReducer:u},k[i.a]=h,k}n.d(t,"a",function(){return s}),t.b=a;var r=n(57),o=n(98),i=n.n(o),s={INIT:"@@redux/INIT"}},function(e,t,n){"use strict";function a(e){if(!Object(i.a)(e)||Object(r.a)(e)!=s)return!1;var t=Object(o.a)(e);if(null===t)return!0;var n=u.call(t,"constructor")&&t.constructor;return"function"==typeof n&&n instanceof n&&c.call(n)==h}var r=n(90),o=n(95),i=n(97),s="[object Object]",l=Function.prototype,p=Object.prototype,c=l.toString,u=p.hasOwnProperty,h=c.call(Object);t.a=a},function(e,t,n){"use strict";var a=n(91),r=a.a.Symbol;t.a=r},function(e,t,n){"use strict"},function(e,t,n){"use strict";function a(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];return 0===t.length?function(e){return e}:1===t.length?t[0]:t.reduce(function(e,t){return function(){return e(t.apply(void 0,arguments))}})}t.a=a},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(110);Object.defineProperty(t,"EngineConnector",{enumerable:!0,get:function(){return a.EngineConnector}})},function(e,t,n){"use strict";function a(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function r(e,t,n){var a=e.getState().engine,r=e.getState().shell;!a.adBreak&&a.isPlaying&&r.playerHover!==t.hover&&n.dispatchEvent(new w.UIVisibilityChangedEvent(t.hover))}function o(e,t,n){switch(t.name){case"Volume":n.dispatchEvent(new P.VolumeChangedEvent(t.payload.volume));break;case"SeekBarPlaybackContainer":n.dispatchEvent(new g.SeekedEvent(t.payload.from,t.payload.to))}}function i(e,t,n){switch(t.name){case"Keyboard":x[t.payload.key](e,t,n);break;case"OverlayAction":h(e,t,n);break;case"Settings":u(e,t,n);break;case"CVAAOverlay":n.dispatchEvent(new b.CaptionsStyleSelectedEvent(t.payload.textStyle));break;case"Fullscreen":c(e,t,n);break;case"LanguageControl":p(e,t,n);break;case"Shell":n.dispatchEvent(new d.FakeEvent(d.FakeEvent.Type.UI_CLICKED));break;case"Rewind":n.dispatchEvent(new E.RewindClickedEvent(t.payload.from,t.payload.to));break;case"LiveTag":n.dispatchEvent(new d.FakeEvent(d.FakeEvent.Type.USER_CLICKED_LIVE_TAG));break;case"PrePlaybackPlayOverlay":case"PlayPause":s(e,t,n);break;case"Volume":l(e,t,n)}}function s(e,t,n){var a=e.getState().engine;a.adBreak?a.adIsPlaying?n.dispatchEvent(new d.FakeEvent(d.FakeEvent.Type.USER_CLICKED_PAUSE)):n.dispatchEvent(new d.FakeEvent(d.FakeEvent.Type.USER_CLICKED_PLAY)):a.isPlaying?n.dispatchEvent(new d.FakeEvent(d.FakeEvent.Type.USER_CLICKED_PAUSE)):n.dispatchEvent(new d.FakeEvent(d.FakeEvent.Type.USER_CLICKED_PLAY))}function l(e,t,n){e.getState().engine.muted?n.dispatchEvent(new d.FakeEvent(d.FakeEvent.Type.USER_CLICKED_MUTE)):n.dispatchEvent(new d.FakeEvent(d.FakeEvent.Type.USER_CLICKED_UNMUTE))}function p(e,t,n){t.payload.type===n.Track.AUDIO?n.dispatchEvent(new y.AudioSelectedEvent(t.payload.track)):t.payload.type===n.Track.TEXT&&n.dispatchEvent(new v.CaptionSelectedEvent(t.payload.track))}function c(e,t,n){n.isFullscreen()?n.dispatchEvent(new d.FakeEvent(d.FakeEvent.Type.USER_EXITED_FULL_SCREEN)):n.dispatchEvent(new d.FakeEvent(d.FakeEvent.Type.USER_ENTERED_FULL_SCREEN))}function u(e,t,n){t.payload.type===n.Track.VIDEO?n.dispatchEvent(new m.QualitySelectedEvent(t.payload.track)):n.dispatchEvent(new _.SpeedSelectedEvent(t.payload.speed))}function h(e,t,n){"PlayPause"===t.payload.type?s(e,t,n):"Fullscreen"===t.payload.type&&c(e,t,n)}Object.defineProperty(t,"__esModule",{value:!0}),t.eventDispatcherMiddleware=t.types=void 0;var k,d=n(9),f=n(8),y=n(111),v=n(112),b=n(113),m=n(114),g=n(115),_=n(116),w=n(117),E=n(118),P=n(119),O=n(6),T={COMPONENT_CLICKED:"event-dispatcher-middleware/COMPONENT_CLICKED",COMPONENT_CHANGED:"event-dispatcher-middleware/COMPONENT_CHANGED"},C=function(e){return function(t){return function(n){return function(a){switch(a.type){case T.COMPONENT_CLICKED:i(t,a,e);break;case T.COMPONENT_CHANGED:o(t,a,e);break;case f.types.UPDATE_PLAYER_HOVER_STATE:r(t,a,e)}n(a)}}}},x=(k={},a(k,O.KeyMap.SPACE,function(e,t,n){s(e,t,n)}),a(k,O.KeyMap.UP,function(e,t,n){n.dispatchEvent(new P.VolumeChangedEvent(t.payload.volume))}),a(k,O.KeyMap.DOWN,function(e,t,n){n.dispatchEvent(new P.VolumeChangedEvent(t.payload.volume))}),a(k,O.KeyMap.F,function(e,t,n){c(e,t,n)}),a(k,O.KeyMap.ESC,function(e,t,n){c(e,t,n)}),a(k,O.KeyMap.LEFT,function(e,t,n){n.dispatchEvent(new g.SeekedEvent(t.payload.from,t.payload.to))}),a(k,O.KeyMap.RIGHT,function(e,t,n){n.dispatchEvent(new g.SeekedEvent(t.payload.from,t.payload.to))}),a(k,O.KeyMap.HOME,function(e,t,n){n.dispatchEvent(new g.SeekedEvent(t.payload.from,t.payload.to))}),a(k,O.KeyMap.END,function(e,t,n){n.dispatchEvent(new g.SeekedEvent(t.payload.from,t.payload.to))}),a(k,O.KeyMap.M,function(e,t,n){l(e,t,n)}),a(k,O.KeyMap.SEMI_COLON,function(e,t,n){n.dispatchEvent(new _.SpeedSelectedEvent(t.payload.speed))}),a(k,O.KeyMap.PERIOD,function(e,t,n){n.dispatchEvent(new _.SpeedSelectedEvent(t.payload.speed))}),a(k,O.KeyMap.COMMA,function(e,t,n){n.dispatchEvent(new _.SpeedSelectedEvent(t.payload.speed))}),a(k,O.KeyMap.C,function(e,t,n){n.dispatchEvent(new v.CaptionSelectedEvent(t.payload.track))}),k);t.types=T,t.eventDispatcherMiddleware=C},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(10);Object.defineProperty(t,"Shell",{enumerable:!0,get:function(){return a.Shell}})},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(126);Object.defineProperty(t,"VideoPlayer",{enumerable:!0,get:function(){return a.VideoPlayer}})},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(128);Object.defineProperty(t,"idleUI",{enumerable:!0,get:function(){return a.idleUI}});var r=n(130);Object.defineProperty(t,"playbackUI",{enumerable:!0,get:function(){return r.playbackUI}});var o=n(165);Object.defineProperty(t,"adsUI",{enumerable:!0,get:function(){return o.adsUI}});var i=n(170);Object.defineProperty(t,"errorUI",{enumerable:!0,get:function(){return i.errorUI}});var s=n(173);Object.defineProperty(t,"liveUI",{enumerable:!0,get:function(){return s.liveUI}})},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(133);Object.defineProperty(t,"RewindControl",{enumerable:!0,get:function(){return a.RewindControl}})},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(134);Object.defineProperty(t,"SeekBarPlaybackContainer",{enumerable:!0,get:function(){return a.SeekBarPlaybackContainer}})},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.SmartContainerItem=void 0;var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),l=n(1),p=a(l),c=n(0),u=n(46),h=n(4),k=a(h),d=function(e){function t(){return r(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),s(t,[{key:"render",value:function(e){var t=e.label&&e.label.toLowerCase();return(0,c.h)("div",{className:[p.default.smartContainerItem,p.default.selectMenuItem].join(" ")},(0,c.h)("label",{htmlFor:t},e.icon?(0,c.h)("div",{className:p.default.labelIcon},(0,c.h)(k.default,{type:e.icon})):void 0,e.label),(0,c.h)(u.DropDown,{name:t,onSelect:function(t){return e.onSelect(t)},options:e.options}))}}]),t}(c.Component);t.SmartContainerItem=d},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(141);Object.defineProperty(t,"Menu",{enumerable:!0,get:function(){return a.Menu}})},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(143);Object.defineProperty(t,"CVAAOverlay",{enumerable:!0,get:function(){return a.CVAAOverlay}})},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(145);Object.defineProperty(t,"Slider",{enumerable:!0,get:function(){return a.Slider}})},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(148);Object.defineProperty(t,"TimeDisplayPlaybackContainer",{enumerable:!0,get:function(){return a.TimeDisplayPlaybackContainer}})},function(e,t,n){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function r(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.Backdrop=void 0;var i,s,l=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),p=n(1),c=function(e){return e&&e.__esModule?e:{default:e}}(p),u=n(0),h=n(2),k=function(e){return{show:e.backdrop.show}},d=(i=(0,h.connect)(k,null))(s=function(e){function t(){return a(this,t),r(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return o(t,e),l(t,[{key:"render",value:function(e){if(e.show)return(0,u.h)("div",{className:c.default.backdrop})}}]),t}(u.Component))||s;t.Backdrop=d},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(155);Object.defineProperty(t,"PlaylistButton",{enumerable:!0,get:function(){return a.PlaylistButton}})},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(156);Object.defineProperty(t,"PlayPauseControl",{enumerable:!0,get:function(){return a.PlayPauseControl}})},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(159);Object.defineProperty(t,"PlaylistNextScreen",{enumerable:!0,get:function(){return a.PlaylistNextScreen}})},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(161);Object.defineProperty(t,"PictureInPictureOverlay",{enumerable:!0,get:function(){return a.PictureInPictureOverlay}})},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(163);Object.defineProperty(t,"ShareOverlay",{enumerable:!0,get:function(){return a.ShareOverlay}})},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.CopyButton=void 0;var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),l=n(1),p=a(l),c=n(0),u=n(3),h=a(u),k=n(4),d=n(16),f=n(5),y=function(e){function t(e){r(this,t);var n=o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.setState({copySuccess:!1}),n}return i(t,e),s(t,[{key:"copy",value:function(){var e=this;try{this.props.copy(),this.setState({copySuccess:!0}),setTimeout(function(){e.setState({copySuccess:!1})},2e3)}catch(e){this.setState({copySuccess:!1})}}},{key:"render",value:function(){var e=this,t=[p.default.btnCopyUrl].join(" ");return t+=this.state.copySuccess?" "+p.default.copied:"",(0,c.h)(f.Localizer,null,(0,c.h)("a",{className:t,onClick:function(){return e.copy()},title:(0,c.h)(f.Text,{id:"copy.button"})},(0,c.h)(d.Icon,{type:k.IconType.Copy}),(0,c.h)(d.Icon,{type:k.IconType.Check})))}}]),t}(h.default);y.defaultProps={icon:k.IconType.Copy},t.CopyButton=y},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(166);Object.defineProperty(t,"TimeDisplayAdsContainer",{enumerable:!0,get:function(){return a.TimeDisplayAdsContainer}})},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(167);Object.defineProperty(t,"AdSkip",{enumerable:!0,get:function(){return a.AdSkip}})},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(168);Object.defineProperty(t,"AdLearnMore",{enumerable:!0,get:function(){return a.AdLearnMore}})},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(169);Object.defineProperty(t,"TopBar",{enumerable:!0,get:function(){return a.TopBar}})},function(e,t,n){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function r(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.AdNotice=void 0;var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),s=n(1),l=function(e){return e&&e.__esModule?e:{default:e}}(s),p=n(0),c=n(5),u=function(e){function t(){return a(this,t),r(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return o(t,e),i(t,[{key:"render",value:function(){return(0,p.h)("span",{className:l.default.adNotice},(0,p.h)(c.Text,{id:"ads.ad_notice"}))}}]),t}(p.Component);t.AdNotice=u},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(171);Object.defineProperty(t,"ErrorOverlay",{enumerable:!0,get:function(){return a.ErrorOverlay}})},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(174);Object.defineProperty(t,"SeekBarLivePlaybackContainer",{enumerable:!0,get:function(){return a.SeekBarLivePlaybackContainer}})},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(175);Object.defineProperty(t,"LiveTag",{enumerable:!0,get:function(){return a.LiveTag}})},function(e,t,n){"use strict";function a(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}Object.defineProperty(t,"__esModule",{value:!0}),t.NAME=t.VERSION=t.UIManager=t.EventType=t.Utils=t.Components=t.Presets=t.Reducers=t.style=t.redux=t.preact=t.h=void 0;var r=n(0);Object.defineProperty(t,"h",{enumerable:!0,get:function(){return r.h}});var o=n(89),i=a(r),s=n(31),l=n(2),p=a(l),c=n(178),u=a(c),h=n(65),k=a(h),d=n(179),f=a(d),y=n(188),v=a(y),b=n(1),m=function(e){return e&&e.__esModule?e:{default:e}}(b);t.preact=i,t.redux=p,t.style=m.default,t.Reducers=u,t.Presets=k,t.Components=f,t.Utils=v,t.EventType=s.EventType,t.UIManager=o.UIManager,t.VERSION="0.40.1",t.NAME="@pakhshkit-js/pakhshkit-js-ui"},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.UIManager=void 0;var o=function(){function e(e,t){var n=[],a=!0,r=!1,o=void 0;try{for(var i,s=e[Symbol.iterator]();!(a=(i=s.next()).done)&&(n.push(i.value),!t||n.length!==t);a=!0);}catch(e){r=!0,o=e}finally{try{!a&&s.return&&s.return()}finally{if(r)throw o}}return n}return function(t,n){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return e(t,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),i=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),s=n(0),l=n(2),p=n(5),c=n(13),u=n(106),h=n(29),k=n(30),d=n(31),f=n(6),y=n(108),v=a(y),b=n(109),m=a(b),g=n(12),_=n(61),w=n(63),E=n(64),P=n(127),O=n(65),T=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}(O),C=n(176);n(1);var x=function(){function e(t,n){r(this,e),this._translations={en:m.default},this._locale="en",n.logLevel&&this.LogLevel[n.logLevel]&&(0,k.setLogLevel)(this.LogLevel[n.logLevel]),this.player=t,this.targetId=n.targetId,this._createStore(n),this.setConfig(n),this._setLocaleTranslations(n),(0,f.setEnv)(this.player.env)}return i(e,[{key:"setConfig",value:function(e,t){t?this.store.dispatch(g.actions.updateComponentConfig(t,e)):this.store.dispatch(g.actions.updateConfig(e))}},{key:"buildDefaultUI",value:function(){var e=[{template:function(e){return T.idleUI(e)},condition:function(e){return e.engine.isIdle}},{template:function(e){return T.errorUI(e)},condition:function(e){return e.engine.hasError}},{template:function(e){return T.adsUI(e)},condition:function(e){return e.engine.adBreak}},{template:function(e){return T.liveUI(e)},condition:function(e){return e.engine.isLive}},{template:function(e){return T.playbackUI(e)}}];this._buildUI(e)}},{key:"buildCustomUI",value:function(e){if(e.length>0)this._buildUI(e);else{var t=[{template:function(e){return T.playbackUI(e)}}];this._buildUI(t)}}},{key:"_setLocaleTranslations",value:function(e){var t=this;e.translations&&Object.entries(e.translations).forEach(function(e){var n=o(e,2),a=n[0],r=n[1];r=(0,h.mergeDeep)({},t._translations.en,r),t._translations[a]=r}),e.locale&&this._translations[e.locale]&&(this._locale=e.locale)}},{key:"_createStore",value:function(e){this.store=(0,c.createStore)(v.default,window.devToolsExtension&&window.devToolsExtension({name:"pakhshkit #"+this.targetId,instanceId:this.targetId}),(0,C.middleware)(this.player,e))}},{key:"_buildUI",value:function(e){if(this.player&&(this.container=document.getElementById(this.targetId),this.container)){var t=(0,s.h)(l.Provider,{store:this.store},(0,s.h)(p.IntlProvider,{definition:this._translations[this._locale]},(0,s.h)(w.Shell,{player:this.player},(0,s.h)(_.EngineConnector,{player:this.player}),(0,s.h)(E.VideoPlayer,{player:this.player}),(0,s.h)(P.PlayerGUI,{uis:e,player:this.player,playerContainer:this.container}))));this.root=(0,s.render)(t,this.container)}}},{key:"destroy",value:function(){this.container&&(this.container.prepend(this.player.getView()),(0,s.render)("",this.container,this.root))}},{key:"getLogLevel",value:function(e){return(0,k.getLogLevel)(e)}},{key:"setLogLevel",value:function(e,t){(0,k.setLogLevel)(e,t)}},{key:"config",get:function(){return(0,u.copyDeep)(this.store.getState().config)}},{key:"LogLevel",get:function(){return k.LogLevel}},{key:"Event",get:function(){return d.EventType}}]),e}();t.UIManager=x},function(e,t,n){"use strict";function a(e){return null==e?void 0===e?l:s:p&&p in Object(e)?Object(o.a)(e):Object(i.a)(e)}var r=n(58),o=n(93),i=n(94),s="[object Null]",l="[object Undefined]",p=r.a?r.a.toStringTag:void 0;t.a=a},function(e,t,n){"use strict";var a=n(92),r="object"==typeof self&&self&&self.Object===Object&&self,o=a.a||r||Function("return this")();t.a=o},function(e,t,n){"use strict";(function(e){var n="object"==typeof e&&e&&e.Object===Object&&e;t.a=n}).call(t,n(28))},function(e,t,n){"use strict";function a(e){var t=i.call(e,l),n=e[l];try{e[l]=void 0;var a=!0}catch(e){}var r=s.call(e);return a&&(t?e[l]=n:delete e[l]),r}var r=n(58),o=Object.prototype,i=o.hasOwnProperty,s=o.toString,l=r.a?r.a.toStringTag:void 0;t.a=a},function(e,t,n){"use strict";function a(e){return o.call(e)}var r=Object.prototype,o=r.toString;t.a=a},function(e,t,n){"use strict";var a=n(96),r=Object(a.a)(Object.getPrototypeOf,Object);t.a=r},function(e,t,n){"use strict";function a(e,t){return function(n){return e(t(n))}}t.a=a},function(e,t,n){"use strict";function a(e){return null!=e&&"object"==typeof e}t.a=a},function(e,t,n){e.exports=n(99)},function(e,t,n){"use strict";(function(e,a){Object.defineProperty(t,"__esModule",{value:!0});var r,o=n(101),i=function(e){return e&&e.__esModule?e:{default:e}}(o);r="undefined"!=typeof self?self:"undefined"!=typeof window?window:void 0!==e?e:a;var s=(0,i.default)(r);t.default=s}).call(t,n(28),n(100)(e))},function(e,t){e.exports=function(e){return e.webpackPolyfill||(e.deprecate=function(){},e.paths=[],e.children||(e.children=[]),Object.defineProperty(e,"loaded",{enumerable:!0,get:function(){return e.l}}),Object.defineProperty(e,"id",{enumerable:!0,get:function(){return e.i}}),e.webpackPolyfill=1),e}},function(e,t,n){"use strict";function a(e){var t,n=e.Symbol;return"function"==typeof n?n.observable?t=n.observable:(t=n("observable"),n.observable=t):t="@@observable",t}Object.defineProperty(t,"__esModule",{value:!0}),t.default=a},function(e,t,n){"use strict";function a(e,t){var n=t&&t.type;return"Given action "+(n&&'"'+n.toString()+'"'||"an action")+', reducer "'+e+'" returned undefined. To ignore an action, you must explicitly return the previous state. If you want this reducer to hold no value, you can return null instead of undefined.'}function r(e){Object.keys(e).forEach(function(t){var n=e[t];if(void 0===n(void 0,{type:i.a.INIT}))throw new Error('Reducer "'+t+"\" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined. If you don't want to set a value for this reducer, you can use null instead of undefined.");if(void 0===n(void 0,{type:"@@redux/PROBE_UNKNOWN_ACTION_"+Math.random().toString(36).substring(7).split("").join(".")}))throw new Error('Reducer "'+t+"\" returned undefined when probed with a random type. Don't try to handle "+i.a.INIT+' or other actions in "redux/*" namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined, but can be null.')})}function o(e){for(var t=Object.keys(e),n={},o=0;o<t.length;o++){var i=t[o];"function"==typeof e[i]&&(n[i]=e[i])}var s=Object.keys(n),l=void 0;try{r(n)}catch(e){l=e}return function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=arguments[1];if(l)throw l;for(var r=!1,o={},i=0;i<s.length;i++){var p=s[i],c=n[p],u=e[p],h=c(u,t);if(void 0===h){var k=a(p,t);throw new Error(k)}o[p]=h,r=r||h!==u}return r?o:e}}t.a=o;var i=n(56);n(57),n(59)},function(e,t,n){"use strict";function a(e,t){return function(){return t(e.apply(void 0,arguments))}}function r(e,t){if("function"==typeof e)return a(e,t);if("object"!=typeof e||null===e)throw new Error("bindActionCreators expected an object or a function, instead received "+(null===e?"null":typeof e)+'. Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');for(var n=Object.keys(e),r={},o=0;o<n.length;o++){var i=n[o],s=e[i];"function"==typeof s&&(r[i]=a(s,t))}return r}t.a=r},function(e,t,n){"use strict";function a(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];return function(e){return function(n,a,i){var s=e(n,a,i),l=s.dispatch,p=[],c={getState:s.getState,dispatch:function(e){return l(e)}};return p=t.map(function(e){return e(c)}),l=r.a.apply(void 0,p)(s.dispatch),o({},s,{dispatch:l})}}}t.a=a;var r=n(60),o=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a])}return e}},function(e,t,n){!function(t,n){e.exports=n()}(0,function(){function e(e,t,n,a){for(a=0,t=t.split?t.split("."):t;e&&a<t.length;)e=e[t[a++]];return void 0===e?n:e}return e})},function(e,t,n){"use strict";function a(e){var t=void 0;return Array.isArray(e)?(t=e.length>0?e.slice(0):[],t.forEach(function(e,n){("object"===(void 0===e?"undefined":r(e))&&e!=={}||Array.isArray(e)&&e.length>0)&&(t[n]=a(e))})):"object"===(void 0===e?"undefined":r(e))?(t=Object.assign({},e),Object.keys(t).forEach(function(e){("object"===r(t[e])&&t[e]!=={}||Array.isArray(t[e])&&t[e].length>0)&&(t[e]=a(t[e]))})):t=e,t}Object.defineProperty(t,"__esModule",{value:!0});var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.copyDeep=a},function(e,t,n){var a,r;/*!
 * js-logger - http://github.com/jonnyreeves/js-logger
 * Jonny Reeves, http://jonnyreeves.co.uk/
 * js-logger may be freely distributed under the MIT license.
 */
!function(o){"use strict";var i={};i.VERSION="1.4.1";var s,l={},p=function(e,t){return function(){return t.apply(e,arguments)}},c=function(){var e,t,n=arguments,a=n[0];for(t=1;t<n.length;t++)for(e in n[t])e in a||!n[t].hasOwnProperty(e)||(a[e]=n[t][e]);return a},u=function(e,t){return{value:e,name:t}};i.DEBUG=u(1,"DEBUG"),i.INFO=u(2,"INFO"),i.TIME=u(3,"TIME"),i.WARN=u(4,"WARN"),i.ERROR=u(8,"ERROR"),i.OFF=u(99,"OFF");var h=function(e){this.context=e,this.setLevel(e.filterLevel),this.log=this.info};h.prototype={setLevel:function(e){e&&"value"in e&&(this.context.filterLevel=e)},getLevel:function(){return this.context.filterLevel},enabledFor:function(e){var t=this.context.filterLevel;return e.value>=t.value},debug:function(){this.invoke(i.DEBUG,arguments)},info:function(){this.invoke(i.INFO,arguments)},warn:function(){this.invoke(i.WARN,arguments)},error:function(){this.invoke(i.ERROR,arguments)},time:function(e){"string"==typeof e&&e.length>0&&this.invoke(i.TIME,[e,"start"])},timeEnd:function(e){"string"==typeof e&&e.length>0&&this.invoke(i.TIME,[e,"end"])},invoke:function(e,t){s&&this.enabledFor(e)&&s(t,c({level:e},this.context))}};var k=new h({filterLevel:i.OFF});!function(){var e=i;e.enabledFor=p(k,k.enabledFor),e.debug=p(k,k.debug),e.time=p(k,k.time),e.timeEnd=p(k,k.timeEnd),e.info=p(k,k.info),e.warn=p(k,k.warn),e.error=p(k,k.error),e.log=e.info}(),i.setHandler=function(e){s=e},i.setLevel=function(e){k.setLevel(e);for(var t in l)l.hasOwnProperty(t)&&l[t].setLevel(e)},i.getLevel=function(){return k.getLevel()},i.get=function(e){return l[e]||(l[e]=new h(c({name:e},k.context)))},i.createDefaultHandler=function(e){e=e||{},e.formatter=e.formatter||function(e,t){t.name&&e.unshift("["+t.name+"]")};var t={},n=function(e,t){Function.prototype.apply.call(e,console,t)};return"undefined"==typeof console?function(){}:function(a,r){a=Array.prototype.slice.call(a);var o,s=console.log;r.level===i.TIME?(o=(r.name?"["+r.name+"] ":"")+a[0],"start"===a[1]?console.time?console.time(o):t[o]=(new Date).getTime():console.timeEnd?console.timeEnd(o):n(s,[o+": "+((new Date).getTime()-t[o])+"ms"])):(r.level===i.WARN&&console.warn?s=console.warn:r.level===i.ERROR&&console.error?s=console.error:r.level===i.INFO&&console.info?s=console.info:r.level===i.DEBUG&&console.debug&&(s=console.debug),e.formatter(a,r),n(s,a))}},i.useDefaults=function(e){i.setLevel(e&&e.defaultLevel||i.DEBUG),i.setHandler(i.createDefaultHandler(e))},a=i,void 0!==(r="function"==typeof a?a.call(t,n,t,e):a)&&(e.exports=r)}()},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var r=n(13),o=n(12),i=a(o),s=n(11),l=a(s),p=n(8),c=a(p),u=n(18),h=a(u),k=n(33),d=a(k),f=n(14),y=a(f),v=n(19),b=a(v),m=n(20),g=a(m),_=n(34),w=a(_),E=n(21),P=a(E),O=n(35),T=a(O),C=(0,r.combineReducers)({config:i.default,engine:l.default,shell:c.default,seekbar:h.default,volume:d.default,loading:y.default,share:b.default,cvaa:g.default,settings:w.default,overlayAction:P.default,backdrop:T.default});t.default=C},function(e,t){e.exports={controls:{play:"Play",pause:"Pause",share:"Share",language:"Language",settings:"Settings",fullscreen:"Fullscreen",rewind:"Rewind",vrStereo:"vrStereo",live:"Live",unmute:"Unmute",next:"Next",prev:"Prev",startOver:"Start over",pictureInPicture:"Picture in picture"},unmute:{unmute:"Unmute"},copy:{button:"Copy"},settings:{title:"Settings",quality:"Quality",speed:"Speed"},language:{title:"Language",audio:"Audio",captions:"Captions",advanced_captions_settings:"Advanced captions settings"},share:{title:"Share",embed_options:"Embed Options",start_video_at:"Start video at",email:"Share on Email",embed:"Get embed code"},overlay:{close:"Close"},error:{default_error:"Something went wrong",default_session_text:"Session ID",retry:"Retry"},ads:{ad_notice:"Advertisement",learn_more:"Learn more",skip_ad:"Skip ad",skip_in:"Skip in"},cvaa:{title:"Advanced captions settings",sample_caption_tag:"Sample",set_custom_caption:"Set custom caption",edit_caption:"Edit caption",size_label:"Size",font_color_label:"Font color",font_family_label:"Font family",font_style_label:"Font style",font_opacity_label:"Font opacity",background_color_label:"Background color",background_opacity_label:"Background opacity",apply:"Apply",caption_preview:"This is your caption preview"},cast:{play_on_tv:"Play on TV",disconnect_from_tv:"Disconnect from TV",status:{connecting_to:"Connecting to",connected_to:"Connected to",playing_on:"Playing on"}},playlist:{prev:"Previous",next:"Next",up_next:"Up Next",cancel:"Cancel"},pictureInPicture:{overlay_text:"Playing in Picture In Picture mode",overlay_button:"Play Here"}}},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.EngineConnector=void 0;var s,l,p=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),c=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a])}return e},u=n(0),h=n(2),k=n(7),d=n(11),f=a(d),y=n(14),v=n(8),b=n(3),m=a(b),g=(s=(0,h.connect)(f.default,(0,k.bindActions)(c({},d.actions,y.actions,v.actions))))(l=function(e){function t(e){return r(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,{name:"EngineConnector",player:e.player}))}return i(t,e),p(t,[{key:"componentDidMount",value:function(){var e=this,t=this.player.Track;this.props.updatePrePlayback(!this.player.config.playback.autoplay),this.eventManager.listen(this.player,this.player.Event.PLAYER_RESET,function(){e.props.updateCurrentTime(0),e.props.updateIsIdle(!0),e.props.updateIsPlaybackStarted(!1)}),this.eventManager.listen(this.player,this.player.Event.SOURCE_SELECTED,function(){e.props.updateIsVr(e.player.isVr()),e.props.updateIsInPictureInPicture(e.player.isInPictureInPicture()),e.player.config.playback.autoplay?e.props.updateLoadingSpinnerState(!0):e.props.updateLoadingSpinnerState(!1)}),this.eventManager.listen(this.player,this.player.Event.CHANGE_SOURCE_STARTED,function(){e.props.updatePrePlayback(!e.player.config.playback.autoplay&&!e.props.engine.isPlaybackStarted),e.props.updateIsChangingSource(!0),e.props.updateFallbackToMutedAutoPlay(!1),e.props.updateAdBreak(!1),e.props.updateAdIsPlaying(!1),e.props.updateIsPlaying(!1),e.props.updateIsEnded(!1),e.props.updateIsPlaybackEnded(!1),e.props.updateLastSeekPoint(0),e.props.updateIsPaused(!1),e.props.engine.isCasting&&e.props.updateLoadingSpinnerState(!0)}),this.eventManager.listen(this.player,this.player.Event.CHANGE_SOURCE_ENDED,function(){e.props.updateIsChangingSource(!1),e.props.updatePlayerPoster(e.player.poster),e.props.updateIsIdle(!1)}),this.eventManager.listen(this.player,this.player.Event.PLAYER_STATE_CHANGED,function(t){e.props.updatePlayerState(t.payload.oldState.type,t.payload.newState.type)}),this.eventManager.listen(this.player,this.player.Event.TIME_UPDATE,function(){e.props.updateCurrentTime(e.player.currentTime)}),this.eventManager.listen(this.player,this.player.Event.DURATION_CHANGE,function(){e.props.updateDuration(e.player.duration)}),this.eventManager.listen(this.player,this.player.Event.LOADED_DATA,function(){e.props.updateDuration(e.player.duration),e.props.updatePictureInPictureSupport(e.player.isPictureInPictureSupported())}),this.eventManager.listen(this.player,this.player.Event.LOADED_METADATA,function(){e.props.updateMuted(e.player.muted),e.props.updateMetadataLoadingStatus(!0),e.props.updateIsLive(e.player.isLive()),e.props.updateIsDvr(e.player.isDvr()),e.props.updatePlayerPoster(e.player.poster)}),this.eventManager.listen(this.player,this.player.Event.VOLUME_CHANGE,function(){e.props.updateVolume(e.player.volume)}),this.eventManager.listen(this.player,this.player.Event.MUTE_CHANGE,function(){e.props.updateMuted(e.player.muted),e.props.engine.fallbackToMutedAutoPlay&&e.props.updateFallbackToMutedAutoPlay(e.player.muted)}),this.eventManager.listen(this.player,this.player.Event.PLAYBACK_START,function(){e.props.updatePrePlayback(!1),e.props.updateIsPlaybackStarted(!0),e.props.updateLoadingSpinnerState(!0)}),this.eventManager.listen(this.player,this.player.Event.AUTOPLAY_FAILED,function(){e.props.updatePrePlayback(!0)}),this.eventManager.listen(this.player,this.player.Event.PLAY,function(){e.props.updateIsPlaying(!0),e.props.updateIsEnded(!1),e.props.updateIsPaused(!1),e.props.updateIsPlaybackEnded(!1)}),this.eventManager.listen(this.player,this.player.Event.PAUSE,function(){e.props.updateIsPlaying(!1),e.props.updateIsPaused(!0)}),this.eventManager.listen(this.player,this.player.Event.SEEKING,function(){e.props.updateIsSeeking(!0)}),this.eventManager.listen(this.player,this.player.Event.SEEKED,function(){e.props.updateIsSeeking(!1),e.props.updateLastSeekPoint(e.player.currentTime),e.props.updateIsPlaybackEnded(!1)}),this.eventManager.listen(this.player,this.player.Event.ENDED,function(){e.props.updateIsEnded(!0),e.props.updateIsPlaying(!1),e.props.updateIsPaused(!0)}),this.eventManager.listen(this.player,this.player.Event.PLAYBACK_ENDED,function(){e.props.updateIsPlaybackEnded(!0)}),this.eventManager.listen(this.player,this.player.Event.TRACKS_CHANGED,function(){var n=e.player.getTracks(t.AUDIO),a=e.player.getTracks(t.VIDEO),r=e.player.getTracks(t.TEXT);e.props.updateAudioTracks(n),e.props.updateVideoTracks(a),e.props.updateTextTracks(r)}),this.eventManager.listen(this.player,this.player.Event.TEXT_TRACK_CHANGED,function(){var n=e.player.getTracks(t.TEXT);e.props.updateTextTracks(n)}),this.eventManager.listen(this.player,this.player.Event.AUDIO_TRACK_CHANGED,function(){var n=e.player.getTracks(t.AUDIO);e.props.updateAudioTracks(n)}),this.eventManager.listen(this.player,this.player.Event.VIDEO_TRACK_CHANGED,function(){var n=e.player.getTracks(t.VIDEO);e.props.updateVideoTracks(n)}),this.eventManager.listen(this.player,this.player.Event.AD_BREAK_START,function(){e.props.updateHasError(!1),e.props.updateAdBreak(!0)}),this.eventManager.listen(this.player,this.player.Event.AD_BREAK_END,function(){e.props.updateAdBreak(!1)}),this.eventManager.listen(this.player,this.player.Event.ALL_ADS_COMPLETED,function(){e.props.updateAdBreak(!1)}),this.eventManager.listen(this.player,this.player.Event.AD_PROGRESS,function(t){var n=t.payload.adProgress.currentTime,a=t.payload.adProgress.duration;e.props.updateAdBreakProgress(n,a)}),this.eventManager.listen(this.player,this.player.Event.AD_COMPLETED,function(){e.props.updateAdBreakCompleted()}),this.eventManager.listen(this.player,this.player.Event.AD_STARTED,function(){e.props.updateLoadingSpinnerState(!1),e.props.updateAdIsPlaying(!0)}),this.eventManager.listen(this.player,this.player.Event.AD_RESUMED,function(){e.props.updateAdIsPlaying(!0)}),this.eventManager.listen(this.player,this.player.Event.AD_PAUSED,function(){e.props.updateAdIsPlaying(!1)}),this.eventManager.listen(this.player,this.player.Event.AD_ERROR,function(t){t.payload.severity===e.player.Error.Severity.CRITICAL&&e.props.updateAdBreak(!1)}),this.eventManager.listen(this.player,this.player.Event.FALLBACK_TO_MUTED_AUTOPLAY,function(){e.props.updateFallbackToMutedAutoPlay(!0)}),this.eventManager.listen(this.player,this.player.Event.AD_LOADED,function(t){var n=t.payload.ad;e.props.updateAdIsLinear(n.linear),e.props.updateAdClickUrl(n.clickThroughUrl),e.props.updateAdSkipTimeOffset(n.skipOffset),e.props.updateAdSkippableState(n.skippable)}),this.eventManager.listen(this.player,this.player.Event.VR_STEREO_MODE_CHANGED,function(t){e.props.updateVrStereoMode(t.payload.mode)}),this.eventManager.listen(this.player,this.player.Event.ERROR,function(t){t.payload.severity===e.player.Error.Severity.CRITICAL&&(e.props.updateIsIdle(!1),e.props.updateHasError(!0))}),this.eventManager.listen(this.player,this.player.Event.Cast.CAST_SESSION_STARTED,function(t){var n=t.payload.session;e.props.updateIsCasting(!0),e.props.updateCastSession(n),n.resuming&&e.props.updateLoadingSpinnerState(!1)}),this.eventManager.listen(this.player,this.player.Event.Cast.CAST_SESSION_ENDED,function(){e.props.updateIsCasting(!1),e.props.updateCastSession(null)}),this.eventManager.listen(this.player,this.player.Event.Cast.CAST_AVAILABLE,function(t){var n=t.payload.available;e.props.updateIsCastAvailable(n)}),this.eventManager.listen(this.player,this.player.Event.Playlist.PLAYLIST_ITEM_CHANGED,function(){e.props.updatePlaylist({next:e.player.playlist.next,prev:e.player.playlist.prev})}),this.eventManager.listen(this.player,this.player.Event.ENTER_PICTURE_IN_PICTURE,function(){e.props.updateIsInPictureInPicture(!0)}),this.eventManager.listen(this.player,this.player.Event.LEAVE_PICTURE_IN_PICTURE,function(){e.props.updateIsInPictureInPicture(!1)}),this.eventManager.listen(this.player,this.player.Event.PRESENTATION_MODE_CHANGED,function(){e.player.isInPictureInPicture()?e.props.updateIsInPictureInPicture(!0):e.props.updateIsInPictureInPicture(!1)}),this.eventManager.listen(this.player,this.player.Event.ENTER_FULLSCREEN,function(){e.props.updateFullscreen(!0)}),this.eventManager.listen(this.player,this.player.Event.EXIT_FULLSCREEN,function(){e.props.updateFullscreen(!1)})}},{key:"shouldComponentUpdate",value:function(){return!1}},{key:"render",value:function(){return(0,u.h)("span",null)}}]),t}(m.default))||l;t.EngineConnector=g},function(e,t,n){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function r(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.AudioSelectedEvent=void 0;var i=n(9),s=function(e){function t(e){a(this,t);var n=r(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,i.FakeEvent.Type.USER_SELECTED_AUDIO_TRACK));return n.payload={audioTrack:e},n}return o(t,e),t}(i.FakeEvent);t.AudioSelectedEvent=s},function(e,t,n){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function r(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.CaptionSelectedEvent=void 0;var i=n(9),s=function(e){function t(e){a(this,t);var n=r(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,i.FakeEvent.Type.USER_SELECTED_CAPTION_TRACK));return n.payload={captionTrack:e},n}return o(t,e),t}(i.FakeEvent);t.CaptionSelectedEvent=s},function(e,t,n){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function r(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.CaptionsStyleSelectedEvent=void 0;var i=n(9),s=function(e){function t(e){a(this,t);var n=r(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,i.FakeEvent.Type.USER_SELECTED_CAPTIONS_STYLE));return n.payload={captionsStyle:e},n}return o(t,e),t}(i.FakeEvent);t.CaptionsStyleSelectedEvent=s},function(e,t,n){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function r(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.QualitySelectedEvent=void 0;var i=n(9),s=function(e){function t(e){a(this,t);var n=r(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,i.FakeEvent.Type.USER_SELECTED_QUALITY_TRACK));return n.payload={qualityTrack:e},n}return o(t,e),t}(i.FakeEvent);t.QualitySelectedEvent=s},function(e,t,n){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function r(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.SeekedEvent=void 0;var i=n(9),s=function(e){function t(e,n){a(this,t);var o=r(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,i.FakeEvent.Type.USER_SEEKED));return o.payload={from:e,to:n},o}return o(t,e),t}(i.FakeEvent);t.SeekedEvent=s},function(e,t,n){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function r(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.SpeedSelectedEvent=void 0;var i=n(9),s=function(e){function t(e){a(this,t);var n=r(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,i.FakeEvent.Type.USER_SELECTED_SPEED));return n.payload={speed:e},n}return o(t,e),t}(i.FakeEvent);t.SpeedSelectedEvent=s},function(e,t,n){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function r(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.UIVisibilityChangedEvent=void 0;var i=n(9),s=function(e){function t(e){a(this,t);var n=r(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,i.FakeEvent.Type.UI_VISIBILITY_CHANGED));return n.payload={visible:e},n}return o(t,e),t}(i.FakeEvent);t.UIVisibilityChangedEvent=s},function(e,t,n){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function r(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.RewindClickedEvent=void 0;var i=n(9),s=function(e){function t(e,n){a(this,t);var o=r(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,i.FakeEvent.Type.USER_CLICKED_REWIND));return o.payload={from:e,to:n},o}return o(t,e),t}(i.FakeEvent);t.RewindClickedEvent=s},function(e,t,n){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function r(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.VolumeChangedEvent=void 0;var i=n(9),s=function(e){function t(e){a(this,t);var n=r(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,i.FakeEvent.Type.USER_CHANGED_VOLUME));return n.payload={volume:e},n}return o(t,e),t}(i.FakeEvent);t.VolumeChangedEvent=s},function(e,t,n){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.EventManager=void 0;var r=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),o=n(121),i=(n(9),function(){function e(){a(this,e),this._bindingMap=new o.MultiMap}return r(e,[{key:"destroy",value:function(){return this.removeAll(),this._bindingMap=null,Promise.resolve()}},{key:"listenOnce",value:function(e,t,n){var a=this,r=function r(o){a.unlisten(e,t,r),n.call(a,o)};this.listen(e,t,r)}},{key:"listen",value:function(e,t,n){var a=new s(e,t,n);this._bindingMap&&this._bindingMap.push(t,a)}},{key:"unlisten",value:function(e,t,n){if(this._bindingMap)for(var a=this._bindingMap.get(t),r=0;r<a.length;++r){var o=a[r];o.target!==e||o.listener!==n&&n||(o.unlisten(),this._bindingMap&&this._bindingMap.remove(t,o))}}},{key:"removeAll",value:function(){if(this._bindingMap){var e=this._bindingMap.getAll(),t=!0,n=!1,a=void 0;try{for(var r,o=e[Symbol.iterator]();!(t=(r=o.next()).done);t=!0){r.value.unlisten()}}catch(e){n=!0,a=e}finally{try{!t&&o.return&&o.return()}finally{if(n)throw a}}this._bindingMap&&this._bindingMap.clear()}}}]),e}()),s=function(){function e(t,n,r){a(this,e),this.target=t,this.type=n,this.listener=r,this.target.addEventListener(n,r,!1)}return r(e,[{key:"unlisten",value:function(){this.target&&(this.target.removeEventListener(this.type,this.listener,!1),this.target=null,this.listener=null)}}]),e}();t.EventManager=i},function(e,t,n){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var r=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),o=function(){function e(){a(this,e),this._map=new Map}return r(e,[{key:"push",value:function(e,t){if(this._map.has(e)){var n=this._map.get(e);Array.isArray(n)&&(n.push(t),this._map.set(e,n))}else this._map.set(e,[t])}},{key:"set",value:function(e,t){this._map.set(e,t)}},{key:"has",value:function(e){return this._map.has(e)}},{key:"get",value:function(e){var t=this._map.get(e);return t?t.slice():[]}},{key:"getAll",value:function(){var e=[],t=!0,n=!1,a=void 0;try{for(var r,o=this._map.values()[Symbol.iterator]();!(t=(r=o.next()).done);t=!0){var i=r.value;e=e.concat(i)}}catch(e){n=!0,a=e}finally{try{!t&&o.return&&o.return()}finally{if(n)throw a}}return e}},{key:"remove",value:function(e,t){if(this._map.has(e)){var n=this._map.get(e);if(Array.isArray(n))for(var a=0;a<n.length;++a)n[a]===t&&(n.splice(a,1),--a)}}},{key:"keys",value:function(){return this._map.keys()}},{key:"clear",value:function(){this._map.clear()}}]),e}();t.MultiMap=o},function(e,t,n){t=e.exports=n(123)(void 0),t.push([e.i,"@charset \"UTF-8\";\n.pakhshkit-row {\n  display: block; }\n  .pakhshkit-row:after {\n    content: '';\n    clear: both;\n    display: block; }\n\n.pakhshkit-d-inline-block {\n  display: inline-block; }\n\n.pakhshkit-mobile-hidden-select {\n  display: block;\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  left: 0px;\n  width: 100%;\n  height: 100%; }\n\n.pakhshkit-font-size-base, .pakhshkit-ad-notice {\n  font-size: 15px; }\n\n.pakhshkit-player .pakhshkit-form-group {\n  margin: 10px 0;\n  position: relative;\n  max-width: 100%; }\n  .pakhshkit-player .pakhshkit-form-group.pakhshkit-has-error .pakhshkit-form-control {\n    border-color: #db1f26; }\n    .pakhshkit-player .pakhshkit-form-group.pakhshkit-has-error .pakhshkit-form-control:focus {\n      border-color: #fff; }\n  .pakhshkit-player .pakhshkit-form-group.pakhshkit-has-icon .pakhshkit-form-control {\n    padding-left: 34px; }\n  .pakhshkit-player .pakhshkit-form-group .pakhshkit-icon {\n    position: absolute;\n    top: 2px;\n    left: 2px;\n    width: 32px;\n    height: 32px;\n    fill: rgba(255, 255, 255, 0.4); }\n\n.pakhshkit-player .pakhshkit-form-control {\n  height: 36px;\n  width: 100%;\n  min-width: 72px;\n  border: 2px solid rgba(255, 255, 255, 0.2);\n  border-radius: 4px;\n  background-color: rgba(0, 0, 0, 0.4);\n  font-size: 15px;\n  line-height: 18px;\n  color: #fff;\n  padding: 8px 10px;\n  text-overflow: ellipsis; }\n  .pakhshkit-player .pakhshkit-form-control::-webkit-input-placeholder {\n    color: rgba(255, 255, 255, 0.6); }\n  .pakhshkit-player .pakhshkit-form-control:focus {\n    background-color: #fff;\n    border-color: #fff;\n    color: #333; }\n    .pakhshkit-player .pakhshkit-form-control:focus::-webkit-input-placeholder {\n      color: #ccc; }\n    .pakhshkit-player .pakhshkit-form-control:focus + .pakhshkit-icon {\n      fill: #999; }\n\n.pakhshkit-player textarea.pakhshkit-form-control {\n  min-height: 72px; }\n\n.pakhshkit-player select {\n  font-size: 15px;\n  font-family: sans-serif;\n  color: #fff;\n  -webkit-appearance: none;\n  border: 0;\n  background: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='%23FFFFFF' viewBox='0 0 1024 1024'><path d='M301.255 338.745c-24.994-24.994-65.516-24.994-90.51 0s-24.994 65.516 0 90.51l256 256c24.994 24.994 65.516 24.994 90.51 0l256-256c24.994-24.994 24.994-65.516 0-90.51s-65.516-24.994-90.51 0l-210.745 210.745-210.745-210.745z' /></svg>\") no-repeat;\n  background-size: 16px;\n  background-position: 100% center;\n  background-repeat: no-repeat;\n  padding-right: 24px; }\n\n.pakhshkit-checkbox {\n  font-size: 15px;\n  position: relative; }\n  .pakhshkit-checkbox input {\n    display: none; }\n  .pakhshkit-checkbox label:before {\n    height: 16px;\n    width: 16px;\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    border-radius: 4px;\n    background-color: rgba(0, 0, 0, 0.4);\n    margin-right: 8px;\n    display: inline-block;\n    content: '';\n    vertical-align: middle; }\n  .pakhshkit-checkbox input:checked + label:before {\n    content: '\\2714'; }\n\n.pakhshkit-form-group-row {\n  font-size: 15px;\n  margin: 24px 0; }\n  .pakhshkit-form-group-row:after {\n    clear: both;\n    content: ' ';\n    display: block; }\n  .pakhshkit-form-group-row label {\n    float: left;\n    color: rgba(244, 244, 244, 0.8); }\n  .pakhshkit-form-group-row .pakhshkit-dropdown {\n    float: right; }\n\n.pakhshkit-btn {\n  text-decoration: none;\n  height: 36px;\n  border-radius: 18px;\n  color: #fff;\n  line-height: 36px;\n  font-weight: bold;\n  cursor: pointer;\n  display: inline-block;\n  padding: 0 24px; }\n  .pakhshkit-btn.pakhshkit-btn-block {\n    display: block; }\n  .pakhshkit-btn.pakhshkit-btn-dark-transparent {\n    background-color: rgba(0, 0, 0, 0.5);\n    border: 2px solid rgba(255, 255, 255, 0.2);\n    line-height: 32px; }\n    .pakhshkit-btn.pakhshkit-btn-dark-transparent:hover {\n      color: #fff;\n      border: 2px solid rgba(255, 255, 255, 0.4); }\n  .pakhshkit-btn.pakhshkit-btn-branded {\n    background-color: #01accd; }\n    .pakhshkit-btn.pakhshkit-btn-branded:hover {\n      color: #fff; }\n\n.pakhshkit-btn-rounded {\n  height: 36px;\n  width: 36px;\n  min-width: 36px;\n  min-height: 36px;\n  border-radius: 18px;\n  background-color: rgba(0, 0, 0, 0.4);\n  display: inline-block;\n  padding: 2px; }\n\n.pakhshkit-player button:focus {\n  outline: none; }\n\n.pakhshkit-icon {\n  display: inline-block;\n  font-size: 0;\n  width: 100%;\n  height: 100%;\n  margin: 0 auto;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: 50% 50%; }\n\n.pakhshkit-icon-maximize {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1024 1024' width='36' height='36'%3E%3Cpath fill='%23fff' d='M800 269.255v114.745c0 17.673 14.327 32 32 32s32-14.327 32-32v-192c0-17.673-14.327-32-32-32h-192c-17.673 0-32 14.327-32 32s14.327 32 32 32h114.745l-137.373 137.373c-12.497 12.497-12.497 32.758 0 45.255s32.758 12.497 45.255 0l137.373-137.373z' /%3E %3Cpath fill='%23fff' d='M224 754.745v-114.745c0-17.673-14.327-32-32-32s-32 14.327-32 32v192c0 17.673 14.327 32 32 32h192c17.673 0 32-14.327 32-32s-14.327-32-32-32h-114.745l137.373-137.373c12.497-12.497 12.497-32.758 0-45.255s-32.758-12.497-45.255 0l-137.373 137.373z' /%3E%3C/svg%3E\"); }\n\n.pakhshkit-icon-minimize {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1024 1024' width='36' height='36'%3E%3Cpath fill='%23fff' d='M672 306.745v-114.745c0-17.673-14.327-32-32-32s-32 14.327-32 32v192c0 17.673 14.327 32 32 32h192c17.673 0 32-14.327 32-32s-14.327-32-32-32h-114.745l137.373-137.373c12.497-12.497 12.497-32.758 0-45.255s-32.758-12.497-45.255 0l-137.373 137.373z' /%3E%3Cpath fill='%23fff' d='M352 717.255v114.745c0 17.673 14.327 32 32 32s32-14.327 32-32v-192c0-17.673-14.327-32-32-32h-192c-17.673 0-32 14.327-32 32s14.327 32 32 32h114.745l-137.373 137.373c-12.497 12.497-12.497 32.758 0 45.255s32.758 12.497 45.255 0l137.373-137.373z' /%3E%3C/svg%3E\"); }\n\n.pakhshkit-icon-play {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1024 1024' width='36' height='36'%3E%3Cpath fill='%23fff' d='M796.806 461.202c44.919 28.075 44.739 73.706 0 101.668l-459.472 287.171c-44.919 28.075-81.334 7.915-81.334-45.305v-585.4c0-53.096 36.595-73.266 81.334-45.305l459.472 287.171z' /%3E%3C/svg%3E\"); }\n\n.pakhshkit-icon-pause {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1024 1024' width='36' height='36'%3E%3Cpath fill='%23fff' d='M256 287.843c0-35.259 28.407-63.843 64-63.843 35.346 0 64 28.564 64 63.843v448.314c0 35.259-28.407 63.843-64 63.843-35.346 0-64-28.564-64-63.843v-448.314zM640 287.843c0-35.259 28.407-63.843 64-63.843 35.346 0 64 28.564 64 63.843v448.314c0 35.259-28.407 63.843-64 63.843-35.346 0-64-28.564-64-63.843v-448.314z' /%3E%3C/svg%3E\"); }\n\n.pakhshkit-icon-volume-base {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1024 1024' width='36' height='36'%3E%3Cpath fill='%23fff' d='M128 416v192h96v-192h-96zM64 383.853c0-17.592 14.012-31.853 32.094-31.853h159.813c17.725 0 32.094 14.581 32.094 31.853v256.295c0 17.592-14.012 31.853-32.094 31.853h-159.813c-17.725 0-32.094-14.581-32.094-31.853v-256.295z' /%3E%3Cpath fill='%23fff' d='M288 634.342l160 88.889v-422.462l-160 88.889v244.684zM224 352l231.787-128.771c31.046-17.248 56.213-2.487 56.213 32.476v512.589c0 35.184-25.054 49.786-56.213 32.476l-231.787-128.771v-320z' /%3E%3C/svg%3E\"); }\n\n.pakhshkit-icon-volume-waves {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1024 1024' width='36' height='36'%3E%3Cpath fill='%23fff' d='M802.017 837.177c82.359-86.627 129.183-201.774 129.183-324.26 0-123.976-47.976-240.409-132.127-327.329-12.293-12.697-32.552-13.025-45.249-0.732s-13.025 32.552-0.732 45.249c72.692 75.084 114.109 175.597 114.109 282.812 0 105.928-40.422 205.331-111.566 280.162-12.177 12.808-11.666 33.063 1.143 45.24s33.063 11.666 45.24-1.143z' /%3E%3Cpath fill='%23fff' d='M667.436 743.221c67.761-60.884 107.273-147.888 107.273-241.233 0-87.318-34.552-169.203-94.836-229.446-12.501-12.493-32.762-12.486-45.255 0.015s-12.486 32.762 0.015 45.255c48.375 48.342 76.075 113.989 76.075 184.176 0 75.021-31.679 144.776-86.048 193.627-13.146 11.812-14.227 32.044-2.416 45.19s32.044 14.227 45.19 2.416z' /%3E%3C/svg%3E\"); }\n\n.pakhshkit-icon-volume-wave {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1024 1024' width='36' height='36'%3E%3Cpath fill='%23fff' d='M667.436 743.221c67.761-60.884 107.273-147.888 107.273-241.233 0-87.318-34.552-169.203-94.836-229.446-12.501-12.493-32.762-12.486-45.255 0.015s-12.486 32.762 0.015 45.255c48.375 48.342 76.075 113.989 76.075 184.176 0 75.021-31.679 144.776-86.048 193.627-13.146 11.812-14.227 32.044-2.416 45.19s32.044 14.227 45.19 2.416z'/%3E%3C/svg%3E\"); }\n\n.pakhshkit-icon-volume-mute {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1024 1024' width='36' height='36'%3E%3Cpath fill='%23fff' d='M768 466.745l-67.986-67.986c-12.213-12.213-32.654-12.393-45.151 0.104-12.584 12.584-12.543 32.711-0.104 45.151l67.986 67.986-67.986 67.986c-12.213 12.213-12.393 32.654 0.104 45.151 12.584 12.584 32.711 12.543 45.151 0.104l67.986-67.986 67.986 67.986c12.213 12.213 32.654 12.393 45.151-0.104 12.584-12.584 12.543-32.711 0.104-45.151l-67.986-67.986 67.986-67.986c12.213-12.213 12.393-32.654-0.104-45.151-12.584-12.584-32.711-12.543-45.151-0.104l-67.986 67.986z' /%3E%3C/svg%3E\"); }\n\n.pakhshkit-icon-close {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1024 1024' width='36' height='36'%3E%3Cpath fill='%23fff' d='M573.162 512l214.269-214.269c16.772-16.772 16.688-44.071-0.202-60.96-17.007-17.007-44.182-16.98-60.96-0.202l-214.269 214.269-214.269-214.269c-16.772-16.772-44.071-16.688-60.96 0.202-17.007 17.007-16.98 44.182-0.202 60.96l214.269 214.269-214.269 214.269c-16.772 16.772-16.688 44.071 0.202 60.96 17.007 17.007 44.182 16.98 60.96 0.202l214.269-214.269 214.269 214.269c16.772 16.772 44.071 16.688 60.96-0.202 17.007-17.007 16.98-44.182 0.202-60.96l-214.269-214.269z' /%3E%3C/svg%3E\"); }\n\n.pakhshkit-icon-share {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1024 1024' width='36' height='36'%3E%3Cpath fill='%23fff' d='M318.641 446.219l236.155-142.257c-0.086-1.754-0.129-3.52-0.129-5.295 0-58.91 47.756-106.667 106.667-106.667s106.667 47.756 106.667 106.667c0 58.91-47.756 106.667-106.667 106.667-33.894 0-64.095-15.808-83.633-40.454l-236.467 142.445c-0.132-3.064-0.394-6.095-0.779-9.087l7.271-12.835-0.117 53.333-7.183-12.743c0.399-3.046 0.67-6.131 0.806-9.252l236.467 142.383c19.538-24.648 49.741-40.457 83.636-40.457 58.91 0 106.667 47.756 106.667 106.667s-47.756 106.667-106.667 106.667c-58.91 0-106.667-47.756-106.667-106.667 0-1.775 0.043-3.539 0.129-5.293l-236.19-142.216c-19.528 24.867-49.868 40.841-83.939 40.841-58.91 0-106.667-47.756-106.667-106.667s47.756-106.667 106.667-106.667c34.091 0 64.447 15.993 83.974 40.886zM234.667 554.667c23.564 0 42.667-19.103 42.667-42.667s-19.103-42.667-42.667-42.667c-23.564 0-42.667 19.103-42.667 42.667s19.103 42.667 42.667 42.667zM661.333 341.333c23.564 0 42.667-19.103 42.667-42.667s-19.103-42.667-42.667-42.667c-23.564 0-42.667 19.103-42.667 42.667s19.103 42.667 42.667 42.667zM661.333 768c23.564 0 42.667-19.103 42.667-42.667s-19.103-42.667-42.667-42.667c-23.564 0-42.667 19.103-42.667 42.667s19.103 42.667 42.667 42.667z' /%3E%3C/svg%3E\"); }\n\n.pakhshkit-icon-settings {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1024 1024' width='36' height='36'%3E%3Cpath fill='%23fff' d='M803.451 546.033c2.552-22.107 2.552-44.408 0.246-64.81-1.084-6.208-6.499-10.721-12.535-10.671-30.286 0.533-57.727-17.773-68.866-45.941s-3.64-60.291 18.795-80.593c3.935-3.569 4.416-9.583 0.92-13.959-13.595-17.35-29.146-33.073-46.311-46.83-4.23-3.38-10.359-2.886-14.783 1.966-14.421 14.721-34.212 22.938-54.434 22.761-9.009 0.041-17.942-1.652-26.865-5.212-28.414-11.992-46.226-40.546-44.49-71.542 0.335-5.319-3.547-9.972-8.785-10.588-21.926-2.538-44.068-2.595-65.961-0.176-5.349 0.6-9.341 5.207-9.175 10.514 1.027 30.384-16.802 58.251-45.764 70.431-8.238 3.138-16.993 4.701-25.207 4.609-20.599 0.206-40.395-7.982-55.482-23.363-2.014-2.187-4.849-3.435-7.553-3.445-2.441 0.015-4.811 0.83-6.513 2.139-17.541 13.798-33.455 29.547-47.262 46.729-3.418 4.337-2.922 10.575 0.97 14.162 22.816 20.692 30.19 53.479 17.807 83.351-13.035 27.396-41.135 44.394-71.446 43.222-5.112-0.197-9.499 3.606-10.086 9.179-2.673 22.023-2.673 44.289-0.212 64.867 1.080 6.27 6.559 10.824 13.309 10.737l2.225 0.006c28.935 0.604 54.726 18.391 65.634 45.374 11.22 28.205 3.921 60.407-18.565 81.204-3.866 3.509-4.341 9.418-0.895 13.742 13.545 17.354 29.027 33.106 46.042 46.867 4.303 3.449 10.547 2.954 14.986-1.907 14.414-14.76 34.226-23.001 54.43-22.82 9.070-0.052 18.063 1.668 27.041 5.299 28.19 12.071 45.891 40.41 44.347 71.468-0.342 5.312 3.536 9.962 8.802 10.578 21.915 2.548 44.049 2.605 65.929 0.176 5.364-0.604 9.364-5.227 9.191-10.598-0.997-30.358 16.84-58.183 45.452-70.201 8.263-3.256 17.070-4.908 25.521-4.865 20.676-0.206 40.533 8.070 55.398 23.38 2.039 2.195 4.898 3.446 7.673 3.455 2.268-0.011 4.468-0.776 6.321-2.228 17.625-13.724 33.599-29.444 47.415-46.611 3.426-4.348 2.928-10.6-0.863-14.097-22.358-20.082-30.057-51.85-19.372-79.939s37.55-46.71 67.745-46.857h5.229c5.12-0.026 9.413-3.875 9.996-8.962zM861.733 552.735c-3.961 34.572-33.157 60.748-68.129 60.926h-5.235c-5.803 0.028-10.991 3.624-13.054 9.048s-0.577 11.558 4.020 15.69c26.602 24.519 29.853 65.381 7.275 94.034-16.847 20.934-36.063 39.845-57.197 56.302-12.034 9.427-26.861 14.584-42.368 14.658-19.254-0.051-37.623-8.090-50.269-21.718-3.221-3.315-7.66-5.165-12.712-5.118-1.425-0.007-2.839 0.258-3.554 0.532-5.581 2.346-9.136 7.892-8.937 13.966 1.152 35.958-25.509 66.771-61.307 70.804-26.332 2.923-52.909 2.854-79.246-0.208-36.286-4.245-62.897-36.157-60.576-72.186 0.304-6.123-3.235-11.788-8.302-13.964-1.328-0.536-2.748-0.808-4.606-0.8-4.651-0.041-9.118 1.817-11.635 4.367-24.544 27.036-65.886 30.311-94.481 7.394-20.587-16.65-39.207-35.595-55.308-56.226-22.552-28.277-19.261-69.208 7.317-93.334 4.474-4.138 5.939-10.604 3.748-16.115-2.052-5.076-6.932-8.442-11.794-8.55-36.436 0.464-66.759-24.741-72.949-60.89-3.243-26.718-3.243-53.731-0.055-79.964 3.744-35.827 34.642-62.605 70.642-61.219 6.877 0.266 13.251-3.59 15.584-8.401 2.309-5.59 0.861-12.028-3.789-16.247-26.603-24.51-29.856-65.368-7.293-93.994 16.767-20.868 35.856-39.76 57.129-56.491 12.099-9.322 26.921-14.42 42.463-14.513 19.308 0.059 37.717 8.166 50.145 21.684 3.263 3.322 7.737 5.172 12.994 5.126 1.471 0.015 2.933-0.245 3.363-0.39 5.601-2.359 9.165-7.93 8.957-14.077-1.126-35.941 25.542-66.721 61.322-70.731 26.322-2.909 52.889-2.84 79.251 0.212 36.244 4.265 62.828 36.125 60.546 72.343-0.339 6.047 3.159 11.654 8.186 13.782 1.381 0.55 2.855 0.829 4.726 0.823 4.663 0.040 9.142-1.819 11.615-4.312 24.439-26.99 65.656-30.312 94.137-7.557 20.721 16.607 39.456 35.549 55.655 56.225 22.667 28.35 19.38 69.439-7.531 93.846-4.33 3.918-5.776 10.112-3.628 15.542s7.438 8.96 13.543 8.854c34.999-0.298 65.076 24.766 71.337 60.925 3.065 26.552 3.065 53.368 0 79.92zM511.956 589.951c43.215-0.108 78.137-35.17 78.072-78.385 0-31.732-19.132-60.334-48.461-72.448s-63.068-5.35-85.461 17.133c-22.393 22.483-29.022 56.249-16.791 85.529s40.909 48.298 72.641 48.171zM512.146 648.617c-55.438 0.221-105.58-33.029-126.965-84.224s-9.796-110.233 29.358-149.543c39.153-39.31 98.144-51.136 149.424-29.956s84.731 71.189 84.732 126.627c0.114 75.549-60.999 136.907-136.548 137.096z' /%3E%3C/svg%3E\"); }\n\n.pakhshkit-icon-check {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1024 1024' width='36' height='36'%3E%3Cpath fill='%23fff' d='M342.481 563.894c-12.577-12.416-32.838-12.285-45.254 0.292s-12.285 32.838 0.292 45.254l118.857 117.333c13.275 13.105 34.901 12.123 46.933-2.131l297.143-352c11.4-13.505 9.694-33.694-3.811-45.094s-33.694-9.694-45.094 3.811l-274.828 325.566-94.238-93.030z' /%3E%3C/svg%3E\"); }\n\n.pakhshkit-icon-language {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1024 1024' width='36' height='36'%3E%3Cpath fill='%23fff' d='M512 800c159.058 0 288-128.942 288-288s-128.942-288-288-288c-159.058 0-288 128.942-288 288s128.942 288 288 288zM512 864c-194.404 0-352-157.596-352-352s157.596-352 352-352c194.404 0 352 157.596 352 352s-157.596 352-352 352z' /%3E%3Cpath fill='%23fff' d='M441.231 173.324c-76.632 84.62-121.231 207.208-121.231 338.676 0 134.304 46.556 259.282 126.083 343.936l46.646-43.82c-68.041-72.429-108.728-181.651-108.728-300.116 0-116.001 39.001-223.203 104.669-295.716l-47.438-42.96z' /%3E%3Cpath fill='%23fff' d='M584.297 173.324c76.632 84.62 121.231 207.208 121.231 338.676 0 134.304-46.556 259.282-126.083 343.936l-46.646-43.82c68.041-72.429 108.728-181.651 108.728-300.116 0-116.001-39.001-223.203-104.669-295.716l47.438-42.96z' /%3E%3Cpath fill='%23fff' d='M840.432 419.786c-81.65-22.637-200.551-35.786-328.432-35.786-128.056 0-247.103 13.185-328.758 35.876l17.136 61.663c75.47-20.972 188.938-33.539 311.622-33.539 122.521 0 235.854 12.533 311.334 33.459l17.099-61.674z' /%3E%3Cpath fill='%23fff' d='M840.432 605.754c-81.65 22.637-200.551 35.786-328.432 35.786-128.056 0-247.103-13.185-328.758-35.876l17.136-61.663c75.47 20.972 188.938 33.539 311.622 33.539 122.521 0 235.854-12.533 311.334-33.459l17.099 61.674z' /%3E%3Cpath fill='%23fff' d='M480 192h64v640h-64v-640z' /%3E%3C/svg%3E\"); }\n\n.pakhshkit-icon-quality {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1024 1024' width='36' height='36'%3E%3Cpath fill='%23fff' d='M159.904 192h288.234c17.277 0 31.862 14.323 31.862 31.992 0 17.792-14.261 31.993-31.853 31.994l-288.147 0.014v544.174c-0.017-0.18 704-0.174 704-0.174v-128.006c0-17.795 14.327-31.994 32-31.994 17.796 0 32 14.34 32 32.029v128.145c0 35.25-28.639 63.826-63.904 63.826h-704.192c-35.293 0-63.904-28.875-63.904-63.826v-544.348c0-35.25 28.639-63.826 63.904-63.826zM501.818 378.182c108.449 0 196.364-87.915 196.364-196.364 0-29.091 43.636-29.091 43.636 0 0 108.449 87.915 196.364 196.364 196.364 29.091 0 29.091 43.636 0 43.636-108.449 0-196.364 87.915-196.364 196.364 0 29.091-43.636 29.091-43.636 0 0-108.449-87.915-196.364-196.364-196.364-29.091 0-29.091-43.636 0-43.636z' /%3E%3C/svg%3E\"); }\n\n.pakhshkit-icon-captions {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1024 1024' width='36' height='36'%3E%3Cpath fill='%23fff' d='M160 771.213c-0.017-0.172 704-0.166 704-0.166v-518.261c0.017 0.172-704 0.166-704 0.166v518.261zM96 252.787c0-33.572 28.639-60.787 63.904-60.787h704.192c35.293 0 63.904 27.5 63.904 60.787v518.427c0 33.572-28.639 60.787-63.904 60.787h-704.192c-35.293 0-63.904-27.5-63.904-60.787v-518.427z' /%3E%3Cpath fill='%23fff' d='M490.583 568.655c0 7.729-2.311 15.987-6.933 24.777s-11.668 17.162-21.14 25.118c-9.471 7.956-21.405 14.358-35.801 19.208s-30.611 7.274-48.644 7.274c-38.34 0-68.268-11.176-89.787-33.528s-32.278-52.319-32.278-89.901c0-25.459 4.925-47.962 14.775-67.511s24.095-34.665 42.734-45.348c18.639-10.684 40.916-16.025 66.829-16.025 16.063 0 30.8 2.349 44.212 7.047s24.777 10.759 34.096 18.185c9.32 7.425 16.442 15.343 21.367 23.754s7.388 16.253 7.388 23.527c0 7.425-2.766 13.714-8.297 18.867s-12.237 7.729-20.117 7.729c-5.152 0-9.433-1.326-12.843-3.978s-7.236-6.933-11.479-12.843c-7.577-11.517-15.495-20.155-23.754-25.913s-18.753-8.638-31.482-8.638c-18.336 0-33.111 7.16-44.325 21.481s-16.821 33.907-16.821 58.759c0 11.669 1.44 22.39 4.319 32.164s7.047 18.109 12.502 25.004c5.455 6.895 12.047 12.123 19.776 15.684s16.215 5.342 25.459 5.342c12.426 0 23.072-2.879 31.937-8.638s16.707-14.548 23.527-26.368c3.789-6.971 7.88-12.426 12.275-16.366s9.774-5.91 16.139-5.91c7.577 0 13.866 2.879 18.867 8.638s7.501 11.896 7.501 18.412zM767.219 568.655c0 7.729-2.311 15.987-6.933 24.777s-11.668 17.162-21.14 25.118c-9.471 7.956-21.405 14.358-35.801 19.208s-30.611 7.274-48.644 7.274c-38.34 0-68.268-11.176-89.787-33.528s-32.278-52.319-32.278-89.901c0-25.459 4.925-47.962 14.775-67.511s24.095-34.665 42.734-45.348c18.639-10.684 40.916-16.025 66.829-16.025 16.063 0 30.8 2.349 44.212 7.047s24.777 10.759 34.096 18.185c9.32 7.425 16.442 15.343 21.367 23.754s7.388 16.253 7.388 23.527c0 7.425-2.766 13.714-8.297 18.867s-12.237 7.729-20.117 7.729c-5.152 0-9.433-1.326-12.843-3.978s-7.236-6.933-11.479-12.843c-7.577-11.517-15.495-20.155-23.754-25.913s-18.753-8.638-31.482-8.638c-18.336 0-33.111 7.16-44.325 21.481s-16.821 33.907-16.821 58.759c0 11.669 1.44 22.39 4.319 32.164s7.047 18.109 12.502 25.004c5.455 6.895 12.047 12.123 19.776 15.684s16.215 5.342 25.459 5.342c12.426 0 23.072-2.879 31.937-8.638s16.707-14.548 23.527-26.368c3.789-6.971 7.88-12.426 12.275-16.366s9.774-5.91 16.139-5.91c7.577 0 13.866 2.879 18.867 8.638s7.501 11.896 7.501 18.412z' /%3E%3C/svg%3E\"); }\n\n.pakhshkit-icon-speed {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1024 1024' width='36' height='36'%3E%3Cpath fill='%23fff' d='M512 832c35.346 0 64-28.654 64-64s-28.654-64-64-64c-35.346 0-64 28.654-64 64s28.654 64 64 64zM480.239 643.971c-0.158-1.272-0.239-2.566-0.239-3.876v-192.19c0-17.621 14.204-31.905 32-31.905 17.673 0 32 14.497 32 31.905v192.19c0 1.313-0.079 2.607-0.232 3.878 55.325 14.128 96.232 64.301 96.232 124.027 0 70.692-57.308 128-128 128s-128-57.308-128-128c0-59.729 40.91-109.903 96.239-124.029zM928 576c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-194.404-157.596-352-352-352s-352 157.596-352 352c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-229.75 186.25-416 416-416s416 186.25 416 416z' /%3E%3C/svg%3E\"); }\n\n.pakhshkit-icon-speed-down {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1024 1024' width='36' height='36'%3E%3Cpath fill='%23fff' d='M512 800c35.346 0 64-28.654 64-64s-28.654-64-64-64c-35.346 0-64 28.654-64 64s28.654 64 64 64zM401.852 670.758c-1.056-0.826-2.077-1.728-3.055-2.706l-113.005-113.005c-12.533-12.533-12.65-32.737-0.066-45.321 12.497-12.497 32.536-12.719 45.321 0.066l113.005 113.005c0.976 0.976 1.876 1.998 2.701 3.059 19.106-11.343 41.416-17.855 65.248-17.855 70.692 0 128 57.308 128 128s-57.308 128-128 128c-70.692 0-128-57.308-128-128 0-23.829 6.511-46.137 17.852-65.242zM928 576c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-194.404-157.596-352-352-352s-352 157.596-352 352c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-229.75 186.25-416 416-416s416 186.25 416 416z'/%3E%3C/svg%3E\"); }\n\n.pakhshkit-icon-speed-up {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1024 1024' width='36' height='36'%3E%3Cpath fill='%23fff' d='M512 800c35.346 0 64-28.654 64-64s-28.654-64-64-64c-35.346 0-64 28.654-64 64s28.654 64 64 64zM546.516 612.708c0.524-1.23 1.129-2.446 1.819-3.64l79.906-138.402c8.862-15.35 28.348-20.692 43.76-11.794 15.305 8.837 20.707 28.135 11.666 43.794l-79.906 138.402c-0.693 1.201-1.451 2.34-2.268 3.416 23.761 23.238 38.508 55.655 38.508 91.516 0 70.692-57.308 128-128 128s-128-57.308-128-128c0-70.692 57.308-128 128-128 11.959 0 23.535 1.64 34.516 4.708zM928 576c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-194.404-157.596-352-352-352s-352 157.596-352 352c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-229.75 186.25-416 416-416s416 186.25 416 416z'/%3E%3C/svg%3E\"); }\n\n.pakhshkit-icon-audio {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1024 1024' width='36' height='36'%3E%3Cpath fill='%23fff' d='M768 625.124v-354.531l-352 135.385v330.022c0 70.692-57.308 128-128 128s-128-57.308-128-128c0-70.692 57.308-128 128-128 23.314 0 45.173 6.233 64 17.124v-241.124c0-13.241 8.155-25.114 20.513-29.867l416-160c20.96-8.062 43.487 7.41 43.487 29.867v512c0 70.692-57.308 128-128 128s-128-57.308-128-128c0-70.692 57.308-128 128-128 23.314 0 45.173 6.233 64 17.124zM288 800c35.346 0 64-28.654 64-64s-28.654-64-64-64c-35.346 0-64 28.654-64 64s28.654 64 64 64zM704 800c35.346 0 64-28.654 64-64s-28.654-64-64-64c-35.346 0-64 28.654-64 64s28.654 64 64 64z' /%3E%3C/svg%3E\"); }\n\n.pakhshkit-icon-copy {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1024 1024' width='36' height='36'%3E%3Cpath fill='%23fff' d='M703.727 320c35.497 0 64.273 28.482 64.273 64.003v351.993c0 35.348-28.862 64.003-64.273 64.003h-191.454c-35.496 0-64.271-28.48-64.273-64.001l255.727 0.001v-352c0 0-28.356 0.147-63.727 0.001v-63.912l63.727-0.088zM256 288.187c0-35.45 28.398-64.187 63.988-64.187h192.025c35.339 0 63.988 28.706 63.988 64.187v319.625c0 35.45-28.398 64.187-63.988 64.187h-192.025c-35.339 0-63.988-28.706-63.988-64.187v-319.625zM320 288v320h192v-320h-192z' /%3E%3C/svg%3E\"); }\n\n.pakhshkit-icon-facebook {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1024 1024' width='36' height='36'%3E%3Cpath fill='%23fff' d='M432 405.333h-80v106.667h80v320h133.333v-320h97.12l9.547-106.667h-106.667v-44.453c0-25.467 5.12-35.547 29.733-35.547h76.933v-133.333h-101.547c-95.893 0-138.453 42.213-138.453 123.067v90.267z' /%3E%3C/svg%3E\"); }\n\n.pakhshkit-icon-twitter {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1024 1024' width='36' height='36'%3E%3Cpath fill='%23fff' d='M832 316.614c-23.547 10.29-48.853 17.221-75.413 20.345 27.12-15.987 47.947-41.319 57.733-71.508-25.36 14.806-53.467 25.568-83.387 31.37-23.92-25.122-58.080-40.82-95.84-40.82-84.773 0-147.067 77.861-127.92 158.687-109.093-5.381-205.84-56.833-270.613-135.035-34.4 58.094-17.84 134.090 40.613 172.574-21.493-0.683-41.76-6.484-59.44-16.171-1.44 59.879 42.16 115.898 105.307 128.368-18.48 4.935-38.72 6.090-59.307 2.205 16.693 51.347 65.173 88.702 122.667 89.752-55.2 42.605-124.747 61.637-194.4 53.552 58.107 36.673 127.147 58.067 201.28 58.067 243.787 0 381.52-202.684 373.2-384.473 25.653-18.244 47.92-41.004 65.52-66.914v0z' /%3E%3C/svg%3E\"); }\n\n.pakhshkit-icon-linkedin {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1024 1024' width='36' height='36'%3E%3Cpath fill='%23fff' d='M324.8 290.087c0 36.506-29.6 66.087-66.133 66.087s-66.133-29.581-66.133-66.087c0-36.48 29.6-66.087 66.133-66.087s66.133 29.607 66.133 66.087zM325.333 409.043h-133.333v422.957h133.333v-422.957zM538.187 409.043h-132.48v422.957h132.507v-222.026c0-123.45 160.773-133.549 160.773 0v222.026h133.013v-267.811c0-208.306-237.92-200.719-293.813-98.179v-56.967z' /%3E%3C/svg%3E\"); }\n\n.pakhshkit-icon-email {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1024 1024' width='36' height='36'%3E%3Cpath fill='%23fff' d='M256 768c-35.346 0-64-28.654-64-64v-352c0-35.346 28.654-64 64-64h512c35.346 0 64 28.654 64 64v352c0 35.346-28.654 64-64 64h-512zM512 467.488l147.52-115.488h-295.040l147.52 115.488zM748.48 352l-211.2 179.2c-0.713 1.308-1.572 2.532-2.56 3.648-12.707 12.158-32.733 12.158-45.44 0-0.988-1.116-1.847-2.34-2.56-3.648l-211.2-179.2h-19.52v352h512v-352h-19.52z' /%3E%3C/svg%3E\"); }\n\n.pakhshkit-icon-embed {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1024 1024' width='36' height='36'%3E%3Cpath fill='%23fff' d='M377.989 579.335c12.669 12.904 12.669 33.777 0 46.68-12.733 12.969-33.427 12.969-46.16 0l-104.727-106.667c-12.669-12.904-12.669-33.777 0-46.68l104.727-106.667c12.733-12.969 33.427-12.969 46.16 0 12.669 12.904 12.669 33.777 0 46.68l-81.812 83.327 81.812 83.327zM646.011 412.68c-12.669-12.904-12.669-33.777 0-46.68 12.733-12.969 33.427-12.969 46.16 0l104.727 106.667c12.669 12.904 12.669 33.777 0 46.68l-104.727 106.667c-12.733 12.969-33.427 12.969-46.16 0-12.669-12.904-12.669-33.777 0-46.68l81.812-83.327-81.812-83.327zM572.293 250.6c17.455 4.445 28.025 22.388 23.686 40.066l-104.727 426.669c-4.349 17.719-22.048 28.535-39.545 24.079-17.455-4.445-28.025-22.388-23.686-40.066l104.727-426.669c4.349-17.719 22.048-28.535 39.545-24.079z' /%3E%3C/svg%3E\"); }\n\n.pakhshkit-icon-link {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1024 1024' width='36' height='36'%3E%3Cpath fill='%23fff' d='M355.028 445.537c12.497 12.497 12.497 32.758 0 45.255s-32.758 12.497-45.255 0l-24.141-24.141c-49.92-49.92-49.832-130.999 0.094-180.925 49.984-49.984 130.995-50.025 180.955-0.064l113.266 113.266c49.964 49.964 49.935 130.955-0.064 180.955-12.497 12.497-32.758 12.497-45.255 0s-12.497-32.758 0-45.255c25.013-25.013 25.027-65.482 0.064-90.445l-113.266-113.266c-24.957-24.957-65.445-24.936-90.445 0.064-24.955 24.955-24.998 65.511-0.094 90.416l24.141 24.141zM668.972 578.463c-12.497-12.497-12.497-32.758 0-45.255s32.758-12.497 45.255 0l24.141 24.141c49.92 49.92 49.832 130.999-0.094 180.925-49.984 49.984-130.995 50.025-180.955 0.064l-113.266-113.266c-49.964-49.964-49.935-130.955 0.064-180.955 12.497-12.497 32.758-12.497 45.255 0s12.497 32.758 0 45.255c-25.013 25.013-25.027 65.482-0.064 90.445l113.266 113.266c24.957 24.957 65.445 24.936 90.445-0.064 24.955-24.955 24.998-65.511 0.094-90.416l-24.141-24.141z' /%3E%3C/svg%3E\"); }\n\n.pakhshkit-icon-arrow-down {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1024 1024' width='36' height='36'%3E%3Cpath fill='%23fff' d='M301.255 338.745c-24.994-24.994-65.516-24.994-90.51 0s-24.994 65.516 0 90.51l256 256c24.994 24.994 65.516 24.994 90.51 0l256-256c24.994-24.994 24.994-65.516 0-90.51s-65.516-24.994-90.51 0l-210.745 210.745-210.745-210.745z' /%3E%3C/svg%3E\"); }\n\n.pakhshkit-icon-start-over {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1024 1024' width='36' height='36'%3E%3Cpath fill='%23fff' d='M255.271 339.053c94.182-126.513 270.298-165.203 410.222-84.418 150.758 87.040 202.411 279.813 115.371 430.571s-279.813 202.411-430.571 115.371c-61.424-35.463-107.948-89.4-134.169-153.673-7.677-18.818-29.156-27.85-47.974-20.173s-27.85 29.156-20.173 47.974c32.339 79.269 89.818 145.906 165.517 189.611 185.96 107.364 423.747 43.649 531.111-142.311s43.649-423.747-142.311-531.111c-172.433-99.554-389.428-52.014-505.682 103.69l-27.226-78.49c-6.66-19.202-27.626-29.368-46.828-22.708s-29.368 27.626-22.708 46.828l52.434 151.164c5.36 15.452 20.275 25.513 36.61 24.694l159.799-8.011c20.299-1.018 35.929-18.298 34.911-38.596s-18.298-35.929-38.596-34.911l-89.738 4.499z' /%3E%3C/svg%3E\"); }\n\n.pakhshkit-icon-seek-forward {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1024 1024' width='36' height='36'%3E%3Cpath fill='%23fff' opacity='0.5' d='M765.529 323.053c-94.182-126.513-270.298-165.203-410.222-84.418-150.758 87.040-202.411 279.813-115.371 430.571s279.813 202.411 430.571 115.371c61.424-35.463 107.948-89.4 134.169-153.673 7.677-18.818 29.156-27.85 47.974-20.173s27.85 29.156 20.173 47.974c-32.339 79.269-89.818 145.906-165.517 189.611-185.96 107.364-423.747 43.649-531.111-142.311s-43.649-423.747 142.311-531.111c172.433-99.554 389.428-52.014 505.682 103.69l27.226-78.49c6.66-19.202 27.626-29.368 46.828-22.708s29.368 27.626 22.708 46.828l-52.434 151.164c-5.36 15.452-20.275 25.513-36.61 24.694l-159.799-8.011c-20.299-1.018-35.929-18.298-34.911-38.596s18.298-35.929 38.596-34.911l89.738 4.499z'/%3E%3Cpath fill='%23fff' d='M207.932 431.974c20.553-78.699 71.369-149.456 147.375-193.338 139.923-80.785 316.040-42.095 410.222 84.418l-89.738-4.499c-20.299-1.018-37.579 14.613-38.596 34.911s14.613 37.579 34.911 38.596l159.799 8.011c16.335 0.819 31.25-9.242 36.61-24.694l52.434-151.164c6.66-19.202-3.506-40.167-22.708-46.828s-40.167 3.506-46.828 22.708l-27.226 78.49c-116.254-155.703-333.248-203.244-505.682-103.69-91.184 52.645-152.976 136.648-179.618 230.523l69.044 26.555z'/%3E%3C/svg%3E\"); }\n\n.pakhshkit-icon-seek-end {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1024 1024' width='36' height='36'%3E%3Cpath fill='%23fff' d='M742.494 323.053c-94.182-126.513-270.298-165.203-410.222-84.418-150.758 87.040-202.411 279.813-115.371 430.571s279.813 202.411 430.571 115.371c61.424-35.463 107.948-89.4 134.169-153.673 7.677-18.818 29.156-27.85 47.974-20.173s27.85 29.156 20.173 47.974c-32.339 79.269-89.818 145.906-165.517 189.611-185.96 107.364-423.747 43.649-531.111-142.311s-43.649-423.747 142.311-531.111c172.433-99.554 389.428-52.014 505.682 103.69l27.226-78.49c6.66-19.202 27.626-29.368 46.828-22.708s29.368 27.626 22.708 46.828l-52.434 151.164c-5.36 15.452-20.275 25.513-36.61 24.694l-159.799-8.011c-20.299-1.018-35.929-18.298-34.911-38.596s18.298-35.929 38.596-34.911l89.738 4.499z'/%3E%3C/svg%3E\"); }\n\n.pakhshkit-icon-rewind {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1024 1024' width='36' height='36'%3E%3Cpath fill='%23fff' opacity='0.5' d='M258.471 323.053c94.182-126.513 270.298-165.203 410.222-84.418 150.758 87.040 202.411 279.813 115.371 430.571s-279.813 202.411-430.571 115.371c-61.424-35.463-107.948-89.4-134.169-153.673-7.677-18.818-29.156-27.85-47.974-20.173s-27.85 29.156-20.173 47.974c32.339 79.269 89.818 145.906 165.517 189.611 185.96 107.364 423.747 43.649 531.111-142.311s43.649-423.747-142.311-531.111c-172.433-99.554-389.428-52.014-505.682 103.69l-27.226-78.49c-6.66-19.202-27.626-29.368-46.828-22.708s-29.368 27.626-22.708 46.828l52.434 151.164c5.36 15.452 20.275 25.513 36.61 24.694l159.799-8.011c20.299-1.018 35.929-18.298 34.911-38.596s-18.298-35.929-38.596-34.911l-89.738 4.499z'%3E%3C/path%3E%3Cpath fill='%23fff' d='M816.068 431.974c-20.553-78.699-71.369-149.456-147.375-193.338-139.923-80.785-316.040-42.095-410.222 84.418l89.738-4.499c20.299-1.018 37.579 14.613 38.596 34.911s-14.613 37.579-34.911 38.596l-159.799 8.011c-16.335 0.819-31.25-9.242-36.61-24.694l-52.434-151.164c-6.66-19.202 3.506-40.167 22.708-46.828s40.167 3.506 46.828 22.708l27.226 78.49c116.254-155.703 333.248-203.244 505.682-103.69 91.184 52.645 152.976 136.648 179.618 230.523l-69.044 26.555z'%3E%3C/path%3E%3C/svg%3E\"); }\n\n.pakhshkit-icon-rewind-10 {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1024 1024' width='36' height='36'%3E%3Cpath fill='%23fff' d='M258.471 323.053c94.182-126.513 270.298-165.203 410.222-84.418 150.758 87.040 202.411 279.813 115.371 430.571s-279.813 202.411-430.571 115.371c-61.424-35.463-107.948-89.4-134.169-153.673-7.677-18.818-29.156-27.85-47.974-20.173s-27.85 29.156-20.173 47.974c32.339 79.269 89.818 145.906 165.517 189.611 185.96 107.364 423.747 43.649 531.111-142.311s43.649-423.747-142.311-531.111c-172.433-99.554-389.428-52.014-505.682 103.69l-27.226-78.49c-6.66-19.202-27.626-29.368-46.828-22.708s-29.368 27.626-22.708 46.828l52.434 151.164c5.36 15.452 20.275 25.513 36.61 24.694l159.799-8.011c20.299-1.018 35.929-18.298 34.911-38.596s-18.298-35.929-38.596-34.911l-89.738 4.499z'%3E%3C/path%3E%3Cpath fill='%23fff' d='M413.327 636.083h67.358v-252.083h-48.527c-2.173 7.358-4.949 13.589-8.329 18.693s-7.726 9.139-13.037 12.106c-5.311 2.967-11.709 5.103-19.193 6.409s-16.417 1.958-26.798 1.958v41.302h48.527v171.616zM596.807 554.192c0 17.803 1.569 29.849 4.708 36.139s8.208 9.435 15.21 9.435c7.001 0 12.071-3.145 15.21-9.435s4.708-18.336 4.708-36.139v-83.316c0-17.803-1.569-29.849-4.708-36.139s-8.208-9.435-15.21-9.435c-7.001 0-12.071 3.145-15.21 9.435s-4.708 18.336-4.708 36.139v83.316zM529.449 512.534c0-25.398 1.75-46.405 5.251-63.021s8.812-29.789 15.934-39.522c7.122-9.732 16.176-16.497 27.16-20.295s23.962-5.697 38.93-5.697c14.969 0 27.945 1.899 38.93 5.697s20.038 10.563 27.16 20.295c7.122 9.732 12.433 22.906 15.934 39.522s5.251 37.622 5.251 63.021c0 25.636-1.75 46.702-5.251 63.199s-8.812 29.552-15.934 39.166c-7.122 9.613-16.176 16.2-27.16 19.761s-23.962 5.341-38.93 5.341c-14.969 0-27.945-1.78-38.93-5.341s-20.038-10.147-27.16-19.761c-7.122-9.613-12.433-22.668-15.934-39.166s-5.251-37.563-5.251-63.199z'%3E%3C/path%3E%3C/svg%3E\"); }\n\n.pakhshkit-icon-vr-stereo {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1024 1024' width='36' height='36'%3E%3Cpath fill='%23fff' d='M864 255.996c53.019 0 96 42.981 96 96v384.004c0 53.019-42.981 96-96 96h-219.764c-33.721 0-64.97-17.693-82.319-46.608l-49.917-83.195-49.917 83.195c-17.349 28.916-48.598 46.608-82.319 46.608h-219.764c-53.019 0-96-42.981-96-96v-384.003c0-53.019 42.981-96 96-96h704zM128 351.997v384.003c0 17.673 14.327 32 32 32h219.764c11.24 0 21.657-5.898 27.44-15.536l49.917-83.195c5.405-9.008 12.944-16.547 21.952-21.952 30.309-18.185 69.622-8.357 87.807 21.952l49.917 83.195c5.783 9.639 16.199 15.536 27.44 15.536h219.764c17.673 0 32-14.327 32-32v-384.004c0-17.673-14.327-32-32-32h-704c-17.673 0-32 14.327-32 32zM304 624c-44.183 0-80-35.817-80-80s35.817-80 80-80c44.183 0 80 35.817 80 80s-35.817 80-80 80zM720 624c-44.183 0-80-35.817-80-80s35.817-80 80-80c44.183 0 80 35.817 80 80s-35.817 80-80 80z'%3E%3C/path%3E%3C/svg%3E\"); }\n\n.pakhshkit-icon-vr-stereo-full {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1024 1024' width='36' height='36'%3E%3Cpath fill='%2301ACCD' d='M864 255.996c53.019 0 96 42.981 96 96v384.004c0 53.019-42.981 96-96 96h-219.764c-33.721 0-64.97-17.693-82.319-46.608l-49.917-83.195-49.917 83.195c-17.349 28.916-48.598 46.608-82.319 46.608h-219.764c-53.019 0-96-42.981-96-96v-384.003c0-53.019 42.981-96 96-96h704zM304 624c44.183 0 80-35.817 80-80s-35.817-80-80-80c-44.183 0-80 35.817-80 80s35.817 80 80 80zM720 624c44.183 0 80-35.817 80-80s-35.817-80-80-80c-44.183 0-80 35.817-80 80s35.817 80 80 80z'%3E%3C/path%3E%3C/svg%3E\"); }\n\n.pakhshkit-icon-chromecast {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1024 1024' width='36' height='36'%3E%3Cpath fill='%23fff' d='M160 704v96h96c0-53.12-42.88-96-96-96zM160 576v64c88.32 0 160 71.68 160 160h64c0-123.84-100.16-224-224-224zM736 352h-448v52.16c126.72 40.96 226.88 141.12 267.84 267.84h180.16v-320zM160 448v64c159.040 0 288 128.96 288 288h64c0-194.56-157.76-352-352-352zM800 224h-576c-35.2 0-64 28.8-64 64v96h64v-96h576v448h-224v64h224c35.2 0 64-28.8 64-64v-448c0-35.2-28.8-64-64-64z'%3E%3C/path%3E%3C/svg%3E\"); }\n\n.pakhshkit-icon-chromecast-brand {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1024 1024' width='36' height='36'%3E%3Cpath fill='%2301accd' d='M160 704v96h96c0-53.12-42.88-96-96-96zM160 576v64c88.32 0 160 71.68 160 160h64c0-123.84-100.16-224-224-224zM736 352h-448v52.16c126.72 40.96 226.88 141.12 267.84 267.84h180.16v-320zM160 448v64c159.040 0 288 128.96 288 288h64c0-194.56-157.76-352-352-352zM800 224h-576c-35.2 0-64 28.8-64 64v96h64v-96h576v448h-224v64h224c35.2 0 64-28.8 64-64v-448c0-35.2-28.8-64-64-64z'%3E%3C/path%3E%3C/svg%3E\"); }\n\n.pakhshkit-icon-next {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1024 1024' width='36' height='36'%3E%3Cpath fill='%23fff' d='M640 549.333l-264.982 154.573c-30.386 17.725-55.018 3.388-55.018-32.094v-319.625c0-35.45 24.605-49.835 55.018-32.094l264.982 154.573v-154.448c0-17.794 14.204-32.219 32-32.219 17.673 0 32 14.398 32 32.219v383.562c0 17.794-14.204 32.219-32 32.219-17.673 0-32-14.398-32-32.219v-154.448z'%3E%3C/path%3E%3C/svg%3E\"); }\n\n.pakhshkit-icon-prev {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1024 1024' width='36' height='36'%3E%3Cpath fill='%23fff' d='M384 549.333l264.982 154.573c30.386 17.725 55.018 3.388 55.018-32.094v-319.625c0-35.45-24.605-49.835-55.018-32.094l-264.982 154.573v-154.448c0-17.794-14.204-32.219-32-32.219-17.673 0-32 14.398-32 32.219v383.562c0 17.794 14.204 32.219 32 32.219 17.673 0 32-14.398 32-32.219v-154.448z'%3E%3C/path%3E%3C/svg%3E\"); }\n\n.pakhshkit-icon-picture-in-picture {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1024 1024' width='36' height='36'%3E%3Cpath fill='%23fff' d='M224 256c-17.673 0-32 14.327-32 32v448c0 17.673 14.327 32 32 32h576c17.673 0 32-14.327 32-32v-448c0-17.673-14.327-32-32-32h-576zM224 192h576c53.019 0 96 42.981 96 96v448c0 53.019-42.981 96-96 96h-576c-53.019 0-96-42.981-96-96v-448c0-53.019 42.981-96 96-96z'%3E%3C/path%3E%3Cpath fill='%23fff' d='M544 512h192c17.673 0 32 14.327 32 32v128c0 17.673-14.327 32-32 32h-192c-17.673 0-32-14.327-32-32v-128c0-17.673 14.327-32 32-32z'%3E%3C/path%3E%3C/svg%3E\"); }\n\n@keyframes pakhshkit-openDropmenu {\n  from {\n    opacity: 0;\n    transform: translateY(10px); }\n  to {\n    opacity: 1;\n    transform: translateY(0); } }\n\n.pakhshkit-dropdown {\n  position: relative;\n  font-size: 15px; }\n  .pakhshkit-dropdown.pakhshkit-active .pakhshkit-dropdown-menu {\n    display: block;\n    opacity: 1; }\n  .pakhshkit-dropdown.pakhshkit-active .pakhshkit-dropdown-button .pakhshkit-icon {\n    transform: rotate(180deg); }\n  .pakhshkit-dropdown .pakhshkit-dropdown-button {\n    font-weight: bold;\n    line-height: 18px;\n    color: #fff;\n    cursor: pointer;\n    padding-left: 20px; }\n    .pakhshkit-dropdown .pakhshkit-dropdown-button .pakhshkit-icon {\n      width: 16px;\n      height: 16px;\n      vertical-align: middle;\n      margin-left: 6px;\n      transition: 150ms transform;\n      will-change: transform; }\n\n.pakhshkit-dropdown-menu {\n  display: block;\n  opacity: 1;\n  position: absolute;\n  background-color: #333333;\n  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.3);\n  border-radius: 4px;\n  padding: 6px 0;\n  z-index: 5;\n  animation: pakhshkit-openDropmenu 100ms ease-out forwards;\n  max-height: 220px;\n  overflow-y: auto;\n  font-size: 15px;\n  text-align: left; }\n  .pakhshkit-dropdown-menu.pakhshkit-top {\n    margin-bottom: 10px;\n    bottom: 100%; }\n  .pakhshkit-dropdown-menu.pakhshkit-bottom {\n    margin-top: 10px;\n    top: 100%; }\n  .pakhshkit-dropdown-menu.pakhshkit-right {\n    left: 0; }\n  .pakhshkit-dropdown-menu.pakhshkit-left {\n    right: 0; }\n  .pakhshkit-dropdown-menu.pakhshkit-stick-bottom {\n    bottom: -95px;\n    margin: 5px 0; }\n  .pakhshkit-dropdown-menu .pakhshkit-dropdown-menu-item {\n    padding: 2px 10px 2px 16px;\n    white-space: nowrap;\n    min-height: 30px;\n    cursor: pointer; }\n    .pakhshkit-dropdown-menu .pakhshkit-dropdown-menu-item:hover {\n      color: #fff; }\n    .pakhshkit-dropdown-menu .pakhshkit-dropdown-menu-item.pakhshkit-active {\n      color: #01accd; }\n      .pakhshkit-dropdown-menu .pakhshkit-dropdown-menu-item.pakhshkit-active .pakhshkit-icon-check {\n        background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1024 1024' width='36' height='36'%3E%3Cpath fill='%2301accd' d='M342.481 563.894c-12.577-12.416-32.838-12.285-45.254 0.292s-12.285 32.838 0.292 45.254l118.857 117.333c13.275 13.105 34.901 12.123 46.933-2.131l297.143-352c11.4-13.505 9.694-33.694-3.811-45.094s-33.694-9.694-45.094 3.811l-274.828 325.566-94.238-93.030z' /%3E%3C/svg%3E\"); }\n    .pakhshkit-dropdown-menu .pakhshkit-dropdown-menu-item .pakhshkit-icon-check {\n      display: inline-block;\n      margin-left: 16px;\n      vertical-align: middle;\n      width: 24px;\n      height: 24px; }\n    .pakhshkit-dropdown-menu .pakhshkit-dropdown-menu-item span {\n      vertical-align: middle;\n      line-height: 26px; }\n\n.pakhshkit-player .pakhshkit-control-button {\n  width: 32px;\n  height: 32px;\n  background: transparent;\n  display: inline-block;\n  opacity: 0.8;\n  border: none;\n  padding: 0;\n  cursor: pointer; }\n  .pakhshkit-player .pakhshkit-control-button i {\n    width: 32px;\n    height: 32px; }\n  .pakhshkit-player .pakhshkit-control-button.pakhshkit-active {\n    opacity: 1; }\n  .pakhshkit-player .pakhshkit-control-button:disabled {\n    opacity: 0.4;\n    cursor: default; }\n  .pakhshkit-player .pakhshkit-control-button.pakhshkit-control-button-rounded {\n    width: 36px;\n    height: 36px;\n    padding: 2px; }\n\n.pakhshkit-player:not(.pakhshkit-touch) .pakhshkit-control-button:not(:disabled):hover {\n  opacity: 1; }\n\n.pakhshkit-player:not(.pakhshkit-touch) .pakhshkit-control-button:not(:disabled).pakhshkit-control-button-rounded:hover {\n  background-color: rgba(0, 0, 0, 0.4);\n  border-radius: 18px; }\n\n.pakhshkit-player .pakhshkit-control-button-container {\n  display: inline-block;\n  position: relative;\n  vertical-align: top; }\n\n.pakhshkit-player.pakhshkit-touch .pakhshkit-player .pakhshkit-control-button-container {\n  position: static; }\n\n.pakhshkit-player.pakhshkit-touch .pakhshkit-control-button {\n  position: relative; }\n\n.pakhshkit-rotate {\n  -moz-animation: pakhshkit-spin 0.3s 1 linear;\n  -o-animation: pakhshkit-spin 0.3s 1 linear;\n  -webkit-animation: pakhshkit-spin 0.3s 1 linear;\n  animation: pakhshkit-spin 0.3s 1 linear; }\n\n@-webkit-keyframes pakhshkit-spin {\n  0% {\n    -webkit-transform: rotate(359deg); }\n  100% {\n    -webkit-transform: rotate(0deg); } }\n\n@-moz-keyframes pakhshkit-spin {\n  0% {\n    -moz-transform: rotate(359deg); }\n  100% {\n    -moz-transform: rotate(0deg); } }\n\n@-o-keyframes pakhshkit-spin {\n  0% {\n    -o-transform: rotate(359deg); }\n  100% {\n    -o-transform: rotate(0deg); } }\n\n@-ms-keyframes pakhshkit-spin {\n  0% {\n    -ms-transform: rotate(359deg); }\n  100% {\n    -ms-transform: rotate(0deg); } }\n\n@keyframes pakhshkit-spin {\n  0% {\n    transform: rotate(359deg); }\n  100% {\n    transform: rotate(0deg); } }\n\n.pakhshkit-player a {\n  font-size: 15px;\n  line-height: 18px;\n  cursor: pointer; }\n  .pakhshkit-player a:hover {\n    color: #01819a; }\n  .pakhshkit-player a:active {\n    opacity: 0.7; }\n\n.pakhshkit-player {\n  overflow: hidden;\n  user-select: none;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  outline: none;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-tap-highlight-color: transparent; }\n  .pakhshkit-player:-webkit-full-screen {\n    width: 100%;\n    height: 100%;\n    max-width: none; }\n  .pakhshkit-player * {\n    box-sizing: border-box;\n    outline: none; }\n  .pakhshkit-player ::selection {\n    background-color: rgba(0, 0, 0, 0.1); }\n  .pakhshkit-player video {\n    width: 100%; }\n  .pakhshkit-player .pakhshkit-player-gui {\n    opacity: 0;\n    overflow: hidden;\n    font-size: 0;\n    font-family: sans-serif; }\n    .pakhshkit-player .pakhshkit-player-gui label {\n      margin-bottom: initial; }\n    .pakhshkit-player .pakhshkit-player-gui input,\n    .pakhshkit-player .pakhshkit-player-gui textarea {\n      font-family: sans-serif; }\n  .pakhshkit-player .overlay-portal {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%; }\n  .pakhshkit-player.pakhshkit-overlay-active .overlay-portal {\n    z-index: 11; }\n  .pakhshkit-player.pakhshkit-casting .pakhshkit-player-gui,\n  .pakhshkit-player.pakhshkit-metadata-loaded .pakhshkit-player-gui,\n  .pakhshkit-player.pakhshkit-state-paused .pakhshkit-player-gui,\n  .pakhshkit-player.pakhshkit-state-idle .pakhshkit-player-gui,\n  .pakhshkit-player.pakhshkit-ad-break .pakhshkit-player-gui,\n  .pakhshkit-player.pakhshkit-overlay-active .pakhshkit-player-gui,\n  .pakhshkit-player.pakhshkit-menu-active .pakhshkit-player-gui {\n    opacity: 1; }\n\n.pakhshkit-player.pakhshkit-nav .pakhshkit-control-button:focus,\n.pakhshkit-player.pakhshkit-nav .pakhshkit-seek-bar:focus,\n.pakhshkit-player.pakhshkit-nav .pakhshkit-dropdown-button:focus,\n.pakhshkit-player.pakhshkit-nav .pakhshkit-smart-container-item:focus,\n.pakhshkit-player.pakhshkit-nav .pakhshkit-dropdown-menu-item:focus,\n.pakhshkit-player.pakhshkit-nav .pakhshkit-pre-playback-play-button:focus,\n.pakhshkit-player.pakhshkit-nav .pakhshkit-sample:focus,\n.pakhshkit-player.pakhshkit-nav .pakhshkit-custom-captions-applied > a:focus,\n.pakhshkit-player.pakhshkit-nav .pakhshkit-form-group-row > a:focus,\n.pakhshkit-player.pakhshkit-nav .pakhshkit-button-save-cvaa:focus,\n.pakhshkit-player.pakhshkit-nav .pakhshkit-slider:focus,\n.pakhshkit-player.pakhshkit-nav .pakhshkit-unmute-button-container:focus,\n.pakhshkit-player.pakhshkit-nav .pakhshkit-live-tag:focus {\n  outline: 1px solid #00cbff; }\n\n.pakhshkit-player [id^='pakhshkit-ads-container'] {\n  transition: transform 100ms; }\n  .pakhshkit-player [id^='pakhshkit-ads-container'][data-adtype='overlay'] {\n    z-index: 1; }\n\n.pakhshkit-player:not(.pakhshkit-ad-break).pakhshkit-metadata-loaded.pakhshkit-hover [id^='pakhshkit-ads-container'],\n.pakhshkit-player:not(.pakhshkit-ad-break).pakhshkit-metadata-loaded.pakhshkit-state-paused [id^='pakhshkit-ads-container'],\n.pakhshkit-player:not(.pakhshkit-ad-break).pakhshkit-metadata-loaded.pakhshkit-state-idle [id^='pakhshkit-ads-container'] {\n  transform: translateY(-60px); }\n\nvideo {\n  left: 0; }\n  video::-webkit-media-controls-panel-container, video::-webkit-media-controls {\n    display: none !important;\n    -webkit-appearance: none; }\n  video::-webkit-media-controls-start-playback-button {\n    display: none !important;\n    -webkit-appearance: none; }\n\n.pakhshkit-player video::-webkit-media-text-track-container {\n  max-height: none; }\n\n.pakhshkit-player.pakhshkit-iOS video::-webkit-media-text-track-container {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0; }\n\n.pakhshkit-player.pakhshkit-state-paused video::-webkit-media-text-track-container, .pakhshkit-player.pakhshkit-state-idle video::-webkit-media-text-track-container, .pakhshkit-player.pakhshkit-hover video::-webkit-media-text-track-container {\n  padding: 0 0 50px 0; }\n\n.pakhshkit-player.pakhshkit-state-paused.pakhshkit-Safari video::-webkit-media-text-track-container, .pakhshkit-player.pakhshkit-state-paused.pakhshkit-iOS video::-webkit-media-text-track-container, .pakhshkit-player.pakhshkit-state-idle.pakhshkit-Safari video::-webkit-media-text-track-container, .pakhshkit-player.pakhshkit-state-idle.pakhshkit-iOS video::-webkit-media-text-track-container, .pakhshkit-player.pakhshkit-hover.pakhshkit-Safari video::-webkit-media-text-track-container, .pakhshkit-player.pakhshkit-hover.pakhshkit-iOS video::-webkit-media-text-track-container {\n  padding: initial;\n  max-height: calc(100% - 50px); }\n\n.pakhshkit-player.pakhshkit-fullscreen.pakhshkit-iOS video::-webkit-media-text-track-container {\n  max-height: none; }\n\n.pakhshkit-player.pakhshkit-overlay-active .pakhshkit-subtitles {\n  visibility: hidden; }\n\n.pakhshkit-player .pakhshkit-subtitles {\n  top: 50px;\n  transform: translateY(0px);\n  transition: ease-in 100ms; }\n\n.pakhshkit-player:not(.pakhshkit-overlay-active).pakhshkit-state-paused .pakhshkit-subtitles,\n.pakhshkit-player:not(.pakhshkit-overlay-active).pakhshkit-state-idle .pakhshkit-subtitles,\n.pakhshkit-player:not(.pakhshkit-overlay-active).pakhshkit-hover .pakhshkit-subtitles {\n  transform: translateY(-50px); }\n\n.pakhshkit-player:not(.pakhshkit-overlay-active).pakhshkit-fullscreen.pakhshkit-iOS .pakhshkit-subtitles {\n  transform: translateY(0px); }\n\n.pakhshkit-video-player {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: black; }\n\n@keyframes pakhshkit-openOverlay {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n.pakhshkit-overlay {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: none;\n  opacity: 0;\n  animation: pakhshkit-openOverlay 100ms ease-in-out forwards;\n  z-index: 11; }\n  .pakhshkit-overlay.pakhshkit-active {\n    display: block;\n    opacity: 1; }\n  .pakhshkit-overlay .pakhshkit-overlay-contents {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.42);\n    z-index: 4;\n    text-align: center;\n    color: #fff;\n    padding: 60px 20px 30px 20px;\n    overflow-y: auto; }\n  .pakhshkit-overlay .pakhshkit-title {\n    font-size: 24px;\n    font-weight: bold;\n    line-height: 29px;\n    margin-bottom: 60px; }\n  .pakhshkit-overlay .pakhshkit-close-overlay {\n    position: absolute;\n    top: 48px;\n    right: 48px;\n    z-index: 5;\n    cursor: pointer; }\n    .pakhshkit-overlay .pakhshkit-close-overlay .pakhshkit-icon-close {\n      width: 24px;\n      height: 24px; }\n  .pakhshkit-overlay .pakhshkit-overlay-screen {\n    display: none; }\n    .pakhshkit-overlay .pakhshkit-overlay-screen.pakhshkit-active {\n      display: block; }\n\n.pakhshkit-player.pakhshkit-size-md .pakhshkit-overlay .pakhshkit-overlay-contents {\n  padding: 36px 20px; }\n\n.pakhshkit-player.pakhshkit-size-md .pakhshkit-overlay .pakhshkit-close-overlay {\n  top: 38px; }\n\n.pakhshkit-player.pakhshkit-size-md .pakhshkit-overlay .pakhshkit-title {\n  margin-bottom: 24px; }\n\n.pakhshkit-player.pakhshkit-size-sm .pakhshkit-overlay .pakhshkit-overlay-contents, .pakhshkit-player.pakhshkit-size-xs .pakhshkit-overlay .pakhshkit-overlay-contents {\n  padding: 16px 24px; }\n\n.pakhshkit-player.pakhshkit-size-sm .pakhshkit-overlay .pakhshkit-close-overlay, .pakhshkit-player.pakhshkit-size-xs .pakhshkit-overlay .pakhshkit-close-overlay {\n  top: 15px;\n  right: 24px; }\n\n.pakhshkit-player.pakhshkit-size-sm .pakhshkit-overlay .pakhshkit-title, .pakhshkit-player.pakhshkit-size-xs .pakhshkit-overlay .pakhshkit-title {\n  font-size: 20px;\n  line-height: 19px;\n  margin-bottom: 24px; }\n\n@keyframes pakhshkit-openSmartContainer {\n  from {\n    opacity: 0;\n    transform: translateY(10px); }\n  to {\n    opacity: 1;\n    transform: translateY(0); } }\n\n@keyframes pakhshkit-closeSmartContainer {\n  from {\n    opacity: 1;\n    transform: translateY(0); }\n  to {\n    opacity: 0;\n    transform: translateY(10px); } }\n\n.pakhshkit-player:not(.pakhshkit-touch) .pakhshkit-smart-container {\n  background-color: #222222;\n  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.3);\n  border-radius: 4px;\n  position: absolute;\n  right: 0px;\n  min-width: 193px;\n  font-size: 15px;\n  z-index: 10;\n  display: block;\n  animation: pakhshkit-openSmartContainer 100ms ease-out forwards; }\n  .pakhshkit-player:not(.pakhshkit-touch) .pakhshkit-smart-container.pakhshkit-leaving {\n    animation: pakhshkit-closeSmartContainer 100ms ease-out forwards; }\n  .pakhshkit-player:not(.pakhshkit-touch) .pakhshkit-smart-container.pakhshkit-top {\n    bottom: 100%;\n    margin-bottom: 6px; }\n    .pakhshkit-player:not(.pakhshkit-touch) .pakhshkit-smart-container.pakhshkit-top:before {\n      display: block;\n      content: ' ';\n      position: absolute;\n      bottom: -6px;\n      left: 0;\n      width: 100%;\n      height: 6px; }\n  .pakhshkit-player:not(.pakhshkit-touch) .pakhshkit-smart-container.pakhshkit-bottom {\n    top: 100%;\n    margin-top: 6px; }\n  .pakhshkit-player:not(.pakhshkit-touch) .pakhshkit-smart-container.pakhshkit-right {\n    left: 0px; }\n  .pakhshkit-player:not(.pakhshkit-touch) .pakhshkit-smart-container.pakhshkit-left {\n    right: 0px; }\n  .pakhshkit-player:not(.pakhshkit-touch) .pakhshkit-smart-container .pakhshkit-smart-container-item {\n    margin: 16px;\n    color: rgba(244, 244, 244, 0.8);\n    white-space: nowrap;\n    display: flex;\n    justify-content: space-between; }\n    .pakhshkit-player:not(.pakhshkit-touch) .pakhshkit-smart-container .pakhshkit-smart-container-item.pakhshkit-select-menu-item label .pakhshkit-label-icon {\n      display: none; }\n    .pakhshkit-player:not(.pakhshkit-touch) .pakhshkit-smart-container .pakhshkit-smart-container-item.pakhshkit-select-menu-item .pakhshkit-dropdown,\n    .pakhshkit-player:not(.pakhshkit-touch) .pakhshkit-smart-container .pakhshkit-smart-container-item.pakhshkit-select-menu-item select {\n      align-self: flex-end; }\n    .pakhshkit-player:not(.pakhshkit-touch) .pakhshkit-smart-container .pakhshkit-smart-container-item.pakhshkit-select-menu-item .pakhshkit-dropdown span {\n      max-width: 100px;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      display: inline-block;\n      vertical-align: middle; }\n    .pakhshkit-player:not(.pakhshkit-touch) .pakhshkit-smart-container .pakhshkit-smart-container-item.pakhshkit-select-menu-item select {\n      text-align-last: right; }\n\n.pakhshkit-player.pakhshkit-touch .pakhshkit-smart-container-item, .pakhshkit-player.pakhshkit-size-sm .pakhshkit-smart-container-item, .pakhshkit-player.pakhshkit-size-xs .pakhshkit-smart-container-item {\n  width: 300px;\n  max-width: 100%;\n  margin: 16px auto;\n  color: rgba(244, 244, 244, 0.8);\n  white-space: nowrap;\n  text-align: left;\n  display: flex;\n  justify-content: space-between; }\n  .pakhshkit-player.pakhshkit-touch .pakhshkit-smart-container-item.pakhshkit-select-menu-item label, .pakhshkit-player.pakhshkit-size-sm .pakhshkit-smart-container-item.pakhshkit-select-menu-item label, .pakhshkit-player.pakhshkit-size-xs .pakhshkit-smart-container-item.pakhshkit-select-menu-item label {\n    font-size: 16px;\n    color: rgba(255, 255, 255, 0.8);\n    margin-right: 20px; }\n    .pakhshkit-player.pakhshkit-touch .pakhshkit-smart-container-item.pakhshkit-select-menu-item label .pakhshkit-label-icon, .pakhshkit-player.pakhshkit-size-sm .pakhshkit-smart-container-item.pakhshkit-select-menu-item label .pakhshkit-label-icon, .pakhshkit-player.pakhshkit-size-xs .pakhshkit-smart-container-item.pakhshkit-select-menu-item label .pakhshkit-label-icon {\n      width: 24px;\n      height: 24px;\n      display: inline-block;\n      vertical-align: middle;\n      margin-right: 16px; }\n  .pakhshkit-player.pakhshkit-touch .pakhshkit-smart-container-item.pakhshkit-select-menu-item .pakhshkit-dropdown,\n  .pakhshkit-player.pakhshkit-touch .pakhshkit-smart-container-item.pakhshkit-select-menu-item select, .pakhshkit-player.pakhshkit-size-sm .pakhshkit-smart-container-item.pakhshkit-select-menu-item .pakhshkit-dropdown,\n  .pakhshkit-player.pakhshkit-size-sm .pakhshkit-smart-container-item.pakhshkit-select-menu-item select, .pakhshkit-player.pakhshkit-size-xs .pakhshkit-smart-container-item.pakhshkit-select-menu-item .pakhshkit-dropdown,\n  .pakhshkit-player.pakhshkit-size-xs .pakhshkit-smart-container-item.pakhshkit-select-menu-item select {\n    align-self: flex-end; }\n  .pakhshkit-player.pakhshkit-touch .pakhshkit-smart-container-item.pakhshkit-select-menu-item select, .pakhshkit-player.pakhshkit-size-sm .pakhshkit-smart-container-item.pakhshkit-select-menu-item select, .pakhshkit-player.pakhshkit-size-xs .pakhshkit-smart-container-item.pakhshkit-select-menu-item select {\n    text-align-last: right;\n    min-width: 1px;\n    line-height: 24px; }\n\n.pakhshkit-player.pakhshkit-touch.pakhshkit-Windows select option, .pakhshkit-player.pakhshkit-size-sm.pakhshkit-Windows select option, .pakhshkit-player.pakhshkit-size-xs.pakhshkit-Windows select option {\n  color: black;\n  background-color: white; }\n\n.pakhshkit-overlay.pakhshkit-share-overlay .pakhshkit-share-icons {\n  margin: 60px 0; }\n  .pakhshkit-overlay.pakhshkit-share-overlay .pakhshkit-share-icons .pakhshkit-btn-rounded {\n    margin: 0 8px;\n    transition: transform 100ms;\n    will-change: transform;\n    border: none; }\n    .pakhshkit-overlay.pakhshkit-share-overlay .pakhshkit-share-icons .pakhshkit-btn-rounded:first-child {\n      margin-left: 0; }\n    .pakhshkit-overlay.pakhshkit-share-overlay .pakhshkit-share-icons .pakhshkit-btn-rounded:last-child {\n      margin-right: 0; }\n    .pakhshkit-overlay.pakhshkit-share-overlay .pakhshkit-share-icons .pakhshkit-btn-rounded.pakhshkit-facebook {\n      background-color: #3b5998; }\n    .pakhshkit-overlay.pakhshkit-share-overlay .pakhshkit-share-icons .pakhshkit-btn-rounded.pakhshkit-twitter {\n      background-color: #1da1f2; }\n    .pakhshkit-overlay.pakhshkit-share-overlay .pakhshkit-share-icons .pakhshkit-btn-rounded.pakhshkit-linkedin {\n      background-color: #00a0dc; }\n\n.pakhshkit-overlay.pakhshkit-share-overlay .pakhshkit-link-options-container {\n  width: auto;\n  display: inline-block;\n  max-width: 100%;\n  text-align: left;\n  margin: 0 auto; }\n  .pakhshkit-overlay.pakhshkit-share-overlay .pakhshkit-link-options-container .pakhshkit-copy-url-row {\n    display: flex; }\n    .pakhshkit-overlay.pakhshkit-share-overlay .pakhshkit-link-options-container .pakhshkit-copy-url-row .pakhshkit-input-copy-url {\n      margin: 0; }\n    .pakhshkit-overlay.pakhshkit-share-overlay .pakhshkit-link-options-container .pakhshkit-copy-url-row .pakhshkit-btn-copy-url .pakhshkit-icon {\n      width: 32px;\n      margin-top: 5px; }\n  .pakhshkit-overlay.pakhshkit-share-overlay .pakhshkit-link-options-container .pakhshkit-video-start-options-row {\n    margin-top: 24px; }\n    .pakhshkit-overlay.pakhshkit-share-overlay .pakhshkit-link-options-container .pakhshkit-video-start-options-row .pakhshkit-checkbox {\n      margin-right: 15px; }\n    .pakhshkit-overlay.pakhshkit-share-overlay .pakhshkit-link-options-container .pakhshkit-video-start-options-row .pakhshkit-form-group {\n      margin: 0; }\n\n.pakhshkit-share-main-container {\n  width: 300px;\n  max-width: 100%;\n  margin: 0 auto;\n  text-align: center; }\n\n.pakhshkit-player:not(.pakhshkit-touch) .pakhshkit-overlay.pakhshkit-share-overlay .pakhshkit-share-icons .pakhshkit-btn-rounded:hover {\n  transform: scale(1.1667); }\n\n.pakhshkit-player.pakhshkit-size-md .pakhshkit-overlay.pakhshkit-share-overlay .pakhshkit-share-icons {\n  margin: 40px 0; }\n\n.pakhshkit-player.pakhshkit-size-sm .pakhshkit-overlay.pakhshkit-share-overlay .pakhshkit-share-icons {\n  margin: 20px 0; }\n\n.pakhshkit-overlay.pakhshkit-cvaa-overlay .pakhshkit-sample {\n  border: 2px solid rgba(255, 255, 255, 0.2);\n  border-radius: 4px;\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 36px;\n  text-align: center;\n  padding: 0 31px;\n  display: inline-block;\n  margin: 0 12px;\n  cursor: pointer;\n  position: relative; }\n  .pakhshkit-overlay.pakhshkit-cvaa-overlay .pakhshkit-sample.pakhshkit-black-bg {\n    background-color: #000; }\n  .pakhshkit-overlay.pakhshkit-cvaa-overlay .pakhshkit-sample.pakhshkit-yellow-text {\n    color: #faff00; }\n  .pakhshkit-overlay.pakhshkit-cvaa-overlay .pakhshkit-sample .pakhshkit-active-tick {\n    height: 16px;\n    width: 16px;\n    border-radius: 8px;\n    background-color: #01accd;\n    position: absolute;\n    top: -5px;\n    right: -5px; }\n    .pakhshkit-overlay.pakhshkit-cvaa-overlay .pakhshkit-sample .pakhshkit-active-tick .pakhshkit-icon {\n      vertical-align: top; }\n  .pakhshkit-overlay.pakhshkit-cvaa-overlay .pakhshkit-sample span {\n    font-size: 16px !important;\n    line-height: 1;\n    vertical-align: middle; }\n\n.pakhshkit-overlay.pakhshkit-cvaa-overlay .pakhshkit-button-save-cvaa {\n  margin-top: 50px;\n  height: 40px;\n  width: 400px;\n  max-width: 100%;\n  border: 2px solid rgba(255, 255, 255, 0.2);\n  border-radius: 4px;\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 38px;\n  text-align: center;\n  display: inline-block;\n  color: #fff;\n  text-decoration: none;\n  cursor: pointer; }\n\n.pakhshkit-overlay.pakhshkit-cvaa-overlay .pakhshkit-custom-captions-applied {\n  margin-top: 50px; }\n\n.pakhshkit-overlay.pakhshkit-cvaa-overlay .pakhshkit-custom-caption-form {\n  width: 300px;\n  max-width: 100%;\n  margin: 0 auto; }\n  .pakhshkit-overlay.pakhshkit-cvaa-overlay .pakhshkit-custom-caption-form a {\n    color: white;\n    line-height: 36px;\n    text-decoration: none; }\n    .pakhshkit-overlay.pakhshkit-cvaa-overlay .pakhshkit-custom-caption-form a:hover, .pakhshkit-overlay.pakhshkit-cvaa-overlay .pakhshkit-custom-caption-form a:focus {\n      text-decoration: underline; }\n  .pakhshkit-overlay.pakhshkit-cvaa-overlay .pakhshkit-custom-caption-form .pakhshkit-slider {\n    float: right;\n    width: 100px;\n    margin-top: 5px; }\n\n.pakhshkit-overlay.pakhshkit-cvaa-overlay .pakhshkit-preview-container {\n  width: 100%;\n  text-align: center;\n  font-size: 16px; }\n\n.pakhshkit-player.pakhshkit-size-sm .pakhshkit-overlay.pakhshkit-cvaa-overlay .pakhshkit-sample {\n  width: 30%;\n  margin: 2.33%;\n  padding: 0; }\n  .pakhshkit-player.pakhshkit-size-sm .pakhshkit-overlay.pakhshkit-cvaa-overlay .pakhshkit-sample:first-child {\n    margin-left: 0; }\n  .pakhshkit-player.pakhshkit-size-sm .pakhshkit-overlay.pakhshkit-cvaa-overlay .pakhshkit-sample:last-child {\n    margin-right: 0; }\n  .pakhshkit-player.pakhshkit-size-sm .pakhshkit-overlay.pakhshkit-cvaa-overlay .pakhshkit-sample.pakhshkit-custom {\n    width: auto;\n    padding: 0 10px; }\n\n.pakhshkit-player.pakhshkit-size-sm .pakhshkit-overlay.pakhshkit-cvaa-overlay .pakhshkit-button-save-cvaa,\n.pakhshkit-player.pakhshkit-size-sm .pakhshkit-overlay.pakhshkit-cvaa-overlay .pakhshkit-custom-captions-applied {\n  margin-top: 20px; }\n\n.pakhshkit-font-size, .pakhshkit-font-color, .pakhshkit-font-family, .pakhshkit-font-style, .pakhshkit-font-opacity, .pakhshkit-background-color, .pakhshkit-background-opacity {\n  background: initial; }\n\n@keyframes pakhshkit-vidiun-spinner {\n  0% {\n    transform: rotate(0deg) scale(0.7);\n    opacity: 1; }\n  70% {\n    transform: rotate(360deg) scale(0.7);\n    opacity: 1; }\n  82% {\n    transform: rotate(360deg) scale(0);\n    opacity: 0; }\n  87% {\n    transform: rotate(360deg) scale(0.9);\n    opacity: 1; }\n  100% {\n    transform: rotate(360deg) scale(0.7);\n    opacity: 1; } }\n\n.pakhshkit-loading-backdrop {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transition: 100ms opacity;\n  opacity: 0;\n  z-index: 5; }\n  .pakhshkit-loading-backdrop.pakhshkit-show {\n    opacity: 1; }\n    .pakhshkit-loading-backdrop.pakhshkit-show .pakhshkit-spinner-container {\n      display: block; }\n  .pakhshkit-loading-backdrop .pakhshkit-spinner-container {\n    display: none;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate3d(-50px, -50px, 0); }\n\n.pakhshkit-spinner {\n  width: 100px;\n  height: 100px;\n  position: relative;\n  animation: pakhshkit-vidiun-spinner 2.5s infinite; }\n  .pakhshkit-spinner span {\n    width: 8px;\n    height: 8px;\n    background-color: #fff;\n    display: block;\n    border-radius: 8px;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    margin-top: -4px;\n    margin-left: -4px; }\n    .pakhshkit-spinner span:nth-child(1) {\n      transform: rotate(45deg) translateX(-25px) translateY(-25px);\n      background-color: #da1f26; }\n    .pakhshkit-spinner span:nth-child(2) {\n      transform: rotate(90deg) translateX(-25px) translateY(-25px);\n      background-color: #06a885; }\n    .pakhshkit-spinner span:nth-child(3) {\n      transform: rotate(135deg) translateX(-25px) translateY(-25px);\n      background-color: #009344; }\n    .pakhshkit-spinner span:nth-child(4) {\n      transform: rotate(180deg) translateX(-25px) translateY(-25px);\n      background-color: #f8a61a; }\n    .pakhshkit-spinner span:nth-child(5) {\n      transform: rotate(225deg) translateX(-25px) translateY(-25px);\n      background-color: #1b4a97; }\n    .pakhshkit-spinner span:nth-child(6) {\n      transform: rotate(270deg) translateX(-25px) translateY(-25px);\n      background-color: #00abcc; }\n    .pakhshkit-spinner span:nth-child(7) {\n      transform: rotate(315deg) translateX(-25px) translateY(-25px);\n      background-color: #b1d238; }\n    .pakhshkit-spinner span:nth-child(8) {\n      transform: rotate(360deg) translateX(-25px) translateY(-25px);\n      background-color: #fcd203; }\n\n.pakhshkit-control-button-container.pakhshkit-control-play-pause .pakhshkit-control-button {\n  transition: 400ms transform; }\n  .pakhshkit-control-button-container.pakhshkit-control-play-pause .pakhshkit-control-button .pakhshkit-icon-pause {\n    transition: 400ms opacity;\n    opacity: 0;\n    display: none; }\n  .pakhshkit-control-button-container.pakhshkit-control-play-pause .pakhshkit-control-button .pakhshkit-icon-play {\n    transition: 400ms opacity;\n    opacity: 1;\n    display: block; }\n  .pakhshkit-control-button-container.pakhshkit-control-play-pause .pakhshkit-control-button.pakhshkit-is-playing {\n    transform: rotate(360deg); }\n    .pakhshkit-control-button-container.pakhshkit-control-play-pause .pakhshkit-control-button.pakhshkit-is-playing .pakhshkit-icon-pause {\n      opacity: 1;\n      display: block; }\n    .pakhshkit-control-button-container.pakhshkit-control-play-pause .pakhshkit-control-button.pakhshkit-is-playing .pakhshkit-icon-play {\n      opacity: 0;\n      display: none; }\n\n.pakhshkit-control-button-container.pakhshkit-volume-control {\n  display: inline-block !important; }\n  .pakhshkit-control-button-container.pakhshkit-volume-control.pakhshkit-hover .pakhshkit-volume-control-bar {\n    display: block !important; }\n  .pakhshkit-control-button-container.pakhshkit-volume-control.pakhshkit-is-muted .pakhshkit-icon-volume-waves {\n    opacity: 0;\n    transform: translateX(-5px); }\n  .pakhshkit-control-button-container.pakhshkit-volume-control.pakhshkit-is-muted .pakhshkit-icon-volume-mute {\n    opacity: 1;\n    transform: scale(1); }\n  .pakhshkit-control-button-container.pakhshkit-volume-control.pakhshkit-dragging-active .pakhshkit-volume-control-bar {\n    display: block; }\n  .pakhshkit-control-button-container.pakhshkit-volume-control .pakhshkit-icon-volume-waves {\n    transform: translateX(0px); }\n  .pakhshkit-control-button-container.pakhshkit-volume-control .pakhshkit-icon-volume-mute {\n    opacity: 1;\n    transform: scale(0); }\n  .pakhshkit-control-button-container.pakhshkit-volume-control .pakhshkit-icon-volume-waves,\n  .pakhshkit-control-button-container.pakhshkit-volume-control .pakhshkit-icon-volume-mute {\n    transition: 300ms transform, 300ms opacity; }\n  .pakhshkit-control-button-container.pakhshkit-volume-control i {\n    position: absolute;\n    top: 0;\n    left: 0; }\n\n.pakhshkit-volume-control-bar {\n  position: absolute;\n  z-index: 2;\n  bottom: 38px;\n  left: 0px;\n  display: block;\n  height: 112px;\n  width: 34px;\n  border-radius: 4px;\n  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.3);\n  background-color: #333333;\n  padding: 6px;\n  display: none; }\n  .pakhshkit-volume-control-bar:before {\n    position: absolute;\n    width: 34px;\n    height: 14px;\n    bottom: -8px;\n    left: 0;\n    content: ' ';\n    display: block; }\n  .pakhshkit-volume-control-bar .pakhshkit-bar {\n    background-color: #424242;\n    height: 100%;\n    position: relative;\n    cursor: pointer; }\n  .pakhshkit-volume-control-bar .pakhshkit-progress {\n    position: absolute;\n    bottom: 0px;\n    left: 0px;\n    width: 100%;\n    border-radius: 0 0 2px 2px;\n    background-color: #01accd; }\n\n.pakhshkit-player.pakhshkit-smart-container-open .pakhshkit-control-button-container.pakhshkit-volume-control.pakhshkit-hover .pakhshkit-volume-control-bar, .pakhshkit-size-ty .pakhshkit-control-button-container.pakhshkit-volume-control.pakhshkit-hover .pakhshkit-volume-control-bar {\n  display: none !important; }\n\n.pakhshkit-touch .pakhshkit-control-button-container.pakhshkit-volume-control.pakhshkit-hover .pakhshkit-volume-control-bar, .pakhshkit-size-ty .pakhshkit-control-button-container.pakhshkit-volume-control.pakhshkit-hover .pakhshkit-volume-control-bar {\n  display: none !important; }\n\n.pakhshkit-player .pakhshkit-control-button-container.pakhshkit-control-fullscreen .pakhshkit-control-button {\n  transition: 100ms transform;\n  transform: scale(1); }\n  .pakhshkit-player .pakhshkit-control-button-container.pakhshkit-control-fullscreen .pakhshkit-control-button .pakhshkit-icon-minimize {\n    display: none; }\n  .pakhshkit-player .pakhshkit-control-button-container.pakhshkit-control-fullscreen .pakhshkit-control-button.pakhshkit-is-fullscreen .pakhshkit-icon-maximize {\n    display: none; }\n  .pakhshkit-player .pakhshkit-control-button-container.pakhshkit-control-fullscreen .pakhshkit-control-button.pakhshkit-is-fullscreen .pakhshkit-icon-minimize {\n    display: block; }\n\n.pakhshkit-player:not(.pakhshkit-touch) .pakhshkit-control-button-container.pakhshkit-control-fullscreen .pakhshkit-control-button:hover {\n  transform: scale(1.1); }\n\n.pakhshkit-player .pakhshkit-seek-bar {\n  padding: 12px 0;\n  margin: -6px 0;\n  cursor: pointer;\n  position: relative; }\n  .pakhshkit-player .pakhshkit-seek-bar:hover .pakhshkit-time-preview,\n  .pakhshkit-player .pakhshkit-seek-bar:hover .pakhshkit-frame-preview, .pakhshkit-player .pakhshkit-seek-bar.pakhshkit-hover .pakhshkit-time-preview,\n  .pakhshkit-player .pakhshkit-seek-bar.pakhshkit-hover .pakhshkit-frame-preview, .pakhshkit-player .pakhshkit-seek-bar.pakhshkit-dragging-active .pakhshkit-time-preview,\n  .pakhshkit-player .pakhshkit-seek-bar.pakhshkit-dragging-active .pakhshkit-frame-preview {\n    display: block; }\n  .pakhshkit-player .pakhshkit-seek-bar:hover .pakhshkit-progress-bar .pakhshkit-scrubber, .pakhshkit-player .pakhshkit-seek-bar.pakhshkit-hover .pakhshkit-progress-bar .pakhshkit-scrubber, .pakhshkit-player .pakhshkit-seek-bar.pakhshkit-dragging-active .pakhshkit-progress-bar .pakhshkit-scrubber {\n    transform: scale(1); }\n  .pakhshkit-player .pakhshkit-seek-bar:hover .pakhshkit-progress-bar .pakhshkit-virtual-progress, .pakhshkit-player .pakhshkit-seek-bar.pakhshkit-hover .pakhshkit-progress-bar .pakhshkit-virtual-progress, .pakhshkit-player .pakhshkit-seek-bar.pakhshkit-dragging-active .pakhshkit-progress-bar .pakhshkit-virtual-progress {\n    display: block; }\n  .pakhshkit-player .pakhshkit-seek-bar.pakhshkit-ad-break {\n    cursor: initial; }\n    .pakhshkit-player .pakhshkit-seek-bar.pakhshkit-ad-break .pakhshkit-progress-bar .pakhshkit-progress {\n      background-color: #f9a71b; }\n  .pakhshkit-player .pakhshkit-seek-bar.pakhshkit-live .pakhshkit-progress-bar .pakhshkit-progress {\n    background-color: #da1f26; }\n  .pakhshkit-player .pakhshkit-seek-bar .pakhshkit-progress-bar {\n    height: 4px;\n    background-color: rgba(255, 255, 255, 0.3);\n    border-radius: 2px;\n    position: relative; }\n    .pakhshkit-player .pakhshkit-seek-bar .pakhshkit-progress-bar .pakhshkit-progress {\n      position: absolute;\n      top: 0;\n      left: 0;\n      height: 100%;\n      border-radius: 2px 0 0 2px;\n      background-color: #01accd; }\n    .pakhshkit-player .pakhshkit-seek-bar .pakhshkit-progress-bar .pakhshkit-virtual-progress {\n      display: none; }\n    .pakhshkit-player .pakhshkit-seek-bar .pakhshkit-progress-bar .pakhshkit-buffered,\n    .pakhshkit-player .pakhshkit-seek-bar .pakhshkit-progress-bar .pakhshkit-virtual-progress {\n      position: absolute;\n      top: 0;\n      left: 0;\n      height: 100%;\n      border-radius: 2px 0 0 2px;\n      background-color: rgba(255, 255, 255, 0.3); }\n    .pakhshkit-player .pakhshkit-seek-bar .pakhshkit-progress-bar .pakhshkit-scrubber {\n      position: absolute;\n      cursor: pointer;\n      display: block;\n      top: -6px;\n      right: -8px;\n      border-radius: 8px;\n      height: 16px;\n      width: 16px;\n      background-color: #ffffff;\n      box-shadow: 0 0 31px 0 rgba(0, 0, 0, 0.3);\n      transform: scale(0);\n      transition: 100ms transform; }\n      .pakhshkit-player .pakhshkit-seek-bar .pakhshkit-progress-bar .pakhshkit-scrubber:active {\n        opacity: 1;\n        cursor: grabbing; }\n  .pakhshkit-player .pakhshkit-seek-bar .pakhshkit-frame-preview {\n    position: absolute;\n    bottom: 16px;\n    left: 0;\n    height: 94px;\n    width: 164px;\n    border: 2px solid rgba(255, 255, 255, 0.2);\n    border-radius: 4px; }\n    .pakhshkit-player .pakhshkit-seek-bar .pakhshkit-frame-preview:hover {\n      display: none !important; }\n    .pakhshkit-player .pakhshkit-seek-bar .pakhshkit-frame-preview .pakhshkit-frame-preview-img {\n      background-size: auto 100%;\n      width: 100%;\n      height: 100%;\n      position: relative; }\n  .pakhshkit-player .pakhshkit-seek-bar .pakhshkit-time-preview {\n    position: absolute;\n    bottom: 22px;\n    left: 0;\n    height: 22px;\n    min-width: 48px;\n    padding: 0 3px;\n    text-align: center;\n    border-radius: 3px;\n    background-color: rgba(0, 0, 0, 0.7);\n    font-size: 13px;\n    font-weight: bold;\n    line-height: 22px;\n    color: #fff; }\n  .pakhshkit-player .pakhshkit-seek-bar .pakhshkit-time-preview,\n  .pakhshkit-player .pakhshkit-seek-bar .pakhshkit-frame-preview {\n    display: none; }\n\n.pakhshkit-touch .pakhshkit-virtual-progress,\n.pakhshkit-touch .pakhshkit-time-preview,\n.pakhshkit-touch .pakhshkit-frame-preview {\n  display: none !important; }\n\n.pakhshkit-player.pakhshkit-size-sm .pakhshkit-virtual-progress,\n.pakhshkit-player.pakhshkit-size-sm .pakhshkit-time-preview,\n.pakhshkit-player.pakhshkit-size-sm .pakhshkit-frame-preview {\n  display: none; }\n\n.pakhshkit-player.pakhshkit-size-ty .pakhshkit-seek-bar {\n  padding: 12px 0;\n  cursor: pointer;\n  position: relative;\n  float: left;\n  width: calc(100% - 45px);\n  margin: 1px 0; }\n\n.pakhshkit-player .pakhshkit-time-display {\n  display: inline-block;\n  line-height: 32px;\n  vertical-align: top;\n  font-size: 14px;\n  padding: 0 23px;\n  font-weight: bold; }\n\n.pakhshkit-touch .pakhshkit-time-display {\n  padding-left: 0; }\n\n.pakhshkit-player.pakhshkit-size-xs .pakhshkit-time-display, .pakhshkit-player.pakhshkit-size-sm .pakhshkit-time-display {\n  padding: 0 12px 0 0; }\n\n.pakhshkit-player .pakhshkit-video-playing-title {\n  font-size: 15px;\n  font-weight: bold;\n  line-height: 18px;\n  padding: 6px 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap; }\n\n.pakhshkit-player .pakhshkit-bottom-bar {\n  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 100%);\n  padding: 6px 16px;\n  color: #fff;\n  opacity: 0;\n  visibility: hidden;\n  transition: 100ms opacity;\n  width: 100%;\n  margin-top: auto;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  z-index: 1; }\n  .pakhshkit-player .pakhshkit-bottom-bar.pakhshkit-hide {\n    display: none; }\n  .pakhshkit-player .pakhshkit-bottom-bar .pakhshkit-left-controls {\n    float: left;\n    text-align: left; }\n    .pakhshkit-player .pakhshkit-bottom-bar .pakhshkit-left-controls .pakhshkit-control-button-container:first-child {\n      margin-left: 0px; }\n  .pakhshkit-player .pakhshkit-bottom-bar .pakhshkit-right-controls {\n    float: right;\n    text-align: left; }\n    .pakhshkit-player .pakhshkit-bottom-bar .pakhshkit-right-controls .pakhshkit-control-button-container:last-child {\n      margin-right: 0px; }\n  .pakhshkit-player .pakhshkit-bottom-bar .pakhshkit-control-button-container {\n    margin: 0 6px; }\n\n.pakhshkit-player.pakhshkit-size-ty .pakhshkit-left-controls {\n  display: none; }\n\n.pakhshkit-player.pakhshkit-size-ty .pakhshkit-control-button-container {\n  display: none;\n  margin: 0; }\n\n.pakhshkit-player.pakhshkit-size-xs .pakhshkit-control-button-container {\n  margin: 0 1px; }\n\n.pakhshkit-player.pakhshkit-size-xs .pakhshkit-left-controls .pakhshkit-control-button-container {\n  display: none; }\n\n.pakhshkit-player.pakhshkit-casting .pakhshkit-bottom-bar,\n.pakhshkit-player.pakhshkit-hover .pakhshkit-bottom-bar,\n.pakhshkit-player.pakhshkit-state-paused .pakhshkit-bottom-bar,\n.pakhshkit-player.pakhshkit-state-idle .pakhshkit-bottom-bar,\n.pakhshkit-player.pakhshkit-ad-break .pakhshkit-bottom-bar,\n.pakhshkit-player.pakhshkit-menu-active .pakhshkit-bottom-bar {\n  opacity: 1;\n  visibility: visible; }\n\n.pakhshkit-player.pakhshkit-overlay-active .pakhshkit-bottom-bar {\n  opacity: 0;\n  visibility: hidden; }\n\n.pakhshkit-player.pakhshkit-size-sm .pakhshkit-bottom-bar {\n  padding: 6px 8px; }\n  .pakhshkit-player.pakhshkit-size-sm .pakhshkit-bottom-bar .pakhshkit-time-display {\n    padding-left: 0; }\n\n.pakhshkit-player .pakhshkit-top-bar {\n  background: linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 100%);\n  padding: 14px 16px;\n  color: #fff;\n  opacity: 0;\n  visibility: hidden;\n  transition: 100ms opacity;\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  pointer-events: none; }\n  .pakhshkit-player .pakhshkit-top-bar.pakhshkit-hide {\n    display: none; }\n  .pakhshkit-player .pakhshkit-top-bar .pakhshkit-left-controls {\n    text-align: left;\n    min-width: 0; }\n  .pakhshkit-player .pakhshkit-top-bar .pakhshkit-right-controls {\n    text-align: left; }\n    .pakhshkit-player .pakhshkit-top-bar .pakhshkit-right-controls .pakhshkit-control-button-container {\n      margin: 0 6px; }\n      .pakhshkit-player .pakhshkit-top-bar .pakhshkit-right-controls .pakhshkit-control-button-container:last-child {\n        margin-right: 0; }\n\n.pakhshkit-player.pakhshkit-casting .pakhshkit-top-bar,\n.pakhshkit-player.pakhshkit-hover .pakhshkit-top-bar,\n.pakhshkit-player.pakhshkit-state-paused .pakhshkit-top-bar,\n.pakhshkit-player.pakhshkit-state-idle .pakhshkit-top-bar,\n.pakhshkit-player.pakhshkit-ad-break .pakhshkit-top-bar,\n.pakhshkit-player.pakhshkit-menu-active .pakhshkit-top-bar {\n  opacity: 1;\n  visibility: visible; }\n\n.pakhshkit-player.pakhshkit-overlay-active .pakhshkit-top-bar {\n  opacity: 0;\n  visibility: hidden; }\n\n.pakhshkit-player.pakhshkit-size-sm .pakhshkit-player .pakhshkit-top-bar {\n  padding: 8px 8px 20px 8px; }\n\n@keyframes pakhshkit-overlayActionIconIn {\n  0% {\n    opacity: 0;\n    transform: scale(0); }\n  10% {\n    opacity: 0.1;\n    transform: scale(0.1); }\n  20% {\n    opacity: 0.3;\n    transform: scale(0.2); }\n  30% {\n    opacity: 0.5;\n    transform: scale(0.3); }\n  40% {\n    opacity: 0.7;\n    transform: scale(0.4); }\n  50% {\n    opacity: 0.9;\n    transform: scale(0.5); }\n  60% {\n    opacity: 0.9;\n    transform: scale(0.5); }\n  70% {\n    opacity: 0.9;\n    transform: scale(0.5); }\n  75% {\n    opacity: 0.9;\n    transform: scale(0.5); }\n  80% {\n    opacity: 1;\n    transform: scale(0.5); }\n  85% {\n    opacity: 1;\n    transform: scale(0.5); }\n  90% {\n    opacity: 1;\n    transform: scale(0.5); }\n  93% {\n    opacity: 0.7;\n    transform: scale(0.5); }\n  95% {\n    opacity: 0.5;\n    transform: scale(0.5); }\n  98% {\n    opacity: 0.2;\n    transform: scale(0.5); }\n  100% {\n    opacity: 0;\n    transform: scale(0.5); } }\n\n.pakhshkit-overlay-action {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%; }\n  .pakhshkit-overlay-action .pakhshkit-icon {\n    width: 144px;\n    height: 144px;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    margin: -72px 0 0 -72px;\n    opacity: 0; }\n\n.pakhshkit-player  .pakhshkit-overlay-action.pakhshkit-in .pakhshkit-icon {\n  animation: pakhshkit-overlayActionIconIn 300ms linear forwards; }\n\n.pakhshkit-pre-playback-play-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%; }\n  .pakhshkit-pre-playback-play-overlay .pakhshkit-pre-playback-play-button {\n    z-index: 1;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    height: 108px;\n    width: 108px;\n    border: 2px solid rgba(255, 255, 255, 0.2);\n    background-color: rgba(0, 0, 0, 0.5);\n    transform: translate(-50%, -50%);\n    border-radius: 54px;\n    padding: 20px;\n    cursor: pointer; }\n    .pakhshkit-pre-playback-play-overlay .pakhshkit-pre-playback-play-button:hover {\n      border: 2px solid rgba(255, 255, 255, 0.4); }\n    .pakhshkit-pre-playback-play-overlay .pakhshkit-pre-playback-play-button:active {\n      opacity: 0.7;\n      transform: scale(1) translate(-50%, -50%); }\n\n.pakhshkit-pre-playback .pakhshkit-player-gui {\n  opacity: 0 !important;\n  display: none; }\n\n.pakhshkit-player.pakhshkit-size-ty .pakhshkit-pre-playback-play-button {\n  width: 75px;\n  height: 75px;\n  padding: 12px; }\n\n.pakhshkit-player.pakhshkit-size-xs .pakhshkit-pre-playback-play-button {\n  width: 85px;\n  height: 85px;\n  padding: 15px; }\n\n.pakhshkit-player .pakhshkit-btn-skip-ad {\n  font-weight: lighter;\n  position: absolute;\n  bottom: 60px;\n  right: 16px;\n  line-height: 36px; }\n\n.pakhshkit-player .pakhshkit-skip-ad {\n  color: #fff;\n  font-size: 20px;\n  font-weight: lighter;\n  line-height: 24px;\n  text-shadow: 0 0 6px rgba(0, 0, 0, 0.6);\n  position: absolute;\n  bottom: 66px;\n  right: 16px; }\n\n.pakhshkit-row {\n  display: block; }\n  .pakhshkit-row:after {\n    content: '';\n    clear: both;\n    display: block; }\n\n.pakhshkit-d-inline-block {\n  display: inline-block; }\n\n.pakhshkit-mobile-hidden-select {\n  display: block;\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  left: 0px;\n  width: 100%;\n  height: 100%; }\n\n.pakhshkit-font-size-base, .pakhshkit-ad-notice {\n  font-size: 15px; }\n\n.pakhshkit-live-tag {\n  color: #da1f26;\n  font-size: 14px;\n  font-weight: bold;\n  letter-spacing: 1px;\n  line-height: 19px;\n  border: 2px solid #da1f26;\n  border-radius: 4px;\n  text-transform: uppercase;\n  text-align: center;\n  display: inline-block;\n  padding: 0 3px 0 5px;\n  margin: 5px 23px;\n  cursor: default; }\n  .pakhshkit-live-tag.pakhshkit-non-live-playhead {\n    background-color: rgba(255, 255, 255, 0.2);\n    border: none;\n    color: #fff;\n    line-height: 23px;\n    padding: 0 5px 0 7px;\n    cursor: pointer; }\n\n.pakhshkit-player.pakhshkit-size-sm .pakhshkit-live-tag {\n  margin-left: 0; }\n\n.pakhshkit-unmute-button-container {\n  display: inline-block;\n  position: absolute;\n  top: 13px;\n  left: 16px;\n  z-index: 15; }\n  .pakhshkit-unmute-button-container a {\n    color: #ffffff; }\n  .pakhshkit-unmute-button-container.pakhshkit-show-icon-only .pakhshkit-btn.pakhshkit-unmute-button {\n    max-width: 64px; }\n    .pakhshkit-unmute-button-container.pakhshkit-show-icon-only .pakhshkit-btn.pakhshkit-unmute-button span {\n      transform: translateX(10px);\n      opacity: 0; }\n\n.pakhshkit-btn.pakhshkit-unmute-button {\n  font-size: 15px;\n  max-width: 200px;\n  transition: max-width 200ms;\n  padding: 0 16px;\n  white-space: nowrap; }\n  .pakhshkit-btn.pakhshkit-unmute-button span {\n    transform: translateX(0px);\n    opacity: 1;\n    transition: transform 100ms, opacity 100ms;\n    display: inline-block;\n    color: #ffffff; }\n  .pakhshkit-btn.pakhshkit-unmute-button.pakhshkit-has-top-bar {\n    transition: 100ms transform; }\n\n.pakhshkit-unmute-icon-container {\n  width: 32px;\n  height: 32px;\n  display: inline-block;\n  vertical-align: top;\n  position: relative;\n  margin-right: 3px; }\n  .pakhshkit-unmute-icon-container i {\n    position: absolute;\n    top: 0;\n    left: 0; }\n\n.pakhshkit-player.pakhshkit-hover .pakhshkit-unmute-button-container.pakhshkit-has-top-bar,\n.pakhshkit-player.pakhshkit-state-paused .pakhshkit-unmute-button-container.pakhshkit-has-top-bar,\n.pakhshkit-player.pakhshkit-state-idle .pakhshkit-unmute-button-container.pakhshkit-has-top-bar,\n.pakhshkit-player.pakhshkit-menu-active .pakhshkit-unmute-button-container.pakhshkit-has-top-bar {\n  transform: translateY(32px); }\n\n.pakhshkit-overlay.pakhshkit-error-overlay {\n  background-color: #333;\n  font-size: 0em; }\n\n.pakhshkit-overlay-contents .pakhshkit-error-overlay {\n  padding-top: 20px; }\n\n.pakhshkit-error-overlay {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  height: 100%;\n  font-family: sans-serif; }\n  .pakhshkit-error-overlay .pakhshkit-copy-url-row {\n    display: flex; }\n  .pakhshkit-error-overlay .pakhshkit-svg-container {\n    flex: 4;\n    display: flex;\n    justify-content: space-around;\n    flex-flow: column; }\n  .pakhshkit-error-overlay .pakhshkit-headline {\n    color: #ffffff;\n    font-size: 18px;\n    margin: 10px 0 14px 0;\n    flex: 1; }\n  .pakhshkit-error-overlay .pakhshkit-error-session {\n    font-size: 14px;\n    color: #ccc;\n    margin-bottom: 20px;\n    user-select: text;\n    -webkit-user-select: text;\n    -moz-user-select: text;\n    -ms-user-select: text;\n    max-width: 300px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    flex: 1; }\n  .pakhshkit-error-overlay .pakhshkit-control-button-container {\n    flex: 5; }\n  .pakhshkit-error-overlay .pakhshkit-retry-btn {\n    height: 36px;\n    width: 120px;\n    border: 2px solid #333;\n    border-radius: 18px;\n    background-color: black;\n    color: #ffffff;\n    font-size: 15px;\n    font-weight: bold;\n    line-height: 32px;\n    cursor: pointer; }\n  .pakhshkit-error-overlay .pakhshkit-error-text {\n    height: 0px;\n    visibility: hidden; }\n\n.pakhshkit-link-options-container {\n  width: auto; }\n  .pakhshkit-link-options-container .pakhshkit-copy-url-row .pakhshkit-input-copy-url {\n    margin: 0; }\n  .pakhshkit-link-options-container .pakhshkit-copy-url-row .pakhshkit-btn-copy-url {\n    margin-left: 10px; }\n    .pakhshkit-link-options-container .pakhshkit-copy-url-row .pakhshkit-btn-copy-url .pakhshkit-icon {\n      height: 24px;\n      width: 24px;\n      margin-top: -3px; }\n\n.pakhshkit-slider {\n  height: 8px;\n  border-radius: 4px;\n  background-color: rgba(255, 255, 255, 0.2); }\n  .pakhshkit-slider .pakhshkit-progress {\n    background-color: #01accd;\n    height: 8px;\n    border-radius: 4px;\n    position: relative; }\n    .pakhshkit-slider .pakhshkit-progress .pakhshkit-handle {\n      height: 12px;\n      width: 12px;\n      border-radius: 5px;\n      background-color: #ffffff;\n      box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.3);\n      position: absolute;\n      right: 0;\n      top: 0px;\n      transform: translate3d(6px, -2px, 0);\n      cursor: pointer; }\n\n.pakhshkit-btn {\n  text-decoration: none;\n  height: 36px;\n  border-radius: 18px;\n  color: #fff;\n  line-height: 36px;\n  font-weight: bold;\n  cursor: pointer;\n  display: inline-block;\n  padding: 0 24px; }\n  .pakhshkit-btn.pakhshkit-btn-block {\n    display: block; }\n  .pakhshkit-btn.pakhshkit-btn-dark-transparent {\n    background-color: rgba(0, 0, 0, 0.5);\n    border: 2px solid rgba(255, 255, 255, 0.2);\n    line-height: 32px; }\n    .pakhshkit-btn.pakhshkit-btn-dark-transparent:hover {\n      color: #fff;\n      border: 2px solid rgba(255, 255, 255, 0.4); }\n  .pakhshkit-btn.pakhshkit-btn-branded {\n    background-color: #01accd; }\n    .pakhshkit-btn.pakhshkit-btn-branded:hover {\n      color: #fff; }\n\n.pakhshkit-btn-rounded {\n  height: 36px;\n  width: 36px;\n  min-width: 36px;\n  min-height: 36px;\n  border-radius: 18px;\n  background-color: rgba(0, 0, 0, 0.4);\n  display: inline-block;\n  padding: 2px; }\n\n.pakhshkit-player button:focus {\n  outline: none; }\n\n.pakhshkit-player .pakhshkit-learn-more {\n  font-weight: lighter; }\n\n.pakhshkit-player .pakhshkit-control-button-container.pakhshkit-control-fullscreen .pakhshkit-control-button {\n  transition: 100ms transform;\n  transform: scale(1); }\n  .pakhshkit-player .pakhshkit-control-button-container.pakhshkit-control-fullscreen .pakhshkit-control-button .pakhshkit-icon-minimize {\n    display: none; }\n  .pakhshkit-player .pakhshkit-control-button-container.pakhshkit-control-fullscreen .pakhshkit-control-button.pakhshkit-is-fullscreen .pakhshkit-icon-maximize {\n    display: none; }\n  .pakhshkit-player .pakhshkit-control-button-container.pakhshkit-control-fullscreen .pakhshkit-control-button.pakhshkit-is-fullscreen .pakhshkit-icon-minimize {\n    display: block; }\n\n.pakhshkit-player:not(.pakhshkit-touch) .pakhshkit-control-button-container.pakhshkit-control-fullscreen .pakhshkit-control-button:hover {\n  transform: scale(1.1); }\n\n.pakhshkit-player .pakhshkit-watermark {\n  position: absolute;\n  padding: 5px;\n  transition: visibility 0s 1s, opacity 1s linear, transform ease-out 100ms; }\n  .pakhshkit-player .pakhshkit-watermark.pakhshkit-hide-watermark {\n    visibility: hidden;\n    opacity: 0; }\n  .pakhshkit-player .pakhshkit-watermark.pakhshkit-top {\n    top: 0; }\n  .pakhshkit-player .pakhshkit-watermark.pakhshkit-bottom {\n    bottom: 0; }\n  .pakhshkit-player .pakhshkit-watermark.pakhshkit-right {\n    right: 0; }\n  .pakhshkit-player .pakhshkit-watermark.pakhshkit-left {\n    left: 0; }\n\n.pakhshkit-player:not(.pakhshkit-pre-playback):not(.pakhshkit-overlay-active).pakhshkit-state-paused .pakhshkit-watermark.pakhshkit-bottom, .pakhshkit-player:not(.pakhshkit-pre-playback):not(.pakhshkit-overlay-active).pakhshkit-state-idle .pakhshkit-watermark.pakhshkit-bottom, .pakhshkit-player:not(.pakhshkit-pre-playback):not(.pakhshkit-overlay-active).pakhshkit-hover .pakhshkit-watermark.pakhshkit-bottom {\n  transform: translateY(-60px); }\n\n.pakhshkit-player a:not([href]):not([tabindex]).pakhshkit-advanced-captions-menu-link {\n  color: #01accd;\n  text-decoration: underline; }\n\n.pakhshkit-control-button-container.pakhshkit-control-vr-stereo .pakhshkit-control-button .pakhshkit-icon-vr-stereo-full {\n  display: none; }\n\n.pakhshkit-control-button-container.pakhshkit-control-vr-stereo .pakhshkit-control-button.pakhshkit-vr-stereo-mode .pakhshkit-icon-vr-stereo {\n  display: none; }\n\n.pakhshkit-control-button-container.pakhshkit-control-vr-stereo .pakhshkit-control-button.pakhshkit-vr-stereo-mode .pakhshkit-icon-vr-stereo-full {\n  display: block; }\n\n.pakhshkit-player .pakhshkit-cast-button {\n  display: block;\n  width: 28px;\n  height: 30px;\n  background-color: rgba(255, 255, 255, 0);\n  border: none;\n  cursor: pointer;\n  --connected-color: rgba(1, 172, 205, 0.8);\n  --disconnected-color: $grayscale4; }\n\n.pakhshkit-player .pakhshkit-cast-button:hover {\n  --disconnected-color: $white;\n  --connected-color: $brand-color; }\n\n.pakhshkit-player .pakhshkit-cast-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%; }\n  .pakhshkit-player .pakhshkit-cast-overlay .pakhshkit-cast-poster {\n    all: inherit;\n    background-size: contain;\n    background: black no-repeat center center; }\n    .pakhshkit-player .pakhshkit-cast-overlay .pakhshkit-cast-poster.pakhshkit-has-poster {\n      background-color: #000; }\n  .pakhshkit-player .pakhshkit-cast-overlay .pakhshkit-cast-black-cover {\n    all: inherit;\n    background: linear-gradient(to top, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0) 72%, rgba(0, 0, 0, 0) 100%); }\n\n.pakhshkit-player .pakhshkit-cast-box .pakhshkit-cast-icon {\n  position: absolute;\n  bottom: 0;\n  left: 46px;\n  height: 128px; }\n  .pakhshkit-player .pakhshkit-cast-box .pakhshkit-cast-icon .pakhshkit-icon {\n    width: 30px;\n    height: 22px;\n    color: rgba(255, 255, 255, 0.6);\n    opacity: 0.6; }\n\n.pakhshkit-player .pakhshkit-cast-box .pakhshkit-cast-connecting-spinner {\n  height: 21px;\n  width: 21px;\n  -webkit-animation: pakhshkit-spin .9s infinite linear;\n  border: 3px solid rgba(255, 255, 255, 0.4);\n  border-top-color: rgba(255, 255, 255, 0.8);\n  border-radius: 100%; }\n\n.pakhshkit-player .pakhshkit-cast-box .pakhshkit-cast-text {\n  position: absolute;\n  bottom: 0;\n  left: 89px;\n  height: 128px;\n  font-family: sans-serif;\n  font-weight: lighter; }\n  .pakhshkit-player .pakhshkit-cast-box .pakhshkit-cast-text .pakhshkit-cast-status {\n    display: inline-block;\n    margin-top: 3px;\n    font-size: 16px;\n    color: rgba(255, 255, 255, 0.6);\n    float: left;\n    font-weight: inherit; }\n  .pakhshkit-player .pakhshkit-cast-box .pakhshkit-cast-text .pakhshkit-cast-device {\n    left: 0;\n    display: inline-block;\n    font-weight: inherit;\n    font-size: 25px;\n    color: #FFFFFF;\n    line-height: 40px; }\n\n@keyframes pakhshkit-castOnTVAnimation {\n  0% {\n    opacity: 0;\n    transform: rotateY(70deg); }\n  33% {\n    opacity: 0.3;\n    transform: rotateY(50deg); }\n  66% {\n    opacity: 0.6;\n    transform: rotateY(30deg); }\n  100% {\n    opacity: 1;\n    transform: rotateY(0); } }\n\n.pakhshkit-player .pakhshkit-cast-on-tv-button-container {\n  position: absolute;\n  width: 100%;\n  text-align: center;\n  bottom: 20px;\n  opacity: 0; }\n  .pakhshkit-player .pakhshkit-cast-on-tv-button-container span {\n    font-family: sans-serif;\n    font-weight: lighter;\n    color: white; }\n  .pakhshkit-player .pakhshkit-cast-on-tv-button-container.pakhshkit-show-cast-on-tv {\n    animation: pakhshkit-castOnTVAnimation 300ms linear forwards; }\n\n.pakhshkit-player .pakhshkit-btn.pakhshkit-cast-on-tv-button {\n  font-size: 15px;\n  max-width: 200px;\n  transition: max-width 200ms;\n  padding: 0 16px;\n  white-space: nowrap; }\n  .pakhshkit-player .pakhshkit-btn.pakhshkit-cast-on-tv-button span {\n    transform: translateX(0px);\n    opacity: 1;\n    transition: transform 100ms, opacity 100ms;\n    display: inline-block; }\n\n.pakhshkit-player .pakhshkit-cast-on-tv-icon-container {\n  width: 32px;\n  height: 32px;\n  display: inline-block;\n  vertical-align: top;\n  position: relative;\n  margin-right: 3px; }\n  .pakhshkit-player .pakhshkit-cast-on-tv-icon-container i {\n    position: absolute;\n    top: 0;\n    left: 0; }\n\n.pakhshkit-player .pakhshkit-backdrop {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.6);\n  transition: 100ms opacity;\n  z-index: 5; }\n\n.pakhshkit-control-button-container.pakhshkit-control-playlist-button .pakhshkit-poster-preview {\n  position: absolute;\n  bottom: 35px;\n  width: 160px;\n  height: 90px;\n  border: 2px solid rgba(255, 255, 255, 0.2);\n  border-radius: 4px;\n  opacity: 0;\n  transition: 400ms opacity;\n  pointer-events: none; }\n  .pakhshkit-control-button-container.pakhshkit-control-playlist-button .pakhshkit-poster-preview:hover {\n    opacity: 0 !important; }\n  .pakhshkit-control-button-container.pakhshkit-control-playlist-button .pakhshkit-poster-preview .pakhshkit-poster-preview-text {\n    position: absolute;\n    padding: 8px;\n    width: 100%; }\n    .pakhshkit-control-button-container.pakhshkit-control-playlist-button .pakhshkit-poster-preview .pakhshkit-poster-preview-text .pakhshkit-poster-preview-text-title {\n      font-size: 14px;\n      font-weight: 400;\n      margin-bottom: 3px;\n      opacity: 0.7; }\n    .pakhshkit-control-button-container.pakhshkit-control-playlist-button .pakhshkit-poster-preview .pakhshkit-poster-preview-text .pakhshkit-poster-preview-text-name {\n      font-size: 15px;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      font-weight: 400; }\n  .pakhshkit-control-button-container.pakhshkit-control-playlist-button .pakhshkit-poster-preview .pakhshkit-poster-preview-img {\n    height: 100%;\n    background-size: contain;\n    background-repeat: round; }\n    .pakhshkit-control-button-container.pakhshkit-control-playlist-button .pakhshkit-poster-preview .pakhshkit-poster-preview-img:after {\n      display: block;\n      background-image: linear-gradient(rgba(0, 0, 0, 0.8), transparent);\n      height: 60%;\n      content: ''; }\n\n.pakhshkit-control-button-container.pakhshkit-control-playlist-button:hover .pakhshkit-poster-preview {\n  opacity: 1; }\n\n.pakhshkit-player-gui > .pakhshkit-playback-controls {\n  display: none;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin-top: -32px;\n  margin-left: -48px; }\n\n.pakhshkit-player.pakhshkit-playlist .pakhshkit-player-gui > .pakhshkit-playback-controls {\n  margin-left: -144px; }\n\n.pakhshkit-bottom-bar .pakhshkit-playback-controls {\n  display: inline; }\n\n.pakhshkit-player.pakhshkit-size-sm.pakhshkit-state-idle .pakhshkit-control-playlist-button, .pakhshkit-player.pakhshkit-size-xs.pakhshkit-state-idle .pakhshkit-control-playlist-button, .pakhshkit-player.pakhshkit-touch.pakhshkit-state-idle .pakhshkit-control-playlist-button {\n  display: none; }\n\n.pakhshkit-player.pakhshkit-size-sm:not(.pakhshkit-state-idle) .pakhshkit-bottom-bar .pakhshkit-playback-controls, .pakhshkit-player.pakhshkit-size-xs:not(.pakhshkit-state-idle) .pakhshkit-bottom-bar .pakhshkit-playback-controls, .pakhshkit-player.pakhshkit-touch:not(.pakhshkit-state-idle) .pakhshkit-bottom-bar .pakhshkit-playback-controls {\n  display: none; }\n\n.pakhshkit-player.pakhshkit-size-sm:not(.pakhshkit-state-idle).pakhshkit-hover .pakhshkit-player-gui > .pakhshkit-playback-controls, .pakhshkit-player.pakhshkit-size-xs:not(.pakhshkit-state-idle).pakhshkit-hover .pakhshkit-player-gui > .pakhshkit-playback-controls, .pakhshkit-player.pakhshkit-touch:not(.pakhshkit-state-idle).pakhshkit-hover .pakhshkit-player-gui > .pakhshkit-playback-controls {\n  display: block; }\n  .pakhshkit-player.pakhshkit-size-sm:not(.pakhshkit-state-idle).pakhshkit-hover .pakhshkit-player-gui > .pakhshkit-playback-controls .pakhshkit-control-button, .pakhshkit-player.pakhshkit-size-xs:not(.pakhshkit-state-idle).pakhshkit-hover .pakhshkit-player-gui > .pakhshkit-playback-controls .pakhshkit-control-button, .pakhshkit-player.pakhshkit-touch:not(.pakhshkit-state-idle).pakhshkit-hover .pakhshkit-player-gui > .pakhshkit-playback-controls .pakhshkit-control-button {\n    width: auto;\n    height: auto;\n    padding: 0 16px;\n    -webkit-filter: drop-shadow(0px 0px 8px rgba(0, 0, 0, 0.5));\n    filter: drop-shadow(0px 0px 8px rgba(0, 0, 0, 0.5)); }\n  .pakhshkit-player.pakhshkit-size-sm:not(.pakhshkit-state-idle).pakhshkit-hover .pakhshkit-player-gui > .pakhshkit-playback-controls .pakhshkit-icon, .pakhshkit-player.pakhshkit-size-xs:not(.pakhshkit-state-idle).pakhshkit-hover .pakhshkit-player-gui > .pakhshkit-playback-controls .pakhshkit-icon, .pakhshkit-player.pakhshkit-touch:not(.pakhshkit-state-idle).pakhshkit-hover .pakhshkit-player-gui > .pakhshkit-playback-controls .pakhshkit-icon {\n    width: 64px;\n    height: 64px; }\n  .pakhshkit-player.pakhshkit-size-sm:not(.pakhshkit-state-idle).pakhshkit-hover .pakhshkit-player-gui > .pakhshkit-playback-controls .pakhshkit-poster-preview, .pakhshkit-player.pakhshkit-size-xs:not(.pakhshkit-state-idle).pakhshkit-hover .pakhshkit-player-gui > .pakhshkit-playback-controls .pakhshkit-poster-preview, .pakhshkit-player.pakhshkit-touch:not(.pakhshkit-state-idle).pakhshkit-hover .pakhshkit-player-gui > .pakhshkit-playback-controls .pakhshkit-poster-preview {\n    opacity: 0; }\n\n.pakhshkit-player .pakhshkit-playlist-countdown {\n  font-family: sans-serif;\n  height: 72px;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  margin: 16px;\n  transform: translateY(0px);\n  transition: transform ease-in 100ms, right 500ms 500ms, opacity 400ms, bottom 300ms;\n  cursor: pointer; }\n  .pakhshkit-player .pakhshkit-playlist-countdown.pakhshkit-hidden {\n    right: -160px;\n    pointer-events: none;\n    opacity: 0; }\n    .pakhshkit-player .pakhshkit-playlist-countdown.pakhshkit-hidden .pakhshkit-playlist-countdown-content-placeholder .pakhshkit-playlist-countdown-content-background {\n      width: 0; }\n      .pakhshkit-player .pakhshkit-playlist-countdown.pakhshkit-hidden .pakhshkit-playlist-countdown-content-placeholder .pakhshkit-playlist-countdown-content-background .pakhshkit-playlist-countdown-content {\n        opacity: 0; }\n  .pakhshkit-player .pakhshkit-playlist-countdown.pakhshkit-canceled {\n    bottom: -50px;\n    opacity: 0; }\n  .pakhshkit-player .pakhshkit-playlist-countdown .pakhshkit-playlist-countdown-poster {\n    width: 120px;\n    height: inherit;\n    float: left;\n    border-radius: 4px 0 0 4px;\n    background-size: contain;\n    background-repeat: round; }\n  .pakhshkit-player .pakhshkit-playlist-countdown .pakhshkit-playlist-countdown-content-placeholder {\n    width: 160px;\n    height: inherit;\n    float: right; }\n    .pakhshkit-player .pakhshkit-playlist-countdown .pakhshkit-playlist-countdown-content-placeholder .pakhshkit-playlist-countdown-content-background {\n      width: inherit;\n      border-radius: 0 4px 3px 0;\n      background-color: rgba(0, 0, 0, 0.7);\n      height: inherit;\n      transition: width 500ms 1000ms; }\n      .pakhshkit-player .pakhshkit-playlist-countdown .pakhshkit-playlist-countdown-content-placeholder .pakhshkit-playlist-countdown-content-background .pakhshkit-playlist-countdown-content {\n        width: inherit;\n        transition: opacity 300ms 1200ms; }\n        .pakhshkit-player .pakhshkit-playlist-countdown .pakhshkit-playlist-countdown-content-placeholder .pakhshkit-playlist-countdown-content-background .pakhshkit-playlist-countdown-content .pakhshkit-playlist-countdown-text {\n          width: 100%;\n          padding: 10px;\n          text-align: left;\n          color: #fff;\n          float: left;\n          line-height: initial; }\n          .pakhshkit-player .pakhshkit-playlist-countdown .pakhshkit-playlist-countdown-content-placeholder .pakhshkit-playlist-countdown-content-background .pakhshkit-playlist-countdown-content .pakhshkit-playlist-countdown-text .pakhshkit-playlist-countdown-text-title {\n            font-size: 14px;\n            font-weight: 400;\n            margin-bottom: 12px;\n            opacity: 0.7; }\n          .pakhshkit-player .pakhshkit-playlist-countdown .pakhshkit-playlist-countdown-content-placeholder .pakhshkit-playlist-countdown-content-background .pakhshkit-playlist-countdown-content .pakhshkit-playlist-countdown-text .pakhshkit-playlist-countdown-text-name {\n            font-size: 15px;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            font-weight: 600; }\n        .pakhshkit-player .pakhshkit-playlist-countdown .pakhshkit-playlist-countdown-content-placeholder .pakhshkit-playlist-countdown-content-background .pakhshkit-playlist-countdown-content .pakhshkit-playlist-countdown-cancel {\n          position: absolute;\n          top: 4px;\n          right: 4px; }\n        .pakhshkit-player .pakhshkit-playlist-countdown .pakhshkit-playlist-countdown-content-placeholder .pakhshkit-playlist-countdown-content-background .pakhshkit-playlist-countdown-content .pakhshkit-playlist-countdown-indicator-bar {\n          height: 4px;\n          background-color: rgba(255, 255, 255, 0.3);\n          position: absolute;\n          bottom: 0;\n          width: inherit;\n          border-radius: inherit; }\n          .pakhshkit-player .pakhshkit-playlist-countdown .pakhshkit-playlist-countdown-content-placeholder .pakhshkit-playlist-countdown-content-background .pakhshkit-playlist-countdown-content .pakhshkit-playlist-countdown-indicator-bar .pakhshkit-playlist-countdown-indicator-progress {\n            max-width: 100%;\n            height: 100%;\n            background-color: rgba(255, 255, 255, 0.5);\n            transition: width 400ms linear; }\n\n.pakhshkit-player:not(.pakhshkit-overlay-active).pakhshkit-state-paused .pakhshkit-playlist-countdown, .pakhshkit-player:not(.pakhshkit-overlay-active).pakhshkit-state-idle .pakhshkit-playlist-countdown, .pakhshkit-player:not(.pakhshkit-overlay-active).pakhshkit-hover .pakhshkit-playlist-countdown {\n  transform: translateY(-50px); }\n\n.pakhshkit-player.pakhshkit-size-md .pakhshkit-playlist-countdown {\n  height: 54px; }\n  .pakhshkit-player.pakhshkit-size-md .pakhshkit-playlist-countdown .pakhshkit-playlist-countdown-poster {\n    width: 96px; }\n  .pakhshkit-player.pakhshkit-size-md .pakhshkit-playlist-countdown .pakhshkit-playlist-countdown-content-placeholder {\n    width: 152px; }\n    .pakhshkit-player.pakhshkit-size-md .pakhshkit-playlist-countdown .pakhshkit-playlist-countdown-content-placeholder .pakhshkit-playlist-countdown-content-background .pakhshkit-playlist-countdown-content .pakhshkit-playlist-countdown-text {\n      padding: 8px; }\n      .pakhshkit-player.pakhshkit-size-md .pakhshkit-playlist-countdown .pakhshkit-playlist-countdown-content-placeholder .pakhshkit-playlist-countdown-content-background .pakhshkit-playlist-countdown-content .pakhshkit-playlist-countdown-text .pakhshkit-playlist-countdown-text-title {\n        margin-bottom: 4px; }\n    .pakhshkit-player.pakhshkit-size-md .pakhshkit-playlist-countdown .pakhshkit-playlist-countdown-content-placeholder .pakhshkit-playlist-countdown-content-background .pakhshkit-playlist-countdown-content .pakhshkit-playlist-countdown-cancel {\n      top: 0;\n      right: 0; }\n\n.pakhshkit-player.pakhshkit-size-sm .pakhshkit-playlist-countdown, .pakhshkit-player.pakhshkit-size-xs .pakhshkit-playlist-countdown, .pakhshkit-player.pakhshkit-size-ty .pakhshkit-playlist-countdown {\n  z-index: 1;\n  height: 36px;\n  margin: 8px; }\n  .pakhshkit-player.pakhshkit-size-sm .pakhshkit-playlist-countdown .pakhshkit-playlist-countdown-poster, .pakhshkit-player.pakhshkit-size-xs .pakhshkit-playlist-countdown .pakhshkit-playlist-countdown-poster, .pakhshkit-player.pakhshkit-size-ty .pakhshkit-playlist-countdown .pakhshkit-playlist-countdown-poster {\n    display: none; }\n  .pakhshkit-player.pakhshkit-size-sm .pakhshkit-playlist-countdown .pakhshkit-playlist-countdown-content-placeholder, .pakhshkit-player.pakhshkit-size-xs .pakhshkit-playlist-countdown .pakhshkit-playlist-countdown-content-placeholder, .pakhshkit-player.pakhshkit-size-ty .pakhshkit-playlist-countdown .pakhshkit-playlist-countdown-content-placeholder {\n    width: 108px; }\n    .pakhshkit-player.pakhshkit-size-sm .pakhshkit-playlist-countdown .pakhshkit-playlist-countdown-content-placeholder .pakhshkit-playlist-countdown-content-background, .pakhshkit-player.pakhshkit-size-xs .pakhshkit-playlist-countdown .pakhshkit-playlist-countdown-content-placeholder .pakhshkit-playlist-countdown-content-background, .pakhshkit-player.pakhshkit-size-ty .pakhshkit-playlist-countdown .pakhshkit-playlist-countdown-content-placeholder .pakhshkit-playlist-countdown-content-background {\n      transition: width 500ms;\n      border-radius: 2px; }\n      .pakhshkit-player.pakhshkit-size-sm .pakhshkit-playlist-countdown .pakhshkit-playlist-countdown-content-placeholder .pakhshkit-playlist-countdown-content-background .pakhshkit-playlist-countdown-content .pakhshkit-playlist-countdown-text, .pakhshkit-player.pakhshkit-size-xs .pakhshkit-playlist-countdown .pakhshkit-playlist-countdown-content-placeholder .pakhshkit-playlist-countdown-content-background .pakhshkit-playlist-countdown-content .pakhshkit-playlist-countdown-text, .pakhshkit-player.pakhshkit-size-ty .pakhshkit-playlist-countdown .pakhshkit-playlist-countdown-content-placeholder .pakhshkit-playlist-countdown-content-background .pakhshkit-playlist-countdown-content .pakhshkit-playlist-countdown-text {\n        width: 90%;\n        padding: 3px 0 0 4px; }\n        .pakhshkit-player.pakhshkit-size-sm .pakhshkit-playlist-countdown .pakhshkit-playlist-countdown-content-placeholder .pakhshkit-playlist-countdown-content-background .pakhshkit-playlist-countdown-content .pakhshkit-playlist-countdown-text .pakhshkit-playlist-countdown-text-title, .pakhshkit-player.pakhshkit-size-xs .pakhshkit-playlist-countdown .pakhshkit-playlist-countdown-content-placeholder .pakhshkit-playlist-countdown-content-background .pakhshkit-playlist-countdown-content .pakhshkit-playlist-countdown-text .pakhshkit-playlist-countdown-text-title, .pakhshkit-player.pakhshkit-size-ty .pakhshkit-playlist-countdown .pakhshkit-playlist-countdown-content-placeholder .pakhshkit-playlist-countdown-content-background .pakhshkit-playlist-countdown-content .pakhshkit-playlist-countdown-text .pakhshkit-playlist-countdown-text-title {\n          font-size: 12px;\n          margin-bottom: 0; }\n        .pakhshkit-player.pakhshkit-size-sm .pakhshkit-playlist-countdown .pakhshkit-playlist-countdown-content-placeholder .pakhshkit-playlist-countdown-content-background .pakhshkit-playlist-countdown-content .pakhshkit-playlist-countdown-text .pakhshkit-playlist-countdown-text-name, .pakhshkit-player.pakhshkit-size-xs .pakhshkit-playlist-countdown .pakhshkit-playlist-countdown-content-placeholder .pakhshkit-playlist-countdown-content-background .pakhshkit-playlist-countdown-content .pakhshkit-playlist-countdown-text .pakhshkit-playlist-countdown-text-name, .pakhshkit-player.pakhshkit-size-ty .pakhshkit-playlist-countdown .pakhshkit-playlist-countdown-content-placeholder .pakhshkit-playlist-countdown-content-background .pakhshkit-playlist-countdown-content .pakhshkit-playlist-countdown-text .pakhshkit-playlist-countdown-text-name {\n          font-size: 12px;\n          font-weight: 400; }\n      .pakhshkit-player.pakhshkit-size-sm .pakhshkit-playlist-countdown .pakhshkit-playlist-countdown-content-placeholder .pakhshkit-playlist-countdown-content-background .pakhshkit-playlist-countdown-content .pakhshkit-playlist-countdown-cancel, .pakhshkit-player.pakhshkit-size-xs .pakhshkit-playlist-countdown .pakhshkit-playlist-countdown-content-placeholder .pakhshkit-playlist-countdown-content-background .pakhshkit-playlist-countdown-content .pakhshkit-playlist-countdown-cancel, .pakhshkit-player.pakhshkit-size-ty .pakhshkit-playlist-countdown .pakhshkit-playlist-countdown-content-placeholder .pakhshkit-playlist-countdown-content-background .pakhshkit-playlist-countdown-content .pakhshkit-playlist-countdown-cancel {\n        width: 24px;\n        height: 24px;\n        margin-top: 3px; }\n        .pakhshkit-player.pakhshkit-size-sm .pakhshkit-playlist-countdown .pakhshkit-playlist-countdown-content-placeholder .pakhshkit-playlist-countdown-content-background .pakhshkit-playlist-countdown-content .pakhshkit-playlist-countdown-cancel *, .pakhshkit-player.pakhshkit-size-xs .pakhshkit-playlist-countdown .pakhshkit-playlist-countdown-content-placeholder .pakhshkit-playlist-countdown-content-background .pakhshkit-playlist-countdown-content .pakhshkit-playlist-countdown-cancel *, .pakhshkit-player.pakhshkit-size-ty .pakhshkit-playlist-countdown .pakhshkit-playlist-countdown-content-placeholder .pakhshkit-playlist-countdown-content-background .pakhshkit-playlist-countdown-content .pakhshkit-playlist-countdown-cancel * {\n          width: inherit;\n          height: inherit; }\n\n.pakhshkit-player.pakhshkit-state-idle .pakhshkit-playlist-next-screen-overlay {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5); }\n  .pakhshkit-player.pakhshkit-state-idle .pakhshkit-playlist-next-screen-overlay .pakhshkit-playlist-next-screen-content {\n    position: relative;\n    top: 50%;\n    transform: translateY(-50%); }\n    .pakhshkit-player.pakhshkit-state-idle .pakhshkit-playlist-next-screen-overlay .pakhshkit-playlist-next-screen-content .pakhshkit-playlist-next-screen-text {\n      position: absolute;\n      width: 100%;\n      top: -90px;\n      font-size: 15px;\n      color: #fff;\n      padding: 4px 8px 12px 8px;\n      text-align: center; }\n      .pakhshkit-player.pakhshkit-state-idle .pakhshkit-playlist-next-screen-overlay .pakhshkit-playlist-next-screen-content .pakhshkit-playlist-next-screen-text .pakhshkit-playlist-next-screen-text-title {\n        padding: 4px;\n        font-weight: 100; }\n      .pakhshkit-player.pakhshkit-state-idle .pakhshkit-playlist-next-screen-overlay .pakhshkit-playlist-next-screen-content .pakhshkit-playlist-next-screen-text .pakhshkit-playlist-next-screen-text-name {\n        padding: 16px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis; }\n    .pakhshkit-player.pakhshkit-state-idle .pakhshkit-playlist-next-screen-overlay .pakhshkit-playlist-next-screen-content .pakhshkit-playlist-next-screen-poster-placeholder {\n      position: relative;\n      margin: auto;\n      width: 384px; }\n      .pakhshkit-player.pakhshkit-state-idle .pakhshkit-playlist-next-screen-overlay .pakhshkit-playlist-next-screen-content .pakhshkit-playlist-next-screen-poster-placeholder .pakhshkit-playlist-next-screen-poster-aspect-ratio {\n        width: 100%;\n        padding-top: 56%; }\n        .pakhshkit-player.pakhshkit-state-idle .pakhshkit-playlist-next-screen-overlay .pakhshkit-playlist-next-screen-content .pakhshkit-playlist-next-screen-poster-placeholder .pakhshkit-playlist-next-screen-poster-aspect-ratio .pakhshkit-playlist-next-screen-poster {\n          position: absolute;\n          top: 0;\n          left: 0;\n          bottom: 0;\n          right: 0;\n          border: 2px solid rgba(255, 255, 255, 0.2);\n          border-radius: 4px;\n          cursor: pointer; }\n          .pakhshkit-player.pakhshkit-state-idle .pakhshkit-playlist-next-screen-overlay .pakhshkit-playlist-next-screen-content .pakhshkit-playlist-next-screen-poster-placeholder .pakhshkit-playlist-next-screen-poster-aspect-ratio .pakhshkit-playlist-next-screen-poster .pakhshkit-playlist-next-screen-poster-img {\n            height: 100%;\n            border-radius: 3px;\n            background-size: contain;\n            background-repeat: round; }\n          .pakhshkit-player.pakhshkit-state-idle .pakhshkit-playlist-next-screen-overlay .pakhshkit-playlist-next-screen-content .pakhshkit-playlist-next-screen-poster-placeholder .pakhshkit-playlist-next-screen-poster-aspect-ratio .pakhshkit-playlist-next-screen-poster .pakhshkit-icon {\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            transform: translate(-50%, -50%);\n            width: 64px;\n            height: 64px; }\n\n.pakhshkit-player.pakhshkit-state-idle.pakhshkit-size-lg .pakhshkit-playlist-next-screen-content .pakhshkit-playlist-next-screen-poster-placeholder {\n  width: 37.5%; }\n\n.pakhshkit-player.pakhshkit-state-idle.pakhshkit-size-md .pakhshkit-playlist-next-screen-content .pakhshkit-playlist-next-screen-text {\n  top: -58px; }\n  .pakhshkit-player.pakhshkit-state-idle.pakhshkit-size-md .pakhshkit-playlist-next-screen-content .pakhshkit-playlist-next-screen-text .pakhshkit-playlist-next-screen-text-name {\n    padding: 0; }\n\n.pakhshkit-player.pakhshkit-state-idle.pakhshkit-size-md .pakhshkit-playlist-next-screen-content .pakhshkit-playlist-next-screen-poster-placeholder {\n  width: 42%; }\n\n.pakhshkit-player.pakhshkit-state-idle.pakhshkit-size-sm .pakhshkit-playlist-next-screen-content .pakhshkit-playlist-next-screen-poster-placeholder, .pakhshkit-player.pakhshkit-state-idle.pakhshkit-size-xs .pakhshkit-playlist-next-screen-content .pakhshkit-playlist-next-screen-poster-placeholder, .pakhshkit-player.pakhshkit-state-idle.pakhshkit-size-ty .pakhshkit-playlist-next-screen-content .pakhshkit-playlist-next-screen-poster-placeholder {\n  width: 32px; }\n  .pakhshkit-player.pakhshkit-state-idle.pakhshkit-size-sm .pakhshkit-playlist-next-screen-content .pakhshkit-playlist-next-screen-poster-placeholder .pakhshkit-playlist-next-screen-poster-aspect-ratio .pakhshkit-playlist-next-screen-poster, .pakhshkit-player.pakhshkit-state-idle.pakhshkit-size-xs .pakhshkit-playlist-next-screen-content .pakhshkit-playlist-next-screen-poster-placeholder .pakhshkit-playlist-next-screen-poster-aspect-ratio .pakhshkit-playlist-next-screen-poster, .pakhshkit-player.pakhshkit-state-idle.pakhshkit-size-ty .pakhshkit-playlist-next-screen-content .pakhshkit-playlist-next-screen-poster-placeholder .pakhshkit-playlist-next-screen-poster-aspect-ratio .pakhshkit-playlist-next-screen-poster {\n    border: 0; }\n    .pakhshkit-player.pakhshkit-state-idle.pakhshkit-size-sm .pakhshkit-playlist-next-screen-content .pakhshkit-playlist-next-screen-poster-placeholder .pakhshkit-playlist-next-screen-poster-aspect-ratio .pakhshkit-playlist-next-screen-poster .pakhshkit-playlist-next-screen-poster-img, .pakhshkit-player.pakhshkit-state-idle.pakhshkit-size-xs .pakhshkit-playlist-next-screen-content .pakhshkit-playlist-next-screen-poster-placeholder .pakhshkit-playlist-next-screen-poster-aspect-ratio .pakhshkit-playlist-next-screen-poster .pakhshkit-playlist-next-screen-poster-img, .pakhshkit-player.pakhshkit-state-idle.pakhshkit-size-ty .pakhshkit-playlist-next-screen-content .pakhshkit-playlist-next-screen-poster-placeholder .pakhshkit-playlist-next-screen-poster-aspect-ratio .pakhshkit-playlist-next-screen-poster .pakhshkit-playlist-next-screen-poster-img {\n      display: none; }\n    .pakhshkit-player.pakhshkit-state-idle.pakhshkit-size-sm .pakhshkit-playlist-next-screen-content .pakhshkit-playlist-next-screen-poster-placeholder .pakhshkit-playlist-next-screen-poster-aspect-ratio .pakhshkit-playlist-next-screen-poster .pakhshkit-icon, .pakhshkit-player.pakhshkit-state-idle.pakhshkit-size-xs .pakhshkit-playlist-next-screen-content .pakhshkit-playlist-next-screen-poster-placeholder .pakhshkit-playlist-next-screen-poster-aspect-ratio .pakhshkit-playlist-next-screen-poster .pakhshkit-icon, .pakhshkit-player.pakhshkit-state-idle.pakhshkit-size-ty .pakhshkit-playlist-next-screen-content .pakhshkit-playlist-next-screen-poster-placeholder .pakhshkit-playlist-next-screen-poster-aspect-ratio .pakhshkit-playlist-next-screen-poster .pakhshkit-icon {\n      width: 32px;\n      height: 32px; }\n\n.pakhshkit-picture-in-picture-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  font-family: sans-serif;\n  display: flex;\n  align-items: center;\n  justify-content: center; }\n  .pakhshkit-picture-in-picture-overlay .pakhshkit-picture-in-picture-poster {\n    all: inherit;\n    background-size: contain;\n    background: black no-repeat center center; }\n    .pakhshkit-picture-in-picture-overlay .pakhshkit-picture-in-picture-poster.pakhshkit-has-poster {\n      background-color: #000; }\n    .pakhshkit-picture-in-picture-overlay .pakhshkit-picture-in-picture-poster .pakhshkit-dark-layer {\n      background-color: rgba(0, 0, 0, 0.4);\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%; }\n  .pakhshkit-picture-in-picture-overlay .pakhshkit-picture-in-picture-control {\n    position: absolute;\n    display: flex;\n    flex-direction: column; }\n  .pakhshkit-picture-in-picture-overlay .pakhshkit-picture-in-picture-text {\n    color: #ffffff;\n    font-size: 18px;\n    white-space: nowrap;\n    overflow: hidden; }\n  .pakhshkit-picture-in-picture-overlay .pakhshkit-picture-in-picture-button {\n    height: 36px;\n    width: 120px;\n    border: 2px solid #424242;\n    border-radius: 18px;\n    background-color: #333;\n    color: #ffffff;\n    font-size: 15px;\n    font-weight: bold;\n    line-height: 30px;\n    cursor: pointer;\n    margin-top: 20px;\n    align-self: center; }\n    .pakhshkit-picture-in-picture-overlay .pakhshkit-picture-in-picture-button:hover {\n      background-color: #424242; }\n\n.pakhshkit-player .pakhshkit-control-button-container.pakhshkit-control-share {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  display: none;\n  z-index: 1; }\n\n.pakhshkit-player.pakhshkit-hover .pakhshkit-control-button-container.pakhshkit-control-share, .pakhshkit-player.pakhshkit-state-paused .pakhshkit-control-button-container.pakhshkit-control-share, .pakhshkit-player.pakhshkit-state-idle .pakhshkit-control-button-container.pakhshkit-control-share {\n  display: inline-block; }\n\n.pakhshkit-copy-url-row .pakhshkit-input-copy-url {\n  margin: 0; }\n\n.pakhshkit-copy-url-row .pakhshkit-btn-copy-url {\n  margin-left: 10px; }\n  .pakhshkit-copy-url-row .pakhshkit-btn-copy-url .pakhshkit-icon {\n    height: 24px;\n    width: 24px;\n    margin-top: -3px;\n    display: none; }\n  .pakhshkit-copy-url-row .pakhshkit-btn-copy-url .pakhshkit-icon-copy {\n    display: block; }\n  .pakhshkit-copy-url-row .pakhshkit-btn-copy-url.pakhshkit-copied .pakhshkit-icon-copy {\n    display: none; }\n  .pakhshkit-copy-url-row .pakhshkit-btn-copy-url.pakhshkit-copied .pakhshkit-icon-check {\n    display: block; }\n",""]),t.locals={row:"pakhshkit-row","d-inline-block":"pakhshkit-d-inline-block",dInlineBlock:"pakhshkit-d-inline-block","mobile-hidden-select":"pakhshkit-mobile-hidden-select",mobileHiddenSelect:"pakhshkit-mobile-hidden-select","font-size-base":"pakhshkit-font-size-base",fontSizeBase:"pakhshkit-font-size-base","ad-notice":"pakhshkit-ad-notice",adNotice:"pakhshkit-ad-notice",player:"pakhshkit-player","form-group":"pakhshkit-form-group",formGroup:"pakhshkit-form-group","has-error":"pakhshkit-has-error",hasError:"pakhshkit-has-error","form-control":"pakhshkit-form-control",formControl:"pakhshkit-form-control","has-icon":"pakhshkit-has-icon",hasIcon:"pakhshkit-has-icon",icon:"pakhshkit-icon",checkbox:"pakhshkit-checkbox","form-group-row":"pakhshkit-form-group-row",formGroupRow:"pakhshkit-form-group-row",dropdown:"pakhshkit-dropdown",btn:"pakhshkit-btn","btn-block":"pakhshkit-btn-block",btnBlock:"pakhshkit-btn-block","btn-dark-transparent":"pakhshkit-btn-dark-transparent",btnDarkTransparent:"pakhshkit-btn-dark-transparent","btn-branded":"pakhshkit-btn-branded",btnBranded:"pakhshkit-btn-branded","btn-rounded":"pakhshkit-btn-rounded",btnRounded:"pakhshkit-btn-rounded","icon-maximize":"pakhshkit-icon-maximize",iconMaximize:"pakhshkit-icon-maximize","icon-minimize":"pakhshkit-icon-minimize",iconMinimize:"pakhshkit-icon-minimize","icon-play":"pakhshkit-icon-play",iconPlay:"pakhshkit-icon-play","icon-pause":"pakhshkit-icon-pause",iconPause:"pakhshkit-icon-pause","icon-volume-base":"pakhshkit-icon-volume-base",iconVolumeBase:"pakhshkit-icon-volume-base","icon-volume-waves":"pakhshkit-icon-volume-waves",iconVolumeWaves:"pakhshkit-icon-volume-waves","icon-volume-wave":"pakhshkit-icon-volume-wave",iconVolumeWave:"pakhshkit-icon-volume-wave","icon-volume-mute":"pakhshkit-icon-volume-mute",iconVolumeMute:"pakhshkit-icon-volume-mute","icon-close":"pakhshkit-icon-close",iconClose:"pakhshkit-icon-close","icon-share":"pakhshkit-icon-share",iconShare:"pakhshkit-icon-share","icon-settings":"pakhshkit-icon-settings",iconSettings:"pakhshkit-icon-settings","icon-check":"pakhshkit-icon-check",iconCheck:"pakhshkit-icon-check","icon-language":"pakhshkit-icon-language",iconLanguage:"pakhshkit-icon-language","icon-quality":"pakhshkit-icon-quality",iconQuality:"pakhshkit-icon-quality","icon-captions":"pakhshkit-icon-captions",iconCaptions:"pakhshkit-icon-captions","icon-speed":"pakhshkit-icon-speed",iconSpeed:"pakhshkit-icon-speed","icon-speed-down":"pakhshkit-icon-speed-down",iconSpeedDown:"pakhshkit-icon-speed-down","icon-speed-up":"pakhshkit-icon-speed-up",iconSpeedUp:"pakhshkit-icon-speed-up","icon-audio":"pakhshkit-icon-audio",iconAudio:"pakhshkit-icon-audio","icon-copy":"pakhshkit-icon-copy",iconCopy:"pakhshkit-icon-copy","icon-facebook":"pakhshkit-icon-facebook",iconFacebook:"pakhshkit-icon-facebook","icon-twitter":"pakhshkit-icon-twitter",iconTwitter:"pakhshkit-icon-twitter","icon-linkedin":"pakhshkit-icon-linkedin",iconLinkedin:"pakhshkit-icon-linkedin","icon-email":"pakhshkit-icon-email",iconEmail:"pakhshkit-icon-email","icon-embed":"pakhshkit-icon-embed",iconEmbed:"pakhshkit-icon-embed","icon-link":"pakhshkit-icon-link",iconLink:"pakhshkit-icon-link","icon-arrow-down":"pakhshkit-icon-arrow-down",iconArrowDown:"pakhshkit-icon-arrow-down","icon-start-over":"pakhshkit-icon-start-over",iconStartOver:"pakhshkit-icon-start-over","icon-seek-forward":"pakhshkit-icon-seek-forward",iconSeekForward:"pakhshkit-icon-seek-forward","icon-seek-end":"pakhshkit-icon-seek-end",iconSeekEnd:"pakhshkit-icon-seek-end","icon-rewind":"pakhshkit-icon-rewind",iconRewind:"pakhshkit-icon-rewind","icon-rewind-10":"pakhshkit-icon-rewind-10",iconRewind10:"pakhshkit-icon-rewind-10","icon-vr-stereo":"pakhshkit-icon-vr-stereo",iconVrStereo:"pakhshkit-icon-vr-stereo","icon-vr-stereo-full":"pakhshkit-icon-vr-stereo-full",iconVrStereoFull:"pakhshkit-icon-vr-stereo-full","icon-chromecast":"pakhshkit-icon-chromecast",iconChromecast:"pakhshkit-icon-chromecast","icon-chromecast-brand":"pakhshkit-icon-chromecast-brand",iconChromecastBrand:"pakhshkit-icon-chromecast-brand","icon-next":"pakhshkit-icon-next",iconNext:"pakhshkit-icon-next","icon-prev":"pakhshkit-icon-prev",iconPrev:"pakhshkit-icon-prev","icon-picture-in-picture":"pakhshkit-icon-picture-in-picture",iconPictureInPicture:"pakhshkit-icon-picture-in-picture",active:"pakhshkit-active","dropdown-menu":"pakhshkit-dropdown-menu",dropdownMenu:"pakhshkit-dropdown-menu","dropdown-button":"pakhshkit-dropdown-button",dropdownButton:"pakhshkit-dropdown-button",openDropmenu:"pakhshkit-openDropmenu",top:"pakhshkit-top",bottom:"pakhshkit-bottom",right:"pakhshkit-right",left:"pakhshkit-left","stick-bottom":"pakhshkit-stick-bottom",stickBottom:"pakhshkit-stick-bottom","dropdown-menu-item":"pakhshkit-dropdown-menu-item",dropdownMenuItem:"pakhshkit-dropdown-menu-item","control-button":"pakhshkit-control-button",controlButton:"pakhshkit-control-button","control-button-rounded":"pakhshkit-control-button-rounded",controlButtonRounded:"pakhshkit-control-button-rounded",touch:"pakhshkit-touch","control-button-container":"pakhshkit-control-button-container",controlButtonContainer:"pakhshkit-control-button-container",rotate:"pakhshkit-rotate",spin:"pakhshkit-spin","player-gui":"pakhshkit-player-gui",playerGui:"pakhshkit-player-gui","overlay-active":"pakhshkit-overlay-active",overlayActive:"pakhshkit-overlay-active",casting:"pakhshkit-casting","metadata-loaded":"pakhshkit-metadata-loaded",metadataLoaded:"pakhshkit-metadata-loaded","state-paused":"pakhshkit-state-paused",statePaused:"pakhshkit-state-paused","state-idle":"pakhshkit-state-idle",stateIdle:"pakhshkit-state-idle","ad-break":"pakhshkit-ad-break",adBreak:"pakhshkit-ad-break","menu-active":"pakhshkit-menu-active",menuActive:"pakhshkit-menu-active",nav:"pakhshkit-nav","seek-bar":"pakhshkit-seek-bar",seekBar:"pakhshkit-seek-bar","smart-container-item":"pakhshkit-smart-container-item",smartContainerItem:"pakhshkit-smart-container-item","pre-playback-play-button":"pakhshkit-pre-playback-play-button",prePlaybackPlayButton:"pakhshkit-pre-playback-play-button",sample:"pakhshkit-sample","custom-captions-applied":"pakhshkit-custom-captions-applied",customCaptionsApplied:"pakhshkit-custom-captions-applied","button-save-cvaa":"pakhshkit-button-save-cvaa",buttonSaveCvaa:"pakhshkit-button-save-cvaa",slider:"pakhshkit-slider","unmute-button-container":"pakhshkit-unmute-button-container",unmuteButtonContainer:"pakhshkit-unmute-button-container","live-tag":"pakhshkit-live-tag",liveTag:"pakhshkit-live-tag",hover:"pakhshkit-hover",iOS:"pakhshkit-iOS",iOs:"pakhshkit-iOS",Safari:"pakhshkit-Safari",safari:"pakhshkit-Safari",fullscreen:"pakhshkit-fullscreen","video-player":"pakhshkit-video-player",videoPlayer:"pakhshkit-video-player",overlay:"pakhshkit-overlay",openOverlay:"pakhshkit-openOverlay","overlay-contents":"pakhshkit-overlay-contents",overlayContents:"pakhshkit-overlay-contents",title:"pakhshkit-title","close-overlay":"pakhshkit-close-overlay",closeOverlay:"pakhshkit-close-overlay","overlay-screen":"pakhshkit-overlay-screen",overlayScreen:"pakhshkit-overlay-screen","size-md":"pakhshkit-size-md",sizeMd:"pakhshkit-size-md","size-sm":"pakhshkit-size-sm",sizeSm:"pakhshkit-size-sm","size-xs":"pakhshkit-size-xs",sizeXs:"pakhshkit-size-xs","smart-container":"pakhshkit-smart-container",smartContainer:"pakhshkit-smart-container",openSmartContainer:"pakhshkit-openSmartContainer",leaving:"pakhshkit-leaving",closeSmartContainer:"pakhshkit-closeSmartContainer","select-menu-item":"pakhshkit-select-menu-item",selectMenuItem:"pakhshkit-select-menu-item","label-icon":"pakhshkit-label-icon",labelIcon:"pakhshkit-label-icon",Windows:"pakhshkit-Windows",windows:"pakhshkit-Windows","share-overlay":"pakhshkit-share-overlay",shareOverlay:"pakhshkit-share-overlay","share-icons":"pakhshkit-share-icons",shareIcons:"pakhshkit-share-icons",facebook:"pakhshkit-facebook",twitter:"pakhshkit-twitter",linkedin:"pakhshkit-linkedin","link-options-container":"pakhshkit-link-options-container",linkOptionsContainer:"pakhshkit-link-options-container","copy-url-row":"pakhshkit-copy-url-row",copyUrlRow:"pakhshkit-copy-url-row","input-copy-url":"pakhshkit-input-copy-url",inputCopyUrl:"pakhshkit-input-copy-url","btn-copy-url":"pakhshkit-btn-copy-url",btnCopyUrl:"pakhshkit-btn-copy-url","video-start-options-row":"pakhshkit-video-start-options-row",videoStartOptionsRow:"pakhshkit-video-start-options-row","share-main-container":"pakhshkit-share-main-container",shareMainContainer:"pakhshkit-share-main-container","cvaa-overlay":"pakhshkit-cvaa-overlay",cvaaOverlay:"pakhshkit-cvaa-overlay","black-bg":"pakhshkit-black-bg",blackBg:"pakhshkit-black-bg","yellow-text":"pakhshkit-yellow-text",yellowText:"pakhshkit-yellow-text","active-tick":"pakhshkit-active-tick",activeTick:"pakhshkit-active-tick","custom-caption-form":"pakhshkit-custom-caption-form",customCaptionForm:"pakhshkit-custom-caption-form","preview-container":"pakhshkit-preview-container",previewContainer:"pakhshkit-preview-container",custom:"pakhshkit-custom","font-size":"pakhshkit-font-size",fontSize:"pakhshkit-font-size","font-color":"pakhshkit-font-color",fontColor:"pakhshkit-font-color","font-family":"pakhshkit-font-family",fontFamily:"pakhshkit-font-family","font-style":"pakhshkit-font-style",fontStyle:"pakhshkit-font-style","font-opacity":"pakhshkit-font-opacity",fontOpacity:"pakhshkit-font-opacity","background-color":"pakhshkit-background-color",backgroundColor:"pakhshkit-background-color","background-opacity":"pakhshkit-background-opacity",backgroundOpacity:"pakhshkit-background-opacity","loading-backdrop":"pakhshkit-loading-backdrop",loadingBackdrop:"pakhshkit-loading-backdrop",show:"pakhshkit-show","spinner-container":"pakhshkit-spinner-container",spinnerContainer:"pakhshkit-spinner-container",spinner:"pakhshkit-spinner","vidiun-spinner":"pakhshkit-vidiun-spinner",vidiunSpinner:"pakhshkit-vidiun-spinner","control-play-pause":"pakhshkit-control-play-pause",controlPlayPause:"pakhshkit-control-play-pause","is-playing":"pakhshkit-is-playing",isPlaying:"pakhshkit-is-playing","volume-control":"pakhshkit-volume-control",volumeControl:"pakhshkit-volume-control","volume-control-bar":"pakhshkit-volume-control-bar",volumeControlBar:"pakhshkit-volume-control-bar","is-muted":"pakhshkit-is-muted",isMuted:"pakhshkit-is-muted","dragging-active":"pakhshkit-dragging-active",draggingActive:"pakhshkit-dragging-active",bar:"pakhshkit-bar",progress:"pakhshkit-progress","smart-container-open":"pakhshkit-smart-container-open",smartContainerOpen:"pakhshkit-smart-container-open","size-ty":"pakhshkit-size-ty",sizeTy:"pakhshkit-size-ty","control-fullscreen":"pakhshkit-control-fullscreen",controlFullscreen:"pakhshkit-control-fullscreen","is-fullscreen":"pakhshkit-is-fullscreen",isFullscreen:"pakhshkit-is-fullscreen","time-preview":"pakhshkit-time-preview",timePreview:"pakhshkit-time-preview","frame-preview":"pakhshkit-frame-preview",framePreview:"pakhshkit-frame-preview","progress-bar":"pakhshkit-progress-bar",progressBar:"pakhshkit-progress-bar",scrubber:"pakhshkit-scrubber","virtual-progress":"pakhshkit-virtual-progress",virtualProgress:"pakhshkit-virtual-progress",live:"pakhshkit-live",buffered:"pakhshkit-buffered","frame-preview-img":"pakhshkit-frame-preview-img",framePreviewImg:"pakhshkit-frame-preview-img","time-display":"pakhshkit-time-display",timeDisplay:"pakhshkit-time-display","video-playing-title":"pakhshkit-video-playing-title",videoPlayingTitle:"pakhshkit-video-playing-title","bottom-bar":"pakhshkit-bottom-bar",bottomBar:"pakhshkit-bottom-bar",hide:"pakhshkit-hide","left-controls":"pakhshkit-left-controls",leftControls:"pakhshkit-left-controls","right-controls":"pakhshkit-right-controls",rightControls:"pakhshkit-right-controls","top-bar":"pakhshkit-top-bar",topBar:"pakhshkit-top-bar","overlay-action":"pakhshkit-overlay-action",overlayAction:"pakhshkit-overlay-action",in:"pakhshkit-in",overlayActionIconIn:"pakhshkit-overlayActionIconIn","pre-playback-play-overlay":"pakhshkit-pre-playback-play-overlay",prePlaybackPlayOverlay:"pakhshkit-pre-playback-play-overlay","pre-playback":"pakhshkit-pre-playback",prePlayback:"pakhshkit-pre-playback","btn-skip-ad":"pakhshkit-btn-skip-ad",btnSkipAd:"pakhshkit-btn-skip-ad","skip-ad":"pakhshkit-skip-ad",skipAd:"pakhshkit-skip-ad","non-live-playhead":"pakhshkit-non-live-playhead",nonLivePlayhead:"pakhshkit-non-live-playhead","show-icon-only":"pakhshkit-show-icon-only",showIconOnly:"pakhshkit-show-icon-only","unmute-button":"pakhshkit-unmute-button",unmuteButton:"pakhshkit-unmute-button","has-top-bar":"pakhshkit-has-top-bar",hasTopBar:"pakhshkit-has-top-bar","unmute-icon-container":"pakhshkit-unmute-icon-container",unmuteIconContainer:"pakhshkit-unmute-icon-container","error-overlay":"pakhshkit-error-overlay",errorOverlay:"pakhshkit-error-overlay","svg-container":"pakhshkit-svg-container",svgContainer:"pakhshkit-svg-container",headline:"pakhshkit-headline","error-session":"pakhshkit-error-session",errorSession:"pakhshkit-error-session","retry-btn":"pakhshkit-retry-btn",retryBtn:"pakhshkit-retry-btn","error-text":"pakhshkit-error-text",errorText:"pakhshkit-error-text",handle:"pakhshkit-handle","learn-more":"pakhshkit-learn-more",learnMore:"pakhshkit-learn-more",watermark:"pakhshkit-watermark","hide-watermark":"pakhshkit-hide-watermark",hideWatermark:"pakhshkit-hide-watermark","advanced-captions-menu-link":"pakhshkit-advanced-captions-menu-link",advancedCaptionsMenuLink:"pakhshkit-advanced-captions-menu-link","control-vr-stereo":"pakhshkit-control-vr-stereo",controlVrStereo:"pakhshkit-control-vr-stereo","vr-stereo-mode":"pakhshkit-vr-stereo-mode",vrStereoMode:"pakhshkit-vr-stereo-mode","cast-button":"pakhshkit-cast-button",castButton:"pakhshkit-cast-button","cast-overlay":"pakhshkit-cast-overlay",castOverlay:"pakhshkit-cast-overlay","cast-poster":"pakhshkit-cast-poster",castPoster:"pakhshkit-cast-poster","has-poster":"pakhshkit-has-poster",hasPoster:"pakhshkit-has-poster","cast-black-cover":"pakhshkit-cast-black-cover",castBlackCover:"pakhshkit-cast-black-cover","cast-box":"pakhshkit-cast-box",castBox:"pakhshkit-cast-box","cast-icon":"pakhshkit-cast-icon",castIcon:"pakhshkit-cast-icon","cast-connecting-spinner":"pakhshkit-cast-connecting-spinner",castConnectingSpinner:"pakhshkit-cast-connecting-spinner","cast-text":"pakhshkit-cast-text",castText:"pakhshkit-cast-text","cast-status":"pakhshkit-cast-status",castStatus:"pakhshkit-cast-status","cast-device":"pakhshkit-cast-device",castDevice:"pakhshkit-cast-device","cast-on-tv-button-container":"pakhshkit-cast-on-tv-button-container",castOnTvButtonContainer:"pakhshkit-cast-on-tv-button-container","show-cast-on-tv":"pakhshkit-show-cast-on-tv",showCastOnTv:"pakhshkit-show-cast-on-tv",castOnTVAnimation:"pakhshkit-castOnTVAnimation",castOnTvAnimation:"pakhshkit-castOnTVAnimation","cast-on-tv-button":"pakhshkit-cast-on-tv-button",castOnTvButton:"pakhshkit-cast-on-tv-button","cast-on-tv-icon-container":"pakhshkit-cast-on-tv-icon-container",castOnTvIconContainer:"pakhshkit-cast-on-tv-icon-container",backdrop:"pakhshkit-backdrop","control-playlist-button":"pakhshkit-control-playlist-button",controlPlaylistButton:"pakhshkit-control-playlist-button","poster-preview":"pakhshkit-poster-preview",posterPreview:"pakhshkit-poster-preview","poster-preview-text":"pakhshkit-poster-preview-text",posterPreviewText:"pakhshkit-poster-preview-text","poster-preview-text-title":"pakhshkit-poster-preview-text-title",posterPreviewTextTitle:"pakhshkit-poster-preview-text-title","poster-preview-text-name":"pakhshkit-poster-preview-text-name",posterPreviewTextName:"pakhshkit-poster-preview-text-name","poster-preview-img":"pakhshkit-poster-preview-img",posterPreviewImg:"pakhshkit-poster-preview-img","playback-controls":"pakhshkit-playback-controls",playbackControls:"pakhshkit-playback-controls",playlist:"pakhshkit-playlist","playlist-countdown":"pakhshkit-playlist-countdown",playlistCountdown:"pakhshkit-playlist-countdown",hidden:"pakhshkit-hidden","playlist-countdown-content-placeholder":"pakhshkit-playlist-countdown-content-placeholder",playlistCountdownContentPlaceholder:"pakhshkit-playlist-countdown-content-placeholder","playlist-countdown-content-background":"pakhshkit-playlist-countdown-content-background",playlistCountdownContentBackground:"pakhshkit-playlist-countdown-content-background","playlist-countdown-content":"pakhshkit-playlist-countdown-content",playlistCountdownContent:"pakhshkit-playlist-countdown-content",canceled:"pakhshkit-canceled","playlist-countdown-poster":"pakhshkit-playlist-countdown-poster",playlistCountdownPoster:"pakhshkit-playlist-countdown-poster","playlist-countdown-text":"pakhshkit-playlist-countdown-text",playlistCountdownText:"pakhshkit-playlist-countdown-text","playlist-countdown-text-title":"pakhshkit-playlist-countdown-text-title",playlistCountdownTextTitle:"pakhshkit-playlist-countdown-text-title","playlist-countdown-text-name":"pakhshkit-playlist-countdown-text-name",playlistCountdownTextName:"pakhshkit-playlist-countdown-text-name","playlist-countdown-cancel":"pakhshkit-playlist-countdown-cancel",playlistCountdownCancel:"pakhshkit-playlist-countdown-cancel","playlist-countdown-indicator-bar":"pakhshkit-playlist-countdown-indicator-bar",playlistCountdownIndicatorBar:"pakhshkit-playlist-countdown-indicator-bar","playlist-countdown-indicator-progress":"pakhshkit-playlist-countdown-indicator-progress",playlistCountdownIndicatorProgress:"pakhshkit-playlist-countdown-indicator-progress","playlist-next-screen-overlay":"pakhshkit-playlist-next-screen-overlay",playlistNextScreenOverlay:"pakhshkit-playlist-next-screen-overlay","playlist-next-screen-content":"pakhshkit-playlist-next-screen-content",playlistNextScreenContent:"pakhshkit-playlist-next-screen-content","playlist-next-screen-text":"pakhshkit-playlist-next-screen-text",playlistNextScreenText:"pakhshkit-playlist-next-screen-text","playlist-next-screen-text-title":"pakhshkit-playlist-next-screen-text-title",playlistNextScreenTextTitle:"pakhshkit-playlist-next-screen-text-title","playlist-next-screen-text-name":"pakhshkit-playlist-next-screen-text-name",playlistNextScreenTextName:"pakhshkit-playlist-next-screen-text-name","playlist-next-screen-poster-placeholder":"pakhshkit-playlist-next-screen-poster-placeholder",playlistNextScreenPosterPlaceholder:"pakhshkit-playlist-next-screen-poster-placeholder","playlist-next-screen-poster-aspect-ratio":"pakhshkit-playlist-next-screen-poster-aspect-ratio",playlistNextScreenPosterAspectRatio:"pakhshkit-playlist-next-screen-poster-aspect-ratio","playlist-next-screen-poster":"pakhshkit-playlist-next-screen-poster",playlistNextScreenPoster:"pakhshkit-playlist-next-screen-poster","playlist-next-screen-poster-img":"pakhshkit-playlist-next-screen-poster-img",playlistNextScreenPosterImg:"pakhshkit-playlist-next-screen-poster-img","size-lg":"pakhshkit-size-lg",sizeLg:"pakhshkit-size-lg","picture-in-picture-overlay":"pakhshkit-picture-in-picture-overlay",pictureInPictureOverlay:"pakhshkit-picture-in-picture-overlay","picture-in-picture-poster":"pakhshkit-picture-in-picture-poster",pictureInPicturePoster:"pakhshkit-picture-in-picture-poster","dark-layer":"pakhshkit-dark-layer",darkLayer:"pakhshkit-dark-layer","picture-in-picture-control":"pakhshkit-picture-in-picture-control",pictureInPictureControl:"pakhshkit-picture-in-picture-control","picture-in-picture-text":"pakhshkit-picture-in-picture-text",pictureInPictureText:"pakhshkit-picture-in-picture-text","picture-in-picture-button":"pakhshkit-picture-in-picture-button",pictureInPictureButton:"pakhshkit-picture-in-picture-button","control-share":"pakhshkit-control-share",controlShare:"pakhshkit-control-share",copied:"pakhshkit-copied"}},function(e,t){function n(e,t){var n=e[1]||"",r=e[3];if(!r)return n;if(t&&"function"==typeof btoa){var o=a(r);return[n].concat(r.sources.map(function(e){return"/*# sourceURL="+r.sourceRoot+e+" */"})).concat([o]).join("\n")}return[n].join("\n")}function a(e){return"/*# sourceMappingURL=data:application/json;charset=utf-8;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(e))))+" */"}e.exports=function(e){var t=[];return t.toString=function(){return this.map(function(t){var a=n(t,e);return t[2]?"@media "+t[2]+"{"+a+"}":a}).join("")},t.i=function(e,n){"string"==typeof e&&(e=[[null,e,""]]);for(var a={},r=0;r<this.length;r++){var o=this[r][0];"number"==typeof o&&(a[o]=!0)}for(r=0;r<e.length;r++){var i=e[r];"number"==typeof i[0]&&a[i[0]]||(n&&!i[2]?i[2]=n:n&&(i[2]="("+i[2]+") and ("+n+")"),t.push(i))}},t}},function(e,t,n){function a(e,t){for(var n=0;n<e.length;n++){var a=e[n],r=d[a.id];if(r){r.refs++;for(var o=0;o<r.parts.length;o++)r.parts[o](a.parts[o]);for(;o<a.parts.length;o++)r.parts.push(c(a.parts[o],t))}else{for(var i=[],o=0;o<a.parts.length;o++)i.push(c(a.parts[o],t));d[a.id]={id:a.id,refs:1,parts:i}}}}function r(e,t){for(var n=[],a={},r=0;r<e.length;r++){var o=e[r],i=t.base?o[0]+t.base:o[0],s=o[1],l=o[2],p=o[3],c={css:s,media:l,sourceMap:p};a[i]?a[i].parts.push(c):n.push(a[i]={id:i,parts:[c]})}return n}function o(e,t){var n=y(e.insertInto);if(!n)throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");var a=m[m.length-1];if("top"===e.insertAt)a?a.nextSibling?n.insertBefore(t,a.nextSibling):n.appendChild(t):n.insertBefore(t,n.firstChild),m.push(t);else{if("bottom"!==e.insertAt)throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");n.appendChild(t)}}function i(e){if(null===e.parentNode)return!1;e.parentNode.removeChild(e);var t=m.indexOf(e);t>=0&&m.splice(t,1)}function s(e){var t=document.createElement("style");return e.attrs.type="text/css",p(t,e.attrs),o(e,t),t}function l(e){var t=document.createElement("link");return e.attrs.type="text/css",e.attrs.rel="stylesheet",p(t,e.attrs),o(e,t),t}function p(e,t){Object.keys(t).forEach(function(n){e.setAttribute(n,t[n])})}function c(e,t){var n,a,r,o;if(t.transform&&e.css){if(!(o=t.transform(e.css)))return function(){};e.css=o}if(t.singleton){var p=b++;n=v||(v=s(t)),a=u.bind(null,n,p,!1),r=u.bind(null,n,p,!0)}else e.sourceMap&&"function"==typeof URL&&"function"==typeof URL.createObjectURL&&"function"==typeof URL.revokeObjectURL&&"function"==typeof Blob&&"function"==typeof btoa?(n=l(t),a=k.bind(null,n,t),r=function(){i(n),n.href&&URL.revokeObjectURL(n.href)}):(n=s(t),a=h.bind(null,n),r=function(){i(n)});return a(e),function(t){if(t){if(t.css===e.css&&t.media===e.media&&t.sourceMap===e.sourceMap)return;a(e=t)}else r()}}function u(e,t,n,a){var r=n?"":a.css;if(e.styleSheet)e.styleSheet.cssText=_(t,r);else{var o=document.createTextNode(r),i=e.childNodes;i[t]&&e.removeChild(i[t]),i.length?e.insertBefore(o,i[t]):e.appendChild(o)}}function h(e,t){var n=t.css,a=t.media;if(a&&e.setAttribute("media",a),e.styleSheet)e.styleSheet.cssText=n;else{for(;e.firstChild;)e.removeChild(e.firstChild);e.appendChild(document.createTextNode(n))}}function k(e,t,n){var a=n.css,r=n.sourceMap,o=void 0===t.convertToAbsoluteUrls&&r;(t.convertToAbsoluteUrls||o)&&(a=g(a)),r&&(a+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(r))))+" */");var i=new Blob([a],{type:"text/css"}),s=e.href;e.href=URL.createObjectURL(i),s&&URL.revokeObjectURL(s)}var d={},f=function(e){var t;return function(){return void 0===t&&(t=e.apply(this,arguments)),t}}(function(){return window&&document&&document.all&&!window.atob}),y=function(e){var t={};return function(n){return void 0===t[n]&&(t[n]=e.call(this,n)),t[n]}}(function(e){return document.querySelector(e)}),v=null,b=0,m=[],g=n(125);e.exports=function(e,t){if("undefined"!=typeof DEBUG&&DEBUG&&"object"!=typeof document)throw new Error("The style-loader cannot be used in a non-browser environment");t=t||{},t.attrs="object"==typeof t.attrs?t.attrs:{},t.singleton||(t.singleton=f()),t.insertInto||(t.insertInto="head"),t.insertAt||(t.insertAt="bottom");var n=r(e,t);return a(n,t),function(e){for(var o=[],i=0;i<n.length;i++){var s=n[i],l=d[s.id];l.refs--,o.push(l)}if(e){a(r(e,t),t)}for(var i=0;i<o.length;i++){var l=o[i];if(0===l.refs){for(var p=0;p<l.parts.length;p++)l.parts[p]();delete d[l.id]}}}};var _=function(){var e=[];return function(t,n){return e[t]=n,e.filter(Boolean).join("\n")}}()},function(e,t){e.exports=function(e){var t="undefined"!=typeof window&&window.location;if(!t)throw new Error("fixUrls requires window.location");if(!e||"string"!=typeof e)return e;var n=t.protocol+"//"+t.host,a=n+t.pathname.replace(/\/[^\/]*$/,"/");return e.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi,function(e,t){var r=t.trim().replace(/^"(.*)"$/,function(e,t){return t}).replace(/^'(.*)'$/,function(e,t){return t});if(/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(r))return e;var o;return o=0===r.indexOf("//")?r:0===r.indexOf("/")?n+r:a+r.replace(/^\.\//,""),"url("+JSON.stringify(o)+")"})}},function(e,t,n){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function r(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.VideoPlayer=void 0;var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),s=n(1),l=function(e){return e&&e.__esModule?e:{default:e}}(s),p=n(0),c=function(e){function t(){return a(this,t),r(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return o(t,e),i(t,[{key:"shouldComponentUpdate",value:function(){return!1}},{key:"componentDidMount",value:function(){this._el.appendChild(this.props.player.getView())}},{key:"render",value:function(){var e=this;return(0,p.h)("div",{className:l.default.videoPlayer,ref:function(t){return e._el=t}})}}]),t}(p.Component);t.VideoPlayer=c},function(e,t,n){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function r(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.PlayerGUI=void 0;var i,s,l=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),p=n(0),c=n(2),u=function(e){return{state:{shell:e.shell,engine:{adBreak:e.engine.adBreak,isLive:e.engine.isLive,hasError:e.engine.hasError,isIdle:e.engine.isIdle,isVr:e.engine.isVr,playlist:e.engine.playlist}},config:e.config}},h=(i=(0,c.connect)(u))(s=function(e){function t(){return a(this,t),r(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return o(t,e),l(t,[{key:"getMatchedUI",value:function(e,t){var n=void 0,a=!0,r=!1,o=void 0;try{for(var i,s=e[Symbol.iterator]();!(a=(i=s.next()).done);a=!0){var l=i.value;if(void 0===l.condition||l.condition(t)){n=l;break}}}catch(e){r=!0,o=e}finally{try{!a&&s.return&&s.return()}finally{if(r)throw o}}return n}},{key:"render",value:function(e){var t=void 0;return this.props.uis.length>0?(t=this.getMatchedUI(e.uis,e.state),t?t.template(e):this.props.uis[0].template(e)):void 0}}]),t}(p.Component))||s;t.PlayerGUI=h},function(e,t,n){"use strict";function a(e){return(0,r.h)("div",{className:i.default.playbackGuiWWrapper},(0,r.h)(s.Loading,{player:e.player}))}Object.defineProperty(t,"__esModule",{value:!0}),t.idleUI=a;var r=n(0),o=n(1),i=function(e){return e&&e.__esModule?e:{default:e}}(o),s=n(15)},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function r(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.Loading=void 0;var l,p,c=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),u=n(1),h=a(u),k=n(0),d=n(2),f=n(7),y=n(14),v=n(3),b=a(v),m=function(e){return{show:e.loading.show,isMobile:e.shell.isMobile,adBreak:e.engine.adBreak,adIsLinear:e.engine.adIsLinear}},g=(l=(0,d.connect)(m,(0,f.bindActions)(y.actions)))(p=function(e){function t(e){o(this,t);var n=i(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,{name:"Loading",player:e.player}));return n.setState({afterPlayingEvent:!1}),n}return s(t,e),c(t,[{key:"componentDidMount",value:function(){var e=this;this.eventManager.listen(this.player,this.player.Event.PLAYER_STATE_CHANGED,function(t){if(e.state.afterPlayingEvent){var n=e.player.State;t.payload.newState.type===n.IDLE||t.payload.newState.type===n.PLAYING||t.payload.newState.type===n.PAUSED?e.props.updateLoadingSpinnerState(!1):e.props.updateLoadingSpinnerState(!0)}}),this.eventManager.listen(this.player,this.player.Event.AD_BREAK_START,function(){e.props.updateLoadingSpinnerState(!0)}),this.eventManager.listen(this.player,this.player.Event.AD_LOADED,function(){e.props.updateLoadingSpinnerState(!0)}),this.eventManager.listen(this.player,this.player.Event.AD_STARTED,function(){e.props.adIsLinear&&e.props.updateLoadingSpinnerState(!1)}),this.eventManager.listen(this.player,this.player.Event.ALL_ADS_COMPLETED,function(){e.props.updateLoadingSpinnerState(!1)}),this.eventManager.listen(this.player,this.player.Event.AUTOPLAY_FAILED,function(){e.props.updateLoadingSpinnerState(!1)}),this.eventManager.listen(this.player,this.player.Event.PLAYING,function(){e.setState({afterPlayingEvent:!0}),e.props.updateLoadingSpinnerState(!1)}),this.eventManager.listen(this.player,this.player.Event.CHANGE_SOURCE_STARTED,function(){e.setState({afterPlayingEvent:!1})})}},{key:"render",value:function(e){if(e.show)return(0,k.h)("div",{className:[h.default.loadingBackdrop,h.default.show].join(" ")},(0,k.h)("div",{className:h.default.spinnerContainer},(0,k.h)("div",{className:h.default.spinner},[].concat(r(Array(8))).map(function(e){return(0,k.h)("span",{key:e})}))))}}]),t}(b.default))||p;t.Loading=g},function(e,t,n){"use strict";function a(e){return(0,i.h)("div",{className:o.default.playbackGuiWWrapper},(0,i.h)(g.KeyboardControl,{player:e.player,config:e.config}),(0,i.h)(p.Loading,{player:e.player}),(0,i.h)("div",{className:o.default.playerGui,id:"player-gui"},(0,i.h)(m.OverlayPortal,null),(0,i.h)(_.UnmuteIndication,{player:e.player}),(0,i.h)(s.OverlayAction,{player:e.player}),(0,i.h)(T.PlaybackControls,{player:e.player}),(0,i.h)(M.ShareControl,{player:e.player}),x.PlaylistNextScreen.shouldRender(e)?(0,i.h)(x.PlaylistNextScreen,{player:e.player}):void 0,(0,i.h)(b.BottomBar,null,(0,i.h)(u.SeekBarPlaybackContainer,{showFramePreview:!0,showTimeBubble:!0,player:e.player,playerContainer:e.playerContainer}),(0,i.h)("div",{className:o.default.leftControls},(0,i.h)(T.PlaybackControls,{player:e.player}),(0,i.h)(c.RewindControl,{player:e.player,step:10}),(0,i.h)(v.TimeDisplayPlaybackContainer,{format:"current / total"})),(0,i.h)("div",{className:o.default.rightControls},y.VrStereoToggleControl.shouldRender(e)?(0,i.h)(y.VrStereoToggleControl,{player:e.player}):void 0,(0,i.h)(h.VolumeControl,{player:e.player}),(0,i.h)(d.LanguageControl,{player:e.player}),(0,i.h)(k.SettingsControl,{player:e.player}),(0,i.h)(E.CastControl,{player:e.player}),(0,i.h)(S.PictureInPicture,{player:e.player}),(0,i.h)(f.FullscreenControl,{player:e.player})))),w.Watermark.shouldRender(e)?(0,i.h)(w.Watermark,{player:e.player}):void 0,C.PlaylistCountdown.shouldRender(e)?(0,i.h)(C.PlaylistCountdown,{player:e.player}):void 0,(0,i.h)(l.PrePlaybackPlayOverlay,{player:e.player}),(0,i.h)(P.CastBeforePlay,{player:e.player}),(0,i.h)(A.PictureInPictureOverlay,{player:e.player}),(0,i.h)(O.Backdrop,null))}Object.defineProperty(t,"__esModule",{value:!0}),t.playbackUI=a;var r=n(1),o=function(e){return e&&e.__esModule?e:{default:e}}(r),i=n(0),s=n(36),l=n(38),p=n(15),c=n(66),u=n(67),h=n(22),k=n(43),d=n(47),f=n(23),y=n(48),v=n(72),b=n(24),m=n(50),g=n(25),_=n(26),w=n(51),E=n(52),P=n(53),O=n(73),T=n(27),C=n(157),x=n(76),S=n(54),A=n(77),M=n(55)},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.OverlayAction=t.OVERLAY_ACTION_DEFAULT_TIMEOUT=void 0;var s,l,p=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),c=n(0),u=n(1),h=a(u),k=n(2),d=n(7),f=n(21),y=n(8),v=n(3),b=a(v),m=n(4),g=a(m),_=n(37),w=function(e){return{isPlayingAdOrPlayback:(0,_.isPlayingAdOrPlayback)(e.engine),iconType:e.overlayAction.iconType,playerHover:e.shell.playerHover,isMobile:e.shell.isMobile,isSmartContainerOpen:e.shell.smartContainerOpen}},E=t.OVERLAY_ACTION_DEFAULT_TIMEOUT=300,P=(s=(0,k.connect)(w,(0,d.bindActions)(Object.assign({},f.actions,y.actions))))(l=function(e){function t(e){r(this,t);var n=o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,{name:"OverlayAction",player:e.player}));return n._iconTimeout=null,n._pointerDownPosX=NaN,n._pointerDownPosY=NaN,n._firstClickTime=0,n._clickTimeout=0,n}return i(t,e),p(t,[{key:"togglePlayPause",value:function(){this.props.isPlayingAdOrPlayback?(this.player.pause(),this.props.updateOverlayActionIcon(m.IconType.Pause)):(this.player.play(),this.props.updateOverlayActionIcon(m.IconType.Play)),this.props.updatePlayerHoverState(!0),this.notifyClick({type:"PlayPause"})}},{key:"toggleFullscreen",value:function(){this.player.isFullscreen()?(this.logger.debug("Exit fullscreen"),this.player.exitFullscreen()):(this.logger.debug("Enter fullscreen"),this.player.enterFullscreen()),this.notifyClick({type:"Fullscreen"})}},{key:"onOverlayPointerDown",value:function(e){this._pointerDownPosX=e.clientX||e.changedTouches&&e.changedTouches[0]&&e.changedTouches[0].clientX,this._pointerDownPosY=e.clientY||e.changedTouches&&e.changedTouches[0]&&e.changedTouches[0].clientY}},{key:"onOverlayMouseUp",value:function(e){this.isDragging(e)||this.overlayClick()}},{key:"onOverlayTouchEnd",value:function(e){e.preventDefault(),this.props.playerHover&&!this.isDragging(e)&&this.togglePlayPause()}},{key:"isDragging",value:function(e){var t={clientX:e.clientX||e.changedTouches&&e.changedTouches[0]&&e.changedTouches[0].clientX,clientY:e.clientY||e.changedTouches&&e.changedTouches[0]&&e.changedTouches[0].clientY};return Math.abs(t.clientX-this._pointerDownPosX)>5||Math.abs(t.clientY-this._pointerDownPosY)>5}},{key:"overlayClick",value:function(){var e=this;if(!this.props.isSmartContainerOpen){var t=Date.now();if(t-this._firstClickTime<200)return this.cancelClickTimeout(),void this.toggleFullscreen();if(t-this._firstClickTime<500)return this.cancelClickTimeout(),this.togglePlayPause(),this.toggleFullscreen(),void(this._firstClickTime=0);this._firstClickTime=t,this._clickTimeout=setTimeout(function(){e._clickTimeout=null,e.togglePlayPause()},200)}}},{key:"cancelClickTimeout",value:function(){this._clickTimeout&&(clearTimeout(this._clickTimeout),this._clickTimeout=null)}},{key:"shouldComponentUpdate",value:function(e){return e.iconType&&this.toggleOverlayActionIcon(e.iconType),!0}},{key:"toggleOverlayActionIcon",value:function(e){var t=this;null!==this._iconTimeout&&(clearTimeout(this._iconTimeout),this._iconTimeout=null,this.setState({animation:!1}),this.forceUpdate()),this.setState({animation:!0,iconType:e}),this._iconTimeout=setTimeout(function(){t.setState({animation:!1})},E)}},{key:"render",value:function(){var e=this;return(0,c.h)("div",{className:h.default.overlayAction+" "+(this.state.animation?h.default.in:""),onMouseDown:function(t){return e.onOverlayPointerDown(t)},onTouchStart:function(t){return e.onOverlayPointerDown(t)},onMouseUp:function(t){return e.onOverlayMouseUp(t)},onTouchEnd:function(t){return e.onOverlayTouchEnd(t)}},this.state.animation?this.renderIcons():void 0)}},{key:"renderIcons",value:function(){return Array.isArray(this.state.iconType)?this.state.iconType.map(function(e,t){return(0,c.h)(g.default,{key:t,type:e})}):(0,c.h)(g.default,{type:this.state.iconType})}},{key:"componentDidUpdate",value:function(){this.state.animation&&this.props.updateOverlayActionIcon(null)}}]),t}(b.default))||l;t.OverlayAction=P},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.PrePlaybackPlayOverlay=void 0;var s,l,p=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),c=n(1),u=a(c),h=n(0),k=n(2),d=n(7),f=n(3),y=a(f),v=n(4),b=a(v),m=n(6),g=n(14),_=n(5),w=function(e){return{prePlayback:e.engine.prePlayback,isPlaybackEnded:e.engine.isPlaybackEnded,playlist:e.engine.playlist,loading:e.loading.show}},E=(s=(0,k.connect)(w,(0,d.bindActions)(Object.assign({},g.actions))))(l=function(e){function t(e){return r(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,{name:"PrePlaybackPlayOverlay",player:e.player}))}return i(t,e),p(t,[{key:"handleClick",value:function(){this.player.getView().focus(),this.props.playlist&&this.props.isPlaybackEnded?this.player.playlist.playNext():this.player.play(),this.notifyClick()}},{key:"render",value:function(e){var t=this;if(!(!e.prePlayback&&(!e.isPlaybackEnded||e.playlist&&e.playlist.next)||e.loading))return(0,h.h)("div",{className:u.default.prePlaybackPlayOverlay,onMouseOver:function(e){return e.stopPropagation()},onClick:function(){return t.handleClick()}},(0,h.h)(_.Localizer,null,(0,h.h)("a",{className:u.default.prePlaybackPlayButton,tabIndex:"0","aria-label":(0,h.h)(_.Text,{id:e.isPlaybackEnded?"controls.startOver":"controls.play"}),onKeyDown:function(e){e.keyCode===m.KeyMap.ENTER&&t.handleClick()}},e.isPlaybackEnded?(0,h.h)(b.default,{type:v.IconType.StartOver}):(0,h.h)(b.default,{type:v.IconType.Play}))))}}]),t}(y.default))||l;t.PrePlaybackPlayOverlay=E},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.RewindControl=t.REWIND_DEFAULT_STEP=void 0;var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),l=n(1),p=a(l),c=n(0),u=n(5),h=n(3),k=a(h),d=n(4),f=a(d),y=n(6),v=t.REWIND_DEFAULT_STEP=10,b=function(e){function t(e){return r(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,{name:"Rewind",player:e.player}))}return i(t,e),s(t,[{key:"onClick",value:function(){this.animate();var e=void 0,t=this.props.step||v,n=this.player.currentTime;e=this.player.currentTime-t<0?0:this.player.currentTime-t,this.player.currentTime=e,this.notifyClick({from:n,to:e})}},{key:"animate",value:function(){this.setState({animation:!1}),this.forceUpdate(),this.setState({animation:!0})}},{key:"render",value:function(e){var t=this;return(0,c.h)("div",{className:[p.default.controlButtonContainer,p.default.controlRewind].join(" ")},(0,c.h)(u.Localizer,null,(0,c.h)("button",{tabIndex:"0","aria-label":(0,c.h)(u.Text,{id:"controls.rewind"}),className:p.default.controlButton+" "+(this.state.animation?p.default.rotate:""),onClick:function(){return t.onClick()},onKeyDown:function(e){e.keyCode===y.KeyMap.ENTER&&t.onClick()}},(0,c.h)(f.default,{type:e.step&&e.step!==v?d.IconType.Rewind:d.IconType.Rewind10}))))}}]),t}(k.default);t.RewindControl=b},function(e,t,n){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function r(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.SeekBarPlaybackContainer=void 0;var i,s,l=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),p=n(0),c=n(2),u=n(7),h=n(18),k=n(3),d=function(e){return e&&e.__esModule?e:{default:e}}(k),f=n(39),y=function(e){return{currentTime:e.seekbar.currentTime,duration:e.engine.duration,isDraggingActive:e.seekbar.draggingActive,isMobile:e.shell.isMobile,poster:e.engine.poster}},v=(i=(0,c.connect)(y,(0,u.bindActions)(h.actions)))(s=function(e){function t(e){return a(this,t),r(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,{name:"SeekBarPlaybackContainer",player:e.player}))}return o(t,e),l(t,[{key:"componentDidMount",value:function(){var e=this;this.eventManager.listen(this.player,this.player.Event.TIME_UPDATE,function(){e.props.isDraggingActive||e.props.updateCurrentTime(e.player.currentTime)})}},{key:"render",value:function(){var e=this;return(0,p.h)(f.SeekBarControl,{player:this.props.player,playerElement:this.props.playerContainer,showFramePreview:this.props.showFramePreview,showTimeBubble:this.props.showTimeBubble,changeCurrentTime:function(t){return e.player.currentTime=t},playerPoster:this.props.poster,updateSeekbarDraggingStatus:function(t){return e.props.updateSeekbarDraggingStatus(t)},updateSeekbarHoverActive:function(t){return e.props.updateSeekbarHoverActive(t)},updateCurrentTime:function(t){return e.props.updateCurrentTime(t)},currentTime:this.props.currentTime,duration:this.props.duration,isDraggingActive:this.props.isDraggingActive,isMobile:this.props.isMobile,notifyChange:function(t){return e.notifyChange(t)}})}}]),t}(d.default))||s;t.SeekBarPlaybackContainer=v},function(e,t,n){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function r(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.SeekBarControl=void 0;var i,s,l=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),p=n(1),c=function(e){return e&&e.__esModule?e:{default:e}}(p),u=n(0),h=n(40),k=n(6),d=n(2),f=n(7),y=n(8),v=n(41),b=n(42),m=function(e){return{config:e.config.components.seekbar,isMobile:e.shell.isMobile}},g=(i=(0,d.connect)(m,(0,f.bindActions)(y.actions)))(s=function(e){function t(){a(this,t);var e=r(this,(t.__proto__||Object.getPrototypeOf(t)).call(this));return e.onPlayerMouseUp=(0,b.bindMethod)(e,e.onPlayerMouseUp),e.onPlayerMouseMove=(0,b.bindMethod)(e,e.onPlayerMouseMove),e}return o(t,e),l(t,[{key:"componentWillMount",value:function(){this.setState({virtualTime:0})}},{key:"componentDidMount",value:function(){document.addEventListener("mouseup",this.onPlayerMouseUp),document.addEventListener("mousemove",this.onPlayerMouseMove)}},{key:"componentWillUnmount",value:function(){document.removeEventListener("mouseup",this.onPlayerMouseUp),document.removeEventListener("mousemove",this.onPlayerMouseMove)}},{key:"onSeekbarMouseDown",value:function(e){if(!this.props.isMobile&&(e.preventDefault(),this.props.updateSeekbarDraggingStatus(!0),this.props.isDraggingActive)){var t=this.getTime(e);this.updateSeekBarProgress(t,this.props.duration)}}},{key:"onTap",value:function(e){if(this.props.isMobile){var t=this.props.player.currentTime,n=this.getTime(e);this.props.changeCurrentTime(n),this.updateSeekBarProgress(n,this.props.duration),this.props.updateSeekbarDraggingStatus(!1),this.props.notifyChange({from:t,to:n})}}},{key:"onPlayerMouseUp",value:function(e){if(!this.props.isMobile&&this.props.isDraggingActive){var t=this.props.player.currentTime,n=this.getTime(e);this.props.changeCurrentTime(n),this.updateSeekBarProgress(n,this.props.duration),this.props.updateSeekbarDraggingStatus(!1),this.props.notifyChange({from:t,to:n})}}},{key:"onPlayerMouseMove",value:function(e){if(!this.props.isMobile&&this.props.isDraggingActive){var t=this.getTime(e);this.updateSeekBarProgress(t,this.props.duration),this.updateSeekBarProgress(t,this.props.duration,!0)}}},{key:"onSeekbarMouseMove",value:function(e){if(!this.props.isMobile){var t=this.getTime(e);this.updateSeekBarProgress(t,this.props.duration,!0)}}},{key:"onSeekbarTouchStart",value:function(e){if(this.props.updateSeekbarDraggingStatus(!0),this.props.isDraggingActive){var t=this.getTime(e);this.updateSeekBarProgress(t,this.props.duration)}}},{key:"onSeekbarTouchMove",value:function(e){var t=this.getTime(e);this._movex=t,this.updateSeekBarProgress(t,this.props.duration,!0),this.props.isDraggingActive&&this.updateSeekBarProgress(t,this.props.duration),e.preventDefault()}},{key:"onSeekbarKeyDown",value:function(e){var t=this;if(!this.props.adBreak){var n=function(e,n){t.props.player.currentTime=n,t.updateSeekBarProgress(t.props.player.currentTime,t.props.duration,!0),t.props.notifyChange({from:e,to:n})},a=void 0;switch(e.keyCode){case k.KeyMap.LEFT:a=this.props.player.currentTime-v.KEYBOARD_DEFAULT_SEEK_JUMP>0?this.props.player.currentTime-5:0,n(this.props.player.currentTime,a);break;case k.KeyMap.RIGHT:a=this.props.player.currentTime+v.KEYBOARD_DEFAULT_SEEK_JUMP>this.props.player.duration?this.props.player.duration:this.props.player.currentTime+5,n(this.props.player.currentTime,a)}}}},{key:"onSeekbarTouchEnd",value:function(){if(this.props.isDraggingActive){var e=this.props.player.currentTime,t=this._movex;this.props.changeCurrentTime(t),this.updateSeekBarProgress(t,this.props.duration),this.props.notifyChange({from:e,to:t})}this.props.updateSeekbarDraggingStatus(!1)}},{key:"onSeekbarMouseOver",value:function(){this.props.isMobile||this.props.updateSeekbarHoverActive(!0)}},{key:"onSeekbarMouseLeave",value:function(){this.props.isMobile||this.props.updateSeekbarHoverActive(!1)}},{key:"updateSeekBarProgress",value:function(e,t){arguments.length>2&&void 0!==arguments[2]&&arguments[2]?this.setState({virtualTime:e}):this.props.updateCurrentTime(e)}},{key:"getOffset",value:function(e){for(var t=0,n=0;e&&!isNaN(e.offsetLeft)&&!isNaN(e.offsetTop);)t+=e.offsetLeft-e.scrollLeft+this._getTransformX(e),n+=e.offsetTop-e.scrollTop,e=e.offsetParent;return this.props.player.isFullscreen()&&(t=0),{top:n,left:t}}},{key:"_getTransformX",value:function(e){var t=getComputedStyle(e),n=t.getPropertyValue("transform")||t.getPropertyValue("-webkit-transform")||t.getPropertyValue("-moz-transform")||t.getPropertyValue("-ms-transform")||t.getPropertyValue("-o-transform"),a=n.match(/-?\d+/g),r=0;return a&&a.length>0&&(r=parseFloat(a[4])),r}},{key:"getTime",value:function(e){var t=e.touches?e.touches[0].clientX:e.clientX,n=this.props.duration*((t-this._seekBarElement.offsetLeft-this.getOffset(this.props.playerElement).left)/this._seekBarElement.clientWidth);return n=parseFloat(n.toFixed(2)),n<0?0:n>this.props.duration?this.props.duration:n}},{key:"getBufferedPercent",value:function(){if(this.props.player.duration>0&&this.props.player.buffered.length>0){var e=this.props.player.isLive()?this.props.player.buffered.end(0)-this.props.player.getStartTimeOfDvrWindow():this.props.player.buffered.end(0),t=e/this.props.player.duration*100;return t<100?t:100}return 0}},{key:"getThumbSpriteOffset",value:function(){var e=this.state.virtualTime/this.props.duration;return-Math.ceil(this.props.config.thumbsSlices*e)*this.props.config.thumbsWidth+"px 0px"}},{key:"getFramePreviewOffset",value:function(){if(this._seekBarElement&&this._framePreviewElement){var e=this.state.virtualTime/this.props.duration*this._seekBarElement.clientWidth-this._framePreviewElement.clientWidth/2;return e<0?0:e>this._seekBarElement.clientWidth-this._framePreviewElement.clientWidth?this._seekBarElement.clientWidth-this._framePreviewElement.clientWidth:e}return 0}},{key:"getTimeBubbleOffset",value:function(){if(this._timeBubbleElement){var e=this.state.virtualTime/this.props.duration*this._seekBarElement.clientWidth-this._timeBubbleElement.clientWidth/2;return e<0?0:e>this._seekBarElement.clientWidth-this._timeBubbleElement.clientWidth?this._seekBarElement.clientWidth-this._timeBubbleElement.clientWidth:e}return 0}},{key:"renderFramePreview",value:function(){var e=this;if(this.props.config.thumbsSprite&&this.props.config.thumbsSlices&&this.props.config.thumbsWidth&&this.props.showFramePreview&&!this.props.isMobile)return(0,u.h)("div",{className:c.default.framePreview,style:this._getFramePreviewStyle(),ref:function(t){return e._framePreviewElement=t}},(0,u.h)("div",{className:c.default.framePreviewImg,style:this._getFramePreviewImgStyle()}))}},{key:"_getFramePreviewImgStyle",value:function(){var e="background-image: url("+this.props.config.thumbsSprite+");";return e+="background-position: "+this.getThumbSpriteOffset()+";",e+="background-size: "+this.props.config.thumbsSlices*this.props.config.thumbsWidth+"px 100%;"}},{key:"_getFramePreviewStyle",value:function(){var e="left: "+this.getFramePreviewOffset()+"px;";return e+="width: "+this.props.config.thumbsWidth+"px;"}},{key:"renderTimeBubble",value:function(){var e=this;if(this.props.showTimeBubble&&!this.props.isMobile){var t="left: "+this.getTimeBubbleOffset()+"px",n=this.props.isDvr?"-"+(0,h.toHHMMSS)(this.props.duration-this.state.virtualTime):(0,h.toHHMMSS)(this.state.virtualTime);return(0,u.h)("div",{className:c.default.timePreview,style:t,ref:function(t){return e._timeBubbleElement=t}},n)}}},{key:"render",value:function(e){var t=this,n=this.state.virtualTime/e.duration*100+"%",a=e.currentTime/e.duration*100+"%",r=Math.round(this.getBufferedPercent())+"%",o=[c.default.seekBar];return e.adBreak&&o.push(c.default.adBreak),e.isDvr&&o.push(c.default.live),e.isMobile&&o.push(c.default.hover),e.isDraggingActive&&o.push(c.default.hover),(0,u.h)("div",{tabIndex:"0",className:o.join(" "),ref:function(e){return t._seekBarElement=e},role:"slider","aria-label":"Seek slider","aria-valuemin":"0","aria-valuemax":Math.round(this.props.duration),"aria-valuenow":Math.round(this.props.currentTime),"aria-valuetext":(0,h.toHHMMSS)(this.props.currentTime)+" of "+(0,h.toHHMMSS)(this.props.duration),onClick:function(e){return t.onTap(e)},onMouseOver:function(){return t.onSeekbarMouseOver()},onMouseLeave:function(){return t.onSeekbarMouseLeave()},onMouseMove:function(e){return t.onSeekbarMouseMove(e)},onMouseDown:function(e){return t.onSeekbarMouseDown(e)},onTouchStart:function(e){return t.onSeekbarTouchStart(e)},onTouchMove:function(e){return t.onSeekbarTouchMove(e)},onTouchEnd:function(){return t.onSeekbarTouchEnd()},onKeyDown:function(e){return t.onSeekbarKeyDown(e)}},(0,u.h)("div",{className:c.default.progressBar},this.renderFramePreview(),this.renderTimeBubble(),(0,u.h)("div",{className:c.default.virtualProgress,style:{width:n}}),(0,u.h)("div",{className:c.default.buffered,style:{width:r}}),(0,u.h)("div",{className:c.default.progress,style:{width:a}},e.adBreak?void 0:(0,u.h)("a",{className:c.default.scrubber}))))}}]),t}(u.Component))||s;t.SeekBarControl=g},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.VolumeControl=void 0;var s,l,p=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),c=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a])}return e},u=n(1),h=a(u),k=n(0),d=n(2),f=n(7),y=n(33),v=n(11),b=n(3),m=a(b),g=n(4),_=a(g),w=n(6),E=n(41),P=(n(9),function(e){return{isDraggingActive:e.volume.draggingActive,volume:e.engine.volume,muted:e.engine.muted,isMobile:e.shell.isMobile}}),O=(s=(0,d.connect)(P,(0,f.bindActions)(c({},y.actions,v.actions))))(l=function(e){function t(e){return r(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,{name:"Volume",player:e.player}))}return i(t,e),p(t,[{key:"componentDidMount",value:function(){var e=this;this.eventManager.listen(this.player,this.player.Event.LOADED_METADATA,function(){e.props.updateVolume(e.player.volume),e.props.updateMuted(e.player.muted)}),this.eventManager.listen(this.player,this.player.Event.VOLUME_CHANGE,function(){e.props.updateMuted(e.player.muted),e.props.updateVolume(e.player.volume)}),this.eventManager.listen(document,"mouseup",function(t){return e.onVolumeProgressBarMouseUp(t)}),this.eventManager.listen(document,"mousemove",function(t){return e.onVolumeProgressBarMouseMove(t)})}},{key:"getVolumeProgressHeight",value:function(){return this.props.muted?"0%":Math.round(100*this.props.volume)+"%"}},{key:"onVolumeProgressBarMouseDown",value:function(){this.props.updateVolumeDraggingStatus(!0)}},{key:"onVolumeProgressBarMouseMove",value:function(e){this.props.isDraggingActive&&this.changeVolume(e)}},{key:"onVolumeMouseOver",value:function(){this.props.isMobile||(this.props.updateVolumeHover(!0),this.setState({hover:!0}))}},{key:"onVolumeMouseOut",value:function(){this.props.isMobile||(this.props.updateVolumeHover(!1),this.setState({hover:!1}))}},{key:"onVolumeControlKeyDown",value:function(e){var t=this,n=function(e){t.setState({hover:!0}),e>100||e<0||(t.player.muted=e<E.KEYBOARD_DEFAULT_VOLUME_JUMP,t.player.volume=e/100,t.notifyChange({volume:t.player.volume}))};switch(e.keyCode){case w.KeyMap.UP:n(Math.round(100*this.player.volume)+E.KEYBOARD_DEFAULT_VOLUME_JUMP);break;case w.KeyMap.DOWN:n(Math.round(100*this.player.volume)-E.KEYBOARD_DEFAULT_VOLUME_JUMP);break;default:this.setState({hover:!1})}}},{key:"onVolumeProgressBarMouseUp",value:function(e){this.props.isDraggingActive&&(this.props.updateVolumeDraggingStatus(!1),this.changeVolume(e))}},{key:"onVolumeControlButtonClick",value:function(){0==this.player.volume?(this.logger.debug("Toggle mute. Volume is 0, set mute to false & volume to 0.5"),this.player.muted=!1,this.player.volume=.5):(this.logger.debug("Toggle mute. "+this.player.muted+" => "+!this.player.muted),this.player.muted=!this.player.muted),this.notifyClick()}},{key:"changeVolume",value:function(e){var t=this._volumeProgressBarElement.getBoundingClientRect(),n=void 0;n=t.height>t.width?this._getVerticalVolume(t,e):this._getHorizontalVolume(t,e),(n=parseFloat(n.toFixed(2)))<=1&&n>=0&&(this.logger.debug("Change volume from "+this.player.volume+" => "+n),this.player.volume=n,this.props.muted&&(this.player.muted=!1),this.notifyChange({volume:this.player.volume}))}},{key:"_getHorizontalVolume",value:function(e,t){var n=e.width,a=e.left,r=t.clientX;return 0!=n?(r-a)/n:0}},{key:"_getVerticalVolume",value:function(e,t){var n=e.height,a=e.top,r=t.clientY;return 0!=n?1-(r-a)/n:0}},{key:"render",value:function(){var e=this,t=[h.default.controlButtonContainer,h.default.volumeControl];return this.props.isDraggingActive&&t.push(h.default.draggingActive),(this.props.muted||0===this.props.volume)&&t.push(h.default.isMuted),this.state.hover&&!this.props.smartContainerOpen&&t.push(h.default.hover),(0,k.h)("div",{ref:function(t){return e._volumeControlElement=t},className:t.join(" "),onMouseOver:function(){return e.onVolumeMouseOver()},onMouseOut:function(){return e.onVolumeMouseOut()}},(0,k.h)("button",{tabIndex:"0","aria-label":"Volume",className:h.default.controlButton,onClick:function(){return e.onVolumeControlButtonClick()},onKeyDown:function(t){return e.onVolumeControlKeyDown(t)}},(0,k.h)(_.default,{type:g.IconType.VolumeBase}),(0,k.h)(_.default,{type:g.IconType.VolumeWaves}),(0,k.h)(_.default,{type:g.IconType.VolumeMute})),(0,k.h)("div",{className:h.default.volumeControlBar,role:"slider","aria-valuemin":"0","aria-valuemaz":"100","aria-valuenow":100*this.player.volume,"aria-valuetext":100*this.player.volume+"% volume "+(this.player.muted?"muted":"")},(0,k.h)("div",{className:h.default.bar,ref:function(t){return e._volumeProgressBarElement=t},onMouseDown:function(){return e.onVolumeProgressBarMouseDown()}},(0,k.h)("div",{className:h.default.progress,style:{height:this.getVolumeProgressHeight()}}))))}}]),t}(m.default))||l;t.VolumeControl=O},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.SettingsControl=void 0;var s,l,p=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),c=n(1),u=a(c),h=n(0),k=n(5),d=n(2),f=n(7),y=n(34),v=n(3),b=a(v),m=n(44),g=n(68),_=n(4),w=a(_),E=n(10),P=function(e){return{videoTracks:e.engine.videoTracks,isMobile:e.shell.isMobile,isLive:e.engine.isLive,playerSize:e.shell.playerSize}},O=(s=(0,d.connect)(P,(0,f.bindActions)(y.actions)))(l=function(e){function t(e){return r(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,{name:"Settings",player:e.player}))}return i(t,e),p(t,[{key:"componentWillMount",value:function(){this.setState({smartContainerOpen:!1})}},{key:"componentDidMount",value:function(){var e=this;this.eventManager.listen(document,"click",function(t){return e.handleClickOutside(t)})}},{key:"handleClickOutside",value:function(e){this.props.isMobile||[E.PLAYER_SIZE.SMALL,E.PLAYER_SIZE.EXTRA_SMALL].includes(this.props.playerSize)||!this._controlSettingsElement||this._controlSettingsElement.contains(e.target)||!this.state.smartContainerOpen||(e.target.classList.contains(u.default.overlayPlay)&&e.stopPropagation(),this.setState({smartContainerOpen:!1}))}},{key:"onControlButtonClick",value:function(){this.setState({smartContainerOpen:!this.state.smartContainerOpen})}},{key:"onSpeedChange",value:function(e){this.props.updateSpeed(e),this.player.playbackRate=e,this.notifyClick({speed:e})}},{key:"onQualityChange",value:function(e){"auto"===e?this.player.enableAdaptiveBitrate():this.player.selectTrack(e),this.notifyClick({type:this.player.Track.VIDEO,track:e})}},{key:"filterUniqueQualities",value:function(e,t){var n=e.length-1,a=e[n];return n>-1&&t.label===a.label?t.bandwidth>a.bandwidth&&(e[n]=t):e.push(t),e}},{key:"render",value:function(e){var t=this,n=this.player.playbackRates.reduce(function(e,n){var a={value:n,label:1===n?"Normal":n,active:!1};return n===t.player.playbackRate&&(a.active=!0),e.push(a),e},[]),a=e.videoTracks.sort(function(e,t){return e.bandwidth<t.bandwidth?1:-1}).filter(function(e){return e.bandwidth||e.height}).reduce(this.filterUniqueQualities,[]).map(function(e){return{label:e.label,active:!t.player.isAdaptiveBitrateEnabled()&&e.active,value:e}});if(a.length>1&&"progressive"!==this.player.streamType&&a.unshift({label:"Auto",active:this.player.isAdaptiveBitrateEnabled(),value:"auto"}),!(a.length<=1&&n.length<=1||e.isLive&&a.length<=1))return(0,h.h)("div",{ref:function(e){return t._controlSettingsElement=e},className:[u.default.controlButtonContainer,u.default.controlSettings].join(" ")},(0,h.h)(k.Localizer,null,(0,h.h)("button",{tabIndex:"0","aria-label":(0,h.h)(k.Text,{id:"controls.settings"}),className:this.state.smartContainerOpen?[u.default.controlButton,u.default.active].join(" "):u.default.controlButton,onClick:function(){return t.onControlButtonClick()}},(0,h.h)(w.default,{type:_.IconType.Settings}))),this.state.smartContainerOpen?(0,h.h)(m.SmartContainer,{targetId:this.player.config.targetId,title:(0,h.h)(k.Text,{id:"settings.title"}),onClose:function(){return t.onControlButtonClick()}},a.length<=1?"":(0,h.h)(k.Localizer,null,(0,h.h)(g.SmartContainerItem,{icon:"quality",label:(0,h.h)(k.Text,{id:"settings.quality"}),options:a,onSelect:function(e){return t.onQualityChange(e)}})),e.isLive||n.length<=1?"":(0,h.h)(k.Localizer,null,(0,h.h)(g.SmartContainerItem,{icon:"speed",label:(0,h.h)(k.Text,{id:"settings.speed"}),options:n,onSelect:function(e){return t.onSpeedChange(e)}}))):"")}}]),t}(b.default))||l;t.SettingsControl=O},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.SmartContainer=void 0;var s,l,p=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),c=n(1),u=a(c),h=n(0),k=n(2),d=n(7),f=n(8),y=n(45),v=a(y),b=n(17),m=n(6),g=n(10),_=function(e){return{isMobile:e.shell.isMobile,playerSize:e.shell.playerSize}},w=(s=(0,k.connect)(_,(0,d.bindActions)(f.actions)))(l=function(e){function t(){return r(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),p(t,[{key:"componentWillMount",value:function(){this.props.addPlayerClass(u.default.smartContainerOpen),this.props.updateSmartContainerOpen(!0)}},{key:"componentWillUnmount",value:function(){this.props.removePlayerClass(u.default.smartContainerOpen),this.props.updateSmartContainerOpen(!1)}},{key:"render",value:function(e){var t=this,n="#"+this.props.targetId+" .overlay-portal";return e.isMobile||[g.PLAYER_SIZE.SMALL,g.PLAYER_SIZE.EXTRA_SMALL].includes(this.props.playerSize)?(0,h.h)(v.default,{into:n,ref:function(e){return t._portal=e}},(0,h.h)(b.Overlay,{open:!0,onClose:function(){return e.onClose()}},(0,h.h)("div",{className:u.default.title},e.title),e.children)):(0,h.h)("div",{tabIndex:"-1",className:[u.default.smartContainer,u.default.top,u.default.left].join(" "),onKeyDown:function(t){t.keyCode===m.KeyMap.ESC&&e.onClose()}},e.children)}}]),t}(h.Component))||l;t.SmartContainer=w},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.Overlay=void 0;var s,l,p=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),c=n(1),u=a(c),h=n(0),k=n(5),d=n(2),f=n(7),y=n(8),v=n(4),b=a(v),m=n(6),g=(s=(0,d.connect)(null,(0,f.bindActions)(y.actions)))(l=function(e){function t(){return r(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),p(t,[{key:"componentWillMount",value:function(){this.props.addPlayerClass(u.default.overlayActive)}},{key:"componentWillUnmount",value:function(){this.props.removePlayerClass(u.default.overlayActive)}},{key:"renderCloseButton",value:function(e){return e.permanent?void 0:(0,h.h)(k.Localizer,null,(0,h.h)("a",{onClick:function(){return e.onClose()},"aria-label":(0,h.h)(k.Text,{id:"overlay.close"}),className:u.default.closeOverlay},(0,h.h)(b.default,{type:v.IconType.Close})))}},{key:"render",value:function(e){var t=[u.default.overlay];return e.type&&t.push(u.default[e.type+"-overlay"]),e.open&&t.push(u.default.active),(0,h.h)("div",{tabIndex:"-1",className:t.join(" "),role:"dialog",onKeyDown:function(t){t.keyCode===m.KeyMap.ESC&&e.onClose()}},(0,h.h)("div",{className:u.default.overlayContents},e.children),this.renderCloseButton(e))}}]),t}(h.Component))||l;t.Overlay=g},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.DropDown=void 0;var s,l,p=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),c=n(1),u=a(c),h=n(0),k=n(2),d=n(69),f=n(4),y=a(f),v=n(6),b=n(10),m=function(e){return{isMobile:e.shell.isMobile,playerSize:e.shell.playerSize}},g=(s=(0,k.connect)(m))(l=function(e){function t(){return r(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),p(t,[{key:"componentWillMount",value:function(){this.setState({dropMenuActive:!1})}},{key:"isSelected",value:function(e){return e.active}},{key:"onSelect",value:function(e){this.props.onSelect(e),this.setState({dropMenuActive:!1})}},{key:"onKeyDown",value:function(e){switch(e.keyCode){case v.KeyMap.ENTER:this.setState({dropMenuActive:!this.state.dropMenuActive});break;case v.KeyMap.ESC:this.onClose(),e.stopPropagation()}}},{key:"onClose",value:function(){this.setState({dropMenuActive:!1})}},{key:"getActiveOptionLabel",value:function(){var e=this.props.options.filter(function(e){return e.active});try{return e[0].label}catch(e){return this.props.options[0].label||"Unlabled"}}},{key:"renderNativeSelect",value:function(){var e=this;return(0,h.h)(d.Menu,{options:this.props.options,onSelect:function(t){return e.onSelect(t)},onClose:function(){return e.onClose()}})}},{key:"render",value:function(e){var t=this;return e.isMobile||[b.PLAYER_SIZE.SMALL,b.PLAYER_SIZE.EXTRA_SMALL].includes(this.props.playerSize)?this.renderNativeSelect():(0,h.h)("div",{name:e.name,className:this.state.dropMenuActive?[u.default.dropdown,u.default.active].join(" "):u.default.dropdown,ref:function(e){return t._el=e}},(0,h.h)("div",{tabIndex:"0",className:u.default.dropdownButton,onClick:function(){return t.setState({dropMenuActive:!t.state.dropMenuActive})},onKeyDown:function(e){return t.onKeyDown(e)}},(0,h.h)("span",null,this.getActiveOptionLabel()),(0,h.h)(y.default,{type:f.IconType.ArrowDown})),this.state.dropMenuActive?(0,h.h)(d.Menu,{parentEl:this._el,options:e.options,onSelect:function(e){return t.onSelect(e)},onClose:function(){return t.onClose()}}):void 0)}}]),t}(h.Component))||l;t.DropDown=g},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function r(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.Menu=void 0;var l,p,c=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),u=n(1),h=a(u),k=n(0),d=n(4),f=a(d),y=n(2),v=n(6),b=n(42),m=n(10),g=function(e){return{isMobile:e.shell.isMobile,playerClientRect:e.shell.playerClientRect,playerSize:e.shell.playerSize}},_=(l=(0,y.connect)(g))(p=function(e){function t(){o(this,t);var e=i(this,(t.__proto__||Object.getPrototypeOf(t)).call(this));return e.handleClickOutside=(0,b.bindMethod)(e,e.handleClickOutside),e}return s(t,e),c(t,[{key:"componentWillMount",value:function(){this.setState({position:[h.default.top,h.default.left]})}},{key:"componentDidMount",value:function(){document.addEventListener("click",this.handleClickOutside,!0),this.props.isMobile||[m.PLAYER_SIZE.SMALL,m.PLAYER_SIZE.EXTRA_SMALL].includes(this.props.playerSize)||this.setState({position:this.getPosition()})}},{key:"componentWillUnmount",value:function(){document.removeEventListener("click",this.handleClickOutside)}},{key:"getPosition",value:function(){var e=this._menuElement.getBoundingClientRect(),t=this.props.playerClientRect;return e.top>=t.top?[h.default.top,h.default.left]:e.bottom+e.height<t.bottom?[h.default.bottom,h.default.left]:(this._menuElement.style.maxHeight=.8*t.height+"px",[h.default.stickBottom,h.default.left])}},{key:"handleClickOutside",value:function(e){this.props.isMobile||[m.PLAYER_SIZE.SMALL,m.PLAYER_SIZE.EXTRA_SMALL].includes(this.props.playerSize)||!this._menuElement||this._menuElement.contains(e.target)||this.props.onClose()}},{key:"isSelected",value:function(e){return e.active}},{key:"onSelect",value:function(e){this.props.onSelect(e.value),this.props.options.filter(function(e){return e.active}).forEach(function(e){e.active=!1}),this.props.options.filter(function(t){return t.value===e.value})[0].active=!0}},{key:"onKeyDown",value:function(e,t){switch(e.keyCode){case v.KeyMap.ENTER:this.onSelect(t);break;case v.KeyMap.ESC:this.props.onClose(),e.stopPropagation()}}},{key:"getActiveOptionLabel",value:function(){var e=this.props.options.filter(function(e){return e.active});return e.length>0?e[0].label:this.props.options[0].label}},{key:"renderNativeSelect",value:function(){var e=this,t=this.props.hideSelect?h.default.mobileHiddenSelect:"";return t+=" "+h.default.dropdown,(0,k.h)("select",{className:t,onChange:function(t){return e.onSelect(e.props.options[t.target.value])}},this.props.options.map(function(t,n){return(0,k.h)("option",{selected:e.isSelected(t),value:n,key:n},t.label)}))}},{key:"render",value:function(e){var t=this;return e.isMobile||[m.PLAYER_SIZE.SMALL,m.PLAYER_SIZE.EXTRA_SMALL].includes(this.props.playerSize)?this.renderNativeSelect():(0,k.h)("div",{ref:function(e){return t._menuElement=e},className:[h.default.dropdownMenu].concat(r(this.state.position)).join(" ")},e.options.map(function(e,n){return(0,k.h)("div",{tabIndex:"",key:n,className:t.isSelected(e)?[h.default.dropdownMenuItem,h.default.active].join(" "):h.default.dropdownMenuItem,onClick:function(){return t.onSelect(e)},onKeyDown:function(n){return t.onKeyDown(n,e)}},(0,k.h)("span",null,e.label),(0,k.h)("span",{className:h.default.menuIconContainer,style:"opacity: "+(t.isSelected(e)?1:0)},(0,k.h)(f.default,{type:d.IconType.Check})))}))}}]),t}(k.Component))||p;t.Menu=_},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.LanguageControl=void 0;var s,l,p=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),c=n(1),u=a(c),h=n(0),k=n(5),d=n(2),f=n(7),y=n(20),v=n(3),b=a(v),m=n(44),g=n(68),_=n(4),w=a(_),E=n(70),P=n(45),O=a(P),T=n(6),C=n(10),x=function(e){return{audioTracks:e.engine.audioTracks,textTracks:e.engine.textTracks,overlayOpen:e.cvaa.overlayOpen,isMobile:e.shell.isMobile,playerSize:e.shell.playerSize}},S=(s=(0,d.connect)(x,(0,f.bindActions)(y.actions)))(l=function(e){function t(e){return r(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,{name:"LanguageControl",player:e.player}))}return i(t,e),p(t,[{key:"componentWillMount",value:function(){this.setState({smartContainerOpen:!1})}},{key:"componentDidMount",value:function(){var e=this;this.eventManager.listen(document,"click",function(t){return e.handleClickOutside(t)})}},{key:"handleClickOutside",value:function(e){!this._controlLanguageElement||this.props.isMobile||this._controlLanguageElement.contains(e.target)||!this.state.smartContainerOpen||this.state.cvaaOverlay||[C.PLAYER_SIZE.SMALL,C.PLAYER_SIZE.EXTRA_SMALL].includes(this.props.playerSize)||(e.target.classList.contains("overlay-action")&&e.stopPropagation(),this.setState({smartContainerOpen:!1}))}},{key:"onControlButtonClick",value:function(){this.setState({smartContainerOpen:!this.state.smartContainerOpen})}},{key:"onAudioChange",value:function(e){this.player.selectTrack(e),this.notifyClick({type:this.player.Track.AUDIO,track:e})}},{key:"onCaptionsChange",value:function(e){this.player.selectTrack(e),this.notifyClick({type:this.player.Track.TEXT,track:e})}},{key:"toggleCVAAOverlay",value:function(){this.setState({cvaaOverlay:!this.state.cvaaOverlay})}},{key:"renderAll",value:function(e,t){var n=this,a="#"+this.player.config.targetId+" .overlay-portal";return(0,h.h)("div",{ref:function(e){return n._controlLanguageElement=e},className:[u.default.controlButtonContainer,u.default.controlLanguage].join(" ")},(0,h.h)(k.Localizer,null,(0,h.h)("button",{tabIndex:"0","aria-label":(0,h.h)(k.Text,{id:"controls.language"}),className:this.state.smartContainerOpen?[u.default.controlButton,u.default.active].join(" "):u.default.controlButton,onClick:function(){return n.onControlButtonClick()}},(0,h.h)(w.default,{type:_.IconType.Language}))),!this.state.smartContainerOpen||this.state.cvaaOverlay?void 0:(0,h.h)(m.SmartContainer,{targetId:this.player.config.targetId,title:(0,h.h)(k.Text,{id:"language.title"}),onClose:function(){return n.onControlButtonClick()}},e.length<=1?void 0:(0,h.h)(k.Localizer,null,(0,h.h)(g.SmartContainerItem,{icon:"audio",label:(0,h.h)(k.Text,{id:"language.audio"}),options:e,onSelect:function(e){return n.onAudioChange(e)}})),t.length<=1?void 0:(0,h.h)(k.Localizer,null,(0,h.h)(g.SmartContainerItem,{icon:"captions",label:(0,h.h)(k.Text,{id:"language.captions"}),options:t,onSelect:function(e){return n.onCaptionsChange(e)}})),t.length<=1?void 0:(0,h.h)("div",{tabIndex:"0",className:u.default.smartContainerItem,onKeyDown:function(e){e.keyCode===T.KeyMap.ENTER&&n.toggleCVAAOverlay()}},(0,h.h)("a",{className:u.default.advancedCaptionsMenuLink,onClick:function(){return n.toggleCVAAOverlay()}},(0,h.h)(k.Text,{id:"language.advanced_captions_settings"})))),this.state.cvaaOverlay?(0,h.h)(O.default,{into:a,ref:function(e){return n._portal=e}},(0,h.h)(E.CVAAOverlay,{player:this.player,onClose:function(){n.toggleCVAAOverlay(),n.onControlButtonClick()}})):(0,h.h)("div",null))}},{key:"render",value:function(e){var t=e.audioTracks.filter(function(e){return e.label||e.language}).map(function(e){return{label:e.label||e.language,active:e.active,value:e}}),n=e.textTracks.map(function(e){return{label:e.label||e.language,active:e.active,value:e}});return t.length>1||n.length>1?this.renderAll(t,n):void 0}}]),t}(b.default))||l;t.LanguageControl=S},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.CVAAOverlay=void 0;var s,l,p=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),c=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a])}return e},u=n(1),h=a(u),k=n(0),d=n(2),f=n(144),y=a(f),v=n(7),b=n(20),m=n(8),g=n(3),_=a(g),w=n(17),E=n(46),P=n(71),O=n(4),T=a(O),C=n(6),x=n(5),S=function(e){return{open:e.cvaa.overlayOpen,style:e.cvaa.style}},A={Main:"main",CustomCaptions:"custom-captions"},M=(s=(0,d.connect)(S,(0,v.bindActions)(c({},b.actions,m.actions))))(l=function(e){function t(){return r(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,{name:"CVAAOverlay"}))}return i(t,e),p(t,[{key:"componentWillUnmount",value:function(){this.setState({state:A.Main})}},{key:"componentWillMount",value:function(){this.setState({state:A.Main,customTextStyle:this.props.player.textStyle}),this.captionsStyleDefault=Object.assign(new this.props.player.TextStyle,{backgroundOpacity:this.props.player.TextStyle.StandardOpacities.TRANSPARENT}),this.captionsStyleYellow=Object.assign(new this.props.player.TextStyle,{backgroundOpacity:this.props.player.TextStyle.StandardOpacities.TRANSPARENT,fontColor:this.props.player.TextStyle.StandardColors.YELLOW}),this.captionsStyleBlackBG=Object.assign(new this.props.player.TextStyle,{backgroundColor:this.props.player.TextStyle.StandardColors.BLACK,fontColor:this.props.player.TextStyle.StandardColors.WHITE})}},{key:"transitionToState",value:function(e){this.setState({state:e})}},{key:"changeCaptionsStyle",value:function(e){this.props.updateCaptionsStyle(e),this.props.player.textStyle=e,this.props.onClose(),this.notifyClick({textStyle:e})}},{key:"isAdvancedStyleApplied",value:function(){return!(0,y.default)(this.props.player.textStyle,this.captionsStyleDefault)&&!(0,y.default)(this.props.player.textStyle,this.captionsStyleBlackBG)&&!(0,y.default)(this.props.player.textStyle,this.captionsStyleYellow)}},{key:"renderMainState",value:function(){var e=this;return(0,k.h)("div",{className:this.state.state===A.Main?[h.default.overlayScreen,h.default.active].join(" "):h.default.overlayScreen},(0,k.h)("div",{className:h.default.title},(0,k.h)(x.Text,{id:"cvaa.title"})),(0,k.h)("div",null,(0,k.h)("div",{tabIndex:"0",className:h.default.sample,onClick:function(){return e.changeCaptionsStyle(e.captionsStyleDefault)},onKeyDown:function(t){t.keyCode===C.KeyMap.ENTER&&e.changeCaptionsStyle(e.captionsStyleDefault)}},(0,k.h)(x.Text,{id:"cvaa.sample_caption_tag"}),(0,y.default)(this.props.player.textStyle,this.captionsStyleDefault)?(0,k.h)("div",{className:h.default.activeTick},(0,k.h)(T.default,{type:O.IconType.Check})):void 0),(0,k.h)("div",{tabIndex:"0",className:[h.default.sample,h.default.blackBg].join(" "),onClick:function(){return e.changeCaptionsStyle(e.captionsStyleBlackBG)},onKeyDown:function(t){t.keyCode===C.KeyMap.ENTER&&e.changeCaptionsStyle(e.captionsStyleBlackBG)}},(0,k.h)(x.Text,{id:"cvaa.sample_caption_tag"}),(0,y.default)(this.props.player.textStyle,this.captionsStyleBlackBG)?(0,k.h)("div",{className:h.default.activeTick},(0,k.h)(T.default,{type:O.IconType.Check})):void 0),(0,k.h)("div",{tabIndex:"0",className:[h.default.sample,h.default.yellowText].join(" "),onClick:function(){return e.changeCaptionsStyle(e.captionsStyleYellow)},onKeyDown:function(t){t.keyCode===C.KeyMap.ENTER&&e.changeCaptionsStyle(e.captionsStyleYellow)}},(0,k.h)(x.Text,{id:"cvaa.sample_caption_tag"}),(0,y.default)(this.props.player.textStyle,this.captionsStyleYellow)?(0,k.h)("div",{className:h.default.activeTick},(0,k.h)(T.default,{type:O.IconType.Check})):void 0)),this.isAdvancedStyleApplied()?(0,k.h)("div",{className:h.default.customCaptionsApplied},(0,k.h)("div",{tabIndex:"0",className:[h.default.sample,h.default.custom].join(" "),style:this.state.customTextStyle.toCSS()},(0,k.h)("span",null,"Custom captions"),(0,k.h)("div",{className:h.default.activeTick},(0,k.h)(T.default,{type:O.IconType.Check}))),(0,k.h)("a",{tabIndex:"0",onClick:function(){return e.transitionToState(A.CustomCaptions)},onKeyDown:function(t){t.keyCode===C.KeyMap.ENTER&&e.transitionToState(A.CustomCaptions)}},(0,k.h)(x.Text,{id:"cvaa.edit_caption"}))):(0,k.h)("a",{tabIndex:"0",className:h.default.buttonSaveCvaa,onClick:function(){return e.transitionToState(A.CustomCaptions)},onKeyDown:function(t){t.keyCode===C.KeyMap.ENTER&&e.transitionToState(A.CustomCaptions)}},(0,k.h)(x.Text,{id:"cvaa.set_custom_caption"})))}},{key:"_getPreviewStyle",value:function(){return"font-size: "+100*this.state.customTextStyle.implicitFontScale+"%!important; "+this.state.customTextStyle.toCSS()}},{key:"changeCustomStyle",value:function(e){this.setState({customTextStyle:Object.assign(this.state.customTextStyle,e)})}},{key:"renderCustomCaptionsState",value:function(e){var t=this,n=this.props.player.TextStyle.FontFamily,a=this.props.player.TextStyle.EdgeStyles,r=e.player.TextStyle.StandardColors,o=this.props.player.TextStyle.FontSizes.map(function(e){return{value:e.value,label:e.label,active:t.state.customTextStyle.fontScale===e.value}}),i=Object.keys(r).map(function(e){return{value:r[e],label:e.charAt(0).toUpperCase()+e.toLowerCase().slice(1),active:t.state.customTextStyle.fontColor.every(function(t,n){return t===r[e][n]})}}),s=Object.keys(n).map(function(e){return{value:n[e],label:n[e],active:t.state.customTextStyle.fontFamily===n[e]}}),l=Object.keys(a).map(function(e){return{value:a[e],label:e.charAt(0).toUpperCase()+e.toLowerCase().slice(1),active:t.state.customTextStyle.fontEdge===a[e]}}),p=Object.keys(r).map(function(e){return{value:r[e],label:e.charAt(0).toUpperCase()+e.toLowerCase().slice(1),active:t.state.customTextStyle.backgroundColor.every(function(t,n){return t===r[e][n]})}});return(0,k.h)("div",{className:this.state.state===A.CustomCaptions?[h.default.overlayScreen,h.default.active].join(" "):h.default.overlayScreen},(0,k.h)("form",{className:[h.default.form,h.default.customCaptionForm].join(" ")},(0,k.h)("div",{className:[h.default.formGroupRow,h.default.fontSize].join(" ")},(0,k.h)("label",null,(0,k.h)(x.Text,{id:"cvaa.size_label"})),(0,k.h)(E.DropDown,{onSelect:function(e){return t.changeCustomStyle({fontScale:e})},options:o})),(0,k.h)("div",{className:[h.default.formGroupRow,h.default.fontColor].join(" ")},(0,k.h)("label",null,(0,k.h)(x.Text,{id:"cvaa.font_color_label"})),(0,k.h)(E.DropDown,{onSelect:function(e){return t.changeCustomStyle({fontColor:e})},options:i})),(0,k.h)("div",{className:[h.default.formGroupRow,h.default.fontFamily].join(" ")},(0,k.h)("label",null,(0,k.h)(x.Text,{id:"cvaa.font_family_label"})),(0,k.h)(E.DropDown,{onSelect:function(e){return t.changeCustomStyle({fontFamily:e})},options:s})),(0,k.h)("div",{className:[h.default.formGroupRow,h.default.fontStyle].join(" ")},(0,k.h)("label",null,(0,k.h)(x.Text,{id:"cvaa.font_style_label"})),(0,k.h)(E.DropDown,{onSelect:function(e){return t.changeCustomStyle({fontEdge:e})},options:l})),(0,k.h)("div",{className:[h.default.formGroupRow,h.default.fontOpacity].join(" ")},(0,k.h)("label",null,(0,k.h)(x.Text,{id:"cvaa.font_opacity_label"})),(0,k.h)(P.Slider,{min:0,max:100,value:100*this.state.customTextStyle.fontOpacity,onChange:function(e){return t.changeCustomStyle({fontOpacity:e/100})}})),(0,k.h)("div",{className:[h.default.formGroupRow,h.default.backgroundColor].join(" ")},(0,k.h)("label",null,(0,k.h)(x.Text,{id:"cvaa.background_color_label"})),(0,k.h)(E.DropDown,{onSelect:function(e){return t.changeCustomStyle({backgroundColor:e})},options:p})),(0,k.h)("div",{className:[h.default.formGroupRow,h.default.backgroundOpacity].join(" ")},(0,k.h)("label",null,(0,k.h)(x.Text,{id:"cvaa.background_opacity_label"})),(0,k.h)(P.Slider,{min:0,max:100,value:100*this.state.customTextStyle.backgroundOpacity,onChange:function(e){return t.changeCustomStyle({backgroundOpacity:e/100})}})),(0,k.h)("div",{className:h.default.formGroupRow},(0,k.h)("a",{tabIndex:"0",onClick:function(){return t.changeCaptionsStyle(t.state.customTextStyle)},onKeyDown:function(e){e.keyCode===C.KeyMap.ENTER&&t.changeCaptionsStyle(t.state.customTextStyle)},className:[h.default.btn,h.default.btnBranded,h.default.btnBlock].join(" ")},(0,k.h)(x.Text,{id:"cvaa.apply"}))),(0,k.h)("div",{className:h.default.previewContainer},(0,k.h)("span",{style:this._getPreviewStyle()},(0,k.h)(x.Text,{id:"cvaa.caption_preview"})))))}},{key:"render",value:function(e){return(0,k.h)(w.Overlay,{open:!0,onClose:function(){return e.onClose()},type:"cvaa"},this.renderMainState(),this.renderCustomCaptionsState(e))}}]),t}(_.default))||l;t.CVAAOverlay=M},function(e,t,n){"use strict";function a(e,t){var n=Object.keys(e),a=Object.keys(t);if(n.length!==a.length)return!1;for(var r=0;r<n.length;r++)if(e[n[r]]!==t[n[r]])return!1;return!0}Object.defineProperty(t,"__esModule",{value:!0}),t.default=a},function(e,t,n){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function r(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.Slider=void 0;var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),s=n(1),l=function(e){return e&&e.__esModule?e:{default:e}}(s),p=n(0),c=n(6),u=n(42),h=function(e){function t(){a(this,t);var e=r(this,(t.__proto__||Object.getPrototypeOf(t)).call(this));return e.mouseUpHandler=(0,u.bindMethod)(e,e.mouseUpHandler),e.mouseMoveHandler=(0,u.bindMethod)(e,e.mouseMoveHandler),e}return o(t,e),i(t,[{key:"componentWillMount",value:function(){this.setState({value:this.props.value||0,min:this.props.min||0,max:this.props.max||100,dragging:!1}),document.addEventListener("mouseup",this.mouseUpHandler),document.addEventListener("mousemove",this.mouseMoveHandler),document.addEventListener("touchend",this.mouseUpHandler),document.addEventListener("touchmove",this.mouseMoveHandler)}},{key:"componentWillUnmount",value:function(){document.removeEventListener("mouseup",this.mouseUpHandler),document.removeEventListener("mousemove",this.mouseMoveHandler),document.removeEventListener("touchend",this.mouseUpHandler),document.removeEventListener("touchmove",this.mouseMoveHandler)}},{key:"componentDidMount",value:function(){this.sliderWidth=this._sliderElement.clientWidth,this._sliderElementOffsetLeft=this._sliderElement.getBoundingClientRect().left}},{key:"mouseDownHandler",value:function(e){this._sliderElementOffsetLeft=this._sliderElement.getBoundingClientRect().left,this.state.dragging||(this.setState({dragging:!0,value:this.mouseEventToValue(e)}),this.props.onChange(this.mouseEventToValue(e)))}},{key:"onKeyboardDragging",value:function(e){e.stopPropagation(),this._sliderElementOffsetLeft=this._sliderElement.getBoundingClientRect().left;var t=this.props.value;switch(e.keyCode){case c.KeyMap.RIGHT:t+=5,t>this.state.max&&(t=this.state.max);break;case c.KeyMap.LEFT:t-=5,t<this.state.min&&(t=this.state.min)}this.setState({value:t,dragging:!1}),this.props.onChange(t)}},{key:"mouseMoveHandler",value:function(e){this.state.dragging&&(this.setState({value:this.mouseEventToValue(e)}),this.props.onChange(this.mouseEventToValue(e)))}},{key:"mouseUpHandler",value:function(e){this.state.dragging&&(this.setState({value:this.mouseEventToValue(e),dragging:!1}),this.props.onChange(this.mouseEventToValue(e)))}},{key:"mouseEventToValue",value:function(e){var t=void 0;t=e.touches&&e.touches.length>0?e.touches[0].clientX:e.changedTouches?e.changedTouches[0].pageX:e.clientX;var n=t-this._sliderElement.getBoundingClientRect().left,a=Math.round(n/this._sliderElement.clientWidth*100);return this.getValueByPersentage(a)<this.state.min?this.state.min:this.getValueByPersentage(a)>this.state.max?this.state.max:this.getValueByPersentage(a)}},{key:"getValueByPersentage",value:function(e){return this.state.max/100*e}},{key:"getPersentageByValue",value:function(){return Math.round(this.state.value/this.state.max*100)}},{key:"render",value:function(){var e=this;return(0,p.h)("div",{tabIndex:"0",ref:function(t){return e._sliderElement=t},className:l.default.slider,onMouseDown:function(t){return e.mouseDownHandler(t)},onTouchStart:function(t){return e.mouseDownHandler(t)},onKeyDown:function(t){t.keyCode!==c.KeyMap.LEFT&&t.keyCode!==c.KeyMap.RIGHT||e.onKeyboardDragging(t)}},(0,p.h)("div",{className:l.default.progress,style:{width:this.getPersentageByValue()+"%"}},(0,p.h)("div",{className:l.default.handle,onMouseDown:function(t){return e.mouseDownHandler(t)},onTouchStart:function(t){return e.mouseDownHandler(t)}})))}}]),t}(p.Component);t.Slider=h},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.FullscreenControl=void 0;var s,l,p=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),c=n(1),u=a(c),h=n(0),k=n(5),d=n(2),f=n(3),y=a(f),v=n(4),b=a(v),m=function(e){return{fullscreen:e.engine.fullscreen}},g=(s=(0,d.connect)(m))(l=function(e){function t(e){return r(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,{name:"Fullscreen",player:e.player}))}return i(t,e),p(t,[{key:"toggleFullscreen",value:function(){this.logger.debug("Toggle fullscreen"),this.props.fullscreen?this.player.exitFullscreen():this.player.enterFullscreen(),this.notifyClick()}},{key:"render",value:function(){var e=this;return(0,h.h)("div",{className:[u.default.controlButtonContainer,u.default.controlFullscreen].join(" ")},(0,h.h)(k.Localizer,null,(0,h.h)("button",{tabIndex:"0","aria-label":(0,h.h)(k.Text,{id:"controls.fullscreen"}),className:this.props.fullscreen?[u.default.controlButton,u.default.isFullscreen].join(" "):u.default.controlButton,onClick:function(){return e.toggleFullscreen()}},(0,h.h)(b.default,{type:v.IconType.Maximize}),(0,h.h)(b.default,{type:v.IconType.Minimize}))))}}]),t}(y.default))||l;t.FullscreenControl=g},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.VrStereoToggleControl=void 0;var s,l,p=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),c=n(1),u=a(c),h=n(0),k=n(5),d=n(3),f=a(d),y=n(4),v=a(y),b=n(6),m=n(11),g=n(7),_=n(2),w=n(8),E=function(e){return{vrStereoMode:e.engine.vrStereoMode,config:e.config.components.vrStereo}},P=(s=(0,_.connect)(E,(0,g.bindActions)(Object.assign({},w.actions,m.actions))))(l=function(e){function t(e){return r(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,{name:t.displayName,player:e.player}))}return i(t,e),p(t,null,[{key:"shouldRender",value:function(e){var t=e.config.components[this.displayName];return e.state.engine.isVr&&!(0===Object.keys(t).length&&t.constructor===Object)}}]),p(t,[{key:"onClick",value:function(){this.player.toggleVrStereoMode(),this.props.updateVrStereoMode(!this.props.vrStereoMode)}},{key:"componentWillMount",value:function(){this.props.updateVrStereoMode(this.props.config.vrStereoMode)}},{key:"render",value:function(){var e=this;return(0,h.h)("div",{className:[u.default.controlButtonContainer,u.default.controlVrStereo].join(" ")},(0,h.h)(k.Localizer,null,(0,h.h)("button",{tabIndex:"0","aria-label":(0,h.h)(k.Text,{id:"controls.vrStereo"}),className:this.props.vrStereoMode?[u.default.controlButton,u.default.vrStereoMode].join(" "):u.default.controlButton,onClick:function(){return e.onClick()},onKeyDown:function(t){t.keyCode===b.KeyMap.ENTER&&e.onClick()}},(0,h.h)(v.default,{type:y.IconType.vrStereo}),(0,h.h)(v.default,{type:y.IconType.vrStereoFull}))))}}]),t}(f.default))||l;P.displayName="vrStereo",t.VrStereoToggleControl=P},function(e,t,n){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function r(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.TimeDisplayPlaybackContainer=void 0;var i,s,l=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a])}return e},p=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),c=n(0),u=n(2),h=n(3),k=function(e){return e&&e.__esModule?e:{default:e}}(h),d=n(49),f=function(e){return{currentTime:e.engine.currentTime,duration:e.engine.duration}},y=(i=(0,u.connect)(f))(s=function(e){function t(){return a(this,t),r(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,{name:"TimeDisplayPlaybackContainer"}))}return o(t,e),p(t,[{key:"render",value:function(e){return(0,c.h)(d.TimeDisplay,l({currentTime:e.currentTime,duration:e.duration},e))}}]),t}(k.default))||s;t.TimeDisplayPlaybackContainer=y},function(e,t,n){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function r(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.TimeDisplay=void 0;var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),s=n(1),l=function(e){return e&&e.__esModule?e:{default:e}}(s),p=n(0),c=n(40),u=function(e){function t(){return a(this,t),r(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return o(t,e),i(t,[{key:"getTimeDisplay",value:function(e,t,n){var a=n||"current / total",r=(0,c.toHHMMSS)(e),o=(0,c.toHHMMSS)(t),i=(0,c.toHHMMSS)(t-e);return a=a.replace(/current/g,r),a=a.replace(/total/g,o),a=a.replace(/left/g,i)}},{key:"render",value:function(e){return(0,p.h)("div",{className:l.default.timeDisplay},(0,p.h)("span",null,this.getTimeDisplay(e.currentTime,e.duration,e.format)))}}]),t}(p.Component);t.TimeDisplay=u},function(e,t,n){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function r(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.BottomBar=void 0;var i,s,l=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),p=n(1),c=function(e){return e&&e.__esModule?e:{default:e}}(p),u=n(0),h=n(7),k=n(8),d=n(2),f=function(e){return{isCasting:e.engine.isCasting,isPlaybackEnded:e.engine.isPlaybackEnded}},y=(i=(0,d.connect)(f,(0,h.bindActions)(k.actions)))(s=function(e){function t(){return a(this,t),r(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return o(t,e),l(t,[{key:"render",value:function(e){var t=this,n=[c.default.bottomBar];return e.isCasting&&e.isPlaybackEnded&&n.push(c.default.hide),(0,u.h)("div",{className:n.join(" "),onMouseOver:function(){return t.props.updateBottomBarHoverActive(!0)},onMouseLeave:function(){return t.props.updateBottomBarHoverActive(!1)}},e.children)}}]),t}(u.Component))||s;t.BottomBar=y},function(e,t,n){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function r(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.OverlayPortal=void 0;var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),s=n(0),l=function(e){function t(){return a(this,t),r(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return o(t,e),i(t,[{key:"shouldComponentUpdate",value:function(){return!1}},{key:"render",value:function(e){return(0,s.h)("div",{className:"overlay-portal"},e.children)}}]),t}(s.Component);t.OverlayPortal=l},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.UnmuteIndication=t.MUTED_AUTOPLAY_ICON_ONLY_DEFAULT_TIMEOUT=void 0;var s,l,p=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),c=n(1),u=a(c),h=n(0),k=n(2),d=n(3),f=a(d),y=n(4),v=a(y),b=n(6),m=n(5),g=t.MUTED_AUTOPLAY_ICON_ONLY_DEFAULT_TIMEOUT=3e3,_=function(e){return{fallbackToMutedAutoPlay:e.engine.fallbackToMutedAutoPlay}},w=(s=(0,k.connect)(_,null))(l=function(e){function t(e){return r(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,{name:"UnmuteIndication",player:e.player}))}return i(t,e),p(t,[{key:"componentDidUpdate",value:function(e){var t=this;!e.fallbackToMutedAutoPlay&&this.props.fallbackToMutedAutoPlay&&(this.eventManager.listenOnce(this.player,this.player.Event.PLAYING,function(){return t._iconOnlyTimeout()}),this.eventManager.listenOnce(this.player,this.player.Event.AD_STARTED,function(){return t._iconOnlyTimeout()}))}},{key:"_iconOnlyTimeout",value:function(){var e=this;setTimeout(function(){e.setState({iconOnly:!0})},g)}},{key:"_keyDownHandler",value:function(e){e.keyCode===b.KeyMap.ENTER&&(this.player.muted=!this.player.muted)}},{key:"render",value:function(e){var t=this;if(this.props.fallbackToMutedAutoPlay){var n=[u.default.unmuteButtonContainer];return e.hasTopBar&&n.push(u.default.hasTopBar),this.state.iconOnly&&n.push(u.default.showIconOnly),(0,h.h)(m.Localizer,null,(0,h.h)("div",{tabIndex:"0","aria-label":(0,h.h)(m.Text,{id:"controls.unmute"}),className:n.join(" "),onMouseOver:function(){return t.setState({iconOnly:!1})},onMouseOut:function(){return t.setState({iconOnly:!0})},onClick:function(){return t.player.muted=!t.player.muted},onTouchEnd:function(e){return e.stopImmediatePropagation()},onKeyDown:function(e){return t._keyDownHandler(e)}},(0,h.h)("a",{className:[u.default.btn,u.default.btnDarkTransparent,u.default.unmuteButton].join(" ")},(0,h.h)("div",{className:u.default.unmuteIconContainer},(0,h.h)(v.default,{type:y.IconType.VolumeBase}),(0,h.h)(v.default,{type:y.IconType.VolumeMute})),(0,h.h)("span",null,(0,h.h)(m.Text,{id:"unmute.unmute"})))))}}}]),t}(f.default))||l;t.UnmuteIndication=w},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.CastControl=void 0;var s,l,p=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),c=n(1),u=a(c),h=n(0),k=n(3),d=a(k),f=n(2),y=n(35),v=function(e){return{isCasting:e.engine.isCasting,isCastAvailable:e.engine.isCastAvailable}},b=(s=(0,f.connect)(v,y.actions))(l=function(e){function t(e){return r(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,{name:"Cast",player:e.player}))}return i(t,e),p(t,[{key:"onClick",value:function(){var e=this;this.props.updateBackdropVisibility(!0),this.eventManager.listenOnce(this.player,this.player.Event.Cast.CAST_SESSION_START_FAILED,function(){return e.props.updateBackdropVisibility(!1)})}},{key:"render",value:function(e){var t=this;if(e.isCasting||e.isCastAvailable)return(0,h.h)("div",{class:u.default.controlButtonContainer,onClick:function(){return t.onClick()}},(0,h.h)("google-cast-launcher",{class:u.default.castButton}))}}]),t}(d.default))||l;t.CastControl=b},function(e,t,n){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function r(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.PlaybackControls=void 0;var i,s,l=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),p=n(1),c=function(e){return e&&e.__esModule?e:{default:e}}(p),u=n(0),h=n(2),k=n(74),d=n(75),f=function(e){return{playlist:e.engine.playlist}},y=(i=(0,h.connect)(f))(s=function(e){function t(){return a(this,t),r(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return o(t,e),l(t,[{key:"render",value:function(e){return(0,u.h)("div",{className:[c.default.playbackControls]},e.playlist?(0,u.h)(k.PlaylistButton,{player:e.player,type:"prev"}):void 0,(0,u.h)(d.PlayPauseControl,{player:e.player}),e.playlist?(0,u.h)(k.PlaylistButton,{player:e.player,type:"next"}):void 0)}}]),t}(u.Component))||s;t.PlaybackControls=y},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.PlaylistButton=void 0;var s,l,p=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),c=n(1),u=a(c),h=n(0),k=n(5),d=n(3),f=a(d),y=n(4),v=a(y),b=n(6),m=n(2),g=function(e){return{playlist:e.engine.playlist}},_=(s=(0,m.connect)(g))(l=function(e){function t(e){return r(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,{name:"PlaybackButton-"+e.type,player:e.player}))}return i(t,e),p(t,[{key:"onClick",value:function(){"prev"===this.props.type?this.player.playlist.playPrev():this.player.playlist.playNext()}},{key:"render",value:function(e){var t=this,n=e.playlist[e.type];return(0,h.h)("div",{className:[u.default.controlButtonContainer,u.default.controlPlaylistButton].join(" ")},n&&n.sources&&(n.sources.poster||n.sources.metadata&&n.sources.metadata.name)?(0,h.h)("div",{className:u.default.posterPreview},(0,h.h)("div",{className:u.default.posterPreviewText},(0,h.h)(k.Localizer,null,(0,h.h)("div",{className:u.default.posterPreviewTextTitle},(0,h.h)(k.Text,{id:"prev"===e.type?"playlist.prev":"playlist.up_next"}))),(0,h.h)("div",{className:u.default.posterPreviewTextName},""+(n.sources.metadata?n.sources.metadata.name:""))),(0,h.h)("div",{className:u.default.posterPreviewImg,style:"background-image: url("+n.sources.poster+");"})):void 0,(0,h.h)(k.Localizer,null,(0,h.h)("button",{disabled:!n,tabIndex:"0","aria-label":(0,h.h)(k.Text,{id:"controls."+e.type}),className:""+u.default.controlButton,onClick:function(){return t.onClick()},onKeyDown:function(e){e.keyCode===b.KeyMap.ENTER&&t.onClick()}},"prev"===e.type?(0,h.h)("div",null,(0,h.h)(v.default,{type:y.IconType.Prev})):(0,h.h)("div",null,(0,h.h)(v.default,{type:y.IconType.Next})))))}}]),t}(f.default))||l;t.PlaylistButton=_},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.PlayPauseControl=void 0;var s,l,p=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),c=n(1),u=a(c),h=n(0),k=n(5),d=n(2),f=n(3),y=a(f),v=n(4),b=a(v),m=n(6),g=n(37),_=function(e){return{isPlayingAdOrPlayback:(0,g.isPlayingAdOrPlayback)(e.engine),isPlaying:e.engine.isPlaying,adBreak:e.engine.adBreak,isPlaybackEnded:e.engine.isPlaybackEnded}},w=(s=(0,d.connect)(_))(l=function(e){function t(e){return r(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,{name:"PlayPause",player:e.player}))}return i(t,e),p(t,[{key:"togglePlayPause",value:function(){this.logger.debug("Toggle play"),this.props.isPlayingAdOrPlayback?this.player.pause():this.player.play(),this.notifyClick()}},{key:"render",value:function(e){var t=this,n=this.props.isPlayingAdOrPlayback?[u.default.controlButton,u.default.isPlaying].join(" "):u.default.controlButton;return(0,h.h)("div",{className:[u.default.controlButtonContainer,u.default.controlPlayPause].join(" ")},(0,h.h)(k.Localizer,null,(0,h.h)("button",{tabIndex:"0","aria-label":(0,h.h)(k.Text,{id:e.isPlaybackEnded?"controls.startOver":this.props.isPlayingAdOrPlayback?"controls.pause":"controls.play"}),className:n,onClick:function(){return t.togglePlayPause()},onKeyDown:function(e){e.keyCode===m.KeyMap.ENTER&&t.togglePlayPause()}},e.isPlaybackEnded?(0,h.h)(b.default,{type:v.IconType.StartOver}):(0,h.h)("div",null,(0,h.h)(b.default,{type:v.IconType.Play}),(0,h.h)(b.default,{type:v.IconType.Pause})))))}}]),t}(y.default))||l;t.PlayPauseControl=w},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(158);Object.defineProperty(t,"PlaylistCountdown",{enumerable:!0,get:function(){return a.PlaylistCountdown}})},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.PlaylistCountdown=void 0;var s,l,p=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),c=n(1),u=a(c),h=n(0),k=n(5),d=n(3),f=a(d),y=n(4),v=a(y),b=n(6),m=n(2),g=function(e){return{playlist:e.engine.playlist,currentTime:e.engine.currentTime,duration:e.engine.duration,lastSeekPoint:e.engine.lastSeekPoint,isSeeking:e.engine.isSeeking,isPlaybackEnded:e.engine.isPlaybackEnded}},_=(s=(0,m.connect)(g))(l=function(e){function t(e){return r(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,{name:"PlaylistCountdown",player:e.player}))}return i(t,e),p(t,null,[{key:"shouldRender",value:function(e){return e.state.engine.playlist&&e.state.engine.playlist.next&&e.state.engine.playlist.next.sources&&e.player.playlist.countdown.showing&&(e.player.playlist.options.autoContinue||e.player.playlist.options.loop)}}]),p(t,[{key:"onClick",value:function(){this.player.playlist.playNext()}},{key:"cancelNext",value:function(e){this.logger.debug("Cancel auto play next item"),e.stopPropagation(),this.setState({canceled:!0})}},{key:"_getTimeToShow",value:function(){var e=this.player.playlist.countdown,t=this.props.duration-e.duration;return e.timeToShow>=0&&e.timeToShow<=this.props.duration&&(t=Math.max(e.timeToShow,this.props.lastSeekPoint)),Math.max(0,Math.min(t,this.props.duration))}},{key:"componentDidMount",value:function(){this.setState({canceled:!1})}},{key:"componentWillUpdate",value:function(e){var t=this._getTimeToShow();e.currentTime>t?this.setState({timeToShow:!0}):this.setState({timeToShow:!1,canceled:!1})}},{key:"componentDidUpdate",value:function(){var e=this._getTimeToShow(),t=this.player.playlist.countdown;!this.state.canceled&&(this.props.isPlaybackEnded||this.props.currentTime>=e+t.duration&&this.props.currentTime<this.props.duration)&&this.player.playlist.playNext()}},{key:"shouldComponentUpdate",value:function(e){return!e.isSeeking}},{key:"render",value:function(e){var t=this,n=e.playlist.next;if(n&&n.sources){var a=this.player.playlist.countdown,r=this._getTimeToShow(),o=e.currentTime-r,i=Math.min(a.duration,e.duration-r),s=(o>0?o/i*104:0)+"%",l=[u.default.playlistCountdown];return!this.state.timeToShow||a.duration>=e.duration?l.push(u.default.hidden):this.state.canceled&&l.push(u.default.canceled),(0,h.h)("div",{className:l.join(" "),onClick:function(){return t.onClick()}},(0,h.h)("div",{className:u.default.playlistCountdownPoster,style:"background-image: url("+n.sources.poster+");"}),(0,h.h)("div",{className:u.default.playlistCountdownContentPlaceholder},(0,h.h)("div",{className:u.default.playlistCountdownContentBackground},(0,h.h)("div",{className:u.default.playlistCountdownContent},(0,h.h)(k.Localizer,null,(0,h.h)("div",{className:u.default.playlistCountdownText},(0,h.h)("div",{className:u.default.playlistCountdownTextTitle},(0,h.h)(k.Text,{id:"playlist.up_next"})),(0,h.h)("div",{className:u.default.playlistCountdownTextName},""+(n.sources.metadata?n.sources.metadata.name:"")))),(0,h.h)("div",{className:[u.default.controlButtonContainer,u.default.playlistCountdownCancel].join(" ")},(0,h.h)(k.Localizer,null,(0,h.h)("button",{tabIndex:"0","aria-label":(0,h.h)(k.Text,{id:"playlist.cancel"}),className:[u.default.controlButton,u.default.playlistCountdownCancelButton].join(" "),onClick:function(e){return t.cancelNext(e)},onKeyDown:function(e){e.keyCode===b.KeyMap.ENTER&&t.cancelNext()}},(0,h.h)(v.default,{type:y.IconType.Close})))),(0,h.h)("div",{className:u.default.playlistCountdownIndicatorBar},(0,h.h)("div",{className:u.default.playlistCountdownIndicatorProgress,style:{width:s}}))))))}}}]),t}(f.default))||l;t.PlaylistCountdown=_},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.PlaylistNextScreen=void 0;var s,l,p=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),c=n(1),u=a(c),h=n(0),k=n(5),d=n(3),f=a(d),y=n(2),v=n(4),b=a(v),m=function(e){return{playlist:e.engine.playlist,isPlaybackEnded:e.engine.isPlaybackEnded}},g=(s=(0,y.connect)(m))(l=function(e){function t(e){return r(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,{name:"PlaylistNextScreen",player:e.player}))}return i(t,e),p(t,null,[{key:"shouldRender",value:function(e){return e.state.engine.playlist&&e.state.engine.playlist.next&&e.state.engine.playlist.next.sources}}]),p(t,[{key:"onPosterClick",value:function(){this.player.playlist.playNext()}},{key:"_getPosterUrl",value:function(){var e=this.props.playlist.next;return e.sources.poster?e.sources.poster.indexOf("entry_id/"+e.sources.id)>-1&&-1===e.sources.poster.indexOf("/width/")?e.sources.poster+"/width/384":e.sources.poster:""}},{key:"render",value:function(e){var t=this,n=e.playlist.next;return e.isPlaybackEnded?(0,h.h)("div",{className:u.default.playlistNextScreenOverlay},(0,h.h)("div",{className:u.default.playlistNextScreenContent},(0,h.h)("div",{className:u.default.playlistNextScreenText},(0,h.h)(k.Localizer,null,(0,h.h)("div",{className:u.default.playlistNextScreenTextTitle},(0,h.h)(k.Text,{id:"playlist.next"}))),(0,h.h)("div",{className:u.default.playlistNextScreenTextName},""+(n.sources.metadata?n.sources.metadata.name:""))),(0,h.h)("div",{className:u.default.playlistNextScreenPosterPlaceholder},(0,h.h)("div",{className:u.default.playlistNextScreenPosterAspectRatio},(0,h.h)("div",{className:u.default.playlistNextScreenPoster,onClick:function(){return t.onPosterClick()}},(0,h.h)("div",{className:u.default.playlistNextScreenPosterImg,style:"background-image: url("+this._getPosterUrl()+");"}),(0,h.h)(b.default,{type:v.IconType.Play})))))):void 0}}]),t}(f.default))||l;t.PlaylistNextScreen=g},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.PictureInPicture=void 0;var s,l,p=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),c=n(1),u=a(c),h=n(0),k=n(5),d=n(4),f=a(d),y=n(6),v=n(3),b=a(v),m=n(2),g=n(10),_=function(e){return{isPictureInPictureSupported:e.engine.isPictureInPictureSupported,playerSize:e.shell.playerSize}},w=(s=(0,m.connect)(_))(l=function(e){function t(e){return r(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,{name:"PictureInPicture",player:e.player}))}return i(t,e),p(t,[{key:"_onClick",value:function(){this.player.isInPictureInPicture()?this.player.exitPictureInPicture():this.player.enterPictureInPicture()}},{key:"render",value:function(){var e=this;if(this.props.isPictureInPictureSupported&&this.props.playerSize!==g.PLAYER_SIZE.EXTRA_SMALL)return(0,h.h)("div",{className:[u.default.controlButtonContainer,u.default.pictureInPicture].join(" ")},(0,h.h)(k.Localizer,null,(0,h.h)("button",{tabIndex:"0","aria-label":(0,h.h)(k.Text,{id:"controls.pictureInPicture"}),className:u.default.controlButton+" "+(this.state.animation?u.default.rotate:""),onClick:function(){return e._onClick()},onKeyDown:function(t){t.keyCode===y.KeyMap.ENTER&&e._onClick()}},(0,h.h)(f.default,{type:d.IconType.PictureInPicture}))))}}]),t}(b.default))||l;t.PictureInPicture=w},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.PictureInPictureOverlay=void 0;var s,l,p=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),c=n(1),u=a(c),h=n(0),k=n(3),d=a(k),f=n(2),y=n(5),v=function(e){return{poster:e.engine.poster,isInPictureInPicture:e.engine.isInPictureInPicture,isChangingSource:e.engine.isChangingSource}},b=(s=(0,f.connect)(v))(l=function(e){function t(e){return r(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,{name:"PictureInPictureOverlay",player:e.player}))}return i(t,e),p(t,[{key:"_handleClick",value:function(){this.player.exitPictureInPicture()}},{key:"render",value:function(){var e=this;if(this.props.isInPictureInPicture){var t={},n=[u.default.pictureInPicturePoster];if(this.props.poster){t={backgroundImage:this.props.isChangingSource?"":"url("+this.props.poster+")",backgroundSize:"contain"},n.push(u.default.hasPoster)}return(0,h.h)("div",null,(0,h.h)("div",{className:u.default.pictureInPictureOverlay},(0,h.h)("div",{className:n.join(" "),style:t,onMouseOver:function(e){return e.stopPropagation()}},(0,h.h)("div",{className:u.default.darkLayer})),(0,h.h)("div",{className:u.default.pictureInPictureControl},(0,h.h)(y.Localizer,null,(0,h.h)("span",{className:u.default.pictureInPictureText},(0,h.h)(y.Text,{id:"pictureInPicture.overlay_text"}))),(0,h.h)(y.Localizer,null,(0,h.h)("button",{className:[u.default.pictureInPictureButton,u.default.controlButtonContainer].join(" "),onClick:function(){return e._handleClick()}},(0,h.h)(y.Text,{id:"pictureInPicture.overlay_button"}))))))}}}]),t}(d.default))||l;t.PictureInPictureOverlay=b},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.ShareControl=void 0;var s,l,p=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),c=n(0),u=n(3),h=a(u),k=n(4),d=a(k),f=n(78),y=n(45),v=a(y),b=n(1),m=a(b),g=n(164),_=n(19),w=n(2),E=n(7),P=function(e){return{open:e.share.overlayOpen,isPlaying:e.engine.isPlaying,config:e.config.components.share}},O=(s=(0,w.connect)(P,(0,E.bindActions)(_.actions)))(l=function(e){function t(e){return r(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,{name:"Share",player:e.player}))}return i(t,e),p(t,[{key:"toggleOverlay",value:function(){this.setState({overlay:!this.state.overlay}),this.props.toggleShareOverlay(this.state.overlay),this.props.isPlaying||this.state.previousIsPlaying?this.setState({previousIsPlaying:!0}):this.setState({previousIsPlaying:!1}),this.state.overlay?this.player.pause():this.state.previousIsPlaying&&(this.player.play(),this.setState({previousIsPlaying:!1}))}},{key:"_getMergedShareConfig",value:function(){var e=this.props.config.socialNetworks||[];return e.concat(g.defaultConfig.filter(function(t){return!e.find(function(e){return e.name===t.name})}))}},{key:"render",value:function(){var e=this,t=this.props.config,n=t.embedUrl,a=t.enable,r=t.shareUrl,o=t.enableTimeOffset;if(a&&r&&n){var i=this._getMergedShareConfig(),s="#"+this.player.config.targetId+" .overlay-portal";return(0,c.h)("div",{className:[m.default.controlButtonContainer,m.default.controlShare].join(" ")},this.state.overlay?(0,c.h)(v.default,{into:s,ref:function(t){return e._portal=t}},(0,c.h)(f.ShareOverlay,{shareUrl:r,embedUrl:n,enableTimeOffset:o,socialNetworks:i,player:this.player,onClose:function(){return e.toggleOverlay()}})):(0,c.h)("button",{className:m.default.controlButton,onClick:function(){return e.toggleOverlay()},"aria-label":"Share"},(0,c.h)(d.default,{type:k.IconType.Share})))}}}]),t}(h.default))||l;t.ShareControl=O},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.ShareOverlay=void 0;var s,l,p=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),c=n(0),u=n(5),h=n(2),k=n(7),d=n(19),f=n(40),y=n(3),v=a(y),b=n(17),m=n(4),g=a(m),_=n(1),w=a(_),E=n(79),P=function(e){return{open:e.share.overlayOpen}},O={Main:"main",EmbedOptions:"embed-options"},T=function(e){var t=function(){var t=e.config.shareUrl,n=e.config.templateUrl,a=t;n&&(a=n.replace("{shareUrl}",t)),window.open(a,"_blank","width=580,height=580")};return(0,c.h)("button",{href:e.config.shareUrl,target:"_blank",rel:"noopener noreferrer",title:e.config.title,role:"button","aria-label":e.config.ariaLabel,className:[w.default.btnRounded,w.default[e.config.iconType],e.config.iconType].join(" "),onClick:function(){return t()}},(0,c.h)(g.default,{style:"svg"===e.config.iconType?"background-image: url("+e.config.svg+")":"",type:e.config.iconType}))},C=function(e){var t=void 0,n=function(e,t){t?e.setSelectionRange(0,9999):e.select(),document.execCommand("copy"),e.blur()};return(0,c.h)("div",{className:e.copy?w.default.copyUrlRow:""},(0,c.h)("div",{className:[w.default.formGroup,w.default.hasIcon,w.default.inputCopyUrl].join(" "),style:"width: 350px;"},(0,c.h)("input",{type:"text",ref:function(e){return t=e},className:w.default.formControl,value:e.shareUrl,readOnly:!0}),(0,c.h)(g.default,{type:m.IconType.Link})),e.copy&&(0,c.h)(E.CopyButton,{copy:function(){return n(t,e.isIos)}}))},x=function(e){return(0,c.h)("div",{className:w.default.videoStartOptionsRow},(0,c.h)("div",{className:[w.default.checkbox,w.default.dInlineBlock].join(" ")},(0,c.h)("input",{type:"checkbox",id:"start-from",checked:e.startFrom,onClick:function(){return e.toggleStartFrom()}}),(0,c.h)("label",{htmlFor:"start-from"},(0,c.h)(u.Text,{id:"share.start_video_at"}))),(0,c.h)("div",{className:[w.default.formGroup,w.default.dInlineBlock].join(" ")},(0,c.h)("input",{type:"text",className:w.default.formControl,onChange:function(t){return e.handleStartFromChange(t)},value:(0,f.toHHMMSS)(e.startFromValue),style:"width: 72px;"})))},S=(s=(0,h.connect)(P,(0,k.bindActions)(d.actions)))(l=function(e){function t(e){return r(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,{name:"ShareOverlay",player:e.player}))}return i(t,e),p(t,[{key:"componentWillMount",value:function(){this.isIos="iOS"===this.player.env.os.name,this.setState({view:O.Main,startFrom:!1,startFromValue:Math.floor(this.player.currentTime)})}},{key:"_transitionToState",value:function(e){this.setState({view:e})}},{key:"getShareUrl",value:function(){var e=this.props.shareUrl;return this.state.startFrom&&(e+="?start="+this.state.startFromValue),e}},{key:"getEmbedCode",value:function(){var e=this.props.embedUrl;return this.state.startFrom&&(e+="?start="+this.state.startFromValue),'<iframe src="'+e+'" style="width: 560px;height: 395px" allowfullscreen webkitallowfullscreen mozAllowFullScreen frameborder="0" allow="accelerometer *; autoplay *; encrypted-media *; gyroscope *; picture-in-picture *"/>'}},{key:"_getEmailTemplate",value:function(){var e="this video";return this.player.config.sources&&this.player.config.sources.metadata&&this.player.config.sources.metadata.name&&(e=this.player.config.sources.metadata.name),"mailto:?subject="+encodeURIComponent("Check out "+e)+"&body="+encodeURIComponent("Check out "+e+": "+this.getShareUrl())}},{key:"_toggleStartFrom",value:function(){this.setState({startFrom:!this.state.startFrom})}},{key:"_handleStartFromChange",value:function(e){var t=(0,f.toSecondsFromHHMMSS)(e.target.value);t>=this.player.duration&&this.setState({startFromValue:1}),this.setState({startFromValue:t})}},{key:"_createSocialNetworks",value:function(e){var t=this;return e.map(function(e){return"default"===e.iconType&&(e.iconType=e.name,e.shareUrl=t.props.shareUrl),(0,c.h)(T,{key:e.name,config:e})})}},{key:"renderMainState",value:function(){var e=this;return(0,c.h)("div",{className:this.state.view===O.Main?"overlay-screen active":"overlay-screen"},(0,c.h)("div",{className:w.default.title},(0,c.h)(u.Text,{id:"share.title"})),(0,c.h)("div",{className:w.default.shareMainContainer},(0,c.h)("div",{className:w.default.shareIcons},this._createSocialNetworks(this.props.socialNetworks),(0,c.h)(u.Localizer,null,(0,c.h)("a",{className:[w.default.btnRounded,w.default.emailShareBtn].join(" "),href:this._getEmailTemplate(),title:(0,c.h)(u.Text,{id:"share.email"})},(0,c.h)(g.default,{type:m.IconType.Email}))),(0,c.h)(u.Localizer,null,(0,c.h)("button",{className:[w.default.btnRounded,w.default.embedShareBtn].join(" "),onClick:function(){return e._transitionToState(O.EmbedOptions)},title:(0,c.h)(u.Text,{id:"share.embed"})},(0,c.h)(g.default,{type:m.IconType.Embed})))),(0,c.h)("div",{className:w.default.linkOptionsContainer},(0,c.h)(C,{shareUrl:this.getShareUrl(),copy:!0,isIos:this.isIos}),this.props.enableTimeOffset?(0,c.h)(x,{startFrom:this.state.startFrom,startFromValue:this.state.startFromValue,handleStartFromChange:function(t){return e._handleStartFromChange(t)},toggleStartFrom:function(){return e._toggleStartFrom()}}):void 0)))}},{key:"renderOptionsState",value:function(e){var t=this;return(0,c.h)("div",{className:this.state.view===O.EmbedOptions?"overlay-screen active":"overlay-screen"},(0,c.h)("div",{className:w.default.title},e.title),(0,c.h)("div",{className:w.default.linkOptionsContainer},(0,c.h)(C,{shareUrl:e.shareUrl,copy:!0,isIos:this.isIos}),this.props.enableTimeOffset?(0,c.h)(x,{startFrom:this.state.startFrom,startFromValue:this.state.startFromValue,handleStartFromChange:function(e){return t._handleStartFromChange(e)},toggleStartFrom:function(){return t._toggleStartFrom()}}):void 0))}},{key:"renderStateContent",value:function(){switch(this.state.view){case O.EmbedOptions:return this.renderOptionsState({title:(0,c.h)(u.Text,{id:"share.embed_options"}),shareUrl:this.getEmbedCode()});case O.Main:default:return this.renderMainState()}}},{key:"render",value:function(e){return(0,c.h)(b.Overlay,{open:!0,onClose:function(){return e.onClose()},type:"share"},this.renderStateContent())}}]),t}(v.default))||l;t.ShareOverlay=S},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=[{name:"facebook",templateUrl:"https://www.facebook.com/sharer/sharer.php?u={shareUrl}",title:"Share on Facebook",ariaLabel:"Share on Facebook",iconType:"default",svg:""},{name:"linkedin",templateUrl:"https://www.linkedin.com/shareArticle?mini=true&url={shareUrl}",title:"Share on Linkedin",ariaLabel:"Share on Linkedin",iconType:"default",svg:""},{name:"twitter",templateUrl:"https://twitter.com/share?url={shareUrl}",title:"Share on Twitter",ariaLabel:"Share on Twitter",iconType:"default",svg:""}];t.defaultConfig=a},function(e,t,n){"use strict";function a(e){if(o(e))return(0,l.h)("div",{className:s.default.adGuiWrapper},(0,l.h)(p.Loading,{player:e.player}),(0,l.h)("div",{className:s.default.playerGui,id:"player-gui"},(0,l.h)(v.UnmuteIndication,{player:e.player,hasTopBar:!0}),(0,l.h)(f.TopBar,null,(0,l.h)("div",{className:s.default.leftControls},(0,l.h)(m.AdNotice,null)))));var t=r();return(0,l.h)("div",{className:s.default.adGuiWrapper},(0,l.h)(b.KeyboardControl,{player:e.player,config:e.config}),(0,l.h)(p.Loading,{player:e.player}),(0,l.h)("div",{className:s.default.playerGui,id:"player-gui"},(0,l.h)(v.UnmuteIndication,{player:e.player,hasTopBar:!0}),(0,l.h)(f.TopBar,null,(0,l.h)("div",{className:s.default.leftControls},(0,l.h)(m.AdNotice,null)),(0,l.h)("div",{className:s.default.rightControls},t.learnMoreButton?(0,l.h)(d.AdLearnMore,null):void 0)),t.skipButton?(0,l.h)(k.AdSkip,{player:e.player}):void 0,(0,l.h)(g.PlaybackControls,{player:e.player}),(0,l.h)(y.BottomBar,null,(0,l.h)("div",{className:s.default.leftControls},(0,l.h)(g.PlaybackControls,{player:e.player}),(0,l.h)(h.TimeDisplayAdsContainer,null)),(0,l.h)("div",{className:s.default.rightControls},(0,l.h)(c.VolumeControl,{player:e.player}),(0,l.h)(u.FullscreenControl,{player:e.player})))))}function r(){return{learnMoreButton:!1,skipButton:!1}}function o(e){var t=!!e.player.env.device.type,n=!1;try{var a=e.player.config.plugins.ima.adsRenderingSettings;n=a&&a.useStyledLinearAds}catch(e){}return t||n}Object.defineProperty(t,"__esModule",{value:!0}),t.adsUI=a;var i=n(1),s=function(e){return e&&e.__esModule?e:{default:e}}(i),l=n(0),p=n(15),c=n(22),u=n(23),h=n(80),k=n(81),d=n(82),f=n(83),y=n(24),v=n(26),b=n(25),m=n(84),g=n(27)},function(e,t,n){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function r(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.TimeDisplayAdsContainer=void 0;var i,s,l=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a])}return e},p=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),c=n(0),u=n(2),h=n(3),k=function(e){return e&&e.__esModule?e:{default:e}}(h),d=n(49),f=function(e){return{adProgress:e.engine.adProgress}},y=(i=(0,u.connect)(f))(s=function(e){function t(){return a(this,t),r(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,{name:"TimeDisplayAdsContainer"}))}return o(t,e),p(t,[{key:"render",value:function(e){return(0,c.h)(d.TimeDisplay,l({currentTime:Math.round(e.adProgress.currentTime),duration:Math.round(e.adProgress.duration)},e))}}]),t}(k.default))||s;t.TimeDisplayAdsContainer=y},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.AdSkip=void 0;var s,l,p=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),c=n(1),u=a(c),h=n(0),k=n(2),d=n(3),f=a(d),y=n(5),v=function(e){return{currentTime:e.engine.adProgress.currentTime,duration:e.engine.adProgress.duration,adSkipTimeOffset:e.engine.adSkipTimeOffset,adSkippableState:e.engine.adSkippableState}},b=(s=(0,k.connect)(v))(l=function(e){function t(e){return r(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,{name:"AdSkip",player:e.player}))}return i(t,e),p(t,[{key:"getSkipTimeOffset",value:function(){return Math.ceil(this.props.adSkipTimeOffset-this.props.currentTime)}},{key:"render",value:function(){var e=this;return this.props.adSkippableState?this.getSkipTimeOffset()<=0?(0,h.h)(y.Localizer,null,(0,h.h)("a",{className:[u.default.btn,u.default.btnBranded,u.default.btnSkipAd].join(" "),onClick:function(){return e.player.ads.skipAd()}},(0,h.h)(y.Text,{id:"ads.skip_ad"}))):(0,h.h)(y.Localizer,null,(0,h.h)("span",{className:u.default.skipAd},(0,h.h)(y.Text,{id:"ads.skip_in"})," "+this.getSkipTimeOffset())):void 0}}]),t}(f.default))||l;t.AdSkip=b},function(e,t,n){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function r(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.AdLearnMore=void 0;var i,s,l=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),p=n(1),c=function(e){return e&&e.__esModule?e:{default:e}}(p),u=n(0),h=n(2),k=n(5),d=function(e){return{url:e.engine.adUrl}},f=(i=(0,h.connect)(d))(s=function(e){function t(){return a(this,t),r(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return o(t,e),l(t,[{key:"render",value:function(e){return(0,u.h)("a",{href:e.url,target:"_blank",className:[c.default.btn,c.default.btnDarkTransparent,c.default.learnMore].join(" ")},(0,u.h)(k.Text,{id:"ads.learn_more"}))}}]),t}(u.Component))||s;t.AdLearnMore=f},function(e,t,n){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function r(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.TopBar=void 0;var i,s,l=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),p=n(1),c=function(e){return e&&e.__esModule?e:{default:e}}(p),u=n(0),h=n(2),k=function(e){return{isCasting:e.engine.isCasting,isPlaybackEnded:e.engine.isPlaybackEnded}},d=(i=(0,h.connect)(k))(s=function(e){function t(){return a(this,t),r(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return o(t,e),l(t,[{key:"render",value:function(e){var t=[c.default.topBar];return e.isCasting&&e.isPlaybackEnded&&t.push(c.default.hide),(0,u.h)("div",{className:t.join(" ")},e.children)}}]),t}(u.Component))||s;t.TopBar=d},function(e,t,n){"use strict";function a(e){return(0,i.h)("div",{className:o.default.playbackGuiWWrapper},(0,i.h)(s.ErrorOverlay,{player:e.player}))}Object.defineProperty(t,"__esModule",{value:!0}),t.errorUI=a;var r=n(1),o=function(e){return e&&e.__esModule?e:{default:e}}(r),i=n(0),s=n(85)},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.ErrorOverlay=void 0;var s,l,p=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),c=n(1),u=a(c),h=n(0),k=n(2),d=n(3),f=a(d),y=n(17),v=n(5),b=n(7),m=n(11),g=n(172),_=function(e){return{hasError:e.engine.hasError}},w=(s=(0,k.connect)(_,(0,b.bindActions)(m.actions)))(l=function(e){function t(e){return r(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,{name:"ErrorOverlay",player:e.player}))}return i(t,e),p(t,[{key:"copyError",value:function(){var e=window.getSelection(),t=document.createRange();t.selectNode(this.sessionEl),e.removeAllRanges(),e.addRange(t),document.execCommand("copy")}},{key:"handleClick",value:function(){var e=this.player.getMediaInfo();this.player.loadMedia(e)}},{key:"renderSessionID",value:function(){var e=this,t=this.player&&this.player.config&&this.player.config.session&&this.player.config.session.id;return t?(0,h.h)("div",{className:u.default.linkOptionsContainer},(0,h.h)("div",{className:u.default.copyUrlRow},(0,h.h)("div",{ref:function(t){e.sessionEl=t},className:u.default.errorSession},(0,h.h)(v.Text,{id:"error.default_session_text"})," "," "+t),(0,h.h)(g.CopyButton,{copy:function(){return e.copyError()}}))):void 0}},{key:"renderRetryButton",value:function(){var e=this;if(this.player.getMediaInfo())return(0,h.h)("div",{className:u.default.controlButtonContainer,onClick:function(){return e.handleClick()}},(0,h.h)("button",{className:[u.default.controlButton,u.default.retryBtn].join(" ")},(0,h.h)(v.Text,{id:"error.retry"})))}},{key:"render",value:function(){return this.props&&this.props.hasError?(0,h.h)("div",{className:"overlay-portal"},(0,h.h)(y.Overlay,{open:!0,permanent:!0,type:"error"},(0,h.h)("div",{className:u.default.errorOverlay},(0,h.h)("p",{className:u.default.errorText}),(0,h.h)("div",{className:u.default.svgContainer},(0,h.h)("svg",{width:"124",height:"110",viewBox:"0 0 124 110",xmlns:"http://www.w3.org/2000/svg",xmlnsXlink:"http://www.w3.org/1999/xlink"},(0,h.h)("defs",null,(0,h.h)("polygon",{id:"path-1",points:"58.0906294 70 50.7492774 88.8201923 60.1881585 88.8201923 54.22331 107 73.8876457 84.2307692 64.0554779 84.2307692 70.6102564 70"})),(0,h.h)("g",{id:"Player-v3",fill:"none",fillRule:"evenodd"},(0,h.h)("g",{id:"Desktop---Default---Error",transform:"translate(-365 -103)"},(0,h.h)("g",{id:"Cloud",transform:"translate(366 104)"},(0,h.h)("path",{d:"M63.5662942,30.179068 C61.0506558,29.4162424 58.3339083,29 55.5,29 C42.5213084,29 32,37.7304474 32,48.5 C32,48.6497107 32.0020332,48.7990274 32.0060779,48.947932 L32.0060779,48.947932 C20.975194,51.4855427 13,58.8323573 13,67.5 C13,71.2164926 14.4662425,74.6901504 17.0109182,77.6459815 C17.3714483,67.0552274 26.624181,58.1393462 39.3259742,55.0194402 L39.3259742,55.0194402 C39.3212229,54.8326784 39.3188345,54.6453999 39.3188345,54.4576271 C39.3188345,41.956968 49.9040267,31.6467441 63.5662942,30.179068 Z",id:"Combined-Shape",fillOpacity:".08",fill:"#2E2E2E"}),(0,h.h)("path",{d:"M31.0032591,48.1614253 C31.2192187,36.9518144 42.1402046,28 55.5,28 C64.749856,28 73.0886419,32.3249294 77.2653132,39.0733535 C84.8537029,39.7078593 90.7909537,44.3809769 90.9945979,50.1913309 C102.911627,51.5069936 112,59.4322556 112,69 C112,79.5603607 100.981582,88 87.5,88 C84.4639246,88 81.503099,87.5724513 78.7283559,86.7489741 C74.6488476,88.1943213 69.4726739,89 64,89 C58.7323857,89 53.737093,88.2538247 49.7263698,86.9058736 C46.7827225,87.6274324 43.6763865,88 40.5,88 C24.8190401,88 12,78.9101352 12,67.5 C12,58.659353 19.7679337,51.004786 31.0032591,48.1614253 Z",id:"Combined-Shape",stroke:"#666",strokeWidth:"2"}),(0,h.h)("g",{id:"Path-8",strokeLinecap:"round",strokeLinejoin:"round"},(0,h.h)("use",{fill:"#666",xlinkHref:"#path-1"}),(0,h.h)("path",{stroke:"#1D1D1D",strokeWidth:"2",d:"M65.6170644,83.2307692 L76.0725949,83.2307692 L51.7165365,111.432521 L58.8076053,89.8201923 L49.2858112,89.8201923 L57.4073201,69 L72.1718429,69 L65.6170644,83.2307692 Z"})),(0,h.h)("path",{d:"M59.9991166,0 L59.9991166,7.04768642 C59.9991166,7.59997117 60.4468318,8.04768642 60.9991166,8.04768642 C61.5514013,8.04768642 61.9991166,7.59997117 61.9991166,7.04768642 L61.9991166,0 C61.9991166,-0.55228475 61.5514013,-1 60.9991166,-1 C60.4468318,-1 59.9991166,-0.55228475 59.9991166,0 Z M95.3084192,8.85153517 L90.7782537,14.2503762 C90.4232519,14.6734508 90.4784359,15.3042064 90.9015106,15.6592082 C91.3245852,16.01421 91.9553408,15.9590261 92.3103426,15.5359514 L96.8405081,10.1371104 C97.1955099,9.71403572 97.140326,9.08328013 96.7172513,8.72827833 C96.2941766,8.37327654 95.663421,8.4284605 95.3084192,8.85153517 Z M121.628196,36.6783398 L114.687579,37.9021577 C114.143685,37.9980609 113.780517,38.5167193 113.87642,39.0606136 C113.972323,39.6045079 114.490981,39.9676764 115.034876,39.8717732 L121.975492,38.6479553 C122.519386,38.552052 122.882555,38.0333936 122.786652,37.4894993 C122.690748,36.945605 122.17209,36.5824365 121.628196,36.6783398 Z M0.0227411046,38.6479553 L6.96335733,39.8717732 C7.50725163,39.9676764 8.02591002,39.6045079 8.12181326,39.0606136 C8.2177165,38.5167193 7.85454799,37.9980609 7.31065368,37.9021577 L0.37003746,36.6783398 C-0.173856844,36.5824365 -0.69251523,36.945605 -0.788418471,37.4894993 C-0.884321711,38.0333936 -0.521153199,38.552052 0.0227411046,38.6479553 Z M25.157725,10.1371104 L29.6878905,15.5359514 C30.0428923,15.9590261 30.6736479,16.01421 31.0967226,15.6592082 C31.5197972,15.3042064 31.5749812,14.6734508 31.2199794,14.2503762 L26.6898139,8.85153517 C26.3348121,8.4284605 25.7040565,8.37327654 25.2809818,8.72827833 C24.8579072,9.08328013 24.8027232,9.71403572 25.157725,10.1371104 Z",id:"Path-9",fill:"#666",fillRule:"nonzero"})))))),(0,h.h)("div",{className:u.default.headline},this.props.errorHead?this.props.errorHead:(0,h.h)(v.Text,{id:"error.default_error"})),this.renderSessionID(),this.renderRetryButton()))):void 0}}]),t}(f.default))||l;t.ErrorOverlay=w},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(79);Object.defineProperty(t,"CopyButton",{enumerable:!0,get:function(){return a.CopyButton}})},function(e,t,n){"use strict";function a(e){return(0,i.h)("div",{className:o.default.playbackGuiWWrapper},(0,i.h)(v.KeyboardControl,{player:e.player,config:e.config}),(0,i.h)(p.Loading,{player:e.player}),(0,i.h)("div",{className:o.default.playerGui,id:"player-gui"},(0,i.h)(y.OverlayPortal,null),(0,i.h)(m.UnmuteIndication,{player:e.player}),(0,i.h)(s.OverlayAction,{player:e.player}),(0,i.h)(O.PlaybackControls,{player:e.player}),(0,i.h)(x.ShareControl,{player:e.player}),(0,i.h)(f.BottomBar,null,(0,i.h)(c.SeekBarLivePlaybackContainer,{showFramePreview:!0,showTimeBubble:!0,player:e.player,playerContainer:e.playerContainer}),(0,i.h)("div",{className:o.default.leftControls},(0,i.h)(O.PlaybackControls,{player:e.player}),(0,i.h)(b.LiveTag,{player:e.player})),(0,i.h)("div",{className:o.default.rightControls},_.VrStereoToggleControl.shouldRender(e)?(0,i.h)(_.VrStereoToggleControl,{player:e.player}):void 0,(0,i.h)(u.VolumeControl,{player:e.player}),(0,i.h)(k.LanguageControl,{player:e.player}),(0,i.h)(h.SettingsControl,{player:e.player}),(0,i.h)(w.CastControl,{player:e.player}),(0,i.h)(T.PictureInPicture,{player:e.player}),(0,i.h)(d.FullscreenControl,{player:e.player})))),g.Watermark.shouldRender(e)?(0,i.h)(g.Watermark,{player:e.player}):void 0,(0,i.h)(l.PrePlaybackPlayOverlay,{player:e.player}),(0,i.h)(E.CastBeforePlay,{player:e.player}),(0,i.h)(C.PictureInPictureOverlay,{player:e.player}),(0,i.h)(P.Backdrop,null))}Object.defineProperty(t,"__esModule",{value:!0}),t.liveUI=a;var r=n(1),o=function(e){return e&&e.__esModule?e:{default:e}}(r),i=n(0),s=n(36),l=n(38),p=n(15),c=n(86),u=n(22),h=n(43),k=n(47),d=n(23),f=n(24),y=n(50),v=n(25),b=n(87),m=n(26),g=n(51),_=n(48),w=n(52),E=n(53),P=n(73),O=n(27),T=n(54),C=n(77),x=n(55)},function(e,t,n){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function r(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.SeekBarLivePlaybackContainer=void 0;var i,s,l=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),p=n(0),c=n(2),u=n(7),h=n(18),k=n(3),d=function(e){return e&&e.__esModule?e:{default:e}}(k),f=n(39),y=function(e){return{currentTime:e.seekbar.currentTime,duration:e.engine.duration,isDraggingActive:e.seekbar.draggingActive,isMobile:e.shell.isMobile,poster:e.engine.poster,isDvr:e.engine.isDvr}},v=(i=(0,c.connect)(y,(0,u.bindActions)(h.actions)))(s=function(e){function t(e){return a(this,t),r(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,{name:"SeekBarLivePlaybackContainer",player:e.player}))}return o(t,e),l(t,[{key:"componentDidMount",value:function(){var e=this;this.eventManager.listen(this.player,this.player.Event.TIME_UPDATE,function(){e.props.isDraggingActive||e.props.updateCurrentTime(e.player.currentTime)})}},{key:"render",value:function(e){var t=this;if(e.isDvr)return(0,p.h)(f.SeekBarControl,{player:this.props.player,playerElement:this.props.playerContainer,showTimeBubble:this.props.showTimeBubble,changeCurrentTime:function(e){return t.player.currentTime=e},playerPoster:this.props.poster,updateSeekbarDraggingStatus:function(e){return t.props.updateSeekbarDraggingStatus(e)},updateSeekbarHoverActive:function(e){return t.props.updateSeekbarHoverActive(e)},updateCurrentTime:function(e){return t.props.updateCurrentTime(e)},isDvr:this.props.isDvr,currentTime:this.props.currentTime,duration:this.props.duration,isDraggingActive:this.props.isDraggingActive,isMobile:this.props.isMobile,notifyChange:function(e){return t.notifyChange(e)}})}}]),t}(d.default))||s;t.SeekBarLivePlaybackContainer=v},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.LiveTag=void 0;var s,l,p=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),c=n(1),u=a(c),h=n(0),k=n(2),d=n(3),f=a(d),y=n(6),v=n(5),b=function(e){return{isLive:e.engine.isLive,isDvr:e.engine.isDvr,currentTime:e.engine.currentTime,duration:e.engine.duration}},m=(s=(0,k.connect)(b))(l=function(e){function t(e){return r(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,{name:"LiveTag",player:e.player}))}return i(t,e),p(t,[{key:"isOnLiveEdge",value:function(){return this.props.currentTime>=this.props.duration-1}},{key:"onClick",value:function(){this.isOnLiveEdge()||(this.player.seekToLiveEdge(),this.player.paused&&this.player.play()),this.notifyClick()}},{key:"render",value:function(e){var t=this,n=[u.default.liveTag];return e.isDvr&&!this.isOnLiveEdge()&&n.push(u.default.nonLivePlayhead),(0,h.h)("div",{tabIndex:"0",className:n.join(" "),onClick:function(){return t.onClick()},onKeyDown:function(e){e.keyCode===y.KeyMap.ENTER&&t.onClick()}},(0,h.h)(v.Text,{id:"controls.live"}))}}]),t}(f.default))||l;t.LiveTag=m},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.middleware=void 0;var a=n(13),r=n(62),o=n(177),i=function(e,t){return(0,a.applyMiddleware)((0,o.loggerMiddleware)(t),(0,r.eventDispatcherMiddleware)(e))};t.middleware=i},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.loggerMiddleware=void 0;var a=n(30),r=function(e){return e&&e.__esModule?e:{default:e}}(a),o=(0,r.default)("UILoggerMiddleware"),i=function(e){return function(t){return function(t){return function(n){e.debugActions&&o.debug("Action fired",n),t(n)}}}};t.loggerMiddleware=i},function(e,t,n){"use strict";function a(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}Object.defineProperty(t,"__esModule",{value:!0}),t.volume=t.shell=t.share=t.setting=t.seekbar=t.overlayAction=t.loading=t.engine=t.cvaa=t.config=void 0;var r=n(12),o=a(r),i=n(20),s=a(i),l=n(11),p=a(l),c=n(14),u=a(c),h=n(21),k=a(h),d=n(18),f=a(d),y=n(34),v=a(y),b=n(19),m=a(b),g=n(8),_=a(g),w=n(33),E=a(w);t.config=o,t.cvaa=s,t.engine=p,t.loading=u,t.overlayAction=k,t.seekbar=f,t.setting=v,t.share=m,t.shell=_,t.volume=E},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(82);Object.defineProperty(t,"AdLearnMore",{enumerable:!0,get:function(){return a.AdLearnMore}});var r=n(81);Object.defineProperty(t,"AdSkip",{enumerable:!0,get:function(){return r.AdSkip}});var o=n(180);Object.defineProperty(t,"AdNotice",{enumerable:!0,get:function(){return o.AdNotice}});var i=n(3);Object.defineProperty(t,"BaseComponent",{enumerable:!0,get:function(){return i.BaseComponent}});var s=n(24);Object.defineProperty(t,"BottomBar",{enumerable:!0,get:function(){return s.BottomBar}});var l=n(70);Object.defineProperty(t,"CVAAOverlay",{enumerable:!0,get:function(){return l.CVAAOverlay}});var p=n(46);Object.defineProperty(t,"DropDown",{enumerable:!0,get:function(){return p.DropDown}});var c=n(61);Object.defineProperty(t,"EngineConnector",{enumerable:!0,get:function(){return c.EngineConnector}});var u=n(85);Object.defineProperty(t,"ErrorOverlay",{enumerable:!0,get:function(){return u.ErrorOverlay}});var h=n(23);Object.defineProperty(t,"FullscreenControl",{enumerable:!0,get:function(){return h.FullscreenControl}});var k=n(4);Object.defineProperty(t,"Icon",{enumerable:!0,get:function(){return k.Icon}}),Object.defineProperty(t,"IconType",{enumerable:!0,get:function(){return k.IconType}});var d=n(25);Object.defineProperty(t,"KeyboardControl",{enumerable:!0,get:function(){return d.KeyboardControl}});var f=n(47);Object.defineProperty(t,"LanguageControl",{enumerable:!0,get:function(){return f.LanguageControl}});var y=n(87);Object.defineProperty(t,"LiveTag",{enumerable:!0,get:function(){return y.LiveTag}});var v=n(15);Object.defineProperty(t,"Loading",{enumerable:!0,get:function(){return v.Loading}});var b=n(69);Object.defineProperty(t,"Menu",{enumerable:!0,get:function(){return b.Menu}});var m=n(17);Object.defineProperty(t,"Overlay",{enumerable:!0,get:function(){return m.Overlay}});var g=n(36);Object.defineProperty(t,"OverlayAction",{enumerable:!0,get:function(){return g.OverlayAction}});var _=n(50);Object.defineProperty(t,"OverlayPortal",{enumerable:!0,get:function(){return _.OverlayPortal}});var w=n(75);Object.defineProperty(t,"PlayPauseControl",{enumerable:!0,get:function(){return w.PlayPauseControl}});var E=n(38);Object.defineProperty(t,"PrePlaybackPlayOverlay",{enumerable:!0,get:function(){return E.PrePlaybackPlayOverlay}});var P=n(66);Object.defineProperty(t,"RewindControl",{enumerable:!0,get:function(){return P.RewindControl}});var O=n(39);Object.defineProperty(t,"SeekBarControl",{enumerable:!0,get:function(){return O.SeekBarControl}});var T=n(86);Object.defineProperty(t,"SeekBarLivePlaybackContainer",{enumerable:!0,get:function(){return T.SeekBarLivePlaybackContainer}});var C=n(67);Object.defineProperty(t,"SeekBarPlaybackContainer",{enumerable:!0,get:function(){return C.SeekBarPlaybackContainer}});var x=n(43);Object.defineProperty(t,"SettingsControl",{enumerable:!0,get:function(){return x.SettingsControl}});var S=n(55);Object.defineProperty(t,"ShareControl",{enumerable:!0,get:function(){return S.ShareControl}});var A=n(78);Object.defineProperty(t,"ShareOverlay",{enumerable:!0,get:function(){return A.ShareOverlay}});var M=n(63);Object.defineProperty(t,"Shell",{enumerable:!0,get:function(){return M.Shell}});var j=n(71);Object.defineProperty(t,"Slider",{enumerable:!0,get:function(){return j.Slider}});var I=n(44);Object.defineProperty(t,"SmartContainer",{enumerable:!0,get:function(){return I.SmartContainer}});var D=n(49);Object.defineProperty(t,"TimeDisplay",{enumerable:!0,get:function(){return D.TimeDisplay}});var N=n(80);Object.defineProperty(t,"TimeDisplayAdsContainer",{enumerable:!0,get:function(){return N.TimeDisplayAdsContainer}});var U=n(72);Object.defineProperty(t,"TimeDisplayPlaybackContainer",{enumerable:!0,get:function(){return U.TimeDisplayPlaybackContainer}});var L=n(181);Object.defineProperty(t,"Tooltip",{enumerable:!0,get:function(){return L.Tooltip}});var R=n(83);Object.defineProperty(t,"TopBar",{enumerable:!0,get:function(){return R.TopBar}});var B=n(26);Object.defineProperty(t,"UnmuteIndication",{enumerable:!0,get:function(){return B.UnmuteIndication}});var z=n(64);Object.defineProperty(t,"VideoPlayer",{enumerable:!0,get:function(){return z.VideoPlayer}});var V=n(22);Object.defineProperty(t,"VolumeControl",{enumerable:!0,get:function(){return V.VolumeControl}});var F=n(183);Object.defineProperty(t,"Watermark",{enumerable:!0,get:function(){return F.Watermark}});var K=n(52);Object.defineProperty(t,"CastControl",{enumerable:!0,get:function(){return K.CastControl}});var H=n(184);Object.defineProperty(t,"CastOverlay",{enumerable:!0,get:function(){return H.CastOverlay}});var Y=n(48);Object.defineProperty(t,"VrStereoToggleControl",{enumerable:!0,get:function(){return Y.VrStereoToggleControl}});var G=n(186);Object.defineProperty(t,"CastBeforePlay",{enumerable:!0,get:function(){return G.CastBeforePlay}}),Object.defineProperty(t,"CastAfterPlay",{enumerable:!0,get:function(){return G.CastAfterPlay}});var W=n(74);Object.defineProperty(t,"PlaylistButton",{enumerable:!0,get:function(){return W.PlaylistButton}});var X=n(76);Object.defineProperty(t,"PlaylistNextScreen",{enumerable:!0,get:function(){return X.PlaylistNextScreen}});var q=n(54);Object.defineProperty(t,"PictureInPicture",{enumerable:!0,get:function(){return q.PictureInPicture}});var Z=n(27);Object.defineProperty(t,"PlaybackControls",{enumerable:!0,get:function(){return Z.PlaybackControls}})},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(84);Object.defineProperty(t,"AdNotice",{enumerable:!0,get:function(){return a.AdNotice}})},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(182);Object.defineProperty(t,"Tooltip",{enumerable:!0,get:function(){return a.Tooltip}})},function(e,t,n){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function r(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.Tooltip=void 0;var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),s=n(1),l=function(e){return e&&e.__esModule?e:{default:e}}(s),p=n(0),c=function(e){function t(){return a(this,t),r(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return o(t,e),i(t,[{key:"render",value:function(e){var t=[l.default.tooltip];return e.out&&t.push(l.default.out),(0,p.h)("div",{className:t.join(" "),style:e.left?{left:e.left}:""},e.children)}}]),t}(p.Component);t.Tooltip=c},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(51);Object.defineProperty(t,"Watermark",{enumerable:!0,get:function(){return a.Watermark}})},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(185);Object.defineProperty(t,"CastOverlay",{enumerable:!0,get:function(){return a.CastOverlay}})},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.CastOverlay=void 0;var s,l,p=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),c=n(1),u=a(c),h=n(0),k=n(3),d=a(k),f=n(2),y=n(4),v=n(16),b=n(5),m=function(e){return{poster:e.engine.poster,castSession:e.engine.castSession,isIdle:e.engine.isIdle,isPlaying:e.engine.isPlaying,isPlaybackEnded:e.engine.isPlaybackEnded,isPaused:e.engine.isPaused,isChangingSource:e.engine.isChangingSource}},g=(s=(0,f.connect)(m))(l=function(e){function t(e){return r(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,{name:"CastOverlay",player:e.player}))}return i(t,e),p(t,[{key:"getStatus",value:function(){return this.props.isPlaying||this.props.isPaused?(0,h.h)(b.Text,{id:"cast.status.playing_on"}):this.props.isPlaybackEnded||this.props.isChangingSource||this.props.castSession.resuming?(0,h.h)(b.Text,{id:"cast.status.connected_to"}):(0,h.h)(b.Text,{id:"cast.status.connecting_to"})}},{key:"getIcon",value:function(){return this.props.isPlaying||this.props.isPaused||this.props.isPlaybackEnded||this.props.isChangingSource||this.props.castSession.resuming?(0,h.h)(v.Icon,{type:this.props.icon}):(0,h.h)("div",{className:u.default.castConnectingSpinner})}},{key:"render",value:function(e){if(e.castSession){var t={},n=[u.default.castPoster];if(e.poster){t={backgroundImage:e.isChangingSource?"":"url("+e.poster+")",backgroundSize:"contain"},n.push(u.default.hasPoster)}var a=this.getStatus(),r=this.getIcon();return(0,h.h)("div",null,(0,h.h)("div",{className:u.default.castOverlay},(0,h.h)("div",{className:n.join(" "),style:t,onMouseOver:function(e){return e.stopPropagation()}}),(0,h.h)("div",{className:u.default.castBlackCover})),(0,h.h)("div",{className:u.default.castBox},(0,h.h)("div",{className:u.default.castIcon},r),(0,h.h)("div",{className:u.default.castText},(0,h.h)(b.Localizer,null,(0,h.h)("span",{className:u.default.castStatus},a)),(0,h.h)("br",null),(0,h.h)("span",{className:u.default.castDevice},e.castSession.deviceFriendlyName))))}}}]),t}(d.default))||l;g.defaultProps={icon:y.IconType.Cast},t.CastOverlay=g},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(53);Object.defineProperty(t,"CastBeforePlay",{enumerable:!0,get:function(){return a.CastBeforePlay}});var r=n(187);Object.defineProperty(t,"CastAfterPlay",{enumerable:!0,get:function(){return r.CastAfterPlay}})},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.CastAfterPlay=void 0;var s,l,p=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),c=n(1),u=a(c),h=n(0),k=n(3),d=a(k),f=n(2),y=n(4),v=n(16),b=n(5),m=function(e){return{isPlaybackEnded:e.engine.isPlaybackEnded,isCasting:e.engine.isCasting}},g=(s=(0,f.connect)(m,null))(l=function(e){function t(e){return r(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,{name:"CastAfterPlay",player:e.player}))}return i(t,e),p(t,[{key:"onClick",value:function(e){e.stopPropagation(),this.player.stopCasting()}},{key:"componentDidMount",value:function(){var e=this;setTimeout(function(){e.setState({show:!0})},700)}},{key:"render",value:function(e){var t=this;if(e.isCasting&&e.isPlaybackEnded){var n=[u.default.castOnTvButtonContainer];return this.state.show&&n.push(u.default.showCastOnTv),(0,h.h)("div",null,(0,h.h)("div",{className:n.join(" "),onClick:function(e){return t.onClick(e)}},(0,h.h)("a",{className:[u.default.btn,u.default.btnDarkTransparent,u.default.castOnTvButton].join(" ")},(0,h.h)("div",{className:u.default.castOnTvIconContainer},(0,h.h)(v.Icon,{type:e.icon})),(0,h.h)(b.Localizer,null,(0,h.h)("span",null,(0,h.h)(b.Text,{id:"cast.disconnect_from_tv"}))))))}}}]),t}(d.default))||l;g.defaultProps={icon:y.IconType.CastBrand},t.CastAfterPlay=g},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(7);Object.defineProperty(t,"bindActions",{enumerable:!0,get:function(){return a.bindActions}})}])});


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RemoteControl = undefined;

var _vidiunPlayer = __webpack_require__(44);

var _playerSnapshot = __webpack_require__(99);

var _castEventType = __webpack_require__(100);

var _pakhshkitJs = __webpack_require__(9);

var _remotePayload = __webpack_require__(139);

var _uiWrapper = __webpack_require__(141);

var _logger = __webpack_require__(16);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /* eslint-disable require-jsdoc */


var logger = (0, _logger2.default)('RemoteControl');

/**
 * @class RemoteControl
 * @param {VidiunPlayer} player - The Vidiun player.
 */

var RemoteControl =
/**
 * On remote device disconnecting handler.
 * @returns {void}
 * @memberof RemoteControl
 * @instance
 */

/**
 * On remote device available handler.
 * @param {RemoteAvailablePayload} payload - available payload.
 * @returns {void}
 * @memberof RemoteControl
 * @instance
 */

/**
 * On remote device disconnected handler.
 * @param {RemoteDisconnectedPayload} payload - disconnected payload.
 * @returns {void}
 * @memberof RemoteControl
 * @instance
 */

/**
 * Gets the player snapshot.
 * @returns {PlayerSnapshot} - player snapshot.
 * @memberof RemoteControl
 * @instance
 */
function RemoteControl(player) {
  _classCallCheck(this, RemoteControl);

  this.getPlayerSnapshot = getPlayerSnapshot.bind(player);
  this.getUIWrapper = getUIWrapper.bind(player);
  this.onRemoteDeviceAvailable = onRemoteDeviceAvailable.bind(player);
  this.onRemoteDeviceConnected = onRemoteDeviceConnected.bind(player);
  this.onRemoteDeviceDisconnected = onRemoteDeviceDisconnected.bind(player);
  this.onRemoteDeviceConnecting = onRemoteDeviceConnecting.bind(player);
  this.onRemoteDeviceDisconnecting = onRemoteDeviceDisconnecting.bind(player);
  this.onRemoteDeviceConnectFailed = onRemoteDeviceConnectFailed.bind(player);
}
/**
 * On remote device connect failed handler.
 * @returns {void}
 * @memberof RemoteControl
 * @instance
 */

/**
 * On remote device connecting handler.
 * @returns {void}
 * @memberof RemoteControl
 * @instance
 * @fires CastEventType:CAST_SESSION_STARTING
 */

/**
 * On remote device connected handler.
 * @param {RemoteConnectedPayload} payload - connected payload.
 * @returns {void}
 * @memberof RemoteControl
 * @instance
 */

/**
 * Gets the UI wrapper.
 * @returns {UIWrapper} - The UI wrapper.
 * @memberof RemoteControl
 * @instance
 */
;

function onRemoteDeviceConnecting() {
  logger.debug('onRemoteDeviceConnecting');
  this.dispatchEvent(new _pakhshkitJs.FakeEvent(_castEventType.CastEventType.CAST_SESSION_STARTING));
}

function onRemoteDeviceConnected(payload) {
  var _this = this;

  logger.debug('onRemoteDeviceConnected', payload);
  var player = payload.player,
      ui = payload.ui,
      session = payload.session;
  // After remote player is connected, clean all listeners and bounce the remote player events forward

  this._eventManager.removeAll();
  Object.values(_pakhshkitJs.EventType).forEach(function (coreEvent) {
    return _this._eventManager.listen(player, coreEvent, function (e) {
      return _this.dispatchEvent(e);
    });
  });
  // Use the current config with the remote player presets on the new ui wrapper
  var config = this.config;
  if (ui) {
    _pakhshkitJs.Utils.Object.mergeDeep(config, { ui: { customPreset: ui.uis } });
  }
  this.configure({
    playback: {
      muted: this.muted,
      volume: this.volume
    }
  });
  // Reset the local player, create new ui wrapper and set the remote player
  this._localPlayer.reset();
  this._uiWrapper.destroy();
  this._remotePlayer = player;
  this._uiWrapper = new _uiWrapper.UIWrapper(this, config);
  // Dispatch the cast started event
  this.dispatchEvent(new _pakhshkitJs.FakeEvent(_castEventType.CastEventType.CAST_SESSION_STARTED, {
    session: session
  }));
}

function onRemoteDeviceDisconnecting() {
  logger.debug('onRemoteDeviceDisconnecting');
  this.dispatchEvent(new _pakhshkitJs.FakeEvent(_castEventType.CastEventType.CAST_SESSION_ENDING));
}

function onRemoteDeviceDisconnected(payload) {
  var _this2 = this;

  logger.debug('onRemoteDeviceDisconnected', payload);
  var player = payload.player,
      snapshot = payload.snapshot;

  if (this._remotePlayer && this._remotePlayer === player) {
    // After remote player is disconnected, clean all listeners and bounce the remote player events forward
    this._eventManager.removeAll();
    reconstructPlayerComponents.call(this, snapshot);
    if (snapshot) {
      this.dispatchEvent(new _pakhshkitJs.FakeEvent(_castEventType.CastEventType.CAST_SESSION_ENDED));
      var originPlaybackConfig = this.config.playback;
      var shouldPause = !snapshot.config.playback.autoplay;
      var mediaInfo = snapshot.mediaInfo;
      snapshot.config.playback.autoplay = true;
      configurePlayback.call(this, snapshot.config.playback);
      if (mediaInfo) {
        this.loadMedia(mediaInfo).then(function () {
          _this2._eventManager.listenOnce(_this2, _this2.Event.Core.FIRST_PLAYING, function () {
            _this2.textStyle = snapshot.textStyle;
            configurePlayback.call(_this2, originPlaybackConfig);
            setInitialTracks.call(_this2, snapshot);
            if (shouldPause) {
              _this2.pause();
            }
          });
        });
      }
    }
  }
}

function onRemoteDeviceAvailable(payload) {
  logger.debug('onRemoteDeviceAvailable', payload);
  var player = payload.player,
      available = payload.available;

  this.dispatchEvent(new _pakhshkitJs.FakeEvent(_castEventType.CastEventType.CAST_AVAILABLE, {
    type: player.type,
    available: available
  }));
}

function onRemoteDeviceConnectFailed() {
  logger.debug('onRemoteDeviceConnectFailed');
  this.dispatchEvent(new _pakhshkitJs.FakeEvent(_castEventType.CastEventType.CAST_SESSION_START_FAILED));
}

function getPlayerSnapshot() {
  var snapshot = new _playerSnapshot.PlayerSnapshot(this);
  logger.debug('getPlayerSnapshot', snapshot);
  return snapshot;
}

function getUIWrapper() {
  logger.debug('getUIWrapper');
  return this._uiWrapper;
}

function reconstructPlayerComponents(snapshot) {
  var _this3 = this;

  // Destroy the remote ui wrapper
  this._uiWrapper.destroy();
  var playerConfig = this._localPlayer.config;
  // If the local player config contains ima, needs to destroy the player and create it from scratch
  if (playerConfig.plugins && playerConfig.plugins.ima) {
    var imaConfig = {};
    // If it's a VAST ad we are empty the ad tag so ads won't play and configure it later
    if (playerConfig.cast.advertising && playerConfig.cast.advertising.vast) {
      if (snapshot.config.playback.startTime > 0) {
        var adTagUrl = playerConfig.plugins.ima.adTagUrl;
        imaConfig = {
          adTagUrl: ''
        };
        this._eventManager.listen(this, _pakhshkitJs.EventType.FIRST_PLAYING, function () {
          return _this3.configure({ plugins: { ima: { adTagUrl: adTagUrl } } });
        });
      }
    } else {
      imaConfig = {
        // Needs to wait for engine to create the new ads container
        delayInitUntilSourceSelected: true
      };
    }
    _pakhshkitJs.Utils.Object.mergeDeep(playerConfig, { plugins: { ima: imaConfig } });
    // Destroy the local player and load new one
    this._localPlayer.destroy();
    this._remotePlayer = null;
    this._localPlayer = (0, _pakhshkitJs.loadPlayer)(playerConfig);
  } else {
    this._remotePlayer = null;
  }
  // Listen on the local player events and bounce its events forward
  Object.values(_pakhshkitJs.EventType).forEach(function (coreEvent) {
    return _this3._eventManager.listen(_this3._localPlayer, coreEvent, function (e) {
      return _this3.dispatchEvent(e);
    });
  });
  // Create new ui wrapper with an updated state for the isCastAvailable prop
  this._uiWrapper = new _uiWrapper.UIWrapper(this, this.config);
  this._uiWrapper.setConfig({ isCastAvailable: this.isCastAvailable() }, 'engine');
}

function configurePlayback(playbackConfig) {
  var autoplay = playbackConfig.autoplay,
      startTime = playbackConfig.startTime;

  this.configure({
    playback: {
      startTime: startTime,
      autoplay: autoplay
    }
  });
}

function setInitialTracks(playbackConfig) {
  if (playbackConfig.audioLanguage) {
    var audioTrack = this.getTracks(_pakhshkitJs.TrackType.AUDIO).find(function (t) {
      return t.language === playbackConfig.audioLanguage;
    });
    this.selectTrack(audioTrack);
  }
  if (playbackConfig.textLanguage) {
    var textTrack = this.getTracks(_pakhshkitJs.TrackType.TEXT).find(function (t) {
      return t.language === playbackConfig.textLanguage;
    });
    this.selectTrack(textTrack);
  }
}

exports.RemoteControl = RemoteControl;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseRemotePlayer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _remotePlayer = __webpack_require__(368);

var _pakhshkitJs = __webpack_require__(9);

var _remoteControl = __webpack_require__(69);

var _logger = __webpack_require__(16);

var _logger2 = _interopRequireDefault(_logger);

var _remoteSession = __webpack_require__(53);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
/* eslint no-unused-vars: 0 */


/**
 * Basic remote player.
 * Implements the Vidiun Player playback, ads, tracks,vr and cast APIs.
 * Remote players should extend this class and implement the needed API.
 * @class BaseRemotePlayer
 * @param {string} name - Remote player name.
 * @param {Object} config - Cast configuration.
 * @param {RemoteControl} remoteControl - Remote control.
 * @extends {FakeEventTarget}
 * @implements {IRemotePlayer}
 */
var BaseRemotePlayer = function (_FakeEventTarget) {
  _inherits(BaseRemotePlayer, _FakeEventTarget);

  _createClass(BaseRemotePlayer, null, [{
    key: 'isSupported',


    /**
     * @static
     * @returns {boolean} - Whether the remote player is supported in the current environment.
     * @memberof BaseRemotePlayer
     * @example
     * BaseRemotePlayer.isSupported() // true
     */

    /**
     * Default configuration of the remote player.
     * @static
     * @type {Object}
     * @memberof BaseRemotePlayer
     * @example
     * BaseRemotePlayer.defaultConfig // {}
     */
    value: function isSupported() {
      return true;
    }

    /**
     * Remote player type.
     * @static
     * @type {string}
     * @memberof BaseRemotePlayer
     * @example
     * BaseRemotePlayer.Type // 'BaseRemotePlayer'
     */

  }]);

  function BaseRemotePlayer(name, castConfig, remoteControl) {
    _classCallCheck(this, BaseRemotePlayer);

    var _this = _possibleConstructorReturn(this, (BaseRemotePlayer.__proto__ || Object.getPrototypeOf(BaseRemotePlayer)).call(this));

    _this._playerConfig = {};
    _this._logger = (0, _logger2.default)(name);
    _this._remoteControl = remoteControl;
    _this._castConfig = _pakhshkitJs.Utils.Object.mergeDeep({}, _this.constructor.defaultConfig, castConfig);
    _this._eventManager = new _pakhshkitJs.EventManager();
    _this._logger.debug('Initialized');
    return _this;
  }

  /**
   * Loads a media to the receiver application.
   * @param {Object} mediaInfo - The entry media info.
   * @returns {Promise<void>} - Promise to indicate load succeed or failed.
   * @instance
   * @memberof BaseRemotePlayer
   */


  _createClass(BaseRemotePlayer, [{
    key: 'loadMedia',
    value: function loadMedia(mediaInfo) {
      return Promise.resolve();
    }

    /**
     * Sets a media to the remote player..
     * @param {Object} mediaConfig - Media configuration to set.
     * @instance
     * @returns {void}
     * @memberof BaseRemotePlayer
     */

  }, {
    key: 'setMedia',
    value: function setMedia(mediaConfig) {}

    /**
     * Gets the media Info.
     * @returns {?Object} - The media info.
     * @instance
     * @memberof BaseRemotePlayer
     */

  }, {
    key: 'getMediaInfo',
    value: function getMediaInfo() {}

    /**
     * Configure the remote player
     * @param {Object} config - Configuration to set.
     * @instance
     * @returns {void}
     * @memberof BaseRemotePlayer
     */

  }, {
    key: 'configure',
    value: function configure() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    }

    /**
     * The remote player readiness.
     * @returns {Promise<*>} - Promise which resolved when the remote player is ready.
     * @instance
     * @memberof BaseRemotePlayer
     */

  }, {
    key: 'ready',
    value: function ready() {
      return Promise.resolve();
    }

    /**
     * Load the remote player.
     * @instance
     * @returns {void}
     * @memberof BaseRemotePlayer
     */

  }, {
    key: 'load',
    value: function load() {}

    /**
     * Play/resume the remote player.
     * @instance
     * @returns {void}
     * @memberof BaseRemotePlayer
     */

  }, {
    key: 'play',
    value: function play() {}

    /**
     * Pause the remote player.
     * @instance
     * @returns {void}
     * @memberof BaseRemotePlayer
     */

  }, {
    key: 'pause',
    value: function pause() {}

    /**
     * Reset the remote player.
     * @instance
     * @returns {void}
     * @memberof BaseRemotePlayer
     */

  }, {
    key: 'reset',
    value: function reset() {}

    /**
     * Destroy the remote player.
     * @instance
     * @returns {void}
     * @memberof BaseRemotePlayer
     */

  }, {
    key: 'destroy',
    value: function destroy() {}

    /**
     * @returns {boolean} - Whether the current playback is a live playback.
     * @instance
     * @memberof BaseRemotePlayer
     * @example
     * BaseRemotePlayer.prototype.isLive() // false
     */

  }, {
    key: 'isLive',
    value: function isLive() {
      return false;
    }

    /**
     * @returns {boolean} - Whether the current live playback has DVR window. In case of non-live playback will return false.
     * @instance
     * @memberof BaseRemotePlayer
     * @example
     * BaseRemotePlayer.prototype.isDvr() // false
     */

  }, {
    key: 'isDvr',
    value: function isDvr() {
      return false;
    }

    /**
     * Seeks to the live edge.
     * @instance
     * @returns {void}
     * @memberof BaseRemotePlayer
     */

  }, {
    key: 'seekToLiveEdge',
    value: function seekToLiveEdge() {}

    /**
     * @returns {number} - The start time of the DVR window.
     * @instance
     * @memberof BaseRemotePlayer
     * @example
     * BaseRemotePlayer.prototype.getStartTimeOfDvrWindow() // 0
     */

  }, {
    key: 'getStartTimeOfDvrWindow',
    value: function getStartTimeOfDvrWindow() {
      return 0;
    }

    /**
     * @param {string} [type] - Track type.
     * @returns {Array<Track>} - The remote player tracks.
     * @instance
     * @memberof BaseRemotePlayer
     * @example
     * BaseRemotePlayer.prototype.getTracks() // []
     */

  }, {
    key: 'getTracks',
    value: function getTracks(type) {
      return [];
    }

    /**
     * @returns {Object} - The remote player active tracks.
     * @instance
     * @memberof BaseRemotePlayer
     * @example
     * BaseRemotePlayer.prototype.getTracks() // {audio: undefined, video: undefined, text: undefined}
     */

  }, {
    key: 'getActiveTracks',
    value: function getActiveTracks() {
      return { audio: undefined, video: undefined, text: undefined };
    }

    /**
     * Select a certain track to be active.
     * @param {Track} track - The track to activate.
     * @returns {void}
     * @instance
     * @memberof BaseRemotePlayer
     */

  }, {
    key: 'selectTrack',
    value: function selectTrack(track) {}

    /**
     * Hides the active text track.
     * @returns {void}
     * @instance
     * @memberof BaseRemotePlayer
     */

  }, {
    key: 'hideTextTrack',
    value: function hideTextTrack() {}

    /**
     * @function enableAdaptiveBitrate
     * @description Enables automatic adaptive bitrate switching.
     * @returns {void}
     * @instance
     * @memberof BaseRemotePlayer
     */

  }, {
    key: 'enableAdaptiveBitrate',
    value: function enableAdaptiveBitrate() {}

    /**
     * @function isAdaptiveBitrateEnabled
     * @returns {boolean} - Whether adaptive bitrate is enabled.
     * @instance
     * @memberof BaseRemotePlayer
     * @example
     * BaseRemotePlayer.prototype.isAdaptiveBitrateEnabled() // true
     */

  }, {
    key: 'isAdaptiveBitrateEnabled',
    value: function isAdaptiveBitrateEnabled() {
      return true;
    }

    /**
     * Sets the text display settings.
     * @function setTextDisplaySettings
     * @param {Object} settings - Text settings.
     * @instance
     * @memberof BaseRemotePlayer
     * @returns {void}
     */

  }, {
    key: 'setTextDisplaySettings',
    value: function setTextDisplaySettings(settings) {}

    /**
     * Start casting.
     * @returns {Promise<*>} - A promise to indicate session is starting, or failed
     * @instance
     * @memberof BaseRemotePlayer
     */

  }, {
    key: 'startCasting',
    value: function startCasting() {}

    /**
     * Stops the current cast session.
     * @returns {void}
     * @instance
     * @memberof BaseRemotePlayer
     */

  }, {
    key: 'stopCasting',
    value: function stopCasting() {}

    /**
     * @returns {boolean} - Whether casting is currently active.
     * @instance
     * @memberof BaseRemotePlayer
     * @example
     * BaseRemotePlayer.prototype.isCasting() // true
     */

  }, {
    key: 'isCasting',
    value: function isCasting() {
      return true;
    }

    /**
     * @returns {boolean} - Whether casting is available.
     * @instance
     * @memberof BaseRemotePlayer
     * @example
     * BaseRemotePlayer.prototype.isCastAvailable() // true
     */

  }, {
    key: 'isCastAvailable',
    value: function isCastAvailable() {
      return true;
    }

    /**
     * Gets the current remote session.
     * @returns {RemoteSession} - The remote session.
     * @instance
     * @memberof BaseRemotePlayer
     * @example
     * BaseRemotePlayer.prototype.getCastSession() // new RemoteSession('', '')
     */

  }, {
    key: 'getCastSession',
    value: function getCastSession() {
      return new _remoteSession.RemoteSession('', '');
    }

    /**
     * @returns {boolean} - Whether the current media is of VR type (360 content).
     * @instance
     * @memberof BaseRemotePlayer
     * @example
     * BaseRemotePlayer.prototype.isVr() // false
     */

  }, {
    key: 'isVr',
    value: function isVr() {
      return false;
    }

    /**
     * Toggles VR mode on the current content.
     * @instance
     * @returns {void}
     * @memberof BaseRemotePlayer
     */

  }, {
    key: 'toggleVrStereoMode',
    value: function toggleVrStereoMode() {}

    /**
     * @returns {boolean} - Whether the current content displayed in VR mode.
     * @instance
     * @memberof BaseRemotePlayer
     * @example
     * BaseRemotePlayer.prototype.isInVrStereoMode() // false
     */

  }, {
    key: 'isInVrStereoMode',
    value: function isInVrStereoMode() {
      return false;
    }

    /**
     * The remote player ads controller.
     * @type {?Object}
     * @instance
     * @memberof BaseRemotePlayer
     * @example
     * BaseRemotePlayer.prototype.ads // null
     */

  }, {
    key: 'ads',
    get: function get() {
      return null;
    }

    /**
     * Setter.
     * @param {TextStyle} style - The text style to set.
     * @returns {void}
     * @instance
     * @memberof BaseRemotePlayer
     */

  }, {
    key: 'textStyle',
    set: function set(style) {}

    /**
     * Getter.
     * @returns {TextStyle} - The current text style.
     * @instance
     * @memberof BaseRemotePlayer
     * @example
     * BaseRemotePlayer.prototype.textStyle // new TextStyle()
     */
    ,
    get: function get() {
      return new _pakhshkitJs.TextStyle();
    }

    /**
     * Gets the first buffered range of the remote player.
     * @returns {Array<any>} - First buffered range in seconds.
     * @public
     * @instance
     * @memberof BaseRemotePlayer
     * @example
     * BaseRemotePlayer.prototype.buffered // []
     */

  }, {
    key: 'buffered',
    get: function get() {
      return [];
    }

    /**
     * Setter.
     * @param {number} to - The number to set in seconds.
     * @returns {void}
     * @instance
     * @memberof BaseRemotePlayer
     */

  }, {
    key: 'currentTime',
    set: function set(to) {}

    /**
     * Getter.
     * @returns {number} - The current time in seconds.
     * @instance
     * @memberof BaseRemotePlayer
     * @example
     * BaseRemotePlayer.prototype.currentTime // 0
     */
    ,
    get: function get() {
      return 0;
    }

    /**
     * @returns {number} - The duration in seconds.
     * @instance
     * @memberof BaseRemotePlayer
     * @example
     * BaseRemotePlayer.prototype.duration // 0
     */

  }, {
    key: 'duration',
    get: function get() {
      return 0;
    }

    /**
     * Setter.
     * @param {number} vol - The volume to set in the range of 0-1.
     * @returns {void}
     * @instance
     * @memberof BaseRemotePlayer
     */

  }, {
    key: 'volume',
    set: function set(vol) {}

    /**
     * Getter.
     * @returns {number} - The current volume in the range of 0-1.
     * @instance
     * @memberof BaseRemotePlayer
     * @example
     * BaseRemotePlayer.prototype.volume // 1
     */
    ,
    get: function get() {
      return 1;
    }

    /**
     * @returns {boolean} - Whether the cast player is in paused state.
     * @instance
     * @memberof BaseRemotePlayer
     * @example
     * BaseRemotePlayer.prototype.paused // false
     */

  }, {
    key: 'paused',
    get: function get() {
      return false;
    }

    /**
     * @returns {boolean} - Whether the cast player is in ended state.
     * @instance
     * @memberof BaseRemotePlayer
     * @example
     * BaseRemotePlayer.prototype.ended // false
     */

  }, {
    key: 'ended',
    get: function get() {
      return false;
    }

    /**
     * @returns {boolean} - Whether the cast player is in seeking state.
     * @instance
     * @memberof BaseRemotePlayer
     * @example
     * BaseRemotePlayer.prototype.seeking // false
     */

  }, {
    key: 'seeking',
    get: function get() {
      return false;
    }

    /**
     * Setter.
     * @param {boolean} mute - The mute value to set.
     * @returns {void}
     * @instance
     * @memberof BaseRemotePlayer
     */

  }, {
    key: 'muted',
    set: function set(mute) {}

    /**
     * Getter.
     * @returns {boolean} - The muted state.
     * @instance
     * @memberof BaseRemotePlayer
     * @example
     * BaseRemotePlayer.prototype.muted // false
     */
    ,
    get: function get() {
      return false;
    }

    /**
     * @returns {string} - The current playing source url.
     * @instance
     * @memberof BaseRemotePlayer
     * @example
     * BaseRemotePlayer.prototype.src // ''
     */

  }, {
    key: 'src',
    get: function get() {
      return '';
    }

    /**
     * @returns {string} - The current poster url.
     * @instance
     * @memberof BaseRemotePlayer
     * @example
     * BaseRemotePlayer.prototype.poster // ''
     */

  }, {
    key: 'poster',
    get: function get() {
      return '';
    }

    /**
     * Setter.
     * @param {number} rate - The playback rate to set.
     * @instance
     * @memberof BaseRemotePlayer
     */

  }, {
    key: 'playbackRate',
    set: function set(rate) {}

    /**
     * @returns {string} - The current playback rate.
     * @instance
     * @memberof BaseRemotePlayer
     * @example
     * BaseRemotePlayer.prototype.playbackRate // 1
     */
    ,
    get: function get() {
      return 1;
    }

    /**
     * @returns {string} - The active engine type.
     * @instance
     * @memberof BaseRemotePlayer
     * @example
     * BaseRemotePlayer.prototype.engineType // ''
     */

  }, {
    key: 'engineType',
    get: function get() {
      return '';
    }

    /**
     * @returns {string} - The active stream type.
     * @instance
     * @memberof BaseRemotePlayer
     * @example
     * BaseRemotePlayer.prototype.streamType // ''
     */

  }, {
    key: 'streamType',
    get: function get() {
      return '';
    }

    /**
     * @returns {string} - The remote player type.
     * @instance
     * @memberof BaseRemotePlayer
     * @example
     * BaseRemotePlayer.prototype.type // BaseRemotePlayer.Type
     */

  }, {
    key: 'type',
    get: function get() {
      return BaseRemotePlayer.Type;
    }

    /**
     * @returns {VPOptionsObject} - The runtime remote player config.
     * @instance
     * @memberof BaseRemotePlayer
     */

  }, {
    key: 'config',
    get: function get() {
      return this._playerConfig;
    }
  }]);

  return BaseRemotePlayer;
}(_pakhshkitJs.FakeEventTarget);

BaseRemotePlayer.defaultConfig = {};
BaseRemotePlayer.Type = 'BaseRemotePlayer';
exports.BaseRemotePlayer = BaseRemotePlayer;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _logger = __webpack_require__(16);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

if (!window._babelPolyfill) {
  __webpack_require__(150);
}

var PolyfillManager = function () {
  function PolyfillManager() {
    _classCallCheck(this, PolyfillManager);
  }

  _createClass(PolyfillManager, null, [{
    key: 'register',
    value: function register(polyfill) {
      PolyfillManager._logger.debug('Register <' + polyfill.id + '> polyfill');
      PolyfillManager._polyfills.push(polyfill);
    }
  }, {
    key: 'installAll',
    value: function installAll() {
      PolyfillManager._logger.debug('Installing all polyfills');
      for (var i = 0; i < PolyfillManager._polyfills.length; i++) {
        PolyfillManager._polyfills[i].install();
      }
    }
  }]);

  return PolyfillManager;
}();

PolyfillManager._polyfills = [];
PolyfillManager._logger = (0, _logger2.default)('PolyfillManager');
exports.default = PolyfillManager;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(4);
var document = __webpack_require__(2).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var core = __webpack_require__(23);
var LIBRARY = __webpack_require__(35);
var wksExt = __webpack_require__(103);
var defineProperty = __webpack_require__(7).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(54)('keys');
var uid = __webpack_require__(34);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 75 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(2).document;
module.exports = document && document.documentElement;


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(4);
var anObject = __webpack_require__(1);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(20)(Function.call, __webpack_require__(18).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(4);
var setPrototypeOf = __webpack_require__(77).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(26);
var defined = __webpack_require__(25);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 81 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 82 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(26);
var defined = __webpack_require__(25);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(35);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(14);
var hide = __webpack_require__(13);
var has = __webpack_require__(12);
var Iterators = __webpack_require__(47);
var $iterCreate = __webpack_require__(85);
var setToStringTag = __webpack_require__(45);
var getPrototypeOf = __webpack_require__(19);
var ITERATOR = __webpack_require__(5)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(38);
var descriptor = __webpack_require__(33);
var setToStringTag = __webpack_require__(45);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(13)(IteratorPrototype, __webpack_require__(5)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(58);
var defined = __webpack_require__(25);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(5)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(47);
var ITERATOR = __webpack_require__(5)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(7);
var createDesc = __webpack_require__(33);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(52);
var ITERATOR = __webpack_require__(5)('iterator');
var Iterators = __webpack_require__(47);
module.exports = __webpack_require__(23).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(242);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(10);
var toAbsoluteIndex = __webpack_require__(37);
var toLength = __webpack_require__(8);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(32);
var step = __webpack_require__(119);
var Iterators = __webpack_require__(47);
var toIObject = __webpack_require__(17);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(84)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(20);
var invoke = __webpack_require__(109);
var html = __webpack_require__(76);
var cel = __webpack_require__(72);
var global = __webpack_require__(2);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(21)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var macrotask = __webpack_require__(94).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(21)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver
  } else if (Observer) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(11);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(2);
var DESCRIPTORS = __webpack_require__(6);
var LIBRARY = __webpack_require__(35);
var $typed = __webpack_require__(64);
var hide = __webpack_require__(13);
var redefineAll = __webpack_require__(43);
var fails = __webpack_require__(3);
var anInstance = __webpack_require__(41);
var toInteger = __webpack_require__(26);
var toLength = __webpack_require__(8);
var toIndex = __webpack_require__(128);
var gOPN = __webpack_require__(39).f;
var dP = __webpack_require__(7).f;
var arrayFill = __webpack_require__(92);
var setToStringTag = __webpack_require__(45);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RemotePlayerManager = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _remoteControl = __webpack_require__(69);

var _baseRemotePlayer = __webpack_require__(70);

var _logger = __webpack_require__(16);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RemotePlayerManager = function () {
  function RemotePlayerManager() {
    _classCallCheck(this, RemotePlayerManager);
  }

  _createClass(RemotePlayerManager, null, [{
    key: 'register',
    value: function register(type, remotePlayer) {
      if (typeof remotePlayer === 'function') {
        if (!RemotePlayerManager._registry.has(type)) {
          RemotePlayerManager._logger.debug('Register remote player of type ' + type);
          RemotePlayerManager._registry.set(type, remotePlayer);
        } else {
          RemotePlayerManager._logger.debug('Remote player of type ' + type + ' is already registered');
        }
      } else {
        RemotePlayerManager._logger.debug('remote player must be instance of BaseRemotePlayer');
      }
    }
  }, {
    key: 'load',
    value: function load(castConfig, remoteControl) {
      var registry = RemotePlayerManager._registry;
      registry.forEach(function (RemotePlayer, type) {
        RemotePlayerManager._logger.debug('Load remote player of type ' + type);
        RemotePlayerManager._remotePlayers.set(type, new RemotePlayer(castConfig, remoteControl));
      });
    }
  }, {
    key: 'startCasting',
    value: function startCasting(type) {
      RemotePlayerManager._logger.debug('Start casting');
      var remotePlayer = RemotePlayerManager._getRemotePlayer(type);
      if (remotePlayer) {
        return remotePlayer.startCasting();
      }
      return Promise.reject();
    }
  }, {
    key: 'isCastAvailable',
    value: function isCastAvailable(type) {
      var remotePlayer = RemotePlayerManager._getRemotePlayer(type);
      if (remotePlayer) {
        RemotePlayerManager._logger.debug('isCastAvailable: ' + remotePlayer.isCastAvailable());
        return remotePlayer.isCastAvailable();
      }
      return false;
    }
  }, {
    key: '_getRemotePlayer',
    value: function _getRemotePlayer(type) {
      var remotePlayers = RemotePlayerManager._remotePlayers;
      if (type && remotePlayers.get(type)) {
        return remotePlayers.get(type);
      } else if (remotePlayers.size > 0) {
        return Array.from(remotePlayers.values())[0];
      }
    }
  }]);

  return RemotePlayerManager;
}();

RemotePlayerManager._logger = (0, _logger2.default)('RemotePlayerManager');
RemotePlayerManager._registry = new Map();
RemotePlayerManager._remotePlayers = new Map();
exports.RemotePlayerManager = RemotePlayerManager;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlayerSnapshot = undefined;

var _vidiunPlayer = __webpack_require__(44);

var _pakhshkitJs = __webpack_require__(9);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class PlayerSnapshot
 * @param {VidiunPlayer} player -  The Vidiun player.
 *
 */
var PlayerSnapshot =
/**
 * @type {Object}
 * @instance
 * @memberof PlayerSnapshot
 */
function PlayerSnapshot(player) {
  _classCallCheck(this, PlayerSnapshot);

  this.textStyle = player.textStyle;
  this.mediaInfo = player.getMediaInfo();
  this.advertising = player.config.plugins && player.config.plugins.ima;
  this.config = _pakhshkitJs.Utils.Object.mergeDeep({}, player.config, {
    playback: {
      startTime: getStartTime(player),
      autoplay: player.currentTime === 0 ? true : !player.paused,
      audioLanguage: getLanguage(_pakhshkitJs.TrackType.AUDIO, player),
      textLanguage: getLanguage(_pakhshkitJs.TrackType.TEXT, player)
    }
  });
}
/**
 * @type {Object}
 * @instance
 * @memberof PlayerSnapshot
 */

/**
 * @type {TextStyle}
 * @instance
 * @memberof PlayerSnapshot
 */
;

/**
 * Gets the time to start from with respect to live media.
 * @private
 * @param {VidiunPlayer} player - The player.
 * @returns {number} - The time to start from (0 in live indicates the live edge).
 */


function getStartTime(player) {
  if (player.isLive()) {
    if (player.isDvr()) {
      var isOnLiveEdge = player.duration - player.currentTime < player.config.cast.dvrThreshold;
      if (isOnLiveEdge || !player.currentTime) {
        return -1;
      }
      return player.currentTime;
    } else {
      return -1;
    }
  } else if (!player.isCasting() && !player.currentTime && player.config.playback.startTime > -1) {
    return player.config.playback.startTime;
  }
  return player.currentTime;
}

/**
 * Gets the audio/text language.
 * If the player has started to play it will return the current played audio/text.
 * Otherwise, it will return the configured audio/text.
 * @private
 * @param {string} type - The language type.
 * @param {VidiunPlayer} player - The player.
 * @returns {?string} - The audio language or undefined.
 */
function getLanguage(type, player) {
  var activeTracks = player.getActiveTracks();
  if (activeTracks[type]) {
    return activeTracks[type].language;
  }
  try {
    return player.config.playback[type + 'Language'];
  } catch (e) {
    return null;
  }
}

exports.PlayerSnapshot = PlayerSnapshot;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var namespace = 'vidiun-player';

/**
 * @const {Object} CastEventType
 *
 * @example
 * // Events lifecycle
 * 1. CAST_AVAILABLE
 * 2. CAST_SESSION_STARTING
 * 3. CAST_SESSION_STARTED || CAST_SESSION_START_FAILED -> X
 * 4. CAST_SESSION_ENDING
 * 5. CAST_SESSION_ENDED
 * @example
 * // How to use
 * player.addEventListener(VidiunPlayer.cast.CastEventType.CAST_SESSION_STARTED, e => {
 *   console.log(e.session);
 * };
 */
var CastEventType = {
  /**
   * Fires when cast session start failed.
   * @event CAST_SESSION_START_FAILED
   * @memberof CastEventType
   */
  CAST_SESSION_START_FAILED: namespace + '-castsessionstartfailed',
  /**
   * Fires when cast session starting.
   * @event CAST_SESSION_STARTING
   * @memberof CastEventType
   */
  CAST_SESSION_STARTING: namespace + '-castsessionstarting',
  /**
   * Fires when cast session started.
   * @event CAST_SESSION_STARTED
   * @memberof CastEventType
   */
  CAST_SESSION_STARTED: namespace + '-castsessionstarted',
  /**
   * Fires when cast session ending.
   * @event CAST_SESSION_ENDING
   * @memberof CastEventType
   */
  CAST_SESSION_ENDING: namespace + '-castsessionending',
  /**
   * Fires when cast session ended.
   * @event CAST_SESSION_ENDED
   * @memberof CastEventType
   */
  CAST_SESSION_ENDED: namespace + '-castsessionended',
  /**
   * Fires when cast is available.
   * @event CAST_AVAILABLE
   * @memberof CastEventType
   */
  CAST_AVAILABLE: namespace + '-castavailable'
};

exports.CastEventType = CastEventType;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var namespace = 'vidiun-player';

/**
 * @const {Object} PlaylistEventType
 *
 * @example
 * // Events lifecycle
 * 1. PLAYLIST_LOADED
 * 2. PLAYLIST_ITEM_CHANGED (multiple)
 * 3. PLAYLIST_ENDED
 * @example
 * // How to use
 * player.addEventListener(VidiunPlayer.playlist.PlaylistEventType.PLAYLIST_LOADED, e => {
 *   console.log(e.payload.playlist.metadata.name);
 * };
 */
var PlaylistEventType = {
  /**
   * Fires when the playlist has been loaded.
   * @event PLAYLIST_LOADED
   * @memberof PlaylistEventType
   */
  PLAYLIST_LOADED: namespace + '-playlistloaded',
  /**
   * Fires when a playlist item start to changed.
   * @event PLAYLIST_ITEM_CHANGED
   * @memberof PlaylistEventType
   */
  PLAYLIST_ITEM_CHANGED: namespace + '-playlistitemchanged',
  /**
   * Fires when the playlist has finished.
   * @event PLAYLIST_ENDED
   * @memberof PlaylistEventType
   */
  PLAYLIST_ENDED: namespace + '-playlistended'
};

exports.PlaylistEventType = PlaylistEventType;

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(6) && !__webpack_require__(3)(function () {
  return Object.defineProperty(__webpack_require__(72)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(5);


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(12);
var toIObject = __webpack_require__(17);
var arrayIndexOf = __webpack_require__(55)(false);
var IE_PROTO = __webpack_require__(74)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(7);
var anObject = __webpack_require__(1);
var getKeys = __webpack_require__(36);

module.exports = __webpack_require__(6) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(17);
var gOPN = __webpack_require__(39).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(36);
var gOPS = __webpack_require__(56);
var pIE = __webpack_require__(51);
var toObject = __webpack_require__(10);
var IObject = __webpack_require__(50);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(3)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(11);
var isObject = __webpack_require__(4);
var invoke = __webpack_require__(109);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 109 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(2).parseInt;
var $trim = __webpack_require__(46).trim;
var ws = __webpack_require__(78);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(2).parseFloat;
var $trim = __webpack_require__(46).trim;

module.exports = 1 / $parseFloat(__webpack_require__(78) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(21);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(4);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 114 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(81);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(1);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(11);
var toObject = __webpack_require__(10);
var IObject = __webpack_require__(50);
var toLength = __webpack_require__(8);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(10);
var toAbsoluteIndex = __webpack_require__(37);
var toLength = __webpack_require__(8);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(6) && /./g.flags != 'g') __webpack_require__(7).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(60)
});


/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(1);
var isObject = __webpack_require__(4);
var newPromiseCapability = __webpack_require__(96);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(124);
var validate = __webpack_require__(48);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(63)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(7).f;
var create = __webpack_require__(38);
var redefineAll = __webpack_require__(43);
var ctx = __webpack_require__(20);
var anInstance = __webpack_require__(41);
var forOf = __webpack_require__(42);
var $iterDefine = __webpack_require__(84);
var step = __webpack_require__(119);
var setSpecies = __webpack_require__(40);
var DESCRIPTORS = __webpack_require__(6);
var fastKey = __webpack_require__(31).fastKey;
var validate = __webpack_require__(48);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(124);
var validate = __webpack_require__(48);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(63)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var each = __webpack_require__(28)(0);
var redefine = __webpack_require__(14);
var meta = __webpack_require__(31);
var assign = __webpack_require__(107);
var weak = __webpack_require__(127);
var isObject = __webpack_require__(4);
var fails = __webpack_require__(3);
var validate = __webpack_require__(48);
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var tmp = {};
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(63)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(43);
var getWeak = __webpack_require__(31).getWeak;
var anObject = __webpack_require__(1);
var isObject = __webpack_require__(4);
var anInstance = __webpack_require__(41);
var forOf = __webpack_require__(42);
var createArrayMethod = __webpack_require__(28);
var $has = __webpack_require__(12);
var validate = __webpack_require__(48);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(26);
var toLength = __webpack_require__(8);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(39);
var gOPS = __webpack_require__(56);
var anObject = __webpack_require__(1);
var Reflect = __webpack_require__(2).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(57);
var isObject = __webpack_require__(4);
var toLength = __webpack_require__(8);
var ctx = __webpack_require__(20);
var IS_CONCAT_SPREADABLE = __webpack_require__(5)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(8);
var repeat = __webpack_require__(80);
var defined = __webpack_require__(25);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(36);
var toIObject = __webpack_require__(17);
var isEnum = __webpack_require__(51).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(52);
var from = __webpack_require__(134);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(42);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 135 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.ott=t():(e.pakhshkit=e.pakhshkit||{},e.pakhshkit.providers=e.pakhshkit.providers||{},e.pakhshkit.providers.ott=t())}(this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.i=function(e){return e},t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=41)}([function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),a=n(1),i=function(e){return e&&e.__esModule?e:{default:e}}(a),u=function(){function e(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:new Map;r(this,e),this._attemptCounter=1,this.headers=t}return o(e,[{key:"getUrl",value:function(e){return e+"/service/"+this.service+(this.action?"/action/"+this.action:"")}},{key:"doHttpRequest",value:function(){var e=this,t=new Promise(function(t,n){e._requestPromise={resolve:t,reject:n}});return this.url||this._requestPromise.reject(new i.default(i.default.Severity.CRITICAL,i.default.Category.NETWORK,i.default.Code.MALFORMED_DATA_URI,{url:this.url})),this._createXHR(),t}},{key:"_createXHR",value:function(){var e=this,t=new XMLHttpRequest;t.onreadystatechange=function(){if(4===t.readyState&&200===t.status)try{var n=JSON.parse(t.responseText);return e.responseHeaders=e._getResponseHeaders(t),e._requestPromise.resolve(n)}catch(n){e._requestPromise.reject(e._createError(t,i.default.Code.BAD_SERVER_RESPONSE,{text:t.responseText}))}},t.open(this.method,this.url,this.retryConfig.async),this.retryConfig.async&&this.retryConfig.timeout&&(t.timeout=this.retryConfig.timeout);var n=performance.now();t.ontimeout=function(){e._handleError(t,i.default.Code.TIMEOUT,{timeout:(performance.now()-n)/1e3,statusText:t.statusText})},t.onerror=t.onabort=function(){e._handleError(t,i.default.Code.HTTP_ERROR,{text:t.responseText,statusText:t.statusText})},this.headers.forEach(function(e,n){t.setRequestHeader(n,e)}),t.send(this.params)}},{key:"_getResponseHeaders",value:function(e){return e.getAllResponseHeaders().split("\n").filter(function(e){return 0===e.toLowerCase().indexOf("x-")})}},{key:"_handleError",value:function(e,t,n){var r=this._createError(e,t,n);if(e.onreadystatechange=function(){},e.onerror=function(){},e.ontimeout=function(){},e.onabort=function(){},!(this.retryConfig.maxAttempts&&this._attemptCounter<this.retryConfig.maxAttempts))return this._requestPromise.reject(r);this._attemptCounter++,this._createXHR()}},{key:"_createError",value:function(e,t,n){return Object.assign(n,{url:this.url,headers:this._getResponseHeaders(e),attempt:this._attemptCounter}),new i.default(i.default.Severity.CRITICAL,i.default.Category.NETWORK,t,n)}}]),e}();t.default=u},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var o=n(2),a=function(e){return e&&e.__esModule?e:{default:e}}(o),i=n(23),u=n(22),s=n(21),c=function e(t,n,a){var i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{};r(this,e),this.severity=t,this.category=n,this.code=a,this.data=i,(0,o.getLogLevel)("Error")!==o.LogLevel.OFF&&e._logger.error("Category:"+n+" | Code:"+a+" |",i)};c.Severity=i.Severity,c.Category=s.Category,c.Code=u.Code,c._logger=(0,a.default)("Error"),t.default=c},function(e,t,n){"use strict";function r(e){return e?u.get(e):u}function o(e){return r(e).getLevel()}function a(e,t){r(t).setLevel(e)}Object.defineProperty(t,"__esModule",{value:!0}),t.setLogLevel=t.getLogLevel=t.LogLevel=void 0;var i=n(27),u=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}(i),s={DEBUG:u.DEBUG,INFO:u.INFO,TIME:u.TIME,WARN:u.WARN,ERROR:u.ERROR,OFF:u.OFF};u.useDefaults({defaultLevel:u.ERROR}),t.default=r,t.LogLevel=s,t.getLogLevel=o,t.setLogLevel=a},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var o=function e(t){r(this,e),this.hasError=!1,"VidiunAPIException"===t.objectType?(this.hasError=!0,this.error=new a(t.code,t.message)):t.error&&"VidiunAPIException"===t.error.objectType?(this.hasError=!0,this.error=new a(t.error.code,t.error.message)):this.data=t};t.default=o;var a=function e(t,n){r(this,e),this.code=t,this.message=n}},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),a=n(10),i=function(e){return e&&e.__esModule?e:{default:e}}(a),u=function(){function e(){r(this,e),this.metadata=new Map,this.sources=new i.default,this.type=e.Type.UNKNOWN}return o(e,[{key:"toJSON",value:function(){return{id:this.id,name:this.name,sources:this.sources.toJSON(),duration:this.duration,dvrStatus:this.dvrStatus,metadata:this.metadata,type:this.type,poster:this.poster,assetReferenceType:this.assetReferenceType}}}]),e}();u.Type={VOD:"Vod",LIVE:"Live",IMAGE:"Image",AUDIO:"Audio",UNKNOWN:"Unknown"},t.default=u},,function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),u=n(3),s=function(e){return e&&e.__esModule?e:{default:e}}(u),c=function(e){function t(e){r(this,t);var n=o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.name="",n.description="",n.tags=[],n.metas=[],n.pictures=[],n.hasError||(n.id=e.id,n.name=e.name,n.description=e.description,n.metas=n._formatTagsMetas(e.metas),n.tags=n._formatTagsMetas(e.tags),n.pictures=e.images),n}return a(t,e),i(t,[{key:"_formatTagsMetas",value:function(e){var t=[];return Object.keys(e).forEach(function(n){if(e[n].objects){var r="";e[n].objects.forEach(function(e){r+=e.value+"|"}),t.push({key:n,value:r})}else t.push({key:n,value:e[n].value})}),t}}]),t}(s.default);c.Type={MEDIA:"media",RECORDING:"recording",EPG:"epg"},c.AssetReferenceType={MEDIA:"media",EPG_INTERNAL:"epg_internal",EPG_EXTERNAL:"epg_external"},t.default=c},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),a=function(){function e(t,n,o){r(this,e),this.licenseUrl=t,this.scheme=n,o&&(this.certificate=o)}return o(e,[{key:"toJSON",value:function(){var e={licenseUrl:this.licenseUrl,scheme:this.scheme};return this.certificate&&(e.certificate=this.certificate),e}}]),e}();t.default=a},function(e,t,n){"use strict";function r(e){var t=a.get(e);return!!t&&t.name===o.MP4.name}Object.defineProperty(t,"__esModule",{value:!0});var o=t.MediaFormat={DASH:{name:"dash",mimeType:"application/dash+xml",pathExt:"mpd"},HLS:{name:"hls",mimeType:"application/x-mpegURL",pathExt:"m3u8"},WVM:{name:"wvm",mimeType:"video/wvm",pathExt:"wvm"},MP4:{name:"mp4",mimeType:"video/mp4",pathExt:"mp4"},MP3:{name:"mp3",mimeType:"audio/mpeg",pathExt:"mp3"}},a=t.SupportedStreamFormat=new Map([["mpegdash",o.DASH],["applehttp",o.HLS],["url",o.MP4]]);t.isProgressiveSource=r},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),a=n(7),i=(function(e){e&&e.__esModule}(a),function(){function e(){r(this,e)}return o(e,[{key:"toJSON",value:function(){var e={id:this.id,url:this.url,mimetype:this.mimetype};return this.bandwidth&&(e.bandwidth=this.bandwidth),this.width&&(e.width=this.width),this.height&&(e.height=this.height),this.label&&(e.label=this.label),this.drmData&&this.drmData.length>0&&(e.drmData=[],this.drmData.forEach(function(t){Array.isArray(e.drmData)&&e.drmData.push(t.toJSON())})),e}}]),e}());t.default=i},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),a=n(9),i=(function(e){e&&e.__esModule}(a),n(8)),u=function(){function e(){r(this,e),this.progressive=[],this.dash=[],this.hls=[]}return o(e,[{key:"map",value:function(e,t){if(t)switch(t.name){case i.MediaFormat.MP4.name:this.progressive.push(e);break;case i.MediaFormat.DASH.name:this.dash.push(e);break;case i.MediaFormat.HLS.name:this.hls.push(e)}}},{key:"toJSON",value:function(){var e={progressive:[],dash:[],hls:[]};return this.progressive.forEach(function(t){return e.progressive.push(t.toJSON())}),this.hls.forEach(function(t){return e.hls.push(t.toJSON())}),this.dash.forEach(function(t){return e.dash.push(t.toJSON())}),e}}]),e}();t.default=u},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var a=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),i=n(12),u=(r(i),n(1)),s=r(u),c=function(){function e(t){o(this,e),this._loadersResponseMap=new Map,this._loaders=new Map,this._networkRetryConfig=t}return a(e,[{key:"add",value:function(e,t){var n=this,r=new e(t);if(r.isValid()){this._loaders.set(e.id,r);var o=this._multiRequest.requests.length,a=r.requests;this._multiRequest.retryConfig=this._networkRetryConfig,a.forEach(function(e){n._multiRequest.add(e)});var i=Array.from(new Array(a.length),function(e,t){return t+o});this._loadersResponseMap.set(e.id,i)}}},{key:"fetchData",value:function(){var e=this;return new Promise(function(t,n){e._multiRequest.execute().then(function(r){e._multiResponse=r.response,e.prepareData(r.response).success?t(e._loaders):n(new s.default(s.default.Severity.CRITICAL,s.default.Category.NETWORK,s.default.Code.API_RESPONSE_MISMATCH,{headers:r.headers}))},function(e){n(e)})})}},{key:"prepareData",value:function(e){var t=this;return this._loaders.forEach(function(n,r){var o=t._loadersResponseMap.get(r);try{o&&o.length>0&&(n.response=e.results.slice(o[0],o[o.length-1]+1))}catch(e){return{success:!1,error:e}}}),{success:!0,data:this._loaders}}}]),e}();t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.MultiRequestResult=void 0;var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),c=n(0),f=r(c),l=n(2),d=r(l),p=n(3),h=r(p),y=n(1),v=r(y),_=function(e){function t(){var e,n,r,o;a(this,t);for(var u=arguments.length,s=Array(u),c=0;c<u;c++)s[c]=arguments[c];return n=r=i(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(s))),r.requests=[],o=n,i(r,o)}return u(t,e),s(t,[{key:"add",value:function(e){this.requests.push(e);var t={},n={service:e.service,action:e.action};return Object.assign(t,o({},this.requests.length,Object.assign(n,e.params))),Object.assign(t,this.params),this.params=t,this}},{key:"execute",value:function(){var e=this;return new Promise(function(n,r){try{e.params=JSON.stringify(e.params)}catch(n){t._logger.error(""+n.message),r(new v.default(v.default.Severity.CRITICAL,v.default.Category.PROVIDER,v.default.Code.FAILED_PARSING_REQUEST,{error:n,params:e.params}))}e.doHttpRequest().then(function(t){var o=new m(t);o.success?n({headers:e.responseHeaders,response:o}):r(new v.default(v.default.Severity.CRITICAL,v.default.Category.NETWORK,v.default.Code.MULTIREQUEST_API_ERROR,{url:e.url,headers:e.responseHeaders,results:o.results}))},function(e){r(e)})})}}]),t}(f.default);_._logger=(0,d.default)("MultiRequestBuilder"),t.default=_;var m=t.MultiRequestResult=function e(t){var n=this;a(this,e),this.results=[],this.success=!0,(t.result?t.result:t).forEach(function(t){var r=new h.default(t);if(n.results.push(r),r.hasError)return e._logger.error("Service returned an error with error code: "+r.error.code+" and message: "+r.error.message+"."),void(n.success=!1)})};m._logger=(0,d.default)("MultiRequestResult")},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var o=function e(t){r(this,e),this.message=t.message,this.code=t.code};t.default=o},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var o=function e(t){r(this,e),this.scheme=t.scheme,this.licenseURL=t.licenseURL,this.certificate=t.certificate};o.Scheme={"drm.PLAYREADY_CENC":"com.microsoft.playready","drm.WIDEVINE_CENC":"com.widevine.alpha","fairplay.FAIRPLAY":"com.apple.fairplay",WIDEVINE_CENC:"com.widevine.alpha",PLAYREADY_CENC:"com.microsoft.playready",FAIRPLAY:"com.apple.fairplay"},t.default=o},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.OTTConfiguration=void 0;var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),a=n(20),i={serviceParams:{apiVersion:"4.7.1"}},u=function(){function e(){r(this,e)}return o(e,null,[{key:"set",value:function(e){e&&Object.assign(i,e)}},{key:"get",value:function(){return(0,a.clone)(i)}}]),e}();t.default=u,t.OTTConfiguration=u},,function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(3),c=r(s),f=n(13),l=r(f),d=n(29),p=r(d),h=n(28),y=r(h),v=function(e){function t(e){o(this,t);var n=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));if(n.sources=[],n.actions=[],n.messages=[],!n.hasError){var r=e.messages;r&&r.map(function(e){return n.messages.push(new l.default(e))});var i=e.actions;i&&i.map(function(e){return n.actions.push(new p.default(e))});var u=e.sources;u&&u.map(function(e){return n.sources.push(new y.default(e))})}return n}return i(t,e),u(t,[{key:"hasBlockAction",value:function(){return void 0!==this.getBlockAction()}},{key:"getBlockAction",value:function(){return this.actions.find(function(e){return e.type===p.default.Type.BLOCK})}},{key:"getErrorMessages",value:function(){return this.messages}}]),t}(c.default);v.Type={TRAILER:"TRAILER",CATCHUP:"CATCHUP",START_OVER:"START_OVER",PLAYBACK:"PLAYBACK"},t.default=v},,function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var o=n(4),a=(function(e){e&&e.__esModule}(o),function e(){r(this,e),this.items=[]});t.default=a},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},o=function e(t){var n=void 0;return Array.isArray(t)?(n=t.length>0?t.slice(0):[],n.forEach(function(t,o){("object"===(void 0===t?"undefined":r(t))&&t!=={}||Array.isArray(t)&&t.length>0)&&(n[o]=e(t))})):"object"===(void 0===t?"undefined":r(t))?(n=Object.assign({},t),Object.keys(n).forEach(function(t){("object"===r(n[t])&&n[t]!=={}||Array.isArray(n[t])&&n[t].length>0)&&(n[t]=e(n[t]))})):n=t,n};t.clone=o},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r={NETWORK:1,SERVICE:2,PROVIDER:3};t.Category=r},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r={UNSUPPORTED_SCHEME:1e3,BAD_HTTP_STATUS:1001,HTTP_ERROR:1002,TIMEOUT:1003,MALFORMED_DATA_URI:1004,BAD_SERVER_RESPONSE:1005,MULTIREQUEST_API_ERROR:1006,API_RESPONSE_MISMATCH:1007,ERROR:2e3,BLOCK_ACTION:2001,MISSING_MANDATORY_PARAMS:3e3,MISSING_PLAY_SOURCE:3001};t.Code=r},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r={RECOVERABLE:1,CRITICAL:2};t.Severity=r},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var a=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),i=n(2),u=n(11),s=(r(u),n(1)),c=r(s),f=function(){function e(t,n){o(this,e),this._networkRetryConfig={async:!0,timeout:0,maxAttempts:4},this._partnerId=t.partnerId,this._widgetId=t.widgetId,this._uiConfId=t.uiConfId,this._isAnonymous=!t.vs,this._vs=t.vs||"",this._playerVersion=n,t.logLevel&&this.LogLevel[t.logLevel]&&(0,i.setLogLevel)(this.LogLevel[t.logLevel])}return a(e,[{key:"partnerId",get:function(){return this._partnerId}},{key:"widgetId",get:function(){return this._widgetId||"_"+this._partnerId}},{key:"uiConfId",get:function(){return this._uiConfId}},{key:"vs",get:function(){return this._vs},set:function(e){this._vs=e}},{key:"playerVersion",get:function(){return this._playerVersion}},{key:"isAnonymous",get:function(){return this._isAnonymous}}]),a(e,[{key:"getMediaConfig",value:function(e){throw new TypeError("getMediaConfig method must be implement by the derived class")}},{key:"_parseDataFromResponse",value:function(e){throw new TypeError("_parseDataFromResponse method must be implement by the derived class")}},{key:"_verifyHasSources",value:function(e){if(0===e.hls.concat(e.dash,e.progressive).length)throw new c.default(c.default.Severity.CRITICAL,c.default.Category.SERVICE,c.default.Code.MISSING_PLAY_SOURCE,{action:"",messages:"No play source for entry id: "+e.id})}},{key:"getLogLevel",value:function(e){return(0,i.getLogLevel)(e)}},{key:"setLogLevel",value:function(e,t){(0,i.setLogLevel)(e,t)}},{key:"LogLevel",get:function(){return i.LogLevel}}]),e}();t.default=f},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var a=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),i=n(12),u=r(i),s=n(15),c=r(s),f=function(){function e(){o(this,e)}return a(e,null,[{key:"getMultiRequest",value:function(e,t){var n=c.default.get(),r=n.serviceParams;e&&Object.assign(r,{vs:e}),t&&Object.assign(r,{partnerId:t});var o=new Map;o.set("Content-Type","application/json");var a=new u.default(o);return a.method="POST",a.service="multirequest",a.url=a.getUrl(n.serviceUrl),a.params=r,a}}]),e}();t.default=f},,function(e,t,n){var r,o;/*!
 * js-logger - http://github.com/jonnyreeves/js-logger
 * Jonny Reeves, http://jonnyreeves.co.uk/
 * js-logger may be freely distributed under the MIT license.
 */
!function(a){"use strict";var i={};i.VERSION="1.4.1";var u,s={},c=function(e,t){return function(){return t.apply(e,arguments)}},f=function(){var e,t,n=arguments,r=n[0];for(t=1;t<n.length;t++)for(e in n[t])e in r||!n[t].hasOwnProperty(e)||(r[e]=n[t][e]);return r},l=function(e,t){return{value:e,name:t}};i.DEBUG=l(1,"DEBUG"),i.INFO=l(2,"INFO"),i.TIME=l(3,"TIME"),i.WARN=l(4,"WARN"),i.ERROR=l(8,"ERROR"),i.OFF=l(99,"OFF");var d=function(e){this.context=e,this.setLevel(e.filterLevel),this.log=this.info};d.prototype={setLevel:function(e){e&&"value"in e&&(this.context.filterLevel=e)},getLevel:function(){return this.context.filterLevel},enabledFor:function(e){var t=this.context.filterLevel;return e.value>=t.value},debug:function(){this.invoke(i.DEBUG,arguments)},info:function(){this.invoke(i.INFO,arguments)},warn:function(){this.invoke(i.WARN,arguments)},error:function(){this.invoke(i.ERROR,arguments)},time:function(e){"string"==typeof e&&e.length>0&&this.invoke(i.TIME,[e,"start"])},timeEnd:function(e){"string"==typeof e&&e.length>0&&this.invoke(i.TIME,[e,"end"])},invoke:function(e,t){u&&this.enabledFor(e)&&u(t,f({level:e},this.context))}};var p=new d({filterLevel:i.OFF});!function(){var e=i;e.enabledFor=c(p,p.enabledFor),e.debug=c(p,p.debug),e.time=c(p,p.time),e.timeEnd=c(p,p.timeEnd),e.info=c(p,p.info),e.warn=c(p,p.warn),e.error=c(p,p.error),e.log=e.info}(),i.setHandler=function(e){u=e},i.setLevel=function(e){p.setLevel(e);for(var t in s)s.hasOwnProperty(t)&&s[t].setLevel(e)},i.getLevel=function(){return p.getLevel()},i.get=function(e){return s[e]||(s[e]=new d(f({name:e},p.context)))},i.createDefaultHandler=function(e){e=e||{},e.formatter=e.formatter||function(e,t){t.name&&e.unshift("["+t.name+"]")};var t={},n=function(e,t){Function.prototype.apply.call(e,console,t)};return"undefined"==typeof console?function(){}:function(r,o){r=Array.prototype.slice.call(r);var a,u=console.log;o.level===i.TIME?(a=(o.name?"["+o.name+"] ":"")+r[0],"start"===r[1]?console.time?console.time(a):t[a]=(new Date).getTime():console.timeEnd?console.timeEnd(a):n(u,[a+": "+((new Date).getTime()-t[a])+"ms"])):(o.level===i.WARN&&console.warn?u=console.warn:o.level===i.ERROR&&console.error?u=console.error:o.level===i.INFO&&console.info?u=console.info:o.level===i.DEBUG&&console.debug&&(u=console.debug),e.formatter(r,o),n(u,r))}},i.useDefaults=function(e){i.setLevel(e&&e.defaultLevel||i.DEBUG),i.setHandler(i.createDefaultHandler(e))},r=i,void 0!==(o="function"==typeof r?r.call(t,n,t,e):r)&&(e.exports=o)}()},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),a=n(14),i=function(e){return e&&e.__esModule?e:{default:e}}(a),u=function(){function e(t){var n=this;r(this,e),this.drm=[],this.format=t.format,this.adsPolicy=t.adsPolicy,this.adsParam=t.adsParam,this.duration=t.duration,this.url=t.url,this.type=t.type,this.fileId=t.id,this.protocols=t.protocols,t.drm&&t.drm.map(function(e){return n.drm.push(new i.default(e))})}return o(e,[{key:"hasDrmData",value:function(){return this.drm&&this.drm.length>0}},{key:"getProtocol",value:function(e){var t="";if(this.protocols&&this.protocols.length>0){this.protocols.split(",").forEach(function(n){n===e&&(t=n)})}else if("http"===e)return e;return t}}]),e}();t.default=u},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var o=function e(t){r(this,e),this.type=t.type};o.Type={BLOCK:"BLOCK",START_DATE_OFFSET:"START_DATE_OFFSET",END_DATE_OFFSET:"END_DATE_OFFSET",USER_BLOCK:"USER_BLOCK",ALLOW_PLAYBACK:"ALLOW_PLAYBACK",BLOCK_PLAYBACK:"BLOCK_PLAYBACK",APPLY_DISCOUNT_MODULE:"APPLY_DISCOUNT_MODULE"},t.default=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(25),c=r(s),f=n(0),l=r(f),d=function(e){function t(){return o(this,t),a(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),u(t,null,[{key:"getPlaybackContext",value:function(e,t,n,r,o){var a=new Map;a.set("Content-Type","application/json");var i=new l.default(a);i.service="asset",i.action="getPlaybackContext",i.method="POST",i.url=i.getUrl(e);var u={objectType:"VidiunPlaybackContextOptions"};return Object.assign(u,o),i.params={assetId:n,assetType:r,contextDataParams:u,vs:t},i}},{key:"get",value:function(e,t,n,r){var o=new Map;o.set("Content-Type","application/json");var a=new l.default(o);return a.service="asset",a.action="get",a.method="POST",a.url=a.getUrl(e),a.params={id:n,assetReferenceType:r,vs:t},a}}]),t}(c.default);t.default=d},,,,,,,function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(24),c=r(s),f=n(2),l=r(f),d=n(15),p=r(d),h=n(44),y=r(h),v=n(45),_=r(v),m=n(43),g=r(m),b=n(42),O=r(b),E=n(46),w=r(E),T=n(6),R=r(T),P=n(17),C=r(P),k=n(4),M=r(k),A=n(1),I=r(A),j=function(e){function t(e,n){o(this,t);var r=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e,n));return r._logger=(0,l.default)("OTTProvider"),p.default.set(e.env),r._networkRetryConfig=Object.assign(r._networkRetryConfig,e.networkRetryParameters),r}return i(t,e),u(t,[{key:"getMediaConfig",value:function(e){var t=this;return e.vs&&(this.vs=e.vs,this._isAnonymous=!1),this._dataLoader=new y.default(this.partnerId,this.vs,this._networkRetryConfig),new Promise(function(n,r){var o=e.entryId;if(o){var a=t.vs;a||(a="{1:result:vs}",t._dataLoader.add(_.default,{partnerId:t.partnerId}));var i=e.contextType||C.default.Type.PLAYBACK,u=e.mediaType||R.default.Type.MEDIA,s=e.assetReferenceType||R.default.AssetReferenceType.MEDIA,c={mediaProtocol:e.protocol,assetFileIds:e.fileIds,context:i};t._dataLoader.add(g.default,{entryId:o,vs:a,type:u,playbackContext:c,assetReferenceType:s});var f={contextType:i,mediaType:u,formats:e.formats||[]};return t._dataLoader.fetchData().then(function(e){try{n(t._parseDataFromResponse(e,f))}catch(e){r(e)}},function(e){r(e)})}r(new I.default(I.default.Severity.CRITICAL,I.default.Category.PROVIDER,I.default.Code.MISSING_MANDATORY_PARAMS,{message:"missing entry id"}))})}},{key:"_parseDataFromResponse",value:function(e,t){this._logger.debug("Data parsing started");var n={session:{isAnonymous:this._isAnonymous,partnerId:this.partnerId},sources:this._getDefaultSourcesObject(),plugins:{}};if(this.uiConfId&&(n.session.uiConfId=this.uiConfId),e){if(e.has(_.default.id)){var r=e.get(_.default.id);r&&r.response&&(n.session.vs=r.response)}else n.session.vs=this.vs;if(e.has(g.default.id)){var o=e.get(g.default.id);if(o&&o.response&&Object.keys(o.response).length){var a=o.response;if(w.default.hasBlockAction(a))throw new I.default(I.default.Severity.CRITICAL,I.default.Category.SERVICE,I.default.Code.BLOCK_ACTION,{action:w.default.getBlockAction(a),messages:w.default.getErrorMessages(a)});var i=w.default.getMediaEntry(a,t);Object.assign(n.sources,this._getSourcesObject(i)),this._verifyHasSources(n.sources)}}}return this._logger.debug("Data parsing finished",n),n}},{key:"getEntryListConfig",value:function(e){var t=this;return e.vs&&(this.vs=e.vs,this._isAnonymous=!1),this._dataLoader=new y.default(this.partnerId,this.vs,this._networkRetryConfig),new Promise(function(n,r){var o=e.entries;if(o&&o.length){var a=t.vs;a||(a="{1:result:vs}",t._dataLoader.add(_.default,{partnerId:t.partnerId})),t._dataLoader.add(O.default,{entries:o,vs:a}),t._dataLoader.fetchData().then(function(e){n(t._parseEntryListDataFromResponse(e))},function(e){r(e)})}else r({success:!1,data:"Missing mandatory parameter"})})}},{key:"_parseEntryListDataFromResponse",value:function(e){var t=this;this._logger.debug("Data parsing started");var n={id:"",metadata:{name:"",description:""},poster:"",items:[]};if(e&&e.has(O.default.id)){var r=e.get(O.default.id);if(r&&r.response){w.default.getEntryList(r.response).items.forEach(function(e){return n.items.push({sources:t._getSourcesObject(e)})})}}return this._logger.debug("Data parsing finished",n),n}},{key:"_getDefaultSourcesObject",value:function(){return{hls:[],dash:[],progressive:[],id:"",duration:0,type:M.default.Type.UNKNOWN,poster:"",dvr:!1,vr:null,metadata:{name:"",description:"",tags:""}}}},{key:"_getSourcesObject",value:function(e){var t=this._getDefaultSourcesObject(),n=e.sources.toJSON();return t.hls=n.hls,t.dash=n.dash,t.progressive=n.progressive,t.id=e.id,t.duration=e.duration,t.type=e.type,t.dvr=!!e.dvrStatus,t.poster=e.poster,e.metadata&&e.metadata.metas&&"string"==typeof e.metadata.metas.tags&&e.metadata.metas.tags.indexOf("360")>-1&&(t.vr={}),Object.assign(t.metadata,e.metadata),t}}]),t}(c.default);t.default=j},,,,function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.VERSION=t.NAME=t.MediaType=t.ContextType=t.Provider=void 0;var o=n(37),a=r(o),i=n(17),u=r(i),s=n(6),c=r(s),f=u.default.Type,l=c.default.Type;t.Provider=a.default,t.ContextType=f,t.MediaType=l,t.NAME="pakhshkit-js-providers-ott",t.VERSION="2.18.1"},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var a=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),i=n(0),u=(r(i),n(15)),s=r(u),c=n(30),f=r(c),l=n(6),d=r(l),p=function(){function e(t){o(this,e),this._response={playlistItems:{entries:[]}},this.requests=this.buildRequests(t),this._entries=t.entries}return a(e,null,[{key:"id",get:function(){return"asset_list"}}]),a(e,[{key:"buildRequests",value:function(e){var t=s.default.get(),n=[];return e.entries.forEach(function(r){var o=r.assetReferenceType||d.default.AssetReferenceType.MEDIA;n.push(f.default.get(t.serviceUrl,e.vs,r.entryId||r,o))}),n}},{key:"isValid",value:function(){return!(!this._entries||!this._entries.length)}},{key:"requests",set:function(e){this._requests=e},get:function(){return this._requests}},{key:"response",set:function(e){var t=this;e.forEach(function(e){t._response.playlistItems.entries.push({mediaDataResult:new d.default(e.data)})})},get:function(){return this._response}}]),e}();t.default=p},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var a=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),i=n(30),u=r(i),s=n(15),c=r(s),f=n(0),l=(r(f),n(17)),d=r(l),p=n(6),h=r(p),y=function(){function e(t){o(this,e),this._response={},this.requests=this.buildRequests(t),this._entryId=t.entryId}return a(e,null,[{key:"id",get:function(){return"asset"}}]),a(e,[{key:"buildRequests",value:function(e){var t=c.default.get(),n=[];return n.push(u.default.get(t.serviceUrl,e.vs,e.entryId,e.assetReferenceType)),n.push(u.default.getPlaybackContext(t.serviceUrl,e.vs,e.entryId,e.type,e.playbackContext)),n}},{key:"isValid",value:function(){return!!this._entryId}},{key:"requests",set:function(e){this._requests=e},get:function(){return this._requests}},{key:"response",set:function(e){this._response.mediaDataResult=new h.default(e[0].data),this._response.playBackContextResult=new d.default(e[1].data)},get:function(){return this._response}}]),e}();t.default=y},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var u=n(11),s=r(u),c=n(25),f=r(c),l=function(e){function t(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"",r=arguments[2];o(this,t);var i=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,r));return i._multiRequest=f.default.getMultiRequest(n,e),i}return i(t,e),t}(s.default);t.default=l},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var a=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),i=n(47),u=r(i),s=n(15),c=r(s),f=n(0),l=(r(f),function(){function e(t){o(this,e),this._response={},this.requests=this.buildRequests(t),this._partnerId=t.partnerId}return a(e,null,[{key:"id",get:function(){return"session"}}]),a(e,[{key:"buildRequests",value:function(e){var t=c.default.get(),n=[];return n.push(u.default.anonymousLogin(t.serviceUrl,e.partnerId,e.udid)),n}},{key:"isValid",value:function(){return!!this._partnerId}},{key:"requests",set:function(e){this._requests=e},get:function(){return this._requests}},{key:"response",set:function(e){this._response.vs=e[0].data.vs},get:function(){return this._response.vs}}]),e}());t.default=l},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}Object.defineProperty(t,"__esModule",{value:!0});var i,u,s,c=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),f=n(2),l=r(f),d=n(28),p=(r(d),n(17)),h=r(p),y=n(6),v=r(y),_=n(4),m=r(_),g=n(7),b=r(g),O=n(9),E=r(O),w=n(10),T=r(w),R=n(19),P=r(R),C=n(8),k=n(14),M=r(k),A=n(29),I=(r(A),n(13)),j=(r(I),s={},a(s,v.default.Type.MEDIA,(i={},a(i,h.default.Type.TRAILER,function(){return{type:m.default.Type.VOD}}),a(i,h.default.Type.PLAYBACK,function(e){return parseInt(e.externalIds)>0||"VidiunLiveAsset"===e.objectType?{type:m.default.Type.LIVE,dvrStatus:0}:{type:m.default.Type.VOD}}),i)),a(s,v.default.Type.EPG,(u={},a(u,h.default.Type.CATCHUP,function(){return{type:m.default.Type.VOD}}),a(u,h.default.Type.START_OVER,function(){return{type:m.default.Type.LIVE,dvrStatus:1}}),u)),a(s,v.default.Type.RECORDING,a({},h.default.Type.PLAYBACK,function(){return{type:m.default.Type.VOD}})),s),L=function(){function e(){o(this,e)}return c(e,null,[{key:"getMediaEntry",value:function(t,n){var r=new m.default;e._fillBaseData(r,t);var o=t.playBackContextResult,a=t.mediaDataResult,i=o.sources,u=e._filterSourcesByFormats(i,n.formats);r.sources=e._getParsedSources(u);var s=e._getMediaType(a.data,n.mediaType,n.contextType);return r.type=s.type,r.dvrStatus=s.dvrStatus,r.duration=Math.max.apply(Math,i.map(function(e){return e.duration})),r}},{key:"getEntryList",value:function(t){var n=new P.default;return t.playlistItems.entries.forEach(function(t){var r=new m.default;e._fillBaseData(r,t),n.items.push(r)}),n}},{key:"_fillBaseData",value:function(t,n){var r=n.mediaDataResult,o=e.reconstructMetadata(r);return o.description=r.description,o.name=r.name,t.metadata=o,t.poster=e._getPoster(r.pictures),t.id=r.id,t}},{key:"reconstructMetadata",value:function(t){return{metas:e.addToMetaObject(t.metas),tags:e.addToMetaObject(t.tags)}}},{key:"addToMetaObject",value:function(e){var t={};return e&&e.forEach(function(e){t[e.key]=e.value}),t}},{key:"_getPoster",value:function(e){if(e&&e.length>0){var t=e[0],n=t.url;return/.*\/thumbnail\/.*(?:width|height)\/\d+\/(?:height|width)\/\d+/.test(n)?n:e.map(function(e){return{url:e.url,width:e.width,height:e.height}})}return""}},{key:"_getMediaType",value:function(e,t,n){var r={type:m.default.Type.UNKNOWN};return j[t]&&j[t][n]&&(r=j[t][n](e)),r}},{key:"_filterSourcesByFormats",value:function(e,t){return t.length>0&&(e=e.filter(function(e){return t.includes(e.type)})),e}},{key:"_getParsedSources",value:function(t){var n=new T.default,r=function(t){var r=e._parseAdaptiveSource(t);if(r){var o=C.SupportedStreamFormat.get(t.format);n.map(r,o)}};return t&&t.length>0&&(function(){t.filter(function(e){return!(0,C.isProgressiveSource)(e.format)}).forEach(r)}(),function(){t.filter(function(e){return(0,C.isProgressiveSource)(e.format)}).forEach(r)}()),n}},{key:"_parseAdaptiveSource",value:function(t){var n=new E.default;if(t){var r=t.url,o=C.SupportedStreamFormat.get(t.format);if(o&&(n.mimetype=o.mimeType),!r)return e._logger.error("failed to create play url from source, discarding source: ("+t.fileId+"), "+t.format+"."),null;if(n.url=r,n.id=t.fileId+","+t.format,t.hasDrmData()){var a=[];t.drm.forEach(function(e){a.push(new b.default(e.licenseURL,M.default.Scheme[e.scheme],e.certificate))}),n.drmData=a}}return n}},{key:"hasBlockAction",value:function(e){return e.playBackContextResult.hasBlockAction()}},{key:"getBlockAction",value:function(e){return e.playBackContextResult.getBlockAction()}},{key:"getErrorMessages",value:function(e){return e.playBackContextResult.getErrorMessages()}}]),e}();L._logger=(0,l.default)("OTTProviderParser"),t.default=L},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(25),c=r(s),f=n(0),l=r(f),d=function(e){function t(){return o(this,t),a(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),u(t,null,[{key:"anonymousLogin",value:function(e,t,n){var r=new Map;r.set("Content-Type","application/json");var o=new l.default(r);o.service="ottuser",o.action="anonymousLogin",o.method="POST",o.url=o.getUrl(e);var a={partnerId:t};return n&&Object.assign(a,{udid:n}),o.params=a,o}}]),t}(c.default);t.default=d}])});


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_RESULT__;(function(){var g={};
(function(window){var m,aa="function"==typeof Object.defineProperties?Object.defineProperty:function(a,b,c){a!=Array.prototype&&a!=Object.prototype&&(a[b]=c.value)},ba="undefined"!=typeof window&&window===this?this:"undefined"!=typeof global&&null!=global?global:this;function ca(){ca=function(){};ba.Symbol||(ba.Symbol=da)}var da=function(){var a=0;return function(b){return"jscomp_symbol_"+(b||"")+a++}}();
function ea(){ca();var a=ba.Symbol.iterator;a||(a=ba.Symbol.iterator=ba.Symbol("iterator"));"function"!=typeof Array.prototype[a]&&aa(Array.prototype,a,{configurable:!0,writable:!0,value:function(){return fa(this)}});ea=function(){}}function fa(a){var b=0;return ha(function(){return b<a.length?{done:!1,value:a[b++]}:{done:!0}})}function ha(a){ea();a={next:a};a[ba.Symbol.iterator]=function(){return this};return a}function ia(a){ea();var b=a[Symbol.iterator];return b?b.call(a):fa(a)}
function ja(a,b){if(b){for(var c=ba,d=a.split("."),e=0;e<d.length-1;e++){var f=d[e];f in c||(c[f]={});c=c[f]}d=d[d.length-1];e=c[d];f=b(e);f!=e&&null!=f&&aa(c,d,{configurable:!0,writable:!0,value:f})}}
ja("Promise",function(a){function b(a){this.b=0;this.g=void 0;this.a=[];var b=this.c();try{a(b.resolve,b.reject)}catch(k){b.reject(k)}}function c(){this.a=null}function d(a){return a instanceof b?a:new b(function(b){b(a)})}if(a)return a;c.prototype.b=function(a){null==this.a&&(this.a=[],this.f());this.a.push(a)};c.prototype.f=function(){var a=this;this.c(function(){a.h()})};var e=ba.setTimeout;c.prototype.c=function(a){e(a,0)};c.prototype.h=function(){for(;this.a&&this.a.length;){var a=this.a;this.a=
[];for(var b=0;b<a.length;++b){var c=a[b];delete a[b];try{c()}catch(l){this.g(l)}}}this.a=null};c.prototype.g=function(a){this.c(function(){throw a;})};b.prototype.c=function(){function a(a){return function(d){c||(c=!0,a.call(b,d))}}var b=this,c=!1;return{resolve:a(this.m),reject:a(this.f)}};b.prototype.m=function(a){if(a===this)this.f(new TypeError("A Promise cannot resolve to itself"));else if(a instanceof b)this.o(a);else{a:switch(typeof a){case "object":var c=null!=a;break a;case "function":c=
!0;break a;default:c=!1}c?this.l(a):this.h(a)}};b.prototype.l=function(a){var b=void 0;try{b=a.then}catch(k){this.f(k);return}"function"==typeof b?this.u(b,a):this.h(a)};b.prototype.f=function(a){this.i(2,a)};b.prototype.h=function(a){this.i(1,a)};b.prototype.i=function(a,b){if(0!=this.b)throw Error("Cannot settle("+a+", "+b|"): Promise already settled in state"+this.b);this.b=a;this.g=b;this.j()};b.prototype.j=function(){if(null!=this.a){for(var a=this.a,b=0;b<a.length;++b)a[b].call(),a[b]=null;
this.a=null}};var f=new c;b.prototype.o=function(a){var b=this.c();a.ob(b.resolve,b.reject)};b.prototype.u=function(a,b){var c=this.c();try{a.call(b,c.resolve,c.reject)}catch(l){c.reject(l)}};b.prototype.then=function(a,c){function d(a,b){return"function"==typeof a?function(b){try{e(a(b))}catch(ib){f(ib)}}:b}var e,f,g=new b(function(a,b){e=a;f=b});this.ob(d(a,e),d(c,f));return g};b.prototype["catch"]=function(a){return this.then(void 0,a)};b.prototype.ob=function(a,b){function c(){switch(d.b){case 1:a(d.g);
break;case 2:b(d.g);break;default:throw Error("Unexpected state: "+d.b);}}var d=this;null==this.a?f.b(c):this.a.push(function(){f.b(c)})};b.resolve=d;b.reject=function(a){return new b(function(b,c){c(a)})};b.race=function(a){return new b(function(b,c){for(var e=ia(a),f=e.next();!f.done;f=e.next())d(f.value).ob(b,c)})};b.all=function(a){var c=ia(a),e=c.next();return e.done?d([]):new b(function(a,b){function f(b){return function(c){g[b]=c;h--;0==h&&a(g)}}var g=[],h=0;do g.push(void 0),h++,d(e.value).ob(f(g.length-
1),b),e=c.next();while(!e.done)})};return b});ja("Array.prototype.find",function(a){return a?a:function(a,c){a:{var b=this;b instanceof String&&(b=String(b));for(var e=b.length,f=0;f<e;f++){var g=b[f];if(a.call(c,g,f,b)){b=g;break a}}b=void 0}return b}});var ka=this;ka.Ze=!0;function n(a,b){var c=a.split("."),d=ka;c[0]in d||!d.execScript||d.execScript("var "+c[0]);for(var e;c.length&&(e=c.shift());)c.length||void 0===b?d[e]?d=d[e]:d=d[e]={}:d[e]=b}
function la(a,b){function c(){}c.prototype=b.prototype;a.ff=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.cf=function(a,c,f){return b.prototype[c].apply(a,Array.prototype.slice.call(arguments,2))}};/*

 Copyright 2016 Google Inc.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
function ma(a){this.c=Math.exp(Math.log(.5)/a);this.b=this.a=0}function na(a,b,c){var d=Math.pow(a.c,b);c=c*(1-d)+d*a.a;isNaN(c)||(a.a=c,a.b+=b)}function oa(a){return a.a/(1-Math.pow(a.c,a.b))};function pa(){this.b=new ma(2);this.c=new ma(5);this.a=0}pa.prototype.getBandwidthEstimate=function(a){return 128E3>this.a?a:Math.min(oa(this.b),oa(this.c))};function qa(){}function ra(){}window.console&&window.console.log.bind&&(qa=console.warn.bind(console));function p(a,b,c,d){this.severity=a;this.category=b;this.code=c;this.data=Array.prototype.slice.call(arguments,3);this.handled=!1}n("shaka.util.Error",p);p.prototype.toString=function(){return"shaka.util.Error "+JSON.stringify(this,null,"  ")};p.Severity={RECOVERABLE:1,CRITICAL:2};p.Category={NETWORK:1,TEXT:2,MEDIA:3,MANIFEST:4,STREAMING:5,DRM:6,PLAYER:7,CAST:8,STORAGE:9};
p.Code={UNSUPPORTED_SCHEME:1E3,BAD_HTTP_STATUS:1001,HTTP_ERROR:1002,TIMEOUT:1003,MALFORMED_DATA_URI:1004,UNKNOWN_DATA_URI_ENCODING:1005,REQUEST_FILTER_ERROR:1006,RESPONSE_FILTER_ERROR:1007,MALFORMED_TEST_URI:1008,UNEXPECTED_TEST_REQUEST:1009,INVALID_TEXT_HEADER:2E3,INVALID_TEXT_CUE:2001,UNABLE_TO_DETECT_ENCODING:2003,BAD_ENCODING:2004,INVALID_XML:2005,INVALID_MP4_TTML:2007,INVALID_MP4_VTT:2008,UNABLE_TO_EXTRACT_CUE_START_TIME:2009,BUFFER_READ_OUT_OF_BOUNDS:3E3,JS_INTEGER_OVERFLOW:3001,EBML_OVERFLOW:3002,
EBML_BAD_FLOATING_POINT_SIZE:3003,MP4_SIDX_WRONG_BOX_TYPE:3004,MP4_SIDX_INVALID_TIMESCALE:3005,MP4_SIDX_TYPE_NOT_SUPPORTED:3006,WEBM_CUES_ELEMENT_MISSING:3007,WEBM_EBML_HEADER_ELEMENT_MISSING:3008,WEBM_SEGMENT_ELEMENT_MISSING:3009,WEBM_INFO_ELEMENT_MISSING:3010,WEBM_DURATION_ELEMENT_MISSING:3011,WEBM_CUE_TRACK_POSITIONS_ELEMENT_MISSING:3012,WEBM_CUE_TIME_ELEMENT_MISSING:3013,MEDIA_SOURCE_OPERATION_FAILED:3014,MEDIA_SOURCE_OPERATION_THREW:3015,VIDEO_ERROR:3016,QUOTA_EXCEEDED_ERROR:3017,UNABLE_TO_GUESS_MANIFEST_TYPE:4E3,
DASH_INVALID_XML:4001,DASH_NO_SEGMENT_INFO:4002,DASH_EMPTY_ADAPTATION_SET:4003,DASH_EMPTY_PERIOD:4004,DASH_WEBM_MISSING_INIT:4005,DASH_UNSUPPORTED_CONTAINER:4006,DASH_PSSH_BAD_ENCODING:4007,DASH_NO_COMMON_KEY_SYSTEM:4008,DASH_MULTIPLE_KEY_IDS_NOT_SUPPORTED:4009,DASH_CONFLICTING_KEY_IDS:4010,UNPLAYABLE_PERIOD:4011,RESTRICTIONS_CANNOT_BE_MET:4012,NO_PERIODS:4014,HLS_PLAYLIST_HEADER_MISSING:4015,INVALID_HLS_TAG:4016,HLS_INVALID_PLAYLIST_HIERARCHY:4017,DASH_DUPLICATE_REPRESENTATION_ID:4018,HLS_MULTIPLE_MEDIA_INIT_SECTIONS_FOUND:4020,
HLS_COULD_NOT_GUESS_MIME_TYPE:4021,HLS_MASTER_PLAYLIST_NOT_PROVIDED:4022,HLS_REQUIRED_ATTRIBUTE_MISSING:4023,HLS_REQUIRED_TAG_MISSING:4024,HLS_COULD_NOT_GUESS_CODECS:4025,HLS_KEYFORMATS_NOT_SUPPORTED:4026,DASH_UNSUPPORTED_XLINK_ACTUATE:4027,DASH_XLINK_DEPTH_LIMIT:4028,HLS_COULD_NOT_PARSE_SEGMENT_START_TIME:4030,INVALID_STREAMS_CHOSEN:5005,NO_RECOGNIZED_KEY_SYSTEMS:6E3,REQUESTED_KEY_SYSTEM_CONFIG_UNAVAILABLE:6001,FAILED_TO_CREATE_CDM:6002,FAILED_TO_ATTACH_TO_VIDEO:6003,INVALID_SERVER_CERTIFICATE:6004,
FAILED_TO_CREATE_SESSION:6005,FAILED_TO_GENERATE_LICENSE_REQUEST:6006,LICENSE_REQUEST_FAILED:6007,LICENSE_RESPONSE_REJECTED:6008,ENCRYPTED_CONTENT_WITHOUT_DRM_INFO:6010,NO_LICENSE_SERVER_GIVEN:6012,OFFLINE_SESSION_REMOVED:6013,EXPIRED:6014,LOAD_INTERRUPTED:7E3,OPERATION_ABORTED:7001,CAST_API_UNAVAILABLE:8E3,NO_CAST_RECEIVERS:8001,ALREADY_CASTING:8002,UNEXPECTED_CAST_ERROR:8003,CAST_CANCELED_BY_USER:8004,CAST_CONNECTION_TIMED_OUT:8005,CAST_RECEIVER_APP_UNAVAILABLE:8006,STORAGE_NOT_SUPPORTED:9E3,INDEXED_DB_ERROR:9001,
DEPRECATED_OPERATION_ABORTED:9002,REQUESTED_ITEM_NOT_FOUND:9003,MALFORMED_OFFLINE_URI:9004,CANNOT_STORE_LIVE_OFFLINE:9005,STORE_ALREADY_IN_PROGRESS:9006,NO_INIT_DATA_FOR_OFFLINE:9007,LOCAL_PLAYER_INSTANCE_REQUIRED:9008,CONTENT_UNSUPPORTED_BY_BROWSER:9009,UNSUPPORTED_UPGRADE_REQUEST:9010};var sa=/^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#(.*))?$/;function ta(a){var b;a instanceof ta?(ua(this,a.ea),this.ya=a.ya,this.ha=a.ha,va(this,a.Ma),this.Y=a.Y,wa(this,xa(a.a)),this.ua=a.ua):a&&(b=String(a).match(sa))?(ua(this,b[1]||"",!0),this.ya=ya(b[2]||""),this.ha=ya(b[3]||"",!0),va(this,b[4]),this.Y=ya(b[5]||"",!0),wa(this,b[6]||"",!0),this.ua=ya(b[7]||"")):this.a=new za(null)}m=ta.prototype;m.ea="";m.ya="";m.ha="";m.Ma=null;m.Y="";m.ua="";
m.toString=function(){var a=[],b=this.ea;b&&a.push(Aa(b,Ba,!0),":");if(b=this.ha){a.push("//");var c=this.ya;c&&a.push(Aa(c,Ba,!0),"@");a.push(encodeURIComponent(b).replace(/%25([0-9a-fA-F]{2})/g,"%$1"));b=this.Ma;null!=b&&a.push(":",String(b))}if(b=this.Y)this.ha&&"/"!=b.charAt(0)&&a.push("/"),a.push(Aa(b,"/"==b.charAt(0)?Ca:Da,!0));(b=this.a.toString())&&a.push("?",b);(b=this.ua)&&a.push("#",Aa(b,Ea));return a.join("")};
m.resolve=function(a){var b=new ta(this);"data"===b.ea&&(b=new ta);var c=!!a.ea;c?ua(b,a.ea):c=!!a.ya;c?b.ya=a.ya:c=!!a.ha;c?b.ha=a.ha:c=null!=a.Ma;var d=a.Y;if(c)va(b,a.Ma);else if(c=!!a.Y){if("/"!=d.charAt(0))if(this.ha&&!this.Y)d="/"+d;else{var e=b.Y.lastIndexOf("/");-1!=e&&(d=b.Y.substr(0,e+1)+d)}if(".."==d||"."==d)d="";else if(-1!=d.indexOf("./")||-1!=d.indexOf("/.")){e=0==d.lastIndexOf("/",0);d=d.split("/");for(var f=[],g=0;g<d.length;){var h=d[g++];"."==h?e&&g==d.length&&f.push(""):".."==h?
((1<f.length||1==f.length&&""!=f[0])&&f.pop(),e&&g==d.length&&f.push("")):(f.push(h),e=!0)}d=f.join("/")}}c?b.Y=d:c=""!==a.a.toString();c?wa(b,xa(a.a)):c=!!a.ua;c&&(b.ua=a.ua);return b};function ua(a,b,c){a.ea=c?ya(b,!0):b;a.ea&&(a.ea=a.ea.replace(/:$/,""))}function va(a,b){if(b){b=Number(b);if(isNaN(b)||0>b)throw Error("Bad port number "+b);a.Ma=b}else a.Ma=null}function wa(a,b,c){b instanceof za?a.a=b:(c||(b=Aa(b,Fa)),a.a=new za(b))}
function ya(a,b){return a?b?decodeURI(a):decodeURIComponent(a):""}function Aa(a,b,c){return"string"==typeof a?(a=encodeURI(a).replace(b,Ga),c&&(a=a.replace(/%25([0-9a-fA-F]{2})/g,"%$1")),a):null}function Ga(a){a=a.charCodeAt(0);return"%"+(a>>4&15).toString(16)+(a&15).toString(16)}var Ba=/[#\/\?@]/g,Da=/[#\?:]/g,Ca=/[#\?]/g,Fa=/[#\?@]/g,Ea=/#/g;function za(a){this.b=a||null}za.prototype.a=null;za.prototype.c=null;
za.prototype.add=function(a,b){if(!this.a&&(this.a={},this.c=0,this.b))for(var c=this.b.split("&"),d=0;d<c.length;d++){var e=c[d].indexOf("="),f=null;if(0<=e){var g=c[d].substring(0,e);f=c[d].substring(e+1)}else g=c[d];g=decodeURIComponent(g.replace(/\+/g," "));f=f||"";this.add(g,decodeURIComponent(f.replace(/\+/g," ")))}this.b=null;(c=this.a.hasOwnProperty(a)&&this.a[a])||(this.a[a]=c=[]);c.push(b);this.c++;return this};
za.prototype.toString=function(){if(this.b)return this.b;if(!this.a)return"";var a=[],b;for(b in this.a)for(var c=encodeURIComponent(b),d=this.a[b],e=0;e<d.length;e++){var f=c;""!==d[e]&&(f+="="+encodeURIComponent(d[e]));a.push(f)}return this.b=a.join("&")};function xa(a){var b=new za;b.b=a.b;if(a.a){var c={},d;for(d in a.a)c[d]=a.a[d].concat();b.a=c;b.c=a.c}return b};function u(){var a,b,c=new Promise(function(c,e){a=c;b=e});c.resolve=a;c.reject=b;return c}u.prototype.resolve=function(){};u.prototype.reject=function(){};function Ha(a,b){var c=Ia();this.i=null==a.maxAttempts?c.maxAttempts:a.maxAttempts;this.f=null==a.baseDelay?c.baseDelay:a.baseDelay;this.h=null==a.fuzzFactor?c.fuzzFactor:a.fuzzFactor;this.g=null==a.backoffFactor?c.backoffFactor:a.backoffFactor;this.a=0;this.b=this.f;if(this.c=b||!1)this.a=1}function Ja(a){if(a.a>=a.i)if(a.c)a.a=1,a.b=a.f;else return Promise.reject();var b=new u;a.a?(window.setTimeout(b.resolve,a.b*(1+(2*Math.random()-1)*a.h)),a.b*=a.g):b.resolve();a.a++;return b}
function Ia(){return{maxAttempts:2,baseDelay:1E3,backoffFactor:2,fuzzFactor:.5,timeout:0}};function Ka(a,b){this.promise=a;this.b=b;this.a=!1}function La(a){return new Ka(Promise.reject(a),function(){return Promise.resolve()})}function Ma(){var a=Promise.reject(new p(2,7,7001));a["catch"](function(){});return new Ka(a,function(){return Promise.resolve()})}function Na(a){return new Ka(Promise.resolve(a),function(){return Promise.resolve()})}function Oa(a){return new Ka(a,function(){return a["catch"](function(){})})}Ka.prototype.abort=function(){this.a=!0;return this.b()};
function Pa(a){return new Ka(Promise.all(a.map(function(a){return a.promise})),function(){return Promise.all(a.map(function(a){return a.abort()}))})}Ka.prototype["finally"]=function(a){this.promise.then(function(){return a(!0)},function(){return a(!1)});return this};
function w(a,b,c){function d(){e.reject(new p(2,7,7001));return a.abort()}var e=new u;a.promise.then(function(c){a.a?e.reject(new p(2,7,7001)):b?d=Qa(b,c,e):e.resolve(c)},function(a){c?d=Qa(c,a,e):e.reject(a)});return new Ka(e,function(){return d()})}
function Qa(a,b,c){try{var d=a(b);if(d&&d.promise&&d.abort)return c.resolve(d.promise),function(){return d.abort()};c.resolve(d);return function(){return Promise.resolve(d).then(function(){})["catch"](function(){})}}catch(e){return c.reject(e),function(){return Promise.resolve()}}};function Ra(a,b){for(var c=[],d=0;d<a.length;++d){for(var e=!1,f=0;f<c.length&&!(e=b?b(a[d],c[f]):a[d]===c[f]);++f);e||c.push(a[d])}return c}function Sa(a,b,c){for(var d=0;d<a.length;++d)if(c(a[d],b))return d;return-1}function Ta(a,b){var c=a.indexOf(b);-1<c&&a.splice(c,1)}function Ua(a,b){var c=0;a.forEach(function(a){c+=b(a)?1:0});return c};function Va(a,b,c,d,e){var f=e in d,g;for(g in b){var h=e+"."+g,k=f?d[e]:c[g];if(f||g in a)void 0===b[g]?void 0===k||f?delete a[g]:a[g]=k:k.constructor==Object&&b[g]&&b[g].constructor==Object?(a[g]||(a[g]=k),Va(a[g],b[g],k,d,h)):typeof b[g]==typeof k&&null!=b[g]&&b[g].constructor==k.constructor&&(a[g]=b[g])}}
function Wa(a){function b(a){switch(typeof a){case "undefined":case "boolean":case "number":case "string":case "symbol":case "function":return a;default:if(!a)return a;if(0<=c.indexOf(a))return null;var d=a.constructor==Array;if(a.constructor!=Object&&!d)return null;c.push(a);var f=d?[]:{},g;for(g in a)f[g]=b(a[g]);d&&(f.length=a.length);return f}}var c=[];return b(a)};function Xa(){this.a=[]}function Ya(a,b){a.a.push(b["finally"](function(){Ta(a.a,b)}))}Xa.prototype.destroy=function(){var a=[];this.a.forEach(function(b){b.promise["catch"](function(){});a.push(b.abort())});this.a=[];return Promise.all(a)};function x(a){this.c=!1;this.g=new Xa;this.a=[];this.b=[];this.f=a||null}n("shaka.net.NetworkingEngine",x);x.RequestType={MANIFEST:0,SEGMENT:1,LICENSE:2,APP:3};x.PluginPriority={$e:1,bf:2,Xe:3};var Za={};function $a(a,b,c){c=c||3;var d=Za[a];if(!d||c>=d.he)Za[a]={he:c,fe:b}}x.registerScheme=$a;x.unregisterScheme=function(a){delete Za[a]};x.prototype.je=function(a){this.a.push(a)};x.prototype.registerRequestFilter=x.prototype.je;x.prototype.Qe=function(a){Ta(this.a,a)};
x.prototype.unregisterRequestFilter=x.prototype.Qe;x.prototype.ad=function(){this.a=[]};x.prototype.clearAllRequestFilters=x.prototype.ad;x.prototype.ke=function(a){this.b.push(a)};x.prototype.registerResponseFilter=x.prototype.ke;x.prototype.Re=function(a){Ta(this.b,a)};x.prototype.unregisterResponseFilter=x.prototype.Re;x.prototype.bd=function(){this.b=[]};x.prototype.clearAllResponseFilters=x.prototype.bd;
function ab(a,b){return{uris:a,method:"GET",body:null,headers:{},allowCrossSiteCredentials:!1,retryParameters:b}}x.prototype.destroy=function(){this.c=!0;this.a=[];this.b=[];return this.g.destroy()};x.prototype.destroy=x.prototype.destroy;
function bb(a){a.then=function(b,c){qa("The network request interface has changed!  Please update your application to the new interface, which allows operations to be aborted.  Support for the old API will be removed in v2.5.");return a.promise.then(b,c)};a["catch"]=function(b){qa("The network request interface has changed!  Please update your application to the new interface, which allows operations to be aborted.  Support for the old API will be removed in v2.5.");return a.promise["catch"](b)};
return a}
x.prototype.request=function(a,b){var c=this;if(this.c)return bb(Ma());b.method=b.method||"GET";b.headers=b.headers||{};b.retryParameters=b.retryParameters?Wa(b.retryParameters):Ia();b.uris=Wa(b.uris);var d=cb(this,a,b),e=w(d,function(){return db(c,a,b,new Ha(b.retryParameters,!1),0,null)}),f=w(e,function(b){return eb(c,a,b)}),g=Date.now(),h=0;d.promise.then(function(){h=Date.now()-g},function(){});var k=0;e.promise.then(function(){k=Date.now()},function(){});d=w(f,function(b){var d=Date.now()-k;
b.timeMs+=h;b.timeMs+=d;c.f&&!b.fromCache&&1==a&&c.f(b.timeMs,b.data.byteLength);return b},function(a){a&&(a.severity=2);throw a;});Ya(this.g,d);return bb(d)};x.prototype.request=x.prototype.request;function cb(a,b,c){var d=Na(void 0);a.a.forEach(function(a){d=w(d,function(){return a(b,c)})});return w(d,void 0,function(a){if(a&&7001==a.code)throw a;throw new p(2,1,1006,a);})}
function db(a,b,c,d,e,f){var g=new ta(c.uris[e]),h=g.ea;h||(h=location.protocol,h=h.slice(0,-1),ua(g,h),c.uris[e]=g.toString());var k=(h=Za[h])?h.fe:null;if(!k)return La(new p(2,1,1E3,g));var l;return w(w(Oa(Ja(d)),function(){if(a.c)return Ma();l=Date.now();var d=k(c.uris[e],c,b);void 0==d.promise&&(qa("The scheme plugin interface has changed!  Please update your scheme plugins to the new interface to add support for abort().  Support for the old plugin interface will be removed in v2.5."),d=Oa(d));
return d}),function(a){void 0==a.timeMs&&(a.timeMs=Date.now()-l);return a},function(g){if(g&&7001==g.code)throw g;if(a.c)return Ma();if(g&&1==g.severity)return e=(e+1)%c.uris.length,db(a,b,c,d,e,g);throw g||f;})}function eb(a,b,c){var d=Na(void 0);a.b.forEach(function(a){d=w(d,function(){return a(b,c)})});return w(d,function(){return c},function(a){if(a&&7001==a.code)throw a;var b=2;a instanceof p&&(b=a.severity);throw new p(b,1,1007,a);})};function fb(){this.a={}}fb.prototype.push=function(a,b){this.a.hasOwnProperty(a)?this.a[a].push(b):this.a[a]=[b]};fb.prototype.get=function(a){return(a=this.a[a])?a.slice():null};fb.prototype.remove=function(a,b){var c=this.a[a];if(c)for(var d=0;d<c.length;++d)c[d]==b&&(c.splice(d,1),--d)};function z(){this.a=new fb}z.prototype.destroy=function(){gb(this);this.a=null;return Promise.resolve()};function A(a,b,c,d){a.a&&(b=new hb(b,c,d),a.a.push(c,b))}function jb(a,b,c,d){A(a,b,c,function(a){this.ka(b,c);d(a)}.bind(a))}z.prototype.ka=function(a,b){if(this.a)for(var c=this.a.get(b)||[],d=0;d<c.length;++d){var e=c[d];e.target==a&&(e.ka(),this.a.remove(b,e))}};function gb(a){if(a.a){var b=a.a,c=[],d;for(d in b.a)c.push.apply(c,b.a[d]);for(b=0;b<c.length;++b)c[b].ka();a.a.a={}}}
function hb(a,b,c){this.target=a;this.type=b;this.a=c;this.target.addEventListener(b,c,!1)}hb.prototype.ka=function(){this.target.removeEventListener(this.type,this.a,!1);this.a=this.target=null};function B(a,b){var c=b||{},d;for(d in c)this[d]=c[d];this.defaultPrevented=this.cancelable=this.bubbles=!1;this.timeStamp=window.performance&&window.performance.now?window.performance.now():Date.now();this.type=a;this.isTrusted=!1;this.target=this.currentTarget=null;this.a=!1}B.prototype.preventDefault=function(){this.cancelable&&(this.defaultPrevented=!0)};B.prototype.stopImmediatePropagation=function(){this.a=!0};B.prototype.stopPropagation=function(){};function kb(a,b){return a.reduce(function(a,b,e){return b["catch"](a.bind(null,e))}.bind(null,b),Promise.reject())}function lb(a,b){return a.concat(b)}function mb(){}function nb(a){return null!=a}function ob(a,b,c){return c.indexOf(a)==b};function C(a,b){if(0==b.length)return a;var c=b.map(function(a){return new ta(a)});return a.map(function(a){return new ta(a)}).map(function(a){return c.map(a.resolve.bind(a))}).reduce(lb,[]).map(function(a){return a.toString()})}function pb(a,b){return{keySystem:a,licenseServerUri:"",distinctiveIdentifierRequired:!1,persistentStateRequired:!1,audioRobustness:"",videoRobustness:"",serverCertificate:null,initData:b||[],keyIds:[]}}var qb=1/15;function rb(a){return!a||0==Object.keys(a).length}function sb(a){return Object.keys(a).map(function(b){return a[b]})}function tb(a,b){return Object.keys(a).every(function(c){return b(c,a[c])})}function ub(a,b){Object.keys(a).forEach(function(c){b(c,a[c])})};function vb(a,b){var c=a;b&&(c+='; codecs="'+b+'"');return c}var wb={codecs:"codecs",frameRate:"framerate",bandwidth:"bitrate",width:"width",height:"height",channelsCount:"channels"};function D(a){if(!a)return"";a=new Uint8Array(a);239==a[0]&&187==a[1]&&191==a[2]&&(a=a.subarray(3));a=escape(xb(a));try{return decodeURIComponent(a)}catch(b){throw new p(2,2,2004);}}n("shaka.util.StringUtils.fromUTF8",D);
function yb(a,b,c){if(!a)return"";if(!c&&0!=a.byteLength%2)throw new p(2,2,2004);if(a instanceof ArrayBuffer)var d=a;else c=new Uint8Array(a.byteLength),c.set(new Uint8Array(a)),d=c.buffer;a=Math.floor(a.byteLength/2);c=new Uint16Array(a);d=new DataView(d);for(var e=0;e<a;e++)c[e]=d.getUint16(2*e,b);return xb(c)}n("shaka.util.StringUtils.fromUTF16",yb);
function zb(a){var b=new Uint8Array(a);if(239==b[0]&&187==b[1]&&191==b[2])return D(b);if(254==b[0]&&255==b[1])return yb(b.subarray(2),!1);if(255==b[0]&&254==b[1])return yb(b.subarray(2),!0);var c=function(a,b){return a.byteLength<=b||32<=a[b]&&126>=a[b]}.bind(null,b);if(0==b[0]&&0==b[2])return yb(a,!1);if(0==b[1]&&0==b[3])return yb(a,!0);if(c(0)&&c(1)&&c(2)&&c(3))return D(a);throw new p(2,2,2003);}n("shaka.util.StringUtils.fromBytesAutoDetect",zb);
function Ab(a){a=encodeURIComponent(a);a=unescape(a);for(var b=new Uint8Array(a.length),c=0;c<a.length;++c)b[c]=a.charCodeAt(c);return b.buffer}n("shaka.util.StringUtils.toUTF8",Ab);function xb(a){for(var b="",c=0;c<a.length;c+=16E3)b+=String.fromCharCode.apply(null,a.subarray(c,c+16E3));return b};function Bb(a){this.a=null;this.b=function(){this.a=null;a()}.bind(this)}Bb.prototype.cancel=function(){null!=this.a&&(clearTimeout(this.a),this.a=null)};function Cb(a,b){a.cancel();a.a=setTimeout(a.b,1E3*b)}function Db(a,b){a.cancel();var c=function(){this.b();this.a=setTimeout(c,1E3*b)}.bind(a);a.a=setTimeout(c,1E3*b)};function Eb(a,b){var c=void 0==b?!0:b,d=window.btoa(String.fromCharCode.apply(null,a)).replace(/\+/g,"-").replace(/\//g,"_");return c?d:d.replace(/=*$/,"")}n("shaka.util.Uint8ArrayUtils.toBase64",Eb);function Fb(a){a=window.atob(a.replace(/-/g,"+").replace(/_/g,"/"));for(var b=new Uint8Array(a.length),c=0;c<a.length;++c)b[c]=a.charCodeAt(c);return b}n("shaka.util.Uint8ArrayUtils.fromBase64",Fb);
function Gb(a){for(var b=new Uint8Array(a.length/2),c=0;c<a.length;c+=2)b[c/2]=window.parseInt(a.substr(c,2),16);return b}n("shaka.util.Uint8ArrayUtils.fromHex",Gb);function Hb(a){for(var b="",c=0;c<a.length;++c){var d=a[c].toString(16);1==d.length&&(d="0"+d);b+=d}return b}n("shaka.util.Uint8ArrayUtils.toHex",Hb);function Ib(a,b){if(!a&&!b)return!0;if(!a||!b||a.length!=b.length)return!1;for(var c=0;c<a.length;++c)if(a[c]!=b[c])return!1;return!0}n("shaka.util.Uint8ArrayUtils.equal",Ib);
function Jb(a){for(var b=0,c=0;c<arguments.length;++c)b+=arguments[c].length;b=new Uint8Array(b);for(var d=c=0;d<arguments.length;++d)b.set(arguments[d],c),c+=arguments[d].length;return b}n("shaka.util.Uint8ArrayUtils.concat",Jb);function Kb(a){this.o=a;this.l=this.i=this.u=null;this.M=!1;this.b=null;this.g=new z;this.a=[];this.m=[];this.j=new u;this.f=null;this.h=function(b){this.j.reject(b);a.onError(b)}.bind(this);this.A={};this.F=new Bb(this.ie.bind(this));this.ca=this.c=!1;this.L=[];this.S=!1;this.v=new Bb(this.ge.bind(this));Db(this.v,1);this.j["catch"](function(){})}m=Kb.prototype;
m.destroy=function(){this.c=!0;var a=[];this.a.forEach(function(b){b=b.fa.close()["catch"](mb);var c=new Promise(function(a){setTimeout(a,1E3)});a.push(Promise.race([b,c]))});this.j.reject();this.g&&a.push(this.g.destroy());this.l&&a.push(this.l.setMediaKeys(null)["catch"](mb));this.v&&(this.v.cancel(),this.v=null);this.F&&(this.F.cancel(),this.F=null);this.g=this.l=this.i=this.u=this.b=null;this.a=[];this.m=[];this.o=this.h=this.f=null;return Promise.all(a)};m.configure=function(a){this.f=a};
m.init=function(a,b){var c={},d=[];this.ca=b;this.m=a.offlineSessionIds;Lb(this,a,b||0<a.offlineSessionIds.length,c,d);return d.length?Mb(this,c,d):(this.M=!0,Promise.resolve())};
function Nb(a,b){if(!a.i)return jb(a.g,b,"encrypted",function(){this.h(new p(2,6,6010))}.bind(a)),Promise.resolve();a.l=b;jb(a.g,a.l,"play",a.Md.bind(a));var c=a.l.setMediaKeys(a.i);c=c["catch"](function(a){return Promise.reject(new p(2,6,6003,a.message))});var d=null;a.b.serverCertificate&&a.b.serverCertificate.length&&(d=a.i.setServerCertificate(a.b.serverCertificate).then(function(){})["catch"](function(a){return Promise.reject(new p(2,6,6004,a.message))}));return Promise.all([c,d]).then(function(){if(this.c)return Promise.reject();
Ob(this);this.b.initData.length||this.m.length||A(this.g,this.l,"encrypted",this.Bd.bind(this))}.bind(a))["catch"](function(a){return this.c?Promise.resolve():Promise.reject(a)}.bind(a))}function Ob(a){var b=a.b?a.b.initData:[];b.forEach(function(a){Pb(this,a.initDataType,a.initData)}.bind(a));a.m.forEach(function(a){Qb(this,a)}.bind(a));b.length||a.m.length||a.j.resolve();return a.j}m.keySystem=function(){return this.b?this.b.keySystem:""};
function Rb(a){return a.a.map(function(a){return a.fa.sessionId})}m.rb=function(){var a=this.a.map(function(a){a=a.fa.expiration;return isNaN(a)?Infinity:a});return Math.min.apply(Math,a)};
function Lb(a,b,c,d,e){var f=Sb(a),g=Tb(a,b);b.periods.forEach(function(a){a.variants.forEach(function(a){f&&(a.drmInfos=[f]);g&&(a.drmInfos=g);a.drmInfos.forEach(function(b){Ub(this,b);window.cast&&window.cast.__platform__&&"com.microsoft.playready"==b.keySystem&&(b.keySystem="com.chromecast.playready");var f=d[b.keySystem];f||(f={audioCapabilities:[],videoCapabilities:[],distinctiveIdentifier:"optional",persistentState:c?"required":"optional",sessionTypes:[c?"persistent-license":"temporary"],label:b.keySystem,
drmInfos:[]},d[b.keySystem]=f,e.push(b.keySystem));f.drmInfos.push(b);b.distinctiveIdentifierRequired&&(f.distinctiveIdentifier="required");b.persistentStateRequired&&(f.persistentState="required");var g=[];a.video&&g.push(a.video);a.audio&&g.push(a.audio);g.forEach(function(a){("video"==a.type?f.videoCapabilities:f.audioCapabilities).push({robustness:("video"==a.type?b.videoRobustness:b.audioRobustness)||"",contentType:vb(a.mimeType,a.codecs)})}.bind(this))}.bind(this))}.bind(this))}.bind(a))}
function Mb(a,b,c){if(1==c.length&&""==c[0])return Promise.reject(new p(2,6,6E3));var d=new u,e=d;[!0,!1].forEach(function(a){c.forEach(function(c){var d=b[c];d.drmInfos.some(function(a){return!!a.licenseServerUri})==a&&(0==d.audioCapabilities.length&&delete d.audioCapabilities,0==d.videoCapabilities.length&&delete d.videoCapabilities,e=e["catch"](function(){return this.c?Promise.reject():navigator.requestMediaKeySystemAccess(c,[d])}.bind(this)))}.bind(this))}.bind(a));e=e["catch"](function(){return Promise.reject(new p(2,
6,6001))});e=e.then(function(a){if(this.c)return Promise.reject();var c=0<=navigator.userAgent.indexOf("Edge/"),d=a.getConfiguration();this.u=(d.audioCapabilities||[]).concat(d.videoCapabilities||[]).map(function(a){return a.contentType});c&&(this.u=null);c=b[a.keySystem];Vb(this,a.keySystem,c,c.drmInfos);return this.b.licenseServerUri?a.createMediaKeys():Promise.reject(new p(2,6,6012))}.bind(a)).then(function(a){if(this.c)return Promise.reject();this.i=a;this.M=!0}.bind(a))["catch"](function(a){if(this.c)return Promise.resolve();
this.u=this.b=null;return a instanceof p?Promise.reject(a):Promise.reject(new p(2,6,6002,a.message))}.bind(a));d.reject();return e}
function Ub(a,b){var c=b.keySystem;if(c){if(!b.licenseServerUri){var d=a.f.servers[c];d&&(b.licenseServerUri=d)}b.keyIds||(b.keyIds=[]);if(c=a.f.advanced[c])b.distinctiveIdentifierRequired||(b.distinctiveIdentifierRequired=c.distinctiveIdentifierRequired),b.persistentStateRequired||(b.persistentStateRequired=c.persistentStateRequired),b.videoRobustness||(b.videoRobustness=c.videoRobustness),b.audioRobustness||(b.audioRobustness=c.audioRobustness),b.serverCertificate||(b.serverCertificate=c.serverCertificate)}}
function Sb(a){if(rb(a.f.clearKeys))return null;var b=[],c=[],d;for(d in a.f.clearKeys){var e=a.f.clearKeys[d],f=Gb(d);e=Gb(e);f={kty:"oct",kid:Eb(f,!1),k:Eb(e,!1)};b.push(f);c.push(f.kid)}a=JSON.stringify({keys:b});c=JSON.stringify({kids:c});c=[{initData:new Uint8Array(Ab(c)),initDataType:"keyids"}];return{keySystem:"org.w3.clearkey",licenseServerUri:"data:application/json;base64,"+window.btoa(a),distinctiveIdentifierRequired:!1,persistentStateRequired:!1,audioRobustness:"",videoRobustness:"",serverCertificate:null,
initData:c,keyIds:[]}}function Tb(a,b){var c=a.f,d=Object.keys(c.servers);return!d.length||b.periods.some(function(a){return a.variants.some(function(a){return a.drmInfos.length})})?null:d.map(function(a){return{keySystem:a,licenseServerUri:c.servers[a],distinctiveIdentifierRequired:!1,persistentStateRequired:!1,audioRobustness:"",videoRobustness:"",serverCertificate:null,initData:[],keyIds:[]}})}
function Vb(a,b,c,d){var e=[],f=[],g=[],h=[];Wb(d,e,f,g,h);a.b={keySystem:b,licenseServerUri:e[0],distinctiveIdentifierRequired:"required"==c.distinctiveIdentifier,persistentStateRequired:"required"==c.persistentState,audioRobustness:c.audioCapabilities?c.audioCapabilities[0].robustness:"",videoRobustness:c.videoCapabilities?c.videoCapabilities[0].robustness:"",serverCertificate:f[0],initData:g,keyIds:h}}
function Wb(a,b,c,d,e){function f(a,b){return a.keyId&&a.keyId==b.keyId?!0:a.initDataType==b.initDataType&&Ib(a.initData,b.initData)}a.forEach(function(a){-1==b.indexOf(a.licenseServerUri)&&b.push(a.licenseServerUri);a.serverCertificate&&-1==Sa(c,a.serverCertificate,Ib)&&c.push(a.serverCertificate);a.initData&&a.initData.forEach(function(a){-1==Sa(d,a,f)&&d.push(a)});if(a.keyIds)for(var g=0;g<a.keyIds.length;++g)-1==e.indexOf(a.keyIds[g])&&e.push(a.keyIds[g])})}
m.Bd=function(a){for(var b=new Uint8Array(a.initData),c=0;c<this.a.length;++c)if(Ib(b,this.a[c].initData))return;Pb(this,a.initDataType,b)};
function Qb(a,b){try{var c=a.i.createSession("persistent-license")}catch(f){var d=new p(2,6,6005,f.message);a.h(d);Promise.reject(d);return}A(a.g,c,"message",a.zc.bind(a));A(a.g,c,"keystatuseschange",a.vc.bind(a));var e={initData:null,fa:c,loaded:!1,Pb:Infinity,qa:null};a.a.push(e);c.load(b).then(function(a){if(!this.c){if(a)return e.loaded=!0,this.a.every(function(a){return a.loaded})&&this.j.resolve(),c;this.a.splice(this.a.indexOf(e),1);this.h(new p(2,6,6013))}}.bind(a),function(a){this.c||(this.a.splice(this.a.indexOf(e),
1),this.h(new p(2,6,6005,a.message)))}.bind(a))}
function Pb(a,b,c){try{var d=a.ca?a.i.createSession("persistent-license"):a.i.createSession()}catch(e){a.h(new p(2,6,6005,e.message));return}A(a.g,d,"message",a.zc.bind(a));A(a.g,d,"keystatuseschange",a.vc.bind(a));a.a.push({initData:c,fa:d,loaded:!1,Pb:Infinity,qa:null});d.generateRequest(b,c.buffer)["catch"](function(a){if(!this.c){for(var b=0;b<this.a.length;++b)if(this.a[b].fa==d){this.a.splice(b,1);break}this.h(new p(2,6,6006,a.message))}}.bind(a))}
m.zc=function(a){this.f.delayLicenseRequestUntilPlayed&&this.l.paused&&!this.S?this.L.push(a):Xb(this,a)};
function Xb(a,b){for(var c=b.target,d,e=0;e<a.a.length;e++)if(a.a[e].fa==c){d=a.a[e];break}e=ab([a.b.licenseServerUri],a.f.retryParameters);e.body=b.message;e.method="POST";"com.microsoft.playready"!=a.b.keySystem&&"com.chromecast.playready"!=a.b.keySystem||Yb(e);a.o.Wa.request(2,e).promise.then(function(a){return this.c?Promise.reject():c.update(a.data).then(function(){this.o.onEvent(new B("drmsessionupdate"));d&&(d.qa&&d.qa.resolve(),setTimeout(function(){d.loaded=!0;this.a.every(function(a){return a.loaded})&&
this.j.resolve()}.bind(this),5E3))}.bind(this))}.bind(a),function(a){if(this.c)return Promise.resolve();a=new p(2,6,6007,a);this.h(a);d&&d.qa&&d.qa.reject(a)}.bind(a))["catch"](function(a){if(this.c)return Promise.resolve();a=new p(2,6,6008,a.message);this.h(a);d&&d.qa&&d.qa.reject(a)}.bind(a))}
function Yb(a){var b=yb(a.body,!0,!0);if(-1==b.indexOf("PlayReadyKeyMessage"))a.headers["Content-Type"]="text/xml; charset=utf-8";else{b=(new DOMParser).parseFromString(b,"application/xml");for(var c=b.getElementsByTagName("HttpHeader"),d=0;d<c.length;++d)a.headers[c[d].querySelector("name").textContent]=c[d].querySelector("value").textContent;a.body=Fb(b.querySelector("Challenge").textContent).buffer}}
m.vc=function(a){a=a.target;var b;for(b=0;b<this.a.length&&this.a[b].fa!=a;++b);if(b!=this.a.length){var c=!1;a.keyStatuses.forEach(function(a,d){if("string"==typeof d){var e=d;d=a;a=e}if("com.microsoft.playready"==this.b.keySystem&&16==d.byteLength&&-1==navigator.userAgent.indexOf("TiVo")){e=new DataView(d);var f=e.getUint32(0,!0),k=e.getUint16(4,!0),l=e.getUint16(6,!0);e.setUint32(0,f,!1);e.setUint16(4,k,!1);e.setUint16(6,l,!1)}"com.microsoft.playready"==this.b.keySystem&&"status-pending"==a&&(a=
"usable");"status-pending"!=a&&(this.a[b].loaded=!0,this.a.every(function(a){return a.loaded})&&this.j.resolve());"expired"==a&&(c=!0);e=Hb(new Uint8Array(d));this.A[e]=a}.bind(this));var d=a.expiration-Date.now();(0>d||c&&1E3>d)&&!this.a[b].qa&&(this.a.splice(b,1),a.close()["catch"](function(){}));Cb(this.F,.5)}};m.ie=function(){function a(a,c){return"expired"==c}!rb(this.A)&&tb(this.A,a)&&this.h(new p(2,6,6014));this.o.Qb(this.A)};
function Zb(){var a=[],b=[{contentType:'video/mp4; codecs="avc1.42E01E"'},{contentType:'video/webm; codecs="vp8"'}],c=[{videoCapabilities:b,persistentState:"required",sessionTypes:["persistent-license"]},{videoCapabilities:b}],d={};"org.w3.clearkey com.widevine.alpha com.microsoft.playready com.apple.fps.2_0 com.apple.fps.1_0 com.apple.fps com.adobe.primetime".split(" ").forEach(function(b){var e=navigator.requestMediaKeySystemAccess(b,c).then(function(a){var c=a.getConfiguration().sessionTypes;c=
c?0<=c.indexOf("persistent-license"):!1;0<=navigator.userAgent.indexOf("Tizen 3")&&(c=!1);d[b]={persistentState:c};return a.createMediaKeys()})["catch"](function(){d[b]=null});a.push(e)});return Promise.all(a).then(function(){return d})}m.Md=function(){for(var a=0;a<this.L.length;a++)Xb(this,this.L[a]);this.S=!0;this.L=[]};function $b(a,b){var c=a.keySystem();return 0==b.drmInfos.length||b.drmInfos.some(function(a){return a.keySystem==c})}
function ac(a,b){if(!a.length)return b;if(!b.length)return a;for(var c=[],d=0;d<a.length;d++)for(var e=0;e<b.length;e++)if(a[d].keySystem==b[e].keySystem){var f=a[d];e=b[e];var g=[];g=g.concat(f.initData||[]);g=g.concat(e.initData||[]);var h=[];h=h.concat(f.keyIds);h=h.concat(e.keyIds);c.push({keySystem:f.keySystem,licenseServerUri:f.licenseServerUri||e.licenseServerUri,distinctiveIdentifierRequired:f.distinctiveIdentifierRequired||e.distinctiveIdentifierRequired,persistentStateRequired:f.persistentStateRequired||
e.persistentStateRequired,videoRobustness:f.videoRobustness||e.videoRobustness,audioRobustness:f.audioRobustness||e.audioRobustness,serverCertificate:f.serverCertificate||e.serverCertificate,initData:g,keyIds:h});break}return c}m.ge=function(){this.a.forEach(function(a){var b=a.Pb,c=a.fa.expiration;isNaN(c)&&(c=Infinity);c!=b&&(this.o.onExpirationUpdated(a.fa.sessionId,c),a.Pb=c)}.bind(this))};function bc(a){return!a||1==a.length&&1E-6>a.end(0)-a.start(0)?null:a.length?a.end(a.length-1):null}function cc(a,b){return!a||!a.length||1==a.length&&1E-6>a.end(0)-a.start(0)?!1:b>=a.start(0)&&b<=a.end(a.length-1)}function dc(a,b){if(!a||!a.length||1==a.length&&1E-6>a.end(0)-a.start(0))return 0;for(var c=0,d=a.length-1;0<=d&&a.end(d)>b;--d)c+=a.end(d)-Math.max(a.start(d),b);return c}function ec(a){if(!a)return[];for(var b=[],c=0;c<a.length;c++)b.push({start:a.start(c),end:a.end(c)});return b};function E(a,b,c){this.startTime=a;this.endTime=b;this.payload=c;this.region=new fc;this.position=null;this.positionAlign=gc;this.size=100;this.textAlign=ic;this.writingDirection=jc;this.lineInterpretation=kc;this.line=null;this.lineHeight="";this.lineAlign=lc;this.displayAlign=mc;this.fontSize=this.backgroundColor=this.color="";this.fontWeight=nc;this.fontStyle=oc;this.fontFamily="";this.textDecoration=[];this.wrapLine=!0;this.id=""}n("shaka.text.Cue",E);var gc="auto";
E.positionAlign={LEFT:"line-left",RIGHT:"line-right",CENTER:"center",AUTO:gc};var ic="center",pc={LEFT:"left",RIGHT:"right",CENTER:ic,START:"start",END:"end"};E.textAlign=pc;var mc="before",qc={BEFORE:mc,CENTER:"center",AFTER:"after"};E.displayAlign=qc;var jc=0;E.writingDirection={HORIZONTAL_LEFT_TO_RIGHT:jc,HORIZONTAL_RIGHT_TO_LEFT:1,VERTICAL_LEFT_TO_RIGHT:2,VERTICAL_RIGHT_TO_LEFT:3};var kc=0;E.lineInterpretation={LINE_NUMBER:kc,PERCENTAGE:1};var lc="center",rc={CENTER:lc,START:"start",END:"end"};
E.lineAlign=rc;var nc=400;E.fontWeight={NORMAL:nc,BOLD:700};var oc="normal",sc={NORMAL:oc,ITALIC:"italic",OBLIQUE:"oblique"};E.fontStyle=sc;E.textDecoration={UNDERLINE:"underline",LINE_THROUGH:"lineThrough",OVERLINE:"overline"};function fc(){this.id="";this.regionAnchorY=this.regionAnchorX=this.viewportAnchorY=this.viewportAnchorX=0;this.height=this.width=100;this.viewportAnchorUnits=this.widthUnits=this.heightUnits=tc;this.scroll=uc}n("shaka.text.CueRegion",fc);var tc=1;
fc.units={PX:0,PERCENTAGE:tc,LINES:2};var uc="";fc.scrollMode={NONE:uc,UP:"up"};function vc(){this.a=new muxjs.mp4.Transmuxer({keepOriginalTimestamps:!0});this.c=null;this.f=[];this.b=[];this.a.on("data",this.h.bind(this));this.a.on("done",this.g.bind(this))}vc.prototype.destroy=function(){this.a.dispose();this.a=null;return Promise.resolve()};function wc(a,b){return window.muxjs&&"mp2t"==a.split(";")[0].split("/")[1]?b?MediaSource.isTypeSupported(xc(b,a)):MediaSource.isTypeSupported(xc("audio",a))||MediaSource.isTypeSupported(xc("video",a)):!1}
function xc(a,b){var c=b.replace("mp2t","mp4");"audio"==a&&(c=c.replace("video","audio"));var d=/avc1\.(66|77|100)\.(\d+)/.exec(c);if(d){var e="avc1.",f=d[1],g=Number(d[2]);e=("66"==f?e+"4200":"77"==f?e+"4d00":e+"6400")+(g>>4).toString(16);e+=(g&15).toString(16);c=c.replace(d[0],e)}return c}function yc(a,b){a.c=new u;a.f=[];a.b=[];var c=new Uint8Array(b);a.a.push(c);a.a.flush();return a.c}
vc.prototype.h=function(a){for(var b=0;b<a.captions.length;b++){var c=a.captions[b];this.b.push(new E(c.startTime,c.endTime,c.text))}b=new Uint8Array(a.data.byteLength+a.initSegment.byteLength);b.set(a.initSegment,0);b.set(a.data,a.initSegment.byteLength);this.f.push(b)};vc.prototype.g=function(){var a={data:Jb.apply(null,this.f),cues:this.b};this.c.resolve(a)};function zc(a){this.f=null;this.c=a;this.i=this.g=0;this.h=Infinity;this.b=this.a=null}var F={};n("shaka.text.TextEngine.registerParser",function(a,b){F[a]=b});n("shaka.text.TextEngine.unregisterParser",function(a){delete F[a]});zc.prototype.destroy=function(){this.c=this.f=null;return Promise.resolve()};zc.prototype.ze=function(a){this.c=a};zc.prototype.setDisplayer=zc.prototype.ze;
zc.prototype.Hb=function(a){var b={periodStart:0,segmentStart:null,segmentEnd:0};try{return this.f.parseMedia(new Uint8Array(a),b)[0].startTime}catch(c){throw new p(2,2,2009,c);}};
function Ac(a,b,c,d){return Promise.resolve().then(function(){if(this.f&&this.c)if(null==c||null==d)this.f.parseInit(new Uint8Array(b));else{var a={periodStart:this.g,segmentStart:this.g+c,segmentEnd:this.g+d};a=this.f.parseMedia(new Uint8Array(b),a).filter(function(a){return a.startTime>=this.i&&a.startTime<this.h}.bind(this));this.c.append(a);null==this.a&&(this.a=Math.max(c,this.i));this.b=Math.min(d,this.h)}}.bind(a))}
zc.prototype.remove=function(a,b){return Promise.resolve().then(function(){!this.c||!this.c.remove(a,b)||null==this.a||b<=this.a||a>=this.b||(a<=this.a&&b>=this.b?this.a=this.b=null:a<=this.a&&b<this.b?this.a=b:a>this.a&&b>=this.b&&(this.b=a))}.bind(this))};zc.prototype.gc=function(a){this.c.append(a)};zc.prototype.appendCues=zc.prototype.gc;function Bc(a){this.f=a;this.m=null;this.b={};this.a=null;this.c={};this.i=new z;this.l=!1;this.h={};this.j=!1;a=this.o=new u;var b=new MediaSource;jb(this.i,b,"sourceopen",a.resolve);this.f.src=window.URL.createObjectURL(b);this.g=b}
function Cc(){var a={};'video/mp4; codecs="avc1.42E01E",video/mp4; codecs="avc3.42E01E",video/mp4; codecs="hev1.1.6.L93.90",video/mp4; codecs="hvc1.1.6.L93.90",video/mp4; codecs="hev1.2.4.L153.B0"; eotf="smpte2084",video/mp4; codecs="hvc1.2.4.L153.B0"; eotf="smpte2084",video/mp4; codecs="vp9",video/mp4; codecs="vp09.00.10.08",audio/mp4; codecs="mp4a.40.2",audio/mp4; codecs="ac-3",audio/mp4; codecs="ec-3",audio/mp4; codecs="opus",audio/mp4; codecs="flac",video/webm; codecs="vp8",video/webm; codecs="vp9",video/webm; codecs="av1",audio/webm; codecs="vorbis",audio/webm; codecs="opus",video/mp2t; codecs="avc1.42E01E",video/mp2t; codecs="avc3.42E01E",video/mp2t; codecs="hvc1.1.6.L93.90",video/mp2t; codecs="mp4a.40.2",video/mp2t; codecs="ac-3",video/mp2t; codecs="ec-3",text/vtt,application/mp4; codecs="wvtt",application/ttml+xml,application/mp4; codecs="stpp"'.split(",").forEach(function(b){a[b]=!!F[b]||
MediaSource.isTypeSupported(b)||wc(b);var c=b.split(";")[0];a[c]=a[c]||a[b]});return a}m=Bc.prototype;
m.destroy=function(){this.l=!0;var a=[],b;for(b in this.c){var c=this.c[b],d=c[0];this.c[b]=c.slice(0,1);d&&a.push(d.p["catch"](mb));for(d=1;d<c.length;++d)c[d].p["catch"](mb),c[d].p.reject()}this.a&&a.push(this.a.destroy());for(var e in this.h)a.push(this.h[e].destroy());this.f&&(this.f.removeAttribute("src"),this.f.load());return Promise.all(a).then(function(){this.i.destroy();this.m=this.a=this.g=this.f=this.i=null;this.b={};this.h={};this.c={}}.bind(this))};
m.init=function(a){var b=this;return this.o.then(function(){for(var c in a){var d=a[c];d=vb(d.mimeType,d.codecs);"text"==c?Dc(b,d):(!MediaSource.isTypeSupported(d)&&wc(d,c)&&(b.h[c]=new vc,d=xc(c,d)),d=b.g.addSourceBuffer(d),A(b.i,d,"error",b.Le.bind(b,c)),A(b.i,d,"updateend",b.Ka.bind(b,c)),b.b[c]=d,b.c[c]=[])}})};function Dc(a,b){a.a||(a.a=new zc(a.m));a.a.f=new F[b]}
function Ec(a,b){if("text"==b)var c=a.a.a;else c=Fc(a,b),c=!c||1==c.length&&1E-6>c.end(0)-c.start(0)?null:1==c.length&&0>c.start(0)?0:c.length?c.start(0):null;return c}m.Db=function(){var a=this.a&&null!=this.a.a?[{start:this.a.a,end:this.a.b}]:[];return{total:ec(this.f.buffered),audio:ec(Fc(this,"audio")),video:ec(Fc(this,"video")),text:a}};function Fc(a,b){try{return a.b[b].buffered}catch(c){return null}}
function Gc(a,b,c,d,e){return"text"==b?Ac(a.a,c,d,e):a.h[b]?yc(a.h[b],c).then(function(a){this.a||Dc(this,"text/vtt");this.j&&this.a.gc(a.cues);return Hc(this,b,this.Pc.bind(this,b,a.data.buffer))}.bind(a)):Hc(a,b,a.Pc.bind(a,b,c))}m.remove=function(a,b,c){return"text"==a?this.a.remove(b,c):Hc(this,a,this.Qc.bind(this,a,b,c))};function Ic(a,b){return"text"==b?a.a?a.a.remove(0,Infinity):Promise.resolve():Hc(a,b,a.Qc.bind(a,b,0,a.g.duration))}
function Jc(a,b,c,d,e){return"text"==b?(a.a.g=c,a=a.a,a.i=d,a.h=e,Promise.resolve()):Promise.all([Hc(a,b,a.Xc.bind(a,b)),Hc(a,b,a.Be.bind(a,b,c)),Hc(a,b,a.ye.bind(a,b,d,e))])}m.endOfStream=function(a){return Kc(this,function(){a?this.g.endOfStream(a):this.g.endOfStream()}.bind(this))};m.ga=function(a){return Kc(this,function(){this.g.duration=a}.bind(this))};m.R=function(){return this.g.duration};m.Pc=function(a,b){this.b[a].appendBuffer(b)};
m.Qc=function(a,b,c){c<=b?this.Ka(a):this.b[a].remove(b,c)};m.Xc=function(a){var b=this.b[a].appendWindowStart,c=this.b[a].appendWindowEnd;this.b[a].abort();this.b[a].appendWindowStart=b;this.b[a].appendWindowEnd=c;this.Ka(a)};m.ed=function(a){this.f.currentTime-=.001;this.Ka(a)};m.Be=function(a,b){0>b&&(b+=.001);this.b[a].timestampOffset=b;this.Ka(a)};m.ye=function(a,b,c){this.b[a].appendWindowStart=0;this.b[a].appendWindowEnd=c;this.b[a].appendWindowStart=b;this.Ka(a)};
m.Le=function(a){this.c[a][0].p.reject(new p(2,3,3014,this.f.error?this.f.error.code:0))};m.Ka=function(a){var b=this.c[a][0];b&&(b.p.resolve(),Lc(this,a))};function Hc(a,b,c){if(a.l)return Promise.reject();c={start:c,p:new u};a.c[b].push(c);if(1==a.c[b].length)try{c.start()}catch(d){"QuotaExceededError"==d.name?c.p.reject(new p(2,3,3017,b)):c.p.reject(new p(2,3,3015,d)),Lc(a,b)}return c.p}
function Kc(a,b){if(a.l)return Promise.reject();var c=[],d;for(d in a.b){var e=new u,f={start:function(a){a.resolve()}.bind(null,e),p:e};a.c[d].push(f);c.push(e);1==a.c[d].length&&f.start()}return Promise.all(c).then(function(){try{b()}catch(k){var a=Promise.reject(new p(2,3,3015,k))}for(var c in this.b)Lc(this,c);return a}.bind(a),function(){return Promise.reject()}.bind(a))}function Lc(a,b){a.c[b].shift();var c=a.c[b][0];if(c)try{c.start()}catch(d){c.p.reject(new p(2,3,3015,d)),Lc(a,b)}};function Mc(a,b,c){return c==b||a>=Nc&&c==b.split("-")[0]||a>=Oc&&c.split("-")[0]==b.split("-")[0]?!0:!1}var Nc=1,Oc=2;function Pc(a){a=a.toLowerCase().split("-");var b=Qc[a[0]];b&&(a[0]=b);return a.join("-")}
var Qc={aar:"aa",abk:"ab",afr:"af",aka:"ak",alb:"sq",amh:"am",ara:"ar",arg:"an",arm:"hy",asm:"as",ava:"av",ave:"ae",aym:"ay",aze:"az",bak:"ba",bam:"bm",baq:"eu",bel:"be",ben:"bn",bih:"bh",bis:"bi",bod:"bo",bos:"bs",bre:"br",bul:"bg",bur:"my",cat:"ca",ces:"cs",cha:"ch",che:"ce",chi:"zh",chu:"cu",chv:"cv",cor:"kw",cos:"co",cre:"cr",cym:"cy",cze:"cs",dan:"da",deu:"de",div:"dv",dut:"nl",dzo:"dz",ell:"el",eng:"en",epo:"eo",est:"et",eus:"eu",ewe:"ee",fao:"fo",fas:"fa",fij:"fj",fin:"fi",fra:"fr",fre:"fr",
fry:"fy",ful:"ff",geo:"ka",ger:"de",gla:"gd",gle:"ga",glg:"gl",glv:"gv",gre:"el",grn:"gn",guj:"gu",hat:"ht",hau:"ha",heb:"he",her:"hz",hin:"hi",hmo:"ho",hrv:"hr",hun:"hu",hye:"hy",ibo:"ig",ice:"is",ido:"io",iii:"ii",iku:"iu",ile:"ie",ina:"ia",ind:"id",ipk:"ik",isl:"is",ita:"it",jav:"jv",jpn:"ja",kal:"kl",kan:"kn",kas:"ks",kat:"ka",kau:"kr",kaz:"kk",khm:"km",kik:"ki",kin:"rw",kir:"ky",kom:"kv",kon:"kg",kor:"ko",kua:"kj",kur:"ku",lao:"lo",lat:"la",lav:"lv",lim:"li",lin:"ln",lit:"lt",ltz:"lb",lub:"lu",
lug:"lg",mac:"mk",mah:"mh",mal:"ml",mao:"mi",mar:"mr",may:"ms",mkd:"mk",mlg:"mg",mlt:"mt",mon:"mn",mri:"mi",msa:"ms",mya:"my",nau:"na",nav:"nv",nbl:"nr",nde:"nd",ndo:"ng",nep:"ne",nld:"nl",nno:"nn",nob:"nb",nor:"no",nya:"ny",oci:"oc",oji:"oj",ori:"or",orm:"om",oss:"os",pan:"pa",per:"fa",pli:"pi",pol:"pl",por:"pt",pus:"ps",que:"qu",roh:"rm",ron:"ro",rum:"ro",run:"rn",rus:"ru",sag:"sg",san:"sa",sin:"si",slk:"sk",slo:"sk",slv:"sl",sme:"se",smo:"sm",sna:"sn",snd:"sd",som:"so",sot:"st",spa:"es",sqi:"sq",
srd:"sc",srp:"sr",ssw:"ss",sun:"su",swa:"sw",swe:"sv",tah:"ty",tam:"ta",tat:"tt",tel:"te",tgk:"tg",tgl:"tl",tha:"th",tib:"bo",tir:"ti",ton:"to",tsn:"tn",tso:"ts",tuk:"tk",tur:"tr",twi:"tw",uig:"ug",ukr:"uk",urd:"ur",uzb:"uz",ven:"ve",vie:"vi",vol:"vo",wel:"cy",wln:"wa",wol:"wo",xho:"xh",yid:"yi",yor:"yo",zha:"za",zho:"zh",zul:"zu"};function Rc(a,b,c){var d=a.video;return d&&(d.width<b.minWidth||d.width>b.maxWidth||d.width>c.width||d.height<b.minHeight||d.height>b.maxHeight||d.height>c.height||d.width*d.height<b.minPixels||d.width*d.height>b.maxPixels)||a.bandwidth<b.minBandwidth||a.bandwidth>b.maxBandwidth?!1:!0}function Sc(a,b,c){var d=!1;a.variants.forEach(function(a){var e=a.allowedByApplication;a.allowedByApplication=Rc(a,b,c);e!=a.allowedByApplication&&(d=!0)});return d}
function Tc(a,b,c,d){d.variants=d.variants.filter(function(d){return a&&a.M&&!$b(a,d)?!1:Uc(d.audio,a,b)&&Uc(d.video,a,c)});d.textStreams=d.textStreams.filter(function(a){return!!F[vb(a.mimeType,a.codecs)]})}
function Uc(a,b,c){if(!a)return!0;var d=null;b&&b.M&&(d=b.u);b=vb(a.mimeType,a.codecs);var e=vb(a.mimeType,a.codecs),f=a.mimeType,g;for(g in wb){var h=a[g],k=wb[g];h&&(f+="; "+k+'="'+h+'"')}return!(F[e]||MediaSource.isTypeSupported(f)||wc(e,a.type))||d&&a.encrypted&&0>d.indexOf(b)||c&&(a.mimeType!=c.mimeType||a.codecs.split(".")[0]!=c.codecs.split(".")[0])?!1:!0}
function Vc(a){var b=a.audio,c=a.video,d=b?b.codecs:null,e=c?c.codecs:null,f=[];e&&f.push(e);d&&f.push(d);var g=[];c&&g.push(c.mimeType);b&&g.push(b.mimeType);g=g[0]||null;var h=[];b&&h.push(b.kind);c&&h.push(c.kind);h=h[0]||null;var k=[];b&&k.push.apply(k,b.roles);c&&k.push.apply(k,c.roles);k=Ra(k);a={id:a.id,active:!1,type:"variant",bandwidth:a.bandwidth,language:a.language,label:null,kind:h,width:null,height:null,frameRate:null,mimeType:g,codecs:f.join(", "),audioCodec:d,videoCodec:e,primary:a.primary,
roles:k,videoId:null,audioId:null,channelsCount:null,audioBandwidth:null,videoBandwidth:null};c&&(a.videoId=c.id,a.width=c.width||null,a.height=c.height||null,a.frameRate=c.frameRate||null,a.videoBandwidth=c.bandwidth||null);b&&(a.audioId=b.id,a.channelsCount=b.channelsCount,a.audioBandwidth=b.bandwidth||null,a.label=b.label);return a}
function Wc(a){return{id:a.id,active:!1,type:"text",bandwidth:0,language:a.language,label:a.label,kind:a.kind||null,width:null,height:null,frameRate:null,mimeType:a.mimeType,codecs:a.codecs||null,audioCodec:null,videoCodec:null,primary:a.primary,roles:a.roles,videoId:null,audioId:null,channelsCount:null,audioBandwidth:null,videoBandwidth:null}}function Xc(a){var b=[],c=Yc(a.variants);a=a.textStreams;c.forEach(function(a){b.push(Vc(a))});a.forEach(function(a){b.push(Wc(a))});return b}
function Zc(a,b,c){return Yc(a.variants).map(function(a){var d=Vc(a);a.video&&a.audio?d.active=c==a.video.id&&b==a.audio.id:a.video?d.active=c==a.video.id:a.audio&&(d.active=b==a.audio.id);return d})}function $c(a,b){return a.textStreams.map(function(a){var c=Wc(a);c.active=b==a.id;return c})}function ad(a,b){for(var c=0;c<a.variants.length;c++)if(a.variants[c].id==b.id)return a.variants[c];return null}
function bd(a,b){for(var c=0;c<a.textStreams.length;c++)if(a.textStreams[c].id==b.id)return a.textStreams[c];return null}function cd(a){return a.allowedByApplication&&a.allowedByKeySystem}function Yc(a){return a.filter(function(a){return cd(a)})}
function dd(a,b,c,d){var e=Yc(a),f=e;a=e.filter(function(a){return a.primary});a.length&&(f=a);var g=f.length?f[0].language:"";f=f.filter(function(a){return a.language==g});if(b){var h=Pc(b);[Oc,Nc,0].forEach(function(a){var b=!1;e.forEach(function(c){h=Pc(h);var e=Pc(c.language);Mc(a,h,e)&&(b?f.push(c):(f=[c],b=!0),d&&(d.audio=!0))})})}if(c&&(b=ed(f,c),b.length))return b;b=f.map(function(a){return(a.audio?a.audio.roles:[]).concat(a.video?a.video.roles:[])}).reduce(lb,[]);return b.length?ed(f,b[0]):
f}function fd(a,b,c,d){var e=a,f=a.filter(function(a){return a.primary});f.length&&(e=f);var g=e.length?e[0].language:"";e=e.filter(function(a){return a.language==g});if(b){var h=Pc(b);[Oc,Nc,0].forEach(function(b){var c=!1;a.forEach(function(a){var f=Pc(a.language);Mc(b,h,f)&&(c?e.push(a):(e=[a],c=!0),d&&(d.text=!0))})})}b=c?gd(e,c):e.filter(function(a){return 0==a.roles.length});if(b.length)return b;b=e.map(function(a){return a.roles}).reduce(lb,[]);return b.length?gd(e,b[0]):e}
function ed(a,b){return a.filter(function(a){return a.audio&&0<=a.audio.roles.indexOf(b)||a.video&&0<=a.video.roles.indexOf(b)})}function gd(a,b){return a.filter(function(a){return 0<=a.roles.indexOf(b)})}function hd(a,b,c){for(var d=0;d<c.length;d++)if(c[d].audio==a&&c[d].video==b)return c[d];return null}function id(a,b,c){function d(a,b){return null==a?null==b:b.id==a}for(var e=0;e<c.length;e++)if(d(a,c[e].audio)&&d(b,c[e].video))return c[e];return null}
function jd(a,b){for(var c=a.periods.length-1;0<c;--c)if(b+qb>=a.periods[c].startTime)return c;return 0}function kd(a,b){for(var c=0;c<a.periods.length;++c){var d=a.periods[c];if("text"==b.type)for(var e=0;e<d.textStreams.length;++e){if(d.textStreams[e]==b)return c}else for(e=0;e<d.variants.length;++e){var f=d.variants[e];if(f.audio==b||f.video==b||f.video&&f.video.trickModeVideo==b)return c}}return-1};function G(){this.h=null;this.c=!1;this.b=new pa;this.g=[];this.i=!1;this.a=this.f=null}n("shaka.abr.SimpleAbrManager",G);G.prototype.stop=function(){this.h=null;this.c=!1;this.g=[];this.f=null};G.prototype.stop=G.prototype.stop;G.prototype.init=function(a){this.h=a};G.prototype.init=G.prototype.init;
G.prototype.chooseVariant=function(){var a=ld(this.a.restrictions,this.g),b=this.b.getBandwidthEstimate(this.a.defaultBandwidthEstimate);if(this.g.length&&!a.length)throw new p(2,4,4012);for(var c=a[0]||null,d=0;d<a.length;++d){var e=a[d],f=(a[d+1]||{bandwidth:Infinity}).bandwidth/this.a.bandwidthUpgradeTarget;b>=e.bandwidth/this.a.bandwidthDowngradeTarget&&b<=f&&(c=e)}this.f=Date.now();return c};G.prototype.chooseVariant=G.prototype.chooseVariant;G.prototype.enable=function(){this.c=!0};
G.prototype.enable=G.prototype.enable;G.prototype.disable=function(){this.c=!1};G.prototype.disable=G.prototype.disable;G.prototype.segmentDownloaded=function(a,b){var c=this.b;if(!(16E3>b)){var d=8E3*b/a,e=a/1E3;c.a+=b;na(c.b,e,d);na(c.c,e,d)}if(null!=this.f&&this.c)a:{if(!this.i){if(!(128E3<=this.b.a))break a;this.i=!0}else if(Date.now()-this.f<1E3*this.a.switchInterval)break a;c=this.chooseVariant();this.b.getBandwidthEstimate(this.a.defaultBandwidthEstimate);this.h(c)}};
G.prototype.segmentDownloaded=G.prototype.segmentDownloaded;G.prototype.getBandwidthEstimate=function(){return this.b.getBandwidthEstimate(this.a.defaultBandwidthEstimate)};G.prototype.getBandwidthEstimate=G.prototype.getBandwidthEstimate;G.prototype.setVariants=function(a){this.g=a};G.prototype.setVariants=G.prototype.setVariants;G.prototype.configure=function(a){this.a=a};G.prototype.configure=G.prototype.configure;
function ld(a,b){return b.filter(function(b){return Rc(b,a,{width:Infinity,height:Infinity})}).sort(function(a,b){return a.bandwidth-b.bandwidth})};var md="ended play playing pause pausing ratechange seeked seeking timeupdate volumechange".split(" "),nd="buffered currentTime duration ended loop muted paused playbackRate seeking videoHeight videoWidth volume".split(" "),od=["loop","playbackRate"],pd=["pause","play"],qd="adaptation buffering emsg error loading streaming texttrackvisibility timelineregionadded timelineregionenter timelineregionexit trackschanged unloading".split(" "),ud={drmInfo:20,getAudioLanguages:2,getAudioLanguagesAndRoles:2,
getBufferedInfo:2,getConfiguration:2,getExpiration:2,getManifestUri:2,getPlaybackRate:2,getTextLanguages:2,getTextLanguagesAndRoles:2,getTextTracks:2,getStats:5,getUseEmbeddedTextTrack:2,getVariantTracks:2,isAudioOnly:10,isBuffering:1,isInProgress:1,isLive:10,isTextTrackVisible:1,keySystem:10,seekRange:1},vd={getPlayheadTimeAsDate:1,getPresentationStartTimeAsDate:20},wd=[["getConfiguration","configure"]],xd=[["isTextTrackVisible","setTextTrackVisibility"]],yd="addTextTrack cancelTrickPlay configure resetConfiguration retryStreaming selectAudioLanguage selectEmbeddedTextTrack selectTextLanguage selectTextTrack selectVariantTrack setTextTrackVisibility trickPlay".split(" "),
zd=["load","unload"];function Ad(a){return JSON.stringify(a,function(a,c){if("function"!=typeof c){if(c instanceof Event||c instanceof B){var b={},e;for(e in c){var f=c[e];f&&"object"==typeof f?"detail"==e&&(b[e]=f):e in Event||(b[e]=f)}return b}if(c instanceof TimeRanges)for(b={__type__:"TimeRanges",length:c.length,start:[],end:[]},e=0;e<c.length;++e)b.start.push(c.start(e)),b.end.push(c.end(e));else b="number"==typeof c?isNaN(c)?"NaN":isFinite(c)?c:0>c?"-Infinity":"Infinity":c;return b}})}
function Bd(a){return JSON.parse(a,function(a,c){return"NaN"==c?NaN:"-Infinity"==c?-Infinity:"Infinity"==c?Infinity:c&&"object"==typeof c&&"TimeRanges"==c.__type__?Cd(c):c})}function Cd(a){return{length:a.length,start:function(b){return a.start[b]},end:function(b){return a.end[b]}}};function Dd(a,b,c,d,e,f){this.L=a;this.g=b;this.M=c;this.j=!1;this.A=d;this.F=e;this.u=f;this.b=this.h=!1;this.v="";this.i=null;this.l=this.tc.bind(this);this.m=this.Id.bind(this);this.a={video:{},player:{}};this.o=0;this.c={};this.f=null}var Ed=!1,H=null;m=Dd.prototype;m.destroy=function(){Fd(this);H&&Gd(this);this.F=this.A=this.g=null;this.b=this.h=!1;this.m=this.l=this.f=this.c=this.a=this.i=null;return Promise.resolve()};m.X=function(){return this.b};m.Ub=function(){return this.v};
m.init=function(){if(window.chrome&&chrome.cast&&chrome.cast.isAvailable){delete window.__onGCastApiAvailable;this.h=!0;this.g();var a=new chrome.cast.SessionRequest(this.L);a=new chrome.cast.ApiConfig(a,this.uc.bind(this),this.Pd.bind(this),"origin_scoped");chrome.cast.initialize(a,function(){},function(){});Ed&&setTimeout(this.g.bind(this),20);(a=H)&&a.status!=chrome.cast.SessionStatus.STOPPED?this.uc(a):H=null}else window.__onGCastApiAvailable=function(a){a&&this.init()}.bind(this)};
m.Xb=function(a){this.i=a;this.b&&Hd({type:"appData",appData:this.i})};m.cast=function(a){if(!this.h)return Promise.reject(new p(1,8,8E3));if(!Ed)return Promise.reject(new p(1,8,8001));if(this.b)return Promise.reject(new p(1,8,8002));this.f=new u;chrome.cast.requestSession(this.Rb.bind(this,a),this.sc.bind(this));return this.f};m.qb=function(){this.b&&(Fd(this),H&&(Gd(this),H.stop(function(){},function(){}),H=null))};
m.get=function(a,b){if("video"==a){if(0<=pd.indexOf(b))return this.Fc.bind(this,a,b)}else if("player"==a){if(vd[b]&&!this.get("player","isLive")())return function(){};if(0<=yd.indexOf(b))return this.Fc.bind(this,a,b);if(0<=zd.indexOf(b))return this.me.bind(this,a,b);if(ud[b])return this.Cc.bind(this,a,b)}return this.Cc(a,b)};m.set=function(a,b,c){this.a[a][b]=c;Hd({type:"set",targetName:a,property:b,value:c})};
m.Rb=function(a,b){H=b;b.addUpdateListener(this.l);b.addMessageListener("urn:x-cast:com.google.shaka.v2",this.m);this.tc();Hd({type:"init",initState:a,appData:this.i});this.f.resolve()};m.sc=function(a){var b=8003;switch(a.code){case "cancel":b=8004;break;case "timeout":b=8005;break;case "receiver_unavailable":b=8006}this.f.reject(new p(2,8,b,a))};m.Cc=function(a,b){return this.a[a][b]};m.Fc=function(a,b){Hd({type:"call",targetName:a,methodName:b,args:Array.prototype.slice.call(arguments,2)})};
m.me=function(a,b){var c=Array.prototype.slice.call(arguments,2),d=new u,e=this.o.toString();this.o++;this.c[e]=d;Hd({type:"asyncCall",targetName:a,methodName:b,args:c,id:e});return d};m.uc=function(a){var b=this.u();this.f=new u;this.j=!0;this.Rb(b,a)};m.Pd=function(a){Ed="available"==a;this.g()};function Gd(a){var b=H;b.removeUpdateListener(a.l);b.removeMessageListener("urn:x-cast:com.google.shaka.v2",a.m)}
m.tc=function(){var a=H?"connected"==H.status:!1;if(this.b&&!a){this.F();for(var b in this.a)this.a[b]={};Fd(this)}this.v=(this.b=a)?H.receiver.friendlyName:"";this.g()};function Fd(a){for(var b in a.c){var c=a.c[b];delete a.c[b];c.reject(new p(1,7,7E3))}}
m.Id=function(a,b){var c=Bd(b);switch(c.type){case "event":var d=c.event;this.A(c.targetName,new B(d.type,d));break;case "update":d=c.update;for(var e in d){c=this.a[e]||{};for(var f in d[e])c[f]=d[e][f]}this.j&&(this.M(),this.j=!1);break;case "asyncComplete":if(e=c.id,c=c.error,f=this.c[e],delete this.c[e],f)if(c){e=new p(c.severity,c.category,c.code);for(d in c)e[d]=c[d];f.reject(e)}else f.resolve()}};function Hd(a){a=Ad(a);H.sendMessage("urn:x-cast:com.google.shaka.v2",a,function(){},ra)};function I(){this.yb=new fb;this.hb=this}I.prototype.addEventListener=function(a,b){this.yb.push(a,b)};I.prototype.removeEventListener=function(a,b){this.yb.remove(a,b)};I.prototype.dispatchEvent=function(a){for(var b=this.yb.get(a.type)||[],c=0;c<b.length;++c){a.target=this.hb;a.currentTarget=this.hb;var d=b[c];try{d.handleEvent?d.handleEvent(a):d.call(this,a)}catch(e){}if(a.a)break}return a.defaultPrevented};function J(a,b,c){I.call(this);this.c=a;this.b=b;this.i=this.g=this.f=this.j=this.h=null;this.a=new Dd(c,this.Ge.bind(this),this.He.bind(this),this.Ie.bind(this),this.Je.bind(this),this.lc.bind(this));Id(this)}la(J,I);n("shaka.cast.CastProxy",J);J.prototype.destroy=function(a){a&&this.a&&this.a.qb();a=[this.i?this.i.destroy():null,this.b?this.b.destroy():null,this.a?this.a.destroy():null];this.a=this.i=this.j=this.h=this.b=this.c=null;return Promise.all(a)};J.prototype.destroy=J.prototype.destroy;
J.prototype.ud=function(){return this.h};J.prototype.getVideo=J.prototype.ud;J.prototype.ld=function(){return this.j};J.prototype.getPlayer=J.prototype.ld;J.prototype.Yc=function(){return this.a?this.a.h&&Ed:!1};J.prototype.canCast=J.prototype.Yc;J.prototype.X=function(){return this.a?this.a.X():!1};J.prototype.isCasting=J.prototype.X;J.prototype.Ub=function(){return this.a?this.a.Ub():""};J.prototype.receiverName=J.prototype.Ub;J.prototype.cast=function(){var a=this.lc();return this.a.cast(a).then(function(){if(this.b)return this.b.wb()}.bind(this))};
J.prototype.cast=J.prototype.cast;J.prototype.Xb=function(a){this.a.Xb(a)};J.prototype.setAppData=J.prototype.Xb;J.prototype.Oe=function(){var a=this.a;if(a.b){var b=a.u();chrome.cast.requestSession(a.Rb.bind(a,b),a.sc.bind(a))}};J.prototype.suggestDisconnect=J.prototype.Oe;J.prototype.qb=function(){this.a.qb()};J.prototype.forceDisconnect=J.prototype.qb;
function Id(a){a.a.init();a.i=new z;md.forEach(function(a){A(this.i,this.c,a,this.Ve.bind(this))}.bind(a));qd.forEach(function(a){A(this.i,this.b,a,this.ee.bind(this))}.bind(a));a.h={};for(var b in a.c)Object.defineProperty(a.h,b,{configurable:!1,enumerable:!0,get:a.Ue.bind(a,b),set:a.We.bind(a,b)});a.j={};for(var c in a.b)Object.defineProperty(a.j,c,{configurable:!1,enumerable:!0,get:a.de.bind(a,c)});a.f=new I;a.f.hb=a.h;a.g=new I;a.g.hb=a.j}m=J.prototype;
m.lc=function(){var a={video:{},player:{},playerAfterLoad:{},manifest:this.b.Fb(),startTime:null};this.c.pause();od.forEach(function(b){a.video[b]=this.c[b]}.bind(this));this.c.ended||(a.startTime=this.c.currentTime);wd.forEach(function(b){var c=b[1];b=this.b[b[0]]();a.player[c]=b}.bind(this));xd.forEach(function(b){var c=b[1];b=this.b[b[0]]();a.playerAfterLoad[c]=b}.bind(this));return a};m.Ge=function(){this.dispatchEvent(new B("caststatuschanged"))};
m.He=function(){this.f.dispatchEvent(new B(this.h.paused?"pause":"play"))};
m.Je=function(){var a=this;wd.forEach(function(a){var b=a[1];a=this.a.get("player",a[0])();this.b[b](a)}.bind(this));var b=this.a.get("player","getManifestUri")(),c=this.a.get("video","ended"),d=Promise.resolve(),e=this.c.autoplay,f=null;c||(f=this.a.get("video","currentTime"));b&&(this.c.autoplay=!1,d=this.b.load(b,f));var g={};od.forEach(function(a){g[a]=this.a.get("video",a)}.bind(this));d.then(function(){a.c&&(od.forEach(function(a){this.c[a]=g[a]}.bind(a)),xd.forEach(function(a){var b=a[1];a=
this.a.get("player",a[0])();this.b[b](a)}.bind(a)),a.c.autoplay=e,b&&a.c.play())},function(b){a.b.dispatchEvent(new B("error",{detail:b}))})};m.Ue=function(a){if("addEventListener"==a)return this.f.addEventListener.bind(this.f);if("removeEventListener"==a)return this.f.removeEventListener.bind(this.f);if(this.a.X()&&0==Object.keys(this.a.a.video).length){var b=this.c[a];if("function"!=typeof b)return b}return this.a.X()?this.a.get("video",a):(a=this.c[a],"function"==typeof a&&(a=a.bind(this.c)),a)};
m.We=function(a,b){this.a.X()?this.a.set("video",a,b):this.c[a]=b};m.Ve=function(a){this.a.X()||this.f.dispatchEvent(new B(a.type,a))};
m.de=function(a){return"addEventListener"==a?this.g.addEventListener.bind(this.g):"removeEventListener"==a?this.g.removeEventListener.bind(this.g):"getMediaElement"==a?function(){return this.h}.bind(this):"getNetworkingEngine"==a?this.b.mc.bind(this.b):"getManifest"==a?this.a.X()?function(){return null}:this.b.ma.bind(this.b):this.a.X()&&0==Object.keys(this.a.a.video).length&&ud[a]||!this.a.X()?this.b[a].bind(this.b):this.a.get("player",a)};m.ee=function(a){this.a.X()||this.g.dispatchEvent(a)};
m.Ie=function(a,b){this.a.X()&&("video"==a?this.f.dispatchEvent(b):"player"==a&&this.g.dispatchEvent(b))};function K(a,b,c,d){I.call(this);this.a=a;this.b=b;this.c=new z;this.u={video:a,player:b};this.v=c||function(){};this.A=d||function(a){return a};this.o=!1;this.h=!0;this.g=0;this.m=!1;this.j=!0;this.l=this.i=this.f=null;Jd(this)}la(K,I);n("shaka.cast.CastReceiver",K);K.prototype.isConnected=function(){return this.o};K.prototype.isConnected=K.prototype.isConnected;K.prototype.wd=function(){return this.h};K.prototype.isIdle=K.prototype.wd;
K.prototype.destroy=function(){var a=[this.c?this.c.destroy():null,this.b?this.b.destroy():null];null!=this.l&&window.clearTimeout(this.l);this.v=this.u=this.c=this.b=this.a=null;this.o=!1;this.h=!0;this.l=this.i=this.f=null;return Promise.all(a).then(function(){cast.receiver.CastReceiverManager.getInstance().stop()})};K.prototype.destroy=K.prototype.destroy;
function Jd(a){var b=cast.receiver.CastReceiverManager.getInstance();b.onSenderConnected=a.yc.bind(a);b.onSenderDisconnected=a.yc.bind(a);b.onSystemVolumeChanged=a.dd.bind(a);a.i=b.getCastMessageBus("urn:x-cast:com.google.cast.media");a.i.onMessage=a.Dd.bind(a);a.f=b.getCastMessageBus("urn:x-cast:com.google.shaka.v2");a.f.onMessage=a.Sd.bind(a);b.start();md.forEach(function(a){A(this.c,this.a,a,this.Dc.bind(this,"video"))}.bind(a));qd.forEach(function(a){A(this.c,this.b,a,this.Dc.bind(this,"player"))}.bind(a));
cast.__platform__&&cast.__platform__.canDisplayType('video/mp4; codecs="avc1.640028"; width=3840; height=2160')?a.b.Yb(3840,2160):a.b.Yb(1920,1080);A(a.c,a.a,"loadeddata",function(){this.m=!0}.bind(a));A(a.c,a.b,"loading",function(){this.h=!1;Kd(this)}.bind(a));A(a.c,a.a,"playing",function(){this.h=!1;Kd(this)}.bind(a));A(a.c,a.a,"pause",function(){Kd(this)}.bind(a));A(a.c,a.b,"unloading",function(){this.h=!0;Kd(this)}.bind(a));A(a.c,a.a,"ended",function(){window.setTimeout(function(){this.a&&this.a.ended&&
(this.h=!0,Kd(this))}.bind(this),5E3)}.bind(a))}m=K.prototype;m.yc=function(){this.g=0;this.j=!0;this.o=0!=cast.receiver.CastReceiverManager.getInstance().getSenders().length;Kd(this)};function Kd(a){Promise.resolve().then(function(){this.b&&(this.dispatchEvent(new B("caststatuschanged")),Ld(this)||Md(this,0))}.bind(a))}
function Nd(a,b,c){for(var d in b.player)a.b[d](b.player[d]);a.v(c);c=Promise.resolve();var e=a.a.autoplay;b.manifest&&(a.a.autoplay=!1,c=a.b.load(b.manifest,b.startTime));c.then(function(){if(a.b){for(var c in b.video)a.a[c]=b.video[c];for(var d in b.playerAfterLoad)a.b[d](b.playerAfterLoad[d]);a.a.autoplay=e;b.manifest&&(a.a.play(),Md(a,0))}},function(b){a.b.dispatchEvent(new B("error",{detail:b}))})}m.Dc=function(a,b){this.b&&(this.Sb(),Od(this,{type:"event",targetName:a,event:b},this.f))};
m.Sb=function(){null!=this.l&&window.clearTimeout(this.l);this.l=window.setTimeout(this.Sb.bind(this),500);var a={video:{},player:{}};nd.forEach(function(b){a.video[b]=this.a[b]}.bind(this));if(this.b.O())for(var b in vd)0==this.g%vd[b]&&(a.player[b]=this.b[b]());for(var c in ud)0==this.g%ud[c]&&(a.player[c]=this.b[c]());if(b=cast.receiver.CastReceiverManager.getInstance().getSystemVolume())a.video.volume=b.level,a.video.muted=b.muted;this.m&&(this.g+=1);Od(this,{type:"update",update:a},this.f);Ld(this)};
function Ld(a){return a.j&&(a.a.duration||a.b.O())?(Pd(a),a.j=!1,!0):!1}function Pd(a){var b={contentId:a.b.Fb(),streamType:a.b.O()?"LIVE":"BUFFERED",duration:a.a.duration,contentType:""};Md(a,0,b)}m.dd=function(){var a=cast.receiver.CastReceiverManager.getInstance().getSystemVolume();a&&Od(this,{type:"update",update:{video:{volume:a.level,muted:a.muted}}},this.f);Od(this,{type:"event",targetName:"video",event:{type:"volumechange"}},this.f)};
m.Sd=function(a){var b=Bd(a.data);switch(b.type){case "init":this.g=0;this.m=!1;this.j=!0;Nd(this,b.initState,b.appData);this.Sb();break;case "appData":this.v(b.appData);break;case "set":var c=b.targetName,d=b.property;b=b.value;if("video"==c){var e=cast.receiver.CastReceiverManager.getInstance();if("volume"==d){e.setSystemVolumeLevel(b);break}else if("muted"==d){e.setSystemVolumeMuted(b);break}}this.u[c][d]=b;break;case "call":c=this.u[b.targetName];c[b.methodName].apply(c,b.args);break;case "asyncCall":c=
b.targetName;d=b.methodName;"player"==c&&"load"==d&&(this.g=0,this.m=!1);e=b.id;a=a.senderId;var f=this.u[c];b=f[d].apply(f,b.args);"player"==c&&"load"==d&&(b=b.then(function(){this.j=!0}.bind(this)));b.then(this.Kc.bind(this,a,e,null),this.Kc.bind(this,a,e))}};
m.Dd=function(a){var b=Bd(a.data);switch(b.type){case "PLAY":this.a.play();Md(this,0);break;case "PAUSE":this.a.pause();Md(this,0);break;case "SEEK":a=b.currentTime;var c=b.resumeState;null!=a&&(this.a.currentTime=Number(a));c&&"PLAYBACK_START"==c?(this.a.play(),Md(this,0)):c&&"PLAYBACK_PAUSE"==c&&(this.a.pause(),Md(this,0));break;case "STOP":this.b.wb().then(function(){this.b&&Md(this,0)}.bind(this));break;case "GET_STATUS":Md(this,Number(b.requestId));break;case "VOLUME":c=b.volume;a=c.level;c=
c.muted;var d=this.a.volume,e=this.a.muted;null!=a&&(this.a.volume=Number(a));null!=c&&(this.a.muted=c);d==this.a.volume&&e==this.a.muted||Md(this,0);break;case "LOAD":this.g=0;this.j=this.m=!1;a=b.currentTime;c=this.A(b.media.contentId);this.a.autoplay=!0;this.b.load(c,a).then(function(){this.b&&Pd(this)}.bind(this))["catch"](function(a){var c="LOAD_FAILED";7==a.category&&7E3==a.code&&(c="LOAD_CANCELLED");Od(this,{requestId:Number(b.requestId),type:c},this.i)}.bind(this));break;default:Od(this,{requestId:Number(b.requestId),
type:"INVALID_REQUEST",reason:"INVALID_COMMAND"},this.i)}};m.Kc=function(a,b,c){this.b&&Od(this,{type:"asyncComplete",id:b,error:c},this.f,a)};function Od(a,b,c,d){a.o&&(a=Ad(b),d?c.getCastChannel(d).send(a):c.broadcast(a))}
function Md(a,b,c){var d=a.a.playbackRate;var e=Qd;e=a.h?e.IDLE:a.b.pc()?e.Sc:a.a.paused?e.Uc:e.Vc;d={mediaSessionId:0,playbackRate:d,playerState:e,currentTime:a.a.currentTime,supportedMediaCommands:15,volume:{level:a.a.volume,muted:a.a.muted}};c&&(d.media=c);Od(a,{requestId:b,type:"MEDIA_STATUS",status:[d]},a.i)}var Qd={IDLE:"IDLE",Vc:"PLAYING",Sc:"BUFFERING",Uc:"PAUSED"};function Rd(a,b){var c=L(a,b);return 1!=c.length?null:c[0]}function L(a,b){return Array.prototype.filter.call(a.childNodes,function(a){return a instanceof Element&&a.tagName==b})}function Sd(a){var b=a.firstChild;return b&&b.nodeType==Node.TEXT_NODE?a.textContent.trim():null}function M(a,b,c,d){var e=null;a=a.getAttribute(b);null!=a&&(e=c(a));return null==e?void 0!=d?d:null:e}
function Td(a){if(!a)return null;/^\d+-\d+-\d+T\d+:\d+:\d+(\.\d+)?$/.test(a)&&(a+="Z");a=Date.parse(a);return isNaN(a)?null:Math.floor(a/1E3)}function Ud(a){if(!a)return null;a=/^P(?:([0-9]*)Y)?(?:([0-9]*)M)?(?:([0-9]*)D)?(?:T(?:([0-9]*)H)?(?:([0-9]*)M)?(?:([0-9.]*)S)?)?$/.exec(a);if(!a)return null;a=31536E3*Number(a[1]||null)+2592E3*Number(a[2]||null)+86400*Number(a[3]||null)+3600*Number(a[4]||null)+60*Number(a[5]||null)+Number(a[6]||null);return isFinite(a)?a:null}
function Vd(a){var b=/([0-9]+)-([0-9]+)/.exec(a);if(!b)return null;a=Number(b[1]);if(!isFinite(a))return null;b=Number(b[2]);return isFinite(b)?{start:a,end:b}:null}function Wd(a){a=Number(a);return 0===a%1?a:null}function Xd(a){a=Number(a);return 0===a%1&&0<a?a:null}function Yd(a){a=Number(a);return 0===a%1&&0<=a?a:null}function Zd(a){var b;a=(b=a.match(/^(\d+)\/(\d+)$/))?Number(b[1]/b[2]):Number(a);return isNaN(a)?null:a};var $d={"urn:uuid:1077efec-c0b2-4d02-ace3-3c1e52e2fb4b":"org.w3.clearkey","urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed":"com.widevine.alpha","urn:uuid:9a04f079-9840-4286-ab92-e65be0885f95":"com.microsoft.playready","urn:uuid:f239e769-efa3-4850-9c16-a903c6932efb":"com.adobe.primetime"};
function ae(a,b,c){a=be(a);var d=null,e=[],f=[],g=a.map(function(a){return a.keyId}).filter(nb);if(g.length&&1<g.filter(ob).length)throw new p(2,4,4010);c||(f=a.filter(function(a){return"urn:mpeg:dash:mp4protection:2011"==a.Jc?(d=a.init||d,!1):!0}),f.length&&(e=ce(d,b,f),0==e.length&&(e=[pb("",d)])));!a.length||!c&&f.length||(e=sb($d).map(function(a){return pb(a,d)}));var h=g[0]||null;h&&e.forEach(function(a){a.initData.forEach(function(a){a.keyId=h})});return{hc:h,df:d,drmInfos:e,kc:!0}}
function de(a,b,c,d){var e=ae(a,b,d);if(c.kc){a=1==c.drmInfos.length&&!c.drmInfos[0].keySystem;b=0==e.drmInfos.length;if(0==c.drmInfos.length||a&&!b)c.drmInfos=e.drmInfos;c.kc=!1}else if(0<e.drmInfos.length&&(c.drmInfos=c.drmInfos.filter(function(a){return e.drmInfos.some(function(b){return b.keySystem==a.keySystem})}),0==c.drmInfos.length))throw new p(2,4,4008);return e.hc||c.hc}function ce(a,b,c){return c.map(function(c){var d=$d[c.Jc];return d?[pb(d,c.init||a)]:b(c.node)||[]}).reduce(lb,[])}
function be(a){return a.map(function(a){var b=a.getAttribute("schemeIdUri"),d=a.getAttribute("cenc:default_KID"),e=L(a,"cenc:pssh").map(Sd);if(!b)return null;b=b.toLowerCase();if(d&&(d=d.replace(/-/g,"").toLowerCase(),0<=d.indexOf(" ")))throw new p(2,4,4009);var f=[];try{f=e.map(function(a){return{initDataType:"cenc",initData:Fb(a),keyId:null}})}catch(g){throw new p(2,4,4007);}return{node:a,Jc:b,keyId:d,init:0<f.length?f:null}}).filter(nb)};function ee(a,b,c,d,e){null!=e&&(e=Math.round(e));var f={RepresentationID:b,Number:c,Bandwidth:d,Time:e};return a.replace(/\$(RepresentationID|Number|Bandwidth|Time)?(?:%0([0-9]+)d)?\$/g,function(a,b,c){if("$$"==a)return"$";var d=f[b];if(null==d)return a;"RepresentationID"==b&&c&&(c=void 0);a=d.toString();c=window.parseInt(c,10)||1;return Array(Math.max(0,c-a.length)+1).join("0")+a})}
function fe(a,b){var c=ge(a,b,"timescale"),d=1;c&&(d=Xd(c)||1);c=ge(a,b,"duration");(c=Xd(c||""))&&(c/=d);var e=ge(a,b,"startNumber"),f=Number(ge(a,b,"presentationTimeOffset"))||0,g=Yd(e||"");if(null==e||null==g)g=1;var h=he(a,b,"SegmentTimeline");e=null;if(h){e=d;var k=a.N.duration||Infinity;h=L(h,"S");for(var l=[],q=0,r=0;r<h.length;++r){var t=h[r],v=M(t,"t",Yd),y=M(t,"d",Yd);t=M(t,"r",Wd);null!=v&&(v-=f);if(!y)break;v=null!=v?v:q;t=t||0;if(0>t)if(r+1<h.length){t=M(h[r+1],"t",Yd);if(null==t)break;
else if(v>=t)break;t=Math.ceil((t-v)/y)-1}else{if(Infinity==k)break;else if(v/e>=k)break;t=Math.ceil((k*e-v)/y)-1}0<l.length&&v!=q&&(l[l.length-1].end=v/e);for(var ib=0;ib<=t;++ib)q=v+y,l.push({start:v/e,end:q/e,Se:v}),v=q}e=l}return{timescale:d,P:c,xa:g,aa:f/d||0,dc:f,I:e}}function ge(a,b,c){return[b(a.w),b(a.T),b(a.Z)].filter(nb).map(function(a){return a.getAttribute(c)}).reduce(function(a,b){return a||b})}
function he(a,b,c){return[b(a.w),b(a.T),b(a.Z)].filter(nb).map(function(a){return Rd(a,c)}).reduce(function(a,b){return a||b})}function ie(a,b){var c=new DOMParser;try{var d=D(a);var e=c.parseFromString(d,"text/xml")}catch(g){}if(e&&e.documentElement.tagName==b)var f=e.documentElement;return f&&0<f.getElementsByTagName("parsererror").length?null:f}
function je(a,b,c,d,e,f){for(var g=a.getAttribute("xlink:href"),h=a.getAttribute("xlink:actuate")||"onRequest",k=0;k<a.attributes.length;k++){var l=a.attributes[k].nodeName;-1!=l.indexOf("xlink:")&&(a.removeAttribute(l),--k)}if(5<=f)return La(new p(2,4,4028));if("onLoad"!=h)return La(new p(2,4,4027));var q=C([d],[g]);return w(e.request(0,ab(q,b)),function(d){d=ie(d.data,a.tagName);if(!d)return La(new p(2,4,4001,g));for(;a.childNodes.length;)a.removeChild(a.childNodes[0]);for(;d.childNodes.length;){var h=
d.childNodes[0];d.removeChild(h);a.appendChild(h)}for(h=0;h<d.attributes.length;h++){var k=d.attributes[h].nodeName,l=d.getAttribute(k);a.setAttribute(k,l)}return ke(a,b,c,q[0],e,f+1)})}
function ke(a,b,c,d,e,f){f=f||0;if(a.getAttribute("xlink:href")){var g=je(a,b,c,d,e,f);c&&(g=w(g,void 0,function(){return ke(a,b,c,d,e,f)}));return g}for(g=0;g<a.childNodes.length;g++){var h=a.childNodes[g];h instanceof Element&&"urn:mpeg:dash:resolve-to-zero:2013"==h.getAttribute("xlink:href")&&(a.removeChild(h),--g)}g=[];for(h=0;h<a.childNodes.length;h++){var k=a.childNodes[h];k.nodeType==Node.ELEMENT_NODE&&g.push(ke(k,b,c,d,e,f))}return w(Pa(g),function(){return a})};function N(a,b,c){this.W=a;this.K=b;this.C=c;this.uris=[]}n("shaka.media.InitSegmentReference",N);N.prototype.Ab=function(){return this.W()};N.prototype.createUris=N.prototype.Ab;N.prototype.Gb=function(){return this.K};N.prototype.getStartByte=N.prototype.Gb;N.prototype.Eb=function(){return this.C};N.prototype.getEndByte=N.prototype.Eb;function O(a,b,c,d,e,f){this.position=a;this.startTime=b;this.endTime=c;this.W=d;this.K=e;this.C=f;this.dataKey=null;this.Ca=0}n("shaka.media.SegmentReference",O);
O.prototype.U=function(){return this.position};O.prototype.getPosition=O.prototype.U;O.prototype.Hb=function(){return this.startTime};O.prototype.getStartTime=O.prototype.Hb;O.prototype.hd=function(){return this.endTime};O.prototype.getEndTime=O.prototype.hd;O.prototype.Ab=function(){return this.W()};O.prototype.createUris=O.prototype.Ab;O.prototype.Gb=function(){return this.K};O.prototype.getStartByte=O.prototype.Gb;O.prototype.Eb=function(){return this.C};O.prototype.getEndByte=O.prototype.Eb;function P(a,b){this.H=a;this.b=b==le;this.a=0}n("shaka.util.DataViewReader",P);var le=1;P.Endianness={Ye:0,af:le};P.prototype.da=function(){return this.a<this.H.byteLength};P.prototype.hasMoreData=P.prototype.da;P.prototype.U=function(){return this.a};P.prototype.getPosition=P.prototype.U;P.prototype.jd=function(){return this.H.byteLength};P.prototype.getLength=P.prototype.jd;P.prototype.$=function(){try{var a=this.H.getUint8(this.a);this.a+=1;return a}catch(b){me()}};P.prototype.readUint8=P.prototype.$;
P.prototype.Za=function(){try{var a=this.H.getUint16(this.a,this.b);this.a+=2;return a}catch(b){me()}};P.prototype.readUint16=P.prototype.Za;P.prototype.D=function(){try{var a=this.H.getUint32(this.a,this.b);this.a+=4;return a}catch(b){me()}};P.prototype.readUint32=P.prototype.D;P.prototype.Ec=function(){try{var a=this.H.getInt32(this.a,this.b);this.a+=4;return a}catch(b){me()}};P.prototype.readInt32=P.prototype.Ec;
P.prototype.Oa=function(){try{if(this.b){var a=this.H.getUint32(this.a,!0);var b=this.H.getUint32(this.a+4,!0)}else b=this.H.getUint32(this.a,!1),a=this.H.getUint32(this.a+4,!1)}catch(c){me()}if(2097151<b)throw new p(2,3,3001);this.a+=8;return b*Math.pow(2,32)+a};P.prototype.readUint64=P.prototype.Oa;P.prototype.Na=function(a){this.a+a>this.H.byteLength&&me();var b=new Uint8Array(this.H.buffer,this.H.byteOffset+this.a,a);this.a+=a;return new Uint8Array(b)};P.prototype.readBytes=P.prototype.Na;
P.prototype.G=function(a){this.a+a>this.H.byteLength&&me();this.a+=a};P.prototype.skip=P.prototype.G;P.prototype.Ic=function(a){this.a<a&&me();this.a-=a};P.prototype.rewind=P.prototype.Ic;P.prototype.seek=function(a){(0>a||a>this.H.byteLength)&&me();this.a=a};P.prototype.seek=P.prototype.seek;P.prototype.Tb=function(){for(var a=this.a;this.da()&&0!=this.H.getUint8(this.a);)this.a+=1;a=new Uint8Array(this.H.buffer,this.H.byteOffset+a,this.a-a);this.a+=1;return D(a)};
P.prototype.readTerminatedString=P.prototype.Tb;function me(){throw new p(2,3,3E3);};function Q(){this.c=[];this.b=[];this.a=!1}n("shaka.util.Mp4Parser",Q);Q.prototype.B=function(a,b){var c=ne(a);this.c[c]=0;this.b[c]=b;return this};Q.prototype.box=Q.prototype.B;Q.prototype.V=function(a,b){var c=ne(a);this.c[c]=1;this.b[c]=b;return this};Q.prototype.fullBox=Q.prototype.V;Q.prototype.stop=function(){this.a=!0};Q.prototype.stop=Q.prototype.stop;
Q.prototype.parse=function(a,b){var c=new Uint8Array(a);c=new P(new DataView(c.buffer,c.byteOffset,c.byteLength),0);for(this.a=!1;c.da()&&!this.a;)this.ub(0,c,b)};Q.prototype.parse=Q.prototype.parse;
Q.prototype.ub=function(a,b,c){var d=b.U(),e=b.D(),f=b.D();switch(e){case 0:e=b.H.byteLength-d;break;case 1:e=b.Oa()}var g=this.b[f];if(g){var h=null,k=null;1==this.c[f]&&(k=b.D(),h=k>>>24,k&=16777215);f=d+e;c&&f>b.H.byteLength&&(f=b.H.byteLength);f-=b.U();b=0<f?b.Na(f):new Uint8Array(0);b=new P(new DataView(b.buffer,b.byteOffset,b.byteLength),0);g({ja:this,Bc:c||!1,version:h,flags:k,s:b,size:e,start:d+a})}else b.G(d+e-b.U())};Q.prototype.parseNext=Q.prototype.ub;
function R(a){for(;a.s.da()&&!a.ja.a;)a.ja.ub(a.start,a.s,a.Bc)}Q.children=R;function oe(a){for(var b=a.s.D();0<b&&!a.ja.a;--b)a.ja.ub(a.start,a.s,a.Bc)}Q.sampleDescription=oe;function pe(a){return function(b){a(b.s.Na(b.s.H.byteLength-b.s.U()))}}Q.allData=pe;function ne(a){for(var b=0,c=0;c<a.length;c++)b=b<<8|a.charCodeAt(c);return b};function qe(a,b,c,d){var e,f=(new Q).V("sidx",function(a){e=re(b,d,c,a)});a&&f.parse(a);if(e)return e;throw new p(2,3,3004);}
function re(a,b,c,d){var e=[];d.s.G(4);var f=d.s.D();if(0==f)throw new p(2,3,3005);if(0==d.version){var g=d.s.D();var h=d.s.D()}else g=d.s.Oa(),h=d.s.Oa();d.s.G(2);var k=d.s.Za();a=a+d.size+h;for(h=0;h<k;h++){var l=d.s.D(),q=(l&2147483648)>>>31;l&=2147483647;var r=d.s.D();d.s.G(4);if(1==q)throw new p(2,3,3006);e.push(new O(e.length,g/f-b,(g+r)/f-b,function(){return c},a,a+l-1));g+=r;a+=l}d.ja.stop();return e};function S(a){this.a=a}n("shaka.media.SegmentIndex",S);S.prototype.destroy=function(){this.a=null;return Promise.resolve()};S.prototype.destroy=S.prototype.destroy;S.prototype.find=function(a){for(var b=this.a.length-1;0<=b;--b){var c=this.a[b];if(a>=c.startTime&&a<c.endTime)return c.position}return this.a.length&&a<this.a[0].startTime?this.a[0].position:null};S.prototype.find=S.prototype.find;
S.prototype.get=function(a){if(0==this.a.length)return null;a-=this.a[0].position;return 0>a||a>=this.a.length?null:this.a[a]};S.prototype.get=S.prototype.get;S.prototype.offset=function(a){for(var b=0;b<this.a.length;++b)this.a[b].startTime+=a,this.a[b].endTime+=a};S.prototype.offset=S.prototype.offset;
S.prototype.Mb=function(a){for(var b=[],c=0,d=0;c<this.a.length&&d<a.length;){var e=this.a[c],f=a[d];e.startTime<f.startTime?(b.push(e),c++):(e.startTime>f.startTime?0==c&&b.push(f):(.1<Math.abs(e.endTime-f.endTime)?b.push(new O(e.position,f.startTime,f.endTime,f.W,f.K,f.C)):b.push(e),c++),d++)}for(;c<this.a.length;)b.push(this.a[c++]);if(b.length)for(c=b[b.length-1].position+1;d<a.length;)e=a[d++],e=new O(c++,e.startTime,e.endTime,e.W,e.K,e.C),b.push(e);else b=a;this.a=b};S.prototype.merge=S.prototype.Mb;
S.prototype.Cb=function(a){for(var b=0;b<this.a.length;++b)if(this.a[b].endTime>a){this.a.splice(0,b);return}this.a=[]};S.prototype.evict=S.prototype.Cb;function se(a,b){for(;a.a.length;)if(a.a[a.a.length-1].startTime>=b)a.a.pop();else break;for(;a.a.length;)if(0>=a.a[0].endTime)a.a.shift();else break;if(0!=a.a.length){var c=a.a[0];c.startTime<qb&&(a.a[0]=new O(c.position,0,c.endTime,c.W,c.K,c.C));c=a.a[a.a.length-1];a.a[a.a.length-1]=new O(c.position,c.startTime,b,c.W,c.K,c.C)}};function te(a){this.b=a;this.a=new P(a,0);ue||(ue=[new Uint8Array([255]),new Uint8Array([127,255]),new Uint8Array([63,255,255]),new Uint8Array([31,255,255,255]),new Uint8Array([15,255,255,255,255]),new Uint8Array([7,255,255,255,255,255]),new Uint8Array([3,255,255,255,255,255,255]),new Uint8Array([1,255,255,255,255,255,255,255])])}var ue;te.prototype.da=function(){return this.a.da()};
function ve(a){var b=we(a);if(7<b.length)throw new p(2,3,3002);for(var c=0,d=0;d<b.length;d++)c=256*c+b[d];b=c;c=we(a);a:{for(d=0;d<ue.length;d++)if(Ib(c,ue[d])){d=!0;break a}d=!1}if(d)c=a.b.byteLength-a.a.U();else{if(8==c.length&&c[1]&224)throw new p(2,3,3001);d=c[0]&(1<<8-c.length)-1;for(var e=1;e<c.length;e++)d=256*d+c[e];c=d}c=a.a.U()+c<=a.b.byteLength?c:a.b.byteLength-a.a.U();d=new DataView(a.b.buffer,a.b.byteOffset+a.a.U(),c);a.a.G(c);return new xe(b,d)}
function we(a){var b=a.a.$(),c;for(c=1;8>=c&&!(b&1<<8-c);c++);if(8<c)throw new p(2,3,3002);var d=new Uint8Array(c);d[0]=b;for(b=1;b<c;b++)d[b]=a.a.$();return d}function xe(a,b){this.id=a;this.a=b}function ye(a){if(8<a.a.byteLength)throw new p(2,3,3002);if(8==a.a.byteLength&&a.a.getUint8(0)&224)throw new p(2,3,3001);for(var b=0,c=0;c<a.a.byteLength;c++){var d=a.a.getUint8(c);b=256*b+d}return b};function ze(){}
ze.prototype.parse=function(a,b,c,d){var e;b=new te(new DataView(b));if(440786851!=ve(b).id)throw new p(2,3,3008);var f=ve(b);if(408125543!=f.id)throw new p(2,3,3009);b=f.a.byteOffset;f=new te(f.a);for(e=null;f.da();){var g=ve(f);if(357149030==g.id){e=g;break}}if(!e)throw new p(2,3,3010);f=new te(e.a);e=1E6;for(g=null;f.da();){var h=ve(f);if(2807729==h.id)e=ye(h);else if(17545==h.id)if(g=h,4==g.a.byteLength)g=g.a.getFloat32(0);else if(8==g.a.byteLength)g=g.a.getFloat64(0);else throw new p(2,3,3003);
}if(null==g)throw new p(2,3,3011);f=e/1E9;e=g*f;a=ve(new te(new DataView(a)));if(475249515!=a.id)throw new p(2,3,3007);return Ae(a,b,f,e,c,d)};function Ae(a,b,c,d,e,f){function g(){return e}var h=[];a=new te(a.a);for(var k=null,l=null;a.da();){var q=ve(a);if(187==q.id){var r=Be(q);r&&(q=c*r.Te,r=b+r.le,null!=k&&h.push(new O(h.length,k-f,q-f,g,l,r-1)),k=q,l=r)}}null!=k&&h.push(new O(h.length,k-f,d-f,g,l,null));return h}
function Be(a){var b=new te(a.a);a=ve(b);if(179!=a.id)throw new p(2,3,3013);a=ye(a);b=ve(b);if(183!=b.id)throw new p(2,3,3012);b=new te(b.a);for(var c=0;b.da();){var d=ve(b);if(241==d.id){c=ye(d);break}}return{Te:a,le:c}};function Ce(a,b){var c=he(a,b,"Initialization");if(!c)return null;var d=a.w.ba,e=c.getAttribute("sourceURL");e&&(d=C(a.w.ba,[e]));e=0;var f=null;if(c=M(c,"range",Vd))e=c.start,f=c.end;return new N(function(){return d},e,f)}
function De(a,b){var c=Number(ge(a,Ee,"presentationTimeOffset"))||0,d=ge(a,Ee,"timescale"),e=1;d&&(e=Xd(d)||1);c=c/e||0;d=Ce(a,Ee);var f=a.w.contentType;e=a.w.mimeType.split("/")[1];if("text"!=f&&"mp4"!=e&&"webm"!=e)throw new p(2,4,4006);if("webm"==e&&!d)throw new p(2,4,4005);f=he(a,Ee,"RepresentationIndex");var g=ge(a,Ee,"indexRange"),h=a.w.ba;g=Vd(g||"");if(f){var k=f.getAttribute("sourceURL");k&&(h=C(a.w.ba,[k]));g=M(f,"range",Vd,g)}if(!g)throw new p(2,4,4002);e=Fe(a,b,d,h,g.start,g.end,e,c);return{createSegmentIndex:e.createSegmentIndex,
findSegmentPosition:e.findSegmentPosition,getSegmentReference:e.getSegmentReference,initSegmentReference:d,aa:c}}
function Fe(a,b,c,d,e,f,g,h){var k=a.presentationTimeline,l=!a.Da||!a.N.Ib,q=a.N.index,r=a.N.duration,t=b,v=null;return{createSegmentIndex:function(){var a=[t(d,e,f),"webm"==g?t(c.W(),c.K,c.C):null];t=null;return Promise.all(a).then(function(a){var b=a[0];a=a[1]||null;b="mp4"==g?qe(b,e,d,h):(new ze).parse(b,a,d,h);k.Xa(b,0==q);v=new S(b);l&&se(v,r)})},findSegmentPosition:function(a){return v.find(a)},getSegmentReference:function(a){return v.get(a)}}}function Ee(a){return a.$a};function Ge(a,b){var c=Ce(a,He);var d=Ie(a);var e=fe(a,He),f=e.xa;0==f&&(f=1);var g=0;e.P?g=e.P*(f-1):e.I&&0<e.I.length&&(g=e.I[0].start);d={P:e.P,startTime:g,xa:f,aa:e.aa,I:e.I,Ja:d};if(!d.P&&!d.I&&1<d.Ja.length)throw new p(2,4,4002);if(!d.P&&!a.N.duration&&!d.I&&1==d.Ja.length)throw new p(2,4,4002);if(d.I&&0==d.I.length)throw new p(2,4,4002);f=e=null;a.Z.id&&a.w.id&&(f=a.Z.id+","+a.w.id,e=b[f]);g=Je(a.N.duration,d.xa,a.w.ba,d);e?(e.Mb(g),f=a.presentationTimeline.Ha(),e.Cb(f-a.N.start)):(a.presentationTimeline.Xa(g,
0==a.N.index),e=new S(g),f&&a.Da&&(b[f]=e));a.Da&&a.N.Ib||se(e,a.N.duration);return{createSegmentIndex:Promise.resolve.bind(Promise),findSegmentPosition:e.find.bind(e),getSegmentReference:e.get.bind(e),initSegmentReference:c,aa:d.aa}}function He(a){return a.pa}
function Je(a,b,c,d){var e=d.Ja.length;d.I&&d.I.length!=d.Ja.length&&(e=Math.min(d.I.length,d.Ja.length));for(var f=[],g=d.startTime,h=0;h<e;h++){var k=d.Ja[h],l=C(c,[k.yd]),q=void 0;q=null!=d.P?g+d.P:d.I?d.I[h].end:g+a;f.push(new O(h+b,g,q,function(a){return a}.bind(null,l),k.start,k.end));g=q}return f}
function Ie(a){return[a.w.pa,a.T.pa,a.Z.pa].filter(nb).map(function(a){return L(a,"SegmentURL")}).reduce(function(a,c){return 0<a.length?a:c}).map(function(b){b.getAttribute("indexRange")&&!a.oc&&(a.oc=!0);var c=b.getAttribute("media");b=M(b,"mediaRange",Vd,{start:0,end:null});return{yd:c,start:b.start,end:b.end}})};function Ke(a,b,c,d){var e=Le(a);var f=fe(a,Me);var g=ge(a,Me,"media"),h=ge(a,Me,"index");f={P:f.P,timescale:f.timescale,xa:f.xa,aa:f.aa,dc:f.dc,I:f.I,Lb:g,Va:h};g=0+(f.Va?1:0);g+=f.I?1:0;g+=f.P?1:0;if(0==g)throw new p(2,4,4002);1!=g&&(f.Va&&(f.I=null),f.P=null);if(!f.Va&&!f.Lb)throw new p(2,4,4002);if(f.Va){c=a.w.mimeType.split("/")[1];if("mp4"!=c&&"webm"!=c)throw new p(2,4,4006);if("webm"==c&&!e)throw new p(2,4,4005);d=ee(f.Va,a.w.id,null,a.bandwidth||null,null);d=C(a.w.ba,[d]);a=Fe(a,b,e,d,0,null,
c,f.aa)}else f.P?(d||a.presentationTimeline.tb(f.P),a=Ne(a,f)):(d=b=null,a.Z.id&&a.w.id&&(d=a.Z.id+","+a.w.id,b=c[d]),g=Oe(a,f),b?(b.Mb(g),c=a.presentationTimeline.Ha(),b.Cb(c-a.N.start)):(a.presentationTimeline.Xa(g,0==a.N.index),b=new S(g),d&&a.Da&&(c[d]=b)),a.Da&&a.N.Ib||se(b,a.N.duration),a={createSegmentIndex:Promise.resolve.bind(Promise),findSegmentPosition:b.find.bind(b),getSegmentReference:b.get.bind(b)});return{createSegmentIndex:a.createSegmentIndex,findSegmentPosition:a.findSegmentPosition,
getSegmentReference:a.getSegmentReference,initSegmentReference:e,aa:f.aa}}function Me(a){return a.bb}
function Ne(a,b){var c=a.N.duration,d=b.P,e=b.xa,f=b.timescale,g=b.Lb,h=a.bandwidth||null,k=a.w.id,l=a.w.ba;return{createSegmentIndex:Promise.resolve.bind(Promise),findSegmentPosition:function(a){return 0>a||c&&a>=c?null:Math.floor(a/d)},getSegmentReference:function(a){var b=a*d,q=b+d;c&&(q=Math.min(q,c));return 0>q||c&&b>=c?null:new O(a,b,q,function(){var c=ee(g,k,a+e,h,b*f);return C(l,[c])},0,null)}}}
function Oe(a,b){for(var c=[],d=0;d<b.I.length;d++){var e=d+b.xa;c.push(new O(e,b.I[d].start,b.I[d].end,function(a,b,c,d,e,q){a=ee(a,b,e,c,q);return C(d,[a]).map(function(a){return a.toString()})}.bind(null,b.Lb,a.w.id,a.bandwidth||null,a.w.ba,e,b.I[d].Se+b.dc),0,null))}return c}function Le(a){var b=ge(a,Me,"initialization");if(!b)return null;var c=a.w.id,d=a.bandwidth||null,e=a.w.ba;return new N(function(){var a=ee(b,c,null,d,null);return C(e,[a])},0,null)};var Pe={},Qe={};n("shaka.media.ManifestParser.registerParserByExtension",function(a,b){Qe[a]=b});n("shaka.media.ManifestParser.registerParserByMime",function(a,b){Pe[a]=b});function Re(){var a={},b;for(b in Pe)a[b]=!0;for(var c in Qe)a[c]=!0;["application/dash+xml","application/x-mpegurl","application/vnd.apple.mpegurl","application/vnd.ms-sstr+xml"].forEach(function(b){a[b]=!!Pe[b]});["mpd","m3u8","ism"].forEach(function(b){a[b]=!!Qe[b]});return a}
function Se(a,b,c,d){var e=d;e||(d=(new ta(a)).Y.split("/").pop().split("."),1<d.length&&(d=d.pop().toLowerCase(),e=Qe[d]));if(e)return Promise.resolve(e);c=ab([a],c);c.method="HEAD";return b.request(0,c).promise.then(function(b){(b=b.headers["content-type"])&&(b=b.toLowerCase());return(e=Pe[b])?e:Promise.reject(new p(2,4,4E3,a))},function(a){a.severity=2;return Promise.reject(a)})};function T(a,b){this.c=a;this.l=b;this.f=this.a=Infinity;this.b=1;this.j=this.g=0;this.i=!0;this.h=0}n("shaka.media.PresentationTimeline",T);T.prototype.R=function(){return this.a};T.prototype.getDuration=T.prototype.R;T.prototype.ga=function(a){this.a=a};T.prototype.setDuration=T.prototype.ga;T.prototype.nd=function(){return this.c};T.prototype.getPresentationStartTime=T.prototype.nd;T.prototype.Mc=function(a){this.j=a};T.prototype.setClockOffset=T.prototype.Mc;
T.prototype.vb=function(a){this.i=a};T.prototype.setStatic=T.prototype.vb;T.prototype.Zb=function(a){this.f=a};T.prototype.setSegmentAvailabilityDuration=T.prototype.Zb;T.prototype.Nc=function(a){this.l=a};T.prototype.setDelay=T.prototype.Nc;T.prototype.Xa=function(a,b){0!=a.length&&(b&&(this.g=Math.max(this.g,a[0].startTime)),this.b=a.reduce(function(a,b){return Math.max(a,b.endTime-b.startTime)},this.b))};T.prototype.notifySegments=T.prototype.Xa;
T.prototype.tb=function(a){this.b=Math.max(this.b,a)};T.prototype.notifyMaxSegmentDuration=T.prototype.tb;T.prototype.O=function(){return Infinity==this.a&&!this.i};T.prototype.isLive=T.prototype.O;T.prototype.na=function(){return Infinity!=this.a&&!this.i};T.prototype.isInProgress=T.prototype.na;T.prototype.Ha=function(){if(Infinity==this.f)return this.h;var a=this.Ga()-this.f;return Math.max(this.h,a)};T.prototype.getSegmentAvailabilityStart=T.prototype.Ha;T.prototype.Lc=function(a){this.h=a};
T.prototype.setAvailabilityStart=T.prototype.Lc;T.prototype.Ga=function(){return this.O()||this.na()?Math.min(Math.max(0,(Date.now()+this.j)/1E3-this.b-this.c),this.a):this.a};T.prototype.getSegmentAvailabilityEnd=T.prototype.Ga;T.prototype.Ea=function(a){Infinity==this.f&&(a=0);var b=this.Ga();a=Math.min(this.g+a,b);return Math.max(this.Ha(),a)};T.prototype.getSafeSeekRangeStart=T.prototype.Ea;T.prototype.Ta=function(){return this.Ea(0)};T.prototype.getSeekRangeStart=T.prototype.Ta;
T.prototype.Fa=function(){var a=this.O()||this.na()?this.l:0;return Math.max(0,this.Ga()-a)};T.prototype.getSeekRangeEnd=T.prototype.Fa;function Te(){this.a=this.b=null;this.h=[];this.c=null;this.j=[];this.i=1;this.l={};this.m=0;this.g=null;this.f=new Xa}n("shaka.dash.DashParser",Te);m=Te.prototype;m.configure=function(a){this.b=a};m.start=function(a,b){this.h=[a];this.a=b;return Ue(this).then(function(){this.a&&Ve(this,0);return this.c}.bind(this))};m.stop=function(){this.b=this.a=null;this.h=[];this.c=null;this.j=[];this.l={};null!=this.g&&(window.clearTimeout(this.g),this.g=null);return this.f.destroy()};m.update=function(){Ue(this)["catch"](function(a){if(this.a)this.a.onError(a)}.bind(this))};
m.onExpirationUpdated=function(){};function Ue(a){var b=a.a.networkingEngine.request(0,ab(a.h,a.b.retryParameters));Ya(a.f,b);return b.promise.then(function(b){if(a.a)return We(a,b.data,b.uri)})}function We(a,b,c){b=ie(b,"MPD");if(!b)throw new p(2,4,4001,c);b=ke(b,a.b.retryParameters,a.b.dash.xlinkFailGracefully,c,a.a.networkingEngine);Ya(a.f,b);return b.promise.then(function(b){return Xe(a,b,c)})}
function Xe(a,b,c){c=[c];var d=L(b,"Location").map(Sd).filter(nb);0<d.length&&(c=a.h=d);d=L(b,"BaseURL").map(Sd);c=C(c,d);var e=M(b,"minBufferTime",Ud);a.m=M(b,"minimumUpdatePeriod",Ud,-1);var f=M(b,"availabilityStartTime",Td);d=M(b,"timeShiftBufferDepth",Ud);var g=M(b,"suggestedPresentationDelay",Ud),h=M(b,"maxSegmentDuration",Ud),k=b.getAttribute("type")||"static";if(a.c)var l=a.c.presentationTimeline;else{var q=Math.max(a.b.dash.defaultPresentationDelay,1.5*e);l=new T(f,null!=g?g:q)}f=Ye(a,{Da:"static"!=
k,presentationTimeline:l,Z:null,N:null,T:null,w:null,bandwidth:0,oc:!1},c,b);g=f.duration;var r=f.periods;l.vb("static"==k);"static"!=k&&f.ic||l.ga(g||Infinity);l.Zb(null!=d?d:Infinity);l.tb(h||1);if(a.c)return Promise.resolve();b=L(b,"UTCTiming");d=l.O();return $e(a,c,b,d).then(function(a){this.a&&(l.Mc(a),this.c={presentationTimeline:l,periods:r,offlineSessionIds:[],minBufferTime:e||0})}.bind(a))}
function Ye(a,b,c,d){var e=M(d,"mediaPresentationDuration",Ud),f=[],g=0;d=L(d,"Period");for(var h=0;h<d.length;h++){var k=d[h];g=M(k,"start",Ud,g);var l=M(k,"duration",Ud),q=null;if(h!=d.length-1){var r=M(d[h+1],"start",Ud);null!=r&&(q=r-g)}else null!=e&&(q=e-g);null==q&&(q=l);k=af(a,b,c,{start:g,duration:q,node:k,index:h,Ib:null==q||h==d.length-1});f.push(k);l=b.Z.id;-1==a.j.indexOf(l)&&(a.j.push(l),a.c&&(a.a.filterNewPeriod(k),a.c.periods.push(k)));if(null==q){g=null;break}g+=q}null==a.c&&a.a.filterAllPeriods(f);
return null!=e?{periods:f,duration:e,ic:!1}:{periods:f,duration:g,ic:!0}}
function af(a,b,c,d){b.Z=bf(d.node,null,c);b.N=d;b.Z.id||(b.Z.id="__shaka_period_"+d.start);L(d.node,"EventStream").forEach(a.be.bind(a,d.start,d.duration));c=L(d.node,"AdaptationSet").map(a.$d.bind(a,b)).filter(nb);var e=c.map(function(a){return a.oe}).reduce(lb,[]),f=e.filter(ob);if(b.Da&&e.length!=f.length)throw new p(2,4,4018);var g=c.filter(function(a){return!a.cc});c.filter(function(a){return a.cc}).forEach(function(a){var b=a.streams[0],c=a.cc;g.forEach(function(a){a.id==c&&a.streams.forEach(function(a){a.trickModeVideo=
b})})});c=cf(g,"video");e=cf(g,"audio");if(!c.length&&!e.length)throw new p(2,4,4004);e.length||(e=[null]);c.length||(c=[null]);b=[];for(f=0;f<e.length;f++)for(var h=0;h<c.length;h++)df(a,e[f],c[h],b);a=cf(g,"text");c=[];for(e=0;e<a.length;e++)c.push.apply(c,a[e].streams);return{startTime:d.start,textStreams:c,variants:b}}function cf(a,b){return a.filter(function(a){return a.contentType==b})}
function df(a,b,c,d){if(b||c)if(b&&c){var e=b.drmInfos;var f=c.drmInfos;if(e.length&&f.length?0<ac(e,f).length:1){f=ac(b.drmInfos,c.drmInfos);for(var g=0;g<b.streams.length;g++)for(var h=0;h<c.streams.length;h++)e=(c.streams[h].bandwidth||0)+(b.streams[g].bandwidth||0),e={id:a.i++,language:b.language,primary:b.Kb||c.Kb,audio:b.streams[g],video:c.streams[h],bandwidth:e,drmInfos:f,allowedByApplication:!0,allowedByKeySystem:!0},d.push(e)}}else for(f=b||c,g=0;g<f.streams.length;g++)e=f.streams[g].bandwidth||
0,e={id:a.i++,language:f.language||"und",primary:f.Kb,audio:b?f.streams[g]:null,video:c?f.streams[g]:null,bandwidth:e,drmInfos:f.drmInfos,allowedByApplication:!0,allowedByKeySystem:!0},d.push(e)}
m.$d=function(a,b){a.T=bf(b,a.Z,null);var c=!1,d=L(b,"Role"),e=d.map(function(a){return a.getAttribute("value")}).filter(nb),f=void 0;"text"==a.T.contentType&&(f="subtitle");for(var g=0;g<d.length;g++){var h=d[g].getAttribute("schemeIdUri");if(null==h||"urn:mpeg:dash:role:2011"==h)switch(h=d[g].getAttribute("value"),h){case "main":c=!0;break;case "caption":case "subtitle":f=h}}var k=null,l=!1;L(b,"EssentialProperty").forEach(function(a){"http://dashif.org/guidelines/trickmode"==a.getAttribute("schemeIdUri")?
k=a.getAttribute("value"):l=!0});if(l)return null;d=L(b,"ContentProtection");var q=ae(d,this.b.dash.customScheme,this.b.dash.ignoreDrmInfo);d=Pc(b.getAttribute("lang")||"und");h=b.getAttribute("label");g=L(b,"Representation");e=g.map(this.ce.bind(this,a,q,f,d,h,c,e)).filter(function(a){return!!a});if(0==e.length)throw new p(2,4,4003);a.T.contentType&&"application"!=a.T.contentType||(a.T.contentType=ef(e[0].mimeType,e[0].codecs),e.forEach(function(b){b.type=a.T.contentType}));e.forEach(function(a){q.drmInfos.forEach(function(b){a.keyId&&
b.keyIds.push(a.keyId)})});f=g.map(function(a){return a.getAttribute("id")}).filter(nb);return{id:a.T.id||"__fake__"+this.i++,contentType:a.T.contentType,language:d,Kb:c,streams:e,drmInfos:q.drmInfos,cc:k,oe:f}};
m.ce=function(a,b,c,d,e,f,g,h){a.w=bf(h,a.T,null);if(!ff(a.w))return null;a.bandwidth=M(h,"bandwidth",Xd)||0;var k=this.pe.bind(this);if(a.w.$a)k=De(a,k);else if(a.w.pa)k=Ge(a,this.l);else if(a.w.bb)k=Ke(a,k,this.l,!!this.c);else{var l=a.w.ba,q=a.N.duration||0;k={createSegmentIndex:Promise.resolve.bind(Promise),findSegmentPosition:function(a){return 0<=a&&a<q?1:null},getSegmentReference:function(a){return 1!=a?null:new O(1,0,q,function(){return l},0,null)},initSegmentReference:null,aa:0}}h=L(h,"ContentProtection");
h=de(h,this.b.dash.customScheme,b,this.b.dash.ignoreDrmInfo);return{id:this.i++,createSegmentIndex:k.createSegmentIndex,findSegmentPosition:k.findSegmentPosition,getSegmentReference:k.getSegmentReference,initSegmentReference:k.initSegmentReference,presentationTimeOffset:k.aa,mimeType:a.w.mimeType,codecs:a.w.codecs,frameRate:a.w.frameRate,bandwidth:a.bandwidth,width:a.w.width,height:a.w.height,kind:c,encrypted:0<b.drmInfos.length,keyId:h,language:d,label:e,type:a.T.contentType,primary:f,trickModeVideo:null,
containsEmsgBoxes:a.w.containsEmsgBoxes,roles:g,channelsCount:a.w.Ob}};m.Ke=function(){this.g=null;var a=Date.now();Ue(this).then(function(){this.a&&Ve(this,(Date.now()-a)/1E3)}.bind(this))["catch"](function(a){this.a&&(a.severity=1,this.a.onError(a),Ve(this,0))}.bind(this))};function Ve(a,b){0>a.m||(a.g=window.setTimeout(a.Ke.bind(a),1E3*Math.max(Math.max(3,a.m)-b,0)))}
function bf(a,b,c){b=b||{contentType:"",mimeType:"",codecs:"",containsEmsgBoxes:!1,frameRate:void 0,Ob:null};c=c||b.ba;var d=L(a,"BaseURL").map(Sd),e=a.getAttribute("contentType")||b.contentType,f=a.getAttribute("mimeType")||b.mimeType,g=a.getAttribute("codecs")||b.codecs,h=M(a,"frameRate",Zd)||b.frameRate,k=!!L(a,"InbandEventStream").length,l=L(a,"AudioChannelConfiguration");l=gf(l)||b.Ob;e||(e=ef(f,g));return{ba:C(c,d),$a:Rd(a,"SegmentBase")||b.$a,pa:Rd(a,"SegmentList")||b.pa,bb:Rd(a,"SegmentTemplate")||
b.bb,width:M(a,"width",Yd)||b.width,height:M(a,"height",Yd)||b.height,contentType:e,mimeType:f,codecs:g,frameRate:h,containsEmsgBoxes:k||b.containsEmsgBoxes,id:a.getAttribute("id"),Ob:l}}
function gf(a){for(var b=0;b<a.length;++b){var c=a[b],d=c.getAttribute("schemeIdUri");if(d&&(c=c.getAttribute("value")))switch(d){case "urn:mpeg:dash:outputChannelPositionList:2012":return c.trim().split(/ +/).length;case "urn:mpeg:dash:23003:3:audio_channel_configuration:2011":case "urn:dts:dash:audio_channel_configuration:2012":d=parseInt(c,10);if(!d)continue;return d;case "tag:dolby.com,2014:dash:audio_channel_configuration:2011":case "urn:dolby:dash:audio_channel_configuration:2011":if(d=parseInt(c,
16)){for(a=0;d;)d&1&&++a,d>>=1;return a}}}return null}function ff(a){var b=0+(a.$a?1:0);b+=a.pa?1:0;b+=a.bb?1:0;if(0==b)return"text"==a.contentType||"application"==a.contentType?!0:!1;1!=b&&(a.$a&&(a.pa=null),a.bb=null);return!0}
function hf(a,b,c,d){b=C(b,[c]);b=ab(b,a.b.retryParameters);b.method=d;b=a.a.networkingEngine.request(0,b);Ya(a.f,b);return b.promise.then(function(a){if("HEAD"==d){if(!a.headers||!a.headers.date)return 0;a=a.headers.date}else a=D(a.data);a=Date.parse(a);return isNaN(a)?0:a-Date.now()})}
function $e(a,b,c,d){c=c.map(function(a){return{scheme:a.getAttribute("schemeIdUri"),value:a.getAttribute("value")}});var e=a.b.dash.clockSyncUri;d&&!c.length&&e&&c.push({scheme:"urn:mpeg:dash:utc:http-head:2014",value:e});return kb(c,function(a){var c=a.value;switch(a.scheme){case "urn:mpeg:dash:utc:http-head:2014":case "urn:mpeg:dash:utc:http-head:2012":return hf(this,b,c,"HEAD");case "urn:mpeg:dash:utc:http-xsdate:2014":case "urn:mpeg:dash:utc:http-iso:2014":case "urn:mpeg:dash:utc:http-xsdate:2012":case "urn:mpeg:dash:utc:http-iso:2012":return hf(this,
b,c,"GET");case "urn:mpeg:dash:utc:direct:2014":case "urn:mpeg:dash:utc:direct:2012":return a=Date.parse(c),isNaN(a)?0:a-Date.now();case "urn:mpeg:dash:utc:http-ntp:2014":case "urn:mpeg:dash:utc:ntp:2014":case "urn:mpeg:dash:utc:sntp:2014":return Promise.reject();default:return Promise.reject()}}.bind(a))["catch"](function(){return 0})}
m.be=function(a,b,c){var d=c.getAttribute("schemeIdUri")||"",e=c.getAttribute("value")||"",f=M(c,"timescale",Yd)||1;L(c,"Event").forEach(function(c){var g=M(c,"presentationTime",Yd)||0,k=M(c,"duration",Yd)||0;g=g/f+a;k=g+k/f;null!=b&&(g=Math.min(g,a+b),k=Math.min(k,a+b));c={schemeIdUri:d,value:e,startTime:g,endTime:k,id:c.getAttribute("id")||"",eventElement:c};this.a.onTimelineRegionAdded(c)}.bind(this))};
m.pe=function(a,b,c){a=ab(a,this.b.retryParameters);null!=b&&(a.headers.Range="bytes="+b+"-"+(null!=c?c:""));b=this.a.networkingEngine.request(1,a);Ya(this.f,b);return b.promise.then(function(a){return a.data})};function ef(a,b){return F[vb(a,b)]?"text":a.split("/")[0]}Qe.mpd=Te;Pe["application/dash+xml"]=Te;function jf(a,b,c,d){this.uri=a;this.type=b;this.a=c;this.segments=d||null}function kf(a,b,c,d){this.id=a;this.name=b;this.a=c;this.value=d||null}kf.prototype.toString=function(){function a(a){return a.name+'="'+a.value+'"'}return this.value?"#"+this.name+":"+this.value:0<this.a.length?"#"+this.name+":"+this.a.map(a).join(","):"#"+this.name};function lf(a,b){this.name=a;this.value=b}kf.prototype.getAttribute=function(a){var b=this.a.filter(function(b){return b.name==a});return b.length?b[0]:null};
function mf(a,b,c){c=c||null;return(a=a.getAttribute(b))?a.value:c}function nf(a,b){this.a=b;this.uri=a};function of(a,b){return a.filter(function(a){return a.name==b})}function pf(a,b){var c=of(a,b);return c.length?c[0]:null}function qf(a,b,c){return a.filter(function(a){var d=a.getAttribute("TYPE");a=a.getAttribute("GROUP-ID");return d.value==b&&a.value==c})}function rf(a,b){return C([a],[b])[0]};function sf(a){this.b=a;this.a=0}function tf(a){uf(a,/[ \t]+/gm)}function uf(a,b){b.lastIndex=a.a;var c=b.exec(a.b);c=null==c?null:{position:c.index,length:c[0].length,re:c};if(a.a==a.b.length||null==c||c.position!=a.a)return null;a.a+=c.length;return c.re}function vf(a){return a.a==a.b.length?null:(a=uf(a,/[^ \t\n]*/gm))?a[0]:null};function wf(){this.a=0}
function xf(a,b,c){b=D(b);b=b.replace(/\r\n|\r(?=[^\n]|$)/gm,"\n").trim();var d=b.split(/\n+/m);if(!/^#EXTM3U($|[ \t\n])/m.test(d[0]))throw new p(2,4,4015);b=0;for(var e=[],f=1;f<d.length;)if(/^#(?!EXT)/m.test(d[f]))f+=1;else{var g=d[f];g=yf(a.a++,g);if(0<=zf.indexOf(g.name))b=1;else if(0<=Af.indexOf(g.name)){if(1!=b)throw new p(2,4,4017);d=d.splice(f,d.length-f);a=Bf(a,d,e);return new jf(c,b,e,a)}e.push(g);f+=1;"EXT-X-STREAM-INF"==g.name&&(g.a.push(new lf("URI",d[f])),f+=1)}return new jf(c,b,e)}
function Bf(a,b,c){var d=[],e=[];b.forEach(function(a){if(/^(#EXT)/.test(a))a=yf(this.a++,a),0<=zf.indexOf(a.name)?c.push(a):e.push(a);else{if(/^#(?!EXT)/m.test(a))return[];d.push(new nf(a.trim(),e));e=[]}}.bind(a));return d}
function yf(a,b){var c=b.match(/^#(EXT[^:]*)(?::(.*))?$/);if(!c)throw new p(2,4,4016);var d=c[1],e=c[2];c=[];if(e&&0<=e.indexOf("=")){e=new sf(e);for(var f,g=/([^=]+)=(?:"([^"]*)"|([^",]*))(?:,|$)/g;f=uf(e,g);)c.push(new lf(f[1],f[2]||f[3]))}else if(e)return new kf(a,d,c,e);return new kf(a,d,c)}var zf="EXT-X-TARGETDURATION EXT-X-MEDIA-SEQUENCE EXT-X-DISCONTINUITY-SEQUENCE EXT-X-PLAYLIST-TYPE EXT-X-MAP EXT-X-I-FRAMES-ONLY EXT-X-ENDLIST".split(" "),Af="EXTINF EXT-X-BYTERANGE EXT-X-DISCONTINUITY EXT-X-PROGRAM-DATE-TIME EXT-X-KEY EXT-X-DATERANGE".split(" ");function Cf(a){try{var b=Cf.parse(a);return Na({uri:a,data:b.data,headers:{"content-type":b.contentType}})}catch(c){return La(c)}}n("shaka.net.DataUriPlugin",Cf);
Cf.parse=function(a){var b=a.split(":");if(2>b.length||"data"!=b[0])throw new p(2,1,1004,a);b=b.slice(1).join(":").split(",");if(2>b.length)throw new p(2,1,1004,a);var c=b[0];b=window.decodeURIComponent(b.slice(1).join(","));c=c.split(";");var d=null;1<c.length&&(d=c[1]);if("base64"==d)a=Fb(b).buffer;else{if(d)throw new p(2,1,1005,a);a=Ab(b)}return{data:a,contentType:c[0]}};$a("data",Cf);function Df(){this.h=this.c=null;this.L=1;this.v={};this.F={};this.S={};this.a={};this.b=null;this.l="";this.u=new wf;this.j=this.i=null;this.f=Ef;this.m=null;this.g=0;this.A=Infinity;this.o=new Xa}n("shaka.hls.HlsParser",Df);m=Df.prototype;m.configure=function(a){this.h=a};m.start=function(a,b){this.c=b;this.l=a;return Ff(this,a).then(function(b){return Gf(this,b.data,a).then(function(){Hf(this,this.i);return this.m}.bind(this))}.bind(this))};
m.stop=function(){this.h=this.c=null;this.v={};this.F={};this.m=null;return this.o.destroy()};m.update=function(){if(this.f!=If.la){var a=[],b;for(b in this.a)a.push(Jf(this,this.a[b],b));return Promise.all(a)}};
function Jf(a,b,c){Ff(a,c).then(function(a){var d=If,f=xf(this.u,a.data,c);if(1!=f.type)throw new p(2,4,4017);a=pf(f.a,"EXT-X-MEDIA-SEQUENCE");var g=b.stream;Kf(this,f,a?Number(a.value):0,g.mimeType,g.codecs).then(function(a){b.ab.a=a;a=a[a.length-1];pf(f.a,"EXT-X-ENDLIST")&&(Lf(this,d.la),this.b.ga(a.endTime))}.bind(this))}.bind(a))}m.onExpirationUpdated=function(){};
function Gf(a,b,c){b=xf(a.u,b,c);if(0!=b.type)throw new p(2,4,4022);return Mf(a,b).then(function(a){this.c.filterAllPeriods([a]);var b=Infinity,c=0,d=0,h=Infinity;for(l in this.a){var k=this.a[l];b=Math.min(b,k.Nb);c=Math.max(c,k.Nb);d=Math.max(d,k.xd);"text"!=k.stream.type&&(h=Math.min(h,k.duration))}var l=null;k=0;this.f!=If.la&&(l=Date.now()/1E3-d,k=3*this.g);this.b=new T(l,k);this.b.vb(this.f==If.la);this.b.tb(this.g);if(this.f!=If.la){b=3*this.g;this.b.Nc(b);this.i=this.A;this.f==If.ec&&this.b.Zb(b);
for(b=0;95443.7176888889<=c;)b+=95443.7176888889,c-=95443.7176888889;if(b)for(var q in this.a)c=this.a[q],95443.7176888889>c.Nb&&(c.stream.presentationTimeOffset=-b,c.ab.offset(b))}else{this.b.ga(h);for(var r in this.a)q=this.a[r],q.stream.presentationTimeOffset=b,q.ab.offset(-b),se(q.ab,h)}this.m={presentationTimeline:this.b,periods:[a],offlineSessionIds:[],minBufferTime:0}}.bind(a))}
function Mf(a,b){var c=b.a,d=of(b.a,"EXT-X-MEDIA").filter(function(a){return"SUBTITLES"==Nf(a,"TYPE")}.bind(a)).map(function(a){return Of(this,a)}.bind(a));return Promise.all(d).then(function(a){var d=of(c,"EXT-X-STREAM-INF").map(function(a){return Pf(this,a,b)}.bind(this));return Promise.all(d).then(function(b){return{startTime:0,variants:b.reduce(lb,[]),textStreams:a}}.bind(this))}.bind(a))}
function Pf(a,b,c){var d=mf(b,"CODECS","avc1.42E01E,mp4a.40.2").split(","),e=b.getAttribute("RESOLUTION"),f=null,g=null,h=mf(b,"FRAME-RATE"),k=Number(Nf(b,"BANDWIDTH"));if(e){var l=e.value.split("x");f=l[0];g=l[1]}c=of(c.a,"EXT-X-MEDIA");var q=mf(b,"AUDIO"),r=mf(b,"VIDEO");q?c=qf(c,"AUDIO",q):r&&(c=qf(c,"VIDEO",r));if(l=Qf("text",d)){var t=mf(b,"SUBTITLES");t&&(t=qf(c,"SUBTITLES",t),t.length&&(a.v[t[0].id].stream.codecs=l));d.splice(d.indexOf(l),1)}c=c.map(function(a){return Rf(this,a,d)}.bind(a));
var v=[],y=[];return Promise.all(c).then(function(a){q?v=a:r&&(y=a);a=!1;if(v.length||y.length)if(v.length)if(Nf(b,"URI")==v[0].Wb){var c="audio";a=!0}else c="video";else c="audio";else 1==d.length?(c=Qf("video",d),c=e||h||c?"video":"audio"):(c="video",d=[d.join(",")]);return a?Promise.resolve():Sf(this,b,d,c)}.bind(a)).then(function(a){a&&("audio"==a.stream.type?v=[a]:y=[a]);y&&Tf(y);v&&Tf(v);return Wf(this,v,y,k,f,g,h)}.bind(a))}
function Tf(a){a.forEach(function(a){var b=a.stream.codecs.split(",");b=b.filter(function(a){return"mp4a.40.34"!=a});a.stream.codecs=b.join(",")})}
function Wf(a,b,c,d,e,f,g){c.forEach(function(a){if(a=a.stream)a.width=Number(e)||void 0,a.height=Number(f)||void 0,a.frameRate=Number(g)||void 0}.bind(a));b.length||(b=[null]);c.length||(c=[null]);for(var h=[],k=0;k<b.length;k++)for(var l=0;l<c.length;l++){var q=b[k]?b[k].stream:null,r=c[l]?c[l].stream:null,t=b[k]?b[k].drmInfos:null,v=c[l]?c[l].drmInfos:null,y=void 0;if(q&&r)if(t.length&&v.length?0<ac(t,v).length:1)y=ac(t,v);else continue;else q?y=t:r&&(y=v);t=(c[k]?c[k].Wb:"")+" - "+(b[k]?b[k].Wb:
"");a.F[t]||(q=Xf(a,q,r,d,y),h.push(q),a.F[t]=q)}return h}function Xf(a,b,c,d,e){return{id:a.L++,language:b?b.language:"und",primary:!!b&&b.primary||!!c&&c.primary,audio:b,video:c,bandwidth:d,drmInfos:e,allowedByApplication:!0,allowedByKeySystem:!0}}function Of(a,b){Nf(b,"TYPE");return Rf(a,b,[]).then(function(a){return a.stream})}
function Rf(a,b,c){var d=Nf(b,"URI");d=rf(a.l,d);if(a.a[d])return Promise.resolve(a.a[d]);var e=Nf(b,"TYPE").toLowerCase();"subtitles"==e&&(e="text");var f=Pc(mf(b,"LANGUAGE","und")),g=mf(b,"NAME"),h=b.getAttribute("DEFAULT"),k=b.getAttribute("AUTOSELECT"),l=mf(b,"CHANNELS");return Yf(a,d,c,e,f,!!h||!!k,g,"audio"==e?Zf(l):null).then(function(a){if(this.a[d])return this.a[d];this.v[b.id]=a;return this.a[d]=a}.bind(a))}function Zf(a){if(!a)return null;a=a.split("/")[0];return parseInt(a,10)}
function Sf(a,b,c,d){var e=Nf(b,"URI");e=rf(a.l,e);return a.a[e]?Promise.resolve(a.a[e]):Yf(a,e,c,d,"und",!1,null,null).then(function(a){return this.a[e]?this.a[e]:this.a[e]=a}.bind(a))}
function Yf(a,b,c,d,e,f,g,h){var k=b;b=rf(a.l,b);var l,q="",r;return Ff(a,b).then(function(a){l=xf(this.u,a.data,b);if(1!=l.type)throw new p(2,4,4017);a=l;var e=If,f=pf(a.a,"EXT-X-PLAYLIST-TYPE"),g=pf(a.a,"EXT-X-ENDLIST");g=f&&"VOD"==f.value||g;f=f&&"EVENT"==f.value&&!g;f=!g&&!f;g?Lf(this,e.la):(f?Lf(this,e.ec):Lf(this,e.Tc),a=$f(a.a,"EXT-X-TARGETDURATION"),a=Number(a.value),this.g=Math.max(a,this.g),this.A=Math.min(a,this.A));if(1==c.length)q=c[0];else if(a=Qf(d,c),null!=a)q=a;else throw new p(2,
4,4025,c);return ag(this,d,q,l)}.bind(a)).then(function(a){r=a;a=pf(l.a,"EXT-X-MEDIA-SEQUENCE");return Kf(this,l,a?Number(a.value):0,r,q)}.bind(a)).then(function(a){var b=a[0].startTime,c=a[a.length-1].endTime,t=c-b;a=new S(a);var hc=bg(l),Uf=void 0;"text"==d&&(Uf="subtitle");var rd=[];l.segments.forEach(function(a){a=of(a.a,"EXT-X-KEY");rd.push.apply(rd,a)});var sd=!1,td=[],Vf=null;rd.forEach(function(a){if("NONE"!=Nf(a,"METHOD")){sd=!0;var b=Nf(a,"KEYFORMAT");if(a=(b=cg[b])?b(a):null)a.keyIds.length&&
(Vf=a.keyIds[0]),td.push(a)}});if(sd&&!td.length)throw new p(2,4,4026);hc={id:this.L++,createSegmentIndex:Promise.resolve.bind(Promise),findSegmentPosition:a.find.bind(a),getSegmentReference:a.get.bind(a),initSegmentReference:hc,presentationTimeOffset:0,mimeType:r,codecs:q,kind:Uf,encrypted:sd,keyId:Vf,language:e,label:g||null,type:d,primary:f,trickModeVideo:null,containsEmsgBoxes:!1,frameRate:void 0,width:void 0,height:void 0,bandwidth:void 0,roles:[],channelsCount:h};this.S[hc.id]=a;return{stream:hc,
ab:a,drmInfos:td,Wb:k,Nb:b,xd:c,duration:t}}.bind(a))}function bg(a){var b=of(a.a,"EXT-X-MAP");if(!b.length)return null;if(1<b.length)throw new p(2,4,4020);b=b[0];var c=Nf(b,"URI"),d=rf(a.uri,c);a=0;c=null;if(b=mf(b,"BYTERANGE"))a=b.split("@"),b=Number(a[0]),a=Number(a[1]),c=a+b-1;return new N(function(){return[d]},a,c)}
function dg(a,b,c,d,e){var f=c.a,g=rf(a.uri,c.uri);a=$f(f,"EXTINF").value.split(",");a=e+Number(a[0]);c=0;var h=null;if(f=pf(f,"EXT-X-BYTERANGE"))c=f.value.split("@"),f=Number(c[0]),c=c[1]?Number(c[1]):b.C+1,h=c+f-1;return new O(d,e,a,function(){return[g]},c,h)}
function Kf(a,b,c,d,e){var f=b.segments,g=[],h=rf(b.uri,f[0].uri),k=dg(b,null,f[0],c,0),l=bg(b);return eg(a,b.uri,l,k,d,e).then(function(a){h.split("/").pop();for(var d=0;d<f.length;++d){var e=g[g.length-1];e=dg(b,e,f[d],c+d,0==d?a:e.endTime);g.push(e)}return g}.bind(a))}
function fg(a,b){var c=a.c.networkingEngine,d=ab(b.W(),a.h.retryParameters),e={},f=b.K;e.Range="bytes="+f+"-"+(f+2048-1);var g={};if(0!=f||null!=b.C)f="bytes="+f+"-",null!=b.C&&(f+=b.C),g.Range=f;d.headers=e;e=c.request(1,d);Ya(a.o,e);return e.promise["catch"](function(){qa("Unable to fetch a partial HLS segment! Falling back to a full segment request, which is expensive!  Your server should support Range requests and CORS preflights.",d.uris[0]);d.headers=g;return c.request(1,d)})}
function eg(a,b,c,d,e,f){if(a.m&&(b=a.a[b].ab.get(d.position)))return Promise.resolve(b.startTime);d=[fg(a,d)];if("video/mp4"==e||"audio/mp4"==e)c?d.push(fg(a,c)):d.push(d[0]);return Promise.all(d).then(function(a){if("video/mp4"==e||"audio/mp4"==e)return gg(a[0].data,a[1].data);if("audio/mpeg"==e)return 0;if("video/mp2t"==e)return hg(a[0].data);if("application/mp4"==e||0==e.indexOf("text/")){a=a[0].data;var b=vb(e,f);if(F[b]){var c=new zc(null);c.f=new F[b];a=c.Hb(a)}else a=0;return a}throw new p(2,
4,4030);}.bind(a))}function gg(a,b){var c=0;(new Q).B("moov",R).B("trak",R).B("mdia",R).V("mdhd",function(a){a.s.G(0==a.version?8:16);c=a.s.D();a.ja.stop()}).parse(b,!0);if(!c)throw new p(2,4,4030);var d=0,e=!1;(new Q).B("moof",R).B("traf",R).V("tfdt",function(a){d=(0==a.version?a.s.D():a.s.Oa())/c;e=!0;a.ja.stop()}).parse(a,!0);if(!e)throw new p(2,4,4030);return d}
function hg(a){function b(){throw new p(2,4,4030);}a=new P(new DataView(a),0);for(var c=0,d=0;;)if(c=a.U(),d=a.$(),71!=d&&b(),a.Za()&16384||b(),d=(a.$()&48)>>4,0!=d&&2!=d||b(),3==d&&(d=a.$(),a.G(d)),1!=a.D()>>8)a.seek(c+188),d=a.$(),71!=d&&(a.seek(c+192),d=a.$()),71!=d&&(a.seek(c+204),d=a.$()),71!=d&&b(),a.Ic(1);else return a.G(3),c=a.$()>>6,0!=c&&1!=c||b(),0==a.$()&&b(),c=a.$(),d=a.Za(),a=a.Za(),(1073741824*((c&14)>>1)+((d&65534)<<14|(a&65534)>>1))/9E4}
function Qf(a,b){for(var c=ig[a],d=0;d<c.length;d++)for(var e=0;e<b.length;e++)if(c[d].test(b[e].trim()))return b[e].trim();return"text"==a?"":null}
function ag(a,b,c,d){d=rf(d.uri,d.segments[0].uri);var e=(new ta(d)).Y.split(".").pop(),f=jg[b][e];if(f)return Promise.resolve(f);if("text"==b)return c&&"vtt"!=c?Promise.resolve("application/mp4"):Promise.resolve("text/vtt");b=ab([d],a.h.retryParameters);b.method="HEAD";b=a.c.networkingEngine.request(1,b);Ya(a.o,b);return b.promise.then(function(a){a=a.headers["content-type"];if(!a)throw new p(2,4,4021,e);return a.split(";")[0]})}
function Nf(a,b){var c=a.getAttribute(b);if(!c)throw new p(2,4,4023,b);return c.value}function $f(a,b){var c=pf(a,b);if(!c)throw new p(2,4,4024,b);return c}function Ff(a,b){var c=a.c.networkingEngine.request(0,ab([b],a.h.retryParameters));Ya(a.o,c);return c.promise}
var ig={audio:[/^vorbis$/,/^opus$/,/^flac$/,/^mp4a/,/^[ae]c-3$/],video:[/^avc/,/^hev/,/^hvc/,/^vp0?[89]/,/^av1$/],text:[/^vtt$/,/^wvtt/,/^stpp/]},jg={audio:{mp4:"audio/mp4",m4s:"audio/mp4",m4i:"audio/mp4",m4a:"audio/mp4",ts:"video/mp2t"},video:{mp4:"video/mp4",m4s:"video/mp4",m4i:"video/mp4",m4v:"video/mp4",ts:"video/mp2t"},text:{mp4:"application/mp4",m4s:"application/mp4",m4i:"application/mp4",vtt:"text/vtt",ttml:"application/ttml+xml"}};
Df.prototype.M=function(){this.c&&(this.j=null,this.update().then(function(){Hf(this,this.i)}.bind(this))["catch"](function(a){this.c&&(a.severity=1,this.c.onError(a),Hf(this,0))}.bind(this)))};function Hf(a,b){null!=a.i&&null!=b&&(a.j=window.setTimeout(a.M.bind(a),1E3*b))}function Lf(a,b){a.f=b;a.b&&a.b.vb(a.f==If.la);a.f==If.la&&null!=a.j&&(window.clearTimeout(a.j),a.j=null,a.i=null)}
var cg={"urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed":function(a){var b=Nf(a,"METHOD");if("SAMPLE-AES-CENC"!=b&&"SAMPLE-AES-CTR"!=b)return null;b=Nf(a,"URI");b=Cf.parse(b);b=new Uint8Array(b.data);b=pb("com.widevine.alpha",[{initDataType:"cenc",initData:b}]);if(a=mf(a,"KEYID"))b.keyIds=[a.substr(2).toLowerCase()];return b}},Ef="VOD",If={la:Ef,Tc:"EVENT",ec:"LIVE"};Qe.m3u8=Df;Pe["application/x-mpegurl"]=Df;Pe["application/vnd.apple.mpegurl"]=Df;function kg(a,b,c,d){this.a=a;this.u=b;this.o=c;this.v=d;this.h=new z;this.b=null;this.g=!1;this.m=a.readyState;this.c=!1;this.j=this.A=-1;this.f=this.i=!1;b=this.l.bind(this);A(this.h,a,"waiting",b);this.b=new Bb(b);Db(this.b,.25)}kg.prototype.destroy=function(){var a=this.h.destroy();this.v=this.u=this.a=this.h=null;null!=this.b&&(this.b.cancel(),this.b=null);return a};kg.prototype.Ya=function(){this.f=!0;this.l()};
kg.prototype.l=function(){if(0!=this.a.readyState){if(this.a.seeking){if(!this.g)return}else this.g=!1;if(!this.a.paused){this.a.readyState!=this.m&&(this.c=!1,this.m=this.a.readyState);var a=this.o.smallGapLimit,b=this.a.currentTime,c=this.a.buffered;a:{if(c&&c.length&&!(1==c.length&&1E-6>c.end(0)-c.start(0))){var d=.1;/(Edge\/|Trident\/|Tizen)/.test(navigator.userAgent)&&(d=.5);for(var e=0;e<c.length;e++)if(c.start(e)>b&&(0==e||c.end(e-1)-b<=d)){d=e;break a}}d=null}if(null==d){if(c=this.a.currentTime,
b=this.a.buffered,3>this.a.readyState&&0<this.a.playbackRate)if(this.j!=c)this.j=c,this.A=Date.now(),this.i=!1;else if(!this.i&&this.A<Date.now()-1E3)for(d=0;d<b.length;d++)if(c>=b.start(d)&&c<b.end(d)-.5){this.a.currentTime+=.1;this.j=this.a.currentTime;this.i=!0;break}}else if(0!=d||this.f){e=c.start(d);var f=this.u.presentationTimeline.Fa();if(!(e>=f)){f=e-b;a=f<=a;var g=!1;.001>f||(a||this.c||(this.c=!0,b=new B("largegap",{currentTime:b,gapSize:f}),b.cancelable=!0,this.v(b),this.o.jumpLargeGaps&&
!b.defaultPrevented&&(g=!0)),!a&&!g)||(0!=d&&c.end(d-1),this.a.currentTime=e)}}}}};function lg(a,b,c){var d=this;this.a=a;this.j=b;this.i=c;this.b=new z;this.g=1;this.h=!1;this.c=null;this.f=new Bb(this.Ad.bind(this));0<a.readyState?this.wc():(jb(this.b,a,"loadedmetadata",this.wc.bind(this)),A(this.b,a,"timeupdate",function(){Cb(d.f,.1)}));A(this.b,a,"ratechange",this.Od.bind(this))}m=lg.prototype;m.destroy=function(){var a=this.b.destroy();this.b=null;null!=this.c&&(this.c.cancel(),this.c=null);null!=this.f&&(this.f.cancel(),this.f=null);this.j=this.a=null;return a};
function mg(a){return 0<a.a.readyState?a.a.currentTime:a.i}function ng(a,b){0<a.a.readyState?og(a,a.a.currentTime,b):(a.i=b,setTimeout(a.j,0))}m.Sa=function(){return this.g};function pg(a,b){null!=a.c&&(a.c.cancel(),a.c=null);a.g=b;a.a.playbackRate=a.h||0>b?0:b;!a.h&&0>b&&(a.c=new Bb(function(){a.a.currentTime+=b/4}),Db(a.c,.25))}m.Od=function(){var a=this.h||0>this.g?0:this.g;this.a.playbackRate&&this.a.playbackRate!=a&&pg(this,this.a.playbackRate)};
m.wc=function(){this.b.ka(this.a,"timeupdate");this.f.cancel();.001>Math.abs(this.a.currentTime-this.i)?this.xc():(jb(this.b,this.a,"seeking",this.xc.bind(this)),this.a.currentTime=this.i)};m.xc=function(){var a=this;A(this.b,this.a,"seeking",function(){return a.j()})};m.Ad=function(){this.i=this.a.currentTime;this.j()};function og(a,b,c){function d(){!a.a||10<=e++||a.a.currentTime!=b||(a.a.currentTime=c,setTimeout(d,100))}a.a.currentTime=c;var e=0;setTimeout(d,100)};function qg(a,b,c,d,e,f){this.b=a;this.c=b;this.h=c;this.i=e;this.f=null;this.g=new kg(a,b,c,f);b=this.Qd.bind(this);null==d&&(d=this.c.presentationTimeline,d=Infinity>d.R()?d.Ta():d.Fa());d=rg(this,sg(this,d));this.a=new lg(a,b,d);this.f=new Bb(this.Nd.bind(this));Db(this.f,.25)}m=qg.prototype;m.destroy=function(){var a=Promise.all([this.a.destroy(),this.g.destroy()]);this.g=this.a=null;null!=this.f&&(this.f.cancel(),this.f=null);this.i=this.h=this.c=this.b=null;return a};
function tg(a){var b=mg(a.a);0<a.b.readyState&&(a.b.paused||(b=sg(a,b)));return b}m.Sa=function(){return this.a.Sa()};m.Ya=function(){this.g.Ya()};m.Nd=function(){if(0!=this.b.readyState&&!this.b.seeking&&!this.b.paused){var a=this.b.currentTime,b=this.c.presentationTimeline.Ta();a<b&&(a=ug(this,a),this.b.currentTime=a)}};m.Qd=function(){var a=this.g;a.g=!0;a.f=!1;a.c=!1;a=mg(this.a);var b=ug(this,a);.001<Math.abs(b-a)?ng(this.a,b):this.i()};
function rg(a,b){var c=a.c.presentationTimeline.R();return b>=c?c-a.h.durationBackoff:b}function ug(a,b){var c=cc.bind(null,a.b.buffered),d=1*Math.max(a.c.minBufferTime||0,a.h.rebufferingGoal),e=a.c.presentationTimeline,f=e.Ea(0),g=e.Fa(),h=e.R(),k=e.Ea(d),l=e.Ea(5);d=e.Ea(d+5);return b>=h?rg(a,b):b>g?g:b<f?c(l)?l:d:b>=k||c(b)?b:d}function sg(a,b){var c=a.c.presentationTimeline.Ta();if(b<c)return c;c=a.c.presentationTimeline.Fa();return b>c?c:b};function vg(a,b,c,d,e,f,g){this.a=a;this.v=b;this.g=c;this.u=d;this.l=e;this.h=f;this.A=g;this.c=[];this.j=new z;this.b=!1;this.i=-1;this.f=null;wg(this)}vg.prototype.destroy=function(){var a=this.j?this.j.destroy():Promise.resolve();this.j=null;xg(this);this.A=this.h=this.l=this.u=this.g=this.v=this.a=null;this.c=[];return a};
vg.prototype.o=function(a){if(!this.c.some(function(b){return b.info.schemeIdUri==a.schemeIdUri&&b.info.startTime==a.startTime&&b.info.endTime==a.endTime})){var b={info:a,status:1};this.c.push(b);var c=new B("timelineregionadded",{detail:yg(a)});this.h(c);this.m(!0,b)}};function yg(a){var b=Wa(a);b.eventElement=a.eventElement;return b}
vg.prototype.m=function(a,b){var c=b.info.startTime>this.a.currentTime?1:b.info.endTime<this.a.currentTime?3:2,d=2==b.status,e=2==c;if(c!=b.status){if(!a||d||e)d||this.h(new B("timelineregionenter",{detail:yg(b.info)})),e||this.h(new B("timelineregionexit",{detail:yg(b.info)}));b.status=c}};function wg(a){xg(a);a.f=window.setTimeout(a.F.bind(a),250)}function xg(a){a.f&&(window.clearTimeout(a.f),a.f=null)}
vg.prototype.F=function(){this.f=null;wg(this);var a=jd(this.g,this.a.currentTime);a!=this.i&&(-1!=this.i&&this.A(),this.i=a);a=dc(this.a.buffered,this.a.currentTime);var b=bc(this.a.buffered),c=this.g.presentationTimeline,d=c.Ga();b=c.O()&&b>=d;c=this.v;c=c.g?"ended"==c.g.readyState:!0;b=b||this.a.ended||c;this.b?(c=1*Math.max(this.g.minBufferTime||0,this.u.rebufferingGoal),(b||a>=c)&&0!=this.b&&(this.b=!1,this.l(!1))):!b&&.5>a&&1!=this.b&&(this.b=!0,this.l(!0));this.c.forEach(this.m.bind(this,!1))};function zg(a,b){this.a=b;this.b=a;this.h=null;this.i=1;this.m=Promise.resolve();this.g=[];this.j={};this.c={};this.o=!1;this.A=null;this.v=this.f=this.l=!1;this.u=0}m=zg.prototype;m.destroy=function(){for(var a in this.c)Ag(this.c[a]);this.h=this.c=this.j=this.g=this.m=this.b=this.a=null;this.f=!0;return Promise.resolve()};
m.configure=function(a){this.h=a;this.A=new Ha({maxAttempts:Math.max(a.retryParameters.maxAttempts,2),baseDelay:a.retryParameters.baseDelay,backoffFactor:a.retryParameters.backoffFactor,fuzzFactor:a.retryParameters.fuzzFactor,timeout:0},!0)};m.init=function(){var a=tg(this.a.La);a=this.a.rc(this.b.periods[jd(this.b,a)]);return a.variant||a.text?Bg(this,a).then(function(){!this.f&&this.a&&this.a.Ed&&this.a.Ed()}.bind(this)):Promise.reject(new p(2,5,5005))};
function U(a){var b=tg(a.a.La);return a.b.periods[jd(a.b,b)]}function Cg(a){var b=a.c.video||a.c.audio;return b?a.b.periods[b.va]:null}function Dg(a){return Eg(a,"audio")}function Fg(a){return Eg(a,"video")}function Eg(a,b){var c=a.c[b];return c?c.oa||c.stream:null}function Gg(a,b){Ic(a.a.J,"text");a.u++;a.v=!1;var c=a.u;return a.a.J.init({text:b}).then(function(){return Hg(a,[b])}).then(function(){if(!a.f&&a.u==c&&!a.c.text&&!a.v){var d=tg(a.a.La);a.c.text=Ig(b,jd(a.b,d));Jg(a,a.c.text,0)}})}
function Kg(a){a.v=!0;a.c.text&&(Ag(a.c.text),delete a.c.text)}function Lg(a,b){var c=a.c.video;if(c){var d=c.stream;if(d)if(b){var e=d.trickModeVideo;e&&!c.oa&&(Mg(a,e,!1),c.oa=d)}else if(d=c.oa)c.oa=null,Mg(a,d,!0)}}function Ng(a,b,c){b.video&&Mg(a,b.video,c);b.audio&&Mg(a,b.audio,c)}
function Mg(a,b,c){var d=a.c[b.type];if(!d&&"text"==b.type&&a.h.ignoreTextStreamFailures)Gg(a,b);else if(d){var e=kd(a.b,b);c&&e!=d.va?Og(a):(d.oa&&(b.trickModeVideo?(d.oa=b,b=b.trickModeVideo):d.oa=null),(e=a.g[e])&&e.Pa&&(e=a.j[b.id])&&e.Pa&&d.stream!=b&&("text"==b.type&&Dc(a.a.J,vb(b.mimeType,b.codecs)),d.stream=b,d.sb=!0,c&&(d.ta?d.xb=!0:d.wa?(d.sa=!0,d.xb=!0):(Ag(d),Pg(a,d,!0)))))}}
function Qg(a){var b=tg(a.a.La);Object.keys(a.c).every(function(a){var c=this.a.J;"text"==a?(a=c.a,a=b>=a.a&&b<a.b):(a=Fc(c,a),a=cc(a,b));return a}.bind(a))||Og(a)}function Og(a){for(var b in a.c){var c=a.c[b];c.ta||c.sa||(c.wa?c.sa=!0:null==Ec(a.a.J,b)?null==c.ra&&Jg(a,c,0):(Ag(c),Pg(a,c,!1)))}}
function Bg(a,b,c){var d=tg(a.a.La),e=jd(a.b,d),f={},g=[];b.variant&&b.variant.audio&&(f.audio=b.variant.audio,g.push(b.variant.audio));b.variant&&b.variant.video&&(f.video=b.variant.video,g.push(b.variant.video));b.text&&(f.text=b.text,g.push(b.text));return a.a.J.init(f).then(function(){if(!a.f){var b=a.b.presentationTimeline.R();Infinity>b?a.a.J.ga(b):a.a.J.ga(Math.pow(2,32));return Hg(a,g)}}).then(function(){if(!a.f)for(var b in f){var d=f[b];a.c[b]||(a.c[b]=Ig(d,e,c),Jg(a,a.c[b],0))}})}
function Ig(a,b,c){return{stream:a,type:a.type,Ia:null,ia:null,oa:null,sb:!0,va:b,endOfStream:!1,wa:!1,ra:null,sa:!1,xb:!1,ta:!1,Vb:!1,Ua:!1,Gc:c||0}}
function Rg(a,b){var c=a.g[b];if(c)return c.promise;c={promise:new u,Pa:!1};a.g[b]=c;var d=a.b.periods[b].variants.map(function(a){var b=[];a.audio&&b.push(a.audio);a.video&&b.push(a.video);a.video&&a.video.trickModeVideo&&b.push(a.video.trickModeVideo);return b}).reduce(lb,[]).filter(ob);d.push.apply(d,a.b.periods[b].textStreams);a.m=a.m.then(function(){if(!this.f)return Hg(this,d)}.bind(a)).then(function(){this.f||(this.g[b].promise.resolve(),this.g[b].Pa=!0)}.bind(a))["catch"](function(a){this.f||
(this.g[b].promise.reject(),delete this.g[b],this.a.onError(a))}.bind(a));return c.promise}
function Hg(a,b){b.map(function(a){return a.id}).filter(ob);for(var c=[],d=0;d<b.length;++d){var e=b[d],f=a.j[e.id];f?c.push(f.promise):(a.j[e.id]={promise:new u,Pa:!1},c.push(e.createSegmentIndex()))}return Promise.all(c).then(function(){if(!this.f)for(var a=0;a<b.length;++a){var c=this.j[b[a].id];c.Pa||(c.promise.resolve(),c.Pa=!0)}}.bind(a))["catch"](function(a){if(!this.f){for(var c=0;c<b.length;c++)this.j[b[c].id].promise.reject(),delete this.j[b[c].id];return Promise.reject(a)}}.bind(a))}
m.Me=function(a){if(!this.f&&!a.wa&&null!=a.ra&&!a.ta)if(a.ra=null,a.sa)Pg(this,a,a.xb);else{try{var b=Sg(this,a);null!=b&&(Jg(this,a,b),a.Ua=!1)}catch(c){Tg(this,c);return}b=sb(this.c);Ug(this,a);b.every(function(a){return a.endOfStream})&&this.a.J.endOfStream().then(function(){if(!this.f){var a=this.a.J.R();a<this.b.presentationTimeline.R()&&this.b.presentationTimeline.ga(a)}}.bind(this))}};
function Sg(a,b){var c=tg(a.a.La),d=b.Ia&&b.ia?a.b.periods[kd(a.b,b.Ia)].startTime+b.ia.endTime:Math.max(c,b.Gc),e=kd(a.b,b.stream),f=jd(a.b,d);var g=a.a.J;var h=b.type;"text"==h?(g=g.a,g=null==g.b||g.b<c?0:g.b-Math.max(c,g.a)):(g=Fc(g,h),g=dc(g,c));h=Math.max(a.i*Math.max(a.b.minBufferTime||0,a.h.rebufferingGoal),a.i*a.h.bufferingGoal);if(d>=a.b.presentationTimeline.R())return b.endOfStream=!0,null;b.endOfStream=!1;b.va=f;if(f!=e)return null;if(g>=h)return.5;d=a.a.J;f=b.type;d="text"==f?d.a.b:bc(Fc(d,
f));b.ia&&b.stream==b.Ia?d=Vg(a,b,e,b.ia.position+1):(f=b.ia?b.stream.findSegmentPosition(Math.max(0,a.b.periods[kd(a.b,b.Ia)].startTime+b.ia.endTime-a.b.periods[e].startTime)):b.stream.findSegmentPosition(Math.max(0,(d||c)-a.b.periods[e].startTime)),null==f?d=null:(g=null,null==d&&(g=Vg(a,b,e,Math.max(0,f-1))),d=g||Vg(a,b,e,f)));if(!d)return 1;b.Gc=0;Wg(a,b,c,e,d);return null}
function Vg(a,b,c,d){c=a.b.periods[c];b=b.stream.getSegmentReference(d);if(!b)return null;d=a.b.presentationTimeline;a=d.Ha();d=d.Ga();return c.startTime+b.endTime<a||c.startTime+b.startTime>d?null:b}
function Wg(a,b,c,d,e){var f=a.b.periods[d],g=b.stream,h=a.b.presentationTimeline.R(),k=a.b.periods[d+1];d=Xg(a,b,d,Math.max(0,f.startTime-.1),k?k.startTime:h);b.wa=!0;b.sb=!1;h=Yg(a,e);Promise.all([d,h]).then(function(a){if(!this.f&&!this.l)return Zg(this,b,c,f,g,e,a[1])}.bind(a)).then(function(){this.f||this.l||(b.wa=!1,b.Vb=!1,b.sa||this.a.Ya(),Jg(this,b,0),$g(this,g))}.bind(a))["catch"](function(a){this.f||this.l||(b.wa=!1,"text"==b.type&&this.h.ignoreTextStreamFailures?delete this.c.text:3017==
a.code?ah(this,b,a):(b.Ua=!0,a.severity=2,Tg(this,a)))}.bind(a))}function ah(a,b,c){if(!sb(a.c).some(function(a){return a!=b&&a.Vb})){var d=Math.round(100*a.i);if(20<d)a.i-=.2;else if(4<d)a.i-=.04;else{b.Ua=!0;a.l=!0;a.a.onError(c);return}b.Vb=!0}Jg(a,b,4)}
function Xg(a,b,c,d,e){if(!b.sb)return Promise.resolve();c=Jc(a.a.J,b.type,a.b.periods[c].startTime-b.stream.presentationTimeOffset,d,e);if(!b.stream.initSegmentReference)return c;a=Yg(a,b.stream.initSegmentReference).then(function(a){if(!this.f)return Gc(this.a.J,b.type,a,null,null)}.bind(a))["catch"](function(a){b.sb=!0;return Promise.reject(a)});return Promise.all([c,a])}
function Zg(a,b,c,d,e,f,g){e.containsEmsgBoxes&&(new Q).V("emsg",a.ae.bind(a,d,f)).parse(g);return bh(a,b,c).then(function(){if(!this.f)return Gc(this.a.J,b.type,g,f.startTime,f.endTime)}.bind(a)).then(function(){if(!this.f)return b.Ia=e,b.ia=f,Promise.resolve()}.bind(a))}
m.ae=function(a,b,c){var d=c.s.Tb(),e=c.s.Tb(),f=c.s.D(),g=c.s.D(),h=c.s.D(),k=c.s.D(),l=c.s.Na(c.s.H.byteLength-c.s.U());a=a.startTime+b.startTime+g/f;if("urn:mpeg:dash:event:2012"==d)this.a.Gd();else this.a.onEvent(new B("emsg",{detail:{startTime:a,endTime:a+h/f,schemeIdUri:d,value:e,timescale:f,presentationTimeDelta:g,eventDuration:h,id:k,messageData:l}}));c.ja.stop()};
function bh(a,b,c){var d=Math.max(a.h.bufferBehind,a.b.presentationTimeline.b),e=Ec(a.a.J,b.type);if(null==e)return Promise.resolve();c=c-e-d;return 0>=c?Promise.resolve():a.a.J.remove(b.type,e,e+c).then(function(){}.bind(a))}function $g(a,b){if(!a.o&&(a.o=sb(a.c).every(function(a){return"text"==a.type?!0:!a.sa&&!a.ta&&a.ia}),a.o)){var c=kd(a.b,b);a.g[c]||Rg(a,c).then(function(){this.f||this.a.qc()}.bind(a))["catch"](mb);for(c=0;c<a.b.periods.length;++c)Rg(a,c)["catch"](mb);a.a.Td&&a.a.Td()}}
function Ug(a,b){if(b.va!=kd(a.b,b.stream)){var c=b.va,d=sb(a.c);d.every(function(a){return a.va==c})&&d.every(ch)&&Rg(a,c).then(function(){if(!this.f&&d.every(function(a){var b=kd(this.b,a.stream);return ch(a)&&a.va==c&&b!=c}.bind(this))){var a=this.b.periods[c],b=this.a.rc(a),g={};b.variant&&b.variant.video&&(g.video=b.variant.video);b.variant&&b.variant.audio&&(g.audio=b.variant.audio);b.text&&(g.text=b.text);for(var h in this.c)if(!g[h]&&"text"!=h){this.a.onError(new p(2,5,5005));return}for(var k in g)if(!this.c[k])if("text"==
k)Bg(this,{text:g.text},a.startTime),delete g[k];else{this.a.onError(new p(2,5,5005));return}for(var l in this.c)(a=g[l])?(Mg(this,a,!1),Jg(this,this.c[l],0)):delete this.c[l];this.a.qc()}}.bind(a))["catch"](mb)}}function ch(a){return!a.wa&&null==a.ra&&!a.sa&&!a.ta}function Yg(a,b){var c=ab(b.W(),a.h.retryParameters);if(0!=b.K||null!=b.C){var d="bytes="+b.K+"-";null!=b.C&&(d+=b.C);c.headers.Range=d}return a.a.Wa.request(1,c).promise.then(function(a){return a.data})}
function Pg(a,b,c){b.sa=!1;b.xb=!1;b.ta=!0;Ic(a.a.J,b.type).then(function(){if(!this.f&&c){var a=this.a.J,e=b.type;return"text"==e?Promise.resolve():Hc(a,e,a.ed.bind(a,e))}}.bind(a)).then(function(){this.f||(b.Ia=null,b.ia=null,b.ta=!1,b.endOfStream=!1,Jg(this,b,0))}.bind(a))}function Jg(a,b,c){b.ra=window.setTimeout(a.Me.bind(a,b),1E3*c)}function Ag(a){null!=a.ra&&(window.clearTimeout(a.ra),a.ra=null)}
function Tg(a,b){Ja(a.A).then(function(){this.f||(this.a.onError(b),b.handled||this.h.failureCallback(b))}.bind(a))};function dh(a,b,c,d,e,f){if(200<=c&&299>=c&&202!=c)return e&&(d=e),{uri:d,data:b,headers:a,fromCache:!!a["x-shaka-from-cache"]};e=null;try{e=zb(b)}catch(g){}throw new p(401==c||403==c?2:1,1,1001,d,c,e,a,f);};function V(a,b,c){var d=new V.b;ub(b.headers,function(a,b){d.append(a,b)});var e=new V.a,f={body:b.body||void 0,headers:d,method:b.method,signal:e.signal,credentials:b.allowCrossSiteCredentials?"include":void 0},g=!1,h=!1,k;b.retryParameters.timeout&&(k=setTimeout(function(){h=!0;e.abort()},b.retryParameters.timeout));b=V.c;f=b(a,f).then(function(b){clearTimeout(k);return b.arrayBuffer().then(function(d){var e={};b.headers.forEach(function(a,b){e[b.trim()]=a});return dh(e,d,b.status,a,b.url,c)})})["catch"](function(b){clearTimeout(k);
return g?Promise.reject(new p(1,1,7001,a,c)):h?Promise.reject(new p(1,1,1003,a,c)):void 0==b.severity?Promise.reject(new p(1,1,1002,a,b,c)):Promise.reject(b)});return new Ka(f,function(){g=!0;e.abort();return Promise.resolve()})}n("shaka.net.HttpFetchPlugin",V);V.isSupported=function(){return!(!window.fetch||!window.AbortController)};V.isSupported=V.isSupported;V.c=window.fetch;V.a=window.AbortController;V.b=window.Headers;V.isSupported()&&($a("http",V,2),$a("https",V,2));function eh(a,b,c){var d=new eh.f,e=new Promise(function(e,g){d.open(b.method,a,!0);d.responseType="arraybuffer";d.timeout=b.retryParameters.timeout;d.withCredentials=b.allowCrossSiteCredentials;d.onabort=function(){g(new p(1,1,7001,a,c))};d.onload=function(b){b=b.target;var d=b.getAllResponseHeaders().trim().split("\r\n").reduce(function(a,b){var c=b.split(": ");a[c[0].toLowerCase()]=c.slice(1).join(": ");return a},{});try{var f=dh(d,b.response,b.status,a,b.responseURL,c);e(f)}catch(r){g(r)}};d.onerror=
function(b){g(new p(1,1,1002,a,b,c))};d.ontimeout=function(){g(new p(1,1,1003,a,c))};for(var f in b.headers)d.setRequestHeader(f.toLowerCase(),b.headers[f]);d.send(b.body)});return new Ka(e,function(){d.abort();return Promise.resolve()})}n("shaka.net.HttpXHRPlugin",eh);eh.f=window.XMLHttpRequest;$a("http",eh,1);$a("https",eh,1);function fh(){this.b=null;this.a=[]}function gh(){if(!window.indexedDB)return Promise.resolve();var a=window.indexedDB.deleteDatabase("shaka_offline_db"),b=new u;a.onsuccess=function(){b.resolve()};a.onerror=hh.bind(null,a,b);return b}fh.prototype.init=function(a){var b=this;return ih(a).then(function(a){b.b=a})};
fh.prototype.destroy=function(){var a=this;return Promise.all(this.a.map(function(a){try{a.transaction.abort()}catch(c){}return a.promise["catch"](function(){})})).then(function(){a.b&&(a.b.close(),a.b=null)})};fh.prototype.ma=function(a){return jh(this,"manifest-v3",a)};function kh(a,b){return lh(a,b)}function mh(a,b,c){return nh(a,"segment-v3",b.filter(function(a){return null!=a}),c)}function jh(a,b,c){var d;return oh(a,b,"readonly",function(a){d=a.get(c)}).then(function(){return d.result})}
function lh(a,b){return oh(a,"manifest-v3","readonly",function(a){a.openCursor().onsuccess=function(a){if(a=a.target.result)b(a.key,a.value),a["continue"]()}})}function ph(a,b,c){return oh(a,"manifest-v3","readwrite",function(a){a.put(c,b)})}function qh(a,b,c){var d;return oh(a,b,"readwrite",function(a){a.add(c).onsuccess=function(a){d=a.target.result}}).then(function(){return d})}
function nh(a,b,c,d){return oh(a,b,"readwrite",function(a){c.forEach(function(b){a["delete"](b).onsuccess=function(){d&&d(b)}})})}function oh(a,b,c,d){var e={transaction:a.b.transaction([b],c),promise:new u};e.transaction.oncomplete=function(){a.a.splice(a.a.indexOf(e),1);e.promise.resolve()};e.transaction.onabort=function(b){a.a.splice(a.a.indexOf(e),1);hh(e.transaction,e.promise,b)};e.transaction.onerror=rh();b=e.transaction.objectStore(b);d(b);a.a.push(e);return e.promise}
function sh(a,b,c){function d(){var b=f.pop();b?e(b,d):(a.reject(new p(1,9,9010,g)),c.abort())}function e(a,b){c.objectStore(a).openCursor().onsuccess=function(a){(a=a.target.result)?(g.push(a.value.originalManifestUri),a["continue"]()):b()}}var f=["manifest","manifest-v2"].filter(function(a){return b.objectStoreNames.contains(a)}),g=[];d()}function hh(a,b,c){b.reject(a.error?new p(2,9,9001,a.error):new p(2,9,7001));c.preventDefault()}
function ih(a){function b(){return new Promise(function(a){return setTimeout(a,1E3)})}var c=a||0,d=0<c;a=th(d);for(var e=0;e<c;e++)a=a.then(function(a){return a?a:b().then(function(){return th(d)})});return a.then(function(a){return a?a:Promise.reject(new p(2,9,9001,"Failed to issue upgrade after "+c+" retries"))})}
function th(a){var b=new u,c=!1,d=window.indexedDB.open("shaka_offline_db",3);d.onupgradeneeded=function(a){var d=a.target.transaction,e=d.db,h={autoIncrement:!0};0==a.oldVersion?(e.createObjectStore("manifest-v3",h),e.createObjectStore("segment-v3",h)):sh(b,e,d);c=!0};d.onsuccess=function(d){d=d.target.result;a&&!c?(d.close(),b.resolve(null)):b.resolve(d)};d.onerror=rh(function(){b.reject(new p(2,9,9001,"Failed to open IndexedDB Connection",d.error.message))});return b}
function rh(a){return function(b){b.preventDefault();a&&a(b)}};function uh(a,b,c){this.b={};this.i=[];this.g=a;this.j=b;this.m=c;this.h=this.a=null;this.c=this.f=0;this.l=[];this.u=null}function vh(a,b){a.l.push(b)}uh.prototype.destroy=function(){var a=this.g,b=this.i,c=this.h||Promise.resolve();b.length&&(c=c.then(function(){return mh(a,b,null)}));this.b={};this.i=[];this.h=this.a=this.m=this.j=this.g=null;return c};function wh(a,b,c,d,e){a.b[b]=a.b[b]||[];a.b[b].push({uris:c.uris&&0<c.uris.length?c.uris:c.W(),K:c.K,C:c.C,Ca:d||c.Ca||0,Ac:e})}
function xh(a,b,c){a.f=b.size||0;a.c=b.size||0;sb(a.b).forEach(function(a){a.forEach(this.o.bind(this))}.bind(a));a.a=b;var d=sb(a.b).map(function(a){var b=0,d=function(){if(!this.a)return Promise.reject(new p(2,9,7001));if(b>=a.length)return Promise.resolve();var e=a[b++];return yh(this,e,c,this.a).then(d)}.bind(this);return d()}.bind(a));c&&(a.b={});a.h=Promise.all(d).then(function(){return null==c||"undefined"==typeof c?Promise.reject(new p(2,9,9004,c)):ph(this.g,c,b)}.bind(a)).then(function(a){this.i=
[];return a}.bind(a));return a.h}
function yh(a,b,c,d){if(null!=b.dataKey&&"undefined"!=typeof b.dataKey)return b.Ac(b.dataKey||null),Promise.resolve();if("paused"==a.a.downloadStatus)return Promise.resolve();var e=ab(b.uris,a.m);if(0!=b.K||null!=b.C)e.headers.Range="bytes="+b.K+"-"+(null==b.C?"":b.C);var f;return a.j.request(1,e).promise.then(function(a){if(!this.a)return Promise.reject(new p(2,9,7001));f=a.data.byteLength;return qh(this.g,"segment-v3",{data:a.data})}.bind(a)).then(function(a){if(!this.a)return Promise.reject(new p(2,9,
7001));this.a.size+=f;this.c+=null==b.C?b.Ca:b.C-b.K+1;this.i.push(a);b.Ac(a);null!=c&&null!=d&&ph(this.g,c,this.a);zh(this)}.bind(a))}uh.prototype.pause=function(){this.a.ef=this.c;this.a.downloadStatus="paused"};uh.prototype.o=function(a){this.f+=null==a.C?a.Ca:a.C-a.K+1};function zh(a){var b=0==a.f?0:a.c/a.f,c=a.a.size;a.l.forEach(function(a){a(b,c)})};function Ah(a){return(a=/^offline:manifest\/([0-9]+)$/.exec(a))?Number(a[1]):null};function Bh(a,b,c){var d=void 0==b.expiration?Infinity:b.expiration,e=b.presentationTimeline.R();b=Xc(b.periods[0]);return{offlineUri:null,originalManifestUri:a,duration:e,size:0,expiration:d,tracks:b,appMetadata:c,downloadStatus:null}}function Ch(a,b){var c=Dh(b.periods[0],[],new T(null,0)),d=b.appMetadata||{};c=Xc(c);return{offlineUri:a,originalManifestUri:b.originalManifestUri,duration:b.duration,size:b.size,expiration:b.expiration,tracks:c,appMetadata:d,downloadStatus:null}}
function Dh(a,b,c){var d=a.streams.filter(Eh),e=a.streams.filter(Fh);b=Gh(d,e,b);d=a.streams.filter(Hh).map(Ih);a.streams.forEach(function(a,b){var d=a.segments.map(function(a,b){return Jh(b,a)});c.Xa(d,0==b)});return{startTime:a.startTime,variants:b,textStreams:d}}function Jh(a,b){var c="offline:segment/"+b.dataKey;return new O(a,b.startTime,b.endTime,function(){return[c]},0,null)}
function Gh(a,b,c){var d={},e=[];e.push.apply(e,a);e.push.apply(e,b);e.forEach(function(a){a.variantIds.forEach(function(a){d[a]||(d[a]={id:a,language:"",primary:!1,audio:null,video:null,bandwidth:0,drmInfos:c,allowedByApplication:!0,allowedByKeySystem:!0})})});a.forEach(function(a){var b=Ih(a);a.variantIds.forEach(function(a){a=d[a];a.language=b.language;a.primary=a.primary||b.primary;a.audio=b})});b.forEach(function(a){var b=Ih(a);a.variantIds.forEach(function(a){a=d[a];a.primary=a.primary||b.primary;
a.video=b})});return sb(d)}
function Ih(a){var b=a.segments.map(function(a,b){return Jh(b,a)});b=new S(b);b={id:a.id,createSegmentIndex:Promise.resolve.bind(Promise),findSegmentPosition:b.find.bind(b),getSegmentReference:b.get.bind(b),initSegmentReference:null,presentationTimeOffset:a.presentationTimeOffset,mimeType:a.mimeType,codecs:a.codecs,width:a.width||void 0,height:a.height||void 0,frameRate:a.frameRate||void 0,kind:a.kind,encrypted:a.encrypted,keyId:a.keyId,language:a.language,label:a.label||null,type:a.contentType,primary:a.primary,
trickModeVideo:null,containsEmsgBoxes:!1,roles:[],channelsCount:null};null!=a.initSegmentKey&&(b.initSegmentReference=Kh(a.initSegmentKey));return b}function Kh(a){var b="offline:segment/"+a;return new N(function(){return[b]},0,null)}function Eh(a){return"audio"==a.contentType}function Fh(a){return"video"==a.contentType}function Hh(a){return"text"==a.contentType}
function Lh(a,b){var c=b[0].streams;a[0].streams.forEach(function(a){var b=a.id,d=c.filter(function(a){return a.id==b});a.segments=d[0].segments})};function Mh(){return Nh().then(function(){var a=new fh;return a.init().then(function(){return a})})}function Oh(){return Nh().then(function(){return gh()})}function Nh(){return null!=window.indexedDB?Promise.resolve():Promise.reject(new p(2,9,9E3))};function Ph(){this.a=-1}m=Ph.prototype;m.configure=function(){};m.start=function(a){var b=Ah(a);if(null==b)return Promise.reject(new p(2,1,9004,a));this.a=b;var c;return Mh().then(function(a){c=a;return c.ma(b)}.bind(this)).then(function(a){if(!a)throw new p(2,9,9003,b);return Qh(a)}).then(function(a){return c.destroy().then(function(){return a})},function(a){return c.destroy().then(function(){throw a;})})};m.stop=function(){return Promise.resolve()};m.update=function(){};
m.onExpirationUpdated=function(a,b){var c=this.a,d;Mh().then(function(a){d=a;return d.ma(c)}).then(function(e){if(e&&!(0>e.sessionIds.indexOf(a))&&(void 0==e.expiration||e.expiration>b))return e.expiration=b,ph(d,c,e)})["catch"](function(){}).then(function(){return d.destroy()})};
function Qh(a){var b=new T(null,0);b.ga(a.duration);var c=a.drmInfo?[a.drmInfo]:[];return{presentationTimeline:b,minBufferTime:2,offlineSessionIds:a.sessionIds,Rc:a.periods,periods:a.periods.map(function(a){return Dh(a,c,b)})}}Pe["application/x-offline-manifest"]=Ph;function Rh(a){if(null!=Ah(a))return Rh.a(a);var b=(b=/^offline:segment\/([0-9]+)$/.exec(a))?Number(b[1]):null;return null!=b?Rh.b(b,a):La(new p(2,1,9004,a))}n("shaka.offline.OfflineScheme",Rh);Rh.a=function(a){a={uri:a,data:new ArrayBuffer(0),headers:{"content-type":"application/x-offline-manifest"}};return Na(a)};
Rh.b=function(a,b){var c,d,e=Mh().then(function(b){c=b;return jh(c,"segment-v3",a)}).then(function(a){d=a;return c.destroy()}).then(function(){if(!d)throw new p(2,9,9003,a);return{uri:b,data:d.data,headers:{}}});return Oa(e)};$a("offline",Rh);function W(a){this.a=null;this.b=a;for(var b=0;b<a.textTracks.length;++b){var c=a.textTracks[b];c.mode="disabled";"Shaka Player TextTrack"==c.label&&(this.a=c)}this.a||(this.a=a.addTextTrack("subtitles","Shaka Player TextTrack"));this.a.mode="hidden";this.c=this.a.cues}n("shaka.text.SimpleTextDisplayer",W);W.prototype.remove=function(a,b){if(!this.a)return!1;Sh(this,function(c){return c.startTime>=b||c.endTime<=a?!1:!0});return!0};W.prototype.remove=W.prototype.remove;
W.prototype.append=function(a){var b=[];if(window.VTTRegion){var c=a.map(function(a){return a.region});c=c.filter(ob);for(var d=0;d<c.length;d++){var e=Th(this,c[d]);b.push(e)}}var f=[];for(c=0;c<a.length;c++)(d=Uh(a[c],b))&&f.push(d);f.slice().sort(function(a,b){return a.startTime!=b.startTime?a.startTime-b.startTime:a.endTime!=b.endTime?a.endTime-b.startTime:f.indexOf(b)-f.indexOf(a)}).forEach(function(a){this.a.addCue(a)}.bind(this))};W.prototype.append=W.prototype.append;
W.prototype.destroy=function(){this.a&&Sh(this,function(){return!0});this.b=this.a=null;return Promise.resolve()};W.prototype.destroy=W.prototype.destroy;W.prototype.isTextVisible=function(){return"showing"==this.a.mode};W.prototype.isTextVisible=W.prototype.isTextVisible;W.prototype.setTextVisibility=function(a){this.a.mode=a?"showing":"hidden"};W.prototype.setTextVisibility=W.prototype.setTextVisibility;
function Uh(a,b){if(a.startTime>=a.endTime)return null;var c=new VTTCue(a.startTime,a.endTime,a.payload);c.lineAlign=a.lineAlign;c.positionAlign=a.positionAlign;c.size=a.size;try{c.align=a.textAlign}catch(e){}"center"==a.textAlign&&"center"!=c.align&&(c.align="middle");2==a.writingDirection?c.vertical="lr":3==a.writingDirection&&(c.vertical="rl");1==a.lineInterpretation&&(c.snapToLines=!1);null!=a.line&&(c.line=a.line);null!=a.position&&(c.position=a.position);if(a.region.id.length){var d=b.filter(function(b){return b.id==
a.region.id});d.length&&(c.region=d[0])}return c}function Th(a,b){var c=new VTTRegion,d=a.b.offsetWidth,e=a.b.offsetHeight;c.id=b.id;c.regionAnchorX=b.regionAnchorX;c.regionAnchorY=b.regionAnchorY;c.scroll=b.scroll;2==b.heightUnits&&(c.lines=b.height);c.width=0==b.widthUnits?100*b.width/d:b.width;0==b.viewportAnchorUnits?(c.viewportAnchorX=100*b.viewportAnchorX/d,c.viewportAnchorY=100*b.viewportAnchorY/e):(c.viewportAnchorX=b.viewportAnchorX,c.viewportAnchorY=b.viewportAnchorY);return c}
function Sh(a,b){for(var c=a.c,d=[],e=0;e<c.length;++e)b(c[e])&&d.push(c[e]);for(c=0;c<d.length;++c)a.a.removeCue(d[c])};function Vh(){this.a=Promise.resolve();this.b=this.c=this.f=!1;this.i=new Promise(function(a){this.g=a}.bind(this));this.l=[];this.j=[]}Vh.prototype.then=function(a){this.a=this.a.then(a).then(function(a){return this.b?(this.g(),Promise.reject(this.h)):Promise.resolve(a)}.bind(this));return this};
function Wh(a){a.f||(a.a=a.a.then(function(a){this.c=!0;this.l.forEach(function(a){a()});return Promise.resolve(a)}.bind(a),function(a){this.c=!0;return this.b?(this.g(),Promise.reject(this.h)):Promise.reject(a)}.bind(a)));a.f=!0;return a.a}Vh.prototype.cancel=function(a){if(this.c)return Promise.resolve();this.b=!0;this.h=a;this.j.forEach(function(a){a()});return this.i};function X(a,b){I.call(this);this.S=!1;this.f=a;this.nb=!1;this.v=null;this.o=new z;this.h=this.zb=this.b=this.j=this.a=this.A=this.g=this.i=this.m=this.u=null;this.Wc=1E9;this.jb=[];this.mb=!1;this.ca=!0;this.M=this.Ra=this.Ba=null;this.fc=!1;this.F=null;this.lb=[];this.L={};this.c=Xh(this);this.kb={width:Infinity,height:Infinity};this.l=Yh();this.ib=0;this.za=this.c.preferredAudioLanguage;this.Aa=this.c.preferredTextLanguage;this.fb=this.gb="";b&&b(this);this.u=new x(this.Ee.bind(this));this.i=
new Bc(this.f);this.i.init({});A(this.o,this.f,"error",this.Vd.bind(this))}la(X,I);n("shaka.Player",X);function Zh(a){if(!a.Ba)return Promise.resolve();var b=Promise.resolve();a.j&&(b=a.j.stop(),a.j=null);a=a.Ba.cancel(new p(2,7,7E3));return Promise.all([b,a])}X.prototype.destroy=function(){this.S=!0;return Zh(this).then(function(){var a=Promise.all([this.Ra,$h(this),this.o?this.o.destroy():null,this.u?this.u.destroy():null]);this.f=null;this.nb=!1;this.c=this.u=this.h=this.o=null;return a}.bind(this))};
X.prototype.destroy=X.prototype.destroy;X.version="v2.3.3-k-4-1-g24f03766";var ai={};X.registerSupportPlugin=function(a,b){ai[a]=b};X.isBrowserSupported=function(){return!!window.Promise&&!!window.Uint8Array&&!!Array.prototype.forEach&&!!window.MediaSource&&!!MediaSource.isTypeSupported&&!!window.MediaKeys&&!!window.navigator&&!!window.navigator.requestMediaKeySystemAccess&&!!window.MediaKeySystemAccess&&!!window.MediaKeySystemAccess.prototype.getConfiguration};
X.probeSupport=function(){return Zb().then(function(a){var b=Re(),c=Cc();a={manifest:b,media:c,drm:a};for(var d in ai)a[d]=ai[d]();return a})};
X.prototype.load=function(a,b,c){var d=this.wb(),e=new Vh;this.Ba=e;this.dispatchEvent(new B("loading"));var f=Date.now();return Wh(e.then(function(){return d}).then(function(){this.l=Yh();A(this.o,this.f,"playing",this.eb.bind(this));A(this.o,this.f,"pause",this.eb.bind(this));A(this.o,this.f,"ended",this.eb.bind(this));this.h=new this.c.abrFactory;this.h.configure(this.c.abr);this.v=new this.c.textDisplayFactory;this.v.setTextVisibility(this.nb);return Se(a,this.u,this.c.manifest.retryParameters,
c)}.bind(this)).then(function(b){this.j=new b;this.j.configure(this.c.manifest);return this.j.start(a,{networkingEngine:this.u,filterNewPeriod:this.pb.bind(this),filterAllPeriods:this.$b.bind(this),onTimelineRegionAdded:this.Ud.bind(this),onEvent:this.cb.bind(this),onError:this.Qa.bind(this)})}.bind(this)).then(function(b){b.periods.some(function(a){return a.variants.some(function(a){return a.video&&a.audio})})&&b.periods.forEach(function(a){a.variants=a.variants.filter(function(a){return a.video&&
a.audio})});if(0==b.periods.length)throw new p(2,4,4014);this.b=b;this.zb=a;this.m=new Kb({Wa:this.u,onError:this.Qa.bind(this),Qb:this.Fd.bind(this),onExpirationUpdated:this.Cd.bind(this),onEvent:this.cb.bind(this)});this.m.configure(this.c.drm);return this.m.init(b,!1)}.bind(this)).then(function(){this.$b(this.b.periods);this.ib=Date.now()/1E3;this.za=this.c.preferredAudioLanguage;this.Aa=this.c.preferredTextLanguage;var a=this.b.presentationTimeline.R(),b=this.c.playRangeEnd,c=this.c.playRangeStart;
0<c&&(this.O()||this.b.presentationTimeline.Lc(c));b<a&&(this.O()||this.b.presentationTimeline.ga(b));return Nb(this.m,this.f)}.bind(this)).then(function(){this.h.init(this.Fe.bind(this));this.i||(this.i=new Bc(this.f));this.i.m=this.v;this.g=new qg(this.f,this.b,this.c.streaming,void 0==b?null:b,this.De.bind(this),this.cb.bind(this));this.A=new vg(this.f,this.i,this.b,this.c.streaming,this.Oc.bind(this),this.cb.bind(this),this.Ce.bind(this));this.a=new zg(this.b,{La:this.g,J:this.i,Wa:this.u,rc:this.zd.bind(this),
qc:this.Zc.bind(this),onError:this.Qa.bind(this),onEvent:this.cb.bind(this),Gd:this.Hd.bind(this),Ya:this.Rd.bind(this),filterNewPeriod:this.pb.bind(this),filterAllPeriods:this.$b.bind(this)});this.a.configure(this.c.streaming);bi(this);this.dispatchEvent(new B("streaming"));return this.a.init()}.bind(this)).then(function(){if(this.c.streaming.startAtSegmentBoundary){var a=ci(this,tg(this.g));ng(this.g.a,a)}this.b.periods.forEach(this.pb.bind(this));di(this);ei(this);a=U(this.a);var b=dd(a.variants,
this.za,this.gb);this.h.setVariants(b);a.variants.some(function(a){return a.primary});this.lb.forEach(this.A.o.bind(this.A));this.lb=[];jb(this.o,this.f,"loadeddata",function(){this.l.loadLatency=(Date.now()-f)/1E3}.bind(this));this.Ba=null}.bind(this)))["catch"](function(a){this.Ba==e&&(this.Ba=null,this.dispatchEvent(new B("unloading")));return Promise.reject(a)}.bind(this))};X.prototype.load=X.prototype.load;
function bi(a){function b(a){return(a.video?a.video.codecs.split(".")[0]:"")+"-"+(a.audio?a.audio.codecs.split(".")[0]:"")}var c={};a.b.periods.forEach(function(a){a.variants.forEach(function(a){var d=b(a);d in c||(c[d]=[]);c[d].push(a)})});var d=null,e=Infinity;ub(c,function(a,b){var c=0,f=0;b.forEach(function(a){c+=a.bandwidth||0;++f});var g=c/f;g<e&&(d=a,e=g)});a.b.periods.forEach(function(a){a.variants=a.variants.filter(function(a){return b(a)==d?!0:!1})})}
X.prototype.configure=function(a){Va(this.c,a,Xh(this),fi(),"");gi(this)};X.prototype.configure=X.prototype.configure;function gi(a){a.j&&a.j.configure(a.c.manifest);a.m&&a.m.configure(a.c.drm);if(a.a){a.a.configure(a.c.streaming);try{a.b.periods.forEach(a.pb.bind(a))}catch(e){a.Qa(e)}var b=Dg(a.a),c=Fg(a.a),d=U(a.a);(b=hd(b,c,d.variants))&&b.allowedByApplication&&b.allowedByKeySystem||hi(a,d)}a.h&&(a.h.configure(a.c.abr),a.c.abr.enabled&&!a.ca?a.h.enable():a.h.disable())}
X.prototype.getConfiguration=function(){var a=Xh(this);Va(a,this.c,Xh(this),fi(),"");return a};X.prototype.getConfiguration=X.prototype.getConfiguration;X.prototype.qe=function(){this.c=Xh(this);gi(this)};X.prototype.resetConfiguration=X.prototype.qe;X.prototype.kd=function(){return this.f};X.prototype.getMediaElement=X.prototype.kd;X.prototype.mc=function(){return this.u};X.prototype.getNetworkingEngine=X.prototype.mc;X.prototype.Fb=function(){return this.zb};X.prototype.getManifestUri=X.prototype.Fb;
X.prototype.O=function(){return this.b?this.b.presentationTimeline.O():!1};X.prototype.isLive=X.prototype.O;X.prototype.na=function(){return this.b?this.b.presentationTimeline.na():!1};X.prototype.isInProgress=X.prototype.na;X.prototype.vd=function(){if(!this.b||!this.b.periods.length)return!1;var a=this.b.periods[0].variants;return a.length?!a[0].video:!1};X.prototype.isAudioOnly=X.prototype.vd;
X.prototype.se=function(){var a=0,b=0;this.b&&(b=this.b.presentationTimeline,a=b.Ta(),b=b.Fa());return{start:a,end:b}};X.prototype.seekRange=X.prototype.se;X.prototype.keySystem=function(){return this.m?this.m.keySystem():""};X.prototype.keySystem=X.prototype.keySystem;X.prototype.drmInfo=function(){return this.m?this.m.b:null};X.prototype.drmInfo=X.prototype.drmInfo;X.prototype.rb=function(){return this.m?this.m.rb():Infinity};X.prototype.getExpiration=X.prototype.rb;X.prototype.pc=function(){return this.mb};
X.prototype.isBuffering=X.prototype.pc;X.prototype.wb=function(){if(this.S)return Promise.resolve();this.dispatchEvent(new B("unloading"));return Zh(this).then(function(){this.Ra||(this.Ra=ii(this).then(function(){this.Ra=null}.bind(this)));return this.Ra}.bind(this))};X.prototype.unload=X.prototype.wb;X.prototype.Sa=function(){return this.g?this.g.Sa():0};X.prototype.getPlaybackRate=X.prototype.Sa;X.prototype.Pe=function(a){this.g&&pg(this.g.a,a);this.a&&Lg(this.a,1!=a)};X.prototype.trickPlay=X.prototype.Pe;
X.prototype.$c=function(){this.g&&pg(this.g.a,1);this.a&&Lg(this.a,!1)};X.prototype.cancelTrickPlay=X.prototype.$c;X.prototype.td=function(){if(!this.b||!this.g)return[];var a=jd(this.b,tg(this.g)),b=this.L[a]||{};return Zc(this.b.periods[a],b.audio,b.video)};X.prototype.getVariantTracks=X.prototype.td;X.prototype.rd=function(){if(!this.b||!this.g)return[];var a=jd(this.b,tg(this.g));return $c(this.b.periods[a],(this.L[a]||{}).text).filter(function(a){return 0>this.jb.indexOf(a.id)}.bind(this))};
X.prototype.getTextTracks=X.prototype.rd;X.prototype.we=function(a){if(this.a){var b=U(this.a);if(a=bd(b,a))this.i.j=!1,ji(this,a,!1),this.ca?this.F=a:Mg(this.a,a,!0),this.Aa=a.language}};X.prototype.selectTextTrack=X.prototype.we;X.prototype.ue=function(){this.i.j=!0;Kg(this.a)};X.prototype.selectEmbeddedTextTrack=X.prototype.ue;X.prototype.sd=function(){return this.i?this.i.j:!1};X.prototype.getUseEmbeddedTextTrack=X.prototype.sd;
X.prototype.xe=function(a,b){if(this.a){this.c.abr.enabled&&qa("Changing tracks while abr manager is enabled will likely result in the selected track being overriden. Consider disabling abr before calling selectVariantTrack().");var c=U(this.a);(c=ad(c,a))&&cd(c)&&(ki(this,c,!1),li(this,c,b),this.za=c.language)}};X.prototype.selectVariantTrack=X.prototype.xe;X.prototype.gd=function(){if(!this.a)return[];var a=U(this.a);a=Yc(a.variants).map(function(a){return a.audio}).filter(ob);return mi(a)};
X.prototype.getAudioLanguagesAndRoles=X.prototype.gd;X.prototype.qd=function(){if(!this.a)return[];var a=U(this.a);return mi(a.textStreams)};X.prototype.getTextLanguagesAndRoles=X.prototype.qd;X.prototype.fd=function(){if(!this.a)return[];var a=U(this.a);return Yc(a.variants).map(function(a){return a.language}).filter(ob)};X.prototype.getAudioLanguages=X.prototype.fd;X.prototype.pd=function(){return this.a?U(this.a).textStreams.map(function(a){return a.language}).filter(ob):[]};
X.prototype.getTextLanguages=X.prototype.pd;function mi(a){var b=[];a.forEach(function(a){if(a){var c=a.language;a.roles.length?a.roles.forEach(function(a){b.push({language:c,role:a})}):b.push({language:c,role:""})}else b.push({language:"und",role:""})});return Ra(b,function(a,b){return a.language==b.language&&a.role==b.role})}X.prototype.te=function(a,b){if(this.a){var c=U(this.a);this.za=a;this.gb=b||"";hi(this,c)}};X.prototype.selectAudioLanguage=X.prototype.te;
X.prototype.ve=function(a,b){if(this.a){var c=U(this.a);this.Aa=a;this.fb=b||"";hi(this,c)}};X.prototype.selectTextLanguage=X.prototype.ve;X.prototype.Jb=function(){return this.v?this.v.isTextVisible():this.nb};X.prototype.isTextTrackVisible=X.prototype.Jb;X.prototype.Ae=function(a){this.v&&this.v.setTextVisibility(a);this.nb=a;ni(this);this.a&&(a?(a=U(this.a),(a=fd(a.textStreams,this.Aa,this.fb)[0])&&Gg(this.a,a)):Kg(this.a))};X.prototype.setTextTrackVisibility=X.prototype.Ae;
X.prototype.md=function(){return this.b?new Date(1E3*this.b.presentationTimeline.c+1E3*this.f.currentTime):null};X.prototype.getPlayheadTimeAsDate=X.prototype.md;X.prototype.od=function(){return this.b?new Date(1E3*this.b.presentationTimeline.c):null};X.prototype.getPresentationStartTimeAsDate=X.prototype.od;X.prototype.Db=function(){return this.i?this.i.Db():{total:[],audio:[],video:[],text:[]}};X.prototype.getBufferedInfo=X.prototype.Db;
X.prototype.getStats=function(){oi(this);this.eb();var a=null,b=null,c=this.f;c=c&&c.getVideoPlaybackQuality?c.getVideoPlaybackQuality():{};if(this.g&&this.b){var d=jd(this.b,tg(this.g)),e=this.b.periods[d];if(d=this.L[d])b=id(d.audio,d.video,e.variants),a=b.video||{}}a||(a={});b||(b={});return{width:a.width||0,height:a.height||0,streamBandwidth:b.bandwidth||0,decodedFrames:Number(c.totalVideoFrames),droppedFrames:Number(c.droppedVideoFrames),estimatedBandwidth:this.h?this.h.getBandwidthEstimate():
NaN,loadLatency:this.l.loadLatency,playTime:this.l.playTime,bufferingTime:this.l.bufferingTime,switchHistory:Wa(this.l.switchHistory),stateHistory:Wa(this.l.stateHistory)}};X.prototype.getStats=X.prototype.getStats;
X.prototype.addTextTrack=function(a,b,c,d,e,f){if(!this.a)return Promise.reject();for(var g=U(this.a),h,k=0;k<this.b.periods.length;k++)if(this.b.periods[k]==g){if(k==this.b.periods.length-1){if(h=this.b.presentationTimeline.R()-g.startTime,Infinity==h)return Promise.reject()}else h=this.b.periods[k+1].startTime-g.startTime;break}var l={id:this.Wc++,createSegmentIndex:Promise.resolve.bind(Promise),findSegmentPosition:function(){return 1},getSegmentReference:function(b){return 1!=b?null:new O(1,0,
h,function(){return[a]},0,null)},initSegmentReference:null,presentationTimeOffset:0,mimeType:d,codecs:e||"",kind:c,encrypted:!1,keyId:null,language:b,label:f||null,type:"text",primary:!1,trickModeVideo:null,containsEmsgBoxes:!1,roles:[],channelsCount:null};this.jb.push(l.id);g.textStreams.push(l);return Gg(this.a,l).then(function(){if(!this.S){var a=this.b.periods.indexOf(g),d=Eg(this.a,"text");d&&(this.L[a].text=d.id);this.jb.splice(this.jb.indexOf(l.id),1);hi(this,g);di(this);return{id:l.id,active:!1,
type:"text",bandwidth:0,language:b,label:f||null,kind:c,width:null,height:null}}}.bind(this))};X.prototype.addTextTrack=X.prototype.addTextTrack;X.prototype.Yb=function(a,b){this.kb.width=a;this.kb.height=b};X.prototype.setMaxHardwareResolution=X.prototype.Yb;X.prototype.Hc=function(){if(this.a){var a=this.a;if(a.f)a=!1;else if(a.l)a=!1;else{for(var b in a.c){var c=a.c[b];c.Ua&&(c.Ua=!1,Jg(a,c,.1))}a=!0}}else a=!1;return a};X.prototype.retryStreaming=X.prototype.Hc;X.prototype.ma=function(){return this.b};
X.prototype.getManifest=X.prototype.ma;function ki(a,b,c){b.video&&pi(a,b.video);b.audio&&pi(a,b.audio);var d=Cg(a.a);b!=hd(Dg(a.a),Fg(a.a),d?d.variants:[])&&a.l.switchHistory.push({timestamp:Date.now()/1E3,id:b.id,type:"variant",fromAdaptation:c,bandwidth:b.bandwidth})}function ji(a,b,c){pi(a,b);a.l.switchHistory.push({timestamp:Date.now()/1E3,id:b.id,type:"text",fromAdaptation:c,bandwidth:null})}function pi(a,b){var c=kd(a.b,b);a.L[c]||(a.L[c]={});a.L[c][b.type]=b.id}
function $h(a){a.o&&(a.o.ka(a.f,"loadeddata"),a.o.ka(a.f,"playing"),a.o.ka(a.f,"pause"),a.o.ka(a.f,"ended"));var b=Promise.all([a.h?a.h.stop():null,a.i?a.i.destroy():null,a.m?a.m.destroy():null,a.g?a.g.destroy():null,a.A?a.A.destroy():null,a.a?a.a.destroy():null,a.j?a.j.stop():null,a.v?a.v.destroy():null]);a.ca=!0;a.m=null;a.i=null;a.g=null;a.A=null;a.a=null;a.j=null;a.v=null;a.b=null;a.zb=null;a.lb=[];a.L={};a.l=Yh();return b}
function ii(a){return a.j?$h(a).then(function(){this.S||(this.Oc(!1),this.i=new Bc(this.f),this.i.init({}))}.bind(a)):Promise.resolve()}function fi(){return{".drm.servers":"",".drm.clearKeys":"",".drm.advanced":{distinctiveIdentifierRequired:!1,persistentStateRequired:!1,videoRobustness:"",audioRobustness:"",serverCertificate:new Uint8Array(0)}}}
function Xh(a){var b=5E5;navigator.connection&&navigator.connection.type&&(b=1E6*navigator.connection.downlink);return{drm:{retryParameters:Ia(),servers:{},clearKeys:{},advanced:{},delayLicenseRequestUntilPlayed:!1},manifest:{retryParameters:Ia(),dash:{customScheme:function(a){if(a)return null},clockSyncUri:"",ignoreDrmInfo:!1,xlinkFailGracefully:!1,defaultPresentationDelay:10}},streaming:{retryParameters:Ia(),failureCallback:a.cd.bind(a),rebufferingGoal:2,bufferingGoal:10,bufferBehind:30,ignoreTextStreamFailures:!1,
startAtSegmentBoundary:!1,smallGapLimit:.5,jumpLargeGaps:!1,durationBackoff:1},abrFactory:G,textDisplayFactory:function(a){return new W(a)}.bind(null,a.f),abr:{enabled:!0,defaultBandwidthEstimate:b,switchInterval:8,bandwidthUpgradeTarget:.85,bandwidthDowngradeTarget:.95,restrictions:{minWidth:0,maxWidth:Infinity,minHeight:0,maxHeight:Infinity,minPixels:0,maxPixels:Infinity,minBandwidth:0,maxBandwidth:Infinity}},preferredAudioLanguage:"",preferredTextLanguage:"",restrictions:{minWidth:0,maxWidth:Infinity,
minHeight:0,maxHeight:Infinity,minPixels:0,maxPixels:Infinity,minBandwidth:0,maxBandwidth:Infinity},playRangeStart:0,playRangeEnd:Infinity}}m=X.prototype;m.cd=function(a){var b=[1001,1002,1003];this.O()&&0<=b.indexOf(a.code)&&(a.severity=1,this.Hc())};function Yh(){return{width:NaN,height:NaN,streamBandwidth:NaN,decodedFrames:NaN,droppedFrames:NaN,estimatedBandwidth:NaN,loadLatency:NaN,playTime:0,bufferingTime:0,switchHistory:[],stateHistory:[]}}
m.$b=function(a){a.forEach(Tc.bind(null,this.m,this.a?Dg(this.a):null,this.a?Fg(this.a):null));var b=Ua(a,function(a){return a.variants.some(cd)});if(0==b)throw new p(2,4,9009);if(b<a.length)throw new p(2,4,4011);a.forEach(function(a){Sc(a,this.c.restrictions,this.kb)&&this.a&&U(this.a)==a&&di(this);if(!a.variants.some(cd))throw new p(2,4,4012);}.bind(this))};
m.pb=function(a){Tc(this.m,this.a?Dg(this.a):null,this.a?Fg(this.a):null,a);var b=a.variants,c=b.some(cd);Sc(a,this.c.restrictions,this.kb)&&this.a&&U(this.a)==a&&di(this);a=b.some(cd);if(!c)throw new p(2,4,4011);if(!a)throw new p(2,4,4012);};function li(a,b,c){a.ca?(a.M=b,a.fc=c||!1):Ng(a.a,b,c||!1)}function oi(a){if(a.b){var b=Date.now()/1E3;a.mb?a.l.bufferingTime+=b-a.ib:a.l.playTime+=b-a.ib;a.ib=b}}
function ci(a,b){function c(a,b){if(!a)return null;var c=a.findSegmentPosition(b-f.startTime);return null==c?null:(c=a.getSegmentReference(c))?c.startTime+f.startTime:null}var d=Dg(a.a),e=Fg(a.a),f=U(a.a);d=c(d,b);e=c(e,b);return null!=e&&null!=d?Math.max(e,d):null!=e?e:null!=d?d:b}m.Ee=function(a,b){this.h&&this.h.segmentDownloaded(a,b)};m.Oc=function(a){oi(this);this.mb=a;this.eb();if(this.g){var b=this.g.a;a!=b.h&&(b.h=a,pg(b,b.g))}this.dispatchEvent(new B("buffering",{buffering:a}))};m.Ce=function(){di(this)};
m.eb=function(){if(!this.S){var a=this.mb?"buffering":this.f.ended?"ended":this.f.paused?"paused":"playing";var b=Date.now()/1E3;if(this.l.stateHistory.length){var c=this.l.stateHistory[this.l.stateHistory.length-1];c.duration=b-c.timestamp;if(a==c.state)return}this.l.stateHistory.push({timestamp:b,state:a,duration:0})}};m.De=function(){if(this.A){var a=this.A;a.c.forEach(a.m.bind(a,!0))}this.a&&Qg(this.a)};
function qi(a,b){if(!b||!b.length)return a.Qa(new p(2,4,4012)),null;a.h.setVariants(b);return a.h.chooseVariant()}function hi(a,b){var c=dd(b.variants,a.za,a.gb),d=fd(b.textStreams,a.Aa,a.fb);if(c=qi(a,c))ki(a,c,!0),li(a,c,!0);(d=d[0])&&a.Jb()&&(ji(a,d,!0),a.ca?a.F=d:Mg(a.a,d,!0));ei(a)}
m.zd=function(a){this.ca=!0;this.h.disable();var b={audio:!1,text:!1},c=dd(a.variants,this.za,this.gb,b),d=fd(a.textStreams,this.Aa,this.fb,b);c=qi(this,c);d=d[0]||null;if(this.M){a:{var e=this.b;for(var f=0;f<e.periods.length;++f)for(var g=e.periods[f],h=0;h<g.variants.length;++h)if(g.variants[h]==this.M){e=f;break a}e=-1}this.b.periods[e]==a&&(c=this.M);this.M=null}this.F&&(this.b.periods[kd(this.b,this.F)]==a&&(d=this.F),this.F=null);c&&ki(this,c,!0);d&&(ji(this,d,!0),!Cg(this.a)&&c&&c.audio&&
b.text&&d.language!=c.audio.language&&(this.v.setTextVisibility(!0),ni(this)));return this.Jb()?{variant:c,text:d}:{variant:c,text:null}};m.Zc=function(){this.ca=!1;this.c.abr.enabled&&this.h.enable();this.M&&(Ng(this.a,this.M,this.fc),this.M=null);this.F&&(Mg(this.a,this.F,!0),this.F=null)};m.Hd=function(){this.j&&this.j.update&&this.j.update()};m.Rd=function(){this.g&&this.g.Ya()};m.Fe=function(a,b){ki(this,a,!0);this.a&&(Ng(this.a,a,b||!1),ei(this))};
function ei(a){Promise.resolve().then(function(){this.S||this.dispatchEvent(new B("adaptation"))}.bind(a))}function di(a){Promise.resolve().then(function(){this.S||this.dispatchEvent(new B("trackschanged"))}.bind(a))}function ni(a){a.dispatchEvent(new B("texttrackvisibility"))}m.Qa=function(a){if(!this.S){var b=new B("error",{detail:a});this.dispatchEvent(b);b.defaultPrevented&&(a.handled=!0)}};m.Ud=function(a){this.A?this.A.o(a):this.lb.push(a)};m.cb=function(a){this.dispatchEvent(a)};
m.Vd=function(){if(this.f.error){var a=this.f.error.code;if(1!=a){var b=this.f.error.msExtendedCode;b&&(0>b&&(b+=Math.pow(2,32)),b=b.toString(16));this.Qa(new p(2,3,3016,a,b,this.f.error.message))}}};
m.Fd=function(a){var b=["output-restricted","internal-error"],c=U(this.a),d=!1,e=Object.keys(a),f=1==e.length&&"00"==e[0];e.length&&c.variants.forEach(function(c){var e=[];c.audio&&e.push(c.audio);c.video&&e.push(c.video);e.forEach(function(e){var g=c.allowedByKeySystem;e.keyId&&(e=a[f?"00":e.keyId],c.allowedByKeySystem=!!e&&0>b.indexOf(e));g!=c.allowedByKeySystem&&(d=!0)})});(e=hd(Dg(this.a),Fg(this.a),c.variants))&&!e.allowedByKeySystem&&hi(this,c);d&&di(this)};
m.Cd=function(a,b){if(this.j&&this.j.onExpirationUpdated)this.j.onExpirationUpdated(a,b);this.dispatchEvent(new B("expirationupdated"))};function Y(a){if(!a||a.constructor!=X)throw new p(2,9,9008);this.c=null;this.g=a;this.h=ri(this);this.a=null;this.m=!1;this.b=this.j=this.f=this.i=null;this.v={};this.o=0}n("shaka.offline.Storage",Y);function si(){return null!=window.indexedDB}Y.support=si;Y.prototype.destroy=function(){var a=this.c,b=this.b?this.b.destroy()["catch"](function(){}).then(function(){if(a)return a.destroy()}):Promise.resolve();this.h=this.g=this.b=this.c=null;return b};Y.prototype.destroy=Y.prototype.destroy;
Y.prototype.configure=function(a){Va(this.h,a,ri(this),{},"")};Y.prototype.configure=Y.prototype.configure;
Y.prototype.store=function(a,b,c){function d(a){f=a}if(this.m)return Promise.reject(new p(2,9,9006));this.m=!0;var e=b||{},f=null;return ti(this).then(function(){Z(this);return ui(this,a,d,c)}.bind(this)).then(function(b){Z(this);if(f)throw f;return vi(this,a,b.manifest,e,b.Bb)}.bind(this)).then(function(a){Z(this);return wi(this).then(function(){return a})}.bind(this))["catch"](function(a){f=f||a;return wi(this).then(function(){throw f;})}.bind(this))};Y.prototype.store=Y.prototype.store;
function vi(a,b,c,d,e){if(c.presentationTimeline.O()||c.presentationTimeline.na())throw new p(2,9,9005,b);a.f=c;a.a=e;a.l(c.periods);a.j=Bh(b,c,d);var f=xi(a,b,d);return qh(a.c,"manifest-v3",f).then(function(b){var c="offline:manifest/"+b;b=xh(a.b,f,b).then(function(){return f.downloadStatus});return{manifest:Ch(c,f),downloadPromise:b}})}
Y.prototype.Ne=function(a,b,c){function d(a){f=a}if(this.m)return Promise.reject(new p(2,9,9006));this.m=!0;var e=b||{},f=null;return ti(this).then(function(){Z(this);return ui(this,a,d,c)}.bind(this)).then(function(b){Z(this);if(f)throw f;return yi(this,a,b.manifest,e,b.Bb)}.bind(this)).then(function(a){Z(this);return wi(this).then(function(){return a})}.bind(this))["catch"](function(a){f=f||a;return wi(this).then(function(){throw f;})}.bind(this))};Y.prototype.storeManifest=Y.prototype.Ne;
function yi(a,b,c,d,e){if(c.presentationTimeline.O()||c.presentationTimeline.na())throw new p(2,9,9005,b);a.f=c;a.a=e;a.l(c.periods);a.j=Bh(b,c,d);var f=xi(a,b,d);return qh(a.c,"manifest-v3",f).then(function(b){var d=f.periods[0].streams.filter(Fh)[0],e=f.periods[0].streams.filter(Eh)[0],g=id(e.id,d.id,c.periods[0].variants);a.b.b={};zi(a,g.audio,e);zi(a,g.video,d);return xh(a.b,f,b).then(function(){var c=Ch("offline:manifest/"+b,f);c.expectedSize=a.o;return c})})}
Y.prototype.remove=function(a){return a.offlineUri?(qa("Removing downloaded content using shakaExtern.StoredContent is deprecated. Please remove using the offline uri."),Ai(this,a.offlineUri)):Ai(this,a)};Y.prototype.remove=Y.prototype.remove;
function Ai(a,b){var c=Ah(b);if(null==c)return Promise.reject(new p(2,9,9004,b));var d;return ti(a).then(function(){Z(this);return this.c.ma(c)}.bind(a)).then(function(a){Z(this);if(!a)throw new p(2,9,9003,b);d=a;return null==c?Promise.reject(new p(2,9,9004,b)):Bi(this,b,c,d)}.bind(a))}Y.prototype.pause=function(){this.b.pause();return Promise.resolve("paused")};Y.prototype.pause=Y.prototype.pause;Y.prototype.download=function(a){return Ci(this,a).then(function(a){return Promise.resolve(a)})};
Y.prototype.download=Y.prototype.download;
function Ci(a,b){var c=Ah(b);return null==c?Promise.reject(new p(2,9,9004,b)):ti(a).then(function(){Z(this);return this.c.ma(c)}.bind(a)).then(function(a){a.downloadStatus="resumed";Z(this);if(!a)throw new p(2,9,9003,b);Di(this,a.periods);this.f=Qh(a);var d=this.f.periods.map(this.A.bind(this));Lh(d,this.f.Rc);this.b.u=c;this.j={appMetadata:a.appMetadata,duration:a.duration,expiration:a.expiration,offlineUri:null,originalManifestUri:a.originalManifestUri,size:a.size,tracks:null,downloadStatus:null};
return xh(this.b,a,c).then(function(){"resumed"==a.downloadStatus&&(a.downloadStatus="ended");return a}.bind(this))}.bind(a))}function Di(a,b){b[0].streams.forEach(function(b){a.v[b.id]=Ei(b.segments)})}
Y.prototype.ne=function(a){function b(a){e=a}var c=this,d=Ah(a);if(null==d)return Promise.reject(new p(2,9,9004,a));var e=null,f,g,h;return ti(this).then(function(){Z(this);return this.c.ma(d)}.bind(this)).then(function(a){f=a;a=Qh(a);c.a=new Kb({Wa:c.g.u,onError:b,Qb:function(){},onExpirationUpdated:function(){},onEvent:function(){}});c.a.configure(c.g.getConfiguration().drm);return c.a.init(a,!0)}).then(function(){g=c.a.i.createSession("persistent-license");return g.load(f.sessionIds[0])}).then(function(){return g.remove()}).then(function(){return ui(c,
f.originalManifestUri,b)}).then(function(a){c.f=a.manifest;c.a=a.Bb;var b=f.periods;c.l(a.manifest.periods);c.j=Bh(f.originalManifestUri,a.manifest,f.appMetadata);h=xi(c,f.originalManifestUri,f.appMetadata);h.periods=b;c.a.a[0].fa.close();if(null!=d)return ph(c.c,d,h)}).then(function(){return Promise.resolve(h)})["catch"](function(a){e=e||a;return wi(this).then(function(){throw e;})}.bind(this))};Y.prototype.renewLicense=Y.prototype.ne;
function Bi(a,b,c,d){function e(){k++;f(g,k/l)}var f=a.h.progressCallback,g=Ch(b,d),h=Fi(d),k=0,l=h.length+1;return Promise.resolve().then(function(){Z(this);return mh(this.c,h,e)}.bind(a)).then(function(){Z(this);return nh(this.c,"manifest-v3",[c],e)}.bind(a))}Y.prototype.list=function(){var a=[];return ti(this).then(function(){Z(this);return kh(this.c,function(b,c){var d=Ch("offline:manifest/"+b,c);a.push(d)})}.bind(this)).then(function(){return a})};Y.prototype.list=Y.prototype.list;
function ui(a,b,c,d){function e(){}var f=a.g.u,g=a.g.getConfiguration(),h,k,l;return Se(b,f,g.manifest.retryParameters,d).then(function(a){Z(this);l=new a;l.configure(g.manifest);return l.start(b,{networkingEngine:f,filterAllPeriods:this.l.bind(this),filterNewPeriod:this.u.bind(this),onTimelineRegionAdded:function(){},onEvent:function(){},onError:c})}.bind(a)).then(function(a){Z(this);h=a;k=new Kb({Wa:f,onError:c,Qb:e,onExpirationUpdated:function(){},onEvent:function(){}});k.configure(g.drm);return k.init(h,
this.h.usePersistentLicense||!1)}.bind(a)).then(function(){Z(this);return Gi(h)}.bind(a)).then(function(){Z(this);return Ob(k)}.bind(a)).then(function(){Z(this);return l.stop()}.bind(a)).then(function(){Z(this);return{manifest:h,Bb:k}}.bind(a))["catch"](function(a){if(l)return l.stop().then(function(){throw a;});throw a;})}
Y.prototype.F=function(a){var b=[],c=Pc(this.g.getConfiguration().preferredAudioLanguage),d=[0,Nc,Oc],e=a.filter(function(a){return"variant"==a.type});d=d.map(function(a){return e.filter(function(b){b=Pc(b.language);return Mc(a,c,b)})});for(var f,g=0;g<d.length;g++)if(d[g].length){f=d[g];break}f||(d=e.filter(function(a){return a.primary}),d.length&&(f=d));f||(f=e,e.map(function(a){return a.language}).filter(ob));var h=f.filter(function(a){return a.height&&480>=a.height});h.length&&(h.sort(function(a,
b){return b.height-a.height}),f=h.filter(function(a){return a.height==h[0].height}));f.sort(function(a,b){return a.bandwidth-b.bandwidth});f.length&&b.push(f[Math.floor(f.length/2)]);b.push.apply(b,a.filter(function(a){return"text"==a.type}));return b};function ri(a){return{trackSelectionCallback:a.F.bind(a),progressCallback:function(a,c){if(a||c)return null},usePersistentLicense:!0}}
function ti(a){if(null==window.indexedDB)return Promise.reject(new p(2,9,9E3));if(a.c)return Promise.resolve();var b=a.g.u,c=a.g.getConfiguration().streaming.retryParameters;return Mh().then(function(a){this.c=a;this.b=new uh(a,b,c);vh(this.b,function(a,b){var c=this.j;c.size=b;this.h.progressCallback(c,a)}.bind(this))}.bind(a))}Y.prototype.l=function(a){a.forEach(this.u.bind(this))};
Y.prototype.u=function(a){var b=null;if(this.i){var c=this.i.filter(function(a){return"variant"==a.type})[0];c&&(b=ad(a,c))}var d=c=null;b&&(b.audio&&(c=b.audio),b.video&&(d=b.video));Tc(this.a,c,d,a);Sc(a,this.g.getConfiguration().restrictions,{width:Infinity,height:Infinity})};function wi(a){var b=a.a?a.a.destroy():Promise.resolve();a.a=null;a.f=null;a.m=!1;a.i=null;return b}
function Gi(a){var b=a.periods.map(function(a){return a.variants}).reduce(lb,[]).map(function(a){var b=[];a.audio&&b.push(a.audio);a.video&&b.push(a.video);return b}).reduce(lb,[]).filter(ob);a=a.periods.map(function(a){return a.textStreams}).reduce(lb,[]);b.push.apply(b,a);return Promise.all(b.map(function(a){return a.createSegmentIndex()}))}
function xi(a,b,c){var d=a.f.periods.map(a.A.bind(a)),e=a.a.b,f=Rb(a.a);if(e&&a.h.usePersistentLicense){if(!f.length)throw new p(2,9,9007,b);e.initData=[]}return{originalManifestUri:b,duration:a.f.presentationTimeline.R(),size:0,expiration:a.a.rb(),periods:d,sessionIds:a.h.usePersistentLicense?f:[],drmInfo:e,appMetadata:c,downloadStatus:null}}
Y.prototype.A=function(a){var b=Zc(a,null,null),c=$c(a,null);b=this.h.trackSelectionCallback(b.concat(c));null==this.i&&(this.i=b,this.l(this.f.periods));for(c=b.length-1;0<c;--c){for(var d=!1,e=c-1;0<=e;--e)if(b[c].type==b[e].type&&b[c].kind==b[e].kind&&b[c].language==b[e].language){d=!0;break}if(d)break}c=[];d={};for(e=0;e<b.length;d={variant:d.variant},e++)if(d.variant=ad(a,b[e]),d.variant){var f=void 0;d.variant.audio&&((f=c.filter(function(a){return function(b){return b.id==a.variant.audio.id}}(d))[0])?
f.variantIds.push(d.variant.id):(f=d.variant.video?d.variant.bandwidth/2:d.variant.bandwidth,c.push(Hi(this,d.variant.audio,f,d.variant.id))));d.variant.video&&((f=c.filter(function(a){return function(b){return b.id==a.variant.video.id}}(d))[0])?f.variantIds.push(d.variant.id):(f=d.variant.audio?d.variant.bandwidth/2:d.variant.bandwidth,c.push(Hi(this,d.variant.video,f,d.variant.id))))}else c.push(Hi(this,bd(a,b[e]),0));return{startTime:a.startTime,streams:c}};
function Hi(a,b,c,d){var e={id:b.id,primary:b.primary,presentationTimeOffset:b.presentationTimeOffset||0,contentType:b.type,mimeType:b.mimeType,codecs:b.codecs,frameRate:b.frameRate,kind:b.kind,language:b.language,label:b.label,width:b.width||null,height:b.height||null,initSegmentKey:null,encrypted:b.encrypted,keyId:b.keyId,segments:[],variantIds:[]};null!=d&&e.variantIds.push(d);d=a.f.presentationTimeline.Ha();var f=a.v[b.id]||{};Ii.bind(a)(b,d,function(a){var d=a.startTime,g=a.endTime,l=a.Ca||(g-
d)*c/8||0,q=a.uris&&0<a.uris.length?a.uris:a.W(),r=a.K,t=a.C;e.segments.push({startTime:d,endTime:g,dataKey:null,Ca:l,K:r,C:t,position:a.position,uris:q});q=a.startTime+"-"+a.endTime;f[q]||(f[q]=e.segments.length-1);this.o+=null==t?l:t-r+1;wh(this.b,b.type,a,l,function(a){a={startTime:d,endTime:g,dataKey:a};0==Object.keys(f)&&(f=Ei(e.segments));e.segments[f[a.startTime+"-"+a.endTime]]=a})}.bind(a),a.f.Rc);zi(a,b,e);(d=b.initSegmentReference)&&wh(a.b,b.type,d,0,function(a){e.initSegmentKey=a});return e}
function zi(a,b,c){var d=b.initSegmentReference;d&&wh(a.b,b.type,d,0,function(a){c.initSegmentKey=a})}function Ei(a){var b={};a.forEach(function(a,d){b[a.startTime+"-"+a.endTime]=d});return b}function Ii(a,b,c,d){b=a.findSegmentPosition(b);var e=null==b?null:a.getSegmentReference(b),f=a.id;if(d)d[0].streams.filter(function(a){return a.id==f})[0].segments.filter(function(a){return null==a.dataKey}).forEach(function(a){c(a)});else for(;e;)c(e),e=a.getSegmentReference(++b)}
function Z(a){if(!a.g)throw new p(2,9,7001);}function Fi(a){var b=[];a.periods.forEach(function(a){a.streams.forEach(function(a){null!=a.initSegmentKey&&b.push(a.initSegmentKey);a.segments.forEach(function(a){b.push(a.dataKey)})})});return b}Y.deleteAll=function(){return Oh()};ai.offline=si;n("shaka.polyfill.installAll",function(){for(var a=0;a<Ji.length;++a)Ji[a]()});var Ji=[];function Ki(a){Ji.push(a)}n("shaka.polyfill.register",Ki);function Li(a){var b=a.type.replace(/^(webkit|moz|MS)/,"").toLowerCase();if("function"===typeof Event)var c=new Event(b,a);else c=document.createEvent("Event"),c.initEvent(b,a.bubbles,a.cancelable);a.target.dispatchEvent(c)}
Ki(function(){if(window.Document){var a=Element.prototype;a.requestFullscreen=a.requestFullscreen||a.mozRequestFullScreen||a.msRequestFullscreen||a.webkitRequestFullscreen;a=Document.prototype;a.exitFullscreen=a.exitFullscreen||a.mozCancelFullScreen||a.msExitFullscreen||a.webkitExitFullscreen;"fullscreenElement"in document||(Object.defineProperty(document,"fullscreenElement",{get:function(){return document.mozFullScreenElement||document.msFullscreenElement||document.webkitFullscreenElement}}),Object.defineProperty(document,
"fullscreenEnabled",{get:function(){return document.mozFullScreenEnabled||document.msFullscreenEnabled||document.webkitFullscreenEnabled}}));document.addEventListener("webkitfullscreenchange",Li);document.addEventListener("webkitfullscreenerror",Li);document.addEventListener("mozfullscreenchange",Li);document.addEventListener("mozfullscreenerror",Li);document.addEventListener("MSFullscreenChange",Li);document.addEventListener("MSFullscreenError",Li)}});Ki(function(){var a=navigator.userAgent;a&&0<=a.indexOf("CrKey")&&delete window.indexedDB});var Mi;function Ni(a,b,c){if("input"==a)switch(this.type){case "range":a="change"}Mi.call(this,a,b,c)}Ki(function(){0>navigator.userAgent.indexOf("Trident/")||HTMLInputElement.prototype.addEventListener==Ni||(Mi=HTMLInputElement.prototype.addEventListener,HTMLInputElement.prototype.addEventListener=Ni)});Ki(function(){if(4503599627370497!=Math.round(4503599627370497)){var a=Math.round;Math.round=function(b){var c=b;4503599627370496>=b&&(c=a(b));return c}}});function Oi(a){this.f=[];this.b=[];this.a=[];(new Q).V("pssh",this.c.bind(this)).parse(a.buffer)}Oi.prototype.c=function(a){if(!(1<a.version)){var b=Hb(a.s.Na(16)),c=[];if(0<a.version)for(var d=a.s.D(),e=0;e<d;++e){var f=Hb(a.s.Na(16));c.push(f)}d=a.s.D();a.s.G(d);this.b.push.apply(this.b,c);this.f.push(b);this.a.push({start:a.start,end:a.start+a.size-1})}};function Pi(a,b){try{var c=new Qi(a,b);return Promise.resolve(c)}catch(d){return Promise.reject(d)}}
function Qi(a,b){this.keySystem=a;for(var c=!1,d=0;d<b.length;++d){var e=b[d],f={audioCapabilities:[],videoCapabilities:[],persistentState:"optional",distinctiveIdentifier:"optional",initDataTypes:e.initDataTypes,sessionTypes:["temporary"],label:e.label},g=!1;if(e.audioCapabilities)for(var h=0;h<e.audioCapabilities.length;++h){var k=e.audioCapabilities[h];if(k.contentType){g=!0;var l=k.contentType.split(";")[0];MSMediaKeys.isTypeSupported(this.keySystem,l)&&(f.audioCapabilities.push(k),c=!0)}}if(e.videoCapabilities)for(h=
0;h<e.videoCapabilities.length;++h)k=e.videoCapabilities[h],k.contentType&&(g=!0,l=k.contentType.split(";")[0],MSMediaKeys.isTypeSupported(this.keySystem,l)&&(f.videoCapabilities.push(k),c=!0));g||(c=MSMediaKeys.isTypeSupported(this.keySystem,"video/mp4"));"required"==e.persistentState&&(c=!1);if(c){this.a=f;return}}c=Error("Unsupported keySystem");c.name="NotSupportedError";c.code=DOMException.NOT_SUPPORTED_ERR;throw c;}Qi.prototype.createMediaKeys=function(){var a=new Ri(this.keySystem);return Promise.resolve(a)};
Qi.prototype.getConfiguration=function(){return this.a};function Si(a){var b=this.mediaKeys;b&&b!=a&&Ti(b,null);delete this.mediaKeys;return(this.mediaKeys=a)?Ti(a,this):Promise.resolve()}function Ri(a){this.a=new MSMediaKeys(a);this.b=new z}Ri.prototype.createSession=function(a){var b=a||"temporary";if("temporary"!=b)throw new TypeError("Session type "+a+" is unsupported on this platform.");return new Ui(this.a,b)};Ri.prototype.setServerCertificate=function(){return Promise.resolve(!1)};
function Ti(a,b){function c(){b.msSetMediaKeys(d.a);b.removeEventListener("loadedmetadata",c)}gb(a.b);if(!b)return Promise.resolve();A(a.b,b,"msneedkey",Vi);var d=a;try{return 1<=b.readyState?b.msSetMediaKeys(a.a):b.addEventListener("loadedmetadata",c),Promise.resolve()}catch(e){return Promise.reject(e)}}function Ui(a){I.call(this);this.c=null;this.g=a;this.b=this.a=null;this.f=new z;this.sessionId="";this.expiration=NaN;this.closed=new u;this.keyStatuses=new Wi}la(Ui,I);m=Ui.prototype;
m.generateRequest=function(a,b){this.a=new u;try{this.c=this.g.createSession("video/mp4",new Uint8Array(b),null),A(this.f,this.c,"mskeymessage",this.Ld.bind(this)),A(this.f,this.c,"mskeyadded",this.Jd.bind(this)),A(this.f,this.c,"mskeyerror",this.Kd.bind(this)),Xi(this,"status-pending")}catch(c){this.a.reject(c)}return this.a};m.load=function(){return Promise.reject(Error("MediaKeySession.load not yet supported"))};m.update=function(a){this.b=new u;try{this.c.update(new Uint8Array(a))}catch(b){this.b.reject(b)}return this.b};
m.close=function(){try{this.c.close(),this.closed.resolve(),gb(this.f)}catch(a){this.closed.reject(a)}return this.closed};m.remove=function(){return Promise.reject(Error("MediaKeySession.remove is only applicable for persistent licenses, which are not supported on this platform"))};
function Vi(a){var b=document.createEvent("CustomEvent");b.initCustomEvent("encrypted",!1,!1,null);b.initDataType="cenc";if(a=a.initData){var c=new Oi(a);if(!(1>=c.a.length)){for(var d=[],e=0;e<c.a.length;e++)d.push(a.subarray(c.a[e].start,c.a[e].end+1));a=Ra(d,Yi);for(d=c=0;d<a.length;d++)c+=a[d].length;c=new Uint8Array(c);for(e=d=0;e<a.length;e++)c.set(a[e],d),d+=a[e].length;a=c}}b.initData=a;this.dispatchEvent(b)}function Yi(a,b){return Ib(a,b)}
m.Ld=function(a){this.a&&(this.a.resolve(),this.a=null);this.dispatchEvent(new B("message",{messageType:void 0==this.keyStatuses.a?"licenserequest":"licenserenewal",message:a.message.buffer}))};m.Jd=function(){this.a?(Xi(this,"usable"),this.a.resolve(),this.a=null):this.b&&(Xi(this,"usable"),this.b.resolve(),this.b=null)};
m.Kd=function(){var a=Error("EME PatchedMediaKeysMs key error");a.errorCode=this.c.error;if(null!=this.a)this.a.reject(a),this.a=null;else if(null!=this.b)this.b.reject(a),this.b=null;else switch(this.c.error.code){case MSMediaKeyError.MS_MEDIA_KEYERR_OUTPUT:case MSMediaKeyError.MS_MEDIA_KEYERR_HARDWARECHANGE:Xi(this,"output-not-allowed");break;default:Xi(this,"internal-error")}};function Xi(a,b){var c=a.keyStatuses;c.size=void 0==b?0:1;c.a=b;a.dispatchEvent(new B("keystatuseschange"))}
function Wi(){this.size=0;this.a=void 0}var Zi;m=Wi.prototype;m.forEach=function(a){this.a&&a(this.a,Zi)};m.get=function(a){if(this.has(a))return this.a};m.has=function(a){var b=Zi;return this.a&&Ib(new Uint8Array(a),new Uint8Array(b))?!0:!1};m.entries=function(){};m.keys=function(){};m.values=function(){};function $i(){return Promise.reject(Error("The key system specified is not supported."))}function aj(a){return null==a?Promise.resolve():Promise.reject(Error("MediaKeys not supported."))}function bj(){throw new TypeError("Illegal constructor.");}bj.prototype.createSession=function(){};bj.prototype.setServerCertificate=function(){};function cj(){throw new TypeError("Illegal constructor.");}cj.prototype.getConfiguration=function(){};cj.prototype.createMediaKeys=function(){};var dj="";function ej(a){dj=a;fj=(new Uint8Array([0])).buffer;navigator.requestMediaKeySystemAccess=gj;delete HTMLMediaElement.prototype.mediaKeys;HTMLMediaElement.prototype.mediaKeys=null;HTMLMediaElement.prototype.setMediaKeys=hj;window.MediaKeys=ij;window.MediaKeySystemAccess=jj}function kj(a){var b=dj;return b?b+a.charAt(0).toUpperCase()+a.slice(1):a}function gj(a,b){try{var c=new jj(a,b);return Promise.resolve(c)}catch(d){return Promise.reject(d)}}
function hj(a){var b=this.mediaKeys;b&&b!=a&&lj(b,null);delete this.mediaKeys;(this.mediaKeys=a)&&lj(a,this);return Promise.resolve()}
function jj(a,b){this.a=this.keySystem=a;var c=!1;"org.w3.clearkey"==a&&(this.a="webkit-org.w3.clearkey",c=!1);var d=!1;var e=document.getElementsByTagName("video");e=e.length?e[0]:document.createElement("video");for(var f=0;f<b.length;++f){var g=b[f],h={audioCapabilities:[],videoCapabilities:[],persistentState:"optional",distinctiveIdentifier:"optional",initDataTypes:g.initDataTypes,sessionTypes:["temporary"],label:g.label},k=!1;if(g.audioCapabilities)for(var l=0;l<g.audioCapabilities.length;++l){var q=
g.audioCapabilities[l];if(q.contentType){k=!0;var r=q.contentType.split(";")[0];e.canPlayType(r,this.a)&&(h.audioCapabilities.push(q),d=!0)}}if(g.videoCapabilities)for(l=0;l<g.videoCapabilities.length;++l)q=g.videoCapabilities[l],q.contentType&&(k=!0,e.canPlayType(q.contentType,this.a)&&(h.videoCapabilities.push(q),d=!0));k||(d=e.canPlayType("video/mp4",this.a)||e.canPlayType("video/webm",this.a));"required"==g.persistentState&&(c?(h.persistentState="required",h.sessionTypes=["persistent-license"]):
d=!1);if(d){this.b=h;return}}c="Unsupported keySystem";if("org.w3.clearkey"==a||"com.widevine.alpha"==a)c="None of the requested configurations were supported.";c=Error(c);c.name="NotSupportedError";c.code=DOMException.NOT_SUPPORTED_ERR;throw c;}jj.prototype.createMediaKeys=function(){var a=new ij(this.a);return Promise.resolve(a)};jj.prototype.getConfiguration=function(){return this.b};function ij(a){this.g=a;this.b=null;this.a=new z;this.c=[];this.f={}}
function lj(a,b){a.b=b;gb(a.a);var c=dj;b&&(A(a.a,b,c+"needkey",a.Zd.bind(a)),A(a.a,b,c+"keymessage",a.Yd.bind(a)),A(a.a,b,c+"keyadded",a.Wd.bind(a)),A(a.a,b,c+"keyerror",a.Xd.bind(a)))}m=ij.prototype;m.createSession=function(a){var b=a||"temporary";if("temporary"!=b&&"persistent-license"!=b)throw new TypeError("Session type "+a+" is unsupported on this platform.");a=this.b||document.createElement("video");a.src||(a.src="about:blank");b=new mj(a,this.g,b);this.c.push(b);return b};
m.setServerCertificate=function(){return Promise.resolve(!1)};m.Zd=function(a){var b=document.createEvent("CustomEvent");b.initCustomEvent("encrypted",!1,!1,null);b.initDataType="webm";b.initData=a.initData;this.b.dispatchEvent(b)};m.Yd=function(a){var b=nj(this,a.sessionId);b&&(a=new B("message",{messageType:void 0==b.keyStatuses.a?"licenserequest":"licenserenewal",message:a.message}),b.b&&(b.b.resolve(),b.b=null),b.dispatchEvent(a))};
m.Wd=function(a){if(a=nj(this,a.sessionId))oj(a,"usable"),a.a&&a.a.resolve(),a.a=null};
m.Xd=function(a){var b=nj(this,a.sessionId);if(b){var c=Error("EME v0.1b key error");c.errorCode=a.errorCode;c.errorCode.systemCode=a.systemCode;!a.sessionId&&b.b?(c.method="generateRequest",45==a.systemCode&&(c.message="Unsupported session type."),b.b.reject(c),b.b=null):a.sessionId&&b.a?(c.method="update",b.a.reject(c),b.a=null):(c=a.systemCode,a.errorCode.code==MediaKeyError.MEDIA_KEYERR_OUTPUT?oj(b,"output-restricted"):1==c?oj(b,"expired"):oj(b,"internal-error"))}};
function nj(a,b){var c=a.f[b];return c?c:(c=a.c.shift())?(c.sessionId=b,a.f[b]=c):null}function mj(a,b,c){I.call(this);this.f=a;this.h=!1;this.a=this.b=null;this.c=b;this.g=c;this.sessionId="";this.expiration=NaN;this.closed=new u;this.keyStatuses=new pj}la(mj,I);
function qj(a,b,c){if(a.h)return Promise.reject(Error("The session is already initialized."));a.h=!0;try{if("persistent-license"==a.g)if(c)var d=new Uint8Array(Ab("LOAD_SESSION|"+c));else{var e=Ab("PERSISTENT|"),f=new Uint8Array(e.byteLength+b.byteLength);f.set(new Uint8Array(e),0);f.set(new Uint8Array(b),e.byteLength);d=f}else d=new Uint8Array(b)}catch(h){return Promise.reject(h)}a.b=new u;var g=kj("generateKeyRequest");try{a.f[g](a.c,d)}catch(h){if("InvalidStateError"!=h.name)return a.b=null,Promise.reject(h);
setTimeout(function(){try{this.f[g](this.c,d)}catch(k){this.b.reject(k),this.b=null}}.bind(a),10)}return a.b}m=mj.prototype;
m.ac=function(a,b){if(this.a)this.a.then(this.ac.bind(this,a,b))["catch"](this.ac.bind(this,a,b));else{this.a=a;if("webkit-org.w3.clearkey"==this.c){var c=D(b);var d=JSON.parse(c);"oct"!=d.keys[0].kty&&(this.a.reject(Error("Response is not a valid JSON Web Key Set.")),this.a=null);c=Fb(d.keys[0].k);d=Fb(d.keys[0].kid)}else c=new Uint8Array(b),d=null;var e=kj("addKey");try{this.f[e](this.c,c,d,this.sessionId)}catch(f){this.a.reject(f),this.a=null}}};
function oj(a,b){var c=a.keyStatuses;c.size=void 0==b?0:1;c.a=b;a.dispatchEvent(new B("keystatuseschange"))}m.generateRequest=function(a,b){return qj(this,b,null)};m.load=function(a){return"persistent-license"==this.g?qj(this,null,a):Promise.reject(Error("Not a persistent session."))};m.update=function(a){var b=new u;this.ac(b,a);return b};
m.close=function(){if("persistent-license"!=this.g){if(!this.sessionId)return this.closed.reject(Error("The session is not callable.")),this.closed;var a=kj("cancelKeyRequest");try{this.f[a](this.c,this.sessionId)}catch(b){}}this.closed.resolve();return this.closed};m.remove=function(){return"persistent-license"!=this.g?Promise.reject(Error("Not a persistent session.")):this.close()};function pj(){this.size=0;this.a=void 0}var fj;m=pj.prototype;m.forEach=function(a){this.a&&a(this.a,fj)};m.get=function(a){if(this.has(a))return this.a};
m.has=function(a){var b=fj;return this.a&&Ib(new Uint8Array(a),new Uint8Array(b))?!0:!1};m.entries=function(){};m.keys=function(){};m.values=function(){};Ki(function(){!window.HTMLVideoElement||navigator.requestMediaKeySystemAccess&&MediaKeySystemAccess.prototype.getConfiguration||(HTMLMediaElement.prototype.webkitGenerateKeyRequest?ej("webkit"):HTMLMediaElement.prototype.generateKeyRequest?ej(""):window.MSMediaKeys?(Zi=(new Uint8Array([0])).buffer,delete HTMLMediaElement.prototype.mediaKeys,HTMLMediaElement.prototype.mediaKeys=null,HTMLMediaElement.prototype.setMediaKeys=Si,window.MediaKeys=Ri,window.MediaKeySystemAccess=Qi,navigator.requestMediaKeySystemAccess=
Pi):(navigator.requestMediaKeySystemAccess=$i,delete HTMLMediaElement.prototype.mediaKeys,HTMLMediaElement.prototype.mediaKeys=null,HTMLMediaElement.prototype.setMediaKeys=aj,window.MediaKeys=bj,window.MediaKeySystemAccess=cj))});function rj(){var a=MediaSource.prototype.addSourceBuffer;MediaSource.prototype.addSourceBuffer=function(){var b=a.apply(this,arguments);b.abort=function(){};return b}}function sj(){var a=SourceBuffer.prototype.remove;SourceBuffer.prototype.remove=function(b,c){return a.call(this,b,c-.001)}}
function tj(){var a=MediaSource.prototype.endOfStream;MediaSource.prototype.endOfStream=function(){for(var b=0,c=0;c<this.sourceBuffers.length;++c){var f=this.sourceBuffers[c];f=f.buffered.end(f.buffered.length-1);b=Math.max(b,f)}if(!isNaN(this.duration)&&b<this.duration)for(this.nc=!0,b=0;b<this.sourceBuffers.length;++b)this.sourceBuffers[b].jc=!1;return a.apply(this,arguments)};var b=!1,c=MediaSource.prototype.addSourceBuffer;MediaSource.prototype.addSourceBuffer=function(){var a=c.apply(this,arguments);
a.mediaSource_=this;a.addEventListener("updateend",uj,!1);b||(this.addEventListener("sourceclose",vj,!1),b=!0);return a}}function uj(a){var b=a.target,c=b.mediaSource_;if(c.nc){a.preventDefault();a.stopPropagation();a.stopImmediatePropagation();b.jc=!0;for(a=0;a<c.sourceBuffers.length;++a)if(0==c.sourceBuffers[a].jc)return;c.nc=!1}}
function vj(a){a=a.target;for(var b=0;b<a.sourceBuffers.length;++b)a.sourceBuffers[b].removeEventListener("updateend",uj,!1);a.removeEventListener("sourceclose",vj,!1)}function wj(){var a=MediaSource.isTypeSupported;MediaSource.isTypeSupported=function(b){return"mp2t"==b.split(/ *; */)[0].split("/")[1]?!1:a(b)}}
function xj(){var a=MediaSource.isTypeSupported,b=/^dv(?:he|av)\./;MediaSource.isTypeSupported=function(c){for(var d=c.split(/ *; */),e=d[0],f={},g=1;g<d.length;++g){var h=d[g].split("="),k=h[0];h=h[1].replace(/"(.*)"/,"$1");f[k]=h}d=f.codecs;if(!d)return a(c);var l=!1,q=!1;c=d.split(",").filter(function(a){if(b.test(a))return q=!0,!1;/^(hev|hvc)1\.2/.test(a)&&(l=!0);return!0});q&&(l=!1);f.codecs=c.join(",");l&&(f.eotf="smpte2084");for(var r in f)e+="; "+r+'="'+f[r]+'"';return cast.__platform__.canDisplayType(e)}}
Ki(function(){if(window.MediaSource)if(window.cast&&cast.__platform__&&cast.__platform__.canDisplayType)xj();else if(navigator.vendor&&0<=navigator.vendor.indexOf("Apple")){var a=navigator.appVersion;wj();0<=a.indexOf("Version/8")?window.MediaSource=null:0<=a.indexOf("Version/9")?rj():0<=a.indexOf("Version/10")?(rj(),tj()):0<=a.indexOf("Version/11")&&(rj(),sj())}});Ki(function(){if(window.HTMLMediaElement){var a=HTMLMediaElement.prototype.play;HTMLMediaElement.prototype.play=function(){var b=a.apply(this,arguments);b&&b["catch"](function(){});return b}}});function yj(){return{droppedVideoFrames:this.webkitDroppedFrameCount,totalVideoFrames:this.webkitDecodedFrameCount,corruptedVideoFrames:0,creationTime:NaN,totalFrameDelay:0}}Ki(function(){if(window.HTMLVideoElement){var a=HTMLVideoElement.prototype;!a.getVideoPlaybackQuality&&"webkitDroppedFrameCount"in a&&(a.getVideoPlaybackQuality=yj)}});function zj(a,b,c){return new window.TextTrackCue(a,b,c)}function Aj(a,b,c){return new window.TextTrackCue(a+"-"+b+"-"+c,a,b,c)}Ki(function(){if(!window.VTTCue&&window.TextTrackCue){var a=TextTrackCue.length;if(3==a)window.VTTCue=zj;else if(6==a)window.VTTCue=Aj;else{try{var b=!!zj(1,2,"")}catch(c){b=!1}b&&(window.VTTCue=zj)}}});function Bj(){}Bj.prototype.parseInit=function(){};
Bj.prototype.parseMedia=function(a,b){var c=D(a),d=[],e=new DOMParser,f=null;try{f=e.parseFromString(c,"text/xml")}catch(ib){throw new p(2,2,2005);}if(f){if(e=f.getElementsByTagName("tt")[0]){f=e.getAttribute("ttp:frameRate");var g=e.getAttribute("ttp:subFrameRate");var h=e.getAttribute("ttp:frameRateMultiplier");var k=e.getAttribute("ttp:tickRate");c=e.getAttribute("xml:space")||"default"}else throw new p(2,2,2005);if("default"!=c&&"preserve"!=c)throw new p(2,2,2005);c="default"==c;f=new Cj(f,g,
h,k);g=Dj(e.getElementsByTagName("styling")[0]);h=Dj(e.getElementsByTagName("layout")[0]);k=[];for(var l=0;l<h.length;l++){var q=h[l],r=g;var t=new fc;var v=q.getAttribute("xml:id");if(v){t.id=v;var y;if(y=Ej(q,r,"tts:extent"))y=(v=Fj.exec(y))||Gj.exec(y),null!=y&&(t.width=Number(y[1]),t.height=Number(y[2]),t.widthUnits=v?tc:0,t.heightUnits=v?tc:0);if(q=Ej(q,r,"tts:origin"))y=(v=Fj.exec(q))||Gj.exec(q),null!=y&&(t.viewportAnchorX=Number(y[1]),t.viewportAnchorY=Number(y[2]),t.viewportAnchorUnits=v?
tc:0)}else t=null;t&&k.push(t)}e=Dj(e.getElementsByTagName("body")[0]);for(l=0;l<e.length;l++)(t=Hj(e[l],b.periodStart,f,g,h,k,c))&&d.push(t)}return d};
var Fj=/^(\d{1,2}|100)% (\d{1,2}|100)%$/,Ij=/^(\d+px|\d+em)$/,Gj=/^(\d+)px (\d+)px$/,Jj=/^(\d{2,}):(\d{2}):(\d{2}):(\d{2})\.?(\d+)?$/,Kj=/^(?:(\d{2,}):)?(\d{2}):(\d{2})$/,Lj=/^(?:(\d{2,}):)?(\d{2}):(\d{2}\.\d{2,})$/,Mj=/^(\d*(?:\.\d*)?)f$/,Nj=/^(\d*(?:\.\d*)?)t$/,Oj=/^(?:(\d*(?:\.\d*)?)h)?(?:(\d*(?:\.\d*)?)m)?(?:(\d*(?:\.\d*)?)s)?(?:(\d*(?:\.\d*)?)ms)?$/,Pj={left:"start",center:lc,right:"end",start:"start",end:"end"},Qj={left:"line-left",center:"center",right:"line-right"};
function Dj(a){var b=[];if(!a)return b;for(var c=a.childNodes,d=0;d<c.length;d++){var e="span"==c[d].nodeName&&"p"==a.nodeName;c[d].nodeType!=Node.ELEMENT_NODE||"br"==c[d].nodeName||e||(e=Dj(c[d]),b=b.concat(e))}b.length||b.push(a);return b}function Rj(a,b){for(var c=a.childNodes,d=0;d<c.length;d++)if("br"==c[d].nodeName&&0<d)c[d-1].textContent+="\n";else if(0<c[d].childNodes.length)Rj(c[d],b);else if(b){var e=c[d].textContent.trim();e=e.replace(/\s+/g," ");c[d].textContent=e}}
function Hj(a,b,c,d,e,f,g){if(!a.hasAttribute("begin")&&!a.hasAttribute("end")&&/^\s*$/.test(a.textContent))return null;Rj(a,g);g=Sj(a.getAttribute("begin"),c);var h=Sj(a.getAttribute("end"),c);c=Sj(a.getAttribute("dur"),c);var k=a.textContent;null==h&&null!=c&&(h=g+c);if(null==g||null==h)throw new p(2,2,2001);b=new E(g+b,h+b,k);if((e=Tj(a,"region",e))&&e.getAttribute("xml:id")){var l=e.getAttribute("xml:id");f=f.filter(function(a){return a.id==l});b.region=f[0]}Uj(b,a,e,d);return b}
function Uj(a,b,c,d){"rtl"==Vj(b,c,d,"tts:direction")&&(a.writingDirection=1);var e=Vj(b,c,d,"tts:writingMode");"tb"==e||"tblr"==e?a.writingDirection=2:"tbrl"==e?a.writingDirection=3:"rltb"==e||"rl"==e?a.writingDirection=1:e&&(a.writingDirection=jc);if(e=Vj(b,c,d,"tts:textAlign"))a.positionAlign=Qj[e],a.lineAlign=Pj[e],a.textAlign=pc[e.toUpperCase()];if(e=Vj(b,c,d,"tts:displayAlign"))a.displayAlign=qc[e.toUpperCase()];if(e=Vj(b,c,d,"tts:color"))a.color=e;if(e=Vj(b,c,d,"tts:backgroundColor"))a.backgroundColor=
e;if(e=Vj(b,c,d,"tts:fontFamily"))a.fontFamily=e;(e=Vj(b,c,d,"tts:fontWeight"))&&"bold"==e&&(a.fontWeight=700);(e=Vj(b,c,d,"tts:wrapOption"))&&"noWrap"==e&&(a.wrapLine=!1);(e=Vj(b,c,d,"tts:lineHeight"))&&e.match(Ij)&&(a.lineHeight=e);(e=Vj(b,c,d,"tts:fontSize"))&&e.match(Ij)&&(a.fontSize=e);if(e=Vj(b,c,d,"tts:fontStyle"))a.fontStyle=sc[e.toUpperCase()];(c=Ej(c,d,"tts:textDecoration"))&&Wj(a,c);(b=Xj(b,d,"tts:textDecoration"))&&Wj(a,b)}
function Wj(a,b){for(var c=b.split(" "),d=0;d<c.length;d++)switch(c[d]){case "underline":0>a.textDecoration.indexOf("underline")&&a.textDecoration.push("underline");break;case "noUnderline":0<=a.textDecoration.indexOf("underline")&&Ta(a.textDecoration,"underline");break;case "lineThrough":0>a.textDecoration.indexOf("lineThrough")&&a.textDecoration.push("lineThrough");break;case "noLineThrough":0<=a.textDecoration.indexOf("lineThrough")&&Ta(a.textDecoration,"lineThrough");break;case "overline":0>a.textDecoration.indexOf("overline")&&
a.textDecoration.push("overline");break;case "noOverline":0<=a.textDecoration.indexOf("overline")&&Ta(a.textDecoration,"overline")}}function Vj(a,b,c,d){return(a=Xj(a,c,d))?a:Ej(b,c,d)}function Ej(a,b,c){for(var d=Dj(a),e=0;e<d.length;e++){var f=d[e].getAttribute(c);if(f)return f}return(a=Tj(a,"style",b))?a.getAttribute(c):null}function Xj(a,b,c){return(a=Tj(a,"style",b))?a.getAttribute(c):null}
function Tj(a,b,c){if(!a||1>c.length)return null;var d=null,e=a;for(a=null;e&&!(a=e.getAttribute(b))&&(e=e.parentNode,e instanceof Element););if(b=a)for(a=0;a<c.length;a++)if(c[a].getAttribute("xml:id")==b){d=c[a];break}return d}
function Sj(a,b){var c=null;if(Jj.test(a)){c=Jj.exec(a);var d=Number(c[1]),e=Number(c[2]),f=Number(c[3]),g=Number(c[4]);g+=(Number(c[5])||0)/b.b;f+=g/b.frameRate;c=f+60*e+3600*d}else Kj.test(a)?c=Yj(Kj,a):Lj.test(a)?c=Yj(Lj,a):Mj.test(a)?(c=Mj.exec(a),c=Number(c[1])/b.frameRate):Nj.test(a)?(c=Nj.exec(a),c=Number(c[1])/b.a):Oj.test(a)&&(c=Yj(Oj,a));return c}
function Yj(a,b){var c=a.exec(b);return null==c||""==c[0]?null:(Number(c[4])||0)/1E3+(Number(c[3])||0)+60*(Number(c[2])||0)+3600*(Number(c[1])||0)}function Cj(a,b,c,d){this.frameRate=Number(a)||30;this.b=Number(b)||1;this.a=Number(d);0==this.a&&(this.a=a?this.frameRate*this.b:1);c&&(a=/^(\d+) (\d+)$/g.exec(c))&&(this.frameRate*=a[1]/a[2])}F["application/ttml+xml"]=Bj;function Zj(){this.a=new Bj}Zj.prototype.parseInit=function(a){var b=!1;(new Q).B("moov",R).B("trak",R).B("mdia",R).B("minf",R).B("stbl",R).V("stsd",oe).B("stpp",function(a){b=!0;a.ja.stop()}).parse(a);if(!b)throw new p(2,2,2007);};Zj.prototype.parseMedia=function(a,b){var c=!1,d=[];(new Q).B("mdat",pe(function(a){c=!0;d=d.concat(this.a.parseMedia(a,b))}.bind(this))).parse(a);if(!c)throw new p(2,2,2007);return d};F['application/mp4; codecs="stpp"']=Zj;
F['application/mp4; codecs="stpp.TTML.im1t"']=Zj;function ak(){}ak.prototype.parseInit=function(){};
ak.prototype.parseMedia=function(a,b){var c=D(a);c=c.replace(/\r\n|\r(?=[^\n]|$)/gm,"\n");c=c.split(/\n{2,}/m);if(!/^WEBVTT($|[ \t\n])/m.test(c[0]))throw new p(2,2,2E3);var d=b.segmentStart;if(null==d&&(d=0,0<=c[0].indexOf("X-TIMESTAMP-MAP"))){var e=c[0].match(/LOCAL:((?:(\d{1,}):)?(\d{2}):(\d{2})\.(\d{3}))/m),f=c[0].match(/MPEGTS:(\d+)/m);e&&f&&(d=bk(new sf(e[1])),d=b.periodStart+(Number(f[1])/9E4-d))}f=[];var g=c[0].split("\n");for(e=1;e<g.length;e++)if(/^Region:/.test(g[e])){var h=new sf(g[e]),
k=new fc;vf(h);tf(h);for(var l=vf(h);l;){var q=k,r=l;(l=/^id=(.*)$/.exec(r))?q.id=l[1]:(l=/^width=(\d{1,2}|100)%$/.exec(r))?q.width=Number(l[1]):(l=/^lines=(\d+)$/.exec(r))?(q.height=Number(l[1]),q.heightUnits=2):(l=/^regionanchor=(\d{1,2}|100)%,(\d{1,2}|100)%$/.exec(r))?(q.regionAnchorX=Number(l[1]),q.regionAnchorY=Number(l[2])):(l=/^viewportanchor=(\d{1,2}|100)%,(\d{1,2}|100)%$/.exec(r))?(q.viewportAnchorX=Number(l[1]),q.viewportAnchorY=Number(l[2])):/^scroll=up$/.exec(r)&&(q.scroll="up");tf(h);
l=vf(h)}f.push(k)}e=[];for(h=1;h<c.length;h++){g=c[h].split("\n");l=g;r=d;g=f;if(1==l.length&&!l[0]||/^NOTE($|[ \t])/.test(l[0])||"STYLE"==l[0])g=null;else{k=null;0>l[0].indexOf("--\x3e")&&(k=l[0],l.splice(0,1));q=new sf(l[0]);var t=bk(q),v=uf(q,/[ \t]+--\x3e[ \t]+/g),y=bk(q);if(null==t||null==v||null==y)throw new p(2,2,2001);l=new E(t+r,y+r,l.slice(1).join("\n").trim());tf(q);for(r=vf(q);r;)ck(l,r,g),tf(q),r=vf(q);null!=k&&(l.id=k);g=l}g&&e.push(g)}return e};
function ck(a,b,c){var d;if(d=/^align:(start|middle|center|end|left|right)$/.exec(b))b=d[1],"middle"==b?a.textAlign=ic:a.textAlign=pc[b.toUpperCase()];else if(d=/^vertical:(lr|rl)$/.exec(b))a.writingDirection="lr"==d[1]?2:3;else if(d=/^size:([\d.]+)%$/.exec(b))a.size=Number(d[1]);else if(d=/^position:([\d.]+)%(?:,(line-left|line-right|center|start|end))?$/.exec(b))a.position=Number(d[1]),d[2]&&(b=d[2],a.positionAlign="line-left"==b||"start"==b?"line-left":"line-right"==b||"end"==b?"line-right":"center");
else if(d=/^region:(.*)$/.exec(b)){if(b=dk(c,d[1]))a.region=b}else if(c=/^line:([\d.]+)%(?:,(start|end|center))?$/.exec(b))a.lineInterpretation=1,a.line=Number(c[1]),c[2]&&(a.lineAlign=rc[c[2].toUpperCase()]);else if(c=/^line:(-?\d+)(?:,(start|end|center))?$/.exec(b))a.lineInterpretation=kc,a.line=Number(c[1]),c[2]&&(a.lineAlign=rc[c[2].toUpperCase()])}function dk(a,b){var c=a.filter(function(a){return a.id==b});return c.length?c[0]:null}
function bk(a){a=uf(a,/(?:(\d{1,}):)?(\d{2}):(\d{2})\.(\d{3})/g);if(null==a)return null;var b=Number(a[2]),c=Number(a[3]);return 59<b||59<c?null:Number(a[4])/1E3+c+60*b+3600*(Number(a[1])||0)}F["text/vtt"]=ak;F['text/vtt; codecs="vtt"']=ak;function ek(){this.a=null}ek.prototype.parseInit=function(a){var b=!1;(new Q).B("moov",R).B("trak",R).B("mdia",R).V("mdhd",function(a){0==a.version?(a.s.G(4),a.s.G(4),this.a=a.s.D(),a.s.G(4)):(a.s.G(8),a.s.G(8),this.a=a.s.D(),a.s.G(8));a.s.G(4)}.bind(this)).B("minf",R).B("stbl",R).V("stsd",oe).B("wvtt",function(){b=!0}).parse(a);if(!this.a)throw new p(2,2,2008);if(!b)throw new p(2,2,2008);};
ek.prototype.parseMedia=function(a,b){if(!this.a)throw new p(2,2,2008);var c=0,d=[],e=[],f=[],g=!1,h=!1,k=!1,l=null;(new Q).B("moof",R).B("traf",R).V("tfdt",function(a){g=!0;c=0==a.version?a.s.D():a.s.Oa()}).V("tfhd",function(a){var b=a.flags;a=a.s;a.G(4);b&1&&a.G(8);b&2&&a.G(4);l=b&8?a.D():null}).V("trun",function(a){h=!0;var b=a.version,c=a.flags;a=a.s;var e=a.D();c&1&&a.G(4);c&4&&a.G(4);for(var f=[],g=0;g<e;g++){var k={duration:null,bc:null};c&256&&(k.duration=a.D());c&512&&a.G(4);c&1024&&a.G(4);
c&2048&&(k.bc=0==b?a.D():a.Ec());f.push(k)}d=f}).B("vtte",function(){e.push(null)}).B("vttc",pe(function(a){e.push(a)})).B("mdat",function(a){k=!0;R(a)}).parse(a);if(!k&&!g&&!h)throw new p(2,2,2008);for(var q=c,r=0;r<d.length;r++){var t=d[r],v=e[r],y=t.duration||l;y&&(t=t.bc?c+t.bc:q,q=t+y,v&&f.push(fk(v,b.periodStart+t/this.a,b.periodStart+q/this.a)))}return f.filter(nb)};
function fk(a,b,c){var d,e,f;(new Q).B("payl",pe(function(a){d=D(a)})).B("iden",pe(function(a){e=D(a)})).B("sttg",pe(function(a){f=D(a)})).parse(a);return d?gk(d,e,f,b,c):null}function gk(a,b,c,d,e){a=new E(d,e,a);b&&(a.id=b);if(c)for(b=new sf(c),c=vf(b);c;)ck(a,c,[]),tf(b),c=vf(b);return a}F['application/mp4; codecs="wvtt"']=ek;}.call(g,this));
if (typeof(module)!="undefined"&&module.exports)module.exports=g.shaka;
else if (true)!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return g.shaka}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
else this.shaka=g.shaka;
})();


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasYoutubeSource = exports.maybeSetStreamPriority = exports.isIos = exports.isSafari = exports.getDefaultOptions = exports.checkNativeHlsSupport = exports.createVidiunPlayerContainer = exports.setLogLevel = exports.validateConfig = exports.attachToFirstClick = exports.setStorageTextStyle = exports.applyCastSupport = exports.applyStorageSupport = exports.setStorageConfig = exports.supportLegacyOptions = exports.printSetupMessages = undefined;

var _playerDefaults = __webpack_require__(363);

var _pakhshkitJs = __webpack_require__(9);

var _validationError = __webpack_require__(364);

var _storageManager = __webpack_require__(365);

var _storageManager2 = _interopRequireDefault(_storageManager);

var _logger = __webpack_require__(16);

var _logger2 = _interopRequireDefault(_logger);

var _externalStreamRedirectHelper = __webpack_require__(367);

var _remotePlayerManager = __webpack_require__(98);

var _remoteControl = __webpack_require__(69);

var _vidiunPlayer = __webpack_require__(44);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setupMessages = [];

var CONTAINER_CLASS_NAME = 'vidiun-player-container';
var VIDIUN_PLAYER_DEBUG_QS = 'debugVidiunPlayer';

/**
 * Validate the initial user config.
 * @private
 * @param {PartialVPOptionsObject} options - partial vidiun player options.
 * @returns {void}
 */
function validateConfig(options) {
  if (!options) {
    throw new Error(_validationError.ValidationErrorType.INITIAL_CONFIG_REQUIRED);
  }
  validateTargetId(options.targetId);
  validateProviderConfig(options.provider);
}

/**
 * Validate the user input for target id.
 * @private
 * @param {string} targetId - The DOM element id which the player will be append to.
 * @returns {void}
 */
function validateTargetId(targetId) {
  if (!targetId) {
    throw new Error(_validationError.ValidationErrorType.TARGET_ID_REQUIRED);
  }
  var targetIdElement = document.getElementById(targetId);
  if (!targetIdElement) {
    throw new Error(_validationError.ValidationErrorType.DOM_ELEMENT_WITH_TARGET_ID_REQUIRED + targetId);
  }
  if (targetIdElement.getElementsByClassName(CONTAINER_CLASS_NAME).length > 0) {
    throw new Error(_validationError.ValidationErrorType.TARGET_ID_ALREADY_USED + targetId);
  }
}

/**
 * Validate the initial user input for the provider options.
 * @private
 * @param {ProviderOptionsObject} providerOptions - provider options.
 * @returns {void}
 */
function validateProviderConfig(providerOptions) {
  if (!providerOptions.partnerId && providerOptions.partnerId !== 0) {
    throw new Error(_validationError.ValidationErrorType.PARTNER_ID_REQUIRED);
  }
}

/**
 * Creates the player container dom element.
 * @private
 * @param {string} targetId - The div id which the player will append to.
 * @returns {string} - The player container id.
 */
function createVidiunPlayerContainer(targetId) {
  var el = document.createElement('div');
  el.id = _pakhshkitJs.Utils.Generator.uniqueId(5);
  el.className = CONTAINER_CLASS_NAME;
  el.setAttribute('tabindex', '-1');
  var parentNode = document.getElementById(targetId);
  if (parentNode && el) {
    parentNode.appendChild(el);
  }
  return el.id;
}

/**
 * Sets the storage config on the player config if certain conditions are met.
 * @private
 * @param {VPOptionsObject} options - vidiun player options
 * @returns {void}
 */
function setStorageConfig(options) {
  if (!options.disableUserCache && _storageManager2.default.isLocalStorageAvailable() && _storageManager2.default.hasStorage()) {
    _pakhshkitJs.Utils.Object.mergeDeep(options, _storageManager2.default.getStorageConfig());
  }
}

/**
 * Applies cache support if it's supported by the environment.
 * @private
 * @param {VidiunPlayer} player - The Vidiun player.
 * @returns {void}
 */
function applyStorageSupport(player) {
  if (_storageManager2.default.isLocalStorageAvailable()) {
    _storageManager2.default.attach(player);
  }
}

/**
 * Loads the registered remote players.
 * @private
 * @param {VPOptionsObject} defaultOptions - The vidiun player options.
 * @param {VidiunPlayer} player - The Vidiun player.
 * @returns {void}
 */
function applyCastSupport(defaultOptions, player) {
  if (defaultOptions.cast) {
    _remotePlayerManager.RemotePlayerManager.load(defaultOptions.cast, new _remoteControl.RemoteControl(player));
  }
}

/**
 * Sets the player text style from storage.
 * @private
 * @param {VidiunPlayer} player - The Vidiun player.
 * @returns {void}
 */
function setStorageTextStyle(player) {
  if (_storageManager2.default.isLocalStorageAvailable()) {
    var textStyleObj = _storageManager2.default.getPlayerTextStyle();
    if (textStyleObj) {
      player.textStyle = _pakhshkitJs.Utils.Object.mergeDeep(new _pakhshkitJs.TextStyle(), textStyleObj);
    }
  }
}

/**
 * Call to setCapabilities on the first UI_CLICKED event
 * @private
 * @param {Player} player - The Vidiun player.
 * @returns {void}
 */
function attachToFirstClick(player) {
  if (isIos()) {
    var onUIClicked = function onUIClicked() {
      player.removeEventListener(player.Event.UI.UI_CLICKED, onUIClicked);
      (0, _pakhshkitJs.setCapabilities)(_pakhshkitJs.EngineType.HTML5, { autoplay: true });
    };
    var onSourceSelected = function onSourceSelected() {
      player.removeEventListener(player.Event.SOURCE_SELECTED, onSourceSelected);
      player.addEventListener(player.Event.UI.UI_CLICKED, onUIClicked);
    };
    player.addEventListener(player.Event.SOURCE_SELECTED, onSourceSelected);
  }
}

/**
 * check the player debug mode according to config or URL query string params
 * @private
 * @returns {boolean} - if to set debug mode or not
 */
function isDebugMode() {
  var isDebugMode = false;
  if (window.DEBUG_VIDIUN_PLAYER === true) {
    isDebugMode = true;
  } else if (window.URLSearchParams) {
    var urlParams = new URLSearchParams(window.location.search);
    isDebugMode = urlParams.has(VIDIUN_PLAYER_DEBUG_QS);
  } else {
    isDebugMode = !!getUrlParameter(VIDIUN_PLAYER_DEBUG_QS);
  }
  return isDebugMode;
}

/**
 * set the logger
 * @private
 * @param {VPOptionsObject} options - vidiun player options
 * @returns {void}
 */
function setLogLevel(options) {
  var logLevelObj = _logger.LogLevel.ERROR;
  if (isDebugMode()) {
    logLevelObj = _logger.LogLevel.DEBUG;
    options.logLevel = _logger.LogLevel.DEBUG.name;
  } else if (options.logLevel && _logger.LogLevel[options.logLevel]) {
    logLevelObj = _logger.LogLevel[options.logLevel];
  }
  options.ui.logLevel = options.provider.logLevel = logLevelObj.name;
  (0, _logger.setLogLevel)(logLevelObj);
}

/**
 * gets the url query string parameter
 * @private
 * @param {string} name - name of query string param
 * @returns {string} - value of the query string param
 */
function getUrlParameter(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

/**
 * Checks if the server UIConf exist
 * @private
 * @param {number} uiConfId - The server UIConf
 * @returns {boolean} - server UIConf exist
 */
function serverUIConfExist(uiConfId) {
  var UIConf = _pakhshkitJs.Utils.Object.getPropertyPath(window, '__vidiunplayerdata.UIConf');
  var hasUiConfId = uiConfId !== null && uiConfId !== undefined;
  return hasUiConfId && (UIConf !== undefined && UIConf[uiConfId] !== undefined || false);
}

/**
 * Extracts the server UIConf
 * @private
 * @param {number} uiConfId - The server UIConf
 * @returns {Object} - The server UIConf
 */
function extractServerUIConf(uiConfId) {
  var config = {};
  if (serverUIConfExist(uiConfId)) {
    config = window.__vidiunplayerdata.UIConf[uiConfId];
  }
  return config;
}

/**
 * Gets the default options after merging the user options with the uiConf options and the default internal options.
 * @private
 * @param {PartialVPOptionsObject} options - partial user vidiun player options.
 * @returns {VPOptionsObject} - default vidiun player options.
 */
function getDefaultOptions(options) {
  var targetId = createVidiunPlayerContainer(options.targetId);
  var defaultOptions = {
    targetId: options.targetId,
    provider: {
      partnerId: options.provider.partnerId
    },
    ui: {
      targetId: targetId
    }
  };
  _pakhshkitJs.Utils.Object.mergeDeep(defaultOptions, options);
  if (defaultOptions.provider.uiConfId) {
    var uiConfOptions = supportLegacyOptions(extractServerUIConf(defaultOptions.provider.uiConfId));
    defaultOptions = _pakhshkitJs.Utils.Object.mergeDeep({}, uiConfOptions, defaultOptions);
  }
  checkNativeHlsSupport(defaultOptions);
  checkNativeTextTracksSupport(defaultOptions);
  (0, _playerDefaults.setDefaultAnalyticsPlugin)(defaultOptions);
  configureVrDefaultOptions(defaultOptions);
  configureLGTVDefaultOptions(defaultOptions);
  (0, _externalStreamRedirectHelper.configureExternalStreamRedirect)(defaultOptions);
  return defaultOptions;
}

/**
 * Sets config option for native HLS playback
 * @private
 * @param {VPOptionsObject} options - vidiun player options
 * @returns {void}
 */
function checkNativeHlsSupport(options) {
  if (isSafari() || isIos()) {
    var preferNativeHlsValue = _pakhshkitJs.Utils.Object.getPropertyPath(options, 'playback.preferNative.hls');
    if (typeof preferNativeHlsValue !== 'boolean') {
      _pakhshkitJs.Utils.Object.mergeDeep(options, {
        playback: {
          preferNative: {
            hls: true
          }
        }
      });
    }
  }
}

/**
 * Sets config option for native text track support
 * @private
 * @param {VPOptionsObject} options - vidiun player options
 * @returns {void}
 */
function checkNativeTextTracksSupport(options) {
  if (isSafari() || isIos()) {
    var useNativeTextTrack = _pakhshkitJs.Utils.Object.getPropertyPath(options, 'playback.useNativeTextTrack');
    if (typeof useNativeTextTrack !== 'boolean') {
      _pakhshkitJs.Utils.Object.mergeDeep(options, {
        playback: {
          useNativeTextTrack: true
        }
      });
    }
  }
}

/**
 * Sets config option fullscreen element for Vr Mode support
 * @private
 * @param {VPOptionsObject} options - vidiun player options
 * @returns {void}
 */
function configureVrDefaultOptions(options) {
  if (options.plugins && options.plugins.vr && !options.plugins.vr.disable) {
    var fullscreenConfig = _pakhshkitJs.Utils.Object.getPropertyPath(options, 'playback.inBrowserFullscreen');
    if (typeof fullscreenConfig !== 'boolean') {
      _pakhshkitJs.Utils.Object.mergeDeep(options, {
        playback: {
          inBrowserFullscreen: true
        }
      });
    }
  }
}

/**
 * Sets config option for LG TV
 * @private
 * @param {VPOptionsObject} options - vidiun player options
 * @returns {void}
 */
function configureLGTVDefaultOptions(options) {
  if (isLGTV() && options.plugins && options.plugins.ima) {
    var imaForceReload = _pakhshkitJs.Utils.Object.getPropertyPath(options, 'plugins.ima.forceReloadMediaAfterAds');
    var delayUntilSourceSelected = _pakhshkitJs.Utils.Object.getPropertyPath(options, 'plugins.ima.delayInitUntilSourceSelected');
    var preferNativeHls = _pakhshkitJs.Utils.Object.getPropertyPath(options, 'playback.preferNative.hls');

    if (typeof imaForceReload !== 'boolean') {
      options = _pakhshkitJs.Utils.Object.createPropertyPath(options, 'plugins.ima.forceReloadMediaAfterAds', true);
    }
    if (typeof preferNativeHls !== 'boolean') {
      options = _pakhshkitJs.Utils.Object.createPropertyPath(options, 'playback.preferNative.hls', true);
    }
    if (typeof delayUntilSourceSelected !== 'boolean') {
      options = _pakhshkitJs.Utils.Object.createPropertyPath(options, 'plugins.ima.delayInitUntilSourceSelected', true);
    }
  }
}

/**
 * Transform options structure from legacy structure to new structure.
 * @private
 * @param {Object} options - The options with the legacy structure.
 * @return {PartialVPOptionsObject} - Partial options with the expected structure.
 */
function supportLegacyOptions(options) {
  var removePlayerEntry = function removePlayerEntry() {
    if (options.player) {
      setupMessages.push({
        level: 'warn',
        msg: 'Path config.player will be deprecated soon. Please update your config structure as describe here: ' + "https://github.com/vidiun/vidiun-player-js/blob/master/docs/configuration.md"
      });
      var playerOptions = _pakhshkitJs.Utils.Object.copyDeep(options.player);
      delete options.player;
      _pakhshkitJs.Utils.Object.mergeDeep(options, playerOptions);
    }
  };
  var moveProp = function moveProp(propPath, targetPath) {
    if (_pakhshkitJs.Utils.Object.hasPropertyPath(options, propPath)) {
      setupMessages.push({
        level: 'warn',
        msg: 'Path config.player.' + propPath + ' will be deprecated soon. Please update your config structure as describe here: ' + "https://github.com/vidiun/vidiun-player-js/blob/master/docs/configuration.md"
      });
      if (!_pakhshkitJs.Utils.Object.hasPropertyPath(options, targetPath)) {
        var propValue = _pakhshkitJs.Utils.Object.getPropertyPath(options, propPath);
        var propObj = _pakhshkitJs.Utils.Object.createPropertyPath({}, targetPath, propValue);
        _pakhshkitJs.Utils.Object.mergeDeep(options, propObj);
        _pakhshkitJs.Utils.Object.deletePropertyPath(options, propPath);
      } else {
        _pakhshkitJs.Utils.Object.deletePropertyPath(options, propPath);
      }
    }
  };
  var moves = [['duration', 'sources.duration'], ['type', 'sources.type'], ['dvr', 'sources.dvr'], ['id', 'sources.id'], ['name', 'metadata.name'], ['metadata.poster', 'sources.poster'], ['metadata', 'sources.metadata'], ['ui.components.fullscreen.inBrowserFullscreenForIOS', 'playback.inBrowserFullscreen']];
  removePlayerEntry();
  moves.forEach(function (move) {
    return moveProp(move[0], move[1]);
  });
  return options;
}

/**
 * Prints early setup messages.
 * @private
 * @returns {void}
 */
function printSetupMessages() {
  setupMessages.forEach(function (msgObj) {
    return (0, _logger2.default)('VidiunPlayer:Setup')[msgObj.level](msgObj.msg);
  });
}

/**
 * Returns true if user agent indicate that browser is Safari
 * @private
 * @returns {boolean} - if browser is Safari
 */
function isSafari() {
  return _pakhshkitJs.Utils.Object.hasPropertyPath(_pakhshkitJs.Env, 'browser.name') && _pakhshkitJs.Env.browser.name.includes('Safari');
}

/**
 * Returns true if user agent indicate that browser is Chrome on iOS
 * @private
 * @returns {boolean} - if browser is Chrome on iOS
 */
function isIos() {
  return _pakhshkitJs.Env.os.name === 'iOS';
}

/**
 * Returns true if user agent indicate that browser is LG TV
 * @private
 * @returns {boolean} - if browser is in LG TV
 */
function isLGTV() {
  return (/^(?=.*\bweb0s\b)(?=.*\bsmarttv\b).*$/i.test(_pakhshkitJs.Env.ua)
  );
}

/**
 * set stream priority according to playerConfig
 * @param {Player} player - player
 * @param {PartialVPOptionsObject} playerConfig - player config
 * @return {void}
 */
function maybeSetStreamPriority(player, playerConfig) {
  if (playerConfig.sources && hasYoutubeSource(playerConfig.sources)) {
    var playbackConfig = player.config.playback;
    var hasYoutube = false;
    playbackConfig.streamPriority.forEach(function (sp) {
      if (sp.engine === 'youtube') {
        hasYoutube = true;
      }
    });
    if (!hasYoutube) {
      playbackConfig.streamPriority.push({
        engine: 'youtube',
        format: 'progressive'
      });
    }

    playerConfig.playback = playbackConfig;
  }
}

/**
 * returns true if sources contain youtube video source
 * @param {PKSourcesConfigObject} sources - thr sources object
 * @returns {boolean} - true if sources contain youtube source
 */
function hasYoutubeSource(sources) {
  var source = sources && sources.progressive;
  return !!(source && source[0] && source[0].mimetype === 'video/youtube');
}

exports.printSetupMessages = printSetupMessages;
exports.supportLegacyOptions = supportLegacyOptions;
exports.setStorageConfig = setStorageConfig;
exports.applyStorageSupport = applyStorageSupport;
exports.applyCastSupport = applyCastSupport;
exports.setStorageTextStyle = setStorageTextStyle;
exports.attachToFirstClick = attachToFirstClick;
exports.validateConfig = validateConfig;
exports.setLogLevel = setLogLevel;
exports.createVidiunPlayerContainer = createVidiunPlayerContainer;
exports.checkNativeHlsSupport = checkNativeHlsSupport;
exports.getDefaultOptions = getDefaultOptions;
exports.isSafari = isSafari;
exports.isIos = isIos;
exports.maybeSetStreamPriority = maybeSetStreamPriority;
exports.hasYoutubeSource = hasYoutubeSource;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RemoteAvailablePayload = exports.RemoteDisconnectedPayload = exports.RemoteConnectedPayload = exports.RemotePayload = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _baseRemotePlayer = __webpack_require__(70);

var _remoteSession = __webpack_require__(53);

var _playerSnapshot = __webpack_require__(99);

var _remotePlayerUi = __webpack_require__(140);

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class RemotePayload
 * @param {BaseRemotePlayer} player - The active remote player.
 */
var RemotePayload = function () {
  function RemotePayload(player) {
    _classCallCheck(this, RemotePayload);

    this._player = player;
  }

  /**
   * The active remote player.
   * @type {BaseRemotePlayer}
   * @instance
   * @memberof RemotePayload
   */


  _createClass(RemotePayload, [{
    key: 'player',
    get: function get() {
      return this._player;
    }
  }]);

  return RemotePayload;
}();

/**
 * @class RemoteConnectedPayload
 * @param {BaseRemotePlayer} player - The active remote player.
 * @param {RemoteSession} session - The remote session.
 * @param {RemotePlayerUI} [ui] - Optional remote player UI preset.
 * @extends RemotePayload
 */


var RemoteConnectedPayload = function (_RemotePayload) {
  _inherits(RemoteConnectedPayload, _RemotePayload);

  function RemoteConnectedPayload(player, session, ui) {
    _classCallCheck(this, RemoteConnectedPayload);

    var _this = _possibleConstructorReturn(this, (RemoteConnectedPayload.__proto__ || Object.getPrototypeOf(RemoteConnectedPayload)).call(this, player));

    _this._session = session;
    if (ui) {
      _this._ui = ui;
    }
    return _this;
  }

  /**
   * Remote player UI preset.
   * @type {?RemotePlayerUI}
   * @instance
   * @memberof RemoteConnectedPayload
   */


  _createClass(RemoteConnectedPayload, [{
    key: 'ui',
    get: function get() {
      return this._ui;
    }

    /**
     * Remote session.
     * @type {RemoteSession}
     * @instance
     * @memberof RemoteConnectedPayload
     */

  }, {
    key: 'session',
    get: function get() {
      return this._session;
    }
  }]);

  return RemoteConnectedPayload;
}(RemotePayload);

/**
 * @class RemoteDisconnectedPayload
 * @param {BaseRemotePlayer} player - The active remote player.
 * @param {PlayerSnapshot} snapshot - The remote player snapshot.
 * @extends RemotePayload
 */


var RemoteDisconnectedPayload = function (_RemotePayload2) {
  _inherits(RemoteDisconnectedPayload, _RemotePayload2);

  function RemoteDisconnectedPayload(player, snapshot) {
    _classCallCheck(this, RemoteDisconnectedPayload);

    var _this2 = _possibleConstructorReturn(this, (RemoteDisconnectedPayload.__proto__ || Object.getPrototypeOf(RemoteDisconnectedPayload)).call(this, player));

    _this2._snapshot = snapshot;
    return _this2;
  }

  /**
   * Remote player snapshot.
   * @type {PlayerSnapshot}
   * @instance
   * @memberof RemoteDisconnectedPayload
   */


  _createClass(RemoteDisconnectedPayload, [{
    key: 'snapshot',
    get: function get() {
      return this._snapshot;
    }
  }]);

  return RemoteDisconnectedPayload;
}(RemotePayload);

/**
 * @class RemoteAvailablePayload
 * @param {BaseRemotePlayer} player - The active remote player.
 * @param {boolean} available - Remote player availability.
 * @extends RemotePayload
 */


var RemoteAvailablePayload = function (_RemotePayload3) {
  _inherits(RemoteAvailablePayload, _RemotePayload3);

  function RemoteAvailablePayload(player, available) {
    _classCallCheck(this, RemoteAvailablePayload);

    var _this3 = _possibleConstructorReturn(this, (RemoteAvailablePayload.__proto__ || Object.getPrototypeOf(RemoteAvailablePayload)).call(this, player));

    _this3._available = available;
    return _this3;
  }

  /**
   * Remote player availability.
   * @type {boolean}
   * @instance
   * @memberof RemoteAvailablePayload
   */


  _createClass(RemoteAvailablePayload, [{
    key: 'available',
    get: function get() {
      return this._available;
    }
  }]);

  return RemoteAvailablePayload;
}(RemotePayload);

exports.RemotePayload = RemotePayload;
exports.RemoteConnectedPayload = RemoteConnectedPayload;
exports.RemoteDisconnectedPayload = RemoteDisconnectedPayload;
exports.RemoteAvailablePayload = RemoteAvailablePayload;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RemotePlayerUI = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _pakhshkitJsUi = __webpack_require__(68);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class RemotePlayerUI
 */
var RemotePlayerUI = function () {
  function RemotePlayerUI() {
    var _this = this;

    _classCallCheck(this, RemotePlayerUI);

    this._uis = [{ template: function template(props) {
        return _this.idleUI(props);
      }, condition: function condition(state) {
        return state.engine.isIdle;
      } }, { template: function template(props) {
        return _this.errorUI(props);
      }, condition: function condition(state) {
        return state.engine.hasError;
      } }, { template: function template(props) {
        return _this.adsUI(props);
      }, condition: function condition(state) {
        return state.engine.adBreak;
      } }, { template: function template(props) {
        return _this.liveUI(props);
      }, condition: function condition(state) {
        return state.engine.isLive;
      } }, { template: function template(props) {
        return _this.playbackUI(props);
      } }];
  }

  _createClass(RemotePlayerUI, [{
    key: 'playbackUI',


    /**
     * Playback UI of the remote player.
     * @param {Object} props - UI creation parameters.
     * @returns {React$Element<any>} - Component.
     * @instance
     * @memberof RemotePlayerUI
     */
    value: function playbackUI(props) {
      return _pakhshkitJsUi.Presets.playbackUI(props);
    }

    /**
     * Idle UI of the remote player.
     * @param {Object} props - UI creation parameters.
     * @returns {React$Element<any>} - Component.
     * @instance
     * @memberof RemotePlayerUI
     */

  }, {
    key: 'idleUI',
    value: function idleUI(props) {
      return _pakhshkitJsUi.Presets.idleUI(props);
    }

    /**
     * Idle UI of the remote player.
     * @param {Object} props - UI creation parameters.
     * @returns {React$Element<any>} - Component.
     * @instance
     * @memberof RemotePlayerUI
     */

  }, {
    key: 'adsUI',
    value: function adsUI(props) {
      return _pakhshkitJsUi.Presets.adsUI(props);
    }

    /**
     * Live UI of the remote player.
     * @param {Object} props - UI creation parameters.
     * @returns {React$Element<any>} - Component.
     * @instance
     * @memberof RemotePlayerUI
     */

  }, {
    key: 'liveUI',
    value: function liveUI(props) {
      return _pakhshkitJsUi.Presets.liveUI(props);
    }

    /**
     * Error UI of the remote player.
     * @param {Object} props - UI creation parameters.
     * @returns {React$Element<any>} - Component.
     * @instance
     * @memberof RemotePlayerUI
     */

  }, {
    key: 'errorUI',
    value: function errorUI(props) {
      return _pakhshkitJsUi.Presets.errorUI(props);
    }

    /**
     * UI presets.
     * @type {Array<UIPreset>}
     * @instance
     * @memberof RemotePlayerUI
     */

  }, {
    key: 'uis',
    get: function get() {
      return this._uis;
    }
  }]);

  return RemotePlayerUI;
}();

exports.RemotePlayerUI = RemotePlayerUI;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UIWrapper = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _pakhshkitJsUi = __webpack_require__(68);

var _pakhshkitJs = __webpack_require__(9);

var _thumbs = __webpack_require__(369);

var _vidiunPlayer = __webpack_require__(44);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UIWrapper = function () {
  function UIWrapper(player, options) {
    var _this = this;

    _classCallCheck(this, UIWrapper);

    this._disabled = false;

    var config = options.ui;
    if (config.disable) {
      this._disabled = true;
      appendPlayerViewToTargetContainer(config.targetId, player.getView());
    } else {
      this._uiManager = new _pakhshkitJsUi.UIManager(player, config);
      if (config.customPreset) {
        this._uiManager.buildCustomUI(config.customPreset);
      } else {
        this._uiManager.buildDefaultUI();
      }
      this._handleVr(options.plugins);
    }
    return new Proxy(this, {
      get: function get(uiw, prop) {
        if (_this._disabled) return function () {
          return undefined;
        };
        // $FlowFixMe
        return uiw[prop];
      }
    });
  }

  _createClass(UIWrapper, [{
    key: 'destroy',
    value: function destroy() {
      this._uiManager.destroy();
    }
  }, {
    key: 'reset',
    value: function reset() {
      this._resetErrorState();
    }
  }, {
    key: 'setConfig',
    value: function setConfig(config, componentAlias) {
      this._uiManager.setConfig(config, componentAlias);
    }
  }, {
    key: '_resetErrorState',
    value: function _resetErrorState() {
      this.setConfig({ hasError: false }, 'engine');
    }
  }, {
    key: 'setSeekbarConfig',
    value: function setSeekbarConfig(mediaConfig, uiConfig) {
      var seekbarConfig = _pakhshkitJs.Utils.Object.getPropertyPath(uiConfig, 'components.seekbar');
      var previewThumbnailConfig = getPreviewThumbnailConfig(mediaConfig, seekbarConfig);
      this.setConfig(_pakhshkitJs.Utils.Object.mergeDeep({}, previewThumbnailConfig, seekbarConfig), 'seekbar');
    }
  }, {
    key: 'setLoadingSpinnerState',
    value: function setLoadingSpinnerState(show) {
      this.setConfig({ show: show }, 'loading');
    }
  }, {
    key: '_handleVr',
    value: function _handleVr() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (config.vr && !config.vr.disable) {
        this._setStereoConfig(config.vr);
      }
    }
  }, {
    key: '_setStereoConfig',
    value: function _setStereoConfig(vrConfig) {
      if (vrConfig.toggleStereo || _pakhshkitJs.Env.device.type && vrConfig.toggleStereo !== false) {
        // enable stereo mode by default for mobile device
        this.setConfig(_pakhshkitJs.Utils.Object.mergeDeep({}, { vrStereoMode: !!vrConfig.startInStereo }), 'vrStereo');
      }
    }
  }]);

  return UIWrapper;
}();

/**
 * Appends the player view to the target element in the dom.
 * @private
 * @param {string} targetId - The target id.
 * @param {HTMLElement} view - The player div element.
 * @returns {void}
 */


function appendPlayerViewToTargetContainer(targetId, view) {
  var targetContainer = document.getElementById(targetId);
  if (targetContainer) {
    targetContainer.appendChild(view);
  }
}

/**
 * Gets the preview thumbnail config for the ui seekbar component.
 * @private
 * @param {ProviderMediaConfigObject} mediaConfig - The provider media config.
 * @param {SeekbarConfig} seekbarConfig - The seek bar config.
 * @returns {SeekbarConfig} - The seekbar component config.
 */
function getPreviewThumbnailConfig(mediaConfig, seekbarConfig) {
  var previewThumbnailConfig = {
    thumbsSprite: (0, _thumbs.getThumbSlicesUrl)(mediaConfig, seekbarConfig),
    thumbsWidth: _thumbs.DEFAULT_THUMBS_WIDTH,
    thumbsSlices: _thumbs.DEFAULT_THUMBS_SLICES
  };
  return previewThumbnailConfig;
}

exports.UIWrapper = UIWrapper;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


/**
 * @private
 * @param {string} template - The template string to evaluate
 * @param {Object} model - The model to evaluate with
 * @return {string} - The evaluated string
 */
function evaluate(template) {
  var model = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  try {
    var reg = void 0,
        res = template;
    for (var key in model) {
      var value = model[key] !== undefined && model[key] !== null ? model[key] : '';
      if (typeof value === 'string' && value.indexOf('"') > -1) {
        value = value.replace(/"/g, '\\"');
      }
      reg = new RegExp('{{' + key + '}}', 'g');
      res = res.replace(reg, value);
    }
    return res;
  } catch (e) {
    return '';
  }
}

exports.default = evaluate;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addClientTag = exports.addReferrer = exports.getReferrer = exports.updateSessionIdInUrl = exports.handleSessionId = exports.addVidiunParams = undefined;

var _pakhshkitJs = __webpack_require__(9);

var PLAY_MANIFEST = 'playmanifest/';

var PLAY_SESSION_ID = 'playSessionId=';
var REFERRER = 'referrer=';
var CLIENT_TAG = 'clientTag=html5:v';

/**
 * @param {Player} player - player
 * @param {PartialVPOptionsObject} playerConfig - player config
 * @return {void}
 * @private
 */
function handleSessionId(player, playerConfig) {
  if (player.config.session && player.config.session.id) {
    // on change media
    updateSessionId(player, playerConfig);
  } else {
    // on first playback
    addSessionId(playerConfig);
  }
}

/**
 * @param {PartialVPOptionsObject} playerConfig - player config
 * @return {void}
 * @private
 */
function addSessionId(playerConfig) {
  var primaryGUID = _pakhshkitJs.Utils.Generator.guid();
  var secondGUID = _pakhshkitJs.Utils.Generator.guid();
  setSessionId(playerConfig, primaryGUID + ':' + secondGUID);
}

/**
 * @param {Player} player - player
 * @param {PartialVPOptionsObject} playerConfig - player config
 * @return {void}
 * @private
 */
function updateSessionId(player, playerConfig) {
  var secondGuidInSessionIdRegex = /:((?:[a-z0-9]|-)*)/i;
  var secondGuidInSessionId = secondGuidInSessionIdRegex.exec(player.config.session.id);
  if (secondGuidInSessionId && secondGuidInSessionId[1]) {
    setSessionId(playerConfig, player.config.session.id.replace(secondGuidInSessionId[1], _pakhshkitJs.Utils.Generator.guid()));
  }
}

/**
 * @param {PartialVPOptionsObject} playerConfig - player config
 * @param {string} sessionId - the session id
 * @return {void}
 * @private
 */
function setSessionId(playerConfig, sessionId) {
  playerConfig.session = playerConfig.session || {};
  playerConfig.session.id = sessionId;
}

/**
 * @param {PKMediaSourceObject} source - PKMediaSourceObject
 * @param {string} sessionId - session id
 * @return {void}
 * @private
 */
function updateSessionIdInUrl() {
  var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var sessionId = arguments[1];

  if (sessionId) {
    var sessionIdInUrlRegex = new RegExp(PLAY_SESSION_ID + '((?:[a-z0-9]|-)*:(?:[a-z0-9]|-)*)', 'i');
    var sessionIdInUrl = sessionIdInUrlRegex.exec(source.url);
    if (sessionIdInUrl && sessionIdInUrl[1]) {
      // this url has session id (has already been played)
      source.url = source.url.replace(sessionIdInUrl[1], sessionId);
    } else {
      var delimiter = source.url.indexOf('?') === -1 ? '?' : '&';
      source.url += delimiter + PLAY_SESSION_ID + sessionId;
    }
  }
}

/**
 * @return {string} - The referrer
 * @private
 */
function getReferrer() {
  var referrer = void 0;
  try {
    referrer = window.parent.document.URL;
  } catch (e) {
    // unfriendly iframe
    referrer = document.referrer;
  }
  return referrer;
}

/**
 * @param {PKMediaSourceObject} source - source
 * @return {void}
 * @private
 */
function addReferrer(source) {
  if (source.url.indexOf(REFERRER) === -1) {
    var delimiter = source.url.indexOf('?') === -1 ? '?' : '&';
    var referrer = btoa(getReferrer().substr(0, 1000));
    source.url += delimiter + REFERRER + referrer;
  }
}

/**
 * @param {PKMediaSourceObject} source - source
 * @return {void}
 * @private
 */
function addClientTag(source) {
  if (source.url.indexOf(CLIENT_TAG) === -1) {
    var delimiter = source.url.indexOf('?') === -1 ? '?' : '&';
    source.url += delimiter + CLIENT_TAG + "0.41.2";
  }
}

/**
 * Adding Vidiun specific params to player config and player sources.
 * @param {Player} player - player
 * @param {PartialVPOptionsObject} playerConfig - player config
 * @return {void}
 * @private
 */
function addVidiunParams(player, playerConfig) {
  handleSessionId(player, playerConfig);
  var sources = playerConfig.sources;
  Object.values(_pakhshkitJs.StreamType).forEach(function (key) {
    // $FlowFixMe
    if (sources[key]) {
      sources[key].forEach(function (source) {
        if (typeof source.url === 'string' && source.url.toLowerCase().indexOf(PLAY_MANIFEST) > -1 && !source.localSource) {
          updateSessionIdInUrl(source, playerConfig.session && playerConfig.session.id);
          addReferrer(source);
          addClientTag(source);
        }
      });
    }
  });
}

exports.addVidiunParams = addVidiunParams;
exports.handleSessionId = handleSessionId;
exports.updateSessionIdInUrl = updateSessionIdInUrl;
exports.getReferrer = getReferrer;
exports.addReferrer = addReferrer;
exports.addClientTag = addClientTag;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.evaluateUIConfig = exports.evaluatePluginsConfig = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _pluginsConfigStore = __webpack_require__(370);

var _evaluate = __webpack_require__(142);

var _evaluate2 = _interopRequireDefault(_evaluate);

var _vidiunParams = __webpack_require__(143);

var _pakhshkitJs = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * returns whether value is evaluated
 * @private
 * @param {*} value - the value to be checked
 * @returns {boolean} - value is evaluated
 */
var isValueEvaluated = function isValueEvaluated(value) {
  return (typeof value === 'number' || typeof value === 'function' || typeof value === 'string' || typeof value === 'boolean') && !_pluginsConfigStore.templateRegex.test(value.toString());
};

/**
 * remove unevaluated expressions form object
 * @private
 * @param {Object} obj - the object examine
 * @returns {Object} - the object without unevaluated strings
 */
var removeUnevaluatedExpression = function removeUnevaluatedExpression() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.entries(obj).reduce(function (product, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    if (typeof value !== 'function' && _pakhshkitJs.Utils.Object.isObject(value)) {
      product[key] = removeUnevaluatedExpression(value);
    } else if (isValueEvaluated(value)) {
      product[key] = value;
    }
    return product;
  }, {});
};

/**
 * returns the data model for evaluating evaluation tokens
 * @private
 * @param {VPOptionsObject} options - the vidiun player options object
 * @returns {Object} - data model
 */
var getModel = function getModel(options) {
  var dataModel = {
    pVersion: "0.41.2",
    pName: "vidiun-player-js"
  };
  if (options.targetId) {
    dataModel.domRootElementId = options.targetId;
  }
  if (options.provider && options.provider.env) {
    dataModel['serviceUrl'] = options.provider.env.serviceUrl;

    if (dataModel['serviceUrl']) {
      dataModel['embedBaseUrl'] = dataModel['serviceUrl'].replace('api_v3', '');
    }
  }
  var entryDataModel = {
    referrer: (0, _vidiunParams.getReferrer)()
  };
  if (options.provider) {
    _pakhshkitJs.Utils.Object.mergeDeep(entryDataModel, {
      vs: options.provider.vs,
      uiConfId: options.provider.uiConfId,
      partnerId: options.provider.partnerId
    });
  }
  if (options.session) {
    _pakhshkitJs.Utils.Object.mergeDeep(entryDataModel, {
      sessionId: options.session.id,
      vs: options.session.vs,
      isAnonymous: options.session.isAnonymous,
      uiConfId: options.session.uiConfId,
      partnerId: options.session.partnerId
    });
  }
  if (options.sources) {
    _pakhshkitJs.Utils.Object.mergeDeep(entryDataModel, {
      entryId: options.sources.id,
      entryName: options.sources.metadata && options.sources.metadata.name,
      entryType: options.sources.type
    });
  }
  if (options.playlist) {
    _pakhshkitJs.Utils.Object.mergeDeep(entryDataModel, {
      playlistId: options.playlist.id
    });
  }
  Object.keys(entryDataModel).forEach(function (key) {
    if (entryDataModel[key] === undefined) {
      delete entryDataModel[key];
    }
  });
  _pakhshkitJs.Utils.Object.mergeDeep(dataModel, entryDataModel);
  return dataModel;
};

/**
 * @param {PKPluginsConfigObject} options - plugins options
 * @param {VPOptionsObject} config - player config
 * @private
 * @return {void}
 */
function evaluatePluginsConfig(options, config) {
  if (options) {
    _pluginsConfigStore.pluginConfig.set(options);
    var dataModel = getModel(config);
    var mergedConfig = _pakhshkitJs.Utils.Object.mergeDeep({}, _pluginsConfigStore.pluginConfig.get(), options);
    var evaluatedConfig = _formatConfigString((0, _evaluate2.default)(JSON.stringify(mergedConfig), dataModel));
    _mergeConfig(options, evaluatedConfig);
  }
}

/**
 * @param {UIOptionsObject} options - UI options
 * @param {VPOptionsObject} config - player config
 * @private
 * @return {void}
 */
function evaluateUIConfig(options, config) {
  if (options) {
    var defaultUiConfig = {
      components: {
        share: {
          shareUrl: '{{embedBaseUrl}}/index.php/extwidget/preview/partner_id/{{partnerId}}/uiconf_id/{{uiConfId}}/entry_id/{{entryId}}/embed/dynamic',
          embedUrl: '{{embedBaseUrl}}/p/{{partnerId}}/embedPakhshkitJs/uiconf_id/{{uiConfId}}?iframeembed=true&entry_id={{entryId}}'
        }
      }
    };
    var dataModel = getModel(config);
    var mergedConfig = _pakhshkitJs.Utils.Object.mergeDeep({}, defaultUiConfig, options);
    var evaluatedConfig = _formatConfigString((0, _evaluate2.default)(JSON.stringify(mergedConfig), dataModel));
    _mergeConfig(options, evaluatedConfig);
  }
}

/**
 *
 * @param {string} config - the config string
 * @returns {Object} - the config object
 * @private
 */
function _formatConfigString(config) {
  var configObj = void 0;
  try {
    configObj = JSON.parse(config, function (key) {
      try {
        return JSON.parse(this[key]);
      } catch (e) {
        return this[key];
      }
    });
  } catch (e) {
    configObj = {};
  }
  return configObj;
}
/**
 * @param {Object} data - target config object
 * @param {Object} evaluatedConfig - the evaluated object
 * @private
 * @returns {void}
 */
function _mergeConfig(data, evaluatedConfig) {
  var evaluatedCleanConfig = removeUnevaluatedExpression(evaluatedConfig);
  var cleanData = removeUnevaluatedExpression(data);

  if (cleanData && evaluatedCleanConfig) {
    Object.keys(data).forEach(function (pluginName) {
      if (data && data[pluginName]) {
        data[pluginName] = _pakhshkitJs.Utils.Object.mergeDeep({}, evaluatedCleanConfig[pluginName], cleanData[pluginName]);
      }
    });
  }
}

exports.evaluatePluginsConfig = evaluatePluginsConfig;
exports.evaluateUIConfig = evaluateUIConfig;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * Add poster with player dimensions.
 * If poster is string and width and height exists in template we need to make a thumbnail API call.
 * If poster is array of objects we need to choose the best fit dimensions according to the player dimensions.
 * @param {PKSourcesConfigObject} playerSources - player sources container
 * @param {ProviderMediaConfigSourcesObject} mediaSources - media config sources container
 * @param {Object} dimensions - player dimensions object
 * @private
 * @returns {void}
 */
function addVidiunPoster(playerSources, mediaSources, dimensions) {
  var playerPoster = playerSources.poster;
  var mediaConfigPoster = mediaSources.poster;
  var playerWidth = dimensions.width;
  var playerHeight = dimensions.height;
  if (typeof playerPoster === 'string' && playerPoster === mediaConfigPoster) {
    var regex = /.*\/thumbnail\/.*(?:width|height)\/\d+\/(?:height|width)\/\d+/;
    if (regex.test(playerPoster)) {
      playerSources.poster = setPlayerDimensionsOnPoster(playerPoster, playerWidth, playerHeight);
    }
  } else if (Array.isArray(playerPoster)) {
    playerSources.poster = selectPosterByPlayerDimensions(playerPoster, playerWidth, playerHeight);
  }
}

/**
 * Replace the current dimensions with the player dimensions.
 * @param {string} poster - Player url.
 * @param {number} playerWidth - Player width.
 * @param {height} playerHeight - Player height.
 * @private
 * @return {string} - The new poster url including the player dimensions.
 */
function setPlayerDimensionsOnPoster(poster, playerWidth, playerHeight) {
  var widthMatch = poster.match(/width\/(\d+)/);
  var heightMatch = poster.match(/height\/(\d+)/);
  if (Array.isArray(widthMatch)) {
    poster = poster.replace(widthMatch[1], playerWidth.toString());
  }
  if (Array.isArray(heightMatch)) {
    poster = poster.replace(heightMatch[1], playerHeight.toString());
  }
  return poster;
}

/**
 * Selects the best fit poster depends on the player dimensions.
 * @param {string} posters - Array of posters candidates.
 * @param {number} playerWidth - Player width.
 * @param {height} playerHeight - Player height.
 * @private
 * @return {string} - The poster url.
 */
function selectPosterByPlayerDimensions(posters, playerWidth, playerHeight) {
  var min = Infinity;
  var url = '';
  posters.forEach(function (picture) {
    var picWidth = picture.width;
    var picHeight = picture.height;
    var widthDelta = Math.abs(picWidth - playerWidth);
    var heightDelta = Math.abs(picHeight - playerHeight);
    var delta = widthDelta + heightDelta;
    if (delta < min) {
      min = delta;
      url = picture.url;
    }
  });
  return url;
}

exports.addVidiunPoster = addVidiunPoster;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var formats = ['hls', 'dash', 'progressive'];
/**
 * @class PlaylistItem
 * @param {ProviderMediaConfigSourcesObject} [sources] - The item sources
 * @param {VPPlaylistItemConfigObject} [config] - The item config
 */

var PlaylistItem = function () {
  function PlaylistItem(sources, config) {
    _classCallCheck(this, PlaylistItem);

    this._sources = sources;
    this._config = config;
  }

  /**
   * Update the playlist item sources
   * @param {ProviderMediaConfigSourcesObject} sourcesObject - The sources
   * @returns {void}
   * @instance
   * @memberof PlaylistItem
   */


  _createClass(PlaylistItem, [{
    key: 'updateSources',
    value: function updateSources(sourcesObject) {
      var _this = this;

      formats.forEach(function (format) {
        _this._sources && (_this._sources[format] = sourcesObject[format]);
      });
    }

    /**
     * Playlist item sources
     * @type {?ProviderMediaConfigSourcesObject}
     * @instance
     * @memberof PlaylistItem
     */

  }, {
    key: 'isPlayable',


    /**
     * @returns {boolean} = Whether the playlist item has sources to play
     * @instance
     * @memberof PlaylistItem
     */
    value: function isPlayable() {
      var _this2 = this;

      return !!formats.find(function (format) {
        return _this2._sources && _this2._sources[format] && _this2._sources[format].length;
      });
    }
  }, {
    key: 'sources',
    get: function get() {
      var _this3 = this;

      formats.forEach(function (format) {
        if (_this3._sources && _this3._sources[format] && _this3._sources[format].length === 0) {
          delete _this3._sources[format];
        }
      });
      return this._sources;
    }

    /**
     * Playlist item config
     * @type {?VPPlaylistItemConfigObject}
     * @instance
     * @memberof PlaylistItem
     */

  }, {
    key: 'config',
    get: function get() {
      return this._config;
    }
  }]);

  return PlaylistItem;
}();

exports.PlaylistItem = PlaylistItem;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPlayers = exports.getPlayer = exports.getPlayerProxy = undefined;

var _vidiunPlayer = __webpack_require__(44);

var _pakhshkitJs = __webpack_require__(9);

var Players = {};
/**
 * get all instantiated players
 * @returns {VidiunPlayers} - map of player ids and their respective instantiated player
 */
function getPlayers() {
  return Players;
}

/**
 * get a player instance by id
 * @param {string} id - the player ID
 * @returns {VidiunPlayer | null} - the player if found by the supplied ID or null if key doesn't exist
 */
function getPlayer(id) {
  if (Players[id]) {
    return Players[id];
  }
  return null;
}

var proxyIgnoredProps = ['_remotePlayer', '_listeners', '_uiWrapper'];
var proxyHandler = {
  get: function get(vp, prop) {
    if (prop === 'destroy') {
      var playerId = vp.config.targetId;
      delete Players[playerId];
    }

    if (prop in _pakhshkitJs.FakeEventTarget.prototype || proxyIgnoredProps.includes(prop)) {
      // $FlowFixMe
      return vp[prop];
    }
    if (vp._remotePlayer && prop in vp._remotePlayer) {
      return vp._remotePlayer[prop];
    }
    // $FlowFixMe
    return vp[prop];
  },
  set: function set(vp, prop, value) {
    if (vp._remotePlayer && !proxyIgnoredProps.includes(prop)) {
      if (prop in vp._remotePlayer) {
        vp._remotePlayer[prop] = value;
      }
    } else {
      // $FlowFixMe
      vp[prop] = value;
    }
    return true;
  }
};

var getPlayerProxy = function getPlayerProxy(options) {
  var player = new _vidiunPlayer.VidiunPlayer(options);
  var proxy = new Proxy(player, proxyHandler);
  Players[options.targetId] = proxy;
  return proxy;
};

exports.getPlayerProxy = getPlayerProxy;
exports.getPlayer = getPlayer;
exports.getPlayers = getPlayers;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PLAYER_NAME = exports.VERSION = exports.PLAYER_TYPE = exports.playlist = exports.cast = exports.shaka = exports.setup = exports.providers = exports.ui = exports.core = exports.getPlayer = exports.getPlayers = undefined;

var _polyfillManager = __webpack_require__(71);

var _polyfillManager2 = _interopRequireDefault(_polyfillManager);

__webpack_require__(352);

var _logger = __webpack_require__(16);

var _logger2 = _interopRequireDefault(_logger);

var _pakhshkitJs = __webpack_require__(9);

var core = _interopRequireWildcard(_pakhshkitJs);

var _pakhshkitJsUi = __webpack_require__(68);

var ui = _interopRequireWildcard(_pakhshkitJsUi);

var _pakhshkitJsProviders = __webpack_require__(136);

var providers = _interopRequireWildcard(_pakhshkitJsProviders);

__webpack_require__(357);

__webpack_require__(359);

__webpack_require__(360);

__webpack_require__(361);

var _shakaPlayer = __webpack_require__(137);

var shaka = _interopRequireWildcard(_shakaPlayer);

var _setup = __webpack_require__(362);

var _proxy = __webpack_require__(147);

var _cast = __webpack_require__(378);

var _playlist = __webpack_require__(382);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Import cast framework

// Import setup method

// Import provider

// Import core
var currentLogLevel = (0, _logger.getLogLevel)();
// Import playlist

// Import shaka-player

// Import analytics plugin

// Import media source adapters

// Import ui

(0, _logger.setLogLevel)(_logger.LogLevel.INFO);
(0, _logger2.default)().log('%c ' + "vidiun-player-js" + ' ' + "0.41.2", 'color: #ff98f9;  font-size: large');
(0, _logger2.default)().log('%c For more details see ' + "https://github.com/vidiun/vidiun-player-js", 'color: #ff98f9;');
(0, _logger.setLogLevel)(currentLogLevel);

_polyfillManager2.default.installAll();

exports.getPlayers = _proxy.getPlayers;
exports.getPlayer = _proxy.getPlayer;
exports.core = core;
exports.ui = ui;
exports.providers = providers;
exports.setup = _setup.setup;
exports.shaka = shaka;
exports.cast = _cast.cast;
exports.playlist = _playlist.playlist;
exports.PLAYER_TYPE = "ott";
exports.VERSION = "0.41.2";
exports.PLAYER_NAME = "vidiun-player-js";

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * js-logger - http://github.com/jonnyreeves/js-logger
 * Jonny Reeves, http://jonnyreeves.co.uk/
 * js-logger may be freely distributed under the MIT license.
 */
(function (global) {
	"use strict";

	// Top level module for the global, static logger instance.
	var Logger = { };

	// For those that are at home that are keeping score.
	Logger.VERSION = "1.4.1";

	// Function which handles all incoming log messages.
	var logHandler;

	// Map of ContextualLogger instances by name; used by Logger.get() to return the same named instance.
	var contextualLoggersByNameMap = {};

	// Polyfill for ES5's Function.bind.
	var bind = function(scope, func) {
		return function() {
			return func.apply(scope, arguments);
		};
	};

	// Super exciting object merger-matron 9000 adding another 100 bytes to your download.
	var merge = function () {
		var args = arguments, target = args[0], key, i;
		for (i = 1; i < args.length; i++) {
			for (key in args[i]) {
				if (!(key in target) && args[i].hasOwnProperty(key)) {
					target[key] = args[i][key];
				}
			}
		}
		return target;
	};

	// Helper to define a logging level object; helps with optimisation.
	var defineLogLevel = function(value, name) {
		return { value: value, name: name };
	};

	// Predefined logging levels.
	Logger.DEBUG = defineLogLevel(1, 'DEBUG');
	Logger.INFO = defineLogLevel(2, 'INFO');
	Logger.TIME = defineLogLevel(3, 'TIME');
	Logger.WARN = defineLogLevel(4, 'WARN');
	Logger.ERROR = defineLogLevel(8, 'ERROR');
	Logger.OFF = defineLogLevel(99, 'OFF');

	// Inner class which performs the bulk of the work; ContextualLogger instances can be configured independently
	// of each other.
	var ContextualLogger = function(defaultContext) {
		this.context = defaultContext;
		this.setLevel(defaultContext.filterLevel);
		this.log = this.info;  // Convenience alias.
	};

	ContextualLogger.prototype = {
		// Changes the current logging level for the logging instance.
		setLevel: function (newLevel) {
			// Ensure the supplied Level object looks valid.
			if (newLevel && "value" in newLevel) {
				this.context.filterLevel = newLevel;
			}
		},
		
		// Gets the current logging level for the logging instance
		getLevel: function () {
			return this.context.filterLevel;
		},

		// Is the logger configured to output messages at the supplied level?
		enabledFor: function (lvl) {
			var filterLevel = this.context.filterLevel;
			return lvl.value >= filterLevel.value;
		},

		debug: function () {
			this.invoke(Logger.DEBUG, arguments);
		},

		info: function () {
			this.invoke(Logger.INFO, arguments);
		},

		warn: function () {
			this.invoke(Logger.WARN, arguments);
		},

		error: function () {
			this.invoke(Logger.ERROR, arguments);
		},

		time: function (label) {
			if (typeof label === 'string' && label.length > 0) {
				this.invoke(Logger.TIME, [ label, 'start' ]);
			}
		},

		timeEnd: function (label) {
			if (typeof label === 'string' && label.length > 0) {
				this.invoke(Logger.TIME, [ label, 'end' ]);
			}
		},

		// Invokes the logger callback if it's not being filtered.
		invoke: function (level, msgArgs) {
			if (logHandler && this.enabledFor(level)) {
				logHandler(msgArgs, merge({ level: level }, this.context));
			}
		}
	};

	// Protected instance which all calls to the to level `Logger` module will be routed through.
	var globalLogger = new ContextualLogger({ filterLevel: Logger.OFF });

	// Configure the global Logger instance.
	(function() {
		// Shortcut for optimisers.
		var L = Logger;

		L.enabledFor = bind(globalLogger, globalLogger.enabledFor);
		L.debug = bind(globalLogger, globalLogger.debug);
		L.time = bind(globalLogger, globalLogger.time);
		L.timeEnd = bind(globalLogger, globalLogger.timeEnd);
		L.info = bind(globalLogger, globalLogger.info);
		L.warn = bind(globalLogger, globalLogger.warn);
		L.error = bind(globalLogger, globalLogger.error);

		// Don't forget the convenience alias!
		L.log = L.info;
	}());

	// Set the global logging handler.  The supplied function should expect two arguments, the first being an arguments
	// object with the supplied log messages and the second being a context object which contains a hash of stateful
	// parameters which the logging function can consume.
	Logger.setHandler = function (func) {
		logHandler = func;
	};

	// Sets the global logging filter level which applies to *all* previously registered, and future Logger instances.
	// (note that named loggers (retrieved via `Logger.get`) can be configured independently if required).
	Logger.setLevel = function(level) {
		// Set the globalLogger's level.
		globalLogger.setLevel(level);

		// Apply this level to all registered contextual loggers.
		for (var key in contextualLoggersByNameMap) {
			if (contextualLoggersByNameMap.hasOwnProperty(key)) {
				contextualLoggersByNameMap[key].setLevel(level);
			}
		}
	};

	// Gets the global logging filter level
	Logger.getLevel = function() {
		return globalLogger.getLevel();
	};

	// Retrieve a ContextualLogger instance.  Note that named loggers automatically inherit the global logger's level,
	// default context and log handler.
	Logger.get = function (name) {
		// All logger instances are cached so they can be configured ahead of use.
		return contextualLoggersByNameMap[name] ||
			(contextualLoggersByNameMap[name] = new ContextualLogger(merge({ name: name }, globalLogger.context)));
	};

	// CreateDefaultHandler returns a handler function which can be passed to `Logger.setHandler()` which will
	// write to the window's console object (if present); the optional options object can be used to customise the
	// formatter used to format each log message.
	Logger.createDefaultHandler = function (options) {
		options = options || {};

		options.formatter = options.formatter || function defaultMessageFormatter(messages, context) {
			// Prepend the logger's name to the log message for easy identification.
			if (context.name) {
				messages.unshift("[" + context.name + "]");
			}
		};

		// Map of timestamps by timer labels used to track `#time` and `#timeEnd()` invocations in environments
		// that don't offer a native console method.
		var timerStartTimeByLabelMap = {};

		// Support for IE8+ (and other, slightly more sane environments)
		var invokeConsoleMethod = function (hdlr, messages) {
			Function.prototype.apply.call(hdlr, console, messages);
		};

		// Check for the presence of a logger.
		if (typeof console === "undefined") {
			return function () { /* no console */ };
		}

		return function(messages, context) {
			// Convert arguments object to Array.
			messages = Array.prototype.slice.call(messages);

			var hdlr = console.log;
			var timerLabel;

			if (context.level === Logger.TIME) {
				timerLabel = (context.name ? '[' + context.name + '] ' : '') + messages[0];

				if (messages[1] === 'start') {
					if (console.time) {
						console.time(timerLabel);
					}
					else {
						timerStartTimeByLabelMap[timerLabel] = new Date().getTime();
					}
				}
				else {
					if (console.timeEnd) {
						console.timeEnd(timerLabel);
					}
					else {
						invokeConsoleMethod(hdlr, [ timerLabel + ': ' +
							(new Date().getTime() - timerStartTimeByLabelMap[timerLabel]) + 'ms' ]);
					}
				}
			}
			else {
				// Delegate through to custom warn/error loggers if present on the console.
				if (context.level === Logger.WARN && console.warn) {
					hdlr = console.warn;
				} else if (context.level === Logger.ERROR && console.error) {
					hdlr = console.error;
				} else if (context.level === Logger.INFO && console.info) {
					hdlr = console.info;
				} else if (context.level === Logger.DEBUG && console.debug) {
					hdlr = console.debug;
				}

				options.formatter(messages, context);
				invokeConsoleMethod(hdlr, messages);
			}
		};
	};

	// Configure and example a Default implementation which writes to the `window.console` (if present).  The
	// `options` hash can be used to configure the default logLevel and provide a custom message formatter.
	Logger.useDefaults = function(options) {
		Logger.setLevel(options && options.defaultLevel || Logger.DEBUG);
		Logger.setHandler(Logger.createDefaultHandler(options));
	};

	// Export to popular environments boilerplate.
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (Logger),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	else if (typeof module !== 'undefined' && module.exports) {
		module.exports = Logger;
	}
	else {
		Logger._prevLogger = global.Logger;

		Logger.noConflict = function () {
			global.Logger = Logger._prevLogger;
			return Logger;
		};

		global.Logger = Logger;
	}
}(this));


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(151);

__webpack_require__(348);

__webpack_require__(349);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(152);
__webpack_require__(154);
__webpack_require__(155);
__webpack_require__(156);
__webpack_require__(157);
__webpack_require__(158);
__webpack_require__(159);
__webpack_require__(160);
__webpack_require__(161);
__webpack_require__(162);
__webpack_require__(163);
__webpack_require__(164);
__webpack_require__(165);
__webpack_require__(166);
__webpack_require__(167);
__webpack_require__(168);
__webpack_require__(170);
__webpack_require__(171);
__webpack_require__(172);
__webpack_require__(173);
__webpack_require__(174);
__webpack_require__(175);
__webpack_require__(176);
__webpack_require__(177);
__webpack_require__(178);
__webpack_require__(179);
__webpack_require__(180);
__webpack_require__(181);
__webpack_require__(182);
__webpack_require__(183);
__webpack_require__(184);
__webpack_require__(185);
__webpack_require__(186);
__webpack_require__(187);
__webpack_require__(188);
__webpack_require__(189);
__webpack_require__(190);
__webpack_require__(191);
__webpack_require__(192);
__webpack_require__(193);
__webpack_require__(194);
__webpack_require__(195);
__webpack_require__(196);
__webpack_require__(197);
__webpack_require__(198);
__webpack_require__(199);
__webpack_require__(200);
__webpack_require__(201);
__webpack_require__(202);
__webpack_require__(203);
__webpack_require__(204);
__webpack_require__(205);
__webpack_require__(206);
__webpack_require__(207);
__webpack_require__(208);
__webpack_require__(209);
__webpack_require__(210);
__webpack_require__(211);
__webpack_require__(212);
__webpack_require__(213);
__webpack_require__(214);
__webpack_require__(215);
__webpack_require__(216);
__webpack_require__(217);
__webpack_require__(218);
__webpack_require__(219);
__webpack_require__(220);
__webpack_require__(221);
__webpack_require__(222);
__webpack_require__(223);
__webpack_require__(224);
__webpack_require__(225);
__webpack_require__(226);
__webpack_require__(227);
__webpack_require__(228);
__webpack_require__(229);
__webpack_require__(230);
__webpack_require__(232);
__webpack_require__(233);
__webpack_require__(235);
__webpack_require__(236);
__webpack_require__(237);
__webpack_require__(238);
__webpack_require__(239);
__webpack_require__(240);
__webpack_require__(241);
__webpack_require__(243);
__webpack_require__(244);
__webpack_require__(245);
__webpack_require__(246);
__webpack_require__(247);
__webpack_require__(248);
__webpack_require__(249);
__webpack_require__(250);
__webpack_require__(251);
__webpack_require__(252);
__webpack_require__(253);
__webpack_require__(254);
__webpack_require__(255);
__webpack_require__(93);
__webpack_require__(256);
__webpack_require__(257);
__webpack_require__(120);
__webpack_require__(258);
__webpack_require__(259);
__webpack_require__(260);
__webpack_require__(261);
__webpack_require__(262);
__webpack_require__(123);
__webpack_require__(125);
__webpack_require__(126);
__webpack_require__(263);
__webpack_require__(264);
__webpack_require__(265);
__webpack_require__(266);
__webpack_require__(267);
__webpack_require__(268);
__webpack_require__(269);
__webpack_require__(270);
__webpack_require__(271);
__webpack_require__(272);
__webpack_require__(273);
__webpack_require__(274);
__webpack_require__(275);
__webpack_require__(276);
__webpack_require__(277);
__webpack_require__(278);
__webpack_require__(279);
__webpack_require__(280);
__webpack_require__(281);
__webpack_require__(282);
__webpack_require__(283);
__webpack_require__(284);
__webpack_require__(285);
__webpack_require__(286);
__webpack_require__(287);
__webpack_require__(288);
__webpack_require__(289);
__webpack_require__(290);
__webpack_require__(291);
__webpack_require__(292);
__webpack_require__(293);
__webpack_require__(294);
__webpack_require__(295);
__webpack_require__(296);
__webpack_require__(297);
__webpack_require__(298);
__webpack_require__(299);
__webpack_require__(300);
__webpack_require__(301);
__webpack_require__(302);
__webpack_require__(303);
__webpack_require__(304);
__webpack_require__(305);
__webpack_require__(306);
__webpack_require__(307);
__webpack_require__(308);
__webpack_require__(309);
__webpack_require__(310);
__webpack_require__(311);
__webpack_require__(312);
__webpack_require__(313);
__webpack_require__(314);
__webpack_require__(315);
__webpack_require__(316);
__webpack_require__(317);
__webpack_require__(318);
__webpack_require__(319);
__webpack_require__(320);
__webpack_require__(321);
__webpack_require__(322);
__webpack_require__(323);
__webpack_require__(324);
__webpack_require__(325);
__webpack_require__(326);
__webpack_require__(327);
__webpack_require__(328);
__webpack_require__(329);
__webpack_require__(330);
__webpack_require__(331);
__webpack_require__(332);
__webpack_require__(333);
__webpack_require__(334);
__webpack_require__(335);
__webpack_require__(336);
__webpack_require__(337);
__webpack_require__(338);
__webpack_require__(339);
__webpack_require__(340);
__webpack_require__(341);
__webpack_require__(342);
__webpack_require__(343);
__webpack_require__(344);
__webpack_require__(345);
__webpack_require__(346);
__webpack_require__(347);
module.exports = __webpack_require__(23);


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(2);
var has = __webpack_require__(12);
var DESCRIPTORS = __webpack_require__(6);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(14);
var META = __webpack_require__(31).KEY;
var $fails = __webpack_require__(3);
var shared = __webpack_require__(54);
var setToStringTag = __webpack_require__(45);
var uid = __webpack_require__(34);
var wks = __webpack_require__(5);
var wksExt = __webpack_require__(103);
var wksDefine = __webpack_require__(73);
var enumKeys = __webpack_require__(153);
var isArray = __webpack_require__(57);
var anObject = __webpack_require__(1);
var toIObject = __webpack_require__(17);
var toPrimitive = __webpack_require__(24);
var createDesc = __webpack_require__(33);
var _create = __webpack_require__(38);
var gOPNExt = __webpack_require__(106);
var $GOPD = __webpack_require__(18);
var $DP = __webpack_require__(7);
var $keys = __webpack_require__(36);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(39).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(51).f = $propertyIsEnumerable;
  __webpack_require__(56).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(35)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    replacer = args[1];
    if (typeof replacer == 'function') $replacer = replacer;
    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
      if ($replacer) value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(13)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(36);
var gOPS = __webpack_require__(56);
var pIE = __webpack_require__(51);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(38) });


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(6), 'Object', { defineProperty: __webpack_require__(7).f });


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(6), 'Object', { defineProperties: __webpack_require__(105) });


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(17);
var $getOwnPropertyDescriptor = __webpack_require__(18).f;

__webpack_require__(27)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(10);
var $getPrototypeOf = __webpack_require__(19);

__webpack_require__(27)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(10);
var $keys = __webpack_require__(36);

__webpack_require__(27)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(27)('getOwnPropertyNames', function () {
  return __webpack_require__(106).f;
});


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(4);
var meta = __webpack_require__(31).onFreeze;

__webpack_require__(27)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(4);
var meta = __webpack_require__(31).onFreeze;

__webpack_require__(27)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(4);
var meta = __webpack_require__(31).onFreeze;

__webpack_require__(27)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(4);

__webpack_require__(27)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(4);

__webpack_require__(27)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(4);

__webpack_require__(27)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(0);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(107) });


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { is: __webpack_require__(169) });


/***/ }),
/* 169 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(77).set });


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(52);
var test = {};
test[__webpack_require__(5)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(14)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(0);

$export($export.P, 'Function', { bind: __webpack_require__(108) });


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(7).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(6) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(4);
var getPrototypeOf = __webpack_require__(19);
var HAS_INSTANCE = __webpack_require__(5)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(7).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(110);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(111);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(2);
var has = __webpack_require__(12);
var cof = __webpack_require__(21);
var inheritIfRequired = __webpack_require__(79);
var toPrimitive = __webpack_require__(24);
var fails = __webpack_require__(3);
var gOPN = __webpack_require__(39).f;
var gOPD = __webpack_require__(18).f;
var dP = __webpack_require__(7).f;
var $trim = __webpack_require__(46).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(38)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(6) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(14)(global, NUMBER, $Number);
}


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toInteger = __webpack_require__(26);
var aNumberValue = __webpack_require__(112);
var repeat = __webpack_require__(80);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(3)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $fails = __webpack_require__(3);
var aNumberValue = __webpack_require__(112);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(0);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(0);
var _isFinite = __webpack_require__(2).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', { isInteger: __webpack_require__(113) });


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(0);
var isInteger = __webpack_require__(113);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(111);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(110);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(0);
var log1p = __webpack_require__(114);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(0);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(0);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(0);
var sign = __webpack_require__(81);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(0);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(0);
var $expm1 = __webpack_require__(82);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { fround: __webpack_require__(115) });


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(0);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(0);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(3)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { log1p: __webpack_require__(114) });


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { sign: __webpack_require__(81) });


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(82);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(3)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(82);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toAbsoluteIndex = __webpack_require__(37);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(17);
var toLength = __webpack_require__(8);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(46)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(83)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(84)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $at = __webpack_require__(83)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(8);
var context = __webpack_require__(86);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(87)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(0);
var context = __webpack_require__(86);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(87)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(80)
});


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(8);
var context = __webpack_require__(86);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(87)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(15)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(15)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(15)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(15)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(15)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(15)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(15)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(15)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(15)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(15)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(15)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(15)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(15)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(0);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(10);
var toPrimitive = __webpack_require__(24);

$export($export.P + $export.F * __webpack_require__(3)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(0);
var toISOString = __webpack_require__(231);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(3);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(14)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(5)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(13)(proto, TO_PRIMITIVE, __webpack_require__(234));


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(1);
var toPrimitive = __webpack_require__(24);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(0);

$export($export.S, 'Array', { isArray: __webpack_require__(57) });


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(20);
var $export = __webpack_require__(0);
var toObject = __webpack_require__(10);
var call = __webpack_require__(116);
var isArrayIter = __webpack_require__(88);
var toLength = __webpack_require__(8);
var createProperty = __webpack_require__(89);
var getIterFn = __webpack_require__(90);

$export($export.S + $export.F * !__webpack_require__(59)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var createProperty = __webpack_require__(89);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(3)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(0);
var toIObject = __webpack_require__(17);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(50) != Object || !__webpack_require__(22)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var html = __webpack_require__(76);
var cof = __webpack_require__(21);
var toAbsoluteIndex = __webpack_require__(37);
var toLength = __webpack_require__(8);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(3)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var aFunction = __webpack_require__(11);
var toObject = __webpack_require__(10);
var fails = __webpack_require__(3);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(22)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $forEach = __webpack_require__(28)(0);
var STRICT = __webpack_require__(22)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(4);
var isArray = __webpack_require__(57);
var SPECIES = __webpack_require__(5)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $map = __webpack_require__(28)(1);

$export($export.P + $export.F * !__webpack_require__(22)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $filter = __webpack_require__(28)(2);

$export($export.P + $export.F * !__webpack_require__(22)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $some = __webpack_require__(28)(3);

$export($export.P + $export.F * !__webpack_require__(22)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $every = __webpack_require__(28)(4);

$export($export.P + $export.F * !__webpack_require__(22)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(117);

$export($export.P + $export.F * !__webpack_require__(22)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(117);

$export($export.P + $export.F * !__webpack_require__(22)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $indexOf = __webpack_require__(55)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(22)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(17);
var toInteger = __webpack_require__(26);
var toLength = __webpack_require__(8);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(22)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { copyWithin: __webpack_require__(118) });

__webpack_require__(32)('copyWithin');


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { fill: __webpack_require__(92) });

__webpack_require__(32)('fill');


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(28)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(32)(KEY);


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(28)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(32)(KEY);


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(40)('Array');


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var inheritIfRequired = __webpack_require__(79);
var dP = __webpack_require__(7).f;
var gOPN = __webpack_require__(39).f;
var isRegExp = __webpack_require__(58);
var $flags = __webpack_require__(60);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(6) && (!CORRECT_NEW || __webpack_require__(3)(function () {
  re2[__webpack_require__(5)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(14)(global, 'RegExp', $RegExp);
}

__webpack_require__(40)('RegExp');


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(120);
var anObject = __webpack_require__(1);
var $flags = __webpack_require__(60);
var DESCRIPTORS = __webpack_require__(6);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(14)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(3)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

// @@match logic
__webpack_require__(61)('match', 1, function (defined, MATCH, $match) {
  // 21.1.3.11 String.prototype.match(regexp)
  return [function match(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  }, $match];
});


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

// @@replace logic
__webpack_require__(61)('replace', 2, function (defined, REPLACE, $replace) {
  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
  return [function replace(searchValue, replaceValue) {
    'use strict';
    var O = defined(this);
    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined
      ? fn.call(searchValue, O, replaceValue)
      : $replace.call(String(O), searchValue, replaceValue);
  }, $replace];
});


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

// @@search logic
__webpack_require__(61)('search', 1, function (defined, SEARCH, $search) {
  // 21.1.3.15 String.prototype.search(regexp)
  return [function search(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  }, $search];
});


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

// @@split logic
__webpack_require__(61)('split', 2, function (defined, SPLIT, $split) {
  'use strict';
  var isRegExp = __webpack_require__(58);
  var _split = $split;
  var $push = [].push;
  var $SPLIT = 'split';
  var LENGTH = 'length';
  var LAST_INDEX = 'lastIndex';
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
    // based on es5-shim implementation, need to rework it
    $split = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return _split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var separator2, match, lastIndex, lastLength, i;
      // Doesn't need flags gy, but they don't hurt
      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
      while (match = separatorCopy.exec(string)) {
        // `separatorCopy.lastIndex` is not reliable cross-browser
        lastIndex = match.index + match[0][LENGTH];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
          // eslint-disable-next-line no-loop-func
          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
          });
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    $split = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
    };
  }
  // 21.1.3.17 String.prototype.split(separator, limit)
  return [function split(separator, limit) {
    var O = defined(this);
    var fn = separator == undefined ? undefined : separator[SPLIT];
    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
  }, $split];
});


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(35);
var global = __webpack_require__(2);
var ctx = __webpack_require__(20);
var classof = __webpack_require__(52);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(4);
var aFunction = __webpack_require__(11);
var anInstance = __webpack_require__(41);
var forOf = __webpack_require__(42);
var speciesConstructor = __webpack_require__(62);
var task = __webpack_require__(94).set;
var microtask = __webpack_require__(95)();
var newPromiseCapabilityModule = __webpack_require__(96);
var perform = __webpack_require__(121);
var promiseResolve = __webpack_require__(122);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(5)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value);
            if (domain) domain.exit();
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  if (promise._h == 1) return false;
  var chain = promise._a || promise._c;
  var i = 0;
  var reaction;
  while (chain.length > i) {
    reaction = chain[i++];
    if (reaction.fail || !isUnhandled(reaction.promise)) return false;
  } return true;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(43)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(45)($Promise, PROMISE);
__webpack_require__(40)(PROMISE);
Wrapper = __webpack_require__(23)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(59)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(127);
var validate = __webpack_require__(48);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(63)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $typed = __webpack_require__(64);
var buffer = __webpack_require__(97);
var anObject = __webpack_require__(1);
var toAbsoluteIndex = __webpack_require__(37);
var toLength = __webpack_require__(8);
var isObject = __webpack_require__(4);
var ArrayBuffer = __webpack_require__(2).ArrayBuffer;
var speciesConstructor = __webpack_require__(62);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(3)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var final = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < final) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(40)(ARRAY_BUFFER);


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
$export($export.G + $export.W + $export.F * !__webpack_require__(64).ABV, {
  DataView: __webpack_require__(97).DataView
});


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(29)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(29)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(29)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(29)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(29)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(29)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(29)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(29)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(29)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(11);
var anObject = __webpack_require__(1);
var rApply = (__webpack_require__(2).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(3)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(0);
var create = __webpack_require__(38);
var aFunction = __webpack_require__(11);
var anObject = __webpack_require__(1);
var isObject = __webpack_require__(4);
var fails = __webpack_require__(3);
var bind = __webpack_require__(108);
var rConstruct = (__webpack_require__(2).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(7);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(1);
var toPrimitive = __webpack_require__(24);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(3)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(0);
var gOPD = __webpack_require__(18).f;
var anObject = __webpack_require__(1);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(1);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(85)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(18);
var getPrototypeOf = __webpack_require__(19);
var has = __webpack_require__(12);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(4);
var anObject = __webpack_require__(1);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(18);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(1);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(0);
var getProto = __webpack_require__(19);
var anObject = __webpack_require__(1);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(1);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(129) });


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(1);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(7);
var gOPD = __webpack_require__(18);
var getPrototypeOf = __webpack_require__(19);
var has = __webpack_require__(12);
var $export = __webpack_require__(0);
var createDesc = __webpack_require__(33);
var anObject = __webpack_require__(1);
var isObject = __webpack_require__(4);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
    existingDescriptor.value = V;
    dP.f(receiver, propertyKey, existingDescriptor);
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(0);
var setProto = __webpack_require__(77);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(0);
var $includes = __webpack_require__(55)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(32)('includes');


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(130);
var toObject = __webpack_require__(10);
var toLength = __webpack_require__(8);
var aFunction = __webpack_require__(11);
var arraySpeciesCreate = __webpack_require__(91);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(32)('flatMap');


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(130);
var toObject = __webpack_require__(10);
var toLength = __webpack_require__(8);
var toInteger = __webpack_require__(26);
var arraySpeciesCreate = __webpack_require__(91);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(32)('flatten');


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(0);
var $at = __webpack_require__(83)(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(131);

$export($export.P, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(131);

$export($export.P, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(46)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(46)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(0);
var defined = __webpack_require__(25);
var toLength = __webpack_require__(8);
var isRegExp = __webpack_require__(58);
var getFlags = __webpack_require__(60);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(85)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(73)('asyncIterator');


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(73)('observable');


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(0);
var ownKeys = __webpack_require__(129);
var toIObject = __webpack_require__(17);
var gOPD = __webpack_require__(18);
var createProperty = __webpack_require__(89);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $values = __webpack_require__(132)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $entries = __webpack_require__(132)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(10);
var aFunction = __webpack_require__(11);
var $defineProperty = __webpack_require__(7);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(6) && $export($export.P + __webpack_require__(65), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(10);
var aFunction = __webpack_require__(11);
var $defineProperty = __webpack_require__(7);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(6) && $export($export.P + __webpack_require__(65), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(10);
var toPrimitive = __webpack_require__(24);
var getPrototypeOf = __webpack_require__(19);
var getOwnPropertyDescriptor = __webpack_require__(18).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(6) && $export($export.P + __webpack_require__(65), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(10);
var toPrimitive = __webpack_require__(24);
var getPrototypeOf = __webpack_require__(19);
var getOwnPropertyDescriptor = __webpack_require__(18).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(6) && $export($export.P + __webpack_require__(65), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(133)('Map') });


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(133)('Set') });


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(66)('Map');


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(66)('Set');


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(66)('WeakMap');


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(66)('WeakSet');


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(67)('Map');


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(67)('Set');


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(67)('WeakMap');


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(67)('WeakSet');


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.G, { global: __webpack_require__(2) });


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.S, 'System', { global: __webpack_require__(2) });


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(0);
var cof = __webpack_require__(21);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var scale = __webpack_require__(135);
var fround = __webpack_require__(115);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { scale: __webpack_require__(135) });


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(0);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(0);
var core = __webpack_require__(23);
var global = __webpack_require__(2);
var speciesConstructor = __webpack_require__(62);
var promiseResolve = __webpack_require__(122);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(0);
var newPromiseCapability = __webpack_require__(96);
var perform = __webpack_require__(121);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(30);
var anObject = __webpack_require__(1);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(30);
var anObject = __webpack_require__(1);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(30);
var anObject = __webpack_require__(1);
var getPrototypeOf = __webpack_require__(19);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(125);
var from = __webpack_require__(134);
var metadata = __webpack_require__(30);
var anObject = __webpack_require__(1);
var getPrototypeOf = __webpack_require__(19);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(30);
var anObject = __webpack_require__(1);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(30);
var anObject = __webpack_require__(1);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(30);
var anObject = __webpack_require__(1);
var getPrototypeOf = __webpack_require__(19);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(30);
var anObject = __webpack_require__(1);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(30);
var anObject = __webpack_require__(1);
var aFunction = __webpack_require__(11);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(0);
var microtask = __webpack_require__(95)();
var process = __webpack_require__(2).process;
var isNode = __webpack_require__(21)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(0);
var global = __webpack_require__(2);
var core = __webpack_require__(23);
var microtask = __webpack_require__(95)();
var OBSERVABLE = __webpack_require__(5)('observable');
var aFunction = __webpack_require__(11);
var anObject = __webpack_require__(1);
var anInstance = __webpack_require__(41);
var redefineAll = __webpack_require__(43);
var hide = __webpack_require__(13);
var forOf = __webpack_require__(42);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(40)('Observable');


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(2);
var $export = __webpack_require__(0);
var navigator = global.navigator;
var slice = [].slice;
var MSIE = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $task = __webpack_require__(94);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(93);
var getKeys = __webpack_require__(36);
var redefine = __webpack_require__(14);
var global = __webpack_require__(2);
var hide = __webpack_require__(13);
var Iterators = __webpack_require__(47);
var wks = __webpack_require__(5);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(350);
module.exports = __webpack_require__(23).RegExp.escape;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(0);
var $re = __webpack_require__(351)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 351 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(353);

__webpack_require__(354);

__webpack_require__(355);

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _polyfillManager = __webpack_require__(71);

var _polyfillManager2 = _interopRequireDefault(_polyfillManager);

var _logger = __webpack_require__(16);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PerformanceNowPolyfill = function () {
  function PerformanceNowPolyfill() {
    _classCallCheck(this, PerformanceNowPolyfill);
  }

  _createClass(PerformanceNowPolyfill, null, [{
    key: 'install',
    value: function install() {
      if (global.performance && global.performance.now) {
        PerformanceNowPolyfill._logger.debug('No need to install polyfill');
        return;
      }
      PerformanceNowPolyfill._logger.debug('Installing polyfill');
      var startTime = Date.now();
      if (!global.performance) {
        global.performance = {};
      }
      global.performance.now = function () {
        return Date.now() - startTime;
      };
    }
  }]);

  return PerformanceNowPolyfill;
}();

PerformanceNowPolyfill.id = 'performance.now';
PerformanceNowPolyfill._logger = (0, _logger2.default)('PerformanceNowPolyfill');
exports.default = PerformanceNowPolyfill;


_polyfillManager2.default.register(PerformanceNowPolyfill);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _polyfillManager = __webpack_require__(71);

var _polyfillManager2 = _interopRequireDefault(_polyfillManager);

var _logger = __webpack_require__(16);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PrependPolyfill = function () {
  function PrependPolyfill() {
    _classCallCheck(this, PrependPolyfill);
  }

  _createClass(PrependPolyfill, null, [{
    key: 'install',
    value: function install() {
      [Element.prototype, Document.prototype, DocumentFragment.prototype].forEach(function (item) {
        if (item.hasOwnProperty('prepend')) {
          PrependPolyfill._logger.debug('No need to install polyfill on item', item);
          return;
        }
        PrependPolyfill._logger.debug('Installing polyfill on item', item);
        // $FlowFixMe
        Object.defineProperty(item, 'prepend', {
          configurable: true,
          enumerable: true,
          writable: true,
          value: function prepend() {
            var argArr = Array.prototype.slice.call(arguments),
                docFrag = document.createDocumentFragment();

            argArr.forEach(function (argItem) {
              var isNode = argItem instanceof Node;
              docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
            });

            this.insertBefore(docFrag, this.firstChild);
          }
        });
      });
    }
  }]);

  return PrependPolyfill;
}();

PrependPolyfill.id = 'prepend';
PrependPolyfill._logger = (0, _logger2.default)('PrependPolyfill');
exports.default = PrependPolyfill;


_polyfillManager2.default.register(PrependPolyfill);

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {(function(){function l(){function n(a){return a?"object"===typeof a||"function"===typeof a:!1}var p=null;var g=function(a,b){function f(){}if(!n(a)||!n(b))throw new TypeError("Cannot create proxy with a non-object as target or handler");p=function(){f=function(a){throw new TypeError("Cannot perform '"+a+"' on a proxy that has been revoked");}};var e=b;b={get:null,set:null,apply:null,construct:null};for(var k in e){if(!(k in b))throw new TypeError("Proxy polyfill does not support trap '"+k+"'");b[k]=e[k]}"function"===
typeof e&&(b.apply=e.apply.bind(e));var c=this,g=!1,q=!1;"function"===typeof a?(c=function(){var h=this&&this.constructor===c,d=Array.prototype.slice.call(arguments);f(h?"construct":"apply");return h&&b.construct?b.construct.call(this,a,d):!h&&b.apply?b.apply(a,this,d):h?(d.unshift(a),new (a.bind.apply(a,d))):a.apply(this,d)},g=!0):a instanceof Array&&(c=[],q=!0);var r=b.get?function(a){f("get");return b.get(this,a,c)}:function(a){f("get");return this[a]},v=b.set?function(a,d){f("set");b.set(this,
a,d,c)}:function(a,b){f("set");this[a]=b},t={};Object.getOwnPropertyNames(a).forEach(function(b){if(!((g||q)&&b in c)){var d={enumerable:!!Object.getOwnPropertyDescriptor(a,b).enumerable,get:r.bind(a,b),set:v.bind(a,b)};Object.defineProperty(c,b,d);t[b]=!0}});e=!0;Object.setPrototypeOf?Object.setPrototypeOf(c,Object.getPrototypeOf(a)):c.__proto__?c.__proto__=a.__proto__:e=!1;if(b.get||!e)for(var m in a)t[m]||Object.defineProperty(c,m,{get:r.bind(a,m)});Object.seal(a);Object.seal(c);return c};g.revocable=
function(a,b){return{proxy:new g(a,b),revoke:p}};return g};var u="undefined"!==typeof process&&"[object process]"==={}.toString.call(process)||"undefined"!==typeof navigator&&"ReactNative"===navigator.product?global:self;u.Proxy||(u.Proxy=l(),u.Proxy.revocable=u.Proxy.revocable);})()

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(356), __webpack_require__(49)))

/***/ }),
/* 356 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(9),__webpack_require__(358)):"function"==typeof define&&define.amd?define("hls",["pakhshkit-js","hls.js"],t):"object"==typeof exports?exports.hls=t(require("@pakhshkit-js/pakhshkit-js"),require("hls.js")):(e.pakhshkit=e.pakhshkit||{},e.pakhshkit.hls=t(e.pakhshkit.core,e.Hls))}(this,function(e,t){return function(e){function t(a){if(r[a])return r[a].exports;var i=r[a]={i:a,l:!1,exports:{}};return e[a].call(i.exports,i,i.exports,t),i.l=!0,i.exports}var r={};return t.m=e,t.c=r,t.d=function(e,r,a){t.o(e,r)||Object.defineProperty(e,r,{configurable:!1,enumerable:!0,get:a})},t.n=function(e){var r=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(r,"a",r),r},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=2)}([function(t,r){t.exports=e},function(e,r){e.exports=t},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.NAME=t.VERSION=void 0;var a=r(0),i=r(3),o=function(e){return e&&e.__esModule?e:{default:e}}(i);t.default=o.default,t.VERSION="1.13.1",t.NAME="@pakhshkit-js/pakhshkit-js-hls",o.default.isSupported()&&(0,a.registerMediaSourceAdapter)(o.default)},function(e,t,r){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function n(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function e(t,r,a){null===t&&(t=Function.prototype);var i=Object.getOwnPropertyDescriptor(t,r);if(void 0===i){var o=Object.getPrototypeOf(t);return null===o?void 0:e(o,r,a)}if("value"in i)return i.value;var n=i.get;if(void 0!==n)return n.call(a)},l=function(){function e(e,t){for(var r=0;r<t.length;r++){var a=t[r];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,r,a){return r&&e(t.prototype,r),a&&e(t,a),t}}(),c=r(1),d=a(c),u=r(4),h=a(u),_=r(5),f=r(0),E=r(6),v=a(E),p=function(e){function t(e,r,a){i(this,t),t._logger.debug("Creating adapter. Hls version: "+d.default.version);var n=o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e,r,a));return n._triedReloadWithRedirect=!1,n._startTime=0,n._config=f.Utils.Object.mergeDeep({},h.default,n._config),n._config.forceRedirectExternalStreams&&(n._config.hlsConfig.pLoader=v.default),n._hls=new d.default(n._config.hlsConfig),n._capabilities.fpsControl=!0,n._hls.subtitleDisplay=n._config.subtitleDisplay,n._addBindings(),n}return n(t,e),l(t,null,[{key:"createAdapter",value:function(e,t,r){var a=f.Utils.Object.copyDeep(h.default);if(f.Utils.Object.hasPropertyPath(r,"sources.options")){var i=r.sources.options;a.forceRedirectExternalStreams=i.forceRedirectExternalStreams,a.redirectExternalStreamsHandler=i.redirectExternalStreamsHandler,a.redirectExternalStreamsTimeout=i.redirectExternalStreamsTimeout,v.default.redirectExternalStreamsHandler=a.redirectExternalStreamsHandler,v.default.redirectExternalStreamsTimeout=a.redirectExternalStreamsTimeout}if(f.Utils.Object.hasPropertyPath(r,"playback.startTime")){f.Utils.Object.getPropertyPath(r,"playback.startTime")>-1&&(a.hlsConfig.startPosition=r.playback.startTime)}if(f.Utils.Object.hasPropertyPath(r,"playback.useNativeTextTrack")&&(a.subtitleDisplay=f.Utils.Object.getPropertyPath(r,"playback.useNativeTextTrack")),f.Utils.Object.hasPropertyPath(r,"abr.fpsDroppedFramesInterval")&&(a.hlsConfig.fpsDroppedFramesInterval=r.abr.fpsDroppedFramesInterval),f.Utils.Object.hasPropertyPath(r,"abr.fpsDroppedMonitoringThreshold")&&(a.hlsConfig.fpsDroppedMonitoringThreshold=r.abr.fpsDroppedMonitoringThreshold),f.Utils.Object.hasPropertyPath(r,"abr.capLevelOnFPSDrop")&&(a.hlsConfig.capLevelOnFPSDrop=r.abr.capLevelOnFPSDrop),a.hlsConfig.enableCEA708Captions=r.playback.enableCEA708Captions,a.hlsConfig.captionsTextTrack1Label=r.playback.captionsTextTrack1Label,a.hlsConfig.captionsTextTrack1LanguageCode=r.playback.captionsTextTrack1LanguageCode,a.hlsConfig.captionsTextTrack2Label=r.playback.captionsTextTrack2Label,a.hlsConfig.captionsTextTrack2LanguageCode=r.playback.captionsTextTrack2LanguageCode,f.Utils.Object.hasPropertyPath(r,"abr")){var o=r.abr;"boolean"==typeof o.enabled&&(a.abr.enabled=o.enabled),"boolean"==typeof o.capLevelToPlayerSize&&(a.hlsConfig.capLevelToPlayerSize=o.capLevelToPlayerSize),o.defaultBandwidthEstimate&&(a.hlsConfig.abrEwmaDefaultEstimate=o.defaultBandwidthEstimate),o.restrictions&&(o.restrictions.minBitrate>0&&(a.hlsConfig.minAutoBitrate=o.restrictions.minBitrate),o.restrictions.maxBitrate<1/0&&(a.hlsConfig.capLevelToPlayerSize=!1,a.abr.restrictions=o.restrictions))}return f.Utils.Object.hasPropertyPath(r,"playback.options.html5.hls")&&f.Utils.Object.mergeDeep(a.hlsConfig,r.playback.options.html5.hls),new this(e,t,a)}},{key:"canPlayType",value:function(e){var r="string"==typeof e&&t._hlsMimeTypes.includes(e.toLowerCase());return t._logger.debug("canPlayType result for mimeType:"+e+" is "+r.toString()),r}},{key:"canPlayDrm",value:function(){return t._logger.warn("canPlayDrm result is false"),!1}},{key:"isSupported",value:function(){var e=d.default.isSupported();return t._logger.debug("isSupported:"+e),e}}]),l(t,[{key:"_addBindings",value:function(){var e=this;this._hls.on(d.default.Events.ERROR,function(t,r){return e._onError(r)}),this._hls.on(d.default.Events.MANIFEST_LOADED,this._onManifestLoaded.bind(this)),this._hls.on(d.default.Events.LEVEL_SWITCHED,this._onLevelSwitched.bind(this)),this._hls.on(d.default.Events.AUDIO_TRACK_SWITCHED,this._onAudioTrackSwitched.bind(this)),this._hls.on(d.default.Events.FPS_DROP,function(t,r){return e._onFpsDrop(r)}),this._hls.on(d.default.Events.FRAG_PARSING_METADATA,function(t,r){return e._onFragParsingMetadata(r)}),this._mediaAttachedPromise=new Promise(function(t){return e._onMediaAttached=t}),this._hls.on(d.default.Events.MEDIA_ATTACHED,function(){return e._onMediaAttached()}),this._onRecoveredCallback=function(){return e._onRecovered()},this._onAddTrack=this._onAddTrack.bind(this),this._videoElement.addEventListener("addtrack",this._onAddTrack),this._videoElement.textTracks.onaddtrack=this._onAddTrack}},{key:"_onFpsDrop",value:function(e){this._trigger(f.EventType.FPS_DROP,e)}},{key:"_onFragParsingMetadata",value:function(e){this._trigger("hlsFragParsingMetadata",e)}},{key:"_onAddTrack",value:function(e){if(!this._hls.subtitleTracks.length){var r=this._parseCEATextTrack(e.track);r&&(t._logger.debug("A CEA 608/708 caption has found",r),this._playerTracks.push(r),this._trigger(f.EventType.TRACKS_CHANGED,{tracks:this._playerTracks}))}}},{key:"handleMediaError",value:function(e){return e.code===e.MEDIA_ERR_DECODE&&(t._logger.debug("The video playback was aborted due to a corruption problem or because the video used features your browser did not support.",e.message),this._handleMediaError())}},{key:"load",value:function(e){var t=this;return this._loadPromise||(this._startTime=e,this._loadPromise=new Promise(function(e){t._resolveLoad=e,t._loadInternal()})),this._loadPromise}},{key:"_loadInternal",value:function(){this._sourceObj&&this._sourceObj.url&&(this._hls.loadSource(this._sourceObj.url),this._hls.attachMedia(this._videoElement),this._trigger(f.EventType.ABR_MODE_CHANGED,{mode:this.isAdaptiveBitrateEnabled()?"auto":"manual"}))}},{key:"_reloadWithDirectManifest",value:function(){this._triedReloadWithRedirect=!0,this._reset(),this._config.hlsConfig.pLoader=v.default,this._hls=new d.default(this._config.hlsConfig),this._addBindings(),this._loadInternal()}},{key:"_removeRecoveredCallbackListener",value:function(){this._onRecoveredCallback&&(this._videoElement.removeEventListener(f.EventType.LOADED_METADATA,this._onRecoveredCallback),this._onRecoveredCallback=null)}},{key:"destroy",value:function(){var e=this;return s(t.prototype.__proto__||Object.getPrototypeOf(t.prototype),"destroy",this).call(this).then(function(){t._logger.debug("destroy"),e._loadPromise=null,e._playerTracks=[],e._reset()})}},{key:"_reset",value:function(){this._removeBindings(),clearTimeout(this._resolveLoadTimeout),this._hls.detachMedia(),this._hls.destroy()}},{key:"_parseTracks",value:function(){var e=this._parseAudioTracks(this._hls.audioTracks||[]),t=this._parseVideoTracks(this._hls.levels||[]),r=this._parseTextTracks(this._hls.subtitleTracks||[]);return e.concat(t).concat(r)}},{key:"_parseAudioTracks",value:function(e){for(var t=[],r=0;r<e.length;r++){var a={id:e[r].id,active:this._hls.audioTrack===e[r].id,label:e[r].name,language:e[r].lang,index:r};t.push(new f.AudioTrack(a))}return t}},{key:"_parseVideoTracks",value:function(e){for(var t=[],r=0;r<e.length;r++){var a={active:this._hls.startLevel===r,bandwidth:e[r].bitrate,width:e[r].width,height:e[r].height,language:"",index:r};t.push(new f.VideoTrack(a))}return t}},{key:"_parseTextTracks",value:function(e){for(var t=[],r=0;r<e.length;r++){var a={id:e[r].id,active:e[r].default,label:e[r].name,kind:e[r].type.toLowerCase(),language:e[r].lang,index:r};t.push(new f.TextTrack(a))}return t}},{key:"_parseCEATextTrack",value:function(e){var t=null;if("captions"===e.kind){var r={id:e.id,active:"showing"===e.mode,label:e.label,kind:e.kind,language:e.language,index:this._playerTracks.filter(function(e){return e instanceof f.TextTrack}).length};t=new f.TextTrack(r)}return t}},{key:"selectAudioTrack",value:function(e){e instanceof f.AudioTrack&&!e.active&&this._hls.audioTracks&&(this._hls.audioTrack=e.id)}},{key:"selectVideoTrack",value:function(e){e instanceof f.VideoTrack&&(!e.active||this.isAdaptiveBitrateEnabled())&&this._hls.levels&&(this.isAdaptiveBitrateEnabled()&&this._trigger(f.EventType.ABR_MODE_CHANGED,{mode:"manual"}),this._hls.currentLevel=e.index)}},{key:"selectTextTrack",value:function(e){e instanceof f.TextTrack&&!e.active&&(this._hls.subtitleTracks.length?(this._hls.subtitleTrack=e.id,this._notifyTrackChanged(e)):this._selectNativeTextTrack(e))}},{key:"_selectNativeTextTrack",value:function(e){var t=Array.from(this._videoElement.textTracks).find(function(t){return t.language===e.language});t&&(this._disableNativeTextTracks(),t.mode=this._config.subtitleDisplay?"showing":"hidden",this._notifyTrackChanged(e))}},{key:"_notifyTrackChanged",value:function(e){t._logger.debug("Text track changed",e),this._onTrackChanged(e)}},{key:"_disableNativeTextTracks",value:function(){Array.from(this._videoElement.textTracks).forEach(function(e){e.mode="disabled"})}},{key:"hideTextTrack",value:function(){this._hls.subtitleTracks.length?this._hls.subtitleTrack=-1:this._disableNativeTextTracks()}},{key:"enableAdaptiveBitrate",value:function(){this.isAdaptiveBitrateEnabled()||(this._trigger(f.EventType.ABR_MODE_CHANGED,{mode:"auto"}),this._hls.nextLevel=-1)}},{key:"isAdaptiveBitrateEnabled",value:function(){return this._hls.autoLevelEnabled}},{key:"_getLevelDetails",value:function(){var e=this._hls.levels[this._hls.currentLevel]||this._hls.levels[this._hls.nextLevel]||this._hls.levels[this._hls.nextAutoLevel]||this._hls.levels[this._hls.nextLoadLevel];return e&&e.details?e.details:{}}},{key:"_getLiveEdge",value:function(){try{var e=void 0;return e=this._hls.liveSyncPosition?this._hls.liveSyncPosition:this._hls.config.liveSyncDuration?this._videoElement.duration-this._hls.config.liveSyncDuration:this._videoElement.duration-this._hls.config.liveSyncDurationCount*this._getLevelDetails().targetduration,e>0?e:this._videoElement.duration}catch(e){return t._logger.debug("Live edge calculation failed, fall back to duration"),this._videoElement.duration}}},{key:"seekToLiveEdge",value:function(){try{this._videoElement.currentTime=this._getLiveEdge()}catch(e){return}}},{key:"isLive",value:function(){try{return!!this._getLevelDetails().live}catch(e){return!1}}},{key:"_onManifestLoaded",value:function(){var e=this;t._logger.debug("The source has been loaded successfully"),this._hls.config.autoStartLoad||this._hls.startLoad(this._startTime),this._playerTracks=this._parseTracks(),this._maybeApplyAbrRestrictions(),this._mediaAttachedPromise.then(function(){e._resolveLoad({tracks:e._playerTracks})})}},{key:"_maybeApplyAbrRestrictions",value:function(){if(this._config.abr.enabled){if(this._config.abr.restrictions){var e=this._config.abr.restrictions;if(e.maxBitrate){var r=e.minBitrate?e.minBitrate:0;if(e.maxBitrate>r){var a=this._hls.levels.findIndex(function(t){return t.bitrate>e.maxBitrate});a>0&&(a-=1),this._hls.autoLevelCapping=a}else t._logger.warn("Invalid maxBitrate restriction, maxBitrate must be greater than minBitrate",r,e.maxBitrate)}}}else this._hls.currentLevel=0}},{key:"_onLevelSwitched",value:function(e,r){var a=this._playerTracks.find(function(e){return e instanceof f.VideoTrack&&e.index===r.level});t._logger.debug("Video track changed",a),this._onTrackChanged(a)}},{key:"_onAudioTrackSwitched",value:function(e,r){var a=this._playerTracks.find(function(e){return e instanceof f.AudioTrack&&e.id===r.id});t._logger.debug("Audio track changed",a),this._onTrackChanged(a),this._handleWaitingUponAudioTrackSwitch()}},{key:"_handleWaitingUponAudioTrackSwitch",value:function(){var e=this;if(["IE","Edge"].includes(f.Env.browser.name)){var t=function t(){e._trigger(f.EventType.PLAYING),e._videoElement.removeEventListener(f.EventType.TIME_UPDATE,t)};this._videoElement.addEventListener(f.EventType.TIME_UPDATE,t)}}},{key:"_onError",value:function(e){var r=e.type,a=e.details;if(e.fatal){var i=void 0;switch(r){case d.default.ErrorTypes.NETWORK_ERROR:![d.default.ErrorDetails.MANIFEST_LOAD_ERROR,d.default.ErrorDetails.MANIFEST_LOAD_TIMEOUT].includes(a)||this._triedReloadWithRedirect||this._config.forceRedirectExternalStreams?i=new f.Error(f.Error.Severity.CRITICAL,f.Error.Category.NETWORK,f.Error.Code.HTTP_ERROR,a):this._reloadWithDirectManifest();break;case d.default.ErrorTypes.MEDIA_ERROR:i=this._handleMediaError()?new f.Error(f.Error.Severity.RECOVERABLE,f.Error.Category.MEDIA,f.Error.Code.HLS_FATAL_MEDIA_ERROR,a):new f.Error(f.Error.Severity.CRITICAL,f.Error.Category.MEDIA,f.Error.Code.HLS_FATAL_MEDIA_ERROR,a);break;default:i=new f.Error(f.Error.Severity.CRITICAL,f.Error.Category.PLAYER,f.Error.Code.HLS_FATAL_MEDIA_ERROR,a)}this._trigger(f.EventType.ERROR,i),i&&i.severity===f.Error.Severity.CRITICAL&&this.destroy()}else{var o=_.HlsJsErrorMap[a]||{category:0,code:0},n=o.category,s=o.code;t._logger.warn(new f.Error(f.Error.Severity.RECOVERABLE,n,s,a))}}},{key:"_handleMediaError",value:function(){var e=performance.now(),r=!0;return this._checkTimeDeltaHasPassed(e,this._recoverDecodingErrorDate,this._config.recoverDecodingErrorDelay)?(this._videoElement.addEventListener(f.EventType.LOADED_METADATA,this._onRecoveredCallback),this._recoverDecodingError()):this._checkTimeDeltaHasPassed(e,this._recoverSwapAudioCodecDate,this._config.recoverSwapAudioCodecDelay)?(this._videoElement.addEventListener(f.EventType.LOADED_METADATA,this._onRecoveredCallback),this._recoverSwapAudioCodec()):(r=!1,t._logger.error("cannot recover, last media error recovery failed")),r}},{key:"_onRecovered",value:function(){this._trigger(f.EventType.MEDIA_RECOVERED),this._videoElement.removeEventListener(f.EventType.LOADED_METADATA,this._onRecoveredCallback)}},{key:"_checkTimeDeltaHasPassed",value:function(e,t,r){return!t||e-t>r}},{key:"_recoverDecodingError",value:function(){this._recoverDecodingErrorDate=performance.now(),t._logger.warn("try to recover media Error"),this._hls.recoverMediaError()}},{key:"_recoverSwapAudioCodec",value:function(){this._recoverSwapAudioCodecDate=performance.now(),t._logger.warn("try to swap Audio Codec and recover media Error"),this._hls.swapAudioCodec(),this._hls.recoverMediaError()}},{key:"_removeBindings",value:function(){this._hls.off(d.default.Events.ERROR,this._onError),this._hls.off(d.default.Events.LEVEL_SWITCHED,this._onLevelSwitched),this._hls.off(d.default.Events.AUDIO_TRACK_SWITCHED,this._onAudioTrackSwitched),this._hls.off(d.default.Events.MANIFEST_LOADED,this._onManifestLoaded),this._hls.off(d.default.Events.FPS_DROP,this._onFpsDrop),this._videoElement.textTracks.onaddtrack=null,this._videoElement.removeEventListener("addtrack",this._onAddTrack),this._removeRecoveredCallbackListener()}},{key:"getStartTimeOfDvrWindow",value:function(){if(!this.isLive())return 0;try{var e=this._hls.levels[this._hls.nextLoadLevel],r=e.details,a=r.fragments,i=a.length,o=a[0].start+a[0].duration,n=a[i-1].start+a[i-1].duration,s=void 0!==this._hls.config.liveMaxLatencyDuration?this._hls.config.liveMaxLatencyDuration:this._hls.config.liveMaxLatencyDurationCount*r.targetduration;return Math.max(o-this._hls.config.maxFragLookUpTolerance,n-s)}catch(e){return t._logger.debug("Unable obtain the start of DVR window"),0}}}]),t}(f.BaseMediaSourceAdapter);p.id="HlsAdapter",p._logger=f.BaseMediaSourceAdapter.getLogger(p.id),p._hlsMimeTypes=["application/x-mpegurl","application/vnd.apple.mpegurl","audio/mpegurl","audio/x-mpegurl","video/x-mpegurl","video/mpegurl","application/mpegurl"],t.default=p},function(e,t){e.exports={recoverDecodingErrorDelay:3e3,recoverSwapAudioCodecDelay:3e3,abr:{enabled:!0,restrictions:{}},hlsConfig:{fragLoadingMaxRetry:4,maxMaxBufferLength:60}}},function(e,t,r){"use strict";function a(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}Object.defineProperty(t,"__esModule",{value:!0}),t.HlsJsErrorMap=void 0;var i,o=r(1),n=function(e){return e&&e.__esModule?e:{default:e}}(o),s=r(0),l=(i={},a(i,n.default.ErrorDetails.MANIFEST_LOAD_ERROR,{category:s.Error.Category.MANIFEST,code:s.Error.Code.HTTP_ERROR}),a(i,n.default.ErrorDetails.MANIFEST_LOAD_TIMEOUT,{category:s.Error.Category.MANIFEST,code:s.Error.Code.TIMEOUT}),a(i,n.default.ErrorDetails.MANIFEST_PARSING_ERROR,{category:s.Error.Category.MANIFEST,code:s.Error.Code.HLSJS_CANNOT_PARSE}),a(i,n.default.ErrorDetails.LEVEL_LOAD_ERROR,{category:s.Error.Category.NETWORK,code:s.Error.Code.HTTP_ERROR}),a(i,n.default.ErrorDetails.LEVEL_LOAD_TIMEOUT,{category:s.Error.Category.NETWORK,code:s.Error.Code.TIMEOUT}),a(i,n.default.ErrorDetails.LEVEL_SWITCH_ERROR,{category:s.Error.Category.PLAYER,code:s.Error.Code.BITRATE_SWITCH_ISSUE}),a(i,n.default.ErrorDetails.FRAG_LOAD_ERROR,{category:s.Error.Category.NETWORK,code:s.Error.Code.HTTP_ERROR}),a(i,n.default.ErrorDetails.FRAG_LOOP_LOADING_ERROR,{category:s.Error.Category.NETWORK,code:s.Error.Code.HTTP_ERROR}),a(i,n.default.ErrorDetails.FRAG_LOAD_TIMEOUT,{category:s.Error.Category.NETWORK,code:s.Error.Code.TIMEOUT}),a(i,n.default.ErrorDetails.FRAG_PARSING_ERROR,{category:s.Error.Category.MEDIA,code:s.Error.Code.HLS_FRAG_PARSING_ERROR}),a(i,n.default.ErrorDetails.BUFFER_APPEND_ERROR,{category:s.Error.Category.MEDIA,code:s.Error.Code.HLS_BUFFER_APPEND_ISSUE}),a(i,n.default.ErrorDetails.BUFFER_APPENDING_ERROR,{category:s.Error.Category.MEDIA,code:s.Error.Code.HLS_BUFFER_APPENDING_ISSUE}),a(i,n.default.ErrorDetails.BUFFER_STALLED_ERROR,{category:s.Error.Category.MEDIA,code:s.Error.Code.HLS_BUFFER_STALLED_ERROR}),i);t.HlsJsErrorMap=l},function(e,t,r){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var n=r(0),s=r(1),l=function(e){return e&&e.__esModule?e:{default:e}}(s),c=function(e){function t(e){a(this,t);var r=i(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e)),o=r.load.bind(r),s=t.redirectExternalStreamsHandler;return r.load=function(e,r,a){var i=e.url;"manifest"===e.type?n.Utils.Http.jsonp(i,s,{timeout:t.redirectExternalStreamsTimeout}).then(function(t){e.url=t,o(e,r,a)}).catch(function(){return o(e,r,a)}):o(e,r,a)},r}return o(t,e),t}(l.default.DefaultConfig.loader);c.redirectExternalStreamsHandler=function(e){return e},t.default=c}])});


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

typeof window !== "undefined" &&
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Hls"] = factory();
	else
		root["Hls"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/hls.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./node_modules/eventemitter3/index.js":
/*!*********************************************!*\
  !*** ./node_modules/eventemitter3/index.js ***!
  \*********************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty
  , prefix = '~';

/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */
function Events() {}

//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
  Events.prototype = Object.create(null);

  //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //
  if (!new Events().__proto__) prefix = false;
}

/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */
function addListener(emitter, event, fn, context, once) {
  if (typeof fn !== 'function') {
    throw new TypeError('The listener must be a function');
  }

  var listener = new EE(fn, context || emitter, once)
    , evt = prefix ? prefix + event : event;

  if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
  else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
  else emitter._events[evt] = [emitter._events[evt], listener];

  return emitter;
}

/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */
function clearEvent(emitter, evt) {
  if (--emitter._eventsCount === 0) emitter._events = new Events();
  else delete emitter._events[evt];
}

/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */
function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var names = []
    , events
    , name;

  if (this._eventsCount === 0) return names;

  for (name in (events = this._events)) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */
EventEmitter.prototype.listeners = function listeners(event) {
  var evt = prefix ? prefix + event : event
    , handlers = this._events[evt];

  if (!handlers) return [];
  if (handlers.fn) return [handlers.fn];

  for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
    ee[i] = handlers[i].fn;
  }

  return ee;
};

/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */
EventEmitter.prototype.listenerCount = function listenerCount(event) {
  var evt = prefix ? prefix + event : event
    , listeners = this._events[evt];

  if (!listeners) return 0;
  if (listeners.fn) return 1;
  return listeners.length;
};

/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  return addListener(this, event, fn, context, false);
};

/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  return addListener(this, event, fn, context, true);
};

/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return this;
  if (!fn) {
    clearEvent(this, evt);
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (
      listeners.fn === fn &&
      (!once || listeners.once) &&
      (!context || listeners.context === context)
    ) {
      clearEvent(this, evt);
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (
        listeners[i].fn !== fn ||
        (once && !listeners[i].once) ||
        (context && listeners[i].context !== context)
      ) {
        events.push(listeners[i]);
      }
    }

    //
    // Reset the array, or remove it completely if we have no more listeners.
    //
    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
    else clearEvent(this, evt);
  }

  return this;
};

/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) clearEvent(this, evt);
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;

//
// Expose the module.
//
if (true) {
  module.exports = EventEmitter;
}


/***/ }),

/***/ "./node_modules/node-libs-browser/node_modules/events/events.js":
/*!**********************************************************************!*\
  !*** ./node_modules/node-libs-browser/node_modules/events/events.js ***!
  \**********************************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}


/***/ }),

/***/ "./node_modules/url-toolkit/src/url-toolkit.js":
/*!*****************************************************!*\
  !*** ./node_modules/url-toolkit/src/url-toolkit.js ***!
  \*****************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

// see https://tools.ietf.org/html/rfc1808

/* jshint ignore:start */
(function(root) { 
/* jshint ignore:end */

  var URL_REGEX = /^((?:[a-zA-Z0-9+\-.]+:)?)(\/\/[^\/?#]*)?((?:[^\/\?#]*\/)*.*?)??(;.*?)?(\?.*?)?(#.*?)?$/;
  var FIRST_SEGMENT_REGEX = /^([^\/?#]*)(.*)$/;
  var SLASH_DOT_REGEX = /(?:\/|^)\.(?=\/)/g;
  var SLASH_DOT_DOT_REGEX = /(?:\/|^)\.\.\/(?!\.\.\/).*?(?=\/)/g;

  var URLToolkit = { // jshint ignore:line
    // If opts.alwaysNormalize is true then the path will always be normalized even when it starts with / or //
    // E.g
    // With opts.alwaysNormalize = false (default, spec compliant)
    // http://a.com/b/cd + /e/f/../g => http://a.com/e/f/../g
    // With opts.alwaysNormalize = true (not spec compliant)
    // http://a.com/b/cd + /e/f/../g => http://a.com/e/g
    buildAbsoluteURL: function(baseURL, relativeURL, opts) {
      opts = opts || {};
      // remove any remaining space and CRLF
      baseURL = baseURL.trim();
      relativeURL = relativeURL.trim();
      if (!relativeURL) {
        // 2a) If the embedded URL is entirely empty, it inherits the
        // entire base URL (i.e., is set equal to the base URL)
        // and we are done.
        if (!opts.alwaysNormalize) {
          return baseURL;
        }
        var basePartsForNormalise = URLToolkit.parseURL(baseURL);
        if (!basePartsForNormalise) {
          throw new Error('Error trying to parse base URL.');
        }
        basePartsForNormalise.path = URLToolkit.normalizePath(basePartsForNormalise.path);
        return URLToolkit.buildURLFromParts(basePartsForNormalise);
      }
      var relativeParts = URLToolkit.parseURL(relativeURL);
      if (!relativeParts) {
        throw new Error('Error trying to parse relative URL.');
      }
      if (relativeParts.scheme) {
        // 2b) If the embedded URL starts with a scheme name, it is
        // interpreted as an absolute URL and we are done.
        if (!opts.alwaysNormalize) {
          return relativeURL;
        }
        relativeParts.path = URLToolkit.normalizePath(relativeParts.path);
        return URLToolkit.buildURLFromParts(relativeParts);
      }
      var baseParts = URLToolkit.parseURL(baseURL);
      if (!baseParts) {
        throw new Error('Error trying to parse base URL.');
      }
      if (!baseParts.netLoc && baseParts.path && baseParts.path[0] !== '/') {
        // If netLoc missing and path doesn't start with '/', assume everthing before the first '/' is the netLoc
        // This causes 'example.com/a' to be handled as '//example.com/a' instead of '/example.com/a'
        var pathParts = FIRST_SEGMENT_REGEX.exec(baseParts.path);
        baseParts.netLoc = pathParts[1];
        baseParts.path = pathParts[2];
      }
      if (baseParts.netLoc && !baseParts.path) {
        baseParts.path = '/';
      }
      var builtParts = {
        // 2c) Otherwise, the embedded URL inherits the scheme of
        // the base URL.
        scheme: baseParts.scheme,
        netLoc: relativeParts.netLoc,
        path: null,
        params: relativeParts.params,
        query: relativeParts.query,
        fragment: relativeParts.fragment
      };
      if (!relativeParts.netLoc) {
        // 3) If the embedded URL's <net_loc> is non-empty, we skip to
        // Step 7.  Otherwise, the embedded URL inherits the <net_loc>
        // (if any) of the base URL.
        builtParts.netLoc = baseParts.netLoc;
        // 4) If the embedded URL path is preceded by a slash "/", the
        // path is not relative and we skip to Step 7.
        if (relativeParts.path[0] !== '/') {
          if (!relativeParts.path) {
            // 5) If the embedded URL path is empty (and not preceded by a
            // slash), then the embedded URL inherits the base URL path
            builtParts.path = baseParts.path;
            // 5a) if the embedded URL's <params> is non-empty, we skip to
            // step 7; otherwise, it inherits the <params> of the base
            // URL (if any) and
            if (!relativeParts.params) {
              builtParts.params = baseParts.params;
              // 5b) if the embedded URL's <query> is non-empty, we skip to
              // step 7; otherwise, it inherits the <query> of the base
              // URL (if any) and we skip to step 7.
              if (!relativeParts.query) {
                builtParts.query = baseParts.query;
              }
            }
          } else {
            // 6) The last segment of the base URL's path (anything
            // following the rightmost slash "/", or the entire path if no
            // slash is present) is removed and the embedded URL's path is
            // appended in its place.
            var baseURLPath = baseParts.path;
            var newPath = baseURLPath.substring(0, baseURLPath.lastIndexOf('/') + 1) + relativeParts.path;
            builtParts.path = URLToolkit.normalizePath(newPath);
          }
        }
      }
      if (builtParts.path === null) {
        builtParts.path = opts.alwaysNormalize ? URLToolkit.normalizePath(relativeParts.path) : relativeParts.path;
      }
      return URLToolkit.buildURLFromParts(builtParts);
    },
    parseURL: function(url) {
      var parts = URL_REGEX.exec(url);
      if (!parts) {
        return null;
      }
      return {
        scheme: parts[1] || '',
        netLoc: parts[2] || '',
        path: parts[3] || '',
        params: parts[4] || '',
        query: parts[5] || '',
        fragment: parts[6] || ''
      };
    },
    normalizePath: function(path) {
      // The following operations are
      // then applied, in order, to the new path:
      // 6a) All occurrences of "./", where "." is a complete path
      // segment, are removed.
      // 6b) If the path ends with "." as a complete path segment,
      // that "." is removed.
      path = path.split('').reverse().join('').replace(SLASH_DOT_REGEX, '');
      // 6c) All occurrences of "<segment>/../", where <segment> is a
      // complete path segment not equal to "..", are removed.
      // Removal of these path segments is performed iteratively,
      // removing the leftmost matching pattern on each iteration,
      // until no matching pattern remains.
      // 6d) If the path ends with "<segment>/..", where <segment> is a
      // complete path segment not equal to "..", that
      // "<segment>/.." is removed.
      while (path.length !== (path = path.replace(SLASH_DOT_DOT_REGEX, '')).length) {} // jshint ignore:line
      return path.split('').reverse().join('');
    },
    buildURLFromParts: function(parts) {
      return parts.scheme + parts.netLoc + parts.path + parts.params + parts.query + parts.fragment;
    }
  };

/* jshint ignore:start */
  if(true)
    module.exports = URLToolkit;
  else {}
})(this);
/* jshint ignore:end */


/***/ }),

/***/ "./node_modules/webworkify-webpack/index.js":
/*!**************************************************!*\
  !*** ./node_modules/webworkify-webpack/index.js ***!
  \**************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

function webpackBootstrapFunc (modules) {
/******/  // The module cache
/******/  var installedModules = {};

/******/  // The require function
/******/  function __webpack_require__(moduleId) {

/******/    // Check if module is in cache
/******/    if(installedModules[moduleId])
/******/      return installedModules[moduleId].exports;

/******/    // Create a new module (and put it into the cache)
/******/    var module = installedModules[moduleId] = {
/******/      i: moduleId,
/******/      l: false,
/******/      exports: {}
/******/    };

/******/    // Execute the module function
/******/    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/    // Flag the module as loaded
/******/    module.l = true;

/******/    // Return the exports of the module
/******/    return module.exports;
/******/  }

/******/  // expose the modules object (__webpack_modules__)
/******/  __webpack_require__.m = modules;

/******/  // expose the module cache
/******/  __webpack_require__.c = installedModules;

/******/  // identity function for calling harmony imports with the correct context
/******/  __webpack_require__.i = function(value) { return value; };

/******/  // define getter function for harmony exports
/******/  __webpack_require__.d = function(exports, name, getter) {
/******/    if(!__webpack_require__.o(exports, name)) {
/******/      Object.defineProperty(exports, name, {
/******/        configurable: false,
/******/        enumerable: true,
/******/        get: getter
/******/      });
/******/    }
/******/  };

/******/  // define __esModule on exports
/******/  __webpack_require__.r = function(exports) {
/******/    Object.defineProperty(exports, '__esModule', { value: true });
/******/  };

/******/  // getDefaultExport function for compatibility with non-harmony modules
/******/  __webpack_require__.n = function(module) {
/******/    var getter = module && module.__esModule ?
/******/      function getDefault() { return module['default']; } :
/******/      function getModuleExports() { return module; };
/******/    __webpack_require__.d(getter, 'a', getter);
/******/    return getter;
/******/  };

/******/  // Object.prototype.hasOwnProperty.call
/******/  __webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

/******/  // __webpack_public_path__
/******/  __webpack_require__.p = "/";

/******/  // on error function for async loading
/******/  __webpack_require__.oe = function(err) { console.error(err); throw err; };

  var f = __webpack_require__(__webpack_require__.s = ENTRY_MODULE)
  return f.default || f // try to call default if defined to also support babel esmodule exports
}

var moduleNameReqExp = '[\\.|\\-|\\+|\\w|\/|@]+'
var dependencyRegExp = '\\((\/\\*.*?\\*\/)?\s?.*?(' + moduleNameReqExp + ').*?\\)' // additional chars when output.pathinfo is true

// http://stackoverflow.com/a/2593661/130442
function quoteRegExp (str) {
  return (str + '').replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&')
}

function isNumeric(n) {
  return !isNaN(1 * n); // 1 * n converts integers, integers as string ("123"), 1e3 and "1e3" to integers and strings to NaN
}

function getModuleDependencies (sources, module, queueName) {
  var retval = {}
  retval[queueName] = []

  var fnString = module.toString()
  var wrapperSignature = fnString.match(/^function\s?\(\w+,\s*\w+,\s*(\w+)\)/)
  if (!wrapperSignature) return retval
  var webpackRequireName = wrapperSignature[1]

  // main bundle deps
  var re = new RegExp('(\\\\n|\\W)' + quoteRegExp(webpackRequireName) + dependencyRegExp, 'g')
  var match
  while ((match = re.exec(fnString))) {
    if (match[3] === 'dll-reference') continue
    retval[queueName].push(match[3])
  }

  // dll deps
  re = new RegExp('\\(' + quoteRegExp(webpackRequireName) + '\\("(dll-reference\\s(' + moduleNameReqExp + '))"\\)\\)' + dependencyRegExp, 'g')
  while ((match = re.exec(fnString))) {
    if (!sources[match[2]]) {
      retval[queueName].push(match[1])
      sources[match[2]] = __webpack_require__(match[1]).m
    }
    retval[match[2]] = retval[match[2]] || []
    retval[match[2]].push(match[4])
  }

  // convert 1e3 back to 1000 - this can be important after uglify-js converted 1000 to 1e3
  var keys = Object.keys(retval);
  for (var i = 0; i < keys.length; i++) {
    for (var j = 0; j < retval[keys[i]].length; j++) {
      if (isNumeric(retval[keys[i]][j])) {
        retval[keys[i]][j] = 1 * retval[keys[i]][j];
      }
    }
  }

  return retval
}

function hasValuesInQueues (queues) {
  var keys = Object.keys(queues)
  return keys.reduce(function (hasValues, key) {
    return hasValues || queues[key].length > 0
  }, false)
}

function getRequiredModules (sources, moduleId) {
  var modulesQueue = {
    main: [moduleId]
  }
  var requiredModules = {
    main: []
  }
  var seenModules = {
    main: {}
  }

  while (hasValuesInQueues(modulesQueue)) {
    var queues = Object.keys(modulesQueue)
    for (var i = 0; i < queues.length; i++) {
      var queueName = queues[i]
      var queue = modulesQueue[queueName]
      var moduleToCheck = queue.pop()
      seenModules[queueName] = seenModules[queueName] || {}
      if (seenModules[queueName][moduleToCheck] || !sources[queueName][moduleToCheck]) continue
      seenModules[queueName][moduleToCheck] = true
      requiredModules[queueName] = requiredModules[queueName] || []
      requiredModules[queueName].push(moduleToCheck)
      var newModules = getModuleDependencies(sources, sources[queueName][moduleToCheck], queueName)
      var newModulesKeys = Object.keys(newModules)
      for (var j = 0; j < newModulesKeys.length; j++) {
        modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]] || []
        modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]].concat(newModules[newModulesKeys[j]])
      }
    }
  }

  return requiredModules
}

module.exports = function (moduleId, options) {
  options = options || {}
  var sources = {
    main: __webpack_require__.m
  }

  var requiredModules = options.all ? { main: Object.keys(sources.main) } : getRequiredModules(sources, moduleId)

  var src = ''

  Object.keys(requiredModules).filter(function (m) { return m !== 'main' }).forEach(function (module) {
    var entryModule = 0
    while (requiredModules[module][entryModule]) {
      entryModule++
    }
    requiredModules[module].push(entryModule)
    sources[module][entryModule] = '(function(module, exports, __webpack_require__) { module.exports = __webpack_require__; })'
    src = src + 'var ' + module + ' = (' + webpackBootstrapFunc.toString().replace('ENTRY_MODULE', JSON.stringify(entryModule)) + ')({' + requiredModules[module].map(function (id) { return '' + JSON.stringify(id) + ': ' + sources[module][id].toString() }).join(',') + '});\n'
  })

  src = src + 'new ((' + webpackBootstrapFunc.toString().replace('ENTRY_MODULE', JSON.stringify(moduleId)) + ')({' + requiredModules.main.map(function (id) { return '' + JSON.stringify(id) + ': ' + sources.main[id].toString() }).join(',') + '}))(self);'

  var blob = new window.Blob([src], { type: 'text/javascript' })
  if (options.bare) { return blob }

  var URL = window.URL || window.webkitURL || window.mozURL || window.msURL

  var workerUrl = URL.createObjectURL(blob)
  var worker = new window.Worker(workerUrl)
  worker.objectURL = workerUrl

  return worker
}


/***/ }),

/***/ "./src/config.js":
/*!***********************!*\
  !*** ./src/config.js ***!
  \***********************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * HLS config
 */
Object.defineProperty(exports, "__esModule", { value: true });
var abr_controller_1 = __webpack_require__(/*! ./controller/abr-controller */ "./src/controller/abr-controller.js");
var buffer_controller_1 = __webpack_require__(/*! ./controller/buffer-controller */ "./src/controller/buffer-controller.js");
var cap_level_controller_1 = __webpack_require__(/*! ./controller/cap-level-controller */ "./src/controller/cap-level-controller.js");
var fps_controller_1 = __webpack_require__(/*! ./controller/fps-controller */ "./src/controller/fps-controller.js");
var xhr_loader_1 = __webpack_require__(/*! ./utils/xhr-loader */ "./src/utils/xhr-loader.js");
// import FetchLoader from './utils/fetch-loader';
var audio_track_controller_1 = __webpack_require__(/*! ./controller/audio-track-controller */ "./src/controller/audio-track-controller.js");
var audio_stream_controller_1 = __webpack_require__(/*! ./controller/audio-stream-controller */ "./src/controller/audio-stream-controller.js");
var Cues = __webpack_require__(/*! ./utils/cues */ "./src/utils/cues.js");
var timeline_controller_1 = __webpack_require__(/*! ./controller/timeline-controller */ "./src/controller/timeline-controller.js");
var subtitle_track_controller_1 = __webpack_require__(/*! ./controller/subtitle-track-controller */ "./src/controller/subtitle-track-controller.js");
var subtitle_stream_controller_1 = __webpack_require__(/*! ./controller/subtitle-stream-controller */ "./src/controller/subtitle-stream-controller.js");
var eme_controller_1 = __webpack_require__(/*! ./controller/eme-controller */ "./src/controller/eme-controller.js");
var mediakeys_helper_1 = __webpack_require__(/*! ./utils/mediakeys-helper */ "./src/utils/mediakeys-helper.js");
exports.hlsDefaultConfig = {
    autoStartLoad: true,
    startPosition: -1,
    defaultAudioCodec: undefined,
    debug: false,
    capLevelOnFPSDrop: false,
    capLevelToPlayerSize: false,
    initialLiveManifestSize: 1,
    maxBufferLength: 30,
    maxBufferSize: 60 * 1000 * 1000,
    maxBufferHole: 0.5,
    lowBufferWatchdogPeriod: 0.5,
    highBufferWatchdogPeriod: 3,
    nudgeOffset: 0.1,
    nudgeMaxRetry: 3,
    maxFragLookUpTolerance: 0.25,
    liveSyncDurationCount: 3,
    liveMaxLatencyDurationCount: Infinity,
    liveSyncDuration: undefined,
    liveMaxLatencyDuration: undefined,
    liveDurationInfinity: false,
    liveBackBufferLength: Infinity,
    maxMaxBufferLength: 600,
    enableWorker: true,
    enableSoftwareAES: true,
    manifestLoadingTimeOut: 10000,
    manifestLoadingMaxRetry: 1,
    manifestLoadingRetryDelay: 1000,
    manifestLoadingMaxRetryTimeout: 64000,
    startLevel: undefined,
    levelLoadingTimeOut: 10000,
    levelLoadingMaxRetry: 4,
    levelLoadingRetryDelay: 1000,
    levelLoadingMaxRetryTimeout: 64000,
    fragLoadingTimeOut: 20000,
    fragLoadingMaxRetry: 6,
    fragLoadingRetryDelay: 1000,
    fragLoadingMaxRetryTimeout: 64000,
    startFragPrefetch: false,
    fpsDroppedMonitoringPeriod: 5000,
    fpsDroppedMonitoringThreshold: 0.2,
    appendErrorMaxRetry: 3,
    loader: xhr_loader_1.default,
    // loader: FetchLoader,
    fLoader: undefined,
    pLoader: undefined,
    xhrSetup: undefined,
    licenseXhrSetup: undefined,
    // fetchSetup: undefined,
    abrController: abr_controller_1.default,
    bufferController: buffer_controller_1.default,
    capLevelController: cap_level_controller_1.default,
    fpsController: fps_controller_1.default,
    stretchShortVideoTrack: false,
    maxAudioFramesDrift: 1,
    forceKeyFrameOnDiscontinuity: true,
    abrEwmaFastLive: 3,
    abrEwmaSlowLive: 9,
    abrEwmaFastVoD: 3,
    abrEwmaSlowVoD: 9,
    abrEwmaDefaultEstimate: 5e5,
    abrBandWidthFactor: 0.95,
    abrBandWidthUpFactor: 0.7,
    abrMaxWithRealBitrate: false,
    maxStarvationDelay: 4,
    maxLoadingDelay: 4,
    minAutoBitrate: 0,
    emeEnabled: false,
    widevineLicenseUrl: undefined,
    requestMediaKeySystemAccessFunc: mediakeys_helper_1.requestMediaKeySystemAccess // used by eme-controller
};
if (true) {
    exports.hlsDefaultConfig.subtitleStreamController = subtitle_stream_controller_1.SubtitleStreamController;
    exports.hlsDefaultConfig.subtitleTrackController = subtitle_track_controller_1.default;
    exports.hlsDefaultConfig.timelineController = timeline_controller_1.default;
    exports.hlsDefaultConfig.cueHandler = Cues; // used by timeline-controller
    exports.hlsDefaultConfig.enableCEA708Captions = true; // used by timeline-controller
    exports.hlsDefaultConfig.enableWebVTT = true; // used by timeline-controller
    exports.hlsDefaultConfig.captionsTextTrack1Label = 'English'; // used by timeline-controller
    exports.hlsDefaultConfig.captionsTextTrack1LanguageCode = 'en'; // used by timeline-controller
    exports.hlsDefaultConfig.captionsTextTrack2Label = 'Spanish'; // used by timeline-controller
    exports.hlsDefaultConfig.captionsTextTrack2LanguageCode = 'es'; // used by timeline-controller
}
if (true) {
    exports.hlsDefaultConfig.audioStreamController = audio_stream_controller_1.default;
    exports.hlsDefaultConfig.audioTrackController = audio_track_controller_1.default;
}
if (true) {
    exports.hlsDefaultConfig.emeController = eme_controller_1.default;
}


/***/ }),

/***/ "./src/controller/abr-controller.js":
/*!******************************************!*\
  !*** ./src/controller/abr-controller.js ***!
  \******************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Number) {
/*
 * simple ABR Controller
 *  - compute next level based on last fragment bw heuristics
 *  - implement an abandon rules triggered if we have less than 2 frag buffered and if computed bw shows that we risk buffer stalling
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var event_handler_1 = __webpack_require__(/*! ../event-handler */ "./src/event-handler.js");
var buffer_helper_1 = __webpack_require__(/*! ../utils/buffer-helper */ "./src/utils/buffer-helper.js");
var errors_1 = __webpack_require__(/*! ../errors */ "./src/errors.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var ewma_bandwidth_estimator_1 = __webpack_require__(/*! ../utils/ewma-bandwidth-estimator */ "./src/utils/ewma-bandwidth-estimator.js");
var performance = window.performance;
var AbrController = /** @class */ (function (_super) {
    __extends(AbrController, _super);
    function AbrController(hls) {
        var _this = _super.call(this, hls, events_1.default.FRAG_LOADING, events_1.default.FRAG_LOADED, events_1.default.FRAG_BUFFERED, events_1.default.ERROR) || this;
        _this.lastLoadedFragLevel = 0;
        _this._nextAutoLevel = -1;
        _this.hls = hls;
        _this.timer = null;
        _this._bwEstimator = null;
        _this.onCheck = _this._abandonRulesCheck.bind(_this);
        return _this;
    }
    AbrController.prototype.destroy = function () {
        this.clearTimer();
        event_handler_1.default.prototype.destroy.call(this);
    };
    AbrController.prototype.onFragLoading = function (data) {
        var frag = data.frag;
        if (frag.type === 'main') {
            if (!this.timer) {
                this.fragCurrent = frag;
                this.timer = setInterval(this.onCheck, 100);
            }
            // lazy init of BwEstimator, rationale is that we use different params for Live/VoD
            // so we need to wait for stream manifest / playlist type to instantiate it.
            if (!this._bwEstimator) {
                var hls_1 = this.hls;
                var config = hls_1.config;
                var level = frag.level;
                var isLive = hls_1.levels[level].details.live;
                var ewmaFast = void 0, ewmaSlow = void 0;
                if (isLive) {
                    ewmaFast = config.abrEwmaFastLive;
                    ewmaSlow = config.abrEwmaSlowLive;
                }
                else {
                    ewmaFast = config.abrEwmaFastVoD;
                    ewmaSlow = config.abrEwmaSlowVoD;
                }
                this._bwEstimator = new ewma_bandwidth_estimator_1.default(hls_1, ewmaSlow, ewmaFast, config.abrEwmaDefaultEstimate);
            }
        }
    };
    AbrController.prototype._abandonRulesCheck = function () {
        /*
          monitor fragment retrieval time...
          we compute expected time of arrival of the complete fragment.
          we compare it to expected time of buffer starvation
        */
        var hls = this.hls;
        var video = hls.media;
        var frag = this.fragCurrent;
        if (!frag) {
            return;
        }
        var loader = frag.loader;
        var minAutoLevel = hls.minAutoLevel;
        // if loader has been destroyed or loading has been aborted, stop timer and return
        if (!loader || (loader.stats && loader.stats.aborted)) {
            logger_1.logger.warn('frag loader destroy or aborted, disarm abandonRules');
            this.clearTimer();
            // reset forced auto level value so that next level will be selected
            this._nextAutoLevel = -1;
            return;
        }
        var stats = loader.stats;
        /* only monitor frag retrieval time if
        (video not paused OR first fragment being loaded(ready state === HAVE_NOTHING = 0)) AND autoswitching enabled AND not lowest level (=> means that we have several levels) */
        if (video && stats && ((!video.paused && (video.playbackRate !== 0)) || !video.readyState) && frag.autoLevel && frag.level) {
            var requestDelay = performance.now() - stats.trequest, playbackRate = Math.abs(video.playbackRate);
            // monitor fragment load progress after half of expected fragment duration,to stabilize bitrate
            if (requestDelay > (500 * frag.duration / playbackRate)) {
                var levels = hls.levels, loadRate = Math.max(1, stats.bw ? stats.bw / 8 : stats.loaded * 1000 / requestDelay), // byte/s; at least 1 byte/s to avoid division by zero
                // compute expected fragment length using frag duration and level bitrate. also ensure that expected len is gte than already loaded size
                level = levels[frag.level], levelBitrate = level.realBitrate ? Math.max(level.realBitrate, level.bitrate) : level.bitrate, expectedLen = stats.total ? stats.total : Math.max(stats.loaded, Math.round(frag.duration * levelBitrate / 8)), pos = video.currentTime, fragLoadedDelay = (expectedLen - stats.loaded) / loadRate, bufferStarvationDelay = (buffer_helper_1.BufferHelper.bufferInfo(video, pos, hls.config.maxBufferHole).end - pos) / playbackRate;
                // consider emergency switch down only if we have less than 2 frag buffered AND
                // time to finish loading current fragment is bigger than buffer starvation delay
                // ie if we risk buffer starvation if bw does not increase quickly
                if ((bufferStarvationDelay < (2 * frag.duration / playbackRate)) && (fragLoadedDelay > bufferStarvationDelay)) {
                    var fragLevelNextLoadedDelay = void 0, nextLoadLevel = void 0;
                    // lets iterate through lower level and try to find the biggest one that could avoid rebuffering
                    // we start from current level - 1 and we step down , until we find a matching level
                    for (nextLoadLevel = frag.level - 1; nextLoadLevel > minAutoLevel; nextLoadLevel--) {
                        // compute time to load next fragment at lower level
                        // 0.8 : consider only 80% of current bw to be conservative
                        // 8 = bits per byte (bps/Bps)
                        var levelNextBitrate = levels[nextLoadLevel].realBitrate ? Math.max(levels[nextLoadLevel].realBitrate, levels[nextLoadLevel].bitrate) : levels[nextLoadLevel].bitrate;
                        fragLevelNextLoadedDelay = frag.duration * levelNextBitrate / (8 * 0.8 * loadRate);
                        if (fragLevelNextLoadedDelay < bufferStarvationDelay) {
                            // we found a lower level that be rebuffering free with current estimated bw !
                            break;
                        }
                    }
                    // only emergency switch down if it takes less time to load new fragment at lowest level instead
                    // of finishing loading current one ...
                    if (fragLevelNextLoadedDelay < fragLoadedDelay) {
                        logger_1.logger.warn("loading too slow, abort fragment loading and switch to level " + nextLoadLevel + ":fragLoadedDelay[" + nextLoadLevel + "]<fragLoadedDelay[" + (frag.level - 1) + "];bufferStarvationDelay:" + fragLevelNextLoadedDelay.toFixed(1) + "<" + fragLoadedDelay.toFixed(1) + ":" + bufferStarvationDelay.toFixed(1));
                        // force next load level in auto mode
                        hls.nextLoadLevel = nextLoadLevel;
                        // update bw estimate for this fragment before cancelling load (this will help reducing the bw)
                        this._bwEstimator.sample(requestDelay, stats.loaded);
                        // abort fragment loading
                        loader.abort();
                        // stop abandon rules timer
                        this.clearTimer();
                        hls.trigger(events_1.default.FRAG_LOAD_EMERGENCY_ABORTED, { frag: frag, stats: stats });
                    }
                }
            }
        }
    };
    AbrController.prototype.onFragLoaded = function (data) {
        var frag = data.frag;
        if (frag.type === 'main' && Number.isFinite(frag.sn)) {
            // stop monitoring bw once frag loaded
            this.clearTimer();
            // store level id after successful fragment load
            this.lastLoadedFragLevel = frag.level;
            // reset forced auto level value so that next level will be selected
            this._nextAutoLevel = -1;
            // compute level average bitrate
            if (this.hls.config.abrMaxWithRealBitrate) {
                var level = this.hls.levels[frag.level];
                var loadedBytes = (level.loaded ? level.loaded.bytes : 0) + data.stats.loaded;
                var loadedDuration = (level.loaded ? level.loaded.duration : 0) + data.frag.duration;
                level.loaded = { bytes: loadedBytes, duration: loadedDuration };
                level.realBitrate = Math.round(8 * loadedBytes / loadedDuration);
            }
            // if fragment has been loaded to perform a bitrate test,
            if (data.frag.bitrateTest) {
                var stats = data.stats;
                stats.tparsed = stats.tbuffered = stats.tload;
                this.onFragBuffered(data);
            }
        }
    };
    AbrController.prototype.onFragBuffered = function (data) {
        var stats = data.stats;
        var frag = data.frag;
        // only update stats on first frag buffering
        // if same frag is loaded multiple times, it might be in browser cache, and loaded quickly
        // and leading to wrong bw estimation
        // on bitrate test, also only update stats once (if tload = tbuffered == on FRAG_LOADED)
        if (stats.aborted !== true && frag.type === 'main' && Number.isFinite(frag.sn) && ((!frag.bitrateTest || stats.tload === stats.tbuffered))) {
            // use tparsed-trequest instead of tbuffered-trequest to compute fragLoadingProcessing; rationale is that  buffer appending only happens once media is attached
            // in case we use config.startFragPrefetch while media is not attached yet, fragment might be parsed while media not attached yet, but it will only be buffered on media attached
            // as a consequence it could happen really late in the process. meaning that appending duration might appears huge ... leading to underestimated throughput estimation
            var fragLoadingProcessingMs = stats.tparsed - stats.trequest;
            logger_1.logger.log("latency/loading/parsing/append/kbps:" + Math.round(stats.tfirst - stats.trequest) + "/" + Math.round(stats.tload - stats.tfirst) + "/" + Math.round(stats.tparsed - stats.tload) + "/" + Math.round(stats.tbuffered - stats.tparsed) + "/" + Math.round(8 * stats.loaded / (stats.tbuffered - stats.trequest)));
            this._bwEstimator.sample(fragLoadingProcessingMs, stats.loaded);
            stats.bwEstimate = this._bwEstimator.getEstimate();
            // if fragment has been loaded to perform a bitrate test, (hls.startLevel = -1), store bitrate test delay duration
            if (frag.bitrateTest) {
                this.bitrateTestDelay = fragLoadingProcessingMs / 1000;
            }
            else {
                this.bitrateTestDelay = 0;
            }
        }
    };
    AbrController.prototype.onError = function (data) {
        // stop timer in case of frag loading error
        switch (data.details) {
            case errors_1.ErrorDetails.FRAG_LOAD_ERROR:
            case errors_1.ErrorDetails.FRAG_LOAD_TIMEOUT:
                this.clearTimer();
                break;
            default:
                break;
        }
    };
    AbrController.prototype.clearTimer = function () {
        clearInterval(this.timer);
        this.timer = null;
    };
    Object.defineProperty(AbrController.prototype, "nextAutoLevel", {
        // return next auto level
        get: function () {
            var forcedAutoLevel = this._nextAutoLevel;
            var bwEstimator = this._bwEstimator;
            // in case next auto level has been forced, and bw not available or not reliable, return forced value
            if (forcedAutoLevel !== -1 && (!bwEstimator || !bwEstimator.canEstimate())) {
                return forcedAutoLevel;
            }
            // compute next level using ABR logic
            var nextABRAutoLevel = this._nextABRAutoLevel;
            // if forced auto level has been defined, use it to cap ABR computed quality level
            if (forcedAutoLevel !== -1) {
                nextABRAutoLevel = Math.min(forcedAutoLevel, nextABRAutoLevel);
            }
            return nextABRAutoLevel;
        },
        set: function (nextLevel) {
            this._nextAutoLevel = nextLevel;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbrController.prototype, "_nextABRAutoLevel", {
        get: function () {
            var hls = this.hls, maxAutoLevel = hls.maxAutoLevel, levels = hls.levels, config = hls.config, minAutoLevel = hls.minAutoLevel;
            var video = hls.media, currentLevel = this.lastLoadedFragLevel, currentFragDuration = this.fragCurrent ? this.fragCurrent.duration : 0, pos = (video ? video.currentTime : 0), 
            // playbackRate is the absolute value of the playback rate; if video.playbackRate is 0, we use 1 to load as
            // if we're playing back at the normal rate.
            playbackRate = ((video && (video.playbackRate !== 0)) ? Math.abs(video.playbackRate) : 1.0), avgbw = this._bwEstimator ? this._bwEstimator.getEstimate() : config.abrEwmaDefaultEstimate, 
            // bufferStarvationDelay is the wall-clock time left until the playback buffer is exhausted.
            bufferStarvationDelay = (buffer_helper_1.BufferHelper.bufferInfo(video, pos, config.maxBufferHole).end - pos) / playbackRate;
            // First, look to see if we can find a level matching with our avg bandwidth AND that could also guarantee no rebuffering at all
            var bestLevel = this._findBestLevel(currentLevel, currentFragDuration, avgbw, minAutoLevel, maxAutoLevel, bufferStarvationDelay, config.abrBandWidthFactor, config.abrBandWidthUpFactor, levels);
            if (bestLevel >= 0) {
                return bestLevel;
            }
            else {
                logger_1.logger.trace('rebuffering expected to happen, lets try to find a quality level minimizing the rebuffering');
                // not possible to get rid of rebuffering ... let's try to find level that will guarantee less than maxStarvationDelay of rebuffering
                // if no matching level found, logic will return 0
                var maxStarvationDelay = currentFragDuration ? Math.min(currentFragDuration, config.maxStarvationDelay) : config.maxStarvationDelay, bwFactor = config.abrBandWidthFactor, bwUpFactor = config.abrBandWidthUpFactor;
                if (bufferStarvationDelay === 0) {
                    // in case buffer is empty, let's check if previous fragment was loaded to perform a bitrate test
                    var bitrateTestDelay = this.bitrateTestDelay;
                    if (bitrateTestDelay) {
                        // if it is the case, then we need to adjust our max starvation delay using maxLoadingDelay config value
                        // max video loading delay used in  automatic start level selection :
                        // in that mode ABR controller will ensure that video loading time (ie the time to fetch the first fragment at lowest quality level +
                        // the time to fetch the fragment at the appropriate quality level is less than ```maxLoadingDelay``` )
                        // cap maxLoadingDelay and ensure it is not bigger 'than bitrate test' frag duration
                        var maxLoadingDelay = currentFragDuration ? Math.min(currentFragDuration, config.maxLoadingDelay) : config.maxLoadingDelay;
                        maxStarvationDelay = maxLoadingDelay - bitrateTestDelay;
                        logger_1.logger.trace("bitrate test took " + Math.round(1000 * bitrateTestDelay) + "ms, set first fragment max fetchDuration to " + Math.round(1000 * maxStarvationDelay) + " ms");
                        // don't use conservative factor on bitrate test
                        bwFactor = bwUpFactor = 1;
                    }
                }
                bestLevel = this._findBestLevel(currentLevel, currentFragDuration, avgbw, minAutoLevel, maxAutoLevel, bufferStarvationDelay + maxStarvationDelay, bwFactor, bwUpFactor, levels);
                return Math.max(bestLevel, 0);
            }
        },
        enumerable: true,
        configurable: true
    });
    AbrController.prototype._findBestLevel = function (currentLevel, currentFragDuration, currentBw, minAutoLevel, maxAutoLevel, maxFetchDuration, bwFactor, bwUpFactor, levels) {
        for (var i = maxAutoLevel; i >= minAutoLevel; i--) {
            var levelInfo = levels[i];
            if (!levelInfo) {
                continue;
            }
            var levelDetails = levelInfo.details, avgDuration = levelDetails ? levelDetails.totalduration / levelDetails.fragments.length : currentFragDuration, live = levelDetails ? levelDetails.live : false, adjustedbw = void 0;
            // follow algorithm captured from stagefright :
            // https://android.googlesource.com/platform/frameworks/av/+/master/media/libstagefright/httplive/LiveSession.cpp
            // Pick the highest bandwidth stream below or equal to estimated bandwidth.
            // consider only 80% of the available bandwidth, but if we are switching up,
            // be even more conservative (70%) to avoid overestimating and immediately
            // switching back.
            if (i <= currentLevel) {
                adjustedbw = bwFactor * currentBw;
            }
            else {
                adjustedbw = bwUpFactor * currentBw;
            }
            var bitrate = levels[i].realBitrate ? Math.max(levels[i].realBitrate, levels[i].bitrate) : levels[i].bitrate, fetchDuration = bitrate * avgDuration / adjustedbw;
            logger_1.logger.trace("level/adjustedbw/bitrate/avgDuration/maxFetchDuration/fetchDuration: " + i + "/" + Math.round(adjustedbw) + "/" + bitrate + "/" + avgDuration + "/" + maxFetchDuration + "/" + fetchDuration);
            // if adjusted bw is greater than level bitrate AND
            if (adjustedbw > bitrate &&
                // fragment fetchDuration unknown OR live stream OR fragment fetchDuration less than max allowed fetch duration, then this level matches
                // we don't account for max Fetch Duration for live streams, this is to avoid switching down when near the edge of live sliding window ...
                // special case to support startLevel = -1 (bitrateTest) on live streams : in that case we should not exit loop so that _findBestLevel will return -1
                (!fetchDuration || (live && !this.bitrateTestDelay) || fetchDuration < maxFetchDuration)) {
                // as we are looping from highest to lowest, this will return the best achievable quality level
                return i;
            }
        }
        // not enough time budget even with quality level 0 ... rebuffering might happen
        return -1;
    };
    return AbrController;
}(event_handler_1.default));
exports.default = AbrController;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./src/polyfills/number */ "./src/polyfills/number.js")["Number"]))

/***/ }),

/***/ "./src/controller/audio-stream-controller.js":
/*!***************************************************!*\
  !*** ./src/controller/audio-stream-controller.js ***!
  \***************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Number) {
/*
 * Audio Stream Controller
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var binary_search_1 = __webpack_require__(/*! ../utils/binary-search */ "./src/utils/binary-search.js");
var buffer_helper_1 = __webpack_require__(/*! ../utils/buffer-helper */ "./src/utils/buffer-helper.js");
var demuxer_1 = __webpack_require__(/*! ../demux/demuxer */ "./src/demux/demuxer.js");
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var LevelHelper = __webpack_require__(/*! ./level-helper */ "./src/controller/level-helper.js");
var time_ranges_1 = __webpack_require__(/*! ../utils/time-ranges */ "./src/utils/time-ranges.js");
var errors_1 = __webpack_require__(/*! ../errors */ "./src/errors.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var discontinuities_1 = __webpack_require__(/*! ../utils/discontinuities */ "./src/utils/discontinuities.js");
var fragment_tracker_1 = __webpack_require__(/*! ./fragment-tracker */ "./src/controller/fragment-tracker.js");
var fragment_1 = __webpack_require__(/*! ../loader/fragment */ "./src/loader/fragment.js");
var base_stream_controller_1 = __webpack_require__(/*! ./base-stream-controller */ "./src/controller/base-stream-controller.js");
var performance = window.performance;
var TICK_INTERVAL = 100; // how often to tick in ms
var AudioStreamController = /** @class */ (function (_super) {
    __extends(AudioStreamController, _super);
    function AudioStreamController(hls, fragmentTracker) {
        var _this = _super.call(this, hls, events_1.default.MEDIA_ATTACHED, events_1.default.MEDIA_DETACHING, events_1.default.AUDIO_TRACKS_UPDATED, events_1.default.AUDIO_TRACK_SWITCHING, events_1.default.AUDIO_TRACK_LOADED, events_1.default.KEY_LOADED, events_1.default.FRAG_LOADED, events_1.default.FRAG_PARSING_INIT_SEGMENT, events_1.default.FRAG_PARSING_DATA, events_1.default.FRAG_PARSED, events_1.default.ERROR, events_1.default.BUFFER_RESET, events_1.default.BUFFER_CREATED, events_1.default.BUFFER_APPENDED, events_1.default.BUFFER_FLUSHED, events_1.default.INIT_PTS_FOUND) || this;
        _this.fragmentTracker = fragmentTracker;
        _this.config = hls.config;
        _this.audioCodecSwap = false;
        _this._state = base_stream_controller_1.State.STOPPED;
        _this.initPTS = [];
        _this.waitingFragment = null;
        _this.videoTrackCC = null;
        return _this;
    }
    AudioStreamController.prototype.onHandlerDestroying = function () {
        this.stopLoad();
        _super.prototype.onHandlerDestroying.call(this);
    };
    AudioStreamController.prototype.onHandlerDestroyed = function () {
        this.state = base_stream_controller_1.State.STOPPED;
        this.fragmentTracker = null;
        _super.prototype.onHandlerDestroyed.call(this);
    };
    // Signal that video PTS was found
    AudioStreamController.prototype.onInitPtsFound = function (data) {
        var demuxerId = data.id, cc = data.frag.cc, initPTS = data.initPTS;
        if (demuxerId === 'main') {
            // Always update the new INIT PTS
            // Can change due level switch
            this.initPTS[cc] = initPTS;
            this.videoTrackCC = cc;
            logger_1.logger.log("InitPTS for cc: " + cc + " found from video track: " + initPTS);
            // If we are waiting we need to demux/remux the waiting frag
            // With the new initPTS
            if (this.state === base_stream_controller_1.State.WAITING_INIT_PTS) {
                this.tick();
            }
        }
    };
    AudioStreamController.prototype.startLoad = function (startPosition) {
        if (this.tracks) {
            var lastCurrentTime = this.lastCurrentTime;
            this.stopLoad();
            this.setInterval(TICK_INTERVAL);
            this.fragLoadError = 0;
            if (lastCurrentTime > 0 && startPosition === -1) {
                logger_1.logger.log("audio:override startPosition with lastCurrentTime @" + lastCurrentTime.toFixed(3));
                this.state = base_stream_controller_1.State.IDLE;
            }
            else {
                this.lastCurrentTime = this.startPosition ? this.startPosition : startPosition;
                this.state = base_stream_controller_1.State.STARTING;
            }
            this.nextLoadPosition = this.startPosition = this.lastCurrentTime;
            this.tick();
        }
        else {
            this.startPosition = startPosition;
            this.state = base_stream_controller_1.State.STOPPED;
        }
    };
    AudioStreamController.prototype.stopLoad = function () {
        var frag = this.fragCurrent;
        if (frag) {
            if (frag.loader) {
                frag.loader.abort();
            }
            this.fragmentTracker.removeFragment(frag);
            this.fragCurrent = null;
        }
        this.fragPrevious = null;
        if (this.demuxer) {
            this.demuxer.destroy();
            this.demuxer = null;
        }
        this.state = base_stream_controller_1.State.STOPPED;
    };
    Object.defineProperty(AudioStreamController.prototype, "state", {
        get: function () {
            return this._state;
        },
        set: function (nextState) {
            if (this.state !== nextState) {
                var previousState = this.state;
                this._state = nextState;
                logger_1.logger.log("audio stream:" + previousState + "->" + nextState);
            }
        },
        enumerable: true,
        configurable: true
    });
    AudioStreamController.prototype.doTick = function () {
        var pos, track, trackDetails, hls = this.hls, config = hls.config;
        // logger.log('audioStream:' + this.state);
        switch (this.state) {
            case base_stream_controller_1.State.ERROR:
            // don't do anything in error state to avoid breaking further ...
            case base_stream_controller_1.State.PAUSED:
            // don't do anything in paused state either ...
            case base_stream_controller_1.State.BUFFER_FLUSHING:
                break;
            case base_stream_controller_1.State.STARTING:
                this.state = base_stream_controller_1.State.WAITING_TRACK;
                this.loadedmetadata = false;
                break;
            case base_stream_controller_1.State.IDLE:
                var tracks = this.tracks;
                // audio tracks not received => exit loop
                if (!tracks) {
                    break;
                }
                // if video not attached AND
                // start fragment already requested OR start frag prefetch disable
                // exit loop
                // => if media not attached but start frag prefetch is enabled and start frag not requested yet, we will not exit loop
                if (!this.media &&
                    (this.startFragRequested || !config.startFragPrefetch)) {
                    break;
                }
                // determine next candidate fragment to be loaded, based on current position and
                //  end of buffer position
                // if we have not yet loaded any fragment, start loading from start position
                if (this.loadedmetadata) {
                    pos = this.media.currentTime;
                }
                else {
                    pos = this.nextLoadPosition;
                    if (pos === undefined) {
                        break;
                    }
                }
                var media = this.mediaBuffer ? this.mediaBuffer : this.media, videoBuffer = this.videoBuffer ? this.videoBuffer : this.media, bufferInfo = buffer_helper_1.BufferHelper.bufferInfo(media, pos, config.maxBufferHole), mainBufferInfo = buffer_helper_1.BufferHelper.bufferInfo(videoBuffer, pos, config.maxBufferHole), bufferLen = bufferInfo.len, bufferEnd_1 = bufferInfo.end, fragPrevious = this.fragPrevious, 
                // ensure we buffer at least config.maxBufferLength (default 30s) or config.maxMaxBufferLength (default: 600s)
                // whichever is smaller.
                // once we reach that threshold, don't buffer more than video (mainBufferInfo.len)
                maxConfigBuffer = Math.min(config.maxBufferLength, config.maxMaxBufferLength), maxBufLen = Math.max(maxConfigBuffer, mainBufferInfo.len), audioSwitch = this.audioSwitch, trackId = this.trackId;
                // if buffer length is less than maxBufLen try to load a new fragment
                if ((bufferLen < maxBufLen || audioSwitch) && trackId < tracks.length) {
                    trackDetails = tracks[trackId].details;
                    // if track info not retrieved yet, switch state and wait for track retrieval
                    if (typeof trackDetails === 'undefined') {
                        this.state = base_stream_controller_1.State.WAITING_TRACK;
                        break;
                    }
                    if (!audioSwitch && this._streamEnded(bufferInfo, trackDetails)) {
                        this.hls.trigger(events_1.default.BUFFER_EOS, { type: 'audio' });
                        this.state = base_stream_controller_1.State.ENDED;
                        return;
                    }
                    // find fragment index, contiguous with end of buffer position
                    var fragments = trackDetails.fragments, fragLen = fragments.length, start = fragments[0].start, end = fragments[fragLen - 1].start + fragments[fragLen - 1].duration, frag = void 0;
                    // When switching audio track, reload audio as close as possible to currentTime
                    if (audioSwitch) {
                        if (trackDetails.live && !trackDetails.PTSKnown) {
                            logger_1.logger.log('switching audiotrack, live stream, unknown PTS,load first fragment');
                            bufferEnd_1 = 0;
                        }
                        else {
                            bufferEnd_1 = pos;
                            // if currentTime (pos) is less than alt audio playlist start time, it means that alt audio is ahead of currentTime
                            if (trackDetails.PTSKnown && pos < start) {
                                // if everything is buffered from pos to start or if audio buffer upfront, let's seek to start
                                if (bufferInfo.end > start || bufferInfo.nextStart) {
                                    logger_1.logger.log('alt audio track ahead of main track, seek to start of alt audio track');
                                    this.media.currentTime = start + 0.05;
                                }
                                else {
                                    return;
                                }
                            }
                        }
                    }
                    if (trackDetails.initSegment && !trackDetails.initSegment.data) {
                        frag = trackDetails.initSegment;
                    } // eslint-disable-line brace-style
                    // if bufferEnd before start of playlist, load first fragment
                    else if (bufferEnd_1 <= start) {
                        frag = fragments[0];
                        if (this.videoTrackCC !== null && frag.cc !== this.videoTrackCC) {
                            // Ensure we find a fragment which matches the continuity of the video track
                            frag = discontinuities_1.findFragWithCC(fragments, this.videoTrackCC);
                        }
                        if (trackDetails.live && frag.loadIdx && frag.loadIdx === this.fragLoadIdx) {
                            // we just loaded this first fragment, and we are still lagging behind the start of the live playlist
                            // let's force seek to start
                            var nextBuffered = bufferInfo.nextStart ? bufferInfo.nextStart : start;
                            logger_1.logger.log("no alt audio available @currentTime:" + this.media.currentTime + ", seeking @" + (nextBuffered + 0.05));
                            this.media.currentTime = nextBuffered + 0.05;
                            return;
                        }
                    }
                    else {
                        var foundFrag = void 0;
                        var maxFragLookUpTolerance_1 = config.maxFragLookUpTolerance;
                        var fragNext = fragPrevious ? fragments[fragPrevious.sn - fragments[0].sn + 1] : undefined;
                        var fragmentWithinToleranceTest = function (candidate) {
                            // offset should be within fragment boundary - config.maxFragLookUpTolerance
                            // this is to cope with situations like
                            // bufferEnd = 9.991
                            // frag[Ø] : [0,10]
                            // frag[1] : [10,20]
                            // bufferEnd is within frag[0] range ... although what we are expecting is to return frag[1] here
                            //              frag start               frag start+duration
                            //                  |-----------------------------|
                            //              <--->                         <--->
                            //  ...--------><-----------------------------><---------....
                            // previous frag         matching fragment         next frag
                            //  return -1             return 0                 return 1
                            // logger.log(`level/sn/start/end/bufEnd:${level}/${candidate.sn}/${candidate.start}/${(candidate.start+candidate.duration)}/${bufferEnd}`);
                            // Set the lookup tolerance to be small enough to detect the current segment - ensures we don't skip over very small segments
                            var candidateLookupTolerance = Math.min(maxFragLookUpTolerance_1, candidate.duration);
                            if ((candidate.start + candidate.duration - candidateLookupTolerance) <= bufferEnd_1) {
                                return 1;
                            }
                            else if (candidate.start - candidateLookupTolerance > bufferEnd_1 && candidate.start) {
                                // if maxFragLookUpTolerance will have negative value then don't return -1 for first element
                                return -1;
                            }
                            return 0;
                        };
                        if (bufferEnd_1 < end) {
                            if (bufferEnd_1 > end - maxFragLookUpTolerance_1) {
                                maxFragLookUpTolerance_1 = 0;
                            }
                            // Prefer the next fragment if it's within tolerance
                            if (fragNext && !fragmentWithinToleranceTest(fragNext)) {
                                foundFrag = fragNext;
                            }
                            else {
                                foundFrag = binary_search_1.default.search(fragments, fragmentWithinToleranceTest);
                            }
                        }
                        else {
                            // reach end of playlist
                            foundFrag = fragments[fragLen - 1];
                        }
                        if (foundFrag) {
                            frag = foundFrag;
                            start = foundFrag.start;
                            // logger.log('find SN matching with pos:' +  bufferEnd + ':' + frag.sn);
                            if (fragPrevious && frag.level === fragPrevious.level && frag.sn === fragPrevious.sn) {
                                if (frag.sn < trackDetails.endSN) {
                                    frag = fragments[frag.sn + 1 - trackDetails.startSN];
                                    logger_1.logger.log("SN just loaded, load next one: " + frag.sn);
                                }
                                else {
                                    frag = null;
                                }
                            }
                        }
                    }
                    if (frag) {
                        // logger.log('      loading frag ' + i +',pos/bufEnd:' + pos.toFixed(3) + '/' + bufferEnd.toFixed(3));
                        if (frag.encrypted) {
                            logger_1.logger.log("Loading key for " + frag.sn + " of [" + trackDetails.startSN + " ," + trackDetails.endSN + "],track " + trackId);
                            this.state = base_stream_controller_1.State.KEY_LOADING;
                            hls.trigger(events_1.default.KEY_LOADING, { frag: frag });
                        }
                        else {
                            logger_1.logger.log("Loading " + frag.sn + ", cc: " + frag.cc + " of [" + trackDetails.startSN + " ," + trackDetails.endSN + "],track " + trackId + ", currentTime:" + pos + ",bufferEnd:" + bufferEnd_1.toFixed(3));
                            // only load if fragment is not loaded or if in audio switch
                            // we force a frag loading in audio switch as fragment tracker might not have evicted previous frags in case of quick audio switch
                            this.fragCurrent = frag;
                            if (audioSwitch || this.fragmentTracker.getState(frag) === fragment_tracker_1.FragmentState.NOT_LOADED) {
                                this.startFragRequested = true;
                                if (Number.isFinite(frag.sn)) {
                                    this.nextLoadPosition = frag.start + frag.duration;
                                }
                                hls.trigger(events_1.default.FRAG_LOADING, { frag: frag });
                                this.state = base_stream_controller_1.State.FRAG_LOADING;
                            }
                        }
                    }
                }
                break;
            case base_stream_controller_1.State.WAITING_TRACK:
                track = this.tracks[this.trackId];
                // check if playlist is already loaded
                if (track && track.details) {
                    this.state = base_stream_controller_1.State.IDLE;
                }
                break;
            case base_stream_controller_1.State.FRAG_LOADING_WAITING_RETRY:
                var now = performance.now();
                var retryDate = this.retryDate;
                media = this.media;
                var isSeeking = media && media.seeking;
                // if current time is gt than retryDate, or if media seeking let's switch to IDLE state to retry loading
                if (!retryDate || (now >= retryDate) || isSeeking) {
                    logger_1.logger.log('audioStreamController: retryDate reached, switch back to IDLE state');
                    this.state = base_stream_controller_1.State.IDLE;
                }
                break;
            case base_stream_controller_1.State.WAITING_INIT_PTS:
                var videoTrackCC = this.videoTrackCC;
                if (this.initPTS[videoTrackCC] === undefined) {
                    break;
                }
                // Ensure we don't get stuck in the WAITING_INIT_PTS state if the waiting frag CC doesn't match any initPTS
                var waitingFrag = this.waitingFragment;
                if (waitingFrag) {
                    var waitingFragCC = waitingFrag.frag.cc;
                    if (videoTrackCC !== waitingFragCC) {
                        track = this.tracks[this.trackId];
                        if (track.details && track.details.live) {
                            logger_1.logger.warn("Waiting fragment CC (" + waitingFragCC + ") does not match video track CC (" + videoTrackCC + ")");
                            this.waitingFragment = null;
                            this.state = base_stream_controller_1.State.IDLE;
                        }
                    }
                    else {
                        this.state = base_stream_controller_1.State.FRAG_LOADING;
                        this.onFragLoaded(this.waitingFragment);
                        this.waitingFragment = null;
                    }
                }
                else {
                    this.state = base_stream_controller_1.State.IDLE;
                }
                break;
            case base_stream_controller_1.State.STOPPED:
            case base_stream_controller_1.State.FRAG_LOADING:
            case base_stream_controller_1.State.PARSING:
            case base_stream_controller_1.State.PARSED:
            case base_stream_controller_1.State.ENDED:
                break;
            default:
                break;
        }
    };
    AudioStreamController.prototype.onMediaAttached = function (data) {
        var media = this.media = this.mediaBuffer = data.media;
        this.onvseeking = this.onMediaSeeking.bind(this);
        this.onvended = this.onMediaEnded.bind(this);
        media.addEventListener('seeking', this.onvseeking);
        media.addEventListener('ended', this.onvended);
        var config = this.config;
        if (this.tracks && config.autoStartLoad) {
            this.startLoad(config.startPosition);
        }
    };
    AudioStreamController.prototype.onMediaDetaching = function () {
        var media = this.media;
        if (media && media.ended) {
            logger_1.logger.log('MSE detaching and video ended, reset startPosition');
            this.startPosition = this.lastCurrentTime = 0;
        }
        // remove video listeners
        if (media) {
            media.removeEventListener('seeking', this.onvseeking);
            media.removeEventListener('ended', this.onvended);
            this.onvseeking = this.onvseeked = this.onvended = null;
        }
        this.media = this.mediaBuffer = this.videoBuffer = null;
        this.loadedmetadata = false;
        this.stopLoad();
    };
    AudioStreamController.prototype.onAudioTracksUpdated = function (data) {
        logger_1.logger.log('audio tracks updated');
        this.tracks = data.audioTracks;
    };
    AudioStreamController.prototype.onAudioTrackSwitching = function (data) {
        // if any URL found on new audio track, it is an alternate audio track
        var altAudio = !!data.url;
        this.trackId = data.id;
        this.fragCurrent = null;
        this.state = base_stream_controller_1.State.PAUSED;
        this.waitingFragment = null;
        // destroy useless demuxer when switching audio to main
        if (!altAudio) {
            if (this.demuxer) {
                this.demuxer.destroy();
                this.demuxer = null;
            }
        }
        else {
            // switching to audio track, start timer if not already started
            this.setInterval(TICK_INTERVAL);
        }
        // should we switch tracks ?
        if (altAudio) {
            this.audioSwitch = true;
            // main audio track are handled by stream-controller, just do something if switching to alt audio track
            this.state = base_stream_controller_1.State.IDLE;
        }
        this.tick();
    };
    AudioStreamController.prototype.onAudioTrackLoaded = function (data) {
        var newDetails = data.details, trackId = data.id, track = this.tracks[trackId], duration = newDetails.totalduration, sliding = 0;
        logger_1.logger.log("track " + trackId + " loaded [" + newDetails.startSN + "," + newDetails.endSN + "],duration:" + duration);
        if (newDetails.live) {
            var curDetails = track.details;
            if (curDetails && newDetails.fragments.length > 0) {
                // we already have details for that level, merge them
                LevelHelper.mergeDetails(curDetails, newDetails);
                sliding = newDetails.fragments[0].start;
                // TODO
                // this.liveSyncPosition = this.computeLivePosition(sliding, curDetails);
                if (newDetails.PTSKnown) {
                    logger_1.logger.log("live audio playlist sliding:" + sliding.toFixed(3));
                }
                else {
                    logger_1.logger.log('live audio playlist - outdated PTS, unknown sliding');
                }
            }
            else {
                newDetails.PTSKnown = false;
                logger_1.logger.log('live audio playlist - first load, unknown sliding');
            }
        }
        else {
            newDetails.PTSKnown = false;
        }
        track.details = newDetails;
        // compute start position
        if (!this.startFragRequested) {
            // compute start position if set to -1. use it straight away if value is defined
            if (this.startPosition === -1) {
                // first, check if start time offset has been set in playlist, if yes, use this value
                var startTimeOffset = newDetails.startTimeOffset;
                if (Number.isFinite(startTimeOffset)) {
                    logger_1.logger.log("start time offset found in playlist, adjust startPosition to " + startTimeOffset);
                    this.startPosition = startTimeOffset;
                }
                else {
                    this.startPosition = 0;
                }
            }
            this.nextLoadPosition = this.startPosition;
        }
        // only switch batck to IDLE state if we were waiting for track to start downloading a new fragment
        if (this.state === base_stream_controller_1.State.WAITING_TRACK) {
            this.state = base_stream_controller_1.State.IDLE;
        }
        // trigger handler right now
        this.tick();
    };
    AudioStreamController.prototype.onKeyLoaded = function () {
        if (this.state === base_stream_controller_1.State.KEY_LOADING) {
            this.state = base_stream_controller_1.State.IDLE;
            this.tick();
        }
    };
    AudioStreamController.prototype.onFragLoaded = function (data) {
        var fragCurrent = this.fragCurrent, fragLoaded = data.frag;
        if (this.state === base_stream_controller_1.State.FRAG_LOADING &&
            fragCurrent &&
            fragLoaded.type === 'audio' &&
            fragLoaded.level === fragCurrent.level &&
            fragLoaded.sn === fragCurrent.sn) {
            var track = this.tracks[this.trackId], details = track.details, duration = details.totalduration, trackId = fragCurrent.level, sn = fragCurrent.sn, cc = fragCurrent.cc, audioCodec = this.config.defaultAudioCodec || track.audioCodec || 'mp4a.40.2', stats = this.stats = data.stats;
            if (sn === 'initSegment') {
                this.state = base_stream_controller_1.State.IDLE;
                stats.tparsed = stats.tbuffered = performance.now();
                details.initSegment.data = data.payload;
                this.hls.trigger(events_1.default.FRAG_BUFFERED, { stats: stats, frag: fragCurrent, id: 'audio' });
                this.tick();
            }
            else {
                this.state = base_stream_controller_1.State.PARSING;
                // transmux the MPEG-TS data to ISO-BMFF segments
                this.appended = false;
                if (!this.demuxer) {
                    this.demuxer = new demuxer_1.default(this.hls, 'audio');
                }
                // Check if we have video initPTS
                // If not we need to wait for it
                var initPTS = this.initPTS[cc];
                var initSegmentData = details.initSegment ? details.initSegment.data : [];
                if (details.initSegment || initPTS !== undefined) {
                    this.pendingBuffering = true;
                    logger_1.logger.log("Demuxing " + sn + " of [" + details.startSN + " ," + details.endSN + "],track " + trackId);
                    // time Offset is accurate if level PTS is known, or if playlist is not sliding (not live)
                    var accurateTimeOffset = false; // details.PTSKnown || !details.live;
                    this.demuxer.push(data.payload, initSegmentData, audioCodec, null, fragCurrent, duration, accurateTimeOffset, initPTS);
                }
                else {
                    logger_1.logger.log("unknown video PTS for continuity counter " + cc + ", waiting for video PTS before demuxing audio frag " + sn + " of [" + details.startSN + " ," + details.endSN + "],track " + trackId);
                    this.waitingFragment = data;
                    this.state = base_stream_controller_1.State.WAITING_INIT_PTS;
                }
            }
        }
        this.fragLoadError = 0;
    };
    AudioStreamController.prototype.onFragParsingInitSegment = function (data) {
        var fragCurrent = this.fragCurrent;
        var fragNew = data.frag;
        if (fragCurrent &&
            data.id === 'audio' &&
            fragNew.sn === fragCurrent.sn &&
            fragNew.level === fragCurrent.level &&
            this.state === base_stream_controller_1.State.PARSING) {
            var tracks = data.tracks, track = void 0;
            // delete any video track found on audio demuxer
            if (tracks.video) {
                delete tracks.video;
            }
            // include levelCodec in audio and video tracks
            track = tracks.audio;
            if (track) {
                track.levelCodec = track.codec;
                track.id = data.id;
                this.hls.trigger(events_1.default.BUFFER_CODECS, tracks);
                logger_1.logger.log("audio track:audio,container:" + track.container + ",codecs[level/parsed]=[" + track.levelCodec + "/" + track.codec + "]");
                var initSegment = track.initSegment;
                if (initSegment) {
                    var appendObj = { type: 'audio', data: initSegment, parent: 'audio', content: 'initSegment' };
                    if (this.audioSwitch) {
                        this.pendingData = [appendObj];
                    }
                    else {
                        this.appended = true;
                        // arm pending Buffering flag before appending a segment
                        this.pendingBuffering = true;
                        this.hls.trigger(events_1.default.BUFFER_APPENDING, appendObj);
                    }
                }
                // trigger handler right now
                this.tick();
            }
        }
    };
    AudioStreamController.prototype.onFragParsingData = function (data) {
        var _this = this;
        var fragCurrent = this.fragCurrent;
        var fragNew = data.frag;
        if (fragCurrent &&
            data.id === 'audio' &&
            data.type === 'audio' &&
            fragNew.sn === fragCurrent.sn &&
            fragNew.level === fragCurrent.level &&
            this.state === base_stream_controller_1.State.PARSING) {
            var trackId = this.trackId, track = this.tracks[trackId], hls_1 = this.hls;
            if (!Number.isFinite(data.endPTS)) {
                data.endPTS = data.startPTS + fragCurrent.duration;
                data.endDTS = data.startDTS + fragCurrent.duration;
            }
            fragCurrent.addElementaryStream(fragment_1.default.ElementaryStreamTypes.AUDIO);
            logger_1.logger.log("parsed " + data.type + ",PTS:[" + data.startPTS.toFixed(3) + "," + data.endPTS.toFixed(3) + "],DTS:[" + data.startDTS.toFixed(3) + "/" + data.endDTS.toFixed(3) + "],nb:" + data.nb);
            LevelHelper.updateFragPTSDTS(track.details, fragCurrent, data.startPTS, data.endPTS);
            var audioSwitch = this.audioSwitch, media = this.media, appendOnBufferFlush = false;
            // Only flush audio from old audio tracks when PTS is known on new audio track
            if (audioSwitch && media) {
                if (media.readyState) {
                    var currentTime = media.currentTime;
                    logger_1.logger.log('switching audio track : currentTime:' + currentTime);
                    if (currentTime >= data.startPTS) {
                        logger_1.logger.log('switching audio track : flushing all audio');
                        this.state = base_stream_controller_1.State.BUFFER_FLUSHING;
                        hls_1.trigger(events_1.default.BUFFER_FLUSHING, { startOffset: 0, endOffset: Number.POSITIVE_INFINITY, type: 'audio' });
                        appendOnBufferFlush = true;
                        // Lets announce that the initial audio track switch flush occur
                        this.audioSwitch = false;
                        hls_1.trigger(events_1.default.AUDIO_TRACK_SWITCHED, { id: trackId });
                    }
                }
                else {
                    // Lets announce that the initial audio track switch flush occur
                    this.audioSwitch = false;
                    hls_1.trigger(events_1.default.AUDIO_TRACK_SWITCHED, { id: trackId });
                }
            }
            var pendingData_1 = this.pendingData;
            if (!pendingData_1) {
                logger_1.logger.warn('Apparently attempt to enqueue media payload without codec initialization data upfront');
                hls_1.trigger(events_1.default.ERROR, { type: errors_1.ErrorTypes.MEDIA_ERROR, details: null, fatal: true });
                return;
            }
            if (!this.audioSwitch) {
                [data.data1, data.data2].forEach(function (buffer) {
                    if (buffer && buffer.length) {
                        pendingData_1.push({ type: data.type, data: buffer, parent: 'audio', content: 'data' });
                    }
                });
                if (!appendOnBufferFlush && pendingData_1.length) {
                    pendingData_1.forEach(function (appendObj) {
                        // only append in PARSING state (rationale is that an appending error could happen synchronously on first segment appending)
                        // in that case it is useless to append following segments
                        if (_this.state === base_stream_controller_1.State.PARSING) {
                            // arm pending Buffering flag before appending a segment
                            _this.pendingBuffering = true;
                            _this.hls.trigger(events_1.default.BUFFER_APPENDING, appendObj);
                        }
                    });
                    this.pendingData = [];
                    this.appended = true;
                }
            }
            // trigger handler right now
            this.tick();
        }
    };
    AudioStreamController.prototype.onFragParsed = function (data) {
        var fragCurrent = this.fragCurrent;
        var fragNew = data.frag;
        if (fragCurrent &&
            data.id === 'audio' &&
            fragNew.sn === fragCurrent.sn &&
            fragNew.level === fragCurrent.level &&
            this.state === base_stream_controller_1.State.PARSING) {
            this.stats.tparsed = performance.now();
            this.state = base_stream_controller_1.State.PARSED;
            this._checkAppendedParsed();
        }
    };
    AudioStreamController.prototype.onBufferReset = function () {
        // reset reference to sourcebuffers
        this.mediaBuffer = this.videoBuffer = null;
        this.loadedmetadata = false;
    };
    AudioStreamController.prototype.onBufferCreated = function (data) {
        var audioTrack = data.tracks.audio;
        if (audioTrack) {
            this.mediaBuffer = audioTrack.buffer;
            this.loadedmetadata = true;
        }
        if (data.tracks.video) {
            this.videoBuffer = data.tracks.video.buffer;
        }
    };
    AudioStreamController.prototype.onBufferAppended = function (data) {
        if (data.parent === 'audio') {
            var state = this.state;
            if (state === base_stream_controller_1.State.PARSING || state === base_stream_controller_1.State.PARSED) {
                // check if all buffers have been appended
                this.pendingBuffering = (data.pending > 0);
                this._checkAppendedParsed();
            }
        }
    };
    AudioStreamController.prototype._checkAppendedParsed = function () {
        // trigger handler right now
        if (this.state === base_stream_controller_1.State.PARSED && (!this.appended || !this.pendingBuffering)) {
            var frag = this.fragCurrent, stats = this.stats, hls_2 = this.hls;
            if (frag) {
                this.fragPrevious = frag;
                stats.tbuffered = performance.now();
                hls_2.trigger(events_1.default.FRAG_BUFFERED, { stats: stats, frag: frag, id: 'audio' });
                var media = this.mediaBuffer ? this.mediaBuffer : this.media;
                logger_1.logger.log("audio buffered : " + time_ranges_1.default.toString(media.buffered));
                if (this.audioSwitch && this.appended) {
                    this.audioSwitch = false;
                    hls_2.trigger(events_1.default.AUDIO_TRACK_SWITCHED, { id: this.trackId });
                }
                this.state = base_stream_controller_1.State.IDLE;
            }
            this.tick();
        }
    };
    AudioStreamController.prototype.onError = function (data) {
        var frag = data.frag;
        // don't handle frag error not related to audio fragment
        if (frag && frag.type !== 'audio') {
            return;
        }
        switch (data.details) {
            case errors_1.ErrorDetails.FRAG_LOAD_ERROR:
            case errors_1.ErrorDetails.FRAG_LOAD_TIMEOUT:
                var frag_1 = data.frag;
                // don't handle frag error not related to audio fragment
                if (frag_1 && frag_1.type !== 'audio') {
                    break;
                }
                if (!data.fatal) {
                    var loadError = this.fragLoadError;
                    if (loadError) {
                        loadError++;
                    }
                    else {
                        loadError = 1;
                    }
                    var config = this.config;
                    if (loadError <= config.fragLoadingMaxRetry) {
                        this.fragLoadError = loadError;
                        // exponential backoff capped to config.fragLoadingMaxRetryTimeout
                        var delay = Math.min(Math.pow(2, loadError - 1) * config.fragLoadingRetryDelay, config.fragLoadingMaxRetryTimeout);
                        logger_1.logger.warn("AudioStreamController: frag loading failed, retry in " + delay + " ms");
                        this.retryDate = performance.now() + delay;
                        // retry loading state
                        this.state = base_stream_controller_1.State.FRAG_LOADING_WAITING_RETRY;
                    }
                    else {
                        logger_1.logger.error("AudioStreamController: " + data.details + " reaches max retry, redispatch as fatal ...");
                        // switch error to fatal
                        data.fatal = true;
                        this.state = base_stream_controller_1.State.ERROR;
                    }
                }
                break;
            case errors_1.ErrorDetails.AUDIO_TRACK_LOAD_ERROR:
            case errors_1.ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT:
            case errors_1.ErrorDetails.KEY_LOAD_ERROR:
            case errors_1.ErrorDetails.KEY_LOAD_TIMEOUT:
                //  when in ERROR state, don't switch back to IDLE state in case a non-fatal error is received
                if (this.state !== base_stream_controller_1.State.ERROR) {
                    // if fatal error, stop processing, otherwise move to IDLE to retry loading
                    this.state = data.fatal ? base_stream_controller_1.State.ERROR : base_stream_controller_1.State.IDLE;
                    logger_1.logger.warn("AudioStreamController: " + data.details + " while loading frag, now switching to " + this.state + " state ...");
                }
                break;
            case errors_1.ErrorDetails.BUFFER_FULL_ERROR:
                // if in appending state
                if (data.parent === 'audio' && (this.state === base_stream_controller_1.State.PARSING || this.state === base_stream_controller_1.State.PARSED)) {
                    var media = this.mediaBuffer, currentTime = this.media.currentTime, mediaBuffered = media && buffer_helper_1.BufferHelper.isBuffered(media, currentTime) && buffer_helper_1.BufferHelper.isBuffered(media, currentTime + 0.5);
                    // reduce max buf len if current position is buffered
                    if (mediaBuffered) {
                        var config = this.config;
                        if (config.maxMaxBufferLength >= config.maxBufferLength) {
                            // reduce max buffer length as it might be too high. we do this to avoid loop flushing ...
                            config.maxMaxBufferLength /= 2;
                            logger_1.logger.warn("AudioStreamController: reduce max buffer length to " + config.maxMaxBufferLength + "s");
                        }
                        this.state = base_stream_controller_1.State.IDLE;
                    }
                    else {
                        // current position is not buffered, but browser is still complaining about buffer full error
                        // this happens on IE/Edge, refer to https://github.com/video-dev/hls.js/pull/708
                        // in that case flush the whole audio buffer to recover
                        logger_1.logger.warn('AudioStreamController: buffer full error also media.currentTime is not buffered, flush audio buffer');
                        this.fragCurrent = null;
                        // flush everything
                        this.state = base_stream_controller_1.State.BUFFER_FLUSHING;
                        this.hls.trigger(events_1.default.BUFFER_FLUSHING, { startOffset: 0, endOffset: Number.POSITIVE_INFINITY, type: 'audio' });
                    }
                }
                break;
            default:
                break;
        }
    };
    AudioStreamController.prototype.onBufferFlushed = function () {
        var _this = this;
        var pendingData = this.pendingData;
        if (pendingData && pendingData.length) {
            logger_1.logger.log('AudioStreamController: appending pending audio data after buffer flushed');
            pendingData.forEach(function (appendObj) {
                _this.hls.trigger(events_1.default.BUFFER_APPENDING, appendObj);
            });
            this.appended = true;
            this.pendingData = [];
            this.state = base_stream_controller_1.State.PARSED;
        }
        else {
            // move to IDLE once flush complete. this should trigger new fragment loading
            this.state = base_stream_controller_1.State.IDLE;
            // reset reference to frag
            this.fragPrevious = null;
            this.tick();
        }
    };
    return AudioStreamController;
}(base_stream_controller_1.default));
exports.default = AudioStreamController;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./src/polyfills/number */ "./src/polyfills/number.js")["Number"]))

/***/ }),

/***/ "./src/controller/audio-track-controller.js":
/*!**************************************************!*\
  !*** ./src/controller/audio-track-controller.js ***!
  \**************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var task_loop_1 = __webpack_require__(/*! ../task-loop */ "./src/task-loop.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var errors_1 = __webpack_require__(/*! ../errors */ "./src/errors.js");
/**
 * @class AudioTrackController
 * @implements {EventHandler}
 *
 * Handles main manifest and audio-track metadata loaded,
 * owns and exposes the selectable audio-tracks data-models.
 *
 * Exposes internal interface to select available audio-tracks.
 *
 * Handles errors on loading audio-track playlists. Manages fallback mechanism
 * with redundants tracks (group-IDs).
 *
 * Handles level-loading and group-ID switches for video (fallback on video levels),
 * and eventually adapts the audio-track group-ID to match.
 *
 * @fires AUDIO_TRACK_LOADING
 * @fires AUDIO_TRACK_SWITCHING
 * @fires AUDIO_TRACKS_UPDATED
 * @fires ERROR
 *
 */
var AudioTrackController = /** @class */ (function (_super) {
    __extends(AudioTrackController, _super);
    function AudioTrackController(hls) {
        var _this = _super.call(this, hls, events_1.default.MANIFEST_LOADING, events_1.default.MANIFEST_PARSED, events_1.default.AUDIO_TRACK_LOADED, events_1.default.AUDIO_TRACK_SWITCHED, events_1.default.LEVEL_LOADED, events_1.default.ERROR) || this;
        /**
         * @private
         * Currently selected index in `tracks`
         * @member {number} trackId
         */
        _this._trackId = -1;
        /**
         * @private
         * If should select tracks according to default track attribute
         * @member {boolean} _selectDefaultTrack
         */
        _this._selectDefaultTrack = true;
        /**
         * @public
         * All tracks available
         * @member {AudioTrack[]}
         */
        _this.tracks = [];
        /**
         * @public
         * List of blacklisted audio track IDs (that have caused failure)
         * @member {number[]}
         */
        _this.trackIdBlacklist = Object.create(null);
        /**
         * @public
         * The currently running group ID for audio
         * (we grab this on manifest-parsed and new level-loaded)
         * @member {string}
         */
        _this.audioGroupId = null;
        return _this;
    }
    /**
     * Reset audio tracks on new manifest loading.
     */
    AudioTrackController.prototype.onManifestLoading = function () {
        this.tracks = [];
        this._trackId = -1;
        this._selectDefaultTrack = true;
    };
    /**
     * Store tracks data from manifest parsed data.
     *
     * Trigger AUDIO_TRACKS_UPDATED event.
     *
     * @param {*} data
     */
    AudioTrackController.prototype.onManifestParsed = function (data) {
        var tracks = this.tracks = data.audioTracks || [];
        this.hls.trigger(events_1.default.AUDIO_TRACKS_UPDATED, { audioTracks: tracks });
    };
    /**
     * Store track details of loaded track in our data-model.
     *
     * Set-up metadata update interval task for live-mode streams.
     *
     * @param {} data
     */
    AudioTrackController.prototype.onAudioTrackLoaded = function (data) {
        if (data.id >= this.tracks.length) {
            logger_1.logger.warn('Invalid audio track id:', data.id);
            return;
        }
        logger_1.logger.log("audioTrack " + data.id + " loaded");
        this.tracks[data.id].details = data.details;
        // check if current playlist is a live playlist
        // and if we have already our reload interval setup
        if (data.details.live && !this.hasInterval()) {
            // if live playlist we will have to reload it periodically
            // set reload period to playlist target duration
            var updatePeriodMs = data.details.targetduration * 1000;
            this.setInterval(updatePeriodMs);
        }
        if (!data.details.live && this.hasInterval()) {
            // playlist is not live and timer is scheduled: cancel it
            this.clearInterval();
        }
    };
    /**
     * Update the internal group ID to any audio-track we may have set manually
     * or because of a failure-handling fallback.
     *
     * Quality-levels should update to that group ID in this case.
     *
     * @param {*} data
     */
    AudioTrackController.prototype.onAudioTrackSwitched = function (data) {
        var audioGroupId = this.tracks[data.id].groupId;
        if (audioGroupId && (this.audioGroupId !== audioGroupId)) {
            this.audioGroupId = audioGroupId;
        }
    };
    /**
     * When a level gets loaded, if it has redundant audioGroupIds (in the same ordinality as it's redundant URLs)
     * we are setting our audio-group ID internally to the one set, if it is different from the group ID currently set.
     *
     * If group-ID got update, we re-select the appropriate audio-track with this group-ID matching the currently
     * selected one (based on NAME property).
     *
     * @param {*} data
     */
    AudioTrackController.prototype.onLevelLoaded = function (data) {
        // FIXME: crashes because currentLevel is undefined
        // const levelInfo = this.hls.levels[this.hls.currentLevel];
        var levelInfo = this.hls.levels[data.level];
        if (!levelInfo.audioGroupIds) {
            return;
        }
        var audioGroupId = levelInfo.audioGroupIds[levelInfo.urlId];
        if (this.audioGroupId !== audioGroupId) {
            this.audioGroupId = audioGroupId;
            this._selectInitialAudioTrack();
        }
    };
    /**
     * Handle network errors loading audio track manifests
     * and also pausing on any netwok errors.
     *
     * @param {ErrorEventData} data
     */
    AudioTrackController.prototype.onError = function (data) {
        // Only handle network errors
        if (data.type !== errors_1.ErrorTypes.NETWORK_ERROR) {
            return;
        }
        // If fatal network error, cancel update task
        if (data.fatal) {
            this.clearInterval();
        }
        // If not an audio-track loading error don't handle further
        if (data.details !== errors_1.ErrorDetails.AUDIO_TRACK_LOAD_ERROR) {
            return;
        }
        logger_1.logger.warn('Network failure on audio-track id:', data.context.id);
        this._handleLoadError();
    };
    Object.defineProperty(AudioTrackController.prototype, "audioTracks", {
        /**
         * @type {AudioTrack[]} Audio-track list we own
         */
        get: function () {
            return this.tracks;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AudioTrackController.prototype, "audioTrack", {
        /**
         * @type {number} Index into audio-tracks list of currently selected track.
         */
        get: function () {
            return this._trackId;
        },
        /**
         * Select current track by index
         */
        set: function (newId) {
            this._setAudioTrack(newId);
            // If audio track is selected from API then don't choose from the manifest default track
            this._selectDefaultTrack = false;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @private
     * @param {number} newId
     */
    AudioTrackController.prototype._setAudioTrack = function (newId) {
        // noop on same audio track id as already set
        if (this._trackId === newId && this.tracks[this._trackId].details) {
            logger_1.logger.debug('Same id as current audio-track passed, and track details available -> no-op');
            return;
        }
        // check if level idx is valid
        if (newId < 0 || newId >= this.tracks.length) {
            logger_1.logger.warn('Invalid id passed to audio-track controller');
            return;
        }
        var audioTrack = this.tracks[newId];
        logger_1.logger.log("Now switching to audio-track index " + newId);
        // stopping live reloading timer if any
        this.clearInterval();
        this._trackId = newId;
        var url = audioTrack.url, type = audioTrack.type, id = audioTrack.id;
        this.hls.trigger(events_1.default.AUDIO_TRACK_SWITCHING, { id: id, type: type, url: url });
        this._loadTrackDetailsIfNeeded(audioTrack);
    };
    /**
     * @override
     */
    AudioTrackController.prototype.doTick = function () {
        this._updateTrack(this._trackId);
    };
    /**
     * Select initial track
     * @private
     */
    AudioTrackController.prototype._selectInitialAudioTrack = function () {
        var _this = this;
        var tracks = this.tracks;
        if (!tracks.length) {
            return;
        }
        var currentAudioTrack = this.tracks[this._trackId];
        var name = null;
        if (currentAudioTrack) {
            name = currentAudioTrack.name;
        }
        // Pre-select default tracks if there are any
        if (this._selectDefaultTrack) {
            var defaultTracks = tracks.filter(function (track) { return track.default; });
            if (defaultTracks.length) {
                tracks = defaultTracks;
            }
            else {
                logger_1.logger.warn('No default audio tracks defined');
            }
        }
        var trackFound = false;
        var traverseTracks = function () {
            // Select track with right group ID
            tracks.forEach(function (track) {
                if (trackFound) {
                    return;
                }
                // We need to match the (pre-)selected group ID
                // and the NAME of the current track.
                if ((!_this.audioGroupId || track.groupId === _this.audioGroupId) &&
                    (!name || name === track.name)) {
                    // If there was a previous track try to stay with the same `NAME`.
                    // It should be unique across tracks of same group, and consistent through redundant track groups.
                    _this._setAudioTrack(track.id);
                    trackFound = true;
                }
            });
        };
        traverseTracks();
        if (!trackFound) {
            name = null;
            traverseTracks();
        }
        if (!trackFound) {
            logger_1.logger.error("No track found for running audio group-ID: " + this.audioGroupId);
            this.hls.trigger(events_1.default.ERROR, {
                type: errors_1.ErrorTypes.MEDIA_ERROR,
                details: errors_1.ErrorDetails.AUDIO_TRACK_LOAD_ERROR,
                fatal: true
            });
        }
    };
    /**
     * @private
     * @param {AudioTrack} audioTrack
     * @returns {boolean}
     */
    AudioTrackController.prototype._needsTrackLoading = function (audioTrack) {
        var details = audioTrack.details, url = audioTrack.url;
        if (!details || details.live) {
            // check if we face an audio track embedded in main playlist (audio track without URI attribute)
            return !!url;
        }
        return false;
    };
    /**
     * @private
     * @param {AudioTrack} audioTrack
     */
    AudioTrackController.prototype._loadTrackDetailsIfNeeded = function (audioTrack) {
        if (this._needsTrackLoading(audioTrack)) {
            var url = audioTrack.url, id = audioTrack.id;
            // track not retrieved yet, or live playlist we need to (re)load it
            logger_1.logger.log("loading audio-track playlist for id: " + id);
            this.hls.trigger(events_1.default.AUDIO_TRACK_LOADING, { url: url, id: id });
        }
    };
    /**
     * @private
     * @param {number} newId
     */
    AudioTrackController.prototype._updateTrack = function (newId) {
        // check if level idx is valid
        if (newId < 0 || newId >= this.tracks.length) {
            return;
        }
        // stopping live reloading timer if any
        this.clearInterval();
        this._trackId = newId;
        logger_1.logger.log("trying to update audio-track " + newId);
        var audioTrack = this.tracks[newId];
        this._loadTrackDetailsIfNeeded(audioTrack);
    };
    /**
     * @private
     */
    AudioTrackController.prototype._handleLoadError = function () {
        // First, let's black list current track id
        this.trackIdBlacklist[this._trackId] = true;
        // Let's try to fall back on a functional audio-track with the same group ID
        var previousId = this._trackId;
        var _a = this.tracks[previousId], name = _a.name, language = _a.language, groupId = _a.groupId;
        logger_1.logger.warn("Loading failed on audio track id: " + previousId + ", group-id: " + groupId + ", name/language: \"" + name + "\" / \"" + language + "\"");
        // Find a non-blacklisted track ID with the same NAME
        // At least a track that is not blacklisted, thus on another group-ID.
        var newId = previousId;
        for (var i = 0; i < this.tracks.length; i++) {
            if (this.trackIdBlacklist[i]) {
                continue;
            }
            var newTrack = this.tracks[i];
            if (newTrack.name === name) {
                newId = i;
                break;
            }
        }
        if (newId === previousId) {
            logger_1.logger.warn("No fallback audio-track found for name/language: \"" + name + "\" / \"" + language + "\"");
            return;
        }
        logger_1.logger.log('Attempting audio-track fallback id:', newId, 'group-id:', this.tracks[newId].groupId);
        this._setAudioTrack(newId);
    };
    return AudioTrackController;
}(task_loop_1.default));
exports.default = AudioTrackController;


/***/ }),

/***/ "./src/controller/base-stream-controller.js":
/*!**************************************************!*\
  !*** ./src/controller/base-stream-controller.js ***!
  \**************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Number) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var task_loop_1 = __webpack_require__(/*! ../task-loop */ "./src/task-loop.js");
var fragment_tracker_1 = __webpack_require__(/*! ./fragment-tracker */ "./src/controller/fragment-tracker.js");
var buffer_helper_1 = __webpack_require__(/*! ../utils/buffer-helper */ "./src/utils/buffer-helper.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
exports.State = {
    STOPPED: 'STOPPED',
    STARTING: 'STARTING',
    IDLE: 'IDLE',
    PAUSED: 'PAUSED',
    KEY_LOADING: 'KEY_LOADING',
    FRAG_LOADING: 'FRAG_LOADING',
    FRAG_LOADING_WAITING_RETRY: 'FRAG_LOADING_WAITING_RETRY',
    WAITING_TRACK: 'WAITING_TRACK',
    PARSING: 'PARSING',
    PARSED: 'PARSED',
    BUFFER_FLUSHING: 'BUFFER_FLUSHING',
    ENDED: 'ENDED',
    ERROR: 'ERROR',
    WAITING_INIT_PTS: 'WAITING_INIT_PTS',
    WAITING_LEVEL: 'WAITING_LEVEL'
};
var BaseStreamController = /** @class */ (function (_super) {
    __extends(BaseStreamController, _super);
    function BaseStreamController() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BaseStreamController.prototype.doTick = function () { };
    BaseStreamController.prototype._streamEnded = function (bufferInfo, levelDetails) {
        var _a = this, fragCurrent = _a.fragCurrent, fragmentTracker = _a.fragmentTracker;
        // we just got done loading the final fragment and there is no other buffered range after ...
        // rationale is that in case there are any buffered ranges after, it means that there are unbuffered portion in between
        // so we should not switch to ENDED in that case, to be able to buffer them
        // dont switch to ENDED if we need to backtrack last fragment
        if (!levelDetails.live && fragCurrent && !fragCurrent.backtracked && fragCurrent.sn === levelDetails.endSN && !bufferInfo.nextStart) {
            var fragState = fragmentTracker.getState(fragCurrent);
            return fragState === fragment_tracker_1.FragmentState.PARTIAL || fragState === fragment_tracker_1.FragmentState.OK;
        }
        return false;
    };
    BaseStreamController.prototype.onMediaSeeking = function () {
        var _a = this, config = _a.config, media = _a.media, mediaBuffer = _a.mediaBuffer, state = _a.state;
        var currentTime = media ? media.currentTime : null;
        var bufferInfo = buffer_helper_1.BufferHelper.bufferInfo(mediaBuffer || media, currentTime, this.config.maxBufferHole);
        if (Number.isFinite(currentTime)) {
            logger_1.logger.log("media seeking to " + currentTime.toFixed(3));
        }
        if (state === exports.State.FRAG_LOADING) {
            var fragCurrent = this.fragCurrent;
            // check if we are seeking to a unbuffered area AND if frag loading is in progress
            if (bufferInfo.len === 0 && fragCurrent) {
                var tolerance = config.maxFragLookUpTolerance;
                var fragStartOffset = fragCurrent.start - tolerance;
                var fragEndOffset = fragCurrent.start + fragCurrent.duration + tolerance;
                // check if we seek position will be out of currently loaded frag range : if out cancel frag load, if in, don't do anything
                if (currentTime < fragStartOffset || currentTime > fragEndOffset) {
                    if (fragCurrent.loader) {
                        logger_1.logger.log('seeking outside of buffer while fragment load in progress, cancel fragment load');
                        fragCurrent.loader.abort();
                    }
                    this.fragCurrent = null;
                    this.fragPrevious = null;
                    // switch to IDLE state to load new fragment
                    this.state = exports.State.IDLE;
                }
                else {
                    logger_1.logger.log('seeking outside of buffer but within currently loaded fragment range');
                }
            }
        }
        else if (state === exports.State.ENDED) {
            // if seeking to unbuffered area, clean up fragPrevious
            if (bufferInfo.len === 0) {
                this.fragPrevious = null;
                this.fragCurrent = null;
            }
            // switch to IDLE state to check for potential new fragment
            this.state = exports.State.IDLE;
        }
        if (media) {
            this.lastCurrentTime = currentTime;
        }
        // in case seeking occurs although no media buffered, adjust startPosition and nextLoadPosition to seek target
        if (!this.loadedmetadata) {
            this.nextLoadPosition = this.startPosition = currentTime;
        }
        // tick to speed up processing
        this.tick();
    };
    BaseStreamController.prototype.onMediaEnded = function () {
        // reset startPosition and lastCurrentTime to restart playback @ stream beginning
        this.startPosition = this.lastCurrentTime = 0;
    };
    return BaseStreamController;
}(task_loop_1.default));
exports.default = BaseStreamController;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./src/polyfills/number */ "./src/polyfills/number.js")["Number"]))

/***/ }),

/***/ "./src/controller/buffer-controller.js":
/*!*********************************************!*\
  !*** ./src/controller/buffer-controller.js ***!
  \*********************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Number) {
/*
 * Buffer Controller
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var event_handler_1 = __webpack_require__(/*! ../event-handler */ "./src/event-handler.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var errors_1 = __webpack_require__(/*! ../errors */ "./src/errors.js");
var mediasource_helper_1 = __webpack_require__(/*! ../utils/mediasource-helper */ "./src/utils/mediasource-helper.js");
var MediaSource = mediasource_helper_1.getMediaSource();
var BufferController = /** @class */ (function (_super) {
    __extends(BufferController, _super);
    function BufferController(hls) {
        var _this = _super.call(this, hls, events_1.default.MEDIA_ATTACHING, events_1.default.MEDIA_DETACHING, events_1.default.MANIFEST_PARSED, events_1.default.BUFFER_RESET, events_1.default.BUFFER_APPENDING, events_1.default.BUFFER_CODECS, events_1.default.BUFFER_EOS, events_1.default.BUFFER_FLUSHING, events_1.default.LEVEL_PTS_UPDATED, events_1.default.LEVEL_UPDATED) || this;
        // the value that we have set mediasource.duration to
        // (the actual duration may be tweaked slighly by the browser)
        _this._msDuration = null;
        // the value that we want to set mediaSource.duration to
        _this._levelDuration = null;
        // the target duration of the current media playlist
        _this._levelTargetDuration = 10;
        // current stream state: true - for live broadcast, false - for VoD content
        _this._live = null;
        // cache the self generated object url to detect hijack of video tag
        _this._objectUrl = null;
        // The number of BUFFER_CODEC events received before any sourceBuffers are created
        _this.bufferCodecEventsExpected = 0;
        // Source Buffer listeners
        _this.onsbue = _this.onSBUpdateEnd.bind(_this);
        _this.onsbe = _this.onSBUpdateError.bind(_this);
        _this.pendingTracks = {};
        _this.tracks = {};
        return _this;
    }
    BufferController.prototype.destroy = function () {
        event_handler_1.default.prototype.destroy.call(this);
    };
    BufferController.prototype.onLevelPtsUpdated = function (data) {
        var type = data.type;
        var audioTrack = this.tracks.audio;
        // Adjusting `SourceBuffer.timestampOffset` (desired point in the timeline where the next frames should be appended)
        // in Chrome browser when we detect MPEG audio container and time delta between level PTS and `SourceBuffer.timestampOffset`
        // is greater than 100ms (this is enough to handle seek for VOD or level change for LIVE videos). At the time of change we issue
        // `SourceBuffer.abort()` and adjusting `SourceBuffer.timestampOffset` if `SourceBuffer.updating` is false or awaiting `updateend`
        // event if SB is in updating state.
        // More info here: https://github.com/video-dev/hls.js/issues/332#issuecomment-257986486
        if (type === 'audio' && audioTrack && audioTrack.container === 'audio/mpeg') { // Chrome audio mp3 track
            var audioBuffer = this.sourceBuffer.audio;
            var delta = Math.abs(audioBuffer.timestampOffset - data.start);
            // adjust timestamp offset if time delta is greater than 100ms
            if (delta > 0.1) {
                var updating = audioBuffer.updating;
                try {
                    audioBuffer.abort();
                }
                catch (err) {
                    logger_1.logger.warn('can not abort audio buffer: ' + err);
                }
                if (!updating) {
                    logger_1.logger.warn('change mpeg audio timestamp offset from ' + audioBuffer.timestampOffset + ' to ' + data.start);
                    audioBuffer.timestampOffset = data.start;
                }
                else {
                    this.audioTimestampOffset = data.start;
                }
            }
        }
    };
    BufferController.prototype.onManifestParsed = function (data) {
        // in case of alt audio 2 BUFFER_CODECS events will be triggered, one per stream controller
        // sourcebuffers will be created all at once when the expected nb of tracks will be reached
        // in case alt audio is not used, only one BUFFER_CODEC event will be fired from main stream controller
        // it will contain the expected nb of source buffers, no need to compute it
        this.bufferCodecEventsExpected = data.altAudio ? 2 : 1;
        logger_1.logger.log(this.bufferCodecEventsExpected + " bufferCodec event(s) expected");
    };
    BufferController.prototype.onMediaAttaching = function (data) {
        var media = this.media = data.media;
        if (media) {
            // setup the media source
            var ms = this.mediaSource = new MediaSource();
            // Media Source listeners
            this.onmso = this.onMediaSourceOpen.bind(this);
            this.onmse = this.onMediaSourceEnded.bind(this);
            this.onmsc = this.onMediaSourceClose.bind(this);
            ms.addEventListener('sourceopen', this.onmso);
            ms.addEventListener('sourceended', this.onmse);
            ms.addEventListener('sourceclose', this.onmsc);
            // link video and media Source
            media.src = window.URL.createObjectURL(ms);
            // cache the locally generated object url
            this._objectUrl = media.src;
        }
    };
    BufferController.prototype.onMediaDetaching = function () {
        logger_1.logger.log('media source detaching');
        var ms = this.mediaSource;
        if (ms) {
            if (ms.readyState === 'open') {
                try {
                    // endOfStream could trigger exception if any sourcebuffer is in updating state
                    // we don't really care about checking sourcebuffer state here,
                    // as we are anyway detaching the MediaSource
                    // let's just avoid this exception to propagate
                    ms.endOfStream();
                }
                catch (err) {
                    logger_1.logger.warn("onMediaDetaching:" + err.message + " while calling endOfStream");
                }
            }
            ms.removeEventListener('sourceopen', this.onmso);
            ms.removeEventListener('sourceended', this.onmse);
            ms.removeEventListener('sourceclose', this.onmsc);
            // Detach properly the MediaSource from the HTMLMediaElement as
            // suggested in https://github.com/w3c/media-source/issues/53.
            if (this.media) {
                window.URL.revokeObjectURL(this._objectUrl);
                // clean up video tag src only if it's our own url. some external libraries might
                // hijack the video tag and change its 'src' without destroying the Hls instance first
                if (this.media.src === this._objectUrl) {
                    this.media.removeAttribute('src');
                    this.media.load();
                }
                else {
                    logger_1.logger.warn('media.src was changed by a third party - skip cleanup');
                }
            }
            this.mediaSource = null;
            this.media = null;
            this._objectUrl = null;
            this.pendingTracks = {};
            this.tracks = {};
            this.sourceBuffer = {};
            this.flushRange = [];
            this.segments = [];
            this.appended = 0;
        }
        this.onmso = this.onmse = this.onmsc = null;
        this.hls.trigger(events_1.default.MEDIA_DETACHED);
    };
    BufferController.prototype.onMediaSourceOpen = function () {
        logger_1.logger.log('media source opened');
        this.hls.trigger(events_1.default.MEDIA_ATTACHED, { media: this.media });
        var mediaSource = this.mediaSource;
        if (mediaSource) {
            // once received, don't listen anymore to sourceopen event
            mediaSource.removeEventListener('sourceopen', this.onmso);
        }
        this.checkPendingTracks();
    };
    BufferController.prototype.checkPendingTracks = function () {
        var _a = this, bufferCodecEventsExpected = _a.bufferCodecEventsExpected, pendingTracks = _a.pendingTracks;
        // Check if we've received all of the expected bufferCodec events. When none remain, create all the sourceBuffers at once.
        // This is important because the MSE spec allows implementations to throw QuotaExceededErrors if creating new sourceBuffers after
        // data has been appended to existing ones.
        // 2 tracks is the max (one for audio, one for video). If we've reach this max go ahead and create the buffers.
        var pendingTracksCount = Object.keys(pendingTracks).length;
        if ((pendingTracksCount && !bufferCodecEventsExpected) || pendingTracksCount === 2) {
            // ok, let's create them now !
            this.createSourceBuffers(pendingTracks);
            this.pendingTracks = {};
            // append any pending segments now !
            this.doAppending();
        }
    };
    BufferController.prototype.onMediaSourceClose = function () {
        logger_1.logger.log('media source closed');
    };
    BufferController.prototype.onMediaSourceEnded = function () {
        logger_1.logger.log('media source ended');
    };
    BufferController.prototype.onSBUpdateEnd = function () {
        // update timestampOffset
        if (this.audioTimestampOffset) {
            var audioBuffer = this.sourceBuffer.audio;
            logger_1.logger.warn("change mpeg audio timestamp offset from " + audioBuffer.timestampOffset + " to " + this.audioTimestampOffset);
            audioBuffer.timestampOffset = this.audioTimestampOffset;
            delete this.audioTimestampOffset;
        }
        if (this._needsFlush) {
            this.doFlush();
        }
        if (this._needsEos) {
            this.checkEos();
        }
        this.appending = false;
        var parent = this.parent;
        // count nb of pending segments waiting for appending on this sourcebuffer
        var pending = this.segments.reduce(function (counter, segment) { return (segment.parent === parent) ? counter + 1 : counter; }, 0);
        // this.sourceBuffer is better to use than media.buffered as it is closer to the PTS data from the fragments
        var timeRanges = {};
        var sourceBuffer = this.sourceBuffer;
        for (var streamType in sourceBuffer) {
            timeRanges[streamType] = sourceBuffer[streamType].buffered;
        }
        this.hls.trigger(events_1.default.BUFFER_APPENDED, { parent: parent, pending: pending, timeRanges: timeRanges });
        // don't append in flushing mode
        if (!this._needsFlush) {
            this.doAppending();
        }
        this.updateMediaElementDuration();
        // appending goes first
        if (pending === 0) {
            this.flushLiveBackBuffer();
        }
    };
    BufferController.prototype.onSBUpdateError = function (event) {
        logger_1.logger.error('sourceBuffer error:', event);
        // according to http://www.w3.org/TR/media-source/#sourcebuffer-append-error
        // this error might not always be fatal (it is fatal if decode error is set, in that case
        // it will be followed by a mediaElement error ...)
        this.hls.trigger(events_1.default.ERROR, { type: errors_1.ErrorTypes.MEDIA_ERROR, details: errors_1.ErrorDetails.BUFFER_APPENDING_ERROR, fatal: false });
        // we don't need to do more than that, as accordin to the spec, updateend will be fired just after
    };
    BufferController.prototype.onBufferReset = function () {
        var sourceBuffer = this.sourceBuffer;
        for (var type in sourceBuffer) {
            var sb = sourceBuffer[type];
            try {
                this.mediaSource.removeSourceBuffer(sb);
                sb.removeEventListener('updateend', this.onsbue);
                sb.removeEventListener('error', this.onsbe);
            }
            catch (err) {
            }
        }
        this.sourceBuffer = {};
        this.flushRange = [];
        this.segments = [];
        this.appended = 0;
    };
    BufferController.prototype.onBufferCodecs = function (tracks) {
        var _this = this;
        // if source buffer(s) not created yet, appended buffer tracks in this.pendingTracks
        // if sourcebuffers already created, do nothing ...
        if (Object.keys(this.sourceBuffer).length) {
            return;
        }
        Object.keys(tracks).forEach(function (trackName) {
            _this.pendingTracks[trackName] = tracks[trackName];
        });
        var mediaSource = this.mediaSource;
        this.bufferCodecEventsExpected = Math.max(this.bufferCodecEventsExpected - 1, 0);
        if (mediaSource && mediaSource.readyState === 'open') {
            this.checkPendingTracks();
        }
    };
    BufferController.prototype.createSourceBuffers = function (tracks) {
        var sourceBuffer = this.sourceBuffer, mediaSource = this.mediaSource;
        for (var trackName in tracks) {
            if (!sourceBuffer[trackName]) {
                var track = tracks[trackName];
                // use levelCodec as first priority
                var codec = track.levelCodec || track.codec;
                var mimeType = track.container + ";codecs=" + codec;
                logger_1.logger.log("creating sourceBuffer(" + mimeType + ")");
                try {
                    var sb = sourceBuffer[trackName] = mediaSource.addSourceBuffer(mimeType);
                    sb.addEventListener('updateend', this.onsbue);
                    sb.addEventListener('error', this.onsbe);
                    this.tracks[trackName] = { codec: codec, container: track.container };
                    track.buffer = sb;
                }
                catch (err) {
                    logger_1.logger.error("error while trying to add sourceBuffer:" + err.message);
                    this.hls.trigger(events_1.default.ERROR, { type: errors_1.ErrorTypes.MEDIA_ERROR, details: errors_1.ErrorDetails.BUFFER_ADD_CODEC_ERROR, fatal: false, err: err, mimeType: mimeType });
                }
            }
        }
        this.hls.trigger(events_1.default.BUFFER_CREATED, { tracks: tracks });
    };
    BufferController.prototype.onBufferAppending = function (data) {
        if (!this._needsFlush) {
            if (!this.segments) {
                this.segments = [data];
            }
            else {
                this.segments.push(data);
            }
            this.doAppending();
        }
    };
    BufferController.prototype.onBufferAppendFail = function (data) {
        logger_1.logger.error('sourceBuffer error:', data.event);
        // according to http://www.w3.org/TR/media-source/#sourcebuffer-append-error
        // this error might not always be fatal (it is fatal if decode error is set, in that case
        // it will be followed by a mediaElement error ...)
        this.hls.trigger(events_1.default.ERROR, { type: errors_1.ErrorTypes.MEDIA_ERROR, details: errors_1.ErrorDetails.BUFFER_APPENDING_ERROR, fatal: false });
    };
    // on BUFFER_EOS mark matching sourcebuffer(s) as ended and trigger checkEos()
    BufferController.prototype.onBufferEos = function (data) {
        var sb = this.sourceBuffer;
        var dataType = data.type;
        for (var type in sb) {
            if (!dataType || type === dataType) {
                if (!sb[type].ended) {
                    sb[type].ended = true;
                    logger_1.logger.log(type + " sourceBuffer now EOS");
                }
            }
        }
        this.checkEos();
    };
    // if all source buffers are marked as ended, signal endOfStream() to MediaSource.
    BufferController.prototype.checkEos = function () {
        var sb = this.sourceBuffer, mediaSource = this.mediaSource;
        if (!mediaSource || mediaSource.readyState !== 'open') {
            this._needsEos = false;
            return;
        }
        for (var type in sb) {
            var sbobj = sb[type];
            if (!sbobj.ended) {
                return;
            }
            if (sbobj.updating) {
                this._needsEos = true;
                return;
            }
        }
        logger_1.logger.log('all media data are available, signal endOfStream() to MediaSource and stop loading fragment');
        // Notify the media element that it now has all of the media data
        try {
            mediaSource.endOfStream();
        }
        catch (e) {
            logger_1.logger.warn('exception while calling mediaSource.endOfStream()');
        }
        this._needsEos = false;
    };
    BufferController.prototype.onBufferFlushing = function (data) {
        this.flushRange.push({ start: data.startOffset, end: data.endOffset, type: data.type });
        // attempt flush immediately
        this.flushBufferCounter = 0;
        this.doFlush();
    };
    BufferController.prototype.flushLiveBackBuffer = function () {
        // clear back buffer for live only
        if (!this._live) {
            return;
        }
        var liveBackBufferLength = this.hls.config.liveBackBufferLength;
        if (!isFinite(liveBackBufferLength) || liveBackBufferLength < 0) {
            return;
        }
        var currentTime = this.media.currentTime;
        var sourceBuffer = this.sourceBuffer;
        var bufferTypes = Object.keys(sourceBuffer);
        var targetBackBufferPosition = currentTime - Math.max(liveBackBufferLength, this._levelTargetDuration);
        for (var index = bufferTypes.length - 1; index >= 0; index--) {
            var bufferType = bufferTypes[index], buffered = sourceBuffer[bufferType].buffered;
            // when target buffer start exceeds actual buffer start
            if (buffered.length > 0 && targetBackBufferPosition > buffered.start(0)) {
                // remove buffer up until current time minus minimum back buffer length (removing buffer too close to current
                // time will lead to playback freezing)
                // credits for level target duration - https://github.com/videojs/http-streaming/blob/3132933b6aa99ddefab29c10447624efd6fd6e52/src/segment-loader.js#L91
                this.removeBufferRange(bufferType, sourceBuffer[bufferType], 0, targetBackBufferPosition);
            }
        }
    };
    BufferController.prototype.onLevelUpdated = function (_a) {
        var details = _a.details;
        if (details.fragments.length > 0) {
            this._levelDuration = details.totalduration + details.fragments[0].start;
            this._levelTargetDuration = details.averagetargetduration || details.targetduration || 10;
            this._live = details.live;
            this.updateMediaElementDuration();
        }
    };
    /**
     * Update Media Source duration to current level duration or override to Infinity if configuration parameter
     * 'liveDurationInfinity` is set to `true`
     * More details: https://github.com/video-dev/hls.js/issues/355
     */
    BufferController.prototype.updateMediaElementDuration = function () {
        var config = this.hls.config;
        var duration;
        if (this._levelDuration === null ||
            !this.media ||
            !this.mediaSource ||
            !this.sourceBuffer ||
            this.media.readyState === 0 ||
            this.mediaSource.readyState !== 'open') {
            return;
        }
        for (var type in this.sourceBuffer) {
            if (this.sourceBuffer[type].updating === true) {
                // can't set duration whilst a buffer is updating
                return;
            }
        }
        duration = this.media.duration;
        // initialise to the value that the media source is reporting
        if (this._msDuration === null) {
            this._msDuration = this.mediaSource.duration;
        }
        if (this._live === true && config.liveDurationInfinity === true) {
            // Override duration to Infinity
            logger_1.logger.log('Media Source duration is set to Infinity');
            this._msDuration = this.mediaSource.duration = Infinity;
        }
        else if ((this._levelDuration > this._msDuration && this._levelDuration > duration) || !Number.isFinite(duration)) {
            // levelDuration was the last value we set.
            // not using mediaSource.duration as the browser may tweak this value
            // only update Media Source duration if its value increase, this is to avoid
            // flushing already buffered portion when switching between quality level
            logger_1.logger.log("Updating Media Source duration to " + this._levelDuration.toFixed(3));
            this._msDuration = this.mediaSource.duration = this._levelDuration;
        }
    };
    BufferController.prototype.doFlush = function () {
        // loop through all buffer ranges to flush
        while (this.flushRange.length) {
            var range = this.flushRange[0];
            // flushBuffer will abort any buffer append in progress and flush Audio/Video Buffer
            if (this.flushBuffer(range.start, range.end, range.type)) {
                // range flushed, remove from flush array
                this.flushRange.shift();
                this.flushBufferCounter = 0;
            }
            else {
                this._needsFlush = true;
                // avoid looping, wait for SB update end to retrigger a flush
                return;
            }
        }
        if (this.flushRange.length === 0) {
            // everything flushed
            this._needsFlush = false;
            // let's recompute this.appended, which is used to avoid flush looping
            var appended = 0;
            var sourceBuffer = this.sourceBuffer;
            try {
                for (var type in sourceBuffer) {
                    appended += sourceBuffer[type].buffered.length;
                }
            }
            catch (error) {
                // error could be thrown while accessing buffered, in case sourcebuffer has already been removed from MediaSource
                // this is harmess at this stage, catch this to avoid reporting an internal exception
                logger_1.logger.error('error while accessing sourceBuffer.buffered');
            }
            this.appended = appended;
            this.hls.trigger(events_1.default.BUFFER_FLUSHED);
        }
    };
    BufferController.prototype.doAppending = function () {
        var _a = this, hls = _a.hls, segments = _a.segments, sourceBuffer = _a.sourceBuffer;
        if (Object.keys(sourceBuffer).length) {
            if (this.media.error) {
                this.segments = [];
                logger_1.logger.error('trying to append although a media error occured, flush segment and abort');
                return;
            }
            if (this.appending) {
                // logger.log(`sb appending in progress`);
                return;
            }
            if (segments && segments.length) {
                var segment = segments.shift();
                try {
                    var type = segment.type, sb = sourceBuffer[type];
                    if (sb) {
                        if (!sb.updating) {
                            // reset sourceBuffer ended flag before appending segment
                            sb.ended = false;
                            // logger.log(`appending ${segment.content} ${type} SB, size:${segment.data.length}, ${segment.parent}`);
                            this.parent = segment.parent;
                            sb.appendBuffer(segment.data);
                            this.appendError = 0;
                            this.appended++;
                            this.appending = true;
                        }
                        else {
                            segments.unshift(segment);
                        }
                    }
                    else {
                        // in case we don't have any source buffer matching with this segment type,
                        // it means that Mediasource fails to create sourcebuffer
                        // discard this segment, and trigger update end
                        this.onSBUpdateEnd();
                    }
                }
                catch (err) {
                    // in case any error occured while appending, put back segment in segments table
                    logger_1.logger.error("error while trying to append buffer:" + err.message);
                    segments.unshift(segment);
                    var event_1 = { type: errors_1.ErrorTypes.MEDIA_ERROR, parent: segment.parent };
                    if (err.code !== 22) {
                        if (this.appendError) {
                            this.appendError++;
                        }
                        else {
                            this.appendError = 1;
                        }
                        event_1.details = errors_1.ErrorDetails.BUFFER_APPEND_ERROR;
                        /* with UHD content, we could get loop of quota exceeded error until
                          browser is able to evict some data from sourcebuffer. retrying help recovering this
                        */
                        if (this.appendError > hls.config.appendErrorMaxRetry) {
                            logger_1.logger.log("fail " + hls.config.appendErrorMaxRetry + " times to append segment in sourceBuffer");
                            this.segments = [];
                            event_1.fatal = true;
                            hls.trigger(events_1.default.ERROR, event_1);
                        }
                        else {
                            event_1.fatal = false;
                            hls.trigger(events_1.default.ERROR, event_1);
                        }
                    }
                    else {
                        // QuotaExceededError: http://www.w3.org/TR/html5/infrastructure.html#quotaexceedederror
                        // let's stop appending any segments, and report BUFFER_FULL_ERROR error
                        this.segments = [];
                        event_1.details = errors_1.ErrorDetails.BUFFER_FULL_ERROR;
                        event_1.fatal = false;
                        hls.trigger(events_1.default.ERROR, event_1);
                    }
                }
            }
        }
    };
    /*
      flush specified buffered range,
      return true once range has been flushed.
      as sourceBuffer.remove() is asynchronous, flushBuffer will be retriggered on sourceBuffer update end
    */
    BufferController.prototype.flushBuffer = function (startOffset, endOffset, typeIn) {
        var sb;
        var sourceBuffer = this.sourceBuffer;
        if (Object.keys(sourceBuffer).length) {
            logger_1.logger.log("flushBuffer,pos/start/end: " + this.media.currentTime.toFixed(3) + "/" + startOffset + "/" + endOffset);
            // safeguard to avoid infinite looping : don't try to flush more than the nb of appended segments
            if (this.flushBufferCounter < this.appended) {
                for (var type in sourceBuffer) {
                    // check if sourcebuffer type is defined (typeIn): if yes, let's only flush this one
                    // if no, let's flush all sourcebuffers
                    if (typeIn && type !== typeIn) {
                        continue;
                    }
                    sb = sourceBuffer[type];
                    // we are going to flush buffer, mark source buffer as 'not ended'
                    sb.ended = false;
                    if (!sb.updating) {
                        if (this.removeBufferRange(type, sb, startOffset, endOffset)) {
                            this.flushBufferCounter++;
                            return false;
                        }
                    }
                    else {
                        logger_1.logger.warn('cannot flush, sb updating in progress');
                        return false;
                    }
                }
            }
            else {
                logger_1.logger.warn('abort flushing too many retries');
            }
            logger_1.logger.log('buffer flushed');
        }
        // everything flushed !
        return true;
    };
    /**
     * Removes first buffered range from provided source buffer that lies within given start and end offsets.
     *
     * @param type Type of the source buffer, logging purposes only.
     * @param sb Target SourceBuffer instance.
     * @param startOffset
     * @param endOffset
     *
     * @returns {boolean} True when source buffer remove requested.
     */
    BufferController.prototype.removeBufferRange = function (type, sb, startOffset, endOffset) {
        try {
            for (var i = 0; i < sb.buffered.length; i++) {
                var bufStart = sb.buffered.start(i);
                var bufEnd = sb.buffered.end(i);
                var removeStart = Math.max(bufStart, startOffset);
                var removeEnd = Math.min(bufEnd, endOffset);
                /* sometimes sourcebuffer.remove() does not flush
                  the exact expected time range.
                  to avoid rounding issues/infinite loop,
                  only flush buffer range of length greater than 500ms.
                */
                if (Math.min(removeEnd, bufEnd) - removeStart > 0.5) {
                    logger_1.logger.log("sb remove " + type + " [" + removeStart + "," + removeEnd + "], of [" + bufStart + "," + bufEnd + "], pos:" + this.media.currentTime);
                    sb.remove(removeStart, removeEnd);
                    return true;
                }
            }
        }
        catch (error) {
            logger_1.logger.warn('removeBufferRange failed', error);
        }
        return false;
    };
    return BufferController;
}(event_handler_1.default));
exports.default = BufferController;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./src/polyfills/number */ "./src/polyfills/number.js")["Number"]))

/***/ }),

/***/ "./src/controller/cap-level-controller.js":
/*!************************************************!*\
  !*** ./src/controller/cap-level-controller.js ***!
  \************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Number) {
/*
 * cap stream level to media size dimension controller
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var event_handler_1 = __webpack_require__(/*! ../event-handler */ "./src/event-handler.js");
var CapLevelController = /** @class */ (function (_super) {
    __extends(CapLevelController, _super);
    function CapLevelController(hls) {
        var _this = _super.call(this, hls, events_1.default.FPS_DROP_LEVEL_CAPPING, events_1.default.MEDIA_ATTACHING, events_1.default.MANIFEST_PARSED, events_1.default.BUFFER_CODECS, events_1.default.MEDIA_DETACHING) || this;
        _this.autoLevelCapping = Number.POSITIVE_INFINITY;
        _this.firstLevel = null;
        _this.levels = [];
        _this.media = null;
        _this.restrictedLevels = [];
        _this.timer = null;
        return _this;
    }
    CapLevelController.prototype.destroy = function () {
        if (this.hls.config.capLevelToPlayerSize) {
            this.media = null;
            this._stopCapping();
        }
    };
    CapLevelController.prototype.onFpsDropLevelCapping = function (data) {
        // Don't add a restricted level more than once
        if (CapLevelController.isLevelAllowed(data.droppedLevel, this.restrictedLevels)) {
            this.restrictedLevels.push(data.droppedLevel);
        }
    };
    CapLevelController.prototype.onMediaAttaching = function (data) {
        this.media = data.media instanceof window.HTMLVideoElement ? data.media : null;
    };
    CapLevelController.prototype.onManifestParsed = function (data) {
        var hls = this.hls;
        this.restrictedLevels = [];
        this.levels = data.levels;
        this.firstLevel = data.firstLevel;
        if (hls.config.capLevelToPlayerSize && data.video) {
            // Start capping immediately if the manifest has signaled video codecs
            this._startCapping();
        }
    };
    // Only activate capping when playing a video stream; otherwise, multi-bitrate audio-only streams will be restricted
    // to the first level
    CapLevelController.prototype.onBufferCodecs = function (data) {
        var hls = this.hls;
        if (hls.config.capLevelToPlayerSize && data.video) {
            // If the manifest did not signal a video codec capping has been deferred until we're certain video is present
            this._startCapping();
        }
    };
    CapLevelController.prototype.onLevelsUpdated = function (data) {
        this.levels = data.levels;
    };
    CapLevelController.prototype.onMediaDetaching = function () {
        this._stopCapping();
    };
    CapLevelController.prototype.detectPlayerSize = function () {
        if (this.media) {
            var levelsLength = this.levels ? this.levels.length : 0;
            if (levelsLength) {
                var hls_1 = this.hls;
                hls_1.autoLevelCapping = this.getMaxLevel(levelsLength - 1);
                if (hls_1.autoLevelCapping > this.autoLevelCapping) {
                    // if auto level capping has a higher value for the previous one, flush the buffer using nextLevelSwitch
                    // usually happen when the user go to the fullscreen mode.
                    hls_1.streamController.nextLevelSwitch();
                }
                this.autoLevelCapping = hls_1.autoLevelCapping;
            }
        }
    };
    /*
    * returns level should be the one with the dimensions equal or greater than the media (player) dimensions (so the video will be downscaled)
    */
    CapLevelController.prototype.getMaxLevel = function (capLevelIndex) {
        var _this = this;
        if (!this.levels) {
            return -1;
        }
        var validLevels = this.levels.filter(function (level, index) {
            return CapLevelController.isLevelAllowed(index, _this.restrictedLevels) && index <= capLevelIndex;
        });
        return CapLevelController.getMaxLevelByMediaSize(validLevels, this.mediaWidth, this.mediaHeight);
    };
    CapLevelController.prototype._startCapping = function () {
        if (this.timer) {
            // Don't reset capping if started twice; this can happen if the manifest signals a video codec
            return;
        }
        this.autoLevelCapping = Number.POSITIVE_INFINITY;
        this.hls.firstLevel = this.getMaxLevel(this.firstLevel);
        clearInterval(this.timer);
        this.timer = setInterval(this.detectPlayerSize.bind(this), 1000);
        this.detectPlayerSize();
    };
    CapLevelController.prototype._stopCapping = function () {
        this.restrictedLevels = [];
        this.firstLevel = null;
        this.autoLevelCapping = Number.POSITIVE_INFINITY;
        if (this.timer) {
            this.timer = clearInterval(this.timer);
            this.timer = null;
        }
    };
    Object.defineProperty(CapLevelController.prototype, "mediaWidth", {
        get: function () {
            var width;
            var media = this.media;
            if (media) {
                width = media.width || media.clientWidth || media.offsetWidth;
                width *= CapLevelController.contentScaleFactor;
            }
            return width;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CapLevelController.prototype, "mediaHeight", {
        get: function () {
            var height;
            var media = this.media;
            if (media) {
                height = media.height || media.clientHeight || media.offsetHeight;
                height *= CapLevelController.contentScaleFactor;
            }
            return height;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CapLevelController, "contentScaleFactor", {
        get: function () {
            var pixelRatio = 1;
            try {
                pixelRatio = window.devicePixelRatio;
            }
            catch (e) { }
            return pixelRatio;
        },
        enumerable: true,
        configurable: true
    });
    CapLevelController.isLevelAllowed = function (level, restrictedLevels) {
        if (restrictedLevels === void 0) { restrictedLevels = []; }
        return restrictedLevels.indexOf(level) === -1;
    };
    CapLevelController.getMaxLevelByMediaSize = function (levels, width, height) {
        if (!levels || (levels && !levels.length)) {
            return -1;
        }
        // Levels can have the same dimensions but differing bandwidths - since levels are ordered, we can look to the next
        // to determine whether we've chosen the greatest bandwidth for the media's dimensions
        var atGreatestBandiwdth = function (curLevel, nextLevel) {
            if (!nextLevel) {
                return true;
            }
            return curLevel.width !== nextLevel.width || curLevel.height !== nextLevel.height;
        };
        // If we run through the loop without breaking, the media's dimensions are greater than every level, so default to
        // the max level
        var maxLevelIndex = levels.length - 1;
        for (var i = 0; i < levels.length; i += 1) {
            var level = levels[i];
            if ((level.width >= width || level.height >= height) && atGreatestBandiwdth(level, levels[i + 1])) {
                maxLevelIndex = i;
                break;
            }
        }
        return maxLevelIndex;
    };
    return CapLevelController;
}(event_handler_1.default));
exports.default = CapLevelController;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./src/polyfills/number */ "./src/polyfills/number.js")["Number"]))

/***/ }),

/***/ "./src/controller/eme-controller.js":
/*!******************************************!*\
  !*** ./src/controller/eme-controller.js ***!
  \******************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @author Stephan Hesse <disparat@gmail.com> | <tchakabam@gmail.com>
 *
 * DRM support for Hls.js
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var event_handler_1 = __webpack_require__(/*! ../event-handler */ "./src/event-handler.js");
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var errors_1 = __webpack_require__(/*! ../errors */ "./src/errors.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var XMLHttpRequest = window.XMLHttpRequest;
var MAX_LICENSE_REQUEST_FAILURES = 3;
/**
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Navigator/requestMediaKeySystemAccess
 */
var KeySystems = {
    WIDEVINE: 'com.widevine.alpha',
    PLAYREADY: 'com.microsoft.playready'
};
/**
 * @see https://developer.mozilla.org/en-US/docs/Web/API/MediaKeySystemConfiguration
 * @param {Array<string>} audioCodecs List of required audio codecs to support
 * @param {Array<string>} videoCodecs List of required video codecs to support
 * @param {object} drmSystemOptions Optional parameters/requirements for the key-system
 * @returns {Array<MediaSystemConfiguration>} An array of supported configurations
 */
var createWidevineMediaKeySystemConfigurations = function (audioCodecs, videoCodecs, drmSystemOptions) {
    var baseConfig = {
        // initDataTypes: ['keyids', 'mp4'],
        // label: "",
        // persistentState: "not-allowed", // or "required" ?
        // distinctiveIdentifier: "not-allowed", // or "required" ?
        // sessionTypes: ['temporary'],
        videoCapabilities: [
        // { contentType: 'video/mp4; codecs="avc1.42E01E"' }
        ]
    };
    videoCodecs.forEach(function (codec) {
        baseConfig.videoCapabilities.push({
            contentType: "video/mp4; codecs=\"" + codec + "\""
        });
    });
    return [
        baseConfig
    ];
};
/**
 * The idea here is to handle key-system (and their respective platforms) specific configuration differences
 * in order to work with the local requestMediaKeySystemAccess method.
 *
 * We can also rule-out platform-related key-system support at this point by throwing an error or returning null.
 *
 * @param {string} keySystem Identifier for the key-system, see `KeySystems` enum
 * @param {Array<string>} audioCodecs List of required audio codecs to support
 * @param {Array<string>} videoCodecs List of required video codecs to support
 * @returns {Array<MediaSystemConfiguration> | null} A non-empty Array of MediaKeySystemConfiguration objects or `null`
 */
var getSupportedMediaKeySystemConfigurations = function (keySystem, audioCodecs, videoCodecs) {
    switch (keySystem) {
        case KeySystems.WIDEVINE:
            return createWidevineMediaKeySystemConfigurations(audioCodecs, videoCodecs);
        default:
            throw Error('Unknown key-system: ' + keySystem);
    }
};
/**
 * Controller to deal with encrypted media extensions (EME)
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Encrypted_Media_Extensions_API
 *
 * @class
 * @constructor
 */
var EMEController = /** @class */ (function (_super) {
    __extends(EMEController, _super);
    /**
       * @constructs
       * @param {Hls} hls Our Hls.js instance
       */
    function EMEController(hls) {
        var _this = _super.call(this, hls, events_1.default.MEDIA_ATTACHED, events_1.default.MANIFEST_PARSED) || this;
        _this._widevineLicenseUrl = hls.config.widevineLicenseUrl;
        _this._licenseXhrSetup = hls.config.licenseXhrSetup;
        _this._emeEnabled = hls.config.emeEnabled;
        _this._requestMediaKeySystemAccess = hls.config.requestMediaKeySystemAccessFunc;
        _this._mediaKeysList = [];
        _this._media = null;
        _this._hasSetMediaKeys = false;
        _this._isMediaEncrypted = false;
        _this._requestLicenseFailureCount = 0;
        return _this;
    }
    /**
       *
       * @param {string} keySystem Identifier for the key-system, see `KeySystems` enum
       * @returns {string} License server URL for key-system (if any configured, otherwise causes error)
       */
    EMEController.prototype.getLicenseServerUrl = function (keySystem) {
        var url;
        switch (keySystem) {
            case KeySystems.WIDEVINE:
                url = this._widevineLicenseUrl;
                break;
            default:
                url = null;
                break;
        }
        if (!url) {
            logger_1.logger.error("No license server URL configured for key-system \"" + keySystem + "\"");
            this.hls.trigger(events_1.default.ERROR, {
                type: errors_1.ErrorTypes.KEY_SYSTEM_ERROR,
                details: errors_1.ErrorDetails.KEY_SYSTEM_LICENSE_REQUEST_FAILED,
                fatal: true
            });
        }
        return url;
    };
    /**
       * Requests access object and adds it to our list upon success
       * @private
       * @param {string} keySystem System ID (see `KeySystems`)
       * @param {Array<string>} audioCodecs List of required audio codecs to support
       * @param {Array<string>} videoCodecs List of required video codecs to support
       */
    EMEController.prototype._attemptKeySystemAccess = function (keySystem, audioCodecs, videoCodecs) {
        // TODO: add other DRM "options"
        var _this = this;
        var mediaKeySystemConfigs = getSupportedMediaKeySystemConfigurations(keySystem, audioCodecs, videoCodecs);
        if (!mediaKeySystemConfigs) {
            logger_1.logger.warn('Can not create config for key-system (maybe because platform is not supported):', keySystem);
            return;
        }
        logger_1.logger.log('Requesting encrypted media key-system access');
        // expecting interface like window.navigator.requestMediaKeySystemAccess
        this.requestMediaKeySystemAccess(keySystem, mediaKeySystemConfigs)
            .then(function (mediaKeySystemAccess) {
            _this._onMediaKeySystemAccessObtained(keySystem, mediaKeySystemAccess);
        })
            .catch(function (err) {
            logger_1.logger.error("Failed to obtain key-system \"" + keySystem + "\" access:", err);
        });
    };
    Object.defineProperty(EMEController.prototype, "requestMediaKeySystemAccess", {
        get: function () {
            if (!this._requestMediaKeySystemAccess) {
                throw new Error('No requestMediaKeySystemAccess function configured');
            }
            return this._requestMediaKeySystemAccess;
        },
        enumerable: true,
        configurable: true
    });
    /**
       * Handles obtaining access to a key-system
       *
       * @param {string} keySystem
       * @param {MediaKeySystemAccess} mediaKeySystemAccess https://developer.mozilla.org/en-US/docs/Web/API/MediaKeySystemAccess
       */
    EMEController.prototype._onMediaKeySystemAccessObtained = function (keySystem, mediaKeySystemAccess) {
        var _this = this;
        logger_1.logger.log("Access for key-system \"" + keySystem + "\" obtained");
        var mediaKeysListItem = {
            mediaKeys: null,
            mediaKeysSession: null,
            mediaKeysSessionInitialized: false,
            mediaKeySystemAccess: mediaKeySystemAccess,
            mediaKeySystemDomain: keySystem
        };
        this._mediaKeysList.push(mediaKeysListItem);
        mediaKeySystemAccess.createMediaKeys()
            .then(function (mediaKeys) {
            mediaKeysListItem.mediaKeys = mediaKeys;
            logger_1.logger.log("Media-keys created for key-system \"" + keySystem + "\"");
            _this._onMediaKeysCreated();
        })
            .catch(function (err) {
            logger_1.logger.error('Failed to create media-keys:', err);
        });
    };
    /**
       * Handles key-creation (represents access to CDM). We are going to create key-sessions upon this
       * for all existing keys where no session exists yet.
       */
    EMEController.prototype._onMediaKeysCreated = function () {
        var _this = this;
        // check for all key-list items if a session exists, otherwise, create one
        this._mediaKeysList.forEach(function (mediaKeysListItem) {
            if (!mediaKeysListItem.mediaKeysSession) {
                mediaKeysListItem.mediaKeysSession = mediaKeysListItem.mediaKeys.createSession();
                _this._onNewMediaKeySession(mediaKeysListItem.mediaKeysSession);
            }
        });
    };
    /**
       *
       * @param {*} keySession
       */
    EMEController.prototype._onNewMediaKeySession = function (keySession) {
        var _this = this;
        logger_1.logger.log("New key-system session " + keySession.sessionId);
        keySession.addEventListener('message', function (event) {
            _this._onKeySessionMessage(keySession, event.message);
        }, false);
    };
    EMEController.prototype._onKeySessionMessage = function (keySession, message) {
        logger_1.logger.log('Got EME message event, creating license request');
        this._requestLicense(message, function (data) {
            logger_1.logger.log('Received license data, updating key-session');
            keySession.update(data);
        });
    };
    EMEController.prototype._onMediaEncrypted = function (initDataType, initData) {
        logger_1.logger.log("Media is encrypted using \"" + initDataType + "\" init data type");
        this._isMediaEncrypted = true;
        this._mediaEncryptionInitDataType = initDataType;
        this._mediaEncryptionInitData = initData;
        this._attemptSetMediaKeys();
        this._generateRequestWithPreferredKeySession();
    };
    EMEController.prototype._attemptSetMediaKeys = function () {
        if (!this._hasSetMediaKeys) {
            // FIXME: see if we can/want/need-to really to deal with several potential key-sessions?
            var keysListItem = this._mediaKeysList[0];
            if (!keysListItem || !keysListItem.mediaKeys) {
                logger_1.logger.error('Fatal: Media is encrypted but no CDM access or no keys have been obtained yet');
                this.hls.trigger(events_1.default.ERROR, {
                    type: errors_1.ErrorTypes.KEY_SYSTEM_ERROR,
                    details: errors_1.ErrorDetails.KEY_SYSTEM_NO_KEYS,
                    fatal: true
                });
                return;
            }
            logger_1.logger.log('Setting keys for encrypted media');
            this._media.setMediaKeys(keysListItem.mediaKeys);
            this._hasSetMediaKeys = true;
        }
    };
    EMEController.prototype._generateRequestWithPreferredKeySession = function () {
        var _this = this;
        // FIXME: see if we can/want/need-to really to deal with several potential key-sessions?
        var keysListItem = this._mediaKeysList[0];
        if (!keysListItem) {
            logger_1.logger.error('Fatal: Media is encrypted but not any key-system access has been obtained yet');
            this.hls.trigger(events_1.default.ERROR, {
                type: errors_1.ErrorTypes.KEY_SYSTEM_ERROR,
                details: errors_1.ErrorDetails.KEY_SYSTEM_NO_ACCESS,
                fatal: true
            });
            return;
        }
        if (keysListItem.mediaKeysSessionInitialized) {
            logger_1.logger.warn('Key-Session already initialized but requested again');
            return;
        }
        var keySession = keysListItem.mediaKeysSession;
        if (!keySession) {
            logger_1.logger.error('Fatal: Media is encrypted but no key-session existing');
            this.hls.trigger(events_1.default.ERROR, {
                type: errors_1.ErrorTypes.KEY_SYSTEM_ERROR,
                details: errors_1.ErrorDetails.KEY_SYSTEM_NO_SESSION,
                fatal: true
            });
        }
        var initDataType = this._mediaEncryptionInitDataType;
        var initData = this._mediaEncryptionInitData;
        logger_1.logger.log("Generating key-session request for \"" + initDataType + "\" init data type");
        keysListItem.mediaKeysSessionInitialized = true;
        keySession.generateRequest(initDataType, initData)
            .then(function () {
            logger_1.logger.debug('Key-session generation succeeded');
        })
            .catch(function (err) {
            logger_1.logger.error('Error generating key-session request:', err);
            _this.hls.trigger(events_1.default.ERROR, {
                type: errors_1.ErrorTypes.KEY_SYSTEM_ERROR,
                details: errors_1.ErrorDetails.KEY_SYSTEM_NO_SESSION,
                fatal: false
            });
        });
    };
    /**
       * @param {string} url License server URL
       * @param {ArrayBuffer} keyMessage Message data issued by key-system
       * @param {function} callback Called when XHR has succeeded
       * @returns {XMLHttpRequest} Unsent (but opened state) XHR object
       */
    EMEController.prototype._createLicenseXhr = function (url, keyMessage, callback) {
        var xhr = new XMLHttpRequest();
        var licenseXhrSetup = this._licenseXhrSetup;
        try {
            if (licenseXhrSetup) {
                try {
                    licenseXhrSetup(xhr, url);
                }
                catch (e) {
                    // let's try to open before running setup
                    xhr.open('POST', url, true);
                    licenseXhrSetup(xhr, url);
                }
            }
            // if licenseXhrSetup did not yet call open, let's do it now
            if (!xhr.readyState) {
                xhr.open('POST', url, true);
            }
        }
        catch (e) {
            // IE11 throws an exception on xhr.open if attempting to access an HTTP resource over HTTPS
            logger_1.logger.error('Error setting up key-system license XHR', e);
            this.hls.trigger(events_1.default.ERROR, {
                type: errors_1.ErrorTypes.KEY_SYSTEM_ERROR,
                details: errors_1.ErrorDetails.KEY_SYSTEM_LICENSE_REQUEST_FAILED,
                fatal: true
            });
            return;
        }
        xhr.responseType = 'arraybuffer';
        xhr.onreadystatechange =
            this._onLicenseRequestReadyStageChange.bind(this, xhr, url, keyMessage, callback);
        return xhr;
    };
    /**
       * @param {XMLHttpRequest} xhr
       * @param {string} url License server URL
       * @param {ArrayBuffer} keyMessage Message data issued by key-system
       * @param {function} callback Called when XHR has succeeded
       *
       */
    EMEController.prototype._onLicenseRequestReadyStageChange = function (xhr, url, keyMessage, callback) {
        switch (xhr.readyState) {
            case 4:
                if (xhr.status === 200) {
                    this._requestLicenseFailureCount = 0;
                    logger_1.logger.log('License request succeeded');
                    callback(xhr.response);
                }
                else {
                    logger_1.logger.error("License Request XHR failed (" + url + "). Status: " + xhr.status + " (" + xhr.statusText + ")");
                    this._requestLicenseFailureCount++;
                    if (this._requestLicenseFailureCount <= MAX_LICENSE_REQUEST_FAILURES) {
                        var attemptsLeft = MAX_LICENSE_REQUEST_FAILURES - this._requestLicenseFailureCount + 1;
                        logger_1.logger.warn("Retrying license request, " + attemptsLeft + " attempts left");
                        this._requestLicense(keyMessage, callback);
                        return;
                    }
                    this.hls.trigger(events_1.default.ERROR, {
                        type: errors_1.ErrorTypes.KEY_SYSTEM_ERROR,
                        details: errors_1.ErrorDetails.KEY_SYSTEM_LICENSE_REQUEST_FAILED,
                        fatal: true
                    });
                }
                break;
        }
    };
    /**
       * @param {object} keysListItem
       * @param {ArrayBuffer} keyMessage
       * @returns {ArrayBuffer} Challenge data posted to license server
       */
    EMEController.prototype._generateLicenseRequestChallenge = function (keysListItem, keyMessage) {
        var challenge;
        if (keysListItem.mediaKeySystemDomain === KeySystems.PLAYREADY) {
            logger_1.logger.error('PlayReady is not supported (yet)');
            // from https://github.com/MicrosoftEdge/Demos/blob/master/eme/scripts/demo.js
            /*
              if (this.licenseType !== this.LICENSE_TYPE_WIDEVINE) {
                  // For PlayReady CDMs, we need to dig the Challenge out of the XML.
                  var keyMessageXml = new DOMParser().parseFromString(String.fromCharCode.apply(null, new Uint16Array(keyMessage)), 'application/xml');
                  if (keyMessageXml.getElementsByTagName('Challenge')[0]) {
                      challenge = atob(keyMessageXml.getElementsByTagName('Challenge')[0].childNodes[0].nodeValue);
                  } else {
                      throw 'Cannot find <Challenge> in key message';
                  }
                  var headerNames = keyMessageXml.getElementsByTagName('name');
                  var headerValues = keyMessageXml.getElementsByTagName('value');
                  if (headerNames.length !== headerValues.length) {
                      throw 'Mismatched header <name>/<value> pair in key message';
                  }
                  for (var i = 0; i < headerNames.length; i++) {
                      xhr.setRequestHeader(headerNames[i].childNodes[0].nodeValue, headerValues[i].childNodes[0].nodeValue);
                  }
              }
              */
        }
        else if (keysListItem.mediaKeySystemDomain === KeySystems.WIDEVINE) {
            // For Widevine CDMs, the challenge is the keyMessage.
            challenge = keyMessage;
        }
        else {
            logger_1.logger.error('Unsupported key-system:', keysListItem.mediaKeySystemDomain);
        }
        return challenge;
    };
    EMEController.prototype._requestLicense = function (keyMessage, callback) {
        logger_1.logger.log('Requesting content license for key-system');
        var keysListItem = this._mediaKeysList[0];
        if (!keysListItem) {
            logger_1.logger.error('Fatal error: Media is encrypted but no key-system access has been obtained yet');
            this.hls.trigger(events_1.default.ERROR, {
                type: errors_1.ErrorTypes.KEY_SYSTEM_ERROR,
                details: errors_1.ErrorDetails.KEY_SYSTEM_NO_ACCESS,
                fatal: true
            });
            return;
        }
        var url = this.getLicenseServerUrl(keysListItem.mediaKeySystemDomain);
        var xhr = this._createLicenseXhr(url, keyMessage, callback);
        logger_1.logger.log("Sending license request to URL: " + url);
        xhr.send(this._generateLicenseRequestChallenge(keysListItem, keyMessage));
    };
    EMEController.prototype.onMediaAttached = function (data) {
        var _this = this;
        if (!this._emeEnabled) {
            return;
        }
        var media = data.media;
        // keep reference of media
        this._media = media;
        // FIXME: also handle detaching media !
        media.addEventListener('encrypted', function (e) {
            _this._onMediaEncrypted(e.initDataType, e.initData);
        });
    };
    EMEController.prototype.onManifestParsed = function (data) {
        if (!this._emeEnabled) {
            return;
        }
        var audioCodecs = data.levels.map(function (level) { return level.audioCodec; });
        var videoCodecs = data.levels.map(function (level) { return level.videoCodec; });
        this._attemptKeySystemAccess(KeySystems.WIDEVINE, audioCodecs, videoCodecs);
    };
    return EMEController;
}(event_handler_1.default));
exports.default = EMEController;


/***/ }),

/***/ "./src/controller/fps-controller.js":
/*!******************************************!*\
  !*** ./src/controller/fps-controller.js ***!
  \******************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * FPS Controller
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var event_handler_1 = __webpack_require__(/*! ../event-handler */ "./src/event-handler.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var performance = window.performance;
var FPSController = /** @class */ (function (_super) {
    __extends(FPSController, _super);
    function FPSController(hls) {
        return _super.call(this, hls, events_1.default.MEDIA_ATTACHING) || this;
    }
    FPSController.prototype.destroy = function () {
        if (this.timer) {
            clearInterval(this.timer);
        }
        this.isVideoPlaybackQualityAvailable = false;
    };
    FPSController.prototype.onMediaAttaching = function (data) {
        var config = this.hls.config;
        if (config.capLevelOnFPSDrop) {
            var video_1 = this.video = data.media instanceof window.HTMLVideoElement ? data.media : null;
            if (typeof video_1.getVideoPlaybackQuality === 'function') {
                this.isVideoPlaybackQualityAvailable = true;
            }
            clearInterval(this.timer);
            this.timer = setInterval(this.checkFPSInterval.bind(this), config.fpsDroppedMonitoringPeriod);
        }
    };
    FPSController.prototype.checkFPS = function (video, decodedFrames, droppedFrames) {
        var currentTime = performance.now();
        if (decodedFrames) {
            if (this.lastTime) {
                var currentPeriod = currentTime - this.lastTime, currentDropped = droppedFrames - this.lastDroppedFrames, currentDecoded = decodedFrames - this.lastDecodedFrames, droppedFPS = 1000 * currentDropped / currentPeriod, hls_1 = this.hls;
                hls_1.trigger(events_1.default.FPS_DROP, { currentDropped: currentDropped, currentDecoded: currentDecoded, totalDroppedFrames: droppedFrames });
                if (droppedFPS > 0) {
                    // logger.log('checkFPS : droppedFPS/decodedFPS:' + droppedFPS/(1000 * currentDecoded / currentPeriod));
                    if (currentDropped > hls_1.config.fpsDroppedMonitoringThreshold * currentDecoded) {
                        var currentLevel = hls_1.currentLevel;
                        logger_1.logger.warn('drop FPS ratio greater than max allowed value for currentLevel: ' + currentLevel);
                        if (currentLevel > 0 && (hls_1.autoLevelCapping === -1 || hls_1.autoLevelCapping >= currentLevel)) {
                            currentLevel = currentLevel - 1;
                            hls_1.trigger(events_1.default.FPS_DROP_LEVEL_CAPPING, { level: currentLevel, droppedLevel: hls_1.currentLevel });
                            hls_1.autoLevelCapping = currentLevel;
                            hls_1.streamController.nextLevelSwitch();
                        }
                    }
                }
            }
            this.lastTime = currentTime;
            this.lastDroppedFrames = droppedFrames;
            this.lastDecodedFrames = decodedFrames;
        }
    };
    FPSController.prototype.checkFPSInterval = function () {
        var video = this.video;
        if (video) {
            if (this.isVideoPlaybackQualityAvailable) {
                var videoPlaybackQuality = video.getVideoPlaybackQuality();
                this.checkFPS(video, videoPlaybackQuality.totalVideoFrames, videoPlaybackQuality.droppedVideoFrames);
            }
            else {
                this.checkFPS(video, video.webkitDecodedFrameCount, video.webkitDroppedFrameCount);
            }
        }
    };
    return FPSController;
}(event_handler_1.default));
exports.default = FPSController;


/***/ }),

/***/ "./src/controller/fragment-finders.js":
/*!********************************************!*\
  !*** ./src/controller/fragment-finders.js ***!
  \********************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Number) {
Object.defineProperty(exports, "__esModule", { value: true });
var binary_search_1 = __webpack_require__(/*! ../utils/binary-search */ "./src/utils/binary-search.js");
/**
 * Returns first fragment whose endPdt value exceeds the given PDT.
 * @param {Array<Fragment>} fragments - The array of candidate fragments
 * @param {number|null} [PDTValue = null] - The PDT value which must be exceeded
 * @param {number} [maxFragLookUpTolerance = 0] - The amount of time that a fragment's start/end can be within in order to be considered contiguous
 * @returns {*|null} fragment - The best matching fragment
 */
function findFragmentByPDT(fragments, PDTValue, maxFragLookUpTolerance) {
    if (!Array.isArray(fragments) || !fragments.length || !Number.isFinite(PDTValue)) {
        return null;
    }
    // if less than start
    if (PDTValue < fragments[0].programDateTime) {
        return null;
    }
    if (PDTValue >= fragments[fragments.length - 1].endProgramDateTime) {
        return null;
    }
    maxFragLookUpTolerance = maxFragLookUpTolerance || 0;
    for (var seg = 0; seg < fragments.length; ++seg) {
        var frag = fragments[seg];
        if (pdtWithinToleranceTest(PDTValue, maxFragLookUpTolerance, frag)) {
            return frag;
        }
    }
    return null;
}
exports.findFragmentByPDT = findFragmentByPDT;
/**
 * Finds a fragment based on the SN of the previous fragment; or based on the needs of the current buffer.
 * This method compensates for small buffer gaps by applying a tolerance to the start of any candidate fragment, thus
 * breaking any traps which would cause the same fragment to be continuously selected within a small range.
 * @param {*} fragPrevious - The last frag successfully appended
 * @param {Array<Fragment>} fragments - The array of candidate fragments
 * @param {number} [bufferEnd = 0] - The end of the contiguous buffered range the playhead is currently within
 * @param {number} maxFragLookUpTolerance - The amount of time that a fragment's start/end can be within in order to be considered contiguous
 * @returns {*} foundFrag - The best matching fragment
 */
function findFragmentByPTS(fragPrevious, fragments, bufferEnd, maxFragLookUpTolerance) {
    if (bufferEnd === void 0) { bufferEnd = 0; }
    if (maxFragLookUpTolerance === void 0) { maxFragLookUpTolerance = 0; }
    var fragNext = fragPrevious ? fragments[fragPrevious.sn - fragments[0].sn + 1] : null;
    // Prefer the next fragment if it's within tolerance
    if (fragNext && !fragmentWithinToleranceTest(bufferEnd, maxFragLookUpTolerance, fragNext)) {
        return fragNext;
    }
    return binary_search_1.default.search(fragments, fragmentWithinToleranceTest.bind(null, bufferEnd, maxFragLookUpTolerance));
}
exports.findFragmentByPTS = findFragmentByPTS;
/**
 * The test function used by the findFragmentBySn's BinarySearch to look for the best match to the current buffer conditions.
 * @param {*} candidate - The fragment to test
 * @param {number} [bufferEnd = 0] - The end of the current buffered range the playhead is currently within
 * @param {number} [maxFragLookUpTolerance = 0] - The amount of time that a fragment's start can be within in order to be considered contiguous
 * @returns {number} - 0 if it matches, 1 if too low, -1 if too high
 */
function fragmentWithinToleranceTest(bufferEnd, maxFragLookUpTolerance, candidate) {
    if (bufferEnd === void 0) { bufferEnd = 0; }
    if (maxFragLookUpTolerance === void 0) { maxFragLookUpTolerance = 0; }
    // offset should be within fragment boundary - config.maxFragLookUpTolerance
    // this is to cope with situations like
    // bufferEnd = 9.991
    // frag[Ø] : [0,10]
    // frag[1] : [10,20]
    // bufferEnd is within frag[0] range ... although what we are expecting is to return frag[1] here
    //              frag start               frag start+duration
    //                  |-----------------------------|
    //              <--->                         <--->
    //  ...--------><-----------------------------><---------....
    // previous frag         matching fragment         next frag
    //  return -1             return 0                 return 1
    // logger.log(`level/sn/start/end/bufEnd:${level}/${candidate.sn}/${candidate.start}/${(candidate.start+candidate.duration)}/${bufferEnd}`);
    // Set the lookup tolerance to be small enough to detect the current segment - ensures we don't skip over very small segments
    var candidateLookupTolerance = Math.min(maxFragLookUpTolerance, candidate.duration + (candidate.deltaPTS ? candidate.deltaPTS : 0));
    if (candidate.start + candidate.duration - candidateLookupTolerance <= bufferEnd) {
        return 1;
    }
    else if (candidate.start - candidateLookupTolerance > bufferEnd && candidate.start) {
        // if maxFragLookUpTolerance will have negative value then don't return -1 for first element
        return -1;
    }
    return 0;
}
exports.fragmentWithinToleranceTest = fragmentWithinToleranceTest;
/**
 * The test function used by the findFragmentByPdt's BinarySearch to look for the best match to the current buffer conditions.
 * This function tests the candidate's program date time values, as represented in Unix time
 * @param {*} candidate - The fragment to test
 * @param {number} [pdtBufferEnd = 0] - The Unix time representing the end of the current buffered range
 * @param {number} [maxFragLookUpTolerance = 0] - The amount of time that a fragment's start can be within in order to be considered contiguous
 * @returns {boolean} True if contiguous, false otherwise
 */
function pdtWithinToleranceTest(pdtBufferEnd, maxFragLookUpTolerance, candidate) {
    var candidateLookupTolerance = Math.min(maxFragLookUpTolerance, candidate.duration + (candidate.deltaPTS ? candidate.deltaPTS : 0)) * 1000;
    return candidate.endProgramDateTime - candidateLookupTolerance > pdtBufferEnd;
}
exports.pdtWithinToleranceTest = pdtWithinToleranceTest;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./src/polyfills/number */ "./src/polyfills/number.js")["Number"]))

/***/ }),

/***/ "./src/controller/fragment-tracker.js":
/*!********************************************!*\
  !*** ./src/controller/fragment-tracker.js ***!
  \********************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Number) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var event_handler_1 = __webpack_require__(/*! ../event-handler */ "./src/event-handler.js");
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
exports.FragmentState = {
    NOT_LOADED: 'NOT_LOADED',
    APPENDING: 'APPENDING',
    PARTIAL: 'PARTIAL',
    OK: 'OK'
};
var FragmentTracker = /** @class */ (function (_super) {
    __extends(FragmentTracker, _super);
    function FragmentTracker(hls) {
        var _this = _super.call(this, hls, events_1.default.BUFFER_APPENDED, events_1.default.FRAG_BUFFERED, events_1.default.FRAG_LOADED) || this;
        _this.bufferPadding = 0.2;
        _this.fragments = Object.create(null);
        _this.timeRanges = Object.create(null);
        _this.config = hls.config;
        return _this;
    }
    FragmentTracker.prototype.destroy = function () {
        this.fragments = null;
        this.timeRanges = null;
        this.config = null;
        event_handler_1.default.prototype.destroy.call(this);
        _super.prototype.destroy.call(this);
    };
    /**
     * Return a Fragment that match the position and levelType.
     * If not found any Fragment, return null
     * @param {number} position
     * @param {LevelType} levelType
     * @returns {Fragment|null}
     */
    FragmentTracker.prototype.getBufferedFrag = function (position, levelType) {
        var fragments = this.fragments;
        var bufferedFrags = Object.keys(fragments).filter(function (key) {
            var fragmentEntity = fragments[key];
            if (fragmentEntity.body.type !== levelType) {
                return false;
            }
            if (!fragmentEntity.buffered) {
                return false;
            }
            var frag = fragmentEntity.body;
            return frag.startPTS <= position && position <= frag.endPTS;
        });
        if (bufferedFrags.length === 0) {
            return null;
        }
        else {
            // https://github.com/video-dev/hls.js/pull/1545#discussion_r166229566
            var bufferedFragKey = bufferedFrags.pop();
            return fragments[bufferedFragKey].body;
        }
    };
    /**
     * Partial fragments effected by coded frame eviction will be removed
     * The browser will unload parts of the buffer to free up memory for new buffer data
     * Fragments will need to be reloaded when the buffer is freed up, removing partial fragments will allow them to reload(since there might be parts that are still playable)
     * @param {String} elementaryStream The elementaryStream of media this is (eg. video/audio)
     * @param {TimeRanges} timeRange TimeRange object from a sourceBuffer
     */
    FragmentTracker.prototype.detectEvictedFragments = function (elementaryStream, timeRange) {
        var _this = this;
        var fragmentTimes, time;
        // Check if any flagged fragments have been unloaded
        Object.keys(this.fragments).forEach(function (key) {
            var fragmentEntity = _this.fragments[key];
            if (fragmentEntity.buffered === true) {
                var esData = fragmentEntity.range[elementaryStream];
                if (esData) {
                    fragmentTimes = esData.time;
                    for (var i = 0; i < fragmentTimes.length; i++) {
                        time = fragmentTimes[i];
                        if (_this.isTimeBuffered(time.startPTS, time.endPTS, timeRange) === false) {
                            // Unregister partial fragment as it needs to load again to be reused
                            _this.removeFragment(fragmentEntity.body);
                            break;
                        }
                    }
                }
            }
        });
    };
    /**
     * Checks if the fragment passed in is loaded in the buffer properly
     * Partially loaded fragments will be registered as a partial fragment
     * @param {Object} fragment Check the fragment against all sourceBuffers loaded
     */
    FragmentTracker.prototype.detectPartialFragments = function (fragment) {
        var _this = this;
        var fragKey = this.getFragmentKey(fragment);
        var fragmentEntity = this.fragments[fragKey];
        if (fragmentEntity) {
            fragmentEntity.buffered = true;
            Object.keys(this.timeRanges).forEach(function (elementaryStream) {
                if (fragment.hasElementaryStream(elementaryStream)) {
                    var timeRange = _this.timeRanges[elementaryStream];
                    // Check for malformed fragments
                    // Gaps need to be calculated for each elementaryStream
                    fragmentEntity.range[elementaryStream] = _this.getBufferedTimes(fragment.startPTS, fragment.endPTS, timeRange);
                }
            });
        }
    };
    FragmentTracker.prototype.getBufferedTimes = function (startPTS, endPTS, timeRange) {
        var fragmentTimes = [];
        var startTime, endTime;
        var fragmentPartial = false;
        for (var i = 0; i < timeRange.length; i++) {
            startTime = timeRange.start(i) - this.bufferPadding;
            endTime = timeRange.end(i) + this.bufferPadding;
            if (startPTS >= startTime && endPTS <= endTime) {
                // Fragment is entirely contained in buffer
                // No need to check the other timeRange times since it's completely playable
                fragmentTimes.push({
                    startPTS: Math.max(startPTS, timeRange.start(i)),
                    endPTS: Math.min(endPTS, timeRange.end(i))
                });
                break;
            }
            else if (startPTS < endTime && endPTS > startTime) {
                // Check for intersection with buffer
                // Get playable sections of the fragment
                fragmentTimes.push({
                    startPTS: Math.max(startPTS, timeRange.start(i)),
                    endPTS: Math.min(endPTS, timeRange.end(i))
                });
                fragmentPartial = true;
            }
            else if (endPTS <= startTime) {
                // No need to check the rest of the timeRange as it is in order
                break;
            }
        }
        return {
            time: fragmentTimes,
            partial: fragmentPartial
        };
    };
    FragmentTracker.prototype.getFragmentKey = function (fragment) {
        return fragment.type + "_" + fragment.level + "_" + fragment.urlId + "_" + fragment.sn;
    };
    /**
     * Gets the partial fragment for a certain time
     * @param {Number} time
     * @returns {Object} fragment Returns a partial fragment at a time or null if there is no partial fragment
     */
    FragmentTracker.prototype.getPartialFragment = function (time) {
        var _this = this;
        var timePadding, startTime, endTime;
        var bestFragment = null;
        var bestOverlap = 0;
        Object.keys(this.fragments).forEach(function (key) {
            var fragmentEntity = _this.fragments[key];
            if (_this.isPartial(fragmentEntity)) {
                startTime = fragmentEntity.body.startPTS - _this.bufferPadding;
                endTime = fragmentEntity.body.endPTS + _this.bufferPadding;
                if (time >= startTime && time <= endTime) {
                    // Use the fragment that has the most padding from start and end time
                    timePadding = Math.min(time - startTime, endTime - time);
                    if (bestOverlap <= timePadding) {
                        bestFragment = fragmentEntity.body;
                        bestOverlap = timePadding;
                    }
                }
            }
        });
        return bestFragment;
    };
    /**
     * @param {Object} fragment The fragment to check
     * @returns {String} Returns the fragment state when a fragment never loaded or if it partially loaded
     */
    FragmentTracker.prototype.getState = function (fragment) {
        var fragKey = this.getFragmentKey(fragment);
        var fragmentEntity = this.fragments[fragKey];
        var state = exports.FragmentState.NOT_LOADED;
        if (fragmentEntity !== undefined) {
            if (!fragmentEntity.buffered) {
                state = exports.FragmentState.APPENDING;
            }
            else if (this.isPartial(fragmentEntity) === true) {
                state = exports.FragmentState.PARTIAL;
            }
            else {
                state = exports.FragmentState.OK;
            }
        }
        return state;
    };
    FragmentTracker.prototype.isPartial = function (fragmentEntity) {
        return fragmentEntity.buffered === true &&
            ((fragmentEntity.range.video !== undefined && fragmentEntity.range.video.partial === true) ||
                (fragmentEntity.range.audio !== undefined && fragmentEntity.range.audio.partial === true));
    };
    FragmentTracker.prototype.isTimeBuffered = function (startPTS, endPTS, timeRange) {
        var startTime, endTime;
        for (var i = 0; i < timeRange.length; i++) {
            startTime = timeRange.start(i) - this.bufferPadding;
            endTime = timeRange.end(i) + this.bufferPadding;
            if (startPTS >= startTime && endPTS <= endTime) {
                return true;
            }
            if (endPTS <= startTime) {
                // No need to check the rest of the timeRange as it is in order
                return false;
            }
        }
        return false;
    };
    /**
     * Fires when a fragment loading is completed
     */
    FragmentTracker.prototype.onFragLoaded = function (e) {
        var fragment = e.frag;
        // don't track initsegment (for which sn is not a number)
        // don't track frags used for bitrateTest, they're irrelevant.
        if (Number.isFinite(fragment.sn) && !fragment.bitrateTest) {
            this.fragments[this.getFragmentKey(fragment)] = {
                body: fragment,
                range: Object.create(null),
                buffered: false
            };
        }
    };
    /**
     * Fires when the buffer is updated
     */
    FragmentTracker.prototype.onBufferAppended = function (e) {
        var _this = this;
        // Store the latest timeRanges loaded in the buffer
        this.timeRanges = e.timeRanges;
        Object.keys(this.timeRanges).forEach(function (elementaryStream) {
            var timeRange = _this.timeRanges[elementaryStream];
            _this.detectEvictedFragments(elementaryStream, timeRange);
        });
    };
    /**
     * Fires after a fragment has been loaded into the source buffer
     */
    FragmentTracker.prototype.onFragBuffered = function (e) {
        this.detectPartialFragments(e.frag);
    };
    /**
     * Return true if fragment tracker has the fragment.
     * @param {Object} fragment
     * @returns {boolean}
     */
    FragmentTracker.prototype.hasFragment = function (fragment) {
        var fragKey = this.getFragmentKey(fragment);
        return this.fragments[fragKey] !== undefined;
    };
    /**
     * Remove a fragment from fragment tracker until it is loaded again
     * @param {Object} fragment The fragment to remove
     */
    FragmentTracker.prototype.removeFragment = function (fragment) {
        var fragKey = this.getFragmentKey(fragment);
        delete this.fragments[fragKey];
    };
    /**
     * Remove all fragments from fragment tracker.
     */
    FragmentTracker.prototype.removeAllFragments = function () {
        this.fragments = Object.create(null);
    };
    return FragmentTracker;
}(event_handler_1.default));
exports.FragmentTracker = FragmentTracker;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./src/polyfills/number */ "./src/polyfills/number.js")["Number"]))

/***/ }),

/***/ "./src/controller/gap-controller.js":
/*!******************************************!*\
  !*** ./src/controller/gap-controller.js ***!
  \******************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var buffer_helper_1 = __webpack_require__(/*! ../utils/buffer-helper */ "./src/utils/buffer-helper.js");
var errors_1 = __webpack_require__(/*! ../errors */ "./src/errors.js");
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var stallDebounceInterval = 1000;
var jumpThreshold = 0.5; // tolerance needed as some browsers stalls playback before reaching buffered range end
var GapController = /** @class */ (function () {
    function GapController(config, media, fragmentTracker, hls) {
        this.config = config;
        this.media = media;
        this.fragmentTracker = fragmentTracker;
        this.hls = hls;
        this.stallReported = false;
    }
    /**
     * Checks if the playhead is stuck within a gap, and if so, attempts to free it.
     * A gap is an unbuffered range between two buffered ranges (or the start and the first buffered range).
     * @param lastCurrentTime
     * @param buffered
     */
    GapController.prototype.poll = function (lastCurrentTime, buffered) {
        var _a = this, config = _a.config, media = _a.media;
        var currentTime = media.currentTime;
        var tnow = window.performance.now();
        if (currentTime !== lastCurrentTime) {
            // The playhead is now moving, but was previously stalled
            if (this.stallReported) {
                logger_1.logger.warn("playback not stuck anymore @" + currentTime + ", after " + Math.round(tnow - this.stalled) + "ms");
                this.stallReported = false;
            }
            this.stalled = null;
            this.nudgeRetry = 0;
            return;
        }
        if (media.ended || !media.buffered.length || media.readyState > 2) {
            return;
        }
        if (media.seeking && buffer_helper_1.BufferHelper.isBuffered(media, currentTime)) {
            return;
        }
        // The playhead isn't moving but it should be
        // Allow some slack time to for small stalls to resolve themselves
        var stalledDuration = tnow - this.stalled;
        var bufferInfo = buffer_helper_1.BufferHelper.bufferInfo(media, currentTime, config.maxBufferHole);
        if (!this.stalled) {
            this.stalled = tnow;
            return;
        }
        else if (stalledDuration >= stallDebounceInterval) {
            // Report stalling after trying to fix
            this._reportStall(bufferInfo.len);
        }
        this._tryFixBufferStall(bufferInfo, stalledDuration);
    };
    /**
     * Detects and attempts to fix known buffer stalling issues.
     * @param bufferInfo - The properties of the current buffer.
     * @param stalledDuration - The amount of time Hls.js has been stalling for.
     * @private
     */
    GapController.prototype._tryFixBufferStall = function (bufferInfo, stalledDuration) {
        var _a = this, config = _a.config, fragmentTracker = _a.fragmentTracker, media = _a.media;
        var currentTime = media.currentTime;
        var partial = fragmentTracker.getPartialFragment(currentTime);
        if (partial) {
            // Try to skip over the buffer hole caused by a partial fragment
            // This method isn't limited by the size of the gap between buffered ranges
            this._trySkipBufferHole(partial);
        }
        if (bufferInfo.len > jumpThreshold && stalledDuration > config.highBufferWatchdogPeriod * 1000) {
            // Try to nudge currentTime over a buffer hole if we've been stalling for the configured amount of seconds
            // We only try to jump the hole if it's under the configured size
            // Reset stalled so to rearm watchdog timer
            this.stalled = null;
            this._tryNudgeBuffer();
        }
    };
    /**
     * Triggers a BUFFER_STALLED_ERROR event, but only once per stall period.
     * @param bufferLen - The playhead distance from the end of the current buffer segment.
     * @private
     */
    GapController.prototype._reportStall = function (bufferLen) {
        var _a = this, hls = _a.hls, media = _a.media, stallReported = _a.stallReported;
        if (!stallReported) {
            // Report stalled error once
            this.stallReported = true;
            logger_1.logger.warn("Playback stalling at @" + media.currentTime + " due to low buffer");
            hls.trigger(events_1.default.ERROR, {
                type: errors_1.ErrorTypes.MEDIA_ERROR,
                details: errors_1.ErrorDetails.BUFFER_STALLED_ERROR,
                fatal: false,
                buffer: bufferLen
            });
        }
    };
    /**
     * Attempts to fix buffer stalls by jumping over known gaps caused by partial fragments
     * @param partial - The partial fragment found at the current time (where playback is stalling).
     * @private
     */
    GapController.prototype._trySkipBufferHole = function (partial) {
        var _a = this, hls = _a.hls, media = _a.media;
        var currentTime = media.currentTime;
        var lastEndTime = 0;
        // Check if currentTime is between unbuffered regions of partial fragments
        for (var i = 0; i < media.buffered.length; i++) {
            var startTime = media.buffered.start(i);
            if (currentTime >= lastEndTime && currentTime < startTime) {
                media.currentTime = Math.max(startTime, media.currentTime + 0.1);
                logger_1.logger.warn("skipping hole, adjusting currentTime from " + currentTime + " to " + media.currentTime);
                this.stalled = null;
                hls.trigger(events_1.default.ERROR, {
                    type: errors_1.ErrorTypes.MEDIA_ERROR,
                    details: errors_1.ErrorDetails.BUFFER_SEEK_OVER_HOLE,
                    fatal: false,
                    reason: "fragment loaded with buffer holes, seeking from " + currentTime + " to " + media.currentTime,
                    frag: partial
                });
                return;
            }
            lastEndTime = media.buffered.end(i);
        }
    };
    /**
     * Attempts to fix buffer stalls by advancing the mediaElement's current time by a small amount.
     * @private
     */
    GapController.prototype._tryNudgeBuffer = function () {
        var _a = this, config = _a.config, hls = _a.hls, media = _a.media;
        var currentTime = media.currentTime;
        var nudgeRetry = (this.nudgeRetry || 0) + 1;
        this.nudgeRetry = nudgeRetry;
        if (nudgeRetry < config.nudgeMaxRetry) {
            var targetTime = currentTime + nudgeRetry * config.nudgeOffset;
            logger_1.logger.log("adjust currentTime from " + currentTime + " to " + targetTime);
            // playback stalled in buffered area ... let's nudge currentTime to try to overcome this
            media.currentTime = targetTime;
            hls.trigger(events_1.default.ERROR, {
                type: errors_1.ErrorTypes.MEDIA_ERROR,
                details: errors_1.ErrorDetails.BUFFER_NUDGE_ON_STALL,
                fatal: false
            });
        }
        else {
            logger_1.logger.error("still stuck in high buffer @" + currentTime + " after " + config.nudgeMaxRetry + ", raise fatal error");
            hls.trigger(events_1.default.ERROR, {
                type: errors_1.ErrorTypes.MEDIA_ERROR,
                details: errors_1.ErrorDetails.BUFFER_STALLED_ERROR,
                fatal: true
            });
        }
    };
    return GapController;
}());
exports.default = GapController;


/***/ }),

/***/ "./src/controller/id3-track-controller.js":
/*!************************************************!*\
  !*** ./src/controller/id3-track-controller.js ***!
  \************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * id3 metadata track controller
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var event_handler_1 = __webpack_require__(/*! ../event-handler */ "./src/event-handler.js");
var id3_1 = __webpack_require__(/*! ../demux/id3 */ "./src/demux/id3.js");
var texttrack_utils_1 = __webpack_require__(/*! ../utils/texttrack-utils */ "./src/utils/texttrack-utils.js");
var ID3TrackController = /** @class */ (function (_super) {
    __extends(ID3TrackController, _super);
    function ID3TrackController(hls) {
        var _this = _super.call(this, hls, events_1.default.MEDIA_ATTACHED, events_1.default.MEDIA_DETACHING, events_1.default.FRAG_PARSING_METADATA) || this;
        _this.id3Track = undefined;
        _this.media = undefined;
        return _this;
    }
    ID3TrackController.prototype.destroy = function () {
        event_handler_1.default.prototype.destroy.call(this);
    };
    // Add ID3 metatadata text track.
    ID3TrackController.prototype.onMediaAttached = function (data) {
        this.media = data.media;
        if (!this.media) {
        }
    };
    ID3TrackController.prototype.onMediaDetaching = function () {
        texttrack_utils_1.clearCurrentCues(this.id3Track);
        this.id3Track = undefined;
        this.media = undefined;
    };
    ID3TrackController.prototype.getID3Track = function (textTracks) {
        for (var i = 0; i < textTracks.length; i++) {
            var textTrack = textTracks[i];
            if (textTrack.kind === 'metadata' && textTrack.label === 'id3') {
                // send 'addtrack' when reusing the textTrack for metadata,
                // same as what we do for captions
                texttrack_utils_1.sendAddTrackEvent(textTrack, this.media);
                return textTrack;
            }
        }
        return this.media.addTextTrack('metadata', 'id3');
    };
    ID3TrackController.prototype.onFragParsingMetadata = function (data) {
        var fragment = data.frag;
        var samples = data.samples;
        // create track dynamically
        if (!this.id3Track) {
            this.id3Track = this.getID3Track(this.media.textTracks);
            this.id3Track.mode = 'hidden';
        }
        // Attempt to recreate Safari functionality by creating
        // WebKitDataCue objects when available and store the decoded
        // ID3 data in the value property of the cue
        var Cue = window.WebKitDataCue || window.VTTCue || window.TextTrackCue;
        for (var i = 0; i < samples.length; i++) {
            var frames_1 = id3_1.default.getID3Frames(samples[i].data);
            if (frames_1) {
                var startTime = samples[i].pts;
                var endTime = i < samples.length - 1 ? samples[i + 1].pts : fragment.endPTS;
                // Give a slight bump to the endTime if it's equal to startTime to avoid a SyntaxError in IE
                if (startTime === endTime) {
                    endTime += 0.0001;
                }
                for (var j = 0; j < frames_1.length; j++) {
                    var frame = frames_1[j];
                    // Safari doesn't put the timestamp frame in the TextTrack
                    if (!id3_1.default.isTimeStampFrame(frame)) {
                        var cue = new Cue(startTime, endTime, '');
                        cue.value = frame;
                        this.id3Track.addCue(cue);
                    }
                }
            }
        }
    };
    return ID3TrackController;
}(event_handler_1.default));
exports.default = ID3TrackController;


/***/ }),

/***/ "./src/controller/level-controller.js":
/*!********************************************!*\
  !*** ./src/controller/level-controller.js ***!
  \********************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Level Controller
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var event_handler_1 = __webpack_require__(/*! ../event-handler */ "./src/event-handler.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var errors_1 = __webpack_require__(/*! ../errors */ "./src/errors.js");
var codecs_1 = __webpack_require__(/*! ../utils/codecs */ "./src/utils/codecs.js");
var level_helper_1 = __webpack_require__(/*! ./level-helper */ "./src/controller/level-helper.js");
var performance = window.performance;
var chromeOrFirefox;
var LevelController = /** @class */ (function (_super) {
    __extends(LevelController, _super);
    function LevelController(hls) {
        var _this = _super.call(this, hls, events_1.default.MANIFEST_LOADED, events_1.default.LEVEL_LOADED, events_1.default.AUDIO_TRACK_SWITCHED, events_1.default.FRAG_LOADED, events_1.default.ERROR) || this;
        _this.canload = false;
        _this.currentLevelIndex = null;
        _this.manualLevelIndex = -1;
        _this.timer = null;
        chromeOrFirefox = /chrome|firefox/.test(navigator.userAgent.toLowerCase());
        return _this;
    }
    LevelController.prototype.onHandlerDestroying = function () {
        this.clearTimer();
        this.manualLevelIndex = -1;
    };
    LevelController.prototype.clearTimer = function () {
        if (this.timer !== null) {
            clearTimeout(this.timer);
            this.timer = null;
        }
    };
    LevelController.prototype.startLoad = function () {
        var levels = this._levels;
        this.canload = true;
        this.levelRetryCount = 0;
        // clean up live level details to force reload them, and reset load errors
        if (levels) {
            levels.forEach(function (level) {
                level.loadError = 0;
                var levelDetails = level.details;
                if (levelDetails && levelDetails.live) {
                    level.details = undefined;
                }
            });
        }
        // speed up live playlist refresh if timer exists
        if (this.timer !== null) {
            this.loadLevel();
        }
    };
    LevelController.prototype.stopLoad = function () {
        this.canload = false;
    };
    LevelController.prototype.onManifestLoaded = function (data) {
        var levels = [];
        var audioTracks = [];
        var bitrateStart;
        var levelSet = {};
        var levelFromSet = null;
        var videoCodecFound = false;
        var audioCodecFound = false;
        // regroup redundant levels together
        data.levels.forEach(function (level) {
            var attributes = level.attrs;
            level.loadError = 0;
            level.fragmentError = false;
            videoCodecFound = videoCodecFound || !!level.videoCodec;
            audioCodecFound = audioCodecFound || !!level.audioCodec;
            // erase audio codec info if browser does not support mp4a.40.34.
            // demuxer will autodetect codec and fallback to mpeg/audio
            if (chromeOrFirefox && level.audioCodec && level.audioCodec.indexOf('mp4a.40.34') !== -1) {
                level.audioCodec = undefined;
            }
            levelFromSet = levelSet[level.bitrate]; // FIXME: we would also have to match the resolution here
            if (!levelFromSet) {
                level.url = [level.url];
                level.urlId = 0;
                levelSet[level.bitrate] = level;
                levels.push(level);
            }
            else {
                levelFromSet.url.push(level.url);
            }
            if (attributes) {
                if (attributes.AUDIO) {
                    audioCodecFound = true;
                    level_helper_1.addGroupId(levelFromSet || level, 'audio', attributes.AUDIO);
                }
                if (attributes.SUBTITLES) {
                    level_helper_1.addGroupId(levelFromSet || level, 'text', attributes.SUBTITLES);
                }
            }
        });
        // remove audio-only level if we also have levels with audio+video codecs signalled
        if (videoCodecFound && audioCodecFound) {
            levels = levels.filter(function (_a) {
                var videoCodec = _a.videoCodec;
                return !!videoCodec;
            });
        }
        // only keep levels with supported audio/video codecs
        levels = levels.filter(function (_a) {
            var audioCodec = _a.audioCodec, videoCodec = _a.videoCodec;
            return (!audioCodec || codecs_1.isCodecSupportedInMp4(audioCodec, 'audio')) && (!videoCodec || codecs_1.isCodecSupportedInMp4(videoCodec, 'video'));
        });
        if (data.audioTracks) {
            audioTracks = data.audioTracks.filter(function (track) { return !track.audioCodec || codecs_1.isCodecSupportedInMp4(track.audioCodec, 'audio'); });
            // Reassign id's after filtering since they're used as array indices
            audioTracks.forEach(function (track, index) {
                track.id = index;
            });
        }
        if (levels.length > 0) {
            // start bitrate is the first bitrate of the manifest
            bitrateStart = levels[0].bitrate;
            // sort level on bitrate
            levels.sort(function (a, b) { return a.bitrate - b.bitrate; });
            this._levels = levels;
            // find index of first level in sorted levels
            for (var i = 0; i < levels.length; i++) {
                if (levels[i].bitrate === bitrateStart) {
                    this._firstLevel = i;
                    logger_1.logger.log("manifest loaded," + levels.length + " level(s) found, first bitrate:" + bitrateStart);
                    break;
                }
            }
            // Audio is only alternate if manifest include a URI along with the audio group tag
            this.hls.trigger(events_1.default.MANIFEST_PARSED, {
                levels: levels,
                audioTracks: audioTracks,
                firstLevel: this._firstLevel,
                stats: data.stats,
                audio: audioCodecFound,
                video: videoCodecFound,
                altAudio: audioTracks.some(function (t) { return !!t.url; })
            });
        }
        else {
            this.hls.trigger(events_1.default.ERROR, {
                type: errors_1.ErrorTypes.MEDIA_ERROR,
                details: errors_1.ErrorDetails.MANIFEST_INCOMPATIBLE_CODECS_ERROR,
                fatal: true,
                url: this.hls.url,
                reason: 'no level with compatible codecs found in manifest'
            });
        }
    };
    Object.defineProperty(LevelController.prototype, "levels", {
        get: function () {
            return this._levels;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LevelController.prototype, "level", {
        get: function () {
            return this.currentLevelIndex;
        },
        set: function (newLevel) {
            var levels = this._levels;
            if (levels) {
                newLevel = Math.min(newLevel, levels.length - 1);
                if (this.currentLevelIndex !== newLevel || !levels[newLevel].details) {
                    this.setLevelInternal(newLevel);
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    LevelController.prototype.setLevelInternal = function (newLevel) {
        var levels = this._levels;
        var hls = this.hls;
        // check if level idx is valid
        if (newLevel >= 0 && newLevel < levels.length) {
            // stopping live reloading timer if any
            this.clearTimer();
            if (this.currentLevelIndex !== newLevel) {
                logger_1.logger.log("switching to level " + newLevel);
                this.currentLevelIndex = newLevel;
                var levelProperties = levels[newLevel];
                levelProperties.level = newLevel;
                hls.trigger(events_1.default.LEVEL_SWITCHING, levelProperties);
            }
            var level = levels[newLevel];
            var levelDetails = level.details;
            // check if we need to load playlist for this level
            if (!levelDetails || levelDetails.live) {
                // level not retrieved yet, or live playlist we need to (re)load it
                var urlId = level.urlId;
                hls.trigger(events_1.default.LEVEL_LOADING, { url: level.url[urlId], level: newLevel, id: urlId });
            }
        }
        else {
            // invalid level id given, trigger error
            hls.trigger(events_1.default.ERROR, {
                type: errors_1.ErrorTypes.OTHER_ERROR,
                details: errors_1.ErrorDetails.LEVEL_SWITCH_ERROR,
                level: newLevel,
                fatal: false,
                reason: 'invalid level idx'
            });
        }
    };
    Object.defineProperty(LevelController.prototype, "manualLevel", {
        get: function () {
            return this.manualLevelIndex;
        },
        set: function (newLevel) {
            this.manualLevelIndex = newLevel;
            if (this._startLevel === undefined) {
                this._startLevel = newLevel;
            }
            if (newLevel !== -1) {
                this.level = newLevel;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LevelController.prototype, "firstLevel", {
        get: function () {
            return this._firstLevel;
        },
        set: function (newLevel) {
            this._firstLevel = newLevel;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LevelController.prototype, "startLevel", {
        get: function () {
            // hls.startLevel takes precedence over config.startLevel
            // if none of these values are defined, fallback on this._firstLevel (first quality level appearing in variant manifest)
            if (this._startLevel === undefined) {
                var configStartLevel = this.hls.config.startLevel;
                if (configStartLevel !== undefined) {
                    return configStartLevel;
                }
                else {
                    return this._firstLevel;
                }
            }
            else {
                return this._startLevel;
            }
        },
        set: function (newLevel) {
            this._startLevel = newLevel;
        },
        enumerable: true,
        configurable: true
    });
    LevelController.prototype.onError = function (data) {
        if (data.fatal) {
            if (data.type === errors_1.ErrorTypes.NETWORK_ERROR) {
                this.clearTimer();
            }
            return;
        }
        var levelError = false, fragmentError = false;
        var levelIndex;
        // try to recover not fatal errors
        switch (data.details) {
            case errors_1.ErrorDetails.FRAG_LOAD_ERROR:
            case errors_1.ErrorDetails.FRAG_LOAD_TIMEOUT:
            case errors_1.ErrorDetails.KEY_LOAD_ERROR:
            case errors_1.ErrorDetails.KEY_LOAD_TIMEOUT:
                levelIndex = data.frag.level;
                fragmentError = true;
                break;
            case errors_1.ErrorDetails.LEVEL_LOAD_ERROR:
            case errors_1.ErrorDetails.LEVEL_LOAD_TIMEOUT:
                levelIndex = data.context.level;
                levelError = true;
                break;
            case errors_1.ErrorDetails.REMUX_ALLOC_ERROR:
                levelIndex = data.level;
                levelError = true;
                break;
        }
        if (levelIndex !== undefined) {
            this.recoverLevel(data, levelIndex, levelError, fragmentError);
        }
    };
    /**
     * Switch to a redundant stream if any available.
     * If redundant stream is not available, emergency switch down if ABR mode is enabled.
     *
     * @param {Object} errorEvent
     * @param {Number} levelIndex current level index
     * @param {Boolean} levelError
     * @param {Boolean} fragmentError
     */
    // FIXME Find a better abstraction where fragment/level retry management is well decoupled
    LevelController.prototype.recoverLevel = function (errorEvent, levelIndex, levelError, fragmentError) {
        var _this = this;
        var config = this.hls.config;
        var errorDetails = errorEvent.details;
        var level = this._levels[levelIndex];
        var redundantLevels, delay, nextLevel;
        level.loadError++;
        level.fragmentError = fragmentError;
        if (levelError) {
            if ((this.levelRetryCount + 1) <= config.levelLoadingMaxRetry) {
                // exponential backoff capped to max retry timeout
                delay = Math.min(Math.pow(2, this.levelRetryCount) * config.levelLoadingRetryDelay, config.levelLoadingMaxRetryTimeout);
                // Schedule level reload
                this.timer = setTimeout(function () { return _this.loadLevel(); }, delay);
                // boolean used to inform stream controller not to switch back to IDLE on non fatal error
                errorEvent.levelRetry = true;
                this.levelRetryCount++;
                logger_1.logger.warn("level controller, " + errorDetails + ", retry in " + delay + " ms, current retry count is " + this.levelRetryCount);
            }
            else {
                logger_1.logger.error("level controller, cannot recover from " + errorDetails + " error");
                this.currentLevelIndex = null;
                // stopping live reloading timer if any
                this.clearTimer();
                // switch error to fatal
                errorEvent.fatal = true;
                return;
            }
        }
        // Try any redundant streams if available for both errors: level and fragment
        // If level.loadError reaches redundantLevels it means that we tried them all, no hope  => let's switch down
        if (levelError || fragmentError) {
            redundantLevels = level.url.length;
            if (redundantLevels > 1 && level.loadError < redundantLevels) {
                level.urlId = (level.urlId + 1) % redundantLevels;
                level.details = undefined;
                logger_1.logger.warn("level controller, " + errorDetails + " for level " + levelIndex + ": switching to redundant URL-id " + level.urlId);
                // console.log('Current audio track group ID:', this.hls.audioTracks[this.hls.audioTrack].groupId);
                // console.log('New video quality level audio group id:', level.attrs.AUDIO);
            }
            else {
                // Search for available level
                if (this.manualLevelIndex === -1) {
                    // When lowest level has been reached, let's start hunt from the top
                    nextLevel = (levelIndex === 0) ? this._levels.length - 1 : levelIndex - 1;
                    logger_1.logger.warn("level controller, " + errorDetails + ": switch to " + nextLevel);
                    this.hls.nextAutoLevel = this.currentLevelIndex = nextLevel;
                }
                else if (fragmentError) {
                    // Allow fragment retry as long as configuration allows.
                    // reset this._level so that another call to set level() will trigger again a frag load
                    logger_1.logger.warn("level controller, " + errorDetails + ": reload a fragment");
                    this.currentLevelIndex = null;
                }
            }
        }
    };
    // reset errors on the successful load of a fragment
    LevelController.prototype.onFragLoaded = function (_a) {
        var frag = _a.frag;
        if (frag !== undefined && frag.type === 'main') {
            var level = this._levels[frag.level];
            if (level !== undefined) {
                level.fragmentError = false;
                level.loadError = 0;
                this.levelRetryCount = 0;
            }
        }
    };
    LevelController.prototype.onLevelLoaded = function (data) {
        var _this = this;
        var levelId = data.level;
        // only process level loaded events matching with expected level
        if (levelId !== this.currentLevelIndex) {
            return;
        }
        var curLevel = this._levels[levelId];
        // reset level load error counter on successful level loaded only if there is no issues with fragments
        if (!curLevel.fragmentError) {
            curLevel.loadError = 0;
            this.levelRetryCount = 0;
        }
        var newDetails = data.details;
        // if current playlist is a live playlist, arm a timer to reload it
        if (newDetails.live) {
            var targetdurationMs = 1000 * (newDetails.averagetargetduration ? newDetails.averagetargetduration : newDetails.targetduration);
            var reloadInterval = targetdurationMs, curDetails = curLevel.details;
            if (curDetails && newDetails.endSN === curDetails.endSN) {
                // follow HLS Spec, If the client reloads a Playlist file and finds that it has not
                // changed then it MUST wait for a period of one-half the target
                // duration before retrying.
                reloadInterval /= 2;
                logger_1.logger.log('same live playlist, reload twice faster');
            }
            // decrement reloadInterval with level loading delay
            reloadInterval -= performance.now() - data.stats.trequest;
            // in any case, don't reload more than half of target duration
            reloadInterval = Math.max(targetdurationMs / 2, Math.round(reloadInterval));
            logger_1.logger.log("live playlist, reload in " + Math.round(reloadInterval) + " ms");
            this.timer = setTimeout(function () { return _this.loadLevel(); }, reloadInterval);
        }
        else {
            this.clearTimer();
        }
    };
    LevelController.prototype.onAudioTrackSwitched = function (data) {
        var audioGroupId = this.hls.audioTracks[data.id].groupId;
        var currentLevel = this.hls.levels[this.currentLevelIndex];
        if (!currentLevel) {
            return;
        }
        if (currentLevel.audioGroupIds) {
            var urlId = currentLevel.audioGroupIds.findIndex(function (groupId) { return groupId === audioGroupId; });
            if (urlId !== currentLevel.urlId) {
                currentLevel.urlId = urlId;
                this.startLoad();
            }
        }
    };
    LevelController.prototype.loadLevel = function () {
        logger_1.logger.debug('call to loadLevel');
        if (this.currentLevelIndex !== null && this.canload) {
            var levelObject = this._levels[this.currentLevelIndex];
            if (typeof levelObject === 'object' &&
                levelObject.url.length > 0) {
                var level = this.currentLevelIndex;
                var id = levelObject.urlId;
                var url = levelObject.url[id];
                logger_1.logger.log("Attempt loading level index " + level + " with URL-id " + id);
                // console.log('Current audio track group ID:', this.hls.audioTracks[this.hls.audioTrack].groupId);
                // console.log('New video quality level audio group id:', levelObject.attrs.AUDIO, level);
                this.hls.trigger(events_1.default.LEVEL_LOADING, { url: url, level: level, id: id });
            }
        }
    };
    Object.defineProperty(LevelController.prototype, "nextLoadLevel", {
        get: function () {
            if (this.manualLevelIndex !== -1) {
                return this.manualLevelIndex;
            }
            else {
                return this.hls.nextAutoLevel;
            }
        },
        set: function (nextLevel) {
            this.level = nextLevel;
            if (this.manualLevelIndex === -1) {
                this.hls.nextAutoLevel = nextLevel;
            }
        },
        enumerable: true,
        configurable: true
    });
    return LevelController;
}(event_handler_1.default));
exports.default = LevelController;


/***/ }),

/***/ "./src/controller/level-helper.js":
/*!****************************************!*\
  !*** ./src/controller/level-helper.js ***!
  \****************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Number) {
/**
 * @module LevelHelper
 *
 * Providing methods dealing with playlist sliding and drift
 *
 * TODO: Create an actual `Level` class/model that deals with all this logic in an object-oriented-manner.
 *
 * */
Object.defineProperty(exports, "__esModule", { value: true });
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
function addGroupId(level, type, id) {
    switch (type) {
        case 'audio':
            if (!level.audioGroupIds) {
                level.audioGroupIds = [];
            }
            level.audioGroupIds.push(id);
            break;
        case 'text':
            if (!level.textGroupIds) {
                level.textGroupIds = [];
            }
            level.textGroupIds.push(id);
            break;
    }
}
exports.addGroupId = addGroupId;
function updatePTS(fragments, fromIdx, toIdx) {
    var fragFrom = fragments[fromIdx], fragTo = fragments[toIdx], fragToPTS = fragTo.startPTS;
    // if we know startPTS[toIdx]
    if (Number.isFinite(fragToPTS)) {
        // update fragment duration.
        // it helps to fix drifts between playlist reported duration and fragment real duration
        if (toIdx > fromIdx) {
            fragFrom.duration = fragToPTS - fragFrom.start;
            if (fragFrom.duration < 0) {
                logger_1.logger.warn("negative duration computed for frag " + fragFrom.sn + ",level " + fragFrom.level + ", there should be some duration drift between playlist and fragment!");
            }
        }
        else {
            fragTo.duration = fragFrom.start - fragToPTS;
            if (fragTo.duration < 0) {
                logger_1.logger.warn("negative duration computed for frag " + fragTo.sn + ",level " + fragTo.level + ", there should be some duration drift between playlist and fragment!");
            }
        }
    }
    else {
        // we dont know startPTS[toIdx]
        if (toIdx > fromIdx) {
            fragTo.start = fragFrom.start + fragFrom.duration;
        }
        else {
            fragTo.start = Math.max(fragFrom.start - fragTo.duration, 0);
        }
    }
}
exports.updatePTS = updatePTS;
function updateFragPTSDTS(details, frag, startPTS, endPTS, startDTS, endDTS) {
    // update frag PTS/DTS
    var maxStartPTS = startPTS;
    if (Number.isFinite(frag.startPTS)) {
        // delta PTS between audio and video
        var deltaPTS = Math.abs(frag.startPTS - startPTS);
        if (!Number.isFinite(frag.deltaPTS)) {
            frag.deltaPTS = deltaPTS;
        }
        else {
            frag.deltaPTS = Math.max(deltaPTS, frag.deltaPTS);
        }
        maxStartPTS = Math.max(startPTS, frag.startPTS);
        startPTS = Math.min(startPTS, frag.startPTS);
        endPTS = Math.max(endPTS, frag.endPTS);
        startDTS = Math.min(startDTS, frag.startDTS);
        endDTS = Math.max(endDTS, frag.endDTS);
    }
    var drift = startPTS - frag.start;
    frag.start = frag.startPTS = startPTS;
    frag.maxStartPTS = maxStartPTS;
    frag.endPTS = endPTS;
    frag.startDTS = startDTS;
    frag.endDTS = endDTS;
    frag.duration = endPTS - startPTS;
    var sn = frag.sn;
    // exit if sn out of range
    if (!details || sn < details.startSN || sn > details.endSN) {
        return 0;
    }
    var fragIdx, fragments, i;
    fragIdx = sn - details.startSN;
    fragments = details.fragments;
    // update frag reference in fragments array
    // rationale is that fragments array might not contain this frag object.
    // this will happen if playlist has been refreshed between frag loading and call to updateFragPTSDTS()
    // if we don't update frag, we won't be able to propagate PTS info on the playlist
    // resulting in invalid sliding computation
    fragments[fragIdx] = frag;
    // adjust fragment PTS/duration from seqnum-1 to frag 0
    for (i = fragIdx; i > 0; i--) {
        updatePTS(fragments, i, i - 1);
    }
    // adjust fragment PTS/duration from seqnum to last frag
    for (i = fragIdx; i < fragments.length - 1; i++) {
        updatePTS(fragments, i, i + 1);
    }
    details.PTSKnown = true;
    return drift;
}
exports.updateFragPTSDTS = updateFragPTSDTS;
function mergeDetails(oldDetails, newDetails) {
    var start = Math.max(oldDetails.startSN, newDetails.startSN) - newDetails.startSN, end = Math.min(oldDetails.endSN, newDetails.endSN) - newDetails.startSN, delta = newDetails.startSN - oldDetails.startSN, oldfragments = oldDetails.fragments, newfragments = newDetails.fragments, ccOffset = 0, PTSFrag;
    // potentially retrieve cached initsegment
    if (newDetails.initSegment && oldDetails.initSegment) {
        newDetails.initSegment = oldDetails.initSegment;
    }
    // check if old/new playlists have fragments in common
    if (end < start) {
        newDetails.PTSKnown = false;
        return;
    }
    // loop through overlapping SN and update startPTS , cc, and duration if any found
    for (var i = start; i <= end; i++) {
        var oldFrag = oldfragments[delta + i], newFrag = newfragments[i];
        if (newFrag && oldFrag) {
            ccOffset = oldFrag.cc - newFrag.cc;
            if (Number.isFinite(oldFrag.startPTS)) {
                newFrag.start = newFrag.startPTS = oldFrag.startPTS;
                newFrag.endPTS = oldFrag.endPTS;
                newFrag.duration = oldFrag.duration;
                newFrag.backtracked = oldFrag.backtracked;
                newFrag.dropped = oldFrag.dropped;
                PTSFrag = newFrag;
            }
        }
    }
    if (ccOffset) {
        logger_1.logger.log('discontinuity sliding from playlist, take drift into account');
        for (i = 0; i < newfragments.length; i++) {
            newfragments[i].cc += ccOffset;
        }
    }
    // if at least one fragment contains PTS info, recompute PTS information for all fragments
    if (PTSFrag) {
        updateFragPTSDTS(newDetails, PTSFrag, PTSFrag.startPTS, PTSFrag.endPTS, PTSFrag.startDTS, PTSFrag.endDTS);
    }
    else {
        // ensure that delta is within oldfragments range
        // also adjust sliding in case delta is 0 (we could have old=[50-60] and new=old=[50-61])
        // in that case we also need to adjust start offset of all fragments
        if (delta >= 0 && delta < oldfragments.length) {
            // adjust start by sliding offset
            var sliding = oldfragments[delta].start;
            for (i = 0; i < newfragments.length; i++) {
                newfragments[i].start += sliding;
            }
        }
    }
    // if we are here, it means we have fragments overlapping between
    // old and new level. reliable PTS info is thus relying on old level
    newDetails.PTSKnown = oldDetails.PTSKnown;
}
exports.mergeDetails = mergeDetails;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./src/polyfills/number */ "./src/polyfills/number.js")["Number"]))

/***/ }),

/***/ "./src/controller/stream-controller.js":
/*!*********************************************!*\
  !*** ./src/controller/stream-controller.js ***!
  \*********************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Number) {
/*
 * Stream Controller
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var binary_search_1 = __webpack_require__(/*! ../utils/binary-search */ "./src/utils/binary-search.js");
var buffer_helper_1 = __webpack_require__(/*! ../utils/buffer-helper */ "./src/utils/buffer-helper.js");
var demuxer_1 = __webpack_require__(/*! ../demux/demuxer */ "./src/demux/demuxer.js");
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var fragment_tracker_1 = __webpack_require__(/*! ./fragment-tracker */ "./src/controller/fragment-tracker.js");
var fragment_1 = __webpack_require__(/*! ../loader/fragment */ "./src/loader/fragment.js");
var playlist_loader_1 = __webpack_require__(/*! ../loader/playlist-loader */ "./src/loader/playlist-loader.js");
var LevelHelper = __webpack_require__(/*! ./level-helper */ "./src/controller/level-helper.js");
var time_ranges_1 = __webpack_require__(/*! ../utils/time-ranges */ "./src/utils/time-ranges.js");
var errors_1 = __webpack_require__(/*! ../errors */ "./src/errors.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var discontinuities_1 = __webpack_require__(/*! ../utils/discontinuities */ "./src/utils/discontinuities.js");
var fragment_finders_1 = __webpack_require__(/*! ./fragment-finders */ "./src/controller/fragment-finders.js");
var gap_controller_1 = __webpack_require__(/*! ./gap-controller */ "./src/controller/gap-controller.js");
var base_stream_controller_1 = __webpack_require__(/*! ./base-stream-controller */ "./src/controller/base-stream-controller.js");
var TICK_INTERVAL = 100; // how often to tick in ms
var StreamController = /** @class */ (function (_super) {
    __extends(StreamController, _super);
    function StreamController(hls, fragmentTracker) {
        var _this = _super.call(this, hls, events_1.default.MEDIA_ATTACHED, events_1.default.MEDIA_DETACHING, events_1.default.MANIFEST_LOADING, events_1.default.MANIFEST_PARSED, events_1.default.LEVEL_LOADED, events_1.default.KEY_LOADED, events_1.default.FRAG_LOADED, events_1.default.FRAG_LOAD_EMERGENCY_ABORTED, events_1.default.FRAG_PARSING_INIT_SEGMENT, events_1.default.FRAG_PARSING_DATA, events_1.default.FRAG_PARSED, events_1.default.ERROR, events_1.default.AUDIO_TRACK_SWITCHING, events_1.default.AUDIO_TRACK_SWITCHED, events_1.default.BUFFER_CREATED, events_1.default.BUFFER_APPENDED, events_1.default.BUFFER_FLUSHED) || this;
        _this.fragmentTracker = fragmentTracker;
        _this.config = hls.config;
        _this.audioCodecSwap = false;
        _this._state = base_stream_controller_1.State.STOPPED;
        _this.stallReported = false;
        _this.gapController = null;
        return _this;
    }
    StreamController.prototype.onHandlerDestroying = function () {
        this.stopLoad();
        _super.prototype.onHandlerDestroying.call(this);
    };
    StreamController.prototype.onHandlerDestroyed = function () {
        this.state = base_stream_controller_1.State.STOPPED;
        this.fragmentTracker = null;
        _super.prototype.onHandlerDestroyed.call(this);
    };
    StreamController.prototype.startLoad = function (startPosition) {
        if (this.levels) {
            var lastCurrentTime = this.lastCurrentTime, hls_1 = this.hls;
            this.stopLoad();
            this.setInterval(TICK_INTERVAL);
            this.level = -1;
            this.fragLoadError = 0;
            if (!this.startFragRequested) {
                // determine load level
                var startLevel = hls_1.startLevel;
                if (startLevel === -1) {
                    // -1 : guess start Level by doing a bitrate test by loading first fragment of lowest quality level
                    startLevel = 0;
                    this.bitrateTest = true;
                }
                // set new level to playlist loader : this will trigger start level load
                // hls.nextLoadLevel remains until it is set to a new value or until a new frag is successfully loaded
                this.level = hls_1.nextLoadLevel = startLevel;
                this.loadedmetadata = false;
            }
            // if startPosition undefined but lastCurrentTime set, set startPosition to last currentTime
            if (lastCurrentTime > 0 && startPosition === -1) {
                logger_1.logger.log("override startPosition with lastCurrentTime @" + lastCurrentTime.toFixed(3));
                startPosition = lastCurrentTime;
            }
            this.state = base_stream_controller_1.State.IDLE;
            this.nextLoadPosition = this.startPosition = this.lastCurrentTime = startPosition;
            this.tick();
        }
        else {
            this.forceStartLoad = true;
            this.state = base_stream_controller_1.State.STOPPED;
        }
    };
    StreamController.prototype.stopLoad = function () {
        var frag = this.fragCurrent;
        if (frag) {
            if (frag.loader) {
                frag.loader.abort();
            }
            this.fragmentTracker.removeFragment(frag);
            this.fragCurrent = null;
        }
        this.fragPrevious = null;
        if (this.demuxer) {
            this.demuxer.destroy();
            this.demuxer = null;
        }
        this.clearInterval();
        this.state = base_stream_controller_1.State.STOPPED;
        this.forceStartLoad = false;
    };
    StreamController.prototype.doTick = function () {
        switch (this.state) {
            case base_stream_controller_1.State.BUFFER_FLUSHING:
                // in buffer flushing state, reset fragLoadError counter
                this.fragLoadError = 0;
                break;
            case base_stream_controller_1.State.IDLE:
                this._doTickIdle();
                break;
            case base_stream_controller_1.State.WAITING_LEVEL:
                var level = this.levels[this.level];
                // check if playlist is already loaded
                if (level && level.details) {
                    this.state = base_stream_controller_1.State.IDLE;
                }
                break;
            case base_stream_controller_1.State.FRAG_LOADING_WAITING_RETRY:
                var now = window.performance.now();
                var retryDate = this.retryDate;
                // if current time is gt than retryDate, or if media seeking let's switch to IDLE state to retry loading
                if (!retryDate || (now >= retryDate) || (this.media && this.media.seeking)) {
                    logger_1.logger.log('mediaController: retryDate reached, switch back to IDLE state');
                    this.state = base_stream_controller_1.State.IDLE;
                }
                break;
            case base_stream_controller_1.State.ERROR:
            case base_stream_controller_1.State.STOPPED:
            case base_stream_controller_1.State.FRAG_LOADING:
            case base_stream_controller_1.State.PARSING:
            case base_stream_controller_1.State.PARSED:
            case base_stream_controller_1.State.ENDED:
                break;
            default:
                break;
        }
        // check buffer
        this._checkBuffer();
        // check/update current fragment
        this._checkFragmentChanged();
    };
    // Ironically the "idle" state is the on we do the most logic in it seems ....
    // NOTE: Maybe we could rather schedule a check for buffer length after half of the currently
    //       played segment, or on pause/play/seek instead of naively checking every 100ms?
    StreamController.prototype._doTickIdle = function () {
        var hls = this.hls, config = hls.config, media = this.media;
        // if start level not parsed yet OR
        // if video not attached AND start fragment already requested OR start frag prefetch disable
        // exit loop, as we either need more info (level not parsed) or we need media to be attached to load new fragment
        if (this.levelLastLoaded === undefined || (!media && (this.startFragRequested || !config.startFragPrefetch))) {
            return;
        }
        // if we have not yet loaded any fragment, start loading from start position
        var pos;
        if (this.loadedmetadata) {
            pos = media.currentTime;
        }
        else {
            pos = this.nextLoadPosition;
        }
        // determine next load level
        var level = hls.nextLoadLevel, levelInfo = this.levels[level];
        if (!levelInfo) {
            return;
        }
        var levelBitrate = levelInfo.bitrate, maxBufLen;
        // compute max Buffer Length that we could get from this load level, based on level bitrate. don't buffer more than 60 MB and more than 30s
        if (levelBitrate) {
            maxBufLen = Math.max(8 * config.maxBufferSize / levelBitrate, config.maxBufferLength);
        }
        else {
            maxBufLen = config.maxBufferLength;
        }
        maxBufLen = Math.min(maxBufLen, config.maxMaxBufferLength);
        // determine next candidate fragment to be loaded, based on current position and end of buffer position
        // ensure up to `config.maxMaxBufferLength` of buffer upfront
        var bufferInfo = buffer_helper_1.BufferHelper.bufferInfo(this.mediaBuffer ? this.mediaBuffer : media, pos, config.maxBufferHole), bufferLen = bufferInfo.len;
        // Stay idle if we are still with buffer margins
        if (bufferLen >= maxBufLen) {
            return;
        }
        // if buffer length is less than maxBufLen try to load a new fragment ...
        logger_1.logger.trace("buffer length of " + bufferLen.toFixed(3) + " is below max of " + maxBufLen.toFixed(3) + ". checking for more payload ...");
        // set next load level : this will trigger a playlist load if needed
        this.level = hls.nextLoadLevel = level;
        var levelDetails = levelInfo.details;
        // if level info not retrieved yet, switch state and wait for level retrieval
        // if live playlist, ensure that new playlist has been refreshed to avoid loading/try to load
        // a useless and outdated fragment (that might even introduce load error if it is already out of the live playlist)
        if (!levelDetails || (levelDetails.live && this.levelLastLoaded !== level)) {
            this.state = base_stream_controller_1.State.WAITING_LEVEL;
            return;
        }
        if (this._streamEnded(bufferInfo, levelDetails)) {
            var data = {};
            if (this.altAudio) {
                data.type = 'video';
            }
            this.hls.trigger(events_1.default.BUFFER_EOS, data);
            this.state = base_stream_controller_1.State.ENDED;
            return;
        }
        // if we have the levelDetails for the selected variant, lets continue enrichen our stream (load keys/fragments or trigger EOS, etc..)
        this._fetchPayloadOrEos(pos, bufferInfo, levelDetails);
    };
    StreamController.prototype._fetchPayloadOrEos = function (pos, bufferInfo, levelDetails) {
        var fragPrevious = this.fragPrevious, level = this.level, fragments = levelDetails.fragments, fragLen = fragments.length;
        // empty playlist
        if (fragLen === 0) {
            return;
        }
        // find fragment index, contiguous with end of buffer position
        var start = fragments[0].start, end = fragments[fragLen - 1].start + fragments[fragLen - 1].duration, bufferEnd = bufferInfo.end, frag;
        if (levelDetails.initSegment && !levelDetails.initSegment.data) {
            frag = levelDetails.initSegment;
        }
        else {
            // in case of live playlist we need to ensure that requested position is not located before playlist start
            if (levelDetails.live) {
                var initialLiveManifestSize = this.config.initialLiveManifestSize;
                if (fragLen < initialLiveManifestSize) {
                    logger_1.logger.warn("Can not start playback of a level, reason: not enough fragments " + fragLen + " < " + initialLiveManifestSize);
                    return;
                }
                frag = this._ensureFragmentAtLivePoint(levelDetails, bufferEnd, start, end, fragPrevious, fragments, fragLen);
                // if it explicitely returns null don't load any fragment and exit function now
                if (frag === null) {
                    return;
                }
            }
            else {
                // VoD playlist: if bufferEnd before start of playlist, load first fragment
                if (bufferEnd < start) {
                    frag = fragments[0];
                }
            }
        }
        if (!frag) {
            frag = this._findFragment(start, fragPrevious, fragLen, fragments, bufferEnd, end, levelDetails);
        }
        if (frag) {
            if (frag.encrypted) {
                logger_1.logger.log("Loading key for " + frag.sn + " of [" + levelDetails.startSN + " ," + levelDetails.endSN + "],level " + level);
                this._loadKey(frag);
            }
            else {
                logger_1.logger.log("Loading " + frag.sn + " of [" + levelDetails.startSN + " ," + levelDetails.endSN + "],level " + level + ", currentTime:" + pos.toFixed(3) + ",bufferEnd:" + bufferEnd.toFixed(3));
                this._loadFragment(frag);
            }
        }
    };
    StreamController.prototype._ensureFragmentAtLivePoint = function (levelDetails, bufferEnd, start, end, fragPrevious, fragments, fragLen) {
        var config = this.hls.config, media = this.media;
        var frag;
        // check if requested position is within seekable boundaries :
        // logger.log(`start/pos/bufEnd/seeking:${start.toFixed(3)}/${pos.toFixed(3)}/${bufferEnd.toFixed(3)}/${this.media.seeking}`);
        var maxLatency = config.liveMaxLatencyDuration !== undefined ? config.liveMaxLatencyDuration : config.liveMaxLatencyDurationCount * levelDetails.targetduration;
        if (bufferEnd < Math.max(start - config.maxFragLookUpTolerance, end - maxLatency)) {
            var liveSyncPosition = this.liveSyncPosition = this.computeLivePosition(start, levelDetails);
            logger_1.logger.log("buffer end: " + bufferEnd.toFixed(3) + " is located too far from the end of live sliding playlist, reset currentTime to : " + liveSyncPosition.toFixed(3));
            bufferEnd = liveSyncPosition;
            if (media && media.readyState && media.duration > liveSyncPosition) {
                media.currentTime = liveSyncPosition;
            }
            this.nextLoadPosition = liveSyncPosition;
        }
        // if end of buffer greater than live edge, don't load any fragment
        // this could happen if live playlist intermittently slides in the past.
        // level 1 loaded [182580161,182580167]
        // level 1 loaded [182580162,182580169]
        // Loading 182580168 of [182580162 ,182580169],level 1 ..
        // Loading 182580169 of [182580162 ,182580169],level 1 ..
        // level 1 loaded [182580162,182580168] <============= here we should have bufferEnd > end. in that case break to avoid reloading 182580168
        // level 1 loaded [182580164,182580171]
        //
        // don't return null in case media not loaded yet (readystate === 0)
        if (levelDetails.PTSKnown && bufferEnd > end && media && media.readyState) {
            return null;
        }
        if (this.startFragRequested && !levelDetails.PTSKnown) {
            /* we are switching level on live playlist, but we don't have any PTS info for that quality level ...
               try to load frag matching with next SN.
               even if SN are not synchronized between playlists, loading this frag will help us
               compute playlist sliding and find the right one after in case it was not the right consecutive one */
            if (fragPrevious) {
                if (levelDetails.hasProgramDateTime) {
                    // Relies on PDT in order to switch bitrates (Support EXT-X-DISCONTINUITY without EXT-X-DISCONTINUITY-SEQUENCE)
                    logger_1.logger.log("live playlist, switching playlist, load frag with same PDT: " + fragPrevious.programDateTime);
                    frag = fragment_finders_1.findFragmentByPDT(fragments, fragPrevious.endProgramDateTime, config.maxFragLookUpTolerance);
                }
                else {
                    // Uses buffer and sequence number to calculate switch segment (required if using EXT-X-DISCONTINUITY-SEQUENCE)
                    var targetSN = fragPrevious.sn + 1;
                    if (targetSN >= levelDetails.startSN && targetSN <= levelDetails.endSN) {
                        var fragNext = fragments[targetSN - levelDetails.startSN];
                        if (fragPrevious.cc === fragNext.cc) {
                            frag = fragNext;
                            logger_1.logger.log("live playlist, switching playlist, load frag with next SN: " + frag.sn);
                        }
                    }
                    // next frag SN not available (or not with same continuity counter)
                    // look for a frag sharing the same CC
                    if (!frag) {
                        frag = binary_search_1.default.search(fragments, function (frag) {
                            return fragPrevious.cc - frag.cc;
                        });
                        if (frag) {
                            logger_1.logger.log("live playlist, switching playlist, load frag with same CC: " + frag.sn);
                        }
                    }
                }
            }
            if (!frag) {
                /* we have no idea about which fragment should be loaded.
                   so let's load mid fragment. it will help computing playlist sliding and find the right one
                */
                frag = fragments[Math.min(fragLen - 1, Math.round(fragLen / 2))];
                logger_1.logger.log("live playlist, switching playlist, unknown, load middle frag : " + frag.sn);
            }
        }
        return frag;
    };
    StreamController.prototype._findFragment = function (start, fragPrevious, fragLen, fragments, bufferEnd, end, levelDetails) {
        var config = this.hls.config;
        var frag;
        if (bufferEnd < end) {
            var lookupTolerance = (bufferEnd > end - config.maxFragLookUpTolerance) ? 0 : config.maxFragLookUpTolerance;
            // Remove the tolerance if it would put the bufferEnd past the actual end of stream
            // Uses buffer and sequence number to calculate switch segment (required if using EXT-X-DISCONTINUITY-SEQUENCE)
            frag = fragment_finders_1.findFragmentByPTS(fragPrevious, fragments, bufferEnd, lookupTolerance);
        }
        else {
            // reach end of playlist
            frag = fragments[fragLen - 1];
        }
        if (frag) {
            var curSNIdx = frag.sn - levelDetails.startSN;
            var sameLevel = fragPrevious && frag.level === fragPrevious.level;
            var prevFrag = fragments[curSNIdx - 1];
            var nextFrag = fragments[curSNIdx + 1];
            // logger.log('find SN matching with pos:' +  bufferEnd + ':' + frag.sn);
            if (fragPrevious && frag.sn === fragPrevious.sn) {
                if (sameLevel && !frag.backtracked) {
                    if (frag.sn < levelDetails.endSN) {
                        var deltaPTS = fragPrevious.deltaPTS;
                        // if there is a significant delta between audio and video, larger than max allowed hole,
                        // and if previous remuxed fragment did not start with a keyframe. (fragPrevious.dropped)
                        // let's try to load previous fragment again to get last keyframe
                        // then we will reload again current fragment (that way we should be able to fill the buffer hole ...)
                        if (deltaPTS && deltaPTS > config.maxBufferHole && fragPrevious.dropped && curSNIdx) {
                            frag = prevFrag;
                            logger_1.logger.warn('SN just loaded, with large PTS gap between audio and video, maybe frag is not starting with a keyframe ? load previous one to try to overcome this');
                        }
                        else {
                            frag = nextFrag;
                            logger_1.logger.log("SN just loaded, load next one: " + frag.sn, frag);
                        }
                    }
                    else {
                        frag = null;
                    }
                }
                else if (frag.backtracked) {
                    // Only backtrack a max of 1 consecutive fragment to prevent sliding back too far when little or no frags start with keyframes
                    if (nextFrag && nextFrag.backtracked) {
                        logger_1.logger.warn("Already backtracked from fragment " + nextFrag.sn + ", will not backtrack to fragment " + frag.sn + ". Loading fragment " + nextFrag.sn);
                        frag = nextFrag;
                    }
                    else {
                        // If a fragment has dropped frames and it's in a same level/sequence, load the previous fragment to try and find the keyframe
                        // Reset the dropped count now since it won't be reset until we parse the fragment again, which prevents infinite backtracking on the same segment
                        logger_1.logger.warn('Loaded fragment with dropped frames, backtracking 1 segment to find a keyframe');
                        frag.dropped = 0;
                        if (prevFrag) {
                            frag = prevFrag;
                            frag.backtracked = true;
                        }
                        else if (curSNIdx) {
                            // can't backtrack on very first fragment
                            frag = null;
                        }
                    }
                }
            }
        }
        return frag;
    };
    StreamController.prototype._loadKey = function (frag) {
        this.state = base_stream_controller_1.State.KEY_LOADING;
        this.hls.trigger(events_1.default.KEY_LOADING, { frag: frag });
    };
    StreamController.prototype._loadFragment = function (frag) {
        // Check if fragment is not loaded
        var fragState = this.fragmentTracker.getState(frag);
        this.fragCurrent = frag;
        this.startFragRequested = true;
        // Don't update nextLoadPosition for fragments which are not buffered
        if (Number.isFinite(frag.sn) && !frag.bitrateTest) {
            this.nextLoadPosition = frag.start + frag.duration;
        }
        // Allow backtracked fragments to load
        if (frag.backtracked || fragState === fragment_tracker_1.FragmentState.NOT_LOADED || fragState === fragment_tracker_1.FragmentState.PARTIAL) {
            frag.autoLevel = this.hls.autoLevelEnabled;
            frag.bitrateTest = this.bitrateTest;
            this.hls.trigger(events_1.default.FRAG_LOADING, { frag: frag });
            // lazy demuxer init, as this could take some time ... do it during frag loading
            if (!this.demuxer) {
                this.demuxer = new demuxer_1.default(this.hls, 'main');
            }
            this.state = base_stream_controller_1.State.FRAG_LOADING;
        }
        else if (fragState === fragment_tracker_1.FragmentState.APPENDING) {
            // Lower the buffer size and try again
            if (this._reduceMaxBufferLength(frag.duration)) {
                this.fragmentTracker.removeFragment(frag);
            }
        }
    };
    Object.defineProperty(StreamController.prototype, "state", {
        get: function () {
            return this._state;
        },
        set: function (nextState) {
            if (this.state !== nextState) {
                var previousState = this.state;
                this._state = nextState;
                logger_1.logger.log("main stream:" + previousState + "->" + nextState);
                this.hls.trigger(events_1.default.STREAM_STATE_TRANSITION, { previousState: previousState, nextState: nextState });
            }
        },
        enumerable: true,
        configurable: true
    });
    StreamController.prototype.getBufferedFrag = function (position) {
        return this.fragmentTracker.getBufferedFrag(position, playlist_loader_1.default.LevelType.MAIN);
    };
    Object.defineProperty(StreamController.prototype, "currentLevel", {
        get: function () {
            var media = this.media;
            if (media) {
                var frag = this.getBufferedFrag(media.currentTime);
                if (frag) {
                    return frag.level;
                }
            }
            return -1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StreamController.prototype, "nextBufferedFrag", {
        get: function () {
            var media = this.media;
            if (media) {
                // first get end range of current fragment
                return this.followingBufferedFrag(this.getBufferedFrag(media.currentTime));
            }
            else {
                return null;
            }
        },
        enumerable: true,
        configurable: true
    });
    StreamController.prototype.followingBufferedFrag = function (frag) {
        if (frag) {
            // try to get range of next fragment (500ms after this range)
            return this.getBufferedFrag(frag.endPTS + 0.5);
        }
        return null;
    };
    Object.defineProperty(StreamController.prototype, "nextLevel", {
        get: function () {
            var frag = this.nextBufferedFrag;
            if (frag) {
                return frag.level;
            }
            else {
                return -1;
            }
        },
        enumerable: true,
        configurable: true
    });
    StreamController.prototype._checkFragmentChanged = function () {
        var fragPlayingCurrent, currentTime, video = this.media;
        if (video && video.readyState && video.seeking === false) {
            currentTime = video.currentTime;
            /* if video element is in seeked state, currentTime can only increase.
              (assuming that playback rate is positive ...)
              As sometimes currentTime jumps back to zero after a
              media decode error, check this, to avoid seeking back to
              wrong position after a media decode error
            */
            if (currentTime > this.lastCurrentTime) {
                this.lastCurrentTime = currentTime;
            }
            if (buffer_helper_1.BufferHelper.isBuffered(video, currentTime)) {
                fragPlayingCurrent = this.getBufferedFrag(currentTime);
            }
            else if (buffer_helper_1.BufferHelper.isBuffered(video, currentTime + 0.1)) {
                /* ensure that FRAG_CHANGED event is triggered at startup,
                  when first video frame is displayed and playback is paused.
                  add a tolerance of 100ms, in case current position is not buffered,
                  check if current pos+100ms is buffered and use that buffer range
                  for FRAG_CHANGED event reporting */
                fragPlayingCurrent = this.getBufferedFrag(currentTime + 0.1);
            }
            if (fragPlayingCurrent) {
                var fragPlaying = fragPlayingCurrent;
                if (fragPlaying !== this.fragPlaying) {
                    this.hls.trigger(events_1.default.FRAG_CHANGED, { frag: fragPlaying });
                    var fragPlayingLevel = fragPlaying.level;
                    if (!this.fragPlaying || this.fragPlaying.level !== fragPlayingLevel) {
                        this.hls.trigger(events_1.default.LEVEL_SWITCHED, { level: fragPlayingLevel });
                    }
                    this.fragPlaying = fragPlaying;
                }
            }
        }
    };
    /*
      on immediate level switch :
       - pause playback if playing
       - cancel any pending load request
       - and trigger a buffer flush
    */
    StreamController.prototype.immediateLevelSwitch = function () {
        logger_1.logger.log('immediateLevelSwitch');
        if (!this.immediateSwitch) {
            this.immediateSwitch = true;
            var media = this.media, previouslyPaused = void 0;
            if (media) {
                previouslyPaused = media.paused;
                media.pause();
            }
            else {
                // don't restart playback after instant level switch in case media not attached
                previouslyPaused = true;
            }
            this.previouslyPaused = previouslyPaused;
        }
        var fragCurrent = this.fragCurrent;
        if (fragCurrent && fragCurrent.loader) {
            fragCurrent.loader.abort();
        }
        this.fragCurrent = null;
        // flush everything
        this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
    };
    /**
     * on immediate level switch end, after new fragment has been buffered:
     * - nudge video decoder by slightly adjusting video currentTime (if currentTime buffered)
     * - resume the playback if needed
     */
    StreamController.prototype.immediateLevelSwitchEnd = function () {
        var media = this.media;
        if (media && media.buffered.length) {
            this.immediateSwitch = false;
            if (buffer_helper_1.BufferHelper.isBuffered(media, media.currentTime)) {
                // only nudge if currentTime is buffered
                media.currentTime -= 0.0001;
            }
            if (!this.previouslyPaused) {
                media.play();
            }
        }
    };
    /**
     * try to switch ASAP without breaking video playback:
     * in order to ensure smooth but quick level switching,
     * we need to find the next flushable buffer range
     * we should take into account new segment fetch time
     */
    StreamController.prototype.nextLevelSwitch = function () {
        var media = this.media;
        // ensure that media is defined and that metadata are available (to retrieve currentTime)
        if (media && media.readyState) {
            var fetchdelay = void 0, fragPlayingCurrent = void 0, nextBufferedFrag = void 0;
            fragPlayingCurrent = this.getBufferedFrag(media.currentTime);
            if (fragPlayingCurrent && fragPlayingCurrent.startPTS > 1) {
                // flush buffer preceding current fragment (flush until current fragment start offset)
                // minus 1s to avoid video freezing, that could happen if we flush keyframe of current video ...
                this.flushMainBuffer(0, fragPlayingCurrent.startPTS - 1);
            }
            if (!media.paused) {
                // add a safety delay of 1s
                var nextLevelId = this.hls.nextLoadLevel, nextLevel = this.levels[nextLevelId], fragLastKbps = this.fragLastKbps;
                if (fragLastKbps && this.fragCurrent) {
                    fetchdelay = this.fragCurrent.duration * nextLevel.bitrate / (1000 * fragLastKbps) + 1;
                }
                else {
                    fetchdelay = 0;
                }
            }
            else {
                fetchdelay = 0;
            }
            // logger.log('fetchdelay:'+fetchdelay);
            // find buffer range that will be reached once new fragment will be fetched
            nextBufferedFrag = this.getBufferedFrag(media.currentTime + fetchdelay);
            if (nextBufferedFrag) {
                // we can flush buffer range following this one without stalling playback
                nextBufferedFrag = this.followingBufferedFrag(nextBufferedFrag);
                if (nextBufferedFrag) {
                    // if we are here, we can also cancel any loading/demuxing in progress, as they are useless
                    var fragCurrent = this.fragCurrent;
                    if (fragCurrent && fragCurrent.loader) {
                        fragCurrent.loader.abort();
                    }
                    this.fragCurrent = null;
                    // start flush position is the start PTS of next buffered frag.
                    // we use frag.naxStartPTS which is max(audio startPTS, video startPTS).
                    // in case there is a small PTS Delta between audio and video, using maxStartPTS avoids flushing last samples from current fragment
                    this.flushMainBuffer(nextBufferedFrag.maxStartPTS, Number.POSITIVE_INFINITY);
                }
            }
        }
    };
    StreamController.prototype.flushMainBuffer = function (startOffset, endOffset) {
        this.state = base_stream_controller_1.State.BUFFER_FLUSHING;
        var flushScope = { startOffset: startOffset, endOffset: endOffset };
        // if alternate audio tracks are used, only flush video, otherwise flush everything
        if (this.altAudio) {
            flushScope.type = 'video';
        }
        this.hls.trigger(events_1.default.BUFFER_FLUSHING, flushScope);
    };
    StreamController.prototype.onMediaAttached = function (data) {
        var media = this.media = this.mediaBuffer = data.media;
        this.onvseeking = this.onMediaSeeking.bind(this);
        this.onvseeked = this.onMediaSeeked.bind(this);
        this.onvended = this.onMediaEnded.bind(this);
        media.addEventListener('seeking', this.onvseeking);
        media.addEventListener('seeked', this.onvseeked);
        media.addEventListener('ended', this.onvended);
        var config = this.config;
        if (this.levels && config.autoStartLoad) {
            this.hls.startLoad(config.startPosition);
        }
        this.gapController = new gap_controller_1.default(config, media, this.fragmentTracker, this.hls);
    };
    StreamController.prototype.onMediaDetaching = function () {
        var media = this.media;
        if (media && media.ended) {
            logger_1.logger.log('MSE detaching and video ended, reset startPosition');
            this.startPosition = this.lastCurrentTime = 0;
        }
        // reset fragment backtracked flag
        var levels = this.levels;
        if (levels) {
            levels.forEach(function (level) {
                if (level.details) {
                    level.details.fragments.forEach(function (fragment) {
                        fragment.backtracked = undefined;
                    });
                }
            });
        }
        // remove video listeners
        if (media) {
            media.removeEventListener('seeking', this.onvseeking);
            media.removeEventListener('seeked', this.onvseeked);
            media.removeEventListener('ended', this.onvended);
            this.onvseeking = this.onvseeked = this.onvended = null;
        }
        this.media = this.mediaBuffer = null;
        this.loadedmetadata = false;
        this.stopLoad();
    };
    StreamController.prototype.onMediaSeeked = function () {
        var media = this.media, currentTime = media ? media.currentTime : undefined;
        if (Number.isFinite(currentTime)) {
            logger_1.logger.log("media seeked to " + currentTime.toFixed(3));
        }
        // tick to speed up FRAGMENT_PLAYING triggering
        this.tick();
    };
    StreamController.prototype.onManifestLoading = function () {
        // reset buffer on manifest loading
        logger_1.logger.log('trigger BUFFER_RESET');
        this.hls.trigger(events_1.default.BUFFER_RESET);
        this.fragmentTracker.removeAllFragments();
        this.stalled = false;
        this.startPosition = this.lastCurrentTime = 0;
    };
    StreamController.prototype.onManifestParsed = function (data) {
        var aac = false, heaac = false, codec;
        data.levels.forEach(function (level) {
            // detect if we have different kind of audio codecs used amongst playlists
            codec = level.audioCodec;
            if (codec) {
                if (codec.indexOf('mp4a.40.2') !== -1) {
                    aac = true;
                }
                if (codec.indexOf('mp4a.40.5') !== -1) {
                    heaac = true;
                }
            }
        });
        this.audioCodecSwitch = (aac && heaac);
        if (this.audioCodecSwitch) {
            logger_1.logger.log('both AAC/HE-AAC audio found in levels; declaring level codec as HE-AAC');
        }
        this.levels = data.levels;
        this.startFragRequested = false;
        var config = this.config;
        if (config.autoStartLoad || this.forceStartLoad) {
            this.hls.startLoad(config.startPosition);
        }
    };
    StreamController.prototype.onLevelLoaded = function (data) {
        var newDetails = data.details;
        var newLevelId = data.level;
        var lastLevel = this.levels[this.levelLastLoaded];
        var curLevel = this.levels[newLevelId];
        var duration = newDetails.totalduration;
        var sliding = 0;
        logger_1.logger.log("level " + newLevelId + " loaded [" + newDetails.startSN + "," + newDetails.endSN + "],duration:" + duration);
        if (newDetails.live) {
            var curDetails = curLevel.details;
            if (curDetails && newDetails.fragments.length > 0) {
                // we already have details for that level, merge them
                LevelHelper.mergeDetails(curDetails, newDetails);
                sliding = newDetails.fragments[0].start;
                this.liveSyncPosition = this.computeLivePosition(sliding, curDetails);
                if (newDetails.PTSKnown && Number.isFinite(sliding)) {
                    logger_1.logger.log("live playlist sliding:" + sliding.toFixed(3));
                }
                else {
                    logger_1.logger.log('live playlist - outdated PTS, unknown sliding');
                    discontinuities_1.alignStream(this.fragPrevious, lastLevel, newDetails);
                }
            }
            else {
                logger_1.logger.log('live playlist - first load, unknown sliding');
                newDetails.PTSKnown = false;
                discontinuities_1.alignStream(this.fragPrevious, lastLevel, newDetails);
            }
        }
        else {
            newDetails.PTSKnown = false;
        }
        // override level info
        curLevel.details = newDetails;
        this.levelLastLoaded = newLevelId;
        this.hls.trigger(events_1.default.LEVEL_UPDATED, { details: newDetails, level: newLevelId });
        if (this.startFragRequested === false) {
            // compute start position if set to -1. use it straight away if value is defined
            if (this.startPosition === -1 || this.lastCurrentTime === -1) {
                // first, check if start time offset has been set in playlist, if yes, use this value
                var startTimeOffset = newDetails.startTimeOffset;
                if (Number.isFinite(startTimeOffset)) {
                    if (startTimeOffset < 0) {
                        logger_1.logger.log("negative start time offset " + startTimeOffset + ", count from end of last fragment");
                        startTimeOffset = sliding + duration + startTimeOffset;
                    }
                    logger_1.logger.log("start time offset found in playlist, adjust startPosition to " + startTimeOffset);
                    this.startPosition = startTimeOffset;
                }
                else {
                    // if live playlist, set start position to be fragment N-this.config.liveSyncDurationCount (usually 3)
                    if (newDetails.live) {
                        this.startPosition = this.computeLivePosition(sliding, newDetails);
                        logger_1.logger.log("configure startPosition to " + this.startPosition);
                    }
                    else {
                        this.startPosition = 0;
                    }
                }
                this.lastCurrentTime = this.startPosition;
            }
            this.nextLoadPosition = this.startPosition;
        }
        // only switch batck to IDLE state if we were waiting for level to start downloading a new fragment
        if (this.state === base_stream_controller_1.State.WAITING_LEVEL) {
            this.state = base_stream_controller_1.State.IDLE;
        }
        // trigger handler right now
        this.tick();
    };
    StreamController.prototype.onKeyLoaded = function () {
        if (this.state === base_stream_controller_1.State.KEY_LOADING) {
            this.state = base_stream_controller_1.State.IDLE;
            this.tick();
        }
    };
    StreamController.prototype.onFragLoaded = function (data) {
        var _a = this, fragCurrent = _a.fragCurrent, hls = _a.hls, levels = _a.levels, media = _a.media;
        var fragLoaded = data.frag;
        if (this.state === base_stream_controller_1.State.FRAG_LOADING &&
            fragCurrent &&
            fragLoaded.type === 'main' &&
            fragLoaded.level === fragCurrent.level &&
            fragLoaded.sn === fragCurrent.sn) {
            var stats = data.stats;
            var currentLevel = levels[fragCurrent.level];
            var details = currentLevel.details;
            // reset frag bitrate test in any case after frag loaded event
            // if this frag was loaded to perform a bitrate test AND if hls.nextLoadLevel is greater than 0
            // then this means that we should be able to load a fragment at a higher quality level
            this.bitrateTest = false;
            this.stats = stats;
            logger_1.logger.log("Loaded " + fragCurrent.sn + " of [" + details.startSN + " ," + details.endSN + "],level " + fragCurrent.level);
            if (fragLoaded.bitrateTest && hls.nextLoadLevel) {
                // switch back to IDLE state ... we just loaded a fragment to determine adequate start bitrate and initialize autoswitch algo
                this.state = base_stream_controller_1.State.IDLE;
                this.startFragRequested = false;
                stats.tparsed = stats.tbuffered = window.performance.now();
                hls.trigger(events_1.default.FRAG_BUFFERED, { stats: stats, frag: fragCurrent, id: 'main' });
                this.tick();
            }
            else if (fragLoaded.sn === 'initSegment') {
                this.state = base_stream_controller_1.State.IDLE;
                stats.tparsed = stats.tbuffered = window.performance.now();
                details.initSegment.data = data.payload;
                hls.trigger(events_1.default.FRAG_BUFFERED, { stats: stats, frag: fragCurrent, id: 'main' });
                this.tick();
            }
            else {
                logger_1.logger.log("Parsing " + fragCurrent.sn + " of [" + details.startSN + " ," + details.endSN + "],level " + fragCurrent.level + ", cc " + fragCurrent.cc);
                this.state = base_stream_controller_1.State.PARSING;
                this.pendingBuffering = true;
                this.appended = false;
                // Bitrate test frags are not usually buffered so the fragment tracker ignores them. If Hls.js decides to buffer
                // it (and therefore ends up at this line), then the fragment tracker needs to be manually informed.
                if (fragLoaded.bitrateTest) {
                    fragLoaded.bitrateTest = false;
                    this.fragmentTracker.onFragLoaded({
                        frag: fragLoaded
                    });
                }
                // time Offset is accurate if level PTS is known, or if playlist is not sliding (not live) and if media is not seeking (this is to overcome potential timestamp drifts between playlists and fragments)
                var accurateTimeOffset = !(media && media.seeking) && (details.PTSKnown || !details.live);
                var initSegmentData = details.initSegment ? details.initSegment.data : [];
                var audioCodec = this._getAudioCodec(currentLevel);
                // transmux the MPEG-TS data to ISO-BMFF segments
                var demuxer = this.demuxer = this.demuxer || new demuxer_1.default(this.hls, 'main');
                demuxer.push(data.payload, initSegmentData, audioCodec, currentLevel.videoCodec, fragCurrent, details.totalduration, accurateTimeOffset);
            }
        }
        this.fragLoadError = 0;
    };
    StreamController.prototype.onFragParsingInitSegment = function (data) {
        var fragCurrent = this.fragCurrent;
        var fragNew = data.frag;
        if (fragCurrent &&
            data.id === 'main' &&
            fragNew.sn === fragCurrent.sn &&
            fragNew.level === fragCurrent.level &&
            this.state === base_stream_controller_1.State.PARSING) {
            var tracks = data.tracks, trackName = void 0, track = void 0;
            // if audio track is expected to come from audio stream controller, discard any coming from main
            if (tracks.audio && this.altAudio) {
                delete tracks.audio;
            }
            // include levelCodec in audio and video tracks
            track = tracks.audio;
            if (track) {
                var audioCodec = this.levels[this.level].audioCodec, ua = navigator.userAgent.toLowerCase();
                if (audioCodec && this.audioCodecSwap) {
                    logger_1.logger.log('swapping playlist audio codec');
                    if (audioCodec.indexOf('mp4a.40.5') !== -1) {
                        audioCodec = 'mp4a.40.2';
                    }
                    else {
                        audioCodec = 'mp4a.40.5';
                    }
                }
                // in case AAC and HE-AAC audio codecs are signalled in manifest
                // force HE-AAC , as it seems that most browsers prefers that way,
                // except for mono streams OR on FF
                // these conditions might need to be reviewed ...
                if (this.audioCodecSwitch) {
                    // don't force HE-AAC if mono stream
                    if (track.metadata.channelCount !== 1 &&
                        // don't force HE-AAC if firefox
                        ua.indexOf('firefox') === -1) {
                        audioCodec = 'mp4a.40.5';
                    }
                }
                // HE-AAC is broken on Android, always signal audio codec as AAC even if variant manifest states otherwise
                if (ua.indexOf('android') !== -1 && track.container !== 'audio/mpeg') { // Exclude mpeg audio
                    audioCodec = 'mp4a.40.2';
                    logger_1.logger.log("Android: force audio codec to " + audioCodec);
                }
                track.levelCodec = audioCodec;
                track.id = data.id;
            }
            track = tracks.video;
            if (track) {
                track.levelCodec = this.levels[this.level].videoCodec;
                track.id = data.id;
            }
            this.hls.trigger(events_1.default.BUFFER_CODECS, tracks);
            // loop through tracks that are going to be provided to bufferController
            for (trackName in tracks) {
                track = tracks[trackName];
                logger_1.logger.log("main track:" + trackName + ",container:" + track.container + ",codecs[level/parsed]=[" + track.levelCodec + "/" + track.codec + "]");
                var initSegment = track.initSegment;
                if (initSegment) {
                    this.appended = true;
                    // arm pending Buffering flag before appending a segment
                    this.pendingBuffering = true;
                    this.hls.trigger(events_1.default.BUFFER_APPENDING, { type: trackName, data: initSegment, parent: 'main', content: 'initSegment' });
                }
            }
            // trigger handler right now
            this.tick();
        }
    };
    StreamController.prototype.onFragParsingData = function (data) {
        var _this = this;
        var fragCurrent = this.fragCurrent;
        var fragNew = data.frag;
        if (fragCurrent &&
            data.id === 'main' &&
            fragNew.sn === fragCurrent.sn &&
            fragNew.level === fragCurrent.level &&
            !(data.type === 'audio' && this.altAudio) && // filter out main audio if audio track is loaded through audio stream controller
            this.state === base_stream_controller_1.State.PARSING) {
            var level = this.levels[this.level], frag = fragCurrent;
            if (!Number.isFinite(data.endPTS)) {
                data.endPTS = data.startPTS + fragCurrent.duration;
                data.endDTS = data.startDTS + fragCurrent.duration;
            }
            if (data.hasAudio === true) {
                frag.addElementaryStream(fragment_1.default.ElementaryStreamTypes.AUDIO);
            }
            if (data.hasVideo === true) {
                frag.addElementaryStream(fragment_1.default.ElementaryStreamTypes.VIDEO);
            }
            logger_1.logger.log("Parsed " + data.type + ",PTS:[" + data.startPTS.toFixed(3) + "," + data.endPTS.toFixed(3) + "],DTS:[" + data.startDTS.toFixed(3) + "/" + data.endDTS.toFixed(3) + "],nb:" + data.nb + ",dropped:" + (data.dropped || 0));
            // Detect gaps in a fragment  and try to fix it by finding a keyframe in the previous fragment (see _findFragments)
            if (data.type === 'video') {
                frag.dropped = data.dropped;
                if (frag.dropped) {
                    if (!frag.backtracked) {
                        var levelDetails = level.details;
                        if (levelDetails && frag.sn === levelDetails.startSN) {
                            logger_1.logger.warn('missing video frame(s) on first frag, appending with gap', frag.sn);
                        }
                        else {
                            logger_1.logger.warn('missing video frame(s), backtracking fragment', frag.sn);
                            // Return back to the IDLE state without appending to buffer
                            // Causes findFragments to backtrack a segment and find the keyframe
                            // Audio fragments arriving before video sets the nextLoadPosition, causing _findFragments to skip the backtracked fragment
                            this.fragmentTracker.removeFragment(frag);
                            frag.backtracked = true;
                            this.nextLoadPosition = data.startPTS;
                            this.state = base_stream_controller_1.State.IDLE;
                            this.fragPrevious = frag;
                            this.tick();
                            return;
                        }
                    }
                    else {
                        logger_1.logger.warn('Already backtracked on this fragment, appending with the gap', frag.sn);
                    }
                }
                else {
                    // Only reset the backtracked flag if we've loaded the frag without any dropped frames
                    frag.backtracked = false;
                }
            }
            var drift = LevelHelper.updateFragPTSDTS(level.details, frag, data.startPTS, data.endPTS, data.startDTS, data.endDTS), hls_2 = this.hls;
            hls_2.trigger(events_1.default.LEVEL_PTS_UPDATED, { details: level.details, level: this.level, drift: drift, type: data.type, start: data.startPTS, end: data.endPTS });
            // has remuxer dropped video frames located before first keyframe ?
            [data.data1, data.data2].forEach(function (buffer) {
                // only append in PARSING state (rationale is that an appending error could happen synchronously on first segment appending)
                // in that case it is useless to append following segments
                if (buffer && buffer.length && _this.state === base_stream_controller_1.State.PARSING) {
                    _this.appended = true;
                    // arm pending Buffering flag before appending a segment
                    _this.pendingBuffering = true;
                    hls_2.trigger(events_1.default.BUFFER_APPENDING, { type: data.type, data: buffer, parent: 'main', content: 'data' });
                }
            });
            // trigger handler right now
            this.tick();
        }
    };
    StreamController.prototype.onFragParsed = function (data) {
        var fragCurrent = this.fragCurrent;
        var fragNew = data.frag;
        if (fragCurrent &&
            data.id === 'main' &&
            fragNew.sn === fragCurrent.sn &&
            fragNew.level === fragCurrent.level &&
            this.state === base_stream_controller_1.State.PARSING) {
            this.stats.tparsed = window.performance.now();
            this.state = base_stream_controller_1.State.PARSED;
            this._checkAppendedParsed();
        }
    };
    StreamController.prototype.onAudioTrackSwitching = function (data) {
        // if any URL found on new audio track, it is an alternate audio track
        var altAudio = !!data.url, trackId = data.id;
        // if we switch on main audio, ensure that main fragment scheduling is synced with media.buffered
        // don't do anything if we switch to alt audio: audio stream controller is handling it.
        // we will just have to change buffer scheduling on audioTrackSwitched
        if (!altAudio) {
            if (this.mediaBuffer !== this.media) {
                logger_1.logger.log('switching on main audio, use media.buffered to schedule main fragment loading');
                this.mediaBuffer = this.media;
                var fragCurrent = this.fragCurrent;
                // we need to refill audio buffer from main: cancel any frag loading to speed up audio switch
                if (fragCurrent.loader) {
                    logger_1.logger.log('switching to main audio track, cancel main fragment load');
                    fragCurrent.loader.abort();
                }
                this.fragCurrent = null;
                this.fragPrevious = null;
                // destroy demuxer to force init segment generation (following audio switch)
                if (this.demuxer) {
                    this.demuxer.destroy();
                    this.demuxer = null;
                }
                // switch to IDLE state to load new fragment
                this.state = base_stream_controller_1.State.IDLE;
            }
            var hls_3 = this.hls;
            // switching to main audio, flush all audio and trigger track switched
            hls_3.trigger(events_1.default.BUFFER_FLUSHING, { startOffset: 0, endOffset: Number.POSITIVE_INFINITY, type: 'audio' });
            hls_3.trigger(events_1.default.AUDIO_TRACK_SWITCHED, { id: trackId });
            this.altAudio = false;
        }
    };
    StreamController.prototype.onAudioTrackSwitched = function (data) {
        var trackId = data.id, altAudio = !!this.hls.audioTracks[trackId].url;
        if (altAudio) {
            var videoBuffer = this.videoBuffer;
            // if we switched on alternate audio, ensure that main fragment scheduling is synced with video sourcebuffer buffered
            if (videoBuffer && this.mediaBuffer !== videoBuffer) {
                logger_1.logger.log('switching on alternate audio, use video.buffered to schedule main fragment loading');
                this.mediaBuffer = videoBuffer;
            }
        }
        this.altAudio = altAudio;
        this.tick();
    };
    StreamController.prototype.onBufferCreated = function (data) {
        var tracks = data.tracks, mediaTrack, name, alternate = false;
        for (var type in tracks) {
            var track = tracks[type];
            if (track.id === 'main') {
                name = type;
                mediaTrack = track;
                // keep video source buffer reference
                if (type === 'video') {
                    this.videoBuffer = tracks[type].buffer;
                }
            }
            else {
                alternate = true;
            }
        }
        if (alternate && mediaTrack) {
            logger_1.logger.log("alternate track found, use " + name + ".buffered to schedule main fragment loading");
            this.mediaBuffer = mediaTrack.buffer;
        }
        else {
            this.mediaBuffer = this.media;
        }
    };
    StreamController.prototype.onBufferAppended = function (data) {
        if (data.parent === 'main') {
            var state = this.state;
            if (state === base_stream_controller_1.State.PARSING || state === base_stream_controller_1.State.PARSED) {
                // check if all buffers have been appended
                this.pendingBuffering = (data.pending > 0);
                this._checkAppendedParsed();
            }
        }
    };
    StreamController.prototype._checkAppendedParsed = function () {
        // trigger handler right now
        if (this.state === base_stream_controller_1.State.PARSED && (!this.appended || !this.pendingBuffering)) {
            var frag = this.fragCurrent;
            if (frag) {
                var media = this.mediaBuffer ? this.mediaBuffer : this.media;
                logger_1.logger.log("main buffered : " + time_ranges_1.default.toString(media.buffered));
                this.fragPrevious = frag;
                var stats = this.stats;
                stats.tbuffered = window.performance.now();
                // we should get rid of this.fragLastKbps
                this.fragLastKbps = Math.round(8 * stats.total / (stats.tbuffered - stats.tfirst));
                this.hls.trigger(events_1.default.FRAG_BUFFERED, { stats: stats, frag: frag, id: 'main' });
                this.state = base_stream_controller_1.State.IDLE;
            }
            this.tick();
        }
    };
    StreamController.prototype.onError = function (data) {
        var frag = data.frag || this.fragCurrent;
        // don't handle frag error not related to main fragment
        if (frag && frag.type !== 'main') {
            return;
        }
        // 0.5 : tolerance needed as some browsers stalls playback before reaching buffered end
        var mediaBuffered = !!this.media && buffer_helper_1.BufferHelper.isBuffered(this.media, this.media.currentTime) && buffer_helper_1.BufferHelper.isBuffered(this.media, this.media.currentTime + 0.5);
        switch (data.details) {
            case errors_1.ErrorDetails.FRAG_LOAD_ERROR:
            case errors_1.ErrorDetails.FRAG_LOAD_TIMEOUT:
            case errors_1.ErrorDetails.KEY_LOAD_ERROR:
            case errors_1.ErrorDetails.KEY_LOAD_TIMEOUT:
                if (!data.fatal) {
                    // keep retrying until the limit will be reached
                    if ((this.fragLoadError + 1) <= this.config.fragLoadingMaxRetry) {
                        // exponential backoff capped to config.fragLoadingMaxRetryTimeout
                        var delay = Math.min(Math.pow(2, this.fragLoadError) * this.config.fragLoadingRetryDelay, this.config.fragLoadingMaxRetryTimeout);
                        logger_1.logger.warn("mediaController: frag loading failed, retry in " + delay + " ms");
                        this.retryDate = window.performance.now() + delay;
                        // retry loading state
                        // if loadedmetadata is not set, it means that we are emergency switch down on first frag
                        // in that case, reset startFragRequested flag
                        if (!this.loadedmetadata) {
                            this.startFragRequested = false;
                            this.nextLoadPosition = this.startPosition;
                        }
                        this.fragLoadError++;
                        this.state = base_stream_controller_1.State.FRAG_LOADING_WAITING_RETRY;
                    }
                    else {
                        logger_1.logger.error("mediaController: " + data.details + " reaches max retry, redispatch as fatal ...");
                        // switch error to fatal
                        data.fatal = true;
                        this.state = base_stream_controller_1.State.ERROR;
                    }
                }
                break;
            case errors_1.ErrorDetails.LEVEL_LOAD_ERROR:
            case errors_1.ErrorDetails.LEVEL_LOAD_TIMEOUT:
                if (this.state !== base_stream_controller_1.State.ERROR) {
                    if (data.fatal) {
                        // if fatal error, stop processing
                        this.state = base_stream_controller_1.State.ERROR;
                        logger_1.logger.warn("streamController: " + data.details + ",switch to " + this.state + " state ...");
                    }
                    else {
                        // in case of non fatal error while loading level, if level controller is not retrying to load level , switch back to IDLE
                        if (!data.levelRetry && this.state === base_stream_controller_1.State.WAITING_LEVEL) {
                            this.state = base_stream_controller_1.State.IDLE;
                        }
                    }
                }
                break;
            case errors_1.ErrorDetails.BUFFER_FULL_ERROR:
                // if in appending state
                if (data.parent === 'main' && (this.state === base_stream_controller_1.State.PARSING || this.state === base_stream_controller_1.State.PARSED)) {
                    // reduce max buf len if current position is buffered
                    if (mediaBuffered) {
                        this._reduceMaxBufferLength(this.config.maxBufferLength);
                        this.state = base_stream_controller_1.State.IDLE;
                    }
                    else {
                        // current position is not buffered, but browser is still complaining about buffer full error
                        // this happens on IE/Edge, refer to https://github.com/video-dev/hls.js/pull/708
                        // in that case flush the whole buffer to recover
                        logger_1.logger.warn('buffer full error also media.currentTime is not buffered, flush everything');
                        this.fragCurrent = null;
                        // flush everything
                        this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
                    }
                }
                break;
            default:
                break;
        }
    };
    StreamController.prototype._reduceMaxBufferLength = function (minLength) {
        var config = this.config;
        if (config.maxMaxBufferLength >= minLength) {
            // reduce max buffer length as it might be too high. we do this to avoid loop flushing ...
            config.maxMaxBufferLength /= 2;
            logger_1.logger.warn("main:reduce max buffer length to " + config.maxMaxBufferLength + "s");
            return true;
        }
        return false;
    };
    /**
     * Checks the health of the buffer and attempts to resolve playback stalls.
     * @private
     */
    StreamController.prototype._checkBuffer = function () {
        var media = this.media;
        if (!media || media.readyState === 0) {
            // Exit early if we don't have media or if the media hasn't bufferd anything yet (readyState 0)
            return;
        }
        var mediaBuffer = this.mediaBuffer ? this.mediaBuffer : media;
        var buffered = mediaBuffer.buffered;
        if (!this.loadedmetadata && buffered.length) {
            this.loadedmetadata = true;
            this._seekToStartPos();
        }
        else if (this.immediateSwitch) {
            this.immediateLevelSwitchEnd();
        }
        else {
            this.gapController.poll(this.lastCurrentTime, buffered);
        }
    };
    StreamController.prototype.onFragLoadEmergencyAborted = function () {
        this.state = base_stream_controller_1.State.IDLE;
        // if loadedmetadata is not set, it means that we are emergency switch down on first frag
        // in that case, reset startFragRequested flag
        if (!this.loadedmetadata) {
            this.startFragRequested = false;
            this.nextLoadPosition = this.startPosition;
        }
        this.tick();
    };
    StreamController.prototype.onBufferFlushed = function () {
        /* after successful buffer flushing, filter flushed fragments from bufferedFrags
          use mediaBuffered instead of media (so that we will check against video.buffered ranges in case of alt audio track)
        */
        var media = this.mediaBuffer ? this.mediaBuffer : this.media;
        if (media) {
            // filter fragments potentially evicted from buffer. this is to avoid memleak on live streams
            this.fragmentTracker.detectEvictedFragments(fragment_1.default.ElementaryStreamTypes.VIDEO, media.buffered);
        }
        // move to IDLE once flush complete. this should trigger new fragment loading
        this.state = base_stream_controller_1.State.IDLE;
        // reset reference to frag
        this.fragPrevious = null;
    };
    StreamController.prototype.swapAudioCodec = function () {
        this.audioCodecSwap = !this.audioCodecSwap;
    };
    StreamController.prototype.computeLivePosition = function (sliding, levelDetails) {
        var targetLatency = this.config.liveSyncDuration !== undefined ? this.config.liveSyncDuration : this.config.liveSyncDurationCount * levelDetails.targetduration;
        return sliding + Math.max(0, levelDetails.totalduration - targetLatency);
    };
    /**
     * Seeks to the set startPosition if not equal to the mediaElement's current time.
     * @private
     */
    StreamController.prototype._seekToStartPos = function () {
        var media = this.media;
        var currentTime = media.currentTime;
        // only adjust currentTime if different from startPosition or if startPosition not buffered
        // at that stage, there should be only one buffered range, as we reach that code after first fragment has been buffered
        var startPosition = media.seeking ? currentTime : this.startPosition;
        // if currentTime not matching with expected startPosition or startPosition not buffered but close to first buffered
        if (currentTime !== startPosition) {
            // if startPosition not buffered, let's seek to buffered.start(0)
            logger_1.logger.log("target start position not buffered, seek to buffered.start(0) " + startPosition + " from current time " + currentTime + " ");
            media.currentTime = startPosition;
        }
    };
    StreamController.prototype._getAudioCodec = function (currentLevel) {
        var audioCodec = this.config.defaultAudioCodec || currentLevel.audioCodec;
        if (this.audioCodecSwap) {
            logger_1.logger.log('swapping playlist audio codec');
            if (audioCodec) {
                if (audioCodec.indexOf('mp4a.40.5') !== -1) {
                    audioCodec = 'mp4a.40.2';
                }
                else {
                    audioCodec = 'mp4a.40.5';
                }
            }
        }
        return audioCodec;
    };
    Object.defineProperty(StreamController.prototype, "liveSyncPosition", {
        get: function () {
            return this._liveSyncPosition;
        },
        set: function (value) {
            this._liveSyncPosition = value;
        },
        enumerable: true,
        configurable: true
    });
    return StreamController;
}(base_stream_controller_1.default));
exports.default = StreamController;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./src/polyfills/number */ "./src/polyfills/number.js")["Number"]))

/***/ }),

/***/ "./src/controller/subtitle-stream-controller.js":
/*!******************************************************!*\
  !*** ./src/controller/subtitle-stream-controller.js ***!
  \******************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @class SubtitleStreamController
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var decrypter_1 = __webpack_require__(/*! ../crypt/decrypter */ "./src/crypt/decrypter.js");
var task_loop_1 = __webpack_require__(/*! ../task-loop */ "./src/task-loop.js");
var buffer_helper_1 = __webpack_require__(/*! ../utils/buffer-helper */ "./src/utils/buffer-helper.js");
var fragment_finders_1 = __webpack_require__(/*! ./fragment-finders */ "./src/controller/fragment-finders.js");
var fragment_tracker_1 = __webpack_require__(/*! ./fragment-tracker */ "./src/controller/fragment-tracker.js");
var performance = window.performance;
exports.SubtitleStreamControllerState = {
    STOPPED: 'STOPPED',
    IDLE: 'IDLE',
    KEY_LOADING: 'KEY_LOADING',
    FRAG_LOADING: 'FRAG_LOADING'
};
var State = exports.SubtitleStreamControllerState;
var TICK_INTERVAL = 500; // how often to tick in ms
var SubtitleStreamController = /** @class */ (function (_super) {
    __extends(SubtitleStreamController, _super);
    function SubtitleStreamController(hls, fragmentTracker) {
        var _this = _super.call(this, hls, events_1.default.MEDIA_ATTACHED, events_1.default.MEDIA_DETACHING, events_1.default.ERROR, events_1.default.KEY_LOADED, events_1.default.FRAG_LOADED, events_1.default.SUBTITLE_TRACKS_UPDATED, events_1.default.SUBTITLE_TRACK_SWITCH, events_1.default.SUBTITLE_TRACK_LOADED, events_1.default.SUBTITLE_FRAG_PROCESSED) || this;
        _this.fragmentTracker = fragmentTracker;
        _this.config = hls.config;
        _this.state = State.STOPPED;
        _this.tracks = [];
        _this.tracksBuffered = [];
        _this.currentTrackId = -1;
        _this.decrypter = new decrypter_1.default(hls, hls.config);
        return _this;
    }
    SubtitleStreamController.prototype.onHandlerDestroyed = function () {
        this.fragmentTracker = null;
        this.state = State.STOPPED;
        _super.prototype.onHandlerDestroyed.call(this);
    };
    SubtitleStreamController.prototype.onSubtitleFragProcessed = function (data) {
        this.state = State.IDLE;
        if (!data.success) {
            return;
        }
        var buffered = this.tracksBuffered[this.currentTrackId];
        var frag = data.frag;
        this.fragPrevious = frag;
        if (!buffered) {
            return;
        }
        // Create/update a buffered array matching the interface used by BufferHelper.bufferedInfo
        // so we can re-use the logic used to detect how much have been buffered
        // FIXME: put this in a utility function or proper object for time-ranges manipulation?
        var timeRange;
        for (var i = 0; i < buffered.length; i++) {
            if (frag.start >= buffered[i].start && frag.start <= buffered[i].end) {
                timeRange = buffered[i];
                break;
            }
        }
        if (timeRange) {
            timeRange.end = frag.start + frag.duration;
        }
        else {
            buffered.push({
                start: frag.start,
                end: frag.start + frag.duration
            });
        }
    };
    SubtitleStreamController.prototype.onMediaAttached = function (data) {
        this.media = data.media;
        this.state = State.IDLE;
    };
    SubtitleStreamController.prototype.onMediaDetaching = function () {
        this.media = null;
        this.state = State.STOPPED;
    };
    // If something goes wrong, procede to next frag, if we were processing one.
    SubtitleStreamController.prototype.onError = function (data) {
        var frag = data.frag;
        // don't handle error not related to subtitle fragment
        if (!frag || frag.type !== 'subtitle') {
            return;
        }
        this.state = State.IDLE;
    };
    // Got all new subtitle tracks.
    SubtitleStreamController.prototype.onSubtitleTracksUpdated = function (data) {
        var _this = this;
        logger_1.logger.log('subtitle tracks updated');
        this.tracksBuffered = [];
        this.tracks = data.subtitleTracks;
        this.tracks.forEach(function (track) {
            _this.tracksBuffered[track.id] = [];
        });
    };
    SubtitleStreamController.prototype.onSubtitleTrackSwitch = function (data) {
        this.currentTrackId = data.id;
        if (!this.tracks || this.currentTrackId === -1) {
            this.clearInterval();
            return;
        }
        // Check if track has the necessary details to load fragments
        var currentTrack = this.tracks[this.currentTrackId];
        if (currentTrack && currentTrack.details) {
            this.setInterval(TICK_INTERVAL);
        }
    };
    // Got a new set of subtitle fragments.
    SubtitleStreamController.prototype.onSubtitleTrackLoaded = function (data) {
        var id = data.id, details = data.details;
        if (!this.tracks) {
            logger_1.logger.warn('Can not update subtitle details, no tracks found');
            return;
        }
        if (this.tracks[id]) {
            logger_1.logger.log('Updating subtitle track details');
            this.tracks[id].details = details;
        }
        this.setInterval(TICK_INTERVAL);
    };
    SubtitleStreamController.prototype.onKeyLoaded = function () {
        if (this.state === State.KEY_LOADING) {
            this.state = State.IDLE;
        }
    };
    SubtitleStreamController.prototype.onFragLoaded = function (data) {
        var fragCurrent = this.fragCurrent;
        var decryptData = data.frag.decryptdata;
        var fragLoaded = data.frag;
        var hls = this.hls;
        if (this.state === State.FRAG_LOADING &&
            fragCurrent &&
            data.frag.type === 'subtitle' &&
            fragCurrent.sn === data.frag.sn) {
            // check to see if the payload needs to be decrypted
            if (data.payload.byteLength > 0 && (decryptData && decryptData.key && decryptData.method === 'AES-128')) {
                var startTime_1 = performance.now();
                // decrypt the subtitles
                this.decrypter.decrypt(data.payload, decryptData.key.buffer, decryptData.iv.buffer, function (decryptedData) {
                    var endTime = performance.now();
                    hls.trigger(events_1.default.FRAG_DECRYPTED, { frag: fragLoaded, payload: decryptedData, stats: { tstart: startTime_1, tdecrypt: endTime } });
                });
            }
        }
    };
    SubtitleStreamController.prototype.doTick = function () {
        if (!this.media) {
            this.state = State.IDLE;
            return;
        }
        switch (this.state) {
            case State.IDLE:
                var tracks = this.tracks;
                var trackId = this.currentTrackId;
                if (!tracks || !tracks[trackId] || !tracks[trackId].details) {
                    break;
                }
                var trackDetails = tracks[trackId].details;
                var config = this.config;
                var maxBufferHole = config.maxBufferHole;
                var maxConfigBuffer = Math.min(config.maxBufferLength, config.maxMaxBufferLength);
                var maxFragLookUpTolerance = config.maxFragLookUpTolerance;
                var bufferedInfo = buffer_helper_1.BufferHelper.bufferedInfo(this._getBuffered(), this.media.currentTime, maxBufferHole);
                var bufferEnd = bufferedInfo.end;
                var bufferLen = bufferedInfo.len;
                var fragments = trackDetails.fragments;
                var fragLen = fragments.length;
                var end = fragments[fragLen - 1].start + fragments[fragLen - 1].duration;
                var foundFrag = void 0;
                if (bufferLen < maxConfigBuffer && bufferEnd < end) {
                    foundFrag = fragment_finders_1.findFragmentByPTS(this.fragPrevious, fragments, bufferEnd, maxFragLookUpTolerance);
                }
                else if (trackDetails.hasProgramDateTime && this.fragPrevious) {
                    foundFrag = fragment_finders_1.findFragmentByPDT(fragments, this.fragPrevious.endProgramDateTime, maxFragLookUpTolerance);
                }
                if (foundFrag && foundFrag.encrypted) {
                    logger_1.logger.log("Loading key for " + foundFrag.sn);
                    this.state = State.KEY_LOADING;
                    this.hls.trigger(events_1.default.KEY_LOADING, { frag: foundFrag });
                }
                else if (foundFrag && this.fragmentTracker.getState(foundFrag) === fragment_tracker_1.FragmentState.NOT_LOADED) {
                    // only load if fragment is not loaded
                    foundFrag.trackId = trackId; // Frags don't know their subtitle track ID, so let's just add that...
                    this.fragCurrent = foundFrag;
                    this.state = State.FRAG_LOADING;
                    this.hls.trigger(events_1.default.FRAG_LOADING, { frag: foundFrag });
                }
        }
    };
    SubtitleStreamController.prototype._getBuffered = function () {
        return this.tracksBuffered[this.currentTrackId] || [];
    };
    return SubtitleStreamController;
}(task_loop_1.default));
exports.SubtitleStreamController = SubtitleStreamController;


/***/ }),

/***/ "./src/controller/subtitle-track-controller.js":
/*!*****************************************************!*\
  !*** ./src/controller/subtitle-track-controller.js ***!
  \*****************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * subtitle track controller
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var event_handler_1 = __webpack_require__(/*! ../event-handler */ "./src/event-handler.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
function filterSubtitleTracks(textTrackList) {
    var tracks = [];
    for (var i = 0; i < textTrackList.length; i++) {
        if (textTrackList[i].kind === 'subtitles') {
            tracks.push(textTrackList[i]);
        }
    }
    return tracks;
}
var SubtitleTrackController = /** @class */ (function (_super) {
    __extends(SubtitleTrackController, _super);
    function SubtitleTrackController(hls) {
        var _this = _super.call(this, hls, events_1.default.MEDIA_ATTACHED, events_1.default.MEDIA_DETACHING, events_1.default.MANIFEST_LOADING, events_1.default.MANIFEST_LOADED, events_1.default.SUBTITLE_TRACK_LOADED) || this;
        _this.tracks = [];
        _this.trackId = -1;
        _this.media = null;
        /**
         * @member {boolean} subtitleDisplay Enable/disable subtitle display rendering
         */
        _this.subtitleDisplay = true;
        return _this;
    }
    SubtitleTrackController.prototype._onTextTracksChanged = function () {
        // Media is undefined when switching streams via loadSource()
        if (!this.media) {
            return;
        }
        var trackId = -1;
        var tracks = filterSubtitleTracks(this.media.textTracks);
        for (var id = 0; id < tracks.length; id++) {
            if (tracks[id].mode === 'hidden') {
                // Do not break in case there is a following track with showing.
                trackId = id;
            }
            else if (tracks[id].mode === 'showing') {
                trackId = id;
                break;
            }
        }
        // Setting current subtitleTrack will invoke code.
        this.subtitleTrack = trackId;
    };
    SubtitleTrackController.prototype.destroy = function () {
        event_handler_1.default.prototype.destroy.call(this);
    };
    // Listen for subtitle track change, then extract the current track ID.
    SubtitleTrackController.prototype.onMediaAttached = function (data) {
        var _this = this;
        this.media = data.media;
        if (!this.media) {
            return;
        }
        if (this.queuedDefaultTrack) {
            this.subtitleTrack = this.queuedDefaultTrack;
            delete this.queuedDefaultTrack;
        }
        this.trackChangeListener = this._onTextTracksChanged.bind(this);
        this.useTextTrackPolling = !(this.media.textTracks && 'onchange' in this.media.textTracks);
        if (this.useTextTrackPolling) {
            this.subtitlePollingInterval = setInterval(function () {
                _this.trackChangeListener();
            }, 500);
        }
        else {
            this.media.textTracks.addEventListener('change', this.trackChangeListener);
        }
    };
    SubtitleTrackController.prototype.onMediaDetaching = function () {
        if (!this.media) {
            return;
        }
        if (this.useTextTrackPolling) {
            clearInterval(this.subtitlePollingInterval);
        }
        else {
            this.media.textTracks.removeEventListener('change', this.trackChangeListener);
        }
        this.media = null;
    };
    // Reset subtitle tracks on manifest loading
    SubtitleTrackController.prototype.onManifestLoading = function () {
        this.tracks = [];
        this.trackId = -1;
    };
    // Fired whenever a new manifest is loaded.
    SubtitleTrackController.prototype.onManifestLoaded = function (data) {
        var _this = this;
        var tracks = data.subtitles || [];
        this.tracks = tracks;
        this.trackId = -1;
        this.hls.trigger(events_1.default.SUBTITLE_TRACKS_UPDATED, { subtitleTracks: tracks });
        // loop through available subtitle tracks and autoselect default if needed
        // TODO: improve selection logic to handle forced, etc
        tracks.forEach(function (track) {
            if (track.default) {
                // setting this.subtitleTrack will trigger internal logic
                // if media has not been attached yet, it will fail
                // we keep a reference to the default track id
                // and we'll set subtitleTrack when onMediaAttached is triggered
                if (_this.media) {
                    _this.subtitleTrack = track.id;
                }
                else {
                    _this.queuedDefaultTrack = track.id;
                }
            }
        });
    };
    // Trigger subtitle track playlist reload.
    SubtitleTrackController.prototype.onTick = function () {
        var trackId = this.trackId;
        var subtitleTrack = this.tracks[trackId];
        if (!subtitleTrack) {
            return;
        }
        var details = subtitleTrack.details;
        // check if we need to load playlist for this subtitle Track
        if (!details || details.live) {
            // track not retrieved yet, or live playlist we need to (re)load it
            logger_1.logger.log("(re)loading playlist for subtitle track " + trackId);
            this.hls.trigger(events_1.default.SUBTITLE_TRACK_LOADING, { url: subtitleTrack.url, id: trackId });
        }
    };
    SubtitleTrackController.prototype.onSubtitleTrackLoaded = function (data) {
        var _this = this;
        if (data.id < this.tracks.length) {
            logger_1.logger.log("subtitle track " + data.id + " loaded");
            this.tracks[data.id].details = data.details;
            // check if current playlist is a live playlist
            if (data.details.live && !this.timer) {
                // if live playlist we will have to reload it periodically
                // set reload period to playlist target duration
                this.timer = setInterval(function () {
                    _this.onTick();
                }, 1000 * data.details.targetduration, this);
            }
            if (!data.details.live && this.timer) {
                // playlist is not live and timer is armed : stopping it
                this._stopTimer();
            }
        }
    };
    Object.defineProperty(SubtitleTrackController.prototype, "subtitleTracks", {
        /** get alternate subtitle tracks list from playlist **/
        get: function () {
            return this.tracks;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubtitleTrackController.prototype, "subtitleTrack", {
        /** get index of the selected subtitle track (index in subtitle track lists) **/
        get: function () {
            return this.trackId;
        },
        /** select a subtitle track, based on its index in subtitle track lists**/
        set: function (subtitleTrackId) {
            if (this.trackId !== subtitleTrackId) {
                this._toggleTrackModes(subtitleTrackId);
                this.setSubtitleTrackInternal(subtitleTrackId);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * This method is responsible for validating the subtitle index and periodically reloading if live.
     * Dispatches the SUBTITLE_TRACK_SWITCH event, which instructs the subtitle-stream-controller to load the selected track.
     * @param newId - The id of the subtitle track to activate.
     */
    SubtitleTrackController.prototype.setSubtitleTrackInternal = function (newId) {
        var _a = this, hls = _a.hls, tracks = _a.tracks;
        if (typeof newId !== 'number' || newId < -1 || newId >= tracks.length) {
            return;
        }
        this._stopTimer();
        this.trackId = newId;
        logger_1.logger.log("switching to subtitle track " + newId);
        hls.trigger(events_1.default.SUBTITLE_TRACK_SWITCH, { id: newId });
        if (newId === -1) {
            return;
        }
        // check if we need to load playlist for this subtitle Track
        var subtitleTrack = tracks[newId];
        var details = subtitleTrack.details;
        if (!details || details.live) {
            // track not retrieved yet, or live playlist we need to (re)load it
            logger_1.logger.log("(re)loading playlist for subtitle track " + newId);
            hls.trigger(events_1.default.SUBTITLE_TRACK_LOADING, { url: subtitleTrack.url, id: newId });
        }
    };
    SubtitleTrackController.prototype._stopTimer = function () {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
    };
    /**
     * Disables the old subtitleTrack and sets current mode on the next subtitleTrack.
     * This operates on the DOM textTracks.
     * A value of -1 will disable all subtitle tracks.
     * @param newId - The id of the next track to enable
     * @private
     */
    SubtitleTrackController.prototype._toggleTrackModes = function (newId) {
        var _a = this, media = _a.media, subtitleDisplay = _a.subtitleDisplay, trackId = _a.trackId;
        if (!media) {
            return;
        }
        var textTracks = filterSubtitleTracks(media.textTracks);
        if (newId === -1) {
            [].slice.call(textTracks).forEach(function (track) {
                track.mode = 'disabled';
            });
        }
        else {
            var oldTrack = textTracks[trackId];
            if (oldTrack) {
                oldTrack.mode = 'disabled';
            }
        }
        var nextTrack = textTracks[newId];
        if (nextTrack) {
            nextTrack.mode = subtitleDisplay ? 'showing' : 'hidden';
        }
    };
    return SubtitleTrackController;
}(event_handler_1.default));
exports.default = SubtitleTrackController;


/***/ }),

/***/ "./src/controller/timeline-controller.js":
/*!***********************************************!*\
  !*** ./src/controller/timeline-controller.js ***!
  \***********************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Number) {
/*
 * Timeline Controller
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var event_handler_1 = __webpack_require__(/*! ../event-handler */ "./src/event-handler.js");
var cea_608_parser_1 = __webpack_require__(/*! ../utils/cea-608-parser */ "./src/utils/cea-608-parser.js");
var output_filter_1 = __webpack_require__(/*! ../utils/output-filter */ "./src/utils/output-filter.js");
var webvtt_parser_1 = __webpack_require__(/*! ../utils/webvtt-parser */ "./src/utils/webvtt-parser.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var texttrack_utils_1 = __webpack_require__(/*! ../utils/texttrack-utils */ "./src/utils/texttrack-utils.js");
function canReuseVttTextTrack(inUseTrack, manifestTrack) {
    return inUseTrack && inUseTrack.label === manifestTrack.name && !(inUseTrack.textTrack1 || inUseTrack.textTrack2);
}
function intersection(x1, x2, y1, y2) {
    return Math.min(x2, y2) - Math.max(x1, y1);
}
var TimelineController = /** @class */ (function (_super) {
    __extends(TimelineController, _super);
    function TimelineController(hls) {
        var _this = _super.call(this, hls, events_1.default.MEDIA_ATTACHING, events_1.default.MEDIA_DETACHING, events_1.default.FRAG_PARSING_USERDATA, events_1.default.FRAG_DECRYPTED, events_1.default.MANIFEST_LOADING, events_1.default.MANIFEST_LOADED, events_1.default.FRAG_LOADED, events_1.default.LEVEL_SWITCHING, events_1.default.INIT_PTS_FOUND) || this;
        _this.hls = hls;
        _this.config = hls.config;
        _this.enabled = true;
        _this.Cues = hls.config.cueHandler;
        _this.textTracks = [];
        _this.tracks = [];
        _this.unparsedVttFrags = [];
        _this.initPTS = [];
        _this.cueRanges = [];
        _this.captionsTracks = {};
        _this.captionsProperties = {
            textTrack1: {
                label: _this.config.captionsTextTrack1Label,
                languageCode: _this.config.captionsTextTrack1LanguageCode
            },
            textTrack2: {
                label: _this.config.captionsTextTrack2Label,
                languageCode: _this.config.captionsTextTrack2LanguageCode
            }
        };
        if (_this.config.enableCEA708Captions) {
            var channel1 = new output_filter_1.default(_this, 'textTrack1');
            var channel2 = new output_filter_1.default(_this, 'textTrack2');
            _this.cea608Parser = new cea_608_parser_1.default(0, channel1, channel2);
        }
        return _this;
    }
    TimelineController.prototype.addCues = function (trackName, startTime, endTime, screen) {
        // skip cues which overlap more than 50% with previously parsed time ranges
        var ranges = this.cueRanges;
        var merged = false;
        for (var i = ranges.length; i--;) {
            var cueRange = ranges[i];
            var overlap = intersection(cueRange[0], cueRange[1], startTime, endTime);
            if (overlap >= 0) {
                cueRange[0] = Math.min(cueRange[0], startTime);
                cueRange[1] = Math.max(cueRange[1], endTime);
                merged = true;
                if ((overlap / (endTime - startTime)) > 0.5) {
                    return;
                }
            }
        }
        if (!merged) {
            ranges.push([startTime, endTime]);
        }
        this.Cues.newCue(this.captionsTracks[trackName], startTime, endTime, screen);
    };
    // Triggered when an initial PTS is found; used for synchronisation of WebVTT.
    TimelineController.prototype.onInitPtsFound = function (data) {
        var _this = this;
        if (data.id === 'main') {
            this.initPTS[data.frag.cc] = data.initPTS;
        }
        // Due to asynchronous processing, initial PTS may arrive later than the first VTT fragments are loaded.
        // Parse any unparsed fragments upon receiving the initial PTS.
        if (this.unparsedVttFrags.length) {
            var unparsedVttFrags = this.unparsedVttFrags;
            this.unparsedVttFrags = [];
            unparsedVttFrags.forEach(function (frag) {
                _this.onFragLoaded(frag);
            });
        }
    };
    TimelineController.prototype.getExistingTrack = function (trackName) {
        var media = this.media;
        if (media) {
            for (var i = 0; i < media.textTracks.length; i++) {
                var textTrack = media.textTracks[i];
                if (textTrack[trackName]) {
                    return textTrack;
                }
            }
        }
        return null;
    };
    TimelineController.prototype.createCaptionsTrack = function (trackName) {
        var _a = this.captionsProperties[trackName], label = _a.label, languageCode = _a.languageCode;
        var captionsTracks = this.captionsTracks;
        if (!captionsTracks[trackName]) {
            // Enable reuse of existing text track.
            var existingTrack = this.getExistingTrack(trackName);
            if (!existingTrack) {
                var textTrack = this.createTextTrack('captions', label, languageCode);
                if (textTrack) {
                    // Set a special property on the track so we know it's managed by Hls.js
                    textTrack[trackName] = true;
                    captionsTracks[trackName] = textTrack;
                }
            }
            else {
                captionsTracks[trackName] = existingTrack;
                texttrack_utils_1.clearCurrentCues(captionsTracks[trackName]);
                texttrack_utils_1.sendAddTrackEvent(captionsTracks[trackName], this.media);
            }
        }
    };
    TimelineController.prototype.createTextTrack = function (kind, label, lang) {
        var media = this.media;
        if (media) {
            return media.addTextTrack(kind, label, lang);
        }
    };
    TimelineController.prototype.destroy = function () {
        event_handler_1.default.prototype.destroy.call(this);
    };
    TimelineController.prototype.onMediaAttaching = function (data) {
        this.media = data.media;
        this._cleanTracks();
    };
    TimelineController.prototype.onMediaDetaching = function () {
        var captionsTracks = this.captionsTracks;
        Object.keys(captionsTracks).forEach(function (trackName) {
            texttrack_utils_1.clearCurrentCues(captionsTracks[trackName]);
            delete captionsTracks[trackName];
        });
    };
    TimelineController.prototype.onManifestLoading = function () {
        this.lastSn = -1; // Detect discontiguity in fragment parsing
        this.prevCC = -1;
        this.vttCCs = {
            ccOffset: 0,
            presentationOffset: 0,
            0: {
                start: 0, prevCC: -1, new: false
            }
        };
        this._cleanTracks();
    };
    TimelineController.prototype._cleanTracks = function () {
        // clear outdated subtitles
        var media = this.media;
        if (media) {
            var textTracks = media.textTracks;
            if (textTracks) {
                for (var i = 0; i < textTracks.length; i++) {
                    texttrack_utils_1.clearCurrentCues(textTracks[i]);
                }
            }
        }
    };
    TimelineController.prototype.onManifestLoaded = function (data) {
        var _this = this;
        this.textTracks = [];
        this.unparsedVttFrags = this.unparsedVttFrags || [];
        this.initPTS = [];
        this.cueRanges = [];
        if (this.config.enableWebVTT) {
            this.tracks = data.subtitles || [];
            var inUseTracks_1 = this.media ? this.media.textTracks : [];
            this.tracks.forEach(function (track, index) {
                var textTrack;
                if (index < inUseTracks_1.length) {
                    var inUseTrack = [].slice.call(inUseTracks_1).find(function (inUseTrack) { return canReuseVttTextTrack(inUseTrack, track); });
                    // Reuse tracks with the same label, but do not reuse 608/708 tracks
                    if (inUseTrack) {
                        textTrack = inUseTrack;
                    }
                }
                if (!textTrack) {
                    textTrack = _this.createTextTrack('subtitles', track.name, track.lang);
                }
                if (track.default) {
                    textTrack.mode = _this.hls.subtitleDisplay ? 'showing' : 'hidden';
                }
                else {
                    textTrack.mode = 'disabled';
                }
                _this.textTracks.push(textTrack);
            });
        }
    };
    TimelineController.prototype.onLevelSwitching = function () {
        this.enabled = this.hls.currentLevel.closedCaptions !== 'NONE';
    };
    TimelineController.prototype.onFragLoaded = function (data) {
        var frag = data.frag, payload = data.payload;
        if (frag.type === 'main') {
            var sn = frag.sn;
            // if this frag isn't contiguous, clear the parser so cues with bad start/end times aren't added to the textTrack
            if (sn !== this.lastSn + 1) {
                var cea608Parser = this.cea608Parser;
                if (cea608Parser) {
                    cea608Parser.reset();
                }
            }
            this.lastSn = sn;
        } // eslint-disable-line brace-style
        // If fragment is subtitle type, parse as WebVTT.
        else if (frag.type === 'subtitle') {
            if (payload.byteLength) {
                // We need an initial synchronisation PTS. Store fragments as long as none has arrived.
                if (!Number.isFinite(this.initPTS[frag.cc])) {
                    this.unparsedVttFrags.push(data);
                    if (this.initPTS.length) {
                        // finish unsuccessfully, otherwise the subtitle-stream-controller could be blocked from loading new frags.
                        this.hls.trigger(events_1.default.SUBTITLE_FRAG_PROCESSED, { success: false, frag: frag });
                    }
                    return;
                }
                var decryptData = frag.decryptdata;
                // If the subtitles are not encrypted, parse VTTs now. Otherwise, we need to wait.
                if ((decryptData == null) || (decryptData.key == null) || (decryptData.method !== 'AES-128')) {
                    this._parseVTTs(frag, payload);
                }
            }
            else {
                // In case there is no payload, finish unsuccessfully.
                this.hls.trigger(events_1.default.SUBTITLE_FRAG_PROCESSED, { success: false, frag: frag });
            }
        }
    };
    TimelineController.prototype._parseVTTs = function (frag, payload) {
        var vttCCs = this.vttCCs;
        if (!vttCCs[frag.cc]) {
            vttCCs[frag.cc] = { start: frag.start, prevCC: this.prevCC, new: true };
            this.prevCC = frag.cc;
        }
        var textTracks = this.textTracks, hls = this.hls;
        // Parse the WebVTT file contents.
        webvtt_parser_1.default.parse(payload, this.initPTS[frag.cc], vttCCs, frag.cc, function (cues) {
            var currentTrack = textTracks[frag.trackId];
            // WebVTTParser.parse is an async method and if the currently selected text track mode is set to "disabled"
            // before parsing is done then don't try to access currentTrack.cues.getCueById as cues will be null
            // and trying to access getCueById method of cues will throw an exception
            if (currentTrack.mode === 'disabled') {
                hls.trigger(events_1.default.SUBTITLE_FRAG_PROCESSED, { success: false, frag: frag });
                return;
            }
            // Add cues and trigger event with success true.
            cues.forEach(function (cue) {
                // Sometimes there are cue overlaps on segmented vtts so the same
                // cue can appear more than once in different vtt files.
                // This avoid showing duplicated cues with same timecode and text.
                if (!currentTrack.cues.getCueById(cue.id)) {
                    try {
                        currentTrack.addCue(cue);
                    }
                    catch (err) {
                        var textTrackCue = new window.TextTrackCue(cue.startTime, cue.endTime, cue.text);
                        textTrackCue.id = cue.id;
                        currentTrack.addCue(textTrackCue);
                    }
                }
            });
            hls.trigger(events_1.default.SUBTITLE_FRAG_PROCESSED, { success: true, frag: frag });
        }, function (e) {
            // Something went wrong while parsing. Trigger event with success false.
            logger_1.logger.log("Failed to parse VTT cue: " + e);
            hls.trigger(events_1.default.SUBTITLE_FRAG_PROCESSED, { success: false, frag: frag });
        });
    };
    TimelineController.prototype.onFragDecrypted = function (data) {
        var decryptedData = data.payload, frag = data.frag;
        if (frag.type === 'subtitle') {
            if (!Number.isFinite(this.initPTS[frag.cc])) {
                this.unparsedVttFrags.push(data);
                return;
            }
            this._parseVTTs(frag, decryptedData);
        }
    };
    TimelineController.prototype.onFragParsingUserdata = function (data) {
        // push all of the CEA-708 messages into the interpreter
        // immediately. It will create the proper timestamps based on our PTS value
        if (this.enabled && this.config.enableCEA708Captions) {
            for (var i = 0; i < data.samples.length; i++) {
                var ccdatas = this.extractCea608Data(data.samples[i].bytes);
                this.cea608Parser.addData(data.samples[i].pts, ccdatas);
            }
        }
    };
    TimelineController.prototype.extractCea608Data = function (byteArray) {
        var count = byteArray[0] & 31;
        var position = 2;
        var tmpByte, ccbyte1, ccbyte2, ccValid, ccType;
        var actualCCBytes = [];
        for (var j = 0; j < count; j++) {
            tmpByte = byteArray[position++];
            ccbyte1 = 0x7F & byteArray[position++];
            ccbyte2 = 0x7F & byteArray[position++];
            ccValid = (4 & tmpByte) !== 0;
            ccType = 3 & tmpByte;
            if (ccbyte1 === 0 && ccbyte2 === 0) {
                continue;
            }
            if (ccValid) {
                if (ccType === 0) { // || ccType === 1
                    actualCCBytes.push(ccbyte1);
                    actualCCBytes.push(ccbyte2);
                }
            }
        }
        return actualCCBytes;
    };
    return TimelineController;
}(event_handler_1.default));
exports.default = TimelineController;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./src/polyfills/number */ "./src/polyfills/number.js")["Number"]))

/***/ }),

/***/ "./src/crypt/aes-crypto.js":
/*!*********************************!*\
  !*** ./src/crypt/aes-crypto.js ***!
  \*********************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AESCrypto = /** @class */ (function () {
    function AESCrypto(subtle, iv) {
        this.subtle = subtle;
        this.aesIV = iv;
    }
    AESCrypto.prototype.decrypt = function (data, key) {
        return this.subtle.decrypt({ name: 'AES-CBC', iv: this.aesIV }, key, data);
    };
    return AESCrypto;
}());
exports.default = AESCrypto;


/***/ }),

/***/ "./src/crypt/aes-decryptor.js":
/*!************************************!*\
  !*** ./src/crypt/aes-decryptor.js ***!
  \************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// PKCS7
function removePadding(buffer) {
    var outputBytes = buffer.byteLength;
    var paddingBytes = outputBytes && (new DataView(buffer)).getUint8(outputBytes - 1);
    if (paddingBytes) {
        return buffer.slice(0, outputBytes - paddingBytes);
    }
    else {
        return buffer;
    }
}
exports.removePadding = removePadding;
var AESDecryptor = /** @class */ (function () {
    function AESDecryptor() {
        // Static after running initTable
        this.rcon = [0x0, 0x1, 0x2, 0x4, 0x8, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];
        this.subMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)];
        this.invSubMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)];
        this.sBox = new Uint32Array(256);
        this.invSBox = new Uint32Array(256);
        // Changes during runtime
        this.key = new Uint32Array(0);
        this.initTable();
    }
    // Using view.getUint32() also swaps the byte order.
    AESDecryptor.prototype.uint8ArrayToUint32Array_ = function (arrayBuffer) {
        var view = new DataView(arrayBuffer);
        var newArray = new Uint32Array(4);
        for (var i = 0; i < 4; i++) {
            newArray[i] = view.getUint32(i * 4);
        }
        return newArray;
    };
    AESDecryptor.prototype.initTable = function () {
        var sBox = this.sBox;
        var invSBox = this.invSBox;
        var subMix = this.subMix;
        var subMix0 = subMix[0];
        var subMix1 = subMix[1];
        var subMix2 = subMix[2];
        var subMix3 = subMix[3];
        var invSubMix = this.invSubMix;
        var invSubMix0 = invSubMix[0];
        var invSubMix1 = invSubMix[1];
        var invSubMix2 = invSubMix[2];
        var invSubMix3 = invSubMix[3];
        var d = new Uint32Array(256);
        var x = 0;
        var xi = 0;
        var i = 0;
        for (i = 0; i < 256; i++) {
            if (i < 128) {
                d[i] = i << 1;
            }
            else {
                d[i] = (i << 1) ^ 0x11b;
            }
        }
        for (i = 0; i < 256; i++) {
            var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
            sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
            sBox[x] = sx;
            invSBox[sx] = x;
            // Compute multiplication
            var x2 = d[x];
            var x4 = d[x2];
            var x8 = d[x4];
            // Compute sub/invSub bytes, mix columns tables
            var t = (d[sx] * 0x101) ^ (sx * 0x1010100);
            subMix0[x] = (t << 24) | (t >>> 8);
            subMix1[x] = (t << 16) | (t >>> 16);
            subMix2[x] = (t << 8) | (t >>> 24);
            subMix3[x] = t;
            // Compute inv sub bytes, inv mix columns tables
            t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
            invSubMix0[sx] = (t << 24) | (t >>> 8);
            invSubMix1[sx] = (t << 16) | (t >>> 16);
            invSubMix2[sx] = (t << 8) | (t >>> 24);
            invSubMix3[sx] = t;
            // Compute next counter
            if (!x) {
                x = xi = 1;
            }
            else {
                x = x2 ^ d[d[d[x8 ^ x2]]];
                xi ^= d[d[xi]];
            }
        }
    };
    AESDecryptor.prototype.expandKey = function (keyBuffer) {
        // convert keyBuffer to Uint32Array
        var key = this.uint8ArrayToUint32Array_(keyBuffer);
        var sameKey = true;
        var offset = 0;
        while (offset < key.length && sameKey) {
            sameKey = (key[offset] === this.key[offset]);
            offset++;
        }
        if (sameKey) {
            return;
        }
        this.key = key;
        var keySize = this.keySize = key.length;
        if (keySize !== 4 && keySize !== 6 && keySize !== 8) {
            throw new Error('Invalid aes key size=' + keySize);
        }
        var ksRows = this.ksRows = (keySize + 6 + 1) * 4;
        var ksRow;
        var invKsRow;
        var keySchedule = this.keySchedule = new Uint32Array(ksRows);
        var invKeySchedule = this.invKeySchedule = new Uint32Array(ksRows);
        var sbox = this.sBox;
        var rcon = this.rcon;
        var invSubMix = this.invSubMix;
        var invSubMix0 = invSubMix[0];
        var invSubMix1 = invSubMix[1];
        var invSubMix2 = invSubMix[2];
        var invSubMix3 = invSubMix[3];
        var prev;
        var t;
        for (ksRow = 0; ksRow < ksRows; ksRow++) {
            if (ksRow < keySize) {
                prev = keySchedule[ksRow] = key[ksRow];
                continue;
            }
            t = prev;
            if (ksRow % keySize === 0) {
                // Rot word
                t = (t << 8) | (t >>> 24);
                // Sub word
                t = (sbox[t >>> 24] << 24) | (sbox[(t >>> 16) & 0xff] << 16) | (sbox[(t >>> 8) & 0xff] << 8) | sbox[t & 0xff];
                // Mix Rcon
                t ^= rcon[(ksRow / keySize) | 0] << 24;
            }
            else if (keySize > 6 && ksRow % keySize === 4) {
                // Sub word
                t = (sbox[t >>> 24] << 24) | (sbox[(t >>> 16) & 0xff] << 16) | (sbox[(t >>> 8) & 0xff] << 8) | sbox[t & 0xff];
            }
            keySchedule[ksRow] = prev = (keySchedule[ksRow - keySize] ^ t) >>> 0;
        }
        for (invKsRow = 0; invKsRow < ksRows; invKsRow++) {
            ksRow = ksRows - invKsRow;
            if (invKsRow & 3) {
                t = keySchedule[ksRow];
            }
            else {
                t = keySchedule[ksRow - 4];
            }
            if (invKsRow < 4 || ksRow <= 4) {
                invKeySchedule[invKsRow] = t;
            }
            else {
                invKeySchedule[invKsRow] = invSubMix0[sbox[t >>> 24]] ^ invSubMix1[sbox[(t >>> 16) & 0xff]] ^ invSubMix2[sbox[(t >>> 8) & 0xff]] ^ invSubMix3[sbox[t & 0xff]];
            }
            invKeySchedule[invKsRow] = invKeySchedule[invKsRow] >>> 0;
        }
    };
    // Adding this as a method greatly improves performance.
    AESDecryptor.prototype.networkToHostOrderSwap = function (word) {
        return (word << 24) | ((word & 0xff00) << 8) | ((word & 0xff0000) >> 8) | (word >>> 24);
    };
    AESDecryptor.prototype.decrypt = function (inputArrayBuffer, offset, aesIV, removePKCS7Padding) {
        var nRounds = this.keySize + 6;
        var invKeySchedule = this.invKeySchedule;
        var invSBOX = this.invSBox;
        var invSubMix = this.invSubMix;
        var invSubMix0 = invSubMix[0];
        var invSubMix1 = invSubMix[1];
        var invSubMix2 = invSubMix[2];
        var invSubMix3 = invSubMix[3];
        var initVector = this.uint8ArrayToUint32Array_(aesIV);
        var initVector0 = initVector[0];
        var initVector1 = initVector[1];
        var initVector2 = initVector[2];
        var initVector3 = initVector[3];
        var inputInt32 = new Int32Array(inputArrayBuffer);
        var outputInt32 = new Int32Array(inputInt32.length);
        var t0, t1, t2, t3;
        var s0, s1, s2, s3;
        var inputWords0, inputWords1, inputWords2, inputWords3;
        var ksRow, i;
        var swapWord = this.networkToHostOrderSwap;
        while (offset < inputInt32.length) {
            inputWords0 = swapWord(inputInt32[offset]);
            inputWords1 = swapWord(inputInt32[offset + 1]);
            inputWords2 = swapWord(inputInt32[offset + 2]);
            inputWords3 = swapWord(inputInt32[offset + 3]);
            s0 = inputWords0 ^ invKeySchedule[0];
            s1 = inputWords3 ^ invKeySchedule[1];
            s2 = inputWords2 ^ invKeySchedule[2];
            s3 = inputWords1 ^ invKeySchedule[3];
            ksRow = 4;
            // Iterate through the rounds of decryption
            for (i = 1; i < nRounds; i++) {
                t0 = invSubMix0[s0 >>> 24] ^ invSubMix1[(s1 >> 16) & 0xff] ^ invSubMix2[(s2 >> 8) & 0xff] ^ invSubMix3[s3 & 0xff] ^ invKeySchedule[ksRow];
                t1 = invSubMix0[s1 >>> 24] ^ invSubMix1[(s2 >> 16) & 0xff] ^ invSubMix2[(s3 >> 8) & 0xff] ^ invSubMix3[s0 & 0xff] ^ invKeySchedule[ksRow + 1];
                t2 = invSubMix0[s2 >>> 24] ^ invSubMix1[(s3 >> 16) & 0xff] ^ invSubMix2[(s0 >> 8) & 0xff] ^ invSubMix3[s1 & 0xff] ^ invKeySchedule[ksRow + 2];
                t3 = invSubMix0[s3 >>> 24] ^ invSubMix1[(s0 >> 16) & 0xff] ^ invSubMix2[(s1 >> 8) & 0xff] ^ invSubMix3[s2 & 0xff] ^ invKeySchedule[ksRow + 3];
                // Update state
                s0 = t0;
                s1 = t1;
                s2 = t2;
                s3 = t3;
                ksRow = ksRow + 4;
            }
            // Shift rows, sub bytes, add round key
            t0 = ((invSBOX[s0 >>> 24] << 24) ^ (invSBOX[(s1 >> 16) & 0xff] << 16) ^ (invSBOX[(s2 >> 8) & 0xff] << 8) ^ invSBOX[s3 & 0xff]) ^ invKeySchedule[ksRow];
            t1 = ((invSBOX[s1 >>> 24] << 24) ^ (invSBOX[(s2 >> 16) & 0xff] << 16) ^ (invSBOX[(s3 >> 8) & 0xff] << 8) ^ invSBOX[s0 & 0xff]) ^ invKeySchedule[ksRow + 1];
            t2 = ((invSBOX[s2 >>> 24] << 24) ^ (invSBOX[(s3 >> 16) & 0xff] << 16) ^ (invSBOX[(s0 >> 8) & 0xff] << 8) ^ invSBOX[s1 & 0xff]) ^ invKeySchedule[ksRow + 2];
            t3 = ((invSBOX[s3 >>> 24] << 24) ^ (invSBOX[(s0 >> 16) & 0xff] << 16) ^ (invSBOX[(s1 >> 8) & 0xff] << 8) ^ invSBOX[s2 & 0xff]) ^ invKeySchedule[ksRow + 3];
            ksRow = ksRow + 3;
            // Write
            outputInt32[offset] = swapWord(t0 ^ initVector0);
            outputInt32[offset + 1] = swapWord(t3 ^ initVector1);
            outputInt32[offset + 2] = swapWord(t2 ^ initVector2);
            outputInt32[offset + 3] = swapWord(t1 ^ initVector3);
            // reset initVector to last 4 unsigned int
            initVector0 = inputWords0;
            initVector1 = inputWords1;
            initVector2 = inputWords2;
            initVector3 = inputWords3;
            offset = offset + 4;
        }
        return removePKCS7Padding ? removePadding(outputInt32.buffer) : outputInt32.buffer;
    };
    AESDecryptor.prototype.destroy = function () {
        this.key = undefined;
        this.keySize = undefined;
        this.ksRows = undefined;
        this.sBox = undefined;
        this.invSBox = undefined;
        this.subMix = undefined;
        this.invSubMix = undefined;
        this.keySchedule = undefined;
        this.invKeySchedule = undefined;
        this.rcon = undefined;
    };
    return AESDecryptor;
}());
exports.default = AESDecryptor;


/***/ }),

/***/ "./src/crypt/decrypter.js":
/*!********************************!*\
  !*** ./src/crypt/decrypter.js ***!
  \********************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var aes_crypto_1 = __webpack_require__(/*! ./aes-crypto */ "./src/crypt/aes-crypto.js");
var fast_aes_key_1 = __webpack_require__(/*! ./fast-aes-key */ "./src/crypt/fast-aes-key.js");
var aes_decryptor_1 = __webpack_require__(/*! ./aes-decryptor */ "./src/crypt/aes-decryptor.js");
var errors_1 = __webpack_require__(/*! ../errors */ "./src/errors.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var get_self_scope_1 = __webpack_require__(/*! ../utils/get-self-scope */ "./src/utils/get-self-scope.js");
// see https://stackoverflow.com/a/11237259/589493
var global = get_self_scope_1.getSelfScope(); // safeguard for code that might run both on worker and main thread
var Decrypter = /** @class */ (function () {
    function Decrypter(observer, config, _a) {
        var _b = (_a === void 0 ? {} : _a).removePKCS7Padding, removePKCS7Padding = _b === void 0 ? true : _b;
        this.logEnabled = true;
        this.observer = observer;
        this.config = config;
        this.removePKCS7Padding = removePKCS7Padding;
        // built in decryptor expects PKCS7 padding
        if (removePKCS7Padding) {
            try {
                var browserCrypto = global.crypto;
                if (browserCrypto) {
                    this.subtle = browserCrypto.subtle || browserCrypto.webkitSubtle;
                }
            }
            catch (e) { }
        }
        this.disableWebCrypto = !this.subtle;
    }
    Decrypter.prototype.isSync = function () {
        return (this.disableWebCrypto && this.config.enableSoftwareAES);
    };
    Decrypter.prototype.decrypt = function (data, key, iv, callback) {
        var _this = this;
        if (this.disableWebCrypto && this.config.enableSoftwareAES) {
            if (this.logEnabled) {
                logger_1.logger.log('JS AES decrypt');
                this.logEnabled = false;
            }
            var decryptor = this.decryptor;
            if (!decryptor) {
                this.decryptor = decryptor = new aes_decryptor_1.default();
            }
            decryptor.expandKey(key);
            callback(decryptor.decrypt(data, 0, iv, this.removePKCS7Padding));
        }
        else {
            if (this.logEnabled) {
                logger_1.logger.log('WebCrypto AES decrypt');
                this.logEnabled = false;
            }
            var subtle_1 = this.subtle;
            if (this.key !== key) {
                this.key = key;
                this.fastAesKey = new fast_aes_key_1.default(subtle_1, key);
            }
            this.fastAesKey.expandKey()
                .then(function (aesKey) {
                // decrypt using web crypto
                var crypto = new aes_crypto_1.default(subtle_1, iv);
                crypto.decrypt(data, aesKey)
                    .catch(function (err) {
                    _this.onWebCryptoError(err, data, key, iv, callback);
                })
                    .then(function (result) {
                    callback(result);
                });
            })
                .catch(function (err) {
                _this.onWebCryptoError(err, data, key, iv, callback);
            });
        }
    };
    Decrypter.prototype.onWebCryptoError = function (err, data, key, iv, callback) {
        if (this.config.enableSoftwareAES) {
            logger_1.logger.log('WebCrypto Error, disable WebCrypto API');
            this.disableWebCrypto = true;
            this.logEnabled = true;
            this.decrypt(data, key, iv, callback);
        }
        else {
            logger_1.logger.error("decrypting error : " + err.message);
            this.observer.trigger(events_1.default.ERROR, { type: errors_1.ErrorTypes.MEDIA_ERROR, details: errors_1.ErrorDetails.FRAG_DECRYPT_ERROR, fatal: true, reason: err.message });
        }
    };
    Decrypter.prototype.destroy = function () {
        var decryptor = this.decryptor;
        if (decryptor) {
            decryptor.destroy();
            this.decryptor = undefined;
        }
    };
    return Decrypter;
}());
exports.default = Decrypter;


/***/ }),

/***/ "./src/crypt/fast-aes-key.js":
/*!***********************************!*\
  !*** ./src/crypt/fast-aes-key.js ***!
  \***********************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FastAESKey = /** @class */ (function () {
    function FastAESKey(subtle, key) {
        this.subtle = subtle;
        this.key = key;
    }
    FastAESKey.prototype.expandKey = function () {
        return this.subtle.importKey('raw', this.key, { name: 'AES-CBC' }, false, ['encrypt', 'decrypt']);
    };
    return FastAESKey;
}());
exports.default = FastAESKey;


/***/ }),

/***/ "./src/demux/aacdemuxer.js":
/*!*********************************!*\
  !*** ./src/demux/aacdemuxer.js ***!
  \*********************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Number) {
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * AAC demuxer
 */
var ADTS = __webpack_require__(/*! ./adts */ "./src/demux/adts.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var id3_1 = __webpack_require__(/*! ../demux/id3 */ "./src/demux/id3.js");
var AACDemuxer = /** @class */ (function () {
    function AACDemuxer(observer, remuxer, config) {
        this.observer = observer;
        this.config = config;
        this.remuxer = remuxer;
    }
    AACDemuxer.prototype.resetInitSegment = function (initSegment, audioCodec, videoCodec, duration) {
        this._audioTrack = { container: 'audio/adts', type: 'audio', id: 0, sequenceNumber: 0, isAAC: true, samples: [], len: 0, manifestCodec: audioCodec, duration: duration, inputTimeScale: 90000 };
    };
    AACDemuxer.prototype.resetTimeStamp = function () {
    };
    AACDemuxer.probe = function (data) {
        if (!data) {
            return false;
        }
        // Check for the ADTS sync word
        // Look for ADTS header | 1111 1111 | 1111 X00X | where X can be either 0 or 1
        // Layer bits (position 14 and 15) in header should be always 0 for ADTS
        // More info https://wiki.multimedia.cx/index.php?title=ADTS
        var id3Data = id3_1.default.getID3Data(data, 0) || [];
        var offset = id3Data.length;
        for (var length_1 = data.length; offset < length_1; offset++) {
            if (ADTS.probe(data, offset)) {
                logger_1.logger.log('ADTS sync word found !');
                return true;
            }
        }
        return false;
    };
    // feed incoming data to the front of the parsing pipeline
    AACDemuxer.prototype.append = function (data, timeOffset, contiguous, accurateTimeOffset) {
        var track = this._audioTrack;
        var id3Data = id3_1.default.getID3Data(data, 0) || [];
        var timestamp = id3_1.default.getTimeStamp(id3Data);
        var pts = Number.isFinite(timestamp) ? timestamp * 90 : timeOffset * 90000;
        var frameIndex = 0;
        var stamp = pts;
        var length = data.length;
        var offset = id3Data.length;
        var id3Samples = [{ pts: stamp, dts: stamp, data: id3Data }];
        while (offset < length - 1) {
            if (ADTS.isHeader(data, offset) && (offset + 5) < length) {
                ADTS.initTrackConfig(track, this.observer, data, offset, track.manifestCodec);
                var frame = ADTS.appendFrame(track, data, offset, pts, frameIndex);
                if (frame) {
                    offset += frame.length;
                    stamp = frame.sample.pts;
                    frameIndex++;
                }
                else {
                    logger_1.logger.log('Unable to parse AAC frame');
                    break;
                }
            }
            else if (id3_1.default.isHeader(data, offset)) {
                id3Data = id3_1.default.getID3Data(data, offset);
                id3Samples.push({ pts: stamp, dts: stamp, data: id3Data });
                offset += id3Data.length;
            }
            else {
                // nothing found, keep looking
                offset++;
            }
        }
        this.remuxer.remux(track, { samples: [] }, { samples: id3Samples, inputTimeScale: 90000 }, { samples: [] }, timeOffset, contiguous, accurateTimeOffset);
    };
    AACDemuxer.prototype.destroy = function () {
    };
    return AACDemuxer;
}());
exports.default = AACDemuxer;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./src/polyfills/number */ "./src/polyfills/number.js")["Number"]))

/***/ }),

/***/ "./src/demux/adts.js":
/*!***************************!*\
  !*** ./src/demux/adts.js ***!
  \***************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 *  ADTS parser helper
 */
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var errors_1 = __webpack_require__(/*! ../errors */ "./src/errors.js");
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
function getAudioConfig(observer, data, offset, audioCodec) {
    var adtsObjectType, // :int
    adtsSampleingIndex, // :int
    adtsExtensionSampleingIndex, // :int
    adtsChanelConfig, // :int
    config, userAgent = navigator.userAgent.toLowerCase(), manifestCodec = audioCodec, adtsSampleingRates = [
        96000, 88200,
        64000, 48000,
        44100, 32000,
        24000, 22050,
        16000, 12000,
        11025, 8000,
        7350
    ];
    // byte 2
    adtsObjectType = ((data[offset + 2] & 0xC0) >>> 6) + 1;
    adtsSampleingIndex = ((data[offset + 2] & 0x3C) >>> 2);
    if (adtsSampleingIndex > adtsSampleingRates.length - 1) {
        observer.trigger(events_1.default.ERROR, { type: errors_1.ErrorTypes.MEDIA_ERROR, details: errors_1.ErrorDetails.FRAG_PARSING_ERROR, fatal: true, reason: "invalid ADTS sampling index:" + adtsSampleingIndex });
        return;
    }
    adtsChanelConfig = ((data[offset + 2] & 0x01) << 2);
    // byte 3
    adtsChanelConfig |= ((data[offset + 3] & 0xC0) >>> 6);
    logger_1.logger.log("manifest codec:" + audioCodec + ",ADTS data:type:" + adtsObjectType + ",sampleingIndex:" + adtsSampleingIndex + "[" + adtsSampleingRates[adtsSampleingIndex] + "Hz],channelConfig:" + adtsChanelConfig);
    // firefox: freq less than 24kHz = AAC SBR (HE-AAC)
    if (/firefox/i.test(userAgent)) {
        if (adtsSampleingIndex >= 6) {
            adtsObjectType = 5;
            config = new Array(4);
            // HE-AAC uses SBR (Spectral Band Replication) , high frequencies are constructed from low frequencies
            // there is a factor 2 between frame sample rate and output sample rate
            // multiply frequency by 2 (see table below, equivalent to substract 3)
            adtsExtensionSampleingIndex = adtsSampleingIndex - 3;
        }
        else {
            adtsObjectType = 2;
            config = new Array(2);
            adtsExtensionSampleingIndex = adtsSampleingIndex;
        }
        // Android : always use AAC
    }
    else if (userAgent.indexOf('android') !== -1) {
        adtsObjectType = 2;
        config = new Array(2);
        adtsExtensionSampleingIndex = adtsSampleingIndex;
    }
    else {
        /*  for other browsers (Chrome/Vivaldi/Opera ...)
            always force audio type to be HE-AAC SBR, as some browsers do not support audio codec switch properly (like Chrome ...)
        */
        adtsObjectType = 5;
        config = new Array(4);
        // if (manifest codec is HE-AAC or HE-AACv2) OR (manifest codec not specified AND frequency less than 24kHz)
        if ((audioCodec && ((audioCodec.indexOf('mp4a.40.29') !== -1) ||
            (audioCodec.indexOf('mp4a.40.5') !== -1))) ||
            (!audioCodec && adtsSampleingIndex >= 6)) {
            // HE-AAC uses SBR (Spectral Band Replication) , high frequencies are constructed from low frequencies
            // there is a factor 2 between frame sample rate and output sample rate
            // multiply frequency by 2 (see table below, equivalent to substract 3)
            adtsExtensionSampleingIndex = adtsSampleingIndex - 3;
        }
        else {
            // if (manifest codec is AAC) AND (frequency less than 24kHz AND nb channel is 1) OR (manifest codec not specified and mono audio)
            // Chrome fails to play back with low frequency AAC LC mono when initialized with HE-AAC.  This is not a problem with stereo.
            if (audioCodec && audioCodec.indexOf('mp4a.40.2') !== -1 && ((adtsSampleingIndex >= 6 && adtsChanelConfig === 1) ||
                /vivaldi/i.test(userAgent)) ||
                (!audioCodec && adtsChanelConfig === 1)) {
                adtsObjectType = 2;
                config = new Array(2);
            }
            adtsExtensionSampleingIndex = adtsSampleingIndex;
        }
    }
    /* refer to http://wiki.multimedia.cx/index.php?title=MPEG-4_Audio#Audio_Specific_Config
        ISO 14496-3 (AAC).pdf - Table 1.13 — Syntax of AudioSpecificConfig()
      Audio Profile / Audio Object Type
      0: Null
      1: AAC Main
      2: AAC LC (Low Complexity)
      3: AAC SSR (Scalable Sample Rate)
      4: AAC LTP (Long Term Prediction)
      5: SBR (Spectral Band Replication)
      6: AAC Scalable
     sampling freq
      0: 96000 Hz
      1: 88200 Hz
      2: 64000 Hz
      3: 48000 Hz
      4: 44100 Hz
      5: 32000 Hz
      6: 24000 Hz
      7: 22050 Hz
      8: 16000 Hz
      9: 12000 Hz
      10: 11025 Hz
      11: 8000 Hz
      12: 7350 Hz
      13: Reserved
      14: Reserved
      15: frequency is written explictly
      Channel Configurations
      These are the channel configurations:
      0: Defined in AOT Specifc Config
      1: 1 channel: front-center
      2: 2 channels: front-left, front-right
    */
    // audioObjectType = profile => profile, the MPEG-4 Audio Object Type minus 1
    config[0] = adtsObjectType << 3;
    // samplingFrequencyIndex
    config[0] |= (adtsSampleingIndex & 0x0E) >> 1;
    config[1] |= (adtsSampleingIndex & 0x01) << 7;
    // channelConfiguration
    config[1] |= adtsChanelConfig << 3;
    if (adtsObjectType === 5) {
        // adtsExtensionSampleingIndex
        config[1] |= (adtsExtensionSampleingIndex & 0x0E) >> 1;
        config[2] = (adtsExtensionSampleingIndex & 0x01) << 7;
        // adtsObjectType (force to 2, chrome is checking that object type is less than 5 ???
        //    https://chromium.googlesource.com/chromium/src.git/+/master/media/formats/mp4/aac.cc
        config[2] |= 2 << 2;
        config[3] = 0;
    }
    return { config: config, samplerate: adtsSampleingRates[adtsSampleingIndex], channelCount: adtsChanelConfig, codec: ('mp4a.40.' + adtsObjectType), manifestCodec: manifestCodec };
}
exports.getAudioConfig = getAudioConfig;
function isHeaderPattern(data, offset) {
    return data[offset] === 0xff && (data[offset + 1] & 0xf6) === 0xf0;
}
exports.isHeaderPattern = isHeaderPattern;
function getHeaderLength(data, offset) {
    return (data[offset + 1] & 0x01 ? 7 : 9);
}
exports.getHeaderLength = getHeaderLength;
function getFullFrameLength(data, offset) {
    return ((data[offset + 3] & 0x03) << 11) |
        (data[offset + 4] << 3) |
        ((data[offset + 5] & 0xE0) >>> 5);
}
exports.getFullFrameLength = getFullFrameLength;
function isHeader(data, offset) {
    // Look for ADTS header | 1111 1111 | 1111 X00X | where X can be either 0 or 1
    // Layer bits (position 14 and 15) in header should be always 0 for ADTS
    // More info https://wiki.multimedia.cx/index.php?title=ADTS
    if (offset + 1 < data.length && isHeaderPattern(data, offset)) {
        return true;
    }
    return false;
}
exports.isHeader = isHeader;
function probe(data, offset) {
    // same as isHeader but we also check that ADTS frame follows last ADTS frame
    // or end of data is reached
    if (offset + 1 < data.length && isHeaderPattern(data, offset)) {
        // ADTS header Length
        var headerLength = getHeaderLength(data, offset);
        // ADTS frame Length
        var frameLength = headerLength;
        if (offset + 5 < data.length) {
            frameLength = getFullFrameLength(data, offset);
        }
        var newOffset = offset + frameLength;
        if (newOffset === data.length || (newOffset + 1 < data.length && isHeaderPattern(data, newOffset))) {
            return true;
        }
    }
    return false;
}
exports.probe = probe;
function initTrackConfig(track, observer, data, offset, audioCodec) {
    if (!track.samplerate) {
        var config = getAudioConfig(observer, data, offset, audioCodec);
        track.config = config.config;
        track.samplerate = config.samplerate;
        track.channelCount = config.channelCount;
        track.codec = config.codec;
        track.manifestCodec = config.manifestCodec;
        logger_1.logger.log("parsed codec:" + track.codec + ",rate:" + config.samplerate + ",nb channel:" + config.channelCount);
    }
}
exports.initTrackConfig = initTrackConfig;
function getFrameDuration(samplerate) {
    return 1024 * 90000 / samplerate;
}
exports.getFrameDuration = getFrameDuration;
function parseFrameHeader(data, offset, pts, frameIndex, frameDuration) {
    var headerLength, frameLength, stamp;
    var length = data.length;
    // The protection skip bit tells us if we have 2 bytes of CRC data at the end of the ADTS header
    headerLength = getHeaderLength(data, offset);
    // retrieve frame size
    frameLength = getFullFrameLength(data, offset);
    frameLength -= headerLength;
    if ((frameLength > 0) && ((offset + headerLength + frameLength) <= length)) {
        stamp = pts + frameIndex * frameDuration;
        // logger.log(`AAC frame, offset/length/total/pts:${offset+headerLength}/${frameLength}/${data.byteLength}/${(stamp/90).toFixed(0)}`);
        return { headerLength: headerLength, frameLength: frameLength, stamp: stamp };
    }
    return undefined;
}
exports.parseFrameHeader = parseFrameHeader;
function appendFrame(track, data, offset, pts, frameIndex) {
    var frameDuration = getFrameDuration(track.samplerate);
    var header = parseFrameHeader(data, offset, pts, frameIndex, frameDuration);
    if (header) {
        var stamp = header.stamp;
        var headerLength = header.headerLength;
        var frameLength = header.frameLength;
        // logger.log(`AAC frame, offset/length/total/pts:${offset+headerLength}/${frameLength}/${data.byteLength}/${(stamp/90).toFixed(0)}`);
        var aacSample = {
            unit: data.subarray(offset + headerLength, offset + headerLength + frameLength),
            pts: stamp,
            dts: stamp
        };
        track.samples.push(aacSample);
        track.len += frameLength;
        return { sample: aacSample, length: frameLength + headerLength };
    }
    return undefined;
}
exports.appendFrame = appendFrame;


/***/ }),

/***/ "./src/demux/demuxer-inline.js":
/*!*************************************!*\
  !*** ./src/demux/demuxer-inline.js ***!
  \*************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 *
 * inline demuxer: probe fragments and instantiate
 * appropriate demuxer depending on content type (TSDemuxer, AACDemuxer, ...)
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var errors_1 = __webpack_require__(/*! ../errors */ "./src/errors.js");
var decrypter_1 = __webpack_require__(/*! ../crypt/decrypter */ "./src/crypt/decrypter.js");
var aacdemuxer_1 = __webpack_require__(/*! ../demux/aacdemuxer */ "./src/demux/aacdemuxer.js");
var mp4demuxer_1 = __webpack_require__(/*! ../demux/mp4demuxer */ "./src/demux/mp4demuxer.js");
var tsdemuxer_1 = __webpack_require__(/*! ../demux/tsdemuxer */ "./src/demux/tsdemuxer.js");
var mp3demuxer_1 = __webpack_require__(/*! ../demux/mp3demuxer */ "./src/demux/mp3demuxer.js");
var mp4_remuxer_1 = __webpack_require__(/*! ../remux/mp4-remuxer */ "./src/remux/mp4-remuxer.js");
var passthrough_remuxer_1 = __webpack_require__(/*! ../remux/passthrough-remuxer */ "./src/remux/passthrough-remuxer.js");
var get_self_scope_1 = __webpack_require__(/*! ../utils/get-self-scope */ "./src/utils/get-self-scope.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
// see https://stackoverflow.com/a/11237259/589493
var global = get_self_scope_1.getSelfScope(); // safeguard for code that might run both on worker and main thread
var now;
// performance.now() not available on WebWorker, at least on Safari Desktop
try {
    now = global.performance.now.bind(global.performance);
}
catch (err) {
    logger_1.logger.debug('Unable to use Performance API on this environment');
    now = global.Date.now;
}
var DemuxerInline = /** @class */ (function () {
    function DemuxerInline(observer, typeSupported, config, vendor) {
        this.observer = observer;
        this.typeSupported = typeSupported;
        this.config = config;
        this.vendor = vendor;
    }
    DemuxerInline.prototype.destroy = function () {
        var demuxer = this.demuxer;
        if (demuxer) {
            demuxer.destroy();
        }
    };
    DemuxerInline.prototype.push = function (data, decryptdata, initSegment, audioCodec, videoCodec, timeOffset, discontinuity, trackSwitch, contiguous, duration, accurateTimeOffset, defaultInitPTS) {
        var _this = this;
        if ((data.byteLength > 0) && (decryptdata != null) && (decryptdata.key != null) && (decryptdata.method === 'AES-128')) {
            var decrypter = this.decrypter;
            if (decrypter == null) {
                decrypter = this.decrypter = new decrypter_1.default(this.observer, this.config);
            }
            var startTime_1 = now();
            decrypter.decrypt(data, decryptdata.key.buffer, decryptdata.iv.buffer, function (decryptedData) {
                var endTime = now();
                _this.observer.trigger(events_1.default.FRAG_DECRYPTED, { stats: { tstart: startTime_1, tdecrypt: endTime } });
                _this.pushDecrypted(new Uint8Array(decryptedData), decryptdata, new Uint8Array(initSegment), audioCodec, videoCodec, timeOffset, discontinuity, trackSwitch, contiguous, duration, accurateTimeOffset, defaultInitPTS);
            });
        }
        else {
            this.pushDecrypted(new Uint8Array(data), decryptdata, new Uint8Array(initSegment), audioCodec, videoCodec, timeOffset, discontinuity, trackSwitch, contiguous, duration, accurateTimeOffset, defaultInitPTS);
        }
    };
    DemuxerInline.prototype.pushDecrypted = function (data, decryptdata, initSegment, audioCodec, videoCodec, timeOffset, discontinuity, trackSwitch, contiguous, duration, accurateTimeOffset, defaultInitPTS) {
        var demuxer = this.demuxer;
        if (!demuxer ||
            // in case of continuity change, or track switch
            // we might switch from content type (AAC container to TS container, or TS to fmp4 for example)
            // so let's check that current demuxer is still valid
            ((discontinuity || trackSwitch) && !this.probe(data))) {
            var observer = this.observer;
            var typeSupported = this.typeSupported;
            var config = this.config;
            // probing order is TS/AAC/MP3/MP4
            var muxConfig = [
                { demux: tsdemuxer_1.default, remux: mp4_remuxer_1.default },
                { demux: mp4demuxer_1.default, remux: passthrough_remuxer_1.default },
                { demux: aacdemuxer_1.default, remux: mp4_remuxer_1.default },
                { demux: mp3demuxer_1.default, remux: mp4_remuxer_1.default }
            ];
            // probe for content type
            for (var i = 0, len = muxConfig.length; i < len; i++) {
                var mux = muxConfig[i];
                var probe = mux.demux.probe;
                if (probe(data)) {
                    var remuxer_1 = this.remuxer = new mux.remux(observer, config, typeSupported, this.vendor);
                    demuxer = new mux.demux(observer, remuxer_1, config, typeSupported);
                    this.probe = probe;
                    break;
                }
            }
            if (!demuxer) {
                observer.trigger(events_1.default.ERROR, { type: errors_1.ErrorTypes.MEDIA_ERROR, details: errors_1.ErrorDetails.FRAG_PARSING_ERROR, fatal: true, reason: 'no demux matching with content found' });
                return;
            }
            this.demuxer = demuxer;
        }
        var remuxer = this.remuxer;
        if (discontinuity || trackSwitch) {
            demuxer.resetInitSegment(initSegment, audioCodec, videoCodec, duration);
            remuxer.resetInitSegment();
        }
        if (discontinuity) {
            demuxer.resetTimeStamp(defaultInitPTS);
            remuxer.resetTimeStamp(defaultInitPTS);
        }
        if (typeof demuxer.setDecryptData === 'function') {
            demuxer.setDecryptData(decryptdata);
        }
        demuxer.append(data, timeOffset, contiguous, accurateTimeOffset);
    };
    return DemuxerInline;
}());
exports.default = DemuxerInline;


/***/ }),

/***/ "./src/demux/demuxer-worker.js":
/*!*************************************!*\
  !*** ./src/demux/demuxer-worker.js ***!
  \*************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* demuxer web worker.
 *  - listen to worker message, and trigger DemuxerInline upon reception of Fragments.
 *  - provides MP4 Boxes back to main thread using [transferable objects](https://developers.google.com/web/updates/2011/12/Transferable-Objects-Lightning-Fast) in order to minimize message passing overhead.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var demuxer_inline_1 = __webpack_require__(/*! ../demux/demuxer-inline */ "./src/demux/demuxer-inline.js");
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var events_2 = __webpack_require__(/*! events */ "./node_modules/node-libs-browser/node_modules/events/events.js");
var DemuxerWorker = function (self) {
    // observer setup
    var observer = new events_2.EventEmitter();
    observer.trigger = function trigger(event) {
        var data = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            data[_i - 1] = arguments[_i];
        }
        observer.emit.apply(observer, [event, event].concat(data));
    };
    observer.off = function off(event) {
        var data = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            data[_i - 1] = arguments[_i];
        }
        observer.removeListener.apply(observer, [event].concat(data));
    };
    var forwardMessage = function (ev, data) {
        self.postMessage({ event: ev, data: data });
    };
    self.addEventListener('message', function (ev) {
        var data = ev.data;
        // console.log('demuxer cmd:' + data.cmd);
        switch (data.cmd) {
            case 'init':
                var config = JSON.parse(data.config);
                self.demuxer = new demuxer_inline_1.default(observer, data.typeSupported, config, data.vendor);
                logger_1.enableLogs(config.debug);
                // signal end of worker init
                forwardMessage('init', null);
                break;
            case 'demux':
                self.demuxer.push(data.data, data.decryptdata, data.initSegment, data.audioCodec, data.videoCodec, data.timeOffset, data.discontinuity, data.trackSwitch, data.contiguous, data.duration, data.accurateTimeOffset, data.defaultInitPTS);
                break;
            default:
                break;
        }
    });
    // forward events to main thread
    observer.on(events_1.default.FRAG_DECRYPTED, forwardMessage);
    observer.on(events_1.default.FRAG_PARSING_INIT_SEGMENT, forwardMessage);
    observer.on(events_1.default.FRAG_PARSED, forwardMessage);
    observer.on(events_1.default.ERROR, forwardMessage);
    observer.on(events_1.default.FRAG_PARSING_METADATA, forwardMessage);
    observer.on(events_1.default.FRAG_PARSING_USERDATA, forwardMessage);
    observer.on(events_1.default.INIT_PTS_FOUND, forwardMessage);
    // special case for FRAG_PARSING_DATA: pass data1/data2 as transferable object (no copy)
    observer.on(events_1.default.FRAG_PARSING_DATA, function (ev, data) {
        var transferable = [];
        var message = { event: ev, data: data };
        if (data.data1) {
            message.data1 = data.data1.buffer;
            transferable.push(data.data1.buffer);
            delete data.data1;
        }
        if (data.data2) {
            message.data2 = data.data2.buffer;
            transferable.push(data.data2.buffer);
            delete data.data2;
        }
        self.postMessage(message, transferable);
    });
};
exports.default = DemuxerWorker;


/***/ }),

/***/ "./src/demux/demuxer.js":
/*!******************************!*\
  !*** ./src/demux/demuxer.js ***!
  \******************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Number) {
Object.defineProperty(exports, "__esModule", { value: true });
var work = __webpack_require__(/*! webworkify-webpack */ "./node_modules/webworkify-webpack/index.js");
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var demuxer_inline_1 = __webpack_require__(/*! ../demux/demuxer-inline */ "./src/demux/demuxer-inline.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var errors_1 = __webpack_require__(/*! ../errors */ "./src/errors.js");
var mediasource_helper_1 = __webpack_require__(/*! ../utils/mediasource-helper */ "./src/utils/mediasource-helper.js");
var get_self_scope_1 = __webpack_require__(/*! ../utils/get-self-scope */ "./src/utils/get-self-scope.js");
var observer_1 = __webpack_require__(/*! ../observer */ "./src/observer.js");
// see https://stackoverflow.com/a/11237259/589493
var global = get_self_scope_1.getSelfScope(); // safeguard for code that might run both on worker and main thread
var MediaSource = mediasource_helper_1.getMediaSource();
var Demuxer = /** @class */ (function () {
    function Demuxer(hls, id) {
        var _this = this;
        this.hls = hls;
        this.id = id;
        var observer = this.observer = new observer_1.Observer();
        var config = hls.config;
        var forwardMessage = function (ev, data) {
            data = data || {};
            data.frag = _this.frag;
            data.id = _this.id;
            hls.trigger(ev, data);
        };
        // forward events to main thread
        observer.on(events_1.default.FRAG_DECRYPTED, forwardMessage);
        observer.on(events_1.default.FRAG_PARSING_INIT_SEGMENT, forwardMessage);
        observer.on(events_1.default.FRAG_PARSING_DATA, forwardMessage);
        observer.on(events_1.default.FRAG_PARSED, forwardMessage);
        observer.on(events_1.default.ERROR, forwardMessage);
        observer.on(events_1.default.FRAG_PARSING_METADATA, forwardMessage);
        observer.on(events_1.default.FRAG_PARSING_USERDATA, forwardMessage);
        observer.on(events_1.default.INIT_PTS_FOUND, forwardMessage);
        var typeSupported = {
            mp4: MediaSource.isTypeSupported('video/mp4'),
            mpeg: MediaSource.isTypeSupported('audio/mpeg'),
            mp3: MediaSource.isTypeSupported('audio/mp4; codecs="mp3"')
        };
        // navigator.vendor is not always available in Web Worker
        // refer to https://developer.mozilla.org/en-US/docs/Web/API/WorkerGlobalScope/navigator
        var vendor = navigator.vendor;
        if (config.enableWorker && (typeof (Worker) !== 'undefined')) {
            logger_1.logger.log('demuxing in webworker');
            var w = void 0;
            try {
                w = this.w = work(/*require.resolve*/(/*! ../demux/demuxer-worker.js */ "./src/demux/demuxer-worker.js"));
                this.onwmsg = this.onWorkerMessage.bind(this);
                w.addEventListener('message', this.onwmsg);
                w.onerror = function (event) {
                    hls.trigger(events_1.default.ERROR, { type: errors_1.ErrorTypes.OTHER_ERROR, details: errors_1.ErrorDetails.INTERNAL_EXCEPTION, fatal: true, event: 'demuxerWorker', err: { message: event.message + ' (' + event.filename + ':' + event.lineno + ')' } });
                };
                w.postMessage({ cmd: 'init', typeSupported: typeSupported, vendor: vendor, id: id, config: JSON.stringify(config) });
            }
            catch (err) {
                logger_1.logger.warn('Error in worker:', err);
                logger_1.logger.error('Error while initializing DemuxerWorker, fallback on DemuxerInline');
                if (w) {
                    // revoke the Object URL that was used to create demuxer worker, so as not to leak it
                    global.URL.revokeObjectURL(w.objectURL);
                }
                this.demuxer = new demuxer_inline_1.default(observer, typeSupported, config, vendor);
                this.w = undefined;
            }
        }
        else {
            this.demuxer = new demuxer_inline_1.default(observer, typeSupported, config, vendor);
        }
    }
    Demuxer.prototype.destroy = function () {
        var w = this.w;
        if (w) {
            w.removeEventListener('message', this.onwmsg);
            w.terminate();
            this.w = null;
        }
        else {
            var demuxer = this.demuxer;
            if (demuxer) {
                demuxer.destroy();
                this.demuxer = null;
            }
        }
        var observer = this.observer;
        if (observer) {
            observer.removeAllListeners();
            this.observer = null;
        }
    };
    Demuxer.prototype.push = function (data, initSegment, audioCodec, videoCodec, frag, duration, accurateTimeOffset, defaultInitPTS) {
        var w = this.w;
        var timeOffset = Number.isFinite(frag.startPTS) ? frag.startPTS : frag.start;
        var decryptdata = frag.decryptdata;
        var lastFrag = this.frag;
        var discontinuity = !(lastFrag && (frag.cc === lastFrag.cc));
        var trackSwitch = !(lastFrag && (frag.level === lastFrag.level));
        var nextSN = lastFrag && (frag.sn === (lastFrag.sn + 1));
        var contiguous = !trackSwitch && nextSN;
        if (discontinuity) {
            logger_1.logger.log(this.id + ":discontinuity detected");
        }
        if (trackSwitch) {
            logger_1.logger.log(this.id + ":switch detected");
        }
        this.frag = frag;
        if (w) {
            // post fragment payload as transferable objects for ArrayBuffer (no copy)
            w.postMessage({ cmd: 'demux', data: data, decryptdata: decryptdata, initSegment: initSegment, audioCodec: audioCodec, videoCodec: videoCodec, timeOffset: timeOffset, discontinuity: discontinuity, trackSwitch: trackSwitch, contiguous: contiguous, duration: duration, accurateTimeOffset: accurateTimeOffset, defaultInitPTS: defaultInitPTS }, data instanceof ArrayBuffer ? [data] : []);
        }
        else {
            var demuxer = this.demuxer;
            if (demuxer) {
                demuxer.push(data, decryptdata, initSegment, audioCodec, videoCodec, timeOffset, discontinuity, trackSwitch, contiguous, duration, accurateTimeOffset, defaultInitPTS);
            }
        }
    };
    Demuxer.prototype.onWorkerMessage = function (ev) {
        var data = ev.data, hls = this.hls;
        switch (data.event) {
            case 'init':
                // revoke the Object URL that was used to create demuxer worker, so as not to leak it
                global.URL.revokeObjectURL(this.w.objectURL);
                break;
            // special case for FRAG_PARSING_DATA: data1 and data2 are transferable objects
            case events_1.default.FRAG_PARSING_DATA:
                data.data.data1 = new Uint8Array(data.data1);
                if (data.data2) {
                    data.data.data2 = new Uint8Array(data.data2);
                }
            /* falls through */
            default:
                data.data = data.data || {};
                data.data.frag = this.frag;
                data.data.id = this.id;
                hls.trigger(data.event, data.data);
                break;
        }
    };
    return Demuxer;
}());
exports.default = Demuxer;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./src/polyfills/number */ "./src/polyfills/number.js")["Number"]))

/***/ }),

/***/ "./src/demux/exp-golomb.js":
/*!*********************************!*\
  !*** ./src/demux/exp-golomb.js ***!
  \*********************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Parser for exponential Golomb codes, a variable-bitwidth number encoding scheme used by h264.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var ExpGolomb = /** @class */ (function () {
    function ExpGolomb(data) {
        this.data = data;
        // the number of bytes left to examine in this.data
        this.bytesAvailable = data.byteLength;
        // the current word being examined
        this.word = 0; // :uint
        // the number of bits left to examine in the current word
        this.bitsAvailable = 0; // :uint
    }
    // ():void
    ExpGolomb.prototype.loadWord = function () {
        var data = this.data, bytesAvailable = this.bytesAvailable, position = data.byteLength - bytesAvailable, workingBytes = new Uint8Array(4), availableBytes = Math.min(4, bytesAvailable);
        if (availableBytes === 0) {
            throw new Error('no bytes available');
        }
        workingBytes.set(data.subarray(position, position + availableBytes));
        this.word = new DataView(workingBytes.buffer).getUint32(0);
        // track the amount of this.data that has been processed
        this.bitsAvailable = availableBytes * 8;
        this.bytesAvailable -= availableBytes;
    };
    // (count:int):void
    ExpGolomb.prototype.skipBits = function (count) {
        var skipBytes; // :int
        if (this.bitsAvailable > count) {
            this.word <<= count;
            this.bitsAvailable -= count;
        }
        else {
            count -= this.bitsAvailable;
            skipBytes = count >> 3;
            count -= (skipBytes >> 3);
            this.bytesAvailable -= skipBytes;
            this.loadWord();
            this.word <<= count;
            this.bitsAvailable -= count;
        }
    };
    // (size:int):uint
    ExpGolomb.prototype.readBits = function (size) {
        var bits = Math.min(this.bitsAvailable, size), // :uint
        valu = this.word >>> (32 - bits); // :uint
        if (size > 32) {
            logger_1.logger.error('Cannot read more than 32 bits at a time');
        }
        this.bitsAvailable -= bits;
        if (this.bitsAvailable > 0) {
            this.word <<= bits;
        }
        else if (this.bytesAvailable > 0) {
            this.loadWord();
        }
        bits = size - bits;
        if (bits > 0 && this.bitsAvailable) {
            return valu << bits | this.readBits(bits);
        }
        else {
            return valu;
        }
    };
    // ():uint
    ExpGolomb.prototype.skipLZ = function () {
        var leadingZeroCount; // :uint
        for (leadingZeroCount = 0; leadingZeroCount < this.bitsAvailable; ++leadingZeroCount) {
            if ((this.word & (0x80000000 >>> leadingZeroCount)) !== 0) {
                // the first bit of working word is 1
                this.word <<= leadingZeroCount;
                this.bitsAvailable -= leadingZeroCount;
                return leadingZeroCount;
            }
        }
        // we exhausted word and still have not found a 1
        this.loadWord();
        return leadingZeroCount + this.skipLZ();
    };
    // ():void
    ExpGolomb.prototype.skipUEG = function () {
        this.skipBits(1 + this.skipLZ());
    };
    // ():void
    ExpGolomb.prototype.skipEG = function () {
        this.skipBits(1 + this.skipLZ());
    };
    // ():uint
    ExpGolomb.prototype.readUEG = function () {
        var clz = this.skipLZ(); // :uint
        return this.readBits(clz + 1) - 1;
    };
    // ():int
    ExpGolomb.prototype.readEG = function () {
        var valu = this.readUEG(); // :int
        if (0x01 & valu) {
            // the number is odd if the low order bit is set
            return (1 + valu) >>> 1; // add 1 to make it even, and divide by 2
        }
        else {
            return -1 * (valu >>> 1); // divide by two then make it negative
        }
    };
    // Some convenience functions
    // :Boolean
    ExpGolomb.prototype.readBoolean = function () {
        return this.readBits(1) === 1;
    };
    // ():int
    ExpGolomb.prototype.readUByte = function () {
        return this.readBits(8);
    };
    // ():int
    ExpGolomb.prototype.readUShort = function () {
        return this.readBits(16);
    };
    // ():int
    ExpGolomb.prototype.readUInt = function () {
        return this.readBits(32);
    };
    /**
     * Advance the ExpGolomb decoder past a scaling list. The scaling
     * list is optionally transmitted as part of a sequence parameter
     * set and is not relevant to transmuxing.
     * @param count {number} the number of entries in this scaling list
     * @see Recommendation ITU-T H.264, Section 7.3.2.1.1.1
     */
    ExpGolomb.prototype.skipScalingList = function (count) {
        var lastScale = 8, nextScale = 8, j, deltaScale;
        for (j = 0; j < count; j++) {
            if (nextScale !== 0) {
                deltaScale = this.readEG();
                nextScale = (lastScale + deltaScale + 256) % 256;
            }
            lastScale = (nextScale === 0) ? lastScale : nextScale;
        }
    };
    /**
     * Read a sequence parameter set and return some interesting video
     * properties. A sequence parameter set is the H264 metadata that
     * describes the properties of upcoming video frames.
     * @param data {Uint8Array} the bytes of a sequence parameter set
     * @return {object} an object with configuration parsed from the
     * sequence parameter set, including the dimensions of the
     * associated video frames.
     */
    ExpGolomb.prototype.readSPS = function () {
        var frameCropLeftOffset = 0, frameCropRightOffset = 0, frameCropTopOffset = 0, frameCropBottomOffset = 0, profileIdc, profileCompat, levelIdc, numRefFramesInPicOrderCntCycle, picWidthInMbsMinus1, picHeightInMapUnitsMinus1, frameMbsOnlyFlag, scalingListCount, i, readUByte = this.readUByte.bind(this), readBits = this.readBits.bind(this), readUEG = this.readUEG.bind(this), readBoolean = this.readBoolean.bind(this), skipBits = this.skipBits.bind(this), skipEG = this.skipEG.bind(this), skipUEG = this.skipUEG.bind(this), skipScalingList = this.skipScalingList.bind(this);
        readUByte();
        profileIdc = readUByte(); // profile_idc
        profileCompat = readBits(5); // constraint_set[0-4]_flag, u(5)
        skipBits(3); // reserved_zero_3bits u(3),
        levelIdc = readUByte(); // level_idc u(8)
        skipUEG(); // seq_parameter_set_id
        // some profiles have more optional data we don't need
        if (profileIdc === 100 ||
            profileIdc === 110 ||
            profileIdc === 122 ||
            profileIdc === 244 ||
            profileIdc === 44 ||
            profileIdc === 83 ||
            profileIdc === 86 ||
            profileIdc === 118 ||
            profileIdc === 128) {
            var chromaFormatIdc = readUEG();
            if (chromaFormatIdc === 3) {
                skipBits(1);
            } // separate_colour_plane_flag
            skipUEG(); // bit_depth_luma_minus8
            skipUEG(); // bit_depth_chroma_minus8
            skipBits(1); // qpprime_y_zero_transform_bypass_flag
            if (readBoolean()) { // seq_scaling_matrix_present_flag
                scalingListCount = (chromaFormatIdc !== 3) ? 8 : 12;
                for (i = 0; i < scalingListCount; i++) {
                    if (readBoolean()) { // seq_scaling_list_present_flag[ i ]
                        if (i < 6) {
                            skipScalingList(16);
                        }
                        else {
                            skipScalingList(64);
                        }
                    }
                }
            }
        }
        skipUEG(); // log2_max_frame_num_minus4
        var picOrderCntType = readUEG();
        if (picOrderCntType === 0) {
            readUEG(); // log2_max_pic_order_cnt_lsb_minus4
        }
        else if (picOrderCntType === 1) {
            skipBits(1); // delta_pic_order_always_zero_flag
            skipEG(); // offset_for_non_ref_pic
            skipEG(); // offset_for_top_to_bottom_field
            numRefFramesInPicOrderCntCycle = readUEG();
            for (i = 0; i < numRefFramesInPicOrderCntCycle; i++) {
                skipEG();
            } // offset_for_ref_frame[ i ]
        }
        skipUEG(); // max_num_ref_frames
        skipBits(1); // gaps_in_frame_num_value_allowed_flag
        picWidthInMbsMinus1 = readUEG();
        picHeightInMapUnitsMinus1 = readUEG();
        frameMbsOnlyFlag = readBits(1);
        if (frameMbsOnlyFlag === 0) {
            skipBits(1);
        } // mb_adaptive_frame_field_flag
        skipBits(1); // direct_8x8_inference_flag
        if (readBoolean()) { // frame_cropping_flag
            frameCropLeftOffset = readUEG();
            frameCropRightOffset = readUEG();
            frameCropTopOffset = readUEG();
            frameCropBottomOffset = readUEG();
        }
        var pixelRatio = [1, 1];
        if (readBoolean()) {
            // vui_parameters_present_flag
            if (readBoolean()) {
                // aspect_ratio_info_present_flag
                var aspectRatioIdc = readUByte();
                switch (aspectRatioIdc) {
                    case 1:
                        pixelRatio = [1, 1];
                        break;
                    case 2:
                        pixelRatio = [12, 11];
                        break;
                    case 3:
                        pixelRatio = [10, 11];
                        break;
                    case 4:
                        pixelRatio = [16, 11];
                        break;
                    case 5:
                        pixelRatio = [40, 33];
                        break;
                    case 6:
                        pixelRatio = [24, 11];
                        break;
                    case 7:
                        pixelRatio = [20, 11];
                        break;
                    case 8:
                        pixelRatio = [32, 11];
                        break;
                    case 9:
                        pixelRatio = [80, 33];
                        break;
                    case 10:
                        pixelRatio = [18, 11];
                        break;
                    case 11:
                        pixelRatio = [15, 11];
                        break;
                    case 12:
                        pixelRatio = [64, 33];
                        break;
                    case 13:
                        pixelRatio = [160, 99];
                        break;
                    case 14:
                        pixelRatio = [4, 3];
                        break;
                    case 15:
                        pixelRatio = [3, 2];
                        break;
                    case 16:
                        pixelRatio = [2, 1];
                        break;
                    case 255: {
                        pixelRatio = [readUByte() << 8 | readUByte(), readUByte() << 8 | readUByte()];
                        break;
                    }
                }
            }
        }
        return {
            width: Math.ceil((((picWidthInMbsMinus1 + 1) * 16) - frameCropLeftOffset * 2 - frameCropRightOffset * 2)),
            height: ((2 - frameMbsOnlyFlag) * (picHeightInMapUnitsMinus1 + 1) * 16) - ((frameMbsOnlyFlag ? 2 : 4) * (frameCropTopOffset + frameCropBottomOffset)),
            pixelRatio: pixelRatio
        };
    };
    ExpGolomb.prototype.readSliceType = function () {
        // skip NALu type
        this.readUByte();
        // discard first_mb_in_slice
        this.readUEG();
        // return slice_type
        return this.readUEG();
    };
    return ExpGolomb;
}());
exports.default = ExpGolomb;


/***/ }),

/***/ "./src/demux/id3.js":
/*!**************************!*\
  !*** ./src/demux/id3.js ***!
  \**************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * ID3 parser
 */
var ID3 = /** @class */ (function () {
    function ID3() {
    }
    /**
     * Returns true if an ID3 header can be found at offset in data
     * @param {Uint8Array} data - The data to search in
     * @param {number} offset - The offset at which to start searching
     * @return {boolean} - True if an ID3 header is found
     */
    ID3.isHeader = function (data, offset) {
        /*
        * http://id3.org/id3v2.3.0
        * [0]     = 'I'
        * [1]     = 'D'
        * [2]     = '3'
        * [3,4]   = {Version}
        * [5]     = {Flags}
        * [6-9]   = {ID3 Size}
        *
        * An ID3v2 tag can be detected with the following pattern:
        *  $49 44 33 yy yy xx zz zz zz zz
        * Where yy is less than $FF, xx is the 'flags' byte and zz is less than $80
        */
        if (offset + 10 <= data.length) {
            // look for 'ID3' identifier
            if (data[offset] === 0x49 && data[offset + 1] === 0x44 && data[offset + 2] === 0x33) {
                // check version is within range
                if (data[offset + 3] < 0xFF && data[offset + 4] < 0xFF) {
                    // check size is within range
                    if (data[offset + 6] < 0x80 && data[offset + 7] < 0x80 && data[offset + 8] < 0x80 && data[offset + 9] < 0x80) {
                        return true;
                    }
                }
            }
        }
        return false;
    };
    /**
     * Returns true if an ID3 footer can be found at offset in data
     * @param {Uint8Array} data - The data to search in
     * @param {number} offset - The offset at which to start searching
     * @return {boolean} - True if an ID3 footer is found
     */
    ID3.isFooter = function (data, offset) {
        /*
        * The footer is a copy of the header, but with a different identifier
        */
        if (offset + 10 <= data.length) {
            // look for '3DI' identifier
            if (data[offset] === 0x33 && data[offset + 1] === 0x44 && data[offset + 2] === 0x49) {
                // check version is within range
                if (data[offset + 3] < 0xFF && data[offset + 4] < 0xFF) {
                    // check size is within range
                    if (data[offset + 6] < 0x80 && data[offset + 7] < 0x80 && data[offset + 8] < 0x80 && data[offset + 9] < 0x80) {
                        return true;
                    }
                }
            }
        }
        return false;
    };
    /**
     * Returns any adjacent ID3 tags found in data starting at offset, as one block of data
     * @param {Uint8Array} data - The data to search in
     * @param {number} offset - The offset at which to start searching
     * @return {Uint8Array} - The block of data containing any ID3 tags found
     */
    ID3.getID3Data = function (data, offset) {
        var front = offset;
        var length = 0;
        while (ID3.isHeader(data, offset)) {
            // ID3 header is 10 bytes
            length += 10;
            var size = ID3._readSize(data, offset + 6);
            length += size;
            if (ID3.isFooter(data, offset + 10)) {
                // ID3 footer is 10 bytes
                length += 10;
            }
            offset += length;
        }
        if (length > 0) {
            return data.subarray(front, front + length);
        }
        return undefined;
    };
    ID3._readSize = function (data, offset) {
        var size = 0;
        size = ((data[offset] & 0x7f) << 21);
        size |= ((data[offset + 1] & 0x7f) << 14);
        size |= ((data[offset + 2] & 0x7f) << 7);
        size |= (data[offset + 3] & 0x7f);
        return size;
    };
    /**
     * Searches for the Elementary Stream timestamp found in the ID3 data chunk
     * @param {Uint8Array} data - Block of data containing one or more ID3 tags
     * @return {number} - The timestamp
     */
    ID3.getTimeStamp = function (data) {
        var frames = ID3.getID3Frames(data);
        for (var i = 0; i < frames.length; i++) {
            var frame = frames[i];
            if (ID3.isTimeStampFrame(frame)) {
                return ID3._readTimeStamp(frame);
            }
        }
        return undefined;
    };
    /**
     * Returns true if the ID3 frame is an Elementary Stream timestamp frame
     * @param {ID3 frame} frame
     */
    ID3.isTimeStampFrame = function (frame) {
        return (frame && frame.key === 'PRIV' && frame.info === 'com.apple.streaming.transportStreamTimestamp');
    };
    ID3._getFrameData = function (data) {
        /*
        Frame ID       $xx xx xx xx (four characters)
        Size           $xx xx xx xx
        Flags          $xx xx
        */
        var type = String.fromCharCode(data[0], data[1], data[2], data[3]);
        var size = ID3._readSize(data, 4);
        // skip frame id, size, and flags
        var offset = 10;
        return { type: type, size: size, data: data.subarray(offset, offset + size) };
    };
    /**
     * Returns an array of ID3 frames found in all the ID3 tags in the id3Data
     * @param {Uint8Array} id3Data - The ID3 data containing one or more ID3 tags
     * @return {ID3 frame[]} - Array of ID3 frame objects
     */
    ID3.getID3Frames = function (id3Data) {
        var offset = 0;
        var frames = [];
        while (ID3.isHeader(id3Data, offset)) {
            var size = ID3._readSize(id3Data, offset + 6);
            // skip past ID3 header
            offset += 10;
            var end = offset + size;
            // loop through frames in the ID3 tag
            while (offset + 8 < end) {
                var frameData = ID3._getFrameData(id3Data.subarray(offset));
                var frame = ID3._decodeFrame(frameData);
                if (frame) {
                    frames.push(frame);
                }
                // skip frame header and frame data
                offset += frameData.size + 10;
            }
            if (ID3.isFooter(id3Data, offset)) {
                offset += 10;
            }
        }
        return frames;
    };
    ID3._decodeFrame = function (frame) {
        if (frame.type === 'PRIV') {
            return ID3._decodePrivFrame(frame);
        }
        else if (frame.type[0] === 'T') {
            return ID3._decodeTextFrame(frame);
        }
        else if (frame.type[0] === 'W') {
            return ID3._decodeURLFrame(frame);
        }
        return undefined;
    };
    ID3._readTimeStamp = function (timeStampFrame) {
        if (timeStampFrame.data.byteLength === 8) {
            var data = new Uint8Array(timeStampFrame.data);
            // timestamp is 33 bit expressed as a big-endian eight-octet number,
            // with the upper 31 bits set to zero.
            var pts33Bit = data[3] & 0x1;
            var timestamp = (data[4] << 23) +
                (data[5] << 15) +
                (data[6] << 7) +
                data[7];
            timestamp /= 45;
            if (pts33Bit) {
                timestamp += 47721858.84;
            } // 2^32 / 90
            return Math.round(timestamp);
        }
        return undefined;
    };
    ID3._decodePrivFrame = function (frame) {
        /*
        Format: <text string>\0<binary data>
        */
        if (frame.size < 2) {
            return undefined;
        }
        var owner = ID3._utf8ArrayToStr(frame.data, true);
        var privateData = new Uint8Array(frame.data.subarray(owner.length + 1));
        return { key: frame.type, info: owner, data: privateData.buffer };
    };
    ID3._decodeTextFrame = function (frame) {
        if (frame.size < 2) {
            return undefined;
        }
        if (frame.type === 'TXXX') {
            /*
            Format:
            [0]   = {Text Encoding}
            [1-?] = {Description}\0{Value}
            */
            var index = 1;
            var description = ID3._utf8ArrayToStr(frame.data.subarray(index));
            index += description.length + 1;
            var value = ID3._utf8ArrayToStr(frame.data.subarray(index));
            return { key: frame.type, info: description, data: value };
        }
        else {
            /*
            Format:
            [0]   = {Text Encoding}
            [1-?] = {Value}
            */
            var text = ID3._utf8ArrayToStr(frame.data.subarray(1));
            return { key: frame.type, data: text };
        }
    };
    ID3._decodeURLFrame = function (frame) {
        if (frame.type === 'WXXX') {
            /*
            Format:
            [0]   = {Text Encoding}
            [1-?] = {Description}\0{URL}
            */
            if (frame.size < 2) {
                return undefined;
            }
            var index = 1;
            var description = ID3._utf8ArrayToStr(frame.data.subarray(index));
            index += description.length + 1;
            var value = ID3._utf8ArrayToStr(frame.data.subarray(index));
            return { key: frame.type, info: description, data: value };
        }
        else {
            /*
            Format:
            [0-?] = {URL}
            */
            var url = ID3._utf8ArrayToStr(frame.data);
            return { key: frame.type, data: url };
        }
    };
    // http://stackoverflow.com/questions/8936984/uint8array-to-string-in-javascript/22373197
    // http://www.onicos.com/staff/iz/amuse/javascript/expert/utf.txt
    /* utf.js - UTF-8 <=> UTF-16 convertion
     *
     * Copyright (C) 1999 Masanao Izumo <iz@onicos.co.jp>
     * Version: 1.0
     * LastModified: Dec 25 1999
     * This library is free.  You can redistribute it and/or modify it.
     */
    ID3._utf8ArrayToStr = function (array, exitOnNull) {
        if (exitOnNull === void 0) { exitOnNull = false; }
        var len = array.length;
        var c;
        var char2;
        var char3;
        var out = '';
        var i = 0;
        while (i < len) {
            c = array[i++];
            if (c === 0x00 && exitOnNull) {
                return out;
            }
            else if (c === 0x00 || c === 0x03) {
                // If the character is 3 (END_OF_TEXT) or 0 (NULL) then skip it
                continue;
            }
            switch (c >> 4) {
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                    // 0xxxxxxx
                    out += String.fromCharCode(c);
                    break;
                case 12:
                case 13:
                    // 110x xxxx   10xx xxxx
                    char2 = array[i++];
                    out += String.fromCharCode(((c & 0x1F) << 6) | (char2 & 0x3F));
                    break;
                case 14:
                    // 1110 xxxx  10xx xxxx  10xx xxxx
                    char2 = array[i++];
                    char3 = array[i++];
                    out += String.fromCharCode(((c & 0x0F) << 12) |
                        ((char2 & 0x3F) << 6) |
                        ((char3 & 0x3F) << 0));
                    break;
                default:
            }
        }
        return out;
    };
    return ID3;
}());
var utf8ArrayToStr = ID3._utf8ArrayToStr;
exports.utf8ArrayToStr = utf8ArrayToStr;
exports.default = ID3;


/***/ }),

/***/ "./src/demux/mp3demuxer.js":
/*!*********************************!*\
  !*** ./src/demux/mp3demuxer.js ***!
  \*********************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * MP3 demuxer
 */
var id3_1 = __webpack_require__(/*! ../demux/id3 */ "./src/demux/id3.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var mpegaudio_1 = __webpack_require__(/*! ./mpegaudio */ "./src/demux/mpegaudio.js");
var MP3Demuxer = /** @class */ (function () {
    function MP3Demuxer(observer, remuxer, config) {
        this.observer = observer;
        this.config = config;
        this.remuxer = remuxer;
    }
    MP3Demuxer.prototype.resetInitSegment = function (initSegment, audioCodec, videoCodec, duration) {
        this._audioTrack = { container: 'audio/mpeg', type: 'audio', id: -1, sequenceNumber: 0, isAAC: false, samples: [], len: 0, manifestCodec: audioCodec, duration: duration, inputTimeScale: 90000 };
    };
    MP3Demuxer.prototype.resetTimeStamp = function () {
    };
    MP3Demuxer.probe = function (data) {
        // check if data contains ID3 timestamp and MPEG sync word
        var offset, length;
        var id3Data = id3_1.default.getID3Data(data, 0);
        if (id3Data && id3_1.default.getTimeStamp(id3Data) !== undefined) {
            // Look for MPEG header | 1111 1111 | 111X XYZX | where X can be either 0 or 1 and Y or Z should be 1
            // Layer bits (position 14 and 15) in header should be always different from 0 (Layer I or Layer II or Layer III)
            // More info http://www.mp3-tech.org/programmer/frame_header.html
            for (offset = id3Data.length, length = Math.min(data.length - 1, offset + 100); offset < length; offset++) {
                if (mpegaudio_1.default.probe(data, offset)) {
                    logger_1.logger.log('MPEG Audio sync word found !');
                    return true;
                }
            }
        }
        return false;
    };
    // feed incoming data to the front of the parsing pipeline
    MP3Demuxer.prototype.append = function (data, timeOffset, contiguous, accurateTimeOffset) {
        var id3Data = id3_1.default.getID3Data(data, 0);
        var timestamp = id3_1.default.getTimeStamp(id3Data);
        var pts = timestamp ? 90 * timestamp : timeOffset * 90000;
        var offset = id3Data.length;
        var length = data.length;
        var frameIndex = 0, stamp = 0;
        var track = this._audioTrack;
        var id3Samples = [{ pts: pts, dts: pts, data: id3Data }];
        while (offset < length) {
            if (mpegaudio_1.default.isHeader(data, offset)) {
                var frame = mpegaudio_1.default.appendFrame(track, data, offset, pts, frameIndex);
                if (frame) {
                    offset += frame.length;
                    stamp = frame.sample.pts;
                    frameIndex++;
                }
                else {
                    // logger.log('Unable to parse Mpeg audio frame');
                    break;
                }
            }
            else if (id3_1.default.isHeader(data, offset)) {
                id3Data = id3_1.default.getID3Data(data, offset);
                id3Samples.push({ pts: stamp, dts: stamp, data: id3Data });
                offset += id3Data.length;
            }
            else {
                // nothing found, keep looking
                offset++;
            }
        }
        this.remuxer.remux(track, { samples: [] }, { samples: id3Samples, inputTimeScale: 90000 }, { samples: [] }, timeOffset, contiguous, accurateTimeOffset);
    };
    MP3Demuxer.prototype.destroy = function () {
    };
    return MP3Demuxer;
}());
exports.default = MP3Demuxer;


/***/ }),

/***/ "./src/demux/mp4demuxer.js":
/*!*********************************!*\
  !*** ./src/demux/mp4demuxer.js ***!
  \*********************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * MP4 demuxer
 */
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var UINT32_MAX = Math.pow(2, 32) - 1;
var MP4Demuxer = /** @class */ (function () {
    function MP4Demuxer(observer, remuxer) {
        this.observer = observer;
        this.remuxer = remuxer;
    }
    MP4Demuxer.prototype.resetTimeStamp = function (initPTS) {
        this.initPTS = initPTS;
    };
    MP4Demuxer.prototype.resetInitSegment = function (initSegment, audioCodec, videoCodec, duration) {
        // jshint unused:false
        if (initSegment && initSegment.byteLength) {
            var initData = this.initData = MP4Demuxer.parseInitSegment(initSegment);
            // default audio codec if nothing specified
            // TODO : extract that from initsegment
            if (audioCodec == null) {
                audioCodec = 'mp4a.40.5';
            }
            if (videoCodec == null) {
                videoCodec = 'avc1.42e01e';
            }
            var tracks = {};
            if (initData.audio && initData.video) {
                tracks.audiovideo = { container: 'video/mp4', codec: audioCodec + ',' + videoCodec, initSegment: duration ? initSegment : null };
            }
            else {
                if (initData.audio) {
                    tracks.audio = { container: 'audio/mp4', codec: audioCodec, initSegment: duration ? initSegment : null };
                }
                if (initData.video) {
                    tracks.video = { container: 'video/mp4', codec: videoCodec, initSegment: duration ? initSegment : null };
                }
            }
            this.observer.trigger(events_1.default.FRAG_PARSING_INIT_SEGMENT, { tracks: tracks });
        }
        else {
            if (audioCodec) {
                this.audioCodec = audioCodec;
            }
            if (videoCodec) {
                this.videoCodec = videoCodec;
            }
        }
    };
    MP4Demuxer.probe = function (data) {
        // ensure we find a moof box in the first 16 kB
        return MP4Demuxer.findBox({ data: data, start: 0, end: Math.min(data.length, 16384) }, ['moof']).length > 0;
    };
    MP4Demuxer.bin2str = function (buffer) {
        return String.fromCharCode.apply(null, buffer);
    };
    MP4Demuxer.readUint16 = function (buffer, offset) {
        if (buffer.data) {
            offset += buffer.start;
            buffer = buffer.data;
        }
        var val = buffer[offset] << 8 |
            buffer[offset + 1];
        return val < 0 ? 65536 + val : val;
    };
    MP4Demuxer.readUint32 = function (buffer, offset) {
        if (buffer.data) {
            offset += buffer.start;
            buffer = buffer.data;
        }
        var val = buffer[offset] << 24 |
            buffer[offset + 1] << 16 |
            buffer[offset + 2] << 8 |
            buffer[offset + 3];
        return val < 0 ? 4294967296 + val : val;
    };
    MP4Demuxer.writeUint32 = function (buffer, offset, value) {
        if (buffer.data) {
            offset += buffer.start;
            buffer = buffer.data;
        }
        buffer[offset] = value >> 24;
        buffer[offset + 1] = (value >> 16) & 0xff;
        buffer[offset + 2] = (value >> 8) & 0xff;
        buffer[offset + 3] = value & 0xff;
    };
    // Find the data for a box specified by its path
    MP4Demuxer.findBox = function (data, path) {
        var results = [], i, size, type, end, subresults, start, endbox;
        if (data.data) {
            start = data.start;
            end = data.end;
            data = data.data;
        }
        else {
            start = 0;
            end = data.byteLength;
        }
        if (!path.length) {
            // short-circuit the search for empty paths
            return null;
        }
        for (i = start; i < end;) {
            size = MP4Demuxer.readUint32(data, i);
            type = MP4Demuxer.bin2str(data.subarray(i + 4, i + 8));
            endbox = size > 1 ? i + size : end;
            if (type === path[0]) {
                if (path.length === 1) {
                    // this is the end of the path and we've found the box we were
                    // looking for
                    results.push({ data: data, start: i + 8, end: endbox });
                }
                else {
                    // recursively search for the next box along the path
                    subresults = MP4Demuxer.findBox({ data: data, start: i + 8, end: endbox }, path.slice(1));
                    if (subresults.length) {
                        results = results.concat(subresults);
                    }
                }
            }
            i = endbox;
        }
        // we've finished searching all of data
        return results;
    };
    MP4Demuxer.parseSegmentIndex = function (initSegment) {
        var moov = MP4Demuxer.findBox(initSegment, ['moov'])[0];
        var moovEndOffset = moov ? moov.end : null; // we need this in case we need to chop of garbage of the end of current data
        var index = 0;
        var sidx = MP4Demuxer.findBox(initSegment, ['sidx']);
        var references;
        if (!sidx || !sidx[0]) {
            return null;
        }
        references = [];
        sidx = sidx[0];
        var version = sidx.data[0];
        // set initial offset, we skip the reference ID (not needed)
        index = version === 0 ? 8 : 16;
        var timescale = MP4Demuxer.readUint32(sidx, index);
        index += 4;
        // TODO: parse earliestPresentationTime and firstOffset
        // usually zero in our case
        var earliestPresentationTime = 0;
        var firstOffset = 0;
        if (version === 0) {
            index += 8;
        }
        else {
            index += 16;
        }
        // skip reserved
        index += 2;
        var startByte = sidx.end + firstOffset;
        var referencesCount = MP4Demuxer.readUint16(sidx, index);
        index += 2;
        for (var i = 0; i < referencesCount; i++) {
            var referenceIndex = index;
            var referenceInfo = MP4Demuxer.readUint32(sidx, referenceIndex);
            referenceIndex += 4;
            var referenceSize = referenceInfo & 0x7FFFFFFF;
            var referenceType = (referenceInfo & 0x80000000) >>> 31;
            if (referenceType === 1) {
                console.warn('SIDX has hierarchical references (not supported)');
                return;
            }
            var subsegmentDuration = MP4Demuxer.readUint32(sidx, referenceIndex);
            referenceIndex += 4;
            references.push({
                referenceSize: referenceSize,
                subsegmentDuration: subsegmentDuration,
                info: {
                    duration: subsegmentDuration / timescale,
                    start: startByte,
                    end: startByte + referenceSize - 1
                }
            });
            startByte += referenceSize;
            // Skipping 1 bit for |startsWithSap|, 3 bits for |sapType|, and 28 bits
            // for |sapDelta|.
            referenceIndex += 4;
            // skip to next ref
            index = referenceIndex;
        }
        return {
            earliestPresentationTime: earliestPresentationTime,
            timescale: timescale,
            version: version,
            referencesCount: referencesCount,
            references: references,
            moovEndOffset: moovEndOffset
        };
    };
    /**
     * Parses an MP4 initialization segment and extracts stream type and
     * timescale values for any declared tracks. Timescale values indicate the
     * number of clock ticks per second to assume for time-based values
     * elsewhere in the MP4.
     *
     * To determine the start time of an MP4, you need two pieces of
     * information: the timescale unit and the earliest base media decode
     * time. Multiple timescales can be specified within an MP4 but the
     * base media decode time is always expressed in the timescale from
     * the media header box for the track:
     * ```
     * moov > trak > mdia > mdhd.timescale
     * moov > trak > mdia > hdlr
     * ```
     * @param init {Uint8Array} the bytes of the init segment
     * @return {object} a hash of track type to timescale values or null if
     * the init segment is malformed.
     */
    MP4Demuxer.parseInitSegment = function (initSegment) {
        var result = [];
        var traks = MP4Demuxer.findBox(initSegment, ['moov', 'trak']);
        traks.forEach(function (trak) {
            var tkhd = MP4Demuxer.findBox(trak, ['tkhd'])[0];
            if (tkhd) {
                var version = tkhd.data[tkhd.start];
                var index = version === 0 ? 12 : 20;
                var trackId = MP4Demuxer.readUint32(tkhd, index);
                var mdhd = MP4Demuxer.findBox(trak, ['mdia', 'mdhd'])[0];
                if (mdhd) {
                    version = mdhd.data[mdhd.start];
                    index = version === 0 ? 12 : 20;
                    var timescale = MP4Demuxer.readUint32(mdhd, index);
                    var hdlr = MP4Demuxer.findBox(trak, ['mdia', 'hdlr'])[0];
                    if (hdlr) {
                        var hdlrType = MP4Demuxer.bin2str(hdlr.data.subarray(hdlr.start + 8, hdlr.start + 12));
                        var type = { 'soun': 'audio', 'vide': 'video' }[hdlrType];
                        if (type) {
                            // extract codec info. TODO : parse codec details to be able to build MIME type
                            var codecBox = MP4Demuxer.findBox(trak, ['mdia', 'minf', 'stbl', 'stsd']);
                            if (codecBox.length) {
                                codecBox = codecBox[0];
                                var codecType = MP4Demuxer.bin2str(codecBox.data.subarray(codecBox.start + 12, codecBox.start + 16));
                                logger_1.logger.log("MP4Demuxer:" + type + ":" + codecType + " found");
                            }
                            result[trackId] = { timescale: timescale, type: type };
                            result[type] = { timescale: timescale, id: trackId };
                        }
                    }
                }
            }
        });
        return result;
    };
    /**
   * Determine the base media decode start time, in seconds, for an MP4
   * fragment. If multiple fragments are specified, the earliest time is
   * returned.
   *
   * The base media decode time can be parsed from track fragment
   * metadata:
   * ```
   * moof > traf > tfdt.baseMediaDecodeTime
   * ```
   * It requires the timescale value from the mdhd to interpret.
   *
   * @param timescale {object} a hash of track ids to timescale values.
   * @return {number} the earliest base media decode start time for the
   * fragment, in seconds
   */
    MP4Demuxer.getStartDTS = function (initData, fragment) {
        var trafs, baseTimes, result;
        // we need info from two childrend of each track fragment box
        trafs = MP4Demuxer.findBox(fragment, ['moof', 'traf']);
        // determine the start times for each track
        baseTimes = [].concat.apply([], trafs.map(function (traf) {
            return MP4Demuxer.findBox(traf, ['tfhd']).map(function (tfhd) {
                var id, scale, baseTime;
                // get the track id from the tfhd
                id = MP4Demuxer.readUint32(tfhd, 4);
                // assume a 90kHz clock if no timescale was specified
                scale = initData[id].timescale || 90e3;
                // get the base media decode time from the tfdt
                baseTime = MP4Demuxer.findBox(traf, ['tfdt']).map(function (tfdt) {
                    var version, result;
                    version = tfdt.data[tfdt.start];
                    result = MP4Demuxer.readUint32(tfdt, 4);
                    if (version === 1) {
                        result *= Math.pow(2, 32);
                        result += MP4Demuxer.readUint32(tfdt, 8);
                    }
                    return result;
                })[0];
                // convert base time to seconds
                return baseTime / scale;
            });
        }));
        // return the minimum
        result = Math.min.apply(null, baseTimes);
        return isFinite(result) ? result : 0;
    };
    MP4Demuxer.offsetStartDTS = function (initData, fragment, timeOffset) {
        MP4Demuxer.findBox(fragment, ['moof', 'traf']).map(function (traf) {
            return MP4Demuxer.findBox(traf, ['tfhd']).map(function (tfhd) {
                // get the track id from the tfhd
                var id = MP4Demuxer.readUint32(tfhd, 4);
                // assume a 90kHz clock if no timescale was specified
                var timescale = initData[id].timescale || 90e3;
                // get the base media decode time from the tfdt
                MP4Demuxer.findBox(traf, ['tfdt']).map(function (tfdt) {
                    var version = tfdt.data[tfdt.start];
                    var baseMediaDecodeTime = MP4Demuxer.readUint32(tfdt, 4);
                    if (version === 0) {
                        MP4Demuxer.writeUint32(tfdt, 4, baseMediaDecodeTime - timeOffset * timescale);
                    }
                    else {
                        baseMediaDecodeTime *= Math.pow(2, 32);
                        baseMediaDecodeTime += MP4Demuxer.readUint32(tfdt, 8);
                        baseMediaDecodeTime -= timeOffset * timescale;
                        baseMediaDecodeTime = Math.max(baseMediaDecodeTime, 0);
                        var upper = Math.floor(baseMediaDecodeTime / (UINT32_MAX + 1));
                        var lower = Math.floor(baseMediaDecodeTime % (UINT32_MAX + 1));
                        MP4Demuxer.writeUint32(tfdt, 4, upper);
                        MP4Demuxer.writeUint32(tfdt, 8, lower);
                    }
                });
            });
        });
    };
    // feed incoming data to the front of the parsing pipeline
    MP4Demuxer.prototype.append = function (data, timeOffset, contiguous, accurateTimeOffset) {
        var initData = this.initData;
        if (!initData) {
            this.resetInitSegment(data, this.audioCodec, this.videoCodec, false);
            initData = this.initData;
        }
        var startDTS, initPTS = this.initPTS;
        if (initPTS === undefined) {
            var startDTS_1 = MP4Demuxer.getStartDTS(initData, data);
            this.initPTS = initPTS = startDTS_1 - timeOffset;
            this.observer.trigger(events_1.default.INIT_PTS_FOUND, { initPTS: initPTS });
        }
        MP4Demuxer.offsetStartDTS(initData, data, initPTS);
        startDTS = MP4Demuxer.getStartDTS(initData, data);
        this.remuxer.remux(initData.audio, initData.video, null, null, startDTS, contiguous, accurateTimeOffset, data);
    };
    MP4Demuxer.prototype.destroy = function () { };
    return MP4Demuxer;
}());
exports.default = MP4Demuxer;


/***/ }),

/***/ "./src/demux/mpegaudio.js":
/*!********************************!*\
  !*** ./src/demux/mpegaudio.js ***!
  \********************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 *  MPEG parser helper
 */
Object.defineProperty(exports, "__esModule", { value: true });
var MpegAudio = {
    BitratesMap: [
        32, 64, 96, 128, 160, 192, 224, 256, 288, 320, 352, 384, 416, 448,
        32, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 384,
        32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320,
        32, 48, 56, 64, 80, 96, 112, 128, 144, 160, 176, 192, 224, 256,
        8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160
    ],
    SamplingRateMap: [44100, 48000, 32000, 22050, 24000, 16000, 11025, 12000, 8000],
    SamplesCoefficients: [
        // MPEG 2.5
        [
            0,
            72,
            144,
            12 // Layer1
        ],
        // Reserved
        [
            0,
            0,
            0,
            0 // Layer1
        ],
        // MPEG 2
        [
            0,
            72,
            144,
            12 // Layer1
        ],
        // MPEG 1
        [
            0,
            144,
            144,
            12 // Layer1
        ]
    ],
    BytesInSlot: [
        0,
        1,
        1,
        4 // Layer1
    ],
    appendFrame: function (track, data, offset, pts, frameIndex) {
        // Using http://www.datavoyage.com/mpgscript/mpeghdr.htm as a reference
        if (offset + 24 > data.length) {
            return undefined;
        }
        var header = this.parseHeader(data, offset);
        if (header && offset + header.frameLength <= data.length) {
            var frameDuration = header.samplesPerFrame * 90000 / header.sampleRate;
            var stamp = pts + frameIndex * frameDuration;
            var sample = { unit: data.subarray(offset, offset + header.frameLength), pts: stamp, dts: stamp };
            track.config = [];
            track.channelCount = header.channelCount;
            track.samplerate = header.sampleRate;
            track.samples.push(sample);
            track.len += header.frameLength;
            return { sample: sample, length: header.frameLength };
        }
        return undefined;
    },
    parseHeader: function (data, offset) {
        var headerB = (data[offset + 1] >> 3) & 3;
        var headerC = (data[offset + 1] >> 1) & 3;
        var headerE = (data[offset + 2] >> 4) & 15;
        var headerF = (data[offset + 2] >> 2) & 3;
        var headerG = (data[offset + 2] >> 1) & 1;
        if (headerB !== 1 && headerE !== 0 && headerE !== 15 && headerF !== 3) {
            var columnInBitrates = headerB === 3 ? (3 - headerC) : (headerC === 3 ? 3 : 4);
            var bitRate = MpegAudio.BitratesMap[columnInBitrates * 14 + headerE - 1] * 1000;
            var columnInSampleRates = headerB === 3 ? 0 : headerB === 2 ? 1 : 2;
            var sampleRate = MpegAudio.SamplingRateMap[columnInSampleRates * 3 + headerF];
            var channelCount = data[offset + 3] >> 6 === 3 ? 1 : 2; // If bits of channel mode are `11` then it is a single channel (Mono)
            var sampleCoefficient = MpegAudio.SamplesCoefficients[headerB][headerC];
            var bytesInSlot = MpegAudio.BytesInSlot[headerC];
            var samplesPerFrame = sampleCoefficient * 8 * bytesInSlot;
            var frameLength = parseInt(sampleCoefficient * bitRate / sampleRate + headerG, 10) * bytesInSlot;
            return { sampleRate: sampleRate, channelCount: channelCount, frameLength: frameLength, samplesPerFrame: samplesPerFrame };
        }
        return undefined;
    },
    isHeaderPattern: function (data, offset) {
        return data[offset] === 0xff && (data[offset + 1] & 0xe0) === 0xe0 && (data[offset + 1] & 0x06) !== 0x00;
    },
    isHeader: function (data, offset) {
        // Look for MPEG header | 1111 1111 | 111X XYZX | where X can be either 0 or 1 and Y or Z should be 1
        // Layer bits (position 14 and 15) in header should be always different from 0 (Layer I or Layer II or Layer III)
        // More info http://www.mp3-tech.org/programmer/frame_header.html
        if (offset + 1 < data.length && this.isHeaderPattern(data, offset)) {
            return true;
        }
        return false;
    },
    probe: function (data, offset) {
        // same as isHeader but we also check that MPEG frame follows last MPEG frame
        // or end of data is reached
        if (offset + 1 < data.length && this.isHeaderPattern(data, offset)) {
            // MPEG header Length
            var headerLength = 4;
            // MPEG frame Length
            var header = this.parseHeader(data, offset);
            var frameLength = headerLength;
            if (header && header.frameLength) {
                frameLength = header.frameLength;
            }
            var newOffset = offset + frameLength;
            if (newOffset === data.length || (newOffset + 1 < data.length && this.isHeaderPattern(data, newOffset))) {
                return true;
            }
        }
        return false;
    }
};
exports.default = MpegAudio;


/***/ }),

/***/ "./src/demux/sample-aes.js":
/*!*********************************!*\
  !*** ./src/demux/sample-aes.js ***!
  \*********************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * SAMPLE-AES decrypter
*/
Object.defineProperty(exports, "__esModule", { value: true });
var decrypter_1 = __webpack_require__(/*! ../crypt/decrypter */ "./src/crypt/decrypter.js");
var SampleAesDecrypter = /** @class */ (function () {
    function SampleAesDecrypter(observer, config, decryptdata, discardEPB) {
        this.decryptdata = decryptdata;
        this.discardEPB = discardEPB;
        this.decrypter = new decrypter_1.default(observer, config, { removePKCS7Padding: false });
    }
    SampleAesDecrypter.prototype.decryptBuffer = function (encryptedData, callback) {
        this.decrypter.decrypt(encryptedData, this.decryptdata.key.buffer, this.decryptdata.iv.buffer, callback);
    };
    // AAC - encrypt all full 16 bytes blocks starting from offset 16
    SampleAesDecrypter.prototype.decryptAacSample = function (samples, sampleIndex, callback, sync) {
        var curUnit = samples[sampleIndex].unit;
        var encryptedData = curUnit.subarray(16, curUnit.length - curUnit.length % 16);
        var encryptedBuffer = encryptedData.buffer.slice(encryptedData.byteOffset, encryptedData.byteOffset + encryptedData.length);
        var localthis = this;
        this.decryptBuffer(encryptedBuffer, function (decryptedData) {
            decryptedData = new Uint8Array(decryptedData);
            curUnit.set(decryptedData, 16);
            if (!sync) {
                localthis.decryptAacSamples(samples, sampleIndex + 1, callback);
            }
        });
    };
    SampleAesDecrypter.prototype.decryptAacSamples = function (samples, sampleIndex, callback) {
        for (;; sampleIndex++) {
            if (sampleIndex >= samples.length) {
                callback();
                return;
            }
            if (samples[sampleIndex].unit.length < 32) {
                continue;
            }
            var sync = this.decrypter.isSync();
            this.decryptAacSample(samples, sampleIndex, callback, sync);
            if (!sync) {
                return;
            }
        }
    };
    // AVC - encrypt one 16 bytes block out of ten, starting from offset 32
    SampleAesDecrypter.prototype.getAvcEncryptedData = function (decodedData) {
        var encryptedDataLen = Math.floor((decodedData.length - 48) / 160) * 16 + 16;
        var encryptedData = new Int8Array(encryptedDataLen);
        var outputPos = 0;
        for (var inputPos = 32; inputPos <= decodedData.length - 16; inputPos += 160, outputPos += 16) {
            encryptedData.set(decodedData.subarray(inputPos, inputPos + 16), outputPos);
        }
        return encryptedData;
    };
    SampleAesDecrypter.prototype.getAvcDecryptedUnit = function (decodedData, decryptedData) {
        decryptedData = new Uint8Array(decryptedData);
        var inputPos = 0;
        for (var outputPos = 32; outputPos <= decodedData.length - 16; outputPos += 160, inputPos += 16) {
            decodedData.set(decryptedData.subarray(inputPos, inputPos + 16), outputPos);
        }
        return decodedData;
    };
    SampleAesDecrypter.prototype.decryptAvcSample = function (samples, sampleIndex, unitIndex, callback, curUnit, sync) {
        var decodedData = this.discardEPB(curUnit.data);
        var encryptedData = this.getAvcEncryptedData(decodedData);
        var localthis = this;
        this.decryptBuffer(encryptedData.buffer, function (decryptedData) {
            curUnit.data = localthis.getAvcDecryptedUnit(decodedData, decryptedData);
            if (!sync) {
                localthis.decryptAvcSamples(samples, sampleIndex, unitIndex + 1, callback);
            }
        });
    };
    SampleAesDecrypter.prototype.decryptAvcSamples = function (samples, sampleIndex, unitIndex, callback) {
        for (;; sampleIndex++, unitIndex = 0) {
            if (sampleIndex >= samples.length) {
                callback();
                return;
            }
            var curUnits = samples[sampleIndex].units;
            for (;; unitIndex++) {
                if (unitIndex >= curUnits.length) {
                    break;
                }
                var curUnit = curUnits[unitIndex];
                if (curUnit.length <= 48 || (curUnit.type !== 1 && curUnit.type !== 5)) {
                    continue;
                }
                var sync = this.decrypter.isSync();
                this.decryptAvcSample(samples, sampleIndex, unitIndex, callback, curUnit, sync);
                if (!sync) {
                    return;
                }
            }
        }
    };
    return SampleAesDecrypter;
}());
exports.default = SampleAesDecrypter;


/***/ }),

/***/ "./src/demux/tsdemuxer.js":
/*!********************************!*\
  !*** ./src/demux/tsdemuxer.js ***!
  \********************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * highly optimized TS demuxer:
 * parse PAT, PMT
 * extract PES packet from audio and video PIDs
 * extract AVC/H264 NAL units and AAC/ADTS samples from PES packet
 * trigger the remuxer upon parsing completion
 * it also tries to workaround as best as it can audio codec switch (HE-AAC to AAC and vice versa), without having to restart the MediaSource.
 * it also controls the remuxing process :
 * upon discontinuity or level switch detection, it will also notifies the remuxer so that it can reset its state.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var ADTS = __webpack_require__(/*! ./adts */ "./src/demux/adts.js");
var mpegaudio_1 = __webpack_require__(/*! ./mpegaudio */ "./src/demux/mpegaudio.js");
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var exp_golomb_1 = __webpack_require__(/*! ./exp-golomb */ "./src/demux/exp-golomb.js");
var sample_aes_1 = __webpack_require__(/*! ./sample-aes */ "./src/demux/sample-aes.js");
// import Hex from '../utils/hex';
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var errors_1 = __webpack_require__(/*! ../errors */ "./src/errors.js");
// We are using fixed track IDs for driving the MP4 remuxer
// instead of following the TS PIDs.
// There is no reason not to do this and some browsers/SourceBuffer-demuxers
// may not like if there are TrackID "switches"
// See https://github.com/video-dev/hls.js/issues/1331
// Here we are mapping our internal track types to constant MP4 track IDs
// With MSE currently one can only have one track of each, and we are muxing
// whatever video/audio rendition in them.
var RemuxerTrackIdConfig = {
    video: 1,
    audio: 2,
    id3: 3,
    text: 4
};
var TSDemuxer = /** @class */ (function () {
    function TSDemuxer(observer, remuxer, config, typeSupported) {
        this.observer = observer;
        this.config = config;
        this.typeSupported = typeSupported;
        this.remuxer = remuxer;
        this.sampleAes = null;
    }
    TSDemuxer.prototype.setDecryptData = function (decryptdata) {
        if ((decryptdata != null) && (decryptdata.key != null) && (decryptdata.method === 'SAMPLE-AES')) {
            this.sampleAes = new sample_aes_1.default(this.observer, this.config, decryptdata, this.discardEPB);
        }
        else {
            this.sampleAes = null;
        }
    };
    TSDemuxer.probe = function (data) {
        var syncOffset = TSDemuxer._syncOffset(data);
        if (syncOffset < 0) {
            return false;
        }
        else {
            if (syncOffset) {
                logger_1.logger.warn("MPEG2-TS detected but first sync word found @ offset " + syncOffset + ", junk ahead ?");
            }
            return true;
        }
    };
    TSDemuxer._syncOffset = function (data) {
        // scan 1000 first bytes
        var scanwindow = Math.min(1000, data.length - 3 * 188);
        var i = 0;
        while (i < scanwindow) {
            // a TS fragment should contain at least 3 TS packets, a PAT, a PMT, and one PID, each starting with 0x47
            if (data[i] === 0x47 && data[i + 188] === 0x47 && data[i + 2 * 188] === 0x47) {
                return i;
            }
            else {
                i++;
            }
        }
        return -1;
    };
    /**
     * Creates a track model internal to demuxer used to drive remuxing input
     *
     * @param {string} type 'audio' | 'video' | 'id3' | 'text'
     * @param {number} duration
     * @return {object} TSDemuxer's internal track model
     */
    TSDemuxer.createTrack = function (type, duration) {
        return {
            container: type === 'video' || type === 'audio' ? 'video/mp2t' : undefined,
            type: type,
            id: RemuxerTrackIdConfig[type],
            pid: -1,
            inputTimeScale: 90000,
            sequenceNumber: 0,
            samples: [],
            len: 0,
            dropped: type === 'video' ? 0 : undefined,
            isAAC: type === 'audio' ? true : undefined,
            duration: type === 'audio' ? duration : undefined
        };
    };
    /**
     * Initializes a new init segment on the demuxer/remuxer interface. Needed for discontinuities/track-switches (or at stream start)
     * Resets all internal track instances of the demuxer.
     *
     * @override Implements generic demuxing/remuxing interface (see DemuxerInline)
     * @param {object} initSegment
     * @param {string} audioCodec
     * @param {string} videoCodec
     * @param {number} duration (in TS timescale = 90kHz)
     */
    TSDemuxer.prototype.resetInitSegment = function (initSegment, audioCodec, videoCodec, duration) {
        this.pmtParsed = false;
        this._pmtId = -1;
        this._avcTrack = TSDemuxer.createTrack('video', duration);
        this._audioTrack = TSDemuxer.createTrack('audio', duration);
        this._id3Track = TSDemuxer.createTrack('id3', duration);
        this._txtTrack = TSDemuxer.createTrack('text', duration);
        // flush any partial content
        this.aacOverFlow = null;
        this.aacLastPTS = null;
        this.avcSample = null;
        this.audioCodec = audioCodec;
        this.videoCodec = videoCodec;
        this._duration = duration;
    };
    /**
     *
     * @override
     */
    TSDemuxer.prototype.resetTimeStamp = function () { };
    // feed incoming data to the front of the parsing pipeline
    TSDemuxer.prototype.append = function (data, timeOffset, contiguous, accurateTimeOffset) {
        var start, len = data.length, stt, pid, atf, offset, pes, unknownPIDs = false;
        this.contiguous = contiguous;
        var pmtParsed = this.pmtParsed, avcTrack = this._avcTrack, audioTrack = this._audioTrack, id3Track = this._id3Track, avcId = avcTrack.pid, audioId = audioTrack.pid, id3Id = id3Track.pid, pmtId = this._pmtId, avcData = avcTrack.pesData, audioData = audioTrack.pesData, id3Data = id3Track.pesData, parsePAT = this._parsePAT, parsePMT = this._parsePMT, parsePES = this._parsePES, parseAVCPES = this._parseAVCPES.bind(this), parseAACPES = this._parseAACPES.bind(this), parseMPEGPES = this._parseMPEGPES.bind(this), parseID3PES = this._parseID3PES.bind(this);
        var syncOffset = TSDemuxer._syncOffset(data);
        // don't parse last TS packet if incomplete
        len -= (len + syncOffset) % 188;
        // loop through TS packets
        for (start = syncOffset; start < len; start += 188) {
            if (data[start] === 0x47) {
                stt = !!(data[start + 1] & 0x40);
                // pid is a 13-bit field starting at the last bit of TS[1]
                pid = ((data[start + 1] & 0x1f) << 8) + data[start + 2];
                atf = (data[start + 3] & 0x30) >> 4;
                // if an adaption field is present, its length is specified by the fifth byte of the TS packet header.
                if (atf > 1) {
                    offset = start + 5 + data[start + 4];
                    // continue if there is only adaptation field
                    if (offset === (start + 188)) {
                        continue;
                    }
                }
                else {
                    offset = start + 4;
                }
                switch (pid) {
                    case avcId:
                        if (stt) {
                            if (avcData && (pes = parsePES(avcData)) && pes.pts !== undefined) {
                                parseAVCPES(pes, false);
                            }
                            avcData = { data: [], size: 0 };
                        }
                        if (avcData) {
                            avcData.data.push(data.subarray(offset, start + 188));
                            avcData.size += start + 188 - offset;
                        }
                        break;
                    case audioId:
                        if (stt) {
                            if (audioData && (pes = parsePES(audioData)) && pes.pts !== undefined) {
                                if (audioTrack.isAAC) {
                                    parseAACPES(pes);
                                }
                                else {
                                    parseMPEGPES(pes);
                                }
                            }
                            audioData = { data: [], size: 0 };
                        }
                        if (audioData) {
                            audioData.data.push(data.subarray(offset, start + 188));
                            audioData.size += start + 188 - offset;
                        }
                        break;
                    case id3Id:
                        if (stt) {
                            if (id3Data && (pes = parsePES(id3Data)) && pes.pts !== undefined) {
                                parseID3PES(pes);
                            }
                            id3Data = { data: [], size: 0 };
                        }
                        if (id3Data) {
                            id3Data.data.push(data.subarray(offset, start + 188));
                            id3Data.size += start + 188 - offset;
                        }
                        break;
                    case 0:
                        if (stt) {
                            offset += data[offset] + 1;
                        }
                        pmtId = this._pmtId = parsePAT(data, offset);
                        break;
                    case pmtId:
                        if (stt) {
                            offset += data[offset] + 1;
                        }
                        var parsedPIDs = parsePMT(data, offset, this.typeSupported.mpeg === true || this.typeSupported.mp3 === true, this.sampleAes != null);
                        // only update track id if track PID found while parsing PMT
                        // this is to avoid resetting the PID to -1 in case
                        // track PID transiently disappears from the stream
                        // this could happen in case of transient missing audio samples for example
                        // NOTE this is only the PID of the track as found in TS,
                        // but we are not using this for MP4 track IDs.
                        avcId = parsedPIDs.avc;
                        if (avcId > 0) {
                            avcTrack.pid = avcId;
                        }
                        audioId = parsedPIDs.audio;
                        if (audioId > 0) {
                            audioTrack.pid = audioId;
                            audioTrack.isAAC = parsedPIDs.isAAC;
                        }
                        id3Id = parsedPIDs.id3;
                        if (id3Id > 0) {
                            id3Track.pid = id3Id;
                        }
                        if (unknownPIDs && !pmtParsed) {
                            logger_1.logger.log('reparse from beginning');
                            unknownPIDs = false;
                            // we set it to -188, the += 188 in the for loop will reset start to 0
                            start = syncOffset - 188;
                        }
                        pmtParsed = this.pmtParsed = true;
                        break;
                    case 17:
                    case 0x1fff:
                        break;
                    default:
                        unknownPIDs = true;
                        break;
                }
            }
            else {
                this.observer.trigger(events_1.default.ERROR, { type: errors_1.ErrorTypes.MEDIA_ERROR, details: errors_1.ErrorDetails.FRAG_PARSING_ERROR, fatal: false, reason: 'TS packet did not start with 0x47' });
            }
        }
        // try to parse last PES packets
        if (avcData && (pes = parsePES(avcData)) && pes.pts !== undefined) {
            parseAVCPES(pes, true);
            avcTrack.pesData = null;
        }
        else {
            // either avcData null or PES truncated, keep it for next frag parsing
            avcTrack.pesData = avcData;
        }
        if (audioData && (pes = parsePES(audioData)) && pes.pts !== undefined) {
            if (audioTrack.isAAC) {
                parseAACPES(pes);
            }
            else {
                parseMPEGPES(pes);
            }
            audioTrack.pesData = null;
        }
        else {
            if (audioData && audioData.size) {
                logger_1.logger.log('last AAC PES packet truncated,might overlap between fragments');
            }
            // either audioData null or PES truncated, keep it for next frag parsing
            audioTrack.pesData = audioData;
        }
        if (id3Data && (pes = parsePES(id3Data)) && pes.pts !== undefined) {
            parseID3PES(pes);
            id3Track.pesData = null;
        }
        else {
            // either id3Data null or PES truncated, keep it for next frag parsing
            id3Track.pesData = id3Data;
        }
        if (this.sampleAes == null) {
            this.remuxer.remux(audioTrack, avcTrack, id3Track, this._txtTrack, timeOffset, contiguous, accurateTimeOffset);
        }
        else {
            this.decryptAndRemux(audioTrack, avcTrack, id3Track, this._txtTrack, timeOffset, contiguous, accurateTimeOffset);
        }
    };
    TSDemuxer.prototype.decryptAndRemux = function (audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset) {
        if (audioTrack.samples && audioTrack.isAAC) {
            var localthis_1 = this;
            this.sampleAes.decryptAacSamples(audioTrack.samples, 0, function () {
                localthis_1.decryptAndRemuxAvc(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset);
            });
        }
        else {
            this.decryptAndRemuxAvc(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset);
        }
    };
    TSDemuxer.prototype.decryptAndRemuxAvc = function (audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset) {
        if (videoTrack.samples) {
            var localthis_2 = this;
            this.sampleAes.decryptAvcSamples(videoTrack.samples, 0, 0, function () {
                localthis_2.remuxer.remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset);
            });
        }
        else {
            this.remuxer.remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset);
        }
    };
    TSDemuxer.prototype.destroy = function () {
        this._initPTS = this._initDTS = undefined;
        this._duration = 0;
    };
    TSDemuxer.prototype._parsePAT = function (data, offset) {
        // skip the PSI header and parse the first PMT entry
        return (data[offset + 10] & 0x1F) << 8 | data[offset + 11];
        // logger.log('PMT PID:'  + this._pmtId);
    };
    TSDemuxer.prototype._parsePMT = function (data, offset, mpegSupported, isSampleAes) {
        var sectionLength, tableEnd, programInfoLength, pid, result = { audio: -1, avc: -1, id3: -1, isAAC: true };
        sectionLength = (data[offset + 1] & 0x0f) << 8 | data[offset + 2];
        tableEnd = offset + 3 + sectionLength - 4;
        // to determine where the table is, we have to figure out how
        // long the program info descriptors are
        programInfoLength = (data[offset + 10] & 0x0f) << 8 | data[offset + 11];
        // advance the offset to the first entry in the mapping table
        offset += 12 + programInfoLength;
        while (offset < tableEnd) {
            pid = (data[offset + 1] & 0x1F) << 8 | data[offset + 2];
            switch (data[offset]) {
                case 0xcf: // SAMPLE-AES AAC
                    if (!isSampleAes) {
                        logger_1.logger.log('unkown stream type:' + data[offset]);
                        break;
                    }
                /* falls through */
                // ISO/IEC 13818-7 ADTS AAC (MPEG-2 lower bit-rate audio)
                case 0x0f:
                    // logger.log('AAC PID:'  + pid);
                    if (result.audio === -1) {
                        result.audio = pid;
                    }
                    break;
                // Packetized metadata (ID3)
                case 0x15:
                    // logger.log('ID3 PID:'  + pid);
                    if (result.id3 === -1) {
                        result.id3 = pid;
                    }
                    break;
                case 0xdb: // SAMPLE-AES AVC
                    if (!isSampleAes) {
                        logger_1.logger.log('unkown stream type:' + data[offset]);
                        break;
                    }
                /* falls through */
                // ITU-T Rec. H.264 and ISO/IEC 14496-10 (lower bit-rate video)
                case 0x1b:
                    // logger.log('AVC PID:'  + pid);
                    if (result.avc === -1) {
                        result.avc = pid;
                    }
                    break;
                // ISO/IEC 11172-3 (MPEG-1 audio)
                // or ISO/IEC 13818-3 (MPEG-2 halved sample rate audio)
                case 0x03:
                case 0x04:
                    // logger.log('MPEG PID:'  + pid);
                    if (!mpegSupported) {
                        logger_1.logger.log('MPEG audio found, not supported in this browser for now');
                    }
                    else if (result.audio === -1) {
                        result.audio = pid;
                        result.isAAC = false;
                    }
                    break;
                case 0x24:
                    logger_1.logger.warn('HEVC stream type found, not supported for now');
                    break;
                default:
                    logger_1.logger.log('unkown stream type:' + data[offset]);
                    break;
            }
            // move to the next table entry
            // skip past the elementary stream descriptors, if present
            offset += ((data[offset + 3] & 0x0F) << 8 | data[offset + 4]) + 5;
        }
        return result;
    };
    TSDemuxer.prototype._parsePES = function (stream) {
        var i = 0, frag, pesFlags, pesPrefix, pesLen, pesHdrLen, pesData, pesPts, pesDts, payloadStartOffset, data = stream.data;
        // safety check
        if (!stream || stream.size === 0) {
            return null;
        }
        // we might need up to 19 bytes to read PES header
        // if first chunk of data is less than 19 bytes, let's merge it with following ones until we get 19 bytes
        // usually only one merge is needed (and this is rare ...)
        while (data[0].length < 19 && data.length > 1) {
            var newData = new Uint8Array(data[0].length + data[1].length);
            newData.set(data[0]);
            newData.set(data[1], data[0].length);
            data[0] = newData;
            data.splice(1, 1);
        }
        // retrieve PTS/DTS from first fragment
        frag = data[0];
        pesPrefix = (frag[0] << 16) + (frag[1] << 8) + frag[2];
        if (pesPrefix === 1) {
            pesLen = (frag[4] << 8) + frag[5];
            // if PES parsed length is not zero and greater than total received length, stop parsing. PES might be truncated
            // minus 6 : PES header size
            if (pesLen && pesLen > stream.size - 6) {
                return null;
            }
            pesFlags = frag[7];
            if (pesFlags & 0xC0) {
                /* PES header described here : http://dvd.sourceforge.net/dvdinfo/pes-hdr.html
                    as PTS / DTS is 33 bit we cannot use bitwise operator in JS,
                    as Bitwise operators treat their operands as a sequence of 32 bits */
                pesPts = (frag[9] & 0x0E) * 536870912 + // 1 << 29
                    (frag[10] & 0xFF) * 4194304 + // 1 << 22
                    (frag[11] & 0xFE) * 16384 + // 1 << 14
                    (frag[12] & 0xFF) * 128 + // 1 << 7
                    (frag[13] & 0xFE) / 2;
                // check if greater than 2^32 -1
                if (pesPts > 4294967295) {
                    // decrement 2^33
                    pesPts -= 8589934592;
                }
                if (pesFlags & 0x40) {
                    pesDts = (frag[14] & 0x0E) * 536870912 + // 1 << 29
                        (frag[15] & 0xFF) * 4194304 + // 1 << 22
                        (frag[16] & 0xFE) * 16384 + // 1 << 14
                        (frag[17] & 0xFF) * 128 + // 1 << 7
                        (frag[18] & 0xFE) / 2;
                    // check if greater than 2^32 -1
                    if (pesDts > 4294967295) {
                        // decrement 2^33
                        pesDts -= 8589934592;
                    }
                    if (pesPts - pesDts > 60 * 90000) {
                        logger_1.logger.warn(Math.round((pesPts - pesDts) / 90000) + "s delta between PTS and DTS, align them");
                        pesPts = pesDts;
                    }
                }
                else {
                    pesDts = pesPts;
                }
            }
            pesHdrLen = frag[8];
            // 9 bytes : 6 bytes for PES header + 3 bytes for PES extension
            payloadStartOffset = pesHdrLen + 9;
            stream.size -= payloadStartOffset;
            // reassemble PES packet
            pesData = new Uint8Array(stream.size);
            for (var j = 0, dataLen = data.length; j < dataLen; j++) {
                frag = data[j];
                var len = frag.byteLength;
                if (payloadStartOffset) {
                    if (payloadStartOffset > len) {
                        // trim full frag if PES header bigger than frag
                        payloadStartOffset -= len;
                        continue;
                    }
                    else {
                        // trim partial frag if PES header smaller than frag
                        frag = frag.subarray(payloadStartOffset);
                        len -= payloadStartOffset;
                        payloadStartOffset = 0;
                    }
                }
                pesData.set(frag, i);
                i += len;
            }
            if (pesLen) {
                // payload size : remove PES header + PES extension
                pesLen -= pesHdrLen + 3;
            }
            return { data: pesData, pts: pesPts, dts: pesDts, len: pesLen };
        }
        else {
            return null;
        }
    };
    TSDemuxer.prototype.pushAccesUnit = function (avcSample, avcTrack) {
        if (avcSample.units.length && avcSample.frame) {
            var samples = avcTrack.samples;
            var nbSamples = samples.length;
            // only push AVC sample if starting with a keyframe is not mandatory OR
            //    if keyframe already found in this fragment OR
            //       keyframe found in last fragment (track.sps) AND
            //          samples already appended (we already found a keyframe in this fragment) OR fragment is contiguous
            if (!this.config.forceKeyFrameOnDiscontinuity ||
                avcSample.key === true ||
                (avcTrack.sps && (nbSamples || this.contiguous))) {
                avcSample.id = nbSamples;
                samples.push(avcSample);
            }
            else {
                // dropped samples, track it
                avcTrack.dropped++;
            }
        }
        if (avcSample.debug.length) {
            logger_1.logger.log(avcSample.pts + '/' + avcSample.dts + ':' + avcSample.debug);
        }
    };
    TSDemuxer.prototype._parseAVCPES = function (pes, last) {
        var _this = this;
        // logger.log('parse new PES');
        var track = this._avcTrack, units = this._parseAVCNALu(pes.data), debug = false, expGolombDecoder, avcSample = this.avcSample, push, spsfound = false, i, pushAccesUnit = this.pushAccesUnit.bind(this), createAVCSample = function (key, pts, dts, debug) {
            return { key: key, pts: pts, dts: dts, units: [], debug: debug };
        };
        // free pes.data to save up some memory
        pes.data = null;
        // if new NAL units found and last sample still there, let's push ...
        // this helps parsing streams with missing AUD (only do this if AUD never found)
        if (avcSample && units.length && !track.audFound) {
            pushAccesUnit(avcSample, track);
            avcSample = this.avcSample = createAVCSample(false, pes.pts, pes.dts, '');
        }
        units.forEach(function (unit) {
            switch (unit.type) {
                // NDR
                case 1:
                    push = true;
                    if (!avcSample) {
                        avcSample = _this.avcSample = createAVCSample(true, pes.pts, pes.dts, '');
                    }
                    if (debug) {
                        avcSample.debug += 'NDR ';
                    }
                    avcSample.frame = true;
                    var data = unit.data;
                    // only check slice type to detect KF in case SPS found in same packet (any keyframe is preceded by SPS ...)
                    if (spsfound && data.length > 4) {
                        // retrieve slice type by parsing beginning of NAL unit (follow H264 spec, slice_header definition) to detect keyframe embedded in NDR
                        var sliceType = new exp_golomb_1.default(data).readSliceType();
                        // 2 : I slice, 4 : SI slice, 7 : I slice, 9: SI slice
                        // SI slice : A slice that is coded using intra prediction only and using quantisation of the prediction samples.
                        // An SI slice can be coded such that its decoded samples can be constructed identically to an SP slice.
                        // I slice: A slice that is not an SI slice that is decoded using intra prediction only.
                        // if (sliceType === 2 || sliceType === 7) {
                        if (sliceType === 2 || sliceType === 4 || sliceType === 7 || sliceType === 9) {
                            avcSample.key = true;
                        }
                    }
                    break;
                // IDR
                case 5:
                    push = true;
                    // handle PES not starting with AUD
                    if (!avcSample) {
                        avcSample = _this.avcSample = createAVCSample(true, pes.pts, pes.dts, '');
                    }
                    if (debug) {
                        avcSample.debug += 'IDR ';
                    }
                    avcSample.key = true;
                    avcSample.frame = true;
                    break;
                // SEI
                case 6:
                    push = true;
                    if (debug && avcSample) {
                        avcSample.debug += 'SEI ';
                    }
                    expGolombDecoder = new exp_golomb_1.default(_this.discardEPB(unit.data));
                    // skip frameType
                    expGolombDecoder.readUByte();
                    var payloadType = 0;
                    var payloadSize = 0;
                    var endOfCaptions = false;
                    var b = 0;
                    while (!endOfCaptions && expGolombDecoder.bytesAvailable > 1) {
                        payloadType = 0;
                        do {
                            b = expGolombDecoder.readUByte();
                            payloadType += b;
                        } while (b === 0xFF);
                        // Parse payload size.
                        payloadSize = 0;
                        do {
                            b = expGolombDecoder.readUByte();
                            payloadSize += b;
                        } while (b === 0xFF);
                        // TODO: there can be more than one payload in an SEI packet...
                        // TODO: need to read type and size in a while loop to get them all
                        if (payloadType === 4 && expGolombDecoder.bytesAvailable !== 0) {
                            endOfCaptions = true;
                            var countryCode = expGolombDecoder.readUByte();
                            if (countryCode === 181) {
                                var providerCode = expGolombDecoder.readUShort();
                                if (providerCode === 49) {
                                    var userStructure = expGolombDecoder.readUInt();
                                    if (userStructure === 0x47413934) {
                                        var userDataType = expGolombDecoder.readUByte();
                                        // Raw CEA-608 bytes wrapped in CEA-708 packet
                                        if (userDataType === 3) {
                                            var firstByte = expGolombDecoder.readUByte();
                                            var secondByte = expGolombDecoder.readUByte();
                                            var totalCCs = 31 & firstByte;
                                            var byteArray = [firstByte, secondByte];
                                            for (i = 0; i < totalCCs; i++) {
                                                // 3 bytes per CC
                                                byteArray.push(expGolombDecoder.readUByte());
                                                byteArray.push(expGolombDecoder.readUByte());
                                                byteArray.push(expGolombDecoder.readUByte());
                                            }
                                            _this._insertSampleInOrder(_this._txtTrack.samples, { type: 3, pts: pes.pts, bytes: byteArray });
                                        }
                                    }
                                }
                            }
                        }
                        else if (payloadSize < expGolombDecoder.bytesAvailable) {
                            for (i = 0; i < payloadSize; i++) {
                                expGolombDecoder.readUByte();
                            }
                        }
                    }
                    break;
                // SPS
                case 7:
                    push = true;
                    spsfound = true;
                    if (debug && avcSample) {
                        avcSample.debug += 'SPS ';
                    }
                    if (!track.sps) {
                        expGolombDecoder = new exp_golomb_1.default(unit.data);
                        var config = expGolombDecoder.readSPS();
                        track.width = config.width;
                        track.height = config.height;
                        track.pixelRatio = config.pixelRatio;
                        track.sps = [unit.data];
                        track.duration = _this._duration;
                        var codecarray = unit.data.subarray(1, 4);
                        var codecstring = 'avc1.';
                        for (i = 0; i < 3; i++) {
                            var h = codecarray[i].toString(16);
                            if (h.length < 2) {
                                h = '0' + h;
                            }
                            codecstring += h;
                        }
                        track.codec = codecstring;
                    }
                    break;
                // PPS
                case 8:
                    push = true;
                    if (debug && avcSample) {
                        avcSample.debug += 'PPS ';
                    }
                    if (!track.pps) {
                        track.pps = [unit.data];
                    }
                    break;
                // AUD
                case 9:
                    push = false;
                    track.audFound = true;
                    if (avcSample) {
                        pushAccesUnit(avcSample, track);
                    }
                    avcSample = _this.avcSample = createAVCSample(false, pes.pts, pes.dts, debug ? 'AUD ' : '');
                    break;
                // Filler Data
                case 12:
                    push = false;
                    break;
                default:
                    push = false;
                    if (avcSample) {
                        avcSample.debug += 'unknown NAL ' + unit.type + ' ';
                    }
                    break;
            }
            if (avcSample && push) {
                var units_1 = avcSample.units;
                units_1.push(unit);
            }
        });
        // if last PES packet, push samples
        if (last && avcSample) {
            pushAccesUnit(avcSample, track);
            this.avcSample = null;
        }
    };
    TSDemuxer.prototype._insertSampleInOrder = function (arr, data) {
        var len = arr.length;
        if (len > 0) {
            if (data.pts >= arr[len - 1].pts) {
                arr.push(data);
            }
            else {
                for (var pos = len - 1; pos >= 0; pos--) {
                    if (data.pts < arr[pos].pts) {
                        arr.splice(pos, 0, data);
                        break;
                    }
                }
            }
        }
        else {
            arr.push(data);
        }
    };
    TSDemuxer.prototype._getLastNalUnit = function () {
        var avcSample = this.avcSample, lastUnit;
        // try to fallback to previous sample if current one is empty
        if (!avcSample || avcSample.units.length === 0) {
            var track = this._avcTrack, samples = track.samples;
            avcSample = samples[samples.length - 1];
        }
        if (avcSample) {
            var units = avcSample.units;
            lastUnit = units[units.length - 1];
        }
        return lastUnit;
    };
    TSDemuxer.prototype._parseAVCNALu = function (array) {
        var i = 0, len = array.byteLength, value, overflow, track = this._avcTrack, state = track.naluState || 0, lastState = state;
        var units = [], unit, unitType, lastUnitStart = -1, lastUnitType;
        // logger.log('PES:' + Hex.hexDump(array));
        if (state === -1) {
            // special use case where we found 3 or 4-byte start codes exactly at the end of previous PES packet
            lastUnitStart = 0;
            // NALu type is value read from offset 0
            lastUnitType = array[0] & 0x1f;
            state = 0;
            i = 1;
        }
        while (i < len) {
            value = array[i++];
            // optimization. state 0 and 1 are the predominant case. let's handle them outside of the switch/case
            if (!state) {
                state = value ? 0 : 1;
                continue;
            }
            if (state === 1) {
                state = value ? 0 : 2;
                continue;
            }
            // here we have state either equal to 2 or 3
            if (!value) {
                state = 3;
            }
            else if (value === 1) {
                if (lastUnitStart >= 0) {
                    unit = { data: array.subarray(lastUnitStart, i - state - 1), type: lastUnitType };
                    // logger.log('pushing NALU, type/size:' + unit.type + '/' + unit.data.byteLength);
                    units.push(unit);
                }
                else {
                    // lastUnitStart is undefined => this is the first start code found in this PES packet
                    // first check if start code delimiter is overlapping between 2 PES packets,
                    // ie it started in last packet (lastState not zero)
                    // and ended at the beginning of this PES packet (i <= 4 - lastState)
                    var lastUnit = this._getLastNalUnit();
                    if (lastUnit) {
                        if (lastState && (i <= 4 - lastState)) {
                            // start delimiter overlapping between PES packets
                            // strip start delimiter bytes from the end of last NAL unit
                            // check if lastUnit had a state different from zero
                            if (lastUnit.state) {
                                // strip last bytes
                                lastUnit.data = lastUnit.data.subarray(0, lastUnit.data.byteLength - lastState);
                            }
                        }
                        // If NAL units are not starting right at the beginning of the PES packet, push preceding data into previous NAL unit.
                        overflow = i - state - 1;
                        if (overflow > 0) {
                            // logger.log('first NALU found with overflow:' + overflow);
                            var tmp = new Uint8Array(lastUnit.data.byteLength + overflow);
                            tmp.set(lastUnit.data, 0);
                            tmp.set(array.subarray(0, overflow), lastUnit.data.byteLength);
                            lastUnit.data = tmp;
                        }
                    }
                }
                // check if we can read unit type
                if (i < len) {
                    unitType = array[i] & 0x1f;
                    // logger.log('find NALU @ offset:' + i + ',type:' + unitType);
                    lastUnitStart = i;
                    lastUnitType = unitType;
                    state = 0;
                }
                else {
                    // not enough byte to read unit type. let's read it on next PES parsing
                    state = -1;
                }
            }
            else {
                state = 0;
            }
        }
        if (lastUnitStart >= 0 && state >= 0) {
            unit = { data: array.subarray(lastUnitStart, len), type: lastUnitType, state: state };
            units.push(unit);
            // logger.log('pushing NALU, type/size/state:' + unit.type + '/' + unit.data.byteLength + '/' + state);
        }
        // no NALu found
        if (units.length === 0) {
            // append pes.data to previous NAL unit
            var lastUnit = this._getLastNalUnit();
            if (lastUnit) {
                var tmp = new Uint8Array(lastUnit.data.byteLength + array.byteLength);
                tmp.set(lastUnit.data, 0);
                tmp.set(array, lastUnit.data.byteLength);
                lastUnit.data = tmp;
            }
        }
        track.naluState = state;
        return units;
    };
    /**
     * remove Emulation Prevention bytes from a RBSP
     */
    TSDemuxer.prototype.discardEPB = function (data) {
        var length = data.byteLength, EPBPositions = [], i = 1, newLength, newData;
        // Find all `Emulation Prevention Bytes`
        while (i < length - 2) {
            if (data[i] === 0 &&
                data[i + 1] === 0 &&
                data[i + 2] === 0x03) {
                EPBPositions.push(i + 2);
                i += 2;
            }
            else {
                i++;
            }
        }
        // If no Emulation Prevention Bytes were found just return the original
        // array
        if (EPBPositions.length === 0) {
            return data;
        }
        // Create a new array to hold the NAL unit data
        newLength = length - EPBPositions.length;
        newData = new Uint8Array(newLength);
        var sourceIndex = 0;
        for (i = 0; i < newLength; sourceIndex++, i++) {
            if (sourceIndex === EPBPositions[0]) {
                // Skip this byte
                sourceIndex++;
                // Remove this position index
                EPBPositions.shift();
            }
            newData[i] = data[sourceIndex];
        }
        return newData;
    };
    TSDemuxer.prototype._parseAACPES = function (pes) {
        var track = this._audioTrack, data = pes.data, pts = pes.pts, startOffset = 0, aacOverFlow = this.aacOverFlow, aacLastPTS = this.aacLastPTS, frameDuration, frameIndex, offset, stamp, len;
        if (aacOverFlow) {
            var tmp = new Uint8Array(aacOverFlow.byteLength + data.byteLength);
            tmp.set(aacOverFlow, 0);
            tmp.set(data, aacOverFlow.byteLength);
            // logger.log(`AAC: append overflowing ${aacOverFlow.byteLength} bytes to beginning of new PES`);
            data = tmp;
        }
        // look for ADTS header (0xFFFx)
        for (offset = startOffset, len = data.length; offset < len - 1; offset++) {
            if (ADTS.isHeader(data, offset)) {
                break;
            }
        }
        // if ADTS header does not start straight from the beginning of the PES payload, raise an error
        if (offset) {
            var reason = void 0, fatal = void 0;
            if (offset < len - 1) {
                reason = "AAC PES did not start with ADTS header,offset:" + offset;
                fatal = false;
            }
            else {
                reason = 'no ADTS header found in AAC PES';
                fatal = true;
            }
            logger_1.logger.warn("parsing error:" + reason);
            this.observer.trigger(events_1.default.ERROR, { type: errors_1.ErrorTypes.MEDIA_ERROR, details: errors_1.ErrorDetails.FRAG_PARSING_ERROR, fatal: fatal, reason: reason });
            if (fatal) {
                return;
            }
        }
        ADTS.initTrackConfig(track, this.observer, data, offset, this.audioCodec);
        frameIndex = 0;
        frameDuration = ADTS.getFrameDuration(track.samplerate);
        // if last AAC frame is overflowing, we should ensure timestamps are contiguous:
        // first sample PTS should be equal to last sample PTS + frameDuration
        if (aacOverFlow && aacLastPTS) {
            var newPTS = aacLastPTS + frameDuration;
            if (Math.abs(newPTS - pts) > 1) {
                logger_1.logger.log("AAC: align PTS for overlapping frames by " + Math.round((newPTS - pts) / 90));
                pts = newPTS;
            }
        }
        // scan for aac samples
        while (offset < len) {
            if (ADTS.isHeader(data, offset) && (offset + 5) < len) {
                var frame = ADTS.appendFrame(track, data, offset, pts, frameIndex);
                if (frame) {
                    // logger.log(`${Math.round(frame.sample.pts)} : AAC`);
                    offset += frame.length;
                    stamp = frame.sample.pts;
                    frameIndex++;
                }
                else {
                    // logger.log('Unable to parse AAC frame');
                    break;
                }
            }
            else {
                // nothing found, keep looking
                offset++;
            }
        }
        if (offset < len) {
            aacOverFlow = data.subarray(offset, len);
            // logger.log(`AAC: overflow detected:${len-offset}`);
        }
        else {
            aacOverFlow = null;
        }
        this.aacOverFlow = aacOverFlow;
        this.aacLastPTS = stamp;
    };
    TSDemuxer.prototype._parseMPEGPES = function (pes) {
        var data = pes.data;
        var length = data.length;
        var frameIndex = 0;
        var offset = 0;
        var pts = pes.pts;
        while (offset < length) {
            if (mpegaudio_1.default.isHeader(data, offset)) {
                var frame = mpegaudio_1.default.appendFrame(this._audioTrack, data, offset, pts, frameIndex);
                if (frame) {
                    offset += frame.length;
                    frameIndex++;
                }
                else {
                    // logger.log('Unable to parse Mpeg audio frame');
                    break;
                }
            }
            else {
                // nothing found, keep looking
                offset++;
            }
        }
    };
    TSDemuxer.prototype._parseID3PES = function (pes) {
        this._id3Track.samples.push(pes);
    };
    return TSDemuxer;
}());
exports.default = TSDemuxer;


/***/ }),

/***/ "./src/errors.js":
/*!***********************!*\
  !*** ./src/errors.js ***!
  \***********************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorTypes = {
    // Identifier for a network error (loading error / timeout ...)
    NETWORK_ERROR: 'networkError',
    // Identifier for a media Error (video/parsing/mediasource error)
    MEDIA_ERROR: 'mediaError',
    // EME (encrypted media extensions) errors
    KEY_SYSTEM_ERROR: 'keySystemError',
    // Identifier for a mux Error (demuxing/remuxing)
    MUX_ERROR: 'muxError',
    // Identifier for all other errors
    OTHER_ERROR: 'otherError'
};
/**
 * @enum {ErrorDetails}
 * @typedef {string} ErrorDetail
 */
exports.ErrorDetails = {
    KEY_SYSTEM_NO_KEYS: 'keySystemNoKeys',
    KEY_SYSTEM_NO_ACCESS: 'keySystemNoAccess',
    KEY_SYSTEM_NO_SESSION: 'keySystemNoSession',
    KEY_SYSTEM_LICENSE_REQUEST_FAILED: 'keySystemLicenseRequestFailed',
    // Identifier for a manifest load error - data: { url : faulty URL, response : { code: error code, text: error text }}
    MANIFEST_LOAD_ERROR: 'manifestLoadError',
    // Identifier for a manifest load timeout - data: { url : faulty URL, response : { code: error code, text: error text }}
    MANIFEST_LOAD_TIMEOUT: 'manifestLoadTimeOut',
    // Identifier for a manifest parsing error - data: { url : faulty URL, reason : error reason}
    MANIFEST_PARSING_ERROR: 'manifestParsingError',
    // Identifier for a manifest with only incompatible codecs error - data: { url : faulty URL, reason : error reason}
    MANIFEST_INCOMPATIBLE_CODECS_ERROR: 'manifestIncompatibleCodecsError',
    // Identifier for a level load error - data: { url : faulty URL, response : { code: error code, text: error text }}
    LEVEL_LOAD_ERROR: 'levelLoadError',
    // Identifier for a level load timeout - data: { url : faulty URL, response : { code: error code, text: error text }}
    LEVEL_LOAD_TIMEOUT: 'levelLoadTimeOut',
    // Identifier for a level switch error - data: { level : faulty level Id, event : error description}
    LEVEL_SWITCH_ERROR: 'levelSwitchError',
    // Identifier for an audio track load error - data: { url : faulty URL, response : { code: error code, text: error text }}
    AUDIO_TRACK_LOAD_ERROR: 'audioTrackLoadError',
    // Identifier for an audio track load timeout - data: { url : faulty URL, response : { code: error code, text: error text }}
    AUDIO_TRACK_LOAD_TIMEOUT: 'audioTrackLoadTimeOut',
    // Identifier for fragment load error - data: { frag : fragment object, response : { code: error code, text: error text }}
    FRAG_LOAD_ERROR: 'fragLoadError',
    // Identifier for fragment load timeout error - data: { frag : fragment object}
    FRAG_LOAD_TIMEOUT: 'fragLoadTimeOut',
    // Identifier for a fragment decryption error event - data: {id : demuxer Id,frag: fragment object, reason : parsing error description }
    FRAG_DECRYPT_ERROR: 'fragDecryptError',
    // Identifier for a fragment parsing error event - data: { id : demuxer Id, reason : parsing error description }
    // will be renamed DEMUX_PARSING_ERROR and switched to MUX_ERROR in the next major release
    FRAG_PARSING_ERROR: 'fragParsingError',
    // Identifier for a remux alloc error event - data: { id : demuxer Id, frag : fragment object, bytes : nb of bytes on which allocation failed , reason : error text }
    REMUX_ALLOC_ERROR: 'remuxAllocError',
    // Identifier for decrypt key load error - data: { frag : fragment object, response : { code: error code, text: error text }}
    KEY_LOAD_ERROR: 'keyLoadError',
    // Identifier for decrypt key load timeout error - data: { frag : fragment object}
    KEY_LOAD_TIMEOUT: 'keyLoadTimeOut',
    // Triggered when an exception occurs while adding a sourceBuffer to MediaSource - data : {  err : exception , mimeType : mimeType }
    BUFFER_ADD_CODEC_ERROR: 'bufferAddCodecError',
    // Identifier for a buffer append error - data: append error description
    BUFFER_APPEND_ERROR: 'bufferAppendError',
    // Identifier for a buffer appending error event - data: appending error description
    BUFFER_APPENDING_ERROR: 'bufferAppendingError',
    // Identifier for a buffer stalled error event
    BUFFER_STALLED_ERROR: 'bufferStalledError',
    // Identifier for a buffer full event
    BUFFER_FULL_ERROR: 'bufferFullError',
    // Identifier for a buffer seek over hole event
    BUFFER_SEEK_OVER_HOLE: 'bufferSeekOverHole',
    // Identifier for a buffer nudge on stall (playback is stuck although currentTime is in a buffered area)
    BUFFER_NUDGE_ON_STALL: 'bufferNudgeOnStall',
    // Identifier for an internal exception happening inside hls.js while handling an event
    INTERNAL_EXCEPTION: 'internalException'
};


/***/ }),

/***/ "./src/event-handler.js":
/*!******************************!*\
  !*** ./src/event-handler.js ***!
  \******************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
*
* All objects in the event handling chain should inherit from this class
*
*/
Object.defineProperty(exports, "__esModule", { value: true });
var logger_1 = __webpack_require__(/*! ./utils/logger */ "./src/utils/logger.js");
var errors_1 = __webpack_require__(/*! ./errors */ "./src/errors.js");
var events_1 = __webpack_require__(/*! ./events */ "./src/events.js");
var FORBIDDEN_EVENT_NAMES = {
    'hlsEventGeneric': true,
    'hlsHandlerDestroying': true,
    'hlsHandlerDestroyed': true
};
var EventHandler = /** @class */ (function () {
    function EventHandler(hls) {
        var events = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            events[_i - 1] = arguments[_i];
        }
        this.hls = hls;
        this.onEvent = this.onEvent.bind(this);
        this.handledEvents = events;
        this.useGenericHandler = true;
        this.registerListeners();
    }
    EventHandler.prototype.destroy = function () {
        this.onHandlerDestroying();
        this.unregisterListeners();
        this.onHandlerDestroyed();
    };
    EventHandler.prototype.onHandlerDestroying = function () { };
    EventHandler.prototype.onHandlerDestroyed = function () { };
    EventHandler.prototype.isEventHandler = function () {
        return typeof this.handledEvents === 'object' && this.handledEvents.length && typeof this.onEvent === 'function';
    };
    EventHandler.prototype.registerListeners = function () {
        if (this.isEventHandler()) {
            this.handledEvents.forEach(function (event) {
                if (FORBIDDEN_EVENT_NAMES[event]) {
                    throw new Error('Forbidden event-name: ' + event);
                }
                this.hls.on(event, this.onEvent);
            }, this);
        }
    };
    EventHandler.prototype.unregisterListeners = function () {
        if (this.isEventHandler()) {
            this.handledEvents.forEach(function (event) {
                this.hls.off(event, this.onEvent);
            }, this);
        }
    };
    /**
     * arguments: event (string), data (any)
     */
    EventHandler.prototype.onEvent = function (event, data) {
        this.onEventGeneric(event, data);
    };
    EventHandler.prototype.onEventGeneric = function (event, data) {
        var eventToFunction = function (event, data) {
            var funcName = 'on' + event.replace('hls', '');
            if (typeof this[funcName] !== 'function') {
                throw new Error("Event " + event + " has no generic handler in this " + this.constructor.name + " class (tried " + funcName + ")");
            }
            return this[funcName].bind(this, data);
        };
        try {
            eventToFunction.call(this, event, data).call();
        }
        catch (err) {
            logger_1.logger.error("An internal error happened while handling event " + event + ". Error message: \"" + err.message + "\". Here is a stacktrace:", err);
            this.hls.trigger(events_1.default.ERROR, { type: errors_1.ErrorTypes.OTHER_ERROR, details: errors_1.ErrorDetails.INTERNAL_EXCEPTION, fatal: false, event: event, err: err });
        }
    };
    return EventHandler;
}());
exports.default = EventHandler;


/***/ }),

/***/ "./src/events.js":
/*!***********************!*\
  !*** ./src/events.js ***!
  \***********************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @readonly
 * @enum {string}
 */
var HlsEvents = {
    // fired before MediaSource is attaching to media element - data: { media }
    MEDIA_ATTACHING: 'hlsMediaAttaching',
    // fired when MediaSource has been succesfully attached to media element - data: { }
    MEDIA_ATTACHED: 'hlsMediaAttached',
    // fired before detaching MediaSource from media element - data: { }
    MEDIA_DETACHING: 'hlsMediaDetaching',
    // fired when MediaSource has been detached from media element - data: { }
    MEDIA_DETACHED: 'hlsMediaDetached',
    // fired when we buffer is going to be reset - data: { }
    BUFFER_RESET: 'hlsBufferReset',
    // fired when we know about the codecs that we need buffers for to push into - data: {tracks : { container, codec, levelCodec, initSegment, metadata }}
    BUFFER_CODECS: 'hlsBufferCodecs',
    // fired when sourcebuffers have been created - data: { tracks : tracks }
    BUFFER_CREATED: 'hlsBufferCreated',
    // fired when we append a segment to the buffer - data: { segment: segment object }
    BUFFER_APPENDING: 'hlsBufferAppending',
    // fired when we are done with appending a media segment to the buffer - data : { parent : segment parent that triggered BUFFER_APPENDING, pending : nb of segments waiting for appending for this segment parent}
    BUFFER_APPENDED: 'hlsBufferAppended',
    // fired when the stream is finished and we want to notify the media buffer that there will be no more data - data: { }
    BUFFER_EOS: 'hlsBufferEos',
    // fired when the media buffer should be flushed - data { startOffset, endOffset }
    BUFFER_FLUSHING: 'hlsBufferFlushing',
    // fired when the media buffer has been flushed - data: { }
    BUFFER_FLUSHED: 'hlsBufferFlushed',
    // fired to signal that a manifest loading starts - data: { url : manifestURL}
    MANIFEST_LOADING: 'hlsManifestLoading',
    // fired after manifest has been loaded - data: { levels : [available quality levels], audioTracks : [ available audio tracks], url : manifestURL, stats : { trequest, tfirst, tload, mtime}}
    MANIFEST_LOADED: 'hlsManifestLoaded',
    // fired after manifest has been parsed - data: { levels : [available quality levels], firstLevel : index of first quality level appearing in Manifest}
    MANIFEST_PARSED: 'hlsManifestParsed',
    // fired when a level switch is requested - data: { level : id of new level }
    LEVEL_SWITCHING: 'hlsLevelSwitching',
    // fired when a level switch is effective - data: { level : id of new level }
    LEVEL_SWITCHED: 'hlsLevelSwitched',
    // fired when a level playlist loading starts - data: { url : level URL, level : id of level being loaded}
    LEVEL_LOADING: 'hlsLevelLoading',
    // fired when a level playlist loading finishes - data: { details : levelDetails object, level : id of loaded level, stats : { trequest, tfirst, tload, mtime} }
    LEVEL_LOADED: 'hlsLevelLoaded',
    // fired when a level's details have been updated based on previous details, after it has been loaded - data: { details : levelDetails object, level : id of updated level }
    LEVEL_UPDATED: 'hlsLevelUpdated',
    // fired when a level's PTS information has been updated after parsing a fragment - data: { details : levelDetails object, level : id of updated level, drift: PTS drift observed when parsing last fragment }
    LEVEL_PTS_UPDATED: 'hlsLevelPtsUpdated',
    // fired to notify that audio track lists has been updated - data: { audioTracks : audioTracks }
    AUDIO_TRACKS_UPDATED: 'hlsAudioTracksUpdated',
    // fired when an audio track switching is requested - data: { id : audio track id }
    AUDIO_TRACK_SWITCHING: 'hlsAudioTrackSwitching',
    // fired when an audio track switch actually occurs - data: { id : audio track id }
    AUDIO_TRACK_SWITCHED: 'hlsAudioTrackSwitched',
    // fired when an audio track loading starts - data: { url : audio track URL, id : audio track id }
    AUDIO_TRACK_LOADING: 'hlsAudioTrackLoading',
    // fired when an audio track loading finishes - data: { details : levelDetails object, id : audio track id, stats : { trequest, tfirst, tload, mtime } }
    AUDIO_TRACK_LOADED: 'hlsAudioTrackLoaded',
    // fired to notify that subtitle track lists has been updated - data: { subtitleTracks : subtitleTracks }
    SUBTITLE_TRACKS_UPDATED: 'hlsSubtitleTracksUpdated',
    // fired when an subtitle track switch occurs - data: { id : subtitle track id }
    SUBTITLE_TRACK_SWITCH: 'hlsSubtitleTrackSwitch',
    // fired when a subtitle track loading starts - data: { url : subtitle track URL, id : subtitle track id }
    SUBTITLE_TRACK_LOADING: 'hlsSubtitleTrackLoading',
    // fired when a subtitle track loading finishes - data: { details : levelDetails object, id : subtitle track id, stats : { trequest, tfirst, tload, mtime } }
    SUBTITLE_TRACK_LOADED: 'hlsSubtitleTrackLoaded',
    // fired when a subtitle fragment has been processed - data: { success : boolean, frag : the processed frag }
    SUBTITLE_FRAG_PROCESSED: 'hlsSubtitleFragProcessed',
    // fired when the first timestamp is found - data: { id : demuxer id, initPTS: initPTS, frag : fragment object }
    INIT_PTS_FOUND: 'hlsInitPtsFound',
    // fired when a fragment loading starts - data: { frag : fragment object }
    FRAG_LOADING: 'hlsFragLoading',
    // fired when a fragment loading is progressing - data: { frag : fragment object, { trequest, tfirst, loaded } }
    FRAG_LOAD_PROGRESS: 'hlsFragLoadProgress',
    // Identifier for fragment load aborting for emergency switch down - data: { frag : fragment object }
    FRAG_LOAD_EMERGENCY_ABORTED: 'hlsFragLoadEmergencyAborted',
    // fired when a fragment loading is completed - data: { frag : fragment object, payload : fragment payload, stats : { trequest, tfirst, tload, length } }
    FRAG_LOADED: 'hlsFragLoaded',
    // fired when a fragment has finished decrypting - data: { id : demuxer id, frag: fragment object, payload : fragment payload, stats : { tstart, tdecrypt } }
    FRAG_DECRYPTED: 'hlsFragDecrypted',
    // fired when Init Segment has been extracted from fragment - data: { id : demuxer id, frag: fragment object, moov : moov MP4 box, codecs : codecs found while parsing fragment }
    FRAG_PARSING_INIT_SEGMENT: 'hlsFragParsingInitSegment',
    // fired when parsing sei text is completed - data: { id : demuxer id, frag: fragment object, samples : [ sei samples pes ] }
    FRAG_PARSING_USERDATA: 'hlsFragParsingUserdata',
    // fired when parsing id3 is completed - data: { id : demuxer id, frag: fragment object, samples : [ id3 samples pes ] }
    FRAG_PARSING_METADATA: 'hlsFragParsingMetadata',
    // fired when data have been extracted from fragment - data: { id : demuxer id, frag: fragment object, data1 : moof MP4 box or TS fragments, data2 : mdat MP4 box or null}
    FRAG_PARSING_DATA: 'hlsFragParsingData',
    // fired when fragment parsing is completed - data: { id : demuxer id, frag: fragment object }
    FRAG_PARSED: 'hlsFragParsed',
    // fired when fragment remuxed MP4 boxes have all been appended into SourceBuffer - data: { id : demuxer id, frag : fragment object, stats : { trequest, tfirst, tload, tparsed, tbuffered, length, bwEstimate } }
    FRAG_BUFFERED: 'hlsFragBuffered',
    // fired when fragment matching with current media position is changing - data : { id : demuxer id, frag : fragment object }
    FRAG_CHANGED: 'hlsFragChanged',
    // Identifier for a FPS drop event - data: { curentDropped, currentDecoded, totalDroppedFrames }
    FPS_DROP: 'hlsFpsDrop',
    // triggered when FPS drop triggers auto level capping - data: { level, droppedlevel }
    FPS_DROP_LEVEL_CAPPING: 'hlsFpsDropLevelCapping',
    // Identifier for an error event - data: { type : error type, details : error details, fatal : if true, hls.js cannot/will not try to recover, if false, hls.js will try to recover,other error specific data }
    ERROR: 'hlsError',
    // fired when hls.js instance starts destroying. Different from MEDIA_DETACHED as one could want to detach and reattach a media to the instance of hls.js to handle mid-rolls for example - data: { }
    DESTROYING: 'hlsDestroying',
    // fired when a decrypt key loading starts - data: { frag : fragment object }
    KEY_LOADING: 'hlsKeyLoading',
    // fired when a decrypt key loading is completed - data: { frag : fragment object, payload : key payload, stats : { trequest, tfirst, tload, length } }
    KEY_LOADED: 'hlsKeyLoaded',
    // fired upon stream controller state transitions - data: { previousState, nextState }
    STREAM_STATE_TRANSITION: 'hlsStreamStateTransition'
};
exports.default = HlsEvents;


/***/ }),

/***/ "./src/hls.js":
/*!********************!*\
  !*** ./src/hls.js ***!
  \********************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var URLToolkit = __webpack_require__(/*! url-toolkit */ "./node_modules/url-toolkit/src/url-toolkit.js");
var errors_1 = __webpack_require__(/*! ./errors */ "./src/errors.js");
var playlist_loader_1 = __webpack_require__(/*! ./loader/playlist-loader */ "./src/loader/playlist-loader.js");
var fragment_loader_1 = __webpack_require__(/*! ./loader/fragment-loader */ "./src/loader/fragment-loader.js");
var key_loader_1 = __webpack_require__(/*! ./loader/key-loader */ "./src/loader/key-loader.js");
var fragment_tracker_1 = __webpack_require__(/*! ./controller/fragment-tracker */ "./src/controller/fragment-tracker.js");
var stream_controller_1 = __webpack_require__(/*! ./controller/stream-controller */ "./src/controller/stream-controller.js");
var level_controller_1 = __webpack_require__(/*! ./controller/level-controller */ "./src/controller/level-controller.js");
var id3_track_controller_1 = __webpack_require__(/*! ./controller/id3-track-controller */ "./src/controller/id3-track-controller.js");
var is_supported_1 = __webpack_require__(/*! ./is-supported */ "./src/is-supported.js");
var logger_1 = __webpack_require__(/*! ./utils/logger */ "./src/utils/logger.js");
var config_1 = __webpack_require__(/*! ./config */ "./src/config.js");
var events_1 = __webpack_require__(/*! ./events */ "./src/events.js");
var observer_1 = __webpack_require__(/*! ./observer */ "./src/observer.js");
/**
 * @module Hls
 * @class
 * @constructor
 */
var Hls = /** @class */ (function (_super) {
    __extends(Hls, _super);
    /**
     * Creates an instance of an HLS client that can attach to exactly one `HTMLMediaElement`.
     *
     * @constructs Hls
     * @param {HlsConfig} config
     */
    function Hls(config) {
        if (config === void 0) { config = {}; }
        var _this = _super.call(this) || this;
        var defaultConfig = Hls.DefaultConfig;
        if ((config.liveSyncDurationCount || config.liveMaxLatencyDurationCount) && (config.liveSyncDuration || config.liveMaxLatencyDuration)) {
            throw new Error('Illegal hls.js config: don\'t mix up liveSyncDurationCount/liveMaxLatencyDurationCount and liveSyncDuration/liveMaxLatencyDuration');
        }
        for (var prop in defaultConfig) {
            if (prop in config)
                continue;
            config[prop] = defaultConfig[prop];
        }
        if (config.liveMaxLatencyDurationCount !== undefined && config.liveMaxLatencyDurationCount <= config.liveSyncDurationCount) {
            throw new Error('Illegal hls.js config: "liveMaxLatencyDurationCount" must be gt "liveSyncDurationCount"');
        }
        if (config.liveMaxLatencyDuration !== undefined && (config.liveMaxLatencyDuration <= config.liveSyncDuration || config.liveSyncDuration === undefined)) {
            throw new Error('Illegal hls.js config: "liveMaxLatencyDuration" must be gt "liveSyncDuration"');
        }
        logger_1.enableLogs(config.debug);
        _this.config = config;
        _this._autoLevelCapping = -1;
        // core controllers and network loaders
        /**
         * @member {AbrController} abrController
         */
        var abrController = _this.abrController = new config.abrController(_this);
        var bufferController = new config.bufferController(_this);
        var capLevelController = new config.capLevelController(_this);
        var fpsController = new config.fpsController(_this);
        var playListLoader = new playlist_loader_1.default(_this);
        var fragmentLoader = new fragment_loader_1.default(_this);
        var keyLoader = new key_loader_1.default(_this);
        var id3TrackController = new id3_track_controller_1.default(_this);
        // network controllers
        /**
         * @member {LevelController} levelController
         */
        var levelController = _this.levelController = new level_controller_1.default(_this);
        // FIXME: FragmentTracker must be defined before StreamController because the order of event handling is important
        var fragmentTracker = new fragment_tracker_1.FragmentTracker(_this);
        /**
         * @member {StreamController} streamController
         */
        var streamController = _this.streamController = new stream_controller_1.default(_this, fragmentTracker);
        var networkControllers = [levelController, streamController];
        // optional audio stream controller
        /**
         * @var {ICoreComponent | Controller}
         */
        var Controller = config.audioStreamController;
        if (Controller) {
            networkControllers.push(new Controller(_this, fragmentTracker));
        }
        /**
         * @member {INetworkController[]} networkControllers
         */
        _this.networkControllers = networkControllers;
        /**
         * @var {ICoreComponent[]}
         */
        var coreComponents = [
            playListLoader,
            fragmentLoader,
            keyLoader,
            abrController,
            bufferController,
            capLevelController,
            fpsController,
            id3TrackController,
            fragmentTracker
        ];
        // optional audio track and subtitle controller
        Controller = config.audioTrackController;
        if (Controller) {
            var audioTrackController = new Controller(_this);
            /**
             * @member {AudioTrackController} audioTrackController
             */
            _this.audioTrackController = audioTrackController;
            coreComponents.push(audioTrackController);
        }
        Controller = config.subtitleTrackController;
        if (Controller) {
            var subtitleTrackController = new Controller(_this);
            /**
             * @member {SubtitleTrackController} subtitleTrackController
             */
            _this.subtitleTrackController = subtitleTrackController;
            coreComponents.push(subtitleTrackController);
        }
        Controller = config.emeController;
        if (Controller) {
            var emeController = new Controller(_this);
            /**
             * @member {EMEController} emeController
             */
            _this.emeController = emeController;
            coreComponents.push(emeController);
        }
        // optional subtitle controllers
        Controller = config.subtitleStreamController;
        if (Controller) {
            coreComponents.push(new Controller(_this, fragmentTracker));
        }
        Controller = config.timelineController;
        if (Controller) {
            coreComponents.push(new Controller(_this));
        }
        /**
         * @member {ICoreComponent[]}
         */
        _this.coreComponents = coreComponents;
        return _this;
    }
    Object.defineProperty(Hls, "version", {
        /**
         * @type {string}
         */
        get: function () {
            return "0.12.2";
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @type {boolean}
     */
    Hls.isSupported = function () {
        return is_supported_1.isSupported();
    };
    Object.defineProperty(Hls, "Events", {
        /**
         * @type {HlsEvents}
         */
        get: function () {
            return events_1.default;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hls, "ErrorTypes", {
        /**
         * @type {HlsErrorTypes}
         */
        get: function () {
            return errors_1.ErrorTypes;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hls, "ErrorDetails", {
        /**
         * @type {HlsErrorDetails}
         */
        get: function () {
            return errors_1.ErrorDetails;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hls, "DefaultConfig", {
        /**
         * @type {HlsConfig}
         */
        get: function () {
            if (!Hls.defaultConfig) {
                return config_1.hlsDefaultConfig;
            }
            return Hls.defaultConfig;
        },
        /**
         * @type {HlsConfig}
         */
        set: function (defaultConfig) {
            Hls.defaultConfig = defaultConfig;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Dispose of the instance
     */
    Hls.prototype.destroy = function () {
        logger_1.logger.log('destroy');
        this.trigger(events_1.default.DESTROYING);
        this.detachMedia();
        this.coreComponents.concat(this.networkControllers).forEach(function (component) {
            component.destroy();
        });
        this.url = null;
        this.removeAllListeners();
        this._autoLevelCapping = -1;
    };
    /**
     * Attach a media element
     * @param {HTMLMediaElement} media
     */
    Hls.prototype.attachMedia = function (media) {
        logger_1.logger.log('attachMedia');
        this.media = media;
        this.trigger(events_1.default.MEDIA_ATTACHING, { media: media });
    };
    /**
     * Detach from the media
     */
    Hls.prototype.detachMedia = function () {
        logger_1.logger.log('detachMedia');
        this.trigger(events_1.default.MEDIA_DETACHING);
        this.media = null;
    };
    /**
     * Set the source URL. Can be relative or absolute.
     * @param {string} url
     */
    Hls.prototype.loadSource = function (url) {
        url = URLToolkit.buildAbsoluteURL(window.location.href, url, { alwaysNormalize: true });
        logger_1.logger.log("loadSource:" + url);
        this.url = url;
        // when attaching to a source URL, trigger a playlist load
        this.trigger(events_1.default.MANIFEST_LOADING, { url: url });
    };
    /**
     * Start loading data from the stream source.
     * Depending on default config, client starts loading automatically when a source is set.
     *
     * @param {number} startPosition Set the start position to stream from
     * @default -1 None (from earliest point)
     */
    Hls.prototype.startLoad = function (startPosition) {
        if (startPosition === void 0) { startPosition = -1; }
        logger_1.logger.log("startLoad(" + startPosition + ")");
        this.networkControllers.forEach(function (controller) {
            controller.startLoad(startPosition);
        });
    };
    /**
     * Stop loading of any stream data.
     */
    Hls.prototype.stopLoad = function () {
        logger_1.logger.log('stopLoad');
        this.networkControllers.forEach(function (controller) {
            controller.stopLoad();
        });
    };
    /**
     * Swap through possible audio codecs in the stream (for example to switch from stereo to 5.1)
     */
    Hls.prototype.swapAudioCodec = function () {
        logger_1.logger.log('swapAudioCodec');
        this.streamController.swapAudioCodec();
    };
    /**
     * When the media-element fails, this allows to detach and then re-attach it
     * as one call (convenience method).
     *
     * Automatic recovery of media-errors by this process is configurable.
     */
    Hls.prototype.recoverMediaError = function () {
        logger_1.logger.log('recoverMediaError');
        var media = this.media;
        this.detachMedia();
        this.attachMedia(media);
    };
    Object.defineProperty(Hls.prototype, "levels", {
        /**
         * @type {QualityLevel[]}
         */
        get: function () {
            return this.levelController.levels;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hls.prototype, "currentLevel", {
        /**
         * Index of quality level currently played
         * @type {number}
         */
        get: function () {
            return this.streamController.currentLevel;
        },
        /**
         * Set quality level index immediately .
         * This will flush the current buffer to replace the quality asap.
         * That means playback will interrupt at least shortly to re-buffer and re-sync eventually.
         * @type {number} -1 for automatic level selection
         */
        set: function (newLevel) {
            logger_1.logger.log("set currentLevel:" + newLevel);
            this.loadLevel = newLevel;
            this.streamController.immediateLevelSwitch();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hls.prototype, "nextLevel", {
        /**
         * Index of next quality level loaded as scheduled by stream controller.
         * @type {number}
         */
        get: function () {
            return this.streamController.nextLevel;
        },
        /**
         * Set quality level index for next loaded data.
         * This will switch the video quality asap, without interrupting playback.
         * May abort current loading of data, and flush parts of buffer (outside currently played fragment region).
         * @type {number} -1 for automatic level selection
         */
        set: function (newLevel) {
            logger_1.logger.log("set nextLevel:" + newLevel);
            this.levelController.manualLevel = newLevel;
            this.streamController.nextLevelSwitch();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hls.prototype, "loadLevel", {
        /**
         * Return the quality level of the currently or last (of none is loaded currently) segment
         * @type {number}
         */
        get: function () {
            return this.levelController.level;
        },
        /**
         * Set quality level index for next loaded data in a conservative way.
         * This will switch the quality without flushing, but interrupt current loading.
         * Thus the moment when the quality switch will appear in effect will only be after the already existing buffer.
         * @type {number} newLevel -1 for automatic level selection
         */
        set: function (newLevel) {
            logger_1.logger.log("set loadLevel:" + newLevel);
            this.levelController.manualLevel = newLevel;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hls.prototype, "nextLoadLevel", {
        /**
         * get next quality level loaded
         * @type {number}
         */
        get: function () {
            return this.levelController.nextLoadLevel;
        },
        /**
         * Set quality level of next loaded segment in a fully "non-destructive" way.
         * Same as `loadLevel` but will wait for next switch (until current loading is done).
         * @type {number} level
         */
        set: function (level) {
            this.levelController.nextLoadLevel = level;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hls.prototype, "firstLevel", {
        /**
         * Return "first level": like a default level, if not set,
         * falls back to index of first level referenced in manifest
         * @type {number}
         */
        get: function () {
            return Math.max(this.levelController.firstLevel, this.minAutoLevel);
        },
        /**
         * Sets "first-level", see getter.
         * @type {number}
         */
        set: function (newLevel) {
            logger_1.logger.log("set firstLevel:" + newLevel);
            this.levelController.firstLevel = newLevel;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hls.prototype, "startLevel", {
        /**
         * Return start level (level of first fragment that will be played back)
         * if not overrided by user, first level appearing in manifest will be used as start level
         * if -1 : automatic start level selection, playback will start from level matching download bandwidth
         * (determined from download of first segment)
         * @type {number}
         */
        get: function () {
            return this.levelController.startLevel;
        },
        /**
         * set  start level (level of first fragment that will be played back)
         * if not overrided by user, first level appearing in manifest will be used as start level
         * if -1 : automatic start level selection, playback will start from level matching download bandwidth
         * (determined from download of first segment)
         * @type {number} newLevel
         */
        set: function (newLevel) {
            logger_1.logger.log("set startLevel:" + newLevel);
            var hls = this;
            // if not in automatic start level detection, ensure startLevel is greater than minAutoLevel
            if (newLevel !== -1) {
                newLevel = Math.max(newLevel, hls.minAutoLevel);
            }
            hls.levelController.startLevel = newLevel;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hls.prototype, "autoLevelCapping", {
        /**
         * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
         * @type {number}
         */
        get: function () {
            return this._autoLevelCapping;
        },
        /**
         * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
         * @type {number}
         */
        set: function (newLevel) {
            logger_1.logger.log("set autoLevelCapping:" + newLevel);
            this._autoLevelCapping = newLevel;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hls.prototype, "autoLevelEnabled", {
        /**
         * True when automatic level selection enabled
         * @type {boolean}
         */
        get: function () {
            return (this.levelController.manualLevel === -1);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hls.prototype, "manualLevel", {
        /**
         * Level set manually (if any)
         * @type {number}
         */
        get: function () {
            return this.levelController.manualLevel;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hls.prototype, "minAutoLevel", {
        /**
         * min level selectable in auto mode according to config.minAutoBitrate
         * @type {number}
         */
        get: function () {
            var hls = this, levels = hls.levels, minAutoBitrate = hls.config.minAutoBitrate, len = levels ? levels.length : 0;
            for (var i = 0; i < len; i++) {
                var levelNextBitrate = levels[i].realBitrate ? Math.max(levels[i].realBitrate, levels[i].bitrate) : levels[i].bitrate;
                if (levelNextBitrate > minAutoBitrate) {
                    return i;
                }
            }
            return 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hls.prototype, "maxAutoLevel", {
        /**
         * max level selectable in auto mode according to autoLevelCapping
         * @type {number}
         */
        get: function () {
            var hls = this;
            var levels = hls.levels;
            var autoLevelCapping = hls.autoLevelCapping;
            var maxAutoLevel;
            if (autoLevelCapping === -1 && levels && levels.length) {
                maxAutoLevel = levels.length - 1;
            }
            else {
                maxAutoLevel = autoLevelCapping;
            }
            return maxAutoLevel;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hls.prototype, "nextAutoLevel", {
        /**
         * next automatically selected quality level
         * @type {number}
         */
        get: function () {
            var hls = this;
            // ensure next auto level is between  min and max auto level
            return Math.min(Math.max(hls.abrController.nextAutoLevel, hls.minAutoLevel), hls.maxAutoLevel);
        },
        /**
         * this setter is used to force next auto level.
         * this is useful to force a switch down in auto mode:
         * in case of load error on level N, hls.js can set nextAutoLevel to N-1 for example)
         * forced value is valid for one fragment. upon succesful frag loading at forced level,
         * this value will be resetted to -1 by ABR controller.
         * @type {number}
         */
        set: function (nextLevel) {
            var hls = this;
            hls.abrController.nextAutoLevel = Math.max(hls.minAutoLevel, nextLevel);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hls.prototype, "audioTracks", {
        /**
         * @type {AudioTrack[]}
         */
        get: function () {
            var audioTrackController = this.audioTrackController;
            return audioTrackController ? audioTrackController.audioTracks : [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hls.prototype, "audioTrack", {
        /**
         * index of the selected audio track (index in audio track lists)
         * @type {number}
         */
        get: function () {
            var audioTrackController = this.audioTrackController;
            return audioTrackController ? audioTrackController.audioTrack : -1;
        },
        /**
         * selects an audio track, based on its index in audio track lists
         * @type {number}
         */
        set: function (audioTrackId) {
            var audioTrackController = this.audioTrackController;
            if (audioTrackController) {
                audioTrackController.audioTrack = audioTrackId;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hls.prototype, "liveSyncPosition", {
        /**
         * @type {Seconds}
         */
        get: function () {
            return this.streamController.liveSyncPosition;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hls.prototype, "subtitleTracks", {
        /**
         * get alternate subtitle tracks list from playlist
         * @type {SubtitleTrack[]}
         */
        get: function () {
            var subtitleTrackController = this.subtitleTrackController;
            return subtitleTrackController ? subtitleTrackController.subtitleTracks : [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hls.prototype, "subtitleTrack", {
        /**
         * index of the selected subtitle track (index in subtitle track lists)
         * @type {number}
         */
        get: function () {
            var subtitleTrackController = this.subtitleTrackController;
            return subtitleTrackController ? subtitleTrackController.subtitleTrack : -1;
        },
        /**
         * select an subtitle track, based on its index in subtitle track lists
         * @type{number}
         */
        set: function (subtitleTrackId) {
            var subtitleTrackController = this.subtitleTrackController;
            if (subtitleTrackController) {
                subtitleTrackController.subtitleTrack = subtitleTrackId;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hls.prototype, "subtitleDisplay", {
        /**
         * @type {boolean}
         */
        get: function () {
            var subtitleTrackController = this.subtitleTrackController;
            return subtitleTrackController ? subtitleTrackController.subtitleDisplay : false;
        },
        /**
         * Enable/disable subtitle display rendering
         * @type {boolean}
         */
        set: function (value) {
            var subtitleTrackController = this.subtitleTrackController;
            if (subtitleTrackController) {
                subtitleTrackController.subtitleDisplay = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    return Hls;
}(observer_1.Observer));
exports.default = Hls;


/***/ }),

/***/ "./src/is-supported.js":
/*!*****************************!*\
  !*** ./src/is-supported.js ***!
  \*****************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var mediasource_helper_1 = __webpack_require__(/*! ./utils/mediasource-helper */ "./src/utils/mediasource-helper.js");
function isSupported() {
    var mediaSource = mediasource_helper_1.getMediaSource();
    var sourceBuffer = window.SourceBuffer || window.WebKitSourceBuffer;
    var isTypeSupported = mediaSource &&
        typeof mediaSource.isTypeSupported === 'function' &&
        mediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"');
    // if SourceBuffer is exposed ensure its API is valid
    // safari and old version of Chrome doe not expose SourceBuffer globally so checking SourceBuffer.prototype is impossible
    var sourceBufferValidAPI = !sourceBuffer ||
        (sourceBuffer.prototype &&
            typeof sourceBuffer.prototype.appendBuffer === 'function' &&
            typeof sourceBuffer.prototype.remove === 'function');
    return !!isTypeSupported && !!sourceBufferValidAPI;
}
exports.isSupported = isSupported;


/***/ }),

/***/ "./src/loader/fragment-loader.js":
/*!***************************************!*\
  !*** ./src/loader/fragment-loader.js ***!
  \***************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Number) {
/*
 * Fragment Loader
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var event_handler_1 = __webpack_require__(/*! ../event-handler */ "./src/event-handler.js");
var errors_1 = __webpack_require__(/*! ../errors */ "./src/errors.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var FragmentLoader = /** @class */ (function (_super) {
    __extends(FragmentLoader, _super);
    function FragmentLoader(hls) {
        var _this = _super.call(this, hls, events_1.default.FRAG_LOADING) || this;
        _this.loaders = {};
        return _this;
    }
    FragmentLoader.prototype.destroy = function () {
        var loaders = this.loaders;
        for (var loaderName in loaders) {
            var loader = loaders[loaderName];
            if (loader) {
                loader.destroy();
            }
        }
        this.loaders = {};
        _super.prototype.destroy.call(this);
    };
    FragmentLoader.prototype.onFragLoading = function (data) {
        var frag = data.frag, type = frag.type, loaders = this.loaders, config = this.hls.config, FragmentILoader = config.fLoader, DefaultILoader = config.loader;
        // reset fragment state
        frag.loaded = 0;
        var loader = loaders[type];
        if (loader) {
            logger_1.logger.warn("abort previous fragment loader for type: " + type);
            loader.abort();
        }
        loader = loaders[type] = frag.loader =
            config.fLoader ? new FragmentILoader(config) : new DefaultILoader(config);
        var loaderContext, loaderConfig, loaderCallbacks;
        loaderContext = { url: frag.url, frag: frag, responseType: 'arraybuffer', progressData: false };
        var start = frag.byteRangeStartOffset, end = frag.byteRangeEndOffset;
        if (Number.isFinite(start) && Number.isFinite(end)) {
            loaderContext.rangeStart = start;
            loaderContext.rangeEnd = end;
        }
        loaderConfig = {
            timeout: config.fragLoadingTimeOut,
            maxRetry: 0,
            retryDelay: 0,
            maxRetryDelay: config.fragLoadingMaxRetryTimeout
        };
        loaderCallbacks = {
            onSuccess: this.loadsuccess.bind(this),
            onError: this.loaderror.bind(this),
            onTimeout: this.loadtimeout.bind(this),
            onProgress: this.loadprogress.bind(this)
        };
        loader.load(loaderContext, loaderConfig, loaderCallbacks);
    };
    FragmentLoader.prototype.loadsuccess = function (response, stats, context, networkDetails) {
        if (networkDetails === void 0) { networkDetails = null; }
        var payload = response.data, frag = context.frag;
        // detach fragment loader on load success
        frag.loader = undefined;
        this.loaders[frag.type] = undefined;
        this.hls.trigger(events_1.default.FRAG_LOADED, { payload: payload, frag: frag, stats: stats, networkDetails: networkDetails });
    };
    FragmentLoader.prototype.loaderror = function (response, context, networkDetails) {
        if (networkDetails === void 0) { networkDetails = null; }
        var frag = context.frag;
        var loader = frag.loader;
        if (loader) {
            loader.abort();
        }
        this.loaders[frag.type] = undefined;
        this.hls.trigger(events_1.default.ERROR, { type: errors_1.ErrorTypes.NETWORK_ERROR, details: errors_1.ErrorDetails.FRAG_LOAD_ERROR, fatal: false, frag: context.frag, response: response, networkDetails: networkDetails });
    };
    FragmentLoader.prototype.loadtimeout = function (stats, context, networkDetails) {
        if (networkDetails === void 0) { networkDetails = null; }
        var frag = context.frag;
        var loader = frag.loader;
        if (loader) {
            loader.abort();
        }
        this.loaders[frag.type] = undefined;
        this.hls.trigger(events_1.default.ERROR, { type: errors_1.ErrorTypes.NETWORK_ERROR, details: errors_1.ErrorDetails.FRAG_LOAD_TIMEOUT, fatal: false, frag: context.frag, networkDetails: networkDetails });
    };
    // data will be used for progressive parsing
    FragmentLoader.prototype.loadprogress = function (stats, context, data, networkDetails) {
        if (networkDetails === void 0) { networkDetails = null; }
        var frag = context.frag;
        frag.loaded = stats.loaded;
        this.hls.trigger(events_1.default.FRAG_LOAD_PROGRESS, { frag: frag, stats: stats, networkDetails: networkDetails });
    };
    return FragmentLoader;
}(event_handler_1.default));
exports.default = FragmentLoader;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./src/polyfills/number */ "./src/polyfills/number.js")["Number"]))

/***/ }),

/***/ "./src/loader/fragment.js":
/*!********************************!*\
  !*** ./src/loader/fragment.js ***!
  \********************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Number) {
Object.defineProperty(exports, "__esModule", { value: true });
var URLToolkit = __webpack_require__(/*! url-toolkit */ "./node_modules/url-toolkit/src/url-toolkit.js");
var level_key_1 = __webpack_require__(/*! ./level-key */ "./src/loader/level-key.js");
var Fragment = /** @class */ (function () {
    function Fragment() {
        var _a;
        this._url = null;
        this._byteRange = null;
        this._decryptdata = null;
        this.tagList = [];
        this.programDateTime = null;
        this.rawProgramDateTime = null;
        // Holds the types of data this fragment supports
        this._elementaryStreams = (_a = {},
            _a[Fragment.ElementaryStreamTypes.AUDIO] = false,
            _a[Fragment.ElementaryStreamTypes.VIDEO] = false,
            _a);
    }
    Object.defineProperty(Fragment, "ElementaryStreamTypes", {
        /**
         * `type` property for this._elementaryStreams
         *
         * @enum
         */
        get: function () {
            return {
                AUDIO: 'audio',
                VIDEO: 'video'
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Fragment.prototype, "url", {
        get: function () {
            if (!this._url && this.relurl) {
                this._url = URLToolkit.buildAbsoluteURL(this.baseurl, this.relurl, { alwaysNormalize: true });
            }
            return this._url;
        },
        set: function (value) {
            this._url = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Fragment.prototype, "byteRange", {
        get: function () {
            if (!this._byteRange && !this.rawByteRange) {
                return [];
            }
            if (this._byteRange) {
                return this._byteRange;
            }
            var byteRange = [];
            if (this.rawByteRange) {
                var params = this.rawByteRange.split('@', 2);
                if (params.length === 1) {
                    var lastByteRangeEndOffset = this.lastByteRangeEndOffset;
                    byteRange[0] = lastByteRangeEndOffset || 0;
                }
                else {
                    byteRange[0] = parseInt(params[1]);
                }
                byteRange[1] = parseInt(params[0]) + byteRange[0];
                this._byteRange = byteRange;
            }
            return byteRange;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Fragment.prototype, "byteRangeStartOffset", {
        /**
         * @type {number}
         */
        get: function () {
            return this.byteRange[0];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Fragment.prototype, "byteRangeEndOffset", {
        get: function () {
            return this.byteRange[1];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Fragment.prototype, "decryptdata", {
        get: function () {
            if (!this._decryptdata) {
                this._decryptdata = this.fragmentDecryptdataFromLevelkey(this.levelkey, this.sn);
            }
            return this._decryptdata;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Fragment.prototype, "endProgramDateTime", {
        get: function () {
            if (!Number.isFinite(this.programDateTime)) {
                return null;
            }
            var duration = !Number.isFinite(this.duration) ? 0 : this.duration;
            return this.programDateTime + (duration * 1000);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Fragment.prototype, "encrypted", {
        get: function () {
            return !!((this.decryptdata && this.decryptdata.uri !== null) && (this.decryptdata.key === null));
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {ElementaryStreamType} type
     */
    Fragment.prototype.addElementaryStream = function (type) {
        this._elementaryStreams[type] = true;
    };
    /**
     * @param {ElementaryStreamType} type
     */
    Fragment.prototype.hasElementaryStream = function (type) {
        return this._elementaryStreams[type] === true;
    };
    /**
     * Utility method for parseLevelPlaylist to create an initialization vector for a given segment
     * @returns {Uint8Array}
     */
    Fragment.prototype.createInitializationVector = function (segmentNumber) {
        var uint8View = new Uint8Array(16);
        for (var i = 12; i < 16; i++) {
            uint8View[i] = (segmentNumber >> 8 * (15 - i)) & 0xff;
        }
        return uint8View;
    };
    /**
     * Utility method for parseLevelPlaylist to get a fragment's decryption data from the currently parsed encryption key data
     * @param levelkey - a playlist's encryption info
     * @param segmentNumber - the fragment's segment number
     * @returns {*} - an object to be applied as a fragment's decryptdata
     */
    Fragment.prototype.fragmentDecryptdataFromLevelkey = function (levelkey, segmentNumber) {
        var decryptdata = levelkey;
        if (levelkey && levelkey.method && levelkey.uri && !levelkey.iv) {
            decryptdata = new level_key_1.default();
            decryptdata.method = levelkey.method;
            decryptdata.baseuri = levelkey.baseuri;
            decryptdata.reluri = levelkey.reluri;
            decryptdata.iv = this.createInitializationVector(segmentNumber);
        }
        return decryptdata;
    };
    return Fragment;
}());
exports.default = Fragment;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./src/polyfills/number */ "./src/polyfills/number.js")["Number"]))

/***/ }),

/***/ "./src/loader/key-loader.js":
/*!**********************************!*\
  !*** ./src/loader/key-loader.js ***!
  \**********************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Decrypt key Loader
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var event_handler_1 = __webpack_require__(/*! ../event-handler */ "./src/event-handler.js");
var errors_1 = __webpack_require__(/*! ../errors */ "./src/errors.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var KeyLoader = /** @class */ (function (_super) {
    __extends(KeyLoader, _super);
    function KeyLoader(hls) {
        var _this = _super.call(this, hls, events_1.default.KEY_LOADING) || this;
        _this.loaders = {};
        _this.decryptkey = null;
        _this.decrypturl = null;
        return _this;
    }
    KeyLoader.prototype.destroy = function () {
        for (var loaderName in this.loaders) {
            var loader = this.loaders[loaderName];
            if (loader) {
                loader.destroy();
            }
        }
        this.loaders = {};
        event_handler_1.default.prototype.destroy.call(this);
    };
    KeyLoader.prototype.onKeyLoading = function (data) {
        var frag = data.frag, type = frag.type, loader = this.loaders[type], decryptdata = frag.decryptdata, uri = decryptdata.uri;
        // if uri is different from previous one or if decrypt key not retrieved yet
        if (uri !== this.decrypturl || this.decryptkey === null) {
            var config = this.hls.config;
            if (loader) {
                logger_1.logger.warn("abort previous key loader for type:" + type);
                loader.abort();
            }
            frag.loader = this.loaders[type] = new config.loader(config);
            this.decrypturl = uri;
            this.decryptkey = null;
            var loaderContext = void 0, loaderConfig = void 0, loaderCallbacks = void 0;
            loaderContext = { url: uri, frag: frag, responseType: 'arraybuffer' };
            // maxRetry is 0 so that instead of retrying the same key on the same variant multiple times,
            // key-loader will trigger an error and rely on stream-controller to handle retry logic.
            // this will also align retry logic with fragment-loader
            loaderConfig = { timeout: config.fragLoadingTimeOut, maxRetry: 0, retryDelay: config.fragLoadingRetryDelay, maxRetryDelay: config.fragLoadingMaxRetryTimeout };
            loaderCallbacks = { onSuccess: this.loadsuccess.bind(this), onError: this.loaderror.bind(this), onTimeout: this.loadtimeout.bind(this) };
            frag.loader.load(loaderContext, loaderConfig, loaderCallbacks);
        }
        else if (this.decryptkey) {
            // we already loaded this key, return it
            decryptdata.key = this.decryptkey;
            this.hls.trigger(events_1.default.KEY_LOADED, { frag: frag });
        }
    };
    KeyLoader.prototype.loadsuccess = function (response, stats, context) {
        var frag = context.frag;
        this.decryptkey = frag.decryptdata.key = new Uint8Array(response.data);
        // detach fragment loader on load success
        frag.loader = undefined;
        this.loaders[frag.type] = undefined;
        this.hls.trigger(events_1.default.KEY_LOADED, { frag: frag });
    };
    KeyLoader.prototype.loaderror = function (response, context) {
        var frag = context.frag, loader = frag.loader;
        if (loader) {
            loader.abort();
        }
        this.loaders[context.type] = undefined;
        this.hls.trigger(events_1.default.ERROR, { type: errors_1.ErrorTypes.NETWORK_ERROR, details: errors_1.ErrorDetails.KEY_LOAD_ERROR, fatal: false, frag: frag, response: response });
    };
    KeyLoader.prototype.loadtimeout = function (stats, context) {
        var frag = context.frag, loader = frag.loader;
        if (loader) {
            loader.abort();
        }
        this.loaders[context.type] = undefined;
        this.hls.trigger(events_1.default.ERROR, { type: errors_1.ErrorTypes.NETWORK_ERROR, details: errors_1.ErrorDetails.KEY_LOAD_TIMEOUT, fatal: false, frag: frag });
    };
    return KeyLoader;
}(event_handler_1.default));
exports.default = KeyLoader;


/***/ }),

/***/ "./src/loader/level-key.js":
/*!*********************************!*\
  !*** ./src/loader/level-key.js ***!
  \*********************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var URLToolkit = __webpack_require__(/*! url-toolkit */ "./node_modules/url-toolkit/src/url-toolkit.js");
var LevelKey = /** @class */ (function () {
    function LevelKey() {
        this.method = null;
        this.key = null;
        this.iv = null;
        this._uri = null;
    }
    Object.defineProperty(LevelKey.prototype, "uri", {
        get: function () {
            if (!this._uri && this.reluri) {
                this._uri = URLToolkit.buildAbsoluteURL(this.baseuri, this.reluri, { alwaysNormalize: true });
            }
            return this._uri;
        },
        enumerable: true,
        configurable: true
    });
    return LevelKey;
}());
exports.default = LevelKey;


/***/ }),

/***/ "./src/loader/level.js":
/*!*****************************!*\
  !*** ./src/loader/level.js ***!
  \*****************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Number) {
Object.defineProperty(exports, "__esModule", { value: true });
var Level = /** @class */ (function () {
    function Level(baseUrl) {
        // Please keep properties in alphabetical order
        this.endCC = 0;
        this.endSN = 0;
        this.fragments = [];
        this.initSegment = null;
        this.live = true;
        this.needSidxRanges = false;
        this.startCC = 0;
        this.startSN = 0;
        this.startTimeOffset = null;
        this.targetduration = 0;
        this.totalduration = 0;
        this.type = null;
        this.url = baseUrl;
        this.version = null;
    }
    Object.defineProperty(Level.prototype, "hasProgramDateTime", {
        get: function () {
            return !!(this.fragments[0] && Number.isFinite(this.fragments[0].programDateTime));
        },
        enumerable: true,
        configurable: true
    });
    return Level;
}());
exports.default = Level;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./src/polyfills/number */ "./src/polyfills/number.js")["Number"]))

/***/ }),

/***/ "./src/loader/m3u8-parser.js":
/*!***********************************!*\
  !*** ./src/loader/m3u8-parser.js ***!
  \***********************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Number) {
Object.defineProperty(exports, "__esModule", { value: true });
var URLToolkit = __webpack_require__(/*! url-toolkit */ "./node_modules/url-toolkit/src/url-toolkit.js");
var fragment_1 = __webpack_require__(/*! ./fragment */ "./src/loader/fragment.js");
var level_1 = __webpack_require__(/*! ./level */ "./src/loader/level.js");
var level_key_1 = __webpack_require__(/*! ./level-key */ "./src/loader/level-key.js");
var attr_list_1 = __webpack_require__(/*! ../utils/attr-list */ "./src/utils/attr-list.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var codecs_1 = __webpack_require__(/*! ../utils/codecs */ "./src/utils/codecs.js");
/**
 * M3U8 parser
 * @module
 */
// https://regex101.com is your friend
var MASTER_PLAYLIST_REGEX = /#EXT-X-STREAM-INF:([^\n\r]*)[\r\n]+([^\r\n]+)/g;
var MASTER_PLAYLIST_MEDIA_REGEX = /#EXT-X-MEDIA:(.*)/g;
var LEVEL_PLAYLIST_REGEX_FAST = new RegExp([
    /#EXTINF:\s*(\d*(?:\.\d+)?)(?:,(.*)\s+)?/.source,
    /|(?!#)([\S+ ?]+)/.source,
    /|#EXT-X-BYTERANGE:*(.+)/.source,
    /|#EXT-X-PROGRAM-DATE-TIME:(.+)/.source,
    /|#.*/.source // All other non-segment oriented tags will match with all groups empty
].join(''), 'g');
var LEVEL_PLAYLIST_REGEX_SLOW = /(?:(?:#(EXTM3U))|(?:#EXT-X-(PLAYLIST-TYPE):(.+))|(?:#EXT-X-(MEDIA-SEQUENCE): *(\d+))|(?:#EXT-X-(TARGETDURATION): *(\d+))|(?:#EXT-X-(KEY):(.+))|(?:#EXT-X-(START):(.+))|(?:#EXT-X-(ENDLIST))|(?:#EXT-X-(DISCONTINUITY-SEQ)UENCE:(\d+))|(?:#EXT-X-(DIS)CONTINUITY))|(?:#EXT-X-(VERSION):(\d+))|(?:#EXT-X-(MAP):(.+))|(?:(#)([^:]*):(.*))|(?:(#)(.*))(?:.*)\r?\n?/;
var MP4_REGEX_SUFFIX = /\.(mp4|m4s|m4v|m4a)$/i;
var M3U8Parser = /** @class */ (function () {
    function M3U8Parser() {
    }
    M3U8Parser.findGroup = function (groups, mediaGroupId) {
        if (!groups) {
            return null;
        }
        var matchingGroup = null;
        for (var i = 0; i < groups.length; i++) {
            var group = groups[i];
            if (group.id === mediaGroupId) {
                matchingGroup = group;
            }
        }
        return matchingGroup;
    };
    M3U8Parser.convertAVC1ToAVCOTI = function (codec) {
        var result, avcdata = codec.split('.');
        if (avcdata.length > 2) {
            result = avcdata.shift() + '.';
            result += parseInt(avcdata.shift()).toString(16);
            result += ('000' + parseInt(avcdata.shift()).toString(16)).substr(-4);
        }
        else {
            result = codec;
        }
        return result;
    };
    M3U8Parser.resolve = function (url, baseUrl) {
        return URLToolkit.buildAbsoluteURL(baseUrl, url, { alwaysNormalize: true });
    };
    M3U8Parser.parseMasterPlaylist = function (string, baseurl) {
        var levels = [], result;
        MASTER_PLAYLIST_REGEX.lastIndex = 0;
        function setCodecs(codecs, level) {
            ['video', 'audio'].forEach(function (type) {
                var filtered = codecs.filter(function (codec) { return codecs_1.isCodecType(codec, type); });
                if (filtered.length) {
                    var preferred = filtered.filter(function (codec) {
                        return codec.lastIndexOf('avc1', 0) === 0 || codec.lastIndexOf('mp4a', 0) === 0;
                    });
                    level[type + "Codec"] = preferred.length > 0 ? preferred[0] : filtered[0];
                    // remove from list
                    codecs = codecs.filter(function (codec) { return filtered.indexOf(codec) === -1; });
                }
            });
            level.unknownCodecs = codecs;
        }
        while ((result = MASTER_PLAYLIST_REGEX.exec(string)) != null) {
            var level = {};
            var attrs = level.attrs = new attr_list_1.default(result[1]);
            level.url = M3U8Parser.resolve(result[2], baseurl);
            var resolution = attrs.decimalResolution('RESOLUTION');
            if (resolution) {
                level.width = resolution.width;
                level.height = resolution.height;
            }
            level.bitrate = attrs.decimalInteger('AVERAGE-BANDWIDTH') || attrs.decimalInteger('BANDWIDTH');
            level.name = attrs.NAME;
            setCodecs([].concat((attrs.CODECS || '').split(/[ ,]+/)), level);
            if (level.videoCodec && level.videoCodec.indexOf('avc1') !== -1) {
                level.videoCodec = M3U8Parser.convertAVC1ToAVCOTI(level.videoCodec);
            }
            levels.push(level);
        }
        return levels;
    };
    M3U8Parser.parseMasterPlaylistMedia = function (string, baseurl, type, audioGroups) {
        if (audioGroups === void 0) { audioGroups = []; }
        var result;
        var medias = [];
        var id = 0;
        MASTER_PLAYLIST_MEDIA_REGEX.lastIndex = 0;
        while ((result = MASTER_PLAYLIST_MEDIA_REGEX.exec(string)) !== null) {
            var media = {};
            var attrs = new attr_list_1.default(result[1]);
            if (attrs.TYPE === type) {
                media.groupId = attrs['GROUP-ID'];
                media.name = attrs.NAME;
                media.type = type;
                media.default = (attrs.DEFAULT === 'YES');
                media.autoselect = (attrs.AUTOSELECT === 'YES');
                media.forced = (attrs.FORCED === 'YES');
                if (attrs.URI) {
                    media.url = M3U8Parser.resolve(attrs.URI, baseurl);
                }
                media.lang = attrs.LANGUAGE;
                if (!media.name) {
                    media.name = media.lang;
                }
                if (audioGroups.length) {
                    var groupCodec = M3U8Parser.findGroup(audioGroups, media.groupId);
                    media.audioCodec = groupCodec ? groupCodec.codec : audioGroups[0].codec;
                }
                media.id = id++;
                medias.push(media);
            }
        }
        return medias;
    };
    M3U8Parser.parseLevelPlaylist = function (string, baseurl, id, type, levelUrlId) {
        var currentSN = 0;
        var totalduration = 0;
        var level = new level_1.default(baseurl);
        var levelkey = new level_key_1.default();
        var cc = 0;
        var prevFrag = null;
        var frag = new fragment_1.default();
        var result;
        var i;
        var firstPdtIndex = null;
        LEVEL_PLAYLIST_REGEX_FAST.lastIndex = 0;
        while ((result = LEVEL_PLAYLIST_REGEX_FAST.exec(string)) !== null) {
            var duration = result[1];
            if (duration) { // INF
                frag.duration = parseFloat(duration);
                // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
                var title = (' ' + result[2]).slice(1);
                frag.title = title || null;
                frag.tagList.push(title ? ['INF', duration, title] : ['INF', duration]);
            }
            else if (result[3]) { // url
                if (Number.isFinite(frag.duration)) {
                    var sn = currentSN++;
                    frag.type = type;
                    frag.start = totalduration;
                    frag.levelkey = levelkey;
                    frag.sn = sn;
                    frag.level = id;
                    frag.cc = cc;
                    frag.urlId = levelUrlId;
                    frag.baseurl = baseurl;
                    // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
                    frag.relurl = (' ' + result[3]).slice(1);
                    assignProgramDateTime(frag, prevFrag);
                    level.fragments.push(frag);
                    prevFrag = frag;
                    totalduration += frag.duration;
                    frag = new fragment_1.default();
                }
            }
            else if (result[4]) { // X-BYTERANGE
                frag.rawByteRange = (' ' + result[4]).slice(1);
                if (prevFrag) {
                    var lastByteRangeEndOffset = prevFrag.byteRangeEndOffset;
                    if (lastByteRangeEndOffset) {
                        frag.lastByteRangeEndOffset = lastByteRangeEndOffset;
                    }
                }
            }
            else if (result[5]) { // PROGRAM-DATE-TIME
                // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
                frag.rawProgramDateTime = (' ' + result[5]).slice(1);
                frag.tagList.push(['PROGRAM-DATE-TIME', frag.rawProgramDateTime]);
                if (firstPdtIndex === null) {
                    firstPdtIndex = level.fragments.length;
                }
            }
            else {
                result = result[0].match(LEVEL_PLAYLIST_REGEX_SLOW);
                for (i = 1; i < result.length; i++) {
                    if (result[i] !== undefined) {
                        break;
                    }
                }
                // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
                var value1 = (' ' + result[i + 1]).slice(1);
                var value2 = (' ' + result[i + 2]).slice(1);
                switch (result[i]) {
                    case '#':
                        frag.tagList.push(value2 ? [value1, value2] : [value1]);
                        break;
                    case 'PLAYLIST-TYPE':
                        level.type = value1.toUpperCase();
                        break;
                    case 'MEDIA-SEQUENCE':
                        currentSN = level.startSN = parseInt(value1);
                        break;
                    case 'TARGETDURATION':
                        level.targetduration = parseFloat(value1);
                        break;
                    case 'VERSION':
                        level.version = parseInt(value1);
                        break;
                    case 'EXTM3U':
                        break;
                    case 'ENDLIST':
                        level.live = false;
                        break;
                    case 'DIS':
                        cc++;
                        frag.tagList.push(['DIS']);
                        break;
                    case 'DISCONTINUITY-SEQ':
                        cc = parseInt(value1);
                        break;
                    case 'KEY':
                        // https://tools.ietf.org/html/draft-pantos-http-live-streaming-08#section-3.4.4
                        var decryptparams = value1;
                        var keyAttrs = new attr_list_1.default(decryptparams);
                        var decryptmethod = keyAttrs.enumeratedString('METHOD'), decrypturi = keyAttrs.URI, decryptiv = keyAttrs.hexadecimalInteger('IV');
                        if (decryptmethod) {
                            levelkey = new level_key_1.default();
                            if ((decrypturi) && (['AES-128', 'SAMPLE-AES', 'SAMPLE-AES-CENC'].indexOf(decryptmethod) >= 0)) {
                                levelkey.method = decryptmethod;
                                // URI to get the key
                                levelkey.baseuri = baseurl;
                                levelkey.reluri = decrypturi;
                                levelkey.key = null;
                                // Initialization Vector (IV)
                                levelkey.iv = decryptiv;
                            }
                        }
                        break;
                    case 'START':
                        var startParams = value1;
                        var startAttrs = new attr_list_1.default(startParams);
                        var startTimeOffset = startAttrs.decimalFloatingPoint('TIME-OFFSET');
                        // TIME-OFFSET can be 0
                        if (Number.isFinite(startTimeOffset)) {
                            level.startTimeOffset = startTimeOffset;
                        }
                        break;
                    case 'MAP':
                        var mapAttrs = new attr_list_1.default(value1);
                        frag.relurl = mapAttrs.URI;
                        frag.rawByteRange = mapAttrs.BYTERANGE;
                        frag.baseurl = baseurl;
                        frag.level = id;
                        frag.type = type;
                        frag.sn = 'initSegment';
                        level.initSegment = frag;
                        frag = new fragment_1.default();
                        frag.rawProgramDateTime = level.initSegment.rawProgramDateTime;
                        break;
                    default:
                        logger_1.logger.warn("line parsed but not handled: " + result);
                        break;
                }
            }
        }
        frag = prevFrag;
        // logger.log('found ' + level.fragments.length + ' fragments');
        if (frag && !frag.relurl) {
            level.fragments.pop();
            totalduration -= frag.duration;
        }
        level.totalduration = totalduration;
        level.averagetargetduration = totalduration / level.fragments.length;
        level.endSN = currentSN - 1;
        level.startCC = level.fragments[0] ? level.fragments[0].cc : 0;
        level.endCC = cc;
        if (!level.initSegment && level.fragments.length) {
            // this is a bit lurky but HLS really has no other way to tell us
            // if the fragments are TS or MP4, except if we download them :/
            // but this is to be able to handle SIDX.
            if (level.fragments.every(function (frag) { return MP4_REGEX_SUFFIX.test(frag.relurl); })) {
                logger_1.logger.warn('MP4 fragments found but no init segment (probably no MAP, incomplete M3U8), trying to fetch SIDX');
                frag = new fragment_1.default();
                frag.relurl = level.fragments[0].relurl;
                frag.baseurl = baseurl;
                frag.level = id;
                frag.type = type;
                frag.sn = 'initSegment';
                level.initSegment = frag;
                level.needSidxRanges = true;
            }
        }
        /**
         * Backfill any missing PDT values
           "If the first EXT-X-PROGRAM-DATE-TIME tag in a Playlist appears after
           one or more Media Segment URIs, the client SHOULD extrapolate
           backward from that tag (using EXTINF durations and/or media
           timestamps) to associate dates with those segments."
         * We have already extrapolated forward, but all fragments up to the first instance of PDT do not have their PDTs
         * computed.
         */
        if (firstPdtIndex) {
            backfillProgramDateTimes(level.fragments, firstPdtIndex);
        }
        return level;
    };
    return M3U8Parser;
}());
exports.default = M3U8Parser;
function backfillProgramDateTimes(fragments, startIndex) {
    var fragPrev = fragments[startIndex];
    for (var i = startIndex - 1; i >= 0; i--) {
        var frag = fragments[i];
        frag.programDateTime = fragPrev.programDateTime - (frag.duration * 1000);
        fragPrev = frag;
    }
}
function assignProgramDateTime(frag, prevFrag) {
    if (frag.rawProgramDateTime) {
        frag.programDateTime = Date.parse(frag.rawProgramDateTime);
    }
    else if (prevFrag && prevFrag.programDateTime) {
        frag.programDateTime = prevFrag.endProgramDateTime;
    }
    if (!Number.isFinite(frag.programDateTime)) {
        frag.programDateTime = null;
        frag.rawProgramDateTime = null;
    }
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./src/polyfills/number */ "./src/polyfills/number.js")["Number"]))

/***/ }),

/***/ "./src/loader/playlist-loader.js":
/*!***************************************!*\
  !*** ./src/loader/playlist-loader.js ***!
  \***************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Number) {
/**
 * PlaylistLoader - delegate for media manifest/playlist loading tasks. Takes care of parsing media to internal data-models.
 *
 * Once loaded, dispatches events with parsed data-models of manifest/levels/audio/subtitle tracks.
 *
 * Uses loader(s) set in config to do actual internal loading of resource tasks.
 *
 * @module
 *
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var event_handler_1 = __webpack_require__(/*! ../event-handler */ "./src/event-handler.js");
var errors_1 = __webpack_require__(/*! ../errors */ "./src/errors.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var mp4demuxer_1 = __webpack_require__(/*! ../demux/mp4demuxer */ "./src/demux/mp4demuxer.js");
var m3u8_parser_1 = __webpack_require__(/*! ./m3u8-parser */ "./src/loader/m3u8-parser.js");
var performance = window.performance;
/**
 * `type` property values for this loaders' context object
 * @enum
 *
 */
var ContextType = {
    MANIFEST: 'manifest',
    LEVEL: 'level',
    AUDIO_TRACK: 'audioTrack',
    SUBTITLE_TRACK: 'subtitleTrack'
};
/**
 * @enum {string}
 */
var LevelType = {
    MAIN: 'main',
    AUDIO: 'audio',
    SUBTITLE: 'subtitle'
};
/**
 * @constructor
 */
var PlaylistLoader = /** @class */ (function (_super) {
    __extends(PlaylistLoader, _super);
    /**
     * @constructs
     * @param {Hls} hls
     */
    function PlaylistLoader(hls) {
        var _this = _super.call(this, hls, events_1.default.MANIFEST_LOADING, events_1.default.LEVEL_LOADING, events_1.default.AUDIO_TRACK_LOADING, events_1.default.SUBTITLE_TRACK_LOADING) || this;
        _this.loaders = {};
        return _this;
    }
    Object.defineProperty(PlaylistLoader, "ContextType", {
        get: function () {
            return ContextType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlaylistLoader, "LevelType", {
        get: function () {
            return LevelType;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {ContextType} type
     * @returns {boolean}
     */
    PlaylistLoader.canHaveQualityLevels = function (type) {
        return (type !== ContextType.AUDIO_TRACK &&
            type !== ContextType.SUBTITLE_TRACK);
    };
    /**
     * Map context.type to LevelType
     * @param {{type: ContextType}} context
     * @returns {LevelType}
     */
    PlaylistLoader.mapContextToLevelType = function (context) {
        var type = context.type;
        switch (type) {
            case ContextType.AUDIO_TRACK:
                return LevelType.AUDIO;
            case ContextType.SUBTITLE_TRACK:
                return LevelType.SUBTITLE;
            default:
                return LevelType.MAIN;
        }
    };
    PlaylistLoader.getResponseUrl = function (response, context) {
        var url = response.url;
        // responseURL not supported on some browsers (it is used to detect URL redirection)
        // data-uri mode also not supported (but no need to detect redirection)
        if (url === undefined || url.indexOf('data:') === 0) {
            // fallback to initial URL
            url = context.url;
        }
        return url;
    };
    /**
     * Returns defaults or configured loader-type overloads (pLoader and loader config params)
     * Default loader is XHRLoader (see utils)
     * @param {object} context
     * @returns {XHRLoader} or other compatible configured overload
     */
    PlaylistLoader.prototype.createInternalLoader = function (context) {
        var config = this.hls.config;
        var PLoader = config.pLoader;
        var Loader = config.loader;
        var InternalLoader = PLoader || Loader;
        var loader = new InternalLoader(config);
        context.loader = loader;
        this.loaders[context.type] = loader;
        return loader;
    };
    PlaylistLoader.prototype.getInternalLoader = function (context) {
        return this.loaders[context.type];
    };
    PlaylistLoader.prototype.resetInternalLoader = function (contextType) {
        if (this.loaders[contextType]) {
            delete this.loaders[contextType];
        }
    };
    /**
     * Call `destroy` on all internal loader instances mapped (one per context type)
     */
    PlaylistLoader.prototype.destroyInternalLoaders = function () {
        for (var contextType in this.loaders) {
            var loader = this.loaders[contextType];
            if (loader) {
                loader.destroy();
            }
            this.resetInternalLoader(contextType);
        }
    };
    PlaylistLoader.prototype.destroy = function () {
        this.destroyInternalLoaders();
        _super.prototype.destroy.call(this);
    };
    PlaylistLoader.prototype.onManifestLoading = function (data) {
        this.load(data.url, { type: ContextType.MANIFEST, level: 0, id: null });
    };
    PlaylistLoader.prototype.onLevelLoading = function (data) {
        this.load(data.url, { type: ContextType.LEVEL, level: data.level, id: data.id });
    };
    PlaylistLoader.prototype.onAudioTrackLoading = function (data) {
        this.load(data.url, { type: ContextType.AUDIO_TRACK, level: null, id: data.id });
    };
    PlaylistLoader.prototype.onSubtitleTrackLoading = function (data) {
        this.load(data.url, { type: ContextType.SUBTITLE_TRACK, level: null, id: data.id });
    };
    PlaylistLoader.prototype.load = function (url, context) {
        var config = this.hls.config;
        logger_1.logger.debug("Loading playlist of type " + context.type + ", level: " + context.level + ", id: " + context.id);
        // Check if a loader for this context already exists
        var loader = this.getInternalLoader(context);
        if (loader) {
            var loaderContext = loader.context;
            if (loaderContext && loaderContext.url === url) { // same URL can't overlap
                logger_1.logger.trace('playlist request ongoing');
                return false;
            }
            else {
                logger_1.logger.warn("aborting previous loader for type: " + context.type);
                loader.abort();
            }
        }
        var maxRetry, timeout, retryDelay, maxRetryDelay;
        // apply different configs for retries depending on
        // context (manifest, level, audio/subs playlist)
        switch (context.type) {
            case ContextType.MANIFEST:
                maxRetry = config.manifestLoadingMaxRetry;
                timeout = config.manifestLoadingTimeOut;
                retryDelay = config.manifestLoadingRetryDelay;
                maxRetryDelay = config.manifestLoadingMaxRetryTimeout;
                break;
            case ContextType.LEVEL:
                // Disable internal loader retry logic, since we are managing retries in Level Controller
                maxRetry = 0;
                timeout = config.levelLoadingTimeOut;
                // TODO Introduce retry settings for audio-track and subtitle-track, it should not use level retry config
                break;
            default:
                maxRetry = config.levelLoadingMaxRetry;
                timeout = config.levelLoadingTimeOut;
                retryDelay = config.levelLoadingRetryDelay;
                maxRetryDelay = config.levelLoadingMaxRetryTimeout;
                break;
        }
        loader = this.createInternalLoader(context);
        context.url = url;
        context.responseType = context.responseType || ''; // FIXME: (should not be necessary to do this)
        var loaderConfig = {
            timeout: timeout,
            maxRetry: maxRetry,
            retryDelay: retryDelay,
            maxRetryDelay: maxRetryDelay
        };
        var loaderCallbacks = {
            onSuccess: this.loadsuccess.bind(this),
            onError: this.loaderror.bind(this),
            onTimeout: this.loadtimeout.bind(this)
        };
        logger_1.logger.debug("Calling internal loader delegate for URL: " + url);
        loader.load(context, loaderConfig, loaderCallbacks);
        return true;
    };
    PlaylistLoader.prototype.loadsuccess = function (response, stats, context, networkDetails) {
        if (networkDetails === void 0) { networkDetails = null; }
        if (context.isSidxRequest) {
            this._handleSidxRequest(response, context);
            this._handlePlaylistLoaded(response, stats, context, networkDetails);
            return;
        }
        this.resetInternalLoader(context.type);
        var string = response.data;
        stats.tload = performance.now();
        // stats.mtime = new Date(target.getResponseHeader('Last-Modified'));
        // Validate if it is an M3U8 at all
        if (string.indexOf('#EXTM3U') !== 0) {
            this._handleManifestParsingError(response, context, 'no EXTM3U delimiter', networkDetails);
            return;
        }
        // Check if chunk-list or master. handle empty chunk list case (first EXTINF not signaled, but TARGETDURATION present)
        if (string.indexOf('#EXTINF:') > 0 || string.indexOf('#EXT-X-TARGETDURATION:') > 0) {
            this._handleTrackOrLevelPlaylist(response, stats, context, networkDetails);
        }
        else {
            this._handleMasterPlaylist(response, stats, context, networkDetails);
        }
    };
    PlaylistLoader.prototype.loaderror = function (response, context, networkDetails) {
        if (networkDetails === void 0) { networkDetails = null; }
        this._handleNetworkError(context, networkDetails, false, response);
    };
    PlaylistLoader.prototype.loadtimeout = function (stats, context, networkDetails) {
        if (networkDetails === void 0) { networkDetails = null; }
        this._handleNetworkError(context, networkDetails, true);
    };
    PlaylistLoader.prototype._handleMasterPlaylist = function (response, stats, context, networkDetails) {
        var hls = this.hls;
        var string = response.data;
        var url = PlaylistLoader.getResponseUrl(response, context);
        var levels = m3u8_parser_1.default.parseMasterPlaylist(string, url);
        if (!levels.length) {
            this._handleManifestParsingError(response, context, 'no level found in manifest', networkDetails);
            return;
        }
        // multi level playlist, parse level info
        var audioGroups = levels.map(function (level) { return ({
            id: level.attrs.AUDIO,
            codec: level.audioCodec
        }); });
        var audioTracks = m3u8_parser_1.default.parseMasterPlaylistMedia(string, url, 'AUDIO', audioGroups);
        var subtitles = m3u8_parser_1.default.parseMasterPlaylistMedia(string, url, 'SUBTITLES');
        if (audioTracks.length) {
            // check if we have found an audio track embedded in main playlist (audio track without URI attribute)
            var embeddedAudioFound_1 = false;
            audioTracks.forEach(function (audioTrack) {
                if (!audioTrack.url) {
                    embeddedAudioFound_1 = true;
                }
            });
            // if no embedded audio track defined, but audio codec signaled in quality level,
            // we need to signal this main audio track this could happen with playlists with
            // alt audio rendition in which quality levels (main)
            // contains both audio+video. but with mixed audio track not signaled
            if (embeddedAudioFound_1 === false && levels[0].audioCodec && !levels[0].attrs.AUDIO) {
                logger_1.logger.log('audio codec signaled in quality level, but no embedded audio track signaled, create one');
                audioTracks.unshift({
                    type: 'main',
                    name: 'main'
                });
            }
        }
        hls.trigger(events_1.default.MANIFEST_LOADED, {
            levels: levels,
            audioTracks: audioTracks,
            subtitles: subtitles,
            url: url,
            stats: stats,
            networkDetails: networkDetails
        });
    };
    PlaylistLoader.prototype._handleTrackOrLevelPlaylist = function (response, stats, context, networkDetails) {
        var hls = this.hls;
        var id = context.id, level = context.level, type = context.type;
        var url = PlaylistLoader.getResponseUrl(response, context);
        var levelUrlId = Number.isFinite(id) ? id : 0;
        var levelId = Number.isFinite(level) ? level : levelUrlId;
        var levelType = PlaylistLoader.mapContextToLevelType(context);
        var levelDetails = m3u8_parser_1.default.parseLevelPlaylist(response.data, url, levelId, levelType, levelUrlId);
        // set stats on level structure
        levelDetails.tload = stats.tload;
        // We have done our first request (Manifest-type) and receive
        // not a master playlist but a chunk-list (track/level)
        // We fire the manifest-loaded event anyway with the parsed level-details
        // by creating a single-level structure for it.
        if (type === ContextType.MANIFEST) {
            var singleLevel = {
                url: url,
                details: levelDetails
            };
            hls.trigger(events_1.default.MANIFEST_LOADED, {
                levels: [singleLevel],
                audioTracks: [],
                url: url,
                stats: stats,
                networkDetails: networkDetails
            });
        }
        // save parsing time
        stats.tparsed = performance.now();
        // in case we need SIDX ranges
        // return early after calling load for
        // the SIDX box.
        if (levelDetails.needSidxRanges) {
            var sidxUrl = levelDetails.initSegment.url;
            this.load(sidxUrl, {
                isSidxRequest: true,
                type: type,
                level: level,
                levelDetails: levelDetails,
                id: id,
                rangeStart: 0,
                rangeEnd: 2048,
                responseType: 'arraybuffer'
            });
            return;
        }
        // extend the context with the new levelDetails property
        context.levelDetails = levelDetails;
        this._handlePlaylistLoaded(response, stats, context, networkDetails);
    };
    PlaylistLoader.prototype._handleSidxRequest = function (response, context) {
        var sidxInfo = mp4demuxer_1.default.parseSegmentIndex(new Uint8Array(response.data));
        // if provided fragment does not contain sidx, early return
        if (!sidxInfo) {
            return;
        }
        var sidxReferences = sidxInfo.references;
        var levelDetails = context.levelDetails;
        sidxReferences.forEach(function (segmentRef, index) {
            var segRefInfo = segmentRef.info;
            var frag = levelDetails.fragments[index];
            if (frag.byteRange.length === 0) {
                frag.rawByteRange = String(1 + segRefInfo.end - segRefInfo.start) + '@' + String(segRefInfo.start);
            }
        });
        levelDetails.initSegment.rawByteRange = String(sidxInfo.moovEndOffset) + '@0';
    };
    PlaylistLoader.prototype._handleManifestParsingError = function (response, context, reason, networkDetails) {
        this.hls.trigger(events_1.default.ERROR, {
            type: errors_1.ErrorTypes.NETWORK_ERROR,
            details: errors_1.ErrorDetails.MANIFEST_PARSING_ERROR,
            fatal: true,
            url: response.url,
            reason: reason,
            networkDetails: networkDetails
        });
    };
    PlaylistLoader.prototype._handleNetworkError = function (context, networkDetails, timeout, response) {
        if (timeout === void 0) { timeout = false; }
        if (response === void 0) { response = null; }
        logger_1.logger.info("A network error occured while loading a " + context.type + "-type playlist");
        var details;
        var fatal;
        var loader = this.getInternalLoader(context);
        switch (context.type) {
            case ContextType.MANIFEST:
                details = (timeout ? errors_1.ErrorDetails.MANIFEST_LOAD_TIMEOUT : errors_1.ErrorDetails.MANIFEST_LOAD_ERROR);
                fatal = true;
                break;
            case ContextType.LEVEL:
                details = (timeout ? errors_1.ErrorDetails.LEVEL_LOAD_TIMEOUT : errors_1.ErrorDetails.LEVEL_LOAD_ERROR);
                fatal = false;
                break;
            case ContextType.AUDIO_TRACK:
                details = (timeout ? errors_1.ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT : errors_1.ErrorDetails.AUDIO_TRACK_LOAD_ERROR);
                fatal = false;
                break;
            default:
                // details = ...?
                fatal = false;
        }
        if (loader) {
            loader.abort();
            this.resetInternalLoader(context.type);
        }
        var errorData = {
            type: errors_1.ErrorTypes.NETWORK_ERROR,
            details: details,
            fatal: fatal,
            url: loader.url,
            loader: loader,
            context: context,
            networkDetails: networkDetails
        };
        if (response) {
            errorData.response = response;
        }
        this.hls.trigger(events_1.default.ERROR, errorData);
    };
    PlaylistLoader.prototype._handlePlaylistLoaded = function (response, stats, context, networkDetails) {
        var type = context.type, level = context.level, id = context.id, levelDetails = context.levelDetails;
        if (!levelDetails.targetduration) {
            this._handleManifestParsingError(response, context, 'invalid target duration', networkDetails);
            return;
        }
        var canHaveLevels = PlaylistLoader.canHaveQualityLevels(context.type);
        if (canHaveLevels) {
            this.hls.trigger(events_1.default.LEVEL_LOADED, {
                details: levelDetails,
                level: level || 0,
                id: id || 0,
                stats: stats,
                networkDetails: networkDetails
            });
        }
        else {
            switch (type) {
                case ContextType.AUDIO_TRACK:
                    this.hls.trigger(events_1.default.AUDIO_TRACK_LOADED, {
                        details: levelDetails,
                        id: id,
                        stats: stats,
                        networkDetails: networkDetails
                    });
                    break;
                case ContextType.SUBTITLE_TRACK:
                    this.hls.trigger(events_1.default.SUBTITLE_TRACK_LOADED, {
                        details: levelDetails,
                        id: id,
                        stats: stats,
                        networkDetails: networkDetails
                    });
                    break;
            }
        }
    };
    return PlaylistLoader;
}(event_handler_1.default));
exports.default = PlaylistLoader;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./src/polyfills/number */ "./src/polyfills/number.js")["Number"]))

/***/ }),

/***/ "./src/observer.js":
/*!*************************!*\
  !*** ./src/observer.js ***!
  \*************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var eventemitter3_1 = __webpack_require__(/*! eventemitter3 */ "./node_modules/eventemitter3/index.js");
/**
 * @class
 *
 * Simple adapter sub-class of Nodejs-like EventEmitter.
 *
 * We simply want to pass along the event-name itself
 * in every call to a handler, which is the purpose of our `trigger` method
 * extending the standard API.
 *
 */
var Observer = /** @class */ (function (_super) {
    __extends(Observer, _super);
    function Observer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} event
     * @param {any} data
     */
    Observer.prototype.trigger = function (event) {
        var data = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            data[_i - 1] = arguments[_i];
        }
        this.emit.apply(this, [event, event].concat(data));
    };
    return Observer;
}(eventemitter3_1.EventEmitter));
exports.Observer = Observer;


/***/ }),

/***/ "./src/polyfills/number.js":
/*!*********************************!*\
  !*** ./src/polyfills/number.js ***!
  \*********************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var get_self_scope_1 = __webpack_require__(/*! ../utils/get-self-scope */ "./src/utils/get-self-scope.js");
var self = get_self_scope_1.getSelfScope();
var Number = self.Number;
exports.Number = Number;
// TODO: get rid of global polyfills and replace them with wrappers ("ponyfills")
Number.isFinite = Number.isFinite || function (value) {
    return typeof value === 'number' && isFinite(value);
};


/***/ }),

/***/ "./src/remux/aac-helper.js":
/*!*********************************!*\
  !*** ./src/remux/aac-helper.js ***!
  \*********************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 *  AAC helper
 */
Object.defineProperty(exports, "__esModule", { value: true });
var AAC = /** @class */ (function () {
    function AAC() {
    }
    AAC.getSilentFrame = function (codec, channelCount) {
        switch (codec) {
            case 'mp4a.40.2':
                if (channelCount === 1) {
                    return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x23, 0x80]);
                }
                else if (channelCount === 2) {
                    return new Uint8Array([0x21, 0x00, 0x49, 0x90, 0x02, 0x19, 0x00, 0x23, 0x80]);
                }
                else if (channelCount === 3) {
                    return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x20, 0x84, 0x01, 0x26, 0x40, 0x08, 0x64, 0x00, 0x8e]);
                }
                else if (channelCount === 4) {
                    return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x20, 0x84, 0x01, 0x26, 0x40, 0x08, 0x64, 0x00, 0x80, 0x2c, 0x80, 0x08, 0x02, 0x38]);
                }
                else if (channelCount === 5) {
                    return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x20, 0x84, 0x01, 0x26, 0x40, 0x08, 0x64, 0x00, 0x82, 0x30, 0x04, 0x99, 0x00, 0x21, 0x90, 0x02, 0x38]);
                }
                else if (channelCount === 6) {
                    return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x20, 0x84, 0x01, 0x26, 0x40, 0x08, 0x64, 0x00, 0x82, 0x30, 0x04, 0x99, 0x00, 0x21, 0x90, 0x02, 0x00, 0xb2, 0x00, 0x20, 0x08, 0xe0]);
                }
                break;
            // handle HE-AAC below (mp4a.40.5 / mp4a.40.29)
            default:
                if (channelCount === 1) {
                    // ffmpeg -y -f lavfi -i "aevalsrc=0:d=0.05" -c:a libfdk_aac -profile:a aac_he -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
                    return new Uint8Array([0x1, 0x40, 0x22, 0x80, 0xa3, 0x4e, 0xe6, 0x80, 0xba, 0x8, 0x0, 0x0, 0x0, 0x1c, 0x6, 0xf1, 0xc1, 0xa, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5e]);
                }
                else if (channelCount === 2) {
                    // ffmpeg -y -f lavfi -i "aevalsrc=0|0:d=0.05" -c:a libfdk_aac -profile:a aac_he_v2 -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
                    return new Uint8Array([0x1, 0x40, 0x22, 0x80, 0xa3, 0x5e, 0xe6, 0x80, 0xba, 0x8, 0x0, 0x0, 0x0, 0x0, 0x95, 0x0, 0x6, 0xf1, 0xa1, 0xa, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5e]);
                }
                else if (channelCount === 3) {
                    // ffmpeg -y -f lavfi -i "aevalsrc=0|0|0:d=0.05" -c:a libfdk_aac -profile:a aac_he_v2 -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
                    return new Uint8Array([0x1, 0x40, 0x22, 0x80, 0xa3, 0x5e, 0xe6, 0x80, 0xba, 0x8, 0x0, 0x0, 0x0, 0x0, 0x95, 0x0, 0x6, 0xf1, 0xa1, 0xa, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5e]);
                }
                break;
        }
        return null;
    };
    return AAC;
}());
exports.default = AAC;


/***/ }),

/***/ "./src/remux/mp4-generator.js":
/*!************************************!*\
  !*** ./src/remux/mp4-generator.js ***!
  \************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Generate MP4 Box
*/
Object.defineProperty(exports, "__esModule", { value: true });
var UINT32_MAX = Math.pow(2, 32) - 1;
var MP4 = /** @class */ (function () {
    function MP4() {
    }
    MP4.init = function () {
        MP4.types = {
            avc1: [],
            avcC: [],
            btrt: [],
            dinf: [],
            dref: [],
            esds: [],
            ftyp: [],
            hdlr: [],
            mdat: [],
            mdhd: [],
            mdia: [],
            mfhd: [],
            minf: [],
            moof: [],
            moov: [],
            mp4a: [],
            '.mp3': [],
            mvex: [],
            mvhd: [],
            pasp: [],
            sdtp: [],
            stbl: [],
            stco: [],
            stsc: [],
            stsd: [],
            stsz: [],
            stts: [],
            tfdt: [],
            tfhd: [],
            traf: [],
            trak: [],
            trun: [],
            trex: [],
            tkhd: [],
            vmhd: [],
            smhd: []
        };
        var i;
        for (i in MP4.types) {
            if (MP4.types.hasOwnProperty(i)) {
                MP4.types[i] = [
                    i.charCodeAt(0),
                    i.charCodeAt(1),
                    i.charCodeAt(2),
                    i.charCodeAt(3)
                ];
            }
        }
        var videoHdlr = new Uint8Array([
            0x00,
            0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x76, 0x69, 0x64, 0x65,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x56, 0x69, 0x64, 0x65,
            0x6f, 0x48, 0x61, 0x6e,
            0x64, 0x6c, 0x65, 0x72, 0x00 // name: 'VideoHandler'
        ]);
        var audioHdlr = new Uint8Array([
            0x00,
            0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x73, 0x6f, 0x75, 0x6e,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x53, 0x6f, 0x75, 0x6e,
            0x64, 0x48, 0x61, 0x6e,
            0x64, 0x6c, 0x65, 0x72, 0x00 // name: 'SoundHandler'
        ]);
        MP4.HDLR_TYPES = {
            'video': videoHdlr,
            'audio': audioHdlr
        };
        var dref = new Uint8Array([
            0x00,
            0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x01,
            0x00, 0x00, 0x00, 0x0c,
            0x75, 0x72, 0x6c, 0x20,
            0x00,
            0x00, 0x00, 0x01 // entry_flags
        ]);
        var stco = new Uint8Array([
            0x00,
            0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00 // entry_count
        ]);
        MP4.STTS = MP4.STSC = MP4.STCO = stco;
        MP4.STSZ = new Uint8Array([
            0x00,
            0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00 // sample_count
        ]);
        MP4.VMHD = new Uint8Array([
            0x00,
            0x00, 0x00, 0x01,
            0x00, 0x00,
            0x00, 0x00,
            0x00, 0x00,
            0x00, 0x00 // opcolor
        ]);
        MP4.SMHD = new Uint8Array([
            0x00,
            0x00, 0x00, 0x00,
            0x00, 0x00,
            0x00, 0x00 // reserved
        ]);
        MP4.STSD = new Uint8Array([
            0x00,
            0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x01
        ]); // entry_count
        var majorBrand = new Uint8Array([105, 115, 111, 109]); // isom
        var avc1Brand = new Uint8Array([97, 118, 99, 49]); // avc1
        var minorVersion = new Uint8Array([0, 0, 0, 1]);
        MP4.FTYP = MP4.box(MP4.types.ftyp, majorBrand, minorVersion, majorBrand, avc1Brand);
        MP4.DINF = MP4.box(MP4.types.dinf, MP4.box(MP4.types.dref, dref));
    };
    MP4.box = function (type) {
        var payload = Array.prototype.slice.call(arguments, 1), size = 8, i = payload.length, len = i, result;
        // calculate the total size we need to allocate
        while (i--) {
            size += payload[i].byteLength;
        }
        result = new Uint8Array(size);
        result[0] = (size >> 24) & 0xff;
        result[1] = (size >> 16) & 0xff;
        result[2] = (size >> 8) & 0xff;
        result[3] = size & 0xff;
        result.set(type, 4);
        // copy the payload into the result
        for (i = 0, size = 8; i < len; i++) {
            // copy payload[i] array @ offset size
            result.set(payload[i], size);
            size += payload[i].byteLength;
        }
        return result;
    };
    MP4.hdlr = function (type) {
        return MP4.box(MP4.types.hdlr, MP4.HDLR_TYPES[type]);
    };
    MP4.mdat = function (data) {
        return MP4.box(MP4.types.mdat, data);
    };
    MP4.mdhd = function (timescale, duration) {
        duration *= timescale;
        var upperWordDuration = Math.floor(duration / (UINT32_MAX + 1));
        var lowerWordDuration = Math.floor(duration % (UINT32_MAX + 1));
        return MP4.box(MP4.types.mdhd, new Uint8Array([
            0x01,
            0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x02,
            0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x03,
            (timescale >> 24) & 0xFF,
            (timescale >> 16) & 0xFF,
            (timescale >> 8) & 0xFF,
            timescale & 0xFF,
            (upperWordDuration >> 24),
            (upperWordDuration >> 16) & 0xFF,
            (upperWordDuration >> 8) & 0xFF,
            upperWordDuration & 0xFF,
            (lowerWordDuration >> 24),
            (lowerWordDuration >> 16) & 0xFF,
            (lowerWordDuration >> 8) & 0xFF,
            lowerWordDuration & 0xFF,
            0x55, 0xc4,
            0x00, 0x00
        ]));
    };
    MP4.mdia = function (track) {
        return MP4.box(MP4.types.mdia, MP4.mdhd(track.timescale, track.duration), MP4.hdlr(track.type), MP4.minf(track));
    };
    MP4.mfhd = function (sequenceNumber) {
        return MP4.box(MP4.types.mfhd, new Uint8Array([
            0x00,
            0x00, 0x00, 0x00,
            (sequenceNumber >> 24),
            (sequenceNumber >> 16) & 0xFF,
            (sequenceNumber >> 8) & 0xFF,
            sequenceNumber & 0xFF // sequence_number
        ]));
    };
    MP4.minf = function (track) {
        if (track.type === 'audio') {
            return MP4.box(MP4.types.minf, MP4.box(MP4.types.smhd, MP4.SMHD), MP4.DINF, MP4.stbl(track));
        }
        else {
            return MP4.box(MP4.types.minf, MP4.box(MP4.types.vmhd, MP4.VMHD), MP4.DINF, MP4.stbl(track));
        }
    };
    MP4.moof = function (sn, baseMediaDecodeTime, track) {
        return MP4.box(MP4.types.moof, MP4.mfhd(sn), MP4.traf(track, baseMediaDecodeTime));
    };
    /**
   * @param tracks... (optional) {array} the tracks associated with this movie
   */
    MP4.moov = function (tracks) {
        var i = tracks.length, boxes = [];
        while (i--) {
            boxes[i] = MP4.trak(tracks[i]);
        }
        return MP4.box.apply(null, [MP4.types.moov, MP4.mvhd(tracks[0].timescale, tracks[0].duration)].concat(boxes).concat(MP4.mvex(tracks)));
    };
    MP4.mvex = function (tracks) {
        var i = tracks.length, boxes = [];
        while (i--) {
            boxes[i] = MP4.trex(tracks[i]);
        }
        return MP4.box.apply(null, [MP4.types.mvex].concat(boxes));
    };
    MP4.mvhd = function (timescale, duration) {
        duration *= timescale;
        var upperWordDuration = Math.floor(duration / (UINT32_MAX + 1));
        var lowerWordDuration = Math.floor(duration % (UINT32_MAX + 1));
        var bytes = new Uint8Array([
            0x01,
            0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x02,
            0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x03,
            (timescale >> 24) & 0xFF,
            (timescale >> 16) & 0xFF,
            (timescale >> 8) & 0xFF,
            timescale & 0xFF,
            (upperWordDuration >> 24),
            (upperWordDuration >> 16) & 0xFF,
            (upperWordDuration >> 8) & 0xFF,
            upperWordDuration & 0xFF,
            (lowerWordDuration >> 24),
            (lowerWordDuration >> 16) & 0xFF,
            (lowerWordDuration >> 8) & 0xFF,
            lowerWordDuration & 0xFF,
            0x00, 0x01, 0x00, 0x00,
            0x01, 0x00,
            0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x01, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x01, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x40, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0xff, 0xff, 0xff, 0xff // next_track_ID
        ]);
        return MP4.box(MP4.types.mvhd, bytes);
    };
    MP4.sdtp = function (track) {
        var samples = track.samples || [], bytes = new Uint8Array(4 + samples.length), flags, i;
        // leave the full box header (4 bytes) all zero
        // write the sample table
        for (i = 0; i < samples.length; i++) {
            flags = samples[i].flags;
            bytes[i + 4] = (flags.dependsOn << 4) |
                (flags.isDependedOn << 2) |
                (flags.hasRedundancy);
        }
        return MP4.box(MP4.types.sdtp, bytes);
    };
    MP4.stbl = function (track) {
        return MP4.box(MP4.types.stbl, MP4.stsd(track), MP4.box(MP4.types.stts, MP4.STTS), MP4.box(MP4.types.stsc, MP4.STSC), MP4.box(MP4.types.stsz, MP4.STSZ), MP4.box(MP4.types.stco, MP4.STCO));
    };
    MP4.avc1 = function (track) {
        var sps = [], pps = [], i, data, len;
        // assemble the SPSs
        for (i = 0; i < track.sps.length; i++) {
            data = track.sps[i];
            len = data.byteLength;
            sps.push((len >>> 8) & 0xFF);
            sps.push((len & 0xFF));
            // SPS
            sps = sps.concat(Array.prototype.slice.call(data));
        }
        // assemble the PPSs
        for (i = 0; i < track.pps.length; i++) {
            data = track.pps[i];
            len = data.byteLength;
            pps.push((len >>> 8) & 0xFF);
            pps.push((len & 0xFF));
            pps = pps.concat(Array.prototype.slice.call(data));
        }
        var avcc = MP4.box(MP4.types.avcC, new Uint8Array([
            0x01,
            sps[3],
            sps[4],
            sps[5],
            0xfc | 3,
            0xE0 | track.sps.length // 3bit reserved (111) + numOfSequenceParameterSets
        ].concat(sps).concat([
            track.pps.length // numOfPictureParameterSets
        ]).concat(pps))), // "PPS"
        width = track.width, height = track.height, hSpacing = track.pixelRatio[0], vSpacing = track.pixelRatio[1];
        return MP4.box(MP4.types.avc1, new Uint8Array([
            0x00, 0x00, 0x00,
            0x00, 0x00, 0x00,
            0x00, 0x01,
            0x00, 0x00,
            0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            (width >> 8) & 0xFF,
            width & 0xff,
            (height >> 8) & 0xFF,
            height & 0xff,
            0x00, 0x48, 0x00, 0x00,
            0x00, 0x48, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x01,
            0x12,
            0x64, 0x61, 0x69, 0x6C,
            0x79, 0x6D, 0x6F, 0x74,
            0x69, 0x6F, 0x6E, 0x2F,
            0x68, 0x6C, 0x73, 0x2E,
            0x6A, 0x73, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00,
            0x00, 0x18,
            0x11, 0x11
        ]), // pre_defined = -1
        avcc, MP4.box(MP4.types.btrt, new Uint8Array([
            0x00, 0x1c, 0x9c, 0x80,
            0x00, 0x2d, 0xc6, 0xc0,
            0x00, 0x2d, 0xc6, 0xc0
        ])), // avgBitrate
        MP4.box(MP4.types.pasp, new Uint8Array([
            (hSpacing >> 24),
            (hSpacing >> 16) & 0xFF,
            (hSpacing >> 8) & 0xFF,
            hSpacing & 0xFF,
            (vSpacing >> 24),
            (vSpacing >> 16) & 0xFF,
            (vSpacing >> 8) & 0xFF,
            vSpacing & 0xFF
        ])));
    };
    MP4.esds = function (track) {
        var configlen = track.config.length;
        return new Uint8Array([
            0x00,
            0x00, 0x00, 0x00,
            0x03,
            0x17 + configlen,
            0x00, 0x01,
            0x00,
            0x04,
            0x0f + configlen,
            0x40,
            0x15,
            0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x05 // descriptor_type
        ].concat([configlen]).concat(track.config).concat([0x06, 0x01, 0x02])); // GASpecificConfig)); // length + audio config descriptor
    };
    MP4.mp4a = function (track) {
        var samplerate = track.samplerate;
        return MP4.box(MP4.types.mp4a, new Uint8Array([
            0x00, 0x00, 0x00,
            0x00, 0x00, 0x00,
            0x00, 0x01,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, track.channelCount,
            0x00, 0x10,
            0x00, 0x00, 0x00, 0x00,
            (samplerate >> 8) & 0xFF,
            samplerate & 0xff,
            0x00, 0x00
        ]), MP4.box(MP4.types.esds, MP4.esds(track)));
    };
    MP4.mp3 = function (track) {
        var samplerate = track.samplerate;
        return MP4.box(MP4.types['.mp3'], new Uint8Array([
            0x00, 0x00, 0x00,
            0x00, 0x00, 0x00,
            0x00, 0x01,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, track.channelCount,
            0x00, 0x10,
            0x00, 0x00, 0x00, 0x00,
            (samplerate >> 8) & 0xFF,
            samplerate & 0xff,
            0x00, 0x00
        ]));
    };
    MP4.stsd = function (track) {
        if (track.type === 'audio') {
            if (!track.isAAC && track.codec === 'mp3') {
                return MP4.box(MP4.types.stsd, MP4.STSD, MP4.mp3(track));
            }
            return MP4.box(MP4.types.stsd, MP4.STSD, MP4.mp4a(track));
        }
        else {
            return MP4.box(MP4.types.stsd, MP4.STSD, MP4.avc1(track));
        }
    };
    MP4.tkhd = function (track) {
        var id = track.id, duration = track.duration * track.timescale, width = track.width, height = track.height, upperWordDuration = Math.floor(duration / (UINT32_MAX + 1)), lowerWordDuration = Math.floor(duration % (UINT32_MAX + 1));
        return MP4.box(MP4.types.tkhd, new Uint8Array([
            0x01,
            0x00, 0x00, 0x07,
            0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x02,
            0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x03,
            (id >> 24) & 0xFF,
            (id >> 16) & 0xFF,
            (id >> 8) & 0xFF,
            id & 0xFF,
            0x00, 0x00, 0x00, 0x00,
            (upperWordDuration >> 24),
            (upperWordDuration >> 16) & 0xFF,
            (upperWordDuration >> 8) & 0xFF,
            upperWordDuration & 0xFF,
            (lowerWordDuration >> 24),
            (lowerWordDuration >> 16) & 0xFF,
            (lowerWordDuration >> 8) & 0xFF,
            lowerWordDuration & 0xFF,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00,
            0x00, 0x00,
            0x00, 0x00,
            0x00, 0x00,
            0x00, 0x01, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x01, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x40, 0x00, 0x00, 0x00,
            (width >> 8) & 0xFF,
            width & 0xFF,
            0x00, 0x00,
            (height >> 8) & 0xFF,
            height & 0xFF,
            0x00, 0x00 // height
        ]));
    };
    MP4.traf = function (track, baseMediaDecodeTime) {
        var sampleDependencyTable = MP4.sdtp(track), id = track.id, upperWordBaseMediaDecodeTime = Math.floor(baseMediaDecodeTime / (UINT32_MAX + 1)), lowerWordBaseMediaDecodeTime = Math.floor(baseMediaDecodeTime % (UINT32_MAX + 1));
        return MP4.box(MP4.types.traf, MP4.box(MP4.types.tfhd, new Uint8Array([
            0x00,
            0x00, 0x00, 0x00,
            (id >> 24),
            (id >> 16) & 0XFF,
            (id >> 8) & 0XFF,
            (id & 0xFF) // track_ID
        ])), MP4.box(MP4.types.tfdt, new Uint8Array([
            0x01,
            0x00, 0x00, 0x00,
            (upperWordBaseMediaDecodeTime >> 24),
            (upperWordBaseMediaDecodeTime >> 16) & 0XFF,
            (upperWordBaseMediaDecodeTime >> 8) & 0XFF,
            (upperWordBaseMediaDecodeTime & 0xFF),
            (lowerWordBaseMediaDecodeTime >> 24),
            (lowerWordBaseMediaDecodeTime >> 16) & 0XFF,
            (lowerWordBaseMediaDecodeTime >> 8) & 0XFF,
            (lowerWordBaseMediaDecodeTime & 0xFF)
        ])), MP4.trun(track, sampleDependencyTable.length +
            16 + // tfhd
            20 + // tfdt
            8 + // traf header
            16 + // mfhd
            8 + // moof header
            8), // mdat header
        sampleDependencyTable);
    };
    /**
     * Generate a track box.
     * @param track {object} a track definition
     * @return {Uint8Array} the track box
     */
    MP4.trak = function (track) {
        track.duration = track.duration || 0xffffffff;
        return MP4.box(MP4.types.trak, MP4.tkhd(track), MP4.mdia(track));
    };
    MP4.trex = function (track) {
        var id = track.id;
        return MP4.box(MP4.types.trex, new Uint8Array([
            0x00,
            0x00, 0x00, 0x00,
            (id >> 24),
            (id >> 16) & 0XFF,
            (id >> 8) & 0XFF,
            (id & 0xFF),
            0x00, 0x00, 0x00, 0x01,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x00, 0x00, 0x00,
            0x00, 0x01, 0x00, 0x01 // default_sample_flags
        ]));
    };
    MP4.trun = function (track, offset) {
        var samples = track.samples || [], len = samples.length, arraylen = 12 + (16 * len), array = new Uint8Array(arraylen), i, sample, duration, size, flags, cts;
        offset += 8 + arraylen;
        array.set([
            0x00,
            0x00, 0x0f, 0x01,
            (len >>> 24) & 0xFF,
            (len >>> 16) & 0xFF,
            (len >>> 8) & 0xFF,
            len & 0xFF,
            (offset >>> 24) & 0xFF,
            (offset >>> 16) & 0xFF,
            (offset >>> 8) & 0xFF,
            offset & 0xFF // data_offset
        ], 0);
        for (i = 0; i < len; i++) {
            sample = samples[i];
            duration = sample.duration;
            size = sample.size;
            flags = sample.flags;
            cts = sample.cts;
            array.set([
                (duration >>> 24) & 0xFF,
                (duration >>> 16) & 0xFF,
                (duration >>> 8) & 0xFF,
                duration & 0xFF,
                (size >>> 24) & 0xFF,
                (size >>> 16) & 0xFF,
                (size >>> 8) & 0xFF,
                size & 0xFF,
                (flags.isLeading << 2) | flags.dependsOn,
                (flags.isDependedOn << 6) |
                    (flags.hasRedundancy << 4) |
                    (flags.paddingValue << 1) |
                    flags.isNonSync,
                flags.degradPrio & 0xF0 << 8,
                flags.degradPrio & 0x0F,
                (cts >>> 24) & 0xFF,
                (cts >>> 16) & 0xFF,
                (cts >>> 8) & 0xFF,
                cts & 0xFF // sample_composition_time_offset
            ], 12 + 16 * i);
        }
        return MP4.box(MP4.types.trun, array);
    };
    MP4.initSegment = function (tracks) {
        if (!MP4.types) {
            MP4.init();
        }
        var movie = MP4.moov(tracks), result;
        result = new Uint8Array(MP4.FTYP.byteLength + movie.byteLength);
        result.set(MP4.FTYP);
        result.set(movie, MP4.FTYP.byteLength);
        return result;
    };
    return MP4;
}());
exports.default = MP4;


/***/ }),

/***/ "./src/remux/mp4-remuxer.js":
/*!**********************************!*\
  !*** ./src/remux/mp4-remuxer.js ***!
  \**********************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * fMP4 remuxer
*/
Object.defineProperty(exports, "__esModule", { value: true });
var aac_helper_1 = __webpack_require__(/*! ./aac-helper */ "./src/remux/aac-helper.js");
var mp4_generator_1 = __webpack_require__(/*! ./mp4-generator */ "./src/remux/mp4-generator.js");
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var errors_1 = __webpack_require__(/*! ../errors */ "./src/errors.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
// 10 seconds
var MAX_SILENT_FRAME_DURATION = 10 * 1000;
var MP4Remuxer = /** @class */ (function () {
    function MP4Remuxer(observer, config, typeSupported, vendor) {
        this.observer = observer;
        this.config = config;
        this.typeSupported = typeSupported;
        var userAgent = navigator.userAgent;
        this.isSafari = vendor && vendor.indexOf('Apple') > -1 && userAgent && !userAgent.match('CriOS');
        this.ISGenerated = false;
    }
    MP4Remuxer.prototype.destroy = function () {
    };
    MP4Remuxer.prototype.resetTimeStamp = function (defaultTimeStamp) {
        this._initPTS = this._initDTS = defaultTimeStamp;
    };
    MP4Remuxer.prototype.resetInitSegment = function () {
        this.ISGenerated = false;
    };
    MP4Remuxer.prototype.remux = function (audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset) {
        // generate Init Segment if needed
        if (!this.ISGenerated) {
            this.generateIS(audioTrack, videoTrack, timeOffset);
        }
        if (this.ISGenerated) {
            var nbAudioSamples = audioTrack.samples.length;
            var nbVideoSamples = videoTrack.samples.length;
            var audioTimeOffset = timeOffset;
            var videoTimeOffset = timeOffset;
            if (nbAudioSamples && nbVideoSamples) {
                // timeOffset is expected to be the offset of the first timestamp of this fragment (first DTS)
                // if first audio DTS is not aligned with first video DTS then we need to take that into account
                // when providing timeOffset to remuxAudio / remuxVideo. if we don't do that, there might be a permanent / small
                // drift between audio and video streams
                var audiovideoDeltaDts = (audioTrack.samples[0].pts - videoTrack.samples[0].pts) / videoTrack.inputTimeScale;
                audioTimeOffset += Math.max(0, audiovideoDeltaDts);
                videoTimeOffset += Math.max(0, -audiovideoDeltaDts);
            }
            // Purposefully remuxing audio before video, so that remuxVideo can use nextAudioPts, which is
            // calculated in remuxAudio.
            // logger.log('nb AAC samples:' + audioTrack.samples.length);
            if (nbAudioSamples) {
                // if initSegment was generated without video samples, regenerate it again
                if (!audioTrack.timescale) {
                    logger_1.logger.warn('regenerate InitSegment as audio detected');
                    this.generateIS(audioTrack, videoTrack, timeOffset);
                }
                var audioData = this.remuxAudio(audioTrack, audioTimeOffset, contiguous, accurateTimeOffset);
                // logger.log('nb AVC samples:' + videoTrack.samples.length);
                if (nbVideoSamples) {
                    var audioTrackLength = void 0;
                    if (audioData) {
                        audioTrackLength = audioData.endPTS - audioData.startPTS;
                    }
                    // if initSegment was generated without video samples, regenerate it again
                    if (!videoTrack.timescale) {
                        logger_1.logger.warn('regenerate InitSegment as video detected');
                        this.generateIS(audioTrack, videoTrack, timeOffset);
                    }
                    this.remuxVideo(videoTrack, videoTimeOffset, contiguous, audioTrackLength, accurateTimeOffset);
                }
            }
            else {
                // logger.log('nb AVC samples:' + videoTrack.samples.length);
                if (nbVideoSamples) {
                    var videoData = this.remuxVideo(videoTrack, videoTimeOffset, contiguous, 0, accurateTimeOffset);
                    if (videoData && audioTrack.codec) {
                        this.remuxEmptyAudio(audioTrack, audioTimeOffset, contiguous, videoData);
                    }
                }
            }
        }
        // logger.log('nb ID3 samples:' + audioTrack.samples.length);
        if (id3Track.samples.length) {
            this.remuxID3(id3Track, timeOffset);
        }
        // logger.log('nb ID3 samples:' + audioTrack.samples.length);
        if (textTrack.samples.length) {
            this.remuxText(textTrack, timeOffset);
        }
        // notify end of parsing
        this.observer.trigger(events_1.default.FRAG_PARSED);
    };
    MP4Remuxer.prototype.generateIS = function (audioTrack, videoTrack, timeOffset) {
        var observer = this.observer, audioSamples = audioTrack.samples, videoSamples = videoTrack.samples, typeSupported = this.typeSupported, container = 'audio/mp4', tracks = {}, data = { tracks: tracks }, computePTSDTS = (this._initPTS === undefined), initPTS, initDTS;
        if (computePTSDTS) {
            initPTS = initDTS = Infinity;
        }
        if (audioTrack.config && audioSamples.length) {
            // let's use audio sampling rate as MP4 time scale.
            // rationale is that there is a integer nb of audio frames per audio sample (1024 for AAC)
            // using audio sampling rate here helps having an integer MP4 frame duration
            // this avoids potential rounding issue and AV sync issue
            audioTrack.timescale = audioTrack.samplerate;
            logger_1.logger.log("audio sampling rate : " + audioTrack.samplerate);
            if (!audioTrack.isAAC) {
                if (typeSupported.mpeg) { // Chrome and Safari
                    container = 'audio/mpeg';
                    audioTrack.codec = '';
                }
                else if (typeSupported.mp3) { // Firefox
                    audioTrack.codec = 'mp3';
                }
            }
            tracks.audio = {
                container: container,
                codec: audioTrack.codec,
                initSegment: !audioTrack.isAAC && typeSupported.mpeg ? new Uint8Array() : mp4_generator_1.default.initSegment([audioTrack]),
                metadata: {
                    channelCount: audioTrack.channelCount
                }
            };
            if (computePTSDTS) {
                // remember first PTS of this demuxing context. for audio, PTS = DTS
                initPTS = initDTS = audioSamples[0].pts - audioTrack.inputTimeScale * timeOffset;
            }
        }
        if (videoTrack.sps && videoTrack.pps && videoSamples.length) {
            // let's use input time scale as MP4 video timescale
            // we use input time scale straight away to avoid rounding issues on frame duration / cts computation
            var inputTimeScale = videoTrack.inputTimeScale;
            videoTrack.timescale = inputTimeScale;
            tracks.video = {
                container: 'video/mp4',
                codec: videoTrack.codec,
                initSegment: mp4_generator_1.default.initSegment([videoTrack]),
                metadata: {
                    width: videoTrack.width,
                    height: videoTrack.height
                }
            };
            if (computePTSDTS) {
                initPTS = Math.min(initPTS, videoSamples[0].pts - inputTimeScale * timeOffset);
                initDTS = Math.min(initDTS, videoSamples[0].dts - inputTimeScale * timeOffset);
                this.observer.trigger(events_1.default.INIT_PTS_FOUND, { initPTS: initPTS });
            }
        }
        if (Object.keys(tracks).length) {
            observer.trigger(events_1.default.FRAG_PARSING_INIT_SEGMENT, data);
            this.ISGenerated = true;
            if (computePTSDTS) {
                this._initPTS = initPTS;
                this._initDTS = initDTS;
            }
        }
        else {
            observer.trigger(events_1.default.ERROR, { type: errors_1.ErrorTypes.MEDIA_ERROR, details: errors_1.ErrorDetails.FRAG_PARSING_ERROR, fatal: false, reason: 'no audio/video samples found' });
        }
    };
    MP4Remuxer.prototype.remuxVideo = function (track, timeOffset, contiguous, audioTrackLength, accurateTimeOffset) {
        var offset = 8;
        var mp4SampleDuration;
        var mdat;
        var moof;
        var firstPTS;
        var firstDTS;
        var lastPTS;
        var lastDTS;
        var timeScale = track.timescale;
        var inputSamples = track.samples;
        var outputSamples = [];
        var nbSamples = inputSamples.length;
        var ptsNormalize = this._PTSNormalize;
        var initPTS = this._initPTS;
        // if parsed fragment is contiguous with last one, let's use last DTS value as reference
        var nextAvcDts = this.nextAvcDts;
        var isSafari = this.isSafari;
        if (nbSamples === 0) {
            return;
        }
        // Safari does not like overlapping DTS on consecutive fragments. let's use nextAvcDts to overcome this if fragments are consecutive
        if (isSafari) {
            // also consider consecutive fragments as being contiguous (even if a level switch occurs),
            // for sake of clarity:
            // consecutive fragments are frags with
            //  - less than 100ms gaps between new time offset (if accurate) and next expected PTS OR
            //  - less than 200 ms PTS gaps (timeScale/5)
            contiguous |= (inputSamples.length && nextAvcDts &&
                ((accurateTimeOffset && Math.abs(timeOffset - nextAvcDts / timeScale) < 0.1) ||
                    Math.abs((inputSamples[0].pts - nextAvcDts - initPTS)) < timeScale / 5));
        }
        if (!contiguous) {
            // if not contiguous, let's use target timeOffset
            nextAvcDts = timeOffset * timeScale;
        }
        // PTS is coded on 33bits, and can loop from -2^32 to 2^32
        // ptsNormalize will make PTS/DTS value monotonic, we use last known DTS value as reference value
        inputSamples.forEach(function (sample) {
            sample.pts = ptsNormalize(sample.pts - initPTS, nextAvcDts);
            sample.dts = ptsNormalize(sample.dts - initPTS, nextAvcDts);
        });
        // sort video samples by DTS then PTS then demux id order
        inputSamples.sort(function (a, b) {
            var deltadts = a.dts - b.dts;
            var deltapts = a.pts - b.pts;
            return deltadts || (deltapts || (a.id - b.id));
        });
        // handle broken streams with PTS < DTS, tolerance up 200ms (18000 in 90kHz timescale)
        var PTSDTSshift = inputSamples.reduce(function (prev, curr) { return Math.max(Math.min(prev, curr.pts - curr.dts), -18000); }, 0);
        if (PTSDTSshift < 0) {
            logger_1.logger.warn("PTS < DTS detected in video samples, shifting DTS by " + Math.round(PTSDTSshift / 90) + " ms to overcome this issue");
            for (var i = 0; i < inputSamples.length; i++) {
                inputSamples[i].dts += PTSDTSshift;
            }
        }
        // compute first DTS and last DTS, normalize them against reference value
        var sample = inputSamples[0];
        firstDTS = Math.max(sample.dts, 0);
        firstPTS = Math.max(sample.pts, 0);
        // check timestamp continuity accross consecutive fragments (this is to remove inter-fragment gap/hole)
        var delta = Math.round((firstDTS - nextAvcDts) / 90);
        // if fragment are contiguous, detect hole/overlapping between fragments
        if (contiguous) {
            if (delta) {
                if (delta > 1) {
                    logger_1.logger.log("AVC:" + delta + " ms hole between fragments detected,filling it");
                }
                else if (delta < -1) {
                    logger_1.logger.log("AVC:" + (-delta) + " ms overlapping between fragments detected");
                }
                // remove hole/gap : set DTS to next expected DTS
                firstDTS = nextAvcDts;
                inputSamples[0].dts = firstDTS;
                // offset PTS as well, ensure that PTS is smaller or equal than new DTS
                firstPTS = Math.max(firstPTS - delta, nextAvcDts);
                inputSamples[0].pts = firstPTS;
                logger_1.logger.log("Video/PTS/DTS adjusted: " + Math.round(firstPTS / 90) + "/" + Math.round(firstDTS / 90) + ",delta:" + delta + " ms");
            }
        }
        // compute lastPTS/lastDTS
        sample = inputSamples[inputSamples.length - 1];
        lastDTS = Math.max(sample.dts, 0);
        lastPTS = Math.max(sample.pts, 0, lastDTS);
        // on Safari let's signal the same sample duration for all samples
        // sample duration (as expected by trun MP4 boxes), should be the delta between sample DTS
        // set this constant duration as being the avg delta between consecutive DTS.
        if (isSafari) {
            mp4SampleDuration = Math.round((lastDTS - firstDTS) / (inputSamples.length - 1));
        }
        var nbNalu = 0, naluLen = 0;
        for (var i = 0; i < nbSamples; i++) {
            // compute total/avc sample length and nb of NAL units
            var sample_1 = inputSamples[i], units = sample_1.units, nbUnits = units.length, sampleLen = 0;
            for (var j = 0; j < nbUnits; j++) {
                sampleLen += units[j].data.length;
            }
            naluLen += sampleLen;
            nbNalu += nbUnits;
            sample_1.length = sampleLen;
            // normalize PTS/DTS
            if (isSafari) {
                // sample DTS is computed using a constant decoding offset (mp4SampleDuration) between samples
                sample_1.dts = firstDTS + i * mp4SampleDuration;
            }
            else {
                // ensure sample monotonic DTS
                sample_1.dts = Math.max(sample_1.dts, firstDTS);
            }
            // ensure that computed value is greater or equal than sample DTS
            sample_1.pts = Math.max(sample_1.pts, sample_1.dts);
        }
        /* concatenate the video data and construct the mdat in place
          (need 8 more bytes to fill length and mpdat type) */
        var mdatSize = naluLen + (4 * nbNalu) + 8;
        try {
            mdat = new Uint8Array(mdatSize);
        }
        catch (err) {
            this.observer.trigger(events_1.default.ERROR, { type: errors_1.ErrorTypes.MUX_ERROR, details: errors_1.ErrorDetails.REMUX_ALLOC_ERROR, fatal: false, bytes: mdatSize, reason: "fail allocating video mdat " + mdatSize });
            return;
        }
        var view = new DataView(mdat.buffer);
        view.setUint32(0, mdatSize);
        mdat.set(mp4_generator_1.default.types.mdat, 4);
        for (var i = 0; i < nbSamples; i++) {
            var avcSample = inputSamples[i], avcSampleUnits = avcSample.units, mp4SampleLength = 0, compositionTimeOffset = void 0;
            // convert NALU bitstream to MP4 format (prepend NALU with size field)
            for (var j = 0, nbUnits = avcSampleUnits.length; j < nbUnits; j++) {
                var unit = avcSampleUnits[j], unitData = unit.data, unitDataLen = unit.data.byteLength;
                view.setUint32(offset, unitDataLen);
                offset += 4;
                mdat.set(unitData, offset);
                offset += unitDataLen;
                mp4SampleLength += 4 + unitDataLen;
            }
            if (!isSafari) {
                // expected sample duration is the Decoding Timestamp diff of consecutive samples
                if (i < nbSamples - 1) {
                    mp4SampleDuration = inputSamples[i + 1].dts - avcSample.dts;
                }
                else {
                    var config = this.config, lastFrameDuration = avcSample.dts - inputSamples[i > 0 ? i - 1 : i].dts;
                    if (config.stretchShortVideoTrack) {
                        // In some cases, a segment's audio track duration may exceed the video track duration.
                        // Since we've already remuxed audio, and we know how long the audio track is, we look to
                        // see if the delta to the next segment is longer than maxBufferHole.
                        // If so, playback would potentially get stuck, so we artificially inflate
                        // the duration of the last frame to minimize any potential gap between segments.
                        var maxBufferHole = config.maxBufferHole, gapTolerance = Math.floor(maxBufferHole * timeScale), deltaToFrameEnd = (audioTrackLength ? firstPTS + audioTrackLength * timeScale : this.nextAudioPts) - avcSample.pts;
                        if (deltaToFrameEnd > gapTolerance) {
                            // We subtract lastFrameDuration from deltaToFrameEnd to try to prevent any video
                            // frame overlap. maxBufferHole should be >> lastFrameDuration anyway.
                            mp4SampleDuration = deltaToFrameEnd - lastFrameDuration;
                            if (mp4SampleDuration < 0) {
                                mp4SampleDuration = lastFrameDuration;
                            }
                            logger_1.logger.log("It is approximately " + deltaToFrameEnd / 90 + " ms to the next segment; using duration " + mp4SampleDuration / 90 + " ms for the last video frame.");
                        }
                        else {
                            mp4SampleDuration = lastFrameDuration;
                        }
                    }
                    else {
                        mp4SampleDuration = lastFrameDuration;
                    }
                }
                compositionTimeOffset = Math.round(avcSample.pts - avcSample.dts);
            }
            else {
                compositionTimeOffset = Math.max(0, mp4SampleDuration * Math.round((avcSample.pts - avcSample.dts) / mp4SampleDuration));
            }
            // console.log('PTS/DTS/initDTS/normPTS/normDTS/relative PTS : ${avcSample.pts}/${avcSample.dts}/${initDTS}/${ptsnorm}/${dtsnorm}/${(avcSample.pts/4294967296).toFixed(3)}');
            outputSamples.push({
                size: mp4SampleLength,
                // constant duration
                duration: mp4SampleDuration,
                cts: compositionTimeOffset,
                flags: {
                    isLeading: 0,
                    isDependedOn: 0,
                    hasRedundancy: 0,
                    degradPrio: 0,
                    dependsOn: avcSample.key ? 2 : 1,
                    isNonSync: avcSample.key ? 0 : 1
                }
            });
        }
        // next AVC sample DTS should be equal to last sample DTS + last sample duration (in PES timescale)
        this.nextAvcDts = lastDTS + mp4SampleDuration;
        var dropped = track.dropped;
        track.len = 0;
        track.nbNalu = 0;
        track.dropped = 0;
        if (outputSamples.length && navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
            var flags = outputSamples[0].flags;
            // chrome workaround, mark first sample as being a Random Access Point to avoid sourcebuffer append issue
            // https://code.google.com/p/chromium/issues/detail?id=229412
            flags.dependsOn = 2;
            flags.isNonSync = 0;
        }
        track.samples = outputSamples;
        moof = mp4_generator_1.default.moof(track.sequenceNumber++, firstDTS, track);
        track.samples = [];
        var data = {
            data1: moof,
            data2: mdat,
            startPTS: firstPTS / timeScale,
            endPTS: (lastPTS + mp4SampleDuration) / timeScale,
            startDTS: firstDTS / timeScale,
            endDTS: this.nextAvcDts / timeScale,
            type: 'video',
            hasAudio: false,
            hasVideo: true,
            nb: outputSamples.length,
            dropped: dropped
        };
        this.observer.trigger(events_1.default.FRAG_PARSING_DATA, data);
        return data;
    };
    MP4Remuxer.prototype.remuxAudio = function (track, timeOffset, contiguous, accurateTimeOffset) {
        var inputTimeScale = track.inputTimeScale;
        var mp4timeScale = track.timescale;
        var scaleFactor = inputTimeScale / mp4timeScale;
        var mp4SampleDuration = track.isAAC ? 1024 : 1152;
        var inputSampleDuration = mp4SampleDuration * scaleFactor;
        var ptsNormalize = this._PTSNormalize;
        var initPTS = this._initPTS;
        var rawMPEG = !track.isAAC && this.typeSupported.mpeg;
        var offset, mp4Sample, fillFrame, mdat, moof, firstPTS, lastPTS, inputSamples = track.samples, outputSamples = [], nextAudioPts = this.nextAudioPts;
        // for audio samples, also consider consecutive fragments as being contiguous (even if a level switch occurs),
        // for sake of clarity:
        // consecutive fragments are frags with
        //  - less than 100ms gaps between new time offset (if accurate) and next expected PTS OR
        //  - less than 20 audio frames distance
        // contiguous fragments are consecutive fragments from same quality level (same level, new SN = old SN + 1)
        // this helps ensuring audio continuity
        // and this also avoids audio glitches/cut when switching quality, or reporting wrong duration on first audio frame
        contiguous |= (inputSamples.length && nextAudioPts &&
            ((accurateTimeOffset && Math.abs(timeOffset - nextAudioPts / inputTimeScale) < 0.1) ||
                Math.abs((inputSamples[0].pts - nextAudioPts - initPTS)) < 20 * inputSampleDuration));
        // compute normalized PTS
        inputSamples.forEach(function (sample) {
            sample.pts = sample.dts = ptsNormalize(sample.pts - initPTS, timeOffset * inputTimeScale);
        });
        // filter out sample with negative PTS that are not playable anyway
        // if we don't remove these negative samples, they will shift all audio samples forward.
        // leading to audio overlap between current / next fragment
        inputSamples = inputSamples.filter(function (sample) {
            return sample.pts >= 0;
        });
        // in case all samples have negative PTS, and have been filtered out, return now
        if (inputSamples.length === 0) {
            return;
        }
        if (!contiguous) {
            if (!accurateTimeOffset) {
                // if frag are mot contiguous and if we cant trust time offset, let's use first sample PTS as next audio PTS
                nextAudioPts = inputSamples[0].pts;
            }
            else {
                // if timeOffset is accurate, let's use it as predicted next audio PTS
                nextAudioPts = timeOffset * inputTimeScale;
            }
        }
        // If the audio track is missing samples, the frames seem to get "left-shifted" within the
        // resulting mp4 segment, causing sync issues and leaving gaps at the end of the audio segment.
        // In an effort to prevent this from happening, we inject frames here where there are gaps.
        // When possible, we inject a silent frame; when that's not possible, we duplicate the last
        // frame.
        if (track.isAAC) {
            var maxAudioFramesDrift = this.config.maxAudioFramesDrift;
            for (var i = 0, nextPts = nextAudioPts; i < inputSamples.length;) {
                // First, let's see how far off this frame is from where we expect it to be
                var sample = inputSamples[i], delta;
                var pts = sample.pts;
                delta = pts - nextPts;
                var duration = Math.abs(1000 * delta / inputTimeScale);
                // If we're overlapping by more than a duration, drop this sample
                if (delta <= -maxAudioFramesDrift * inputSampleDuration) {
                    logger_1.logger.warn("Dropping 1 audio frame @ " + (nextPts / inputTimeScale).toFixed(3) + "s due to " + Math.round(duration) + " ms overlap.");
                    inputSamples.splice(i, 1);
                    track.len -= sample.unit.length;
                    // Don't touch nextPtsNorm or i
                } // eslint-disable-line brace-style
                // Insert missing frames if:
                // 1: We're more than maxAudioFramesDrift frame away
                // 2: Not more than MAX_SILENT_FRAME_DURATION away
                // 3: currentTime (aka nextPtsNorm) is not 0
                else if (delta >= maxAudioFramesDrift * inputSampleDuration && duration < MAX_SILENT_FRAME_DURATION && nextPts) {
                    var missing = Math.round(delta / inputSampleDuration);
                    logger_1.logger.warn("Injecting " + missing + " audio frame @ " + (nextPts / inputTimeScale).toFixed(3) + "s due to " + Math.round(1000 * delta / inputTimeScale) + " ms gap.");
                    for (var j = 0; j < missing; j++) {
                        var newStamp = Math.max(nextPts, 0);
                        fillFrame = aac_helper_1.default.getSilentFrame(track.manifestCodec || track.codec, track.channelCount);
                        if (!fillFrame) {
                            logger_1.logger.log('Unable to get silent frame for given audio codec; duplicating last frame instead.');
                            fillFrame = sample.unit.subarray();
                        }
                        inputSamples.splice(i, 0, { unit: fillFrame, pts: newStamp, dts: newStamp });
                        track.len += fillFrame.length;
                        nextPts += inputSampleDuration;
                        i++;
                    }
                    // Adjust sample to next expected pts
                    sample.pts = sample.dts = nextPts;
                    nextPts += inputSampleDuration;
                    i++;
                }
                else {
                    // Otherwise, just adjust pts
                    if (Math.abs(delta) > (0.1 * inputSampleDuration)) {
                        // logger.log(`Invalid frame delta ${Math.round(delta + inputSampleDuration)} at PTS ${Math.round(pts / 90)} (should be ${Math.round(inputSampleDuration)}).`);
                    }
                    sample.pts = sample.dts = nextPts;
                    nextPts += inputSampleDuration;
                    i++;
                }
            }
        }
        for (var j = 0, nbSamples_1 = inputSamples.length; j < nbSamples_1; j++) {
            var audioSample = inputSamples[j];
            var unit = audioSample.unit;
            var pts = audioSample.pts;
            // logger.log(`Audio/PTS:${Math.round(pts/90)}`);
            // if not first sample
            if (lastPTS !== undefined) {
                mp4Sample.duration = Math.round((pts - lastPTS) / scaleFactor);
            }
            else {
                var delta_1 = Math.round(1000 * (pts - nextAudioPts) / inputTimeScale), numMissingFrames = 0;
                // if fragment are contiguous, detect hole/overlapping between fragments
                // contiguous fragments are consecutive fragments from same quality level (same level, new SN = old SN + 1)
                if (contiguous && track.isAAC) {
                    // log delta
                    if (delta_1) {
                        if (delta_1 > 0 && delta_1 < MAX_SILENT_FRAME_DURATION) {
                            numMissingFrames = Math.round((pts - nextAudioPts) / inputSampleDuration);
                            logger_1.logger.log(delta_1 + " ms hole between AAC samples detected,filling it");
                            if (numMissingFrames > 0) {
                                fillFrame = aac_helper_1.default.getSilentFrame(track.manifestCodec || track.codec, track.channelCount);
                                if (!fillFrame) {
                                    fillFrame = unit.subarray();
                                }
                                track.len += numMissingFrames * fillFrame.length;
                            }
                            // if we have frame overlap, overlapping for more than half a frame duraion
                        }
                        else if (delta_1 < -12) {
                            // drop overlapping audio frames... browser will deal with it
                            logger_1.logger.log("drop overlapping AAC sample, expected/parsed/delta:" + (nextAudioPts / inputTimeScale).toFixed(3) + "s/" + (pts / inputTimeScale).toFixed(3) + "s/" + (-delta_1) + "ms");
                            track.len -= unit.byteLength;
                            continue;
                        }
                        // set PTS/DTS to expected PTS/DTS
                        pts = nextAudioPts;
                    }
                }
                // remember first PTS of our audioSamples
                firstPTS = pts;
                if (track.len > 0) {
                    /* concatenate the audio data and construct the mdat in place
                      (need 8 more bytes to fill length and mdat type) */
                    var mdatSize = rawMPEG ? track.len : track.len + 8;
                    offset = rawMPEG ? 0 : 8;
                    try {
                        mdat = new Uint8Array(mdatSize);
                    }
                    catch (err) {
                        this.observer.trigger(events_1.default.ERROR, { type: errors_1.ErrorTypes.MUX_ERROR, details: errors_1.ErrorDetails.REMUX_ALLOC_ERROR, fatal: false, bytes: mdatSize, reason: "fail allocating audio mdat " + mdatSize });
                        return;
                    }
                    if (!rawMPEG) {
                        var view = new DataView(mdat.buffer);
                        view.setUint32(0, mdatSize);
                        mdat.set(mp4_generator_1.default.types.mdat, 4);
                    }
                }
                else {
                    // no audio samples
                    return;
                }
                for (var i = 0; i < numMissingFrames; i++) {
                    fillFrame = aac_helper_1.default.getSilentFrame(track.manifestCodec || track.codec, track.channelCount);
                    if (!fillFrame) {
                        logger_1.logger.log('Unable to get silent frame for given audio codec; duplicating this frame instead.');
                        fillFrame = unit.subarray();
                    }
                    mdat.set(fillFrame, offset);
                    offset += fillFrame.byteLength;
                    mp4Sample = {
                        size: fillFrame.byteLength,
                        cts: 0,
                        duration: 1024,
                        flags: {
                            isLeading: 0,
                            isDependedOn: 0,
                            hasRedundancy: 0,
                            degradPrio: 0,
                            dependsOn: 1
                        }
                    };
                    outputSamples.push(mp4Sample);
                }
            }
            mdat.set(unit, offset);
            var unitLen = unit.byteLength;
            offset += unitLen;
            // console.log('PTS/DTS/initDTS/normPTS/normDTS/relative PTS : ${audioSample.pts}/${audioSample.dts}/${initDTS}/${ptsnorm}/${dtsnorm}/${(audioSample.pts/4294967296).toFixed(3)}');
            mp4Sample = {
                size: unitLen,
                cts: 0,
                duration: 0,
                flags: {
                    isLeading: 0,
                    isDependedOn: 0,
                    hasRedundancy: 0,
                    degradPrio: 0,
                    dependsOn: 1
                }
            };
            outputSamples.push(mp4Sample);
            lastPTS = pts;
        }
        var lastSampleDuration = 0;
        var nbSamples = outputSamples.length;
        // set last sample duration as being identical to previous sample
        if (nbSamples >= 2) {
            lastSampleDuration = outputSamples[nbSamples - 2].duration;
            mp4Sample.duration = lastSampleDuration;
        }
        if (nbSamples) {
            // next audio sample PTS should be equal to last sample PTS + duration
            this.nextAudioPts = nextAudioPts = lastPTS + scaleFactor * lastSampleDuration;
            // logger.log('Audio/PTS/PTSend:' + audioSample.pts.toFixed(0) + '/' + this.nextAacDts.toFixed(0));
            track.len = 0;
            track.samples = outputSamples;
            if (rawMPEG) {
                moof = new Uint8Array();
            }
            else {
                moof = mp4_generator_1.default.moof(track.sequenceNumber++, firstPTS / scaleFactor, track);
            }
            track.samples = [];
            var start = firstPTS / inputTimeScale;
            var end = nextAudioPts / inputTimeScale;
            var audioData = {
                data1: moof,
                data2: mdat,
                startPTS: start,
                endPTS: end,
                startDTS: start,
                endDTS: end,
                type: 'audio',
                hasAudio: true,
                hasVideo: false,
                nb: nbSamples
            };
            this.observer.trigger(events_1.default.FRAG_PARSING_DATA, audioData);
            return audioData;
        }
        return null;
    };
    MP4Remuxer.prototype.remuxEmptyAudio = function (track, timeOffset, contiguous, videoData) {
        var inputTimeScale = track.inputTimeScale, mp4timeScale = track.samplerate ? track.samplerate : inputTimeScale, scaleFactor = inputTimeScale / mp4timeScale, nextAudioPts = this.nextAudioPts, 
        // sync with video's timestamp
        startDTS = (nextAudioPts !== undefined ? nextAudioPts : videoData.startDTS * inputTimeScale) + this._initDTS, endDTS = videoData.endDTS * inputTimeScale + this._initDTS, 
        // one sample's duration value
        sampleDuration = 1024, frameDuration = scaleFactor * sampleDuration, 
        // samples count of this segment's duration
        nbSamples = Math.ceil((endDTS - startDTS) / frameDuration), 
        // silent frame
        silentFrame = aac_helper_1.default.getSilentFrame(track.manifestCodec || track.codec, track.channelCount);
        logger_1.logger.warn('remux empty Audio');
        // Can't remux if we can't generate a silent frame...
        if (!silentFrame) {
            logger_1.logger.trace('Unable to remuxEmptyAudio since we were unable to get a silent frame for given audio codec!');
            return;
        }
        var samples = [];
        for (var i = 0; i < nbSamples; i++) {
            var stamp = startDTS + i * frameDuration;
            samples.push({ unit: silentFrame, pts: stamp, dts: stamp });
            track.len += silentFrame.length;
        }
        track.samples = samples;
        this.remuxAudio(track, timeOffset, contiguous);
    };
    MP4Remuxer.prototype.remuxID3 = function (track) {
        var length = track.samples.length, sample;
        var inputTimeScale = track.inputTimeScale;
        var initPTS = this._initPTS;
        var initDTS = this._initDTS;
        // consume samples
        if (length) {
            for (var index = 0; index < length; index++) {
                sample = track.samples[index];
                // setting id3 pts, dts to relative time
                // using this._initPTS and this._initDTS to calculate relative time
                sample.pts = ((sample.pts - initPTS) / inputTimeScale);
                sample.dts = ((sample.dts - initDTS) / inputTimeScale);
            }
            this.observer.trigger(events_1.default.FRAG_PARSING_METADATA, {
                samples: track.samples
            });
        }
        track.samples = [];
    };
    MP4Remuxer.prototype.remuxText = function (track) {
        track.samples.sort(function (a, b) {
            return (a.pts - b.pts);
        });
        var length = track.samples.length, sample;
        var inputTimeScale = track.inputTimeScale;
        var initPTS = this._initPTS;
        // consume samples
        if (length) {
            for (var index = 0; index < length; index++) {
                sample = track.samples[index];
                // setting text pts, dts to relative time
                // using this._initPTS and this._initDTS to calculate relative time
                sample.pts = ((sample.pts - initPTS) / inputTimeScale);
            }
            this.observer.trigger(events_1.default.FRAG_PARSING_USERDATA, {
                samples: track.samples
            });
        }
        track.samples = [];
    };
    MP4Remuxer.prototype._PTSNormalize = function (value, reference) {
        var offset;
        if (reference === undefined) {
            return value;
        }
        if (reference < value) {
            // - 2^33
            offset = -8589934592;
        }
        else {
            // + 2^33
            offset = 8589934592;
        }
        /* PTS is 33bit (from 0 to 2^33 -1)
          if diff between value and reference is bigger than half of the amplitude (2^32) then it means that
          PTS looping occured. fill the gap */
        while (Math.abs(value - reference) > 4294967296) {
            value += offset;
        }
        return value;
    };
    return MP4Remuxer;
}());
exports.default = MP4Remuxer;


/***/ }),

/***/ "./src/remux/passthrough-remuxer.js":
/*!******************************************!*\
  !*** ./src/remux/passthrough-remuxer.js ***!
  \******************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * passthrough remuxer
*/
var events_1 = __webpack_require__(/*! ../events */ "./src/events.js");
var PassThroughRemuxer = /** @class */ (function () {
    function PassThroughRemuxer(observer) {
        this.observer = observer;
    }
    PassThroughRemuxer.prototype.destroy = function () {
    };
    PassThroughRemuxer.prototype.resetTimeStamp = function () {
    };
    PassThroughRemuxer.prototype.resetInitSegment = function () {
    };
    PassThroughRemuxer.prototype.remux = function (audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset, rawData) {
        var observer = this.observer;
        var streamType = '';
        if (audioTrack) {
            streamType += 'audio';
        }
        if (videoTrack) {
            streamType += 'video';
        }
        observer.trigger(events_1.default.FRAG_PARSING_DATA, {
            data1: rawData,
            startPTS: timeOffset,
            startDTS: timeOffset,
            type: streamType,
            hasAudio: !!audioTrack,
            hasVideo: !!videoTrack,
            nb: 1,
            dropped: 0
        });
        // notify end of parsing
        observer.trigger(events_1.default.FRAG_PARSED);
    };
    return PassThroughRemuxer;
}());
exports.default = PassThroughRemuxer;


/***/ }),

/***/ "./src/task-loop.js":
/*!**************************!*\
  !*** ./src/task-loop.js ***!
  \**************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var event_handler_1 = __webpack_require__(/*! ./event-handler */ "./src/event-handler.js");
/**
 * Sub-class specialization of EventHandler base class.
 *
 * TaskLoop allows to schedule a task function being called (optionnaly repeatedly) on the main loop,
 * scheduled asynchroneously, avoiding recursive calls in the same tick.
 *
 * The task itself is implemented in `doTick`. It can be requested and called for single execution
 * using the `tick` method.
 *
 * It will be assured that the task execution method (`tick`) only gets called once per main loop "tick",
 * no matter how often it gets requested for execution. Execution in further ticks will be scheduled accordingly.
 *
 * If further execution requests have already been scheduled on the next tick, it can be checked with `hasNextTick`,
 * and cancelled with `clearNextTick`.
 *
 * The task can be scheduled as an interval repeatedly with a period as parameter (see `setInterval`, `clearInterval`).
 *
 * Sub-classes need to implement the `doTick` method which will effectively have the task execution routine.
 *
 * Further explanations:
 *
 * The baseclass has a `tick` method that will schedule the doTick call. It may be called synchroneously
 * only for a stack-depth of one. On re-entrant calls, sub-sequent calls are scheduled for next main loop ticks.
 *
 * When the task execution (`tick` method) is called in re-entrant way this is detected and
 * we are limiting the task execution per call stack to exactly one, but scheduling/post-poning further
 * task processing on the next main loop iteration (also known as "next tick" in the Node/JS runtime lingo).
 */
var TaskLoop = /** @class */ (function (_super) {
    __extends(TaskLoop, _super);
    function TaskLoop(hls) {
        var events = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            events[_i - 1] = arguments[_i];
        }
        var _this = _super.apply(this, [hls].concat(events)) || this;
        _this._tickInterval = null;
        _this._tickTimer = null;
        _this._tickCallCount = 0;
        _this._boundTick = _this.tick.bind(_this);
        return _this;
    }
    /**
     * @override
     */
    TaskLoop.prototype.onHandlerDestroying = function () {
        // clear all timers before unregistering from event bus
        this.clearNextTick();
        this.clearInterval();
    };
    /**
     * @returns {boolean}
     */
    TaskLoop.prototype.hasInterval = function () {
        return !!this._tickInterval;
    };
    /**
     * @returns {boolean}
     */
    TaskLoop.prototype.hasNextTick = function () {
        return !!this._tickTimer;
    };
    /**
     * @param {number} millis Interval time (ms)
     * @returns {boolean} True when interval has been scheduled, false when already scheduled (no effect)
     */
    TaskLoop.prototype.setInterval = function (millis) {
        if (!this._tickInterval) {
            this._tickInterval = setInterval(this._boundTick, millis);
            return true;
        }
        return false;
    };
    /**
     * @returns {boolean} True when interval was cleared, false when none was set (no effect)
     */
    TaskLoop.prototype.clearInterval = function () {
        if (this._tickInterval) {
            clearInterval(this._tickInterval);
            this._tickInterval = null;
            return true;
        }
        return false;
    };
    /**
     * @returns {boolean} True when timeout was cleared, false when none was set (no effect)
     */
    TaskLoop.prototype.clearNextTick = function () {
        if (this._tickTimer) {
            clearTimeout(this._tickTimer);
            this._tickTimer = null;
            return true;
        }
        return false;
    };
    /**
     * Will call the subclass doTick implementation in this main loop tick
     * or in the next one (via setTimeout(,0)) in case it has already been called
     * in this tick (in case this is a re-entrant call).
     */
    TaskLoop.prototype.tick = function () {
        this._tickCallCount++;
        if (this._tickCallCount === 1) {
            this.doTick();
            // re-entrant call to tick from previous doTick call stack
            // -> schedule a call on the next main loop iteration to process this task processing request
            if (this._tickCallCount > 1) {
                // make sure only one timer exists at any time at max
                this.clearNextTick();
                this._tickTimer = setTimeout(this._boundTick, 0);
            }
            this._tickCallCount = 0;
        }
    };
    /**
     * For subclass to implement task logic
     * @abstract
     */
    TaskLoop.prototype.doTick = function () { };
    return TaskLoop;
}(event_handler_1.default));
exports.default = TaskLoop;


/***/ }),

/***/ "./src/utils/attr-list.js":
/*!********************************!*\
  !*** ./src/utils/attr-list.js ***!
  \********************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Number) {
Object.defineProperty(exports, "__esModule", { value: true });
var DECIMAL_RESOLUTION_REGEX = /^(\d+)x(\d+)$/; // eslint-disable-line no-useless-escape
var ATTR_LIST_REGEX = /\s*(.+?)\s*=((?:\".*?\")|.*?)(?:,|$)/g; // eslint-disable-line no-useless-escape
// adapted from https://github.com/kanongil/node-m3u8parse/blob/master/attrlist.js
var AttrList = /** @class */ (function () {
    function AttrList(attrs) {
        if (typeof attrs === 'string') {
            attrs = AttrList.parseAttrList(attrs);
        }
        for (var attr in attrs) {
            if (attrs.hasOwnProperty(attr)) {
                this[attr] = attrs[attr];
            }
        }
    }
    AttrList.prototype.decimalInteger = function (attrName) {
        var intValue = parseInt(this[attrName], 10);
        if (intValue > Number.MAX_SAFE_INTEGER) {
            return Infinity;
        }
        return intValue;
    };
    AttrList.prototype.hexadecimalInteger = function (attrName) {
        if (this[attrName]) {
            var stringValue = (this[attrName] || '0x').slice(2);
            stringValue = ((stringValue.length & 1) ? '0' : '') + stringValue;
            var value = new Uint8Array(stringValue.length / 2);
            for (var i = 0; i < stringValue.length / 2; i++) {
                value[i] = parseInt(stringValue.slice(i * 2, i * 2 + 2), 16);
            }
            return value;
        }
        else {
            return null;
        }
    };
    AttrList.prototype.hexadecimalIntegerAsNumber = function (attrName) {
        var intValue = parseInt(this[attrName], 16);
        if (intValue > Number.MAX_SAFE_INTEGER) {
            return Infinity;
        }
        return intValue;
    };
    AttrList.prototype.decimalFloatingPoint = function (attrName) {
        return parseFloat(this[attrName]);
    };
    AttrList.prototype.enumeratedString = function (attrName) {
        return this[attrName];
    };
    AttrList.prototype.decimalResolution = function (attrName) {
        var res = DECIMAL_RESOLUTION_REGEX.exec(this[attrName]);
        if (res === null) {
            return undefined;
        }
        return {
            width: parseInt(res[1], 10),
            height: parseInt(res[2], 10)
        };
    };
    AttrList.parseAttrList = function (input) {
        var match, attrs = {};
        ATTR_LIST_REGEX.lastIndex = 0;
        while ((match = ATTR_LIST_REGEX.exec(input)) !== null) {
            var value = match[2], quote = '"';
            if (value.indexOf(quote) === 0 &&
                value.lastIndexOf(quote) === (value.length - 1)) {
                value = value.slice(1, -1);
            }
            attrs[match[1]] = value;
        }
        return attrs;
    };
    return AttrList;
}());
exports.default = AttrList;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./src/polyfills/number */ "./src/polyfills/number.js")["Number"]))

/***/ }),

/***/ "./src/utils/binary-search.js":
/*!************************************!*\
  !*** ./src/utils/binary-search.js ***!
  \************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var BinarySearch = {
    /**
       * Searches for an item in an array which matches a certain condition.
       * This requires the condition to only match one item in the array,
       * and for the array to be ordered.
       *
       * @param {Array} list The array to search.
       * @param {Function} comparisonFunction
       *      Called and provided a candidate item as the first argument.
       *      Should return:
       *          > -1 if the item should be located at a lower index than the provided item.
       *          > 1 if the item should be located at a higher index than the provided item.
       *          > 0 if the item is the item you're looking for.
       *
       * @return {*} The object if it is found or null otherwise.
       */
    search: function (list, comparisonFunction) {
        var minIndex = 0;
        var maxIndex = list.length - 1;
        var currentIndex = null;
        var currentElement = null;
        while (minIndex <= maxIndex) {
            currentIndex = (minIndex + maxIndex) / 2 | 0;
            currentElement = list[currentIndex];
            var comparisonResult = comparisonFunction(currentElement);
            if (comparisonResult > 0) {
                minIndex = currentIndex + 1;
            }
            else if (comparisonResult < 0) {
                maxIndex = currentIndex - 1;
            }
            else {
                return currentElement;
            }
        }
        return null;
    }
};
exports.default = BinarySearch;


/***/ }),

/***/ "./src/utils/buffer-helper.js":
/*!************************************!*\
  !*** ./src/utils/buffer-helper.js ***!
  \************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @module BufferHelper
 *
 * Providing methods dealing with buffer length retrieval for example.
 *
 * In general, a helper around HTML5 MediaElement TimeRanges gathered from `buffered` property.
 *
 * Also @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/buffered
*/
Object.defineProperty(exports, "__esModule", { value: true });
var BufferHelper = /** @class */ (function () {
    function BufferHelper() {
    }
    /**
     * Return true if `media`'s buffered include `position`
     * @param {HTMLMediaElement|SourceBuffer} media
     * @param {number} position
     * @returns {boolean}
     */
    BufferHelper.isBuffered = function (media, position) {
        try {
            if (media) {
                var buffered = media.buffered;
                for (var i = 0; i < buffered.length; i++) {
                    if (position >= buffered.start(i) && position <= buffered.end(i)) {
                        return true;
                    }
                }
            }
        }
        catch (error) {
            // this is to catch
            // InvalidStateError: Failed to read the 'buffered' property from 'SourceBuffer':
            // This SourceBuffer has been removed from the parent media source
        }
        return false;
    };
    BufferHelper.bufferInfo = function (media, pos, maxHoleDuration) {
        try {
            if (media) {
                var vbuffered = media.buffered, buffered = [], i = void 0;
                for (i = 0; i < vbuffered.length; i++) {
                    buffered.push({ start: vbuffered.start(i), end: vbuffered.end(i) });
                }
                return this.bufferedInfo(buffered, pos, maxHoleDuration);
            }
        }
        catch (error) {
            // this is to catch
            // InvalidStateError: Failed to read the 'buffered' property from 'SourceBuffer':
            // This SourceBuffer has been removed from the parent media source
        }
        return { len: 0, start: pos, end: pos, nextStart: undefined };
    };
    BufferHelper.bufferedInfo = function (buffered, pos, maxHoleDuration) {
        var buffered2 = [], 
        // bufferStart and bufferEnd are buffer boundaries around current video position
        bufferLen, bufferStart, bufferEnd, bufferStartNext, i;
        // sort on buffer.start/smaller end (IE does not always return sorted buffered range)
        buffered.sort(function (a, b) {
            var diff = a.start - b.start;
            if (diff) {
                return diff;
            }
            else {
                return b.end - a.end;
            }
        });
        // there might be some small holes between buffer time range
        // consider that holes smaller than maxHoleDuration are irrelevant and build another
        // buffer time range representations that discards those holes
        for (i = 0; i < buffered.length; i++) {
            var buf2len = buffered2.length;
            if (buf2len) {
                var buf2end = buffered2[buf2len - 1].end;
                // if small hole (value between 0 or maxHoleDuration ) or overlapping (negative)
                if ((buffered[i].start - buf2end) < maxHoleDuration) {
                    // merge overlapping time ranges
                    // update lastRange.end only if smaller than item.end
                    // e.g.  [ 1, 15] with  [ 2,8] => [ 1,15] (no need to modify lastRange.end)
                    // whereas [ 1, 8] with  [ 2,15] => [ 1,15] ( lastRange should switch from [1,8] to [1,15])
                    if (buffered[i].end > buf2end) {
                        buffered2[buf2len - 1].end = buffered[i].end;
                    }
                }
                else {
                    // big hole
                    buffered2.push(buffered[i]);
                }
            }
            else {
                // first value
                buffered2.push(buffered[i]);
            }
        }
        for (i = 0, bufferLen = 0, bufferStart = bufferEnd = pos; i < buffered2.length; i++) {
            var start = buffered2[i].start, end = buffered2[i].end;
            // logger.log('buf start/end:' + buffered.start(i) + '/' + buffered.end(i));
            if ((pos + maxHoleDuration) >= start && pos < end) {
                // play position is inside this buffer TimeRange, retrieve end of buffer position and buffer length
                bufferStart = start;
                bufferEnd = end;
                bufferLen = bufferEnd - pos;
            }
            else if ((pos + maxHoleDuration) < start) {
                bufferStartNext = start;
                break;
            }
        }
        return { len: bufferLen, start: bufferStart, end: bufferEnd, nextStart: bufferStartNext };
    };
    return BufferHelper;
}());
exports.BufferHelper = BufferHelper;


/***/ }),

/***/ "./src/utils/cea-608-parser.js":
/*!*************************************!*\
  !*** ./src/utils/cea-608-parser.js ***!
  \*************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 *
 * This code was ported from the dash.js project at:
 *   https://github.com/Dash-Industry-Forum/dash.js/blob/development/externals/cea608-parser.js
 *   https://github.com/Dash-Industry-Forum/dash.js/commit/8269b26a761e0853bb21d78780ed945144ecdd4d#diff-71bc295a2d6b6b7093a1d3290d53a4b2
 *
 * The original copyright appears below:
 *
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2015-2016, DASH Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  1. Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  2. Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
     *  Exceptions from regular ASCII. CodePoints are mapped to UTF-16 codes
     */
Object.defineProperty(exports, "__esModule", { value: true });
var specialCea608CharsCodes = {
    0x2a: 0xe1,
    0x5c: 0xe9,
    0x5e: 0xed,
    0x5f: 0xf3,
    0x60: 0xfa,
    0x7b: 0xe7,
    0x7c: 0xf7,
    0x7d: 0xd1,
    0x7e: 0xf1,
    0x7f: 0x2588,
    // THIS BLOCK INCLUDES THE 16 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
    // THAT COME FROM HI BYTE=0x11 AND LOW BETWEEN 0x30 AND 0x3F
    // THIS MEANS THAT \x50 MUST BE ADDED TO THE VALUES
    0x80: 0xae,
    0x81: 0xb0,
    0x82: 0xbd,
    0x83: 0xbf,
    0x84: 0x2122,
    0x85: 0xa2,
    0x86: 0xa3,
    0x87: 0x266a,
    0x88: 0xe0,
    0x89: 0x20,
    0x8a: 0xe8,
    0x8b: 0xe2,
    0x8c: 0xea,
    0x8d: 0xee,
    0x8e: 0xf4,
    0x8f: 0xfb,
    // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
    // THAT COME FROM HI BYTE=0x12 AND LOW BETWEEN 0x20 AND 0x3F
    0x90: 0xc1,
    0x91: 0xc9,
    0x92: 0xd3,
    0x93: 0xda,
    0x94: 0xdc,
    0x95: 0xfc,
    0x96: 0x2018,
    0x97: 0xa1,
    0x98: 0x2a,
    0x99: 0x2019,
    0x9a: 0x2501,
    0x9b: 0xa9,
    0x9c: 0x2120,
    0x9d: 0x2022,
    0x9e: 0x201c,
    0x9f: 0x201d,
    0xa0: 0xc0,
    0xa1: 0xc2,
    0xa2: 0xc7,
    0xa3: 0xc8,
    0xa4: 0xca,
    0xa5: 0xcb,
    0xa6: 0xeb,
    0xa7: 0xce,
    0xa8: 0xcf,
    0xa9: 0xef,
    0xaa: 0xd4,
    0xab: 0xd9,
    0xac: 0xf9,
    0xad: 0xdb,
    0xae: 0xab,
    0xaf: 0xbb,
    // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
    // THAT COME FROM HI BYTE=0x13 AND LOW BETWEEN 0x20 AND 0x3F
    0xb0: 0xc3,
    0xb1: 0xe3,
    0xb2: 0xcd,
    0xb3: 0xcc,
    0xb4: 0xec,
    0xb5: 0xd2,
    0xb6: 0xf2,
    0xb7: 0xd5,
    0xb8: 0xf5,
    0xb9: 0x7b,
    0xba: 0x7d,
    0xbb: 0x5c,
    0xbc: 0x5e,
    0xbd: 0x5f,
    0xbe: 0x7c,
    0xbf: 0x223c,
    0xc0: 0xc4,
    0xc1: 0xe4,
    0xc2: 0xd6,
    0xc3: 0xf6,
    0xc4: 0xdf,
    0xc5: 0xa5,
    0xc6: 0xa4,
    0xc7: 0x2503,
    0xc8: 0xc5,
    0xc9: 0xe5,
    0xca: 0xd8,
    0xcb: 0xf8,
    0xcc: 0x250f,
    0xcd: 0x2513,
    0xce: 0x2517,
    0xcf: 0x251b // Box drawings heavy up and left
};
/**
 * Utils
 */
var getCharForByte = function (byte) {
    var charCode = byte;
    if (specialCea608CharsCodes.hasOwnProperty(byte)) {
        charCode = specialCea608CharsCodes[byte];
    }
    return String.fromCharCode(charCode);
};
var NR_ROWS = 15, NR_COLS = 100;
// Tables to look up row from PAC data
var rowsLowCh1 = { 0x11: 1, 0x12: 3, 0x15: 5, 0x16: 7, 0x17: 9, 0x10: 11, 0x13: 12, 0x14: 14 };
var rowsHighCh1 = { 0x11: 2, 0x12: 4, 0x15: 6, 0x16: 8, 0x17: 10, 0x13: 13, 0x14: 15 };
var rowsLowCh2 = { 0x19: 1, 0x1A: 3, 0x1D: 5, 0x1E: 7, 0x1F: 9, 0x18: 11, 0x1B: 12, 0x1C: 14 };
var rowsHighCh2 = { 0x19: 2, 0x1A: 4, 0x1D: 6, 0x1E: 8, 0x1F: 10, 0x1B: 13, 0x1C: 15 };
var backgroundColors = ['white', 'green', 'blue', 'cyan', 'red', 'yellow', 'magenta', 'black', 'transparent'];
/**
 * Simple logger class to be able to write with time-stamps and filter on level.
 */
var logger = {
    verboseFilter: { 'DATA': 3, 'DEBUG': 3, 'INFO': 2, 'WARNING': 2, 'TEXT': 1, 'ERROR': 0 },
    time: null,
    verboseLevel: 0,
    setTime: function (newTime) {
        this.time = newTime;
    },
    log: function (severity, msg) {
        var minLevel = this.verboseFilter[severity];
        if (this.verboseLevel >= minLevel) {
            // console.log(this.time + ' [' + severity + '] ' + msg);
        }
    }
};
var numArrayToHexArray = function (numArray) {
    var hexArray = [];
    for (var j = 0; j < numArray.length; j++) {
        hexArray.push(numArray[j].toString(16));
    }
    return hexArray;
};
var PenState = /** @class */ (function () {
    function PenState(foreground, underline, italics, background, flash) {
        this.foreground = foreground || 'white';
        this.underline = underline || false;
        this.italics = italics || false;
        this.background = background || 'black';
        this.flash = flash || false;
    }
    PenState.prototype.reset = function () {
        this.foreground = 'white';
        this.underline = false;
        this.italics = false;
        this.background = 'black';
        this.flash = false;
    };
    PenState.prototype.setStyles = function (styles) {
        var attribs = ['foreground', 'underline', 'italics', 'background', 'flash'];
        for (var i = 0; i < attribs.length; i++) {
            var style = attribs[i];
            if (styles.hasOwnProperty(style)) {
                this[style] = styles[style];
            }
        }
    };
    PenState.prototype.isDefault = function () {
        return (this.foreground === 'white' && !this.underline && !this.italics &&
            this.background === 'black' && !this.flash);
    };
    PenState.prototype.equals = function (other) {
        return ((this.foreground === other.foreground) &&
            (this.underline === other.underline) &&
            (this.italics === other.italics) &&
            (this.background === other.background) &&
            (this.flash === other.flash));
    };
    PenState.prototype.copy = function (newPenState) {
        this.foreground = newPenState.foreground;
        this.underline = newPenState.underline;
        this.italics = newPenState.italics;
        this.background = newPenState.background;
        this.flash = newPenState.flash;
    };
    PenState.prototype.toString = function () {
        return ('color=' + this.foreground + ', underline=' + this.underline + ', italics=' + this.italics +
            ', background=' + this.background + ', flash=' + this.flash);
    };
    return PenState;
}());
/**
 * Unicode character with styling and background.
 * @constructor
 */
var StyledUnicodeChar = /** @class */ (function () {
    function StyledUnicodeChar(uchar, foreground, underline, italics, background, flash) {
        this.uchar = uchar || ' '; // unicode character
        this.penState = new PenState(foreground, underline, italics, background, flash);
    }
    StyledUnicodeChar.prototype.reset = function () {
        this.uchar = ' ';
        this.penState.reset();
    };
    StyledUnicodeChar.prototype.setChar = function (uchar, newPenState) {
        this.uchar = uchar;
        this.penState.copy(newPenState);
    };
    StyledUnicodeChar.prototype.setPenState = function (newPenState) {
        this.penState.copy(newPenState);
    };
    StyledUnicodeChar.prototype.equals = function (other) {
        return this.uchar === other.uchar && this.penState.equals(other.penState);
    };
    StyledUnicodeChar.prototype.copy = function (newChar) {
        this.uchar = newChar.uchar;
        this.penState.copy(newChar.penState);
    };
    StyledUnicodeChar.prototype.isEmpty = function () {
        return this.uchar === ' ' && this.penState.isDefault();
    };
    return StyledUnicodeChar;
}());
/**
 * CEA-608 row consisting of NR_COLS instances of StyledUnicodeChar.
 * @constructor
 */
var Row = /** @class */ (function () {
    function Row() {
        this.chars = [];
        for (var i = 0; i < NR_COLS; i++) {
            this.chars.push(new StyledUnicodeChar());
        }
        this.pos = 0;
        this.currPenState = new PenState();
    }
    Row.prototype.equals = function (other) {
        var equal = true;
        for (var i = 0; i < NR_COLS; i++) {
            if (!this.chars[i].equals(other.chars[i])) {
                equal = false;
                break;
            }
        }
        return equal;
    };
    Row.prototype.copy = function (other) {
        for (var i = 0; i < NR_COLS; i++) {
            this.chars[i].copy(other.chars[i]);
        }
    };
    Row.prototype.isEmpty = function () {
        var empty = true;
        for (var i = 0; i < NR_COLS; i++) {
            if (!this.chars[i].isEmpty()) {
                empty = false;
                break;
            }
        }
        return empty;
    };
    /**
       *  Set the cursor to a valid column.
       */
    Row.prototype.setCursor = function (absPos) {
        if (this.pos !== absPos) {
            this.pos = absPos;
        }
        if (this.pos < 0) {
            logger.log('ERROR', 'Negative cursor position ' + this.pos);
            this.pos = 0;
        }
        else if (this.pos > NR_COLS) {
            logger.log('ERROR', 'Too large cursor position ' + this.pos);
            this.pos = NR_COLS;
        }
    };
    /**
       * Move the cursor relative to current position.
       */
    Row.prototype.moveCursor = function (relPos) {
        var newPos = this.pos + relPos;
        if (relPos > 1) {
            for (var i = this.pos + 1; i < newPos + 1; i++) {
                this.chars[i].setPenState(this.currPenState);
            }
        }
        this.setCursor(newPos);
    };
    /**
       * Backspace, move one step back and clear character.
       */
    Row.prototype.backSpace = function () {
        this.moveCursor(-1);
        this.chars[this.pos].setChar(' ', this.currPenState);
    };
    Row.prototype.insertChar = function (byte) {
        if (byte >= 0x90) { // Extended char
            this.backSpace();
        }
        var char = getCharForByte(byte);
        if (this.pos >= NR_COLS) {
            logger.log('ERROR', 'Cannot insert ' + byte.toString(16) +
                ' (' + char + ') at position ' + this.pos + '. Skipping it!');
            return;
        }
        this.chars[this.pos].setChar(char, this.currPenState);
        this.moveCursor(1);
    };
    Row.prototype.clearFromPos = function (startPos) {
        var i;
        for (i = startPos; i < NR_COLS; i++) {
            this.chars[i].reset();
        }
    };
    Row.prototype.clear = function () {
        this.clearFromPos(0);
        this.pos = 0;
        this.currPenState.reset();
    };
    Row.prototype.clearToEndOfRow = function () {
        this.clearFromPos(this.pos);
    };
    Row.prototype.getTextString = function () {
        var chars = [];
        var empty = true;
        for (var i = 0; i < NR_COLS; i++) {
            var char = this.chars[i].uchar;
            if (char !== ' ') {
                empty = false;
            }
            chars.push(char);
        }
        if (empty) {
            return '';
        }
        else {
            return chars.join('');
        }
    };
    Row.prototype.setPenStyles = function (styles) {
        this.currPenState.setStyles(styles);
        var currChar = this.chars[this.pos];
        currChar.setPenState(this.currPenState);
    };
    return Row;
}());
/**
 * Keep a CEA-608 screen of 32x15 styled characters
 * @constructor
*/
var CaptionScreen = /** @class */ (function () {
    function CaptionScreen() {
        this.rows = [];
        for (var i = 0; i < NR_ROWS; i++) {
            this.rows.push(new Row());
        } // Note that we use zero-based numbering (0-14)
        this.currRow = NR_ROWS - 1;
        this.nrRollUpRows = null;
        this.reset();
    }
    CaptionScreen.prototype.reset = function () {
        for (var i = 0; i < NR_ROWS; i++) {
            this.rows[i].clear();
        }
        this.currRow = NR_ROWS - 1;
    };
    CaptionScreen.prototype.equals = function (other) {
        var equal = true;
        for (var i = 0; i < NR_ROWS; i++) {
            if (!this.rows[i].equals(other.rows[i])) {
                equal = false;
                break;
            }
        }
        return equal;
    };
    CaptionScreen.prototype.copy = function (other) {
        for (var i = 0; i < NR_ROWS; i++) {
            this.rows[i].copy(other.rows[i]);
        }
    };
    CaptionScreen.prototype.isEmpty = function () {
        var empty = true;
        for (var i = 0; i < NR_ROWS; i++) {
            if (!this.rows[i].isEmpty()) {
                empty = false;
                break;
            }
        }
        return empty;
    };
    CaptionScreen.prototype.backSpace = function () {
        var row = this.rows[this.currRow];
        row.backSpace();
    };
    CaptionScreen.prototype.clearToEndOfRow = function () {
        var row = this.rows[this.currRow];
        row.clearToEndOfRow();
    };
    /**
       * Insert a character (without styling) in the current row.
       */
    CaptionScreen.prototype.insertChar = function (char) {
        var row = this.rows[this.currRow];
        row.insertChar(char);
    };
    CaptionScreen.prototype.setPen = function (styles) {
        var row = this.rows[this.currRow];
        row.setPenStyles(styles);
    };
    CaptionScreen.prototype.moveCursor = function (relPos) {
        var row = this.rows[this.currRow];
        row.moveCursor(relPos);
    };
    CaptionScreen.prototype.setCursor = function (absPos) {
        logger.log('INFO', 'setCursor: ' + absPos);
        var row = this.rows[this.currRow];
        row.setCursor(absPos);
    };
    CaptionScreen.prototype.setPAC = function (pacData) {
        logger.log('INFO', 'pacData = ' + JSON.stringify(pacData));
        var newRow = pacData.row - 1;
        if (this.nrRollUpRows && newRow < this.nrRollUpRows - 1) {
            newRow = this.nrRollUpRows - 1;
        }
        // Make sure this only affects Roll-up Captions by checking this.nrRollUpRows
        if (this.nrRollUpRows && this.currRow !== newRow) {
            // clear all rows first
            for (var i = 0; i < NR_ROWS; i++) {
                this.rows[i].clear();
            }
            // Copy this.nrRollUpRows rows from lastOutputScreen and place it in the newRow location
            // topRowIndex - the start of rows to copy (inclusive index)
            var topRowIndex = this.currRow + 1 - (this.nrRollUpRows);
            // We only copy if the last position was already shown.
            // We use the cueStartTime value to check this.
            var lastOutputScreen = this.lastOutputScreen;
            if (lastOutputScreen) {
                var prevLineTime = lastOutputScreen.rows[topRowIndex].cueStartTime;
                if (prevLineTime && prevLineTime < logger.time) {
                    for (var i = 0; i < this.nrRollUpRows; i++) {
                        this.rows[newRow - this.nrRollUpRows + i + 1].copy(lastOutputScreen.rows[topRowIndex + i]);
                    }
                }
            }
        }
        this.currRow = newRow;
        var row = this.rows[this.currRow];
        if (pacData.indent !== null) {
            var indent = pacData.indent;
            var prevPos = Math.max(indent - 1, 0);
            row.setCursor(pacData.indent);
            pacData.color = row.chars[prevPos].penState.foreground;
        }
        var styles = { foreground: pacData.color, underline: pacData.underline, italics: pacData.italics, background: 'black', flash: false };
        this.setPen(styles);
    };
    /**
       * Set background/extra foreground, but first do back_space, and then insert space (backwards compatibility).
       */
    CaptionScreen.prototype.setBkgData = function (bkgData) {
        logger.log('INFO', 'bkgData = ' + JSON.stringify(bkgData));
        this.backSpace();
        this.setPen(bkgData);
        this.insertChar(0x20); // Space
    };
    CaptionScreen.prototype.setRollUpRows = function (nrRows) {
        this.nrRollUpRows = nrRows;
    };
    CaptionScreen.prototype.rollUp = function () {
        if (this.nrRollUpRows === null) {
            logger.log('DEBUG', 'roll_up but nrRollUpRows not set yet');
            return; // Not properly setup
        }
        logger.log('TEXT', this.getDisplayText());
        var topRowIndex = this.currRow + 1 - this.nrRollUpRows;
        var topRow = this.rows.splice(topRowIndex, 1)[0];
        topRow.clear();
        this.rows.splice(this.currRow, 0, topRow);
        logger.log('INFO', 'Rolling up');
        // logger.log('TEXT', this.get_display_text())
    };
    /**
      * Get all non-empty rows with as unicode text.
      */
    CaptionScreen.prototype.getDisplayText = function (asOneRow) {
        asOneRow = asOneRow || false;
        var displayText = [];
        var text = '';
        var rowNr = -1;
        for (var i = 0; i < NR_ROWS; i++) {
            var rowText = this.rows[i].getTextString();
            if (rowText) {
                rowNr = i + 1;
                if (asOneRow) {
                    displayText.push('Row ' + rowNr + ': \'' + rowText + '\'');
                }
                else {
                    displayText.push(rowText.trim());
                }
            }
        }
        if (displayText.length > 0) {
            if (asOneRow) {
                text = '[' + displayText.join(' | ') + ']';
            }
            else {
                text = displayText.join('\n');
            }
        }
        return text;
    };
    CaptionScreen.prototype.getTextAndFormat = function () {
        return this.rows;
    };
    return CaptionScreen;
}());
// var modes = ['MODE_ROLL-UP', 'MODE_POP-ON', 'MODE_PAINT-ON', 'MODE_TEXT'];
var Cea608Channel = /** @class */ (function () {
    function Cea608Channel(channelNumber, outputFilter) {
        this.chNr = channelNumber;
        this.outputFilter = outputFilter;
        this.mode = null;
        this.verbose = 0;
        this.displayedMemory = new CaptionScreen();
        this.nonDisplayedMemory = new CaptionScreen();
        this.lastOutputScreen = new CaptionScreen();
        this.currRollUpRow = this.displayedMemory.rows[NR_ROWS - 1];
        this.writeScreen = this.displayedMemory;
        this.mode = null;
        this.cueStartTime = null; // Keeps track of where a cue started.
    }
    Cea608Channel.prototype.reset = function () {
        this.mode = null;
        this.displayedMemory.reset();
        this.nonDisplayedMemory.reset();
        this.lastOutputScreen.reset();
        this.currRollUpRow = this.displayedMemory.rows[NR_ROWS - 1];
        this.writeScreen = this.displayedMemory;
        this.mode = null;
        this.cueStartTime = null;
        this.lastCueEndTime = null;
    };
    Cea608Channel.prototype.getHandler = function () {
        return this.outputFilter;
    };
    Cea608Channel.prototype.setHandler = function (newHandler) {
        this.outputFilter = newHandler;
    };
    Cea608Channel.prototype.setPAC = function (pacData) {
        this.writeScreen.setPAC(pacData);
    };
    Cea608Channel.prototype.setBkgData = function (bkgData) {
        this.writeScreen.setBkgData(bkgData);
    };
    Cea608Channel.prototype.setMode = function (newMode) {
        if (newMode === this.mode) {
            return;
        }
        this.mode = newMode;
        logger.log('INFO', 'MODE=' + newMode);
        if (this.mode === 'MODE_POP-ON') {
            this.writeScreen = this.nonDisplayedMemory;
        }
        else {
            this.writeScreen = this.displayedMemory;
            this.writeScreen.reset();
        }
        if (this.mode !== 'MODE_ROLL-UP') {
            this.displayedMemory.nrRollUpRows = null;
            this.nonDisplayedMemory.nrRollUpRows = null;
        }
        this.mode = newMode;
    };
    Cea608Channel.prototype.insertChars = function (chars) {
        for (var i = 0; i < chars.length; i++) {
            this.writeScreen.insertChar(chars[i]);
        }
        var screen = this.writeScreen === this.displayedMemory ? 'DISP' : 'NON_DISP';
        logger.log('INFO', screen + ': ' + this.writeScreen.getDisplayText(true));
        if (this.mode === 'MODE_PAINT-ON' || this.mode === 'MODE_ROLL-UP') {
            logger.log('TEXT', 'DISPLAYED: ' + this.displayedMemory.getDisplayText(true));
            this.outputDataUpdate();
        }
    };
    Cea608Channel.prototype.ccRCL = function () {
        logger.log('INFO', 'RCL - Resume Caption Loading');
        this.setMode('MODE_POP-ON');
    };
    Cea608Channel.prototype.ccBS = function () {
        logger.log('INFO', 'BS - BackSpace');
        if (this.mode === 'MODE_TEXT') {
            return;
        }
        this.writeScreen.backSpace();
        if (this.writeScreen === this.displayedMemory) {
            this.outputDataUpdate();
        }
    };
    Cea608Channel.prototype.ccAOF = function () {
    };
    Cea608Channel.prototype.ccAON = function () {
    };
    Cea608Channel.prototype.ccDER = function () {
        logger.log('INFO', 'DER- Delete to End of Row');
        this.writeScreen.clearToEndOfRow();
        this.outputDataUpdate();
    };
    Cea608Channel.prototype.ccRU = function (nrRows) {
        logger.log('INFO', 'RU(' + nrRows + ') - Roll Up');
        this.writeScreen = this.displayedMemory;
        this.setMode('MODE_ROLL-UP');
        this.writeScreen.setRollUpRows(nrRows);
    };
    Cea608Channel.prototype.ccFON = function () {
        logger.log('INFO', 'FON - Flash On');
        this.writeScreen.setPen({ flash: true });
    };
    Cea608Channel.prototype.ccRDC = function () {
        logger.log('INFO', 'RDC - Resume Direct Captioning');
        this.setMode('MODE_PAINT-ON');
    };
    Cea608Channel.prototype.ccTR = function () {
        logger.log('INFO', 'TR');
        this.setMode('MODE_TEXT');
    };
    Cea608Channel.prototype.ccRTD = function () {
        logger.log('INFO', 'RTD');
        this.setMode('MODE_TEXT');
    };
    Cea608Channel.prototype.ccEDM = function () {
        logger.log('INFO', 'EDM - Erase Displayed Memory');
        this.displayedMemory.reset();
        this.outputDataUpdate(true);
    };
    Cea608Channel.prototype.ccCR = function () {
        logger.log('CR - Carriage Return');
        this.writeScreen.rollUp();
        this.outputDataUpdate(true);
    };
    Cea608Channel.prototype.ccENM = function () {
        logger.log('INFO', 'ENM - Erase Non-displayed Memory');
        this.nonDisplayedMemory.reset();
    };
    Cea608Channel.prototype.ccEOC = function () {
        logger.log('INFO', 'EOC - End Of Caption');
        if (this.mode === 'MODE_POP-ON') {
            var tmp = this.displayedMemory;
            this.displayedMemory = this.nonDisplayedMemory;
            this.nonDisplayedMemory = tmp;
            this.writeScreen = this.nonDisplayedMemory;
            logger.log('TEXT', 'DISP: ' + this.displayedMemory.getDisplayText());
        }
        this.outputDataUpdate(true);
    };
    Cea608Channel.prototype.ccTO = function (nrCols) {
        logger.log('INFO', 'TO(' + nrCols + ') - Tab Offset');
        this.writeScreen.moveCursor(nrCols);
    };
    Cea608Channel.prototype.ccMIDROW = function (secondByte) {
        var styles = { flash: false };
        styles.underline = secondByte % 2 === 1;
        styles.italics = secondByte >= 0x2e;
        if (!styles.italics) {
            var colorIndex = Math.floor(secondByte / 2) - 0x10;
            var colors = ['white', 'green', 'blue', 'cyan', 'red', 'yellow', 'magenta'];
            styles.foreground = colors[colorIndex];
        }
        else {
            styles.foreground = 'white';
        }
        logger.log('INFO', 'MIDROW: ' + JSON.stringify(styles));
        this.writeScreen.setPen(styles);
    };
    Cea608Channel.prototype.outputDataUpdate = function (dispatch) {
        if (dispatch === void 0) { dispatch = false; }
        var t = logger.time;
        if (t === null) {
            return;
        }
        if (this.outputFilter) {
            if (this.cueStartTime === null && !this.displayedMemory.isEmpty()) { // Start of a new cue
                this.cueStartTime = t;
            }
            else {
                if (!this.displayedMemory.equals(this.lastOutputScreen)) {
                    if (this.outputFilter.newCue) {
                        this.outputFilter.newCue(this.cueStartTime, t, this.lastOutputScreen);
                        if (dispatch === true && this.outputFilter.dispatchCue) {
                            this.outputFilter.dispatchCue();
                        }
                    }
                    this.cueStartTime = this.displayedMemory.isEmpty() ? null : t;
                }
            }
            this.lastOutputScreen.copy(this.displayedMemory);
        }
    };
    Cea608Channel.prototype.cueSplitAtTime = function (t) {
        if (this.outputFilter) {
            if (!this.displayedMemory.isEmpty()) {
                if (this.outputFilter.newCue) {
                    this.outputFilter.newCue(this.cueStartTime, t, this.displayedMemory);
                }
                this.cueStartTime = t;
            }
        }
    };
    return Cea608Channel;
}());
var Cea608Parser = /** @class */ (function () {
    function Cea608Parser(field, out1, out2) {
        this.field = field || 1;
        this.outputs = [out1, out2];
        this.channels = [new Cea608Channel(1, out1), new Cea608Channel(2, out2)];
        this.currChNr = -1; // Will be 1 or 2
        this.lastCmdA = null; // First byte of last command
        this.lastCmdB = null; // Second byte of last command
        this.bufferedData = [];
        this.startTime = null;
        this.lastTime = null;
        this.dataCounters = { 'padding': 0, 'char': 0, 'cmd': 0, 'other': 0 };
    }
    Cea608Parser.prototype.getHandler = function (index) {
        return this.channels[index].getHandler();
    };
    Cea608Parser.prototype.setHandler = function (index, newHandler) {
        this.channels[index].setHandler(newHandler);
    };
    /**
       * Add data for time t in forms of list of bytes (unsigned ints). The bytes are treated as pairs.
       */
    Cea608Parser.prototype.addData = function (t, byteList) {
        var cmdFound, a, b, charsFound = false;
        this.lastTime = t;
        logger.setTime(t);
        for (var i = 0; i < byteList.length; i += 2) {
            a = byteList[i] & 0x7f;
            b = byteList[i + 1] & 0x7f;
            if (a === 0 && b === 0) {
                this.dataCounters.padding += 2;
                continue;
            }
            else {
                logger.log('DATA', '[' + numArrayToHexArray([byteList[i], byteList[i + 1]]) + '] -> (' + numArrayToHexArray([a, b]) + ')');
            }
            cmdFound = this.parseCmd(a, b);
            if (!cmdFound) {
                cmdFound = this.parseMidrow(a, b);
            }
            if (!cmdFound) {
                cmdFound = this.parsePAC(a, b);
            }
            if (!cmdFound) {
                cmdFound = this.parseBackgroundAttributes(a, b);
            }
            if (!cmdFound) {
                charsFound = this.parseChars(a, b);
                if (charsFound) {
                    if (this.currChNr && this.currChNr >= 0) {
                        var channel = this.channels[this.currChNr - 1];
                        channel.insertChars(charsFound);
                    }
                    else {
                        logger.log('WARNING', 'No channel found yet. TEXT-MODE?');
                    }
                }
            }
            if (cmdFound) {
                this.dataCounters.cmd += 2;
            }
            else if (charsFound) {
                this.dataCounters.char += 2;
            }
            else {
                this.dataCounters.other += 2;
                logger.log('WARNING', 'Couldn\'t parse cleaned data ' + numArrayToHexArray([a, b]) +
                    ' orig: ' + numArrayToHexArray([byteList[i], byteList[i + 1]]));
            }
        }
    };
    /**
       * Parse Command.
       * @returns {Boolean} Tells if a command was found
       */
    Cea608Parser.prototype.parseCmd = function (a, b) {
        var chNr = null;
        var cond1 = (a === 0x14 || a === 0x1C) && (b >= 0x20 && b <= 0x2F);
        var cond2 = (a === 0x17 || a === 0x1F) && (b >= 0x21 && b <= 0x23);
        if (!(cond1 || cond2)) {
            return false;
        }
        if (a === this.lastCmdA && b === this.lastCmdB) {
            this.lastCmdA = null;
            this.lastCmdB = null; // Repeated commands are dropped (once)
            logger.log('DEBUG', 'Repeated command (' + numArrayToHexArray([a, b]) + ') is dropped');
            return true;
        }
        if (a === 0x14 || a === 0x17) {
            chNr = 1;
        }
        else {
            chNr = 2;
        } // (a === 0x1C || a=== 0x1f)
        var channel = this.channels[chNr - 1];
        if (a === 0x14 || a === 0x1C) {
            if (b === 0x20) {
                channel.ccRCL();
            }
            else if (b === 0x21) {
                channel.ccBS();
            }
            else if (b === 0x22) {
                channel.ccAOF();
            }
            else if (b === 0x23) {
                channel.ccAON();
            }
            else if (b === 0x24) {
                channel.ccDER();
            }
            else if (b === 0x25) {
                channel.ccRU(2);
            }
            else if (b === 0x26) {
                channel.ccRU(3);
            }
            else if (b === 0x27) {
                channel.ccRU(4);
            }
            else if (b === 0x28) {
                channel.ccFON();
            }
            else if (b === 0x29) {
                channel.ccRDC();
            }
            else if (b === 0x2A) {
                channel.ccTR();
            }
            else if (b === 0x2B) {
                channel.ccRTD();
            }
            else if (b === 0x2C) {
                channel.ccEDM();
            }
            else if (b === 0x2D) {
                channel.ccCR();
            }
            else if (b === 0x2E) {
                channel.ccENM();
            }
            else if (b === 0x2F) {
                channel.ccEOC();
            }
        }
        else { // a == 0x17 || a == 0x1F
            channel.ccTO(b - 0x20);
        }
        this.lastCmdA = a;
        this.lastCmdB = b;
        this.currChNr = chNr;
        return true;
    };
    /**
       * Parse midrow styling command
       * @returns {Boolean}
       */
    Cea608Parser.prototype.parseMidrow = function (a, b) {
        var chNr = null;
        if (((a === 0x11) || (a === 0x19)) && b >= 0x20 && b <= 0x2f) {
            if (a === 0x11) {
                chNr = 1;
            }
            else {
                chNr = 2;
            }
            if (chNr !== this.currChNr) {
                logger.log('ERROR', 'Mismatch channel in midrow parsing');
                return false;
            }
            var channel = this.channels[chNr - 1];
            channel.ccMIDROW(b);
            logger.log('DEBUG', 'MIDROW (' + numArrayToHexArray([a, b]) + ')');
            return true;
        }
        return false;
    };
    /**
       * Parse Preable Access Codes (Table 53).
       * @returns {Boolean} Tells if PAC found
       */
    Cea608Parser.prototype.parsePAC = function (a, b) {
        var chNr = null;
        var row = null;
        var case1 = ((a >= 0x11 && a <= 0x17) || (a >= 0x19 && a <= 0x1F)) && (b >= 0x40 && b <= 0x7F);
        var case2 = (a === 0x10 || a === 0x18) && (b >= 0x40 && b <= 0x5F);
        if (!(case1 || case2)) {
            return false;
        }
        if (a === this.lastCmdA && b === this.lastCmdB) {
            this.lastCmdA = null;
            this.lastCmdB = null;
            return true; // Repeated commands are dropped (once)
        }
        chNr = (a <= 0x17) ? 1 : 2;
        if (b >= 0x40 && b <= 0x5F) {
            row = (chNr === 1) ? rowsLowCh1[a] : rowsLowCh2[a];
        }
        else { // 0x60 <= b <= 0x7F
            row = (chNr === 1) ? rowsHighCh1[a] : rowsHighCh2[a];
        }
        var pacData = this.interpretPAC(row, b);
        var channel = this.channels[chNr - 1];
        channel.setPAC(pacData);
        this.lastCmdA = a;
        this.lastCmdB = b;
        this.currChNr = chNr;
        return true;
    };
    /**
       * Interpret the second byte of the pac, and return the information.
       * @returns {Object} pacData with style parameters.
       */
    Cea608Parser.prototype.interpretPAC = function (row, byte) {
        var pacIndex = byte;
        var pacData = { color: null, italics: false, indent: null, underline: false, row: row };
        if (byte > 0x5F) {
            pacIndex = byte - 0x60;
        }
        else {
            pacIndex = byte - 0x40;
        }
        pacData.underline = (pacIndex & 1) === 1;
        if (pacIndex <= 0xd) {
            pacData.color = ['white', 'green', 'blue', 'cyan', 'red', 'yellow', 'magenta', 'white'][Math.floor(pacIndex / 2)];
        }
        else if (pacIndex <= 0xf) {
            pacData.italics = true;
            pacData.color = 'white';
        }
        else {
            pacData.indent = (Math.floor((pacIndex - 0x10) / 2)) * 4;
        }
        return pacData; // Note that row has zero offset. The spec uses 1.
    };
    /**
       * Parse characters.
       * @returns An array with 1 to 2 codes corresponding to chars, if found. null otherwise.
       */
    Cea608Parser.prototype.parseChars = function (a, b) {
        var channelNr = null, charCodes = null, charCode1 = null;
        if (a >= 0x19) {
            channelNr = 2;
            charCode1 = a - 8;
        }
        else {
            channelNr = 1;
            charCode1 = a;
        }
        if (charCode1 >= 0x11 && charCode1 <= 0x13) {
            // Special character
            var oneCode = b;
            if (charCode1 === 0x11) {
                oneCode = b + 0x50;
            }
            else if (charCode1 === 0x12) {
                oneCode = b + 0x70;
            }
            else {
                oneCode = b + 0x90;
            }
            logger.log('INFO', 'Special char \'' + getCharForByte(oneCode) + '\' in channel ' + channelNr);
            charCodes = [oneCode];
        }
        else if (a >= 0x20 && a <= 0x7f) {
            charCodes = (b === 0) ? [a] : [a, b];
        }
        if (charCodes) {
            var hexCodes = numArrayToHexArray(charCodes);
            logger.log('DEBUG', 'Char codes =  ' + hexCodes.join(','));
            this.lastCmdA = null;
            this.lastCmdB = null;
        }
        return charCodes;
    };
    /**
      * Parse extended background attributes as well as new foreground color black.
      * @returns{Boolean} Tells if background attributes are found
      */
    Cea608Parser.prototype.parseBackgroundAttributes = function (a, b) {
        var bkgData, index, chNr, channel;
        var case1 = (a === 0x10 || a === 0x18) && (b >= 0x20 && b <= 0x2f);
        var case2 = (a === 0x17 || a === 0x1f) && (b >= 0x2d && b <= 0x2f);
        if (!(case1 || case2)) {
            return false;
        }
        bkgData = {};
        if (a === 0x10 || a === 0x18) {
            index = Math.floor((b - 0x20) / 2);
            bkgData.background = backgroundColors[index];
            if (b % 2 === 1) {
                bkgData.background = bkgData.background + '_semi';
            }
        }
        else if (b === 0x2d) {
            bkgData.background = 'transparent';
        }
        else {
            bkgData.foreground = 'black';
            if (b === 0x2f) {
                bkgData.underline = true;
            }
        }
        chNr = (a < 0x18) ? 1 : 2;
        channel = this.channels[chNr - 1];
        channel.setBkgData(bkgData);
        this.lastCmdA = null;
        this.lastCmdB = null;
        return true;
    };
    /**
       * Reset state of parser and its channels.
       */
    Cea608Parser.prototype.reset = function () {
        for (var i = 0; i < this.channels.length; i++) {
            if (this.channels[i]) {
                this.channels[i].reset();
            }
        }
        this.lastCmdA = null;
        this.lastCmdB = null;
    };
    /**
       * Trigger the generation of a cue, and the start of a new one if displayScreens are not empty.
       */
    Cea608Parser.prototype.cueSplitAtTime = function (t) {
        for (var i = 0; i < this.channels.length; i++) {
            if (this.channels[i]) {
                this.channels[i].cueSplitAtTime(t);
            }
        }
    };
    return Cea608Parser;
}());
exports.default = Cea608Parser;


/***/ }),

/***/ "./src/utils/codecs.js":
/*!*****************************!*\
  !*** ./src/utils/codecs.js ***!
  \*****************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// from http://mp4ra.org/codecs.html
var sampleEntryCodesISO = {
    audio: {
        'a3ds': true,
        'ac-3': true,
        'ac-4': true,
        'alac': true,
        'alaw': true,
        'dra1': true,
        'dts+': true,
        'dts-': true,
        'dtsc': true,
        'dtse': true,
        'dtsh': true,
        'ec-3': true,
        'enca': true,
        'g719': true,
        'g726': true,
        'm4ae': true,
        'mha1': true,
        'mha2': true,
        'mhm1': true,
        'mhm2': true,
        'mlpa': true,
        'mp4a': true,
        'raw ': true,
        'Opus': true,
        'samr': true,
        'sawb': true,
        'sawp': true,
        'sevc': true,
        'sqcp': true,
        'ssmv': true,
        'twos': true,
        'ulaw': true
    },
    video: {
        'avc1': true,
        'avc2': true,
        'avc3': true,
        'avc4': true,
        'avcp': true,
        'drac': true,
        'dvav': true,
        'dvhe': true,
        'encv': true,
        'hev1': true,
        'hvc1': true,
        'mjp2': true,
        'mp4v': true,
        'mvc1': true,
        'mvc2': true,
        'mvc3': true,
        'mvc4': true,
        'resv': true,
        'rv60': true,
        's263': true,
        'svc1': true,
        'svc2': true,
        'vc-1': true,
        'vp08': true,
        'vp09': true
    }
};
function isCodecType(codec, type) {
    var typeCodes = sampleEntryCodesISO[type];
    return !!typeCodes && typeCodes[codec.slice(0, 4)] === true;
}
exports.isCodecType = isCodecType;
function isCodecSupportedInMp4(codec, type) {
    return window.MediaSource.isTypeSupported((type || 'video') + "/mp4;codecs=\"" + codec + "\"");
}
exports.isCodecSupportedInMp4 = isCodecSupportedInMp4;


/***/ }),

/***/ "./src/utils/cues.js":
/*!***************************!*\
  !*** ./src/utils/cues.js ***!
  \***************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var vttparser_1 = __webpack_require__(/*! ./vttparser */ "./src/utils/vttparser.js");
function newCue(track, startTime, endTime, captionScreen) {
    var row;
    var cue;
    var indenting;
    var indent;
    var text;
    var VTTCue = window.VTTCue || window.TextTrackCue;
    for (var r = 0; r < captionScreen.rows.length; r++) {
        row = captionScreen.rows[r];
        indenting = true;
        indent = 0;
        text = '';
        if (!row.isEmpty()) {
            for (var c = 0; c < row.chars.length; c++) {
                if (row.chars[c].uchar.match(/\s/) && indenting) {
                    indent++;
                }
                else {
                    text += row.chars[c].uchar;
                    indenting = false;
                }
            }
            // To be used for cleaning-up orphaned roll-up captions
            row.cueStartTime = startTime;
            // Give a slight bump to the endTime if it's equal to startTime to avoid a SyntaxError in IE
            if (startTime === endTime) {
                endTime += 0.0001;
            }
            cue = new VTTCue(startTime, endTime, vttparser_1.fixLineBreaks(text.trim()));
            if (indent >= 16) {
                indent--;
            }
            else {
                indent++;
            }
            // VTTCue.line get's flakey when using controls, so let's now include line 13&14
            // also, drop line 1 since it's to close to the top
            if (navigator.userAgent.match(/Firefox\//)) {
                cue.line = r + 1;
            }
            else {
                cue.line = (r > 7 ? r - 2 : r + 1);
            }
            cue.align = 'left';
            // Clamp the position between 0 and 100 - if out of these bounds, Firefox throws an exception and captions break
            cue.position = Math.max(0, Math.min(100, 100 * (indent / 32) + (navigator.userAgent.match(/Firefox\//) ? 50 : 0)));
            track.addCue(cue);
        }
    }
}
exports.newCue = newCue;


/***/ }),

/***/ "./src/utils/discontinuities.js":
/*!**************************************!*\
  !*** ./src/utils/discontinuities.js ***!
  \**************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Number) {
Object.defineProperty(exports, "__esModule", { value: true });
var binary_search_1 = __webpack_require__(/*! ./binary-search */ "./src/utils/binary-search.js");
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
function findFirstFragWithCC(fragments, cc) {
    var firstFrag = null;
    for (var i = 0; i < fragments.length; i += 1) {
        var currentFrag = fragments[i];
        if (currentFrag && currentFrag.cc === cc) {
            firstFrag = currentFrag;
            break;
        }
    }
    return firstFrag;
}
exports.findFirstFragWithCC = findFirstFragWithCC;
function findFragWithCC(fragments, CC) {
    return binary_search_1.default.search(fragments, function (candidate) {
        if (candidate.cc < CC) {
            return 1;
        }
        else if (candidate.cc > CC) {
            return -1;
        }
        else {
            return 0;
        }
    });
}
exports.findFragWithCC = findFragWithCC;
function shouldAlignOnDiscontinuities(lastFrag, lastLevel, details) {
    var shouldAlign = false;
    if (lastLevel && lastLevel.details && details) {
        if (details.endCC > details.startCC || (lastFrag && lastFrag.cc < details.startCC)) {
            shouldAlign = true;
        }
    }
    return shouldAlign;
}
exports.shouldAlignOnDiscontinuities = shouldAlignOnDiscontinuities;
// Find the first frag in the previous level which matches the CC of the first frag of the new level
function findDiscontinuousReferenceFrag(prevDetails, curDetails) {
    var prevFrags = prevDetails.fragments;
    var curFrags = curDetails.fragments;
    if (!curFrags.length || !prevFrags.length) {
        logger_1.logger.log('No fragments to align');
        return;
    }
    var prevStartFrag = findFirstFragWithCC(prevFrags, curFrags[0].cc);
    if (!prevStartFrag || (prevStartFrag && !prevStartFrag.startPTS)) {
        logger_1.logger.log('No frag in previous level to align on');
        return;
    }
    return prevStartFrag;
}
exports.findDiscontinuousReferenceFrag = findDiscontinuousReferenceFrag;
function adjustPts(sliding, details) {
    details.fragments.forEach(function (frag) {
        if (frag) {
            var start = frag.start + sliding;
            frag.start = frag.startPTS = start;
            frag.endPTS = start + frag.duration;
        }
    });
    details.PTSKnown = true;
}
exports.adjustPts = adjustPts;
/**
 * Using the parameters of the last level, this function computes PTS' of the new fragments so that they form a
 * contiguous stream with the last fragments.
 * The PTS of a fragment lets Hls.js know where it fits into a stream - by knowing every PTS, we know which fragment to
 * download at any given time. PTS is normally computed when the fragment is demuxed, so taking this step saves us time
 * and an extra download.
 * @param lastFrag
 * @param lastLevel
 * @param details
 */
function alignStream(lastFrag, lastLevel, details) {
    alignDiscontinuities(lastFrag, details, lastLevel);
    if (!details.PTSKnown && lastLevel) {
        // If the PTS wasn't figured out via discontinuity sequence that means there was no CC increase within the level.
        // Aligning via Program Date Time should therefore be reliable, since PDT should be the same within the same
        // discontinuity sequence.
        alignPDT(details, lastLevel.details);
    }
}
exports.alignStream = alignStream;
/**
 * Computes the PTS if a new level's fragments using the PTS of a fragment in the last level which shares the same
 * discontinuity sequence.
 * @param lastLevel - The details of the last loaded level
 * @param details - The details of the new level
 */
function alignDiscontinuities(lastFrag, details, lastLevel) {
    if (shouldAlignOnDiscontinuities(lastFrag, lastLevel, details)) {
        var referenceFrag = findDiscontinuousReferenceFrag(lastLevel.details, details);
        if (referenceFrag) {
            logger_1.logger.log('Adjusting PTS using last level due to CC increase within current level');
            adjustPts(referenceFrag.start, details);
        }
    }
}
exports.alignDiscontinuities = alignDiscontinuities;
/**
 * Computes the PTS of a new level's fragments using the difference in Program Date Time from the last level.
 * @param details - The details of the new level
 * @param lastDetails - The details of the last loaded level
 */
function alignPDT(details, lastDetails) {
    if (lastDetails && lastDetails.fragments.length) {
        if (!details.hasProgramDateTime || !lastDetails.hasProgramDateTime) {
            return;
        }
        // if last level sliding is 1000 and its first frag PROGRAM-DATE-TIME is 2017-08-20 1:10:00 AM
        // and if new details first frag PROGRAM DATE-TIME is 2017-08-20 1:10:08 AM
        // then we can deduce that playlist B sliding is 1000+8 = 1008s
        var lastPDT = lastDetails.fragments[0].programDateTime;
        var newPDT = details.fragments[0].programDateTime;
        // date diff is in ms. frag.start is in seconds
        var sliding = (newPDT - lastPDT) / 1000 + lastDetails.fragments[0].start;
        if (Number.isFinite(sliding)) {
            logger_1.logger.log("adjusting PTS using programDateTime delta, sliding:" + sliding.toFixed(3));
            adjustPts(sliding, details);
        }
    }
}
exports.alignPDT = alignPDT;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./src/polyfills/number */ "./src/polyfills/number.js")["Number"]))

/***/ }),

/***/ "./src/utils/ewma-bandwidth-estimator.js":
/*!***********************************************!*\
  !*** ./src/utils/ewma-bandwidth-estimator.js ***!
  \***********************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * EWMA Bandwidth Estimator
 *  - heavily inspired from shaka-player
 * Tracks bandwidth samples and estimates available bandwidth.
 * Based on the minimum of two exponentially-weighted moving averages with
 * different half-lives.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var ewma_1 = __webpack_require__(/*! ../utils/ewma */ "./src/utils/ewma.js");
var EwmaBandWidthEstimator = /** @class */ (function () {
    function EwmaBandWidthEstimator(hls, slow, fast, defaultEstimate) {
        this.hls = hls;
        this.defaultEstimate_ = defaultEstimate;
        this.minWeight_ = 0.001;
        this.minDelayMs_ = 50;
        this.slow_ = new ewma_1.default(slow);
        this.fast_ = new ewma_1.default(fast);
    }
    EwmaBandWidthEstimator.prototype.sample = function (durationMs, numBytes) {
        durationMs = Math.max(durationMs, this.minDelayMs_);
        var bandwidth = 8000 * numBytes / durationMs, 
        // console.log('instant bw:'+ Math.round(bandwidth));
        // we weight sample using loading duration....
        weight = durationMs / 1000;
        this.fast_.sample(weight, bandwidth);
        this.slow_.sample(weight, bandwidth);
    };
    EwmaBandWidthEstimator.prototype.canEstimate = function () {
        var fast = this.fast_;
        return (fast && fast.getTotalWeight() >= this.minWeight_);
    };
    EwmaBandWidthEstimator.prototype.getEstimate = function () {
        if (this.canEstimate()) {
            // console.log('slow estimate:'+ Math.round(this.slow_.getEstimate()));
            // console.log('fast estimate:'+ Math.round(this.fast_.getEstimate()));
            // Take the minimum of these two estimates.  This should have the effect of
            // adapting down quickly, but up more slowly.
            return Math.min(this.fast_.getEstimate(), this.slow_.getEstimate());
        }
        else {
            return this.defaultEstimate_;
        }
    };
    EwmaBandWidthEstimator.prototype.destroy = function () {
    };
    return EwmaBandWidthEstimator;
}());
exports.default = EwmaBandWidthEstimator;


/***/ }),

/***/ "./src/utils/ewma.js":
/*!***************************!*\
  !*** ./src/utils/ewma.js ***!
  \***************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * compute an Exponential Weighted moving average
 * - https://en.wikipedia.org/wiki/Moving_average#Exponential_moving_average
 *  - heavily inspired from shaka-player
 */
Object.defineProperty(exports, "__esModule", { value: true });
var EWMA = /** @class */ (function () {
    //  About half of the estimated value will be from the last |halfLife| samples by weight.
    function EWMA(halfLife) {
        // Larger values of alpha expire historical data more slowly.
        this.alpha_ = halfLife ? Math.exp(Math.log(0.5) / halfLife) : 0;
        this.estimate_ = 0;
        this.totalWeight_ = 0;
    }
    EWMA.prototype.sample = function (weight, value) {
        var adjAlpha = Math.pow(this.alpha_, weight);
        this.estimate_ = value * (1 - adjAlpha) + adjAlpha * this.estimate_;
        this.totalWeight_ += weight;
    };
    EWMA.prototype.getTotalWeight = function () {
        return this.totalWeight_;
    };
    EWMA.prototype.getEstimate = function () {
        if (this.alpha_) {
            var zeroFactor = 1 - Math.pow(this.alpha_, this.totalWeight_);
            return this.estimate_ / zeroFactor;
        }
        else {
            return this.estimate_;
        }
    };
    return EWMA;
}());
exports.default = EWMA;


/***/ }),

/***/ "./src/utils/get-self-scope.js":
/*!*************************************!*\
  !*** ./src/utils/get-self-scope.js ***!
  \*************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function getSelfScope() {
    // see https://stackoverflow.com/a/11237259/589493
    if (typeof window === 'undefined') {
        /* eslint-disable-next-line no-undef */
        return self;
    }
    else {
        return window;
    }
}
exports.getSelfScope = getSelfScope;


/***/ }),

/***/ "./src/utils/logger.js":
/*!*****************************!*\
  !*** ./src/utils/logger.js ***!
  \*****************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var get_self_scope_1 = __webpack_require__(/*! ./get-self-scope */ "./src/utils/get-self-scope.js");
function noop() { }
var fakeLogger = {
    trace: noop,
    debug: noop,
    log: noop,
    warn: noop,
    info: noop,
    error: noop
};
var exportedLogger = fakeLogger;
// let lastCallTime;
// function formatMsgWithTimeInfo(type, msg) {
//   const now = Date.now();
//   const diff = lastCallTime ? '+' + (now - lastCallTime) : '0';
//   lastCallTime = now;
//   msg = (new Date(now)).toISOString() + ' | [' +  type + '] > ' + msg + ' ( ' + diff + ' ms )';
//   return msg;
// }
function formatMsg(type, msg) {
    msg = '[' + type + '] > ' + msg;
    return msg;
}
var global = get_self_scope_1.getSelfScope();
function consolePrintFn(type) {
    var func = global.console[type];
    if (func) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (args[0]) {
                args[0] = formatMsg(type, args[0]);
            }
            func.apply(global.console, args);
        };
    }
    return noop;
}
function exportLoggerFunctions(debugConfig) {
    var functions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        functions[_i - 1] = arguments[_i];
    }
    functions.forEach(function (type) {
        exportedLogger[type] = debugConfig[type] ? debugConfig[type].bind(debugConfig) : consolePrintFn(type);
    });
}
exports.enableLogs = function (debugConfig) {
    if (debugConfig === true || typeof debugConfig === 'object') {
        exportLoggerFunctions(debugConfig, 
        // Remove out from list here to hard-disable a log-level
        // 'trace',
        'debug', 'log', 'info', 'warn', 'error');
        // Some browsers don't allow to use bind on console object anyway
        // fallback to default if needed
        try {
            exportedLogger.log();
        }
        catch (e) {
            exportedLogger = fakeLogger;
        }
    }
    else {
        exportedLogger = fakeLogger;
    }
};
exports.logger = exportedLogger;


/***/ }),

/***/ "./src/utils/mediakeys-helper.js":
/*!***************************************!*\
  !*** ./src/utils/mediakeys-helper.js ***!
  \***************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var requestMediaKeySystemAccess = (function () {
    if (typeof window !== 'undefined' && window.navigator && window.navigator.requestMediaKeySystemAccess) {
        return window.navigator.requestMediaKeySystemAccess.bind(window.navigator);
    }
    else {
        return null;
    }
})();
exports.requestMediaKeySystemAccess = requestMediaKeySystemAccess;


/***/ }),

/***/ "./src/utils/mediasource-helper.js":
/*!*****************************************!*\
  !*** ./src/utils/mediasource-helper.js ***!
  \*****************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * MediaSource helper
 */
Object.defineProperty(exports, "__esModule", { value: true });
function getMediaSource() {
    if (typeof window !== 'undefined') {
        return window.MediaSource || window.WebKitMediaSource;
    }
}
exports.getMediaSource = getMediaSource;


/***/ }),

/***/ "./src/utils/output-filter.js":
/*!************************************!*\
  !*** ./src/utils/output-filter.js ***!
  \************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var OutputFilter = /** @class */ (function () {
    function OutputFilter(timelineController, trackName) {
        this.timelineController = timelineController;
        this.trackName = trackName;
        this.startTime = null;
        this.endTime = null;
        this.screen = null;
    }
    OutputFilter.prototype.dispatchCue = function () {
        if (this.startTime === null) {
            return;
        }
        this.timelineController.addCues(this.trackName, this.startTime, this.endTime, this.screen);
        this.startTime = null;
    };
    OutputFilter.prototype.newCue = function (startTime, endTime, screen) {
        if (this.startTime === null || this.startTime > startTime) {
            this.startTime = startTime;
        }
        this.endTime = endTime;
        this.screen = screen;
        this.timelineController.createCaptionsTrack(this.trackName);
    };
    return OutputFilter;
}());
exports.default = OutputFilter;


/***/ }),

/***/ "./src/utils/texttrack-utils.js":
/*!**************************************!*\
  !*** ./src/utils/texttrack-utils.js ***!
  \**************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function sendAddTrackEvent(track, videoEl) {
    var event = null;
    try {
        event = new window.Event('addtrack');
    }
    catch (err) {
        // for IE11
        event = document.createEvent('Event');
        event.initEvent('addtrack', false, false);
    }
    event.track = track;
    videoEl.dispatchEvent(event);
}
exports.sendAddTrackEvent = sendAddTrackEvent;
function clearCurrentCues(track) {
    if (track && track.cues) {
        while (track.cues.length > 0) {
            track.removeCue(track.cues[0]);
        }
    }
}
exports.clearCurrentCues = clearCurrentCues;


/***/ }),

/***/ "./src/utils/time-ranges.js":
/*!**********************************!*\
  !*** ./src/utils/time-ranges.js ***!
  \**********************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 *  TimeRanges to string helper
 */
Object.defineProperty(exports, "__esModule", { value: true });
var TimeRanges = {
    toString: function (r) {
        var log = '', len = r.length;
        for (var i = 0; i < len; i++) {
            log += '[' + r.start(i).toFixed(3) + ',' + r.end(i).toFixed(3) + ']';
        }
        return log;
    }
};
exports.default = TimeRanges;


/***/ }),

/***/ "./src/utils/vttcue.js":
/*!*****************************!*\
  !*** ./src/utils/vttcue.js ***!
  \*****************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2013 vtt.js Contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function () {
    if (typeof window !== 'undefined' && window.VTTCue) {
        return window.VTTCue;
    }
    var autoKeyword = 'auto';
    var directionSetting = {
        '': true,
        lr: true,
        rl: true
    };
    var alignSetting = {
        start: true,
        middle: true,
        end: true,
        left: true,
        right: true
    };
    function findDirectionSetting(value) {
        if (typeof value !== 'string') {
            return false;
        }
        var dir = directionSetting[value.toLowerCase()];
        return dir ? value.toLowerCase() : false;
    }
    function findAlignSetting(value) {
        if (typeof value !== 'string') {
            return false;
        }
        var align = alignSetting[value.toLowerCase()];
        return align ? value.toLowerCase() : false;
    }
    function extend(obj) {
        var i = 1;
        for (; i < arguments.length; i++) {
            var cobj = arguments[i];
            for (var p in cobj) {
                obj[p] = cobj[p];
            }
        }
        return obj;
    }
    function VTTCue(startTime, endTime, text) {
        var cue = this;
        var isIE8 = (function () {
            if (typeof navigator === 'undefined') {
                return;
            }
            return (/MSIE\s8\.0/).test(navigator.userAgent);
        })();
        var baseObj = {};
        if (isIE8) {
            cue = document.createElement('custom');
        }
        else {
            baseObj.enumerable = true;
        }
        /**
         * Shim implementation specific properties. These properties are not in
         * the spec.
         */
        // Lets us know when the VTTCue's data has changed in such a way that we need
        // to recompute its display state. This lets us compute its display state
        // lazily.
        cue.hasBeenReset = false;
        /**
         * VTTCue and TextTrackCue properties
         * http://dev.w3.org/html5/webvtt/#vttcue-interface
         */
        var _id = '';
        var _pauseOnExit = false;
        var _startTime = startTime;
        var _endTime = endTime;
        var _text = text;
        var _region = null;
        var _vertical = '';
        var _snapToLines = true;
        var _line = 'auto';
        var _lineAlign = 'start';
        var _position = 50;
        var _positionAlign = 'middle';
        var _size = 50;
        var _align = 'middle';
        Object.defineProperty(cue, 'id', extend({}, baseObj, {
            get: function () {
                return _id;
            },
            set: function (value) {
                _id = '' + value;
            }
        }));
        Object.defineProperty(cue, 'pauseOnExit', extend({}, baseObj, {
            get: function () {
                return _pauseOnExit;
            },
            set: function (value) {
                _pauseOnExit = !!value;
            }
        }));
        Object.defineProperty(cue, 'startTime', extend({}, baseObj, {
            get: function () {
                return _startTime;
            },
            set: function (value) {
                if (typeof value !== 'number') {
                    throw new TypeError('Start time must be set to a number.');
                }
                _startTime = value;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'endTime', extend({}, baseObj, {
            get: function () {
                return _endTime;
            },
            set: function (value) {
                if (typeof value !== 'number') {
                    throw new TypeError('End time must be set to a number.');
                }
                _endTime = value;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'text', extend({}, baseObj, {
            get: function () {
                return _text;
            },
            set: function (value) {
                _text = '' + value;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'region', extend({}, baseObj, {
            get: function () {
                return _region;
            },
            set: function (value) {
                _region = value;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'vertical', extend({}, baseObj, {
            get: function () {
                return _vertical;
            },
            set: function (value) {
                var setting = findDirectionSetting(value);
                // Have to check for false because the setting an be an empty string.
                if (setting === false) {
                    throw new SyntaxError('An invalid or illegal string was specified.');
                }
                _vertical = setting;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'snapToLines', extend({}, baseObj, {
            get: function () {
                return _snapToLines;
            },
            set: function (value) {
                _snapToLines = !!value;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'line', extend({}, baseObj, {
            get: function () {
                return _line;
            },
            set: function (value) {
                if (typeof value !== 'number' && value !== autoKeyword) {
                    throw new SyntaxError('An invalid number or illegal string was specified.');
                }
                _line = value;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'lineAlign', extend({}, baseObj, {
            get: function () {
                return _lineAlign;
            },
            set: function (value) {
                var setting = findAlignSetting(value);
                if (!setting) {
                    throw new SyntaxError('An invalid or illegal string was specified.');
                }
                _lineAlign = setting;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'position', extend({}, baseObj, {
            get: function () {
                return _position;
            },
            set: function (value) {
                if (value < 0 || value > 100) {
                    throw new Error('Position must be between 0 and 100.');
                }
                _position = value;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'positionAlign', extend({}, baseObj, {
            get: function () {
                return _positionAlign;
            },
            set: function (value) {
                var setting = findAlignSetting(value);
                if (!setting) {
                    throw new SyntaxError('An invalid or illegal string was specified.');
                }
                _positionAlign = setting;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'size', extend({}, baseObj, {
            get: function () {
                return _size;
            },
            set: function (value) {
                if (value < 0 || value > 100) {
                    throw new Error('Size must be between 0 and 100.');
                }
                _size = value;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'align', extend({}, baseObj, {
            get: function () {
                return _align;
            },
            set: function (value) {
                var setting = findAlignSetting(value);
                if (!setting) {
                    throw new SyntaxError('An invalid or illegal string was specified.');
                }
                _align = setting;
                this.hasBeenReset = true;
            }
        }));
        /**
         * Other <track> spec defined properties
         */
        // http://www.whatwg.org/specs/web-apps/current-work/multipage/the-video-element.html#text-track-cue-display-state
        cue.displayState = undefined;
        if (isIE8) {
            return cue;
        }
    }
    /**
     * VTTCue methods
     */
    VTTCue.prototype.getCueAsHTML = function () {
        // Assume WebVTT.convertCueToDOMTree is on the global.
        var WebVTT = window.WebVTT;
        return WebVTT.convertCueToDOMTree(window, this.text);
    };
    return VTTCue;
})();


/***/ }),

/***/ "./src/utils/vttparser.js":
/*!********************************!*\
  !*** ./src/utils/vttparser.js ***!
  \********************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Source: https://github.com/mozilla/vtt.js/blob/master/dist/vtt.js#L1716
 */
Object.defineProperty(exports, "__esModule", { value: true });
var vttcue_1 = __webpack_require__(/*! ./vttcue */ "./src/utils/vttcue.js");
var StringDecoder = function StringDecoder() {
    return {
        decode: function (data) {
            if (!data) {
                return '';
            }
            if (typeof data !== 'string') {
                throw new Error('Error - expected string data.');
            }
            return decodeURIComponent(encodeURIComponent(data));
        }
    };
};
function VTTParser() {
    this.window = window;
    this.state = 'INITIAL';
    this.buffer = '';
    this.decoder = new StringDecoder();
    this.regionList = [];
}
// Try to parse input as a time stamp.
function parseTimeStamp(input) {
    function computeSeconds(h, m, s, f) {
        return (h | 0) * 3600 + (m | 0) * 60 + (s | 0) + (f | 0) / 1000;
    }
    var m = input.match(/^(\d+):(\d{2})(:\d{2})?\.(\d{3})/);
    if (!m) {
        return null;
    }
    if (m[3]) {
        // Timestamp takes the form of [hours]:[minutes]:[seconds].[milliseconds]
        return computeSeconds(m[1], m[2], m[3].replace(':', ''), m[4]);
    }
    else if (m[1] > 59) {
        // Timestamp takes the form of [hours]:[minutes].[milliseconds]
        // First position is hours as it's over 59.
        return computeSeconds(m[1], m[2], 0, m[4]);
    }
    else {
        // Timestamp takes the form of [minutes]:[seconds].[milliseconds]
        return computeSeconds(0, m[1], m[2], m[4]);
    }
}
// A settings object holds key/value pairs and will ignore anything but the first
// assignment to a specific key.
function Settings() {
    this.values = Object.create(null);
}
Settings.prototype = {
    // Only accept the first assignment to any key.
    set: function (k, v) {
        if (!this.get(k) && v !== '') {
            this.values[k] = v;
        }
    },
    // Return the value for a key, or a default value.
    // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
    // a number of possible default values as properties where 'defaultKey' is
    // the key of the property that will be chosen; otherwise it's assumed to be
    // a single value.
    get: function (k, dflt, defaultKey) {
        if (defaultKey) {
            return this.has(k) ? this.values[k] : dflt[defaultKey];
        }
        return this.has(k) ? this.values[k] : dflt;
    },
    // Check whether we have a value for a key.
    has: function (k) {
        return k in this.values;
    },
    // Accept a setting if its one of the given alternatives.
    alt: function (k, v, a) {
        for (var n = 0; n < a.length; ++n) {
            if (v === a[n]) {
                this.set(k, v);
                break;
            }
        }
    },
    // Accept a setting if its a valid (signed) integer.
    integer: function (k, v) {
        if (/^-?\d+$/.test(v)) { // integer
            this.set(k, parseInt(v, 10));
        }
    },
    // Accept a setting if its a valid percentage.
    percent: function (k, v) {
        var m;
        if ((m = v.match(/^([\d]{1,3})(\.[\d]*)?%$/))) {
            v = parseFloat(v);
            if (v >= 0 && v <= 100) {
                this.set(k, v);
                return true;
            }
        }
        return false;
    }
};
// Helper function to parse input into groups separated by 'groupDelim', and
// interprete each group as a key/value pair separated by 'keyValueDelim'.
function parseOptions(input, callback, keyValueDelim, groupDelim) {
    var groups = groupDelim ? input.split(groupDelim) : [input];
    for (var i in groups) {
        if (typeof groups[i] !== 'string') {
            continue;
        }
        var kv = groups[i].split(keyValueDelim);
        if (kv.length !== 2) {
            continue;
        }
        var k = kv[0];
        var v = kv[1];
        callback(k, v);
    }
}
var defaults = new vttcue_1.default(0, 0, 0);
// 'middle' was changed to 'center' in the spec: https://github.com/w3c/webvtt/pull/244
//  Safari doesn't yet support this change, but FF and Chrome do.
var center = defaults.align === 'middle' ? 'middle' : 'center';
function parseCue(input, cue, regionList) {
    // Remember the original input if we need to throw an error.
    var oInput = input;
    // 4.1 WebVTT timestamp
    function consumeTimeStamp() {
        var ts = parseTimeStamp(input);
        if (ts === null) {
            throw new Error('Malformed timestamp: ' + oInput);
        }
        // Remove time stamp from input.
        input = input.replace(/^[^\sa-zA-Z-]+/, '');
        return ts;
    }
    // 4.4.2 WebVTT cue settings
    function consumeCueSettings(input, cue) {
        var settings = new Settings();
        parseOptions(input, function (k, v) {
            switch (k) {
                case 'region':
                    // Find the last region we parsed with the same region id.
                    for (var i = regionList.length - 1; i >= 0; i--) {
                        if (regionList[i].id === v) {
                            settings.set(k, regionList[i].region);
                            break;
                        }
                    }
                    break;
                case 'vertical':
                    settings.alt(k, v, ['rl', 'lr']);
                    break;
                case 'line':
                    var vals = v.split(','), vals0 = vals[0];
                    settings.integer(k, vals0);
                    if (settings.percent(k, vals0)) {
                        settings.set('snapToLines', false);
                    }
                    settings.alt(k, vals0, ['auto']);
                    if (vals.length === 2) {
                        settings.alt('lineAlign', vals[1], ['start', center, 'end']);
                    }
                    break;
                case 'position':
                    vals = v.split(',');
                    settings.percent(k, vals[0]);
                    if (vals.length === 2) {
                        settings.alt('positionAlign', vals[1], ['start', center, 'end', 'line-left', 'line-right', 'auto']);
                    }
                    break;
                case 'size':
                    settings.percent(k, v);
                    break;
                case 'align':
                    settings.alt(k, v, ['start', center, 'end', 'left', 'right']);
                    break;
            }
        }, /:/, /\s/);
        // Apply default values for any missing fields.
        cue.region = settings.get('region', null);
        cue.vertical = settings.get('vertical', '');
        var line = settings.get('line', 'auto');
        if (line === 'auto' && defaults.line === -1) {
            // set numeric line number for Safari
            line = -1;
        }
        cue.line = line;
        cue.lineAlign = settings.get('lineAlign', 'start');
        cue.snapToLines = settings.get('snapToLines', true);
        cue.size = settings.get('size', 100);
        cue.align = settings.get('align', center);
        var position = settings.get('position', 'auto');
        if (position === 'auto' && defaults.position === 50) {
            // set numeric position for Safari
            position = cue.align === 'start' || cue.align === 'left' ? 0 : cue.align === 'end' || cue.align === 'right' ? 100 : 50;
        }
        cue.position = position;
    }
    function skipWhitespace() {
        input = input.replace(/^\s+/, '');
    }
    // 4.1 WebVTT cue timings.
    skipWhitespace();
    cue.startTime = consumeTimeStamp(); // (1) collect cue start time
    skipWhitespace();
    if (input.substr(0, 3) !== '-->') { // (3) next characters must match '-->'
        throw new Error('Malformed time stamp (time stamps must be separated by \'-->\'): ' +
            oInput);
    }
    input = input.substr(3);
    skipWhitespace();
    cue.endTime = consumeTimeStamp(); // (5) collect cue end time
    // 4.1 WebVTT cue settings list.
    skipWhitespace();
    consumeCueSettings(input, cue);
}
function fixLineBreaks(input) {
    return input.replace(/<br(?: \/)?>/gi, '\n');
}
exports.fixLineBreaks = fixLineBreaks;
VTTParser.prototype = {
    parse: function (data) {
        var self = this;
        // If there is no data then we won't decode it, but will just try to parse
        // whatever is in buffer already. This may occur in circumstances, for
        // example when flush() is called.
        if (data) {
            // Try to decode the data that we received.
            self.buffer += self.decoder.decode(data, { stream: true });
        }
        function collectNextLine() {
            var buffer = self.buffer;
            var pos = 0;
            buffer = fixLineBreaks(buffer);
            while (pos < buffer.length && buffer[pos] !== '\r' && buffer[pos] !== '\n') {
                ++pos;
            }
            var line = buffer.substr(0, pos);
            // Advance the buffer early in case we fail below.
            if (buffer[pos] === '\r') {
                ++pos;
            }
            if (buffer[pos] === '\n') {
                ++pos;
            }
            self.buffer = buffer.substr(pos);
            return line;
        }
        // 3.2 WebVTT metadata header syntax
        function parseHeader(input) {
            parseOptions(input, function (k, v) {
                switch (k) {
                    case 'Region':
                        // 3.3 WebVTT region metadata header syntax
                        // console.log('parse region', v);
                        // parseRegion(v);
                        break;
                }
            }, /:/);
        }
        // 5.1 WebVTT file parsing.
        try {
            var line = void 0;
            if (self.state === 'INITIAL') {
                // We can't start parsing until we have the first line.
                if (!/\r\n|\n/.test(self.buffer)) {
                    return this;
                }
                line = collectNextLine();
                // strip of UTF-8 BOM if any
                // https://en.wikipedia.org/wiki/Byte_order_mark#UTF-8
                var m = line.match(/^(ï»¿)?WEBVTT([ \t].*)?$/);
                if (!m || !m[0]) {
                    throw new Error('Malformed WebVTT signature.');
                }
                self.state = 'HEADER';
            }
            var alreadyCollectedLine = false;
            while (self.buffer) {
                // We can't parse a line until we have the full line.
                if (!/\r\n|\n/.test(self.buffer)) {
                    return this;
                }
                if (!alreadyCollectedLine) {
                    line = collectNextLine();
                }
                else {
                    alreadyCollectedLine = false;
                }
                switch (self.state) {
                    case 'HEADER':
                        // 13-18 - Allow a header (metadata) under the WEBVTT line.
                        if (/:/.test(line)) {
                            parseHeader(line);
                        }
                        else if (!line) {
                            // An empty line terminates the header and starts the body (cues).
                            self.state = 'ID';
                        }
                        continue;
                    case 'NOTE':
                        // Ignore NOTE blocks.
                        if (!line) {
                            self.state = 'ID';
                        }
                        continue;
                    case 'ID':
                        // Check for the start of NOTE blocks.
                        if (/^NOTE($|[ \t])/.test(line)) {
                            self.state = 'NOTE';
                            break;
                        }
                        // 19-29 - Allow any number of line terminators, then initialize new cue values.
                        if (!line) {
                            continue;
                        }
                        self.cue = new vttcue_1.default(0, 0, '');
                        self.state = 'CUE';
                        // 30-39 - Check if self line contains an optional identifier or timing data.
                        if (line.indexOf('-->') === -1) {
                            self.cue.id = line;
                            continue;
                        }
                    // Process line as start of a cue.
                    /* falls through */
                    case 'CUE':
                        // 40 - Collect cue timings and settings.
                        try {
                            parseCue(line, self.cue, self.regionList);
                        }
                        catch (e) {
                            // In case of an error ignore rest of the cue.
                            self.cue = null;
                            self.state = 'BADCUE';
                            continue;
                        }
                        self.state = 'CUETEXT';
                        continue;
                    case 'CUETEXT':
                        var hasSubstring = line.indexOf('-->') !== -1;
                        // 34 - If we have an empty line then report the cue.
                        // 35 - If we have the special substring '-->' then report the cue,
                        // but do not collect the line as we need to process the current
                        // one as a new cue.
                        if (!line || hasSubstring && (alreadyCollectedLine = true)) {
                            // We are done parsing self cue.
                            if (self.oncue) {
                                self.oncue(self.cue);
                            }
                            self.cue = null;
                            self.state = 'ID';
                            continue;
                        }
                        if (self.cue.text) {
                            self.cue.text += '\n';
                        }
                        self.cue.text += line;
                        continue;
                    case 'BADCUE': // BADCUE
                        // 54-62 - Collect and discard the remaining cue.
                        if (!line) {
                            self.state = 'ID';
                        }
                        continue;
                }
            }
        }
        catch (e) {
            // If we are currently parsing a cue, report what we have.
            if (self.state === 'CUETEXT' && self.cue && self.oncue) {
                self.oncue(self.cue);
            }
            self.cue = null;
            // Enter BADWEBVTT state if header was not parsed correctly otherwise
            // another exception occurred so enter BADCUE state.
            self.state = self.state === 'INITIAL' ? 'BADWEBVTT' : 'BADCUE';
        }
        return this;
    },
    flush: function () {
        var self = this;
        try {
            // Finish decoding the stream.
            self.buffer += self.decoder.decode();
            // Synthesize the end of the current cue or region.
            if (self.cue || self.state === 'HEADER') {
                self.buffer += '\n\n';
                self.parse();
            }
            // If we've flushed, parsed, and we're still on the INITIAL state then
            // that means we don't have enough of the stream to parse the first
            // line.
            if (self.state === 'INITIAL') {
                throw new Error('Malformed WebVTT signature.');
            }
        }
        catch (e) {
            throw e;
        }
        if (self.onflush) {
            self.onflush();
        }
        return this;
    }
};
exports.default = VTTParser;


/***/ }),

/***/ "./src/utils/webvtt-parser.js":
/*!************************************!*\
  !*** ./src/utils/webvtt-parser.js ***!
  \************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Number) {
Object.defineProperty(exports, "__esModule", { value: true });
var vttparser_1 = __webpack_require__(/*! ./vttparser */ "./src/utils/vttparser.js");
var id3_1 = __webpack_require__(/*! ../demux/id3 */ "./src/demux/id3.js");
// String.prototype.startsWith is not supported in IE11
var startsWith = function (inputString, searchString, position) {
    return inputString.substr(position || 0, searchString.length) === searchString;
};
var cueString2millis = function (timeString) {
    var ts = parseInt(timeString.substr(-3));
    var secs = parseInt(timeString.substr(-6, 2));
    var mins = parseInt(timeString.substr(-9, 2));
    var hours = timeString.length > 9 ? parseInt(timeString.substr(0, timeString.indexOf(':'))) : 0;
    if (!Number.isFinite(ts) || !Number.isFinite(secs) || !Number.isFinite(mins) || !Number.isFinite(hours)) {
        return -1;
    }
    ts += 1000 * secs;
    ts += 60 * 1000 * mins;
    ts += 60 * 60 * 1000 * hours;
    return ts;
};
// From https://github.com/darkskyapp/string-hash
var hash = function (text) {
    var hash = 5381;
    var i = text.length;
    while (i) {
        hash = (hash * 33) ^ text.charCodeAt(--i);
    }
    return (hash >>> 0).toString();
};
var calculateOffset = function (vttCCs, cc, presentationTime) {
    var currCC = vttCCs[cc];
    var prevCC = vttCCs[currCC.prevCC];
    // This is the first discontinuity or cues have been processed since the last discontinuity
    // Offset = current discontinuity time
    if (!prevCC || (!prevCC.new && currCC.new)) {
        vttCCs.ccOffset = vttCCs.presentationOffset = currCC.start;
        currCC.new = false;
        return;
    }
    // There have been discontinuities since cues were last parsed.
    // Offset = time elapsed
    while (prevCC && prevCC.new) {
        vttCCs.ccOffset += currCC.start - prevCC.start;
        currCC.new = false;
        currCC = prevCC;
        prevCC = vttCCs[currCC.prevCC];
    }
    vttCCs.presentationOffset = presentationTime;
};
var WebVTTParser = {
    parse: function (vttByteArray, syncPTS, vttCCs, cc, callBack, errorCallBack) {
        // Convert byteArray into string, replacing any somewhat exotic linefeeds with "\n", then split on that character.
        var re = /\r\n|\n\r|\n|\r/g;
        // Uint8Array.prototype.reduce is not implemented in IE11
        var vttLines = id3_1.utf8ArrayToStr(new Uint8Array(vttByteArray)).trim().replace(re, '\n').split('\n');
        var cueTime = '00:00.000';
        var mpegTs = 0;
        var localTime = 0;
        var presentationTime = 0;
        var cues = [];
        var parsingError;
        var inHeader = true;
        // let VTTCue = VTTCue || window.TextTrackCue;
        // Create parser object using VTTCue with TextTrackCue fallback on certain browsers.
        var parser = new vttparser_1.default();
        parser.oncue = function (cue) {
            // Adjust cue timing; clamp cues to start no earlier than - and drop cues that don't end after - 0 on timeline.
            var currCC = vttCCs[cc];
            var cueOffset = vttCCs.ccOffset;
            // Update offsets for new discontinuities
            if (currCC && currCC.new) {
                if (localTime !== undefined) {
                    // When local time is provided, offset = discontinuity start time - local time
                    cueOffset = vttCCs.ccOffset = currCC.start;
                }
                else {
                    calculateOffset(vttCCs, cc, presentationTime);
                }
            }
            if (presentationTime) {
                // If we have MPEGTS, offset = presentation time + discontinuity offset
                cueOffset = presentationTime - vttCCs.presentationOffset;
            }
            cue.startTime += cueOffset - localTime;
            cue.endTime += cueOffset - localTime;
            // Create a unique hash id for a cue based on start/end times and text.
            // This helps timeline-controller to avoid showing repeated captions.
            cue.id = hash(cue.startTime.toString()) + hash(cue.endTime.toString()) + hash(cue.text);
            // Fix encoding of special characters. TODO: Test with all sorts of weird characters.
            cue.text = decodeURIComponent(encodeURIComponent(cue.text));
            if (cue.endTime > 0) {
                cues.push(cue);
            }
        };
        parser.onparsingerror = function (e) {
            parsingError = e;
        };
        parser.onflush = function () {
            if (parsingError && errorCallBack) {
                errorCallBack(parsingError);
                return;
            }
            callBack(cues);
        };
        // Go through contents line by line.
        vttLines.forEach(function (line) {
            if (inHeader) {
                // Look for X-TIMESTAMP-MAP in header.
                if (startsWith(line, 'X-TIMESTAMP-MAP=')) {
                    // Once found, no more are allowed anyway, so stop searching.
                    inHeader = false;
                    // Extract LOCAL and MPEGTS.
                    line.substr(16).split(',').forEach(function (timestamp) {
                        if (startsWith(timestamp, 'LOCAL:')) {
                            cueTime = timestamp.substr(6);
                        }
                        else if (startsWith(timestamp, 'MPEGTS:')) {
                            mpegTs = parseInt(timestamp.substr(7));
                        }
                    });
                    try {
                        // Calculate subtitle offset in milliseconds.
                        if (syncPTS + ((vttCCs[cc].start * 90000) || 0) < 0) {
                            syncPTS += 8589934592;
                        }
                        // Adjust MPEGTS by sync PTS.
                        mpegTs -= syncPTS;
                        // Convert cue time to seconds
                        localTime = cueString2millis(cueTime) / 1000;
                        // Convert MPEGTS to seconds from 90kHz.
                        presentationTime = mpegTs / 90000;
                        if (localTime === -1) {
                            parsingError = new Error("Malformed X-TIMESTAMP-MAP: " + line);
                        }
                    }
                    catch (e) {
                        parsingError = new Error("Malformed X-TIMESTAMP-MAP: " + line);
                    }
                    // Return without parsing X-TIMESTAMP-MAP line.
                    return;
                }
                else if (line === '') {
                    inHeader = false;
                }
            }
            // Parse line by default.
            parser.parse(line + '\n');
        });
        parser.flush();
    }
};
exports.default = WebVTTParser;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./src/polyfills/number */ "./src/polyfills/number.js")["Number"]))

/***/ }),

/***/ "./src/utils/xhr-loader.js":
/*!*********************************!*\
  !*** ./src/utils/xhr-loader.js ***!
  \*********************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * XHR based logger
*/
Object.defineProperty(exports, "__esModule", { value: true });
var logger_1 = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
var performance = window.performance, XMLHttpRequest = window.XMLHttpRequest;
var XhrLoader = /** @class */ (function () {
    function XhrLoader(config) {
        if (config && config.xhrSetup) {
            this.xhrSetup = config.xhrSetup;
        }
    }
    XhrLoader.prototype.destroy = function () {
        this.abort();
        this.loader = null;
    };
    XhrLoader.prototype.abort = function () {
        var loader = this.loader;
        if (loader && loader.readyState !== 4) {
            this.stats.aborted = true;
            loader.abort();
        }
        window.clearTimeout(this.requestTimeout);
        this.requestTimeout = null;
        window.clearTimeout(this.retryTimeout);
        this.retryTimeout = null;
    };
    XhrLoader.prototype.load = function (context, config, callbacks) {
        this.context = context;
        this.config = config;
        this.callbacks = callbacks;
        this.stats = { trequest: performance.now(), retry: 0 };
        this.retryDelay = config.retryDelay;
        this.loadInternal();
    };
    XhrLoader.prototype.loadInternal = function () {
        var xhr, context = this.context;
        xhr = this.loader = new XMLHttpRequest();
        var stats = this.stats;
        stats.tfirst = 0;
        stats.loaded = 0;
        var xhrSetup = this.xhrSetup;
        try {
            if (xhrSetup) {
                try {
                    xhrSetup(xhr, context.url);
                }
                catch (e) {
                    // fix xhrSetup: (xhr, url) => {xhr.setRequestHeader("Content-Language", "test");}
                    // not working, as xhr.setRequestHeader expects xhr.readyState === OPEN
                    xhr.open('GET', context.url, true);
                    xhrSetup(xhr, context.url);
                }
            }
            if (!xhr.readyState) {
                xhr.open('GET', context.url, true);
            }
        }
        catch (e) {
            // IE11 throws an exception on xhr.open if attempting to access an HTTP resource over HTTPS
            this.callbacks.onError({ code: xhr.status, text: e.message }, context, xhr);
            return;
        }
        if (context.rangeEnd) {
            xhr.setRequestHeader('Range', 'bytes=' + context.rangeStart + '-' + (context.rangeEnd - 1));
        }
        xhr.onreadystatechange = this.readystatechange.bind(this);
        xhr.onprogress = this.loadprogress.bind(this);
        xhr.responseType = context.responseType;
        // setup timeout before we perform request
        this.requestTimeout = window.setTimeout(this.loadtimeout.bind(this), this.config.timeout);
        xhr.send();
    };
    XhrLoader.prototype.readystatechange = function (event) {
        var xhr = event.currentTarget, readyState = xhr.readyState, stats = this.stats, context = this.context, config = this.config;
        // don't proceed if xhr has been aborted
        if (stats.aborted) {
            return;
        }
        // >= HEADERS_RECEIVED
        if (readyState >= 2) {
            // clear xhr timeout and rearm it if readyState less than 4
            window.clearTimeout(this.requestTimeout);
            if (stats.tfirst === 0) {
                stats.tfirst = Math.max(performance.now(), stats.trequest);
            }
            if (readyState === 4) {
                var status_1 = xhr.status;
                // http status between 200 to 299 are all successful
                if (status_1 >= 200 && status_1 < 300) {
                    stats.tload = Math.max(stats.tfirst, performance.now());
                    var data = void 0, len = void 0;
                    if (context.responseType === 'arraybuffer') {
                        data = xhr.response;
                        len = data.byteLength;
                    }
                    else {
                        data = xhr.responseText;
                        len = data.length;
                    }
                    stats.loaded = stats.total = len;
                    var response = { url: xhr.responseURL, data: data };
                    this.callbacks.onSuccess(response, stats, context, xhr);
                }
                else {
                    // if max nb of retries reached or if http status between 400 and 499 (such error cannot be recovered, retrying is useless), return error
                    if (stats.retry >= config.maxRetry || (status_1 >= 400 && status_1 < 499)) {
                        logger_1.logger.error(status_1 + " while loading " + context.url);
                        this.callbacks.onError({ code: status_1, text: xhr.statusText }, context, xhr);
                    }
                    else {
                        // retry
                        logger_1.logger.warn(status_1 + " while loading " + context.url + ", retrying in " + this.retryDelay + "...");
                        // aborts and resets internal state
                        this.destroy();
                        // schedule retry
                        this.retryTimeout = window.setTimeout(this.loadInternal.bind(this), this.retryDelay);
                        // set exponential backoff
                        this.retryDelay = Math.min(2 * this.retryDelay, config.maxRetryDelay);
                        stats.retry++;
                    }
                }
            }
            else {
                // readyState >= 2 AND readyState !==4 (readyState = HEADERS_RECEIVED || LOADING) rearm timeout as xhr not finished yet
                this.requestTimeout = window.setTimeout(this.loadtimeout.bind(this), config.timeout);
            }
        }
    };
    XhrLoader.prototype.loadtimeout = function () {
        logger_1.logger.warn("timeout while loading " + this.context.url);
        this.callbacks.onTimeout(this.stats, this.context, null);
    };
    XhrLoader.prototype.loadprogress = function (event) {
        var xhr = event.currentTarget, stats = this.stats;
        stats.loaded = event.loaded;
        if (event.lengthComputable) {
            stats.total = event.total;
        }
        var onProgress = this.callbacks.onProgress;
        if (onProgress) {
            // third arg is to provide on progress data
            onProgress(stats, this.context, null, xhr);
        }
    };
    return XhrLoader;
}());
exports.default = XhrLoader;


/***/ })

/******/ })["default"];
});


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(9),__webpack_require__(137)):"function"==typeof define&&define.amd?define("dash",["pakhshkit-js","shaka-player"],t):"object"==typeof exports?exports.dash=t(require("@pakhshkit-js/pakhshkit-js"),require("shaka-player")):(e.pakhshkit=e.pakhshkit||{},e.pakhshkit.dash=t(e.pakhshkit.core,e.shaka))}(this,function(e,t){return function(e){function t(n){if(r[n])return r[n].exports;var i=r[n]={i:n,l:!1,exports:{}};return e[n].call(i.exports,i,i.exports,t),i.l=!0,i.exports}var r={};return t.m=e,t.c=r,t.d=function(e,r,n){t.o(e,r)||Object.defineProperty(e,r,{configurable:!1,enumerable:!0,get:n})},t.n=function(e){var r=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(r,"a",r),r},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=2)}([function(t,r){t.exports=e},function(e,r){e.exports=t},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.NAME=t.VERSION=void 0;var n=r(0),i=r(3),a=function(e){return e&&e.__esModule?e:{default:e}}(i);t.default=a.default,t.VERSION="1.10.1",t.NAME="@pakhshkit-js/pakhshkit-js-dash",a.default.isSupported()&&(0,n.registerMediaSourceAdapter)(a.default)},function(e,t,r){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function i(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var u=function e(t,r,n){null===t&&(t=Function.prototype);var i=Object.getOwnPropertyDescriptor(t,r);if(void 0===i){var a=Object.getPrototypeOf(t);return null===a?void 0:e(a,r,n)}if("value"in i)return i.value;var o=i.get;if(void 0!==o)return o.call(n)},c=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),l=r(1),d=n(l),f=r(0),h=r(4),p=n(h),_=r(5),g=n(_),v=r(6),y=n(v),b=r(7),k=n(b),m={ERROR:"error",ADAPTATION:"adaptation",BUFFERING:"buffering"},E=function(e){function t(e,r){var n,s=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};a(this,t),t._logger.debug("Creating adapter. Shaka version: "+d.default.Player.version);var u=o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e,r,s));return u._adapterEventsBindings=(n={},i(n,m.ERROR,function(e){return u._onError(e)}),i(n,m.ADAPTATION,function(){return u._onAdaptation()}),i(n,m.BUFFERING,function(e){return u._onBuffering(e)}),i(n,f.EventType.WAITING,function(){return u._onWaiting()}),i(n,f.EventType.PLAYING,function(){return u._onPlaying()}),n),u._buffering=!1,u._waitingSent=!1,u._playingSent=!1,u._videoSizeUpdateTimer=null,u.VIDEO_ERROR_CODE=3016,u._setShakaConfig(),u}return s(t,e),c(t,[{key:"setMaxBitrate",value:function(e){this._hasLowerOrEqualBitrate(e)&&this._shaka.configure({abr:{restrictions:{maxBandwidth:e}}})}},{key:"_getSortedTracks",value:function(){return this._shaka.getVariantTracks().map(function(e){return{id:e.id,bandwidth:e.bandwidth,active:e.active}}).sort(function(e,t){return e.bandwidth-t.bandwidth})}},{key:"_hasLowerOrEqualBitrate",value:function(e){return this._getSortedTracks()[0].bandwidth<=e}}],[{key:"createAdapter",value:function(e,t,r){var n=f.Utils.Object.copyDeep(y.default);if(f.Utils.Object.hasPropertyPath(r,"playback.useNativeTextTrack")&&(n.textTrackVisibile=f.Utils.Object.getPropertyPath(r,"playback.useNativeTextTrack")),f.Utils.Object.hasPropertyPath(r,"sources.options")){var i=r.sources.options;n.forceRedirectExternalStreams=i.forceRedirectExternalStreams,n.redirectExternalStreamsHandler=i.redirectExternalStreamsHandler,n.redirectExternalStreamsTimeout=i.redirectExternalStreamsTimeout}if(f.Utils.Object.hasPropertyPath(r,"abr")){var a=r.abr;"boolean"==typeof a.enabled&&(n.shakaConfig.abr.enabled=a.enabled),"boolean"==typeof a.capLevelToPlayerSize&&(n.capLevelToPlayerSize=a.capLevelToPlayerSize),a.defaultBandwidthEstimate&&(n.shakaConfig.abr.defaultBandwidthEstimate=a.defaultBandwidthEstimate),a.restrictions&&(a.restrictions.minBitrate>0&&(n.shakaConfig.abr.restrictions.minBandwidth=a.restrictions.minBitrate),a.restrictions.maxBitrate<1/0&&(n.capLevelToPlayerSize=!1,n.shakaConfig.abr.restrictions.maxBandwidth=a.restrictions.maxBitrate))}return f.Utils.Object.hasPropertyPath(r,"playback.options.html5.dash")&&f.Utils.Object.mergeDeep(n.shakaConfig,r.playback.options.html5.dash),new this(e,t,n)}},{key:"canPlayType",value:function(e){var r="string"==typeof e&&e.toLowerCase()===t._dashMimeType;return t._logger.debug("canPlayType result for mimeType: "+e+" is "+r.toString()),r}},{key:"canPlayDrm",value:function(e,r){var n=!1,i=!0,a=!1,o=void 0;try{for(var s,u=t._drmProtocols[Symbol.iterator]();!(i=(s=u.next()).done);i=!0){var c=s.value;if(c.isConfigured(e,r)){t._drmProtocol=c,n=!0;break}}}catch(e){a=!0,o=e}finally{try{!i&&u.return&&u.return()}finally{if(a)throw o}}if(!n){var l=!0,d=!1,f=void 0;try{for(var h,p=t._drmProtocols[Symbol.iterator]();!(l=(h=p.next()).done);l=!0){var _=h.value;if(_.canPlayDrm(e)){t._drmProtocol=_,n=!0;break}}}catch(e){d=!0,f=e}finally{try{!l&&p.return&&p.return()}finally{if(d)throw f}}}return t._logger.debug("canPlayDrm result is "+n.toString(),e),n}},{key:"isSupported",value:function(){var e=!1;window.VTTCue||(e=!0),d.default.polyfill.installAll();var r=d.default.Player.isBrowserSupported();return e&&(window.VTTCue=void 0),t._logger.debug("isSupported:"+r),r}}]),c(t,[{key:"_setShakaConfig",value:function(){var e={shakaConfig:{textDisplayFactory:function(e){return new k.default(e)}.bind(null,this._videoElement)}};this._config=f.Utils.Object.mergeDeep(e,y.default,this._config)}},{key:"_init",value:function(){d.default.polyfill.installAll(),this._shaka=new d.default.Player(this._videoElement),this._maybeSetDrmConfig(),this._shaka.configure(this._config.shakaConfig),this._addBindings()}},{key:"_maybeGetRedirectedUrl",value:function(e){var t=this._config.forceRedirectExternalStreams,r=this._config.redirectExternalStreamsTimeout,n=this._config.redirectExternalStreamsHandler;return new Promise(function(i){if(!t)return i(e);f.Utils.Http.jsonp(e,n,{timeout:r}).then(function(e){i(e)}).catch(function(){return i(e)})})}},{key:"_maybeSetDrmConfig",value:function(){t._drmProtocol&&this._sourceObj&&this._sourceObj.drmData&&t._drmProtocol.setDrmPlayback(this._config.shakaConfig,this._sourceObj.drmData)}},{key:"_maybeApplyAbrRestrictions",value:function(){var e=this;if(this._config.capLevelToPlayerSize){var r=this._getVideoTracks(),n=function(e){return Math.min.apply(null,r.map(function(t){return t[e]}))},i=n("width"),a=n("height"),o=function(){var r=e._videoHeight,n=e._videoWidth;"number"==typeof n&&"number"==typeof r&&(r>=a&&n>=i?(t._logger.debug("applying dimension restriction: width < "+n+", height < "+r),e._shaka.configure({abr:{restrictions:{maxHeight:r,maxWidth:n}}})):(t._logger.debug("applying dimension restriction: width < "+a+", height < "+i),e._shaka.configure({abr:{restrictions:{maxHeight:a,maxWidth:i}}})))};this._clearVideoUpdateTimer(),this._videoSizeUpdateTimer=setInterval(o,1e3),o()}}},{key:"_clearVideoUpdateTimer",value:function(){this._videoSizeUpdateTimer&&(clearInterval(this._videoSizeUpdateTimer),this._videoSizeUpdateTimer=null)}},{key:"_addBindings",value:function(){this._shaka.addEventListener(m.ADAPTATION,this._adapterEventsBindings.adaptation),this._shaka.addEventListener(m.ERROR,this._adapterEventsBindings.error),this._shaka.addEventListener(m.BUFFERING,this._adapterEventsBindings.buffering),this._videoElement.addEventListener(f.EventType.WAITING,this._adapterEventsBindings.waiting),this._videoElement.addEventListener(f.EventType.PLAYING,this._adapterEventsBindings.playing)}},{key:"_removeBindings",value:function(){this._shaka.removeEventListener(m.ADAPTATION,this._adapterEventsBindings.adaptation),this._shaka.removeEventListener(m.ERROR,this._adapterEventsBindings.error),this._shaka.removeEventListener(m.BUFFERING,this._adapterEventsBindings.buffering),this._videoElement.removeEventListener(f.EventType.WAITING,this._adapterEventsBindings.waiting),this._videoElement.removeEventListener(f.EventType.PLAYING,this._adapterEventsBindings.playing)}},{key:"load",value:function(e){var r=this;return this._loadPromise||(this._init(),this._loadPromise=new Promise(function(n,i){if(r._sourceObj&&r._sourceObj.url){r._trigger(f.EventType.ABR_MODE_CHANGED,{mode:r.isAdaptiveBitrateEnabled()?"auto":"manual"});var a=e&&e>-1?e:void 0;r._maybeGetRedirectedUrl(r._sourceObj.url).then(function(e){return r._shaka.load(e,a)}).then(function(){var e={tracks:r._getParsedTracks()};r._maybeApplyAbrRestrictions(),t._logger.debug("The source has been loaded successfully"),n(e)}).catch(function(e){i(new f.Error(e.severity,e.category,e.code,e.data))})}})),this._loadPromise}},{key:"destroy",value:function(){var e=this;return u(t.prototype.__proto__||Object.getPrototypeOf(t.prototype),"destroy",this).call(this).then(function(){if(t._logger.debug("destroy"),e._clearVideoUpdateTimer(),e._loadPromise=null,e._buffering=!1,e._waitingSent=!1,e._playingSent=!1,e._shaka)return e._removeBindings(),e._adapterEventsBindings={},e._shaka.destroy()})}},{key:"_getVideoTracks",value:function(){var e=this._shaka.getVariantTracks(),t=e.filter(function(e){return e.active})[0];return e.filter(function(e){return e.audioId===t.audioId})}},{key:"_getAudioTracks",value:function(){var e=this._shaka.getVariantTracks(),t=this._shaka.getAudioLanguagesAndRoles();return t.forEach(function(t){var r=e.filter(function(e){return e.language===t.language}),n=r.map(function(e){return e.id}).join("_"),i=r.some(function(e){return e.active});t.id=n,t.label=r[0].label,t.active=i}),t}},{key:"_getParsedTracks",value:function(){if(this._shaka){var e=this._getParsedVideoTracks(),t=this._getParsedAudioTracks(),r=this._getParsedTextTracks();return e.concat(t).concat(r)}return[]}},{key:"_getParsedVideoTracks",value:function(){var e=this._getVideoTracks(),t=[];if(e)for(var r=0;r<e.length;r++){var n={id:e[r].id,bandwidth:e[r].bandwidth,width:e[r].width,height:e[r].height,active:e[r].active,index:r};t.push(new f.VideoTrack(n))}return t}},{key:"_getParsedAudioTracks",value:function(){var e=this._getAudioTracks(),t=[];if(e)for(var r=0;r<e.length;r++){var n={id:e[r].id,active:e[r].active,label:e[r].label,language:e[r].language,index:r};t.push(new f.AudioTrack(n))}return t}},{key:"_getParsedTextTracks",value:function(){var e=this._shaka.getTextTracks(),t=[];if(e)for(var r=0;r<e.length;r++){var n={kind:e[r].kind?e[r].kind+"s":"",active:!1,label:e[r].label,language:e[r].language,index:r};t.push(new f.TextTrack(n))}return t}},{key:"selectVideoTrack",value:function(e){if(this._shaka){var t=this._getVideoTracks();if(e instanceof f.VideoTrack&&t){var r=t[e.index];r&&(this.isAdaptiveBitrateEnabled()&&(this._shaka.configure({abr:{enabled:!1}}),this._trigger(f.EventType.ABR_MODE_CHANGED,{mode:"manual"})),r.active||(this._shaka.selectVariantTrack(t[e.index],!0),this._onTrackChanged(e)))}}}},{key:"selectAudioTrack",value:function(e){this._shaka&&e instanceof f.AudioTrack&&!e.active&&(this._shaka.selectAudioLanguage(e.language),this._onTrackChanged(e))}},{key:"selectTextTrack",value:function(e){this._shaka&&e instanceof f.TextTrack&&!e.active&&("subtitles"===e.kind||"captions"===e.kind)&&(this._shaka.setTextTrackVisibility(this._config.textTrackVisibile),this._shaka.selectTextLanguage(e.language),this._onTrackChanged(e))}},{key:"hideTextTrack",value:function(){this._shaka&&this._shaka.setTextTrackVisibility(!1)}},{key:"enableAdaptiveBitrate",value:function(){this._shaka&&!this.isAdaptiveBitrateEnabled()&&(this._trigger(f.EventType.ABR_MODE_CHANGED,{mode:"auto"}),this._shaka.configure({abr:{enabled:!0}}))}},{key:"isAdaptiveBitrateEnabled",value:function(){if(this._shaka){return this._shaka.getConfiguration().abr.enabled}return!1}},{key:"_getLiveEdge",value:function(){return this._shaka?this._shaka.seekRange().end:NaN}},{key:"seekToLiveEdge",value:function(){this._shaka&&this._videoElement.readyState>0&&(this._videoElement.currentTime=this._shaka.seekRange().end)}},{key:"isLive",value:function(){return!!this._shaka&&this._shaka.isLive()}},{key:"_onAdaptation",value:function(){var e=this._getParsedVideoTracks().filter(function(e){return e.active})[0];t._logger.debug("Video track changed",e),this._onTrackChanged(e)}},{key:"_onError",value:function(e){if(e&&e.detail){var r=e.detail;if(r.code===this.VIDEO_ERROR_CODE)return;this._trigger(f.EventType.ERROR,new f.Error(r.severity,r.category,r.code,r.data)),t._logger.error(r)}}},{key:"_onBuffering",value:function(e){e.buffering?this._waitingSent||(this._videoElement.dispatchEvent(new window.Event(f.EventType.WAITING)),this._buffering=!0):(this._buffering=!1,this._videoElement.paused||this._playingSent||this._videoElement.dispatchEvent(new window.Event(f.EventType.PLAYING)))}},{key:"_onWaiting",value:function(){this._waitingSent=!0,this._playingSent=!1}},{key:"_onPlaying",value:function(){this._playingSent=!0,this._waitingSent=!1,this._buffering&&this._videoElement.dispatchEvent(new window.Event(f.EventType.WAITING))}},{key:"getStartTimeOfDvrWindow",value:function(){return this.isLive()&&this._shaka?this._shaka.seekRange().start:0}},{key:"_videoWidth",get:function(){var e=void 0,t=this._videoElement;return t&&(e=t.width||t.clientWidth||t.offsetWidth,e*=this._contentScaleFactor),e}},{key:"_videoHeight",get:function(){var e=void 0,t=this._videoElement;return t&&(e=t.height||t.clientHeight||t.offsetHeight,e*=this._contentScaleFactor),e}},{key:"_contentScaleFactor",get:function(){var e=1;try{e=window.devicePixelRatio}catch(e){t._logger.debug("failed reading devicePixelRatio, assume 1")}return e}}]),t}(f.BaseMediaSourceAdapter);E.id="DashAdapter",E._logger=f.BaseMediaSourceAdapter.getLogger(E.id),E._dashMimeType="application/dash+xml",E._drmProtocols=[p.default,g.default],E._drmProtocol=null,t.default=E},function(e,t,r){"use strict";function n(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),u=r(0),c=u.BaseDrmProtocol.DrmSupport,l=u.BaseDrmProtocol.DrmScheme,d=function(e){function t(){return i(this,t),a(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return o(t,e),s(t,null,[{key:"isConfigured",value:function(e,t){return l.WIDEVINE===t.keySystem&&!!e.find(function(e){return e.scheme===t.keySystem})}},{key:"canPlayDrm",value:function(e){return t._logger.debug("Can play DRM scheme of: "+l.WIDEVINE),c.isProtocolSupported(l.WIDEVINE,e)}},{key:"setDrmPlayback",value:function(e,r){t._logger.debug("Sets drm playback");var i=u.Env.browser.name,a=r.find(function(e){return e.scheme===l.WIDEVINE});a&&(e.drm={servers:n({},l.WIDEVINE,a.licenseUrl),advanced:{}},"Chrome"===i&&(e.drm.advanced=n({},l.WIDEVINE,{videoRobustness:"SW_SECURE_CRYPTO",audioRobustness:"SW_SECURE_CRYPTO"})))}}]),t}(u.BaseDrmProtocol);d._logger=u.BaseDrmProtocol.getLogger("Widevine"),t.default=d},function(e,t,r){"use strict";function n(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),u=r(0),c=u.BaseDrmProtocol.DrmSupport,l=u.BaseDrmProtocol.DrmScheme,d=function(e){function t(){return i(this,t),a(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return o(t,e),s(t,null,[{key:"isConfigured",value:function(e,t){return l.PLAYREADY===t.keySystem&&!!e.find(function(e){return e.scheme===t.keySystem})}},{key:"canPlayDrm",value:function(e){return t._logger.debug("Can play DRM scheme of: "+l.PLAYREADY),c.isProtocolSupported(l.PLAYREADY,e)}},{key:"setDrmPlayback",value:function(e,r){t._logger.debug("Sets drm playback");var i=r.find(function(e){return e.scheme===l.PLAYREADY});i&&(e.drm={servers:n({},l.PLAYREADY,i.licenseUrl)})}}]),t}(u.BaseDrmProtocol);d._logger=u.BaseDrmProtocol.getLogger("PlayReady"),t.default=d},function(e,t){e.exports={shakaConfig:{streaming:{ignoreTextStreamFailures:!0},abr:{enabled:!0,restrictions:{}}},forceRedirectExternalStreams:!1}},function(e,t,r){"use strict";function n(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var o=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),s=r(1),u=function(e){return e&&e.__esModule?e:{default:e}}(s),c=function(e){function t(){return n(this,t),i(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return a(t,e),o(t,[{key:"isTextVisible",value:function(){return!0}}]),t}(u.default.text.SimpleTextDisplayer);t.default=c}])});


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(9)):"function"==typeof define&&define.amd?define(["pakhshkit-js"],t):"object"==typeof exports?exports.ottanalytics=t(require("pakhshkit-js")):(e.pakhshkit=e.pakhshkit||{},e.pakhshkit.ottanalytics=t(e.pakhshkit.core))}(this,function(e){return function(e){function t(r){if(n[r])return n[r].exports;var i=n[r]={i:r,l:!1,exports:{}};return e[r].call(i.exports,i,i.exports,t),i.l=!0,i.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=1)}([function(t,n){t.exports=e},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.NAME=t.VERSION=void 0;var r=n(0),i=n(2);t.default=i.OttAnalytics,t.VERSION="0.5.0",t.NAME="@pakhshkit-js/pakhshkit-js-ott-analytics";(0,r.registerPlugin)("ottAnalytics",i.OttAnalytics)},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.BookmarkError=t.BookmarkEvent=t.OttAnalytics=void 0;var a=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(0),u=n(3),l={LOAD:"LOAD",PLAY:"PLAY",STOP:"STOP",PAUSE:"PAUSE",FINISH:"FINISH",FIRST_PLAY:"FIRST_PLAY",BITRATE_CHANGE:"BITRATE_CHANGE",HIT:"HIT"},c={BOOKMARK_ERROR:"bookmarkerror",CONCURRENCY_LIMIT:"concurrencylimit"},f=function(e){function t(e,n,o){r(this,t);var a=i(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e,n,o));return a._isPlaying=!1,a._isFinished=!1,a._isStopped=!1,a._fileId=0,a._didFirstPlay=!1,a._mediaHitInterval=null,a._playerDidError=!1,a.config.serviceUrl?a._registerListeners():a.logger.warn("No service URL provided. Tracking aborted"),a}return o(t,e),a(t,null,[{key:"isValid",value:function(){return!0}}]),a(t,[{key:"reset",value:function(){this._clearMediaHitInterval(),this._maybeSendStop(),this._didFirstPlay=!1,this._playerDidError=!1}},{key:"destroy",value:function(){this._maybeSendStop(),this.eventManager.destroy()}},{key:"_maybeSendStop",value:function(){this._isFinished||this._isStopped||(this._isStopped=!0,this._sendAnalytics(l.STOP,this._eventParams))}},{key:"_registerListeners",value:function(){var e=this,t=this.player.Event;this.eventManager.listen(this.player,t.FIRST_PLAY,function(){return e._onFirstPlay()}),this.eventManager.listen(this.player,t.PLAY,function(){return e._onPlay()}),this.eventManager.listen(this.player,t.PAUSE,function(){return e._onPause()}),this.eventManager.listen(this.player,t.ENDED,function(){return e._onEnded()}),this.eventManager.listen(this.player,t.SEEKED,function(){return e._onSeeked()}),this.eventManager.listen(this.player,t.ERROR,function(t){return e._onError(t)}),this.eventManager.listen(this.player,t.VIDEO_TRACK_CHANGED,function(){return e._onVideoTrackChanged()}),this.eventManager.listen(this.player,t.SOURCE_SELECTED,function(t){return e._onSourceSelected(t)}),this.eventManager.listen(this.player,t.MEDIA_LOADED,function(){return e._onMediaLoaded()})}},{key:"_onSourceSelected",value:function(e){try{var t=e.payload.selectedSource[0],n=t.id.split(","),r=n[0];this._fileId=parseInt(r)}catch(e){this.logger.warn("Unable to parse file ID")}}},{key:"_onMediaLoaded",value:function(){this._sendAnalytics(l.LOAD,this._eventParams)}},{key:"_onPlay",value:function(){this._isPlaying=!0,this._isStopped=!1,this._isFinished=!1,this._startMediaHitInterval(),this._sendAnalytics(l.PLAY,this._eventParams)}},{key:"_onPause",value:function(){this._isPlaying=!1,this._didFirstPlay&&this._sendAnalytics(l.PAUSE,this._eventParams)}},{key:"_onEnded",value:function(){this._isPlaying=!1,this._isFinished=!0,this._clearMediaHitInterval(),this._sendAnalytics(l.FINISH,this._eventParams)}},{key:"_onError",value:function(e){e.payload&&e.payload.severity===s.Error.Severity.CRITICAL&&(this._isPlaying=!1,this._playerDidError=!0,this._clearMediaHitInterval())}},{key:"_onFirstPlay",value:function(){this._didFirstPlay=!0,this._sendAnalytics(l.FIRST_PLAY,this._eventParams)}},{key:"_onSeeked",value:function(){this._playFromContinue=!1}},{key:"_onVideoTrackChanged",value:function(){this._sendAnalytics(l.BITRATE_CHANGE,this._eventParams)}},{key:"_sendAnalytics",value:function(e,t){var n=this;if(this._validate(e)){var r={action:e,averageBitrate:0,totalBitrate:0,currentBitrate:0,fileId:t.fileId},i={type:t.mediaType,id:t.mediaId,position:t.position,playerData:r},o=u.OTTBookmarkService.add(this.config.serviceUrl,this.config.vs,i);this.logger.debug("sending bookmark",i),o.doHttpRequest().then(function(e){n.logger.debug("bookmark response",e),n._resultHasError(e)&&("4001"===n._getErrorCode(e)?(n.player.dispatchEvent(new s.FakeEvent(c.CONCURRENCY_LIMIT,e)),n.logger.warn("bookmark concurrency block returned")):(n.player.dispatchEvent(new s.FakeEvent(c.BOOKMARK_ERROR,e)),n.logger.warn("bookmark error returned")))},function(e){n.logger.warn("Failed to send analytics event",i,e)})}}},{key:"_resultHasError",value:function(e){return!(!e.result||!e.result.error)}},{key:"_getErrorCode",value:function(e){return e.result.error.code}},{key:"_validate",value:function(e){if(this._playerDidError)return!1;if(!this.config.entryId)return this._logMissingParam("entryId"),!1;if(!this._fileId)return this._logMissingParam("fileId"),!1;if(this.config.isAnonymous)return this.logger.info("block report for anonymous user"),!1;var t=e===l.HIT;return t&&this.config.disableMediaHit?(this.logger.info("block MediaHit report"),!1):!(!t&&this.config.disableMediaMark)||(this.logger.info("block MediaMark report"),!1)}},{key:"_logMissingParam",value:function(e){this.logger.warn("block report because of missing param "+e)}},{key:"_startMediaHitInterval",value:function(){var e=this;this.player.isLive()&&!this.config.experimentalEnableLiveMediaHit||(this._clearMediaHitInterval(),this._mediaHitInterval=setInterval(function(){e._isPlaying&&(0===e._eventParams.position?e.logger.debug("prevent sending MediaHit"):e._sendAnalytics(l.HIT,e._eventParams))},1e3*this.config.mediaHitInterval))}},{key:"_clearMediaHitInterval",value:function(){this._mediaHitInterval&&(clearInterval(this._mediaHitInterval),this._mediaHitInterval=null)}},{key:"_eventParams",get:function(){return{mediaType:"MEDIA",fileId:this._fileId,mediaId:this.config.entryId,position:this.player.currentTime}}}]),t}(s.BasePlugin);f.defaultConfig={mediaHitInterval:30,isAnonymous:!0,startTime:null,disableMediaHit:!1,disableMediaMark:!1,experimentalEnableLiveMediaHit:!1},t.OttAnalytics=f,t.BookmarkEvent=l,t.BookmarkError=c},function(e,t,n){!function(t,n){e.exports=n()}(0,function(){return function(e){function t(r){if(n[r])return n[r].exports;var i=n[r]={i:r,l:!1,exports:{}};return e[r].call(i.exports,i,i.exports,t),i.l=!0,i.exports}var n={};return t.m=e,t.c=n,t.i=function(e){return e},t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=11)}([function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),a=function(){function e(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:new Map;r(this,e),this.headers=t}return o(e,[{key:"getUrl",value:function(e){return e+"/service/"+this.service+(this.action?"/action/"+this.action:"")}},{key:"doHttpRequest",value:function(){var e=this;if(!this.url)throw new Error("serviceUrl is mandatory for request builder");var t=new XMLHttpRequest;return new Promise(function(n,r){t.onreadystatechange=function(){if(4===t.readyState)if(200===t.status){var e=JSON.parse(t.responseText);e&&"object"===(void 0===e?"undefined":i(e))&&e.code&&e.message?r(e):n(e)}else r(t.responseText)},t.open(e.method,e.url),e.headers.forEach(function(e,n){t.setRequestHeader(n,e)}),t.send(e.params)})}}]),e}();t.default=a},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.OTTConfiguration=void 0;var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=n(3),a={serviceParams:{apiVersion:"4.7.1"}},s=function(){function e(){r(this,e)}return i(e,null,[{key:"set",value:function(e){e&&Object.assign(a,e)}},{key:"get",value:function(){return(0,o.clone)(a)}}]),e}();t.default=s,t.OTTConfiguration=s},,function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},i=function e(t){var n=void 0;return Array.isArray(t)?(n=t.length>0?t.slice(0):[],n.forEach(function(t,i){("object"===(void 0===t?"undefined":r(t))&&t!=={}||Array.isArray(t)&&t.length>0)&&(n[i]=e(t))})):"object"===(void 0===t?"undefined":r(t))?(n=Object.assign({},t),Object.keys(n).forEach(function(t){("object"===r(n[t])&&n[t]!=={}||Array.isArray(n[t])&&n[t].length>0)&&(n[t]=e(n[t]))})):n=t,n};t.clone=i},function(e,t,n){"use strict";function r(e){return e?s.get(e):s}function i(e){return r(e).getLevel()}function o(e,t){r(t).setLevel(e)}Object.defineProperty(t,"__esModule",{value:!0}),t.setLogLevel=t.getLogLevel=t.LogLevel=void 0;var a=n(7),s=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}(a),u={DEBUG:s.DEBUG,INFO:s.INFO,TIME:s.TIME,WARN:s.WARN,ERROR:s.ERROR,OFF:s.OFF};s.useDefaults({defaultLevel:s.ERROR}),t.default=r,t.LogLevel=u,t.getLogLevel=i,t.setLogLevel=o},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var i=function e(t){r(this,e),this.hasError=!1,"VidiunAPIException"===t.objectType?(this.hasError=!0,this.error=new o(t.code,t.message)):t.error&&"VidiunAPIException"===t.error.objectType?(this.hasError=!0,this.error=new o(t.error.code,t.error.message)):this.data=t};t.default=i;var o=function e(t,n){r(this,e),this.code=t,this.message=n}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function i(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.MultiRequestResult=void 0;var u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(0),c=r(l),f=n(4),d=r(f),p=n(5),y=r(p),v=function(e){function t(){var e,n,r,i;o(this,t);for(var s=arguments.length,u=Array(s),l=0;l<s;l++)u[l]=arguments[l];return n=r=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(u))),r.requests=[],i=n,a(r,i)}return s(t,e),u(t,[{key:"add",value:function(e){this.requests.push(e);var t={},n={service:e.service,action:e.action};return Object.assign(t,i({},this.requests.length,Object.assign(n,e.params))),Object.assign(t,this.params),this.params=t,this}},{key:"execute",value:function(){var e=this;try{this.params=JSON.stringify(this.params)}catch(e){t._logger.error(""+e.message)}return new Promise(function(t,n){e.doHttpRequest().then(function(e){t(new h(e))},function(e){n("Error on multiRequest execution, error <"+e+">.")})})}}]),t}(c.default);v._logger=(0,d.default)("MultiRequestBuilder"),t.default=v;var h=t.MultiRequestResult=function e(t){var n=this;o(this,e),this.results=[],this.success=!0,(t.result?t.result:t).forEach(function(t){var r=new y.default(t);if(n.results.push(r),r.hasError)return e._logger.error("Service returned an error with error code: "+r.error.code+" and message: "+r.error.message+"."),void(n.success=!1)})};h._logger=(0,d.default)("MultiRequestResult")},function(e,t,n){var r,i;/*!
 * js-logger - http://github.com/jonnyreeves/js-logger
 * Jonny Reeves, http://jonnyreeves.co.uk/
 * js-logger may be freely distributed under the MIT license.
 */
!function(o){"use strict";var a={};a.VERSION="1.4.1";var s,u={},l=function(e,t){return function(){return t.apply(e,arguments)}},c=function(){var e,t,n=arguments,r=n[0];for(t=1;t<n.length;t++)for(e in n[t])e in r||!n[t].hasOwnProperty(e)||(r[e]=n[t][e]);return r},f=function(e,t){return{value:e,name:t}};a.DEBUG=f(1,"DEBUG"),a.INFO=f(2,"INFO"),a.TIME=f(3,"TIME"),a.WARN=f(4,"WARN"),a.ERROR=f(8,"ERROR"),a.OFF=f(99,"OFF");var d=function(e){this.context=e,this.setLevel(e.filterLevel),this.log=this.info};d.prototype={setLevel:function(e){e&&"value"in e&&(this.context.filterLevel=e)},getLevel:function(){return this.context.filterLevel},enabledFor:function(e){var t=this.context.filterLevel;return e.value>=t.value},debug:function(){this.invoke(a.DEBUG,arguments)},info:function(){this.invoke(a.INFO,arguments)},warn:function(){this.invoke(a.WARN,arguments)},error:function(){this.invoke(a.ERROR,arguments)},time:function(e){"string"==typeof e&&e.length>0&&this.invoke(a.TIME,[e,"start"])},timeEnd:function(e){"string"==typeof e&&e.length>0&&this.invoke(a.TIME,[e,"end"])},invoke:function(e,t){s&&this.enabledFor(e)&&s(t,c({level:e},this.context))}};var p=new d({filterLevel:a.OFF});!function(){var e=a;e.enabledFor=l(p,p.enabledFor),e.debug=l(p,p.debug),e.time=l(p,p.time),e.timeEnd=l(p,p.timeEnd),e.info=l(p,p.info),e.warn=l(p,p.warn),e.error=l(p,p.error),e.log=e.info}(),a.setHandler=function(e){s=e},a.setLevel=function(e){p.setLevel(e);for(var t in u)u.hasOwnProperty(t)&&u[t].setLevel(e)},a.getLevel=function(){return p.getLevel()},a.get=function(e){return u[e]||(u[e]=new d(c({name:e},p.context)))},a.createDefaultHandler=function(e){e=e||{},e.formatter=e.formatter||function(e,t){t.name&&e.unshift("["+t.name+"]")};var t={},n=function(e,t){Function.prototype.apply.call(e,console,t)};return"undefined"==typeof console?function(){}:function(r,i){r=Array.prototype.slice.call(r);var o,s=console.log;i.level===a.TIME?(o=(i.name?"["+i.name+"] ":"")+r[0],"start"===r[1]?console.time?console.time(o):t[o]=(new Date).getTime():console.timeEnd?console.timeEnd(o):n(s,[o+": "+((new Date).getTime()-t[o])+"ms"])):(i.level===a.WARN&&console.warn?s=console.warn:i.level===a.ERROR&&console.error?s=console.error:i.level===a.INFO&&console.info?s=console.info:i.level===a.DEBUG&&console.debug&&(s=console.debug),e.formatter(r,i),n(s,r))}},a.useDefaults=function(e){a.setLevel(e&&e.defaultLevel||a.DEBUG),a.setHandler(a.createDefaultHandler(e))},r=a,void 0!==(i="function"==typeof r?r.call(t,n,t,e):r)&&(e.exports=i)}()},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),u=n(12),l=r(u),c=n(0),f=r(c),d=n(1),p=r(d),y=function(e){function t(){return i(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return a(t,e),s(t,null,[{key:"add",value:function(e,t,n){var r=new Map;r.set("Content-Type","application/json");var i=new f.default(r);i.service="bookmark",i.action="add",i.method="POST",i.url=i.getUrl(e);var o={objectType:"VidiunBookmarkPlayerData",action:n.playerData.action,averageBitrate:n.playerData.averageBitrate,totalBitrate:n.playerData.totalBitrate,currentBitrate:n.playerData.currentBitrate,fileId:n.playerData.fileId},a={objectType:"VidiunBookmark",type:n.type,id:n.id,position:n.position,playerData:o},s=p.default.get(),u=s.serviceParams;return Object.assign(u,{bookmark:a,vs:t}),i.params=JSON.stringify(u),i}}]),t}(l.default);t.default=y},,,function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.VERSION=t.NAME=t.RequestBuilder=t.OTTConfiguration=t.OTTBookmarkService=void 0;var i=n(0),o=r(i),a=n(1),s=r(a),u=n(8),l=r(u);t.OTTBookmarkService=l.default,t.OTTConfiguration=s.default,t.RequestBuilder=o.default,t.NAME="pakhshkit-js-providers-bookmark-service",t.VERSION="2.3.2"},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),a=n(6),s=r(a),u=n(1),l=r(u),c=function(){function e(){i(this,e)}return o(e,null,[{key:"getMultiRequest",value:function(e,t){var n=l.default.get(),r=n.serviceParams;e&&Object.assign(r,{vs:e}),t&&Object.assign(r,{partnerId:t});var i=new Map;i.set("Content-Type","application/json");var o=new s.default(i);return o.method="POST",o.service="multirequest",o.url=o.getUrl(n.serviceUrl),o.params=r,o}}]),e}();t.default=c}])})}])});


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(9)):"function"==typeof define&&define.amd?define("kava",["pakhshkit-js"],t):"object"==typeof exports?exports.kava=t(require("@pakhshkit-js/pakhshkit-js")):(e.VidiunPlayer=e.VidiunPlayer||{},e.VidiunPlayer.plugins=e.VidiunPlayer.plugins||{},e.VidiunPlayer.plugins.kava=t(e.VidiunPlayer.core))}("undefined"!=typeof self?self:this,function(e){return function(e){function t(r){if(n[r])return n[r].exports;var i=n[r]={i:r,l:!1,exports:{}};return e[r].call(i.exports,i,i.exports,t),i.l=!0,i.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=3)}([function(e,t,n){"use strict";function r(e,t){var n={eventType:e.index,partnerId:t.getPartnerId(),entryId:t.getEntryId(),sessionId:t.getSessionId(),eventIndex:t.getEventIndex(),referrer:t.getReferrer(),deliveryType:t.getDeliveryType(),playbackType:t.getPlaybackType(),clientVer:t.getClientVer(),clientTag:t.getClientTag(),position:t.getPosition()};t.getSessionStartTime()&&(n.sessionStartTime=t.getSessionStartTime()),t.getVS()&&(n.vs=t.getVS()),t.getUIConfId()&&(n.uiConfId=t.getUIConfId()),t.getPlaylistId()&&(n.playlistId=t.getPlaylistId()),t.getCustomVar1()&&(n.customVar1=t.getCustomVar1()),t.getCustomVar2()&&(n.customVar2=t.getCustomVar2()),t.getCustomVar3()&&(n.customVar3=t.getCustomVar3()),t.getPlaybackContext()&&(n.playbackContext=t.getPlaybackContext()),t.getApplicationVersion()&&(n.applicationVersion=t.getApplicationVersion());var r=e.getEventModel(t);return Object.assign(r,n)}Object.defineProperty(t,"__esModule",{value:!0}),t.KavaEventType=t.KavaEventModel=void 0,t.getEventModel=r;var i=(n(2),t.KavaEventModel={VIEW:{type:"VIEW",index:99,getEventModel:function(e){return{playTimeSum:e.getPlayTimeSum(),bufferTime:e.getBufferTime(),bufferTimeSum:e.getBufferTimeSum(),actualBitrate:e.getActualBitrate(),averageBitrate:e.getAverageBitrate(),audioLanguage:e.getLanguage(),captionsLanguage:e.getCaption()}}},IMPRESSION:{type:"IMPRESSION",index:1,getEventModel:function(){return{}}},PLAY_REQUEST:{type:"PLAY_REQUEST",index:2,getEventModel:function(){return{}}},PLAY:{type:"PLAY",index:3,getEventModel:function(e){return{bufferTime:e.getBufferTime(),bufferTimeSum:e.getBufferTimeSum(),actualBitrate:e.getActualBitrate(),joinTime:e.getJoinTime(),canPlay:e.getCanPlayTime()}}},RESUME:{type:"RESUME",index:4,getEventModel:function(e){return{bufferTime:e.getBufferTime(),bufferTimeSum:e.getBufferTimeSum(),actualBitrate:e.getActualBitrate()}}},PAUSE:{type:"PAUSE",index:33,getEventModel:function(){return{}}},BUFFER_START:{type:"BUFFER_START",index:45,getEventModel:function(){return{}}},BUFFER_END:{type:"BUFFER_END",index:46,getEventModel:function(){return{}}},REPLAY:{type:"REPLAY",index:34,getEventModel:function(){return{}}},SEEK:{type:"SEEK",index:35,getEventModel:function(e){return{targetPosition:e.getTargetPosition()}}},PLAY_REACHED_25_PERCENT:{type:"PLAY_REACHED_25_PERCENT",index:11,getEventModel:function(){return{}}},PLAY_REACHED_50_PERCENT:{type:"PLAY_REACHED_50_PERCENT",index:12,getEventModel:function(){return{}}},PLAY_REACHED_75_PERCENT:{type:"PLAY_REACHED_75_PERCENT",index:13,getEventModel:function(){return{}}},PLAY_REACHED_100_PERCENT:{type:"PLAY_REACHED_100_PERCENT",index:14,getEventModel:function(){return{}}},SOURCE_SELECTED:{type:"SOURCE_SELECTED",index:39,getEventModel:function(e){return{actualBitrate:e.getActualBitrate()}}},AUDIO_SELECTED:{type:"AUDIO_SELECTED",index:42,getEventModel:function(e){return{language:e.getLanguage()}}},FLAVOR_SWITCH:{type:"FLAVOR_SWITCH",index:43,getEventModel:function(e){return{actualBitrate:e.getActualBitrate()}}},CAPTIONS:{type:"CAPTIONS",index:38,getEventModel:function(e){return{caption:e.getCaption()}}},ERROR:{type:"ERROR",index:98,getEventModel:function(e){return{errorCode:e.getErrorCode()}}}});t.KavaEventType=function(e){return Object.keys(i).forEach(function(t){return e[t]=t}),e}({})},function(t,n){t.exports=e},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.KavaModel=void 0;var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=n(0),a=function(){function e(t){r(this,e),t&&this.updateModel(t)}return i(e,[{key:"getPlayTimeSum",value:function(){return this.playTimeSum}},{key:"getCanPlayTime",value:function(){return this.canPlayTime}},{key:"getBufferTime",value:function(){return this.bufferTime}},{key:"getBufferTimeSum",value:function(){return this.bufferTimeSum}},{key:"getJoinTime",value:function(){return this.joinTime}},{key:"getTargetPosition",value:function(){return this.targetPosition}},{key:"getLanguage",value:function(){return this.language}},{key:"getCaption",value:function(){return this.caption}},{key:"getErrorCode",value:function(){return this.errorCode}},{key:"getEventIndex",value:function(){return this.eventIndex}},{key:"getSessionStartTime",value:function(){return this.sessionStartTime}},{key:"updateModel",value:function(e){Object.assign(this,e)}},{key:"getModel",value:function(e){return(0,o.getEventModel)(e,this)}}]),e}();t.KavaModel=a},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.NAME=t.VERSION=t.EventType=t.Plugin=void 0;var r=n(0);Object.defineProperty(t,"EventType",{enumerable:!0,get:function(){return r.KavaEventType}});var i=n(1),o=n(4);t.Plugin=o.Kava,t.VERSION="0.7.2",t.NAME="@pakhshkit-js/pakhshkit-js-kava";(0,i.registerPlugin)("kava",o.Kava)},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.Kava=void 0;var a="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(1),l=n(5),c=n(0),f=n(6),d=n(7),v=n(2),y=function(e){function t(e,n,o){r(this,t);var a=i(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e,n,o));return a._rateHandler=new f.KavaRateHandler,a._model=new v.KavaModel,a._setModelDelegates(),a._timer=new d.KavaTimer({resetCounter:a.config.resetSessionCountdown,eventCounter:a.config.viewEventCountdown}),a._viewEventEnabled=!0,a._resetFlags(),a._addBindings(),a._model.updateModel({eventIndex:1,bufferTime:0,bufferTimeSum:0,playTimeSum:0}),a}return o(t,e),u(t,null,[{key:"isValid",value:function(){return!0}}]),u(t,[{key:"destroy",value:function(){this.eventManager.destroy(),this._timer.destroy(),this._rateHandler.destroy()}},{key:"reset",value:function(){this.eventManager.removeAll(),this._rateHandler.destroy(),this._timer.destroy(),this._resetFlags(),this._addBindings(),this._model.updateModel({eventIndex:1,bufferTime:0,bufferTimeSum:0,playTimeSum:0,sessionStartTime:null})}},{key:"getEventModel",value:function(e){if(e)return this._model.getModel(c.KavaEventModel[e])}},{key:"sendAnalytics",value:function(e){var t=this;return new Promise(function(n,r){l.OVPAnalyticsService.trackEvent(t.config.serviceUrl,e).doHttpRequest().then(function(r){t._handleServerResponseSuccess(r,e),n()},function(n){t._handleServerResponseFailed(n,e),r(n)}),t._model.updateModel({eventIndex:t._model.getEventIndex()+1})})}},{key:"_resetFlags",value:function(){this._previousCurrentTime=0,this._isPlaying=!1,this._isFirstPlay=!0,this._isEnded=!1,this._isPaused=!1,this._isBuffering=!1,this._timePercentEvent={PLAY_REACHED_25_PERCENT:!1,PLAY_REACHED_50_PERCENT:!1,PLAY_REACHED_75_PERCENT:!1,PLAY_REACHED_100_PERCENT:!1}}},{key:"_resetSession",value:function(){this.logger.debug("Reset KAVA session"),this._rateHandler.reset(),this._model.updateModel({eventIndex:1,bufferTimeSum:0,playTimeSum:0})}},{key:"_sendAnalytics",value:function(e){if(this._validate()){this._isBuffering&&(this._updateBufferModel(),this._bufferStartTime=Date.now());var t=this._model.getModel(e);if("function"==typeof this.config.tamperAnalyticsHandler){if(!this.config.tamperAnalyticsHandler(t))return void this.logger.debug("Cancel KAVA request",t)}this.logger.debug("Sending KAVA event "+t.eventType+":"+e.type),this.sendAnalytics(t)}}},{key:"_handleServerResponseSuccess",value:function(e,t){this.logger.debug("KAVA event sent",t),this._updateSessionStartTimeModel(e)}},{key:"_handleServerResponseFailed",value:function(e,t){this.logger.error("Failed to send KAVA event",t,e)}},{key:"_addBindings",value:function(){var e=this;this.eventManager.listen(this._timer,d.KavaTimer.Event.TICK,function(){return e._rateHandler.countCurrent()}),this.eventManager.listen(this._timer,d.KavaTimer.Event.REPORT,function(){return e._onReport()}),this.eventManager.listen(this._timer,d.KavaTimer.Event.RESET,function(){return e._resetSession()}),this.eventManager.listen(this.player,this.player.Event.SOURCE_SELECTED,function(){return e._onSourceSelected()}),this.eventManager.listen(this.player,this.player.Event.ERROR,function(t){return e._onError(t)}),this.eventManager.listen(this.player,this.player.Event.FIRST_PLAY,function(){return e._onFirstPlay()}),this.eventManager.listen(this.player,this.player.Event.TRACKS_CHANGED,function(){return e._setInitialTracks()}),this.eventManager.listen(this.player,this.player.Event.PLAYING,function(){return e._onPlaying()}),this.eventManager.listen(this.player,this.player.Event.FIRST_PLAYING,function(){return e._onFirstPlaying()}),this.eventManager.listen(this.player,this.player.Event.SEEKING,function(){return e._onSeeking()}),this.eventManager.listen(this.player,this.player.Event.PAUSE,function(){return e._onPause()}),this.eventManager.listen(this.player,this.player.Event.ENDED,function(){return e._onEnded()}),this.eventManager.listen(this.player,this.player.Event.TIME_UPDATE,function(){return e._onTimeUpdate()}),this.eventManager.listen(this.player,this.player.Event.VIDEO_TRACK_CHANGED,function(t){return e._onVideoTrackChanged(t)}),this.eventManager.listen(this.player,this.player.Event.AUDIO_TRACK_CHANGED,function(t){return e._onAudioTrackChanged(t)}),this.eventManager.listen(this.player,this.player.Event.TEXT_TRACK_CHANGED,function(t){return e._onTextTrackChanged(t)}),this.eventManager.listen(this.player,this.player.Event.PLAYER_STATE_CHANGED,function(t){return e._onPlayerStateChanged(t)}),this.eventManager.listen(this.player,this.player.Event.CAN_PLAY,function(){return e._onCanPlay()}),this.eventManager.listen(this.player,this.player.Event.LOAD_START,function(){return e._onLoadStart()})}},{key:"_onFirstPlaying",value:function(){this._isPlaying=!0}},{key:"_onLoadStart",value:function(){this._loadStartTime=Date.now()}},{key:"_getRates",value:function(){var e=[];return this.player.getTracks(this.player.Track.VIDEO).forEach(function(t){return e.push(t.bandwidth/1024)}),e}},{key:"_setInitialTracks",value:function(){var e=this._getRates(),t=this.player.getActiveTracks();this._rateHandler.setRates(e),t.video&&this._rateHandler.setCurrent(t.video.bandwidth/1024),t.audio&&this._model.updateModel({language:t.audio.language}),t.text&&this._model.updateModel({caption:t.text.language})}},{key:"_onReport",value:function(){this._viewEventEnabled?(this._updatePlayTimeSumModel(),this._sendAnalytics(c.KavaEventModel.VIEW)):this.logger.warn("VIEW event blocked because server response of viewEventsEnabled=false"),this._model.updateModel({bufferTime:0})}},{key:"_onPlaying",value:function(){this._isFirstPlay?(this._timer.start(),this._isFirstPlay=!1,this._model.updateModel({joinTime:t._getTimeDifferenceInSeconds(this._firstPlayRequestTime)}),this._sendAnalytics(c.KavaEventModel.PLAY)):this._isEnded?(this._timer.start(),this._isEnded=!1,this._sendAnalytics(c.KavaEventModel.REPLAY)):this._isPaused&&(this._timer.resume(),this._isPaused=!1,this._sendAnalytics(c.KavaEventModel.RESUME))}},{key:"_onCanPlay",value:function(){this._model.updateModel({canPlayTime:t._getTimeDifferenceInSeconds(this._loadStartTime)})}},{key:"_onFirstPlay",value:function(){this._firstPlayRequestTime=Date.now(),this._sendAnalytics(c.KavaEventModel.PLAY_REQUEST)}},{key:"_onSourceSelected",value:function(){this._sendAnalytics(c.KavaEventModel.IMPRESSION)}},{key:"_onSeeking",value:function(){this._previousCurrentTime=this.player.currentTime,this._model.updateModel({targetPosition:this.player.currentTime}),this._sendAnalytics(c.KavaEventModel.SEEK)}},{key:"_onPause",value:function(){this._isPaused=!0,this._timer.stop(),this._sendAnalytics(c.KavaEventModel.PAUSE)}},{key:"_onEnded",value:function(){this._isEnded=!0,this._onTimeUpdate(),this._model.updateModel({bufferTime:0})}},{key:"_onTimeUpdate",value:function(){if(!this.player.isLive()){this._updatePlayTimeSumModel();var e=parseFloat((this.player.currentTime/this.player.duration).toFixed(2));!this._timePercentEvent.PLAY_REACHED_25&&e>=.25&&(this._timePercentEvent.PLAY_REACHED_25=!0,this._sendAnalytics(c.KavaEventModel.PLAY_REACHED_25_PERCENT)),!this._timePercentEvent.PLAY_REACHED_50&&e>=.5&&(this._timePercentEvent.PLAY_REACHED_50=!0,this._sendAnalytics(c.KavaEventModel.PLAY_REACHED_50_PERCENT)),!this._timePercentEvent.PLAY_REACHED_75&&e>=.75&&(this._timePercentEvent.PLAY_REACHED_75=!0,this._sendAnalytics(c.KavaEventModel.PLAY_REACHED_75_PERCENT)),this._timePercentEvent.PLAY_REACHED_100||1!==e||(this._timePercentEvent.PLAY_REACHED_100=!0,this._sendAnalytics(c.KavaEventModel.PLAY_REACHED_100_PERCENT))}}},{key:"_onVideoTrackChanged",value:function(e){var t=e.payload.selectedVideoTrack;this._rateHandler.setCurrent(t.bandwidth/1024),this.player.isAdaptiveBitrateEnabled()?this._sendAnalytics(c.KavaEventModel.FLAVOR_SWITCH):this._sendAnalytics(c.KavaEventModel.SOURCE_SELECTED)}},{key:"_onAudioTrackChanged",value:function(e){var t=e.payload.selectedAudioTrack;this._model.updateModel({language:t.language}),this._sendAnalytics(c.KavaEventModel.AUDIO_SELECTED)}},{key:"_onTextTrackChanged",value:function(e){if(this._isPlaying){var t=e.payload.selectedTextTrack;this._model.updateModel({caption:t.language}),this._sendAnalytics(c.KavaEventModel.CAPTIONS)}}},{key:"_onError",value:function(e){e.payload&&e.payload.severity===s.Error.Severity.CRITICAL&&(this._model.updateModel({errorCode:e.payload.code}),this._sendAnalytics(c.KavaEventModel.ERROR),this.reset())}},{key:"_onPlayerStateChanged",value:function(e){var t=e.payload.oldState,n=e.payload.newState;t.type===this.player.State.BUFFERING&&(this._isBuffering=!1,this._updateBufferModel(),this._sendAnalytics(c.KavaEventModel.BUFFER_END)),n.type===this.player.State.BUFFERING&&(this._isBuffering=!0,this._bufferStartTime=Date.now(),this._sendAnalytics(c.KavaEventModel.BUFFER_START))}},{key:"_updateSessionStartTimeModel",value:function(e){!this._model.getSessionStartTime()&&e&&("object"===(void 0===e?"undefined":a(e))?(this._model.updateModel({sessionStartTime:e.time}),this._viewEventEnabled=e.viewEventsEnabled):this._model.updateModel({sessionStartTime:e})),this._timer.isStopped()&&this._model.updateModel({sessionStartTime:null})}},{key:"_updateBufferModel",value:function(){var e=t._getTimeDifferenceInSeconds(this._bufferStartTime);this._model.updateModel({bufferTime:this._model.getBufferTime()+e,bufferTimeSum:this._model.getBufferTimeSum()+e})}},{key:"_updatePlayTimeSumModel",value:function(){var e=void 0;this.player.isLive()?e=this.config.viewEventCountdown-this._model.getBufferTime():(e=this.player.currentTime-this._previousCurrentTime,this._previousCurrentTime=this.player.currentTime),this._model.updateModel({playTimeSum:this._model.getPlayTimeSum()+e})}},{key:"_setModelDelegates",value:function(){var e=this;this._model.getActualBitrate=function(){return e._rateHandler.getCurrent()},this._model.getAverageBitrate=function(){return e._rateHandler.getAverage()},this._model.getPartnerId=function(){return e.config.partnerId},this._model.getEntryId=function(){return e.config.entryId},this._model.getPlaylistId=function(){return e.config.playlistId},this._model.getSessionId=function(){return e.config.sessionId},this._model.getClientVer=function(){return e.config.playerVersion},this._model.getClientTag=function(){return"html5:v"+e.config.playerVersion},this._model.getVS=function(){return e.config.vs},this._model.getUIConfId=function(){return e.config.uiConfId},this._model.getReferrer=function(){return e.config.referrer},this._model.getCustomVar1=function(){return e.config.customVar1},this._model.getCustomVar2=function(){return e.config.customVar2},this._model.getCustomVar3=function(){return e.config.customVar3},this._model.getPosition=function(){return e._getPosition()},this._model.getDeliveryType=function(){return e._getDeliveryType()},this._model.getPlaybackType=function(){return e._getPlaybackType()},this._model.getPlaybackContext=function(){return e.config.playbackContext},this._model.getApplicationVersion=function(){return e.config.applicationVersion}}},{key:"_getPosition",value:function(){return this.player.isLive()?Number.isNaN(this.player.duration)?0:this.player.duration-this.player.currentTime<1?0:-(this.player.duration-this.player.currentTime):this.player.currentTime}},{key:"_getDeliveryType",value:function(){return this.player.streamType===this.player.StreamType.PROGRESSIVE?"url":this.player.streamType}},{key:"_getPlaybackType",value:function(){if(this.player.isLive()){if(this.player.isDvr()){if(this.player.duration-this.player.currentTime>=this.config.dvrThreshold)return"dvr"}return"live"}return"vod"}},{key:"_validate",value:function(){return this.config.partnerId?!!this.config.entryId||(this._logMissingParam("entryId"),!1):(this._logMissingParam("partnerId"),!1)}},{key:"_logMissingParam",value:function(e){this.logger.warn("Kava analytics block report because of missing param "+e)}},{key:"EventType",get:function(){return s.Utils.Object.copyDeep(c.KavaEventType)}}],[{key:"_getTimeDifferenceInSeconds",value:function(e){return(Date.now()-e)/1e3}}]),t}(s.BasePlugin);y.defaultConfig={serviceUrl:"//analytics.vidiun.com/api_v3/index.php",viewEventCountdown:10,resetSessionCountdown:30,dvrThreshold:120,playbackContext:"",applicationVersion:""},t.Kava=y},function(e,t,n){!function(t,n){e.exports=n()}(0,function(){return function(e){function t(r){if(n[r])return n[r].exports;var i=n[r]={i:r,l:!1,exports:{}};return e[r].call(i.exports,i,i.exports,t),i.l=!0,i.exports}var n={};return t.m=e,t.c=n,t.i=function(e){return e},t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=19)}([function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=n(2),a=function(e){return e&&e.__esModule?e:{default:e}}(o),u=function(){function e(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:new Map;r(this,e),this._attemptCounter=1,this.headers=t}return i(e,[{key:"getUrl",value:function(e){return e+"/service/"+this.service+(this.action?"/action/"+this.action:"")}},{key:"doHttpRequest",value:function(){var e=this,t=new Promise(function(t,n){e._requestPromise={resolve:t,reject:n}});return this.url||this._requestPromise.reject(new a.default(a.default.Severity.CRITICAL,a.default.Category.NETWORK,a.default.Code.MALFORMED_DATA_URI,{url:this.url})),this._createXHR(),t}},{key:"_createXHR",value:function(){var e=this,t=new XMLHttpRequest;t.onreadystatechange=function(){if(4===t.readyState&&200===t.status)try{var n=JSON.parse(t.responseText);return e.responseHeaders=e._getResponseHeaders(t),e._requestPromise.resolve(n)}catch(n){e._requestPromise.reject(e._createError(t,a.default.Code.BAD_SERVER_RESPONSE,{text:t.responseText}))}},t.open(this.method,this.url,this.retryConfig.async),this.retryConfig.async&&this.retryConfig.timeout&&(t.timeout=this.retryConfig.timeout);var n=performance.now();t.ontimeout=function(){e._handleError(t,a.default.Code.TIMEOUT,{timeout:(performance.now()-n)/1e3,statusText:t.statusText})},t.onerror=t.onabort=function(){e._handleError(t,a.default.Code.HTTP_ERROR,{text:t.responseText,statusText:t.statusText})},this.headers.forEach(function(e,n){t.setRequestHeader(n,e)}),t.send(this.params)}},{key:"_getResponseHeaders",value:function(e){return e.getAllResponseHeaders().split("\n").filter(function(e){return 0===e.toLowerCase().indexOf("x-")})}},{key:"_handleError",value:function(e,t,n){var r=this._createError(e,t,n);if(e.onreadystatechange=function(){},e.onerror=function(){},e.ontimeout=function(){},e.onabort=function(){},!(this.retryConfig.maxAttempts&&this._attemptCounter<this.retryConfig.maxAttempts))return this._requestPromise.reject(r);this._attemptCounter++,this._createXHR()}},{key:"_createError",value:function(e,t,n){return Object.assign(n,{url:this.url,headers:this._getResponseHeaders(e),attempt:this._attemptCounter}),new a.default(a.default.Severity.CRITICAL,a.default.Category.NETWORK,t,n)}}]),e}();t.default=u},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.OVPConfiguration=void 0;var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=n(6),a={serviceUrl:"https://cdnapisec.kaltura.com/api_v3",cdnUrl:"https://cdnapisec.kaltura.com",serviceParams:{apiVersion:"3.3.0",format:1},useApiCaptions:!0},u=function(){function e(){r(this,e)}return i(e,null,[{key:"set",value:function(e){e&&Object.assign(a,e)}},{key:"get",value:function(){return(0,o.clone)(a)}}]),e}();t.default=u,t.OVPConfiguration=u},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var i=n(3),o=function(e){return e&&e.__esModule?e:{default:e}}(i),a=n(9),u=n(8),s=n(7),l=function e(t,n,o){var a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{};r(this,e),this.severity=t,this.category=n,this.code=o,this.data=a,(0,i.getLogLevel)("Error")!==i.LogLevel.OFF&&e._logger.error("Category:"+n+" | Code:"+o+" |",a)};l.Severity=a.Severity,l.Category=s.Category,l.Code=u.Code,l._logger=(0,o.default)("Error"),t.default=l},function(e,t,n){"use strict";function r(e){return e?u.get(e):u}function i(e){return r(e).getLevel()}function o(e,t){r(t).setLevel(e)}Object.defineProperty(t,"__esModule",{value:!0}),t.setLogLevel=t.getLogLevel=t.LogLevel=void 0;var a=n(10),u=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}(a),s={DEBUG:u.DEBUG,INFO:u.INFO,TIME:u.TIME,WARN:u.WARN,ERROR:u.ERROR,OFF:u.OFF};u.useDefaults({defaultLevel:u.ERROR}),t.default=r,t.LogLevel=s,t.getLogLevel=i,t.setLogLevel=o},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var i=function e(t){r(this,e),this.hasError=!1,"KalturaAPIException"===t.objectType?(this.hasError=!0,this.error=new o(t.code,t.message)):t.error&&"KalturaAPIException"===t.error.objectType?(this.hasError=!0,this.error=new o(t.error.code,t.error.message)):this.data=t};t.default=i;var o=function e(t,n){r(this,e),this.code=t,this.message=n}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function i(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.MultiRequestResult=void 0;var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(0),c=r(l),f=n(3),d=r(f),v=n(4),y=r(v),p=n(2),h=r(p),_=function(e){function t(){var e,n,r,i;o(this,t);for(var u=arguments.length,s=Array(u),l=0;l<u;l++)s[l]=arguments[l];return n=r=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(s))),r.requests=[],i=n,a(r,i)}return u(t,e),s(t,[{key:"add",value:function(e){this.requests.push(e);var t={},n={service:e.service,action:e.action};return Object.assign(t,i({},this.requests.length,Object.assign(n,e.params))),Object.assign(t,this.params),this.params=t,this}},{key:"execute",value:function(){var e=this;return new Promise(function(n,r){try{e.params=JSON.stringify(e.params)}catch(n){t._logger.error(""+n.message),r(new h.default(h.default.Severity.CRITICAL,h.default.Category.PROVIDER,h.default.Code.FAILED_PARSING_REQUEST,{error:n,params:e.params}))}e.doHttpRequest().then(function(t){var i=new E(t);i.success?n({headers:e.responseHeaders,response:i}):r(new h.default(h.default.Severity.CRITICAL,h.default.Category.NETWORK,h.default.Code.MULTIREQUEST_API_ERROR,{url:e.url,headers:e.responseHeaders,results:i.results}))},function(e){r(e)})})}}]),t}(c.default);_._logger=(0,d.default)("MultiRequestBuilder"),t.default=_;var E=t.MultiRequestResult=function e(t){var n=this;o(this,e),this.results=[],this.success=!0,(t.result?t.result:t).forEach(function(t){var r=new y.default(t);if(n.results.push(r),r.hasError)return e._logger.error("Service returned an error with error code: "+r.error.code+" and message: "+r.error.message+"."),void(n.success=!1)})};E._logger=(0,d.default)("MultiRequestResult")},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},i=function e(t){var n=void 0;return Array.isArray(t)?(n=t.length>0?t.slice(0):[],n.forEach(function(t,i){("object"===(void 0===t?"undefined":r(t))&&t!=={}||Array.isArray(t)&&t.length>0)&&(n[i]=e(t))})):"object"===(void 0===t?"undefined":r(t))?(n=Object.assign({},t),Object.keys(n).forEach(function(t){("object"===r(n[t])&&n[t]!=={}||Array.isArray(n[t])&&n[t].length>0)&&(n[t]=e(n[t]))})):n=t,n};t.clone=i},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r={NETWORK:1,SERVICE:2,PROVIDER:3};t.Category=r},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r={UNSUPPORTED_SCHEME:1e3,BAD_HTTP_STATUS:1001,HTTP_ERROR:1002,TIMEOUT:1003,MALFORMED_DATA_URI:1004,BAD_SERVER_RESPONSE:1005,MULTIREQUEST_API_ERROR:1006,API_RESPONSE_MISMATCH:1007,ERROR:2e3,BLOCK_ACTION:2001,MISSING_MANDATORY_PARAMS:3e3,MISSING_PLAY_SOURCE:3001};t.Code=r},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r={RECOVERABLE:1,CRITICAL:2};t.Severity=r},function(e,t,n){var r,i;/*!
 * js-logger - http://github.com/jonnyreeves/js-logger
 * Jonny Reeves, http://jonnyreeves.co.uk/
 * js-logger may be freely distributed under the MIT license.
 */
!function(o){"use strict";var a={};a.VERSION="1.4.1";var u,s={},l=function(e,t){return function(){return t.apply(e,arguments)}},c=function(){var e,t,n=arguments,r=n[0];for(t=1;t<n.length;t++)for(e in n[t])e in r||!n[t].hasOwnProperty(e)||(r[e]=n[t][e]);return r},f=function(e,t){return{value:e,name:t}};a.DEBUG=f(1,"DEBUG"),a.INFO=f(2,"INFO"),a.TIME=f(3,"TIME"),a.WARN=f(4,"WARN"),a.ERROR=f(8,"ERROR"),a.OFF=f(99,"OFF");var d=function(e){this.context=e,this.setLevel(e.filterLevel),this.log=this.info};d.prototype={setLevel:function(e){e&&"value"in e&&(this.context.filterLevel=e)},getLevel:function(){return this.context.filterLevel},enabledFor:function(e){var t=this.context.filterLevel;return e.value>=t.value},debug:function(){this.invoke(a.DEBUG,arguments)},info:function(){this.invoke(a.INFO,arguments)},warn:function(){this.invoke(a.WARN,arguments)},error:function(){this.invoke(a.ERROR,arguments)},time:function(e){"string"==typeof e&&e.length>0&&this.invoke(a.TIME,[e,"start"])},timeEnd:function(e){"string"==typeof e&&e.length>0&&this.invoke(a.TIME,[e,"end"])},invoke:function(e,t){u&&this.enabledFor(e)&&u(t,c({level:e},this.context))}};var v=new d({filterLevel:a.OFF});!function(){var e=a;e.enabledFor=l(v,v.enabledFor),e.debug=l(v,v.debug),e.time=l(v,v.time),e.timeEnd=l(v,v.timeEnd),e.info=l(v,v.info),e.warn=l(v,v.warn),e.error=l(v,v.error),e.log=e.info}(),a.setHandler=function(e){u=e},a.setLevel=function(e){v.setLevel(e);for(var t in s)s.hasOwnProperty(t)&&s[t].setLevel(e)},a.getLevel=function(){return v.getLevel()},a.get=function(e){return s[e]||(s[e]=new d(c({name:e},v.context)))},a.createDefaultHandler=function(e){e=e||{},e.formatter=e.formatter||function(e,t){t.name&&e.unshift("["+t.name+"]")};var t={},n=function(e,t){Function.prototype.apply.call(e,console,t)};return"undefined"==typeof console?function(){}:function(r,i){r=Array.prototype.slice.call(r);var o,u=console.log;i.level===a.TIME?(o=(i.name?"["+i.name+"] ":"")+r[0],"start"===r[1]?console.time?console.time(o):t[o]=(new Date).getTime():console.timeEnd?console.timeEnd(o):n(u,[o+": "+((new Date).getTime()-t[o])+"ms"])):(i.level===a.WARN&&console.warn?u=console.warn:i.level===a.ERROR&&console.error?u=console.error:i.level===a.INFO&&console.info?u=console.info:i.level===a.DEBUG&&console.debug&&(u=console.debug),e.formatter(r,i),n(u,r))}},a.useDefaults=function(e){a.setLevel(e&&e.defaultLevel||a.DEBUG),a.setHandler(a.createDefaultHandler(e))},r=a,void 0!==(i="function"==typeof r?r.call(t,n,t,e):r)&&(e.exports=i)}()},,function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),a=n(5),u=r(a),s=n(1),l=r(s),c=function(){function e(){i(this,e)}return o(e,null,[{key:"getMultiRequest",value:function(e,t,n){var r=l.default.get(),i=r.serviceParams;Object.assign(i,{ks:t,clientTag:"html5:v"+e}),n&&Object.assign(i,{partnerId:n});var o=new Map;o.set("Content-Type","application/json");var a=new u.default(o);return a.method="POST",a.service="multirequest",a.url=a.getUrl(r.serviceUrl),a.params=i,a}}]),e}();t.default=c},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},i=function(e){var t=[],n=/\[\]$/,i=function(e){return"[object Array]"===Object.prototype.toString.call(e)},o=function(e,n){n="function"==typeof n?n():null===n?"":void 0===n?"":n,t[t.length]=encodeURIComponent(e)+"="+encodeURIComponent(n)};return function e(a,u){var s=void 0,l=void 0,c=void 0;if(a)if(i(u))for(s=0,l=u.length;s<l;s++)n.test(a)?o(a,u[s]):e(a+":"+("object"===r(u[s])?s:""),u[s]);else if(u&&"[object Object]"===String(u))for(c in u)e(a+":"+c,u[c]);else o(a,u);else if(i(u))for(s=0,l=u.length;s<l;s++)o(u[s].name,u[s].value);else for(c in u)e(c,u[c]);return t}("",e).join("&").replace(/%20/g,"+")};t.param=i},,function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(12),l=r(s),c=n(0),f=r(c),d=n(1),v=r(d),y=n(13),p=function(e){function t(){return i(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return a(t,e),u(t,null,[{key:"trackEvent",value:function(e,t){var n=v.default.get(),r={};Object.assign(r,n.serviceParams,t);var i=new f.default;return i.service="analytics",i.action="trackEvent",i.method="GET",i.tag="analytics-trackEvent",i.params=r,i.url=e+"?service="+i.service+"&action="+i.action+"&"+(0,y.param)(i.params),i}}]),t}(l.default);t.default=p},,,,function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.VERSION=t.NAME=t.RequestBuilder=t.OVPConfiguration=t.OVPAnalyticsService=void 0;var i=n(0),o=r(i),a=n(1),u=r(a),s=n(15),l=r(s);t.OVPAnalyticsService=l.default,t.OVPConfiguration=u.default,t.RequestBuilder=o.default,t.NAME="playkit-js-providers-analytics-service",t.VERSION="2.18.1"}])})},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=function(){function e(){r(this,e),this._rates=[],this._rates=[]}return i(e,[{key:"setRates",value:function(e){var t=this;this._rates=[],e.forEach(function(e){t._rates.push({rate:e,active:!1,duration:0})})}},{key:"setCurrent",value:function(e){this._rates.forEach(function(e){return e.active=!1});var t=this._rates.find(function(t){return t.rate===e});t&&(t.active=!0)}},{key:"getCurrent",value:function(){var e=this._rates.find(function(e){return e.active});return e?e.rate:-1}},{key:"countCurrent",value:function(){var e=this._rates.find(function(e){return e.active});e&&e.duration++}},{key:"getAverage",value:function(){var e=0,t=0;return this._rates.forEach(function(n){t+=n.rate*n.duration,e+=n.duration}),e?t/e:0}},{key:"reset",value:function(){this._rates.forEach(function(e){return e.duration=0})}},{key:"destroy",value:function(){this._rates=[]}}]),e}();t.KavaRateHandler=o},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.KavaTimer=void 0;var a=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),u=n(1),s=function(e){function t(e){r(this,t);var n=i(this,(t.__proto__||Object.getPrototypeOf(t)).call(this));return n._config=e,n}return o(t,e),a(t,[{key:"start",value:function(){var e=this;this._clearTimeout(),this._stopped=!1,this._resetCounter=0,this._eventCounter=0,this._intervalId=setInterval(function(){return e._monitor()},1e3)}},{key:"resume",value:function(){this._stopped=!1,this._resetCounter=0}},{key:"stop",value:function(){this._stopped=!0}},{key:"isStopped",value:function(){return this._stopped}},{key:"destroy",value:function(){this._clearTimeout()}},{key:"_clearTimeout",value:function(){this._intervalId&&(clearInterval(this._intervalId),this._intervalId=null)}},{key:"_monitor",value:function(){this._stopped?(this._resetCounter===this._config.resetCounter&&(this.dispatchEvent(new u.FakeEvent(t.Event.RESET)),this._resetCounter=0,this._eventCounter=0),this._resetCounter++):(this.dispatchEvent(new u.FakeEvent(t.Event.TICK)),this._eventCounter===this._config.eventCounter&&(this.dispatchEvent(new u.FakeEvent(t.Event.REPORT)),this._eventCounter=0),this._eventCounter++)}}]),t}(u.FakeEventTarget);s.Event={TICK:"tick",RESET:"reset",REPORT:"report"},t.KavaTimer=s}])});


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setup = undefined;

var _vidiunPlayer = __webpack_require__(44);

var _proxy = __webpack_require__(147);

var _pluginsConfig = __webpack_require__(144);

var _setupHelpers = __webpack_require__(138);

/**
 * Setup the Vidiun Player.
 * @param {PartialVPOptionsObject|LegacyPartialVPOptionsObject} options - partial vidiun player options
 * @private
 * @returns {VidiunPlayer} - The Vidiun Player.
 */
function setup(options) {
  options = (0, _setupHelpers.supportLegacyOptions)(options);
  (0, _setupHelpers.validateConfig)(options);
  var defaultOptions = (0, _setupHelpers.getDefaultOptions)(options);
  (0, _setupHelpers.setLogLevel)(defaultOptions);
  (0, _setupHelpers.printSetupMessages)();
  (0, _pluginsConfig.evaluatePluginsConfig)(defaultOptions.plugins, defaultOptions);
  (0, _setupHelpers.setStorageConfig)(defaultOptions);
  var player = (0, _proxy.getPlayerProxy)(defaultOptions);
  (0, _setupHelpers.setStorageTextStyle)(player);
  (0, _setupHelpers.applyStorageSupport)(player);
  (0, _setupHelpers.applyCastSupport)(defaultOptions, player);
  (0, _setupHelpers.attachToFirstClick)(player);
  return player;
}

exports.setup = setup;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setDefaultAnalyticsPlugin = setDefaultAnalyticsPlugin;

var _pakhshkitJs = __webpack_require__(9);

/**
 * Sets the default analytics plugin for the ott player.
 * @param {VPOptionsObject} options - The player config.
 * @private
 * @returns {void}
 */
function setDefaultAnalyticsPlugin(options) {
  var kavaPlugin = _pakhshkitJs.Utils.Object.getPropertyPath(options, 'plugins.kava');
  if (!kavaPlugin) {
    _pakhshkitJs.Utils.Object.mergeDeep(options, {
      plugins: {
        kava: {
          disable: true
        }
      }
    });
  }
  var ottAnalyticsPlugin = _pakhshkitJs.Utils.Object.getPropertyPath(options, 'plugins.ottAnalytics');
  if (!ottAnalyticsPlugin) {
    _pakhshkitJs.Utils.Object.mergeDeep(options, {
      plugins: {
        ottAnalytics: {}
      }
    });
  }
}

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ValidationErrorType = {
  INITIAL_CONFIG_REQUIRED: 'Must provide initial providers config',
  PARTNER_ID_REQUIRED: 'Must provide partner id',
  TARGET_ID_REQUIRED: 'Must provide target id',
  DOM_ELEMENT_WITH_TARGET_ID_REQUIRED: 'Must provide DOM element with id of: ',
  TARGET_ID_ALREADY_USED: 'The target id provided is already in use. Id: '
};

exports.ValidationErrorType = ValidationErrorType;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _storageWrapper = __webpack_require__(366);

var _storageWrapper2 = _interopRequireDefault(_storageWrapper);

var _logger = __webpack_require__(16);

var _logger2 = _interopRequireDefault(_logger);

var _pakhshkitJs = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StorageManager = function () {
  function StorageManager() {
    _classCallCheck(this, StorageManager);
  }

  _createClass(StorageManager, null, [{
    key: 'isLocalStorageAvailable',


    /**
     * @static
     * @private
     * @returns {boolean} - Whether local storage is implemented in the current browser.
     */
    value: function isLocalStorageAvailable() {
      return _storageWrapper2.default.isLocalStorageAvailable();
    }

    /**
     * Attaches the player listeners to the local storage wrapper.
     * @private
     * @param {Player} player - The player reference.
     * @static
     * @returns {void}
     */

  }, {
    key: 'attach',
    value: function attach(player) {
      var _this = this;

      StorageManager._logger.debug('Attach local storage');
      player.addEventListener(player.Event.UI.USER_CLICKED_MUTE, function () {
        if (!player.isCasting()) {
          _storageWrapper2.default.setItem(StorageManager.StorageKeys.MUTED, player.muted);
        }
      });
      player.addEventListener(player.Event.UI.USER_CLICKED_UNMUTE, function () {
        if (!player.isCasting()) {
          _storageWrapper2.default.setItem(StorageManager.StorageKeys.MUTED, player.muted);
        }
      });
      player.addEventListener(player.Event.UI.USER_CHANGED_VOLUME, function () {
        if (!player.isCasting()) {
          if (player.volume > 0) {
            _storageWrapper2.default.setItem(StorageManager.StorageKeys.MUTED, false);
          } else {
            _storageWrapper2.default.setItem(StorageManager.StorageKeys.MUTED, true);
          }
          _storageWrapper2.default.setItem(StorageManager.StorageKeys.VOLUME, player.volume);
        }
      });
      player.addEventListener(player.Event.UI.USER_SELECTED_AUDIO_TRACK, function (event) {
        var audioTrack = event.payload.audioTrack;
        _storageWrapper2.default.setItem(StorageManager.StorageKeys.AUDIO_LANG, audioTrack.language);
      });
      player.addEventListener(player.Event.UI.USER_SELECTED_CAPTION_TRACK, function (event) {
        var textTrack = event.payload.captionTrack;
        _storageWrapper2.default.setItem(StorageManager.StorageKeys.TEXT_LANG, textTrack.language);
      });
      player.addEventListener(player.Event.UI.USER_SELECTED_CAPTIONS_STYLE, function (event) {
        try {
          var textStyle = JSON.stringify(event.payload.captionsStyle);
          _storageWrapper2.default.setItem(StorageManager.StorageKeys.TEXT_STYLE, textStyle);
        } catch (e) {
          _this._logger.error(e.message);
        }
      });
    }

    /**
     * Gets the player text style from storage.
     * @private
     * @static
     * @returns {?Object} - The stored text style object
     */

  }, {
    key: 'getPlayerTextStyle',
    value: function getPlayerTextStyle() {
      return _storageWrapper2.default.getItem(StorageManager.StorageKeys.TEXT_STYLE);
    }

    /**
     * Checks if we have previous storage.
     * @private
     * @static
     * @return {boolean} - Whether we have previous storage.
     */

  }, {
    key: 'hasStorage',
    value: function hasStorage() {
      var storageSize = _storageWrapper2.default.size;
      var hasStorage = storageSize !== 0;
      if (hasStorage) {
        this._logger.debug('Storage found with size of ', storageSize);
      } else {
        this._logger.debug('No storage found');
      }
      return hasStorage;
    }

    /**
     * Gets the storage in the structure of the player configuration.
     * @private
     * @static
     * @return {Object} - Partial storageable player configuration.
     */

  }, {
    key: 'getStorageConfig',
    value: function getStorageConfig() {
      var values = StorageManager._getExistingValues();
      var storageConfig = StorageManager._buildStorageConfig(values);
      this._logger.debug('Gets storage config', storageConfig);
      return storageConfig;
    }
  }, {
    key: '_getExistingValues',
    value: function _getExistingValues() {
      var obj = {};
      Object.keys(StorageManager.StorageKeys).forEach(function (key) {
        var value = StorageManager.StorageKeys[key];
        var item = _storageWrapper2.default.getItem(value);
        if (item != null) {
          obj[value] = item;
        }
      });
      return obj;
    }
  }, {
    key: '_buildStorageConfig',
    value: function _buildStorageConfig(values) {
      var storageConfig = _pakhshkitJs.Utils.Object.mergeDeep({}, values);
      delete storageConfig.textStyle;
      return {
        playback: storageConfig
      };
    }
  }]);

  return StorageManager;
}();

StorageManager.StorageKeys = {
  MUTED: 'muted',
  VOLUME: 'volume',
  AUDIO_LANG: 'audioLanguage',
  TEXT_LANG: 'textLanguage',
  TEXT_STYLE: 'textStyle'
};
StorageManager._logger = (0, _logger2.default)('StorageManager');
exports.default = StorageManager;

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _logger = __webpack_require__(16);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var STORAGE_PREFIX = "vidiun-player-js" + '_';

var StorageWrapper = function () {
  function StorageWrapper() {
    _classCallCheck(this, StorageWrapper);
  }

  _createClass(StorageWrapper, null, [{
    key: 'isLocalStorageAvailable',


    /**
     * @static
     * @private
     * @returns {boolean} - Whether a local storage object is available on the current environment.
     */
    value: function isLocalStorageAvailable() {
      if (typeof Storage !== 'undefined') {
        try {
          localStorage.setItem('test', 'test');
          localStorage.removeItem('test');
          return true;
        } catch (e) {
          return false;
        }
      } else {
        return false;
      }
    }

    /**
     * @static
     * @private
     * @return {number} - The number of keys in the local storage started with wanted prefix.
     */

  }, {
    key: 'setItem',


    /**
     * Sets an item in the local storage.
     * @param {string} key - The key of the item.
     * @param {any} item - The value of the item.
     * @static
     * @private
     * @returns {void}
     */
    value: function setItem(key, item) {
      StorageWrapper._validateKey(key);
      try {
        StorageWrapper._logger.debug('Sets item for key: ' + key, item);
        localStorage.setItem(STORAGE_PREFIX + key, item);
      } catch (e) {
        if (StorageWrapper._isQuotaExceeded(e)) {
          StorageWrapper._logger.error('Quota exceeded: ' + e.message);
        } else {
          StorageWrapper._logger.error(e.message);
        }
      }
    }

    /**
     * Gets an item from the local storage.
     * @param {string} key - The item key.
     * @static
     * @private
     * @returns {any} - The item value.
     */

  }, {
    key: 'getItem',
    value: function getItem(key) {
      StorageWrapper._validateKey(key);
      var item = null;
      try {
        item = localStorage.getItem(STORAGE_PREFIX + key);
        if (typeof item === 'string') {
          return JSON.parse(item);
        } else {
          return null;
        }
      } catch (e) {
        return item;
      }
    }
  }, {
    key: '_isQuotaExceeded',
    value: function _isQuotaExceeded(e) {
      var quotaExceeded = false;
      if (e) {
        if (e.code) {
          switch (e.code) {
            case 22:
              quotaExceeded = true;
              break;
            case 1014:
              // Firefox
              if (e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
                quotaExceeded = true;
              }
              break;
          }
          // Internet Explorer 8
        } else if (e.number === -2147024882) {
          quotaExceeded = true;
        }
      }
      return quotaExceeded;
    }
  }, {
    key: '_validateKey',
    value: function _validateKey(key) {
      if (typeof key !== 'string' || key.length === 0) {
        throw new Error('Invalid key');
      }
    }
  }, {
    key: 'size',
    get: function get() {
      return Object.keys(localStorage).filter(function (key) {
        return key.startsWith(STORAGE_PREFIX);
      }).length;
    }
  }]);

  return StorageWrapper;
}();

StorageWrapper._logger = (0, _logger2.default)('StorageWrapper');
exports.default = StorageWrapper;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configureExternalStreamRedirect = undefined;

var _pakhshkitJs = __webpack_require__(9);

/**
 * JSONP handler function, returns the direct manifest uri.
 * @private
 * @param {Object} data - The json object that returns from the server.
 * @param {string} uri - Original request uri.
 * @returns {string} - The direct uri.
 */
function getDirectManifestUri(data, uri) {
  var getHostName = function getHostName(uri) {
    var parser = document.createElement('a');
    parser.href = uri;
    return parser.hostname;
  };
  // if the json contains one url, it means it is a redirect url. if it contains few urls, it means its the flavours
  // so we should use the original url.
  var uriHost = getHostName(uri);
  var hasOneFlavor = false;
  var redirectedUriHost = '';
  var redirectedUri = '';
  if (data) {
    if (data.flavors && Array.isArray(data.flavors)) {
      hasOneFlavor = data.flavors.length === 1;
      redirectedUriHost = hasOneFlavor && getHostName(data.flavors[0].url);
      redirectedUri = data.flavors[0].url;
    } else if (data.result) {
      hasOneFlavor = true;
      redirectedUriHost = getHostName(data.result.url);
      redirectedUri = data.result.url;
    }
  }
  if (hasOneFlavor && uriHost !== redirectedUriHost) {
    return redirectedUri;
  }
  return uri;
}

/**
 * Add external stream redirect configuration to the general config.
 * @private
 * @param {VPOptionsObject} options - vidiun player options.
 * @returns {void}
 */

function configureExternalStreamRedirect(options) {
  var sourceOptions = _pakhshkitJs.Utils.Object.getPropertyPath(options, 'sources.options');
  if (!sourceOptions) {
    _pakhshkitJs.Utils.Object.mergeDeep(options, {
      sources: {
        options: {}
      }
    });
    sourceOptions = options.sources && options.sources.options;
  }
  if (sourceOptions && typeof sourceOptions.redirectExternalStreamsHandler !== 'function') {
    sourceOptions.redirectExternalStreamsHandler = getDirectManifestUri;
  }
}

exports.configureExternalStreamRedirect = configureExternalStreamRedirect;

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _pakhshkitJs = __webpack_require__(9);

var _remoteSession = __webpack_require__(53);

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_THUMBS_SLICES = exports.DEFAULT_THUMBS_WIDTH = undefined;
exports.getThumbSlicesUrl = getThumbSlicesUrl;

var _evaluate = __webpack_require__(142);

var _evaluate2 = _interopRequireDefault(_evaluate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_THUMBS_WIDTH = exports.DEFAULT_THUMBS_WIDTH = 164;
var DEFAULT_THUMBS_SLICES = exports.DEFAULT_THUMBS_SLICES = 100;
var TEMPLATE = '{{thumbnailUrl}}/width/{{width}}/vid_slices/{{slices}}/vs/{{vs}}';

/**
 * Builds thumbnail slices url for the ui.
 * @private
 * @param {ProviderMediaConfigObject} mediaConfig - The prover media config.
 * @param {SeekbarConfig?} seekbarConfig - The seek bar config.
 * @returns {string} - The thumbnail slices url.
 */
function getThumbSlicesUrl(mediaConfig, seekbarConfig) {
  var mediaConfigPoster = mediaConfig.sources && mediaConfig.sources.poster;
  if (typeof mediaConfigPoster === 'string') {
    var regex = /.*\/p\/\d+\/(?:[a-zA-Z]+\/\d+\/)*thumbnail\/entry_id\/\w+\/.*\d+/;
    if (regex.test(mediaConfigPoster)) {
      try {
        var model = {
          thumbnailUrl: mediaConfigPoster,
          vs: mediaConfig.session.vs,
          width: seekbarConfig && seekbarConfig.thumbsWidth || DEFAULT_THUMBS_WIDTH,
          slices: seekbarConfig && seekbarConfig.thumbsSlices || DEFAULT_THUMBS_SLICES
        };
        return (0, _evaluate2.default)(TEMPLATE, model);
      } catch (e) {
        return '';
      }
    }
  }
  return '';
}

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.templateRegex = exports.pluginConfig = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _pakhshkitJs = __webpack_require__(9);

var defaultConfig = {
  youbora: {
    playerVersion: '{{pVersion}}',
    playerName: '{{pName}}',
    entryId: '{{entryId}}',
    entryName: '{{entryName}}',
    entryType: '{{entryType}}',
    sessionId: '{{sessionId}}',
    uiConfId: '{{uiConfId}}'
  },
  vanalytics: {
    playerVersion: '{{pVersion}}',
    playlistId: '{{playlistId}}',
    entryId: '{{entryId}}',
    entryType: '{{entryType}}',
    sessionId: '{{sessionId}}',
    vs: '{{vs}}',
    uiConfId: '{{uiConfId}}',
    partnerId: '{{partnerId}}',
    referrer: '{{referrer}}'
  },
  googleAnalytics: {
    entryId: '{{entryId}}',
    entryName: '{{entryName}}',
    uiConfId: '{{uiConfId}}',
    partnerId: '{{partnerId}}'
  },
  ottAnalytics: {
    entryId: '{{entryId}}',
    vs: '{{vs}}',
    isAnonymous: '{{isAnonymous}}',
    partnerId: '{{partnerId}}',
    serviceUrl: '{{serviceUrl}}'
  },
  ima: {
    playerVersion: '{{pVersion}}',
    playerName: '{{pName}}'
  },
  kava: {
    playerVersion: '{{pVersion}}',
    playerName: '{{pName}}',
    partnerId: '{{partnerId}}',
    playlistId: '{{playlistId}}',
    entryId: '{{entryId}}',
    entryType: '{{entryType}}',
    sessionId: '{{sessionId}}',
    vs: '{{vs}}',
    uiConfId: '{{uiConfId}}',
    referrer: '{{referrer}}'
  },
  comscore: {
    playerVersion: '{{pVersion}}'
  },
  vr: {
    rootElement: '{{domRootElementId}}'
  }
};

var config = _pakhshkitJs.Utils.Object.copyDeep(defaultConfig);
var templateRegex = new RegExp('{{.*}}');

/**
 * extract the object members which include an evaluation token of type {{.*}}
 * @private
 * @param {Object} obj - the config object
 * @returns {dataStoreType} - the new object with new tokens
 */
var resolveNewConfig = function resolveNewConfig() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.entries(obj).reduce(function (product, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    if (_pakhshkitJs.Utils.Object.isObject(value)) {
      product[key] = resolveNewConfig(value);
    } else if (typeof value === 'string' && templateRegex.test(value)) {
      product[key] = value;
    } else {
      product[key] = undefined;
    }
    return product;
  }, {});
};

/**
 * remove undefined members from the token data store
 * @private
 * @param {Object} obj - the config object
 * @returns {dataStoreType} - the new object with valid evaluate tokens
 */
var removeUndefineds = function removeUndefineds() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.entries(obj).reduce(function (product, _ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        value = _ref4[1];

    if (_pakhshkitJs.Utils.Object.isObject(value)) {
      product[key] = removeUndefineds(value);
    } else if (value) {
      product[key] = value;
    }
    return product;
  }, {});
};

var pluginConfig = {
  /**
   * return the token store object
   * @private
   * @returns {*|any} - token store object
   */
  get: function get() {
    return config;
  },
  /**
   * recalculate the token store data, if new config with token is passed then add it to the data store, and if
   * an existing token needs to be removed then remove it
   * @private
   * @param {?dataStoreType} pluginsConfig - the new config object
   * @returns {void}
   */
  set: function set(pluginsConfig) {
    if (pluginsConfig) {
      var newConfig = resolveNewConfig(pluginsConfig);
      config = removeUndefineds(_pakhshkitJs.Utils.Object.mergeDeep(config, newConfig));
    }
  },
  /**
   * reset the config store to its initial state
   * @private
   * @returns {void}
   */
  reset: function reset() {
    config = _pakhshkitJs.Utils.Object.copyDeep(defaultConfig);
  }
};

exports.pluginConfig = pluginConfig;
exports.templateRegex = templateRegex;

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(372);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(374)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!./style.css", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(373)(undefined);
// imports


// module
exports.push([module.i, ".vidiun-player-container {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  background-color: #000;\n  outline: none;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-tap-highlight-color: transparent;\n}\n", ""]);

// exports


/***/ }),
/* 373 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			memo[selector] = fn.call(this, selector);
		}

		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(375);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 375 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlaylistManager = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _vidiunPlayer = __webpack_require__(44);

var _pakhshkitJs = __webpack_require__(9);

var _playlistEventType = __webpack_require__(101);

var _logger = __webpack_require__(16);

var _logger2 = _interopRequireDefault(_logger);

var _playlist = __webpack_require__(377);

var _playlistItem = __webpack_require__(146);

var _poster = __webpack_require__(145);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class PlaylistManager
 * @param {VidiunPlayer} player - The player instance
 * @param {VPOptionsObject} options - The player config object
 */
var PlaylistManager = function () {
  function PlaylistManager(player, options) {
    _classCallCheck(this, PlaylistManager);

    this._logger = (0, _logger2.default)('PlaylistManager');

    this._player = player;
    this._eventManager = new _pakhshkitJs.EventManager();
    this._playlist = new _playlist.Playlist();
    this._options = { autoContinue: true, loop: false };
    this._countdown = { duration: 10, showing: true };
    this._mediaInfoList = [];
    this._playerOptions = options;
  }

  /**
   * Config the playlist
   * @param {VPPlaylistObject} [config] - The playlist config
   * @param {ProviderEntryListObject} [entryList] - Entry list
   * @returns {void}
   * @instance
   * @memberof PlaylistManager
   */


  _createClass(PlaylistManager, [{
    key: 'configure',
    value: function configure(config, entryList) {
      if (config) {
        this._playlist.configure(config);
        _pakhshkitJs.Utils.Object.mergeDeep(this._options, config.options);
        _pakhshkitJs.Utils.Object.mergeDeep(this._countdown, config.countdown);
        if (config.items && config.items.find(function (item) {
          return !!item.sources;
        })) {
          this._mediaInfoList = config.items.map(function (item, index) {
            return entryList && entryList.entries && _typeof(entryList.entries[index]) === 'object' ? entryList.entries[index] : { entryId: item.sources.id };
          });
          this._player.dispatchEvent(new _pakhshkitJs.FakeEvent(_playlistEventType.PlaylistEventType.PLAYLIST_LOADED, { playlist: this }));
          this._addBindings();
          this.playNext();
        }
      }
    }

    /**
     * Load a playlist
     * @param {VPPlaylistObject} playlistData - The playlist data
     * @param {VPPlaylistConfigObject} [playlistConfig] - The playlist config
     * @param {ProviderEntryListObject} [entryList] - Entry list
     * @returns {void}
     * @instance
     * @memberof PlaylistManager
     */

  }, {
    key: 'load',
    value: function load(playlistData, playlistConfig, entryList) {
      var mergedPlaylistData = this._getMergedPlaylistData(playlistData, playlistConfig);
      this.configure(mergedPlaylistData, entryList);
    }

    /**
     * Reset the playlist
     * @returns {void}
     * @instance
     * @memberof PlaylistManager
     */

  }, {
    key: 'reset',
    value: function reset() {
      this._eventManager.removeAll();
      this._playlist = new _playlist.Playlist();
      this._mediaInfoList = [];
    }

    /**
     * Play the next item
     * @returns {void}
     * @instance
     * @memberof PlaylistManager
     */

  }, {
    key: 'playNext',
    value: function playNext() {
      this._logger.debug('playNext');
      var next = this._playlist.getNext(true);
      if (next.item) {
        this._setItem(next.item, next.index);
      }
    }

    /**
     * Play the previous item
     * @returns {void}
     * @instance
     * @memberof PlaylistManager
     */

  }, {
    key: 'playPrev',
    value: function playPrev() {
      this._logger.debug('playPrev');
      var prev = this._playlist.prev;
      if (prev.item) {
        this._setItem(prev.item, prev.index);
      }
    }

    /**
     * Play a specific item
     * @param {number} index - The index of the item to play
     * @returns {void}
     * @instance
     * @memberof PlaylistManager
     */

  }, {
    key: 'playItem',
    value: function playItem(index) {
      this._logger.debug('playItem(' + index + ')');
      var item = this._playlist.items[index];
      if (item) {
        this._setItem(item, index);
      }
    }

    /**
     * Playlist items
     * @type {Array<PlaylistItem>}
     * @instance
     * @memberof PlaylistManager
     */

  }, {
    key: '_getMergedPlaylistData',
    value: function _getMergedPlaylistData(playlistData, playlistConfig) {
      var _this = this;

      var mergedPlaylistData = {
        id: playlistData.id,
        metadata: playlistData.metadata,
        poster: playlistData.poster,
        options: playlistConfig ? playlistConfig.options : this._options,
        countdown: playlistConfig ? playlistConfig.countdown : this.countdown,
        items: playlistData.items.map(function (item, index) {
          var itemData = _pakhshkitJs.Utils.Object.copyDeep(item);
          _pakhshkitJs.Utils.Object.mergeDeep(itemData.sources, playlistConfig && playlistConfig.items && playlistConfig.items[index] && playlistConfig.items[index].sources);
          if (Array.isArray(itemData.sources.poster)) {
            (0, _poster.addVidiunPoster)(itemData.sources, item.sources, _this._player.dimensions);
          }
          return {
            sources: itemData.sources,
            config: playlistConfig && playlistConfig.items && playlistConfig.items[index] && playlistConfig.items[index].config
          };
        })
      };
      return mergedPlaylistData;
    }
  }, {
    key: '_addBindings',
    value: function _addBindings() {
      var _this2 = this;

      this._eventManager.listen(this._player, this._player.Event.Core.PLAYBACK_ENDED, function () {
        return _this2._onPlaybackEnded();
      });
    }
  }, {
    key: '_onPlaybackEnded',
    value: function _onPlaybackEnded() {
      var nextItem = this._playlist.getNext(false).item;
      if (!nextItem) {
        this._player.dispatchEvent(new _pakhshkitJs.FakeEvent(_playlistEventType.PlaylistEventType.PLAYLIST_ENDED));
      }
      if (this._playerOptions.ui.disable || !this.countdown.showing) {
        if (nextItem && this._options.autoContinue || this._options.loop) {
          this.playNext();
        }
      }
    }
  }, {
    key: '_setItem',
    value: function _setItem(activeItem, index) {
      var _this3 = this;

      this._logger.debug('Playing item number ' + index, activeItem);
      var playback = { loop: false };
      if (this._playlist.current.item) {
        // from the second item onwards
        playback['autoplay'] = true;
      }
      this._player.configure({ playback: playback });
      this._playlist.activeItemIndex = index;
      if (activeItem.isPlayable()) {
        this._player.reset();
        // $FlowFixMe
        this._player.setMedia({ session: this._player.config.session, plugins: {}, sources: activeItem.sources });
        this._player.dispatchEvent(new _pakhshkitJs.FakeEvent(_playlistEventType.PlaylistEventType.PLAYLIST_ITEM_CHANGED, { index: index, activeItem: activeItem }));
        return Promise.resolve();
      } else {
        if (this._mediaInfoList[index]) {
          this._player.reset();
          this._player.configure({
            sources: activeItem.sources
          });
          return this._player.loadMedia(this._mediaInfoList[index]).then(function (mediaConfig) {
            _this3._playlist.updateItemSources(index, mediaConfig.sources);
            _this3._player.dispatchEvent(new _pakhshkitJs.FakeEvent(_playlistEventType.PlaylistEventType.PLAYLIST_ITEM_CHANGED, { index: index, activeItem: activeItem }));
          });
        }
      }
      return Promise.reject();
    }
  }, {
    key: 'items',
    get: function get() {
      return this._playlist.items;
    }

    /**
     * Next item
     * @type {?PlaylistItem}
     * @instance
     * @memberof PlaylistManager
     */

  }, {
    key: 'next',
    get: function get() {
      return this._playlist.getNext(this._options.loop).item;
    }

    /**
     * Previous item
     * @type {?PlaylistItem}
     * @instance
     * @memberof PlaylistManager
     */

  }, {
    key: 'prev',
    get: function get() {
      return this._playlist.prev.item;
    }

    /**
     * Playlist id
     * @type {string}
     * @instance
     * @memberof PlaylistManager
     */

  }, {
    key: 'id',
    get: function get() {
      return this._playlist.id;
    }

    /**
     * Playlist metadata
     * @type {ProviderPlaylistMetadataObject}
     * @instance
     * @memberof PlaylistManager
     */

  }, {
    key: 'metadata',
    get: function get() {
      return this._playlist.metadata;
    }

    /**
     * Playlist poster
     * @type {?string}
     * @instance
     * @memberof PlaylistManager
     */

  }, {
    key: 'poster',
    get: function get() {
      return this._playlist.poster;
    }

    /**
     * Playlist countdown
     * @type {VPPlaylistCountdownOptions}
     * @instance
     * @memberof PlaylistManager
     */

  }, {
    key: 'countdown',
    get: function get() {
      if (this._playlist.current.item && this._playlist.current.item.config) {
        var mergedConfig = { duration: 10, showing: true };
        _pakhshkitJs.Utils.Object.mergeDeep(mergedConfig, this._countdown, this._playlist.current.item.config.countdown);
        return mergedConfig;
      }
      return this._countdown;
    }

    /**
     * Playlist options
     * @type {VPPlaylistOptions}
     * @instance
     * @memberof PlaylistManager
     */

  }, {
    key: 'options',
    get: function get() {
      return this._options;
    }
  }]);

  return PlaylistManager;
}();

exports.PlaylistManager = PlaylistManager;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Playlist = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _playlistItem = __webpack_require__(146);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Playlist = function () {
  function Playlist() {
    _classCallCheck(this, Playlist);

    this._id = '';
    this._metadata = { name: '', description: '' };
    this._poster = '';
    this._items = [];
    this._activeItemIndex = -1;
  }

  _createClass(Playlist, [{
    key: 'configure',
    value: function configure(config) {
      var _this = this;

      this._id = config.id;
      this._poster = config.poster;
      this._metadata = config.metadata;
      if (config.items) {
        this._items = [];
        config.items.forEach(function (item) {
          _this._items.push(new _playlistItem.PlaylistItem(item.sources, item.config));
        });
      }
    }
  }, {
    key: 'updateItemSources',
    value: function updateItemSources(index, sourcesObject) {
      this._items[index].updateSources(sourcesObject);
    }
  }, {
    key: 'getNext',
    value: function getNext(loop) {
      var nextIndex = loop ? (this._activeItemIndex + 1) % this._items.length : this._activeItemIndex + 1;
      return { item: this._items[nextIndex] || null, index: nextIndex };
    }
  }, {
    key: 'id',
    get: function get() {
      return this._id;
    }
  }, {
    key: 'items',
    get: function get() {
      return this._items;
    }
  }, {
    key: 'metadata',
    get: function get() {
      return this._metadata;
    }
  }, {
    key: 'poster',
    get: function get() {
      return this._poster;
    }
  }, {
    key: 'current',
    get: function get() {
      return { item: this._items[this._activeItemIndex] || null, index: this._activeItemIndex };
    }
  }, {
    key: 'prev',
    get: function get() {
      return { item: this._items[this._activeItemIndex - 1] || null, index: this._activeItemIndex - 1 };
    }
  }, {
    key: 'activeItemIndex',
    set: function set(index) {
      this._activeItemIndex = index;
    }
  }]);

  return Playlist;
}();

exports.Playlist = Playlist;

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cast = undefined;

var _remotePlayerManager = __webpack_require__(98);

var _playerSnapshot = __webpack_require__(99);

var _remoteControl = __webpack_require__(69);

var _castEventType = __webpack_require__(100);

var _remoteSession = __webpack_require__(53);

var _baseRemotePlayer = __webpack_require__(70);

var _remotePayload = __webpack_require__(139);

var _remotePlayerUi = __webpack_require__(140);

var _remotePlayerType = __webpack_require__(379);

var _textStyleConvertor = __webpack_require__(380);

var _customMessage = __webpack_require__(381);

var cast = {
  registerRemotePlayer: _remotePlayerManager.RemotePlayerManager.register,
  PlayerSnapshot: _playerSnapshot.PlayerSnapshot,
  RemoteControl: _remoteControl.RemoteControl,
  RemoteSession: _remoteSession.RemoteSession,
  BaseRemotePlayer: _baseRemotePlayer.BaseRemotePlayer,
  RemoteConnectedPayload: _remotePayload.RemoteConnectedPayload,
  RemoteDisconnectedPayload: _remotePayload.RemoteDisconnectedPayload,
  RemoteAvailablePayload: _remotePayload.RemoteAvailablePayload,
  RemotePlayerUI: _remotePlayerUi.RemotePlayerUI,
  CastEventType: _castEventType.CastEventType,
  RemotePlayerType: _remotePlayerType.RemotePlayerType,
  TextStyleConverter: _textStyleConvertor.TextStyleConverter,
  CustomEventMessage: _customMessage.CustomEventMessage,
  CustomActionMessage: _customMessage.CustomActionMessage,
  CustomMessageType: _customMessage.CustomMessageType,
  CustomActionType: _customMessage.CustomActionType,
  CustomMessage: _customMessage.CustomMessage
};
exports.cast = cast;

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var RemotePlayerType = {
  CHROMECAST: 'chromecast'
};

exports.RemotePlayerType = RemotePlayerType;

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextStyleConverter = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _pakhshkitJs = __webpack_require__(9);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TextStyleConverter = function () {
  function TextStyleConverter() {
    _classCallCheck(this, TextStyleConverter);
  }

  _createClass(TextStyleConverter, null, [{
    key: 'toCastTextStyle',
    value: function toCastTextStyle(playerTextStyle) {
      if (window.chrome && window.chrome.cast) {
        var textTrackStyle = new window.chrome.cast.media.TextTrackStyle();
        textTrackStyle.fontFamily = playerTextStyle.fontFamily;
        textTrackStyle.backgroundColor = TextStyleConverter.rgbToHex(playerTextStyle.backgroundColor);
        textTrackStyle.foregroundColor = TextStyleConverter.rgbToHex(playerTextStyle.fontColor);
        textTrackStyle.fontScale = Number.parseFloat(playerTextStyle.fontSize) / 100;
        return textTrackStyle;
      }
      return {};
    }
  }, {
    key: 'toPlayerTextStyle',
    value: function toPlayerTextStyle(castTextStyle) {
      var textStyle = new _pakhshkitJs.TextStyle();
      textStyle.fontFamily = castTextStyle.fontFamily;
      textStyle.fontSize = castTextStyle.fontScale * 100 + '%';
      textStyle.fontColor = TextStyleConverter.hexToRGB(castTextStyle.foregroundColor);
      textStyle.backgroundColor = TextStyleConverter.hexToRGB(castTextStyle.backgroundColor);
      return textStyle;
    }
  }, {
    key: 'rgbToHex',
    value: function rgbToHex(rgb) {
      var hex = '#' + ('0' + parseInt(rgb[0], 10).toString(16)).slice(-2) + ('0' + parseInt(rgb[1], 10).toString(16)).slice(-2) + ('0' + parseInt(rgb[2], 10).toString(16)).slice(-2);
      if (rgb[3]) {
        var digit = rgb[3];
        digit = Math.round(digit * 100) / 100;
        var alpha = Math.round(digit * 255);
        hex += (alpha + 0x10000).toString(16).substr(-2).toUpperCase();
      } else {
        hex += 'FF';
      }
      return hex.toUpperCase();
    }
  }, {
    key: 'hexToRGB',
    value: function hexToRGB(hex) {
      var rgb = [];
      hex = hex.slice(1);
      var channels = hex.match(/.{1,2}/g);
      for (var i = 0; i < 3; i++) {
        var channel = channels && channels[i];
        if (channel) {
          rgb.push(parseInt(channel, 16));
        }
      }
      return rgb;
    }
  }]);

  return TextStyleConverter;
}();

exports.TextStyleConverter = TextStyleConverter;

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CustomMessageType = {
  ACTION: 'action',
  EVENT: 'event'
};

var CustomActionType = {
  SKIP_AD: 'skipAd'
};

var CustomMessage = function CustomMessage(type) {
  _classCallCheck(this, CustomMessage);

  this.type = type;
};

var CustomEventMessage = function (_CustomMessage) {
  _inherits(CustomEventMessage, _CustomMessage);

  function CustomEventMessage(event, payload) {
    _classCallCheck(this, CustomEventMessage);

    var _this = _possibleConstructorReturn(this, (CustomEventMessage.__proto__ || Object.getPrototypeOf(CustomEventMessage)).call(this, CustomMessageType.EVENT));

    _this.event = event;
    _this.payload = payload;
    return _this;
  }

  return CustomEventMessage;
}(CustomMessage);

var CustomActionMessage = function (_CustomMessage2) {
  _inherits(CustomActionMessage, _CustomMessage2);

  function CustomActionMessage(action, args) {
    _classCallCheck(this, CustomActionMessage);

    var _this2 = _possibleConstructorReturn(this, (CustomActionMessage.__proto__ || Object.getPrototypeOf(CustomActionMessage)).call(this, CustomMessageType.ACTION));

    _this2.action = action;
    _this2.args = args;
    return _this2;
  }

  return CustomActionMessage;
}(CustomMessage);

exports.CustomMessageType = CustomMessageType;
exports.CustomActionType = CustomActionType;
exports.CustomMessage = CustomMessage;
exports.CustomEventMessage = CustomEventMessage;
exports.CustomActionMessage = CustomActionMessage;

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.playlist = undefined;

var _playlistEventType = __webpack_require__(101);

var playlist = {
  PlaylistEventType: _playlistEventType.PlaylistEventType
};
exports.playlist = playlist;

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// vidiun-tv-player.js